(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire41fc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire41fc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dxQrq", function(module, exports) {

var $96Gw4 = parcelRequire("96Gw4");

var $6ohhc = parcelRequire("6ohhc");

var $hyPW0 = parcelRequire("hyPW0");
const $9dc7092d17df2d28$var$BUTTON_ID = "submitButton";
const $9dc7092d17df2d28$var$ERROR_ID = "errors";
const $9dc7092d17df2d28$var$FOOTER_ID = "footer";
const $9dc7092d17df2d28$var$PAYMENT_CONTAINER_ID = "dropinContainer";
const $9dc7092d17df2d28$var$SUBMIT_GROUP_ID = "submitGroup";
const $9dc7092d17df2d28$var$ADYEN_PAYMENT_RESULT_AUTHORIZED = "Authorised";
const $9dc7092d17df2d28$var$Payment = (()=>{
    let adyenDropIn;
    let redirectUrl;
    let paymentInfoValid = false;
    const submitButtonEl = document.getElementById($9dc7092d17df2d28$var$BUTTON_ID);
    const setRedirectUrl = (url)=>{
        redirectUrl = url;
    };
    const getConfig = ({ sessionId: sessionId, sessionData: sessionData })=>{
        return {
            clientKey: "live_YFRU3QRFTZAOPNFLKHVLJMKMZMPEW736",
            environment: "live",
            session: {
                id: sessionId,
                sessionData: sessionData
            },
            paymentMethodsConfiguration: {
                card: {
                    hasHolderName: true,
                    holderNameRequired: true,
                    positionHolderNameOnTop: true
                },
                threeDS2: {
                    /*==
              Accepted values:
              '02': ['390px', '400px'] -  The default window size
              '01': ['250px', '400px']
              '03': ['500px', '600px']
              '04': ['600px', '400px']
              '05': ['100%', '100%']

              We use the fixed dimension variations as 05 option renders double scrollbars
              and CTA is hidden until users scroll down.

              Mobile = 01, Desktop/Tablet = 04
          */ challengeWindowSize: window.innerWidth > 600 ? "04" : "01"
                },
                ideal: {
                    showImage: true
                }
            },
            showPayButton: false,
            locale: "en_US",
            translations: {
                placeholder: {
                    "creditCard.numberField.title": "Card Number",
                    "creditCard.numberField.placeholder": "Card Number",
                    "creditCard.holderName": "Name on Card",
                    "creditCard.holderName.placeholder": "Name on Card",
                    "creditCard.cvcField.title": "Security Code",
                    "creditCard.cvcField.placeholder": "",
                    "creditCard.cvcField.placeholder.4digits": "",
                    "creditCard.cvcField.placeholder.3digits": "",
                    "creditCard.expiryDateField.title": "Expiry Date",
                    "error.va.sf-cc-dat.01": "Invalid expiry date"
                }
            },
            beforeSubmit (data, component, actions) {
                submitButtonEl.disabled = true;
                submitButtonEl.classList.add("submit__btn--loading");
                actions.resolve(data);
            },
            onActionHandled ({ componentType: componentType, actionDescription: actionDescription }) {
                const COMPONENT_TYPE_3DS = "3DS2Challenge";
                // To monitor: Use component type instead of specific action below as sometimes it return a different actionDescription
                // const ACTION_3DS_IFRAME_LOADED = 'challenge-iframe-loaded';
                if (componentType === COMPONENT_TYPE_3DS) document.getElementById($9dc7092d17df2d28$var$SUBMIT_GROUP_ID).classList.add("hide");
            },
            onPaymentCompleted: onPaymentCompleted,
            onError: onError,
            onChange: (state)=>{
                if (state.isValid) paymentInfoValid = true;
            }
        };
    };
    const handleSubmitButton = ()=>{
        submitButtonEl.addEventListener("click", function() {
            adyenDropIn.submit();
            if (paymentInfoValid) (0, (/*@__PURE__*/$parcel$interopDefault($6ohhc))).trackMixpanelEvent((0, $hyPW0.MIXPANEL_EVENT).SubscribePaymentPagePayNow);
        });
    };
    const showElement = (id)=>{
        document.getElementById(id).style.display = "block";
    };
    const onPaymentCompleted = (result)=>{
        const { resultCode: resultCode } = result;
        if (resultCode === $9dc7092d17df2d28$var$ADYEN_PAYMENT_RESULT_AUTHORIZED) window.location.href = `${redirectUrl}?payment=true&status=OK`;
        else window.location.href = `${redirectUrl}?payment=true&status=Error`;
    };
    const onError = (e)=>{
        console.error("ERROR", e);
        showElement($9dc7092d17df2d28$var$ERROR_ID);
    };
    return {
        init: (sessionDetails)=>{
            const { redirectUrl: redirectUrl } = sessionDetails;
            setRedirectUrl(redirectUrl);
            const config = getConfig(sessionDetails);
            (0, (/*@__PURE__*/$parcel$interopDefault($96Gw4)))(config).then((adyenCheckout)=>{
                adyenDropIn = adyenCheckout.create("dropin", {
                    showStoredPaymentMethods: false,
                    onReady: ()=>{
                        showElement($9dc7092d17df2d28$var$FOOTER_ID);
                        handleSubmitButton();
                    }
                }).mount(`#${$9dc7092d17df2d28$var$PAYMENT_CONTAINER_ID}`);
            });
        }
    };
})();
module.exports = $9dc7092d17df2d28$var$Payment;

});
parcelRegister("96Gw4", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
    function t(e) {
        return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
    }
    var r = function(e) {
        return e && e.Math === Math && e;
    }, a = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof e && e) || r("object" == typeof e && e) || function() {
        return this;
    }() || Function("return this")(), n = function(e) {
        try {
            return !!e();
        } catch (e) {
            return !0;
        }
    }, o = !n(function() {
        var e = (function() {}).bind();
        return "function" != typeof e || e.hasOwnProperty("prototype");
    }), i = o, l = Function.prototype, c = l.apply, s = l.call, u = "object" == typeof Reflect && Reflect.apply || (i ? s.bind(c) : function() {
        return s.apply(c, arguments);
    }), d = o, p = Function.prototype, m = p.call, f = d && p.bind.bind(m, m), h = d ? f : function(e) {
        return function() {
            return m.apply(e, arguments);
        };
    }, v = h, y = v({}.toString), g = v("".slice), b = function(e) {
        return g(y(e), 8, -1);
    }, k = b, C = h, _ = function(e) {
        if ("Function" === k(e)) return C(e);
    }, N = "object" == typeof document && document.all, P = {
        all: N,
        IS_HTMLDDA: void 0 === N && void 0 !== N
    }, w = P.all, S = P.IS_HTMLDDA ? function(e) {
        return "function" == typeof e || e === w;
    } : function(e) {
        return "function" == typeof e;
    }, A = {}, I = !n(function() {
        return 7 !== Object.defineProperty({}, 1, {
            get: function() {
                return 7;
            }
        })[1];
    }), D = o, E = Function.prototype.call, R = D ? E.bind(E) : function() {
        return E.apply(E, arguments);
    }, x = {}, F = {}.propertyIsEnumerable, T = Object.getOwnPropertyDescriptor, z = T && !F.call({
        1: 2
    }, 1);
    x.f = z ? function(e) {
        var t = T(this, e);
        return !!t && t.enumerable;
    } : F;
    var O, j, B = function(e, t) {
        return {
            enumerable: !(1 & e),
            configurable: !(2 & e),
            writable: !(4 & e),
            value: t
        };
    }, M = n, L = b, V = Object, U = h("".split), K = M(function() {
        return !V("z").propertyIsEnumerable(0);
    }) ? function(e) {
        return "String" === L(e) ? U(e, "") : V(e);
    } : V, H = function(e) {
        return null == e;
    }, q = H, W = TypeError, G = function(e) {
        if (q(e)) throw new W("Can't call method on " + e);
        return e;
    }, Y = K, Q = G, Z = function(e) {
        return Y(Q(e));
    }, J = S, $ = P.all, X = P.IS_HTMLDDA ? function(e) {
        return "object" == typeof e ? null !== e : J(e) || e === $;
    } : function(e) {
        return "object" == typeof e ? null !== e : J(e);
    }, ee = {}, te = ee, re = a, ae = S, ne = function(e) {
        return ae(e) ? e : void 0;
    }, oe = function(e, t) {
        return arguments.length < 2 ? ne(te[e]) || ne(re[e]) : te[e] && te[e][t] || re[e] && re[e][t];
    }, ie = h({}.isPrototypeOf), le = "undefined" != typeof navigator && String(navigator.userAgent) || "", ce = a, se = le, ue = ce.process, de = ce.Deno, pe = ue && ue.versions || de && de.version, me = pe && pe.v8;
    me && (j = (O = me.split("."))[0] > 0 && O[0] < 4 ? 1 : +(O[0] + O[1])), !j && se && (!(O = se.match(/Edge\/(\d+)/)) || O[1] >= 74) && (O = se.match(/Chrome\/(\d+)/)) && (j = +O[1]);
    var fe = j, he = fe, ve = n, ye = a.String, ge = !!Object.getOwnPropertySymbols && !ve(function() {
        var e = Symbol("symbol detection");
        return !ye(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && he && he < 41;
    }), be = ge && !Symbol.sham && "symbol" == typeof Symbol.iterator, ke = oe, Ce = S, _e = ie, Ne = Object, Pe = be ? function(e) {
        return "symbol" == typeof e;
    } : function(e) {
        var t = ke("Symbol");
        return Ce(t) && _e(t.prototype, Ne(e));
    }, we = String, Se = function(e) {
        try {
            return we(e);
        } catch (e) {
            return "Object";
        }
    }, Ae = S, Ie = Se, De = TypeError, Ee = function(e) {
        if (Ae(e)) return e;
        throw new De(Ie(e) + " is not a function");
    }, Re = Ee, xe = H, Fe = function(e, t) {
        var r = e[t];
        return xe(r) ? void 0 : Re(r);
    }, Te = R, ze = S, Oe = X, je = TypeError, Be = {
        exports: {}
    }, Me = a, Le = Object.defineProperty, Ve = function(e, t) {
        try {
            Le(Me, e, {
                value: t,
                configurable: !0,
                writable: !0
            });
        } catch (r) {
            Me[e] = t;
        }
        return t;
    }, Ue = "__core-js_shared__", Ke = a[Ue] || Ve(Ue, {}), He = Ke;
    (Be.exports = function(e, t) {
        return He[e] || (He[e] = void 0 !== t ? t : {});
    })("versions", []).push({
        version: "3.33.3",
        mode: "pure",
        copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
        license: "https://github.com/zloirock/core-js/blob/v3.33.3/LICENSE",
        source: "https://github.com/zloirock/core-js"
    });
    var qe = Be.exports, We = G, Ge = Object, Ye = function(e) {
        return Ge(We(e));
    }, Qe = Ye, Ze = h({}.hasOwnProperty), Je = Object.hasOwn || function(e, t) {
        return Ze(Qe(e), t);
    }, $e = h, Xe = 0, et = Math.random(), tt = $e(1..toString), rt = function(e) {
        return "Symbol(" + (void 0 === e ? "" : e) + ")_" + tt(++Xe + et, 36);
    }, at = qe, nt = Je, ot = rt, it = ge, lt = be, ct = a.Symbol, st = at("wks"), ut = lt ? ct.for || ct : ct && ct.withoutSetter || ot, dt = function(e) {
        return nt(st, e) || (st[e] = it && nt(ct, e) ? ct[e] : ut("Symbol." + e)), st[e];
    }, pt = R, mt = X, ft = Pe, ht = Fe, vt = function(e, t) {
        var r, a;
        if ("string" === t && ze(r = e.toString) && !Oe(a = Te(r, e))) return a;
        if (ze(r = e.valueOf) && !Oe(a = Te(r, e))) return a;
        if ("string" !== t && ze(r = e.toString) && !Oe(a = Te(r, e))) return a;
        throw new je("Can't convert object to primitive value");
    }, yt = TypeError, gt = dt("toPrimitive"), bt = function(e, t) {
        if (!mt(e) || ft(e)) return e;
        var r, a = ht(e, gt);
        if (a) {
            if (void 0 === t && (t = "default"), r = pt(a, e, t), !mt(r) || ft(r)) return r;
            throw new yt("Can't convert object to primitive value");
        }
        return void 0 === t && (t = "number"), vt(e, t);
    }, kt = Pe, Ct = function(e) {
        var t = bt(e, "string");
        return kt(t) ? t : t + "";
    }, _t = X, Nt = a.document, Pt = _t(Nt) && _t(Nt.createElement), wt = function(e) {
        return Pt ? Nt.createElement(e) : {};
    }, St = wt, At = !I && !n(function() {
        return 7 !== Object.defineProperty(St("div"), "a", {
            get: function() {
                return 7;
            }
        }).a;
    }), It = I, Dt = R, Et = x, Rt = B, xt = Z, Ft = Ct, Tt = Je, zt = At, Ot = Object.getOwnPropertyDescriptor;
    A.f = It ? Ot : function(e, t) {
        if (e = xt(e), t = Ft(t), zt) try {
            return Ot(e, t);
        } catch (e) {}
        if (Tt(e, t)) return Rt(!Dt(Et.f, e, t), e[t]);
    };
    var jt = n, Bt = S, Mt = /#|\.prototype\./, Lt = function(e, t) {
        var r = Ut[Vt(e)];
        return r === Ht || r !== Kt && (Bt(t) ? jt(t) : !!t);
    }, Vt = Lt.normalize = function(e) {
        return String(e).replace(Mt, ".").toLowerCase();
    }, Ut = Lt.data = {}, Kt = Lt.NATIVE = "N", Ht = Lt.POLYFILL = "P", qt = Lt, Wt = Ee, Gt = o, Yt = _(_.bind), Qt = function(e, t) {
        return Wt(e), void 0 === t ? e : Gt ? Yt(e, t) : function() {
            return e.apply(t, arguments);
        };
    }, Zt = {}, Jt = I && n(function() {
        return 42 !== Object.defineProperty(function() {}, "prototype", {
            value: 42,
            writable: !1
        }).prototype;
    }), $t = X, Xt = String, er = TypeError, tr = function(e) {
        if ($t(e)) return e;
        throw new er(Xt(e) + " is not an object");
    }, rr = I, ar = At, nr = Jt, or = tr, ir = Ct, lr = TypeError, cr = Object.defineProperty, sr = Object.getOwnPropertyDescriptor, ur = "enumerable", dr = "configurable", pr = "writable";
    Zt.f = rr ? nr ? function(e, t, r) {
        if (or(e), t = ir(t), or(r), "function" == typeof e && "prototype" === t && "value" in r && pr in r && !r[pr]) {
            var a = sr(e, t);
            a && a[pr] && (e[t] = r.value, r = {
                configurable: dr in r ? r[dr] : a[dr],
                enumerable: ur in r ? r[ur] : a[ur],
                writable: !1
            });
        }
        return cr(e, t, r);
    } : cr : function(e, t, r) {
        if (or(e), t = ir(t), or(r), ar) try {
            return cr(e, t, r);
        } catch (e) {}
        if ("get" in r || "set" in r) throw new lr("Accessors not supported");
        return "value" in r && (e[t] = r.value), e;
    };
    var mr = Zt, fr = B, hr = I ? function(e, t, r) {
        return mr.f(e, t, fr(1, r));
    } : function(e, t, r) {
        return e[t] = r, e;
    }, vr = a, yr = u, gr = _, br = S, kr = A.f, Cr = qt, _r = ee, Nr = Qt, Pr = hr, wr = Je, Sr = function(e) {
        var t = function(r, a, n) {
            if (this instanceof t) {
                switch(arguments.length){
                    case 0:
                        return new e;
                    case 1:
                        return new e(r);
                    case 2:
                        return new e(r, a);
                }
                return new e(r, a, n);
            }
            return yr(e, this, arguments);
        };
        return t.prototype = e.prototype, t;
    }, Ar = function(e, t) {
        var r, a, n, o, i, l, c, s, u, d = e.target, p = e.global, m = e.stat, f = e.proto, h = p ? vr : m ? vr[d] : (vr[d] || {}).prototype, v = p ? _r : _r[d] || Pr(_r, d, {})[d], y = v.prototype;
        for(o in t)a = !(r = Cr(p ? o : d + (m ? "." : "#") + o, e.forced)) && h && wr(h, o), l = v[o], a && (c = e.dontCallGetSet ? (u = kr(h, o)) && u.value : h[o]), i = a && c ? c : t[o], a && typeof l == typeof i || (s = e.bind && a ? Nr(i, vr) : e.wrap && a ? Sr(i) : f && br(i) ? gr(i) : i, (e.sham || i && i.sham || l && l.sham) && Pr(s, "sham", !0), Pr(v, o, s), f && (wr(_r, n = d + "Prototype") || Pr(_r, n, {}), Pr(_r[n], o, i), e.real && y && (r || !y[o]) && Pr(y, o, i)));
    }, Ir = rt, Dr = qe("keys"), Er = function(e) {
        return Dr[e] || (Dr[e] = Ir(e));
    }, Rr = !n(function() {
        function e() {}
        return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype;
    }), xr = Je, Fr = S, Tr = Ye, zr = Rr, Or = Er("IE_PROTO"), jr = Object, Br = jr.prototype, Mr = zr ? jr.getPrototypeOf : function(e) {
        var t = Tr(e);
        if (xr(t, Or)) return t[Or];
        var r = t.constructor;
        return Fr(r) && t instanceof r ? r.prototype : t instanceof jr ? Br : null;
    }, Lr = h, Vr = Ee, Ur = S, Kr = String, Hr = TypeError, qr = function(e, t, r) {
        try {
            return Lr(Vr(Object.getOwnPropertyDescriptor(e, t)[r]));
        } catch (e) {}
    }, Wr = tr, Gr = function(e) {
        if ("object" == typeof e || Ur(e)) return e;
        throw new Hr("Can't set " + Kr(e) + " as a prototype");
    }, Yr = Object.setPrototypeOf || ("__proto__" in {} ? function() {
        var e, t = !1, r = {};
        try {
            (e = qr(Object.prototype, "__proto__", "set"))(r, []), t = r instanceof Array;
        } catch (e) {}
        return function(r, a) {
            return Wr(r), Gr(a), t ? e(r, a) : r.__proto__ = a, r;
        };
    }() : void 0), Qr = {}, Zr = Math.ceil, Jr = Math.floor, $r = Math.trunc || function(e) {
        var t = +e;
        return (t > 0 ? Jr : Zr)(t);
    }, Xr = $r, ea = function(e) {
        var t = +e;
        return t != t || 0 === t ? 0 : Xr(t);
    }, ta = ea, ra = Math.max, aa = Math.min, na = function(e, t) {
        var r = ta(e);
        return r < 0 ? ra(r + t, 0) : aa(r, t);
    }, oa = ea, ia = Math.min, la = function(e) {
        return e > 0 ? ia(oa(e), 9007199254740991) : 0;
    }, ca = la, sa = function(e) {
        return ca(e.length);
    }, ua = Z, da = na, pa = sa, ma = function(e) {
        return function(t, r, a) {
            var n, o = ua(t), i = pa(o), l = da(a, i);
            if (e && r != r) {
                for(; i > l;)if ((n = o[l++]) != n) return !0;
            } else for(; i > l; l++)if ((e || l in o) && o[l] === r) return e || l || 0;
            return !e && -1;
        };
    }, fa = {
        includes: ma(!0),
        indexOf: ma(!1)
    }, ha = {}, va = Je, ya = Z, ga = fa.indexOf, ba = ha, ka = h([].push), Ca = function(e, t) {
        var r, a = ya(e), n = 0, o = [];
        for(r in a)!va(ba, r) && va(a, r) && ka(o, r);
        for(; t.length > n;)va(a, r = t[n++]) && (~ga(o, r) || ka(o, r));
        return o;
    }, _a = [
        "constructor",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "toLocaleString",
        "toString",
        "valueOf"
    ], Na = Ca, Pa = _a.concat("length", "prototype");
    Qr.f = Object.getOwnPropertyNames || function(e) {
        return Na(e, Pa);
    };
    var wa = {};
    wa.f = Object.getOwnPropertySymbols;
    var Sa = oe, Aa = Qr, Ia = wa, Da = tr, Ea = h([].concat), Ra = Sa("Reflect", "ownKeys") || function(e) {
        var t = Aa.f(Da(e)), r = Ia.f;
        return r ? Ea(t, r(e)) : t;
    }, xa = Je, Fa = Ra, Ta = A, za = Zt, Oa = {}, ja = Ca, Ba = _a, Ma = Object.keys || function(e) {
        return ja(e, Ba);
    }, La = I, Va = Jt, Ua = Zt, Ka = tr, Ha = Z, qa = Ma;
    Oa.f = La && !Va ? Object.defineProperties : function(e, t) {
        Ka(e);
        for(var r, a = Ha(t), n = qa(t), o = n.length, i = 0; o > i;)Ua.f(e, r = n[i++], a[r]);
        return e;
    };
    var Wa, Ga = oe("document", "documentElement"), Ya = tr, Qa = Oa, Za = _a, Ja = ha, $a = Ga, Xa = wt, en = "prototype", tn = "script", rn = Er("IE_PROTO"), an = function() {}, nn = function(e) {
        return "<" + tn + ">" + e + "</" + tn + ">";
    }, on = function(e) {
        e.write(nn("")), e.close();
        var t = e.parentWindow.Object;
        return e = null, t;
    }, ln = function() {
        try {
            Wa = new ActiveXObject("htmlfile");
        } catch (e) {}
        var e, t, r;
        ln = "undefined" != typeof document ? document.domain && Wa ? on(Wa) : (t = Xa("iframe"), r = "java" + tn + ":", t.style.display = "none", $a.appendChild(t), t.src = String(r), (e = t.contentWindow.document).open(), e.write(nn("document.F=Object")), e.close(), e.F) : on(Wa);
        for(var a = Za.length; a--;)delete ln[en][Za[a]];
        return ln();
    };
    Ja[rn] = !0;
    var cn = Object.create || function(e, t) {
        var r;
        return null !== e ? (an[en] = Ya(e), r = new an, an[en] = null, r[rn] = e) : r = ln(), void 0 === t ? r : Qa.f(r, t);
    }, sn = X, un = hr, dn = Error, pn = h("".replace), mn = String(new dn("zxcasd").stack), fn = /\n\s*at [^:]*:[^\n]*/, hn = fn.test(mn), vn = B, yn = !n(function() {
        var e = new Error("a");
        return !("stack" in e) || (Object.defineProperty(e, "stack", vn(1, 7)), 7 !== e.stack);
    }), gn = hr, bn = function(e, t) {
        if (hn && "string" == typeof e && !dn.prepareStackTrace) for(; t--;)e = pn(e, fn, "");
        return e;
    }, kn = yn, Cn = Error.captureStackTrace, _n = {}, Nn = _n, Pn = dt("iterator"), wn = Array.prototype, Sn = function(e) {
        return void 0 !== e && (Nn.Array === e || wn[Pn] === e);
    }, An = {};
    An[dt("toStringTag")] = "z";
    var In = "[object z]" === String(An), Dn = In, En = S, Rn = b, xn = dt("toStringTag"), Fn = Object, Tn = "Arguments" === Rn(function() {
        return arguments;
    }()), zn = Dn ? Rn : function(e) {
        var t, r, a;
        return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function(e, t) {
            try {
                return e[t];
            } catch (e) {}
        }(t = Fn(e), xn)) ? r : Tn ? Rn(t) : "Object" === (a = Rn(t)) && En(t.callee) ? "Arguments" : a;
    }, On = zn, jn = Fe, Bn = H, Mn = _n, Ln = dt("iterator"), Vn = function(e) {
        if (!Bn(e)) return jn(e, Ln) || jn(e, "@@iterator") || Mn[On(e)];
    }, Un = R, Kn = Ee, Hn = tr, qn = Se, Wn = Vn, Gn = TypeError, Yn = function(e, t) {
        var r = arguments.length < 2 ? Wn(e) : t;
        if (Kn(r)) return Hn(Un(r, e));
        throw new Gn(qn(e) + " is not iterable");
    }, Qn = R, Zn = tr, Jn = Fe, $n = function(e, t, r) {
        var a, n;
        Zn(e);
        try {
            if (!(a = Jn(e, "return"))) {
                if ("throw" === t) throw r;
                return r;
            }
            a = Qn(a, e);
        } catch (e) {
            n = !0, a = e;
        }
        if ("throw" === t) throw r;
        if (n) throw a;
        return Zn(a), r;
    }, Xn = Qt, eo = R, to = tr, ro = Se, ao = Sn, no = sa, oo = ie, io = Yn, lo = Vn, co = $n, so = TypeError, uo = function(e, t) {
        this.stopped = e, this.result = t;
    }, po = uo.prototype, mo = function(e, t, r) {
        var a, n, o, i, l, c, s, u = r && r.that, d = !(!r || !r.AS_ENTRIES), p = !(!r || !r.IS_RECORD), m = !(!r || !r.IS_ITERATOR), f = !(!r || !r.INTERRUPTED), h = Xn(t, u), v = function(e) {
            return a && co(a, "normal", e), new uo(!0, e);
        }, y = function(e) {
            return d ? (to(e), f ? h(e[0], e[1], v) : h(e[0], e[1])) : f ? h(e, v) : h(e);
        };
        if (p) a = e.iterator;
        else if (m) a = e;
        else {
            if (!(n = lo(e))) throw new so(ro(e) + " is not iterable");
            if (ao(n)) {
                for(o = 0, i = no(e); i > o; o++)if ((l = y(e[o])) && oo(po, l)) return l;
                return new uo(!1);
            }
            a = io(e, n);
        }
        for(c = p ? e.next : a.next; !(s = eo(c, a)).done;){
            try {
                l = y(s.value);
            } catch (e) {
                co(a, "throw", e);
            }
            if ("object" == typeof l && l && oo(po, l)) return l;
        }
        return new uo(!1);
    }, fo = zn, ho = String, vo = function(e) {
        if ("Symbol" === fo(e)) throw new TypeError("Cannot convert a Symbol value to a string");
        return ho(e);
    }, yo = vo, go = Ar, bo = ie, ko = Mr, Co = Yr, _o = function(e, t, r) {
        for(var a = Fa(t), n = za.f, o = Ta.f, i = 0; i < a.length; i++){
            var l = a[i];
            xa(e, l) || r && xa(r, l) || n(e, l, o(t, l));
        }
    }, No = cn, Po = hr, wo = B, So = function(e, t) {
        sn(t) && "cause" in t && un(e, "cause", t.cause);
    }, Ao = function(e, t, r, a) {
        kn && (Cn ? Cn(e, t) : gn(e, "stack", bn(r, a)));
    }, Io = mo, Do = function(e, t) {
        return void 0 === e ? arguments.length < 2 ? "" : t : yo(e);
    }, Eo = dt("toStringTag"), Ro = Error, xo = [].push, Fo = function(e, t) {
        var r, a = bo(To, this);
        Co ? r = Co(new Ro, a ? ko(this) : To) : (r = a ? this : No(To), Po(r, Eo, "Error")), void 0 !== t && Po(r, "message", Do(t)), Ao(r, Fo, r.stack, 1), arguments.length > 2 && So(r, arguments[2]);
        var n = [];
        return Io(e, xo, {
            that: n
        }), Po(r, "errors", n), r;
    };
    Co ? Co(Fo, Ro) : _o(Fo, Ro, {
        name: !0
    });
    var To = Fo.prototype = No(Ro.prototype, {
        constructor: wo(1, Fo),
        message: wo(1, ""),
        name: wo(1, "AggregateError")
    });
    go({
        global: !0,
        constructor: !0,
        arity: 2
    }, {
        AggregateError: Fo
    });
    var zo, Oo, jo, Bo = S, Mo = a.WeakMap, Lo = Bo(Mo) && /native code/.test(String(Mo)), Vo = a, Uo = X, Ko = hr, Ho = Je, qo = Ke, Wo = Er, Go = ha, Yo = "Object already initialized", Qo = Vo.TypeError, Zo = Vo.WeakMap;
    if (Lo || qo.state) {
        var Jo = qo.state || (qo.state = new Zo);
        Jo.get = Jo.get, Jo.has = Jo.has, Jo.set = Jo.set, zo = function(e, t) {
            if (Jo.has(e)) throw new Qo(Yo);
            return t.facade = e, Jo.set(e, t), t;
        }, Oo = function(e) {
            return Jo.get(e) || {};
        }, jo = function(e) {
            return Jo.has(e);
        };
    } else {
        var $o = Wo("state");
        Go[$o] = !0, zo = function(e, t) {
            if (Ho(e, $o)) throw new Qo(Yo);
            return t.facade = e, Ko(e, $o, t), t;
        }, Oo = function(e) {
            return Ho(e, $o) ? e[$o] : {};
        }, jo = function(e) {
            return Ho(e, $o);
        };
    }
    var Xo, ei, ti, ri = {
        set: zo,
        get: Oo,
        has: jo,
        enforce: function(e) {
            return jo(e) ? Oo(e) : zo(e, {});
        },
        getterFor: function(e) {
            return function(t) {
                var r;
                if (!Uo(t) || (r = Oo(t)).type !== e) throw new Qo("Incompatible receiver, " + e + " required");
                return r;
            };
        }
    }, ai = I, ni = Je, oi = Function.prototype, ii = ai && Object.getOwnPropertyDescriptor, li = ni(oi, "name"), ci = {
        EXISTS: li,
        PROPER: li && "something" === (function() {}).name,
        CONFIGURABLE: li && (!ai || ai && ii(oi, "name").configurable)
    }, si = hr, ui = function(e, t, r, a) {
        return a && a.enumerable ? e[t] = r : si(e, t, r), e;
    }, di = n, pi = S, mi = X, fi = cn, hi = Mr, vi = ui, yi = dt("iterator"), gi = !1;
    [].keys && ("next" in (ti = [].keys()) ? (ei = hi(hi(ti))) !== Object.prototype && (Xo = ei) : gi = !0);
    var bi = !mi(Xo) || di(function() {
        var e = {};
        return Xo[yi].call(e) !== e;
    });
    pi((Xo = bi ? {} : fi(Xo))[yi]) || vi(Xo, yi, function() {
        return this;
    });
    var ki = {
        IteratorPrototype: Xo,
        BUGGY_SAFARI_ITERATORS: gi
    }, Ci = zn, _i = In ? ({}).toString : function() {
        return "[object " + Ci(this) + "]";
    }, Ni = In, Pi = Zt.f, wi = hr, Si = Je, Ai = _i, Ii = dt("toStringTag"), Di = function(e, t, r, a) {
        if (e) {
            var n = r ? e : e.prototype;
            Si(n, Ii) || Pi(n, Ii, {
                configurable: !0,
                value: t
            }), a && !Ni && wi(n, "toString", Ai);
        }
    }, Ei = ki.IteratorPrototype, Ri = cn, xi = B, Fi = Di, Ti = _n, zi = function() {
        return this;
    }, Oi = function(e, t, r, a) {
        var n = t + " Iterator";
        return e.prototype = Ri(Ei, {
            next: xi(+!a, r)
        }), Fi(e, n, !1, !0), Ti[n] = zi, e;
    }, ji = Ar, Bi = R, Mi = ci, Li = Oi, Vi = Mr, Ui = Di, Ki = ui, Hi = _n, qi = ki, Wi = Mi.PROPER, Gi = qi.BUGGY_SAFARI_ITERATORS, Yi = dt("iterator"), Qi = "keys", Zi = "values", Ji = "entries", $i = function() {
        return this;
    }, Xi = function(e, t, r, a, n, o, i) {
        Li(r, t, a);
        var l, c, s, u = function(e) {
            if (e === n && h) return h;
            if (!Gi && e && e in m) return m[e];
            switch(e){
                case Qi:
                case Zi:
                case Ji:
                    return function() {
                        return new r(this, e);
                    };
            }
            return function() {
                return new r(this);
            };
        }, d = t + " Iterator", p = !1, m = e.prototype, f = m[Yi] || m["@@iterator"] || n && m[n], h = !Gi && f || u(n), v = "Array" === t && m.entries || f;
        if (v && (l = Vi(v.call(new e))) !== Object.prototype && l.next && (Ui(l, d, !0, !0), Hi[d] = $i), Wi && n === Zi && f && f.name !== Zi && (p = !0, h = function() {
            return Bi(f, this);
        }), n) {
            if (c = {
                values: u(Zi),
                keys: o ? h : u(Qi),
                entries: u(Ji)
            }, i) for(s in c)(Gi || p || !(s in m)) && Ki(m, s, c[s]);
            else ji({
                target: t,
                proto: !0,
                forced: Gi || p
            }, c);
        }
        return i && m[Yi] !== h && Ki(m, Yi, h, {
            name: n
        }), Hi[t] = h, c;
    }, el = function(e, t) {
        return {
            value: e,
            done: t
        };
    }, tl = Z, rl = function() {}, al = _n, nl = ri, ol = (Zt.f, Xi), il = el, ll = "Array Iterator", cl = nl.set, sl = nl.getterFor(ll);
    ol(Array, "Array", function(e, t) {
        cl(this, {
            type: ll,
            target: tl(e),
            index: 0,
            kind: t
        });
    }, function() {
        var e = sl(this), t = e.target, r = e.index++;
        if (!t || r >= t.length) return e.target = void 0, il(void 0, !0);
        switch(e.kind){
            case "keys":
                return il(r, !1);
            case "values":
                return il(t[r], !1);
        }
        return il([
            r,
            t[r]
        ], !1);
    }, "values");
    al.Arguments = al.Array;
    rl(), rl(), rl();
    var ul = "process" === b(a.process), dl = Zt, pl = function(e, t, r) {
        return dl.f(e, t, r);
    }, ml = oe, fl = pl, hl = I, vl = dt("species"), yl = function(e) {
        var t = ml(e);
        hl && t && !t[vl] && fl(t, vl, {
            configurable: !0,
            get: function() {
                return this;
            }
        });
    }, gl = ie, bl = TypeError, kl = function(e, t) {
        if (gl(t, e)) return e;
        throw new bl("Incorrect invocation");
    }, Cl = S, _l = Ke, Nl = h(Function.toString);
    Cl(_l.inspectSource) || (_l.inspectSource = function(e) {
        return Nl(e);
    });
    var Pl = _l.inspectSource, wl = h, Sl = n, Al = S, Il = zn, Dl = Pl, El = function() {}, Rl = [], xl = oe("Reflect", "construct"), Fl = /^\s*(?:class|function)\b/, Tl = wl(Fl.exec), zl = !Fl.test(El), Ol = function(e) {
        if (!Al(e)) return !1;
        try {
            return xl(El, Rl, e), !0;
        } catch (e) {
            return !1;
        }
    }, jl = function(e) {
        if (!Al(e)) return !1;
        switch(Il(e)){
            case "AsyncFunction":
            case "GeneratorFunction":
            case "AsyncGeneratorFunction":
                return !1;
        }
        try {
            return zl || !!Tl(Fl, Dl(e));
        } catch (e) {
            return !0;
        }
    };
    jl.sham = !0;
    var Bl, Ml, Ll, Vl, Ul = !xl || Sl(function() {
        var e;
        return Ol(Ol.call) || !Ol(Object) || !Ol(function() {
            e = !0;
        }) || e;
    }) ? jl : Ol, Kl = Ul, Hl = Se, ql = TypeError, Wl = function(e) {
        if (Kl(e)) return e;
        throw new ql(Hl(e) + " is not a constructor");
    }, Gl = tr, Yl = Wl, Ql = H, Zl = dt("species"), Jl = function(e, t) {
        var r, a = Gl(e).constructor;
        return void 0 === a || Ql(r = Gl(a)[Zl]) ? t : Yl(r);
    }, $l = h([].slice), Xl = TypeError, ec = function(e, t) {
        if (e < t) throw new Xl("Not enough arguments");
        return e;
    }, tc = /(?:ipad|iphone|ipod).*applewebkit/i.test(le), rc = a, ac = u, nc = Qt, oc = S, ic = Je, lc = n, cc = Ga, sc = $l, uc = wt, dc = ec, pc = tc, mc = ul, fc = rc.setImmediate, hc = rc.clearImmediate, vc = rc.process, yc = rc.Dispatch, gc = rc.Function, bc = rc.MessageChannel, kc = rc.String, Cc = 0, _c = {}, Nc = "onreadystatechange";
    lc(function() {
        Bl = rc.location;
    });
    var Pc = function(e) {
        if (ic(_c, e)) {
            var t = _c[e];
            delete _c[e], t();
        }
    }, wc = function(e) {
        return function() {
            Pc(e);
        };
    }, Sc = function(e) {
        Pc(e.data);
    }, Ac = function(e) {
        rc.postMessage(kc(e), Bl.protocol + "//" + Bl.host);
    };
    fc && hc || (fc = function(e) {
        dc(arguments.length, 1);
        var t = oc(e) ? e : gc(e), r = sc(arguments, 1);
        return _c[++Cc] = function() {
            ac(t, void 0, r);
        }, Ml(Cc), Cc;
    }, hc = function(e) {
        delete _c[e];
    }, mc ? Ml = function(e) {
        vc.nextTick(wc(e));
    } : yc && yc.now ? Ml = function(e) {
        yc.now(wc(e));
    } : bc && !pc ? (Vl = (Ll = new bc).port2, Ll.port1.onmessage = Sc, Ml = nc(Vl.postMessage, Vl)) : rc.addEventListener && oc(rc.postMessage) && !rc.importScripts && Bl && "file:" !== Bl.protocol && !lc(Ac) ? (Ml = Ac, rc.addEventListener("message", Sc, !1)) : Ml = Nc in uc("script") ? function(e) {
        cc.appendChild(uc("script"))[Nc] = function() {
            cc.removeChild(this), Pc(e);
        };
    } : function(e) {
        setTimeout(wc(e), 0);
    });
    var Ic = {
        set: fc,
        clear: hc
    }, Dc = function() {
        this.head = null, this.tail = null;
    };
    Dc.prototype = {
        add: function(e) {
            var t = {
                item: e,
                next: null
            }, r = this.tail;
            r ? r.next = t : this.head = t, this.tail = t;
        },
        get: function() {
            var e = this.head;
            if (e) return null === (this.head = e.next) && (this.tail = null), e.item;
        }
    };
    var Ec, Rc, xc, Fc, Tc, zc = Dc, Oc = /ipad|iphone|ipod/i.test(le) && "undefined" != typeof Pebble, jc = /web0s(?!.*chrome)/i.test(le), Bc = a, Mc = Qt, Lc = A.f, Vc = Ic.set, Uc = zc, Kc = tc, Hc = Oc, qc = jc, Wc = ul, Gc = Bc.MutationObserver || Bc.WebKitMutationObserver, Yc = Bc.document, Qc = Bc.process, Zc = Bc.Promise, Jc = Lc(Bc, "queueMicrotask"), $c = Jc && Jc.value;
    if (!$c) {
        var Xc = new Uc, es = function() {
            var e, t;
            for(Wc && (e = Qc.domain) && e.exit(); t = Xc.get();)try {
                t();
            } catch (e) {
                throw Xc.head && Ec(), e;
            }
            e && e.enter();
        };
        Kc || Wc || qc || !Gc || !Yc ? !Hc && Zc && Zc.resolve ? ((Fc = Zc.resolve(void 0)).constructor = Zc, Tc = Mc(Fc.then, Fc), Ec = function() {
            Tc(es);
        }) : Wc ? Ec = function() {
            Qc.nextTick(es);
        } : (Vc = Mc(Vc, Bc), Ec = function() {
            Vc(es);
        }) : (Rc = !0, xc = Yc.createTextNode(""), new Gc(es).observe(xc, {
            characterData: !0
        }), Ec = function() {
            xc.data = Rc = !Rc;
        }), $c = function(e) {
            Xc.head || Ec(), Xc.add(e);
        };
    }
    var ts = $c, rs = function(e) {
        try {
            return {
                error: !1,
                value: e()
            };
        } catch (e) {
            return {
                error: !0,
                value: e
            };
        }
    }, as = a.Promise, ns = "object" == typeof Deno && Deno && "object" == typeof Deno.version, os = !ns && !ul && "object" == typeof window && "object" == typeof document, is = a, ls = as, cs = S, ss = qt, us = Pl, ds = dt, ps = os, ms = ns, fs = fe, hs = ls && ls.prototype, vs = ds("species"), ys = !1, gs = cs(is.PromiseRejectionEvent), bs = ss("Promise", function() {
        var e = us(ls), t = e !== String(ls);
        if (!t && 66 === fs) return !0;
        if (!hs.catch || !hs.finally) return !0;
        if (!fs || fs < 51 || !/native code/.test(e)) {
            var r = new ls(function(e) {
                e(1);
            }), a = function(e) {
                e(function() {}, function() {});
            };
            if ((r.constructor = {})[vs] = a, !(ys = r.then(function() {}) instanceof a)) return !0;
        }
        return !t && (ps || ms) && !gs;
    }), ks = {
        CONSTRUCTOR: bs,
        REJECTION_EVENT: gs,
        SUBCLASSING: ys
    }, Cs = {}, _s = Ee, Ns = TypeError, Ps = function(e) {
        var t, r;
        this.promise = new e(function(e, a) {
            if (void 0 !== t || void 0 !== r) throw new Ns("Bad Promise constructor");
            t = e, r = a;
        }), this.resolve = _s(t), this.reject = _s(r);
    };
    Cs.f = function(e) {
        return new Ps(e);
    };
    var ws, Ss, As = Ar, Is = ul, Ds = a, Es = R, Rs = ui, xs = Di, Fs = yl, Ts = Ee, zs = S, Os = X, js = kl, Bs = Jl, Ms = Ic.set, Ls = ts, Vs = function(e, t) {
        try {
            1 === arguments.length ? console.error(e) : console.error(e, t);
        } catch (e) {}
    }, Us = rs, Ks = zc, Hs = ri, qs = as, Ws = ks, Gs = Cs, Ys = "Promise", Qs = Ws.CONSTRUCTOR, Zs = Ws.REJECTION_EVENT, Js = Hs.getterFor(Ys), $s = Hs.set, Xs = qs && qs.prototype, eu = qs, tu = Xs, ru = Ds.TypeError, au = Ds.document, nu = Ds.process, ou = Gs.f, iu = ou, lu = !!(au && au.createEvent && Ds.dispatchEvent), cu = "unhandledrejection", su = function(e) {
        var t;
        return !(!Os(e) || !zs(t = e.then)) && t;
    }, uu = function(e, t) {
        var r, a, n, o = t.value, i = 1 === t.state, l = i ? e.ok : e.fail, c = e.resolve, s = e.reject, u = e.domain;
        try {
            l ? (i || (2 === t.rejection && hu(t), t.rejection = 1), !0 === l ? r = o : (u && u.enter(), r = l(o), u && (u.exit(), n = !0)), r === e.promise ? s(new ru("Promise-chain cycle")) : (a = su(r)) ? Es(a, r, c, s) : c(r)) : s(o);
        } catch (e) {
            u && !n && u.exit(), s(e);
        }
    }, du = function(e, t) {
        e.notified || (e.notified = !0, Ls(function() {
            for(var r, a = e.reactions; r = a.get();)uu(r, e);
            e.notified = !1, t && !e.rejection && mu(e);
        }));
    }, pu = function(e, t, r) {
        var a, n;
        lu ? ((a = au.createEvent("Event")).promise = t, a.reason = r, a.initEvent(e, !1, !0), Ds.dispatchEvent(a)) : a = {
            promise: t,
            reason: r
        }, !Zs && (n = Ds["on" + e]) ? n(a) : e === cu && Vs("Unhandled promise rejection", r);
    }, mu = function(e) {
        Es(Ms, Ds, function() {
            var t, r = e.facade, a = e.value;
            if (fu(e) && (t = Us(function() {
                Is ? nu.emit("unhandledRejection", a, r) : pu(cu, r, a);
            }), e.rejection = Is || fu(e) ? 2 : 1, t.error)) throw t.value;
        });
    }, fu = function(e) {
        return 1 !== e.rejection && !e.parent;
    }, hu = function(e) {
        Es(Ms, Ds, function() {
            var t = e.facade;
            Is ? nu.emit("rejectionHandled", t) : pu("rejectionhandled", t, e.value);
        });
    }, vu = function(e, t, r) {
        return function(a) {
            e(t, a, r);
        };
    }, yu = function(e, t, r) {
        e.done || (e.done = !0, r && (e = r), e.value = t, e.state = 2, du(e, !0));
    }, gu = function(e, t, r) {
        if (!e.done) {
            e.done = !0, r && (e = r);
            try {
                if (e.facade === t) throw new ru("Promise can't be resolved itself");
                var a = su(t);
                a ? Ls(function() {
                    var r = {
                        done: !1
                    };
                    try {
                        Es(a, t, vu(gu, r, e), vu(yu, r, e));
                    } catch (t) {
                        yu(r, t, e);
                    }
                }) : (e.value = t, e.state = 1, du(e, !1));
            } catch (t) {
                yu({
                    done: !1
                }, t, e);
            }
        }
    };
    Qs && (eu = function(e) {
        js(this, tu), Ts(e), Es(ws, this);
        var t = Js(this);
        try {
            e(vu(gu, t), vu(yu, t));
        } catch (e) {
            yu(t, e);
        }
    }, tu = eu.prototype, (ws = function(e) {
        $s(this, {
            type: Ys,
            done: !1,
            notified: !1,
            parent: !1,
            reactions: new Ks,
            rejection: !1,
            state: 0,
            value: void 0
        });
    }).prototype = Rs(tu, "then", function(e, t) {
        var r = Js(this), a = ou(Bs(this, eu));
        return r.parent = !0, a.ok = !zs(e) || e, a.fail = zs(t) && t, a.domain = Is ? nu.domain : void 0, 0 === r.state ? r.reactions.add(a) : Ls(function() {
            uu(a, r);
        }), a.promise;
    }), Ss = function() {
        var e = new ws, t = Js(e);
        this.promise = e, this.resolve = vu(gu, t), this.reject = vu(yu, t);
    }, Gs.f = ou = function(e) {
        return e === eu || undefined === e ? new Ss(e) : iu(e);
    }), As({
        global: !0,
        constructor: !0,
        wrap: !0,
        forced: Qs
    }, {
        Promise: eu
    }), xs(eu, Ys, !1, !0), Fs(Ys);
    var bu = dt("iterator"), ku = !1;
    try {
        var Cu = 0, _u = {
            next: function() {
                return {
                    done: !!Cu++
                };
            },
            return: function() {
                ku = !0;
            }
        };
        _u[bu] = function() {
            return this;
        }, Array.from(_u, function() {
            throw 2;
        });
    } catch (eV) {}
    var Nu = function(e, t) {
        try {
            if (!t && !ku) return !1;
        } catch (e) {
            return !1;
        }
        var r = !1;
        try {
            var a = {};
            a[bu] = function() {
                return {
                    next: function() {
                        return {
                            done: r = !0
                        };
                    }
                };
            }, e(a);
        } catch (e) {}
        return r;
    }, Pu = as, wu = ks.CONSTRUCTOR || !Nu(function(e) {
        Pu.all(e).then(void 0, function() {});
    }), Su = R, Au = Ee, Iu = Cs, Du = rs, Eu = mo;
    Ar({
        target: "Promise",
        stat: !0,
        forced: wu
    }, {
        all: function(e) {
            var t = this, r = Iu.f(t), a = r.resolve, n = r.reject, o = Du(function() {
                var r = Au(t.resolve), o = [], i = 0, l = 1;
                Eu(e, function(e) {
                    var c = i++, s = !1;
                    l++, Su(r, t, e).then(function(e) {
                        s || (s = !0, o[c] = e, --l || a(o));
                    }, n);
                }), --l || a(o);
            });
            return o.error && n(o.value), r.promise;
        }
    });
    var Ru = Ar, xu = ks.CONSTRUCTOR;
    as && as.prototype, Ru({
        target: "Promise",
        proto: !0,
        forced: xu,
        real: !0
    }, {
        catch: function(e) {
            return this.then(void 0, e);
        }
    });
    var Fu = R, Tu = Ee, zu = Cs, Ou = rs, ju = mo;
    Ar({
        target: "Promise",
        stat: !0,
        forced: wu
    }, {
        race: function(e) {
            var t = this, r = zu.f(t), a = r.reject, n = Ou(function() {
                var n = Tu(t.resolve);
                ju(e, function(e) {
                    Fu(n, t, e).then(r.resolve, a);
                });
            });
            return n.error && a(n.value), r.promise;
        }
    });
    var Bu = R, Mu = Cs;
    Ar({
        target: "Promise",
        stat: !0,
        forced: ks.CONSTRUCTOR
    }, {
        reject: function(e) {
            var t = Mu.f(this);
            return Bu(t.reject, void 0, e), t.promise;
        }
    });
    var Lu = tr, Vu = X, Uu = Cs, Ku = function(e, t) {
        if (Lu(e), Vu(t) && t.constructor === e) return t;
        var r = Uu.f(e);
        return (0, r.resolve)(t), r.promise;
    }, Hu = Ar, qu = as, Wu = ks.CONSTRUCTOR, Gu = Ku, Yu = oe("Promise"), Qu = !Wu;
    Hu({
        target: "Promise",
        stat: !0,
        forced: true
    }, {
        resolve: function(e) {
            return Gu(Qu && this === Yu ? qu : this, e);
        }
    });
    var Zu = R, Ju = Ee, $u = Cs, Xu = rs, ed = mo;
    Ar({
        target: "Promise",
        stat: !0,
        forced: wu
    }, {
        allSettled: function(e) {
            var t = this, r = $u.f(t), a = r.resolve, n = r.reject, o = Xu(function() {
                var r = Ju(t.resolve), n = [], o = 0, i = 1;
                ed(e, function(e) {
                    var l = o++, c = !1;
                    i++, Zu(r, t, e).then(function(e) {
                        c || (c = !0, n[l] = {
                            status: "fulfilled",
                            value: e
                        }, --i || a(n));
                    }, function(e) {
                        c || (c = !0, n[l] = {
                            status: "rejected",
                            reason: e
                        }, --i || a(n));
                    });
                }), --i || a(n);
            });
            return o.error && n(o.value), r.promise;
        }
    });
    var td = R, rd = Ee, ad = oe, nd = Cs, od = rs, id = mo, ld = "No one promise resolved";
    Ar({
        target: "Promise",
        stat: !0,
        forced: wu
    }, {
        any: function(e) {
            var t = this, r = ad("AggregateError"), a = nd.f(t), n = a.resolve, o = a.reject, i = od(function() {
                var a = rd(t.resolve), i = [], l = 0, c = 1, s = !1;
                id(e, function(e) {
                    var u = l++, d = !1;
                    c++, td(a, t, e).then(function(e) {
                        d || s || (s = !0, n(e));
                    }, function(e) {
                        d || s || (d = !0, i[u] = e, --c || o(new r(i, ld)));
                    });
                }), --c || o(new r(i, ld));
            });
            return i.error && o(i.value), a.promise;
        }
    });
    var cd = Ar, sd = as, ud = n, dd = oe, pd = S, md = Jl, fd = Ku, hd = sd && sd.prototype;
    cd({
        target: "Promise",
        proto: !0,
        real: !0,
        forced: !!sd && ud(function() {
            hd.finally.call({
                then: function() {}
            }, function() {});
        })
    }, {
        finally: function(e) {
            var t = md(this, dd("Promise")), r = pd(e);
            return this.then(r ? function(r) {
                return fd(t, e()).then(function() {
                    return r;
                });
            } : e, r ? function(r) {
                return fd(t, e()).then(function() {
                    throw r;
                });
            } : e);
        }
    });
    var vd = h, yd = ea, gd = vo, bd = G, kd = vd("".charAt), Cd = vd("".charCodeAt), _d = vd("".slice), Nd = function(e) {
        return function(t, r) {
            var a, n, o = gd(bd(t)), i = yd(r), l = o.length;
            return i < 0 || i >= l ? e ? "" : void 0 : (a = Cd(o, i)) < 55296 || a > 56319 || i + 1 === l || (n = Cd(o, i + 1)) < 56320 || n > 57343 ? e ? kd(o, i) : a : e ? _d(o, i, i + 2) : n - 56320 + (a - 55296 << 10) + 65536;
        };
    }, Pd = {
        codeAt: Nd(!1),
        charAt: Nd(!0)
    }, wd = Pd.charAt, Sd = vo, Ad = ri, Id = Xi, Dd = el, Ed = "String Iterator", Rd = Ad.set, xd = Ad.getterFor(Ed);
    Id(String, "String", function(e) {
        Rd(this, {
            type: Ed,
            string: Sd(e),
            index: 0
        });
    }, function() {
        var e, t = xd(this), r = t.string, a = t.index;
        return a >= r.length ? Dd(void 0, !0) : (e = wd(r, a), t.index += e.length, Dd(e, !1));
    });
    var Fd = ee.Promise, Td = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
    }, zd = a, Od = zn, jd = hr, Bd = _n, Md = dt("toStringTag");
    for(var Ld in Td){
        var Vd = zd[Ld], Ud = Vd && Vd.prototype;
        Ud && Od(Ud) !== Md && jd(Ud, Md, Ld), Bd[Ld] = Bd.Array;
    }
    var Kd = Fd, Hd = Cs;
    Ar({
        target: "Promise",
        stat: !0
    }, {
        withResolvers: function() {
            var e = Hd.f(this);
            return {
                promise: e.promise,
                resolve: e.resolve,
                reject: e.reject
            };
        }
    });
    var qd = Kd, Wd = Cs, Gd = rs;
    Ar({
        target: "Promise",
        stat: !0,
        forced: !0
    }, {
        try: function(e) {
            var t = Wd.f(this), r = Gd(e);
            return (r.error ? t.reject : t.resolve)(r.value), t.promise;
        }
    });
    var Yd = qd, Qd = t(Yd);
    function Zd(e, t, r, a, n, o, i) {
        try {
            var l = e[o](i), c = l.value;
        } catch (e) {
            return void r(e);
        }
        l.done ? t(c) : Qd.resolve(c).then(a, n);
    }
    function Jd(e) {
        return function() {
            var t = this, r = arguments;
            return new Qd(function(a, n) {
                var o = e.apply(t, r);
                function i(e) {
                    Zd(o, a, n, i, l, "next", e);
                }
                function l(e) {
                    Zd(o, a, n, i, l, "throw", e);
                }
                i(void 0);
            });
        };
    }
    var $d = {
        exports: {}
    }, Xd = {
        exports: {}
    }, ep = b, tp = Array.isArray || function(e) {
        return "Array" === ep(e);
    }, rp = TypeError, ap = function(e) {
        if (e > 9007199254740991) throw rp("Maximum allowed index exceeded");
        return e;
    }, np = Ct, op = Zt, ip = B, lp = function(e, t, r) {
        var a = np(t);
        a in e ? op.f(e, a, ip(0, r)) : e[a] = r;
    }, cp = tp, sp = Ul, up = X, dp = dt("species"), pp = Array, mp = function(e) {
        var t;
        return cp(e) && (t = e.constructor, (sp(t) && (t === pp || cp(t.prototype)) || up(t) && null === (t = t[dp])) && (t = void 0)), void 0 === t ? pp : t;
    }, fp = function(e, t) {
        return new (mp(e))(0 === t ? 0 : t);
    }, hp = n, vp = fe, yp = dt("species"), gp = function(e) {
        return vp >= 51 || !hp(function() {
            var t = [];
            return (t.constructor = {})[yp] = function() {
                return {
                    foo: 1
                };
            }, 1 !== t[e](Boolean).foo;
        });
    }, bp = Ar, kp = n, Cp = tp, _p = X, Np = Ye, Pp = sa, wp = ap, Sp = lp, Ap = fp, Ip = gp, Dp = fe, Ep = dt("isConcatSpreadable"), Rp = Dp >= 51 || !kp(function() {
        var e = [];
        return e[Ep] = !1, e.concat()[0] !== e;
    }), xp = function(e) {
        if (!_p(e)) return !1;
        var t = e[Ep];
        return void 0 !== t ? !!t : Cp(e);
    };
    bp({
        target: "Array",
        proto: !0,
        arity: 1,
        forced: !Rp || !Ip("concat")
    }, {
        concat: function(e) {
            var t, r, a, n, o, i = Np(this), l = Ap(i, 0), c = 0;
            for(t = -1, a = arguments.length; t < a; t++)if (xp(o = -1 === t ? i : arguments[t])) for(n = Pp(o), wp(c + n), r = 0; r < n; r++, c++)r in o && Sp(l, c, o[r]);
            else wp(c + 1), Sp(l, c++, o);
            return l.length = c, l;
        }
    });
    var Fp = {}, Tp = na, zp = sa, Op = lp, jp = Array, Bp = Math.max, Mp = function(e, t, r) {
        for(var a = zp(e), n = Tp(t, a), o = Tp(void 0 === r ? a : r, a), i = jp(Bp(o - n, 0)), l = 0; n < o; n++, l++)Op(i, l, e[n]);
        return i.length = l, i;
    }, Lp = b, Vp = Z, Up = Qr.f, Kp = Mp, Hp = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
    Fp.f = function(e) {
        return Hp && "Window" === Lp(e) ? function(e) {
            try {
                return Up(e);
            } catch (e) {
                return Kp(Hp);
            }
        }(e) : Up(Vp(e));
    };
    var qp = {}, Wp = dt;
    qp.f = Wp;
    var Gp = ee, Yp = Je, Qp = qp, Zp = Zt.f, Jp = function(e) {
        var t = Gp.Symbol || (Gp.Symbol = {});
        Yp(t, e) || Zp(t, e, {
            value: Qp.f(e)
        });
    }, $p = R, Xp = oe, em = dt, tm = ui, rm = function() {
        var e = Xp("Symbol"), t = e && e.prototype, r = t && t.valueOf, a = em("toPrimitive");
        t && !t[a] && tm(t, a, function(e) {
            return $p(r, this);
        }, {
            arity: 1
        });
    }, am = Qt, nm = K, om = Ye, im = sa, lm = fp, cm = h([].push), sm = function(e) {
        var t = 1 === e, r = 2 === e, a = 3 === e, n = 4 === e, o = 6 === e, i = 7 === e, l = 5 === e || o;
        return function(c, s, u, d) {
            for(var p, m, f = om(c), h = nm(f), v = am(s, u), y = im(h), g = 0, b = d || lm, k = t ? b(c, y) : r || i ? b(c, 0) : void 0; y > g; g++)if ((l || g in h) && (m = v(p = h[g], g, f), e)) {
                if (t) k[g] = m;
                else if (m) switch(e){
                    case 3:
                        return !0;
                    case 5:
                        return p;
                    case 6:
                        return g;
                    case 2:
                        cm(k, p);
                }
                else switch(e){
                    case 4:
                        return !1;
                    case 7:
                        cm(k, p);
                }
            }
            return o ? -1 : a || n ? n : k;
        };
    }, um = {
        forEach: sm(0),
        map: sm(1),
        filter: sm(2),
        some: sm(3),
        every: sm(4),
        find: sm(5),
        findIndex: sm(6),
        filterReject: sm(7)
    }, dm = Ar, pm = a, mm = R, fm = h, hm = I, vm = ge, ym = n, gm = Je, bm = ie, km = tr, Cm = Z, _m = Ct, Nm = vo, Pm = B, wm = cn, Sm = Ma, Am = Qr, Im = Fp, Dm = wa, Em = A, Rm = Zt, xm = Oa, Fm = x, Tm = ui, zm = pl, Om = qe, jm = ha, Bm = rt, Mm = dt, Lm = qp, Vm = Jp, Um = rm, Km = Di, Hm = ri, qm = um.forEach, Wm = Er("hidden"), Gm = "Symbol", Ym = "prototype", Qm = Hm.set, Zm = Hm.getterFor(Gm), Jm = Object[Ym], $m = pm.Symbol, Xm = $m && $m[Ym], ef = pm.RangeError, tf = pm.TypeError, rf = pm.QObject, af = Em.f, nf = Rm.f, of = Im.f, lf = Fm.f, cf = fm([].push), sf = Om("symbols"), uf = Om("op-symbols"), df = Om("wks"), pf = !rf || !rf[Ym] || !rf[Ym].findChild, mf = function(e, t, r) {
        var a = af(Jm, t);
        a && delete Jm[t], nf(e, t, r), a && e !== Jm && nf(Jm, t, a);
    }, ff = hm && ym(function() {
        return 7 !== wm(nf({}, "a", {
            get: function() {
                return nf(this, "a", {
                    value: 7
                }).a;
            }
        })).a;
    }) ? mf : nf, hf = function(e, t) {
        var r = sf[e] = wm(Xm);
        return Qm(r, {
            type: Gm,
            tag: e,
            description: t
        }), hm || (r.description = t), r;
    }, vf = function(e, t, r) {
        e === Jm && vf(uf, t, r), km(e);
        var a = _m(t);
        return km(r), gm(sf, a) ? (r.enumerable ? (gm(e, Wm) && e[Wm][a] && (e[Wm][a] = !1), r = wm(r, {
            enumerable: Pm(0, !1)
        })) : (gm(e, Wm) || nf(e, Wm, Pm(1, {})), e[Wm][a] = !0), ff(e, a, r)) : nf(e, a, r);
    }, yf = function(e, t) {
        km(e);
        var r = Cm(t), a = Sm(r).concat(Cf(r));
        return qm(a, function(t) {
            hm && !mm(gf, r, t) || vf(e, t, r[t]);
        }), e;
    }, gf = function(e) {
        var t = _m(e), r = mm(lf, this, t);
        return !(this === Jm && gm(sf, t) && !gm(uf, t)) && (!(r || !gm(this, t) || !gm(sf, t) || gm(this, Wm) && this[Wm][t]) || r);
    }, bf = function(e, t) {
        var r = Cm(e), a = _m(t);
        if (r !== Jm || !gm(sf, a) || gm(uf, a)) {
            var n = af(r, a);
            return !n || !gm(sf, a) || gm(r, Wm) && r[Wm][a] || (n.enumerable = !0), n;
        }
    }, kf = function(e) {
        var t = of(Cm(e)), r = [];
        return qm(t, function(e) {
            gm(sf, e) || gm(jm, e) || cf(r, e);
        }), r;
    }, Cf = function(e) {
        var t = e === Jm, r = of(t ? uf : Cm(e)), a = [];
        return qm(r, function(e) {
            !gm(sf, e) || t && !gm(Jm, e) || cf(a, sf[e]);
        }), a;
    };
    vm || ($m = function() {
        if (bm(Xm, this)) throw new tf("Symbol is not a constructor");
        var e = arguments.length && void 0 !== arguments[0] ? Nm(arguments[0]) : void 0, t = Bm(e), r = function(e) {
            var a = void 0 === this ? pm : this;
            a === Jm && mm(r, uf, e), gm(a, Wm) && gm(a[Wm], t) && (a[Wm][t] = !1);
            var n = Pm(1, e);
            try {
                ff(a, t, n);
            } catch (e) {
                if (!(e instanceof ef)) throw e;
                mf(a, t, n);
            }
        };
        return hm && pf && ff(Jm, t, {
            configurable: !0,
            set: r
        }), hf(t, e);
    }, Tm(Xm = $m[Ym], "toString", function() {
        return Zm(this).tag;
    }), Tm($m, "withoutSetter", function(e) {
        return hf(Bm(e), e);
    }), Fm.f = gf, Rm.f = vf, xm.f = yf, Em.f = bf, Am.f = Im.f = kf, Dm.f = Cf, Lm.f = function(e) {
        return hf(Mm(e), e);
    }, hm && zm(Xm, "description", {
        configurable: !0,
        get: function() {
            return Zm(this).description;
        }
    })), dm({
        global: !0,
        constructor: !0,
        wrap: !0,
        forced: !vm,
        sham: !vm
    }, {
        Symbol: $m
    }), qm(Sm(df), function(e) {
        Vm(e);
    }), dm({
        target: Gm,
        stat: !0,
        forced: !vm
    }, {
        useSetter: function() {
            pf = !0;
        },
        useSimple: function() {
            pf = !1;
        }
    }), dm({
        target: "Object",
        stat: !0,
        forced: !vm,
        sham: !hm
    }, {
        create: function(e, t) {
            return void 0 === t ? wm(e) : yf(wm(e), t);
        },
        defineProperty: vf,
        defineProperties: yf,
        getOwnPropertyDescriptor: bf
    }), dm({
        target: "Object",
        stat: !0,
        forced: !vm
    }, {
        getOwnPropertyNames: kf
    }), Um(), Km($m, Gm), jm[Wm] = !0;
    var _f = ge && !!Symbol.for && !!Symbol.keyFor, Nf = Ar, Pf = oe, wf = Je, Sf = vo, Af = qe, If = _f, Df = Af("string-to-symbol-registry"), Ef = Af("symbol-to-string-registry");
    Nf({
        target: "Symbol",
        stat: !0,
        forced: !If
    }, {
        for: function(e) {
            var t = Sf(e);
            if (wf(Df, t)) return Df[t];
            var r = Pf("Symbol")(t);
            return Df[t] = r, Ef[r] = t, r;
        }
    });
    var Rf = Ar, xf = Je, Ff = Pe, Tf = Se, zf = _f, Of = qe("symbol-to-string-registry");
    Rf({
        target: "Symbol",
        stat: !0,
        forced: !zf
    }, {
        keyFor: function(e) {
            if (!Ff(e)) throw new TypeError(Tf(e) + " is not a symbol");
            if (xf(Of, e)) return Of[e];
        }
    });
    var jf = tp, Bf = S, Mf = b, Lf = vo, Vf = h([].push), Uf = Ar, Kf = oe, Hf = u, qf = R, Wf = h, Gf = n, Yf = S, Qf = Pe, Zf = $l, Jf = function(e) {
        if (Bf(e)) return e;
        if (jf(e)) {
            for(var t = e.length, r = [], a = 0; a < t; a++){
                var n = e[a];
                "string" == typeof n ? Vf(r, n) : "number" != typeof n && "Number" !== Mf(n) && "String" !== Mf(n) || Vf(r, Lf(n));
            }
            var o = r.length, i = !0;
            return function(e, t) {
                if (i) return i = !1, t;
                if (jf(this)) return t;
                for(var a = 0; a < o; a++)if (r[a] === e) return t;
            };
        }
    }, $f = ge, Xf = String, eh = Kf("JSON", "stringify"), th = Wf(/./.exec), rh = Wf("".charAt), ah = Wf("".charCodeAt), nh = Wf("".replace), oh = Wf(1..toString), ih = /[\uD800-\uDFFF]/g, lh = /^[\uD800-\uDBFF]$/, ch = /^[\uDC00-\uDFFF]$/, sh = !$f || Gf(function() {
        var e = Kf("Symbol")("stringify detection");
        return "[null]" !== eh([
            e
        ]) || "{}" !== eh({
            a: e
        }) || "{}" !== eh(Object(e));
    }), uh = Gf(function() {
        return '"\udf06\ud834"' !== eh("\udf06\ud834") || '"\udead"' !== eh("\udead");
    }), dh = function(e, t) {
        var r = Zf(arguments), a = Jf(t);
        if (Yf(a) || void 0 !== e && !Qf(e)) return r[1] = function(e, t) {
            if (Yf(a) && (t = qf(a, this, Xf(e), t)), !Qf(t)) return t;
        }, Hf(eh, null, r);
    }, ph = function(e, t, r) {
        var a = rh(r, t - 1), n = rh(r, t + 1);
        return th(lh, e) && !th(ch, n) || th(ch, e) && !th(lh, a) ? "\\u" + oh(ah(e, 0), 16) : e;
    };
    eh && Uf({
        target: "JSON",
        stat: !0,
        arity: 3,
        forced: sh || uh
    }, {
        stringify: function(e, t, r) {
            var a = Zf(arguments), n = Hf(sh ? dh : eh, null, a);
            return uh && "string" == typeof n ? nh(n, ih, ph) : n;
        }
    });
    var mh = wa, fh = Ye;
    Ar({
        target: "Object",
        stat: !0,
        forced: !ge || n(function() {
            mh.f(1);
        })
    }, {
        getOwnPropertySymbols: function(e) {
            var t = mh.f;
            return t ? t(fh(e)) : [];
        }
    }), Jp("asyncIterator"), Jp("hasInstance"), Jp("isConcatSpreadable"), Jp("iterator"), Jp("match"), Jp("matchAll"), Jp("replace"), Jp("search"), Jp("species"), Jp("split");
    var hh = rm;
    Jp("toPrimitive"), hh();
    var vh = oe, yh = Di;
    Jp("toStringTag"), yh(vh("Symbol"), "Symbol"), Jp("unscopables"), Di(a.JSON, "JSON", !0);
    var gh = ee.Symbol, bh = dt, kh = Zt.f, Ch = bh("metadata"), _h = Function.prototype;
    void 0 === _h[Ch] && kh(_h, Ch, {
        value: null
    }), Jp("asyncDispose"), Jp("dispose"), Jp("metadata");
    var Nh = gh, Ph = h, wh = oe("Symbol"), Sh = wh.keyFor, Ah = Ph(wh.prototype.valueOf), Ih = wh.isRegisteredSymbol || function(e) {
        try {
            return void 0 !== Sh(Ah(e));
        } catch (e) {
            return !1;
        }
    };
    Ar({
        target: "Symbol",
        stat: !0
    }, {
        isRegisteredSymbol: Ih
    });
    for(var Dh = qe, Eh = oe, Rh = h, xh = Pe, Fh = dt, Th = Eh("Symbol"), zh = Th.isWellKnownSymbol, Oh = Eh("Object", "getOwnPropertyNames"), jh = Rh(Th.prototype.valueOf), Bh = Dh("wks"), Mh = 0, Lh = Oh(Th), Vh = Lh.length; Mh < Vh; Mh++)try {
        var Uh = Lh[Mh];
        xh(Th[Uh]) && Fh(Uh);
    } catch (eV) {}
    var Kh = function(e) {
        if (zh && zh(e)) return !0;
        try {
            for(var t = jh(e), r = 0, a = Oh(Bh), n = a.length; r < n; r++)if (Bh[a[r]] == t) return !0;
        } catch (e) {}
        return !1;
    };
    Ar({
        target: "Symbol",
        stat: !0,
        forced: !0
    }, {
        isWellKnownSymbol: Kh
    }), Jp("matcher"), Jp("observable"), Ar({
        target: "Symbol",
        stat: !0,
        name: "isRegisteredSymbol"
    }, {
        isRegistered: Ih
    }), Ar({
        target: "Symbol",
        stat: !0,
        name: "isWellKnownSymbol",
        forced: !0
    }, {
        isWellKnown: Kh
    }), Jp("metadataKey"), Jp("patternMatch"), Jp("replaceAll");
    var Hh = Nh, qh = t(Hh), Wh = qp.f("iterator"), Gh = Wh, Yh = t(Gh);
    !function(e) {
        var t = Hh, r = Gh;
        function a(n) {
            return e.exports = a = "function" == typeof t && "symbol" == typeof r ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof t && e.constructor === t && e !== t.prototype ? "symbol" : typeof e;
            }, e.exports.__esModule = !0, e.exports.default = e.exports, a(n);
        }
        e.exports = a, e.exports.__esModule = !0, e.exports.default = e.exports;
    }(Xd);
    var Qh = Xd.exports, Zh = {
        exports: {}
    }, Jh = Ar, $h = I, Xh = Zt.f;
    Jh({
        target: "Object",
        stat: !0,
        forced: Object.defineProperty !== Xh,
        sham: !$h
    }, {
        defineProperty: Xh
    });
    var ev = ee.Object, tv = Zh.exports = function(e, t, r) {
        return ev.defineProperty(e, t, r);
    };
    ev.defineProperty.sham && (tv.sham = !0);
    var rv = Zh.exports, av = rv, nv = t(av);
    Ar({
        target: "Object",
        stat: !0,
        sham: !I
    }, {
        create: cn
    });
    var ov = ee.Object, iv = function(e, t) {
        return ov.create(e, t);
    }, lv = iv, cv = lv, sv = t(cv), uv = Ye, dv = Mr, pv = Rr;
    Ar({
        target: "Object",
        stat: !0,
        forced: n(function() {
            dv(1);
        }),
        sham: !pv
    }, {
        getPrototypeOf: function(e) {
            return dv(uv(e));
        }
    });
    var mv = ee.Object.getPrototypeOf, fv = t(mv), hv = n, vv = function(e, t) {
        var r = [][e];
        return !!r && hv(function() {
            r.call(null, t || function() {
                return 1;
            }, 1);
        });
    }, yv = um.forEach, gv = vv("forEach") ? [].forEach : function(e) {
        return yv(this, e, arguments.length > 1 ? arguments[1] : void 0);
    };
    Ar({
        target: "Array",
        proto: !0,
        forced: [].forEach !== gv
    }, {
        forEach: gv
    });
    var bv = a, kv = ee, Cv = function(e, t) {
        var r = kv[e + "Prototype"], a = r && r[t];
        if (a) return a;
        var n = bv[e], o = n && n.prototype;
        return o && o[t];
    }, _v = Cv("Array", "forEach"), Nv = zn, Pv = Je, wv = ie, Sv = _v, Av = Array.prototype, Iv = {
        DOMTokenList: !0,
        NodeList: !0
    }, Dv = function(e) {
        var t = e.forEach;
        return e === Av || wv(Av, e) && t === Av.forEach || Pv(Iv, Nv(e)) ? Sv : t;
    }, Ev = Dv, Rv = I, xv = tp, Fv = TypeError, Tv = Object.getOwnPropertyDescriptor, zv = Rv && !function() {
        if (void 0 !== this) return !0;
        try {
            Object.defineProperty([], "length", {
                writable: !1
            }).length = 1;
        } catch (e) {
            return e instanceof TypeError;
        }
    }(), Ov = zv ? function(e, t) {
        if (xv(e) && !Tv(e, "length").writable) throw new Fv("Cannot set read only .length");
        return e.length = t;
    } : function(e, t) {
        return e.length = t;
    }, jv = Ar, Bv = Ye, Mv = sa, Lv = Ov, Vv = ap, Uv = n(function() {
        return 4294967297 !== [].push.call({
            length: 4294967296
        }, 1);
    }) || !function() {
        try {
            Object.defineProperty([], "length", {
                writable: !1
            }).push();
        } catch (e) {
            return e instanceof TypeError;
        }
    }();
    jv({
        target: "Array",
        proto: !0,
        arity: 1,
        forced: Uv
    }, {
        push: function(e) {
            var t = Bv(this), r = Mv(t), a = arguments.length;
            Vv(r + a);
            for(var n = 0; n < a; n++)t[r] = arguments[n], r++;
            return Lv(t, r), r;
        }
    });
    var Kv = Cv("Array", "push"), Hv = ie, qv = Kv, Wv = Array.prototype, Gv = function(e) {
        var t = e.push;
        return e === Wv || Hv(Wv, e) && t === Wv.push ? qv : t;
    }, Yv = t(Gv);
    Ar({
        target: "Object",
        stat: !0
    }, {
        setPrototypeOf: Yr
    });
    var Qv = ee.Object.setPrototypeOf, Zv = t(Qv), Jv = Ar, $v = tp, Xv = h([].reverse), ey = [
        1,
        2
    ];
    Jv({
        target: "Array",
        proto: !0,
        forced: String(ey) === String(ey.reverse())
    }, {
        reverse: function() {
            return $v(this) && (this.length = this.length), Xv(this);
        }
    });
    var ty = Cv("Array", "reverse"), ry = ie, ay = ty, ny = Array.prototype, oy = function(e) {
        var t = e.reverse;
        return e === ny || ry(ny, e) && t === ny.reverse ? ay : t;
    }, iy = oy, ly = Ar, cy = tp, sy = Ul, uy = X, dy = na, py = sa, my = Z, fy = lp, hy = dt, vy = $l, yy = gp("slice"), gy = hy("species"), by = Array, ky = Math.max;
    ly({
        target: "Array",
        proto: !0,
        forced: !yy
    }, {
        slice: function(e, t) {
            var r, a, n, o = my(this), i = py(o), l = dy(e, i), c = dy(void 0 === t ? i : t, i);
            if (cy(o) && (r = o.constructor, (sy(r) && (r === by || cy(r.prototype)) || uy(r) && null === (r = r[gy])) && (r = void 0), r === by || void 0 === r)) return vy(o, l, c);
            for(a = new (void 0 === r ? by : r)(ky(c - l, 0)), n = 0; l < c; l++, n++)l in o && fy(a, n, o[l]);
            return a.length = n, a;
        }
    });
    var Cy = Cv("Array", "slice"), _y = ie, Ny = Cy, Py = Array.prototype, wy = function(e) {
        var t = e.slice;
        return e === Py || _y(Py, e) && t === Py.slice ? Ny : t;
    }, Sy = wy, Ay = t(Sy);
    !function(e) {
        var t = Qh.default, r = av, a = Hh, n = cv, o = mv, i = Ev, l = Gv, c = Qv, s = Yd, u = iy, d = Sy;
        function p() {
            e.exports = p = function() {
                return f;
            }, e.exports.__esModule = !0, e.exports.default = e.exports;
            var m, f = {}, h = Object.prototype, v = h.hasOwnProperty, y = r || function(e, t, r) {
                e[t] = r.value;
            }, g = "function" == typeof a ? a : {}, b = g.iterator || "@@iterator", k = g.asyncIterator || "@@asyncIterator", C = g.toStringTag || "@@toStringTag";
            function _(e, t, a) {
                return r(e, t, {
                    value: a,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), e[t];
            }
            try {
                _({}, "");
            } catch (m) {
                _ = function(e, t, r) {
                    return e[t] = r;
                };
            }
            function N(e, t, r, a) {
                var o = t && t.prototype instanceof E ? t : E, i = n(o.prototype), l = new U(a || []);
                return y(i, "_invoke", {
                    value: B(e, r, l)
                }), i;
            }
            function P(e, t, r) {
                try {
                    return {
                        type: "normal",
                        arg: e.call(t, r)
                    };
                } catch (e) {
                    return {
                        type: "throw",
                        arg: e
                    };
                }
            }
            f.wrap = N;
            var w = "suspendedStart", S = "suspendedYield", A = "executing", I = "completed", D = {};
            function E() {}
            function R() {}
            function x() {}
            var F = {};
            _(F, b, function() {
                return this;
            });
            var T = o && o(o(K([])));
            T && T !== h && v.call(T, b) && (F = T);
            var z = x.prototype = E.prototype = n(F);
            function O(e) {
                var t;
                i(t = [
                    "next",
                    "throw",
                    "return"
                ]).call(t, function(t) {
                    _(e, t, function(e) {
                        return this._invoke(t, e);
                    });
                });
            }
            function j(e, r) {
                function a(n, o, i, l) {
                    var c = P(e[n], e, o);
                    if ("throw" !== c.type) {
                        var s = c.arg, u = s.value;
                        return u && "object" == t(u) && v.call(u, "__await") ? r.resolve(u.__await).then(function(e) {
                            a("next", e, i, l);
                        }, function(e) {
                            a("throw", e, i, l);
                        }) : r.resolve(u).then(function(e) {
                            s.value = e, i(s);
                        }, function(e) {
                            return a("throw", e, i, l);
                        });
                    }
                    l(c.arg);
                }
                var n;
                y(this, "_invoke", {
                    value: function(e, t) {
                        function o() {
                            return new r(function(r, n) {
                                a(e, t, r, n);
                            });
                        }
                        return n = n ? n.then(o, o) : o();
                    }
                });
            }
            function B(e, t, r) {
                var a = w;
                return function(n, o) {
                    if (a === A) throw new Error("Generator is already running");
                    if (a === I) {
                        if ("throw" === n) throw o;
                        return {
                            value: m,
                            done: !0
                        };
                    }
                    for(r.method = n, r.arg = o;;){
                        var i = r.delegate;
                        if (i) {
                            var l = M(i, r);
                            if (l) {
                                if (l === D) continue;
                                return l;
                            }
                        }
                        if ("next" === r.method) r.sent = r._sent = r.arg;
                        else if ("throw" === r.method) {
                            if (a === w) throw a = I, r.arg;
                            r.dispatchException(r.arg);
                        } else "return" === r.method && r.abrupt("return", r.arg);
                        a = A;
                        var c = P(e, t, r);
                        if ("normal" === c.type) {
                            if (a = r.done ? I : S, c.arg === D) continue;
                            return {
                                value: c.arg,
                                done: r.done
                            };
                        }
                        "throw" === c.type && (a = I, r.method = "throw", r.arg = c.arg);
                    }
                };
            }
            function M(e, t) {
                var r = t.method, a = e.iterator[r];
                if (a === m) return t.delegate = null, "throw" === r && e.iterator.return && (t.method = "return", t.arg = m, M(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), D;
                var n = P(a, e.iterator, t.arg);
                if ("throw" === n.type) return t.method = "throw", t.arg = n.arg, t.delegate = null, D;
                var o = n.arg;
                return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = m), t.delegate = null, D) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, D);
            }
            function L(e) {
                var t, r = {
                    tryLoc: e[0]
                };
                1 in e && (r.catchLoc = e[1]), 2 in e && (r.finallyLoc = e[2], r.afterLoc = e[3]), l(t = this.tryEntries).call(t, r);
            }
            function V(e) {
                var t = e.completion || {};
                t.type = "normal", delete t.arg, e.completion = t;
            }
            function U(e) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], i(e).call(e, L, this), this.reset(!0);
            }
            function K(e) {
                if (e || "" === e) {
                    var r = e[b];
                    if (r) return r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var a = -1, n = function t() {
                            for(; ++a < e.length;)if (v.call(e, a)) return t.value = e[a], t.done = !1, t;
                            return t.value = m, t.done = !0, t;
                        };
                        return n.next = n;
                    }
                }
                throw new TypeError(t(e) + " is not iterable");
            }
            return R.prototype = x, y(z, "constructor", {
                value: x,
                configurable: !0
            }), y(x, "constructor", {
                value: R,
                configurable: !0
            }), R.displayName = _(x, C, "GeneratorFunction"), f.isGeneratorFunction = function(e) {
                var t = "function" == typeof e && e.constructor;
                return !!t && (t === R || "GeneratorFunction" === (t.displayName || t.name));
            }, f.mark = function(e) {
                return c ? c(e, x) : (e.__proto__ = x, _(e, C, "GeneratorFunction")), e.prototype = n(z), e;
            }, f.awrap = function(e) {
                return {
                    __await: e
                };
            }, O(j.prototype), _(j.prototype, k, function() {
                return this;
            }), f.AsyncIterator = j, f.async = function(e, t, r, a, n) {
                void 0 === n && (n = s);
                var o = new j(N(e, t, r, a), n);
                return f.isGeneratorFunction(t) ? o : o.next().then(function(e) {
                    return e.done ? e.value : o.next();
                });
            }, O(z), _(z, C, "Generator"), _(z, b, function() {
                return this;
            }), _(z, "toString", function() {
                return "[object Generator]";
            }), f.keys = function(e) {
                var t = Object(e), r = [];
                for(var a in t)l(r).call(r, a);
                return u(r).call(r), function e() {
                    for(; r.length;){
                        var a = r.pop();
                        if (a in t) return e.value = a, e.done = !1, e;
                    }
                    return e.done = !0, e;
                };
            }, f.values = K, U.prototype = {
                constructor: U,
                reset: function(e) {
                    var t;
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = m, this.done = !1, this.delegate = null, this.method = "next", this.arg = m, i(t = this.tryEntries).call(t, V), !e) for(var r in this)"t" === r.charAt(0) && v.call(this, r) && !isNaN(+d(r).call(r, 1)) && (this[r] = m);
                },
                stop: function() {
                    this.done = !0;
                    var e = this.tryEntries[0].completion;
                    if ("throw" === e.type) throw e.arg;
                    return this.rval;
                },
                dispatchException: function(e) {
                    if (this.done) throw e;
                    var t = this;
                    function r(r, a) {
                        return o.type = "throw", o.arg = e, t.next = r, a && (t.method = "next", t.arg = m), !!a;
                    }
                    for(var a = this.tryEntries.length - 1; a >= 0; --a){
                        var n = this.tryEntries[a], o = n.completion;
                        if ("root" === n.tryLoc) return r("end");
                        if (n.tryLoc <= this.prev) {
                            var i = v.call(n, "catchLoc"), l = v.call(n, "finallyLoc");
                            if (i && l) {
                                if (this.prev < n.catchLoc) return r(n.catchLoc, !0);
                                if (this.prev < n.finallyLoc) return r(n.finallyLoc);
                            } else if (i) {
                                if (this.prev < n.catchLoc) return r(n.catchLoc, !0);
                            } else {
                                if (!l) throw new Error("try statement without catch or finally");
                                if (this.prev < n.finallyLoc) return r(n.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function(e, t) {
                    for(var r = this.tryEntries.length - 1; r >= 0; --r){
                        var a = this.tryEntries[r];
                        if (a.tryLoc <= this.prev && v.call(a, "finallyLoc") && this.prev < a.finallyLoc) {
                            var n = a;
                            break;
                        }
                    }
                    n && ("break" === e || "continue" === e) && n.tryLoc <= t && t <= n.finallyLoc && (n = null);
                    var o = n ? n.completion : {};
                    return o.type = e, o.arg = t, n ? (this.method = "next", this.next = n.finallyLoc, D) : this.complete(o);
                },
                complete: function(e, t) {
                    if ("throw" === e.type) throw e.arg;
                    return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), D;
                },
                finish: function(e) {
                    for(var t = this.tryEntries.length - 1; t >= 0; --t){
                        var r = this.tryEntries[t];
                        if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), V(r), D;
                    }
                },
                catch: function(e) {
                    for(var t = this.tryEntries.length - 1; t >= 0; --t){
                        var r = this.tryEntries[t];
                        if (r.tryLoc === e) {
                            var a = r.completion;
                            if ("throw" === a.type) {
                                var n = a.arg;
                                V(r);
                            }
                            return n;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function(e, t, r) {
                    return this.delegate = {
                        iterator: K(e),
                        resultName: t,
                        nextLoc: r
                    }, "next" === this.method && (this.arg = m), D;
                }
            }, f;
        }
        e.exports = p, e.exports.__esModule = !0, e.exports.default = e.exports;
    }($d);
    var Iy = (0, $d.exports)(), Dy = Iy;
    try {
        regeneratorRuntime = Iy;
    } catch (e) {
        "object" == typeof globalThis ? globalThis.regeneratorRuntime = Iy : Function("r", "regeneratorRuntime = r")(Iy);
    }
    var Ey = t(Dy), Ry = Ye, xy = Ma;
    Ar({
        target: "Object",
        stat: !0,
        forced: n(function() {
            xy(1);
        })
    }, {
        keys: function(e) {
            return xy(Ry(e));
        }
    });
    var Fy = ee.Object.keys, Ty = t(Fy), zy = ee.Object.getOwnPropertySymbols, Oy = t(zy), jy = {
        exports: {}
    }, By = Ar, My = n, Ly = Z, Vy = A.f, Uy = I;
    By({
        target: "Object",
        stat: !0,
        forced: !Uy || My(function() {
            Vy(1);
        }),
        sham: !Uy
    }, {
        getOwnPropertyDescriptor: function(e, t) {
            return Vy(Ly(e), t);
        }
    });
    var Ky = ee.Object, Hy = jy.exports = function(e, t) {
        return Ky.getOwnPropertyDescriptor(e, t);
    };
    Ky.getOwnPropertyDescriptor.sham && (Hy.sham = !0);
    var qy = jy.exports, Wy = t(qy), Gy = Ra, Yy = Z, Qy = A, Zy = lp;
    Ar({
        target: "Object",
        stat: !0,
        sham: !I
    }, {
        getOwnPropertyDescriptors: function(e) {
            for(var t, r, a = Yy(e), n = Qy.f, o = Gy(a), i = {}, l = 0; o.length > l;)void 0 !== (r = n(a, t = o[l++])) && Zy(i, t, r);
            return i;
        }
    });
    var Jy = t(ee.Object.getOwnPropertyDescriptors), $y = {
        exports: {}
    }, Xy = Ar, eg = I, tg = Oa.f;
    Xy({
        target: "Object",
        stat: !0,
        forced: Object.defineProperties !== tg,
        sham: !eg
    }, {
        defineProperties: tg
    });
    var rg = ee.Object, ag = $y.exports = function(e, t) {
        return rg.defineProperties(e, t);
    };
    rg.defineProperties.sham && (ag.sham = !0);
    var ng = t($y.exports), og = t(rv);
    function ig(e) {
        return ig = "function" == typeof qh && "symbol" == typeof Yh ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof qh && e.constructor === qh && e !== qh.prototype ? "symbol" : typeof e;
        }, ig(e);
    }
    var lg = t(zy), cg = Ar, sg = fa.indexOf, ug = vv, dg = _([].indexOf), pg = !!dg && 1 / dg([
        1
    ], 1, -0) < 0;
    cg({
        target: "Array",
        proto: !0,
        forced: pg || !ug("indexOf")
    }, {
        indexOf: function(e) {
            var t = arguments.length > 1 ? arguments[1] : void 0;
            return pg ? dg(this, e, t) || 0 : sg(this, e, t);
        }
    });
    var mg = Cv("Array", "indexOf"), fg = ie, hg = mg, vg = Array.prototype, yg = function(e) {
        var t = e.indexOf;
        return e === vg || fg(vg, e) && t === vg.indexOf ? hg : t;
    }, gg = t(yg), bg = t(Fy);
    function kg(e, t) {
        if (null == e) return {};
        var r, a, n = function(e, t) {
            if (null == e) return {};
            var r, a, n = {}, o = bg(e);
            for(a = 0; a < o.length; a++)r = o[a], gg(t).call(t, r) >= 0 || (n[r] = e[r]);
            return n;
        }(e, t);
        if (lg) {
            var o = lg(e);
            for(a = 0; a < o.length; a++)r = o[a], gg(t).call(t, r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
        }
        return n;
    }
    function Cg(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    var _g = t(qp.f("toPrimitive"));
    function Ng(e) {
        var t = function(e, t) {
            if ("object" !== ig(e) || null === e) return e;
            var r = e[_g];
            if (void 0 !== r) {
                var a = r.call(e, t || "default");
                if ("object" !== ig(a)) return a;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" === ig(t) ? t : String(t);
    }
    function Pg(e, t) {
        for(var r = 0; r < t.length; r++){
            var a = t[r];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), nv(e, Ng(a.key), a);
        }
    }
    function wg(e, t, r) {
        return t && Pg(e.prototype, t), r && Pg(e, r), nv(e, "prototype", {
            writable: !1
        }), e;
    }
    function Sg(e, t, r) {
        return (t = Ng(t)) in e ? nv(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    var Ag = t(Dv), Ig = um.filter;
    Ar({
        target: "Array",
        proto: !0,
        forced: !gp("filter")
    }, {
        filter: function(e) {
            return Ig(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var Dg = Cv("Array", "filter"), Eg = ie, Rg = Dg, xg = Array.prototype, Fg = t(function(e) {
        var t = e.filter;
        return e === xg || Eg(xg, e) && t === xg.filter ? Rg : t;
    }), Tg = h, zg = Ee, Og = X, jg = Je, Bg = $l, Mg = o, Lg = Function, Vg = Tg([].concat), Ug = Tg([].join), Kg = {}, Hg = Mg ? Lg.bind : function(e) {
        var t = zg(this), r = t.prototype, a = Bg(arguments, 1), n = function() {
            var r = Vg(a, Bg(arguments));
            return this instanceof n ? function(e, t, r) {
                if (!jg(Kg, t)) {
                    for(var a = [], n = 0; n < t; n++)a[n] = "a[" + n + "]";
                    Kg[t] = Lg("C,a", "return new C(" + Ug(a, ",") + ")");
                }
                return Kg[t](e, r);
            }(t, r.length, r) : t.apply(e, r);
        };
        return Og(r) && (n.prototype = r), n;
    }, qg = Hg;
    Ar({
        target: "Function",
        proto: !0,
        forced: Function.bind !== qg
    }, {
        bind: qg
    });
    var Wg = Cv("Function", "bind"), Gg = ie, Yg = Wg, Qg = Function.prototype, Zg = function(e) {
        var t = e.bind;
        return e === Qg || Gg(Qg, e) && t === Qg.bind ? Yg : t;
    }, Jg = t(Zg), $g = fa.includes;
    Ar({
        target: "Array",
        proto: !0,
        forced: n(function() {
            return !Array(1).includes();
        })
    }, {
        includes: function(e) {
            return $g(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var Xg = Cv("Array", "includes"), eb = X, tb = b, rb = dt("match"), ab = function(e) {
        var t;
        return eb(e) && (void 0 !== (t = e[rb]) ? !!t : "RegExp" === tb(e));
    }, nb = TypeError, ob = function(e) {
        if (ab(e)) throw new nb("The method doesn't accept regular expressions");
        return e;
    }, ib = dt("match"), lb = function(e) {
        var t = /./;
        try {
            "/./"[e](t);
        } catch (r) {
            try {
                return t[ib] = !1, "/./"[e](t);
            } catch (e) {}
        }
        return !1;
    }, cb = Ar, sb = ob, ub = G, db = vo, pb = lb, mb = h("".indexOf);
    cb({
        target: "String",
        proto: !0,
        forced: !pb("includes")
    }, {
        includes: function(e) {
            return !!~mb(db(ub(this)), db(sb(e)), arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var fb = Cv("String", "includes"), hb = ie, vb = Xg, yb = fb, gb = Array.prototype, bb = String.prototype, kb = t(function(e) {
        var t = e.includes;
        return e === gb || hb(gb, e) && t === gb.includes ? vb : "string" == typeof e || e === bb || hb(bb, e) && t === bb.includes ? yb : t;
    }), Cb = Cv("Array", "concat"), _b = ie, Nb = Cb, Pb = Array.prototype, wb = t(function(e) {
        var t = e.concat;
        return e === Pb || _b(Pb, e) && t === Pb.concat ? Nb : t;
    }), Sb = t(Kd), Ab = Ar, Ib = um.find, Db = "find", Eb = !0;
    Db in [] && Array(1)[Db](function() {
        Eb = !1;
    }), Ab({
        target: "Array",
        proto: !0,
        forced: Eb
    }, {
        find: function(e) {
            return Ib(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var Rb = Cv("Array", "find"), xb = ie, Fb = Rb, Tb = Array.prototype, zb = t(function(e) {
        var t = e.find;
        return e === Tb || xb(Tb, e) && t === Tb.find ? Fb : t;
    }), Ob = ee, jb = u;
    Ob.JSON || (Ob.JSON = {
        stringify: JSON.stringify
    });
    var Bb = function(e, t, r) {
        return jb(Ob.JSON.stringify, null, arguments);
    }, Mb = t(Bb), Lb = !n(function() {
        return Object.isExtensible(Object.preventExtensions({}));
    }), Vb = {
        exports: {}
    }, Ub = n(function() {
        if ("function" == typeof ArrayBuffer) {
            var e = new ArrayBuffer(8);
            Object.isExtensible(e) && Object.defineProperty(e, "a", {
                value: 8
            });
        }
    }), Kb = n, Hb = X, qb = b, Wb = Ub, Gb = Object.isExtensible, Yb = Kb(function() {
        Gb(1);
    }) || Wb ? function(e) {
        return !!Hb(e) && (!Wb || "ArrayBuffer" !== qb(e)) && (!Gb || Gb(e));
    } : Gb, Qb = Ar, Zb = h, Jb = ha, $b = X, Xb = Je, ek = Zt.f, tk = Qr, rk = Fp, ak = Yb, nk = Lb, ok = !1, ik = rt("meta"), lk = 0, ck = function(e) {
        ek(e, ik, {
            value: {
                objectID: "O" + lk++,
                weakData: {}
            }
        });
    }, sk = Vb.exports = {
        enable: function() {
            sk.enable = function() {}, ok = !0;
            var e = tk.f, t = Zb([].splice), r = {};
            r[ik] = 1, e(r).length && (tk.f = function(r) {
                for(var a = e(r), n = 0, o = a.length; n < o; n++)if (a[n] === ik) {
                    t(a, n, 1);
                    break;
                }
                return a;
            }, Qb({
                target: "Object",
                stat: !0,
                forced: !0
            }, {
                getOwnPropertyNames: rk.f
            }));
        },
        fastKey: function(e, t) {
            if (!$b(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;
            if (!Xb(e, ik)) {
                if (!ak(e)) return "F";
                if (!t) return "E";
                ck(e);
            }
            return e[ik].objectID;
        },
        getWeakData: function(e, t) {
            if (!Xb(e, ik)) {
                if (!ak(e)) return !0;
                if (!t) return !1;
                ck(e);
            }
            return e[ik].weakData;
        },
        onFreeze: function(e) {
            return nk && ok && ak(e) && !Xb(e, ik) && ck(e), e;
        }
    };
    Jb[ik] = !0;
    var uk = Vb.exports, dk = Ar, pk = Lb, mk = n, fk = X, hk = uk.onFreeze, vk = Object.freeze;
    dk({
        target: "Object",
        stat: !0,
        forced: mk(function() {
            vk(1);
        }),
        sham: !pk
    }, {
        freeze: function(e) {
            return vk && fk(e) ? vk(hk(e)) : e;
        }
    });
    var yk = t(ee.Object.freeze);
    Ar({
        target: "Array",
        stat: !0
    }, {
        isArray: tp
    });
    var gk = ee.Array.isArray, bk = t(gk);
    var kk = Vn, Ck = t(kk);
    var _k = tr, Nk = $n, Pk = Qt, wk = R, Sk = Ye, Ak = function(e, t, r, a) {
        try {
            return a ? t(_k(r)[0], r[1]) : t(r);
        } catch (t) {
            Nk(e, "throw", t);
        }
    }, Ik = Sn, Dk = Ul, Ek = sa, Rk = lp, xk = Yn, Fk = Vn, Tk = Array, zk = function(e) {
        var t = Sk(e), r = Dk(this), a = arguments.length, n = a > 1 ? arguments[1] : void 0, o = void 0 !== n;
        o && (n = Pk(n, a > 2 ? arguments[2] : void 0));
        var i, l, c, s, u, d, p = Fk(t), m = 0;
        if (!p || this === Tk && Ik(p)) for(i = Ek(t), l = r ? new this(i) : Tk(i); i > m; m++)d = o ? n(t[m], m) : t[m], Rk(l, m, d);
        else for(u = (s = xk(t, p)).next, l = r ? new this : []; !(c = wk(u, s)).done; m++)d = o ? Ak(s, n, [
            c.value,
            m
        ], !0) : c.value, Rk(l, m, d);
        return l.length = m, l;
    }, Ok = zk;
    Ar({
        target: "Array",
        stat: !0,
        forced: !Nu(function(e) {
            Array.from(e);
        })
    }, {
        from: Ok
    });
    var jk = ee.Array.from, Bk = t(jk);
    function Mk(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, a = new Array(t); r < t; r++)a[r] = e[r];
        return a;
    }
    function Lk(e, t) {
        var r;
        if (e) {
            if ("string" == typeof e) return Mk(e, t);
            var a = Ay(r = Object.prototype.toString.call(e)).call(r, 8, -1);
            return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Bk(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? Mk(e, t) : void 0;
        }
    }
    function Vk(e, t) {
        return function(e) {
            if (bk(e)) return e;
        }(e) || function(e, t) {
            var r = null == e ? null : void 0 !== qh && Ck(e) || e["@@iterator"];
            if (null != r) {
                var a, n, o, i, l = [], c = !0, s = !1;
                try {
                    if (o = (r = r.call(e)).next, 0 === t) {
                        if (Object(r) !== r) return;
                        c = !1;
                    } else for(; !(c = (a = o.call(r)).done) && (Yv(l).call(l, a.value), l.length !== t); c = !0);
                } catch (e) {
                    s = !0, n = e;
                } finally{
                    try {
                        if (!c && null != r.return && (i = r.return(), Object(i) !== i)) return;
                    } finally{
                        if (s) throw n;
                    }
                }
                return l;
            }
        }(e, t) || Lk(e, t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Uk(e) {
        return function(e) {
            if (bk(e)) return Mk(e);
        }(e) || function(e) {
            if (void 0 !== qh && null != Ck(e) || null != e["@@iterator"]) return Bk(e);
        }(e) || Lk(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    var Kk = t(yg), Hk = Ee, qk = Ye, Wk = K, Gk = sa, Yk = TypeError, Qk = function(e) {
        return function(t, r, a, n) {
            Hk(r);
            var o = qk(t), i = Wk(o), l = Gk(o), c = e ? l - 1 : 0, s = e ? -1 : 1;
            if (a < 2) for(;;){
                if (c in i) {
                    n = i[c], c += s;
                    break;
                }
                if (c += s, e ? c < 0 : l <= c) throw new Yk("Reduce of empty array with no initial value");
            }
            for(; e ? c >= 0 : l > c; c += s)c in i && (n = r(n, i[c], c, o));
            return n;
        };
    }, Zk = {
        left: Qk(!1),
        right: Qk(!0)
    }.left;
    Ar({
        target: "Array",
        proto: !0,
        forced: !ul && fe > 79 && fe < 83 || !vv("reduce")
    }, {
        reduce: function(e) {
            var t = arguments.length;
            return Zk(this, e, t, t > 1 ? arguments[1] : void 0);
        }
    });
    var Jk = Cv("Array", "reduce"), $k = ie, Xk = Jk, eC = Array.prototype, tC = t(function(e) {
        var t = e.reduce;
        return e === eC || $k(eC, e) && t === eC.reduce ? Xk : t;
    }), rC = Cv("Array", "values"), aC = zn, nC = Je, oC = ie, iC = rC, lC = Array.prototype, cC = {
        DOMTokenList: !0,
        NodeList: !0
    }, sC = t(function(e) {
        var t = e.values;
        return e === lC || oC(lC, e) && t === lC.values || nC(cC, aC(e)) ? iC : t;
    }), uC = um.map;
    Ar({
        target: "Array",
        proto: !0,
        forced: !gp("map")
    }, {
        map: function(e) {
            return uC(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var dC = Cv("Array", "map"), pC = ie, mC = dC, fC = Array.prototype, hC = t(function(e) {
        var t = e.map;
        return e === fC || pC(fC, e) && t === fC.map ? mC : t;
    }), vC = {
        payButton: "Pay",
        "payButton.redirecting": "Redirecting...",
        "payButton.with": "Pay %{value} with %{maskedData}",
        "payButton.saveDetails": "Save details",
        close: "Close",
        storeDetails: "Save for my next payment",
        readMore: "Read more",
        "creditCard.holderName": "Name on card",
        "creditCard.holderName.placeholder": "J. Smith",
        "creditCard.holderName.invalid": "Enter name as shown on card",
        "creditCard.numberField.title": "Card number",
        "creditCard.numberField.placeholder": "1234 5678 9012 3456",
        "creditCard.expiryDateField.title": "Expiry date",
        "creditCard.expiryDateField.placeholder": "MM/YY",
        "creditCard.expiryDateField.month": "Month",
        "creditCard.expiryDateField.month.placeholder": "MM",
        "creditCard.expiryDateField.year.placeholder": "YY",
        "creditCard.expiryDateField.year": "Year",
        "creditCard.cvcField.title": "Security code",
        "creditCard.cvcField.placeholder": "123",
        "creditCard.storeDetailsButton": "Remember for next time",
        "creditCard.cvcField.placeholder.4digits": "4 digits",
        "creditCard.cvcField.placeholder.3digits": "3 digits",
        "creditCard.taxNumber.placeholder": "YYMMDD / 0123456789",
        installments: "Number of installments",
        installmentOption: "%{times}x %{partialValue}",
        installmentOptionMonths: "%{times} months",
        "installments.oneTime": "One time payment",
        "installments.installments": "Installments payment",
        "installments.revolving": "Revolving payment",
        "sepaDirectDebit.ibanField.invalid": "Invalid account number",
        "sepaDirectDebit.nameField.placeholder": "J. Smith",
        "sepa.ownerName": "Holder Name",
        "sepa.ibanNumber": "Account Number (IBAN)",
        "error.title": "Error",
        "error.subtitle.redirect": "Redirect failed",
        "error.subtitle.payment": "Payment failed",
        "error.subtitle.refused": "Payment refused",
        "error.message.unknown": "An unknown error occurred",
        "errorPanel.title": "Existing errors",
        "idealIssuer.selectField.title": "Bank",
        "idealIssuer.selectField.placeholder": "Select your bank",
        "creditCard.success": "Payment Successful",
        loading: "Loading\u2026",
        continue: "Continue",
        continueTo: "Continue to",
        "wechatpay.timetopay": "You have %@ to pay",
        "sr.wechatpay.timetopay": "You have %#minutes%# %#seconds%# to pay",
        "wechatpay.scanqrcode": "Scan QR code",
        personalDetails: "Personal details",
        companyDetails: "Company details",
        "companyDetails.name": "Company name",
        "companyDetails.registrationNumber": "Registration number",
        socialSecurityNumber: "Social security number",
        firstName: "First name",
        "firstName.invalid": "Enter your first name",
        infix: "Prefix",
        lastName: "Last name",
        "lastName.invalid": "Enter your last name",
        mobileNumber: "Mobile number",
        "mobileNumber.invalid": "Invalid mobile number",
        city: "City",
        postalCode: "Postal code",
        "postalCode.optional": "Postal code (optional)",
        countryCode: "Country Code",
        telephoneNumber: "Telephone number",
        dateOfBirth: "Date of birth",
        shopperEmail: "Email address",
        gender: "Gender",
        "gender.notselected": "Select your gender",
        male: "Male",
        female: "Female",
        billingAddress: "Billing address",
        street: "Street",
        stateOrProvince: "State or province",
        country: "Country",
        houseNumberOrName: "House number",
        separateDeliveryAddress: "Specify a separate delivery address",
        deliveryAddress: "Delivery Address",
        "deliveryAddress.firstName": "Recipient first name",
        "deliveryAddress.lastName": "Recipient last name",
        zipCode: "Zip code",
        apartmentSuite: "Apartment / Suite",
        provinceOrTerritory: "Province or Territory",
        cityTown: "City / Town",
        address: "Address",
        "address.placeholder": "Find your address",
        "address.errors.incomplete": "Enter an address to continue",
        "address.enterManually": "Enter address manually",
        state: "State",
        "field.title.optional": "(optional)",
        "creditCard.cvcField.title.optional": "Security code (optional)",
        "issuerList.wallet.placeholder": "Select your wallet",
        privacyPolicy: "Privacy policy",
        "afterPay.agreement": "I agree with the %@ of Riverty",
        paymentConditions: "payment conditions",
        openApp: "Open the app",
        "voucher.readInstructions": "Read instructions",
        "voucher.introduction": "Thank you for your purchase, please use the following coupon to complete your payment.",
        "voucher.expirationDate": "Expiration Date",
        "voucher.alternativeReference": "Alternative Reference",
        "dragonpay.voucher.non.bank.selectField.placeholder": "Select your provider",
        "dragonpay.voucher.bank.selectField.placeholder": "Select your bank",
        "voucher.paymentReferenceLabel": "Payment Reference",
        "voucher.surcharge": "Incl. %@ surcharge",
        "voucher.introduction.doku": "Thank you for your purchase, please use the following information to complete your payment.",
        "voucher.shopperName": "Shopper Name",
        "voucher.merchantName": "Merchant",
        "voucher.introduction.econtext": "Thank you for your purchase, please use the following information to complete your payment.",
        "voucher.telephoneNumber": "Phone Number",
        "voucher.shopperReference": "Shopper Reference",
        "voucher.collectionInstitutionNumber": "Collection Institution Number",
        "voucher.econtext.telephoneNumber.invalid": "Telephone number must be 10 or 11 digits long",
        "boletobancario.btnLabel": "Generate Boleto",
        "boleto.sendCopyToEmail": "Send a copy to my email",
        "button.copy": "Copy",
        "button.download": "Download",
        "boleto.socialSecurityNumber": "CPF/CNPJ",
        "boleto.socialSecurityNumber.invalid": "Field is not valid",
        "creditCard.storedCard.description.ariaLabel": "Stored card ends in %@",
        "voucher.entity": "Entity",
        donateButton: "Donate",
        notNowButton: "Not now",
        thanksForYourSupport: "Thanks for your support!",
        "resultMessages.preauthorized": "Details saved",
        preauthorizeWith: "Preauthorize with",
        confirmPreauthorization: "Confirm preauthorization",
        confirmPurchase: "Confirm purchase",
        applyGiftcard: "Redeem",
        giftcardBalance: "Gift card balance",
        deductedBalance: "Deducted balance",
        "creditCard.pin.title": "Pin",
        "creditCard.encryptedPassword.label": "First 2 digits of card password",
        "creditCard.encryptedPassword.placeholder": "12",
        "creditCard.encryptedPassword.invalid": "Invalid password",
        "creditCard.taxNumber": "Cardholder birthdate or Corporate registration number",
        "creditCard.taxNumber.label": "Cardholder birthdate (YYMMDD) or Corporate registration number (10 digits)",
        "creditCard.taxNumber.labelAlt": "Corporate registration number (10 digits)",
        "creditCard.taxNumber.invalid": "Invalid Cardholder birthdate or Corporate registration number",
        "storedPaymentMethod.disable.button": "Remove",
        "storedPaymentMethod.disable.confirmation": "Remove stored payment method",
        "storedPaymentMethod.disable.confirmButton": "Yes, remove",
        "storedPaymentMethod.disable.cancelButton": "Cancel",
        "ach.bankAccount": "Bank account",
        "ach.accountHolderNameField.title": "Account holder name",
        "ach.accountHolderNameField.placeholder": "J. Smith",
        "ach.accountHolderNameField.invalid": "Invalid account holder name",
        "ach.accountNumberField.title": "Account number",
        "ach.accountNumberField.invalid": "Invalid account number",
        "ach.accountLocationField.title": "ABA routing number",
        "ach.accountLocationField.invalid": "Invalid ABA routing number",
        "ach.savedBankAccount": "Saved bank account",
        "select.state": "Select state",
        "select.stateOrProvince": "Select state or province",
        "select.provinceOrTerritory": "Select province or territory",
        "select.country": "Select country",
        "select.noOptionsFound": "No options found",
        "select.filter.placeholder": "Search...",
        "telephoneNumber.invalid": "Invalid telephone number",
        qrCodeOrApp: "or",
        "paypal.processingPayment": "Processing payment...",
        generateQRCode: "Generate QR code",
        "await.waitForConfirmation": "Waiting for confirmation",
        "mbway.confirmPayment": "Confirm your payment on the MB WAY app",
        "shopperEmail.invalid": "Invalid email address",
        "dateOfBirth.format": "DD/MM/YYYY",
        "dateOfBirth.invalid": "Enter a valid date of birth that indicates you are at least 18 years old",
        "blik.confirmPayment": "Open your banking app to confirm the payment.",
        "blik.invalid": "Enter 6 numbers",
        "blik.code": "6-digit code",
        "blik.help": "Get the code from your banking app.",
        "swish.pendingMessage": "After you scan, the status can be pending for up to 10 minutes. Attempting to pay again within this time may result in multiple charges.",
        "field.valid": "Field valid",
        "field.invalid": "Field not valid",
        "error.va.gen.01": "Incomplete field",
        "error.va.gen.02": "Field not valid",
        "error.va.sf-cc-num.01": "Enter a valid card number",
        "error.va.sf-cc-num.02": "Enter the card number",
        "error.va.sf-cc-num.03": "Enter a supported card brand",
        "error.va.sf-cc-num.04": "Enter the complete card number",
        "error.va.sf-cc-dat.01": "Enter a valid expiry date",
        "error.va.sf-cc-dat.02": "Enter a valid expiry date",
        "error.va.sf-cc-dat.03": "Credit card about to expire",
        "error.va.sf-cc-dat.04": "Enter the expiry date",
        "error.va.sf-cc-dat.05": "Enter the complete expiry date",
        "error.va.sf-cc-mth.01": "Enter the expiry month",
        "error.va.sf-cc-yr.01": "Enter the expiry year",
        "error.va.sf-cc-yr.02": "Enter the complete expiry year",
        "error.va.sf-cc-cvc.01": "Enter the security code",
        "error.va.sf-cc-cvc.02": "Enter the complete security code",
        "error.va.sf-ach-num.01": "Bank account number field is empty",
        "error.va.sf-ach-num.02": "Bank account number is the wrong length",
        "error.va.sf-ach-loc.01": "Bank routing number field is empty",
        "error.va.sf-ach-loc.02": "Bank routing number is the wrong length",
        "error.va.sf-kcp-pwd.01": "Password field is empty",
        "error.va.sf-kcp-pwd.02": "Password is the wrong length",
        "error.giftcard.no-balance": "This gift card has zero balance",
        "error.giftcard.card-error": "In our records we have no gift card with this number",
        "error.giftcard.currency-error": "Gift cards are only valid in the currency they were issued in",
        "amazonpay.signout": "Sign out from Amazon",
        "amazonpay.changePaymentDetails": "Change payment details",
        "partialPayment.warning": "Select another payment method to pay the remaining",
        "partialPayment.remainingBalance": "Remaining balance will be %{amount}",
        "bankTransfer.beneficiary": "Beneficiary",
        "bankTransfer.iban": "IBAN",
        "bankTransfer.bic": "BIC",
        "bankTransfer.reference": "Reference",
        "bankTransfer.introduction": "Continue to create a new bank transfer payment. You can use the details in the following screen to finalize this payment.",
        "bankTransfer.instructions": "Thank you for your purchase, please use the following information to complete your payment.",
        "bacs.accountHolderName": "Bank account holder name",
        "bacs.accountHolderName.invalid": "Invalid bank account holder name",
        "bacs.accountNumber": "Bank account number",
        "bacs.accountNumber.invalid": "Invalid bank account number",
        "bacs.bankLocationId": "Sort code",
        "bacs.bankLocationId.invalid": "Invalid sort code",
        "bacs.consent.amount": "I agree that the above amount will be deducted from my bank account.",
        "bacs.consent.account": "I confirm the account is in my name and I am the only signatory required to authorise the Direct Debit on this account.",
        edit: "Edit",
        "bacs.confirm": "Confirm and pay",
        "bacs.result.introduction": "Download your Direct Debit Instruction (DDI / Mandate)",
        "download.pdf": "Download PDF",
        "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe for card number",
        "creditCard.encryptedCardNumber.aria.label": "Card number",
        "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe for expiry date",
        "creditCard.encryptedExpiryDate.aria.label": "Expiry date",
        "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe for expiry month",
        "creditCard.encryptedExpiryMonth.aria.label": "Expiry month",
        "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe for expiry year",
        "creditCard.encryptedExpiryYear.aria.label": "Expiry year",
        "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe for security code",
        "creditCard.encryptedSecurityCode.aria.label": "Security code",
        "creditCard.encryptedPassword.aria.iframeTitle": "Iframe for password",
        "creditCard.encryptedPassword.aria.label": "First 2 digits of card password",
        "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe for card number",
        "giftcard.encryptedCardNumber.aria.label": "Card number",
        "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe for pin",
        "giftcard.encryptedSecurityCode.aria.label": "Pin",
        giftcardTransactionLimit: "Max. %{amount} allowed per transaction on this gift card",
        "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe for bank account number",
        "ach.encryptedBankAccountNumber.aria.label": "Account number",
        "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe for bank routing number",
        "ach.encryptedBankLocationId.aria.label": "ABA routing number",
        "pix.instructions": "Open the app with the PIX registered key, choose Pay with PIX and scan the QR Code or copy and paste the code",
        "twint.saved": "saved",
        orPayWith: "or pay with",
        invalidFormatExpects: "Invalid format. Expected format: %{format}",
        "upi.qrCodeWaitingMessage": "Scan the QR code using your preferred UPI app to complete the payment",
        "upi.vpaWaitingMessage": "Open your UPI app to confirm the payment",
        "upi.modeSelection": "Make a selection on how you would like to use UPI.",
        "onlineBanking.termsAndConditions": "By continuing you agree with the %#terms and conditions%#",
        "onlineBankingPL.termsAndConditions": "By continuing you agree with the %#regulations%# and %#information obligation%# of Przelewy24",
        "ctp.loading.poweredByCtp": "Powered by Click to Pay",
        "ctp.loading.intro": "We are checking to see if you have any saved cards with Click to Pay...",
        "ctp.login.title": "Continue to Click to Pay",
        "ctp.login.subtitle": "Enter the email address that is connected to Click to Pay to continue.",
        "ctp.login.inputLabel": "Email",
        "ctp.logout.notYou": "Not you?",
        "ctp.logout.notYourCards": "Not your cards?",
        "ctp.logout.notYourCard": "Not your card?",
        "ctp.logout.notYourProfile": "Not your profile?",
        "ctp.otp.fieldLabel": "One time code",
        "ctp.otp.resendCode": "Resend code",
        "ctp.otp.codeResent": "Code resent",
        "ctp.otp.title": "Access your Click to Pay cards",
        "ctp.otp.subtitle": "Enter the code %@ sent to %@ to verify it\u2018s you.",
        "ctp.otp.saveCookiesCheckbox.label": "Skip verification next time",
        "ctp.otp.saveCookiesCheckbox.information": "Select to be remembered on your device and browser at participating stores for faster checkout. Not recommended for shared devices.",
        "ctp.otp.saveCookiesCheckbox.shorterInfo": "Select to be remembered on your device and browser",
        "ctp.emptyProfile.message": "No cards registered in this Click to Pay profile",
        "ctp.separatorText": "or use",
        "ctp.cards.title": "Complete payment with Click to Pay",
        "ctp.cards.subtitle": "Select a card to use.",
        "ctp.cards.expiredCard": "Expired",
        "ctp.manualCardEntry": "Manual card entry",
        "ctp.aria.infoModalButton": "What is Click to Pay",
        "ctp.infoPopup.title": "Click to Pay brings the ease of contactless, online",
        "ctp.infoPopup.subtitle": "A fast, secure payment method supported by Mastercard, Visa and other payment cards.",
        "ctp.infoPopup.benefit1": "Click to Pay uses encryption to keep your information safe and secure",
        "ctp.infoPopup.benefit2": "Use it with merchants worldwide",
        "ctp.infoPopup.benefit3": "Set up once for hassle-free payments in the future",
        "ctp.errors.AUTH_INVALID": "Authentication Invalid",
        "ctp.errors.NOT_FOUND": "No account found, enter a valid email or continue using manual card entry",
        "ctp.errors.ID_FORMAT_UNSUPPORTED": "Format not supported",
        "ctp.errors.FRAUD": "The user account was locked or disabled",
        "ctp.errors.CONSUMER_ID_MISSING": "Consumer identity is missing in the request",
        "ctp.errors.ACCT_INACCESSIBLE": "This account is currently not available, e.g it is locked",
        "ctp.errors.CODE_INVALID": "Incorrect verification code",
        "ctp.errors.CODE_EXPIRED": "This code has expired",
        "ctp.errors.RETRIES_EXCEEDED": "The limit for the number of retries for OTP generation was exceeded",
        "ctp.errors.OTP_SEND_FAILED": "The OTP could not be sent to the recipient",
        "ctp.errors.REQUEST_TIMEOUT": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.UNKNOWN_ERROR": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.SERVICE_ERROR": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.SERVER_ERROR": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.INVALID_PARAMETER": "Something went wrong, try again or use the manual card entry",
        "ctp.errors.AUTH_ERROR": "Something went wrong, try again or use the manual card entry",
        "paymentMethodsList.aria.label": "Choose a payment method",
        "companyDetails.name.invalid": "Enter the company name",
        "companyDetails.registrationNumber.invalid": "Enter the registration number",
        "consent.checkbox.invalid": "You must agree with the terms & conditions",
        "form.instruction": "All fields are required unless marked otherwise.",
        "trustly.descriptor": "Instant Bank Payment",
        "trustly.description1": "Pay directly from any of your bank accounts, backed by bank-level security",
        "trustly.description2": "No cards, no app download, no registration",
        "ancv.input.label": "Your ANCV identification",
        "ancv.confirmPayment": "Use your ANCV application to confirm the payment.",
        "ancv.form.instruction": "The Cheque-Vacances application is necessary to validate this payment.",
        "ancv.beneficiaryId.invalid": "Enter a valid email address or ANCV ID",
        "payme.openPayMeApp": "Complete your payment in the PayMe app by authorizing the payment in the app and wait for the confirmation.",
        "payme.redirectButtonLabel": "Open PayMe app",
        "payme.scanQrCode": "Complete your payment by QR code",
        "payme.timeToPay": "This QR code is valid for %@",
        "payme.instructions.steps": "Open the PayMe app.%@Scan the QR code to authorize the payment.%@Complete the payment in the app and wait for confirmation.",
        "payme.instructions.footnote": "Please do not close this page before the payment is completed"
    }, yC = Object.freeze({
        __proto__: null,
        default: vC
    }), gC = "en-US", bC = vC, kC = {
        ar: function() {
            return Promise.resolve().then(function() {
                return q1;
            });
        },
        "cs-CZ": function() {
            return Promise.resolve().then(function() {
                return W1;
            });
        },
        "da-DK": function() {
            return Promise.resolve().then(function() {
                return G1;
            });
        },
        "de-DE": function() {
            return Promise.resolve().then(function() {
                return Y1;
            });
        },
        "el-GR": function() {
            return Promise.resolve().then(function() {
                return Q1;
            });
        },
        "en-US": function() {
            return Promise.resolve().then(function() {
                return yC;
            });
        },
        "es-ES": function() {
            return Promise.resolve().then(function() {
                return Z1;
            });
        },
        "fi-FI": function() {
            return Promise.resolve().then(function() {
                return J1;
            });
        },
        "fr-FR": function() {
            return Promise.resolve().then(function() {
                return $1;
            });
        },
        "hr-HR": function() {
            return Promise.resolve().then(function() {
                return X1;
            });
        },
        "hu-HU": function() {
            return Promise.resolve().then(function() {
                return e2;
            });
        },
        "it-IT": function() {
            return Promise.resolve().then(function() {
                return t2;
            });
        },
        "ja-JP": function() {
            return Promise.resolve().then(function() {
                return r2;
            });
        },
        "ko-KR": function() {
            return Promise.resolve().then(function() {
                return a2;
            });
        },
        "nl-NL": function() {
            return Promise.resolve().then(function() {
                return n2;
            });
        },
        "no-NO": function() {
            return Promise.resolve().then(function() {
                return o2;
            });
        },
        "pl-PL": function() {
            return Promise.resolve().then(function() {
                return i2;
            });
        },
        "pt-BR": function() {
            return Promise.resolve().then(function() {
                return l2;
            });
        },
        "pt-PT": function() {
            return Promise.resolve().then(function() {
                return c2;
            });
        },
        "ro-RO": function() {
            return Promise.resolve().then(function() {
                return s2;
            });
        },
        "ru-RU": function() {
            return Promise.resolve().then(function() {
                return u2;
            });
        },
        "sk-SK": function() {
            return Promise.resolve().then(function() {
                return d2;
            });
        },
        "sl-SI": function() {
            return Promise.resolve().then(function() {
                return p2;
            });
        },
        "sv-SE": function() {
            return Promise.resolve().then(function() {
                return m2;
            });
        },
        "zh-CN": function() {
            return Promise.resolve().then(function() {
                return f2;
            });
        },
        "zh-TW": function() {
            return Promise.resolve().then(function() {
                return h2;
            });
        }
    };
    function CC(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function _C(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = CC(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = CC(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var NC = function(e) {
        return e.toLowerCase().substring(0, 2);
    };
    function PC(e) {
        var t = e.replace("_", "-");
        if (new RegExp("([a-z]{2})([-])([A-Z]{2})").test(t)) return t;
        var r = Vk(t.split("-"), 2), a = r[0], n = r[1];
        if (!a || !n) return null;
        var o = [
            a.toLowerCase(),
            n.toUpperCase()
        ].join("-");
        return 5 === o.length ? o : null;
    }
    function wC(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
        if (!e || e.length < 1 || e.length > 5) return gC;
        var r = PC(e);
        return Kk(t).call(t, r) > -1 ? r : function(e, t) {
            return e && "string" == typeof e && zb(t).call(t, function(t) {
                return NC(t) === NC(e);
            }) || null;
        }(r || e, t);
    }
    var SC = function(e, t) {
        return e.replace(/%{(\w+)}/g, function(e, r) {
            return t[r] || "";
        });
    }, AC = function() {
        var e = Jd(Ey.mark(function e(t) {
            var r, a, n, o = arguments;
            return Ey.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return r = o.length > 1 && void 0 !== o[1] ? o[1] : {}, a = wC(t, Ty(kC)) || gC, e.next = 4, kC[a]();
                    case 4:
                        return n = e.sent, e.abrupt("return", _C(_C(_C({}, bC), n.default), !!r[t] && r[t]));
                    case 6:
                    case "end":
                        return e.stop();
                }
            }, e);
        }));
        return function(t) {
            return e.apply(this, arguments);
        };
    }(), IC = function(e, t) {
        var r = e.split(/%#(.*?)%#/gm);
        if (t.length !== Math.floor(r.length / 2)) throw Error("The number of functions provided does not match the number of elements in the translation string.");
        return hC(r).call(r, function(e, r) {
            var a = Math.floor(r / 2);
            return r % 2 == 0 ? e : t[a](e);
        });
    }, DC = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF", EC = G, RC = vo, xC = DC, FC = h("".replace), TC = RegExp("^[" + xC + "]+"), zC = RegExp("(^|[^" + xC + "])[" + xC + "]+$"), OC = function(e) {
        return function(t) {
            var r = RC(EC(t));
            return 1 & e && (r = FC(r, TC, "")), 2 & e && (r = FC(r, zC, "$1")), r;
        };
    }, jC = {
        start: OC(1),
        end: OC(2),
        trim: OC(3)
    }, BC = a, MC = n, LC = h, VC = vo, UC = jC.trim, KC = DC, HC = BC.parseInt, qC = BC.Symbol, WC = qC && qC.iterator, GC = /^[+-]?0x/i, YC = LC(GC.exec), QC = 8 !== HC(KC + "08") || 22 !== HC(KC + "0x16") || WC && !MC(function() {
        HC(Object(WC));
    }) ? function(e, t) {
        var r = UC(VC(e));
        return HC(r, t >>> 0 || (YC(GC, r) ? 16 : 10));
    } : HC;
    Ar({
        global: !0,
        forced: parseInt !== QC
    }, {
        parseInt: QC
    });
    var ZC = t(ee.parseInt), JC = {
        IDR: 1,
        JPY: 1,
        KRW: 1,
        VND: 1,
        BYR: 1,
        CVE: 1,
        DJF: 1,
        GHC: 1,
        GNF: 1,
        KMF: 1,
        PYG: 1,
        RWF: 1,
        UGX: 1,
        VUV: 1,
        XAF: 1,
        XOF: 1,
        XPF: 1,
        MRO: 10,
        BHD: 1e3,
        IQD: 1e3,
        JOD: 1e3,
        KWD: 1e3,
        OMR: 1e3,
        LYD: 1e3,
        TND: 1e3
    }, $C = {
        RSD: {
            minimumFractionDigits: 2
        },
        AFN: {
            minimumFractionDigits: 2
        },
        ALL: {
            minimumFractionDigits: 2
        },
        IRR: {
            minimumFractionDigits: 2
        },
        LAK: {
            minimumFractionDigits: 2
        },
        LBP: {
            minimumFractionDigits: 2
        },
        MMK: {
            minimumFractionDigits: 2
        },
        SOS: {
            minimumFractionDigits: 2
        },
        SYP: {
            minimumFractionDigits: 2
        },
        YER: {
            minimumFractionDigits: 2
        },
        IQD: {
            minimumFractionDigits: 3
        }
    };
    function XC(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function e_(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = XC(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = XC(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var t_ = function(e, t) {
        var r = function(e) {
            return JC[e] || 100;
        }(t);
        return ZC(String(e), 10) / r;
    };
    function r_(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var a_ = function() {
        function e() {
            var t, r, a = this, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : gC, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            Cg(this, e), Sg(this, "supportedLocales", void 0), Sg(this, "locale", void 0), Sg(this, "languageCode", void 0), Sg(this, "translations", bC), Sg(this, "customTranslations", void 0), Sg(this, "loaded", void 0);
            var i = Ty(kC);
            this.customTranslations = function() {
                var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
                return tC(e = Ty(t)).call(e, function(e, a) {
                    var n = PC(a) || wC(a, r);
                    return n && (e[n] = t[a]), e;
                }, {});
            }(o, i);
            var l = Ty(this.customTranslations);
            this.supportedLocales = Fg(t = wb(r = []).call(r, Uk(i), Uk(l))).call(t, function(e, t, r) {
                return Kk(r).call(r, e) === t;
            }), this.locale = PC(n) || wC(n, this.supportedLocales) || gC;
            var c = Vk(this.locale.split("-"), 1)[0];
            this.languageCode = c, this.loaded = AC(this.locale, this.customTranslations).then(function(e) {
                a.translations = e;
            });
        }
        return wg(e, [
            {
                key: "get",
                value: function(e, t) {
                    var r = function(e, t) {
                        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                            values: {},
                            count: 0
                        }, a = "".concat(t, "__plural"), n = function(e) {
                            var r;
                            return wb(r = "".concat(t, "__")).call(r, e);
                        };
                        return Object.prototype.hasOwnProperty.call(e, n(r.count)) ? SC(e[n(r.count)], sC(r)) : Object.prototype.hasOwnProperty.call(e, a) && r.count > 1 ? SC(e[a], sC(r)) : Object.prototype.hasOwnProperty.call(e, t) ? SC(e[t], sC(r)) : null;
                    }(this.translations, e, t);
                    return null !== r ? r : e;
                }
            },
            {
                key: "amount",
                value: function(e, t, r) {
                    return function(e, t, r) {
                        var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, n = e.toString(), o = t_(n, r), i = t.replace("_", "-"), l = $C[r] ? e_(e_({}, a), $C[r]) : a, c = e_({
                            style: "currency",
                            currency: r,
                            currencyDisplay: "symbol"
                        }, l);
                        try {
                            return o.toLocaleString(i, c);
                        } catch (e) {
                            return n;
                        }
                    }(e, this.locale, t, r);
                }
            },
            {
                key: "date",
                value: function(e) {
                    var t = function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Ag(r = r_(Object(n), !0)).call(r, function(t) {
                                Sg(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Ag(a = r_(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit"
                    }, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
                    return new Date(e).toLocaleDateString(this.locale, t);
                }
            }
        ]), e;
    }(), n_ = Ar, o_ = u, i_ = Hg, l_ = Wl, c_ = tr, s_ = X, u_ = cn, d_ = n, p_ = oe("Reflect", "construct"), m_ = Object.prototype, f_ = [].push, h_ = d_(function() {
        function e() {}
        return !(p_(function() {}, [], e) instanceof e);
    }), v_ = !d_(function() {
        p_(function() {});
    }), y_ = h_ || v_;
    n_({
        target: "Reflect",
        stat: !0,
        forced: y_,
        sham: y_
    }, {
        construct: function(e, t) {
            l_(e), c_(t);
            var r = arguments.length < 3 ? e : l_(arguments[2]);
            if (v_ && !h_) return p_(e, t, r);
            if (e === r) {
                switch(t.length){
                    case 0:
                        return new e;
                    case 1:
                        return new e(t[0]);
                    case 2:
                        return new e(t[0], t[1]);
                    case 3:
                        return new e(t[0], t[1], t[2]);
                    case 4:
                        return new e(t[0], t[1], t[2], t[3]);
                }
                var a = [
                    null
                ];
                return o_(f_, a, t), new (o_(i_, e, a));
            }
            var n = r.prototype, o = u_(s_(n) ? n : m_), i = o_(e, o, t);
            return s_(i) ? i : o;
        }
    });
    var g_ = ee.Reflect.construct, b_ = t(g_), k_ = I, C_ = h, __ = R, N_ = n, P_ = Ma, w_ = wa, S_ = x, A_ = Ye, I_ = K, D_ = Object.assign, E_ = Object.defineProperty, R_ = C_([].concat), x_ = !D_ || N_(function() {
        if (k_ && 1 !== D_({
            b: 1
        }, D_(E_({}, "a", {
            enumerable: !0,
            get: function() {
                E_(this, "b", {
                    value: 3,
                    enumerable: !1
                });
            }
        }), {
            b: 2
        })).b) return !0;
        var e = {}, t = {}, r = Symbol("assign detection"), a = "abcdefghijklmnopqrst";
        return e[r] = 7, a.split("").forEach(function(e) {
            t[e] = e;
        }), 7 !== D_({}, e)[r] || P_(D_({}, t)).join("") !== a;
    }) ? function(e, t) {
        for(var r = A_(e), a = arguments.length, n = 1, o = w_.f, i = S_.f; a > n;)for(var l, c = I_(arguments[n++]), s = o ? R_(P_(c), o(c)) : P_(c), u = s.length, d = 0; u > d;)l = s[d++], k_ && !__(i, c, l) || (r[l] = c[l]);
        return r;
    } : D_, F_ = x_;
    Ar({
        target: "Object",
        stat: !0,
        arity: 2,
        forced: Object.assign !== F_
    }, {
        assign: F_
    });
    var T_ = ee.Object.assign, z_ = t(T_), O_ = t(Zg);
    function j_() {
        var e;
        return j_ = z_ ? O_(e = z_).call(e) : function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var a in r)Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
            }
            return e;
        }, j_.apply(this, arguments);
    }
    function B_(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function M_(e, t) {
        var r;
        return M_ = Zv ? O_(r = Zv).call(r) : function(e, t) {
            return e.__proto__ = t, e;
        }, M_(e, t);
    }
    function L_(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = sv(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), nv(e, "prototype", {
            writable: !1
        }), t && M_(e, t);
    }
    function V_(e, t) {
        if (t && ("object" === ig(t) || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return B_(e);
    }
    function U_(e) {
        var t;
        return U_ = Zv ? O_(t = fv).call(t) : function(e) {
            return e.__proto__ || fv(e);
        }, U_(e);
    }
    var K_, H_, q_, W_, G_, Y_, Q_, Z_, J_ = {}, $_ = [], X_ = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
    function eN(e, t) {
        for(var r in t)e[r] = t[r];
        return e;
    }
    function tN(e) {
        var t = e.parentNode;
        t && t.removeChild(e);
    }
    function rN(e, t, r) {
        var a, n, o, i = {};
        for(o in t)"key" == o ? a = t[o] : "ref" == o ? n = t[o] : i[o] = t[o];
        if (arguments.length > 2 && (i.children = arguments.length > 3 ? K_.call(arguments, 2) : r), "function" == typeof e && null != e.defaultProps) for(o in e.defaultProps)void 0 === i[o] && (i[o] = e.defaultProps[o]);
        return aN(e, i, a, n, null);
    }
    function aN(e, t, r, a, n) {
        var o = {
            type: e,
            props: t,
            key: r,
            ref: a,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __d: void 0,
            __c: null,
            __h: null,
            constructor: void 0,
            __v: null == n ? ++q_ : n
        };
        return null == n && null != H_.vnode && H_.vnode(o), o;
    }
    function nN(e) {
        return e.children;
    }
    function oN(e, t) {
        this.props = e, this.context = t;
    }
    function iN(e, t) {
        if (null == t) return e.__ ? iN(e.__, e.__.__k.indexOf(e) + 1) : null;
        for(var r; t < e.__k.length; t++)if (null != (r = e.__k[t]) && null != r.__e) return r.__e;
        return "function" == typeof e.type ? iN(e) : null;
    }
    function lN(e) {
        var t, r;
        if (null != (e = e.__) && null != e.__c) {
            for(e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)if (null != (r = e.__k[t]) && null != r.__e) {
                e.__e = e.__c.base = r.__e;
                break;
            }
            return lN(e);
        }
    }
    function cN(e) {
        (!e.__d && (e.__d = !0) && W_.push(e) && !sN.__r++ || G_ !== H_.debounceRendering) && ((G_ = H_.debounceRendering) || Y_)(sN);
    }
    function sN() {
        var e, t, r, a, n, o, i, l;
        for(W_.sort(Q_); e = W_.shift();)e.__d && (t = W_.length, a = void 0, n = void 0, i = (o = (r = e).__v).__e, (l = r.__P) && (a = [], (n = eN({}, o)).__v = o.__v + 1, bN(l, o, n, r.__n, void 0 !== l.ownerSVGElement, null != o.__h ? [
            i
        ] : null, a, null == i ? iN(o) : i, o.__h), kN(a, o), o.__e != i && lN(o)), W_.length > t && W_.sort(Q_));
        sN.__r = 0;
    }
    function uN(e, t, r, a, n, o, i, l, c, s) {
        var u, d, p, m, f, h, v, y = a && a.__k || $_, g = y.length;
        for(r.__k = [], u = 0; u < t.length; u++)if (null != (m = r.__k[u] = null == (m = t[u]) || "boolean" == typeof m || "function" == typeof m ? null : "string" == typeof m || "number" == typeof m || "bigint" == typeof m ? aN(null, m, null, null, m) : Array.isArray(m) ? aN(nN, {
            children: m
        }, null, null, null) : m.__b > 0 ? aN(m.type, m.props, m.key, m.ref ? m.ref : null, m.__v) : m)) {
            if (m.__ = r, m.__b = r.__b + 1, null === (p = y[u]) || p && m.key == p.key && m.type === p.type) y[u] = void 0;
            else for(d = 0; d < g; d++){
                if ((p = y[d]) && m.key == p.key && m.type === p.type) {
                    y[d] = void 0;
                    break;
                }
                p = null;
            }
            bN(e, m, p = p || J_, n, o, i, l, c, s), f = m.__e, (d = m.ref) && p.ref != d && (v || (v = []), p.ref && v.push(p.ref, null, m), v.push(d, m.__c || f, m)), null != f ? (null == h && (h = f), "function" == typeof m.type && m.__k === p.__k ? m.__d = c = dN(m, c, e) : c = mN(e, m, p, y, f, c), "function" == typeof r.type && (r.__d = c)) : c && p.__e == c && c.parentNode != e && (c = iN(p));
        }
        for(r.__e = h, u = g; u--;)null != y[u] && ("function" == typeof r.type && null != y[u].__e && y[u].__e == r.__d && (r.__d = fN(a).nextSibling), NN(y[u], y[u]));
        if (v) for(u = 0; u < v.length; u++)_N(v[u], v[++u], v[++u]);
    }
    function dN(e, t, r) {
        for(var a, n = e.__k, o = 0; n && o < n.length; o++)(a = n[o]) && (a.__ = e, t = "function" == typeof a.type ? dN(a, t, r) : mN(r, a, a, n, a.__e, t));
        return t;
    }
    function pN(e, t) {
        return t = t || [], null == e || "boolean" == typeof e || (Array.isArray(e) ? e.some(function(e) {
            pN(e, t);
        }) : t.push(e)), t;
    }
    function mN(e, t, r, a, n, o) {
        var i, l, c;
        if (void 0 !== t.__d) i = t.__d, t.__d = void 0;
        else if (null == r || n != o || null == n.parentNode) e: if (null == o || o.parentNode !== e) e.appendChild(n), i = null;
        else {
            for(l = o, c = 0; (l = l.nextSibling) && c < a.length; c += 1)if (l == n) break e;
            e.insertBefore(n, o), i = o;
        }
        return void 0 !== i ? i : n.nextSibling;
    }
    function fN(e) {
        var t, r, a;
        if (null == e.type || "string" == typeof e.type) return e.__e;
        if (e.__k) {
            for(t = e.__k.length - 1; t >= 0; t--)if ((r = e.__k[t]) && (a = fN(r))) return a;
        }
        return null;
    }
    function hN(e, t, r) {
        "-" === t[0] ? e.setProperty(t, null == r ? "" : r) : e[t] = null == r ? "" : "number" != typeof r || X_.test(t) ? r : r + "px";
    }
    function vN(e, t, r, a, n) {
        var o;
        e: if ("style" === t) {
            if ("string" == typeof r) e.style.cssText = r;
            else {
                if ("string" == typeof a && (e.style.cssText = a = ""), a) for(t in a)r && t in r || hN(e.style, t, "");
                if (r) for(t in r)a && r[t] === a[t] || hN(e.style, t, r[t]);
            }
        } else if ("o" === t[0] && "n" === t[1]) o = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + o] = r, r ? a || e.addEventListener(t, o ? gN : yN, o) : e.removeEventListener(t, o ? gN : yN, o);
        else if ("dangerouslySetInnerHTML" !== t) {
            if (n) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
            else if ("width" !== t && "height" !== t && "href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && t in e) try {
                e[t] = null == r ? "" : r;
                break e;
            } catch (e) {}
            "function" == typeof r || (null == r || !1 === r && "-" !== t[4] ? e.removeAttribute(t) : e.setAttribute(t, r));
        }
    }
    function yN(e) {
        return this.l[e.type + !1](H_.event ? H_.event(e) : e);
    }
    function gN(e) {
        return this.l[e.type + !0](H_.event ? H_.event(e) : e);
    }
    function bN(e, t, r, a, n, o, i, l, c) {
        var s, u, d, p, m, f, h, v, y, g, b, k, C, _, N, P = t.type;
        if (void 0 !== t.constructor) return null;
        null != r.__h && (c = r.__h, l = t.__e = r.__e, t.__h = null, o = [
            l
        ]), (s = H_.__b) && s(t);
        try {
            e: if ("function" == typeof P) {
                if (v = t.props, y = (s = P.contextType) && a[s.__c], g = s ? y ? y.props.value : s.__ : a, r.__c ? h = (u = t.__c = r.__c).__ = u.__E : ("prototype" in P && P.prototype.render ? t.__c = u = new P(v, g) : (t.__c = u = new oN(v, g), u.constructor = P, u.render = PN), y && y.sub(u), u.props = v, u.state || (u.state = {}), u.context = g, u.__n = a, d = u.__d = !0, u.__h = [], u._sb = []), null == u.__s && (u.__s = u.state), null != P.getDerivedStateFromProps && (u.__s == u.state && (u.__s = eN({}, u.__s)), eN(u.__s, P.getDerivedStateFromProps(v, u.__s))), p = u.props, m = u.state, u.__v = t, d) null == P.getDerivedStateFromProps && null != u.componentWillMount && u.componentWillMount(), null != u.componentDidMount && u.__h.push(u.componentDidMount);
                else {
                    if (null == P.getDerivedStateFromProps && v !== p && null != u.componentWillReceiveProps && u.componentWillReceiveProps(v, g), !u.__e && null != u.shouldComponentUpdate && !1 === u.shouldComponentUpdate(v, u.__s, g) || t.__v === r.__v) {
                        for(t.__v !== r.__v && (u.props = v, u.state = u.__s, u.__d = !1), u.__e = !1, t.__e = r.__e, t.__k = r.__k, t.__k.forEach(function(e) {
                            e && (e.__ = t);
                        }), b = 0; b < u._sb.length; b++)u.__h.push(u._sb[b]);
                        u._sb = [], u.__h.length && i.push(u);
                        break e;
                    }
                    null != u.componentWillUpdate && u.componentWillUpdate(v, u.__s, g), null != u.componentDidUpdate && u.__h.push(function() {
                        u.componentDidUpdate(p, m, f);
                    });
                }
                if (u.context = g, u.props = v, u.__P = e, k = H_.__r, C = 0, "prototype" in P && P.prototype.render) {
                    for(u.state = u.__s, u.__d = !1, k && k(t), s = u.render(u.props, u.state, u.context), _ = 0; _ < u._sb.length; _++)u.__h.push(u._sb[_]);
                    u._sb = [];
                } else do u.__d = !1, k && k(t), s = u.render(u.props, u.state, u.context), u.state = u.__s;
                while (u.__d && ++C < 25);
                u.state = u.__s, null != u.getChildContext && (a = eN(eN({}, a), u.getChildContext())), d || null == u.getSnapshotBeforeUpdate || (f = u.getSnapshotBeforeUpdate(p, m)), N = null != s && s.type === nN && null == s.key ? s.props.children : s, uN(e, Array.isArray(N) ? N : [
                    N
                ], t, r, a, n, o, i, l, c), u.base = t.__e, t.__h = null, u.__h.length && i.push(u), h && (u.__E = u.__ = null), u.__e = !1;
            } else null == o && t.__v === r.__v ? (t.__k = r.__k, t.__e = r.__e) : t.__e = CN(r.__e, t, r, a, n, o, i, c);
            (s = H_.diffed) && s(t);
        } catch (e) {
            t.__v = null, (c || null != o) && (t.__e = l, t.__h = !!c, o[o.indexOf(l)] = null), H_.__e(e, t, r);
        }
    }
    function kN(e, t) {
        H_.__c && H_.__c(t, e), e.some(function(t) {
            try {
                e = t.__h, t.__h = [], e.some(function(e) {
                    e.call(t);
                });
            } catch (e) {
                H_.__e(e, t.__v);
            }
        });
    }
    function CN(e, t, r, a, n, o, i, l) {
        var c, s, u, d = r.props, p = t.props, m = t.type, f = 0;
        if ("svg" === m && (n = !0), null != o) {
            for(; f < o.length; f++)if ((c = o[f]) && "setAttribute" in c == !!m && (m ? c.localName === m : 3 === c.nodeType)) {
                e = c, o[f] = null;
                break;
            }
        }
        if (null == e) {
            if (null === m) return document.createTextNode(p);
            e = n ? document.createElementNS("http://www.w3.org/2000/svg", m) : document.createElement(m, p.is && p), o = null, l = !1;
        }
        if (null === m) d === p || l && e.data === p || (e.data = p);
        else {
            if (o = o && K_.call(e.childNodes), s = (d = r.props || J_).dangerouslySetInnerHTML, u = p.dangerouslySetInnerHTML, !l) {
                if (null != o) for(d = {}, f = 0; f < e.attributes.length; f++)d[e.attributes[f].name] = e.attributes[f].value;
                (u || s) && (u && (s && u.__html == s.__html || u.__html === e.innerHTML) || (e.innerHTML = u && u.__html || ""));
            }
            if (function(e, t, r, a, n) {
                var o;
                for(o in r)"children" === o || "key" === o || o in t || vN(e, o, null, r[o], a);
                for(o in t)n && "function" != typeof t[o] || "children" === o || "key" === o || "value" === o || "checked" === o || r[o] === t[o] || vN(e, o, t[o], r[o], a);
            }(e, p, d, n, l), u) t.__k = [];
            else if (f = t.props.children, uN(e, Array.isArray(f) ? f : [
                f
            ], t, r, a, n && "foreignObject" !== m, o, i, o ? o[0] : r.__k && iN(r, 0), l), null != o) for(f = o.length; f--;)null != o[f] && tN(o[f]);
            l || ("value" in p && void 0 !== (f = p.value) && (f !== e.value || "progress" === m && !f || "option" === m && f !== d.value) && vN(e, "value", f, d.value, !1), "checked" in p && void 0 !== (f = p.checked) && f !== e.checked && vN(e, "checked", f, d.checked, !1));
        }
        return e;
    }
    function _N(e, t, r) {
        try {
            "function" == typeof e ? e(t) : e.current = t;
        } catch (e) {
            H_.__e(e, r);
        }
    }
    function NN(e, t, r) {
        var a, n;
        if (H_.unmount && H_.unmount(e), (a = e.ref) && (a.current && a.current !== e.__e || _N(a, null, t)), null != (a = e.__c)) {
            if (a.componentWillUnmount) try {
                a.componentWillUnmount();
            } catch (e) {
                H_.__e(e, t);
            }
            a.base = a.__P = null, e.__c = void 0;
        }
        if (a = e.__k) for(n = 0; n < a.length; n++)a[n] && NN(a[n], t, r || "function" != typeof e.type);
        r || null == e.__e || tN(e.__e), e.__ = e.__e = e.__d = void 0;
    }
    function PN(e, t, r) {
        return this.constructor(e, r);
    }
    function wN(e, t, r) {
        var a, n, o;
        H_.__ && H_.__(e, t), n = (a = "function" == typeof r) ? null : r && r.__k || t.__k, o = [], bN(t, e = (!a && r || t).__k = rN(nN, null, [
            e
        ]), n || J_, J_, void 0 !== t.ownerSVGElement, !a && r ? [
            r
        ] : n ? null : t.firstChild ? K_.call(t.childNodes) : null, o, !a && r ? r : n ? n.__e : t.firstChild, a), kN(o, e);
    }
    function SN(e, t) {
        var r = {
            __c: t = "__cC" + Z_++,
            __: e,
            Consumer: function(e, t) {
                return e.children(t);
            },
            Provider: function(e) {
                var r, a;
                return this.getChildContext || (r = [], (a = {})[t] = this, this.getChildContext = function() {
                    return a;
                }, this.shouldComponentUpdate = function(e) {
                    this.props.value !== e.value && r.some(function(e) {
                        e.__e = !0, cN(e);
                    });
                }, this.sub = function(e) {
                    r.push(e);
                    var t = e.componentWillUnmount;
                    e.componentWillUnmount = function() {
                        r.splice(r.indexOf(e), 1), t && t.call(e);
                    };
                }), e.children;
            }
        };
        return r.Provider.__ = r.Consumer.contextType = r;
    }
    K_ = $_.slice, H_ = {
        __e: function(e, t, r, a) {
            for(var n, o, i; t = t.__;)if ((n = t.__c) && !n.__) try {
                if ((o = n.constructor) && null != o.getDerivedStateFromError && (n.setState(o.getDerivedStateFromError(e)), i = n.__d), null != n.componentDidCatch && (n.componentDidCatch(e, a || {}), i = n.__d), i) return n.__E = n;
            } catch (t) {
                e = t;
            }
            throw e;
        }
    }, q_ = 0, oN.prototype.setState = function(e, t) {
        var r;
        r = null != this.__s && this.__s !== this.state ? this.__s : this.__s = eN({}, this.state), "function" == typeof e && (e = e(eN({}, r), this.props)), e && eN(r, e), null != e && this.__v && (t && this._sb.push(t), cN(this));
    }, oN.prototype.forceUpdate = function(e) {
        this.__v && (this.__e = !0, e && this.__h.push(e), cN(this));
    }, oN.prototype.render = nN, W_ = [], Y_ = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Q_ = function(e, t) {
        return e.__v.__b - t.__v.__b;
    }, sN.__r = 0, Z_ = 0;
    var AN = function(e, t) {
        var r = t.split(".");
        return tC(r).call(r, function(e, t) {
            return e && e[t] ? e[t] : void 0;
        }, e);
    }, IN = wg(function e() {
        var t = this;
        Cg(this, e), Sg(this, "events", {}), Sg(this, "on", function(e, r) {
            t.events[e] = t.events[e] || [], t.events[e].push(r);
        }), Sg(this, "off", function(e, r) {
            var a;
            t.events[e] && (t.events[e] = tC(a = t.events[e]).call(a, function(e, t) {
                return t !== r && e.push(t), e;
            }, []));
        }), Sg(this, "emit", function(e, r) {
            var a;
            t.events[e] && Ag(a = t.events[e]).call(a, function(e) {
                e(r);
            });
        });
    });
    function DN() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
            var t = 16 * Math.random() | 0;
            return ("x" == e ? t : 3 & t | 8).toString(16);
        });
    }
    function EN(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function RN(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = EN(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = EN(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var xN = function() {
        function e(t) {
            var r;
            Cg(this, e), Sg(this, "_id", wb(r = "".concat(this.constructor.type, "-")).call(r, DN())), Sg(this, "props", void 0), Sg(this, "state", void 0), Sg(this, "_node", void 0), Sg(this, "_component", void 0), Sg(this, "eventEmitter", new IN), Sg(this, "_parentInstance", void 0), Sg(this, "resources", void 0), this.props = this.formatProps(RN(RN({}, this.constructor.defaultProps), {}, {
                setStatusAutomatically: !0
            }, t)), this._parentInstance = this.props._parentInstance, this._node = null, this.state = {}, this.resources = this.props.modules ? this.props.modules.resources : void 0;
        }
        return wg(e, [
            {
                key: "formatProps",
                value: function(e) {
                    return e;
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {};
                }
            },
            {
                key: "setState",
                value: function(e) {
                    this.state = RN(RN({}, this.state), e);
                }
            },
            {
                key: "data",
                get: function() {
                    var e = AN(this.props, "modules.risk.data"), t = !!AN(this.props, "modules.analytics.props.enabled") ? AN(this.props, "modules.analytics.checkoutAttemptId") : "do-not-track", r = this.state.order || this.props.order, a = this.formatData();
                    return a.paymentMethod && t && (a.paymentMethod.checkoutAttemptId = t), RN(RN(RN(RN({}, e && {
                        riskData: {
                            clientData: e
                        }
                    }), r && {
                        order: {
                            orderData: r.orderData,
                            pspReference: r.pspReference
                        }
                    }), a), {}, {
                        clientStateDataIndicator: !0
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    throw new Error("Payment method cannot be rendered.");
                }
            },
            {
                key: "mount",
                value: function(e) {
                    var t, r = "string" == typeof e ? document.querySelector(e) : e;
                    if (!r) throw new Error("Component could not mount. Root node was not found.");
                    this._node ? this.unmount() : this.props.modules && this.props.modules.analytics && !this.props.isDropin && this.props.modules.analytics.send({
                        containerWidth: this._node && this._node.offsetWidth,
                        component: null !== (t = this.constructor.analyticsType) && void 0 !== t ? t : this.constructor.type,
                        flavor: "components"
                    });
                    return this._node = r, this._component = this.render(), wN(this._component, r), this;
                }
            },
            {
                key: "update",
                value: function(e) {
                    return this.props = this.formatProps(RN(RN({}, this.props), e)), this.state = {}, this.unmount().mount(this._node);
                }
            },
            {
                key: "remount",
                value: function(e) {
                    if (!this._node) throw new Error("Component is not mounted.");
                    return wN(e || this.render(), this._node, null), this;
                }
            },
            {
                key: "unmount",
                value: function() {
                    return this._node && wN(null, this._node), this;
                }
            },
            {
                key: "remove",
                value: function() {
                    this.unmount(), this._parentInstance && this._parentInstance.remove(this);
                }
            }
        ]), e;
    }();
    Sg(xN, "defaultProps", {});
    var FN = "function" == typeof Bun && Bun && "string" == typeof Bun.version, TN = a, zN = u, ON = S, jN = FN, BN = le, MN = $l, LN = ec, VN = TN.Function, UN = /MSIE .\./.test(BN) || jN && function() {
        var e = TN.Bun.version.split(".");
        return e.length < 3 || "0" === e[0] && (e[1] < 3 || "3" === e[1] && "0" === e[2]);
    }(), KN = function(e, t) {
        var r = t ? 2 : 1;
        return UN ? function(a, n) {
            var o = LN(arguments.length, 1) > r, i = ON(a) ? a : VN(a), l = o ? MN(arguments, r) : [], c = o ? function() {
                zN(i, this, l);
            } : i;
            return t ? e(c, n) : e(c);
        } : e;
    }, HN = Ar, qN = a, WN = KN(qN.setInterval, !0);
    HN({
        global: !0,
        bind: !0,
        forced: qN.setInterval !== WN
    }, {
        setInterval: WN
    });
    var GN = Ar, YN = a, QN = KN(YN.setTimeout, !0);
    GN({
        global: !0,
        bind: !0,
        forced: YN.setTimeout !== QN
    }, {
        setTimeout: QN
    });
    var ZN = t(ee.setTimeout), JN = t(gk), $N = {
        exports: {}
    };
    !function(e) {
        !function() {
            var t = {}.hasOwnProperty;
            function r() {
                for(var e = [], a = 0; a < arguments.length; a++){
                    var n = arguments[a];
                    if (n) {
                        var o = ig(n);
                        if ("string" === o || "number" === o) e.push(n);
                        else if (JN(n)) {
                            if (n.length) {
                                var i = r.apply(null, n);
                                i && e.push(i);
                            }
                        } else if ("object" === o) {
                            var l;
                            if (n.toString !== Object.prototype.toString && !kb(l = n.toString.toString()).call(l, "[native code]")) {
                                e.push(n.toString());
                                continue;
                            }
                            for(var c in n)t.call(n, c) && n[c] && e.push(c);
                        }
                    }
                }
                return e.join(" ");
            }
            e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
        }();
    }($N);
    var XN, eP, tP, rP, aP = t($N.exports), nP = function(e) {
        var t = e.inline, r = void 0 !== t && t, a = e.size, n = void 0 === a ? "large" : a;
        return rN("div", {
            "data-testid": "spinner",
            className: "adyen-checkout__spinner__wrapper ".concat(r ? "adyen-checkout__spinner__wrapper--inline" : "")
        }, rN("div", {
            className: "adyen-checkout__spinner adyen-checkout__spinner--".concat(n)
        }));
    }, oP = 0, iP = [], lP = [], cP = H_.__b, sP = H_.__r, uP = H_.diffed, dP = H_.__c, pP = H_.unmount;
    function mP(e, t) {
        H_.__h && H_.__h(eP, e, oP || t), oP = 0;
        var r = eP.__H || (eP.__H = {
            __: [],
            __h: []
        });
        return e >= r.__.length && r.__.push({
            __V: lP
        }), r.__[e];
    }
    function fP(e) {
        return oP = 1, hP(IP, e);
    }
    function hP(e, t, r) {
        var a = mP(XN++, 2);
        if (a.t = e, !a.__c && (a.__ = [
            r ? r(t) : IP(void 0, t),
            function(e) {
                var t = a.__N ? a.__N[0] : a.__[0], r = a.t(t, e);
                t !== r && (a.__N = [
                    r,
                    a.__[1]
                ], a.__c.setState({}));
            }
        ], a.__c = eP, !eP.u)) {
            var n = function(e, t, r) {
                if (!a.__c.__H) return !0;
                var n = a.__c.__H.__.filter(function(e) {
                    return e.__c;
                });
                if (n.every(function(e) {
                    return !e.__N;
                })) return !o || o.call(this, e, t, r);
                var i = !1;
                return n.forEach(function(e) {
                    if (e.__N) {
                        var t = e.__[0];
                        e.__ = e.__N, e.__N = void 0, t !== e.__[0] && (i = !0);
                    }
                }), !(!i && a.__c.props === e) && (!o || o.call(this, e, t, r));
            };
            eP.u = !0;
            var o = eP.shouldComponentUpdate, i = eP.componentWillUpdate;
            eP.componentWillUpdate = function(e, t, r) {
                if (this.__e) {
                    var a = o;
                    o = void 0, n(e, t, r), o = a;
                }
                i && i.call(this, e, t, r);
            }, eP.shouldComponentUpdate = n;
        }
        return a.__N || a.__;
    }
    function vP(e, t) {
        var r = mP(XN++, 3);
        !H_.__s && AP(r.__H, t) && (r.__ = e, r.i = t, eP.__H.__h.push(r));
    }
    function yP(e, t) {
        var r = mP(XN++, 4);
        !H_.__s && AP(r.__H, t) && (r.__ = e, r.i = t, eP.__h.push(r));
    }
    function gP(e) {
        return oP = 5, bP(function() {
            return {
                current: e
            };
        }, []);
    }
    function bP(e, t) {
        var r = mP(XN++, 7);
        return AP(r.__H, t) ? (r.__V = e(), r.i = t, r.__h = e, r.__V) : r.__;
    }
    function kP(e, t) {
        return oP = 8, bP(function() {
            return e;
        }, t);
    }
    function CP(e) {
        var t = eP.context[e.__c], r = mP(XN++, 9);
        return r.c = e, t ? (null == r.__ && (r.__ = !0, t.sub(eP)), t.props.value) : e.__;
    }
    function _P() {
        for(var e; e = iP.shift();)if (e.__P && e.__H) try {
            e.__H.__h.forEach(wP), e.__H.__h.forEach(SP), e.__H.__h = [];
        } catch (t) {
            e.__H.__h = [], H_.__e(t, e.__v);
        }
    }
    H_.__b = function(e) {
        eP = null, cP && cP(e);
    }, H_.__r = function(e) {
        sP && sP(e), XN = 0;
        var t = (eP = e.__c).__H;
        t && (tP === eP ? (t.__h = [], eP.__h = [], t.__.forEach(function(e) {
            e.__N && (e.__ = e.__N), e.__V = lP, e.__N = e.i = void 0;
        })) : (t.__h.forEach(wP), t.__h.forEach(SP), t.__h = [])), tP = eP;
    }, H_.diffed = function(e) {
        uP && uP(e);
        var t = e.__c;
        t && t.__H && (t.__H.__h.length && (1 !== iP.push(t) && rP === H_.requestAnimationFrame || ((rP = H_.requestAnimationFrame) || PP)(_P)), t.__H.__.forEach(function(e) {
            e.i && (e.__H = e.i), e.__V !== lP && (e.__ = e.__V), e.i = void 0, e.__V = lP;
        })), tP = eP = null;
    }, H_.__c = function(e, t) {
        t.some(function(e) {
            try {
                e.__h.forEach(wP), e.__h = e.__h.filter(function(e) {
                    return !e.__ || SP(e);
                });
            } catch (r) {
                t.some(function(e) {
                    e.__h && (e.__h = []);
                }), t = [], H_.__e(r, e.__v);
            }
        }), dP && dP(e, t);
    }, H_.unmount = function(e) {
        pP && pP(e);
        var t, r = e.__c;
        r && r.__H && (r.__H.__.forEach(function(e) {
            try {
                wP(e);
            } catch (e) {
                t = e;
            }
        }), r.__H = void 0, t && H_.__e(t, r.__v));
    };
    var NP = "function" == typeof requestAnimationFrame;
    function PP(e) {
        var t, r = function() {
            clearTimeout(a), NP && cancelAnimationFrame(t), setTimeout(e);
        }, a = setTimeout(r, 100);
        NP && (t = requestAnimationFrame(r));
    }
    function wP(e) {
        var t = eP, r = e.__c;
        "function" == typeof r && (e.__c = void 0, r()), eP = t;
    }
    function SP(e) {
        var t = eP;
        e.__c = e.__(), eP = t;
    }
    function AP(e, t) {
        return !e || e.length !== t.length || t.some(function(t, r) {
            return t !== e[r];
        });
    }
    function IP(e, t) {
        return "function" == typeof t ? t(e) : t;
    }
    var DP = "https://checkoutshopper-live.adyen.com/checkoutshopper/", EP = [
        "resourceContext",
        "extension"
    ];
    function RP(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function xP(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = RP(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = RP(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var FP = function() {
        function e() {
            var t = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : DP;
            Cg(this, e), Sg(this, "resourceContext", void 0), Sg(this, "returnImage", function(e) {
                var t, r, a, n, o, i, l = e.name, c = e.resourceContext, s = e.imageFolder, u = void 0 === s ? "" : s, d = e.parentFolder, p = void 0 === d ? "" : d, m = e.extension, f = e.size, h = void 0 === f ? "" : f, v = e.subFolder, y = void 0 === v ? "" : v;
                return wb(t = wb(r = wb(a = wb(n = wb(o = wb(i = "".concat(c, "images/")).call(i, u)).call(o, y)).call(n, p)).call(a, l)).call(r, h, ".")).call(t, m);
            }), Sg(this, "getImageUrl", function(e) {
                var r = e.resourceContext, a = void 0 === r ? DP : r, n = e.extension, o = void 0 === n ? "svg" : n, i = kg(e, EP);
                return function(e) {
                    var r = xP({
                        extension: o,
                        resourceContext: a,
                        imageFolder: "logos/",
                        parentFolder: "",
                        name: e
                    }, i);
                    return t.returnImage(r);
                };
            }), this.resourceContext = r;
        }
        return wg(e, [
            {
                key: "getImage",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    return this.getImageUrl(xP(xP({}, e), {}, {
                        resourceContext: this.resourceContext
                    }));
                }
            }
        ]), e;
    }(), TP = SN({
        i18n: new a_,
        loadingContext: "",
        commonProps: {},
        resources: new FP
    });
    function zP() {
        return CP(TP);
    }
    function OP(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var jP = function(e) {
        L_(r, e);
        var t = OP(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "onClick", function(e) {
                e.preventDefault(), a.props.disabled || a.props.onClick(e, {
                    complete: a.complete
                });
            }), Sg(B_(a), "complete", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1e3;
                a.setState({
                    completed: !0
                }), ZN(function() {
                    a.setState({
                        completed: !1
                    });
                }, e);
            }), a;
        }
        return wg(r, [
            {
                key: "render",
                value: function(e, t) {
                    var r, a, n = e.classNameModifiers, o = void 0 === n ? [] : n, i = e.disabled, l = e.href, c = e.icon, s = e.inline, u = e.label, d = e.status, p = e.variant, m = t.completed, f = zP().i18n, h = c ? rN("img", {
                        className: "adyen-checkout__button__icon",
                        src: c,
                        alt: "",
                        "aria-hidden": "true"
                    }) : "", v = wb(r = []).call(r, Uk(o), Uk("primary" !== p ? [
                        p
                    ] : []), Uk(s ? [
                        "inline"
                    ] : []), Uk(m ? [
                        "completed"
                    ] : []), Uk("loading" === d || "redirect" === d ? [
                        "loading"
                    ] : [])), y = aP(wb(a = [
                        "adyen-checkout__button"
                    ]).call(a, Uk(hC(v).call(v, function(e) {
                        return "adyen-checkout__button--".concat(e);
                    })))), g = {
                        loading: rN(nP, {
                            size: "medium"
                        }),
                        redirect: rN("span", {
                            className: "adyen-checkout__button__content"
                        }, rN(nP, {
                            size: "medium",
                            inline: !0
                        }), f.get("payButton.redirecting")),
                        default: rN("span", {
                            className: "adyen-checkout__button__content"
                        }, h, rN("span", {
                            className: "adyen-checkout__button__text"
                        }, u))
                    }, b = g[d] || g.default;
                    return l ? rN("a", {
                        className: y,
                        href: l,
                        disabled: i,
                        target: this.props.target,
                        rel: this.props.rel
                    }, b) : rN("button", {
                        className: y,
                        type: "button",
                        disabled: i,
                        onClick: this.onClick
                    }, b, "loading" !== d && "redirect" !== d && this.props.children);
                }
            }
        ]), r;
    }(oN);
    Sg(jP, "defaultProps", {
        status: "default",
        variant: "primary",
        disabled: !1,
        label: "",
        inline: !1,
        target: "_self",
        onClick: function() {}
    });
    var BP = function(e, t) {
        return null != t && t.value && null != t && t.currency ? e.amount(t.value, t.currency, {
            currencyDisplay: t.currencyDisplay || "symbol"
        }) : "";
    }, MP = function(e, t) {
        var r;
        return wb(r = "".concat(e.get("payButton"), " ")).call(r, BP(e, t));
    }, LP = function(e) {
        return rN("span", {
            className: "checkout-secondary-button__text"
        }, e.label);
    }, VP = [
        "amount",
        "secondaryAmount",
        "classNameModifiers",
        "label"
    ], UP = function(e) {
        var t, r = e.amount, a = e.secondaryAmount, n = e.classNameModifiers, o = void 0 === n ? [] : n, i = e.label, l = kg(e, VP), c = zP().i18n, s = r && ({}).hasOwnProperty.call(r, "value") && 0 === r.value, u = s ? c.get("confirmPreauthorization") : MP(c, r), d = !s && !i && r && a && Ty(a).length ? function(e, t) {
            var r, a = t && null != t && t.value && null != t && t.currency ? e.amount(t.value, t.currency, {
                currencyDisplay: t.currencyDisplay || "symbol"
            }) : "", n = a.length ? "/ " : "";
            return wb(r = "".concat(n)).call(r, a);
        }(c, a) : null;
        return rN(jP, j_({}, l, {
            disabled: l.disabled || "loading" === l.status,
            classNameModifiers: wb(t = []).call(t, Uk(o), [
                "pay"
            ]),
            label: i || u
        }), d && rN(LP, {
            label: d
        }));
    }, KP = [
        "action",
        "resultCode",
        "sessionData",
        "order",
        "sessionResult"
    ];
    var HP = Ar, qP = a, WP = uk, GP = n, YP = hr, QP = mo, ZP = kl, JP = S, $P = X, XP = H, ew = Di, tw = Zt.f, rw = um.forEach, aw = I, nw = ri.set, ow = ri.getterFor, iw = function(e, t, r) {
        var a, n = -1 !== e.indexOf("Map"), o = -1 !== e.indexOf("Weak"), i = n ? "set" : "add", l = qP[e], c = l && l.prototype, s = {};
        if (aw && JP(l) && (o || c.forEach && !GP(function() {
            (new l).entries().next();
        }))) {
            var u = (a = t(function(t, r) {
                nw(ZP(t, u), {
                    type: e,
                    collection: new l
                }), XP(r) || QP(r, t[i], {
                    that: t,
                    AS_ENTRIES: n
                });
            })).prototype, d = ow(e);
            rw([
                "add",
                "clear",
                "delete",
                "forEach",
                "get",
                "has",
                "set",
                "keys",
                "values",
                "entries"
            ], function(e) {
                var t = "add" === e || "set" === e;
                !(e in c) || o && "clear" === e || YP(u, e, function(r, a) {
                    var n = d(this).collection;
                    if (!t && o && !$P(r)) return "get" === e && void 0;
                    var i = n[e](0 === r ? 0 : r, a);
                    return t ? this : i;
                });
            }), o || tw(u, "size", {
                configurable: !0,
                get: function() {
                    return d(this).collection.size;
                }
            });
        } else a = r.getConstructor(t, e, n, i), WP.enable();
        return ew(a, e, !1, !0), s[e] = a, HP({
            global: !0,
            forced: !0
        }, s), o || r.setStrong(a, e, n), a;
    }, lw = ui, cw = function(e, t, r) {
        for(var a in t)r && r.unsafe && e[a] ? e[a] = t[a] : lw(e, a, t[a], r);
        return e;
    }, sw = cn, uw = pl, dw = cw, pw = Qt, mw = kl, fw = H, hw = mo, vw = Xi, yw = el, gw = yl, bw = I, kw = uk.fastKey, Cw = ri.set, _w = ri.getterFor, Nw = {
        getConstructor: function(e, t, r, a) {
            var n = e(function(e, n) {
                mw(e, o), Cw(e, {
                    type: t,
                    index: sw(null),
                    first: void 0,
                    last: void 0,
                    size: 0
                }), bw || (e.size = 0), fw(n) || hw(n, e[a], {
                    that: e,
                    AS_ENTRIES: r
                });
            }), o = n.prototype, i = _w(t), l = function(e, t, r) {
                var a, n, o = i(e), l = c(e, t);
                return l ? l.value = r : (o.last = l = {
                    index: n = kw(t, !0),
                    key: t,
                    value: r,
                    previous: a = o.last,
                    next: void 0,
                    removed: !1
                }, o.first || (o.first = l), a && (a.next = l), bw ? o.size++ : e.size++, "F" !== n && (o.index[n] = l)), e;
            }, c = function(e, t) {
                var r, a = i(e), n = kw(t);
                if ("F" !== n) return a.index[n];
                for(r = a.first; r; r = r.next)if (r.key === t) return r;
            };
            return dw(o, {
                clear: function() {
                    for(var e = i(this), t = e.index, r = e.first; r;)r.removed = !0, r.previous && (r.previous = r.previous.next = void 0), delete t[r.index], r = r.next;
                    e.first = e.last = void 0, bw ? e.size = 0 : this.size = 0;
                },
                delete: function(e) {
                    var t = this, r = i(t), a = c(t, e);
                    if (a) {
                        var n = a.next, o = a.previous;
                        delete r.index[a.index], a.removed = !0, o && (o.next = n), n && (n.previous = o), r.first === a && (r.first = n), r.last === a && (r.last = o), bw ? r.size-- : t.size--;
                    }
                    return !!a;
                },
                forEach: function(e) {
                    for(var t, r = i(this), a = pw(e, arguments.length > 1 ? arguments[1] : void 0); t = t ? t.next : r.first;)for(a(t.value, t.key, this); t && t.removed;)t = t.previous;
                },
                has: function(e) {
                    return !!c(this, e);
                }
            }), dw(o, r ? {
                get: function(e) {
                    var t = c(this, e);
                    return t && t.value;
                },
                set: function(e, t) {
                    return l(this, 0 === e ? 0 : e, t);
                }
            } : {
                add: function(e) {
                    return l(this, e = 0 === e ? 0 : e, e);
                }
            }), bw && uw(o, "size", {
                configurable: !0,
                get: function() {
                    return i(this).size;
                }
            }), n;
        },
        setStrong: function(e, t, r) {
            var a = t + " Iterator", n = _w(t), o = _w(a);
            vw(e, t, function(e, t) {
                Cw(this, {
                    type: a,
                    target: e,
                    state: n(e),
                    kind: t,
                    last: void 0
                });
            }, function() {
                for(var e = o(this), t = e.kind, r = e.last; r && r.removed;)r = r.previous;
                return e.target && (e.last = r = r ? r.next : e.state.first) ? yw("keys" === t ? r.key : "values" === t ? r.value : [
                    r.key,
                    r.value
                ], !1) : (e.target = void 0, yw(void 0, !0));
            }, r ? "entries" : "values", !r, !0), gw(t);
        }
    };
    iw("Map", function(e) {
        return function() {
            return e(this, arguments.length ? arguments[0] : void 0);
        };
    }, Nw);
    var Pw = ee.Map, ww = function(e, t) {
        return 1 === t ? function(t, r) {
            return t[e](r);
        } : function(t, r, a) {
            return t[e](r, a);
        };
    }, Sw = oe("Map"), Aw = {
        Map: Sw,
        set: ww("set", 2),
        get: ww("get", 1),
        has: ww("has", 1),
        remove: ww("delete", 1),
        proto: Sw.prototype
    }, Iw = Ar, Dw = Ee, Ew = G, Rw = mo, xw = Aw.Map, Fw = Aw.has, Tw = Aw.get, zw = Aw.set, Ow = h([].push);
    Iw({
        target: "Map",
        stat: !0,
        forced: true
    }, {
        groupBy: function(e, t) {
            Ew(e), Dw(t);
            var r = new xw, a = 0;
            return Rw(e, function(e) {
                var n = t(e, a++);
                Fw(r, n) ? Ow(Tw(r, n), e) : zw(r, n, [
                    e
                ]);
            }), r;
        }
    });
    var jw = Pw, Bw = Qt, Mw = R, Lw = Ee, Vw = Wl, Uw = H, Kw = mo, Hw = [].push, qw = function(e) {
        var t, r, a, n, o = arguments.length, i = o > 1 ? arguments[1] : void 0;
        return Vw(this), (t = void 0 !== i) && Lw(i), Uw(e) ? new this : (r = [], t ? (a = 0, n = Bw(i, o > 2 ? arguments[2] : void 0), Kw(e, function(e) {
            Mw(Hw, r, n(e, a++));
        })) : Kw(e, Hw, {
            that: r
        }), new this(r));
    };
    Ar({
        target: "Map",
        stat: !0,
        forced: !0
    }, {
        from: qw
    });
    var Ww = $l, Gw = function() {
        return new this(Ww(arguments));
    };
    Ar({
        target: "Map",
        stat: !0,
        forced: !0
    }, {
        of: Gw
    });
    var Yw = Se, Qw = TypeError, Zw = function(e) {
        if ("object" == typeof e && "size" in e && "has" in e && "get" in e && "set" in e && "delete" in e && "entries" in e) return e;
        throw new Qw(Yw(e) + " is not a map");
    }, Jw = Zw, $w = Aw.remove;
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        deleteAll: function() {
            for(var e, t = Jw(this), r = !0, a = 0, n = arguments.length; a < n; a++)e = $w(t, arguments[a]), r = r && e;
            return !!r;
        }
    });
    var Xw = Zw, eS = Aw.get, tS = Aw.has, rS = Aw.set;
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        emplace: function(e, t) {
            var r, a, n = Xw(this);
            return tS(n, e) ? (r = eS(n, e), "update" in t && (r = t.update(r, e, n), rS(n, e, r)), r) : (a = t.insert(e, n), rS(n, e, a), a);
        }
    });
    var aS = R, nS = function(e, t, r) {
        for(var a, n, o = r ? e : e.iterator, i = e.next; !(a = aS(i, o)).done;)if (void 0 !== (n = t(a.value))) return n;
    }, oS = function(e, t, r) {
        return r ? nS(e.entries(), function(e) {
            return t(e[1], e[0]);
        }, !0) : e.forEach(t);
    }, iS = Qt, lS = Zw, cS = oS;
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        every: function(e) {
            var t = lS(this), r = iS(e, arguments.length > 1 ? arguments[1] : void 0);
            return !1 !== cS(t, function(e, a) {
                if (!r(e, a, t)) return !1;
            }, !0);
        }
    });
    var sS = Qt, uS = Zw, dS = oS, pS = Aw.Map, mS = Aw.set;
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        filter: function(e) {
            var t = uS(this), r = sS(e, arguments.length > 1 ? arguments[1] : void 0), a = new pS;
            return dS(t, function(e, n) {
                r(e, n, t) && mS(a, n, e);
            }), a;
        }
    });
    var fS = Qt, hS = Zw, vS = oS;
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        find: function(e) {
            var t = hS(this), r = fS(e, arguments.length > 1 ? arguments[1] : void 0), a = vS(t, function(e, a) {
                if (r(e, a, t)) return {
                    value: e
                };
            }, !0);
            return a && a.value;
        }
    });
    var yS = Qt, gS = Zw, bS = oS;
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        findKey: function(e) {
            var t = gS(this), r = yS(e, arguments.length > 1 ? arguments[1] : void 0), a = bS(t, function(e, a) {
                if (r(e, a, t)) return {
                    key: a
                };
            }, !0);
            return a && a.key;
        }
    });
    var kS = function(e, t) {
        return e === t || e != e && t != t;
    }, CS = Zw, _S = oS;
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        includes: function(e) {
            return !0 === _S(CS(this), function(t) {
                if (kS(t, e)) return !0;
            }, !0);
        }
    });
    var NS = R, PS = mo, wS = S, SS = Ee, AS = Aw.Map;
    Ar({
        target: "Map",
        stat: !0,
        forced: !0
    }, {
        keyBy: function(e, t) {
            var r = new (wS(this) ? this : AS);
            SS(t);
            var a = SS(r.set);
            return PS(e, function(e) {
                NS(a, r, t(e), e);
            }), r;
        }
    });
    var IS = Zw, DS = oS;
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        keyOf: function(e) {
            var t = DS(IS(this), function(t, r) {
                if (t === e) return {
                    key: r
                };
            }, !0);
            return t && t.key;
        }
    });
    var ES = Qt, RS = Zw, xS = oS, FS = Aw.Map, TS = Aw.set;
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        mapKeys: function(e) {
            var t = RS(this), r = ES(e, arguments.length > 1 ? arguments[1] : void 0), a = new FS;
            return xS(t, function(e, n) {
                TS(a, r(e, n, t), e);
            }), a;
        }
    });
    var zS = Qt, OS = Zw, jS = oS, BS = Aw.Map, MS = Aw.set;
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        mapValues: function(e) {
            var t = OS(this), r = zS(e, arguments.length > 1 ? arguments[1] : void 0), a = new BS;
            return jS(t, function(e, n) {
                MS(a, n, r(e, n, t));
            }), a;
        }
    });
    var LS = Zw, VS = mo, US = Aw.set;
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        arity: 1,
        forced: !0
    }, {
        merge: function(e) {
            for(var t = LS(this), r = arguments.length, a = 0; a < r;)VS(arguments[a++], function(e, r) {
                US(t, e, r);
            }, {
                AS_ENTRIES: !0
            });
            return t;
        }
    });
    var KS = Ee, HS = Zw, qS = oS, WS = TypeError;
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        reduce: function(e) {
            var t = HS(this), r = arguments.length < 2, a = r ? void 0 : arguments[1];
            if (KS(e), qS(t, function(n, o) {
                r ? (r = !1, a = n) : a = e(a, n, o, t);
            }), r) throw new WS("Reduce of empty map with no initial value");
            return a;
        }
    });
    var GS = Qt, YS = Zw, QS = oS;
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        some: function(e) {
            var t = YS(this), r = GS(e, arguments.length > 1 ? arguments[1] : void 0);
            return !0 === QS(t, function(e, a) {
                if (r(e, a, t)) return !0;
            }, !0);
        }
    });
    var ZS = Ee, JS = Zw, $S = TypeError, XS = Aw.get, eA = Aw.has, tA = Aw.set;
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        update: function(e, t) {
            var r = JS(this), a = arguments.length;
            ZS(t);
            var n = eA(r, e);
            if (!n && a < 3) throw new $S("Updating absent value");
            var o = n ? XS(r, e) : ZS(a > 2 ? arguments[2] : void 0)(e, r);
            return tA(r, e, t(o, e, r)), r;
        }
    });
    var rA = R, aA = Ee, nA = S, oA = tr, iA = TypeError, lA = function(e, t) {
        var r, a = oA(this), n = aA(a.get), o = aA(a.has), i = aA(a.set), l = arguments.length > 2 ? arguments[2] : void 0;
        if (!nA(t) && !nA(l)) throw new iA("At least one callback required");
        return rA(o, a, e) ? (r = rA(n, a, e), nA(t) && (r = t(r), rA(i, a, e, r))) : nA(l) && (r = l(), rA(i, a, e, r)), r;
    };
    Ar({
        target: "Map",
        proto: !0,
        real: !0,
        forced: !0
    }, {
        upsert: lA
    }), Ar({
        target: "Map",
        proto: !0,
        real: !0,
        name: "upsert",
        forced: !0
    }, {
        updateOrInsert: lA
    });
    var cA = t(jw);
    var sA = t(g_);
    function uA(e, t, r) {
        var a;
        (function() {
            if ("undefined" == typeof Reflect || !sA) return !1;
            if (sA.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(sA(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        })() ? uA = O_(a = sA).call(a) : uA = function(e, t, r) {
            var a = [
                null
            ];
            Yv(a).apply(a, t);
            var n = new (O_(Function).apply(e, a));
            return r && M_(n, r.prototype), n;
        };
        return uA.apply(null, arguments);
    }
    function dA(e) {
        var t = "function" == typeof cA ? new cA : void 0;
        return dA = function(e) {
            if (null === e || !function(e) {
                try {
                    var t;
                    return -1 !== gg(t = Function.toString.call(e)).call(t, "[native code]");
                } catch (t) {
                    return "function" == typeof e;
                }
            }(e)) return e;
            if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t) {
                if (t.has(e)) return t.get(e);
                t.set(e, r);
            }
            function r() {
                return uA(e, arguments, U_(this).constructor);
            }
            return r.prototype = sv(e.prototype, {
                constructor: {
                    value: r,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), M_(r, e);
        }, dA(e);
    }
    function pA(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var mA = function(e) {
        L_(r, e);
        var t = pA(r);
        function r(e, a, n) {
            var o;
            return Cg(this, r), Sg(B_(o = t.call(this, a)), "cause", void 0), o.name = r.errorTypes[e], o.cause = null == n ? void 0 : n.cause, o;
        }
        return wg(r);
    }(dA(Error));
    function fA() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
        return Object.prototype.hasOwnProperty.call(e, t);
    }
    function hA(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function vA(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = hA(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = hA(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function yA(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(mA, "errorTypes", {
        NETWORK_ERROR: "NETWORK_ERROR",
        CANCEL: "CANCEL",
        IMPLEMENTATION_ERROR: "IMPLEMENTATION_ERROR",
        ERROR: "ERROR"
    });
    var gA = function(e) {
        L_(r, e);
        var t = yA(r);
        function r(e) {
            var a, n, o, i, l, c, s, u, d, p;
            return Cg(this, r), Sg(B_(p = t.call(this, e)), "componentRef", void 0), Sg(B_(p), "elementRef", void 0), Sg(B_(p), "handleError", function(e) {
                p.setElementStatus("ready"), p.props.onError && p.props.onError(e, p.elementRef);
            }), Sg(B_(p), "handleAdditionalDetails", function(e) {
                return p.props.onAdditionalDetails ? p.props.onAdditionalDetails(e, p.elementRef) : p.props.session && p.submitAdditionalDetails(e.data), e;
            }), Sg(B_(p), "handleOrder", function(e) {
                p.updateParent({
                    order: e.order
                }), p.props.onPaymentCompleted && p.props.onPaymentCompleted(e, p.elementRef);
            }), Sg(B_(p), "handleFinalResult", function(e) {
                if (p.props.setStatusAutomatically) {
                    var t = function(e) {
                        switch(e.resultCode){
                            case "Authorised":
                            case "Received":
                            case "Pending":
                                return [
                                    "success"
                                ];
                            case "Cancelled":
                            case "Error":
                            case "Refused":
                                return [
                                    "error"
                                ];
                        }
                    }(e), r = Vk(t, 2), a = r[0], n = r[1];
                    a && p.setElementStatus(a, n);
                }
                return p.props.onPaymentCompleted && p.props.onPaymentCompleted(e, p.elementRef), e;
            }), Sg(B_(p), "setComponentRef", function(e) {
                p.componentRef = e;
            }), Sg(B_(p), "payButton", function(e) {
                return rN(UP, j_({}, e, {
                    amount: p.props.amount,
                    secondaryAmount: p.props.secondaryAmount,
                    onClick: p.submit
                }));
            }), p.submit = Jg(a = p.submit).call(a, B_(p)), p.setState = Jg(n = p.setState).call(n, B_(p)), p.onValid = Jg(o = p.onValid).call(o, B_(p)), p.onComplete = Jg(i = p.onComplete).call(i, B_(p)), p.onSubmit = Jg(l = p.onSubmit).call(l, B_(p)), p.handleAction = Jg(c = p.handleAction).call(c, B_(p)), p.handleOrder = Jg(s = p.handleOrder).call(s, B_(p)), p.handleResponse = Jg(u = p.handleResponse).call(u, B_(p)), p.setElementStatus = Jg(d = p.setElementStatus).call(d, B_(p)), p.elementRef = e && e.elementRef || B_(p), p;
        }
        return wg(r, [
            {
                key: "setState",
                value: function(e) {
                    this.state = vA(vA({}, this.state), e), this.onChange();
                }
            },
            {
                key: "onChange",
                value: function() {
                    var e = this.isValid, t = {
                        data: this.data,
                        errors: this.state.errors,
                        valid: this.state.valid,
                        isValid: e
                    };
                    return this.props.onChange && this.props.onChange(t, this.elementRef), e && this.onValid(), t;
                }
            },
            {
                key: "onSubmit",
                value: function() {
                    var e = this;
                    this.props.isInstantPayment && this.elementRef.closeActivePaymentMethod();
                    if (this.props.setStatusAutomatically && this.setElementStatus("loading"), this.props.onSubmit) this.props.onSubmit({
                        data: this.data,
                        isValid: this.isValid
                    }, this.elementRef);
                    else if (this._parentInstance.session) {
                        var t = this.props.beforeSubmit ? new Sb(function(t, r) {
                            return e.props.beforeSubmit(e.data, e.elementRef, {
                                resolve: t,
                                reject: r
                            });
                        }) : Sb.resolve(this.data);
                        t.then(function(t) {
                            return e.submitPayment(t);
                        }).catch(function() {
                            e.elementRef.setStatus("ready");
                        });
                    } else this.handleError(new mA("IMPLEMENTATION_ERROR", "Could not submit the payment"));
                }
            },
            {
                key: "onValid",
                value: function() {
                    var e = {
                        data: this.data
                    };
                    return this.props.onValid && this.props.onValid(e, this.elementRef), e;
                }
            },
            {
                key: "onComplete",
                value: function(e) {
                    this.props.onComplete && this.props.onComplete(e, this.elementRef);
                }
            },
            {
                key: "submit",
                value: function() {
                    this.isValid ? this.onSubmit() : this.showValidation();
                }
            },
            {
                key: "showValidation",
                value: function() {
                    return this.componentRef && this.componentRef.showValidation && this.componentRef.showValidation(), this;
                }
            },
            {
                key: "setElementStatus",
                value: function(e, t) {
                    var r;
                    return null === (r = this.elementRef) || void 0 === r || r.setStatus(e, t), this;
                }
            },
            {
                key: "setStatus",
                value: function(e, t) {
                    var r;
                    return null !== (r = this.componentRef) && void 0 !== r && r.setStatus && this.componentRef.setStatus(e, t), this;
                }
            },
            {
                key: "submitPayment",
                value: function(e) {
                    var t = this;
                    return this._parentInstance.session.submitPayment(e).then(this.handleResponse).catch(function(e) {
                        return t.handleError(e);
                    });
                }
            },
            {
                key: "submitAdditionalDetails",
                value: function(e) {
                    return this._parentInstance.session.submitDetails(e).then(this.handleResponse).catch(this.handleError);
                }
            },
            {
                key: "handleAction",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (!e || !e.type) {
                        if (fA(e, "action") && fA(e, "resultCode")) throw new Error('handleAction::Invalid Action - the passed action object itself has an "action" property and a "resultCode": have you passed in the whole response object by mistake?');
                        throw new Error('handleAction::Invalid Action - the passed action object does not have a "type" property');
                    }
                    var r = this._parentInstance.createFromAction(e, vA(vA(vA({}, this.elementRef.props), t), {}, {
                        onAdditionalDetails: this.handleAdditionalDetails
                    }));
                    return r ? (this.unmount(), r.mount(this._node)) : null;
                }
            },
            {
                key: "handleResponse",
                value: function(e) {
                    var t, r = function(e) {
                        var t, r = [], a = tC(t = Ty(e)).call(t, function(t, a) {
                            return kb(KP).call(KP, a) ? t[a] = e[a] : r.push(a), t;
                        }, {});
                        return r.length && console.warn("The following properties should not be passed to the client: ".concat(r.join(", "))), a;
                    }(e);
                    r.action ? this.elementRef.handleAction(r.action) : (null === (t = r.order) || void 0 === t || null === (t = t.remainingAmount) || void 0 === t ? void 0 : t.value) > 0 ? this.handleOrder(r) : this.elementRef.handleFinalResult(r);
                }
            },
            {
                key: "updateParent",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    return this.elementRef._parentInstance.update(e);
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !1;
                }
            },
            {
                key: "icon",
                get: function() {
                    var e, t = this.props.paymentMethodType || this.type;
                    return null !== (e = this.props.icon) && void 0 !== e ? e : this.resources.getImage()(t);
                }
            },
            {
                key: "displayName",
                get: function() {
                    return this.props.name || this.constructor.type;
                }
            },
            {
                key: "additionalInfo",
                get: function() {
                    return null;
                }
            },
            {
                key: "accessibleName",
                get: function() {
                    return this.displayName;
                }
            },
            {
                key: "type",
                get: function() {
                    return this.props.type || this.constructor.type;
                }
            }
        ]), r;
    }(xN);
    function bA(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var kA = function(e) {
        L_(r, e);
        var t = bA(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "iframeEl", void 0), a;
        }
        return wg(r, [
            {
                key: "iframeOnLoad",
                value: function() {
                    this.props.callback && "function" == typeof this.props.callback && this.props.callback(this.iframeEl.contentWindow);
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e;
                    if (this.iframeEl.addEventListener) this.iframeEl.addEventListener("load", Jg(e = this.iframeOnLoad).call(e, this), !1);
                    else if (this.iframeEl.attachEvent) {
                        var t;
                        this.iframeEl.attachEvent("onload", Jg(t = this.iframeOnLoad).call(t, this));
                    } else {
                        var r;
                        this.iframeEl.onload = Jg(r = this.iframeOnLoad).call(r, this);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e;
                    if (this.iframeEl.removeEventListener) this.iframeEl.removeEventListener("load", Jg(e = this.iframeOnLoad).call(e, this), !1);
                    else if (this.iframeEl.detachEvent) {
                        var t;
                        this.iframeEl.detachEvent("onload", Jg(t = this.iframeOnLoad).call(t, this));
                    } else this.iframeEl.onload = null;
                }
            },
            {
                key: "render",
                value: function(e) {
                    var t = this, r = e.name, a = e.src, n = e.width, o = e.height, i = e.minWidth, l = e.minHeight, c = e.allow, s = e.title, u = e.classNameModifiers, d = Fg(u).call(u, function(e) {
                        return !!e;
                    });
                    return rN("iframe", {
                        ref: function(e) {
                            t.iframeEl = e;
                        },
                        allow: c,
                        className: aP("adyen-checkout__iframe", "adyen-checkout__iframe--".concat(r), d.length && hC(u).call(u, function(e) {
                            var t;
                            return wb(t = "adyen-checkout__iframe--".concat(r, "-")).call(t, e);
                        })),
                        name: r,
                        src: a,
                        width: n,
                        height: o,
                        frameBorder: "0",
                        title: s,
                        referrerpolicy: "origin",
                        "min-width": i,
                        "min-height": l
                    });
                }
            }
        ]), r;
    }(oN);
    Sg(kA, "defaultProps", {
        width: "0",
        height: "0",
        minWidth: "0",
        minHeight: "0",
        src: null,
        allow: null,
        title: "components iframe",
        classNameModifiers: []
    });
    var CA = function(e, t, r) {
        var a, n = new Sb(function(n, o) {
            a = ZN(function() {
                o(r);
            }, e), t.then(function(e) {
                clearTimeout(a), n(e);
            }).catch(function(e) {
                clearTimeout(a), o(e);
            });
        });
        return {
            promise: n,
            cancel: function() {
                clearTimeout(a);
            }
        };
    }, _A = "deviceFingerprint", NA = {
        result: {
            type: _A,
            value: "df-timedOut"
        },
        errorCode: "timeout"
    }, PA = "unknownError", wA = {
        timeout: "iframe loading timed out",
        wrongOrigin: "Result did not come from the expected origin",
        wrongDataType: "Result data was not of the expected type",
        missingProperty: "Result data did not contain the expected properties",
        unknownError: "An unknown error occurred"
    }, SA = function(e, t, r, a) {
        return function(r) {
            var n = {};
            if ((r.origin || r.originalEvent.origin) !== e) return "Message was not sent from the expected domain";
            if ("string" != typeof r.data) return "Event data was not of type string";
            if (!r.data.length) return "Invalid event data string";
            try {
                var o = JSON.parse(r.data);
                if (!fA(o, "type") || o.type !== a) return "Event data was not of expected type";
                t(o);
            } catch (e) {
                return n.type = "".concat(a, "-JSON-parse-error"), n.comment = "failed to JSON parse event.data", n.extraInfo = "event.data = ".concat(r.data), n.eventDataRaw = r.data, console.debug("get-process-message-handler::CATCH::Un-parseable JSON:: parseErrorObj=", n), !1;
            }
            return !0;
        };
    }, AA = function(e) {
        var t, r, a, n = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/.exec(e);
        if (!n) return null;
        var o = Vk(n, 5), i = o[1], l = o[2], c = o[3], s = o[4];
        return i && l && c ? wb(t = wb(r = wb(a = "".concat(i, ":")).call(a, l)).call(r, c)).call(t, s ? ":".concat(s) : "") : null;
    };
    function IA(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var DA = function(e) {
        L_(r, e);
        var t = IA(r);
        function r(e) {
            var a;
            return Cg(this, r), Sg(B_(a = t.call(this, e)), "postMessageDomain", void 0), Sg(B_(a), "processMessageHandler", void 0), Sg(B_(a), "deviceFingerPrintPromise", void 0), a.postMessageDomain = AA(a.props.loadingContext) || a.props.loadingContext, a;
        }
        return wg(r, [
            {
                key: "getDfpPromise",
                value: function() {
                    var e = this;
                    return new Sb(function(t, r) {
                        e.processMessageHandler = SA(e.postMessageDomain, t, 0, _A), window.addEventListener("message", e.processMessageHandler);
                    });
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.deviceFingerPrintPromise = CA(2e4, this.getDfpPromise(), NA), this.deviceFingerPrintPromise.promise.then(function(t) {
                        e.props.onCompleteFingerprint(t), window.removeEventListener("message", e.processMessageHandler);
                    }).catch(function(t) {
                        e.props.onErrorFingerprint(t), window.removeEventListener("message", e.processMessageHandler);
                    });
                }
            },
            {
                key: "render",
                value: function(e) {
                    var t = e.dfpURL;
                    return rN("div", {
                        className: "adyen-checkout-risk__device-fingerprint"
                    }, rN(kA, {
                        name: "dfIframe",
                        src: t,
                        allow: "geolocation; microphone; camera;",
                        title: "devicefingerprinting iframe"
                    }));
                }
            }
        ]), r;
    }(oN);
    function EA(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var RA = function(e) {
        L_(r, e);
        var t = EA(r);
        function r(e) {
            var a, n, o;
            (Cg(this, r), a = t.call(this, e), e.clientKey) && (a.state = {
                status: "retrievingFingerPrint",
                dfpURL: wb(n = wb(o = "".concat(a.props.loadingContext, "assets/html/")).call(o, e.clientKey, "/dfp.")).call(n, "1.0.0", ".html")
            });
            return a;
        }
        return wg(r, [
            {
                key: "setStatusComplete",
                value: function(e) {
                    var t = this;
                    this.setState({
                        status: "complete"
                    }, function() {
                        t.props.onComplete(e);
                    });
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r = this, a = e.loadingContext, n = t.dfpURL;
                    return "retrievingFingerPrint" === this.state.status ? rN("div", {
                        className: "adyen-checkout-risk__device-fingerprint--wrapper",
                        style: {
                            position: "absolute",
                            width: 0,
                            height: 0
                        }
                    }, rN(DA, {
                        loadingContext: a,
                        dfpURL: n,
                        onCompleteFingerprint: function(e) {
                            r.setStatusComplete(e);
                        },
                        onErrorFingerprint: function(e) {
                            var t;
                            r.props.onError({
                                errorCode: t = e.errorCode,
                                message: wA[t] || wA[PA],
                                type: _A
                            }), r.setStatusComplete(e.result);
                        }
                    })) : null;
                }
            }
        ]), r;
    }(oN);
    Sg(RA, "defaultProps", {
        onComplete: function() {},
        onError: function() {}
    });
    var xA = t(wy), FA = {
        decode: function(e) {
            var t;
            return !!FA.isBase64(e) && !!FA.isBase64(e) && (t = e, decodeURIComponent(hC(Array.prototype).call(window.atob(t), function(e) {
                var t;
                return "%".concat(xA(t = "00".concat(e.charCodeAt(0).toString(16))).call(t, -2));
            }).join("")));
        },
        encode: function(e) {
            return window.btoa(e);
        },
        isBase64: function(e) {
            return !!e && !(e.length % 4) && window.btoa(window.atob(e)) === e;
        }
    };
    function TA(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function zA(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = TA(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = TA(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function OA(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var jA = function(e) {
        L_(r, e);
        var t = OA(r);
        function r(e) {
            var a;
            Cg(this, r), Sg(B_(a = t.call(this, e)), "nodeRiskContainer", null), Sg(B_(a), "onComplete", function(e) {
                var t = zA(zA({}, a.state.data), {}, Sg(Sg(Sg({}, e.type, e.value), "persistentCookie", e.persistentCookie), "components", e.components));
                a.setState({
                    data: t,
                    isValid: !0
                }), a.props.risk.onComplete(a.data), a.cleanUp();
            }), Sg(B_(a), "onError", function(e) {
                a.props.risk.onError(e), a.cleanUp();
            }), Sg(B_(a), "cleanUp", function() {
                a.nodeRiskContainer && a.nodeRiskContainer.parentNode && a.nodeRiskContainer.parentNode.removeChild(a.nodeRiskContainer);
            });
            var n = Sg({}, _A, null);
            return a.setState({
                data: n
            }), !0 === a.props.risk.enabled && (document.querySelector(a.props.risk.node) ? (a.nodeRiskContainer = document.createElement("div"), document.querySelector(a.props.risk.node).appendChild(a.nodeRiskContainer), a.mount(a.nodeRiskContainer)) : a.onError({
                message: "RiskModule node was not found"
            })), a;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return zA(zA({}, e), {}, {
                        risk: zA(zA({}, r.defaultProps.risk), e.risk)
                    });
                }
            },
            {
                key: "isValid",
                get: function() {
                    return this.state.isValid;
                }
            },
            {
                key: "data",
                get: function() {
                    if (this.isValid) {
                        var e = zA({
                            version: "1.0.0"
                        }, this.state.data);
                        return FA.encode(Mb(e));
                    }
                    return !1;
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.cleanUp();
                }
            },
            {
                key: "render",
                value: function() {
                    return rN(RA, j_({}, this.props, {
                        loadingContext: this.props.loadingContext,
                        onComplete: this.onComplete,
                        onError: this.onError
                    }));
                }
            }
        ]), r;
    }(xN);
    Sg(jA, "type", "risk"), Sg(jA, "defaultProps", {
        risk: {
            enabled: !0,
            onComplete: function() {},
            onError: function() {},
            node: "body"
        }
    });
    var BA = Je, MA = R, LA = X, VA = tr, UA = function(e) {
        return void 0 !== e && (BA(e, "value") || BA(e, "writable"));
    }, KA = A, HA = Mr;
    Ar({
        target: "Reflect",
        stat: !0
    }, {
        get: function e(t, r) {
            var a, n, o = arguments.length < 3 ? t : arguments[2];
            return VA(t) === o ? t[r] : (a = KA.f(t, r)) ? UA(a) ? a.value : void 0 === a.get ? void 0 : MA(a.get, o) : LA(n = HA(t)) ? e(n, r, o) : void 0;
        }
    });
    var qA = t(ee.Reflect.get), WA = t(qy);
    function GA() {
        var e;
        "undefined" != typeof Reflect && qA ? GA = O_(e = qA).call(e) : GA = function(e, t, r) {
            var a = function(e, t) {
                for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = U_(e)););
                return e;
            }(e, t);
            if (a) {
                var n = WA(a, t);
                return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
            }
        };
        return GA.apply(this, arguments);
    }
    var YA = um.every;
    Ar({
        target: "Array",
        proto: !0,
        forced: !vv("every")
    }, {
        every: function(e) {
            return YA(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var QA = Cv("Array", "every"), ZA = ie, JA = QA, $A = Array.prototype, XA = t(function(e) {
        var t = e.every;
        return e === $A || ZA($A, e) && t === $A.every ? JA : t;
    });
    function eI(e) {
        var t, r = e.children, a = e.classNameModifiers, n = void 0 === a ? [] : a, o = e.label, i = e.readonly, l = void 0 !== i && i, c = zP().i18n;
        return rN("fieldset", {
            className: aP(wb(t = [
                "adyen-checkout__fieldset"
            ]).call(t, Uk(hC(n).call(n, function(e) {
                return "adyen-checkout__fieldset--".concat(e);
            })), [
                {
                    "adyen-checkout__fieldset--readonly": l
                }
            ]))
        }, o && rN("legend", {
            className: "adyen-checkout__fieldset__title"
        }, c.get(o)), rN("div", {
            className: "adyen-checkout__fieldset__fields"
        }, r));
    }
    function tI() {
        var e = zP().resources;
        return kP(function(t) {
            return null == e ? void 0 : e.getImage(t);
        }, []);
    }
    var rI, aI = function(e) {
        var t, r = e.type, a = e.className, n = void 0 === a ? "" : a, o = e.alt, i = void 0 === o ? "" : o, l = e.height, c = e.width, s = null === (t = tI()({
            imageFolder: "components/"
        })) || void 0 === t ? void 0 : t(r);
        return rN("img", {
            className: aP("adyen-checkout__icon", n),
            alt: i,
            src: s,
            height: l,
            width: c
        });
    }, nI = "encryptedCardNumber", oI = "encryptedExpiryDate", iI = "encryptedExpiryMonth", lI = "encryptedExpiryYear", cI = "encryptedSecurityCode", sI = "encryptedPassword", uI = "encryptedBankAccountNumber", dI = "encryptedBankLocationId", pI = "encryptedSecurityCode3digits", mI = "encryptedSecurityCode4digits", fI = "giftcard", hI = [
        "amex",
        "mc",
        "visa"
    ], vI = [
        "ach",
        fI
    ], yI = [
        nI,
        oI,
        iI,
        lI,
        cI,
        sI
    ], gI = [
        uI,
        dI
    ], bI = wb(yI).call(yI, gI), kI = [
        "bcmc"
    ], CI = "required", _I = "optional", NI = "hidden", PI = CI, wI = _I, SI = NI, AI = CI, II = _I, DI = NI, EI = "data-cse", RI = "data-info", xI = "data-uid", FI = [
        "accel",
        "pulse",
        "star",
        "nyce"
    ], TI = {
        visa: "VISA",
        mc: "MasterCard",
        amex: "American Express",
        discover: "Discover",
        cup: "China Union Pay",
        jcb: "JCB",
        diners: "Diners Club",
        maestro: "Maestro",
        bcmc: "Bancontact card",
        bijcard: "de Bijenkorf Card"
    }, zI = "-ariaError", OI = "incomplete field", jI = "Unsupported card entered", BI = "Card number field empty", MI = "Expiry date field empty", LI = "Expiry year field empty", VI = "Expiry month field empty", UI = "Security code field empty", KI = "KCP password field empty", HI = "ACH bank account field empty", qI = "ACH bank location field empty", WI = (Sg(Sg(Sg(Sg(Sg(Sg(Sg(Sg(Sg(Sg(rI = {}, OI, "error.va.gen.01"), "field not valid", "error.va.gen.02"), "luhn check failed", "error.va.sf-cc-num.01"), BI, "error.va.sf-cc-num.02"), jI, "error.va.sf-cc-num.03"), "Card number not filled correctly", "error.va.sf-cc-num.04"), "Card too old", "error.va.sf-cc-dat.01"), "Date too far in future", "error.va.sf-cc-dat.02"), "Your card expires before check out date", "error.va.sf-cc-dat.03"), MI, "error.va.sf-cc-dat.04"), Sg(Sg(Sg(Sg(Sg(Sg(Sg(Sg(Sg(Sg(rI, "Expiry date not filled correctly", "error.va.sf-cc-dat.05"), LI, "error.va.sf-cc-yr.01"), "Expiry year not filled correctly", "error.va.sf-cc-yr.02"), VI, "error.va.sf-cc-mth.01"), UI, "error.va.sf-cc-cvc.01"), "Security code not filled correctly", "error.va.sf-cc-cvc.02"), KI, "error.va.sf-kcp-pwd.01"), "KCP password not filled correctly", "error.va.sf-kcp-pwd.02"), HI, "error.va.sf-ach-num.01"), "ACH bank account not filled correctly", "error.va.sf-ach-num.02"), Sg(Sg(rI, qI, "error.va.sf-ach-loc.01"), "ACH bank location id not filled correctly", "error.va.sf-ach-loc.02")), GI = WI[OI], YI = Sg(Sg(Sg(Sg(Sg(Sg(Sg(Sg({}, nI, WI[BI]), oI, WI[MI]), iI, WI[VI]), lI, WI[LI]), cI, WI[UI]), sI, WI[KI]), uI, WI[HI]), dI, WI[qI]), QI = "focusField", ZI = "notValidating:blurScenario", JI = Ar, $I = Date, XI = h($I.prototype.getTime);
    JI({
        target: "Date",
        stat: !0
    }, {
        now: function() {
            return XI(new $I);
        }
    });
    var eD = t(ee.Date.now), tD = eD(), rD = function() {
        var e;
        return tD += 1, wb(e = "".concat(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "field", "-")).call(e, tD);
    };
    function aD(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function nD(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = aD(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = aD(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var oD = function(e) {
        var t = e.children, r = e.className, a = e.classNameModifiers, n = e.dir, o = e.disabled, i = e.errorMessage, l = e.helper, c = e.inputWrapperModifiers, s = e.isLoading, u = e.isValid, d = e.label, p = e.labelEndAdornment, m = e.name, f = e.onBlur, h = e.onFieldBlur, v = e.onFocus, y = e.onFocusField, g = e.showValidIcon, b = e.useLabelElement, k = e.addContextualElement, C = e.filled, _ = e.focused, N = e.i18n, P = e.errorVisibleToScreenReader, w = e.renderAlternativeToLabel, S = null == P || P, A = gP(rD("adyen-checkout-".concat(m))), I = Vk(fP(!1), 2), D = I[0], E = I[1], R = Vk(fP(!1), 2), x = R[0], F = R[1];
        null != _ && E(!!_), null != C && F(!!C);
        var T = kP(function(e) {
            E(!0), null == v || v(e);
        }, [
            v
        ]), z = kP(function(e) {
            E(!1), null == f || f(e), null == h || h(e);
        }, [
            f,
            h
        ]), O = kP(function() {
            return rN(nN, null, "string" == typeof d && rN("span", {
                className: aP({
                    "adyen-checkout__label__text": !0,
                    "adyen-checkout__label__text--error": i
                }),
                "data-id": m
            }, d), "function" == typeof d && d(), p && rN("span", {
                className: "adyen-checkout__label-adornment--end"
            }, p), l && rN("span", {
                className: "adyen-checkout__helper-text"
            }, l));
        }, [
            d,
            i,
            p,
            l
        ]), j = kP(function() {
            var e, r, a;
            return rN(nN, null, rN("div", {
                className: aP(wb(e = [
                    "adyen-checkout__input-wrapper"
                ]).call(e, Uk(hC(c).call(c, function(e) {
                    return "adyen-checkout__input-wrapper--".concat(e);
                })))),
                dir: n
            }, hC(r = pN(t)).call(r, function(e) {
                return function(e, t, r) {
                    var a, n, o, i = eN({}, e.props);
                    for(o in t)"key" == o ? a = t[o] : "ref" == o ? n = t[o] : i[o] = t[o];
                    return arguments.length > 2 && (i.children = arguments.length > 3 ? K_.call(arguments, 2) : r), aN(e.type, i, a || e.key, n || e.ref, null);
                }(e, nD(nD({
                    isValid: u,
                    onFocusHandler: T,
                    onBlurHandler: z,
                    isInvalid: !!i
                }, m && {
                    uniqueId: A.current
                }), {}, {
                    addContextualElement: k
                }));
            }), s && rN("span", {
                className: "adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--loading"
            }, rN(nP, {
                size: "small"
            })), u && !1 !== g && rN("span", {
                className: "adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--valid"
            }, rN(aI, {
                type: "checkmark",
                alt: null == N ? void 0 : N.get("field.valid")
            })), i && rN("span", {
                className: "adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--invalid"
            }, rN(aI, {
                type: "field_error",
                alt: null == N ? void 0 : N.get("error.title")
            }))), k && rN("span", j_({
                className: "adyen-checkout__error-text"
            }, S && {
                id: wb(a = "".concat(A.current)).call(a, zI)
            }, {
                "aria-hidden": S ? null : "true"
            }), i && "string" == typeof i && i.length ? i : null));
        }, [
            t,
            i,
            s,
            u,
            T,
            z
        ]), B = kP(function(e) {
            var t = e.onFocusField, r = e.focused, a = e.filled, n = e.disabled, o = e.name, i = e.uniqueId, l = e.useLabelElement, c = e.isSecuredField, s = e.children, u = e.renderAlternativeToLabel, d = {
                onClick: t,
                className: aP({
                    "adyen-checkout__label": !0,
                    "adyen-checkout__label--focused": r,
                    "adyen-checkout__label--filled": a,
                    "adyen-checkout__label--disabled": n
                })
            };
            return l ? rN("label", j_({}, d, !c && {
                htmlFor: o && i
            }), s) : u(d, s, i);
        }, []);
        return rN("div", {
            className: aP("adyen-checkout__field", r, hC(a).call(a, function(e) {
                return "adyen-checkout__field--".concat(e);
            }), {
                "adyen-checkout__field--error": i,
                "adyen-checkout__field--valid": u
            })
        }, rN(B, {
            onFocusField: y,
            name: m,
            disabled: o,
            filled: x,
            focused: D,
            useLabelElement: b,
            uniqueId: A.current,
            isSecuredField: !S,
            renderAlternativeToLabel: w
        }, O()), j());
    };
    oD.defaultProps = {
        className: "",
        classNameModifiers: [],
        inputWrapperModifiers: [],
        useLabelElement: !0,
        addContextualElement: !0,
        renderAlternativeToLabel: function() {
            return null;
        }
    };
    var iD = function(e) {
        var t = e.data, r = t.name, a = t.registrationNumber;
        return rN(eI, {
            classNameModifiers: [
                "companyDetails"
            ],
            label: "companyDetails",
            readonly: !0
        }, r && "".concat(r, " "), a && "".concat(a, " "));
    }, lD = ci.PROPER, cD = n, sD = DC, uD = function(e) {
        return cD(function() {
            return !!sD[e]() || "\u200B\x85\u180E" !== "\u200B\x85\u180E"[e]() || lD && sD[e].name !== e;
        });
    }, dD = jC.start, pD = uD("trimStart") ? function() {
        return dD(this);
    } : "".trimStart;
    Ar({
        target: "String",
        proto: !0,
        name: "trimStart",
        forced: "".trimLeft !== pD
    }, {
        trimLeft: pD
    });
    Ar({
        target: "String",
        proto: !0,
        name: "trimStart",
        forced: "".trimStart !== pD
    }, {
        trimStart: pD
    });
    var mD = Cv("String", "trimLeft"), fD = ie, hD = mD, vD = String.prototype, yD = t(function(e) {
        var t = e.trimStart;
        return "string" == typeof e || e === vD || fD(vD, e) && t === vD.trimStart ? hD : t;
    }), gD = function(e, t, r, a) {
        var n, o;
        if (a && null !== (n = e[r]) && void 0 !== n && null !== (n = n[t]) && void 0 !== n && n.formatterFn) return null;
        var i = null === (o = e[r]) || void 0 === o || null === (o = o[t]) || void 0 === o ? void 0 : o.maxlength;
        return i || 30;
    }, bD = function(e) {
        return !(null != e && !/^[\s]*$/.test(e));
    }, kD = "?\\+_=!@#$%^&*(){}~<>\\[\\]\\/\\\\", CD = function(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "g";
        return new RegExp("[".concat(e, "]"), t);
    };
    (function(e, t) {
        var r;
        new RegExp(wb(r = "^[".concat(t ? "^" : "")).call(r, e, "]+$"));
    })(kD, !0);
    var _D = {
        default: {
            validate: function(e) {
                return e && e.length > 0;
            },
            modes: [
                "blur"
            ],
            errorMessage: "error.va.gen.01"
        },
        name: {
            validate: function(e) {
                return !bD(e) || null;
            },
            errorMessage: "companyDetails.name.invalid",
            modes: [
                "blur"
            ]
        },
        registrationNumber: {
            validate: function(e) {
                return !bD(e) || null;
            },
            errorMessage: "companyDetails.registrationNumber.invalid",
            modes: [
                "blur"
            ]
        }
    };
    function ND(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function PD(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = ND(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = ND(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var wD = function(e) {
        var t = e.name, r = e.registrationNumber;
        return PD({}, (t || r) && {
            company: PD(PD({}, t && {
                name: t
            }), r && {
                registrationNumber: r
            })
        });
    }, SD = function() {
        function e(t, r, a, n) {
            var o;
            Cg(this, e), Sg(this, "shouldValidate", void 0), Sg(this, "isValid", void 0), Sg(this, "errorMessage", void 0), this.shouldValidate = kb(o = t.modes).call(o, a), this.isValid = t.validate(r, n), this.errorMessage = t.errorMessage;
        }
        return wg(e, [
            {
                key: "hasError",
                value: function() {
                    return arguments.length > 0 && void 0 !== arguments[0] && arguments[0] ? !this.isValid && this.shouldValidate : null != this.isValid && !this.isValid && this.shouldValidate;
                }
            }
        ]), e;
    }();
    function AD(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function ID(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = AD(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = AD(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var DD = function() {
        function e(t) {
            Cg(this, e), Sg(this, "validationResults", void 0), this.validationResults = t;
        }
        return wg(e, [
            {
                key: "isValid",
                get: function() {
                    var e;
                    return tC(e = this.validationResults).call(e, function(e, t) {
                        return e && t.isValid;
                    }, !0);
                }
            },
            {
                key: "hasError",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    return Boolean(this.getError(e));
                }
            },
            {
                key: "getError",
                value: function() {
                    var e, t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    return zb(e = this.validationResults).call(e, function(e) {
                        return e.hasError(t);
                    });
                }
            },
            {
                key: "getAllErrors",
                value: function() {
                    var e;
                    return Fg(e = this.validationResults).call(e, function(e) {
                        return e.hasError();
                    });
                }
            }
        ]), e;
    }(), ED = function() {
        function e(t) {
            Cg(this, e), Sg(this, "rules", {
                default: {
                    validate: function() {
                        return !0;
                    },
                    modes: [
                        "blur",
                        "input"
                    ]
                }
            }), this.setRules(t);
        }
        return wg(e, [
            {
                key: "setRules",
                value: function(e) {
                    this.rules = ID(ID({}, this.rules), e);
                }
            },
            {
                key: "getRulesFor",
                value: function(e) {
                    var t, r = null !== (t = this.rules[e]) && void 0 !== t ? t : this.rules.default;
                    return JN(r) || (r = [
                        r
                    ]), r;
                }
            },
            {
                key: "validate",
                value: function(e, t) {
                    var r = e.key, a = e.value, n = e.mode, o = void 0 === n ? "blur" : n, i = this.getRulesFor(r), l = hC(i).call(i, function(e) {
                        return new SD(e, a, o, t);
                    });
                    return new DD(l);
                }
            }
        ]), e;
    }(), RD = I, xD = n, FD = h, TD = Mr, zD = Ma, OD = Z, jD = FD(x.f), BD = FD([].push), MD = RD && xD(function() {
        var e = Object.create(null);
        return e[2] = 2, !jD(e, 2);
    }), LD = function(e) {
        return function(t) {
            for(var r, a = OD(t), n = zD(a), o = MD && null === TD(a), i = n.length, l = 0, c = []; i > l;)r = n[l++], RD && !(o ? r in a : jD(a, r)) || BD(c, e ? [
                r,
                a[r]
            ] : a[r]);
            return c;
        };
    }, VD = {
        entries: LD(!0),
        values: LD(!1)
    }, UD = VD.values;
    Ar({
        target: "Object",
        stat: !0
    }, {
        values: function(e) {
            return UD(e);
        }
    });
    var KD = t(ee.Object.values);
    function HD(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function qD(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = HD(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = HD(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var WD = function(e, t) {
        var r, a;
        return tC(r = Fg(a = Ty(e)).call(a, function(e) {
            return !kb(t).call(t, e);
        })).call(r, function(t, r) {
            return t[r] = e[r], t;
        }, {});
    }, GD = function(e, t, r, a, n) {
        return tC(t).call(t, function(e, t) {
            var o, i, l;
            return qD(qD({}, e), {}, Sg({}, t, null !== (o = null !== (i = null !== (l = e[t]) && void 0 !== l ? l : null == n ? void 0 : n[t]) && void 0 !== i ? i : null == a ? void 0 : a[t]) && void 0 !== o ? o : r));
        }, e);
    };
    function YD(e) {
        var t = e.schema, r = e.defaultData, a = e.processField, n = e.fieldProblems, o = function(e) {
            var t, o;
            if (void 0 === r[e]) return {
                valid: !1,
                errors: null,
                data: null,
                fieldProblems: null !== (t = null == n ? void 0 : n[e]) && void 0 !== t ? t : null
            };
            var i = Vk(a({
                key: e,
                value: r[e],
                mode: "blur"
            }, {
                state: {
                    data: r
                }
            }), 2), l = i[0], c = i[1];
            return {
                valid: c.isValid && !(null != n && n[e]) || !1,
                errors: c.hasError() ? c.getError() : null,
                data: l,
                fieldProblems: null !== (o = null == n ? void 0 : n[e]) && void 0 !== o ? o : null
            };
        }, i = tC(t).call(t, function(e, t) {
            var r = o(t), a = r.valid, n = r.errors, i = r.data, l = r.fieldProblems;
            return {
                valid: qD(qD({}, e.valid), {}, Sg({}, t, a)),
                errors: qD(qD({}, e.errors), {}, Sg({}, t, n)),
                data: qD(qD({}, e.data), {}, Sg({}, t, i)),
                fieldProblems: qD(qD({}, e.fieldProblems), {}, Sg({}, t, l))
            };
        }, {
            data: {},
            valid: {},
            errors: {},
            fieldProblems: {}
        });
        return {
            schema: t,
            data: i.data,
            valid: i.valid,
            errors: i.errors,
            fieldProblems: i.fieldProblems
        };
    }
    function QD(e) {
        var t = e.rules, r = void 0 === t ? {} : t, a = e.formatters, n = void 0 === a ? {} : a, o = e.defaultData, i = void 0 === o ? {} : o, l = e.fieldProblems, c = void 0 === l ? {} : l, s = e.schema, u = void 0 === s ? [] : s, d = bP(function() {
            return new ED(r);
        }, [
            r
        ]), p = function(e, t) {
            var r = e.key, a = e.value, o = e.mode, i = null == n ? void 0 : n[r], l = function(e) {
                return e && "formatterFn" in e;
            }(i) ? i.formatterFn : i, c = l && "function" == typeof l ? l(null != a ? a : "", t) : a;
            return [
                c,
                d.validate({
                    key: r,
                    value: c,
                    mode: o
                }, t)
            ];
        }, m = hP(function(e) {
            return function(t, r) {
                var a = r.type, n = r.key, o = r.value, i = r.mode, l = r.schema, c = r.defaultData, s = r.formValue, u = r.selectedSchema, d = r.fieldProblems, p = u || t.schema;
                switch(a){
                    case "setData":
                        return qD(qD({}, t), {}, {
                            data: qD(qD({}, t.data), {}, Sg({}, n, o))
                        });
                    case "setValid":
                        return qD(qD({}, t), {}, {
                            valid: qD(qD({}, t.valid), {}, Sg({}, n, o))
                        });
                    case "setErrors":
                        return qD(qD({}, t), {}, {
                            errors: qD(qD({}, t.errors), {}, Sg({}, n, o))
                        });
                    case "setFieldProblems":
                        var m, f;
                        return null !== (m = null == t || null === (f = t.schema) || void 0 === f ? void 0 : tC(f).call(f, function(e, r) {
                            var a, n;
                            return qD(qD({}, e), {}, {
                                fieldProblems: qD(qD({}, t.fieldProblems), {}, Sg({}, r, null !== (a = null == d ? void 0 : d[r]) && void 0 !== a ? a : null)),
                                valid: qD(qD({}, t.valid), {}, Sg({}, r, (null === (n = t.valid) || void 0 === n ? void 0 : n[r]) && !d[r]))
                            });
                        }, t)) && void 0 !== m ? m : t;
                    case "updateField":
                        var h = Vk(e({
                            key: n,
                            value: o,
                            mode: i
                        }, {
                            state: t
                        }), 2), v = h[0], y = h[1], g = t.data[n], b = qD({}, t.fieldProblems);
                        return g !== v && (b[n] = null), qD(qD({}, t), {}, {
                            data: qD(qD({}, t.data), {}, Sg({}, n, v)),
                            errors: qD(qD({}, t.errors), {}, Sg({}, n, y.hasError() ? y.getError() : null)),
                            valid: qD(qD({}, t.valid), {}, Sg({}, n, y.isValid && !b[n] || !1)),
                            fieldProblems: b
                        });
                    case "mergeForm":
                        var k, C = qD(qD({}, t), {}, {
                            data: qD(qD({}, t.data), s.data),
                            errors: qD(qD({}, t.errors), s.errors),
                            valid: qD(qD({}, t.valid), s.valid),
                            fieldProblems: qD(qD({}, t.fieldProblems), s.fieldProblems)
                        });
                        return C.valid && (C.isValid = XA(k = KD(C.valid)).call(k, function(e) {
                            return e;
                        })), C;
                    case "setSchema":
                        var _, N, P, w, S = YD({
                            schema: l,
                            defaultData: c,
                            processField: e,
                            fieldProblems: d
                        }), A = Fg(_ = t.schema).call(_, function(e) {
                            return !kb(l).call(l, e);
                        }), I = Fg(l).call(l, function(e) {
                            var r;
                            return !kb(r = t.schema).call(r, e);
                        }), D = {
                            data: WD(t.data, I),
                            errors: WD(t.errors, I),
                            valid: WD(t.valid, I)
                        }, E = GD(WD(t.data, A), I, null, S.data, null === (N = t.local) || void 0 === N ? void 0 : N.data), R = GD(WD(t.valid, A), I, !1, S.valid, null === (P = t.local) || void 0 === P ? void 0 : P.valid), x = GD(WD(t.errors, A), I, null, S.errors, null === (w = t.local) || void 0 === w ? void 0 : w.errors);
                        return qD(qD({}, t), {}, {
                            schema: l,
                            data: E,
                            valid: R,
                            errors: x,
                            local: D
                        });
                    case "validateForm":
                        var F = tC(p).call(p, function(r, a) {
                            var n = Vk(e({
                                key: a,
                                value: t.data[a],
                                mode: "blur"
                            }, {
                                state: t
                            }), 2)[1];
                            return {
                                valid: qD(qD({}, r.valid), {}, Sg({}, a, n.isValid && !t.fieldProblems[a] || !1)),
                                errors: qD(qD({}, r.errors), {}, Sg({}, a, n.hasError(!0) ? n.getError(!0) : null))
                            };
                        }, {
                            valid: t.valid,
                            errors: t.errors
                        });
                        return qD(qD({}, t), {}, {
                            valid: F.valid,
                            errors: F.errors
                        });
                    default:
                        throw new Error("Undefined useForm action");
                }
            };
        }(p), {
            defaultData: i,
            schema: null != u ? u : [],
            processField: p,
            fieldProblems: c
        }, YD), f = Vk(m, 2), h = f[0], v = f[1], y = bP(function() {
            var e;
            return tC(e = h.schema).call(e, function(e, t) {
                return e && h.valid[t];
            }, !0);
        }, [
            h.schema,
            h.valid
        ]), g = kP(function() {
            v({
                type: "validateForm",
                selectedSchema: arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null
            });
        }, []), b = kP(function(e, t) {
            return v({
                type: "setErrors",
                key: e,
                value: t
            });
        }, []), k = kP(function(e, t) {
            return v({
                type: "setValid",
                key: e,
                value: t
            });
        }, []), C = kP(function(e, t) {
            return v({
                type: "setData",
                key: e,
                value: t
            });
        }, []), _ = kP(function(e) {
            return v({
                type: "setSchema",
                schema: e,
                defaultData: i
            });
        }, [
            h.schema
        ]), N = kP(function(e) {
            return v({
                type: "mergeForm",
                formValue: e
            });
        }, []), P = kP(function(e) {
            return v({
                type: "setFieldProblems",
                fieldProblems: e
            });
        }, [
            h.schema
        ]);
        return vP(function() {
            P(null != c ? c : {});
        }, [
            Mb(c)
        ]), {
            handleChangeFor: function(e, t) {
                return function(r) {
                    var a = function(e, t) {
                        return t.target ? "checkbox" === t.target.type ? !h.data[e] : t.target.value : t;
                    }(e, r);
                    v({
                        type: "updateField",
                        key: e,
                        value: a,
                        mode: t
                    });
                };
            },
            triggerValidation: g,
            setSchema: _,
            setData: C,
            setValid: k,
            setErrors: b,
            isValid: y,
            mergeForm: N,
            setFieldProblems: P,
            schema: h.schema,
            valid: h.valid,
            errors: h.errors,
            data: h.data,
            fieldProblems: h.fieldProblems
        };
    }
    var ZD = jC.trim;
    Ar({
        target: "String",
        proto: !0,
        forced: uD("trim")
    }, {
        trim: function() {
            return ZD(this);
        }
    });
    var JD = Cv("String", "trim"), $D = ie, XD = JD, eE = String.prototype, tE = t(function(e) {
        var t = e.trim;
        return "string" == typeof e || e === eE || $D(eE, e) && t === eE.trim ? XD : t;
    }), rE = [
        "setRef"
    ], aE = [
        "classNameModifiers",
        "uniqueId",
        "isInvalid",
        "isValid",
        "addContextualElement"
    ];
    function nE(e) {
        var t, r = e.setRef, a = kg(e, rE), n = a.autoCorrect, o = a.classNameModifiers, i = a.isInvalid, l = a.isValid, c = a.readonly, s = void 0 === c ? null : c, u = a.spellCheck, d = a.type, p = a.uniqueId, m = a.disabled, f = a.className;
        Object.prototype.hasOwnProperty.call(a, "onChange") && console.error("Error: Form fields that rely on InputBase may not have an onChange property");
        var h = kP(function(e) {
            a.onInput(e);
        }, [
            a.onInput
        ]), v = kP(function(e) {
            null != a && a.onKeyPress && a.onKeyPress(e);
        }, [
            null == a ? void 0 : a.onKeyPress
        ]), y = kP(function(e) {
            null != a && a.onKeyUp && a.onKeyUp(e);
        }, [
            null == a ? void 0 : a.onKeyUp
        ]), g = kP(function(e) {
            var t, r, n;
            (null == a || null === (t = a.onBlurHandler) || void 0 === t || t.call(a, e), a.trimOnBlur) && (e.target.value = tE(n = e.target.value).call(n));
            null == a || null === (r = a.onBlur) || void 0 === r || r.call(a, e);
        }, [
            a.onBlur,
            a.onBlurHandler
        ]), b = kP(function(e) {
            var t;
            null == a || null === (t = a.onFocusHandler) || void 0 === t || t.call(a, e);
        }, [
            a.onFocusHandler
        ]), k = aP("adyen-checkout__input", [
            "adyen-checkout__input--".concat(d)
        ], f, {
            "adyen-checkout__input--invalid": i,
            "adyen-checkout__input--valid": l
        }, hC(o).call(o, function(e) {
            return "adyen-checkout__input--".concat(e);
        }));
        a.classNameModifiers, a.uniqueId, a.isInvalid, a.isValid, a.addContextualElement;
        var C = kg(a, aE);
        return rN("input", j_({
            id: p
        }, C, {
            "aria-required": C.required,
            type: d,
            className: k,
            readOnly: s,
            spellCheck: u,
            autoCorrect: n,
            "aria-describedby": wb(t = "".concat(p)).call(t, zI),
            "aria-invalid": i,
            onInput: h,
            onBlur: g,
            onFocus: b,
            onKeyUp: y,
            onKeyPress: v,
            disabled: m,
            ref: r
        }));
    }
    function oE(e) {
        return rN(nE, j_({
            classNameModifiers: [
                "large"
            ]
        }, e, {
            "aria-required": e.required,
            type: "text"
        }));
    }
    function iE(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function lE(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = iE(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = iE(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    nE.defaultProps = {
        type: "text",
        classNameModifiers: []
    };
    var cE = [
        "name",
        "registrationNumber"
    ];
    function sE(e) {
        var t, r = e.label, a = void 0 === r ? "" : r, n = e.namePrefix, o = e.requiredFields, i = e.visibility, l = zP().i18n, c = QD({
            schema: o,
            rules: lE(lE({}, _D), e.validationRules),
            defaultData: e.data
        }), s = c.handleChangeFor, u = c.triggerValidation, d = c.data, p = c.valid, m = c.errors, f = c.isValid, h = gP({});
        Ty(h.current).length || null === (t = e.setComponentRef) || void 0 === t || t.call(e, h.current);
        h.current.showValidation = function() {
            u();
        };
        var v = function(e) {
            var t;
            return wb(t = "".concat(n ? "".concat(n, ".") : "")).call(t, e);
        }, y = function(e) {
            return function(t) {
                var r = t.target.name.split("".concat(n, ".")).pop();
                s(r, e)(t);
            };
        };
        return vP(function() {
            var t = wD(d);
            e.onChange({
                data: t,
                valid: p,
                errors: m,
                isValid: f
            });
        }, [
            d,
            p,
            m,
            f
        ]), "hidden" === i ? null : "readOnly" === i ? rN(iD, j_({}, e, {
            data: d
        })) : rN(eI, {
            classNameModifiers: [
                a
            ],
            label: a
        }, kb(o).call(o, "name") && rN(oD, {
            label: l.get("companyDetails.name"),
            classNameModifiers: [
                "name"
            ],
            errorMessage: !!m.name,
            i18n: l,
            name: v("companyName")
        }, rN(oE, {
            name: v("name"),
            value: d.name,
            classNameModifiers: [
                "name"
            ],
            onInput: y("input"),
            onBlur: y("blur"),
            spellCheck: !1
        })), kb(o).call(o, "registrationNumber") && rN(oD, {
            label: l.get("companyDetails.registrationNumber"),
            classNameModifiers: [
                "registrationNumber"
            ],
            errorMessage: !!m.registrationNumber,
            i18n: l,
            name: v("registrationNumber")
        }, rN(oE, {
            name: v("registrationNumber"),
            value: d.registrationNumber,
            classNameModifiers: [
                "registrationNumber"
            ],
            onInput: y("input"),
            onBlur: y("blur"),
            spellCheck: !1
        })));
    }
    sE.defaultProps = {
        data: {},
        onChange: function() {},
        visibility: "editable",
        requiredFields: cE,
        validationRules: _D
    };
    var uE = function(e) {
        var t = e.data, r = t.firstName, a = t.lastName, n = t.shopperEmail, o = t.telephoneNumber;
        return rN(eI, {
            classNameModifiers: [
                "personalDetails"
            ],
            label: "personalDetails",
            readonly: !0
        }, r && "".concat(r, " "), a && "".concat(a, " "), n && rN(nN, null, rN("br", null), n), o && rN(nN, null, rN("br", null), o));
    }, dE = /^(([a-z0-9!#$%&'*+\-/=?^_`{|}~]+(\.[a-z0-9!#$%&'*+\-/=?^_`{|}~]+)*)|(".+"))@((\[((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}])|([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?(\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*\.([a-z]{2,})))$/i, pE = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/, mE = function() {
        var e = document.createElement("input");
        return e.setAttribute("type", "date"), "date" === e.type;
    }, fE = function(e) {
        var t = e.replace(/\D|\s/g, "").replace(/^(00)(.*)?/, "01$2").replace(/^(3[2-9])(.*)?/, "0$1$2").replace(/^([4-9])(.*)?/, "0$1").replace(/^([0-9]{2})(00)(.*)?/, "$101").replace(/^(3[01])(02)(.*)?/, "29$2").replace(/^([0-9]{2})([2-9]|1[3-9])(.*)?/, "$10$2").replace(/^([0-9]{2})([0-9]{2})([0-9])/, "$1/$2/$3").replace(/^([0-9]{2})([0-9])/, "$1/$2"), r = Vk(t.split("/"), 3), a = r[0], n = void 0 === a ? "" : a, o = r[1], i = void 0 === o ? "" : o, l = r[2], c = void 0 === l ? "" : l;
        return 4 === c.length && "29" === n && "02" === i && (Number(c) % 4 != 0 || "00" === c.substr(2, 2) && Number(c) % 400 != 0) ? t.replace(/^29/, "28") : t;
    }, hE = function() {
        var e, t, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        if (-1 === Kk(r).call(r, "/")) return r;
        var a = Vk(r.split("/"), 3), n = a[0], o = void 0 === n ? "" : n, i = a[1], l = void 0 === i ? "" : i, c = a[2], s = void 0 === c ? "" : c;
        return o && l && s ? wb(e = wb(t = "".concat(s, "-")).call(t, l, "-")).call(e, o) : null;
    }, vE = function(e) {
        return bD(e) ? null : e.length >= 6 && e.length <= 320 && dE.test(e);
    }, yE = {
        default: {
            validate: function(e) {
                return e && e.length > 0;
            },
            errorMessage: "error.va.gen.02",
            modes: [
                "blur"
            ]
        },
        gender: {
            validate: function(e) {
                return e && e.length > 0;
            },
            errorMessage: "gender.notselected",
            modes: [
                "blur"
            ]
        },
        firstName: {
            validate: function(e) {
                return !bD(e) || null;
            },
            errorMessage: "firstName.invalid",
            modes: [
                "blur"
            ]
        },
        lastName: {
            validate: function(e) {
                return !bD(e) || null;
            },
            errorMessage: "lastName.invalid",
            modes: [
                "blur"
            ]
        },
        dateOfBirth: {
            validate: function(e) {
                return bD(e) ? null : function(e) {
                    if (!e) return !1;
                    var t = hE(e), r = eD() - Date.parse(t);
                    return new Date(r).getFullYear() - 1970 >= 18;
                }(e);
            },
            errorMessage: "dateOfBirth.invalid",
            modes: [
                "blur"
            ]
        },
        telephoneNumber: {
            validate: function(e) {
                return bD(e) ? null : pE.test(e);
            },
            errorMessage: "telephoneNumber.invalid",
            modes: [
                "blur"
            ]
        },
        shopperEmail: {
            validate: function(e) {
                return vE(e);
            },
            errorMessage: "shopperEmail.invalid",
            modes: [
                "blur"
            ]
        }
    };
    function gE(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function bE(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = gE(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = gE(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var kE = function(e) {
        var t = e.firstName, r = e.lastName, a = e.gender, n = e.dateOfBirth, o = e.shopperEmail, i = e.telephoneNumber;
        return bE(bE(bE(bE({}, (t || r) && {
            shopperName: bE(bE(bE({}, t && {
                firstName: t
            }), r && {
                lastName: r
            }), a && {
                gender: a
            })
        }), n && {
            dateOfBirth: hE(n)
        }), o && {
            shopperEmail: o
        }), i && {
            telephoneNumber: i
        });
    }, CE = u, _E = Z, NE = ea, PE = sa, wE = vv, SE = Math.min, AE = [].lastIndexOf, IE = !!AE && 1 / [
        1
    ].lastIndexOf(1, -0) < 0, DE = wE("lastIndexOf"), EE = IE || !DE ? function(e) {
        if (IE) return CE(AE, this, arguments) || 0;
        var t = _E(this), r = PE(t), a = r - 1;
        for(arguments.length > 1 && (a = SE(a, NE(arguments[1]))), a < 0 && (a = r + a); a >= 0; a--)if (a in t && t[a] === e) return a || 0;
        return -1;
    } : AE;
    Ar({
        target: "Array",
        proto: !0,
        forced: EE !== [].lastIndexOf
    }, {
        lastIndexOf: EE
    });
    var RE = Cv("Array", "lastIndexOf"), xE = ie, FE = RE, TE = Array.prototype, zE = t(function(e) {
        var t = e.lastIndexOf;
        return e === TE || xE(TE, e) && t === TE.lastIndexOf ? FE : t;
    });
    function OE(e) {
        var t = e.items, r = e.name, a = e.onChange, n = e.value, o = e.isInvalid, i = e.uniqueId, l = zP().i18n, c = null == i ? void 0 : i.replace(/[0-9]/g, "").substring(0, zE(i).call(i, "-"));
        return rN("div", {
            className: "adyen-checkout__radio_group"
        }, hC(t).call(t, function(t) {
            var i = rD(c);
            return rN("div", {
                key: t.id,
                className: "adyen-checkout__radio_group__input-wrapper"
            }, rN("input", {
                id: i,
                type: "radio",
                checked: n === t.id,
                className: "adyen-checkout__radio_group__input",
                name: r,
                onChange: a,
                onClick: a,
                value: t.id
            }), rN("label", {
                className: aP([
                    "adyen-checkout__label__text",
                    "adyen-checkout__radio_group__label",
                    e.className,
                    {
                        "adyen-checkout__radio_group__label--invalid": o
                    }
                ]),
                htmlFor: i
            }, l.get(t.name)));
        }));
    }
    function jE(e) {
        return rN(nE, bP(mE, []) ? j_({}, e, {
            type: "date"
        }) : j_({}, e, {
            onInput: function(t) {
                var r = t.target.value;
                t.target.value = fE(r), e.onInput(t);
            },
            maxLength: 10
        }));
    }
    function BE(e) {
        return rN(nE, j_({}, e, {
            type: "email",
            autoCapitalize: "off"
        }));
    }
    function ME(e) {
        return rN(nE, j_({}, e, {
            type: "tel"
        }));
    }
    function LE(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function VE(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = LE(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = LE(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    OE.defaultProps = {
        onChange: function() {},
        items: []
    };
    var UE = [
        "firstName",
        "lastName",
        "gender",
        "dateOfBirth",
        "shopperEmail",
        "telephoneNumber"
    ];
    function KE(e) {
        var t, r = e.label, a = void 0 === r ? "" : r, n = e.namePrefix, o = e.placeholders, i = e.requiredFields, l = e.visibility, c = zP().i18n, s = gP({});
        Ty(s.current).length || null === (t = e.setComponentRef) || void 0 === t || t.call(e, s.current);
        var u = bP(mE, []), d = QD({
            schema: i,
            rules: VE(VE({}, yE), e.validationRules),
            defaultData: e.data
        }), p = d.handleChangeFor, m = d.triggerValidation, f = d.data, h = d.valid, v = d.errors, y = d.isValid;
        s.current.showValidation = function() {
            m();
        };
        var g = function(e) {
            return function(t) {
                var r = t.target.name.split("".concat(n, ".")).pop();
                p(r, e)(t);
            };
        }, b = function(e) {
            var t;
            return wb(t = "".concat(n ? "".concat(n, ".") : "")).call(t, e);
        }, k = function(e) {
            return e && e.errorMessage ? c.get(e.errorMessage) : !!e;
        };
        return vP(function() {
            var t = kE(f);
            e.onChange({
                data: t,
                valid: h,
                errors: v,
                isValid: y
            });
        }, [
            f,
            h,
            v,
            y
        ]), "hidden" === l ? null : "readOnly" === l ? rN(uE, j_({}, e, {
            data: f
        })) : rN(nN, null, rN(eI, {
            classNameModifiers: [
                "personalDetails"
            ],
            label: a
        }, kb(i).call(i, "firstName") && rN(oD, {
            label: c.get("firstName"),
            classNameModifiers: [
                "col-50",
                "firstName"
            ],
            errorMessage: k(v.firstName),
            name: "firstName",
            i18n: c
        }, rN(oE, {
            name: b("firstName"),
            value: f.firstName,
            classNameModifiers: [
                "firstName"
            ],
            onInput: g("input"),
            onBlur: g("blur"),
            placeholder: o.firstName,
            spellCheck: !1,
            required: !0
        })), kb(i).call(i, "lastName") && rN(oD, {
            label: c.get("lastName"),
            classNameModifiers: [
                "col-50",
                "lastName"
            ],
            errorMessage: k(v.lastName),
            name: "lastName",
            i18n: c
        }, rN(oE, {
            name: b("lastName"),
            value: f.lastName,
            classNameModifiers: [
                "lastName"
            ],
            onInput: g("input"),
            onBlur: g("blur"),
            placeholder: o.lastName,
            spellCheck: !1,
            required: !0
        })), kb(i).call(i, "gender") && rN(oD, {
            errorMessage: k(v.gender),
            classNameModifiers: [
                "gender"
            ],
            name: "gender",
            useLabelElement: !1
        }, rN(OE, {
            name: b("gender"),
            value: f.gender,
            items: [
                {
                    id: "MALE",
                    name: "male"
                },
                {
                    id: "FEMALE",
                    name: "female"
                }
            ],
            classNameModifiers: [
                "gender"
            ],
            onInput: g("input"),
            onChange: g("blur"),
            required: !0
        })), kb(i).call(i, "dateOfBirth") && rN(oD, {
            label: c.get("dateOfBirth"),
            classNameModifiers: [
                "col-50",
                "dateOfBirth"
            ],
            errorMessage: k(v.dateOfBirth),
            helper: u ? null : c.get("dateOfBirth.format"),
            name: "dateOfBirth",
            i18n: c
        }, rN(jE, {
            name: b("dateOfBirth"),
            value: f.dateOfBirth,
            classNameModifiers: [
                "dateOfBirth"
            ],
            onInput: g("input"),
            onBlur: g("blur"),
            placeholder: o.dateOfBirth,
            required: !0
        })), kb(i).call(i, "shopperEmail") && rN(oD, {
            label: c.get("shopperEmail"),
            classNameModifiers: [
                "shopperEmail"
            ],
            errorMessage: k(v.shopperEmail),
            dir: "ltr",
            name: "emailAddress",
            i18n: c
        }, rN(BE, {
            name: b("shopperEmail"),
            value: f.shopperEmail,
            classNameModifiers: [
                "shopperEmail"
            ],
            onInput: g("input"),
            onBlur: g("blur"),
            placeholder: o.shopperEmail,
            required: !0
        })), kb(i).call(i, "telephoneNumber") && rN(oD, {
            label: c.get("telephoneNumber"),
            classNameModifiers: [
                "telephoneNumber"
            ],
            errorMessage: k(v.telephoneNumber),
            dir: "ltr",
            name: "telephoneNumber",
            i18n: c
        }, rN(ME, {
            name: b("telephoneNumber"),
            value: f.telephoneNumber,
            classNameModifiers: [
                "telephoneNumber"
            ],
            onInput: g("input"),
            onBlur: g("blur"),
            placeholder: o.telephoneNumber,
            required: !0
        }))), !1);
    }
    KE.defaultProps = {
        data: {},
        onChange: function() {},
        placeholders: {},
        requiredFields: UE,
        validationRules: yE,
        visibility: "editable"
    };
    var HE = "N/A", qE = [
        "street",
        "houseNumberOrName",
        "postalCode",
        "city",
        "stateOrProvince",
        "country",
        "firstName",
        "lastName"
    ], WE = qE[0], GE = qE[1], YE = qE[2], QE = qE[3], ZE = qE[4], JE = qE[5], $E = qE[6], XE = qE[7], eR = {
        AU: {
            hasDataset: !0,
            labels: Sg(Sg(Sg({}, GE, "apartmentSuite"), ZE, "state"), WE, "address"),
            optionalFields: [
                GE
            ],
            placeholders: Sg({}, ZE, "select.state"),
            schema: [
                JE,
                WE,
                GE,
                QE,
                [
                    [
                        ZE,
                        50
                    ],
                    [
                        YE,
                        50
                    ]
                ]
            ]
        },
        BR: {
            hasDataset: !0,
            labels: Sg({}, ZE, "state"),
            placeholders: Sg({}, ZE, "select.state")
        },
        CA: {
            hasDataset: !0,
            labels: Sg(Sg(Sg({}, GE, "apartmentSuite"), ZE, "provinceOrTerritory"), WE, "address"),
            optionalFields: [
                GE
            ],
            schema: [
                JE,
                WE,
                GE,
                [
                    [
                        QE,
                        70
                    ],
                    [
                        YE,
                        30
                    ]
                ],
                ZE
            ]
        },
        GB: {
            labels: Sg({}, QE, "cityTown"),
            schema: [
                JE,
                [
                    [
                        GE,
                        30
                    ],
                    [
                        WE,
                        70
                    ]
                ],
                [
                    [
                        QE,
                        70
                    ],
                    [
                        YE,
                        30
                    ]
                ],
                ZE
            ]
        },
        US: {
            hasDataset: !0,
            labels: Sg(Sg(Sg(Sg({}, YE, "zipCode"), GE, "apartmentSuite"), ZE, "state"), WE, "address"),
            optionalFields: [
                GE
            ],
            placeholders: Sg({}, ZE, "select.state"),
            schema: [
                JE,
                WE,
                GE,
                QE,
                [
                    [
                        ZE,
                        50
                    ],
                    [
                        YE,
                        50
                    ]
                ]
            ]
        },
        default: {
            optionalFields: [],
            placeholders: Sg({}, ZE, "select.provinceOrTerritory"),
            schema: [
                JE,
                [
                    [
                        WE,
                        70
                    ],
                    [
                        GE,
                        30
                    ]
                ],
                [
                    [
                        YE,
                        30
                    ],
                    [
                        QE,
                        70
                    ]
                ],
                ZE
            ]
        }
    }, tR = {
        default: {
            labels: Sg({}, YE, "zipCode"),
            schema: [
                YE
            ]
        }
    }, rR = Ty(eR), aR = function(e) {
        var t = e.firstName, r = e.lastName;
        return rN(nN, null, t && "".concat(t, " "), r && "".concat(r), rN("br", null));
    }, nR = function(e) {
        var t = e.data, r = e.label, a = t.street, n = t.houseNumberOrName, o = t.city, i = t.postalCode, l = t.stateOrProvince, c = t.country, s = t.firstName, u = t.lastName;
        return rN(eI, {
            classNameModifiers: [
                r
            ],
            label: r,
            readonly: !0
        }, (s || u) && rN(aR, {
            firstName: s,
            lastName: u
        }), !!a && a, n && ", ".concat(n, ","), rN("br", null), i && "".concat(i), o && ", ".concat(o), l && l !== HE && ", ".concat(l), c && ", ".concat(c, " "));
    }, oR = Ye, iR = na, lR = sa, cR = function(e) {
        for(var t = oR(this), r = lR(t), a = arguments.length, n = iR(a > 1 ? arguments[1] : void 0, r), o = a > 2 ? arguments[2] : void 0, i = void 0 === o ? r : iR(o, r); i > n;)t[n++] = e;
        return t;
    };
    Ar({
        target: "Array",
        proto: !0
    }, {
        fill: cR
    });
    var sR = Cv("Array", "fill"), uR = ie, dR = sR, pR = Array.prototype, mR = t(function(e) {
        var t = e.fill;
        return e === pR || uR(pR, e) && t === pR.fill ? dR : t;
    }), fR = function(e) {
        var t;
        return {
            formatterFn: function(t) {
                return t.replace(CD("^\\d", "g"), "").substring(0, e);
            },
            format: mR(t = new Array(e)).call(t, "9").join(""),
            maxlength: e
        };
    }, hR = CD(kD), vR = function(e) {
        return (function(e) {
            return yD(e).call(e).replace(/\s+/g, " ");
        })(e).replace(hR, "");
    }, yR = {
        postalCode: {
            formatterFn: function(e, t) {
                var r, a = t.state.data.country, n = null === (r = gR[a]) || void 0 === r ? void 0 : r.postalCode.formatterFn;
                return n ? n(e) : e;
            }
        },
        street: {
            formatterFn: vR
        },
        houseNumberOrName: {
            formatterFn: vR
        },
        city: {
            formatterFn: vR
        }
    }, gR = {
        AT: {
            postalCode: fR(4)
        },
        AU: {
            postalCode: fR(4)
        },
        BE: {
            postalCode: fR(4)
        },
        BG: {
            postalCode: fR(4)
        },
        BR: {
            postalCode: {
                formatterFn: function(e) {
                    var t = e.replace(CD("^\\d-", "g"), ""), r = Kk(t).call(t, "-") > -1 ? 9 : 8;
                    return t.substring(0, r);
                },
                format: "12345678 or 12345-678",
                maxlength: 9
            }
        },
        CA: {
            postalCode: {
                format: "A9A 9A9 or A9A9A9",
                maxlength: 7
            }
        },
        CH: {
            postalCode: fR(4)
        },
        CY: {
            postalCode: fR(4)
        },
        CZ: {
            postalCode: {
                format: "999 99",
                maxlength: 6
            }
        },
        DE: {
            postalCode: fR(5)
        },
        DK: {
            postalCode: {
                format: "9999",
                maxlength: 7
            }
        },
        EE: {
            postalCode: fR(5)
        },
        ES: {
            postalCode: fR(5)
        },
        FI: {
            postalCode: fR(5)
        },
        FR: {
            postalCode: fR(5)
        },
        GB: {
            postalCode: {
                formatterFn: function(e) {
                    return e.replace(CD(kD), "").substring(0, 8);
                },
                format: "AA99 9AA or A99 9AA or A9 9AA",
                maxlength: 8
            }
        },
        GR: {
            postalCode: {
                format: "999 99",
                maxlength: 6
            }
        },
        HR: {
            postalCode: {
                format: "[1-5]9999",
                maxlength: 5
            }
        },
        HU: {
            postalCode: fR(4)
        },
        IE: {
            postalCode: {
                format: "A99 A999",
                maxlength: 8
            }
        },
        IS: {
            postalCode: fR(3)
        },
        IT: {
            postalCode: fR(5)
        },
        LI: {
            postalCode: fR(4)
        },
        LT: {
            postalCode: {
                format: "9999 or 99999 or LT-99999",
                maxlength: 8
            }
        },
        LU: {
            postalCode: fR(4)
        },
        LV: {
            postalCode: {
                format: "9999 or LV-9999",
                maxlength: 7
            }
        },
        MC: {
            postalCode: {
                format: "980NN",
                maxlength: 5
            }
        },
        MT: {
            postalCode: {
                format: "AA99 or AAA99 or AA9999 or AAA9999",
                maxlength: 8
            }
        },
        MY: {
            postalCode: fR(5)
        },
        NL: {
            postalCode: {
                format: "9999AA",
                maxlength: 7
            }
        },
        NZ: {
            postalCode: fR(4)
        },
        NO: {
            postalCode: fR(4)
        },
        PL: {
            postalCode: {
                formatterFn: function(e) {
                    var t = e.replace(CD("^\\d-", "g"), ""), r = Kk(t).call(t, "-") > -1 ? 6 : 5;
                    return t.substring(0, r);
                },
                format: "99999 or 99-999",
                maxlength: 6
            }
        },
        PT: {
            postalCode: {
                formatterFn: function(e) {
                    return e.replace(CD("^\\d-", "g"), "").substring(0, 8);
                },
                format: "9999-999",
                maxlength: 8
            }
        },
        RO: {
            postalCode: fR(6)
        },
        SI: {
            postalCode: {
                format: "9999 or SI-9999",
                maxlength: 7
            }
        },
        SE: {
            postalCode: fR(5)
        },
        SG: {
            postalCode: fR(6)
        },
        SK: {
            postalCode: {
                format: "99999 or SK-99999",
                maxlength: 8
            }
        },
        JP: {
            postalCode: {
                format: "999-9999",
                maxlength: 8
            }
        },
        US: {
            postalCode: {
                formatterFn: function(e) {
                    var t = e.replace(CD("^\\d-", "g"), ""), r = Kk(t).call(t, "-") > -1 ? 10 : 5;
                    return t.substring(0, r);
                },
                format: "99999 or 99999-9999"
            }
        }
    }, bR = function(e) {
        return {
            pattern: new RegExp("\\d{".concat(e, "}"))
        };
    }, kR = function(e, t, r) {
        if (t) {
            var a, n;
            if (r.postalCode.errorMessage = {
                translationKey: "invalidFormatExpects",
                translationObject: {
                    values: {
                        format: (null === (a = gR[t]) || void 0 === a ? void 0 : a.postalCode.format) || null
                    }
                }
            }, bD(e)) return null;
            var o = null === (n = CR[t]) || void 0 === n ? void 0 : n.pattern;
            return o ? o.test(e) : !!e;
        }
        return !bD(e) || null;
    }, CR = {
        AT: bR(4),
        AU: bR(4),
        BE: {
            pattern: /(?:(?:[1-9])(?:\d{3}))/
        },
        BG: bR(4),
        BR: {
            pattern: /^\d{5}-?\d{3}$/
        },
        CA: {
            pattern: /(?:[ABCEGHJ-NPRSTVXY]\d[A-Z][ -]?\d[A-Z]\d)/
        },
        CH: {
            pattern: /[1-9]\d{3}/
        },
        CY: bR(4),
        CZ: {
            pattern: /\d{3}\s?\d{2}/
        },
        DE: bR(5),
        DK: bR(4),
        EE: bR(5),
        ES: {
            pattern: /(?:0[1-9]|[1-4]\d|5[0-2])\d{3}/
        },
        FI: bR(5),
        FR: bR(5),
        GB: {
            pattern: /^([A-Za-z][A-Ha-hK-Yk-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/
        },
        GE: bR(4),
        GR: {
            pattern: /^\d{3}\s{0,1}\d{2}$/
        },
        HR: {
            pattern: /^([1-5])[0-9]{4}$/
        },
        HU: bR(4),
        IE: {
            pattern: /(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}/
        },
        IS: bR(3),
        IT: bR(5),
        LI: bR(4),
        LT: {
            pattern: /^(LT-\d{5})$/
        },
        LU: bR(4),
        LV: {
            pattern: /^(LV-)[0-9]{4}$/
        },
        MC: {
            pattern: /^980\d{2}$/
        },
        MT: {
            pattern: /^[A-Za-z]{3}\d{4}$/
        },
        MY: bR(5),
        NL: {
            pattern: /(?:NL-)?(?:[1-9]\d{3} ?(?:[A-EGHJ-NPRTVWXZ][A-EGHJ-NPRSTVWXZ]|S[BCEGHJ-NPRTVWXZ]))/
        },
        NO: bR(4),
        PL: {
            pattern: /^\d{2}[-]{0,1}\d{3}$/
        },
        PT: {
            pattern: /^([1-9]\d{3})([- ]?(\d{3})? *)$/
        },
        RO: bR(6),
        SI: bR(4),
        SE: bR(5),
        SG: bR(6),
        SK: bR(5),
        US: bR(5)
    }, _R = function(e) {
        var t = {
            postalCode: {
                modes: [
                    "blur"
                ],
                validate: function(r) {
                    return kR(r, e, t);
                },
                errorMessage: WI[OI]
            }
        };
        return t;
    }, NR = function(e) {
        var t = {
            postalCode: {
                modes: [
                    "blur"
                ],
                validate: function(e, r) {
                    var a = r.state.data.country;
                    return kR(e, a, t);
                },
                errorMessage: WI[OI]
            },
            houseNumberOrName: {
                validate: function(t, r) {
                    var a, n = null === (a = r.state) || void 0 === a || null === (a = a.data) || void 0 === a ? void 0 : a.country;
                    return n && e.countryHasOptionalField(n, "houseNumberOrName") || !bD(t) || null;
                },
                modes: [
                    "blur"
                ],
                errorMessage: WI[OI]
            },
            default: {
                validate: function(e) {
                    return !bD(e) || null;
                },
                modes: [
                    "blur"
                ],
                errorMessage: WI[OI]
            }
        };
        return t;
    }, PR = a;
    Ar({
        global: !0,
        forced: PR.globalThis !== PR
    }, {
        globalThis: PR
    });
    var wR = t(a), SR = t(gh), AR = t(Wh), IR = Ar, DR = n, ER = Fp.f;
    IR({
        target: "Object",
        stat: !0,
        forced: DR(function() {
            return !Object.getOwnPropertyNames(1);
        })
    }, {
        getOwnPropertyNames: ER
    });
    var RR = ee.Object, xR = t(function(e) {
        return RR.getOwnPropertyNames(e);
    }), FR = Cv("Array", "entries"), TR = zn, zR = Je, OR = ie, jR = FR, BR = Array.prototype, MR = {
        DOMTokenList: !0,
        NodeList: !0
    }, LR = t(function(e) {
        var t = e.entries;
        return e === BR || OR(BR, e) && t === BR.entries || zR(MR, TR(e)) ? jR : t;
    }), VR = n, UR = dt("iterator"), KR = !VR(function() {
        var e = new URL("b?a=1&b=2&c=3", "http://a"), t = e.searchParams, r = new URLSearchParams("a=1&a=2&b=3"), a = "";
        return e.pathname = "c%20d", t.forEach(function(e, r) {
            t.delete("b"), a += r + e;
        }), r.delete("a", 2), r.delete("b", void 0), !e.toJSON || !r.has("a", 1) || r.has("a", 2) || !r.has("a", void 0) || r.has("b") || !t.size && true || !t.sort || "http://a/c%20d?a=1&c=3" !== e.href || "3" !== t.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !t[UR] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://\u0442\u0435\u0441\u0442").host || "#%D0%B1" !== new URL("http://a#\u0431").hash || "a1c3" !== a || "x" !== new URL("http://x", void 0).host;
    }), HR = Mp, qR = Math.floor, WR = function(e, t) {
        var r = e.length, a = qR(r / 2);
        return r < 8 ? GR(e, t) : YR(e, WR(HR(e, 0, a), t), WR(HR(e, a), t), t);
    }, GR = function(e, t) {
        for(var r, a, n = e.length, o = 1; o < n;){
            for(a = o, r = e[o]; a && t(e[a - 1], r) > 0;)e[a] = e[--a];
            a !== o++ && (e[a] = r);
        }
        return e;
    }, YR = function(e, t, r, a) {
        for(var n = t.length, o = r.length, i = 0, l = 0; i < n || l < o;)e[i + l] = i < n && l < o ? a(t[i], r[l]) <= 0 ? t[i++] : r[l++] : i < n ? t[i++] : r[l++];
        return e;
    }, QR = WR, ZR = Ar, JR = a, $R = R, XR = h, ex = I, tx = KR, rx = ui, ax = pl, nx = cw, ox = Di, ix = Oi, lx = ri, cx = kl, sx = S, ux = Je, dx = Qt, px = zn, mx = tr, fx = X, hx = vo, vx = cn, yx = B, gx = Yn, bx = Vn, kx = el, Cx = ec, _x = QR, Nx = dt("iterator"), Px = "URLSearchParams", wx = Px + "Iterator", Sx = lx.set, Ax = lx.getterFor(Px), Ix = lx.getterFor(wx), Dx = Object.getOwnPropertyDescriptor, Ex = function(e) {
        if (!ex) return JR[e];
        var t = Dx(JR, e);
        return t && t.value;
    }, Rx = Ex("fetch"), xx = Ex("Request"), Fx = Ex("Headers"), Tx = xx && xx.prototype, zx = Fx && Fx.prototype, Ox = JR.RegExp, jx = JR.TypeError, Bx = JR.decodeURIComponent, Mx = JR.encodeURIComponent, Lx = XR("".charAt), Vx = XR([].join), Ux = XR([].push), Kx = XR("".replace), Hx = XR([].shift), qx = XR([].splice), Wx = XR("".split), Gx = XR("".slice), Yx = /\+/g, Qx = Array(4), Zx = function(e) {
        return Qx[e - 1] || (Qx[e - 1] = Ox("((?:%[\\da-f]{2}){" + e + "})", "gi"));
    }, Jx = function(e) {
        try {
            return Bx(e);
        } catch (t) {
            return e;
        }
    }, $x = function(e) {
        var t = Kx(e, Yx, " "), r = 4;
        try {
            return Bx(t);
        } catch (e) {
            for(; r;)t = Kx(t, Zx(r--), Jx);
            return t;
        }
    }, Xx = /[!'()~]|%20/g, eF = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+"
    }, tF = function(e) {
        return eF[e];
    }, rF = function(e) {
        return Kx(Mx(e), Xx, tF);
    }, aF = ix(function(e, t) {
        Sx(this, {
            type: wx,
            target: Ax(e).entries,
            index: 0,
            kind: t
        });
    }, Px, function() {
        var e = Ix(this), t = e.target, r = e.index++;
        if (!t || r >= t.length) return e.target = void 0, kx(void 0, !0);
        var a = t[r];
        switch(e.kind){
            case "keys":
                return kx(a.key, !1);
            case "values":
                return kx(a.value, !1);
        }
        return kx([
            a.key,
            a.value
        ], !1);
    }, !0), nF = function(e) {
        this.entries = [], this.url = null, void 0 !== e && (fx(e) ? this.parseObject(e) : this.parseQuery("string" == typeof e ? "?" === Lx(e, 0) ? Gx(e, 1) : e : hx(e)));
    };
    nF.prototype = {
        type: Px,
        bindURL: function(e) {
            this.url = e, this.update();
        },
        parseObject: function(e) {
            var t, r, a, n, o, i, l, c = this.entries, s = bx(e);
            if (s) for(r = (t = gx(e, s)).next; !(a = $R(r, t)).done;){
                if (o = (n = gx(mx(a.value))).next, (i = $R(o, n)).done || (l = $R(o, n)).done || !$R(o, n).done) throw new jx("Expected sequence with length 2");
                Ux(c, {
                    key: hx(i.value),
                    value: hx(l.value)
                });
            }
            else for(var u in e)ux(e, u) && Ux(c, {
                key: u,
                value: hx(e[u])
            });
        },
        parseQuery: function(e) {
            if (e) for(var t, r, a = this.entries, n = Wx(e, "&"), o = 0; o < n.length;)(t = n[o++]).length && (r = Wx(t, "="), Ux(a, {
                key: $x(Hx(r)),
                value: $x(Vx(r, "="))
            }));
        },
        serialize: function() {
            for(var e, t = this.entries, r = [], a = 0; a < t.length;)e = t[a++], Ux(r, rF(e.key) + "=" + rF(e.value));
            return Vx(r, "&");
        },
        update: function() {
            this.entries.length = 0, this.parseQuery(this.url.query);
        },
        updateURL: function() {
            this.url && this.url.update();
        }
    };
    var oF = function() {
        cx(this, iF);
        var e = Sx(this, new nF(arguments.length > 0 ? arguments[0] : void 0));
        ex || (this.size = e.entries.length);
    }, iF = oF.prototype;
    if (nx(iF, {
        append: function(e, t) {
            var r = Ax(this);
            Cx(arguments.length, 2), Ux(r.entries, {
                key: hx(e),
                value: hx(t)
            }), ex || this.length++, r.updateURL();
        },
        delete: function(e) {
            for(var t = Ax(this), r = Cx(arguments.length, 1), a = t.entries, n = hx(e), o = r < 2 ? void 0 : arguments[1], i = void 0 === o ? o : hx(o), l = 0; l < a.length;){
                var c = a[l];
                if (c.key !== n || void 0 !== i && c.value !== i) l++;
                else if (qx(a, l, 1), void 0 !== i) break;
            }
            ex || (this.size = a.length), t.updateURL();
        },
        get: function(e) {
            var t = Ax(this).entries;
            Cx(arguments.length, 1);
            for(var r = hx(e), a = 0; a < t.length; a++)if (t[a].key === r) return t[a].value;
            return null;
        },
        getAll: function(e) {
            var t = Ax(this).entries;
            Cx(arguments.length, 1);
            for(var r = hx(e), a = [], n = 0; n < t.length; n++)t[n].key === r && Ux(a, t[n].value);
            return a;
        },
        has: function(e) {
            for(var t = Ax(this).entries, r = Cx(arguments.length, 1), a = hx(e), n = r < 2 ? void 0 : arguments[1], o = void 0 === n ? n : hx(n), i = 0; i < t.length;){
                var l = t[i++];
                if (l.key === a && (void 0 === o || l.value === o)) return !0;
            }
            return !1;
        },
        set: function(e, t) {
            var r = Ax(this);
            Cx(arguments.length, 1);
            for(var a, n = r.entries, o = !1, i = hx(e), l = hx(t), c = 0; c < n.length; c++)(a = n[c]).key === i && (o ? qx(n, c--, 1) : (o = !0, a.value = l));
            o || Ux(n, {
                key: i,
                value: l
            }), ex || (this.size = n.length), r.updateURL();
        },
        sort: function() {
            var e = Ax(this);
            _x(e.entries, function(e, t) {
                return e.key > t.key ? 1 : -1;
            }), e.updateURL();
        },
        forEach: function(e) {
            for(var t, r = Ax(this).entries, a = dx(e, arguments.length > 1 ? arguments[1] : void 0), n = 0; n < r.length;)a((t = r[n++]).value, t.key, this);
        },
        keys: function() {
            return new aF(this, "keys");
        },
        values: function() {
            return new aF(this, "values");
        },
        entries: function() {
            return new aF(this, "entries");
        }
    }, {
        enumerable: !0
    }), rx(iF, Nx, iF.entries, {
        name: "entries"
    }), rx(iF, "toString", function() {
        return Ax(this).serialize();
    }, {
        enumerable: !0
    }), ex && ax(iF, "size", {
        get: function() {
            return Ax(this).entries.length;
        },
        configurable: !0,
        enumerable: !0
    }), ox(oF, Px), ZR({
        global: !0,
        constructor: !0,
        forced: !tx
    }, {
        URLSearchParams: oF
    }), !tx && sx(Fx)) {
        var lF = XR(zx.has), cF = XR(zx.set), sF = function(e) {
            if (fx(e)) {
                var t, r = e.body;
                if (px(r) === Px) return t = e.headers ? new Fx(e.headers) : new Fx, lF(t, "content-type") || cF(t, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), vx(e, {
                    body: yx(0, hx(r)),
                    headers: yx(0, t)
                });
            }
            return e;
        };
        if (sx(Rx) && ZR({
            global: !0,
            enumerable: !0,
            dontCallGetSet: !0,
            forced: !0
        }, {
            fetch: function(e) {
                return Rx(e, arguments.length > 1 ? sF(arguments[1]) : {});
            }
        }), sx(xx)) {
            var uF = function(e) {
                return cx(this, Tx), new xx(e, arguments.length > 1 ? sF(arguments[1]) : {});
            };
            Tx.constructor = uF, uF.prototype = Tx, ZR({
                global: !0,
                constructor: !0,
                dontCallGetSet: !0,
                forced: !0
            }, {
                Request: uF
            });
        }
    }
    var dF = {
        URLSearchParams: oF,
        getState: Ax
    }, pF = t(ee.URLSearchParams), mF = t(lv), fF = Ar, hF = _;
    A.f;
    var vF = la, yF = vo, gF = ob, bF = G, kF = lb, CF = hF("".startsWith), _F = hF("".slice), NF = Math.min;
    fF({
        target: "String",
        proto: !0,
        forced: !kF("startsWith")
    }, {
        startsWith: function(e) {
            var t = yF(bF(this));
            gF(e);
            var r = vF(NF(arguments.length > 1 ? arguments[1] : void 0, t.length)), a = yF(e);
            return CF ? CF(t, a, r) : _F(t, r, r + a.length) === a;
        }
    });
    var PF = Cv("String", "startsWith"), wF = ie, SF = PF, AF = String.prototype, IF = t(function(e) {
        var t = e.startsWith;
        return "string" == typeof e || e === AF || wF(AF, e) && t === AF.startsWith ? SF : t;
    }), DF = void 0 !== wR && wR || "undefined" != typeof self && self || "undefined" != typeof $parcel$global && $parcel$global || {}, EF = "URLSearchParams" in DF, RF = "Symbol" in DF && "iterator" in SR, xF = "FileReader" in DF && "Blob" in DF && function() {
        try {
            return new Blob, !0;
        } catch (e) {
            return !1;
        }
    }(), FF = "FormData" in DF, TF = "ArrayBuffer" in DF;
    if (TF) var zF = [
        "[object Int8Array]",
        "[object Uint8Array]",
        "[object Uint8ClampedArray]",
        "[object Int16Array]",
        "[object Uint16Array]",
        "[object Int32Array]",
        "[object Uint32Array]",
        "[object Float32Array]",
        "[object Float64Array]"
    ], OF = ArrayBuffer.isView || function(e) {
        return e && Kk(zF).call(zF, Object.prototype.toString.call(e)) > -1;
    };
    function jF(e) {
        if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e) || "" === e) throw new TypeError('Invalid character in header field name: "' + e + '"');
        return e.toLowerCase();
    }
    function BF(e) {
        return "string" != typeof e && (e = String(e)), e;
    }
    function MF(e) {
        var t = {
            next: function() {
                var t = e.shift();
                return {
                    done: void 0 === t,
                    value: t
                };
            }
        };
        return RF && (t[AR] = function() {
            return t;
        }), t;
    }
    function LF(e) {
        if (this.map = {}, e instanceof LF) Ag(e).call(e, function(e, t) {
            this.append(t, e);
        }, this);
        else if (JN(e)) Ag(e).call(e, function(e) {
            if (2 != e.length) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + e.length);
            this.append(e[0], e[1]);
        }, this);
        else if (e) {
            var t;
            Ag(t = xR(e)).call(t, function(t) {
                this.append(t, e[t]);
            }, this);
        }
    }
    function VF(e) {
        if (!e._noBody) return e.bodyUsed ? Sb.reject(new TypeError("Already read")) : void (e.bodyUsed = !0);
    }
    function UF(e) {
        return new Sb(function(t, r) {
            e.onload = function() {
                t(e.result);
            }, e.onerror = function() {
                r(e.error);
            };
        });
    }
    function KF(e) {
        var t = new FileReader, r = UF(t);
        return t.readAsArrayBuffer(e), r;
    }
    function HF(e) {
        if (xA(e)) return xA(e).call(e, 0);
        var t = new Uint8Array(e.byteLength);
        return t.set(new Uint8Array(e)), t.buffer;
    }
    function qF() {
        return this.bodyUsed = !1, this._initBody = function(e) {
            var t;
            this.bodyUsed = this.bodyUsed, this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : xF && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : FF && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : EF && pF.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : TF && xF && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = HF(e.buffer), this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ])) : TF && (ArrayBuffer.prototype.isPrototypeOf(e) || OF(e)) ? this._bodyArrayBuffer = HF(e) : this._bodyText = e = Object.prototype.toString.call(e) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : EF && pF.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, xF && (this.blob = function() {
            var e = VF(this);
            if (e) return e;
            if (this._bodyBlob) return Sb.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer) return Sb.resolve(new Blob([
                this._bodyArrayBuffer
            ]));
            if (this._bodyFormData) throw new Error("could not read FormData body as blob");
            return Sb.resolve(new Blob([
                this._bodyText
            ]));
        }), this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
                var e, t = VF(this);
                return t || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Sb.resolve(xA(e = this._bodyArrayBuffer.buffer).call(e, this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Sb.resolve(this._bodyArrayBuffer));
            }
            if (xF) return this.blob().then(KF);
            throw new Error("could not read as ArrayBuffer");
        }, this.text = function() {
            var e = VF(this);
            if (e) return e;
            if (this._bodyBlob) return function(e) {
                var t = new FileReader, r = UF(t), a = /charset=([A-Za-z0-9_-]+)/.exec(e.type), n = a ? a[1] : "utf-8";
                return t.readAsText(e, n), r;
            }(this._bodyBlob);
            if (this._bodyArrayBuffer) return Sb.resolve(function(e) {
                for(var t = new Uint8Array(e), r = new Array(t.length), a = 0; a < t.length; a++)r[a] = String.fromCharCode(t[a]);
                return r.join("");
            }(this._bodyArrayBuffer));
            if (this._bodyFormData) throw new Error("could not read FormData body as text");
            return Sb.resolve(this._bodyText);
        }, FF && (this.formData = function() {
            return this.text().then(YF);
        }), this.json = function() {
            return this.text().then(JSON.parse);
        }, this;
    }
    LF.prototype.append = function(e, t) {
        e = jF(e), t = BF(t);
        var r = hC(this)[e];
        hC(this)[e] = r ? r + ", " + t : t;
    }, LF.prototype.delete = function(e) {
        delete hC(this)[jF(e)];
    }, LF.prototype.get = function(e) {
        return e = jF(e), this.has(e) ? hC(this)[e] : null;
    }, LF.prototype.has = function(e) {
        return hC(this).hasOwnProperty(jF(e));
    }, LF.prototype.set = function(e, t) {
        hC(this)[jF(e)] = BF(t);
    }, LF.prototype.forEach = function(e, t) {
        for(var r in hC(this))hC(this).hasOwnProperty(r) && e.call(t, hC(this)[r], r, this);
    }, LF.prototype.keys = function() {
        var e = [];
        return Ag(this).call(this, function(t, r) {
            e.push(r);
        }), MF(e);
    }, LF.prototype.values = function() {
        var e = [];
        return Ag(this).call(this, function(t) {
            e.push(t);
        }), MF(e);
    }, LF.prototype.entries = function() {
        var e = [];
        return Ag(this).call(this, function(t, r) {
            e.push([
                r,
                t
            ]);
        }), MF(e);
    }, RF && (LF.prototype[AR] = LR(LF.prototype));
    var WF = [
        "CONNECT",
        "DELETE",
        "GET",
        "HEAD",
        "OPTIONS",
        "PATCH",
        "POST",
        "PUT",
        "TRACE"
    ];
    function GF(e, t) {
        if (!(this instanceof GF)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        var r = (t = t || {}).body;
        if (e instanceof GF) {
            if (e.bodyUsed) throw new TypeError("Already read");
            this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new LF(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, r || null == e._bodyInit || (r = e._bodyInit, e.bodyUsed = !0);
        } else this.url = String(e);
        if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new LF(t.headers)), this.method = function(e) {
            var t = e.toUpperCase();
            return Kk(WF).call(WF, t) > -1 ? t : e;
        }(t.method || this.method || "GET"), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal || function() {
            if ("AbortController" in DF) return (new AbortController).signal;
        }(), this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && r) throw new TypeError("Body not allowed for GET or HEAD requests");
        if (this._initBody(r), !("GET" !== this.method && "HEAD" !== this.method || "no-store" !== t.cache && "no-cache" !== t.cache)) {
            var a = /([?&])_=[^&]*/;
            if (a.test(this.url)) this.url = this.url.replace(a, "$1_=" + (new Date).getTime());
            else this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (new Date).getTime();
        }
    }
    function YF(e) {
        var t, r = new FormData;
        return Ag(t = tE(e).call(e).split("&")).call(t, function(e) {
            if (e) {
                var t = e.split("="), a = t.shift().replace(/\+/g, " "), n = t.join("=").replace(/\+/g, " ");
                r.append(decodeURIComponent(a), decodeURIComponent(n));
            }
        }), r;
    }
    function QF(e, t) {
        if (!(this instanceof QF)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        if (t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
        this.ok = this.status >= 200 && this.status < 300, this.statusText = void 0 === t.statusText ? "" : "" + t.statusText, this.headers = new LF(t.headers), this.url = t.url || "", this._initBody(e);
    }
    GF.prototype.clone = function() {
        return new GF(this, {
            body: this._bodyInit
        });
    }, qF.call(GF.prototype), qF.call(QF.prototype), QF.prototype.clone = function() {
        return new QF(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new LF(this.headers),
            url: this.url
        });
    }, QF.error = function() {
        var e = new QF(null, {
            status: 200,
            statusText: ""
        });
        return e.status = 0, e.type = "error", e;
    };
    var ZF = [
        301,
        302,
        303,
        307,
        308
    ];
    QF.redirect = function(e, t) {
        if (-1 === Kk(ZF).call(ZF, t)) throw new RangeError("Invalid status code");
        return new QF(null, {
            status: t,
            headers: {
                location: e
            }
        });
    };
    var JF = DF.DOMException;
    try {
        new JF;
    } catch (e) {
        JF = function(e, t) {
            this.message = e, this.name = t;
            var r = Error(e);
            this.stack = r.stack;
        }, JF.prototype = mF(Error.prototype), JF.prototype.constructor = JF;
    }
    function $F(e, t) {
        return new Sb(function(r, a) {
            var n = new GF(e, t);
            if (n.signal && n.signal.aborted) return a(new JF("Aborted", "AbortError"));
            var o = new XMLHttpRequest;
            function i() {
                o.abort();
            }
            if (o.onload = function() {
                var e, t, a, i, l, c, s = {
                    statusText: o.statusText,
                    headers: (t = o.getAllResponseHeaders() || "", l = new LF, c = t.replace(/\r?\n[\t ]+/g, " "), Ag(a = hC(i = c.split("\r")).call(i, function(e) {
                        return 0 === Kk(e).call(e, "\n") ? e.substr(1, e.length) : e;
                    })).call(a, function(e) {
                        var t, r = e.split(":"), a = tE(t = r.shift()).call(t);
                        if (a) {
                            var n, o = tE(n = r.join(":")).call(n);
                            try {
                                l.append(a, o);
                            } catch (e) {
                                console.warn("Response " + e.message);
                            }
                        }
                    }), l)
                };
                IF(e = n.url).call(e, "file://") && (o.status < 200 || o.status > 599) ? s.status = 200 : s.status = o.status, s.url = "responseURL" in o ? o.responseURL : s.headers.get("X-Request-URL");
                var u = "response" in o ? o.response : o.responseText;
                ZN(function() {
                    r(new QF(u, s));
                }, 0);
            }, o.onerror = function() {
                ZN(function() {
                    a(new TypeError("Network request failed"));
                }, 0);
            }, o.ontimeout = function() {
                ZN(function() {
                    a(new TypeError("Network request timed out"));
                }, 0);
            }, o.onabort = function() {
                ZN(function() {
                    a(new JF("Aborted", "AbortError"));
                }, 0);
            }, o.open(n.method, function(e) {
                try {
                    return "" === e && DF.location.href ? DF.location.href : e;
                } catch (t) {
                    return e;
                }
            }(n.url), !0), "include" === n.credentials ? o.withCredentials = !0 : "omit" === n.credentials && (o.withCredentials = !1), "responseType" in o && (xF ? o.responseType = "blob" : TF && (o.responseType = "arraybuffer")), t && "object" === ig(t.headers) && !(t.headers instanceof LF || DF.Headers && t.headers instanceof DF.Headers)) {
                var l, c, s = [];
                Ag(l = xR(t.headers)).call(l, function(e) {
                    s.push(jF(e)), o.setRequestHeader(e, BF(t.headers[e]));
                }), Ag(c = n.headers).call(c, function(e, t) {
                    -1 === Kk(s).call(s, t) && o.setRequestHeader(t, e);
                });
            } else {
                var u;
                Ag(u = n.headers).call(u, function(e, t) {
                    o.setRequestHeader(t, e);
                });
            }
            n.signal && (n.signal.addEventListener("abort", i), o.onreadystatechange = function() {
                4 === o.readyState && n.signal.removeEventListener("abort", i);
            }), o.send(void 0 === n._bodyInit ? null : n._bodyInit);
        });
    }
    $F.polyfill = !0, DF.fetch || (DF.fetch = $F, DF.Headers = LF, DF.Request = GF, DF.Response = QF);
    var XF = "undefined" != typeof window && "fetch" in window ? window.fetch : $F, eT = "https://checkoutshopper-live.adyen.com/checkoutshopper/", tT = [
        "amount",
        "secondaryAmount",
        "countryCode",
        "environment",
        "loadingContext",
        "i18n",
        "modules",
        "order",
        "session",
        "clientKey",
        "showPayButton",
        "redirectFromTopWhenInIframe",
        "installmentOptions",
        "onPaymentCompleted",
        "beforeRedirect",
        "beforeSubmit",
        "onSubmit",
        "onActionHandled",
        "onAdditionalDetails",
        "onCancel",
        "onChange",
        "onError",
        "onBalanceCheck",
        "onOrderRequest",
        "onOrderCreated",
        "setStatusAutomatically"
    ], rT = 6e4;
    function aT(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function nT(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = aT(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = aT(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function oT(e) {
        return e && e.errorCode && e.errorType && e.message && e.status;
    }
    function iT(e, t) {
        var r, a, n, o = e.headers, i = void 0 === o ? [] : o, l = e.errorLevel, c = void 0 === l ? "warn" : l, s = e.loadingContext, u = void 0 === s ? eT : s, d = e.method, p = void 0 === d ? "GET" : d, m = e.path, f = e.timeout, h = void 0 === f ? rT : f, v = nT(nT({
            method: p,
            mode: "cors",
            cache: "default",
            credentials: "same-origin",
            headers: nT({
                Accept: "application/json, text/plain, */*",
                "Content-Type": "POST" === p ? "application/json" : "text/plain"
            }, i),
            redirect: "follow",
            referrerPolicy: "no-referrer-when-downgrade"
        }, (null === (r = AbortSignal) || void 0 === r ? void 0 : r.timeout) && {
            signal: null === (a = AbortSignal) || void 0 === a ? void 0 : a.timeout(h)
        }), t && {
            body: Mb(t)
        }), y = wb(n = "".concat(u)).call(n, m);
        return XF(y, v).then(function() {
            var t = Jd(Ey.mark(function t(r) {
                var a;
                return Ey.wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            return t.next = 2, r.json();
                        case 2:
                            if (a = t.sent, !r.ok) {
                                t.next = 5;
                                break;
                            }
                            return t.abrupt("return", a);
                        case 5:
                            if (!oT(a)) {
                                t.next = 8;
                                break;
                            }
                            return lT(a.message, c), t.abrupt("return");
                        case 8:
                            return lT(e.errorMessage || "Service at ".concat(y, " is not available"), c), t.abrupt("return");
                        case 11:
                        case "end":
                            return t.stop();
                    }
                }, t);
            }));
            return function(e) {
                return t.apply(this, arguments);
            };
        }()).catch(function(t) {
            var r;
            if (t instanceof mA) throw t;
            lT(e.errorMessage || wb(r = "Call to ".concat(y, " failed. Error= ")).call(r, t), c);
        });
    }
    function lT(e, t) {
        switch(t){
            case "silent":
                break;
            case "info":
            case "warn":
            case "error":
                console[t](e);
                break;
            default:
                throw new mA("NETWORK_ERROR", e);
        }
    }
    function cT(e, t) {
        return iT(nT(nT({}, e), {}, {
            method: "POST"
        }), t);
    }
    function sT(e, t, r) {
        var a;
        return function(e, t) {
            return iT(nT(nT({}, e), {}, {
                method: "GET"
            }), t);
        }({
            loadingContext: t,
            errorLevel: "warn",
            errorMessage: "Dataset ".concat(e, " is not available"),
            path: r ? wb(a = "datasets/".concat(e, "/")).call(a, r, ".json") : "datasets/".concat(e, ".json")
        });
    }
    var uT = Ar, dT = um.findIndex, pT = "findIndex", mT = !0;
    pT in [] && Array(1)[pT](function() {
        mT = !1;
    }), uT({
        target: "Array",
        proto: !0,
        forced: mT
    }, {
        findIndex: function(e) {
            return dT(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var fT = Cv("Array", "findIndex"), hT = ie, vT = fT, yT = Array.prototype, gT = t(function(e) {
        var t = e.findIndex;
        return e === yT || hT(yT, e) && t === yT.findIndex ? vT : t;
    }), bT = um.some;
    Ar({
        target: "Array",
        proto: !0,
        forced: !vv("some")
    }, {
        some: function(e) {
            return bT(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
    });
    var kT = Cv("Array", "some"), CT = ie, _T = kT, NT = Array.prototype, PT = t(function(e) {
        var t = e.some;
        return e === NT || CT(NT, e) && t === NT.some ? _T : t;
    }), wT = {
        "adyen-checkout__dropdown": "Select-module_adyen-checkout__dropdown__0Mj-n",
        "adyen-checkout__dropdown__button": "Select-module_adyen-checkout__dropdown__button__yTyqq",
        "adyen-checkout__dropdown__button--active": "Select-module_adyen-checkout__dropdown__button--active__Ej-JR",
        "adyen-checkout__filter-input": "Select-module_adyen-checkout__filter-input__CwPBS",
        "adyen-checkout__dropdown__list": "Select-module_adyen-checkout__dropdown__list__YtEzj",
        "adyen-checkout__dropdown__list--active": "Select-module_adyen-checkout__dropdown__list--active__Gegw2",
        "adyen-checkout__dropdown__element": "Select-module_adyen-checkout__dropdown__element__ORU4-"
    };
    function ST(e) {
        var t, r = e.backgroundUrl, a = void 0 === r ? "" : r, n = e.className, o = void 0 === n ? "" : n, i = e.classNameModifiers, l = void 0 === i ? [] : i, c = e.src, s = void 0 === c ? "" : c, u = e.alt, d = void 0 === u ? "" : u, p = e.showOnError, m = void 0 !== p && p, f = Vk(fP(!1), 2), h = f[0], v = f[1], y = gP(null), g = function() {
            v(!0);
        }, b = aP.apply(void 0, wb(t = [
            [
                o
            ],
            "adyen-checkout__image",
            {
                "adyen-checkout__image--loaded": h
            }
        ]).call(t, Uk(hC(l).call(l, function(e) {
            return "adyen-checkout__image--".concat(e);
        }))));
        return vP(function() {
            var e = a ? new Image : y.current;
            e.src = a || s, e.onload = g, v(!!e.complete);
        }, []), a ? rN("div", j_({
            style: {
                backgroundUrl: a
            }
        }, e, {
            className: b
        })) : rN("img", j_({}, e, {
            alt: d,
            ref: y,
            className: b,
            onError: function() {
                v(m);
            }
        }));
    }
    var AT = [
        "filterable",
        "toggleButtonRef"
    ];
    function IT(e) {
        var t = e.filterable, r = e.toggleButtonRef, a = kg(e, AT);
        return t ? rN("div", j_({}, a, {
            ref: r
        })) : rN("button", j_({
            id: a.id,
            "aria-describedby": a.ariaDescribedBy,
            type: "button"
        }, a, {
            ref: r
        }));
    }
    function DT(e) {
        var t = zP().i18n, r = e.active, a = e.selected, n = e.inputText, o = e.readonly, i = e.showList, l = a.selectedOptionName || a.name || e.placeholder || "", c = i ? n : l, s = o ? null : e.filterable ? function(t) {
            t.preventDefault(), document.activeElement === e.filterInputRef.current ? e.showList || e.toggleList(t) : e.filterInputRef.current && e.filterInputRef.current.focus();
        } : e.toggleList, u = o ? null : e.onFocus;
        return rN(IT, {
            className: aP(Sg(Sg(Sg(Sg(Sg(Sg(Sg({
                "adyen-checkout__dropdown__button": !0
            }, wT["adyen-checkout__dropdown__button"], !0), "adyen-checkout__dropdown__button--readonly", o), "adyen-checkout__dropdown__button--active", i), wT["adyen-checkout__dropdown__button--active"], i), "adyen-checkout__dropdown__button--invalid", e.isInvalid), "adyen-checkout__dropdown__button--valid", e.isValid), "adyen-checkout__dropdown__button--disabled", a.disabled)),
            disabled: e.disabled,
            filterable: e.filterable,
            onClick: s,
            onKeyDown: o ? null : e.onButtonKeyDown,
            toggleButtonRef: e.toggleButtonRef
        }, e.filterable ? rN(nN, null, !i && a.icon && rN(ST, {
            className: "adyen-checkout__dropdown__button__icon",
            src: a.icon,
            alt: a.name
        }), rN("input", {
            value: c,
            "aria-autocomplete": "list",
            "aria-controls": e.selectListId,
            "aria-expanded": i,
            "aria-owns": e.selectListId,
            autoComplete: "off",
            className: aP("adyen-checkout__filter-input", [
                wT["adyen-checkout__filter-input"]
            ]),
            onInput: e.onInput,
            onFocus: u,
            placeholder: t.get("select.filter.placeholder"),
            ref: e.filterInputRef,
            role: "combobox",
            "aria-activedescendant": "listItem-".concat(r.id),
            type: "text",
            readOnly: e.readonly,
            id: e.id,
            "aria-describedby": e.ariaDescribedBy
        }), !i && a.secondaryText && rN("span", {
            className: "adyen-checkout__dropdown__button__secondary-text"
        }, a.secondaryText)) : rN(nN, null, a.icon && rN(ST, {
            className: "adyen-checkout__dropdown__button__icon",
            src: a.icon,
            alt: a.name
        }), rN("span", {
            className: "adyen-checkout__dropdown__button__text"
        }, l), a.secondaryText && rN("span", {
            className: "adyen-checkout__dropdown__button__secondary-text"
        }, a.secondaryText)));
    }
    var ET = [
        "item",
        "active",
        "selected"
    ], RT = function(e) {
        var t = e.item, r = e.active, a = e.selected, n = kg(e, ET);
        return rN("li", {
            "aria-disabled": !!t.disabled,
            "aria-selected": a,
            className: aP([
                "adyen-checkout__dropdown__element",
                wT["adyen-checkout__dropdown__element"],
                {
                    "adyen-checkout__dropdown__element--active": r,
                    "adyen-checkout__dropdown__element--disabled": !!t.disabled
                }
            ]),
            "data-disabled": !0 === t.disabled || null,
            "data-value": t.id,
            onClick: n.onSelect,
            onMouseEnter: n.onHover,
            role: "option",
            id: "listItem-".concat(t.id)
        }, t.icon && rN(ST, {
            className: "adyen-checkout__dropdown__element__icon",
            alt: t.name,
            src: t.icon
        }), rN("span", {
            className: "adyen-checkout__dropdown__element__text"
        }, t.name), t.secondaryText && rN("span", {
            className: "adyen-checkout__dropdown__element__secondary-text"
        }, t.secondaryText), a && rN(aI, {
            type: "checkmark",
            height: 14,
            width: 14
        }));
    }, xT = [
        "selected",
        "active",
        "filteredItems",
        "showList"
    ];
    function FT(e) {
        var t = e.selected, r = e.active, a = e.filteredItems, n = e.showList, o = kg(e, xT), i = zP().i18n;
        return rN("ul", {
            className: aP(Sg(Sg(Sg({
                "adyen-checkout__dropdown__list": !0
            }, wT["adyen-checkout__dropdown__list"], !0), "adyen-checkout__dropdown__list--active", n), wT["adyen-checkout__dropdown__list--active"], n)),
            id: o.selectListId,
            ref: o.selectListRef,
            role: "listbox"
        }, a.length ? hC(a).call(a, function(e) {
            return rN(RT, {
                active: e.id === r.id,
                item: e,
                key: e.id,
                onSelect: o.onSelect,
                onHover: o.onHover,
                selected: e.id === t.id
            });
        }) : rN("div", {
            className: "adyen-checkout__dropdown__element adyen-checkout__dropdown__element--no-options"
        }, i.get("select.noOptionsFound")));
    }
    var TT = {
        arrowDown: "ArrowDown",
        arrowUp: "ArrowUp",
        enter: "Enter",
        escape: "Escape",
        space: " ",
        tab: "Tab"
    }, zT = function(e) {
        var t = e.parentNode, r = window.getComputedStyle(t, null), a = ZC(r.getPropertyValue("border-top-width")), n = e.offsetTop - t.offsetTop < t.scrollTop, o = e.offsetTop - t.offsetTop + e.clientHeight - a > t.scrollTop + t.clientHeight;
        (n || o) && (t.scrollTop = e.offsetTop - t.offsetTop - t.clientHeight / 2 - a + e.clientHeight / 2);
    };
    function OT(e) {
        var t, r, a = e.items, n = void 0 === a ? [] : a, o = e.className, i = void 0 === o ? "" : o, l = e.classNameModifiers, c = void 0 === l ? [] : l, s = e.filterable, u = void 0 === s || s, d = e.readonly, p = void 0 !== d && d, m = e.onChange, f = void 0 === m ? function() {} : m, h = e.onInput, v = e.selectedValue, y = e.name, g = e.isInvalid, b = e.isValid, k = e.placeholder, C = e.uniqueId, _ = e.disabled, N = e.disableTextFilter, P = e.clearOnSelect, w = e.blurOnClose, S = gP(null), A = gP(null), I = gP(null), D = gP(null), E = Vk(fP(null), 2), R = E[0], x = E[1], F = Vk(fP(!1), 2), T = F[0], z = F[1], O = bP(function() {
            return "select-".concat(DN());
        }, []), j = zb(n).call(n, function(e) {
            return e.id === v;
        }) || {}, B = Vk(fP(), 2), M = B[0], L = B[1], V = Vk(fP(j), 2), U = V[0], K = V[1], H = j, q = N ? n : Fg(n).call(n, function(e) {
            var t;
            return !R || kb(t = e.name.toLowerCase()).call(t, R.toLowerCase());
        }), W = function(e) {
            if (e) {
                var t = document.getElementById("listItem-".concat(e.id));
                zT(t);
            }
        }, G = function() {
            w && S.current.blur(), z(!1);
        }, Y = function() {
            z(!0);
        }, Q = function(e) {
            var t = e.currentTarget.getAttribute("data-value");
            return zb(q).call(q, function(e) {
                return e.id == t;
            });
        }, Z = function(e) {
            var t;
            e.preventDefault(), (t = e.currentTarget instanceof HTMLElement && "option" === e.currentTarget.getAttribute("role") ? Q(e) : U.id && PT(q).call(q, function(e) {
                return e.id === U.id;
            }) ? U : R ? q[0] : {
                id: v
            }) && !t.disabled && (f({
                target: {
                    value: t.id,
                    name: y
                }
            }), P && L(null), G());
        }, J = function(e) {
            switch(e.key){
                case TT.space:
                case TT.enter:
                    Z(e);
                    break;
                case TT.arrowDown:
                    e.preventDefault(), function() {
                        if (q && !(q.length < 1)) {
                            var e = gT(q).call(q, function(e) {
                                return e === U;
                            }) + 1, t = e < q.length ? e : 0, r = q[t];
                            W(r), K(r);
                        }
                    }();
                    break;
                case TT.arrowUp:
                    e.preventDefault(), function() {
                        if (q && !(q.length < 1)) {
                            var e = gT(q).call(q, function(e) {
                                return e === U;
                            }) - 1, t = e < 0 ? q.length - 1 : e, r = q[t];
                            W(r), K(r);
                        }
                    }();
            }
        };
        return vP(function() {
            T ? L(null) : x(null);
        }, [
            T
        ]), vP(function() {
            T && u && S.current && S.current.focus();
        }, [
            T
        ]), vP(function() {
            function e(e) {
                var t;
                (e.composedPath ? !kb(t = e.composedPath()).call(t, A.current) : !A.current.contains(e.target)) && G();
            }
            return document.addEventListener("click", e, !1), function() {
                document.removeEventListener("click", e, !1);
            };
        }, [
            A
        ]), rN("div", {
            className: aP(wb(t = [
                "adyen-checkout__dropdown",
                wT["adyen-checkout__dropdown"],
                i
            ]).call(t, Uk(hC(c).call(c, function(e) {
                return "adyen-checkout__dropdown--".concat(e);
            })))),
            ref: A
        }, rN(DT, {
            inputText: M,
            id: null != C ? C : null,
            active: U,
            selected: H,
            filterInputRef: S,
            filterable: u,
            isInvalid: g,
            isValid: b,
            onButtonKeyDown: function(e) {
                var t;
                e.key === TT.enter && u && T && R ? Z(e) : e.key === TT.escape ? G() : !kb(t = [
                    TT.arrowUp,
                    TT.arrowDown,
                    TT.enter
                ]).call(t, e.key) && (e.key !== TT.space || u && T) ? (e.shiftKey && e.key === TT.tab || e.key === TT.tab) && G() : (e.preventDefault(), T ? J(e) : Y());
            },
            onFocus: Y,
            onInput: function(e) {
                var t = e.target.value;
                L(t), x(t), h && h(t);
            },
            placeholder: k,
            readonly: p,
            selectListId: O,
            showList: T,
            toggleButtonRef: I,
            toggleList: function(e) {
                e.preventDefault(), T ? (L(H.name), G()) : (L(null), Y());
            },
            disabled: _,
            ariaDescribedBy: C ? wb(r = "".concat(C)).call(r, zI) : null
        }), rN(FT, {
            active: U,
            filteredItems: q,
            onHover: function(e) {
                e.preventDefault();
                var t = Q(e);
                K(t);
            },
            onSelect: Z,
            selected: H,
            selectListId: O,
            selectListRef: D,
            showList: T
        }));
    }
    function jT(e) {
        var t = e.classNameModifiers, r = e.label, a = e.onDropdownChange, n = e.readOnly, o = e.selectedCountry, i = e.specifications, l = e.value, c = zP(), s = c.i18n, u = c.loadingContext, d = Vk(fP([]), 2), p = d[0], m = d[1], f = Vk(fP(!1), 2), h = f[0], v = f[1], y = i.getPlaceholderKeyForField("stateOrProvince", o);
        return yP(function() {
            if (!o || !i.countryHasDataset(o)) return m([]), void v(!0);
            sT("states/".concat(o), u, s.locale).then(function(e) {
                var t = e && e.length ? e : [];
                m(t), v(!0);
            }).catch(function() {
                m([]), v(!0);
            });
        }, [
            o
        ]), h && p.length ? rN(oD, {
            label: r,
            classNameModifiers: t,
            errorMessage: e.errorMessage,
            isValid: !!l,
            showValidIcon: !1,
            name: "stateOrProvince",
            i18n: s
        }, rN(OT, {
            name: "stateOrProvince",
            onChange: a,
            selectedValue: l,
            placeholder: s.get(y),
            items: p,
            readonly: n && !!l
        })) : null;
    }
    function BT(e) {
        var t = e.allowedCountries, r = void 0 === t ? [] : t, a = e.classNameModifiers, n = void 0 === a ? [] : a, o = e.errorMessage, i = e.onDropdownChange, l = e.value, c = zP(), s = c.i18n, u = c.loadingContext, d = Vk(fP([]), 2), p = d[0], m = d[1], f = Vk(fP(!1), 2), h = f[0], v = f[1], y = Vk(fP(e.readOnly), 2), g = y[0], b = y[1];
        return yP(function() {
            sT("countries", u, s.locale).then(function(e) {
                var t = r.length ? Fg(e).call(e, function(e) {
                    return kb(r).call(r, e.id);
                }) : e;
                m(t || []), b(1 === t.length || g), v(!0);
            }).catch(function(e) {
                console.error(e), m([]), v(!0);
            });
        }, []), h ? rN(oD, {
            name: "country",
            label: s.get("country"),
            errorMessage: o,
            classNameModifiers: n,
            isValid: !!l,
            showValidIcon: !1,
            i18n: s
        }, rN(OT, {
            onChange: i,
            name: "country",
            placeholder: s.get("select.country"),
            selectedValue: l,
            items: p,
            readonly: g && !!l
        })) : null;
    }
    function MT(e) {
        var t, r = zP().i18n, a = e.classNameModifiers, n = void 0 === a ? [] : a, o = e.data, i = e.errors, l = e.valid, c = e.fieldName, s = e.onInput, u = e.onBlur, d = e.trimOnBlur, p = e.maxLength, m = e.disabled, f = o[c], h = o.country, v = e.specifications.countryHasOptionalField(h, c), y = e.specifications.getKeyForField(c, h), g = v ? " ".concat(r.get("field.title.optional")) : "", b = wb(t = "".concat(r.get(y))).call(t, g), k = function(e, t, r) {
            var a, n;
            if ("object" === ig(null === (a = e[t]) || void 0 === a ? void 0 : a.errorMessage)) {
                var o = e[t].errorMessage, i = o.translationKey, l = o.translationObject;
                return r.get(i, l);
            }
            return r.get(null === (n = e[t]) || void 0 === n ? void 0 : n.errorMessage) || !!e[t];
        }(i, c, r);
        switch(c){
            case "country":
                return rN(BT, {
                    allowedCountries: e.allowedCountries,
                    classNameModifiers: n,
                    label: b,
                    errorMessage: k,
                    onDropdownChange: e.onDropdownChange,
                    value: f
                });
            case "stateOrProvince":
                return rN(jT, {
                    classNameModifiers: n,
                    label: b,
                    errorMessage: k,
                    onDropdownChange: e.onDropdownChange,
                    selectedCountry: h,
                    specifications: e.specifications,
                    value: f
                });
            default:
                return rN(oD, {
                    label: b,
                    classNameModifiers: n,
                    errorMessage: k,
                    isValid: l[c],
                    name: c,
                    i18n: r
                }, rN(oE, {
                    name: c,
                    classNameModifiers: n,
                    value: f,
                    onInput: s,
                    onBlur: u,
                    maxlength: p,
                    trimOnBlur: d,
                    disabled: m,
                    required: !v
                }));
        }
    }
    OT.defaultProps = {
        className: "",
        classNameModifiers: [],
        filterable: !0,
        items: [],
        readonly: !1,
        onChange: function() {}
    };
    var LT = tp, VT = sa, UT = ap, KT = Qt, HT = function(e, t, r, a, n, o, i, l) {
        for(var c, s, u = n, d = 0, p = !!i && KT(i, l); d < a;)d in r && (c = p ? p(r[d], d, t) : r[d], o > 0 && LT(c) ? (s = VT(c), u = HT(e, t, c, s, u, o - 1) - 1) : (UT(u + 1), e[u] = c), u++), d++;
        return u;
    }, qT = HT, WT = Ye, GT = sa, YT = ea, QT = fp;
    Ar({
        target: "Array",
        proto: !0
    }, {
        flat: function() {
            var e = arguments.length ? arguments[0] : void 0, t = WT(this), r = GT(t), a = QT(t, 0);
            return a.length = qT(a, t, t, r, 0, void 0 === e ? 1 : YT(e)), a;
        }
    });
    var ZT = Cv("Array", "flat"), JT = ie, $T = ZT, XT = Array.prototype, ez = t(function(e) {
        var t = e.flat;
        return e === XT || JT(XT, e) && t === XT.flat ? $T : t;
    });
    function tz(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function rz(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = tz(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = tz(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var az = function() {
        function e(t) {
            Cg(this, e), Sg(this, "specifications", void 0), this.specifications = rz(rz({}, eR), t);
        }
        return wg(e, [
            {
                key: "countryHasDataset",
                value: function(e) {
                    var t;
                    return !(null === (t = this.specifications) || void 0 === t || null === (t = t[e]) || void 0 === t || !t.hasDataset);
                }
            },
            {
                key: "countryHasOptionalField",
                value: function(e, t) {
                    var r;
                    return !(null === (r = this.specifications) || void 0 === r || null === (r = r[e]) || void 0 === r || null === (r = r.optionalFields) || void 0 === r || !kb(r).call(r, t));
                }
            },
            {
                key: "getAddressSchemaForCountry",
                value: function(e) {
                    var t;
                    return (null === (t = this.specifications) || void 0 === t || null === (t = t[e]) || void 0 === t ? void 0 : t.schema) || this.specifications.default.schema;
                }
            },
            {
                key: "getAddressLabelsForCountry",
                value: function(e) {
                    var t;
                    return (null === (t = this.specifications) || void 0 === t || null === (t = t[e]) || void 0 === t ? void 0 : t.labels) || this.specifications.default.labels;
                }
            },
            {
                key: "getOptionalFieldsForCountry",
                value: function(e) {
                    var t, r;
                    return (null === (t = this.specifications) || void 0 === t || null === (t = t[e]) || void 0 === t ? void 0 : t.optionalFields) || (null === (r = this.specifications.default) || void 0 === r ? void 0 : r.optionalFields) || [];
                }
            },
            {
                key: "getKeyForField",
                value: function(e, t) {
                    var r, a;
                    return (null === (r = this.specifications) || void 0 === r || null === (r = r[t]) || void 0 === r || null === (r = r.labels) || void 0 === r ? void 0 : r[e]) || (null === (a = this.specifications) || void 0 === a || null === (a = a.default) || void 0 === a || null === (a = a.labels) || void 0 === a ? void 0 : a[e]) || e;
                }
            },
            {
                key: "getPlaceholderKeyForField",
                value: function(e, t) {
                    var r, a;
                    return (null === (r = this.specifications) || void 0 === r || null === (r = r[t]) || void 0 === r || null === (r = r.placeholders) || void 0 === r ? void 0 : r[e]) || (null === (a = this.specifications) || void 0 === a || null === (a = a.default) || void 0 === a || null === (a = a.placeholders) || void 0 === a ? void 0 : a[e]);
                }
            },
            {
                key: "getAddressSchemaForCountryFlat",
                value: function(e) {
                    var t, r;
                    return Fg(t = ez(r = this.getAddressSchemaForCountry(e)).call(r, 2)).call(t, function(e) {
                        return "string" == typeof e;
                    });
                }
            }
        ]), e;
    }(), nz = function(e) {
        var t, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 300;
        return function() {
            for(var a = this, n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            clearTimeout(t), t = ZN(function() {
                return e.apply(a, o);
            }, r);
        };
    };
    function oz(e) {
        var t = e.onAddressLookup, r = e.onAddressSelected, a = e.onSelect, n = e.onManualAddress, o = e.externalErrorMessage, i = e.hideManualButton, l = e.addressSearchDebounceMs, c = Vk(fP([]), 2), s = c[0], u = c[1], d = Vk(fP([]), 2), p = d[0], m = d[1], f = Vk(fP(""), 2), h = f[0], v = f[1], y = zP().i18n, g = function(e) {
            return hC(e).call(e, function(e) {
                return {
                    id: e.id,
                    name: e.name
                };
            });
        }, b = kP(function(e) {
            null != e && e.errorMessage && v(e.errorMessage);
        }, []), k = kP(function() {
            var e = Jd(Ey.mark(function e(r) {
                return Ey.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            new Sb(function(e, a) {
                                t(r, {
                                    resolve: e,
                                    reject: a
                                });
                            }).then(function(e) {
                                m(e), u(g(e)), v("");
                            }).catch(function(e) {
                                return b(e);
                            });
                        case 1:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function(t) {
                return e.apply(this, arguments);
            };
        }(), [
            t
        ]);
        vP(function() {
            v(o);
        }, [
            o
        ]);
        var C = function() {
            var e = Jd(Ey.mark(function e(t) {
                var n;
                return Ey.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            if (t.target.value) {
                                e.next = 3;
                                break;
                            }
                            return v(y.get("address.errors.incomplete")), e.abrupt("return");
                        case 3:
                            if (n = zb(p).call(p, function(e) {
                                return e.id === t.target.value;
                            }), "function" == typeof r) {
                                e.next = 8;
                                break;
                            }
                            return a(n), u([]), e.abrupt("return");
                        case 8:
                            new Sb(function(e, t) {
                                r(n, {
                                    resolve: e,
                                    reject: t
                                });
                            }).then(function(e) {
                                a(e), u([]);
                            }).catch(function(e) {
                                return b(e);
                            });
                        case 9:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function(t) {
                return e.apply(this, arguments);
            };
        }(), _ = bP(function() {
            return nz(k, l);
        }, []);
        return rN("div", {
            className: "adyen-checkout__address-search adyen-checkout__field-group"
        }, rN(oD, {
            label: y.get("address"),
            classNameModifiers: [
                "address-search"
            ],
            errorMessage: h,
            name: "address-search"
        }, rN(OT, {
            name: "address-search",
            className: "adyen-checkout__address-search__dropdown",
            onInput: _,
            items: s,
            onChange: C,
            disableTextFilter: !0,
            blurOnClose: !0
        })), !i && rN("span", {
            className: "adyen-checkout__address-search__manual-add"
        }, rN("button", {
            type: "button",
            className: "adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link adyen-checkout__address-search__manual-add__button",
            onClick: n
        }, "+ " + y.get("address.enterManually"))));
    }
    function iz(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function lz(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = iz(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = iz(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function cz(e) {
        var t, r, a = zP().i18n, n = e.label, o = void 0 === n ? "" : n, i = e.requiredFields, l = e.visibility, c = e.iOSFocusedField, s = void 0 === c ? null : c, u = gP({});
        Ty(u.current).length || null === (r = e.setComponentRef) || void 0 === r || r.call(e, u.current);
        var d = bP(function() {
            return new az(e.specifications);
        }, [
            e.specifications
        ]), p = Fg(t = d.getAddressSchemaForCountryFlat(e.countryCode)).call(t, function(e) {
            return kb(i).call(i, e);
        }), m = Vk(fP(!1), 2), f = m[0], h = m[1], v = Vk(fP(!1), 2), y = v[0], g = v[1], b = Vk(fP(""), 2), k = b[0], C = b[1], _ = !!e.onAddressLookup, N = !e.onAddressLookup || f || y, P = QD({
            schema: p,
            defaultData: e.data,
            rules: lz(lz({}, NR(d)), e.validationRules),
            formatters: yR
        }), w = P.data, S = P.errors, A = P.valid, I = P.isValid, D = P.handleChangeFor, E = P.triggerValidation, R = P.setData, x = kP(function(e) {
            var t = qE;
            Ag(t).call(t, function(t) {
                var r = e[t];
                null != r && R(t, String(r));
            }), E(), h(!0);
        }, [
            h,
            E,
            R
        ]), F = kP(function() {
            g(!0);
        }, []);
        u.current.showValidation = function() {
            E(), C(!_ || N || I ? "" : a.get("address.errors.incomplete"));
        };
        var T = Fg(p).call(p, function(e) {
            return !s || e === s;
        });
        if (vP(function() {
            var e = d.countryHasDataset(w.country) ? "" : HE, t = lz(lz({}, w), {}, {
                stateOrProvince: e
            });
            Ag(i).call(i, function(e) {
                var r;
                D(e, "input")(null !== (r = t[e]) && void 0 !== r ? r : "");
            }), t.postalCode && D("postalCode", "blur")(w.postalCode);
        }, [
            w.country
        ]), vP(function() {
            var e = kb(i).call(i, "stateOrProvince"), t = w.country && d.countryHasDataset(w.country), r = e && t, a = w.stateOrProvince || (r ? "" : HE);
            D("stateOrProvince", "input")(a);
        }, []), vP(function() {
            var t = d.getOptionalFieldsForCountry(w.country), r = tC(qE).call(qE, function(r, a) {
                var n = kb(t).call(t, a), o = kb(i).call(i, a), l = w[a], c = e.data[a], s = n && !l || !o ? o || l || !c ? HE : c : l;
                return null != s && s.length && (r[a] = s), r;
            }, {});
            e.onChange({
                data: r,
                valid: A,
                errors: S,
                isValid: I
            });
        }, [
            w,
            A,
            S,
            I
        ]), "hidden" === l) return null;
        if ("readOnly" === l) return rN(nR, {
            data: w,
            label: o
        });
        var z = function(t, r) {
            var a, n = r.classNameModifiers, o = void 0 === n ? [] : n;
            return kb(i).call(i, t) ? rN(MT, {
                key: t,
                allowedCountries: e.allowedCountries,
                classNameModifiers: wb(a = []).call(a, Uk(o), [
                    t
                ]),
                data: w,
                errors: S,
                valid: A,
                fieldName: t,
                onInput: D(t, "input"),
                onBlur: D(t, "blur"),
                onDropdownChange: D(t, "blur"),
                specifications: d,
                maxLength: gD(gR, t, w.country, !0),
                trimOnBlur: !0,
                disabled: !kb(T).call(T, t)
            }) : null;
        }, O = d.getAddressSchemaForCountry(w.country);
        return rN(nN, null, rN(eI, {
            classNameModifiers: [
                o || "address"
            ],
            label: o
        }, _ && rN(oz, {
            onAddressLookup: e.onAddressLookup,
            onAddressSelected: e.onAddressSelected,
            onSelect: x,
            onManualAddress: F,
            externalErrorMessage: k,
            hideManualButton: N,
            addressSearchDebounceMs: e.addressSearchDebounceMs
        }), N && rN(nN, null, hC(O).call(O, function(e) {
            var t;
            return e instanceof Array ? rN("div", {
                className: "adyen-checkout__field-group"
            }, hC(t = e).call(t, function(e) {
                var t = Vk(e, 2), r = t[0], a = t[1];
                return z(r, {
                    classNameModifiers: [
                        "col-".concat(a)
                    ]
                });
            })) : z(e, {});
        }))), !1);
    }
    cz.defaultProps = {
        countryCode: null,
        validationRules: null,
        data: {},
        onChange: function() {},
        visibility: "editable",
        requiredFields: qE,
        specifications: {}
    };
    var sz = [
        "classNameModifiers",
        "label",
        "isInvalid",
        "onChange"
    ], uz = [
        "uniqueId",
        "addContextualElement"
    ];
    function dz(e) {
        var t, r = e.classNameModifiers, a = void 0 === r ? [] : r, n = e.label, o = e.isInvalid, i = e.onChange, l = kg(e, sz), c = l.uniqueId, s = l.addContextualElement;
        return rN("label", {
            className: "adyen-checkout__checkbox",
            htmlFor: c
        }, rN("input", j_({
            id: c
        }, kg(l, uz), s && {
            "aria-describedby": wb(t = "".concat(c)).call(t, zI)
        }, {
            className: aP([
                "adyen-checkout__checkbox__input",
                [
                    l.className
                ],
                {
                    "adyen-checkout__checkbox__input--invalid": o
                },
                hC(a).call(a, function(e) {
                    return "adyen-checkout__input--".concat(e);
                })
            ]),
            type: "checkbox",
            onChange: i
        })), rN("span", {
            className: "adyen-checkout__checkbox__label"
        }, n));
    }
    dz.defaultProps = {
        onChange: function() {}
    };
    var pz = [
        "errorMessage",
        "label",
        "onChange",
        "i18n"
    ];
    function mz(e) {
        var t, r, a, n = e.errorMessage, o = e.label, i = e.onChange, l = e.i18n, c = kg(e, pz);
        return rN(oD, {
            classNameModifiers: [
                "consentCheckbox"
            ],
            errorMessage: n,
            i18n: l,
            name: "consentCheckbox",
            useLabelElement: !1,
            label: l.get("creditCard.holderName")
        }, rN(dz, {
            name: "consentCheckbox",
            classNameModifiers: wb(t = []).call(t, Uk(null !== (r = c.classNameModifiers) && void 0 !== r ? r : c.classNameModifiers = []), [
                "consentCheckbox"
            ]),
            onInput: i,
            value: null == c || null === (a = c.data) || void 0 === a ? void 0 : a.consentCheckbox,
            label: o,
            checked: c.checked
        }));
    }
    var fz = [
        "companyDetails",
        "personalDetails",
        "billingAddress",
        "deliveryAddress",
        "bankAccount"
    ], hz = function(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return tC(fz).call(fz, function(r, a) {
            var n = "hidden" !== e[a], o = "deliveryAddress" === a, i = "hidden" === (null == e ? void 0 : e.billingAddress);
            return r[a] = n && (!o || i || function() {
                return Ty(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).length > 1;
            }(t[a])), r;
        }, {});
    }, vz = function(e, t, r) {
        var a, n, o = e, i = o.split(":"), l = i.length > 1;
        l && (n = i[0], o = i[1]);
        var c = function(e, t, r) {
            return kb(qE).call(qE, e) ? null != r && r[e] ? t.get(null == r ? void 0 : r[e]) : t.get(e) : null;
        }(o, t, r);
        if (c) return l ? wb(a = "".concat(t.get(n), " ")).call(a, c) : c;
        switch(o){
            case "gender":
            case "dateOfBirth":
                return function(e, t) {
                    switch(e){
                        case "gender":
                        case "dateOfBirth":
                            return t.get(e);
                        default:
                            return null;
                    }
                }(o, t);
        }
        return null;
    }, yz = {
        AD: {
            length: 24,
            structure: "F04F04A12",
            example: "AD9912345678901234567890"
        },
        AE: {
            length: 23,
            structure: "F03F16",
            example: "AE993331234567890123456"
        },
        AL: {
            length: 28,
            structure: "F08A16",
            example: "AL47212110090000000235698741"
        },
        AT: {
            length: 20,
            structure: "F05F11",
            example: "AT611904300234573201"
        },
        AZ: {
            length: 28,
            structure: "U04A20",
            example: "AZ21NABZ00000000137010001944"
        },
        BA: {
            length: 20,
            structure: "F03F03F08F02",
            example: "BA391290079401028494"
        },
        BE: {
            length: 16,
            structure: "F03F07F02",
            example: "BE68 5390 0754 7034"
        },
        BG: {
            length: 22,
            structure: "U04F04F02A08",
            example: "BG80BNBG96611020345678"
        },
        BH: {
            length: 22,
            structure: "U04A14",
            example: "BH67BMAG00001299123456"
        },
        BR: {
            length: 29,
            structure: "F08F05F10U01A01",
            example: "BR9700360305000010009795493P1"
        },
        CH: {
            length: 21,
            structure: "F05A12",
            example: "CH9300762011623852957"
        },
        CR: {
            length: 22,
            structure: "F04F14",
            example: "CR72012300000171549015"
        },
        CY: {
            length: 28,
            structure: "F03F05A16",
            example: "CY17002001280000001200527600"
        },
        CZ: {
            length: 24,
            structure: "F04F06F10",
            example: "CZ6508000000192000145399"
        },
        DE: {
            length: 22,
            structure: "F08F10",
            example: "DE00123456789012345678"
        },
        DK: {
            length: 18,
            structure: "F04F09F01",
            example: "DK5000400440116243"
        },
        DO: {
            length: 28,
            structure: "U04F20",
            example: "DO28BAGR00000001212453611324"
        },
        EE: {
            length: 20,
            structure: "F02F02F11F01",
            example: "EE382200221020145685"
        },
        ES: {
            length: 24,
            structure: "F04F04F01F01F10",
            example: "ES9121000418450200051332"
        },
        FI: {
            length: 18,
            structure: "F06F07F01",
            example: "FI2112345600000785"
        },
        FO: {
            length: 18,
            structure: "F04F09F01",
            example: "FO6264600001631634"
        },
        FR: {
            length: 27,
            structure: "F05F05A11F02",
            example: "FR1420041010050500013M02606"
        },
        GB: {
            length: 22,
            structure: "U04F06F08",
            example: "GB29NWBK60161331926819"
        },
        GE: {
            length: 22,
            structure: "U02F16",
            example: "GE29NB0000000101904917"
        },
        GI: {
            length: 23,
            structure: "U04A15",
            example: "GI75NWBK000000007099453"
        },
        GL: {
            length: 18,
            structure: "F04F09F01",
            example: "GL8964710001000206"
        },
        GR: {
            length: 27,
            structure: "F03F04A16",
            example: "GR1601101250000000012300695"
        },
        GT: {
            length: 28,
            structure: "A04A20",
            example: "GT82TRAJ01020000001210029690"
        },
        HR: {
            length: 21,
            structure: "F07F10",
            example: "HR1210010051863000160"
        },
        HU: {
            length: 28,
            structure: "F03F04F01F15F01",
            example: "HU42117730161111101800000000"
        },
        IE: {
            length: 22,
            structure: "U04F06F08",
            example: "IE29AIBK93115212345678"
        },
        IL: {
            length: 23,
            structure: "F03F03F13",
            example: "IL620108000000099999999"
        },
        IS: {
            length: 26,
            structure: "F04F02F06F10",
            example: "IS140159260076545510730339"
        },
        IT: {
            length: 27,
            structure: "U01F05F05A12",
            example: "IT60X0542811101000000123456"
        },
        KW: {
            length: 30,
            structure: "U04A22",
            example: "KW81CBKU0000000000001234560101"
        },
        KZ: {
            length: 20,
            structure: "F03A13",
            example: "KZ86125KZT5004100100"
        },
        LB: {
            length: 28,
            structure: "F04A20",
            example: "LB62099900000001001901229114"
        },
        LC: {
            length: 32,
            structure: "U04F24",
            example: "LC07HEMM000100010012001200013015"
        },
        LI: {
            length: 21,
            structure: "F05A12",
            example: "LI21088100002324013AA"
        },
        LT: {
            length: 20,
            structure: "F05F11",
            example: "LT121000011101001000"
        },
        LU: {
            length: 20,
            structure: "F03A13",
            example: "LU280019400644750000"
        },
        LV: {
            length: 21,
            structure: "U04A13",
            example: "LV80BANK0000435195001"
        },
        MC: {
            length: 27,
            structure: "F05F05A11F02",
            example: "MC5811222000010123456789030"
        },
        MD: {
            length: 24,
            structure: "U02A18",
            example: "MD24AG000225100013104168"
        },
        ME: {
            length: 22,
            structure: "F03F13F02",
            example: "ME25505000012345678951"
        },
        MK: {
            length: 19,
            structure: "F03A10F02",
            example: "MK07250120000058984"
        },
        MR: {
            length: 27,
            structure: "F05F05F11F02",
            example: "MR1300020001010000123456753"
        },
        MT: {
            length: 31,
            structure: "U04F05A18",
            example: "MT84MALT011000012345MTLCAST001S"
        },
        MU: {
            length: 30,
            structure: "U04F02F02F12F03U03",
            example: "MU17BOMM0101101030300200000MUR"
        },
        NL: {
            length: 18,
            structure: "U04F10",
            example: "NL99BANK0123456789"
        },
        NO: {
            length: 15,
            structure: "F04F06F01",
            example: "NO9386011117947"
        },
        PK: {
            length: 24,
            structure: "U04A16",
            example: "PK36SCBL0000001123456702"
        },
        PL: {
            length: 28,
            structure: "F08F16",
            example: "PL00123456780912345678901234"
        },
        PS: {
            length: 29,
            structure: "U04A21",
            example: "PS92PALS000000000400123456702"
        },
        PT: {
            length: 25,
            structure: "F04F04F11F02",
            example: "PT50000201231234567890154"
        },
        RO: {
            length: 24,
            structure: "U04A16",
            example: "RO49AAAA1B31007593840000"
        },
        RS: {
            length: 22,
            structure: "F03F13F02",
            example: "RS35260005601001611379"
        },
        SA: {
            length: 24,
            structure: "F02A18",
            example: "SA0380000000608010167519"
        },
        SE: {
            length: 24,
            structure: "F03F16F01",
            example: "SE4550000000058398257466"
        },
        SI: {
            length: 19,
            structure: "F05F08F02",
            example: "SI56263300012039086"
        },
        SK: {
            length: 24,
            structure: "F04F06F10",
            example: "SK3112000000198742637541"
        },
        SM: {
            length: 27,
            structure: "U01F05F05A12",
            example: "SM86U0322509800000000270100"
        },
        ST: {
            length: 25,
            structure: "F08F11F02",
            example: "ST68000100010051845310112"
        },
        TL: {
            length: 23,
            structure: "F03F14F02",
            example: "TL380080012345678910157"
        },
        TN: {
            length: 24,
            structure: "F02F03F13F02",
            example: "TN5910006035183598478831"
        },
        TR: {
            length: 26,
            structure: "F05F01A16",
            example: "TR330006100519786457841326"
        },
        VG: {
            length: 24,
            structure: "U04F16",
            example: "VG96VPVG0000012345678901"
        },
        XK: {
            length: 20,
            structure: "F04F10F02",
            example: "XK051212012345678906"
        },
        AO: {
            length: 25,
            structure: "F21",
            example: "AO69123456789012345678901"
        },
        BF: {
            length: 27,
            structure: "F23",
            example: "BF2312345678901234567890123"
        },
        BI: {
            length: 16,
            structure: "F12",
            example: "BI41123456789012"
        },
        BJ: {
            length: 28,
            structure: "F24",
            example: "BJ39123456789012345678901234"
        },
        CI: {
            length: 28,
            structure: "U01F23",
            example: "CI17A12345678901234567890123"
        },
        CM: {
            length: 27,
            structure: "F23",
            example: "CM9012345678901234567890123"
        },
        CV: {
            length: 25,
            structure: "F21",
            example: "CV30123456789012345678901"
        },
        DZ: {
            length: 24,
            structure: "F20",
            example: "DZ8612345678901234567890"
        },
        IR: {
            length: 26,
            structure: "F22",
            example: "IR861234568790123456789012"
        },
        JO: {
            length: 30,
            structure: "A04F22",
            example: "JO15AAAA1234567890123456789012"
        },
        MG: {
            length: 27,
            structure: "F23",
            example: "MG1812345678901234567890123"
        },
        ML: {
            length: 28,
            structure: "U01F23",
            example: "ML15A12345678901234567890123"
        },
        MZ: {
            length: 25,
            structure: "F21",
            example: "MZ25123456789012345678901"
        },
        QA: {
            length: 29,
            structure: "U04A21",
            example: "QA30AAAA123456789012345678901"
        },
        SN: {
            length: 28,
            structure: "U01F23",
            example: "SN52A12345678901234567890123"
        },
        UA: {
            length: 29,
            structure: "F25",
            example: "UA511234567890123456789012345"
        }
    }, gz = function(e) {
        var t;
        return tE(t = e.replace(/\W/gi, "").replace(/(.{4})(?!$)/g, "$1 ")).call(t);
    }, bz = function(e) {
        return e.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
    }, kz = function(e, t) {
        return function(e, t) {
            var r;
            if (null === t || !yz[t] || !yz[t].structure) return !1;
            var a = yz[t].structure, n = hC(r = a.match(/(.{3})/g)).call(r, function(e) {
                var t, r, a = xA(e).call(e, 0, 1), n = ZC(xA(e).call(e, 1), 10);
                switch(a){
                    case "A":
                        r = "0-9A-Za-z";
                        break;
                    case "B":
                        r = "0-9A-Z";
                        break;
                    case "C":
                        r = "A-Za-z";
                        break;
                    case "F":
                        r = "0-9";
                        break;
                    case "L":
                        r = "a-z";
                        break;
                    case "U":
                        r = "A-Z";
                        break;
                    case "W":
                        r = "0-9a-z";
                }
                return wb(t = "([".concat(r, "]{")).call(t, n, "})");
            });
            return new RegExp("^".concat(n.join(""), "$"));
        }(0, t);
    }, Cz = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
        return e && yz[e] && yz[e].example ? gz(yz[e].example) : "AB00 1234 5678 9012 3456 7890";
    }, _z = function(e) {
        return xA(e).call(e, 0, 2);
    };
    function Nz(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
        this.status = e, this.code = t;
    }
    var Pz = function(e) {
        var t = bz(e), r = function(e) {
            var t, r = e, a = "A".charCodeAt(0), n = "Z".charCodeAt(0);
            return r = (r = r.toUpperCase()).substr(4) + r.substr(0, 4), hC(t = r.split("")).call(t, function(e) {
                var t = e.charCodeAt(0);
                return t >= a && t <= n ? t - a + 10 : e;
            }).join("");
        }(t), a = 1 === function(e) {
            for(var t, r = e; r.length > 2;)t = xA(r).call(r, 0, 9), r = ZC(t, 10) % 97 + xA(r).call(r, t.length);
            return ZC(r, 10) % 97;
        }(r);
        return a && function(e) {
            var t = xA(e).call(e, 0, 2), r = kz(0, t);
            return r.test && r.test(xA(e).call(e, 4)) || !1;
        }(t);
    }, wz = function(e) {
        var t = bz(e);
        if (e.length < 2) return new Nz("no-validate", "TOO_SHORT");
        var r = function(e) {
            return !(!e || !yz[e]) && yz[e];
        }(_z(t));
        return r ? t.length > r.length ? new Nz("invalid", "TOO_LONG") : t.length === r.length ? Pz(e) ? new Nz("valid", "VALID") : new Nz("invalid", "INVALID_IBAN") : new Nz("no-validate", "UNKNOWN") : new Nz("invalid", "INVALID_COUNTRY");
    }, Sz = function(e) {
        return !bD(e) || null;
    };
    function Az(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Iz(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = Az(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = Az(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function Dz(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var Ez = {
        isValid: !1,
        errorMessage: "ach.accountHolderNameField.invalid",
        error: "ach.accountHolderNameField.invalid"
    }, Rz = {
        isValid: !1,
        errorMessage: "sepaDirectDebit.ibanField.invalid",
        error: "sepaDirectDebit.ibanField.invalid"
    }, xz = function(e) {
        L_(r, e);
        var t = Dz(r);
        function r(e) {
            var a, n, o, i;
            if (Cg(this, r), Sg(B_(i = t.call(this, e)), "ibanNumber", void 0), Sg(B_(i), "setData", function(e, t, r) {
                i.setState(function(r) {
                    return {
                        data: Iz(Iz({}, r.data), {}, Sg({}, e, t))
                    };
                }, r);
            }), Sg(B_(i), "setError", function(e, t, r) {
                i.setState(function(r) {
                    return {
                        errors: Iz(Iz({}, r.errors), {}, Sg({}, e, t))
                    };
                }, r);
            }), Sg(B_(i), "setValid", function(e, t, r) {
                i.setState(function(r) {
                    return {
                        valid: Iz(Iz({}, r.valid), {}, Sg({}, e, t))
                    };
                }, r);
            }), Sg(B_(i), "handleHolderInput", function(e) {
                i.setState(function(t) {
                    return {
                        data: Iz(Iz({}, t.data), {}, {
                            ownerName: e
                        })
                    };
                }, function() {
                    var e = Sz(i.state.data.ownerName), t = null == e || e ? null : Ez;
                    i.setError("holder", t, i.onChange);
                });
            }), Sg(B_(i), "handleIbanInput", function(e) {
                var t = e.target.value, r = bz(t), a = gz(r), n = wz(a).status, o = _z(r), l = e.target.selectionStart, c = i.state.data.ibanNumber, s = function(e, t, r) {
                    if (0 === e || !t.length) return 0;
                    var a = t.length - r.length, n = a > 0, o = function(e, t) {
                        return /\s/.test(e.charAt(t));
                    }, i = e - a;
                    return n && (o(t, i + 1) || o(t, i)) ? e + 1 : !n && o(t, e - 1) ? e - 1 : e;
                }(l, a, c);
                i.setState(function(e) {
                    return {
                        data: Iz(Iz({}, e.data), {}, {
                            ibanNumber: a,
                            countryCode: o
                        }),
                        errors: Iz(Iz({}, e.errors), {}, {
                            iban: "invalid" === n ? Rz : null
                        }),
                        valid: Iz(Iz({}, e.valid), {}, {
                            iban: "valid" === n
                        })
                    };
                }, function() {
                    e.target.setSelectionRange(s, s), i.onChange();
                });
            }), Sg(B_(i), "handleIbanBlur", function(e) {
                var t = e.target.value;
                if (t.length > 0) {
                    var r = wz(t).status;
                    i.setError("iban", "valid" !== r ? Rz : null, i.onChange);
                } else i.setError("iban", null, i.onChange);
            }), i.state = {
                status: "ready",
                data: {
                    ownerName: (null == e || null === (a = e.data) || void 0 === a ? void 0 : a.ownerName) || "",
                    ibanNumber: (null == e || null === (n = e.data) || void 0 === n ? void 0 : n.ibanNumber) || "",
                    countryCode: (null == e || null === (o = e.data) || void 0 === o ? void 0 : o.countryCode) || ""
                },
                isValid: !1,
                cursor: 0,
                errors: {},
                valid: {}
            }, i.state.data.ibanNumber) {
                var l = bz(i.state.data.ibanNumber);
                i.state.data.ibanNumber = gz(l);
            }
            if (i.state.data.ibanNumber || i.state.data.ownerName) {
                var c = i.props.holderName ? Sz(i.state.data.ownerName) : "", s = (i.state.data.ibanNumber ? "valid" === wz(i.state.data.ibanNumber).status : "") && c, u = {
                    data: i.state.data,
                    isValid: s
                };
                i.props.onChange(u);
            }
            return i;
        }
        return wg(r, [
            {
                key: "setStatus",
                value: function(e) {
                    this.setState({
                        status: e
                    });
                }
            },
            {
                key: "onChange",
                value: function() {
                    var e = !this.props.holderName || Sz(this.state.data.ownerName), t = "valid" === wz(this.state.data.ibanNumber).status && e, r = {
                        data: this.state.data,
                        isValid: t,
                        errors: this.state.errors
                    };
                    this.props.onChange(r);
                }
            },
            {
                key: "showValidation",
                value: function() {
                    var e = wz(this.state.data.ibanNumber).status, t = Sz(this.state.data.ownerName);
                    this.setError("iban", "valid" !== e ? Rz : null);
                    var r = t ? null : Ez;
                    this.setError("holder", r, this.onChange);
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r = this, a = e.placeholders, n = e.countryCode, o = t.data, i = t.errors, l = t.valid, c = zP().i18n;
                    return rN(eI, {
                        classNameModifiers: [
                            "iban-input"
                        ],
                        label: this.props.label
                    }, this.props.holderName && rN(oD, {
                        className: "adyen-checkout__field--owner-name",
                        label: c.get("sepa.ownerName"),
                        filled: o.ownerName && o.ownerName.length,
                        errorMessage: !!i.holder && c.get(i.holder.error),
                        dir: "ltr",
                        i18n: c,
                        name: "ownerName"
                    }, rN(oE, {
                        name: "ownerName",
                        className: "adyen-checkout__iban-input__owner-name",
                        placeholder: "ownerName" in a ? a.ownerName : c.get("sepaDirectDebit.nameField.placeholder"),
                        value: o.ownerName,
                        "aria-invalid": !!this.state.errors.holder,
                        "aria-label": c.get("sepa.ownerName"),
                        onInput: function(e) {
                            return r.handleHolderInput(e.target.value);
                        },
                        onBlur: function(e) {
                            return r.handleHolderInput(e.target.value);
                        }
                    })), rN(oD, {
                        className: "adyen-checkout__field--iban-number",
                        label: c.get("sepa.ibanNumber"),
                        errorMessage: !!i.iban && c.get(i.iban.error),
                        filled: o.ibanNumber && o.ibanNumber.length,
                        isValid: l.iban,
                        onBlur: this.handleIbanBlur,
                        dir: "ltr",
                        i18n: c,
                        name: "ibanNumber"
                    }, rN(oE, {
                        setRef: function(e) {
                            r.ibanNumber = e;
                        },
                        name: "ibanNumber",
                        className: "adyen-checkout__iban-input__iban-number",
                        classNameModifiers: [
                            "large"
                        ],
                        placeholder: "ibanNumber" in a ? a.ibanNumber : Cz(n),
                        value: o.ibanNumber,
                        onInput: this.handleIbanInput,
                        "aria-invalid": !!this.state.errors.iban,
                        "aria-label": c.get("sepa.ibanNumber"),
                        autocorrect: "off",
                        spellcheck: !1
                    })), this.props.showPayButton && this.props.payButton({
                        status: this.state.status
                    }));
                }
            }
        ]), r;
    }(oN);
    Sg(xz, "defaultProps", {
        onChange: function() {},
        countryCode: null,
        holderName: !0,
        placeholders: {},
        label: null
    });
    var Fz = VD.entries;
    Ar({
        target: "Object",
        stat: !0
    }, {
        entries: function(e) {
            return Fz(e);
        }
    });
    var Tz = t(ee.Object.entries), zz = Se, Oz = TypeError, jz = le.match(/firefox\/(\d+)/i), Bz = !!jz && +jz[1], Mz = /MSIE|Trident/.test(le), Lz = le.match(/AppleWebKit\/(\d+)\./), Vz = !!Lz && +Lz[1], Uz = Ar, Kz = h, Hz = Ee, qz = Ye, Wz = sa, Gz = function(e, t) {
        if (!delete e[t]) throw new Oz("Cannot delete property " + zz(t) + " of " + zz(e));
    }, Yz = vo, Qz = n, Zz = QR, Jz = vv, $z = Bz, Xz = Mz, eO = fe, tO = Vz, rO = [], aO = Kz(rO.sort), nO = Kz(rO.push), oO = Qz(function() {
        rO.sort(void 0);
    }), iO = Qz(function() {
        rO.sort(null);
    }), lO = Jz("sort"), cO = !Qz(function() {
        if (eO) return eO < 70;
        if (!($z && $z > 3)) {
            if (Xz) return !0;
            if (tO) return tO < 603;
            var e, t, r, a, n = "";
            for(e = 65; e < 76; e++){
                switch(t = String.fromCharCode(e), e){
                    case 66:
                    case 69:
                    case 70:
                    case 72:
                        r = 3;
                        break;
                    case 68:
                    case 71:
                        r = 4;
                        break;
                    default:
                        r = 2;
                }
                for(a = 0; a < 47; a++)rO.push({
                    k: t + a,
                    v: r
                });
            }
            for(rO.sort(function(e, t) {
                return t.v - e.v;
            }), a = 0; a < rO.length; a++)t = rO[a].k.charAt(0), n.charAt(n.length - 1) !== t && (n += t);
            return "DGBEFHACIJK" !== n;
        }
    });
    Uz({
        target: "Array",
        proto: !0,
        forced: oO || !iO || !lO || !cO
    }, {
        sort: function(e) {
            void 0 !== e && Hz(e);
            var t = qz(this);
            if (cO) return void 0 === e ? aO(t) : aO(t, e);
            var r, a, n = [], o = Wz(t);
            for(a = 0; a < o; a++)a in t && nO(n, t[a]);
            for(Zz(n, function(e) {
                return function(t, r) {
                    return void 0 === r ? -1 : void 0 === t ? 1 : void 0 !== e ? +e(t, r) || 0 : Yz(t) > Yz(r) ? 1 : -1;
                };
            }(e)), r = Wz(n), a = 0; a < r;)t[a] = n[a++];
            for(; a < o;)Gz(t, a++);
            return t;
        }
    });
    var sO = Cv("Array", "sort"), uO = ie, dO = sO, pO = Array.prototype, mO = t(function(e) {
        var t = e.sort;
        return e === pO || uO(pO, e) && t === pO.sort ? dO : t;
    });
    function fO(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var hO = function(e) {
        var t, r = WI[e];
        return r || (r = zb(t = Ty(WI)).call(t, function(t) {
            return WI[t] === e;
        })) || e;
    }, vO = function(e, t) {
        var r = function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ag(r = fO(Object(n), !0)).call(r, function(t) {
                    Sg(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Ag(a = fO(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({}, e);
        return r.error = r.error ? r.error : function(e) {
            var t = Ty(WI);
            return tC(t).call(t, function(t, r) {
                var a = WI[r];
                return (Kk(a).call(a, "sf-") > -1 || Kk(a).call(a, "gen.01") > -1) && (t[a] = e.get(a)), t;
            }, {});
        }(t), r;
    }, yO = function(e, t) {
        var r = e.i18n, a = e.fieldTypeMappingFn, n = e.SRPanelRef, o = t.errors, i = t.isValidating, l = t.layout, c = function(e) {
            var t, r = e.errors, a = e.i18n, n = e.layout, o = e.countrySpecificLabels, i = e.fieldTypeMappingFn, l = tC(t = Tz(r)).call(t, function(e, t) {
                var l = Vk(t, 2), c = l[0];
                if (l[1]) {
                    var s, u, d, p, m = r[c];
                    s = m instanceof SD ? "object" === ig(m.errorMessage) ? m.errorMessage.translationKey : m.errorMessage : m.error;
                    var f = u = m instanceof SD || !("errorI18n" in m) ? "object" === ig(m.errorMessage) ? wb(d = wb(p = "".concat(a.get(m.errorMessage.translationKey), " ")).call(p, sC(m.errorMessage.translationObject).format)).call(d, "") : a.get(m.errorMessage) + "" : m.errorI18n + "";
                    if (i) {
                        var h, v = i(c, a, o);
                        v && (f = wb(h = "".concat(v, ": ")).call(h, u));
                    }
                    e.push({
                        field: c,
                        errorMessage: f,
                        errorCode: s
                    }), n && mO(e).call(e, function(e, t) {
                        return Kk(n).call(n, e.field) - Kk(n).call(n, t.field);
                    });
                }
                return e;
            }, []);
            return l;
        }({
            errors: o,
            i18n: r,
            fieldTypeMappingFn: a,
            countrySpecificLabels: t.countrySpecificLabels,
            layout: l
        });
        if (c.length) {
            if (i) {
                var s = hC(c).call(c, function(e) {
                    return e.errorMessage;
                });
                n.setMessages(s);
                var u = hC(c).call(c, function(e) {
                    return e.field;
                });
                return {
                    currentErrorsSortedByLayout: c,
                    action: QI,
                    fieldToFocus: u[0]
                };
            }
            return null == n || n.setMessages(null), {
                currentErrorsSortedByLayout: c,
                action: ZI
            };
        }
        return null == n || n.setMessages(null), {
            currentErrorsSortedByLayout: c,
            action: "none"
        };
    }, gO = SN({
        srPanel: null,
        setSRMessagesFromObjects: null,
        setSRMessagesFromStrings: null,
        clearSRPanel: null,
        shouldMoveFocusSR: null
    });
    function bO() {
        return CP(gO);
    }
    var kO = function(e, t) {
        var r = [];
        return e && "function" == typeof e.querySelectorAll && (r = xA([]).call(e.querySelectorAll(t))), r;
    }, CO = function(e, t) {
        if (e) return e.querySelector(t);
    }, _O = function(e, t) {
        if (e) return e.getAttribute(t);
    }, NO = function(e, t, r, a) {
        if ("function" != typeof e.addEventListener) {
            if (!e.attachEvent) throw new Error(": Unable to bind ".concat(t, "-event"));
            e.attachEvent("on".concat(t), r);
        } else e.addEventListener(t, r, a);
    }, PO = function(e, t, r, a) {
        if ("function" == typeof e.addEventListener) e.removeEventListener(t, r, a);
        else {
            if (!e.attachEvent) throw new Error(": Unable to unbind ".concat(t, "-event"));
            e.detachEvent("on".concat(t), r);
        }
    }, wO = function(e, t) {
        var r = CO(document, e), a = "issuer" === t ? "issuer-list" : t;
        if ("country" === a || "stateOrProvince" === a || "issuer-list" === a) {
            var n = CO(r, ".adyen-checkout__field--".concat(a, " .adyen-checkout__filter-input"));
            null == n || n.focus();
        } else {
            var o = CO(r, '[name="'.concat(a, '"]'));
            null == o || o.focus();
        }
    };
    function SO(e) {
        var t = gP();
        return vP(function() {
            t.current = e;
        }, [
            e
        ]), t.current;
    }
    function AO(e, t, r) {
        var a, n = r || "id";
        return 1 !== e.length || t || (a = e), e.length > (null == t ? void 0 : t.length) && (a = Fg(e).call(e, function(e) {
            var r = e[n];
            return !PT(t).call(t, function(e) {
                return e[n] === r;
            });
        })), a;
    }
    var IO = function() {
        return rN("p", {
            className: "adyen-checkout-form-instruction"
        }, zP().i18n.get("form.instruction"));
    }, DO = [
        "companyDetails",
        "personalDetails",
        "bankAccount",
        "billingAddress",
        "deliveryAddress"
    ];
    function EO(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function RO(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = EO(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = EO(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var xO = {
        isValid: !1,
        errorMessage: "consent.checkbox.invalid",
        error: "consent.checkbox.invalid"
    };
    function FO(e) {
        var t, r, a, n, o, i, l = e.countryCode, c = e.visibility, s = zP().i18n, u = gP({});
        Ty(u.current).length || null === (i = e.setComponentRef) || void 0 === i || i.call(e, u.current);
        var d = gP(!1), p = bO(), m = p.setSRMessagesFromObjects, f = p.setSRMessagesFromStrings, h = p.clearSRPanel, v = p.shouldMoveFocusSR, y = null == m ? void 0 : m({
            fieldTypeMappingFn: vz
        }), g = bP(function() {
            return new az;
        }, []), b = Vk(fP(hz(c, e.data)), 2), k = b[0], C = b[1], _ = gP(tC(fz).call(fz, function(e, t) {
            return e[t] = function(e) {
                _[t].current = e;
            }, e;
        }, {})).current, N = !!e.consentCheckboxLabel, P = !N && XA(t = Ty(k)).call(t, function(e) {
            return !k[e];
        }), w = "editable" === c.deliveryAddress && "hidden" !== c.billingAddress, S = Vk(fP(RO(RO({}, e.data), N && {
            consentCheckbox: !1
        })), 2), A = S[0], I = S[1], D = Vk(fP({}), 2), E = D[0], R = D[1], x = Vk(fP({}), 2), F = x[0], T = x[1], z = Vk(fP("ready"), 2), O = z[0], j = z[1], B = Vk(fP(null), 2), M = B[0], L = B[1];
        u.current.showValidation = function() {
            d.current = !0, Ag(fz).call(fz, function(e) {
                _[e].current && _[e].current.showValidation();
            }), R(RO({}, N && {
                consentCheckbox: A.consentCheckbox ? null : xO
            }));
        }, u.current.setStatus = j;
        var V = SO(M);
        vP(function() {
            var t, r, a, n, o, i, l, c, s, u = function() {
                var e;
                return XA(e = Ty(k)).call(e, function(e) {
                    return !k[e] || !!F[e];
                });
            }(), p = !N || !!F.consentCheckbox, m = u && p, b = function(e, t) {
                var r, a;
                return tC(r = Fg(a = Ty(t)).call(a, function(t) {
                    return e[t];
                })).call(r, function(e, r) {
                    return e[r] = t[r], e;
                }, {});
            }(k, A), C = "deliveryAddress:", _ = E.companyDetails, P = E.personalDetails, w = E.bankAccount, S = E.billingAddress, I = E.deliveryAddress, D = kg(E, DO), R = (c = C, (l = I) ? tC(s = Tz(l)).call(s, function(e, t) {
                var r, a = Vk(t, 2), n = a[0], o = a[1];
                return o && (e[wb(r = "".concat(c)).call(r, n)] = o), e;
            }, {}) : null), x = RO(RO(RO(RO(RO(RO({}, "object" === ig(_) && _), "object" === ig(P) && P), "object" === ig(w) && w), "object" === ig(S) && S), "object" === ig(R) && R), D), T = cE, z = null !== (t = e.personalDetailsRequiredFields) && void 0 !== t ? t : UE, O = Fg(UE).call(UE, function(e) {
                return null == z ? void 0 : kb(z).call(z, e);
            }), j = g.getAddressSchemaForCountryFlat(null === (r = A.billingAddress) || void 0 === r ? void 0 : r.country), B = g.getAddressSchemaForCountryFlat(null === (a = A.deliveryAddress) || void 0 === a ? void 0 : a.country), M = hC(B).call(B, function(e) {
                var t;
                return wb(t = "".concat(C)).call(t, e);
            }), U = wb(T).call(T, O, [
                "holder",
                "iban"
            ], j, M, [
                "consentCheckbox"
            ]), K = g.getAddressLabelsForCountry(null !== (n = null === (o = A.billingAddress) || void 0 === o ? void 0 : o.country) && void 0 !== n ? n : null === (i = A.deliveryAddress) || void 0 === i ? void 0 : i.country), H = null == y ? void 0 : y({
                errors: x,
                isValidating: d.current,
                layout: U,
                countrySpecificLabels: K
            }), q = null == H ? void 0 : H.currentErrorsSortedByLayout;
            switch(L(q), null == H ? void 0 : H.action){
                case QI:
                    v && wO(".adyen-checkout__open-invoice", H.fieldToFocus), ZN(function() {
                        d.current = !1;
                    }, 300);
                    break;
                case ZI:
                    var W = AO(q, V, "field"), G = null == W ? void 0 : W[0];
                    if (G) {
                        var Y = "shopperEmail.invalid" === G.errorCode ? G.errorMessage : null;
                        f(Y);
                    } else h();
            }
            e.onChange({
                data: b,
                errors: E,
                valid: F,
                isValid: m
            });
        }, [
            A,
            k
        ]);
        var U = function(e) {
            return function(t) {
                I(function(r) {
                    return RO(RO({}, r), {}, Sg({}, e, t.data));
                }), T(function(r) {
                    return RO(RO({}, r), {}, Sg({}, e, t.isValid));
                }), R(function(r) {
                    return RO(RO({}, r), {}, Sg({}, e, t.errors));
                });
            };
        };
        return rN("div", {
            className: "adyen-checkout__open-invoice"
        }, e.showFormInstruction && rN(IO, null), k.companyDetails && rN(sE, {
            data: e.data.companyDetails,
            label: "companyDetails",
            onChange: U("companyDetails"),
            setComponentRef: _.companyDetails,
            visibility: c.companyDetails
        }), k.personalDetails && rN(KE, {
            data: e.data.personalDetails,
            requiredFields: e.personalDetailsRequiredFields,
            label: "personalDetails",
            onChange: U("personalDetails"),
            setComponentRef: _.personalDetails,
            visibility: c.personalDetails
        }), k.bankAccount && rN(xz, {
            holderName: !0,
            label: "bankAccount",
            data: A.bankAccount,
            onChange: U("bankAccount"),
            ref: _.bankAccount
        }), k.billingAddress && rN(cz, {
            allowedCountries: null !== (r = null == e || null === (a = e.billingAddressSpecification) || void 0 === a ? void 0 : a.allowedCountries) && void 0 !== r ? r : e.allowedCountries,
            countryCode: l,
            requiredFields: e.billingAddressRequiredFields,
            specifications: e.billingAddressSpecification,
            data: A.billingAddress,
            label: "billingAddress",
            onChange: U("billingAddress"),
            setComponentRef: _.billingAddress,
            visibility: c.billingAddress
        }), w && rN(oD, {
            name: "separateDeliveryAddress",
            useLabelElement: !1,
            addContextualElement: !1
        }, rN(dz, {
            label: s.get("separateDeliveryAddress"),
            checked: k.deliveryAddress,
            classNameModifiers: [
                "separateDeliveryAddress"
            ],
            name: "separateDeliveryAddress",
            onChange: function() {
                C(function(e) {
                    return RO(RO({}, e), {}, {
                        deliveryAddress: !k.deliveryAddress
                    });
                });
            }
        })), k.deliveryAddress && rN(cz, {
            allowedCountries: null !== (n = null == e || null === (o = e.deliveryAddressSpecification) || void 0 === o ? void 0 : o.allowedCountries) && void 0 !== n ? n : e.allowedCountries,
            countryCode: l,
            requiredFields: e.deliveryAddressRequiredFields,
            specifications: e.deliveryAddressSpecification,
            data: A.deliveryAddress,
            label: "deliveryAddress",
            onChange: U("deliveryAddress"),
            setComponentRef: _.deliveryAddress,
            visibility: c.deliveryAddress
        }), N && rN(mz, {
            data: A,
            errorMessage: !!E.consentCheckbox,
            label: e.consentCheckboxLabel,
            onChange: function(e) {
                var t = e.target.checked;
                I(function(e) {
                    return RO(RO({}, e), {}, {
                        consentCheckbox: t
                    });
                }), T(function(e) {
                    return RO(RO({}, e), {}, {
                        consentCheckbox: t
                    });
                }), R(function(e) {
                    return RO(RO({}, e), {}, {
                        consentCheckbox: !t
                    });
                });
            },
            i18n: s
        }), e.showPayButton && e.payButton({
            status: O,
            classNameModifiers: Uk(P ? [
                "standalone"
            ] : []),
            label: s.get("confirmPurchase")
        }));
    }
    function TO(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var zO = function(e) {
        L_(r, e);
        var t = TO(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "state", {
                loaded: !1
            }), a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.i18n ? this.props.i18n.loaded.then(function() {
                        e.setState({
                            loaded: !0
                        });
                    }) : this.setState({
                        loaded: !0
                    }), this.props.i18n && this.props.loadingContext && this.props.resources || console.error("CoreProvider - WARNING core provider is missing one of the following: i18n, loadingContext or resources");
                }
            },
            {
                key: "render",
                value: function(e) {
                    var t = e.children;
                    return this.state.loaded ? rN(TP.Provider, {
                        value: {
                            i18n: this.props.i18n,
                            loadingContext: this.props.loadingContext,
                            commonProps: this.props.commonProps || {},
                            resources: this.props.resources
                        }
                    }, pN(t)) : null;
                }
            }
        ]), r;
    }(oN);
    Ar({
        target: "Number",
        stat: !0
    }, {
        isNaN: function(e) {
            return e != e;
        }
    });
    var OO = t(ee.Number.isNaN), jO = Object.prototype.toString;
    function BO(e) {
        return "object" === ig(e) && null !== e && "[object Array]" === Object.prototype.toString.call(e);
    }
    function MO(e) {
        return null != e;
    }
    function LO(e) {
        return !1 !== e && MO(e);
    }
    function VO(e) {
        return !!e && "object" === ig(e);
    }
    function UO(e, t) {
        var r, a = ig(e), n = ig(t);
        return e && t && "object" === a && a === n ? Ty(e).length === Ty(t).length && XA(r = Ty(e)).call(r, function(r) {
            return UO(e[r], t[r]);
        }) : e === t;
    }
    function KO(e) {
        var t;
        return !LO(e) || !(!("number" == typeof (t = e) || VO(t) && "[object Number]" === jO.call(t)) || 0 !== e && !OO(e)) || !(!BO(e) && !function(e) {
            return "string" == typeof e || VO(e) && "[object String]" === jO.call(e);
        }(e) || 0 !== e.length) || !(!VO(e) || 0 !== Ty(e).length);
    }
    function HO() {
        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
        var a = t, n = a.shift();
        return function() {
            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
            return n.apply(this, wb(a).call(a, t));
        };
    }
    var qO = function(e) {
        var t = e.srPanel, r = e.children, a = zP().i18n, n = t.moveFocus;
        return rN(gO.Provider, {
            value: {
                srPanel: t,
                setSRMessagesFromObjects: function(e) {
                    var r = e.fieldTypeMappingFn;
                    return HO(yO, {
                        SRPanelRef: t,
                        i18n: a,
                        fieldTypeMappingFn: r
                    });
                },
                setSRMessagesFromStrings: function(e) {
                    t.setMessages(e);
                },
                clearSRPanel: function() {
                    t.setMessages(null);
                },
                shouldMoveFocusSR: n
            }
        }, r);
    };
    function WO(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function GO(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = WO(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = WO(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function YO(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var QO = function(e) {
        L_(r, e);
        var t = YO(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    var t, a = e.countryCode || (null === (t = e.data) || void 0 === t || null === (t = t.billingAddress) || void 0 === t ? void 0 : t.countryCode);
                    return GO(GO({}, e), {}, {
                        allowedCountries: [
                            a
                        ],
                        visibility: GO(GO({}, r.defaultProps.visibility), e.visibility),
                        data: GO(GO({}, e.data), {}, {
                            billingAddress: GO(GO({}, e.data.billingAddress), {}, {
                                country: a
                            }),
                            deliveryAddress: GO(GO({}, e.data.deliveryAddress), {}, {
                                country: a
                            })
                        })
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.data, t = void 0 === e ? {} : e, r = t.companyDetails, a = void 0 === r ? {} : r, n = t.personalDetails, o = void 0 === n ? {} : n, i = t.billingAddress, l = t.deliveryAddress, c = t.bankAccount;
                    return GO(GO(GO(GO(GO({
                        paymentMethod: {
                            type: this.constructor.type
                        }
                    }, o), a), c && {
                        bankAccount: {
                            iban: c.ibanNumber,
                            ownerName: c.ownerName,
                            countryCode: c.countryCode
                        }
                    }), i && {
                        billingAddress: i
                    }), (l || i) && {
                        deliveryAddress: l || i
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(qO, {
                        srPanel: this.props.modules.srPanel
                    }, rN(FO, j_({
                        setComponentRef: this.setComponentRef
                    }, this.props, this.state, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    }))));
                }
            }
        ]), r;
    }(gA);
    function ZO(e) {
        var t = zP().i18n, r = t.get("paymentConditions"), a = Vk(t.get("afterPay.agreement").split("%@"), 2), n = a[0], o = a[1];
        return n && o ? rN(nN, null, n, rN("a", {
            className: "adyen-checkout__link",
            target: "_blank",
            rel: "noopener noreferrer",
            href: e.url
        }, r), o) : rN("span", {
            className: "adyen-checkout__checkbox__label"
        }, t.get("privacyPolicy"));
    }
    Sg(QO, "defaultProps", {
        onChange: function() {},
        data: {
            companyDetails: {},
            personalDetails: {},
            billingAddress: {},
            deliveryAddress: {},
            bankAccount: {}
        },
        visibility: {
            companyDetails: "hidden",
            personalDetails: "editable",
            billingAddress: "editable",
            deliveryAddress: "editable",
            bankAccount: "hidden"
        },
        showFormInstruction: !0
    });
    var JO = [
        "BE",
        "NL"
    ], $O = {
        be: {
            en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/be_en",
            fr: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/be_fr",
            nl: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/be_nl"
        },
        nl: {
            en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/nl_en",
            nl: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/nl_nl"
        }
    };
    function XO(e, t, r) {
        var a, n, o, i = null == t ? void 0 : xA(a = t.toLowerCase()).call(a, 0, 2), l = null === (n = r[null == e ? void 0 : e.toLowerCase()]) || void 0 === n ? void 0 : n[i];
        if (l) return l;
        console.warn(wb(o = "Cannot find a consent url for the provided countryCode: ".concat(e, " and locale: ")).call(o, t));
    }
    function ej(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function tj(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = ej(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = ej(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function rj(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var aj = function(e) {
        L_(r, e);
        var t = rj(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t;
                    return tj(tj({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : JO,
                        consentCheckboxLabel: rN(ZO, {
                            url: XO(e.countryCode, null === (t = e.i18n) || void 0 === t ? void 0 : t.locale, $O)
                        })
                    });
                }
            }
        ]), r;
    }(QO);
    function nj(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function oj(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = nj(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = nj(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function ij(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(aj, "type", "afterpay_default");
    var lj = function(e) {
        L_(r, e);
        var t = ij(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return oj(oj({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : JO
                    });
                }
            }
        ]), r;
    }(QO);
    function cj() {
        var e = AN(window, "screen.colorDepth") || "", t = !!AN(window, "navigator.javaEnabled") && window.navigator.javaEnabled(), r = AN(window, "screen.height") || "", a = AN(window, "screen.width") || "", n = AN(window, "navigator.userAgent") || "";
        return {
            acceptHeader: "*/*",
            colorDepth: e,
            language: AN(window, "navigator.language") || AN(window, "navigator.browserLanguage") || "en",
            javaEnabled: t,
            screenHeight: r,
            screenWidth: a,
            userAgent: n,
            timeZoneOffset: (new Date).getTimezoneOffset()
        };
    }
    Sg(lj, "type", "afterpay_b2b"), Sg(lj, "defaultProps", {
        onChange: function() {},
        data: {
            companyDetails: {},
            personalDetails: {},
            billingAddress: {},
            deliveryAddress: {}
        },
        visibility: {
            companyDetails: "editable",
            personalDetails: "editable",
            billingAddress: "editable",
            deliveryAddress: "editable"
        },
        showFormInstruction: !0
    });
    var sj = "v1/AmazonPayUtility/signString", uj = "v1/AmazonPayUtility/updateCheckoutSession", dj = "https://static-eu.payments-amazon.com/checkout.js", pj = "https://static-na.payments-amazon.com/checkout.js", mj = "en_GB", fj = "en_US", hj = {
        EU: "EUR",
        UK: "GBP",
        US: "USD"
    }, vj = [
        "en_GB",
        "de_DE",
        "fr_FR",
        "it_IT",
        "es_ES"
    ], yj = [
        "en_US"
    ];
    function gj(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function bj(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = gj(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = gj(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function kj(e, t) {
        var r = function(e) {
            return "US" === e ? yj : vj;
        }(t), a = kb(r).call(r, e) ? e : function(e) {
            return "US" === e ? fj : mj;
        }(t);
        return a;
    }
    function Cj(e) {
        return "noTagline" === e ? "C0001" : null;
    }
    function _j(e) {
        var t = e.addressDetails, r = e.cancelUrl, a = e.checkoutMode, n = e.deliverySpecifications, o = e.returnUrl, i = e.merchantMetadata, l = e.chargePermissionType, c = e.recurringMetadata, s = e.configuration.storeId, u = "ProcessOrder" === a, d = u ? function(e) {
            return {
                amount: String(t_(e.value, e.currency)),
                currencyCode: e.currency
            };
        }(e.amount) : null;
        return bj(bj(bj(bj(bj({
            storeId: s,
            chargePermissionType: l,
            webCheckoutDetails: bj(bj(bj({}, u ? {
                checkoutResultReturnUrl: o
            } : {
                checkoutReviewReturnUrl: o
            }), r && {
                checkoutCancelUrl: r
            }), u && {
                checkoutMode: a
            })
        }, u && {
            paymentDetails: {
                chargeAmount: d,
                paymentIntent: "Confirm",
                presentmentCurrency: d.currencyCode,
                totalOrderAmount: d
            }
        }), c && {
            recurringMetadata: c
        }), i && {
            merchantMetadata: i
        }), n && {
            deliverySpecifications: n
        }), t && {
            addressDetails: t
        });
    }
    function Nj(e, t, r) {
        var a;
        return cT({
            loadingContext: e,
            path: wb(a = "".concat("v1/AmazonPayUtility/getCheckoutDetails", "?clientKey=")).call(a, t)
        }, r);
    }
    function Pj(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function wj(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = Pj(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = Pj(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function Sj(e) {
        var t = this, r = zP().loadingContext, a = e.amazonRef, n = e.configuration, o = void 0 === n ? {} : n, i = Vk(fP(null), 2), l = i[0], c = i[1], s = _j(e), u = function(e) {
            var t;
            return bj(bj(bj({}, e.buttonColor && {
                buttonColor: e.buttonColor
            }), e.design && {
                design: Cj(e.design)
            }), {}, {
                checkoutLanguage: kj(e.locale, e.configuration.region),
                ledgerCurrency: hj[e.configuration.region] || e.currency || (null === (t = e.amount) || void 0 === t ? void 0 : t.currency),
                merchantId: e.configuration.merchantId,
                productType: e.productType,
                placement: e.placement,
                sandbox: "TEST" === e.environment
            });
        }(e), d = function() {
            new Sb(e.onClick).then(t.initCheckout).catch(function(r) {
                e.onError && e.onError(r, t.componentRef);
            });
        };
        return this.initCheckout = function() {
            var e = {
                payloadJSON: Mb(s),
                publicKeyId: o.publicKeyId,
                signature: l
            };
            a.Pay.initCheckout(wj(wj({}, u), {}, {
                createCheckoutSessionConfig: e
            }));
        }, vP(function() {
            var n = e.clientKey;
            (function(e, t, r) {
                var a;
                return cT({
                    loadingContext: e,
                    path: wb(a = "".concat(sj, "?clientKey=")).call(a, t)
                }, {
                    stringToSign: Mb(r)
                });
            })(r, n, s).then(function(t) {
                if (null == t || !t.signature) return console.error("Could not get AmazonPay signature");
                c(t.signature), e.showPayButton && a.Pay.renderButton("#amazonPayButton", u).onClick(d);
            }).catch(function(r) {
                console.error(r), e.onError && e.onError(r, t.componentRef);
            });
        }, []), e.showPayButton ? rN("div", {
            className: "adyen-checkout__amazonpay__button",
            id: "amazonPayButton"
        }) : null;
    }
    function Aj(e) {
        var t = zP().i18n, r = e.amazonRef, a = e.amazonCheckoutSessionId;
        return vP(function() {
            var e = {
                amazonCheckoutSessionId: a,
                changeAction: "changeAddress"
            };
            r.Pay.bindChangeAction(".adyen-checkout__amazonpay__button--changeAddress", e);
        }, []), rN("button", {
            type: "button",
            className: "adyen-checkout__button adyen-checkout__button--ghost adyen-checkout__amazonpay__button--changeAddress"
        }, t.get("amazonpay.changePaymentDetails"));
    }
    function Ij(e) {
        var t = this, r = zP(), a = r.i18n, n = r.loadingContext;
        return this.createOrder = function() {
            var r = e.amazonCheckoutSessionId, a = e.amount, o = e.clientKey, i = e.chargePermissionType, l = e.publicKeyId, c = e.region, s = e.recurringMetadata, u = e.returnUrl;
            (function(e, t, r) {
                var a;
                return cT({
                    loadingContext: e,
                    path: wb(a = "".concat(uj, "?clientKey=")).call(a, t)
                }, r);
            })(n, o, {
                amount: a,
                chargePermissionType: i,
                checkoutResultReturnUrl: u,
                checkoutSessionId: r,
                publicKeyId: l,
                recurringMetadata: s,
                region: c
            }).then(function(e) {
                var t;
                if (null == e || null === (t = e.action) || void 0 === t || !t.type) return console.error(e.errorMessage || "Could not get the AmazonPay URL");
                "redirect" === e.action.type && window.location.assign(e.action.url);
            }).catch(function(r) {
                e.onError && e.onError(r, t.componentRef);
            });
        }, rN(jP, {
            classNameModifiers: [
                "standalone",
                "pay"
            ],
            label: a.get("confirmPurchase"),
            onClick: this.createOrder
        });
    }
    function Dj(e) {
        return rN("button", {
            type: "button",
            className: "adyen-checkout__button  adyen-checkout__button--ghost adyen-checkout__amazonpay__button--signOut",
            onClick: function() {
                new Sb(e.onSignOut).then(function() {
                    e.amazonRef.Pay.signout();
                }).catch(console.error);
            }
        }, zP().i18n.get("amazonpay.signout"));
    }
    var Ej = t(T_), Rj = wg(function e(t) {
        var r = this, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "body", n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        Cg(this, e), Sg(this, "src", void 0), Sg(this, "node", void 0), Sg(this, "attributes", void 0), Sg(this, "dataAttributes", void 0), Sg(this, "isScriptLoadCalled", !1), Sg(this, "script", void 0), Sg(this, "load", function() {
            if (!r.isScriptLoadCalled) return new Sb(function(e, t) {
                var a = function() {
                    r.script.setAttribute("data-script-loaded", "true"), e();
                }, n = function() {
                    r.remove(), t(new Error("Unable to load script ".concat(r.src)));
                };
                r.isScriptLoadCalled = !0;
                var o = document.querySelector(r.node);
                if (r.script = o.querySelector('script[src="'.concat(r.src, '"]')), r.script && r.script.getAttribute("data-script-loaded")) e();
                else {
                    if (r.script) return r.script.addEventListener("load", a), void r.script.addEventListener("error", n);
                    r.script = document.createElement("script"), Ej(r.script, r.attributes), Ej(r.script.dataset, r.dataAttributes), r.script.src = r.src, r.script.async = !0, r.script.addEventListener("load", a), r.script.addEventListener("error", n), o.appendChild(r.script);
                }
            });
        }), Sg(this, "remove", function() {
            return r.script.parentNode && r.script.parentNode.removeChild(r.script);
        }), this.src = t, this.node = a, this.attributes = n, this.dataAttributes = o;
    });
    function xj(e) {
        var t, r, a = Vk(fP("pending"), 2), n = a[0], o = a[1], i = gP(null), l = gP(null), c = function() {
            o("ready");
        };
        return this.submit = function() {
            return i.current && i.current.initCheckout ? i.current.initCheckout() : l.current && l.current.createOrder ? l.current.createOrder() : void 0;
        }, vP(function() {
            var t = "US" === e.configuration.region ? pj : dj, r = new Rj(t);
            return window.amazon ? c() : r.load().then(c), function() {
                r.remove();
            };
        }, []), "pending" === n ? rN("div", {
            className: "adyen-checkout__amazonpay"
        }, rN("div", {
            className: "adyen-checkout__amazonpay__status adyen-checkout__amazonpay__status--pending"
        }, rN(nP, null))) : e.showSignOutButton ? rN("div", {
            className: "adyen-checkout__amazonpay"
        }, rN(Dj, {
            amazonRef: window.amazon,
            onSignOut: e.onSignOut
        })) : e.amazonCheckoutSessionId ? rN("div", {
            className: "adyen-checkout__amazonpay"
        }, e.showOrderButton && rN(Ij, {
            amazonCheckoutSessionId: e.amazonCheckoutSessionId,
            amount: e.amount,
            chargePermissionType: e.chargePermissionType,
            recurringMetadata: e.recurringMetadata,
            clientKey: e.clientKey,
            onError: e.onError,
            publicKeyId: null === (t = e.configuration) || void 0 === t ? void 0 : t.publicKeyId,
            region: null === (r = e.configuration) || void 0 === r ? void 0 : r.region,
            returnUrl: e.returnUrl,
            ref: l
        }), e.showChangePaymentDetailsButton && rN(Aj, {
            amazonCheckoutSessionId: e.amazonCheckoutSessionId,
            amazonRef: window.amazon
        })) : rN("div", {
            className: "adyen-checkout__amazonpay"
        }, rN(Sj, j_({}, e, {
            amazonRef: window.amazon,
            ref: i
        })));
    }
    var Fj = {
        cancelUrl: "undefined" != typeof window ? window.location.href : "",
        configuration: {},
        environment: "TEST",
        locale: "en_GB",
        placement: "Cart",
        productType: "PayAndShip",
        returnUrl: "undefined" != typeof window ? window.location.href : "",
        showOrderButton: !0,
        showChangePaymentDetailsButton: !1,
        showSignOutButton: !1,
        showPayButton: !0,
        onClick: function(e) {
            return e();
        },
        onSignOut: function(e) {
            return e();
        }
    };
    function Tj(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function zj(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = Tj(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = Tj(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function Oj(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var jj = function(e) {
        L_(r, e);
        var t = Oj(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return zj(zj({}, e), {}, {
                        checkoutMode: e.isDropin ? "ProcessOrder" : e.checkoutMode,
                        environment: e.environment.toUpperCase(),
                        locale: e.locale.replace("-", "_"),
                        productType: e.isDropin && !e.addressDetails ? "PayOnly" : e.productType
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.props.amazonCheckoutSessionId;
                    return {
                        paymentMethod: zj({
                            type: r.type
                        }, e && {
                            checkoutSessionId: e
                        }),
                        browserInfo: this.browserInfo
                    };
                }
            },
            {
                key: "getShopperDetails",
                value: function() {
                    var e = this.props, t = e.amazonCheckoutSessionId, r = e.configuration, a = void 0 === r ? {} : r, n = e.loadingContext, o = e.clientKey;
                    return t ? Nj(n, o, {
                        checkoutSessionId: t,
                        getDeliveryAddress: !0,
                        publicKeyId: a.publicKeyId,
                        region: a.region
                    }) : console.error("Could not shopper details. Missing checkoutSessionId.");
                }
            },
            {
                key: "handleDeclineFlow",
                value: function() {
                    var e = this, t = this.props, r = t.amazonCheckoutSessionId, a = t.configuration, n = void 0 === a ? {} : a, o = t.loadingContext, i = t.clientKey;
                    if (!r) return console.error("Could handle the decline flow. Missing checkoutSessionId.");
                    Nj(o, i, {
                        checkoutSessionId: r,
                        getDeclineFlowUrl: !0,
                        publicKeyId: n.publicKeyId,
                        region: n.region
                    }).then(function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        if (null == e || !e.declineFlowUrl) throw e;
                        window.location.assign(e.declineFlowUrl);
                    }).catch(function(t) {
                        e.props.onError && e.props.onError(t, e.componentRef);
                    });
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return cj();
                }
            },
            {
                key: "submit",
                value: function() {
                    var e = this.data, t = this.isValid, r = this.props.onSubmit, a = void 0 === r ? function() {} : r;
                    return this.componentRef && this.componentRef.submit ? this.componentRef.submit() : a({
                        data: e,
                        isValid: t
                    }, this);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(xj, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props)));
                }
            }
        ]), r;
    }(gA);
    Sg(jj, "type", "amazonpay"), Sg(jj, "defaultProps", Fj);
    var Bj = {
        "apple-pay": "ApplePayButton-module_apple-pay__gYjuP",
        "apple-pay-button": "ApplePayButton-module_apple-pay-button__l5g-d",
        "apple-pay-button-black": "ApplePayButton-module_apple-pay-button-black__istwW",
        "apple-pay-button-white": "ApplePayButton-module_apple-pay-button-white__-wLaE",
        "apple-pay-button-white-with-line": "ApplePayButton-module_apple-pay-button-white-with-line__MlRq7",
        "apple-pay-button--type-plain": "ApplePayButton-module_apple-pay-button--type-plain__ycfNl",
        "apple-pay-button--type-buy": "ApplePayButton-module_apple-pay-button--type-buy__9m8AB",
        "apple-pay-button--type-donate": "ApplePayButton-module_apple-pay-button--type-donate__HmRdK",
        "apple-pay-button--type-check-out": "ApplePayButton-module_apple-pay-button--type-check-out__XdGWd",
        "apple-pay-button--type-book": "ApplePayButton-module_apple-pay-button--type-book__-v-VY",
        "apple-pay-button--type-subscribe": "ApplePayButton-module_apple-pay-button--type-subscribe__WxWIF",
        "apple-pay-button--type-add-money": "ApplePayButton-module_apple-pay-button--type-add-money__zeBA8",
        "apple-pay-button--type-contribute": "ApplePayButton-module_apple-pay-button--type-contribute__G3E8e",
        "apple-pay-button--type-order": "ApplePayButton-module_apple-pay-button--type-order__ggI6j",
        "apple-pay-button--type-reload": "ApplePayButton-module_apple-pay-button--type-reload__QbgLd",
        "apple-pay-button--type-rent": "ApplePayButton-module_apple-pay-button--type-rent__VzC-E",
        "apple-pay-button--type-support": "ApplePayButton-module_apple-pay-button--type-support__6EjmY",
        "apple-pay-button--type-tip": "ApplePayButton-module_apple-pay-button--type-tip__bdzGK",
        "apple-pay-button--type-top-up": "ApplePayButton-module_apple-pay-button--type-top-up__Eb3qR"
    };
    function Mj(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var Lj = function(e) {
        L_(r, e);
        var t = Mj(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "render",
                value: function(e) {
                    var t = e.buttonColor, r = e.buttonType;
                    return rN("button", {
                        type: "button",
                        "aria-label": this.props.i18n.get("payButton"),
                        lang: this.props.i18n.languageCode,
                        className: aP("adyen-checkout__applepay__button", "adyen-checkout__applepay__button--".concat(t), "adyen-checkout__applepay__button--".concat(r), [
                            Bj["apple-pay"]
                        ], [
                            Bj["apple-pay-button"]
                        ], [
                            Bj["apple-pay-button-".concat(t)]
                        ], [
                            Bj["apple-pay-button--type-".concat(r)]
                        ]),
                        onClick: this.props.onClick
                    });
                }
            }
        ]), r;
    }(oN);
    function Vj(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Uj(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = Vj(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = Vj(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    Sg(Lj, "defaultProps", {
        onClick: function() {},
        buttonColor: "black",
        buttonType: "plain"
    });
    var Kj = function() {
        function e(t, r) {
            var a = this;
            Cg(this, e), Sg(this, "session", void 0), Sg(this, "options", void 0), this.options = r, this.session = new ApplePaySession(r.version, t), this.session.onvalidatemerchant = function(e) {
                return a.onvalidatemerchant(e, r.onValidateMerchant);
            }, this.session.onpaymentauthorized = function(e) {
                return a.onpaymentauthorized(e, r.onPaymentAuthorized);
            }, this.session.oncancel = function(e) {
                return a.oncancel(e, r.onCancel);
            }, "function" == typeof r.onPaymentMethodSelected && (this.session.onpaymentmethodselected = function(e) {
                return a.onpaymentmethodselected(e, r.onPaymentMethodSelected);
            }), "function" == typeof r.onShippingContactSelected && (this.session.onshippingcontactselected = function(e) {
                return a.onshippingcontactselected(e, r.onShippingContactSelected);
            }), "function" == typeof r.onShippingMethodSelected && (this.session.onshippingmethodselected = function(e) {
                return a.onshippingmethodselected(e, r.onShippingMethodSelected);
            });
        }
        return wg(e, [
            {
                key: "begin",
                value: function() {
                    return this.session.begin();
                }
            },
            {
                key: "onvalidatemerchant",
                value: function(e, t) {
                    var r = this;
                    return new Sb(function(r, a) {
                        return t(r, a, e.validationURL);
                    }).then(function(e) {
                        r.session.completeMerchantValidation(e);
                    }).catch(function(e) {
                        console.error(e), r.session.abort(), r.options.onError(e);
                    });
                }
            },
            {
                key: "onpaymentauthorized",
                value: function(e, t) {
                    var r = this;
                    return new Sb(function(r, a) {
                        return t(r, a, e);
                    }).then(function(e) {
                        var t;
                        r.session.completePayment(Uj(Uj({}, e), {}, {
                            status: null !== (t = null == e ? void 0 : e.status) && void 0 !== t ? t : ApplePaySession.STATUS_SUCCESS
                        }));
                    }).catch(function(e) {
                        var t;
                        r.session.completePayment(Uj(Uj({}, e), {}, {
                            status: null !== (t = null == e ? void 0 : e.status) && void 0 !== t ? t : ApplePaySession.STATUS_FAILURE
                        }));
                    });
                }
            },
            {
                key: "onpaymentmethodselected",
                value: function(e, t) {
                    var r = this;
                    return new Sb(function(r, a) {
                        return t(r, a, e);
                    }).then(function(e) {
                        console.log("onpaymentmethodselected", e), r.session.completePaymentMethodSelection(e);
                    }).catch(function(e) {
                        r.session.completePaymentMethodSelection(e);
                    });
                }
            },
            {
                key: "onshippingcontactselected",
                value: function(e, t) {
                    var r = this;
                    return new Sb(function(r, a) {
                        return t(r, a, e);
                    }).then(function(e) {
                        r.session.completeShippingContactSelection(e);
                    }).catch(function(e) {
                        r.session.completeShippingContactSelection(e);
                    });
                }
            },
            {
                key: "onshippingmethodselected",
                value: function(e, t) {
                    var r = this;
                    return new Sb(function(r, a) {
                        return t(r, a, e);
                    }).then(function(e) {
                        r.session.completeShippingMethodSelection(e);
                    }).catch(function(e) {
                        r.session.completeShippingMethodSelection(e);
                    });
                }
            },
            {
                key: "oncancel",
                value: function(e, t) {
                    t(e);
                }
            }
        ]), e;
    }(), Hj = {
        amount: {
            currency: "USD",
            value: 0
        },
        countryCode: "US",
        totalPriceStatus: "final",
        totalPriceLabel: void 0,
        configuration: {
            merchantName: "",
            merchantId: ""
        },
        initiative: "web",
        lineItems: void 0,
        merchantCapabilities: [
            "supports3DS"
        ],
        shippingMethods: void 0,
        shippingType: void 0,
        supportedCountries: void 0,
        supportedNetworks: [
            "amex",
            "discover",
            "masterCard",
            "visa"
        ],
        requiredBillingContactFields: void 0,
        requiredShippingContactFields: void 0,
        billingContact: void 0,
        shippingContact: void 0,
        applicationData: void 0,
        onClick: function(e) {
            return e();
        },
        onAuthorized: function(e) {
            return e();
        },
        onPaymentMethodSelected: null,
        onShippingContactSelected: null,
        onShippingMethodSelected: null,
        buttonType: "plain",
        buttonColor: "black",
        showPayButton: !0
    }, qj = [
        "countryCode",
        "companyName",
        "amount"
    ], Wj = function(e) {
        var t = e.countryCode;
        e.companyName;
        var r = e.amount, a = kg(e, qj), n = function(e) {
            return String(t_(e.value, e.currency));
        }(r);
        return {
            countryCode: t,
            currencyCode: r.currency,
            total: {
                label: a.totalPriceLabel,
                amount: n,
                type: a.totalPriceStatus
            },
            lineItems: a.lineItems,
            shippingMethods: a.shippingMethods,
            shippingType: a.shippingType,
            recurringPaymentRequest: a.recurringPaymentRequest,
            merchantCapabilities: a.merchantCapabilities,
            supportedCountries: a.supportedCountries,
            supportedNetworks: a.supportedNetworks,
            requiredShippingContactFields: a.requiredShippingContactFields,
            requiredBillingContactFields: a.requiredBillingContactFields,
            billingContact: a.billingContact,
            shippingContact: a.shippingContact,
            applicationData: a.applicationData
        };
    };
    function Gj(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Yj(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = Gj(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = Gj(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function Qj(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var Zj = function(e) {
        L_(a, e);
        var t, r = Qj(a);
        function a(e) {
            var t, n, o, i;
            return Cg(this, a), (i = r.call(this, e)).startSession = Jg(t = i.startSession).call(t, B_(i)), i.submit = Jg(n = i.submit).call(n, B_(i)), i.validateMerchant = Jg(o = i.validateMerchant).call(o, B_(i)), i;
        }
        return wg(a, [
            {
                key: "formatProps",
                value: function(e) {
                    var t, r, a, n, o = e.version || function(e) {
                        for(var t = [], r = e; r > 0; r--)t.push(r);
                        try {
                            return zb(t).call(t, function(e) {
                                return e && window.ApplePaySession && ApplePaySession.supportsVersion(e);
                            });
                        } catch (e) {
                            return console.warn(e), null;
                        }
                    }(14), i = null !== (t = e.brands) && void 0 !== t && t.length ? (a = e.brands, n = {
                        mc: "masterCard",
                        amex: "amex",
                        visa: "visa",
                        elodebit: "elo",
                        elo: "elo",
                        interac: "interac",
                        discover: "discover",
                        jcb: "jcb",
                        electron: "electron",
                        maestro: "maestro",
                        girocard: "girocard",
                        cartebancaire: "cartesBancaires",
                        eftpos_australia: "eftpos"
                    }, tC(a).call(a, function(e, t) {
                        return n[t] && !kb(e).call(e, n[t]) && e.push(n[t]), e;
                    }, [])) : e.supportedNetworks;
                    return Yj(Yj({}, e), {}, {
                        configuration: e.configuration,
                        supportedNetworks: i,
                        version: o,
                        totalPriceLabel: e.totalPriceLabel || (null === (r = e.configuration) || void 0 === r ? void 0 : r.merchantName)
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: Yj({
                            type: a.type
                        }, this.state)
                    };
                }
            },
            {
                key: "submit",
                value: function() {
                    return this.startSession(this.props.onAuthorized);
                }
            },
            {
                key: "startSession",
                value: function(e) {
                    var t = this, r = this.props, n = r.version, o = r.onValidateMerchant, i = r.onPaymentMethodSelected, l = r.onShippingMethodSelected, c = r.onShippingContactSelected, s = Wj(Yj({
                        companyName: this.props.configuration.merchantName
                    }, this.props)), u = new Kj(s, {
                        version: n,
                        onError: function(e) {
                            t.handleError(new mA("ERROR", "ApplePay - Something went wrong on ApplePayService", {
                                cause: e
                            }));
                        },
                        onCancel: function(e) {
                            t.handleError(new mA("CANCEL", "ApplePay UI dismissed", {
                                cause: e
                            }));
                        },
                        onPaymentMethodSelected: i,
                        onShippingMethodSelected: l,
                        onShippingContactSelected: c,
                        onValidateMerchant: o || this.validateMerchant,
                        onPaymentAuthorized: function(r, n, o) {
                            var i;
                            null != o && null !== (i = o.payment) && void 0 !== i && null !== (i = i.token) && void 0 !== i && i.paymentData && t.setState({
                                applePayToken: btoa(Mb(o.payment.token.paymentData))
                            }), GA(U_(a.prototype), "submit", t).call(t), e(r, n, o);
                        }
                    });
                    return new Sb(function(e, r) {
                        return t.props.onClick(e, r);
                    }).then(function() {
                        u.begin();
                    }).catch(function() {
                        return {};
                    });
                }
            },
            {
                key: "validateMerchant",
                value: (t = Jd(Ey.mark(function e(t, r) {
                    var a, n, o, i, l, c, s, u, d, p, m, f, h, v, y;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return n = window.location.hostname, o = this.props, i = o.clientKey, l = o.configuration, c = o.loadingContext, s = o.initiative, u = l.merchantName, d = l.merchantId, p = wb(a = "".concat("v1/applePay/sessions", "?clientKey=")).call(a, i), m = {
                                    loadingContext: c,
                                    path: p
                                }, f = {
                                    displayName: u,
                                    domainName: n,
                                    initiative: s,
                                    merchantIdentifier: d
                                }, e.prev = 6, e.next = 9, cT(m, f);
                            case 9:
                                h = e.sent, (v = FA.decode(h.data)) || r("Could not decode Apple Pay session"), y = JSON.parse(v), t(y), e.next = 19;
                                break;
                            case 16:
                                e.prev = 16, e.t0 = e.catch(6), r("Could not get Apple Pay session");
                            case 19:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            6,
                            16
                        ]
                    ]);
                })), function(e, r) {
                    return t.apply(this, arguments);
                })
            },
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "isAvailable",
                value: function() {
                    if ("https:" !== document.location.protocol) return Sb.reject(new mA("IMPLEMENTATION_ERROR", "Trying to start an Apple Pay session from an insecure document"));
                    if (!this.props.onValidateMerchant && !this.props.clientKey) return Sb.reject(new mA("IMPLEMENTATION_ERROR", "clientKey was not provided"));
                    try {
                        if (window.ApplePaySession && ApplePaySession.canMakePayments() && ApplePaySession.supportsVersion(this.props.version)) return Sb.resolve(!0);
                    } catch (e) {
                        console.warn(e);
                    }
                    return Sb.reject(new mA("ERROR", "Apple Pay is not available on this device"));
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.showPayButton ? rN(Lj, {
                        i18n: this.props.i18n,
                        buttonColor: this.props.buttonColor,
                        buttonType: this.props.buttonType,
                        onClick: function(t) {
                            t.preventDefault(), e.submit();
                        }
                    }) : null;
                }
            }
        ]), a;
    }(gA);
    function Jj(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function $j(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = Jj(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = Jj(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    Sg(Zj, "type", "applepay"), Sg(Zj, "defaultProps", Hj);
    var Xj = {
        labels: Sg({}, WE, "address"),
        schema: [
            WE,
            [
                [
                    JE,
                    70
                ],
                [
                    YE,
                    30
                ]
            ]
        ]
    }, eB = [
        "ID",
        "PH",
        "TH",
        "VN",
        "JP",
        "TW",
        "KR",
        "SG",
        "MY",
        "HK"
    ], tB = tC(rR).call(rR, function(e, t) {
        return $j($j({}, e), {}, Sg({}, t, Xj));
    }, {
        default: Xj
    });
    function rB(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function aB(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = rB(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = rB(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function nB(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var oB = function(e) {
        L_(r, e);
        var t = nB(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return aB(aB({}, GA(U_(r.prototype), "formatProps", this).call(this, aB(aB({}, e), {
                        visibility: {
                            deliveryAddress: "hidden",
                            companyDetails: "hidden"
                        }
                    }))), {}, {
                        allowedCountries: eB,
                        personalDetailsRequiredFields: [
                            "firstName",
                            "lastName",
                            "telephoneNumber"
                        ],
                        billingAddressRequiredFields: [
                            "country",
                            "street",
                            "postalCode"
                        ],
                        billingAddressSpecification: tB
                    });
                }
            }
        ]), r;
    }(QO);
    function iB(e) {
        var t = e.name, r = e.id, a = e.icon, n = e.onClick, o = e.selected, i = void 0 !== o && o;
        return rN("button", {
            type: "button",
            className: aP("adyen-checkout__issuer-button", {
                "adyen-checkout__issuer-button--selected": i
            }),
            "aria-label": t,
            "aria-pressed": i,
            onClick: n,
            value: r
        }, !!a && rN(ST, {
            className: "adyen-checkout__issuer-button-img",
            alt: t,
            src: a
        }), rN("span", {
            className: "adyen-checkout__issuer-button-text"
        }, t));
    }
    Sg(oB, "type", "atome");
    var lB = function(e) {
        var t = e.items, r = void 0 === t ? [] : t, a = e.selectedIssuerId, n = e.onChange, o = zP().i18n, i = kP(function(e) {
            var t = e.currentTarget.value;
            og(e.target, "value", {
                value: t
            }), n(e);
        }, [
            n
        ]);
        return rN("div", {
            className: "adyen-checkout__issuer-button-group",
            role: "group",
            "aria-label": o.get("idealIssuer.selectField.placeholder")
        }, hC(r).call(r, function(e) {
            return rN(iB, j_({
                key: e.id
            }, e, {
                selected: a === e.id,
                onClick: i
            }));
        }));
    };
    function cB(e) {
        var t, r = e.label, a = void 0 === r ? "qrCodeOrApp" : r, n = e.classNames, o = void 0 === n ? [] : n, i = zP().i18n;
        return rN("div", {
            className: aP.apply(void 0, wb(t = [
                "adyen-checkout__content-separator"
            ]).call(t, Uk(o)))
        }, i.get(a));
    }
    var sB, uB = h, dB = 2147483647, pB = /[^\0-\u007E]/, mB = /[.\u3002\uFF0E\uFF61]/g, fB = "Overflow: input needs wider integers to process", hB = RangeError, vB = uB(mB.exec), yB = Math.floor, gB = String.fromCharCode, bB = uB("".charCodeAt), kB = uB([].join), CB = uB([].push), _B = uB("".replace), NB = uB("".split), PB = uB("".toLowerCase), wB = function(e) {
        return e + 22 + 75 * (e < 26);
    }, SB = function(e, t, r) {
        var a = 0;
        for(e = r ? yB(e / 700) : e >> 1, e += yB(e / t); e > 455;)e = yB(e / 35), a += 36;
        return yB(a + 36 * e / (e + 38));
    }, AB = function(e) {
        var t = [];
        e = function(e) {
            for(var t = [], r = 0, a = e.length; r < a;){
                var n = bB(e, r++);
                if (n >= 55296 && n <= 56319 && r < a) {
                    var o = bB(e, r++);
                    56320 == (64512 & o) ? CB(t, ((1023 & n) << 10) + (1023 & o) + 65536) : (CB(t, n), r--);
                } else CB(t, n);
            }
            return t;
        }(e);
        var r, a, n = e.length, o = 128, i = 0, l = 72;
        for(r = 0; r < e.length; r++)(a = e[r]) < 128 && CB(t, gB(a));
        var c = t.length, s = c;
        for(c && CB(t, "-"); s < n;){
            var u = dB;
            for(r = 0; r < e.length; r++)(a = e[r]) >= o && a < u && (u = a);
            var d = s + 1;
            if (u - o > yB((dB - i) / d)) throw new hB(fB);
            for(i += (u - o) * d, o = u, r = 0; r < e.length; r++){
                if ((a = e[r]) < o && ++i > dB) throw new hB(fB);
                if (a === o) {
                    for(var p = i, m = 36;;){
                        var f = m <= l ? 1 : m >= l + 26 ? 26 : m - l;
                        if (p < f) break;
                        var h = p - f, v = 36 - f;
                        CB(t, gB(wB(f + h % v))), p = yB(h / v), m += 36;
                    }
                    CB(t, gB(wB(p))), l = SB(i, d, s === c), i = 0, s++;
                }
            }
            i++, o++;
        }
        return kB(t, "");
    }, IB = Ar, DB = I, EB = KR, RB = a, xB = Qt, FB = h, TB = ui, zB = pl, OB = kl, jB = Je, BB = x_, MB = zk, LB = Mp, VB = Pd.codeAt, UB = function(e) {
        var t, r, a = [], n = NB(_B(PB(e), mB, "."), ".");
        for(t = 0; t < n.length; t++)r = n[t], CB(a, vB(pB, r) ? "xn--" + AB(r) : r);
        return kB(a, ".");
    }, KB = vo, HB = Di, qB = ec, WB = dF, GB = ri, YB = GB.set, QB = GB.getterFor("URL"), ZB = WB.URLSearchParams, JB = WB.getState, $B = RB.URL, XB = RB.TypeError, eM = RB.parseInt, tM = Math.floor, rM = Math.pow, aM = FB("".charAt), nM = FB(/./.exec), oM = FB([].join), iM = FB(1..toString), lM = FB([].pop), cM = FB([].push), sM = FB("".replace), uM = FB([].shift), dM = FB("".split), pM = FB("".slice), mM = FB("".toLowerCase), fM = FB([].unshift), hM = "Invalid scheme", vM = "Invalid host", yM = "Invalid port", gM = /[a-z]/i, bM = /[\d+-.a-z]/i, kM = /\d/, CM = /^0x/i, _M = /^[0-7]+$/, NM = /^\d+$/, PM = /^[\da-f]+$/i, wM = /[\0\t\n\r #%/:<>?@[\\\]^|]/, SM = /[\0\t\n\r #/:<>?@[\\\]^|]/, AM = /^[\u0000-\u0020]+/, IM = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/, DM = /[\t\n\r]/g, EM = function(e) {
        var t, r, a, n;
        if ("number" == typeof e) {
            for(t = [], r = 0; r < 4; r++)fM(t, e % 256), e = tM(e / 256);
            return oM(t, ".");
        }
        if ("object" == typeof e) {
            for(t = "", a = function(e) {
                for(var t = null, r = 1, a = null, n = 0, o = 0; o < 8; o++)0 !== e[o] ? (n > r && (t = a, r = n), a = null, n = 0) : (null === a && (a = o), ++n);
                return n > r && (t = a, r = n), t;
            }(e), r = 0; r < 8; r++)n && 0 === e[r] || (n && (n = !1), a === r ? (t += r ? ":" : "::", n = !0) : (t += iM(e[r], 16), r < 7 && (t += ":")));
            return "[" + t + "]";
        }
        return e;
    }, RM = {}, xM = BB({}, RM, {
        " ": 1,
        '"': 1,
        "<": 1,
        ">": 1,
        "`": 1
    }), FM = BB({}, xM, {
        "#": 1,
        "?": 1,
        "{": 1,
        "}": 1
    }), TM = BB({}, FM, {
        "/": 1,
        ":": 1,
        ";": 1,
        "=": 1,
        "@": 1,
        "[": 1,
        "\\": 1,
        "]": 1,
        "^": 1,
        "|": 1
    }), zM = function(e, t) {
        var r = VB(e, 0);
        return r > 32 && r < 127 && !jB(t, e) ? e : encodeURIComponent(e);
    }, OM = {
        ftp: 21,
        file: null,
        http: 80,
        https: 443,
        ws: 80,
        wss: 443
    }, jM = function(e, t) {
        var r;
        return 2 === e.length && nM(gM, aM(e, 0)) && (":" === (r = aM(e, 1)) || !t && "|" === r);
    }, BM = function(e) {
        var t;
        return e.length > 1 && jM(pM(e, 0, 2)) && (2 === e.length || "/" === (t = aM(e, 2)) || "\\" === t || "?" === t || "#" === t);
    }, MM = function(e) {
        return "." === e || "%2e" === mM(e);
    }, LM = {}, VM = {}, UM = {}, KM = {}, HM = {}, qM = {}, WM = {}, GM = {}, YM = {}, QM = {}, ZM = {}, JM = {}, $M = {}, XM = {}, eL = {}, tL = {}, rL = {}, aL = {}, nL = {}, oL = {}, iL = {}, lL = function(e, t, r) {
        var a, n, o, i = KB(e);
        if (t) {
            if (n = this.parse(i)) throw new XB(n);
            this.searchParams = null;
        } else {
            if (void 0 !== r && (a = new lL(r, !0)), n = this.parse(i, null, a)) throw new XB(n);
            (o = JB(new ZB)).bindURL(this), this.searchParams = o;
        }
    };
    lL.prototype = {
        type: "URL",
        parse: function(e, t, r) {
            var a, n, o, i, l, c = this, s = t || LM, u = 0, d = "", p = !1, m = !1, f = !1;
            for(e = KB(e), t || (c.scheme = "", c.username = "", c.password = "", c.host = null, c.port = null, c.path = [], c.query = null, c.fragment = null, c.cannotBeABaseURL = !1, e = sM(e, AM, ""), e = sM(e, IM, "$1")), e = sM(e, DM, ""), a = MB(e); u <= a.length;){
                switch(n = a[u], s){
                    case LM:
                        if (!n || !nM(gM, n)) {
                            if (t) return hM;
                            s = UM;
                            continue;
                        }
                        d += mM(n), s = VM;
                        break;
                    case VM:
                        if (n && (nM(bM, n) || "+" === n || "-" === n || "." === n)) d += mM(n);
                        else {
                            if (":" !== n) {
                                if (t) return hM;
                                d = "", s = UM, u = 0;
                                continue;
                            }
                            if (t && (c.isSpecial() !== jB(OM, d) || "file" === d && (c.includesCredentials() || null !== c.port) || "file" === c.scheme && !c.host)) return;
                            if (c.scheme = d, t) return void (c.isSpecial() && OM[c.scheme] === c.port && (c.port = null));
                            d = "", "file" === c.scheme ? s = XM : c.isSpecial() && r && r.scheme === c.scheme ? s = KM : c.isSpecial() ? s = GM : "/" === a[u + 1] ? (s = HM, u++) : (c.cannotBeABaseURL = !0, cM(c.path, ""), s = nL);
                        }
                        break;
                    case UM:
                        if (!r || r.cannotBeABaseURL && "#" !== n) return hM;
                        if (r.cannotBeABaseURL && "#" === n) {
                            c.scheme = r.scheme, c.path = LB(r.path), c.query = r.query, c.fragment = "", c.cannotBeABaseURL = !0, s = iL;
                            break;
                        }
                        s = "file" === r.scheme ? XM : qM;
                        continue;
                    case KM:
                        if ("/" !== n || "/" !== a[u + 1]) {
                            s = qM;
                            continue;
                        }
                        s = YM, u++;
                        break;
                    case HM:
                        if ("/" === n) {
                            s = QM;
                            break;
                        }
                        s = aL;
                        continue;
                    case qM:
                        if (c.scheme = r.scheme, n === sB) c.username = r.username, c.password = r.password, c.host = r.host, c.port = r.port, c.path = LB(r.path), c.query = r.query;
                        else if ("/" === n || "\\" === n && c.isSpecial()) s = WM;
                        else if ("?" === n) c.username = r.username, c.password = r.password, c.host = r.host, c.port = r.port, c.path = LB(r.path), c.query = "", s = oL;
                        else {
                            if ("#" !== n) {
                                c.username = r.username, c.password = r.password, c.host = r.host, c.port = r.port, c.path = LB(r.path), c.path.length--, s = aL;
                                continue;
                            }
                            c.username = r.username, c.password = r.password, c.host = r.host, c.port = r.port, c.path = LB(r.path), c.query = r.query, c.fragment = "", s = iL;
                        }
                        break;
                    case WM:
                        if (!c.isSpecial() || "/" !== n && "\\" !== n) {
                            if ("/" !== n) {
                                c.username = r.username, c.password = r.password, c.host = r.host, c.port = r.port, s = aL;
                                continue;
                            }
                            s = QM;
                        } else s = YM;
                        break;
                    case GM:
                        if (s = YM, "/" !== n || "/" !== aM(d, u + 1)) continue;
                        u++;
                        break;
                    case YM:
                        if ("/" !== n && "\\" !== n) {
                            s = QM;
                            continue;
                        }
                        break;
                    case QM:
                        if ("@" === n) {
                            p && (d = "%40" + d), p = !0, o = MB(d);
                            for(var h = 0; h < o.length; h++){
                                var v = o[h];
                                if (":" !== v || f) {
                                    var y = zM(v, TM);
                                    f ? c.password += y : c.username += y;
                                } else f = !0;
                            }
                            d = "";
                        } else if (n === sB || "/" === n || "?" === n || "#" === n || "\\" === n && c.isSpecial()) {
                            if (p && "" === d) return "Invalid authority";
                            u -= MB(d).length + 1, d = "", s = ZM;
                        } else d += n;
                        break;
                    case ZM:
                    case JM:
                        if (t && "file" === c.scheme) {
                            s = tL;
                            continue;
                        }
                        if (":" !== n || m) {
                            if (n === sB || "/" === n || "?" === n || "#" === n || "\\" === n && c.isSpecial()) {
                                if (c.isSpecial() && "" === d) return vM;
                                if (t && "" === d && (c.includesCredentials() || null !== c.port)) return;
                                if (i = c.parseHost(d)) return i;
                                if (d = "", s = rL, t) return;
                                continue;
                            }
                            "[" === n ? m = !0 : "]" === n && (m = !1), d += n;
                        } else {
                            if ("" === d) return vM;
                            if (i = c.parseHost(d)) return i;
                            if (d = "", s = $M, t === JM) return;
                        }
                        break;
                    case $M:
                        if (!nM(kM, n)) {
                            if (n === sB || "/" === n || "?" === n || "#" === n || "\\" === n && c.isSpecial() || t) {
                                if ("" !== d) {
                                    var g = eM(d, 10);
                                    if (g > 65535) return yM;
                                    c.port = c.isSpecial() && g === OM[c.scheme] ? null : g, d = "";
                                }
                                if (t) return;
                                s = rL;
                                continue;
                            }
                            return yM;
                        }
                        d += n;
                        break;
                    case XM:
                        if (c.scheme = "file", "/" === n || "\\" === n) s = eL;
                        else {
                            if (!r || "file" !== r.scheme) {
                                s = aL;
                                continue;
                            }
                            switch(n){
                                case sB:
                                    c.host = r.host, c.path = LB(r.path), c.query = r.query;
                                    break;
                                case "?":
                                    c.host = r.host, c.path = LB(r.path), c.query = "", s = oL;
                                    break;
                                case "#":
                                    c.host = r.host, c.path = LB(r.path), c.query = r.query, c.fragment = "", s = iL;
                                    break;
                                default:
                                    BM(oM(LB(a, u), "")) || (c.host = r.host, c.path = LB(r.path), c.shortenPath()), s = aL;
                                    continue;
                            }
                        }
                        break;
                    case eL:
                        if ("/" === n || "\\" === n) {
                            s = tL;
                            break;
                        }
                        r && "file" === r.scheme && !BM(oM(LB(a, u), "")) && (jM(r.path[0], !0) ? cM(c.path, r.path[0]) : c.host = r.host), s = aL;
                        continue;
                    case tL:
                        if (n === sB || "/" === n || "\\" === n || "?" === n || "#" === n) {
                            if (!t && jM(d)) s = aL;
                            else if ("" === d) {
                                if (c.host = "", t) return;
                                s = rL;
                            } else {
                                if (i = c.parseHost(d)) return i;
                                if ("localhost" === c.host && (c.host = ""), t) return;
                                d = "", s = rL;
                            }
                            continue;
                        }
                        d += n;
                        break;
                    case rL:
                        if (c.isSpecial()) {
                            if (s = aL, "/" !== n && "\\" !== n) continue;
                        } else if (t || "?" !== n) {
                            if (t || "#" !== n) {
                                if (n !== sB && (s = aL, "/" !== n)) continue;
                            } else c.fragment = "", s = iL;
                        } else c.query = "", s = oL;
                        break;
                    case aL:
                        if (n === sB || "/" === n || "\\" === n && c.isSpecial() || !t && ("?" === n || "#" === n)) {
                            if (".." === (l = mM(l = d)) || "%2e." === l || ".%2e" === l || "%2e%2e" === l ? (c.shortenPath(), "/" === n || "\\" === n && c.isSpecial() || cM(c.path, "")) : MM(d) ? "/" === n || "\\" === n && c.isSpecial() || cM(c.path, "") : ("file" === c.scheme && !c.path.length && jM(d) && (c.host && (c.host = ""), d = aM(d, 0) + ":"), cM(c.path, d)), d = "", "file" === c.scheme && (n === sB || "?" === n || "#" === n)) for(; c.path.length > 1 && "" === c.path[0];)uM(c.path);
                            "?" === n ? (c.query = "", s = oL) : "#" === n && (c.fragment = "", s = iL);
                        } else d += zM(n, FM);
                        break;
                    case nL:
                        "?" === n ? (c.query = "", s = oL) : "#" === n ? (c.fragment = "", s = iL) : n !== sB && (c.path[0] += zM(n, RM));
                        break;
                    case oL:
                        t || "#" !== n ? n !== sB && ("'" === n && c.isSpecial() ? c.query += "%27" : c.query += "#" === n ? "%23" : zM(n, RM)) : (c.fragment = "", s = iL);
                        break;
                    case iL:
                        n !== sB && (c.fragment += zM(n, xM));
                }
                u++;
            }
        },
        parseHost: function(e) {
            var t, r, a;
            if ("[" === aM(e, 0)) {
                if ("]" !== aM(e, e.length - 1)) return vM;
                if (t = function(e) {
                    var t, r, a, n, o, i, l, c = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], s = 0, u = null, d = 0, p = function() {
                        return aM(e, d);
                    };
                    if (":" === p()) {
                        if (":" !== aM(e, 1)) return;
                        d += 2, u = ++s;
                    }
                    for(; p();){
                        if (8 === s) return;
                        if (":" !== p()) {
                            for(t = r = 0; r < 4 && nM(PM, p());)t = 16 * t + eM(p(), 16), d++, r++;
                            if ("." === p()) {
                                if (0 === r) return;
                                if (d -= r, s > 6) return;
                                for(a = 0; p();){
                                    if (n = null, a > 0) {
                                        if (!("." === p() && a < 4)) return;
                                        d++;
                                    }
                                    if (!nM(kM, p())) return;
                                    for(; nM(kM, p());){
                                        if (o = eM(p(), 10), null === n) n = o;
                                        else {
                                            if (0 === n) return;
                                            n = 10 * n + o;
                                        }
                                        if (n > 255) return;
                                        d++;
                                    }
                                    c[s] = 256 * c[s] + n, 2 != ++a && 4 !== a || s++;
                                }
                                if (4 !== a) return;
                                break;
                            }
                            if (":" === p()) {
                                if (d++, !p()) return;
                            } else if (p()) return;
                            c[s++] = t;
                        } else {
                            if (null !== u) return;
                            d++, u = ++s;
                        }
                    }
                    if (null !== u) for(i = s - u, s = 7; 0 !== s && i > 0;)l = c[s], c[s--] = c[u + i - 1], c[u + --i] = l;
                    else if (8 !== s) return;
                    return c;
                }(pM(e, 1, -1)), !t) return vM;
                this.host = t;
            } else if (this.isSpecial()) {
                if (e = UB(e), nM(wM, e)) return vM;
                if (t = function(e) {
                    var t, r, a, n, o, i, l, c = dM(e, ".");
                    if (c.length && "" === c[c.length - 1] && c.length--, (t = c.length) > 4) return e;
                    for(r = [], a = 0; a < t; a++){
                        if ("" === (n = c[a])) return e;
                        if (o = 10, n.length > 1 && "0" === aM(n, 0) && (o = nM(CM, n) ? 16 : 8, n = pM(n, 8 === o ? 1 : 2)), "" === n) i = 0;
                        else {
                            if (!nM(10 === o ? NM : 8 === o ? _M : PM, n)) return e;
                            i = eM(n, o);
                        }
                        cM(r, i);
                    }
                    for(a = 0; a < t; a++)if (i = r[a], a === t - 1) {
                        if (i >= rM(256, 5 - t)) return null;
                    } else if (i > 255) return null;
                    for(l = lM(r), a = 0; a < r.length; a++)l += r[a] * rM(256, 3 - a);
                    return l;
                }(e), null === t) return vM;
                this.host = t;
            } else {
                if (nM(SM, e)) return vM;
                for(t = "", r = MB(e), a = 0; a < r.length; a++)t += zM(r[a], RM);
                this.host = t;
            }
        },
        cannotHaveUsernamePasswordPort: function() {
            return !this.host || this.cannotBeABaseURL || "file" === this.scheme;
        },
        includesCredentials: function() {
            return "" !== this.username || "" !== this.password;
        },
        isSpecial: function() {
            return jB(OM, this.scheme);
        },
        shortenPath: function() {
            var e = this.path, t = e.length;
            !t || "file" === this.scheme && 1 === t && jM(e[0], !0) || e.length--;
        },
        serialize: function() {
            var e = this, t = e.scheme, r = e.username, a = e.password, n = e.host, o = e.port, i = e.path, l = e.query, c = e.fragment, s = t + ":";
            return null !== n ? (s += "//", e.includesCredentials() && (s += r + (a ? ":" + a : "") + "@"), s += EM(n), null !== o && (s += ":" + o)) : "file" === t && (s += "//"), s += e.cannotBeABaseURL ? i[0] : i.length ? "/" + oM(i, "/") : "", null !== l && (s += "?" + l), null !== c && (s += "#" + c), s;
        },
        setHref: function(e) {
            var t = this.parse(e);
            if (t) throw new XB(t);
            this.searchParams.update();
        },
        getOrigin: function() {
            var e = this.scheme, t = this.port;
            if ("blob" === e) try {
                return new cL(e.path[0]).origin;
            } catch (e) {
                return "null";
            }
            return "file" !== e && this.isSpecial() ? e + "://" + EM(this.host) + (null !== t ? ":" + t : "") : "null";
        },
        getProtocol: function() {
            return this.scheme + ":";
        },
        setProtocol: function(e) {
            this.parse(KB(e) + ":", LM);
        },
        getUsername: function() {
            return this.username;
        },
        setUsername: function(e) {
            var t = MB(KB(e));
            if (!this.cannotHaveUsernamePasswordPort()) {
                this.username = "";
                for(var r = 0; r < t.length; r++)this.username += zM(t[r], TM);
            }
        },
        getPassword: function() {
            return this.password;
        },
        setPassword: function(e) {
            var t = MB(KB(e));
            if (!this.cannotHaveUsernamePasswordPort()) {
                this.password = "";
                for(var r = 0; r < t.length; r++)this.password += zM(t[r], TM);
            }
        },
        getHost: function() {
            var e = this.host, t = this.port;
            return null === e ? "" : null === t ? EM(e) : EM(e) + ":" + t;
        },
        setHost: function(e) {
            this.cannotBeABaseURL || this.parse(e, ZM);
        },
        getHostname: function() {
            var e = this.host;
            return null === e ? "" : EM(e);
        },
        setHostname: function(e) {
            this.cannotBeABaseURL || this.parse(e, JM);
        },
        getPort: function() {
            var e = this.port;
            return null === e ? "" : KB(e);
        },
        setPort: function(e) {
            this.cannotHaveUsernamePasswordPort() || ("" === (e = KB(e)) ? this.port = null : this.parse(e, $M));
        },
        getPathname: function() {
            var e = this.path;
            return this.cannotBeABaseURL ? e[0] : e.length ? "/" + oM(e, "/") : "";
        },
        setPathname: function(e) {
            this.cannotBeABaseURL || (this.path = [], this.parse(e, rL));
        },
        getSearch: function() {
            var e = this.query;
            return e ? "?" + e : "";
        },
        setSearch: function(e) {
            "" === (e = KB(e)) ? this.query = null : ("?" === aM(e, 0) && (e = pM(e, 1)), this.query = "", this.parse(e, oL)), this.searchParams.update();
        },
        getSearchParams: function() {
            return this.searchParams.facade;
        },
        getHash: function() {
            var e = this.fragment;
            return e ? "#" + e : "";
        },
        setHash: function(e) {
            "" !== (e = KB(e)) ? ("#" === aM(e, 0) && (e = pM(e, 1)), this.fragment = "", this.parse(e, iL)) : this.fragment = null;
        },
        update: function() {
            this.query = this.searchParams.serialize() || null;
        }
    };
    var cL = function(e) {
        var t = OB(this, sL), r = qB(arguments.length, 1) > 1 ? arguments[1] : void 0, a = YB(t, new lL(e, !1, r));
        DB || (t.href = a.serialize(), t.origin = a.getOrigin(), t.protocol = a.getProtocol(), t.username = a.getUsername(), t.password = a.getPassword(), t.host = a.getHost(), t.hostname = a.getHostname(), t.port = a.getPort(), t.pathname = a.getPathname(), t.search = a.getSearch(), t.searchParams = a.getSearchParams(), t.hash = a.getHash());
    }, sL = cL.prototype, uL = function(e, t) {
        return {
            get: function() {
                return QB(this)[e]();
            },
            set: t && function(e) {
                return QB(this)[t](e);
            },
            configurable: !0,
            enumerable: !0
        };
    };
    if (DB && (zB(sL, "href", uL("serialize", "setHref")), zB(sL, "origin", uL("getOrigin")), zB(sL, "protocol", uL("getProtocol", "setProtocol")), zB(sL, "username", uL("getUsername", "setUsername")), zB(sL, "password", uL("getPassword", "setPassword")), zB(sL, "host", uL("getHost", "setHost")), zB(sL, "hostname", uL("getHostname", "setHostname")), zB(sL, "port", uL("getPort", "setPort")), zB(sL, "pathname", uL("getPathname", "setPathname")), zB(sL, "search", uL("getSearch", "setSearch")), zB(sL, "searchParams", uL("getSearchParams")), zB(sL, "hash", uL("getHash", "setHash"))), TB(sL, "toJSON", function() {
        return QB(this).serialize();
    }, {
        enumerable: !0
    }), TB(sL, "toString", function() {
        return QB(this).serialize();
    }, {
        enumerable: !0
    }), $B) {
        var dL = $B.createObjectURL, pL = $B.revokeObjectURL;
        dL && TB(cL, "createObjectURL", xB(dL, $B)), pL && TB(cL, "revokeObjectURL", xB(pL, $B));
    }
    HB(cL, "URL"), IB({
        global: !0,
        constructor: !0,
        forced: !EB,
        sham: !DB
    }, {
        URL: cL
    });
    var mL = Ar, fL = n, hL = ec, vL = vo, yL = KR, gL = oe("URL");
    mL({
        target: "URL",
        stat: !0,
        forced: !(yL && fL(function() {
            gL.canParse();
        }))
    }, {
        canParse: function(e) {
            var t = hL(arguments.length, 1), r = vL(e), a = t < 2 || void 0 === arguments[1] ? void 0 : vL(arguments[1]);
            try {
                return new gL(r, a), true;
            } catch (e) {
                return !1;
            }
        }
    });
    var bL = t(ee.URL), kL = function(e) {
        var t, r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        try {
            t = new bL(e);
        } catch (e) {
            return !1;
        }
        return r && "http:" === t.protocol || "https:" === t.protocol;
    };
    function CL(e) {
        var t = e.message, r = e.urls, a = "string" == typeof t, n = XA(r).call(r, function(e) {
            return "string" == typeof e && kL(e);
        });
        return a && n ? function(e, t) {
            return rN("span", {
                className: "adyen-checkout-disclaimer__label"
            }, IC(e, hC(t).call(t, function(e) {
                return function(t) {
                    return rN("a", {
                        className: "adyen-checkout__link",
                        href: e,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, t);
                };
            })));
        }(t, r) : null;
    }
    var _L = [
        "items",
        "placeholder",
        "issuer",
        "highlightedIds"
    ];
    function NL(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var PL = function(e, t) {
        var r, a, n = e.issuer, o = e.items, i = null === (r = zb(o).call(o, function(e) {
            return e.id === n;
        })) || void 0 === r ? void 0 : r.name;
        return n && i ? wb(a = "".concat(t.get("continueTo"), " ")).call(a, i) : t.get("continue");
    }, wL = [
        "issuer"
    ], SL = {
        issuer: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "idealIssuer.selectField.placeholder",
            modes: [
                "blur"
            ]
        }
    }, AL = function(e) {
        return e[e.ButtonGroup = 0] = "ButtonGroup", e[e.Dropdown = 1] = "Dropdown", e;
    }(AL || {});
    function IL(e) {
        var t, r = e.items, a = e.placeholder, n = void 0 === a ? "idealIssuer.selectField.placeholder" : a, o = e.issuer, i = e.highlightedIds, l = void 0 === i ? [] : i, c = kg(e, _L), s = zP().i18n, u = QD({
            schema: wL,
            defaultData: {
                issuer: o
            },
            rules: SL
        }), d = u.handleChangeFor, p = u.triggerValidation, m = u.data, f = u.valid, h = u.errors, v = u.isValid, y = Vk(fP("ready"), 2), g = y[0], b = y[1], k = Vk(fP(AL.Dropdown), 2), C = k[0], _ = k[1], N = bO(), P = N.setSRMessagesFromObjects, w = N.shouldMoveFocusSR, S = null == P ? void 0 : P({});
        this.setStatus = function(e) {
            b(e);
        };
        var A = kP(function(e) {
            return function(t) {
                _(e), d("issuer")(t);
            };
        }, [
            d
        ]);
        vP(function() {
            c.onChange({
                data: m,
                valid: f,
                errors: h,
                isValid: v
            });
            var e = null == S ? void 0 : S({
                errors: h,
                isValidating: !0
            });
            (null == e ? void 0 : e.action) === QI && w && wO(".adyen-checkout__issuer-list", e.fieldToFocus);
        }, [
            m,
            f,
            h,
            v
        ]), this.showValidation = function() {
            p();
        };
        var I = tC(r).call(r, function(e, t) {
            return kb(l).call(l, t.id) && e.highlightedItems.push(function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r, a, n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Ag(r = NL(Object(n), !0)).call(r, function(t) {
                        Sg(e, t, n[t]);
                    }) : Jy ? ng(e, Jy(n)) : Ag(a = NL(Object(n))).call(a, function(t) {
                        og(e, t, Wy(n, t));
                    });
                }
                return e;
            }({}, t)), e;
        }, {
            highlightedItems: []
        }), D = I.highlightedItems;
        return rN("div", {
            className: "adyen-checkout__issuer-list"
        }, !!D.length && rN(nN, null, rN(lB, {
            selectedIssuerId: C === AL.ButtonGroup ? m.issuer : null,
            items: D,
            onChange: A(AL.ButtonGroup)
        }), rN(cB, null)), rN(oD, {
            errorMessage: function(e) {
                return e && e.errorMessage ? s.get(e.errorMessage) : !!e;
            }(h.issuer),
            classNameModifiers: [
                "issuer-list"
            ],
            name: "issuer"
        }, rN(OT, {
            items: r,
            selectedValue: C === AL.Dropdown ? m.issuer : null,
            placeholder: s.get(n),
            name: "issuer",
            className: "adyen-checkout__issuer-list__dropdown",
            onChange: A(AL.Dropdown)
        })), c.termsAndConditions && rN("div", {
            className: "adyen-checkout__issuer-list__termsAndConditions"
        }, rN(CL, {
            message: s.get(c.termsAndConditions.translationKey),
            urls: c.termsAndConditions.urls
        })), c.showPayButton && c.payButton({
            status: g,
            label: PL({
                issuer: m.issuer,
                items: wb(t = []).call(t, Uk(r), Uk(D))
            }, s)
        }));
    }
    function DL(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    IL.defaultProps = {
        onChange: function() {}
    };
    var EL = function(e, t, r) {
        return function(a) {
            if (!a) return null;
            var n = function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r, a, n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Ag(r = DL(Object(n), !0)).call(r, function(t) {
                        Sg(e, t, n[t]);
                    }) : Jy ? ng(e, Jy(n)) : Ag(a = DL(Object(n))).call(a, function(t) {
                        og(e, t, Wy(n, t));
                    });
                }
                return e;
            }({
                parentFolder: a ? "".concat(t, "/") : "",
                type: a || t
            }, e);
            return r(n)(a);
        };
    }, RL = [
        "label",
        "icon",
        "payButton",
        "onSubmit",
        "amount",
        "name"
    ];
    function xL(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function FL(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = xL(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = xL(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function TL(e) {
        var t = e.label, r = void 0 === t ? null : t, a = e.icon, n = void 0 === a ? null : a, o = e.payButton, i = e.onSubmit, l = e.amount, c = void 0 === l ? null : l, s = e.name, u = kg(e, RL), d = zP().i18n, p = Vk(fP("ready"), 2), m = p[0], f = p[1];
        this.setStatus = function(e) {
            f(e);
        };
        return rN(nN, null, o(FL(FL({}, u), {}, {
            status: m,
            icon: n,
            classNameModifiers: [
                "standalone"
            ],
            label: r || function() {
                var e, t;
                return c && ({}).hasOwnProperty.call(c, "value") && 0 === c.value ? wb(e = "".concat(d.get("preauthorizeWith"), " ")).call(e, s) : wb(t = "".concat(d.get("continueTo"), " ")).call(t, s);
            }(),
            onClick: i
        })));
    }
    function zL(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function OL(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = zL(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = zL(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function jL(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var BL = function(e) {
        L_(r, e);
        var t = jL(r);
        function r(e) {
            var a;
            Cg(this, r);
            if ((a = t.call(this, e)).props.showImage) {
                var n, o = EL({
                    loadingContext: a.props.loadingContext
                }, a.constructor.type, function(e) {
                    return a.resources.getImage(e);
                });
                a.props.issuers = hC(n = a.props.issuers).call(n, function(e) {
                    return OL(OL({}, e), {}, {
                        icon: o(e.id)
                    });
                });
            }
            return a;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t, r = e.details && e.details.length && (zb(t = e.details).call(t, function(e) {
                        return "issuer" === e.key;
                    }) || {}).items || e.issuers || [];
                    return OL(OL({}, e), {}, {
                        issuers: r
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e;
                    return {
                        paymentMethod: {
                            type: this.constructor.type,
                            issuer: null === (e = this.state) || void 0 === e || null === (e = e.data) || void 0 === e ? void 0 : e.issuer
                        }
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    var e;
                    return 0 === this.props.issuers.length || !(null === (e = this.state) || void 0 === e || !e.isValid);
                }
            },
            {
                key: "brands",
                get: function() {
                    var e;
                    return this.props.showPaymentMethodItemImages ? hC(e = this.props.issuers).call(e, function(e) {
                        return {
                            icon: e.icon,
                            name: e.id
                        };
                    }) : [];
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.issuers.length > 0 ? rN(qO, {
                        srPanel: this.props.modules.srPanel
                    }, rN(IL, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        items: this.props.issuers,
                        highlightedIds: this.props.highlightedIssuers
                    }, this.props, this.state, {
                        showImage: this.props.showImage,
                        type: this.constructor.type,
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    }))) : this.props.showPayButton && rN(TL, j_({
                        name: this.props.name
                    }, this.props, {
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    })));
                }
            }
        ]), r;
    }(gA);
    function ML(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function LL(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = ML(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = ML(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function VL(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(BL, "defaultProps", {
        showImage: !0,
        onValid: function() {},
        issuers: [],
        highlightedIssuers: [],
        loadingContext: eT,
        showPaymentMethodItemImages: !1,
        showPayButton: !0
    });
    var UL = function(e) {
        L_(r, e);
        var t = VL(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return LL(LL({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1
                    });
                }
            }
        ]), r;
    }(BL);
    function KL(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function HL(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = KL(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = KL(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function qL(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(UL, "type", "billdesk_online");
    var WL = function(e) {
        L_(r, e);
        var t = qL(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return HL(HL({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1,
                        placeholder: "issuerList.wallet.placeholder"
                    });
                }
            }
        ]), r;
    }(BL);
    Sg(WL, "type", "billdesk_wallet");
    var GL, YL, QL, ZL, JL = function(e, t) {
        return t === oI ? (e[iI] = !1, e[lI] = !1) : e[t] = !1, e;
    }, $L = function(e, t) {
        return function(r, a) {
            var n = !0 !== t.valid[a] ? function(e, t) {
                return 1 !== t || e !== iI && e !== lI ? e : oI;
            }(a, e) : null;
            return n = function(e, t, r) {
                var a = tC(r).call(r, function(r, a) {
                    return r.isFieldOfType || (r.isFieldOfType = e === a, r.fieldIsValid = !t.errors[a]), r;
                }, {
                    isFieldOfType: !1,
                    fieldIsValid: !1
                }), n = a.isFieldOfType, o = a.fieldIsValid, i = e === cI ? "cvcPolicy" : "expiryDatePolicy", l = "cvcPolicy" === i ? wI : II, c = "cvcPolicy" === i ? SI : DI;
                return (t[i] === l || t[i] === c) && o && n ? null : e;
            }(n, t, [
                cI,
                oI,
                iI,
                lI
            ]), n && !kb(r).call(r, n) && r.push(n), r;
        };
    }, XL = wg(function e(t) {
        Cg(this, e), Sg(this, "callbacks", void 0), Sg(this, "config", void 0), Sg(this, "props", void 0), Sg(this, "state", void 0), Sg(this, "validateForm", void 0), Sg(this, "handleBrandFromBinLookup", void 0), Sg(this, "callbacksHandler", void 0), Sg(this, "configHandler", void 0), Sg(this, "createCardSecuredFields", void 0), Sg(this, "createNonCardSecuredFields", void 0), Sg(this, "createSecuredFields", void 0), Sg(this, "destroySecuredFields", void 0), Sg(this, "handleIOSTouchEvents", void 0), Sg(this, "destroyTouchendListener", void 0), Sg(this, "destroyTouchstartListener", void 0), Sg(this, "handleBinValue", void 0), Sg(this, "handleEncryption", void 0), Sg(this, "handleFocus", void 0), Sg(this, "handleIframeConfigFeedback", void 0), Sg(this, "handleValidation", void 0), Sg(this, "handleSFShiftTab", void 0), Sg(this, "handleShiftTab", void 0), Sg(this, "isConfigured", void 0), Sg(this, "postMessageToAllIframes", void 0), Sg(this, "processAutoComplete", void 0), Sg(this, "processBrand", void 0), Sg(this, "sendBrandToCardSF", void 0), Sg(this, "sendExpiryDatePolicyToSF", void 0), Sg(this, "setFocusOnFrame", void 0), Sg(this, "setupSecuredField", void 0), Sg(this, "touchendListener", void 0), Sg(this, "touchstartListener", void 0), Sg(this, "hasGenuineTouchEvents", void 0), Sg(this, "encryptedAttrName", void 0), Sg(this, "hasRedundantCVCField", void 0), Sg(this, "isSingleBrandedCard", void 0), Sg(this, "securityCode", void 0), this.props = t, this.state = {}, this.config = {}, this.callbacks = {};
    }), eV = "undefined" != typeof window && window.console && window.console.error && Jg(GL = window.console.error).call(GL, window.console);
    "undefined" != typeof window && window.console && window.console.info && Jg(YL = window.console.info).call(YL, window.console);
    var tV = "undefined" != typeof window && window.console && window.console.log && Jg(QL = window.console.log).call(QL, window.console), rV = "undefined" != typeof window && window.console && window.console.warn && Jg(ZL = window.console.warn).call(ZL, window.console);
    function aV(e) {
        var t, r, a, n, o, i;
        this.config.cardGroupTypes = BO(i = e.cardGroupTypes) && i.length ? i : hI;
        var l = e.loadingContext;
        if (l) {
            var c;
            this.config.loadingContext = "/" === (c = l).charAt(c.length - 1) ? l : "".concat(l, "/"), this.config.isCreditCardType = !1 === kb(vI).call(vI, e.type), this.config.iframeUIConfig = e.iframeUIConfig, this.config.allowedDOMAccess = !(!1 === e.allowedDOMAccess || "false" === e.allowedDOMAccess), this.config.autoFocus = !(!1 === e.autoFocus || "false" === e.autoFocus), this.config.showWarnings = !0 === e.showWarnings || "true" === e.showWarnings, this.config.trimTrailingSeparator = !(!1 === e.trimTrailingSeparator || "false" === e.trimTrailingSeparator), this.config.keypadFix = !(!1 === e.keypadFix || "false" === e.keypadFix), this.config.legacyInputMode = e.legacyInputMode || null, this.config.minimumExpiryDate = e.minimumExpiryDate || null, this.config.implementationType = e.implementationType, this.config.sfLogAtStart = !0 === window._b$dl;
            var s = this.config.isCreditCardType ? "card" : e.type;
            Kk(s).call(s, "sepa") > -1 && (s = "iban");
            var u = btoa(window.location.origin), d = !!e.forceCompat || !("function" == typeof window.TextEncoder), p = wb(t = "".concat(s)).call(t, d ? "Compat" : "");
            this.config.iframeSrc = wb(r = wb(a = wb(n = wb(o = "".concat(this.config.loadingContext, "securedfields/")).call(o, e.clientKey, "/")).call(n, "4.8.0", "/securedFields.html?type=")).call(a, p, "&d=")).call(r, u), this.config.maskSecurityCode = e.maskSecurityCode, this.config.shouldDisableIOSArrowKeys = e.shouldDisableIOSArrowKeys;
        } else rV("WARNING Config :: no loadingContext has been specified!");
    }
    var nV = function() {};
    function oV() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        this.callbacks.onLoad = e.onLoad ? e.onLoad : nV, this.callbacks.onConfigSuccess = e.onConfigSuccess ? e.onConfigSuccess : nV, this.callbacks.onFieldValid = e.onFieldValid ? e.onFieldValid : nV, this.callbacks.onAllValid = e.onAllValid ? e.onAllValid : nV, this.callbacks.onBrand = e.onBrand ? e.onBrand : nV, this.callbacks.onError = e.onError ? e.onError : nV, this.callbacks.onFocus = e.onFocus ? e.onFocus : nV, this.callbacks.onBinValue = e.onBinValue ? e.onBinValue : nV, this.callbacks.onAutoComplete = e.onAutoComplete ? e.onAutoComplete : nV, this.callbacks.onAdditionalSFConfig = e.onAdditionalSFConfig ? e.onAdditionalSFConfig : nV, this.callbacks.onAdditionalSFRemoved = e.onAdditionalSFRemoved ? e.onAdditionalSFRemoved : nV, this.callbacks.onTouchstartIOS = e.onTouchstartIOS ? e.onTouchstartIOS : nV;
    }
    var iV = function(e) {
        return {
            fieldType: e.fieldType,
            encryptedFieldName: e.encryptedFieldName,
            uid: e.uuid,
            valid: e.isValid,
            type: e.txVariant,
            rootNode: e.rootNode
        };
    }, lV = function(e, t, r, a, n) {
        if (!fA(e, "error")) return null;
        var o = t, i = {
            rootNode: a,
            fieldType: e.fieldType,
            error: null,
            type: null
        }, l = "" !== e.error;
        return l || o.hasError ? o.errorType === WI[jI] ? null : (i.error = l ? e.error : "", i.type = r, o.hasError = l, o.errorType = i.error, n(i), i) : null;
    };
    function cV(e) {
        var t, r, a, n, o = e.fieldType;
        if ("card" === this.state.type && fA(e, "cvcPolicy") && MO(e.cvcPolicy) && fA(this.state.securedFields, cI) && (this.state.securedFields[cI].cvcPolicy = e.cvcPolicy), lV(e, this.state.securedFields[o], this.state.type, this.props.rootNode, this.callbacks.onError), this.state.securedFields[o].isEncrypted) {
            t = function(e) {
                var t, r, a, n = e.fieldType, o = e.txVariant, i = e.rootNode, l = n === oI, c = [], s = [
                    "encryptedExpiryMonth",
                    "encryptedExpiryYear"
                ], u = l ? 2 : 1;
                for(t = 0; t < u; t += 1){
                    var d;
                    a = l ? s[t] : n, r = wb(d = "".concat(o, "-encrypted-")).call(d, a);
                    var p = iV({
                        fieldType: n,
                        encryptedFieldName: l ? a : n,
                        uuid: r,
                        isValid: !1,
                        txVariant: o,
                        rootNode: i
                    });
                    c.push(p);
                }
                return c;
            }({
                fieldType: o,
                txVariant: this.state.type,
                rootNode: this.props.rootNode
            }), o === nI && (t[0].endDigits = "");
            for(var i = 0, l = t.length; i < l; i += 1)this.config.allowedDOMAccess && (r = this.props.rootNode, a = t[i].uid, n = void 0, (n = CO(r, "#".concat(a))) && r.removeChild(n)), this.callbacks.onFieldValid(t[i]);
            this.state.securedFields[o].isEncrypted = !1;
        }
        this.validateForm(), fA(e, "brand") && this.processBrand(e);
    }
    var sV, uV = function(e, t, r) {
        if (t) {
            var a = Mb(e);
            t.postMessage(a, r);
        }
    };
    function dV(e, t) {
        var r;
        return (null === (r = e.securedFields[t]) || void 0 === r ? void 0 : r.iframeContentWindow) || null;
    }
    function pV(e) {
        var t, r, a = e.fieldType;
        this.config.autoFocus && ("year" !== e.type && a !== lI || this.setFocusOnFrame(cI), a === iI && this.setFocusOnFrame(lI));
        var n = e[a];
        this.state.securedFields[a].isEncrypted = !0, this.config.allowedDOMAccess && function(e, t, r) {
            var a, n, o, i, l, c, s, u;
            for(a = 0; a < e.length; a += 1){
                var d, p = e[a];
                o = p.encryptedFieldName, n = wb(d = "".concat(t, "-encrypted-")).call(d, o), l = o, c = p.blob, u = void 0, (u = CO(i = r, "#".concat(s = n))) || ((u = document.createElement("input")).type = "hidden", u.name = l, u.id = s, i.appendChild(u)), u.setAttribute("value", c);
            }
        }(n, this.state.type, this.props.rootNode), lV({
            error: "",
            fieldType: a
        }, this.state.securedFields[a], this.state.type, this.props.rootNode, this.callbacks.onError);
        var o = function(e) {
            var t, r, a, n, o, i = e.fieldType, l = e.txVariant, c = e.rootNode, s = e.encryptedObjArr, u = [];
            for(t = 0; t < s.length; t += 1){
                var d;
                n = (a = s[t]).encryptedFieldName, r = wb(d = "".concat(l, "-encrypted-")).call(d, n), o = a.blob;
                var p = iV({
                    fieldType: i,
                    encryptedFieldName: n,
                    uuid: r,
                    isValid: !0,
                    txVariant: l,
                    rootNode: c
                });
                p.blob = o, u.push(p);
            }
            return u;
        }({
            fieldType: a,
            txVariant: this.state.type,
            rootNode: this.props.rootNode,
            encryptedObjArr: n
        });
        if (a === iI && fA(this.state.securedFields, lI)) {
            var i = {
                txVariant: this.state.type,
                code: e.code,
                blob: n[0].blob,
                fieldType: lI,
                numKey: this.state.securedFields[lI].numKey
            };
            uV(i, dV(this.state, lI), this.config.loadingContext);
        }
        for(a === nI && LO(e.endDigits) && (o[0].endDigits = e.endDigits), a === nI && LO(e.issuerBin) && (o[0].issuerBin = +e.issuerBin), t = 0, r = o.length; t < r; t += 1)this.callbacks.onFieldValid(o[t]);
        this.validateForm();
    }
    var mV = {
        __NO_BRAND: "noBrand",
        cards: []
    };
    mV.cards.push({
        cardType: "mc",
        startingRules: [
            51,
            52,
            53,
            54,
            55,
            22,
            23,
            24,
            25,
            26,
            27
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(5[1-5][0-9]{0,14}|2[2-7][0-9]{0,14})$/,
        securityCode: "CVC"
    }), mV.cards.push({
        cardType: "visadankort",
        startingRules: [
            4571
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(4571)[0-9]{0,12}$/
    }), mV.cards.push({
        cardType: "visa",
        startingRules: [
            4
        ],
        permittedLengths: [
            13,
            16,
            19
        ],
        pattern: /^4[0-9]{0,18}$/,
        securityCode: "CVV"
    }), mV.cards.push({
        cardType: "amex",
        startingRules: [
            34,
            37
        ],
        permittedLengths: [
            15
        ],
        pattern: /^3[47][0-9]{0,13}$/,
        securityCode: "CID"
    }), mV.cards.push({
        cardType: "diners",
        startingRules: [
            36
        ],
        permittedLengths: [
            14
        ],
        pattern: /^(36)[0-9]{0,12}$/
    }), mV.cards.push({
        cardType: "maestrouk",
        startingRules: [
            6759
        ],
        permittedLengths: [
            16,
            18,
            19
        ],
        pattern: /^(6759)[0-9]{0,15}$/
    }), mV.cards.push({
        cardType: "solo",
        startingRules: [
            6767
        ],
        permittedLengths: [
            16,
            18,
            19
        ],
        pattern: /^(6767)[0-9]{0,15}$/
    }), mV.cards.push({
        cardType: "laser",
        startingRules: [
            6304,
            6706,
            677117,
            677120
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(6304|6706|6709|6771)[0-9]{0,15}$/,
        cvcPolicy: "optional"
    }), mV.cards.push({
        cardType: "discover",
        startingRules: [
            6011,
            644,
            645,
            646,
            647,
            648,
            649,
            65
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(6011[0-9]{0,12}|(644|645|646|647|648|649)[0-9]{0,13}|65[0-9]{0,14})$/
    }), mV.cards.push({
        cardType: "jcb",
        startingRules: [
            3528,
            3529,
            353,
            354,
            355,
            356,
            357,
            358
        ],
        permittedLengths: [
            16,
            19
        ],
        pattern: /^(352[8,9]{1}[0-9]{0,15}|35[4-8]{1}[0-9]{0,16})$/,
        securityCode: "CAV"
    }), mV.cards.push({
        cardType: "bcmc",
        startingRules: [
            6703,
            479658,
            606005
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^((6703)[0-9]{0,15}|(479658|606005)[0-9]{0,13})$/,
        cvcPolicy: "hidden"
    }), mV.cards.push({
        cardType: "bijcard",
        startingRules: [
            5100081
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(5100081)[0-9]{0,9}$/
    }), mV.cards.push({
        cardType: "dankort",
        startingRules: [
            5019
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(5019)[0-9]{0,12}$/
    }), mV.cards.push({
        cardType: "hipercard",
        startingRules: [
            606282
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(606282)[0-9]{0,10}$/
    }), mV.cards.push({
        cardType: "cup",
        startingRules: [
            62,
            81
        ],
        permittedLengths: [
            14,
            15,
            16,
            17,
            18,
            19
        ],
        pattern: /^(62|81)[0-9]{0,17}$/
    }), mV.cards.push({
        cardType: "maestro",
        startingRules: [
            50,
            56,
            57,
            58,
            6
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(5[0|6-8][0-9]{0,17}|6[0-9]{0,18})$/,
        cvcPolicy: "optional"
    }), mV.cards.push({
        cardType: "elo",
        startingRules: [
            506699,
            50670,
            50671,
            50672,
            50673,
            50674,
            50675,
            50676,
            506770,
            506771,
            506772,
            506773,
            506774,
            506775,
            506776,
            506777,
            506778,
            401178,
            438935,
            451416,
            457631,
            457632,
            504175,
            627780,
            636297,
            636368
        ],
        permittedLengths: [
            16
        ],
        pattern: /^((((506699)|(506770)|(506771)|(506772)|(506773)|(506774)|(506775)|(506776)|(506777)|(506778)|(401178)|(438935)|(451416)|(457631)|(457632)|(504175)|(627780)|(636368)|(636297))[0-9]{0,10})|((50676)|(50675)|(50674)|(50673)|(50672)|(50671)|(50670))[0-9]{0,11})$/
    }), mV.cards.push({
        cardType: "uatp",
        startingRules: [
            1
        ],
        permittedLengths: [
            15
        ],
        pattern: /^1[0-9]{0,14}$/,
        cvcPolicy: "optional"
    }), mV.cards.push({
        cardType: "cartebancaire",
        startingRules: [
            4,
            5,
            6
        ],
        permittedLengths: [
            16
        ],
        pattern: /^[4-6][0-9]{0,15}$/
    }), mV.cards.push({
        cardType: "visaalphabankbonus",
        startingRules: [
            450903
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(450903)[0-9]{0,10}$/
    }), mV.cards.push({
        cardType: "mcalphabankbonus",
        startingRules: [
            510099
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(510099)[0-9]{0,10}$/
    }), mV.cards.push({
        cardType: "hiper",
        startingRules: [
            637095,
            637568,
            637599,
            637609,
            637612
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(637095|637568|637599|637609|637612)[0-9]{0,10}$/
    }), mV.cards.push({
        cardType: "oasis",
        startingRules: [
            982616
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(982616)[0-9]{0,10}$/,
        cvcPolicy: "optional"
    }), mV.cards.push({
        cardType: "karenmillen",
        startingRules: [
            98261465
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(98261465)[0-9]{0,8}$/,
        cvcPolicy: "optional"
    }), mV.cards.push({
        cardType: "warehouse",
        startingRules: [
            982633
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(982633)[0-9]{0,10}$/,
        cvcPolicy: "optional"
    }), mV.cards.push({
        cardType: "mir",
        startingRules: [
            220
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(220)[0-9]{0,16}$/
    }), mV.cards.push({
        cardType: "codensa",
        startingRules: [
            590712
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(590712)[0-9]{0,10}$/
    }), mV.cards.push({
        cardType: "naranja",
        startingRules: [
            377798,
            377799,
            402917,
            402918,
            527571,
            527572,
            589562
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(37|40|5[28])([279])\d*$/
    }), mV.cards.push({
        cardType: "cabal",
        startingRules: [
            589657,
            600691,
            603522,
            6042,
            6043,
            636908
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(58|6[03])([03469])\d*$/
    }), mV.cards.push({
        cardType: "shopping",
        startingRules: [
            2799,
            589407,
            603488
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(27|58|60)([39])\d*$/
    }), mV.cards.push({
        cardType: "argencard",
        startingRules: [
            501
        ],
        permittedLengths: [
            16,
            17,
            18,
            19
        ],
        pattern: /^(50)(1)\d*$/
    }), mV.cards.push({
        cardType: "troy",
        startingRules: [
            9792
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(97)(9)\d*$/
    }), mV.cards.push({
        cardType: "forbrugsforeningen",
        startingRules: [
            600722
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(60)(0)\d*$/
    }), mV.cards.push({
        cardType: "vpay",
        startingRules: [
            401,
            408,
            413,
            434,
            435,
            437,
            439,
            441,
            442,
            443,
            444,
            446,
            447,
            455,
            458,
            460,
            461,
            463,
            466,
            471,
            479,
            482,
            483,
            487
        ],
        permittedLengths: [
            13,
            14,
            15,
            16,
            17,
            18,
            19
        ],
        pattern: /^(40[1,8]|413|43[4,5]|44[1,2,3,4,6,7]|45[5,8]|46[0,1,3,6]|47[1,9]|48[2,3,7])[0-9]{0,16}$/
    }), mV.cards.push({
        cardType: "rupay",
        startingRules: [
            508528
        ],
        permittedLengths: [
            16
        ],
        pattern: /^(100003|508(2|[5-9])|60(69|[7-8])|652(1[5-9]|[2-5][0-9]|8[5-9])|65300[3-4]|8172([0-1]|[3-5]|7|9)|817(3[3-8]|40[6-9]|410)|35380([0-2]|[5-6]|9))[0-9]{0,12}$/
    }), mV.cards.push({
        cardType: "ticket",
        expiryDatePolicy: "hidden"
    });
    var fV = {
        detectCard: function(e, t) {
            var r, a, n;
            if (t) {
                var o, i;
                if ((r = Fg(o = Fg(i = mV.cards).call(i, function(e) {
                    return kb(t).call(t, e.cardType);
                })).call(o, function(t) {
                    return fA(t, "pattern") && e.match(t.pattern);
                })).length) {
                    if (1 === r.length) return r[0];
                    for(a = 0, n = r.length; a < n; a += 1)if (!r[a].longestRule) {
                        var l, c = tC(l = r[a].startingRules).call(l, function(e, t) {
                            return e > t ? e : t;
                        });
                        r[a].longestRule = String(c).length;
                    }
                    return tC(r).call(r, function(e, t) {
                        return e.longestRule >= t.longestRule ? e : t;
                    });
                }
                return {
                    cardType: mV.__NO_BRAND
                };
            }
            return {
                cardType: mV.__NO_BRAND
            };
        },
        detectCardLength: function(e, t) {
            var r, a, n, o = 0, i = !1, l = t, c = e.cardType !== mV.__NO_BRAND ? e.permittedLengths[e.permittedLengths.length - 1] : 0;
            if (c && l > c && (o = l.length - c) > 0 && (n = l = l.substring(0, l.length - o)), Ag(r = e.permittedLengths).call(r, function(e) {
                l.length === e && (i = !0);
            }), l.length === c) {
                var s = Math.floor(l.length / 4);
                a = c + (l.length % 4 > 0 ? s : s - 1), "amex" === e.cardType.toLowerCase() && (a = c + 2);
            }
            return {
                shortenedNewValue: n,
                maxLength: a,
                reachedValidLength: i
            };
        },
        getShortestPermittedCardLength: function() {
            if (!sV) {
                var e, t = [];
                Ag(e = mV.cards).call(e, function(e) {
                    var r;
                    t = wb(t).call(t, null !== (r = e.permittedLengths) && void 0 !== r ? r : []);
                }), sV = Math.min.apply(null, t);
            }
            return sV;
        },
        getCardByBrand: function(e) {
            var t;
            return Fg(t = mV.cards).call(t, function(t) {
                return t.cardType === e;
            })[0];
        },
        isGenericCardType: function(e) {
            if (!e) throw new Error("Error: isGenericCardType: type param has not been specified");
            return "card" === e || "scheme" === e;
        },
        __NO_BRAND: mV.__NO_BRAND,
        allCards: mV.cards
    };
    function hV(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function vV(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = hV(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = hV(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var yV = function(e, t) {
        var r = "card" === e ? "nocard" : e || "nocard", a = {
            type: r,
            extension: "svg"
        };
        return t.getImage(a)(r);
    };
    function gV(e) {
        return "object" === ig(e) && null !== e && "[object Array]" === Object.prototype.toString.call(e);
    }
    function bV() {
        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
        var a = gV(t[0]) ? t[0] : t;
        return {
            from: function(e) {
                var t;
                return tC(t = hC(a).call(a, function(t) {
                    return t in e ? Sg({}, t, e[t]) : {};
                })).call(t, function(e, t) {
                    return vV(vV({}, e), t);
                }, {});
            }
        };
    }
    function kV() {
        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
        var a = gV(t[0]) ? t[0] : t;
        return {
            from: function(e) {
                var t, r = Fg(t = Ty(e)).call(t, function(e) {
                    return !kb(a).call(a, e);
                });
                return bV.apply(void 0, Uk(r)).from(e);
            }
        };
    }
    function CV(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function _V(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = CV(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = CV(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function NV(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function PV(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = NV(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = NV(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function wV(e, t, r) {
        var a = e.txVariant, n = function(e) {
            var t = Sg(Sg(Sg(Sg(Sg(Sg(Sg(Sg(Sg(Sg({}, nI, e.get && e.get("creditCard.numberField.placeholder")), oI, e.get && e.get("creditCard.expiryDateField.placeholder")), iI, e.get && e.get("creditCard.expiryDateField.month.placeholder")), lI, e.get && e.get("creditCard.expiryDateField.year.placeholder")), cI, e.get && e.get("creditCard.cvcField.placeholder")), pI, e.get && e.get("creditCard.cvcField.placeholder.3digits")), mI, e.get && e.get("creditCard.cvcField.placeholder.4digits")), sI, e.get && e.get("creditCard.encryptedPassword.placeholder")), uI, e.get && e.get("ach.accountNumberField.placeholder")), dI, e.get && e.get("ach.accountLocationId.placeholder"));
            return "ach.accountNumberField.placeholder" === t[uI] && (t[uI] = ""), "ach.accountLocationId.placeholder" === t[dI] && (t[dI] = ""), t;
        }(r);
        return PV(PV(PV({}, t !== cI && Sg({}, t, n[t])), t === cI && a === fI && Sg({}, t, n[t])), t === cI && a !== fI && Sg(Sg({}, pI, n[pI]), mI, n[mI]));
    }
    function SV(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function AV(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = SV(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = SV(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function IV(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var DV = function(e) {
        L_(r, e);
        var t = IV(r);
        function r(e, a) {
            var n;
            Cg(this, r), n = t.call(this);
            var o = [
                "fieldType",
                "iframeSrc",
                "cvcPolicy",
                "expiryDatePolicy",
                "loadingContext",
                "holderEl"
            ], i = kV(o).from(e);
            n.sfConfig = AV(AV(AV({}, n.sfConfig), i), {}, {
                iframeUIConfig: AV({}, i.iframeUIConfig)
            });
            var l = bV(o).from(e);
            return n.fieldType = l.fieldType, n.cvcPolicy = l.cvcPolicy, n.expiryDatePolicy = l.expiryDatePolicy, n.iframeSrc = l.iframeSrc, n.loadingContext = l.loadingContext, n.holderEl = l.holderEl, n.isValid = !1, n.iframeContentWindow = null, n.numKey = function() {
                if (!window.crypto) return 4294967296 * Math.random() | 0;
                var e = new Uint32Array(1);
                return window.crypto.getRandomValues(e), e[0];
            }(), n.isEncrypted = !1, n.hasError = !1, n.errorType = "", V_(n, n.init(a));
        }
        return wg(r, [
            {
                key: "init",
                value: function(e) {
                    var t = function(e, t, r) {
                        var a, n, o, i = kb(a = [
                            "ach",
                            "giftcard"
                        ]).call(a, e.txVariant) ? e.txVariant : "creditCard", l = r.get(wb(n = "".concat(i, ".")).call(n, t, ".aria.iframeTitle")), c = r.get(wb(o = "".concat(i, ".")).call(o, t, ".aria.label")), s = r.locale, u = vO({
                            iframeTitle: l,
                            label: c
                        }, r);
                        return _V(_V({}, s && {
                            lang: s
                        }), {}, Sg({}, t, u));
                    }(this.sfConfig, this.fieldType, e);
                    this.sfConfig.iframeUIConfig.ariaConfig = t;
                    var r = wV(this.sfConfig, this.fieldType, e);
                    this.sfConfig.iframeUIConfig.placeholders = r;
                    var a = function(e) {
                        var t = e.src, r = e.title, a = void 0 === r ? "iframe element" : r, n = e.policy, o = void 0 === n ? "origin" : n, i = document.createElement("iframe");
                        i.setAttribute("src", t), i.classList.add("js-iframe"), "" === a || 0 === tE(a).call(a).length || "none" === a ? i.setAttribute("role", "presentation") : i.setAttribute("title", a), i.setAttribute("allowtransparency", "true"), i.setAttribute("referrerpolicy", o);
                        var l = document.createTextNode("<p>Your browser does not support iframes.</p>");
                        return i.appendChild(l), i;
                    }({
                        src: this.iframeSrc,
                        title: t[this.fieldType].iframeTitle,
                        policy: "origin"
                    });
                    this.holderEl.appendChild(a);
                    var n = CO(this.holderEl, ".js-iframe");
                    return n && (this.iframeContentWindow = n.contentWindow, this.iframeOnLoadListener = this.iframeOnLoadListenerFn, NO(n, "load", this.iframeOnLoadListener, !1)), this.iframeRef = n, this;
                }
            },
            {
                key: "iframeOnLoadListenerFn",
                value: function() {
                    this.postMessageListener = this.postMessageListenerFn, NO(window, "message", this.postMessageListener, !1);
                    var e = {
                        fieldType: this.fieldType,
                        extraFieldData: this.sfConfig.extraFieldData,
                        uid: this.sfConfig.uid,
                        cvcPolicy: this.cvcPolicy,
                        expiryDatePolicy: this.expiryDatePolicy,
                        numKey: this.numKey,
                        txVariant: this.sfConfig.txVariant,
                        cardGroupTypes: this.sfConfig.cardGroupTypes,
                        iframeUIConfig: this.sfConfig.iframeUIConfig,
                        sfLogAtStart: this.sfConfig.sfLogAtStart,
                        trimTrailingSeparator: this.sfConfig.trimTrailingSeparator,
                        isCreditCardType: this.sfConfig.isCreditCardType,
                        showWarnings: this.sfConfig.showWarnings,
                        legacyInputMode: this.sfConfig.legacyInputMode,
                        minimumExpiryDate: this.sfConfig.minimumExpiryDate,
                        implementationType: this.sfConfig.implementationType,
                        maskSecurityCode: this.sfConfig.maskSecurityCode,
                        disableIOSArrowKeys: this.sfConfig.disableIOSArrowKeys
                    };
                    window._b$dl && console.log("### SecuredField:::: onIframeLoaded:: created configObj=", e), uV(e, this.iframeContentWindow, this.loadingContext), this.onIframeLoadedCallback();
                }
            },
            {
                key: "postMessageListenerFn",
                value: function(e) {
                    if (function(e, t, r) {
                        var a = e.origin, n = Kk(t).call(t, "/checkoutshopper/"), o = n > -1 ? t.substring(0, n) : t, i = o.length - 1;
                        return "/" === o.charAt(i) && (o = o.substring(0, i)), a === o || (r && (rV("WARNING postMessageValidation: postMessage listener for iframe::origin mismatch!\n Received message with origin:", a, "but the only allowed origin for messages to CSF is", o), rV("### event.data=", e.data)), !1);
                    }(e, this.loadingContext, this.sfConfig.showWarnings)) {
                        var t;
                        try {
                            t = JSON.parse(e.data);
                        } catch (t) {
                            return function(e) {
                                var t;
                                return e.data && e.data.type && "string" == typeof e.data.type && Kk(t = e.data.type).call(t, "webpack") > -1;
                            }(e) ? void (this.sfConfig.showWarnings && tV("### SecuredField::postMessageListenerFn:: PARSE FAIL - WEBPACK")) : function(e) {
                                var t;
                                return e.data && "string" == typeof e.data && Kk(t = e.data).call(t, "cvox") > -1;
                            }(e) ? void (this.sfConfig.showWarnings && tV("### SecuredField::postMessageListenerFn:: PARSE FAIL - CHROMEVOX")) : void (this.sfConfig.showWarnings && tV("### SecuredField::postMessageListenerFn:: PARSE FAIL - UNKNOWN REASON: event.data=", e.data));
                        }
                        if (fA(t, "action") && fA(t, "numKey")) {
                            if (this.numKey === t.numKey) switch(t.action){
                                case "encryption":
                                    this.isValid = !0, this.onEncryptionCallback(t);
                                    break;
                                case "config":
                                    window._b$dl && console.log("### SecuredField::postMessageListenerFn:: configured - calling onConfigCallback", t.fieldType), this.onConfigCallback(t);
                                    break;
                                case "focus":
                                    this.onFocusCallback(t);
                                    break;
                                case "binValue":
                                    this.onBinValueCallback(t);
                                    break;
                                case "touch":
                                    this.onTouchstartCallback(t);
                                    break;
                                case "shifttab":
                                    this.onShiftTabCallback(t);
                                    break;
                                case "autoComplete":
                                    this.onAutoCompleteCallback(t);
                                    break;
                                default:
                                    this.isValid = !1, this.onValidationCallback(t);
                            }
                            else this.sfConfig.showWarnings && rV("WARNING SecuredField :: postMessage listener for iframe :: data mismatch! (Probably a message from an unrelated securedField)");
                        } else this.sfConfig.showWarnings && rV("WARNING SecuredField :: postMessage listener for iframe :: data mismatch!");
                    }
                }
            },
            {
                key: "destroy",
                value: function() {
                    PO(window, "message", this.postMessageListener, !1), PO(this.iframeRef, "load", this.iframeOnLoadListener, !1), this.iframeContentWindow = null, function(e) {
                        for(; e.firstChild;)e.removeChild(e.firstChild);
                    }(this.holderEl);
                }
            },
            {
                key: "isOptionalOrHidden",
                value: function() {
                    if (this.fieldType === oI || this.fieldType === iI || this.fieldType === lI) switch(this.expiryDatePolicy){
                        case DI:
                            return !0;
                        case II:
                            return !this.hasError;
                        default:
                            return !1;
                    }
                    if (this.fieldType === cI) switch(this.cvcPolicy){
                        case SI:
                            return !0;
                        case wI:
                            return !this.hasError;
                        default:
                            return !1;
                    }
                    return !1;
                }
            },
            {
                key: "onIframeLoaded",
                value: function(e) {
                    return this.onIframeLoadedCallback = e, this;
                }
            },
            {
                key: "onEncryption",
                value: function(e) {
                    return this.onEncryptionCallback = e, this;
                }
            },
            {
                key: "onValidation",
                value: function(e) {
                    return this.onValidationCallback = e, this;
                }
            },
            {
                key: "onConfig",
                value: function(e) {
                    return this.onConfigCallback = e, this;
                }
            },
            {
                key: "onFocus",
                value: function(e) {
                    return this.onFocusCallback = e, this;
                }
            },
            {
                key: "onBinValue",
                value: function(e) {
                    return this.onBinValueCallback = e, this;
                }
            },
            {
                key: "onTouchstart",
                value: function(e) {
                    return this.onTouchstartCallback = e, this;
                }
            },
            {
                key: "onShiftTab",
                value: function(e) {
                    return this.onShiftTabCallback = e, this;
                }
            },
            {
                key: "onAutoComplete",
                value: function(e) {
                    return this.onAutoCompleteCallback = e, this;
                }
            },
            {
                key: "errorType",
                get: function() {
                    return this._errorType;
                },
                set: function(e) {
                    this._errorType = e;
                }
            },
            {
                key: "hasError",
                get: function() {
                    return this._hasError;
                },
                set: function(e) {
                    this._hasError = e;
                }
            },
            {
                key: "isValid",
                get: function() {
                    if (this.fieldType === cI) switch(this.cvcPolicy){
                        case SI:
                            return !0;
                        case wI:
                            return !this.hasError;
                        default:
                            return this._isValid;
                    }
                    if (this.fieldType === oI || this.fieldType === iI || this.fieldType === lI) switch(this.expiryDatePolicy){
                        case DI:
                            return !0;
                        case II:
                            return !this.hasError;
                        default:
                            return this._isValid;
                    }
                    return this._isValid;
                },
                set: function(e) {
                    this._isValid = e;
                }
            },
            {
                key: "cvcPolicy",
                get: function() {
                    return this._cvcPolicy;
                },
                set: function(e) {
                    this.fieldType === cI && e !== this.cvcPolicy && (this._cvcPolicy = e, this.hasError && "isValidated" === this.errorType && (this.hasError = !1));
                }
            },
            {
                key: "expiryDatePolicy",
                get: function() {
                    return this._expiryDatePolicy;
                },
                set: function(e) {
                    this.fieldType !== oI && this.fieldType !== iI && this.fieldType !== lI || e !== this.expiryDatePolicy && (this._expiryDatePolicy = e, this.hasError && "isValidated" === this.errorType && (this.hasError = !1));
                }
            },
            {
                key: "iframeContentWindow",
                get: function() {
                    return this._iframeContentWindow;
                },
                set: function(e) {
                    this._iframeContentWindow = e;
                }
            },
            {
                key: "isEncrypted",
                get: function() {
                    return this._isEncrypted;
                },
                set: function(e) {
                    this._isEncrypted = e;
                }
            },
            {
                key: "numKey",
                get: function() {
                    return this._numKey;
                },
                set: function(e) {
                    this._numKey = e;
                }
            },
            {
                key: "iframeOnLoadListener",
                get: function() {
                    return this._iframeOnLoadListener;
                },
                set: function(e) {
                    this._iframeOnLoadListener = Jg(e).call(e, this);
                }
            },
            {
                key: "postMessageListener",
                get: function() {
                    return this._postMessageListener;
                },
                set: function(e) {
                    this._postMessageListener = Jg(e).call(e, this);
                }
            }
        ]), r;
    }(wg(function e() {
        Cg(this, e), Sg(this, "sfConfig", void 0), Sg(this, "fieldType", void 0), Sg(this, "iframeSrc", void 0), Sg(this, "loadingContext", void 0), Sg(this, "holderEl", void 0), Sg(this, "iframeRef", void 0), Sg(this, "loadToConfigTimeout", void 0), Sg(this, "_errorType", void 0), Sg(this, "_hasError", void 0), Sg(this, "_isValid", void 0), Sg(this, "_cvcPolicy", void 0), Sg(this, "_expiryDatePolicy", void 0), Sg(this, "_iframeContentWindow", void 0), Sg(this, "_isEncrypted", void 0), Sg(this, "_numKey", void 0), Sg(this, "_iframeOnLoadListener", void 0), Sg(this, "_postMessageListener", void 0), Sg(this, "onIframeLoadedCallback", void 0), Sg(this, "onConfigCallback", void 0), Sg(this, "onEncryptionCallback", void 0), Sg(this, "onValidationCallback", void 0), Sg(this, "onFocusCallback", void 0), Sg(this, "onBinValueCallback", void 0), Sg(this, "onTouchstartCallback", void 0), Sg(this, "onShiftTabCallback", void 0), Sg(this, "onAutoCompleteCallback", void 0), this.sfConfig = {};
    }));
    function EV() {
        var e, t = this;
        this.encryptedAttrName = EI;
        var r = Fg(e = kO(this.props.rootNode, "[".concat(this.encryptedAttrName, "]"))).call(e, function(e) {
            var r, a = _O(e, t.encryptedAttrName), n = kb(bI).call(bI, a);
            n || console.warn(wb(r = "WARNING: '".concat(a, "' is not a valid type for the '")).call(r, t.encryptedAttrName, "' attribute. A SecuredField will not be created for this element."));
            return n;
        }), a = PI, n = AI;
        return this.config.isCreditCardType ? (this.isSingleBrandedCard = !1, this.securityCode = "", this.createCardSecuredFields(r, a, n), r.length) : (this.createNonCardSecuredFields(r), r.length);
    }
    function RV(e) {
        return xV.apply(this, arguments);
    }
    function xV() {
        return xV = Jd(Ey.mark(function e(t) {
            var r, a;
            return Ey.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        r = 0;
                    case 1:
                        if (!(r < t.length)) {
                            e.next = 8;
                            break;
                        }
                        return a = t[r], e.next = 5, this.setupSecuredField(a).catch(function(e) {
                            window._b$dl && console.log("Secured fields setup failure. e=", e);
                        });
                    case 5:
                        r++, e.next = 1;
                        break;
                    case 8:
                    case "end":
                        return e.stop();
                }
            }, e, this);
        })), xV.apply(this, arguments);
    }
    function FV(e, t, r) {
        return TV.apply(this, arguments);
    }
    function TV() {
        return TV = Jd(Ey.mark(function e(t, r, a) {
            var n, o, i, l, c, s = this;
            return Ey.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        "card" === (n = this.state.type) && 1 === this.config.cardGroupTypes.length && (n = this.config.cardGroupTypes[0], this.state.type = n), this.isSingleBrandedCard = "card" !== n, this.isSingleBrandedCard && (MO(o = fV.getCardByBrand(n)) ? (r = o.cvcPolicy || PI, a = o.expiryDatePolicy || AI, this.securityCode = o.securityCode) : this.state.type = "unrecognised-single-brand"), i = 0;
                    case 5:
                        if (!(i < t.length)) {
                            e.next = 14;
                            break;
                        }
                        return l = t[i], window._b$dl && console.log("\nAbout to set up securedField:", l), e.next = 10, this.setupSecuredField(l, r, a).catch(function(e) {
                            window._b$dl && console.log("Secured fields setup failure. e=", e);
                        });
                    case 10:
                        window._b$dl && console.log("Finished setting up securedField:", l);
                    case 11:
                        i++, e.next = 5;
                        break;
                    case 14:
                        window._b$dl && console.log("Finished setting up all securedFields"), this.isSingleBrandedCard && (c = {
                            type: this.state.type,
                            rootNode: this.props.rootNode,
                            brand: n,
                            cvcPolicy: r,
                            expiryDatePolicy: a,
                            cvcText: this.securityCode
                        }, ZN(function() {
                            s.callbacks.onBrand(c);
                        }, 0));
                    case 16:
                    case "end":
                        return e.stop();
                }
            }, e, this);
        })), TV.apply(this, arguments);
    }
    function zV(e, t, r) {
        var a = this;
        return new Sb(function(n, o) {
            var i = _O(e, a.encryptedAttrName);
            i === lI && (a.state.hasSeparateDateFields = !0);
            var l = {
                fieldType: i,
                extraFieldData: _O(e, RI),
                uid: _O(e, xI),
                cvcPolicy: t,
                holderEl: e,
                expiryDatePolicy: r,
                txVariant: a.state.type,
                cardGroupTypes: a.config.cardGroupTypes,
                iframeUIConfig: a.config.iframeUIConfig ? a.config.iframeUIConfig : {},
                sfLogAtStart: a.config.sfLogAtStart,
                trimTrailingSeparator: a.config.trimTrailingSeparator,
                isCreditCardType: a.config.isCreditCardType,
                iframeSrc: a.config.iframeSrc,
                loadingContext: a.config.loadingContext,
                showWarnings: a.config.showWarnings,
                legacyInputMode: a.config.legacyInputMode,
                minimumExpiryDate: a.config.minimumExpiryDate,
                implementationType: a.config.implementationType,
                maskSecurityCode: a.config.maskSecurityCode,
                disableIOSArrowKeys: a.config.shouldDisableIOSArrowKeys
            }, c = new DV(l, a.props.i18n).onIframeLoaded(function() {
                var e;
                if (a.state.iframeCount += 1, window._b$dl && console.log("### createSecuredFields::onIframeLoaded:: this.state.iframeCount=", a.state.iframeCount), a.state.iframeCount > a.state.numIframes) throw a.destroySecuredFields(), new mA("ERROR", wb(e = "One or more securedFields has just loaded new content. This should never happen. securedFields have been removed.\n                        iframe load count=".concat(a.state.iframeCount, ". Expected count:")).call(e, a.state.numIframes));
                if (c.loadToConfigTimeout = ZN(function() {
                    o({
                        type: c.fieldType,
                        failReason: "sf took too long to config"
                    });
                }, 6e3), a.state.iframeCount === a.state.originalNumIframes) a.callbacks.onLoad({
                    iframesLoaded: !0
                });
            }).onConfig(function(e) {
                a.handleIframeConfigFeedback(e), clearTimeout(c.loadToConfigTimeout), c.loadToConfigTimeout = null, n(e);
            }).onFocus(function(e) {
                a.handleFocus(e);
            }).onBinValue(function(e) {
                a.handleBinValue(e);
            }).onTouchstart(function(e) {
                a.config.shouldDisableIOSArrowKeys && (a.hasGenuineTouchEvents || e.hasGenuineTouchEvents) && a.callbacks.onTouchstartIOS({
                    fieldType: e.fieldType
                }), (e.hasGenuineTouchEvents || a.hasGenuineTouchEvents) && a.postMessageToAllIframes({
                    fieldType: e.fieldType,
                    fieldClick: !0
                });
            }).onShiftTab(function(e) {
                a.handleSFShiftTab(e.fieldType);
            }).onEncryption(function(e) {
                a.handleEncryption(e);
            }).onValidation(function(e) {
                a.handleValidation(e);
            }).onAutoComplete(function(e) {
                a.processAutoComplete(e);
            });
            a.state.securedFields[i] = c;
        });
    }
    var OV = "undefined" != typeof navigator && /(android)/i.test(navigator.userAgent), jV = "undefined" != typeof navigator && function() {
        var e = navigator.userAgent, t = Kk(e).call(e, "MSIE ");
        if (t > 0) return ZC(e.substring(t + 5, Kk(e).call(e, ".", t)), 10);
        if (Kk(e).call(e, "Trident/") > 0) {
            var r = Kk(e).call(e, "rv:");
            return ZC(e.substring(r + 3, Kk(e).call(e, ".", r)), 10);
        }
        var a = Kk(e).call(e, "Edge/");
        return a > 0 && ZC(e.substring(a + 5, Kk(e).call(e, ".", a)), 10);
    }(), BV = {
        __IS_ANDROID: OV,
        __IS_IE: jV,
        __IS_IOS: "undefined" != typeof navigator && /iphone|ipod|ipad/i.test(navigator.userAgent),
        __IS_FIREFOX: "undefined" != typeof navigator && /(firefox)/i.test(navigator.userAgent),
        __IS_SAFARI: "undefined" != typeof navigator && /(safari)/i.test(navigator.userAgent) && !/(chrome)/i.test(navigator.userAgent)
    };
    var MV = function(e) {
        var t, r = e.target;
        if (r instanceof HTMLInputElement || HTMLTextAreaElement && r instanceof HTMLTextAreaElement) {
            var a = r.value, n = "selectionStart" in (t = r) ? t.selectionStart : 0, o = !1;
            n === a.length && (n -= 1, o = !0), r.value = a;
            try {
                r.setSelectionRange && (r.focus(), r.setSelectionRange(n, n), o && (n += 1, ZN(function() {
                    r.setSelectionRange(n, n);
                }, 0)));
            } catch (e) {}
        } else if (this.config.keypadFix) {
            var i = this.props.rootNode, l = document.createElement("input");
            l.style.width = "1px", l.style.height = "1px", l.style.opacity = "0", l.style.fontSize = "18px", i.appendChild(l), l.focus(), i.removeChild(l);
        }
        this.destroyTouchendListener(), this.state.registerFieldForIos = !1, this.postMessageToAllIframes({
            fieldType: "webInternalElement",
            fieldClick: !0
        });
    }, LV = function(e) {
        this.hasGenuineTouchEvents = !0;
        var t = e.target;
        if (t instanceof HTMLInputElement || t instanceof HTMLSpanElement) {
            var r, a, n;
            this.postMessageToAllIframes({
                fieldType: "webInternalElement",
                checkoutTouchEvent: !0
            });
            var o = null !== (r = t.getAttribute("name")) && void 0 !== r ? r : t.getAttribute("data-id");
            null === (a = (n = this.callbacks).onTouchstartIOS) || void 0 === a || a.call(n, {
                fieldType: "webInternalElement",
                name: o
            });
        }
    }, VV = function() {
        var e = CO(document, "body");
        e.style.cursor = "pointer", NO(e, "touchend", this.touchendListener), this.state.registerFieldForIos = !0;
    }, UV = function() {
        if (!BV.__IS_IOS) return !1;
        var e = CO(document, "body");
        return e.style.cursor = "auto", PO(e, "touchend", this.touchendListener), !0;
    }, KV = function() {
        return !!BV.__IS_IOS && (PO(document, "touchstart", this.touchstartListener), !0);
    }, HV = function(e, t, r) {
        return function(e) {
            var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = xA(Array.prototype).call(kO(document, "*[data-cse], a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable]")), a = [];
            Ag(r).call(r, function(e) {
                var t = e.getAttribute("tabindex"), r = !t || ZC(t, 10) >= 0, n = e.getBoundingClientRect(), o = n.width > 0 && n.height > 0;
                r && o && a.push(e);
            });
            var n = function(e, t) {
                for(var r = 0; r < e.length; r += 1)if (t(e[r])) return r;
                return -1;
            }(a, function(t) {
                return t === e || e.contains(t);
            });
            return a[n + (t ? -1 : 1)];
        }(CO(t, "[data-cse=".concat(e, "]")), r);
    };
    var qV = function(e) {
        var t;
        switch(this.state.type){
            case "ach":
                t = function(e) {
                    var t;
                    return e === dI && (t = uI), {
                        fieldToFocus: t,
                        additionalField: void 0
                    };
                }(e);
                break;
            case "giftcard":
                t = function(e, t) {
                    var r, a;
                    switch(e){
                        case nI:
                            r = HV(nI, t);
                            break;
                        case cI:
                            a = nI;
                    }
                    return {
                        fieldToFocus: a,
                        additionalField: r
                    };
                }(e, this.props.rootNode);
                break;
            default:
                t = this.state.isKCP ? function(e, t, r) {
                    var a, n;
                    switch(e){
                        case nI:
                            a = HV(nI, t);
                            break;
                        case oI:
                        case iI:
                            n = nI;
                            break;
                        case lI:
                            n = iI;
                            break;
                        case cI:
                            n = r ? lI : oI;
                            break;
                        case sI:
                            a = HV(e, t);
                    }
                    return {
                        fieldToFocus: n,
                        additionalField: a
                    };
                }(e, this.props.rootNode, this.state.hasSeparateDateFields) : function(e, t, r, a) {
                    var n, o;
                    switch(e){
                        case nI:
                            n = HV(nI, t);
                            break;
                        case oI:
                        case iI:
                            o = nI;
                            break;
                        case lI:
                            o = iI;
                            break;
                        case cI:
                            1 === a ? n = HV(cI, t) : o = r ? lI : oI;
                    }
                    return {
                        fieldToFocus: o,
                        additionalField: n
                    };
                }(e, this.props.rootNode, this.state.hasSeparateDateFields, this.state.numIframes);
        }
        var r, a = t.fieldToFocus, n = t.additionalField;
        a ? this.setFocusOnFrame(a, false) : n && (r = n) && (r.focus(), r.blur(), r.focus());
    }, WV = function(e) {
        (BV.__IS_FIREFOX || BV.__IS_IE && BV.__IS_IE <= 11) && this.handleShiftTab(e);
    };
    function GV(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function YV(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = GV(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = GV(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function QV(e) {
        if (fA(this.state.securedFields, nI)) {
            var t = YV(YV({
                txVariant: this.state.type
            }, e), {}, {
                fieldType: nI,
                numKey: this.state.securedFields[nI].numKey
            });
            uV(t, dV(this.state, nI), this.config.loadingContext);
        }
    }
    function ZV(e) {
        var t = this, r = fA(this.state.securedFields, iI) && fA(this.state.securedFields, lI) ? [
            iI,
            lI
        ] : [
            oI
        ];
        Ag(r).call(r, function(r) {
            var a = YV(YV({
                txVariant: t.state.type
            }, e), {}, {
                fieldType: r,
                numKey: t.state.securedFields[r].numKey
            });
            uV(a, dV(t.state, r), t.config.loadingContext);
        });
    }
    function JV(e, t) {
        var r, a, n = "card" === this.state.type;
        if (!e || !Ty(e).length) return n ? (this.sendBrandToCardSF({
            brand: "reset"
        }), this.sendExpiryDatePolicyToSF({
            expiryDatePolicy: AI
        })) : t && this.processBrand(YV(YV({}, t), {}, {
            fieldType: nI
        })), void ("card" === this.state.type && fA(this.state.securedFields, oI) && (this.state.securedFields[oI].expiryDatePolicy = AI));
        var o = e.supportedBrands[0], i = o.brand, l = null !== (r = o.expiryDatePolicy) && void 0 !== r ? r : !0 === o.showExpiryDate ? AI : DI, c = {
            brand: i,
            cvcPolicy: o.cvcPolicy,
            expiryDatePolicy: l,
            cvcText: "Security code",
            showSocialSecurityNumber: null !== (a = o.showSocialSecurityNumber) && void 0 !== a && a,
            fieldType: nI
        };
        if (this.processBrand(c), n) {
            var s = YV({
                brand: i,
                enableLuhnCheck: !1 !== e.supportedBrands[0].enableLuhnCheck
            }, (null == o ? void 0 : o.panLength) && {
                panLength: null == o ? void 0 : o.panLength
            });
            this.sendBrandToCardSF(s), this.sendExpiryDatePolicyToSF({
                expiryDatePolicy: l
            });
        }
        fA(this.state.securedFields, cI) && (this.state.securedFields[cI].cvcPolicy = o.cvcPolicy), fA(this.state.securedFields, oI) ? this.state.securedFields[oI].expiryDatePolicy = l : fA(this.state.securedFields, iI) && fA(this.state.securedFields, lI) && (this.state.securedFields[iI].expiryDatePolicy = l, this.state.securedFields[lI].expiryDatePolicy = l), this.validateForm();
    }
    function $V(e, t, r) {
        var a = e.csfState, n = e.csfConfig;
        if (fA(a.securedFields, t)) {
            var o = {
                txVariant: a.type,
                fieldType: t,
                focus: !0,
                numKey: a.securedFields[t].numKey
            };
            uV(o, dV(a, t), n.loadingContext);
        }
    }
    function XV(e, t) {
        var r = e.csfState, a = e.csfConfig, n = Ty(t || {});
        if (!n.length) return !1;
        var o = Ty(r.securedFields);
        return Ag(o).call(o, function(e) {
            var o = {
                txVariant: r.type,
                fieldType: e,
                numKey: r.securedFields[e].numKey
            };
            Ag(n).call(n, function(e) {
                o[e] = t[e];
            }), uV(o, dV(r, e), a.loadingContext);
        }), !0;
    }
    var eU = function(e, t) {
        return !UO(e, t);
    };
    function tU(e, t) {
        var r = e.csfState, a = e.csfConfig, n = e.csfProps, o = e.csfCallbacks;
        if (t.fieldType === nI) {
            var i = {
                brand: t.brand,
                cvcPolicy: t.cvcPolicy,
                expiryDatePolicy: t.expiryDatePolicy,
                showSocialSecurityNumber: t.showSocialSecurityNumber
            }, l = eU(i, r.brand);
            if (!l) return null;
            var c = "card" === r.type || "bcmc" === r.type;
            if (c && l && (r.brand = i, fA(r.securedFields, cI))) {
                var s = {
                    txVariant: r.type,
                    brand: i.brand,
                    fieldType: cI,
                    cvcPolicy: t.cvcPolicy,
                    numKey: r.securedFields[cI].numKey
                };
                uV(s, dV(r, cI), a.loadingContext);
            }
            var u = c ? bV([
                "brand",
                "cvcPolicy",
                "cvcText",
                "expiryDatePolicy",
                "showSocialSecurityNumber"
            ]).from(t) : null;
            if (u && u.brand) {
                var d = u;
                d.type = r.type, d.rootNode = n.rootNode, o.onBrand(d);
            }
            return !0;
        }
        return !1;
    }
    function rU(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function aU(e, t) {
        var r = e.csfState, a = e.csfConfig, n = e.csfCallbacks;
        if ("cc-name" === t.name) {
            var o = function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r, a, n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Ag(r = rU(Object(n), !0)).call(r, function(t) {
                        Sg(e, t, n[t]);
                    }) : Jy ? ng(e, Jy(n)) : Ag(a = rU(Object(n))).call(a, function(t) {
                        og(e, t, Wy(n, t));
                    });
                }
                return e;
            }({}, t);
            delete o.numKey;
            var i = o;
            return n.onAutoComplete(i), !0;
        }
        if ("cc-exp" === t.name) {
            var l, c = t.value.replace(/[^0-9]/gi, "/").split("/");
            if (2 !== c.length) return !1;
            1 === c[0].length && (c[0] = "0".concat(c[0]));
            var s = c[0], u = c[1];
            if (!((4 === (null == u ? void 0 : u.length) || 2 === (null == u ? void 0 : u.length)) && !isNaN(ZC(u)))) return !1;
            var d = xA(u).call(u, -2), p = wb(l = "".concat(s, "/")).call(l, d);
            if (fA(r.securedFields, oI)) {
                var m = {
                    txVariant: r.type,
                    fieldType: oI,
                    autoComplete: p,
                    numKey: r.securedFields[oI].numKey
                };
                return uV(m, dV(r, oI), a.loadingContext), !0;
            }
            if (fA(r.securedFields, iI)) {
                var f = {
                    txVariant: r.type,
                    fieldType: iI,
                    autoComplete: s,
                    numKey: r.securedFields[iI].numKey
                };
                uV(f, dV(r, iI), a.loadingContext);
            }
            return fA(r.securedFields, lI) && ZN(function() {
                var e = {
                    txVariant: r.type,
                    fieldType: lI,
                    autoComplete: d,
                    numKey: r.securedFields[lI].numKey
                };
                uV(e, dV(r, lI), a.loadingContext);
            }, 0), !0;
        }
        return !1;
    }
    function nU(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function oU(e, t, r) {
        var a = e.csfState, n = e.csfProps, o = e.csfCallbacks, i = function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ag(r = nU(Object(n), !0)).call(r, function(t) {
                    Sg(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Ag(a = nU(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({}, r);
        delete i.numKey, i.rootNode = n.rootNode, i.type = a.type;
        var l = i.fieldType;
        i.focus ? a.currentFocusObject !== l && (a.currentFocusObject = l, BV.__IS_IOS && !a.registerFieldForIos && t()) : a.currentFocusObject === l && (a.currentFocusObject = null);
        var c = i;
        c.currentFocusObject = a.currentFocusObject, o.onFocus(c);
    }
    function iU(e, t, r) {
        var a = e.csfState, n = e.csfCallbacks;
        if (a.iframeConfigCount += 1, window._b$dl && console.log("### handleIframeConfigFeedback::csfState.iframeConfigCount:: ", a.iframeConfigCount, "who=", r.fieldType), a.isConfigured) {
            var o = {
                additionalIframeConfigured: !0,
                fieldType: r.fieldType,
                type: a.type
            };
            n.onAdditionalSFConfig(o);
        } else if (a.iframeConfigCount === a.originalNumIframes) return t(), !0;
        return !1;
    }
    function lU(e, t) {
        var r = e.csfState, a = e.csfConfig, n = e.csfProps, o = e.csfCallbacks;
        r.isConfigured = !0;
        var i = {
            iframesConfigured: !0,
            type: r.type,
            rootNode: n.rootNode
        };
        if (o.onConfigSuccess(i), 1 === r.numIframes && a.isCreditCardType) {
            if ("card" === r.type) return eV("ERROR: Payment method with a single secured field - but 'type' has not been set to a specific card brand"), !1;
            var l, c = fV.getCardByBrand(r.type);
            if (c) (null !== (l = c.cvcPolicy) && void 0 !== l ? l : PI) !== PI && t();
        }
        return !0;
    }
    function cU(e) {
        var t = e.csfState, r = e.csfProps, a = e.csfCallbacks, n = function(e) {
            for(var t = Ty(e), r = 0, a = t.length; r < a; r += 1)if (!e[t[r]].isValid) return !1;
            return !0;
        }(t.securedFields), o = n !== t.allValid;
        if (t.allValid = n, n || o) {
            var i = {
                allValid: n,
                type: t.type,
                rootNode: r.rootNode
            };
            a.onAllValid(i);
        }
    }
    function sU(e, t) {
        var r = e.csfState, a = e.csfCallbacks, n = t.binValue, o = t.encryptedBin, i = t.uuid, l = {
            binValue: n,
            type: r.type
        };
        o && (l.encryptedBin = o, l.uuid = i), a.onBinValue(l);
    }
    function uU() {
        var e = this;
        this.postMessageToAllIframes({
            destroy: !0
        });
        var t = Ty(this.state.securedFields);
        Ag(t).call(t, function(t) {
            var r = e.state.securedFields[t];
            r && r.destroy(), e.state.securedFields[t] = null;
        }), this.destroyTouchendListener(), this.destroyTouchstartListener(), this.state.securedFields = {};
    }
    function dU(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var pU = function() {
        rV("".concat(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "You cannot use secured fields", " - they are not yet configured. Use the 'onConfigSuccess' callback to know when this has happened."));
    }, mU = function(e) {
        L_(r, e);
        var t = dU(r);
        function r(e) {
            var a, n, o, i, l, c;
            Cg(this, r), (c = t.call(this, e)).state = {
                type: c.props.type,
                brand: "card" !== c.props.type ? {
                    brand: c.props.type,
                    cvcPolicy: "required"
                } : {
                    brand: null,
                    cvcPolicy: "required"
                },
                allValid: void 0,
                numIframes: 0,
                originalNumIframes: 0,
                iframeCount: 0,
                iframeConfigCount: 0,
                isConfigured: !1,
                hasSeparateDateFields: !1,
                currentFocusObject: null,
                registerFieldForIos: !1,
                securedFields: {},
                isKCP: !1
            };
            var s = {
                csfState: c.state,
                csfConfig: c.config,
                csfProps: c.props,
                csfCallbacks: c.callbacks
            };
            return c.configHandler = aV, c.callbacksHandler = oV, c.validateForm = HO(cU, s), c.isConfigured = HO(lU, s, c.validateForm), c.handleIframeConfigFeedback = HO(iU, s, c.isConfigured), c.processBrand = HO(tU, s), c.handleValidation = cV, c.handleEncryption = pV, c.createSecuredFields = EV, c.createNonCardSecuredFields = RV, c.createCardSecuredFields = FV, c.setupSecuredField = zV, c.postMessageToAllIframes = HO(XV, s), c.handleIOSTouchEvents = Jg(a = VV).call(a, B_(c)), c.touchendListener = Jg(n = MV).call(n, B_(c)), c.destroyTouchendListener = Jg(o = UV).call(o, B_(c)), c.touchstartListener = Jg(i = LV).call(i, B_(c)), c.destroyTouchstartListener = Jg(l = KV).call(l, B_(c)), c.setFocusOnFrame = HO($V, s), c.handleFocus = HO(oU, s, c.handleIOSTouchEvents), c.handleSFShiftTab = WV, c.handleShiftTab = qV, c.destroySecuredFields = uU, c.processAutoComplete = HO(aU, s), c.handleBinValue = HO(sU, s), c.handleBrandFromBinLookup = JV, c.sendBrandToCardSF = QV, c.sendExpiryDatePolicyToSF = ZV, c.init(), c;
        }
        return wg(r, [
            {
                key: "init",
                value: function() {
                    this.configHandler(this.props), this.callbacksHandler(this.props.callbacks);
                    var e = this.createSecuredFields();
                    this.state.numIframes = this.state.originalNumIframes = e, this.state.isKCP = !!this.props.isKCP, BV.__IS_IOS && this.config.shouldDisableIOSArrowKeys && (this.hasGenuineTouchEvents = !1, NO(document, "touchstart", this.touchstartListener));
                }
            },
            {
                key: "createReturnObject",
                value: function() {
                    var e = this;
                    return {
                        updateStyles: function(t) {
                            e.state.isConfigured ? e.postMessageToAllIframes({
                                styleObject: t
                            }) : rV("You cannot update the secured fields styling - they are not yet configured. Use the 'onConfigSuccess' callback to know when this has happened.");
                        },
                        setFocusOnFrame: function(t) {
                            e.state.isConfigured ? e.setFocusOnFrame(t) : pU("You cannot set focus on any secured field");
                        },
                        isValidated: function(t, r) {
                            if (e.state.isConfigured) {
                                if (fA(e.state.securedFields, t)) {
                                    e.state.securedFields[t].hasError = !0, "" === e.state.securedFields[t].errorType && (e.state.securedFields[t].errorType = "isValidated");
                                    var a = {
                                        txVariant: e.state.type,
                                        fieldType: t,
                                        externalValidation: !0,
                                        code: r,
                                        numKey: e.state.securedFields[t].numKey
                                    };
                                    uV(a, dV(e.state, t), e.config.loadingContext);
                                }
                            } else pU("You cannot set validated on any secured field");
                        },
                        hasUnsupportedCard: function(t, r) {
                            if (e.state.isConfigured) {
                                if (fA(e.state.securedFields, t)) {
                                    e.state.securedFields[t].hasError = !!r, e.state.securedFields[t].errorType = r;
                                    var a = {
                                        txVariant: e.state.type,
                                        fieldType: t,
                                        unsupportedCard: !!r,
                                        code: r,
                                        numKey: e.state.securedFields[t].numKey
                                    };
                                    uV(a, dV(e.state, t), e.config.loadingContext);
                                }
                            } else pU("You cannot set hasUnsupportedCard on any secured field");
                        },
                        destroy: function() {
                            e.state.isConfigured ? e.destroySecuredFields() : pU("You cannot destroy secured fields");
                        },
                        brandsFromBinLookup: function(t, r) {
                            if (!e.config.isCreditCardType) return null;
                            e.state.isConfigured ? e.handleBrandFromBinLookup(t, r) : pU("You cannot set pass brands to secured fields");
                        },
                        addSecuredField: function(t) {
                            var r = CO(e.props.rootNode, '[data-cse="'.concat(t, '"]'));
                            r && (e.state.numIframes += 1, e.setupSecuredField(r));
                        },
                        removeSecuredField: function(t) {
                            if (e.state.securedFields[t]) {
                                e.state.securedFields[t].destroy(), delete e.state.securedFields[t], e.state.numIframes -= 1, e.state.iframeCount -= 1;
                                var r = {
                                    additionalIframeRemoved: !0,
                                    fieldType: t,
                                    type: e.state.type
                                };
                                e.callbacks.onAdditionalSFRemoved(r);
                            }
                        },
                        setKCPStatus: function(t) {
                            e.state.isKCP = t;
                        },
                        sfIsOptionalOrHidden: function(t) {
                            return e.state.securedFields[t].isOptionalOrHidden();
                        }
                    };
                }
            }
        ]), r;
    }(XL);
    function fU(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var hU = function(e) {
        if (!e) throw new Error("No securedFields configuration object defined");
        var t = function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ag(r = fU(Object(n), !0)).call(r, function(t) {
                    Sg(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Ag(a = fU(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({}, e);
        try {
            var r = fV.isGenericCardType(t.type);
            t.type = r ? "card" : t.type;
        } catch (e) {
            t.type = "card";
        }
        if (!fA(t, "rootNode")) return eV('ERROR: SecuredFields configuration object is missing a "rootNode" property');
        if (KO(t.clientKey)) return rV('WARNING: AdyenCheckout configuration object is missing a "clientKey" property.');
        var a = vU(t.rootNode);
        return a ? (t.rootNode = a, new mU(t).createReturnObject()) : eV("ERROR: SecuredFields cannot find a valid rootNode element for ".concat(t.type));
    }, vU = function(e) {
        var t;
        return "object" === ig(e) && (t = e), "string" != typeof e || (t = CO(document, e)) ? t : null;
    };
    function yU(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function gU(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = yU(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = yU(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function bU(e, t, r, a) {
        return (t !== _I && t !== NI || 0 !== r[e]) && a[e];
    }
    var kU = function(e) {
        this.numCharsInField[e.fieldType] = e.numChars, this.props.onFocus(e);
    }, CU = function(e) {
        var t = this;
        return !this.state.detectedUnsupportedBrands && (this.setState({
            isSfpValid: e.allValid
        }, function() {
            t.props.onChange(t.state, {
                event: "handleOnAllValid"
            }), t.props.onAllValid(e);
        }), !0);
    }, _U = function(e) {
        var t = this;
        this.setState({
            autoCompleteName: e.value
        }, function() {
            t.props.onChange(t.state, {
                event: "handleOnAutoComplete",
                fieldType: e.fieldType
            }), t.setState({
                autoCompleteName: null
            });
        }), this.props.onAutoComplete(e);
    }, NU = function(e) {
        var t = this;
        return (!this.state.detectedUnsupportedBrands || e.fieldType !== nI) && (this.setState(function(t) {
            var r;
            return {
                data: gU(gU({}, t.data), {}, Sg({}, e.encryptedFieldName, e.blob)),
                valid: gU(gU({}, t.valid), {}, Sg({}, e.encryptedFieldName, e.valid)),
                errors: gU(gU({}, t.errors), {}, Sg({}, e.fieldType, null !== (r = t.errors[e.fieldType]) && void 0 !== r && r))
            };
        }, function() {
            t.props.onChange(t.state, {
                event: "handleOnFieldValid",
                fieldType: e.fieldType
            }), t.props.onFieldValid(e);
        }), !0);
    }, PU = function(e) {
        var t = this;
        clearTimeout(this.csfLoadFailTimeout), this.csfLoadFailTimeout = null, this.props.onLoad(e), this.csfConfigFailTimeout = ZN(function() {
            "ready" !== t.state.status && (t.setState({
                status: "csfConfigFailure"
            }), t.props.onError(new mA("ERROR", "secured fields have failed to configure")));
        }, this.csfConfigFailTimeoutMS);
    }, wU = function(e) {
        var t = this;
        clearTimeout(this.csfConfigFailTimeout), this.csfConfigFailTimeout = null, this.setState({
            status: "ready"
        }, function() {
            t.props.onConfigSuccess(e);
        });
    }, SU = function(e) {
        var t = this;
        this.setState(function(r) {
            var a, n, o = bU(cI, e.cvcPolicy, t.numCharsInField, r.errors), i = 1 === t.numDateFields ? bU(oI, e.expiryDatePolicy, t.numCharsInField, r.errors) : null, l = 2 === t.numDateFields ? bU(iI, e.expiryDatePolicy, t.numCharsInField, r.errors) : null, c = 2 === t.numDateFields ? bU(lI, e.expiryDatePolicy, t.numCharsInField, r.errors) : null;
            return {
                brand: e.brand,
                cvcPolicy: null !== (a = e.cvcPolicy) && void 0 !== a ? a : PI,
                showSocialSecurityNumber: e.showSocialSecurityNumber,
                errors: gU(gU(gU(gU(gU({}, r.errors), MO(o) && Sg({}, cI, o)), MO(i) && Sg({}, oI, i)), MO(l) && Sg({}, iI, l)), MO(c) && Sg({}, lI, c)),
                expiryDatePolicy: null !== (n = e.expiryDatePolicy) && void 0 !== n ? n : AI
            };
        }, function() {
            var r, a;
            t.props.onChange(t.state, {
                event: "handleOnBrand"
            });
            var n = null !== (r = null === (a = t.props.brandsConfiguration[e.brand]) || void 0 === a ? void 0 : a.icon) && void 0 !== r ? r : yV(e.brand, t.props.resources);
            t.props.onBrand(gU(gU({}, e), {}, {
                brandImageUrl: n
            }));
        });
    }, AU = function(e) {
        var t = this, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, a = e.error;
        return this.setState(function(t) {
            return gU(gU(gU({
                errors: gU(gU({}, t.errors), {}, Sg({}, e.fieldType, a || !1))
            }, r && {
                data: gU(gU({}, t.data), {}, Sg({}, nI, void 0))
            }), r && {
                valid: gU(gU({}, t.valid), {}, Sg({}, nI, !1))
            }), r && {
                isSfpValid: !1
            });
        }, function() {
            t.props.onChange(t.state, {
                event: "handleOnError",
                fieldType: e.fieldType
            });
        }), !0;
    }, IU = function() {
        var e = this;
        this.setState({
            status: "ready"
        }, function() {
            return e.props.onChange({
                isSfpValid: !0
            });
        });
    }, DU = function(e) {
        var t, r;
        null === (t = (r = this.props).disableIOSArrowKeys) || void 0 === t || t.call(r, e);
    };
    function EU(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function RU(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = EU(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = EU(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function xU(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var FU = function(e) {
        L_(r, e);
        var t = xU(r);
        function r(e) {
            var a, n, o, i, l, c, s, u, d, p, m, f, h, v, y, g, b;
            Cg(this, r), Sg(B_(b = t.call(this, e)), "csfLoadFailTimeout", void 0), Sg(B_(b), "csfLoadFailTimeoutMS", void 0), Sg(B_(b), "csfConfigFailTimeout", void 0), Sg(B_(b), "csfConfigFailTimeoutMS", void 0), Sg(B_(b), "numCharsInField", void 0), Sg(B_(b), "rootNode", void 0), Sg(B_(b), "numDateFields", void 0), Sg(B_(b), "csf", void 0), Sg(B_(b), "handleOnLoad", void 0), Sg(B_(b), "handleOnConfigSuccess", void 0), Sg(B_(b), "handleOnFieldValid", void 0), Sg(B_(b), "handleOnAllValid", void 0), Sg(B_(b), "handleOnBrand", void 0), Sg(B_(b), "handleFocus", void 0), Sg(B_(b), "handleOnError", void 0), Sg(B_(b), "handleOnAutoComplete", void 0), Sg(B_(b), "handleOnNoDataRequired", void 0), Sg(B_(b), "handleOnTouchstartIOS", void 0), Sg(B_(b), "state", void 0), Sg(B_(b), "props", void 0), Sg(B_(b), "issuingCountryCode", void 0), Sg(B_(b), "setRootNode", function(e) {
                b.rootNode = e;
            });
            var k = {
                status: "loading",
                brand: e.type,
                errors: {},
                valid: {},
                data: {},
                cvcPolicy: PI,
                expiryDatePolicy: AI,
                isSfpValid: !1,
                hasKoreanFields: e.hasKoreanFields
            };
            return b.state = k, b.csfLoadFailTimeout = null, b.csfLoadFailTimeoutMS = 3e4, b.csfConfigFailTimeout = null, b.csfConfigFailTimeoutMS = 15e3, b.numCharsInField = {}, b.handleOnLoad = Jg(a = PU).call(a, B_(b)), b.handleOnConfigSuccess = Jg(n = wU).call(n, B_(b)), b.handleOnFieldValid = Jg(o = NU).call(o, B_(b)), b.handleOnAllValid = Jg(i = CU).call(i, B_(b)), b.handleOnBrand = Jg(l = SU).call(l, B_(b)), b.handleFocus = Jg(c = kU).call(c, B_(b)), b.handleOnError = Jg(s = AU).call(s, B_(b)), b.handleOnNoDataRequired = Jg(u = IU).call(u, B_(b)), b.handleOnAutoComplete = Jg(d = _U).call(d, B_(b)), b.handleOnTouchstartIOS = Jg(p = DU).call(p, B_(b)), b.processBinLookupResponse = Jg(m = b.processBinLookupResponse).call(m, B_(b)), b.setFocusOn = Jg(f = b.setFocusOn).call(f, B_(b)), b.updateStyles = Jg(h = b.updateStyles).call(h, B_(b)), b.handleUnsupportedCard = Jg(v = b.handleUnsupportedCard).call(v, B_(b)), b.showValidation = Jg(y = b.showValidation).call(y, B_(b)), b.destroy = Jg(g = b.destroy).call(g, B_(b)), b;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.rootNode && this.setRootNode(this.props.rootNode);
                    var t = function(e) {
                        var t;
                        return e ? hC(t = xA(Array.prototype).call(e.querySelectorAll('[data-cse*="encrypted"]'))).call(t, function(e) {
                            return e.getAttribute("data-cse");
                        }) : [];
                    }(this.rootNode), r = tC(t).call(t, JL, {});
                    this.setState({
                        valid: r
                    }), Ag(t).call(t, function(t) {
                        e.numCharsInField[t] = 0;
                    }), this.numDateFields = Fg(t).call(t, function(e) {
                        return e.match(/Expiry/);
                    }).length, t.length ? (this.destroy(), this.initializeCSF(this.rootNode)) : this.handleOnNoDataRequired();
                }
            },
            {
                key: "componentDidUpdate",
                value: function() {
                    this.checkForKCPFields();
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.csf = null, clearTimeout(this.csfLoadFailTimeout), clearTimeout(this.csfConfigFailTimeout);
                }
            },
            {
                key: "initializeCSF",
                value: function(e) {
                    var t = this, r = this.props.loadingContext, a = {
                        rootNode: e,
                        type: this.props.type,
                        clientKey: this.props.clientKey,
                        cardGroupTypes: this.props.brands,
                        allowedDOMAccess: this.props.allowedDOMAccess,
                        autoFocus: this.props.autoFocus,
                        trimTrailingSeparator: this.props.trimTrailingSeparator,
                        loadingContext: r,
                        keypadFix: this.props.keypadFix,
                        showWarnings: this.props.showWarnings,
                        iframeUIConfig: {
                            sfStyles: this.props.styles
                        },
                        i18n: this.props.i18n,
                        callbacks: {
                            onLoad: this.handleOnLoad,
                            onConfigSuccess: this.handleOnConfigSuccess,
                            onFieldValid: this.handleOnFieldValid,
                            onAllValid: this.handleOnAllValid,
                            onBrand: this.handleOnBrand,
                            onError: this.handleOnError,
                            onFocus: this.handleFocus,
                            onBinValue: this.props.onBinValue,
                            onAutoComplete: this.handleOnAutoComplete,
                            onAdditionalSFConfig: this.props.onAdditionalSFConfig,
                            onAdditionalSFRemoved: this.props.onAdditionalSFRemoved,
                            onTouchstartIOS: this.handleOnTouchstartIOS
                        },
                        isKCP: this.state.hasKoreanFields,
                        legacyInputMode: this.props.legacyInputMode,
                        minimumExpiryDate: this.props.minimumExpiryDate,
                        implementationType: this.props.implementationType || "components",
                        forceCompat: this.props.forceCompat,
                        maskSecurityCode: this.props.maskSecurityCode,
                        shouldDisableIOSArrowKeys: !!this.props.disableIOSArrowKeys
                    };
                    this.csf = hU(a), this.csfLoadFailTimeout = ZN(function() {
                        "ready" !== t.state.status && (t.setState({
                            status: "csfLoadFailure"
                        }), t.props.onError(new mA("ERROR", "secured field iframes have failed to load")));
                    }, this.csfLoadFailTimeoutMS);
                }
            },
            {
                key: "checkForKCPFields",
                value: function() {
                    var e = this, t = !1;
                    if (this.props.koreanAuthenticationRequired && (t = this.issuingCountryCode ? "kr" === this.issuingCountryCode : "kr" === this.props.countryCode), this.state.hasKoreanFields && !t) this.setState(function(e) {
                        return {
                            data: RU(RU({}, e.data), {}, Sg({}, sI, void 0)),
                            valid: RU(RU({}, e.valid), {}, Sg({}, sI, !1)),
                            errors: RU(RU({}, e.errors), {}, Sg({}, sI, !1)),
                            hasKoreanFields: !1
                        };
                    }, function() {
                        e.props.onChange(e.state);
                    }), this.csf.removeSecuredField(sI), this.csf.setKCPStatus(!1);
                    if (!this.state.hasKoreanFields && t) this.setState(function(e) {
                        return {
                            valid: RU(RU({}, e.valid), {}, Sg({}, sI, !1)),
                            hasKoreanFields: !0,
                            isSfpValid: !1
                        };
                    }, function() {
                        e.props.onChange(e.state);
                    }), this.csf.addSecuredField(sI), this.csf.setKCPStatus(!0);
                }
            },
            {
                key: "getChildContext",
                value: function() {
                    return {
                        i18n: this.props.i18n
                    };
                }
            },
            {
                key: "handleUnsupportedCard",
                value: function(e) {
                    var t = !!e.error;
                    return t && this.setState({
                        detectedUnsupportedBrands: e.detectedBrands
                    }), e.rootNode = this.rootNode, this.handleOnError(e, t), this.csf && this.csf.hasUnsupportedCard(nI, e.error), t;
                }
            },
            {
                key: "setFocusOn",
                value: function(e) {
                    this.csf && this.csf.setFocusOnFrame(e);
                }
            },
            {
                key: "updateStyles",
                value: function(e) {
                    this.csf && this.csf.updateStyles(e);
                }
            },
            {
                key: "sfIsOptionalOrHidden",
                value: function(e) {
                    return this.csf.sfIsOptionalOrHidden(e);
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.csf && this.csf.destroy();
                }
            },
            {
                key: "showValidation",
                value: function() {
                    var e, t, r = this, a = this.numDateFields, n = this.state;
                    Ag(e = tC(t = Ty(n.valid)).call(t, $L(a, n), [])).call(e, function(e) {
                        var t = function(e, t, r) {
                            return {
                                rootNode: t,
                                fieldType: e,
                                error: AN(r, "errors.".concat(e)) || YI[e] || GI,
                                type: "card"
                            };
                        }(e, r.rootNode, n);
                        r.handleOnError(t, !!n.detectedUnsupportedBrands), r.csf && r.csf.isValidated && r.csf.isValidated(e, t.error);
                    });
                }
            },
            {
                key: "mapErrorsToValidationRuleResult",
                value: function() {
                    var e = this, t = Ty(this.state.errors);
                    return tC(t).call(t, function(t, r) {
                        return e.state.errors[r] ? t[r] = RU({
                            isValid: !1,
                            errorMessage: hO(e.state.errors[r]),
                            errorI18n: e.props.i18n.get(e.state.errors[r]),
                            error: e.state.errors[r],
                            rootNode: e.rootNode
                        }, e.state.detectedUnsupportedBrands && {
                            detectedBrands: e.state.detectedUnsupportedBrands
                        }) : t[r] = null, t;
                    }, {});
                }
            },
            {
                key: "processBinLookupResponse",
                value: function(e, t) {
                    var r, a = this;
                    if (this.state.detectedUnsupportedBrands && (this.setState(function(e) {
                        return {
                            errors: RU(RU({}, e.errors), {}, Sg({}, nI, !1)),
                            detectedUnsupportedBrands: null
                        };
                    }), this.csf && e)) this.handleUnsupportedCard({
                        type: "card",
                        fieldType: "encryptedCardNumber",
                        error: ""
                    });
                    this.issuingCountryCode = null == e || null === (r = e.issuingCountryCode) || void 0 === r ? void 0 : r.toLowerCase();
                    var n = (null == t ? void 0 : t.brand) && kb(kI).call(kI, t.brand);
                    n && this.setState(t, function() {
                        a.props.onChange(a.state);
                    }), this.csf && this.csf.brandsFromBinLookup(e, n ? t : null);
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    return e.render({
                        setRootNode: this.setRootNode,
                        setFocusOn: this.setFocusOn
                    }, t);
                }
            }
        ]), r;
    }(oN);
    Sg(FU, "defaultProps", {
        type: "card",
        keypadFix: !0,
        rootNode: null,
        loadingContext: null,
        brands: [],
        allowedDOMAccess: !1,
        showWarnings: !1,
        autoFocus: !0,
        trimTrailingSeparator: !0,
        onChange: function() {},
        onLoad: function() {},
        onConfigSuccess: function() {},
        onAllValid: function() {},
        onFieldValid: function() {},
        onBrand: function() {},
        onError: function() {},
        onBinValue: function() {},
        onFocus: function() {},
        onAutoComplete: function() {},
        styles: {}
    });
    var TU = function(e) {
        return e.full = "full", e.partial = "partial", e.none = "none", e;
    }({}), zU = {
        type: "card",
        setComponentRef: function() {},
        hasHolderName: !1,
        holderNameRequired: !1,
        enableStoreDetails: !1,
        hasCVC: !0,
        showBrandIcon: !0,
        showBrandsUnderCardNumber: !0,
        positionHolderNameOnTop: !1,
        billingAddressRequired: !1,
        billingAddressMode: TU.full,
        billingAddressRequiredFields: [
            "street",
            "houseNumberOrName",
            "postalCode",
            "city",
            "stateOrProvince",
            "country"
        ],
        installmentOptions: {},
        configuration: {
            koreanAuthenticationRequired: !1,
            socialSecurityNumberMode: "auto"
        },
        autoFocus: !0,
        isPayButtonPrimaryVariant: !0,
        disableIOSArrowKeys: !0,
        onLoad: function() {},
        onConfigSuccess: function() {},
        onAllValid: function() {},
        onFieldValid: function() {},
        onBrand: function() {},
        onError: function() {},
        onBinValue: function() {},
        onBlur: function() {},
        onFocus: function() {},
        onChange: function() {},
        data: {
            billingAddress: {}
        },
        styles: {},
        placeholders: {}
    }, OU = {
        base: {
            caretColor: "#0075FF"
        }
    };
    function jU(e) {
        var t;
        return tE(t = e.replace(/[^0-9]/g, "")).call(t);
    }
    function BU() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        if ("string" != typeof e) return "";
        var t = jU(e), r = t.length > 11 ? function(e) {
            return e.replace(/^(\d{2})(\d{3})(\d{3})?(\d{4})?(\d{1,2})?$/g, function(e, t, r, a) {
                var n, o, i, l, c = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "", s = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "";
                return wb(n = wb(o = wb(i = wb(l = "".concat(t, ".")).call(l, r, ".")).call(i, a, "/")).call(o, c)).call(n, s.length ? "-".concat(s) : "");
            });
        }(t) : function(e) {
            return e.replace(/\W/gi, "").replace(/(\d{3})(?!$)/g, "$1.").replace(/(.{11}).(\d{1,2})$/g, "$1-$2");
        }(t);
        return r;
    }
    function MU(e) {
        return /(^\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$)/.test(e);
    }
    var LU = {
        socialSecurityNumber: BU
    }, VU = {
        socialSecurityNumber: [
            {
                modes: [
                    "blur"
                ],
                validate: function(e) {
                    return bD(e) ? null : MU(e);
                },
                errorMessage: "boleto.socialSecurityNumber.invalid"
            }
        ],
        taxNumber: [
            {
                modes: [
                    "blur"
                ],
                validate: function(e) {
                    return bD(e) ? null : 6 === (null == e ? void 0 : e.length) || 10 === (null == e ? void 0 : e.length);
                },
                errorMessage: "creditCard.taxNumber.invalid"
            }
        ],
        holderName: [
            {
                modes: [
                    "blur"
                ],
                validate: function(e) {
                    return !bD(e) || null;
                },
                errorMessage: "creditCard.holderName.invalid"
            }
        ],
        default: [
            {
                modes: [
                    "blur"
                ],
                validate: function(e) {
                    return !!e && "string" == typeof e && tE(e).call(e).length > 0;
                }
            }
        ]
    }, UU = t(oy);
    function KU(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var HU = function(e, t) {
        return tC(e).call(e, function(e, r) {
            return e || kb(t).call(t, r.brand);
        }, !1);
    }, qU = function(e) {
        return hC(e).call(e, function(e) {
            return function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r, a, n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Ag(r = KU(Object(n), !0)).call(r, function(t) {
                        Sg(e, t, n[t]);
                    }) : Jy ? ng(e, Jy(n)) : Ag(a = KU(Object(n))).call(a, function(t) {
                        og(e, t, Wy(n, t));
                    });
                }
                return e;
            }({}, e);
        });
    }, WU = function(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "mc", r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "visa", a = qU(e);
        return a[0].brand !== t && a[0].brand !== r && UU(a).call(a), a.length = 1, a;
    };
    function GU(e, t, r) {
        var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, n = e.type, o = e.cvcPolicy, i = t.sfp, l = r.dualBrandSelectElements, c = r.setDualBrandSelectElements, s = r.setSelectedBrandValue, u = r.issuingCountryCode, d = r.setIssuingCountryCode;
        return {
            processBinLookup: function(e, t) {
                var r, l, u, p, m = null != e && e.issuingCountryCode ? e.issuingCountryCode.toLowerCase() : null;
                if (d(m), !e || !Ty(e).length) {
                    c([]), s("");
                    var f = t && "card" !== n ? n : null;
                    return i.current.processBinLookupResponse(e, {
                        brand: f,
                        cvcPolicy: o
                    }), void (a.current = 0);
                }
                if (null !== (r = e.supportedBrands) && void 0 !== r && r.length) {
                    var h = HU(e.supportedBrands, FI), v = h ? WU(e.supportedBrands) : qU(e.supportedBrands);
                    if (v.length > 1) {
                        var y = (l = Vk(v, 2), u = l[0], p = l[1], {
                            dualBrandSelectElements: [
                                {
                                    id: u.brand,
                                    brandObject: u
                                },
                                {
                                    id: p.brand,
                                    brandObject: p
                                }
                            ],
                            selectedBrandValue: "",
                            leadBrand: u
                        });
                        c(y.dualBrandSelectElements), s(y.selectedBrandValue), i.current.processBinLookupResponse({
                            issuingCountryCode: e.issuingCountryCode,
                            supportedBrands: [
                                y.leadBrand
                            ]
                        }), y.leadBrand.panLength > 0 && (a.current = y.leadBrand.panLength);
                    } else c([]), s(""), h || s(v[0].brand), i.current.processBinLookupResponse({
                        issuingCountryCode: e.issuingCountryCode,
                        supportedBrands: v
                    }), v[0].panLength > 0 && (a.current = v[0].panLength);
                }
            },
            handleDualBrandSelection: function(e) {
                var t = e;
                if (e instanceof Event) {
                    var r = e.target;
                    t = r.getAttribute("data-value") || r.getAttribute("alt");
                }
                var a = [];
                t && (a = tC(l).call(l, function(e, r) {
                    return r.brandObject.brand === t && e.push(r.brandObject), e;
                }, [])).length && (s(t), i.current.processBinLookupResponse({
                    issuingCountryCode: u,
                    supportedBrands: a
                }));
            }
        };
    }
    var YU = "holderName", QU = "socialSecurityNumber", ZU = [
        nI,
        oI,
        cI
    ], JU = [
        YU,
        nI,
        oI,
        cI
    ], $U = [
        nI,
        oI,
        cI,
        YU
    ], XU = [
        "taxNumber",
        sI
    ], eK = wb(ZU).call(ZU, XU), tK = wb(JU).call(JU, XU), rK = wb($U).call($U, XU), aK = wb(ZU).call(ZU, [
        QU
    ]), nK = wb(JU).call(JU, [
        QU
    ]), oK = wb($U).call($U, [
        QU
    ]), iK = function(e, t) {
        return t({
            type: "card" === e ? "nocard" : e || "nocard",
            extension: "svg"
        })(e);
    }, lK = function(e, t, r) {
        switch(e){
            case "socialSecurityNumber":
                return t.get("boleto.".concat(e));
            case "street":
            case "houseNumberOrName":
            case "postalCode":
            case "stateOrProvince":
            case "city":
            case "country":
                return null != r && r[e] ? t.get(null == r ? void 0 : r[e]) : t.get(e);
            default:
                return null;
        }
    };
    function cK(e) {
        var t;
        return null !== (t = TI[e]) && void 0 !== t ? t : e;
    }
    var sK = "LoadingWrapper-module_loading-input__form__ffCKa", uK = "LoadingWrapper-module_loading-input__form--loading__7GmVo", dK = "LoadingWrapper-module_loading-input__spinner__GxA51", pK = "LoadingWrapper-module_loading-input__spinner--active__ENNBS", mK = function(e) {
        var t = e.children, r = e.status, a = aP("adyen-checkout__loading-input__form", sK, Sg({}, uK, "loading" === r));
        return rN("div", {
            style: {
                position: "relative"
            }
        }, rN("div", {
            className: aP(Sg(Sg({}, dK, !0), pK, "loading" === r))
        }, rN(nP, null)), rN("div", {
            className: a
        }, t));
    };
    function fK(e) {
        var t = e.frontCVC, r = void 0 !== t && t, a = e.fieldLabel;
        return rN("span", {
            className: aP({
                "adyen-checkout__card__cvc__hint__wrapper": !0,
                "adyen-checkout__field__cvc--front-hint": !!r,
                "adyen-checkout__field__cvc--back-hint": !r
            })
        }, rN("svg", {
            className: "adyen-checkout__card__cvc__hint adyen-checkout__card__cvc__hint--front",
            width: "27",
            height: "18",
            viewBox: "0 0 27 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": !r,
            "aria-describedby": "adyen-checkout__cvc__front-hint-img",
            role: "img"
        }, rN("title", {
            id: "adyen-checkout__cvc__front-hint-img"
        }, a), rN("path", {
            d: "M0 3C0 1.34315 1.34315 0 3 0H24C25.6569 0 27 1.34315 27 3V15C27 16.6569 25.6569 18 24 18H3C1.34315 18 0 16.6569 0 15V3Z",
            fill: "#E6E9EB"
        }), rN("rect", {
            x: "4",
            y: "12",
            width: "19",
            height: "2",
            fill: "#B9C4C9"
        }), rN("rect", {
            x: "4",
            y: "4",
            width: "4",
            height: "4",
            rx: "1",
            fill: "white"
        }), rN("rect", {
            className: "adyen-checkout__card__cvc__hint__location",
            x: "16.5",
            y: "4.5",
            width: "7",
            height: "5",
            rx: "2.5",
            stroke: "#C12424"
        })), rN("svg", {
            className: "adyen-checkout__card__cvc__hint adyen-checkout__card__cvc__hint--back",
            width: "27",
            height: "18",
            viewBox: "0 0 27 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": !!r,
            "aria-describedby": "adyen-checkout__cvc__back-hint-img",
            role: "img"
        }, rN("title", {
            id: "adyen-checkout__cvc__back-hint-img"
        }, a), rN("path", {
            d: "M27 4.00001V3.37501C27 2.4799 26.6444 1.62146 26.0115 0.988518C25.3786 0.355581 24.5201 0 23.625 0H3.375C2.47989 0 1.62145 0.355581 0.988514 0.988518C0.355579 1.62146 0 2.4799 0 3.37501V4.00001H27Z",
            fill: "#E6E9EB"
        }), rN("path", {
            d: "M0 6.99994V14.6666C0 15.5507 0.355579 16.3985 0.988514 17.0237C1.62145 17.6488 2.47989 18 3.375 18H23.625C24.5201 18 25.3786 17.6488 26.0115 17.0237C26.6444 16.3985 27 15.5507 27 14.6666V6.99994H0Z",
            fill: "#E6E9EB"
        }), rN("rect", {
            y: "4.00012",
            width: "27",
            height: "3.00001",
            fill: "#687282"
        }), rN("path", {
            d: "M4 11C4 10.4477 4.44772 10 5 10H21C22.1046 10 23 10.8954 23 12C23 13.1046 22.1046 14 21 14H5C4.44771 14 4 13.5523 4 13V11Z",
            fill: "white"
        }), rN("rect", {
            className: "adyen-checkout__card__cvc__hint__location",
            x: "16.5",
            y: "9.5",
            width: "7",
            height: "5",
            rx: "2.5",
            stroke: "#C12424"
        })));
    }
    var hK = {
        "card-input__wrapper": "CardInput-module_card-input__wrapper__wXSCw",
        "card-input__icon": "CardInput-module_card-input__icon__3Cz5M",
        "card-input__form": "CardInput-module_card-input__form__fRo1r",
        "card-input__spinner": "CardInput-module_card-input__spinner__-j2Qi",
        "card-input__spinner--active": "CardInput-module_card-input__spinner--active__slD7w",
        "card-input__form--loading": "CardInput-module_card-input__form--loading__rrmdj",
        "adyen-checkout__input": "CardInput-module_adyen-checkout__input__11tlB",
        "adyen-checkout__card__cvc__input--hidden": "CardInput-module_adyen-checkout__card__cvc__input--hidden__VIlHV",
        "adyen-checkout__card__exp-date__input--hidden": "CardInput-module_adyen-checkout__card__exp-date__input--hidden__evi6-",
        "adyen-checkout__card__exp-cvc__exp-date__input--hidden": "CardInput-module_adyen-checkout__card__exp-cvc__exp-date__input--hidden__YC3VT",
        "revolving-plan-installments__disabled": "CardInput-module_revolving-plan-installments__disabled__VhNj2"
    };
    function vK(e) {
        return rN("span", Sg(Sg(Sg(Sg({}, EI, e.encryptedFieldType), RI, e["data-info"]), xI, e.uniqueId), "className", e.className), e.children);
    }
    var yK = function(e, t) {
        return rN("div", j_({}, e, {
            "aria-hidden": "true"
        }), t);
    };
    function gK(e) {
        var t, r = e.label, a = e.onFocusField, n = void 0 === a ? function() {} : a, o = e.error, i = void 0 === o ? "" : o, l = e.className, c = void 0 === l ? "" : l, s = e.classNameModifiers, u = void 0 === s ? [] : s, d = e.focused, p = e.filled, m = e.isValid, f = e.frontCVC, h = void 0 !== f && f, v = e.cvcPolicy, y = void 0 === v ? PI : v, g = zP().i18n, b = aP(c, Sg(Sg({
            "adyen-checkout__field__cvc": !0
        }, hK["adyen-checkout__card__cvc__input--hidden"], y === SI), "adyen-checkout__field__cvc--optional", y === wI)), k = aP(Sg({
            "adyen-checkout__input": !0,
            "adyen-checkout__input--small": !0,
            "adyen-checkout__card__cvc__input": !0,
            "adyen-checkout__input--error": i,
            "adyen-checkout__input--focus": d,
            "adyen-checkout__input--valid": m
        }, hK["adyen-checkout__input"], !0)), C = y !== wI ? r : g.get("creditCard.cvcField.title.optional");
        return rN(oD, {
            label: C,
            focused: d,
            filled: p,
            classNameModifiers: wb(t = []).call(t, Uk(u), [
                "securityCode"
            ]),
            onFocusField: function() {
                return n(cI);
            },
            className: b,
            errorMessage: i,
            isValid: m,
            dir: "ltr",
            name: cI,
            i18n: g,
            errorVisibleToScreenReader: !1,
            useLabelElement: !1,
            renderAlternativeToLabel: yK
        }, rN(vK, {
            encryptedFieldType: cI,
            className: k
        }), rN(fK, {
            frontCVC: h,
            fieldLabel: C
        }));
    }
    function bK(e) {
        var t, r, a, n, o = e.brand, i = e.hasCVC, l = e.onFocusField, c = e.errors, s = e.valid, u = e.cvcPolicy, d = e.focusedElement, p = e.lastFour, m = e.expiryMonth, f = e.expiryYear, h = zP().i18n, v = h.get("creditCard.storedCard.description.ariaLabel").replace("%@", p), y = m && f ? wb(t = wb(r = " ".concat(h.get("creditCard.expiryDateField.title"), " ")).call(r, m, "/")).call(t, f) : "";
        return rN("div", {
            className: "adyen-checkout__card__form adyen-checkout__card__form--oneClick",
            "aria-label": wb(a = "".concat(v)).call(a, y)
        }, rN("div", {
            className: "adyen-checkout__card__exp-cvc adyen-checkout__field-wrapper"
        }, m && f && rN(oD, {
            label: h.get("creditCard.expiryDateField.title"),
            className: "adyen-checkout__field--50",
            classNameModifiers: [
                "storedCard"
            ],
            name: "expiryDateField",
            disabled: !0
        }, rN(oE, {
            name: "expiryDateField",
            className: "adyen-checkout__input adyen-checkout__input--disabled adyen-checkout__card__exp-date__input--oneclick",
            value: wb(n = "".concat(m, " / ")).call(n, f),
            readonly: !0,
            disabled: !0,
            dir: "ltr"
        })), i && rN(gK, j_({
            cvcPolicy: u,
            error: function(e, t) {
                return e[t] ? h.get(e[t]) : null;
            }(c, cI),
            focused: "encryptedSecurityCode" === d,
            filled: !!s.encryptedSecurityCode || !!c.encryptedSecurityCode,
            isValid: !!s.encryptedSecurityCode,
            label: h.get("creditCard.cvcField.title"),
            onFocusField: l
        }, m && f && {
            className: "adyen-checkout__field--50"
        }, {
            classNameModifiers: [
                "storedCard"
            ],
            frontCVC: "amex" === o
        }))));
    }
    function kK(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function CK(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = kK(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = kK(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function _K(e) {
        var t, r, a, n, o = zP().i18n, i = e.amount, l = e.brand, c = e.onChange, s = e.type, u = e.installmentOptions[l] || e.installmentOptions.card, d = Vk(fP((null == u ? void 0 : u.preselectedValue) || (null == u ? void 0 : sC(u)[0])), 2), p = d[0], m = d[1], f = Vk(fP("onetime"), 2), h = f[0], v = f[1], y = null == u || null === (t = u.plans) || void 0 === t ? void 0 : kb(t).call(t, "revolving"), g = function(e) {
            var t = e.target.value;
            m(Number(t));
        }, b = function(e) {
            var t, r, a;
            return "amount" === s ? (t = "installmentOption", r = {
                count: e,
                values: {
                    times: e,
                    partialValue: (a = e, o.amount(i.value / a, i.currency))
                }
            }) : (t = "installmentOptionMonths", r = {
                count: e,
                values: {
                    times: e
                }
            }), {
                id: e,
                name: i.value ? o.get(t, r) : "".concat(e)
            };
        };
        return vP(function() {
            var e, t;
            null != u && null !== (e = sC(u)) && void 0 !== e && kb(e).call(e, p) || m(null !== (t = null == u ? void 0 : u.preselectedValue) && void 0 !== t ? t : null == u ? void 0 : sC(u)[0]);
        }, [
            l
        ]), vP(function() {
            var e = CK(CK({
                value: p
            }, y && "revolving" === h && {
                plan: h,
                value: 1
            }), y && "onetime" === h && {
                value: 1
            });
            c(u ? e : {
                value: null
            });
        }, [
            p,
            u,
            h
        ]), u ? 0 === i.value ? null : rN("div", {
            className: "adyen-checkout__installments"
        }, y ? rN(eI, {
            classNameModifiers: [
                "revolving-plan"
            ],
            label: ""
        }, rN(OE, {
            items: [
                {
                    id: "onetime",
                    name: "installments.oneTime"
                },
                {
                    id: "installments",
                    name: "installments.installments"
                },
                {
                    id: "revolving",
                    name: "installments.revolving"
                }
            ],
            onChange: function(e) {
                var t = e.currentTarget.getAttribute("value");
                v(t);
            },
            value: h
        }), rN(oD, {
            className: "".concat("installments" !== h ? hK["revolving-plan-installments__disabled"] : hK["revolving-plan-installments"]),
            classNameModifiers: [
                "revolving-plan-installments"
            ],
            name: "",
            useLabelElement: !1,
            addContextualElement: !1
        }, rN(OT, {
            filterable: !1,
            items: hC(n = sC(u)).call(n, b),
            selectedValue: p,
            onChange: g,
            name: "installments",
            disabled: "installments" !== h
        }))) : rN(oD, {
            label: o.get("installments"),
            classNameModifiers: [
                "installments"
            ],
            name: "",
            useLabelElement: !1,
            addContextualElement: !1
        }, rN(OT, {
            filterable: !1,
            items: hC(r = sC(u)).call(r, b),
            selectedValue: p,
            onChange: g,
            name: "installments",
            readonly: 1 === (null == u || null === (a = sC(u)) || void 0 === a ? void 0 : a.length)
        }))) : null;
    }
    _K.defaultProps = {
        brand: "",
        amount: {},
        onChange: function() {}
    };
    var NK = function(e) {
        var t = e.sfpState, r = e.setFocusOn, a = e.cvcPolicy, n = e.focusedElement, o = e.hasInstallments, i = e.handleInstallments, l = e.showAmountsInInstallments, c = e.amount, s = e.hasCVC, u = e.installmentOptions, d = e.lastFour, p = e.expiryMonth, m = e.expiryYear, f = e.disclaimerMessage;
        return rN(mK, {
            status: t.status
        }, rN(bK, {
            errors: t.errors,
            brand: t.brand,
            hasCVC: s,
            cvcPolicy: a,
            onFocusField: r,
            focusedElement: n,
            valid: t.valid,
            lastFour: d,
            expiryMonth: p,
            expiryYear: m
        }), o && rN(_K, {
            amount: c,
            brand: t.brand,
            installmentOptions: u,
            onChange: i,
            type: l ? "amount" : "months"
        }), f && rN(CL, {
            message: f.message.replace("%{linkText}", "%#".concat(f.linkText, "%#")),
            urls: [
                f.link
            ]
        }));
    };
    function PK(e) {
        var t, r, a = e.brand, n = e.brandsConfiguration, o = void 0 === n ? {} : n, i = tI(), l = "card" === a ? "nocard" : a, c = null !== (t = null === (r = o[a]) || void 0 === r ? void 0 : r.icon) && void 0 !== t ? t : iK(l, i);
        return rN("img", {
            className: "".concat(hK["card-input__icon"], " adyen-checkout__card__cardNumber__brandIcon"),
            onError: function(e) {
                e.target.style.cssText = "display: none";
            },
            alt: cK(a),
            src: c
        });
    }
    var wK = function(e) {
        var t, r, a, n = e.brand, o = e.onClick, i = e.dataValue, l = e.notSelected, c = e.brandsConfiguration, s = void 0 === c ? {} : c, u = tI(), d = "card" === n ? "nocard" : n, p = null !== (t = null === (r = s[n]) || void 0 === r ? void 0 : r.icon) && void 0 !== t ? t : iK(d, u);
        return rN("img", {
            className: wb(a = "".concat(hK["card-input__icon"], " ")).call(a, l ? "adyen-checkout__card__cardNumber__brandIcon--not-selected" : "", " adyen-checkout__card__cardNumber__brandIcon"),
            onError: function(e) {
                e.target.style.cssText = "display: none";
            },
            alt: cK(n),
            src: p,
            onClick: o,
            "data-value": i
        });
    };
    function SK(e) {
        var t = zP().i18n, r = e.error, a = void 0 === r ? "" : r, n = e.isValid, o = void 0 !== n && n, i = e.onFocusField, l = void 0 === i ? function() {} : i, c = e.dualBrandingElements, s = e.dualBrandingChangeHandler, u = e.dualBrandingSelected;
        return rN(oD, {
            label: e.label,
            focused: e.focused,
            filled: e.filled,
            classNameModifiers: [
                "cardNumber"
            ],
            onFocusField: function() {
                return l(nI);
            },
            errorMessage: a,
            isValid: o,
            dir: "ltr",
            name: nI,
            showValidIcon: !1,
            i18n: t,
            errorVisibleToScreenReader: !1,
            useLabelElement: !1,
            renderAlternativeToLabel: yK
        }, rN(vK, {
            encryptedFieldType: nI,
            className: aP(Sg(Sg(Sg(Sg(Sg({
                "adyen-checkout__input": !0,
                "adyen-checkout__input--large": !0,
                "adyen-checkout__card__cardNumber__input": !0
            }, hK["adyen-checkout__input"], !0), "adyen-checkout__input--error", a), "adyen-checkout__input--focus", e.focused), "adyen-checkout__input--valid", o), "adyen-checkout__card__cardNumber__input--noBrand", !e.showBrandIcon))
        }, e.showBrandIcon && !c && rN(PK, {
            brandsConfiguration: e.brandsConfiguration,
            brand: e.brand
        })), c && !a && rN("div", {
            className: aP([
                "adyen-checkout__card__dual-branding__buttons",
                {
                    "adyen-checkout__card__dual-branding__buttons--active": o
                }
            ])
        }, hC(c).call(c, function(t) {
            return rN(wK, {
                key: t.id,
                brand: t.id,
                brandsConfiguration: e.brandsConfiguration,
                onClick: s,
                dataValue: t.id,
                notSelected: "" !== u && u !== t.id
            });
        })));
    }
    function AK(e) {
        var t, r = e.label, a = e.focused, n = e.filled, o = e.onFocusField, i = e.className, l = void 0 === i ? "" : i, c = e.error, s = void 0 === c ? "" : c, u = e.isValid, d = void 0 !== u && u, p = e.expiryDatePolicy, m = void 0 === p ? AI : p, f = zP().i18n, h = tI(), v = aP(l, Sg(Sg({
            "adyen-checkout__field__exp-date": !0
        }, hK["adyen-checkout__card__exp-date__input--hidden"], m === DI), "adyen-checkout__field__exp-date--optional", m === II)), y = m !== II ? r : wb(t = "".concat(r, " ")).call(t, f.get("field.title.optional"));
        return rN(oD, {
            label: y,
            classNameModifiers: [
                "expiryDate"
            ],
            className: v,
            focused: a,
            filled: n,
            onFocusField: function() {
                return o(oI);
            },
            errorMessage: s,
            isValid: d,
            dir: "ltr",
            name: "encryptedExpiryDate",
            i18n: f,
            errorVisibleToScreenReader: !1,
            useLabelElement: !1,
            renderAlternativeToLabel: yK
        }, rN(vK, {
            encryptedFieldType: oI,
            className: aP("adyen-checkout__input", "adyen-checkout__input--small", "adyen-checkout__card__exp-date__input", [
                hK["adyen-checkout__input"]
            ], {
                "adyen-checkout__input--error": s,
                "adyen-checkout__input--focus": a,
                "adyen-checkout__input--valid": d
            })
        }), rN("span", {
            className: aP("adyen-checkout__field__exp-date_hint_wrapper", [
                hK["checkout__field__exp-date_hint_wrapper"]
            ], {
                "adyen-checkout__field__exp-date_hint_wrapper--hidden": s || d
            })
        }, rN("img", {
            src: h({
                imageFolder: "components/"
            })("expiry_date_hint"),
            className: "adyen-checkout__field__exp-date_hint",
            alt: y
        })));
    }
    var IK = function(e) {
        var t = e.brands, r = e.activeBrand;
        return null != t && t.length ? rN("span", {
            className: aP("adyen-checkout__card__brands", {
                "adyen-checkout__card__brands--hidden": "card" !== r
            })
        }, hC(t).call(t, function(e) {
            var t = e.name;
            return rN("span", {
                key: t,
                className: "adyen-checkout__card__brands__brand-wrapper"
            }, rN(ST, {
                src: e.icon,
                alt: cK(t)
            }));
        })) : null;
    };
    function DK(e) {
        var t = e.brand, r = e.brandsIcons, a = e.brandsConfiguration, n = e.dualBrandingElements, o = e.dualBrandingChangeHandler, i = e.dualBrandingSelected, l = e.errors, c = e.focusedElement, s = e.hasCVC, u = e.cvcPolicy, d = e.expiryDatePolicy, p = e.onFocusField, m = e.showBrandIcon, f = e.showBrandsUnderCardNumber, h = e.valid, v = zP().i18n, y = function(e, t) {
            return e[t] ? v.get(e[t]) : null;
        }, g = null == r ? void 0 : Fg(r).call(r, function(e) {
            return !(null != FI && kb(FI).call(FI, e.name));
        });
        return rN("div", {
            className: "adyen-checkout__card__form"
        }, rN(SK, {
            brand: t,
            brandsConfiguration: a,
            error: y(l, nI),
            focused: c === nI,
            isValid: !!h.encryptedCardNumber,
            label: v.get("creditCard.numberField.title"),
            onFocusField: p,
            filled: !!l.encryptedCardNumber || !!h.encryptedCardNumber,
            showBrandIcon: m,
            dualBrandingElements: n,
            dualBrandingChangeHandler: o,
            dualBrandingSelected: i
        }), f && rN(IK, {
            activeBrand: t,
            brands: g
        }), rN("div", {
            className: aP("adyen-checkout__card__exp-cvc adyen-checkout__field-wrapper", Sg({}, hK["adyen-checkout__card__exp-cvc__exp-date__input--hidden"], d === DI))
        }, rN(AK, {
            error: y(l, oI),
            focused: c === oI,
            isValid: !!h.encryptedExpiryMonth && !!h.encryptedExpiryYear,
            filled: !!l.encryptedExpiryDate || !!h.encryptedExpiryYear,
            label: v.get("creditCard.expiryDateField.title"),
            onFocusField: p,
            className: "adyen-checkout__field--50",
            expiryDatePolicy: d
        }), s && rN(gK, {
            error: y(l, cI),
            focused: c === cI,
            cvcPolicy: u,
            isValid: !!h.encryptedSecurityCode,
            filled: !!l.encryptedSecurityCode || !!h.encryptedSecurityCode,
            label: v.get("creditCard.cvcField.title"),
            onFocusField: p,
            className: "adyen-checkout__field--50",
            frontCVC: "amex" === t
        })));
    }
    function EK(e) {
        var t = zP().i18n, r = bP(function() {
            var r;
            return (null === (r = e.value) || void 0 === r ? void 0 : r.length) > 6 ? t.get("creditCard.taxNumber.labelAlt") : t.get("creditCard.taxNumber.label");
        }, [
            e.value
        ]);
        return rN("div", {
            className: "adyen-checkout__card__kcp-authentication"
        }, rN(oD, {
            label: r,
            filled: e.filled,
            classNameModifiers: [
                "kcp-taxNumber"
            ],
            errorMessage: e.error && t.get("creditCard.taxNumber.invalid"),
            isValid: e.isValid,
            dir: "ltr",
            name: "kcpTaxNumberOrDOB"
        }, rN(ME, {
            name: "kcpTaxNumberOrDOB",
            className: "adyen-checkout__card__kcp-taxNumber__input ".concat(hK["adyen-checkout__input"]),
            placeholder: t.get("creditCard.taxNumber.placeholder"),
            maxLength: 10,
            minLength: 6,
            autoComplete: "false",
            value: e.value,
            required: !0,
            onBlur: e.onBlur,
            onInput: e.onInput,
            disabled: e.disabled
        })), rN(oD, {
            label: t.get("creditCard.encryptedPassword.label"),
            focused: "encryptedPassword" === e.focusedElement,
            filled: e.filled,
            classNameModifiers: [
                "50",
                "koreanAuthentication-encryptedPassword"
            ],
            onFocusField: function() {
                return e.onFocusField("encryptedPassword");
            },
            errorMessage: e.encryptedPasswordState.errors && t.get(String(e.encryptedPasswordState.errors)),
            isValid: e.encryptedPasswordState.valid,
            dir: "ltr",
            name: "encryptedPassword"
        }, rN(vK, {
            encryptedFieldType: "encryptedPassword",
            className: aP(Sg(Sg(Sg(Sg({
                "adyen-checkout__input": !0,
                "adyen-checkout__input--large": !0
            }, hK["adyen-checkout__input"], !0), "adyen-checkout__input--error", e.encryptedPasswordState.errors), "adyen-checkout__input--valid", e.encryptedPasswordState.valid), "adyen-checkout__input--focus", "encryptedPassword" === e.focusedElement))
        })));
    }
    function RK(e) {
        var t = e.onBlur, r = e.onInput, a = e.valid, n = void 0 !== a && a, o = e.error, i = void 0 === o ? null : o, l = e.data, c = void 0 === l ? "" : l, s = e.required, u = void 0 !== s && s, d = e.disabled, p = void 0 !== d && d, m = zP().i18n;
        return rN(oD, {
            label: "".concat(m.get("boleto.socialSecurityNumber")),
            classNameModifiers: [
                "socialSecurityNumber"
            ],
            errorMessage: i && i.errorMessage ? m.get(i.errorMessage) : !!i,
            isValid: Boolean(n),
            name: "socialSecurityNumber"
        }, rN(oE, {
            name: "socialSecurityNumber",
            autocorrect: "off",
            spellcheck: !1,
            value: c,
            maxLength: 18,
            onInput: r,
            onBlur: t,
            required: u,
            disabled: p
        }));
    }
    var xK = [
        "storeDetails"
    ];
    function FK(e) {
        var t = e.storeDetails, r = void 0 !== t && t, a = kg(e, xK), n = zP().i18n, o = Vk(fP(r), 2), i = o[0], l = o[1];
        return vP(function() {
            a.onChange(i);
        }, [
            i
        ]), rN("div", {
            className: "adyen-checkout__store-details"
        }, rN(dz, {
            onChange: function(e) {
                l(e.target.checked);
            },
            label: n.get("storeDetails"),
            name: "storeDetails"
        }));
    }
    function TK(e) {
        var t = e.onBlur, r = e.onInput, a = e.placeholder, n = e.value, o = e.required, i = e.error, l = void 0 !== i && i, c = e.isValid, s = e.disabled, u = zP().i18n;
        return rN(oD, {
            label: u.get("creditCard.holderName"),
            className: "adyen-checkout__card__holderName",
            errorMessage: l && u.get("creditCard.holderName.invalid"),
            isValid: !!c,
            name: "holderName",
            i18n: u
        }, rN(oE, {
            name: "holderName",
            className: "adyen-checkout__card__holderName__input ".concat(hK["adyen-checkout__input"]),
            placeholder: a || u.get("creditCard.holderName.placeholder"),
            autocomplete: "cc-name",
            value: n,
            required: o,
            onBlur: t,
            onInput: r,
            disabled: s
        }));
    }
    var zK = function(e) {
        var t = e.data, r = e.valid, a = e.errors, n = e.handleChangeFor, o = e.sfpState, i = e.setFocusOn, l = e.cvcPolicy, c = e.focusedElement, s = e.hasInstallments, u = e.handleInstallments, d = e.showAmountsInInstallments, p = e.brandsIcons, m = e.formData, f = e.formErrors, h = e.formValid, v = e.expiryDatePolicy, y = e.dualBrandSelectElements, g = e.extensions, b = e.selectedBrandValue, k = e.showKCP, C = e.showBrazilianSSN, _ = e.socialSecurityNumber, N = e.handleOnStoreDetails, P = e.billingAddress, w = e.handleAddress, S = e.setAddressRef, A = e.partialAddressSchema, I = e.onAddressLookup, D = e.onAddressSelected, E = e.addressSearchDebounceMs, R = e.amount, x = e.billingAddressRequired, F = e.billingAddressRequiredFields, T = e.billingAddressAllowedCountries, z = e.billingAddressValidationRules, O = void 0 === z ? null : z, j = e.brandsConfiguration, B = e.enableStoreDetails, M = e.hasCVC, L = e.hasHolderName, V = e.holderNameRequired, U = e.installmentOptions, K = e.placeholders, H = e.positionHolderNameOnTop, q = e.showBrandIcon, W = e.showBrandsUnderCardNumber, G = e.iOSFocusedField, Y = e.disclaimerMessage, Q = rN(TK, {
            required: V,
            placeholder: K.holderName,
            value: m.holderName,
            error: !!f.holderName && V,
            isValid: !!h.holderName,
            onBlur: n("holderName", "blur"),
            onInput: n("holderName", "input"),
            disabled: G && "holderName" !== G
        });
        return rN(mK, {
            status: o.status
        }, L && H && Q, rN(DK, {
            showBrandIcon: q,
            showBrandsUnderCardNumber: W,
            brand: o.brand,
            brandsIcons: p,
            brandsConfiguration: j,
            focusedElement: c,
            onFocusField: i,
            hasCVC: M,
            cvcPolicy: l,
            expiryDatePolicy: v,
            errors: o.errors,
            valid: o.valid,
            dualBrandingElements: y.length > 0 && y,
            dualBrandingChangeHandler: g.handleDualBrandSelection,
            dualBrandingSelected: b
        }), L && !H && Q, k && rN(EK, {
            onFocusField: i,
            focusedElement: c,
            encryptedPasswordState: {
                data: o.encryptedPassword,
                valid: !!o.valid && o.valid.encryptedPassword,
                errors: !!o.errors && o.errors.encryptedPassword
            },
            value: t.taxNumber,
            error: !!a.taxNumber,
            isValid: !!r.taxNumber,
            onBlur: n("taxNumber", "blur"),
            onInput: n("taxNumber", "input"),
            disabled: G && "kcpTaxNumberOrDOB" !== G
        }), C && rN("div", {
            className: "adyen-checkout__card__socialSecurityNumber"
        }, rN(RK, {
            onBlur: n("socialSecurityNumber", "blur"),
            onInput: n("socialSecurityNumber", "input"),
            error: null == a ? void 0 : a.socialSecurityNumber,
            valid: null == r ? void 0 : r.socialSecurityNumber,
            data: _,
            required: !0,
            disabled: G && "socialSecurityNumber" !== G
        })), B && rN(FK, {
            onChange: N
        }), s && rN(_K, {
            amount: R,
            brand: o.brand,
            installmentOptions: U,
            onChange: u,
            type: d ? "amount" : "months"
        }), x && rN(cz, {
            label: "billingAddress",
            data: P,
            onChange: w,
            allowedCountries: T,
            requiredFields: F,
            setComponentRef: S,
            validationRules: O,
            specifications: A,
            iOSFocusedField: G,
            onAddressLookup: I,
            onAddressSelected: D,
            addressSearchDebounceMs: E
        }), Y && rN(CL, {
            message: Y.message.replace("%{linkText}", "%#".concat(Y.linkText, "%#")),
            urls: [
                Y.link
            ]
        }));
    }, OK = t(jk), jK = t(kk);
    function BK(e, t) {
        var r = void 0 !== SR && jK(e) || e["@@iterator"];
        if (!r) {
            if (JN(e) || (r = function(e, t) {
                var r;
                if (!e) return;
                if ("string" == typeof e) return MK(e, t);
                var a = xA(r = Object.prototype.toString.call(e)).call(r, 8, -1);
                "Object" === a && e.constructor && (a = e.constructor.name);
                if ("Map" === a || "Set" === a) return OK(e);
                if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return MK(e, t);
            }(e)) || t && e && "number" == typeof e.length) {
                r && (e = r);
                var a = 0, n = function() {};
                return {
                    s: n,
                    n: function() {
                        return a >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[a++]
                        };
                    },
                    e: function(e) {
                        throw e;
                    },
                    f: n
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var o, i = !0, l = !1;
        return {
            s: function() {
                r = r.call(e);
            },
            n: function() {
                var e = r.next();
                return i = e.done, e;
            },
            e: function(e) {
                l = !0, o = e;
            },
            f: function() {
                try {
                    i || null == r.return || r.return();
                } finally{
                    if (l) throw o;
                }
            }
        };
    }
    function MK(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, a = new Array(t); r < t; r++)a[r] = e[r];
        return a;
    }
    var LK = function(e, t) {
        var r = e;
        if ("taxNumber" === r && (r = "kcpTaxNumberOrDOB"), "country" === r || "stateOrProvince" === r) {
            var a = CO(t.current.rootNode, ".adyen-checkout__field--".concat(r, " .adyen-checkout__filter-input"));
            null == a || a.focus();
        } else {
            var n = CO(t.current.rootNode, '[name="'.concat(r, '"]'));
            null == n || n.focus();
        }
    }, VK = [
        "billingAddress"
    ];
    function UK(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function KK(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = UK(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = UK(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var HK = function(e) {
        var t, r, a, n = gP(null), o = gP(!1), i = tI(), l = bO(), c = l.setSRMessagesFromObjects, s = l.setSRMessagesFromStrings, u = l.clearSRPanel, d = l.shouldMoveFocusSR, p = null == c ? void 0 : c({
            fieldTypeMappingFn: lK
        }), m = gP(null), f = function(e) {
            m.current = e;
        }, h = gP({});
        Ty(h.current).length || e.setComponentRef(h.current);
        var v = gP(0), y = gP(!1), g = bP(function() {
            return new az(e.specifications);
        }, [
            e.specifications
        ]);
        h.current.sfp = n;
        var b = Vk(fP("ready"), 2), k = b[0], C = b[1], _ = Vk(fP({}), 2), N = _[0], P = _[1], w = Vk(fP(KK({}, e.holderNameRequired && {
            holderName: !1
        })), 2), S = w[0], A = w[1], I = Vk(fP(KK({}, e.hasHolderName && {
            holderName: null !== (t = e.data.holderName) && void 0 !== t ? t : ""
        })), 2), D = I[0], E = I[1], R = Vk(fP(null), 2), x = R[0], F = R[1], T = Vk(fP(""), 2), z = T[0], O = T[1], j = Vk(fP(!1), 2), B = j[0], M = j[1], L = Vk(fP(AI), 2), V = L[0], U = L[1], K = Vk(fP(PI), 2), H = K[0], q = K[1], W = Vk(fP(null), 2), G = W[0], Y = W[1], Q = Vk(fP([]), 2), Z = Q[0], J = Q[1], $ = Vk(fP(""), 2), X = $[0], ee = $[1], te = e.billingAddressMode !== TU.none && e.billingAddressRequired, re = e.billingAddressMode == TU.partial ? tR : null, ae = gP(re && (null === (r = e.data) || void 0 === r || null === (r = r.billingAddress) || void 0 === r ? void 0 : r.country)), ne = Vk(fP(!1), 2), oe = ne[0], ie = ne[1], le = Vk(fP(te ? e.data.billingAddress : null), 2), ce = le[0], se = le[1], ue = Vk(fP(!1), 2), de = ue[0], pe = ue[1], me = Vk(fP(""), 2), fe = me[0], he = me[1], ve = Vk(fP({
            value: null
        }), 2), ye = ve[0], ge = ve[1], be = Vk(fP(null), 2), ke = be[0], Ce = be[1], _e = QD({
            schema: [],
            defaultData: e.data,
            formatters: LU,
            rules: VU
        }), Ne = _e.handleChangeFor, Pe = _e.triggerValidation, we = _e.data, Se = _e.valid, Ae = _e.errors, Ie = _e.setSchema, De = _e.setData, Ee = _e.setValid, Re = _e.setErrors, xe = !!Ty(e.installmentOptions).length && "debit" !== e.fundingSource, Fe = null === (a = e.showInstallmentAmounts) || void 0 === a || a, Te = "kr" === (null != G ? G : e.countryCode), ze = e.configuration.koreanAuthenticationRequired && Te, Oe = de && "auto" === e.configuration.socialSecurityNumberMode || "show" === e.configuration.socialSecurityNumberMode, je = function(e, t, r) {
            return function(a) {
                e(a.currentFocusObject), !0 === a.focus ? t(a) : r(a);
            };
        }(O, e.onFocus, e.onBlur), Be = function() {
            return function(e) {
                var t = e.props, r = e.showKCP, a = e.showBrazilianSSN, n = e.countrySpecificSchemas, o = void 0 === n ? null : n, i = e.billingAddressRequiredFields, l = void 0 === i ? null : i, c = ZU, s = t.hasHolderName && t.holderNameRequired;
                if (s && (c = t.positionHolderNameOnTop ? JU : $U), r && (c = eK, s && (c = t.positionHolderNameOnTop ? tK : rK)), a && (c = aK, s && (c = t.positionHolderNameOnTop ? nK : oK)), o) {
                    var u, d = Fg(u = ez(o).call(o, 2)).call(u, function(e) {
                        return "number" != typeof e;
                    }), p = d;
                    l && (p = Fg(d).call(d, function(e) {
                        return kb(l).call(l, e);
                    })), c = wb(ZU).call(ZU, p), s && (c = t.positionHolderNameOnTop ? wb(JU).call(JU, p) : wb($U).call($U, p));
                }
                return c;
            }(KK({
                props: e,
                showKCP: ze,
                showBrazilianSSN: Oe
            }, e.billingAddressRequired && {
                countrySpecificSchemas: g.getAddressSchemaForCountry(null == ce ? void 0 : ce.country),
                billingAddressRequiredFields: e.billingAddressRequiredFields
            }));
        }, Me = kP(function(e) {
            var t = "webInternalElement" !== e.fieldType ? e.fieldType : e.name;
            Ce(t);
        }, []), Le = function(e, t, r) {
            return function(a) {
                e("billingAddress", a.data), t("billingAddress", a.isValid), r("billingAddress", a.errors);
            };
        }(De, Ee, Re), Ve = function(e, t, r) {
            return function() {
                e.current || (e.current = !0, Sb.resolve().then(function() {
                    var a, n = gT(r).call(r, function(e) {
                        return e === nI;
                    }), o = BK(xA(r).call(r, n + 1));
                    try {
                        for(o.s(); !(a = o.n()).done;){
                            var i = a.value;
                            if (!kb(yI).call(yI, i)) {
                                LK(i, t);
                                break;
                            }
                            if (!t.current.sfIsOptionalOrHidden(i)) {
                                t.current.setFocusOn(i);
                                break;
                            }
                        }
                    } catch (e) {
                        o.e(e);
                    } finally{
                        o.f();
                    }
                    e.current = !1;
                }));
            };
        }(y, n, Be()), Ue = bP(function() {
            return GU(e, {
                sfp: n
            }, {
                dualBrandSelectElements: Z,
                setDualBrandSelectElements: J,
                setSelectedBrandValue: ee,
                issuingCountryCode: G,
                setIssuingCountryCode: Y
            }, v);
        }, [
            Z,
            G
        ]);
        h.current.showValidation = function() {
            o.current = !0, null == u || u(), n.current.showValidation(), Pe([
                "holderName",
                "socialSecurityNumber",
                "taxNumber"
            ]), null != m && m.current && m.current.showValidation();
        }, h.current.processBinLookupResponse = function(e, t) {
            Ue.processBinLookup(e, t);
        }, h.current.setStatus = C, vP(function() {
            return h.current.setFocusOn = n.current.setFocusOn, h.current.updateStyles = n.current.updateStyles, h.current.handleUnsupportedCard = n.current.handleUnsupportedCard, function() {
                n.current.destroy();
            };
        }, []), vP(function() {
            var t, r = wb(t = []).call(t, Uk(e.hasHolderName ? [
                "holderName"
            ] : []), Uk(Oe ? [
                "socialSecurityNumber"
            ] : []), Uk(ze ? [
                "taxNumber"
            ] : []), Uk(te ? [
                "billingAddress"
            ] : []));
            Ie(r);
        }, [
            e.hasHolderName,
            Oe,
            ze
        ]), vP(function() {
            var t, r;
            E(KK(KK({}, D), {}, {
                holderName: null !== (t = we.holderName) && void 0 !== t ? t : "",
                taxNumber: we.taxNumber
            })), he(we.socialSecurityNumber), te && se(KK({}, we.billingAddress)), A(KK(KK({}, S), {}, {
                holderName: !e.holderNameRequired || Se.holderName,
                socialSecurityNumber: !!Se.socialSecurityNumber && Se.socialSecurityNumber,
                taxNumber: !!Se.taxNumber && Se.taxNumber,
                billingAddress: !!Se.billingAddress && Se.billingAddress
            }));
            var a = !!Ae.billingAddress && tC(r = Tz(Ae.billingAddress)).call(r, function(e, t) {
                var r = Vk(t, 2)[1];
                return e || null != r;
            }, !1);
            P(KK(KK({}, N), {}, {
                holderName: e.holderNameRequired && Ae.holderName ? Ae.holderName : null,
                socialSecurityNumber: Oe && Ae.socialSecurityNumber ? Ae.socialSecurityNumber : null,
                taxNumber: ze && Ae.taxNumber ? Ae.taxNumber : null,
                billingAddress: te && a ? Ae.billingAddress : null
            }));
        }, [
            we,
            Se,
            Ae
        ]);
        var Ke = SO(x);
        vP(function() {
            var t, r, a = S.holderName, i = B, l = !te || S.billingAddress, c = !ze || !!S.taxNumber && !!S.encryptedPassword, m = !Oe || !!S.socialSecurityNumber, f = i && a && l && c && m, h = n.current.mapErrorsToValidationRuleResult(), v = KK(KK({}, N), h), y = v.billingAddress, b = KK(KK({}, kg(v, VK)), y), k = null == p ? void 0 : p({
                errors: b,
                isValidating: o.current,
                layout: Be(),
                countrySpecificLabels: null !== (t = g.getAddressLabelsForCountry(null == ce ? void 0 : ce.country)) && void 0 !== t ? t : null == re || null === (r = re.default) || void 0 === r ? void 0 : r.labels
            }), C = null == k ? void 0 : k.currentErrorsSortedByLayout;
            switch(F(C), null == k ? void 0 : k.action){
                case QI:
                    d && function(e, t, r) {
                        e && (kb(yI).call(yI, r) ? t.current.setFocusOn(r) : LK(r, t));
                    }(o.current, n, null == k ? void 0 : k.fieldToFocus), ZN(function() {
                        o.current = !1;
                    }, 300);
                    break;
                case ZI:
                    var _ = AO(C, Ke, "field"), P = null == _ ? void 0 : _[0];
                    if (P) {
                        var w = function(e) {
                            var t;
                            return !kb(t = [
                                "error.va.sf-cc-num.03",
                                "error.va.sf-cc-dat.01",
                                "error.va.sf-cc-dat.02",
                                "error.va.sf-cc-dat.03"
                            ]).call(t, e);
                        }(P.errorCode), A = w ? P.errorMessage : null;
                        s(A);
                    } else u();
            }
            e.onChange({
                data: D,
                valid: S,
                errors: v,
                isValid: f,
                billingAddress: ce,
                selectedBrandValue: X,
                storePaymentMethod: oe,
                socialSecurityNumber: fe,
                installments: ye
            });
        }, [
            D,
            S,
            N,
            X,
            oe,
            ye
        ]);
        var He = e.storedPaymentMethodId ? NK : zK;
        return rN(nN, null, rN(FU, j_({
            ref: n
        }, function(e) {
            return {
                allowedDOMAccess: e.allowedDOMAccess,
                autoFocus: e.autoFocus,
                brands: e.brands,
                brandsConfiguration: e.brandsConfiguration,
                clientKey: e.clientKey,
                countryCode: e.countryCode,
                forceCompat: e.forceCompat,
                i18n: e.i18n,
                implementationType: e.implementationType,
                keypadFix: e.keypadFix,
                legacyInputMode: e.legacyInputMode,
                loadingContext: e.loadingContext,
                minimumExpiryDate: e.minimumExpiryDate,
                onAdditionalSFConfig: e.onAdditionalSFConfig,
                onAdditionalSFRemoved: e.onAdditionalSFRemoved,
                onAllValid: e.onAllValid,
                onAutoComplete: e.onAutoComplete,
                onBinValue: e.onBinValue,
                onConfigSuccess: e.onConfigSuccess,
                onError: e.onError,
                onFieldValid: e.onFieldValid,
                onLoad: e.onLoad,
                showWarnings: e.showWarnings,
                trimTrailingSeparator: e.trimTrailingSeparator,
                maskSecurityCode: e.maskSecurityCode,
                resources: e.resources
            };
        }(e), {
            styles: KK(KK({}, OU), e.styles),
            koreanAuthenticationRequired: e.configuration.koreanAuthenticationRequired,
            hasKoreanFields: !(!e.configuration.koreanAuthenticationRequired || "kr" !== e.countryCode),
            onChange: function(t, r) {
                var a;
                if (t.autoCompleteName) {
                    if (!e.hasHolderName) return;
                    var n = (i = "blur", c = tC(l = VU["holderName"]).call(l, function(e, t) {
                        var r;
                        return e.length || kb(r = t.modes).call(r, i) && e.push(t.validate), e;
                    }, []), c[0]), o = n(t.autoCompleteName) ? t.autoCompleteName : null;
                    o && (De("holderName", o), Ee("holderName", !0), Re("holderName", null));
                } else {
                    var i, l, c;
                    e.autoFocus && v.current > 0 && (!S.encryptedCardNumber && null !== (a = t.valid) && void 0 !== a && a.encryptedCardNumber || S.encryptedCardNumber && t.valid.encryptedCardNumber && "handleOnBrand" === (null == r ? void 0 : r.event)) && Ve(), E(KK(KK({}, D), t.data)), P(KK(KK({}, N), t.errors)), A(KK(KK({}, S), t.valid)), M(t.isSfpValid), q(t.cvcPolicy), pe(t.showSocialSecurityNumber), U(t.expiryDatePolicy);
                }
            },
            onBrand: e.onBrand,
            onFocus: je,
            type: e.brand,
            disableIOSArrowKeys: e.disableIOSArrowKeys ? Me : null,
            render: function(t, r) {
                var a, n = t.setRootNode, o = t.setFocusOn;
                return rN("div", {
                    ref: n,
                    className: aP(Sg(Sg(Sg({
                        "adyen-checkout__card-input": !0
                    }, hK["card-input__wrapper"], !0), "adyen-checkout__card-input--".concat(null !== (a = e.fundingSource) && void 0 !== a ? a : "credit"), !0), "adyen-checkout__card-input--loading", "loading" === k)),
                    role: "form"
                }, e.showFormInstruction && rN(IO, null), rN(He, j_({}, function(e) {
                    return {
                        amount: e.amount,
                        billingAddressRequired: e.billingAddressRequired,
                        billingAddressRequiredFields: e.billingAddressRequiredFields,
                        billingAddressAllowedCountries: e.billingAddressAllowedCountries,
                        brandsConfiguration: e.brandsConfiguration,
                        enableStoreDetails: e.enableStoreDetails,
                        hasCVC: e.hasCVC,
                        hasHolderName: e.hasHolderName,
                        holderNameRequired: e.holderNameRequired,
                        installmentOptions: e.installmentOptions,
                        placeholders: e.placeholders,
                        positionHolderNameOnTop: e.positionHolderNameOnTop,
                        showBrandIcon: e.showBrandIcon,
                        showBrandsUnderCardNumber: e.showBrandsUnderCardNumber,
                        lastFour: e.lastFour,
                        expiryMonth: e.expiryMonth,
                        expiryYear: e.expiryYear,
                        disclaimerMessage: e.disclaimerMessage
                    };
                }(e), {
                    data: D,
                    valid: S,
                    errors: N,
                    handleChangeFor: Ne,
                    focusedElement: z,
                    setFocusOn: o,
                    sfpState: r,
                    cvcPolicy: H,
                    hasInstallments: xe,
                    showAmountsInInstallments: Fe,
                    handleInstallments: ge,
                    brandsIcons: e.brandsIcons,
                    formData: we,
                    formErrors: Ae,
                    formValid: Se,
                    expiryDatePolicy: V,
                    dualBrandSelectElements: Z,
                    extensions: Ue,
                    selectedBrandValue: X,
                    showKCP: ze,
                    showBrazilianSSN: Oe,
                    socialSecurityNumber: fe,
                    handleOnStoreDetails: ie,
                    setAddressRef: f,
                    billingAddress: ce,
                    billingAddressValidationRules: re && _R(ae.current),
                    partialAddressSchema: re,
                    handleAddress: Le,
                    onAddressLookup: e.onAddressLookup,
                    onAddressSelected: e.onAddressSelected,
                    addressSearchDebounceMs: e.addressSearchDebounceMs,
                    iOSFocusedField: ke
                })));
            }
        })), e.showPayButton && e.payButton({
            status: k,
            variant: e.isPayButtonPrimaryVariant ? "primary" : "secondary",
            icon: i({
                imageFolder: "components/"
            })("lock")
        }));
    };
    function qK(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    HK.defaultProps = zU;
    var WK = function(e) {
        var t = null;
        return function(r) {
            if (!1 !== e.props.doBinLookup) {
                if (r.encryptedBin && e.props.clientKey) t = r.uuid, cT({
                    loadingContext: e.props.loadingContext,
                    path: "v3/bin/binLookup?token=".concat(e.props.clientKey)
                }, {
                    type: e.props.type,
                    supportedBrands: e.props.brands || hI,
                    encryptedBin: r.encryptedBin,
                    requestId: r.uuid
                }).then(function(a) {
                    var n;
                    if ((null == a ? void 0 : a.requestId) === t) {
                        if (null !== (n = a.brands) && void 0 !== n && n.length) {
                            var o, i, l = tC(o = a.brands).call(o, function(e, t) {
                                return e.detectedBrands.push(t.brand), e.paymentMethodVariants.push(t.paymentMethodVariant), !0 === t.supported ? (e.supportedBrands.push(t), e) : e;
                            }, {
                                supportedBrands: [],
                                detectedBrands: [],
                                paymentMethodVariants: []
                            });
                            if (l.supportedBrands.length) return e.processBinLookupResponse(function(e) {
                                for(var t = 1; t < arguments.length; t++){
                                    var r, a, n = null != arguments[t] ? arguments[t] : {};
                                    t % 2 ? Ag(r = qK(Object(n), !0)).call(r, function(t) {
                                        Sg(e, t, n[t]);
                                    }) : Jy ? ng(e, Jy(n)) : Ag(a = qK(Object(n))).call(a, function(t) {
                                        og(e, t, Wy(n, t));
                                    });
                                }
                                return e;
                            }({
                                issuingCountryCode: a.issuingCountryCode,
                                supportedBrands: l.supportedBrands
                            }, a.showSocialSecurityNumber ? {
                                showSocialSecurityNumber: a.showSocialSecurityNumber
                            } : {})), void e.onBinLookup({
                                type: r.type,
                                detectedBrands: l.detectedBrands,
                                supportedBrands: hC(i = l.supportedBrands).call(i, function(e) {
                                    return e.brand;
                                }),
                                paymentMethodVariants: l.paymentMethodVariants,
                                supportedBrandsRaw: l.supportedBrands,
                                brands: e.props.brands || hI,
                                issuingCountryCode: a.issuingCountryCode
                            });
                            if (l.detectedBrands.length) {
                                var c = {
                                    type: "card",
                                    fieldType: "encryptedCardNumber",
                                    error: hO(jI),
                                    detectedBrands: l.detectedBrands
                                };
                                return e.handleUnsupportedCard(c), void e.onBinLookup({
                                    type: r.type,
                                    detectedBrands: l.detectedBrands,
                                    supportedBrands: null,
                                    paymentMethodVariants: l.paymentMethodVariants,
                                    brands: e.props.brands || hI
                                });
                            }
                        } else e.onBinLookup({
                            type: r.type,
                            detectedBrands: null,
                            supportedBrands: null,
                            paymentMethodVariants: null,
                            brands: e.props.brands || hI
                        }), e.processBinLookupResponse({}, !0);
                    } else null != a && a.requestId || e.props.onError(a || {
                        errorType: "binLookup",
                        message: "unknownError"
                    });
                });
                else if (t) {
                    e.processBinLookupResponse(null, !0), t = null;
                    e.handleUnsupportedCard({
                        type: "card",
                        fieldType: "encryptedCardNumber",
                        error: ""
                    }), e.onBinLookup({
                        isReset: !0
                    });
                }
                e.props.onBinValue && e.props.onBinValue(r);
            } else e.props.onBinValue && e.props.onBinValue(r);
        };
    };
    function GK(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var YK = function(e) {
        L_(r, e);
        var t = GK(r);
        function r(e, a, n) {
            var o, i, l;
            Cg(this, r), Sg(B_(l = t.call(this)), "reason", void 0), Sg(B_(l), "message", void 0), Sg(B_(l), "source", void 0), Sg(B_(l), "scheme", void 0);
            var c = "error" in e ? null == e || null === (o = e.error) || void 0 === o ? void 0 : o.message : null == e ? void 0 : e.message, s = "error" in e ? null == e || null === (i = e.error) || void 0 === i ? void 0 : i.reason : null == e ? void 0 : e.reason;
            return l.message = c, l.reason = s, l.source = a, l.scheme = n, l;
        }
        return wg(r, [
            {
                key: "toString",
                value: function() {
                    var e, t, r;
                    return wb(e = wb(t = wb(r = "Reason: ".concat(this.reason, " / Source: ")).call(r, this.source, " / Scheme: ")).call(t, this.scheme, " / Message: ")).call(e, this.message);
                }
            }
        ]), r;
    }(dA(Error)), QK = function() {
        function e(t, r) {
            if (Cg(this, e), Sg(this, "schemeSdk", void 0), Sg(this, "schemeName", void 0), Sg(this, "customSdkConfiguration", void 0), Sg(this, "sdkUrl", void 0), Sg(this, "scriptElement", null), !t) throw Error("AbstractSrcInitiator: Invalid SDK URL");
            this.sdkUrl = t, this.customSdkConfiguration = r;
        }
        var t, r, a, n, o, i;
        return wg(e, [
            {
                key: "loadSdkScript",
                value: (i = Jd(Ey.mark(function e() {
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (this.isSdkIsAvailableOnWindow()) {
                                    e.next = 4;
                                    break;
                                }
                                return this.scriptElement = new Rj(this.sdkUrl), e.next = 4, this.scriptElement.load();
                            case 4:
                                this.assignSdkReference();
                            case 5:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function() {
                    return i.apply(this, arguments);
                })
            },
            {
                key: "removeSdkScript",
                value: function() {
                    this.scriptElement.remove();
                }
            },
            {
                key: "checkout",
                value: (o = Jd(Ey.mark(function e(t) {
                    var r;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, this.schemeSdk.checkout(t);
                            case 3:
                                return r = e.sent, e.abrupt("return", r);
                            case 7:
                                throw e.prev = 7, e.t0 = e.catch(0), new YK(e.t0, "checkout", this.schemeName);
                            case 11:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                })), function(e) {
                    return o.apply(this, arguments);
                })
            },
            {
                key: "unbindAppInstance",
                value: (n = Jd(Ey.mark(function e() {
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, this.schemeSdk.unbindAppInstance();
                            case 3:
                                e.next = 9;
                                break;
                            case 5:
                                throw e.prev = 5, e.t0 = e.catch(0), new YK(e.t0, "unbindAppInstance", this.schemeName);
                            case 9:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            5
                        ]
                    ]);
                })), function() {
                    return n.apply(this, arguments);
                })
            },
            {
                key: "isRecognized",
                value: (a = Jd(Ey.mark(function e() {
                    var t;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, this.schemeSdk.isRecognized();
                            case 3:
                                return t = e.sent, e.abrupt("return", t);
                            case 7:
                                throw e.prev = 7, e.t0 = e.catch(0), new YK(e.t0, "isRecognized", this.schemeName);
                            case 11:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                })), function() {
                    return a.apply(this, arguments);
                })
            },
            {
                key: "initiateIdentityValidation",
                value: (r = Jd(Ey.mark(function e() {
                    var t;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, this.schemeSdk.initiateIdentityValidation();
                            case 3:
                                return t = e.sent, e.abrupt("return", t);
                            case 7:
                                throw e.prev = 7, e.t0 = e.catch(0), new YK(e.t0, "initiateIdentityValidation", this.schemeName);
                            case 11:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                })), function() {
                    return r.apply(this, arguments);
                })
            },
            {
                key: "getSrcProfile",
                value: (t = Jd(Ey.mark(function e(t) {
                    var r;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, this.schemeSdk.getSrcProfile({
                                    idTokens: t
                                });
                            case 3:
                                return r = e.sent, e.abrupt("return", r);
                            case 7:
                                throw e.prev = 7, e.t0 = e.catch(0), new YK(e.t0, "getSrcProfile", this.schemeName);
                            case 11:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            }
        ]), e;
    }();
    function ZK(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function JK(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = ZK(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = ZK(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function $K(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var XK = {
        email: "EMAIL",
        telephoneNumber: "MOBILE_NUMBER"
    }, eH = function(e) {
        L_(o, e);
        var t, r, a, n = $K(o);
        function o(e, t) {
            var r, a;
            return Cg(this, o), Sg(B_(a = n.call(this, kb(r = e.toLowerCase()).call(r, "live") ? "https://assets.secure.checkout.visa.com/checkout-widget/resources/js/src-i-adapter/visa-sdk.js?v2" : "https://sandbox-assets.secure.checkout.visa.com/checkout-widget/resources/js/src-i-adapter/visa-sdk.js?v2", t)), "schemeName", "visa"), a;
        }
        return wg(o, [
            {
                key: "isSdkIsAvailableOnWindow",
                value: function() {
                    var e;
                    return !(null === (e = window.vAdapters) || void 0 === e || !e.VisaSRCI);
                }
            },
            {
                key: "assignSdkReference",
                value: function() {
                    this.schemeSdk = new window.vAdapters.VisaSRCI;
                }
            },
            {
                key: "init",
                value: (a = Jd(Ey.mark(function e(t, r) {
                    var a;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, a = JK(JK(JK({}, t), (n = this.customSdkConfiguration, o = void 0, i = void 0, l = void 0, o = n.dpaLocale, i = void 0 === o ? "en_US" : o, l = n.dpaPresentationName, {
                                    dpaTransactionOptions: {
                                        dpaLocale: i,
                                        payloadTypeIndicator: "NON_PAYMENT",
                                        customInputData: {
                                            checkoutOrchestrator: "merchant"
                                        }
                                    },
                                    dpaData: {
                                        dpaPresentationName: void 0 === l ? "" : l
                                    }
                                })), {}, {
                                    srciTransactionId: r
                                }), e.next = 4, this.schemeSdk.init(a);
                            case 4:
                                e.next = 10;
                                break;
                            case 6:
                                throw e.prev = 6, e.t0 = e.catch(0), new YK(e.t0, "init", this.schemeName);
                            case 10:
                            case "end":
                                return e.stop();
                        }
                        var n, o, i, l;
                    }, e, this, [
                        [
                            0,
                            6
                        ]
                    ]);
                })), function(e, t) {
                    return a.apply(this, arguments);
                })
            },
            {
                key: "identityLookup",
                value: (r = Jd(Ey.mark(function e(t) {
                    var r, a, n, o;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return r = t.identityValue, a = t.type, e.prev = 1, n = {
                                    identityValue: r,
                                    type: XK[a]
                                }, e.next = 5, this.schemeSdk.identityLookup(n);
                            case 5:
                                return o = e.sent, e.abrupt("return", o);
                            case 9:
                                throw e.prev = 9, e.t0 = e.catch(1), new YK(e.t0, "identityLookup", this.schemeName);
                            case 13:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            1,
                            9
                        ]
                    ]);
                })), function(e) {
                    return r.apply(this, arguments);
                })
            },
            {
                key: "completeIdentityValidation",
                value: (t = Jd(Ey.mark(function e(t) {
                    var r;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, this.schemeSdk.completeIdentityValidation(t);
                            case 3:
                                return r = e.sent, e.abrupt("return", r);
                            case 7:
                                throw e.prev = 7, e.t0 = e.catch(0), new YK(e.t0, "completeIdentityValidation", this.schemeName);
                            case 11:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            }
        ]), o;
    }(QK);
    function tH(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function rH(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = tH(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = tH(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function aH(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var nH = {
        email: "EMAIL_ADDRESS",
        telephoneNumber: "MOBILE_PHONE_NUMBER"
    }, oH = function(e) {
        L_(o, e);
        var t, r, a, n = aH(o);
        function o(e, t) {
            var r, a;
            return Cg(this, o), Sg(B_(a = n.call(this, kb(r = e.toLowerCase()).call(r, "live") ? "https://src.mastercard.com/sdk/srcsdk.mastercard.js" : "https://sandbox.src.mastercard.com/sdk/srcsdk.mastercard.js", t)), "schemeName", "mc"), a;
        }
        return wg(o, [
            {
                key: "isSdkIsAvailableOnWindow",
                value: function() {
                    return !!window.SRCSDK_MASTERCARD;
                }
            },
            {
                key: "assignSdkReference",
                value: function() {
                    this.schemeSdk = window.SRCSDK_MASTERCARD;
                }
            },
            {
                key: "init",
                value: (a = Jd(Ey.mark(function e(t, r) {
                    var a;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, a = rH(rH(rH({}, t), (n = this.customSdkConfiguration, o = void 0, i = void 0, l = void 0, o = n.dpaLocale, i = void 0 === o ? "en_US" : o, l = n.dpaPresentationName, {
                                    dpaTransactionOptions: {
                                        dpaLocale: i,
                                        paymentOptions: {
                                            dynamicDataType: "CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM"
                                        },
                                        consumerNameRequested: !0,
                                        customInputData: {
                                            "com.mastercard.dcfExperience": "PAYMENT_SETTINGS"
                                        },
                                        confirmPayment: !1
                                    },
                                    dpaData: {
                                        dpaPresentationName: void 0 === l ? "" : l
                                    }
                                })), {}, {
                                    srciTransactionId: r
                                }), e.next = 4, this.schemeSdk.init(a);
                            case 4:
                                e.next = 10;
                                break;
                            case 6:
                                throw e.prev = 6, e.t0 = e.catch(0), new YK(e.t0, "init", this.schemeName);
                            case 10:
                            case "end":
                                return e.stop();
                        }
                        var n, o, i, l;
                    }, e, this, [
                        [
                            0,
                            6
                        ]
                    ]);
                })), function(e, t) {
                    return a.apply(this, arguments);
                })
            },
            {
                key: "identityLookup",
                value: (r = Jd(Ey.mark(function e(t) {
                    var r, a, n, o;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return r = t.identityValue, a = t.type, e.prev = 1, n = {
                                    identityValue: r,
                                    identityType: nH[a]
                                }, e.next = 5, this.schemeSdk.identityLookup({
                                    consumerIdentity: n
                                });
                            case 5:
                                return o = e.sent, e.abrupt("return", o);
                            case 9:
                                throw e.prev = 9, e.t0 = e.catch(1), new YK(e.t0, "identityLookup", this.schemeName);
                            case 13:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            1,
                            9
                        ]
                    ]);
                })), function(e) {
                    return r.apply(this, arguments);
                })
            },
            {
                key: "completeIdentityValidation",
                value: (t = Jd(Ey.mark(function e(t) {
                    var r;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, this.schemeSdk.completeIdentityValidation({
                                    validationData: t
                                });
                            case 3:
                                return r = e.sent, e.abrupt("return", r);
                            case 7:
                                throw e.prev = 7, e.t0 = e.catch(0), new YK(e.t0, "completeIdentityValidation", this.schemeName);
                            case 11:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            }
        ]), o;
    }(QK), iH = function(e) {
        return "fulfilled" === e.status;
    }, lH = function(e) {
        return "rejected" === e.status;
    }, cH = {
        visa: eH,
        mc: oH,
        default: null
    }, sH = function(e, t, r) {
        var a = cH[e] || cH.default;
        return a ? new a(t, r) : null;
    }, uH = function() {
        function e(t, r) {
            var a = r.dpaLocale, n = void 0 === a ? "en_US" : a, o = r.dpaPresentationName, i = void 0 === o ? "" : o;
            Cg(this, e), Sg(this, "schemes", void 0), Sg(this, "customSdkConfiguration", void 0), this.schemes = t, this.customSdkConfiguration = {
                dpaLocale: n,
                dpaPresentationName: i
            };
        }
        var t;
        return wg(e, [
            {
                key: "load",
                value: (t = Jd(Ey.mark(function e(t) {
                    var r = this;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (this.schemes && 0 !== this.schemes.length) {
                                    e.next = 2;
                                    break;
                                }
                                throw new mA("ERROR", "ClickToPay -> SrcSdkLoader: There are no schemes set to be loaded");
                            case 2:
                                return e.abrupt("return", new Sb(function(e, a) {
                                    var n, o = hC(n = r.schemes).call(n, function(e) {
                                        return sH(e, t, r.customSdkConfiguration);
                                    }), i = hC(o).call(o, function(e) {
                                        return e.loadSdkScript();
                                    });
                                    Sb.allSettled(i).then(function(t) {
                                        XA(t).call(t, lH) && a(new mA("ERROR", "ClickToPay -> SrcSdkLoader # Unable to load network schemes: ".concat(r.schemes.toString())));
                                        var n = Fg(o).call(o, function(e, r) {
                                            return iH(t[r]);
                                        });
                                        e(n);
                                    });
                                }));
                            case 3:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            }
        ]), e;
    }(), dH = {
        mc: "Mastercard",
        visa: "Visa"
    }, pH = function() {
        function e(t, r, a) {
            Cg(this, e), Sg(this, "dateOfCardLastUsed", void 0), Sg(this, "panLastFour", void 0), Sg(this, "srcDigitalCardId", void 0), Sg(this, "scheme", void 0), Sg(this, "artUri", void 0), Sg(this, "srcCorrelationId", void 0), Sg(this, "tokenId", void 0), Sg(this, "isExpired", void 0), Sg(this, "panExpirationMonth", void 0), Sg(this, "panExpirationYear", void 0), Sg(this, "descriptorName", void 0), Sg(this, "status", null), this.dateOfCardLastUsed = t.dateOfCardLastUsed, this.panLastFour = t.panLastFour, this.srcDigitalCardId = t.srcDigitalCardId, this.descriptorName = t.digitalCardData.descriptorName, this.tokenId = t.tokenId, this.scheme = r, this.artUri = t.digitalCardData.artUri, this.srcCorrelationId = a, this.panExpirationMonth = t.panExpirationMonth, this.panExpirationYear = t.panExpirationYear, this.status = t.digitalCardData.status, this.isExpired = this.confirmCardIsExpired();
        }
        return wg(e, [
            {
                key: "title",
                get: function() {
                    return "visa" === this.scheme ? dH[this.scheme] : this.descriptorName || dH[this.scheme];
                }
            },
            {
                key: "isDcfPopupEmbedded",
                get: function() {
                    return "mc" === this.scheme;
                }
            },
            {
                key: "confirmCardIsExpired",
                value: function() {
                    if ("ACTIVE" !== this.status) return !0;
                    if (!this.panExpirationYear && !this.panExpirationMonth) return !1;
                    var e = [
                        (new Date).getMonth() + 1,
                        (new Date).getFullYear()
                    ], t = e[0], r = e[1];
                    return !(Number(this.panExpirationYear) > r) && !(Number(this.panExpirationYear) === r && Number(this.panExpirationMonth) >= t);
                }
            }
        ]), e;
    }(), mH = "ctpIframe";
    function fH(e, t, r) {
        var a, n = e.scheme, o = e.tokenId, i = e.srcDigitalCardId, l = e.srcCorrelationId;
        return "visa" === n ? o ? {
            srcScheme: n,
            srcCorrelationId: l,
            srcTokenReference: kb(a = r.toLowerCase()).call(a, "live") ? o : "987654321"
        } : {
            srcScheme: n,
            srcCheckoutPayload: t.checkoutResponse,
            srcCorrelationId: l
        } : {
            srcScheme: n,
            srcDigitalCardId: i,
            srcCorrelationId: l
        };
    }
    function hH(e, t) {
        var r, a = t.profiles, n = t.srcCorrelationId, o = tC(a).call(a, function(e, r) {
            var a, o, i = hC(a = r.maskedCards).call(a, function(e) {
                return new pH(e, t.scheme, n);
            });
            return wb(o = []).call(o, Uk(e), Uk(i));
        }, []);
        return wb(r = []).call(r, Uk(e), Uk(o));
    }
    function vH(e, t) {
        return new Date(t.dateOfCardLastUsed).getTime() - new Date(e.dateOfCardLastUsed).getTime();
    }
    function yH(e, t) {
        return t.isExpired ? e.expiredCards.push(t) : e.availableCards.push(t), e;
    }
    function gH(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var bH = function(e) {
        L_(r, e);
        var t = gH(r);
        function r(e) {
            var a;
            return Cg(this, r), (a = t.call(this, e)).name = "TimeoutError", a;
        }
        return wg(r);
    }(dA(Error));
    function kH(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function CH(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = kH(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = kH(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var _H = function(e) {
        return e.Idle = "Idle", e.Loading = "Loading", e.ShopperIdentified = "ShopperIdentified", e.OneTimePassword = "OneTimePassword", e.Ready = "Ready", e.Login = "Login", e.NotAvailable = "NotAvailable", e;
    }({});
    function NH(e, t, r) {
        var a = new Sb(function(e, a) {
            return ZN(function() {
                return a(r);
            }, t);
        });
        return Sb.race([
            e(),
            a
        ]);
    }
    var PH = function() {
        function e(t, r, a, n, o) {
            Cg(this, e), Sg(this, "sdkLoader", void 0), Sg(this, "schemesConfig", void 0), Sg(this, "shopperIdentity", void 0), Sg(this, "environment", void 0), Sg(this, "onTimeout", void 0), Sg(this, "srciTransactionId", DN()), Sg(this, "sdks", void 0), Sg(this, "validationSchemeSdk", null), Sg(this, "stateSubscriber", void 0), Sg(this, "state", _H.Idle), Sg(this, "shopperCards", null), Sg(this, "identityValidationData", null), Sg(this, "storeCookies", !1), this.sdkLoader = r, this.schemesConfig = t, this.shopperIdentity = n, this.environment = a, this.onTimeout = o;
        }
        var t, r, a, n, o, i, l, c, s;
        return wg(e, [
            {
                key: "shopperAccountFound",
                get: function() {
                    var e;
                    return kb(e = [
                        _H.Ready,
                        _H.ShopperIdentified
                    ]).call(e, this.state);
                }
            },
            {
                key: "schemes",
                get: function() {
                    return this.sdkLoader.schemes;
                }
            },
            {
                key: "updateStoreCookiesConsent",
                value: function(e) {
                    this.storeCookies = e;
                }
            },
            {
                key: "initialize",
                value: (s = Jd(Ey.mark(function e() {
                    var t, r, a, n, o, i, l, c, s;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return this.setState(_H.Loading), e.prev = 1, e.next = 4, this.sdkLoader.load(this.environment);
                            case 4:
                                return this.sdks = e.sent, e.next = 7, this.initiateSdks();
                            case 7:
                                return e.next = 9, this.verifyIfShopperIsRecognized();
                            case 9:
                                if (t = e.sent, r = t.recognized, a = void 0 !== r && r, n = t.idTokens, o = void 0 === n ? null : n, !a) {
                                    e.next = 19;
                                    break;
                                }
                                return e.next = 17, this.getShopperProfile(o);
                            case 17:
                                return this.setState(_H.Ready), e.abrupt("return");
                            case 19:
                                if (this.shopperIdentity) {
                                    e.next = 22;
                                    break;
                                }
                                return this.setState(_H.NotAvailable), e.abrupt("return");
                            case 22:
                                return e.next = 24, this.verifyIfShopperIsEnrolled(this.shopperIdentity);
                            case 24:
                                if (!e.sent.isEnrolled) {
                                    e.next = 29;
                                    break;
                                }
                                return this.setState(_H.ShopperIdentified), e.abrupt("return");
                            case 29:
                                this.setState(_H.NotAvailable), e.next = 36;
                                break;
                            case 32:
                                e.prev = 32, e.t0 = e.catch(1), e.t0 instanceof YK && "REQUEST_TIMEOUT" === (null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.reason) ? (c = new bH(wb(i = "ClickToPayService - Timeout during ".concat(e.t0.source, "() of the scheme '")).call(i, e.t0.scheme, "'")), null === (l = this.onTimeout) || void 0 === l || l.call(this, c)) : e.t0 instanceof bH ? (console.warn(e.t0.toString()), null === (s = this.onTimeout) || void 0 === s || s.call(this, e.t0)) : e.t0 instanceof YK ? console.warn("Error at ClickToPayService # init: ".concat(e.t0.toString())) : console.warn(e.t0), this.setState(_H.NotAvailable);
                            case 36:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            1,
                            32
                        ]
                    ]);
                })), function() {
                    return s.apply(this, arguments);
                })
            },
            {
                key: "subscribeOnStateChange",
                value: function(e) {
                    this.stateSubscriber = e;
                }
            },
            {
                key: "startIdentityValidation",
                value: (c = Jd(Ey.mark(function e() {
                    var t, r;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (this.validationSchemeSdk) {
                                    e.next = 2;
                                    break;
                                }
                                throw Error("startIdentityValidation: No ValidationSDK set for the validation process");
                            case 2:
                                return e.next = 4, this.validationSchemeSdk.initiateIdentityValidation();
                            case 4:
                                t = e.sent, r = t.maskedValidationChannel, this.identityValidationData = {
                                    maskedShopperContact: r.replace(/\*/g, "\u2022"),
                                    selectedNetwork: dH[this.validationSchemeSdk.schemeName]
                                }, this.setState(_H.OneTimePassword);
                            case 8:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function() {
                    return c.apply(this, arguments);
                })
            },
            {
                key: "finishIdentityValidation",
                value: (l = Jd(Ey.mark(function e(t) {
                    var r;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (this.validationSchemeSdk) {
                                    e.next = 2;
                                    break;
                                }
                                throw Error("finishIdentityValidation: No ValidationSDK set for the validation process");
                            case 2:
                                return e.next = 4, this.validationSchemeSdk.completeIdentityValidation(t);
                            case 4:
                                return r = e.sent, e.next = 7, this.getShopperProfile([
                                    r.idToken
                                ]);
                            case 7:
                                this.setState(_H.Ready), this.validationSchemeSdk = null;
                            case 9:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function(e) {
                    return l.apply(this, arguments);
                })
            },
            {
                key: "checkout",
                value: (i = Jd(Ey.mark(function e(t) {
                    var r, a, n;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (t) {
                                    e.next = 2;
                                    break;
                                }
                                throw Error("ClickToPayService # checkout: Missing card data");
                            case 2:
                                return a = zb(r = this.sdks).call(r, function(e) {
                                    return e.schemeName === t.scheme;
                                }), e.next = 5, a.checkout(CH(CH({
                                    srcDigitalCardId: t.srcDigitalCardId,
                                    srcCorrelationId: t.srcCorrelationId
                                }, t.isDcfPopupEmbedded && {
                                    windowRef: window.frames[mH]
                                }), this.storeCookies && {
                                    complianceSettings: {
                                        complianceResources: [
                                            {
                                                complianceType: "REMEMBER_ME",
                                                uri: ""
                                            }
                                        ]
                                    }
                                }));
                            case 5:
                                if ("COMPLETE" === (n = e.sent).dcfActionCode) {
                                    e.next = 8;
                                    break;
                                }
                                throw new mA("ERROR", "Checkout through Scheme DCF did not complete. DCF Action code received: ".concat(n.dcfActionCode));
                            case 8:
                                return e.abrupt("return", fH(t, n, this.environment));
                            case 9:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function(e) {
                    return i.apply(this, arguments);
                })
            },
            {
                key: "logout",
                value: (o = Jd(Ey.mark(function e() {
                    var t, r;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (this.sdks) {
                                    e.next = 2;
                                    break;
                                }
                                throw new mA("ERROR", "ClickToPayService is not initialized");
                            case 2:
                                return e.prev = 2, r = hC(t = this.sdks).call(t, function(e) {
                                    return e.unbindAppInstance();
                                }), e.next = 6, Sb.all(r);
                            case 6:
                                e.next = 11;
                                break;
                            case 8:
                                e.prev = 8, e.t0 = e.catch(2), e.t0 instanceof YK ? console.warn("Error at ClickToPayService # logout: ".concat(e.t0.toString())) : console.warn(e.t0);
                            case 11:
                                this.shopperCards = null, this.identityValidationData = null, this.validationSchemeSdk = null, this.setState(_H.Login);
                            case 15:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                })), function() {
                    return o.apply(this, arguments);
                })
            },
            {
                key: "verifyIfShopperIsEnrolled",
                value: (n = Jd(Ey.mark(function e(t) {
                    var r, a = this;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return r = t.shopperEmail, e.abrupt("return", new Sb(function(e, t) {
                                    var n, o = hC(n = a.sdks).call(n, function(n) {
                                        var o = NH(function() {
                                            return n.identityLookup({
                                                identityValue: r,
                                                type: "email"
                                            });
                                        }, 5e3, new bH("ClickToPayService - Timeout during identityLookup() of the scheme '".concat(n.schemeName, "'")));
                                        return o.then(function(t) {
                                            t.consumerPresent && !a.validationSchemeSdk && (a.setSdkForPerformingShopperIdentityValidation(n), e({
                                                isEnrolled: !0
                                            }));
                                        }).catch(function(e) {
                                            t(e);
                                        }), o;
                                    });
                                    Sb.allSettled(o).then(function() {
                                        e({
                                            isEnrolled: !1
                                        });
                                    });
                                }));
                            case 2:
                            case "end":
                                return e.stop();
                        }
                    }, e);
                })), function(e) {
                    return n.apply(this, arguments);
                })
            },
            {
                key: "setState",
                value: function(e) {
                    var t;
                    this.state = e, null === (t = this.stateSubscriber) || void 0 === t || t.call(this, this.state);
                }
            },
            {
                key: "setSdkForPerformingShopperIdentityValidation",
                value: function(e) {
                    this.validationSchemeSdk = e;
                }
            },
            {
                key: "getShopperProfile",
                value: (a = Jd(Ey.mark(function e(t) {
                    var r = this;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.abrupt("return", new Sb(function(e, a) {
                                    var n, o = hC(n = r.sdks).call(n, function(e) {
                                        return e.getSrcProfile(t);
                                    });
                                    Sb.allSettled(o).then(function(t) {
                                        var n;
                                        XA(t).call(t, lH) && a(t[0].reason);
                                        var o, i, l, c, s, u, d = Fg(n = hC(t).call(t, function(e, t) {
                                            return iH(e) && CH(CH({}, e.value), {}, {
                                                scheme: r.sdks[t].schemeName
                                            });
                                        })).call(n, function(e) {
                                            return !!e;
                                        });
                                        r.shopperCards = (c = tC(i = tC(o = d).call(o, hH, [])).call(i, yH, {
                                            availableCards: [],
                                            expiredCards: []
                                        }), s = c.availableCards, u = c.expiredCards, wb(l = []).call(l, Uk(mO(s).call(s, vH)), Uk(mO(u).call(u, vH)))), e();
                                    });
                                }));
                            case 1:
                            case "end":
                                return e.stop();
                        }
                    }, e);
                })), function(e) {
                    return a.apply(this, arguments);
                })
            },
            {
                key: "verifyIfShopperIsRecognized",
                value: (r = Jd(Ey.mark(function e() {
                    var t = this;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.abrupt("return", new Sb(function(e, r) {
                                    var a, n = hC(a = t.sdks).call(a, function(t) {
                                        var a = NH(function() {
                                            return t.isRecognized();
                                        }, 5e3, new bH("ClickToPayService - Timeout during isRecognized() of the scheme '".concat(t.schemeName, "'")));
                                        return a.then(function(t) {
                                            return t.recognized && e(t);
                                        }).catch(function(e) {
                                            return r(e);
                                        }), a;
                                    });
                                    Sb.allSettled(n).then(function() {
                                        return e({
                                            recognized: !1
                                        });
                                    });
                                }));
                            case 1:
                            case "end":
                                return e.stop();
                        }
                    }, e);
                })), function() {
                    return r.apply(this, arguments);
                })
            },
            {
                key: "initiateSdks",
                value: (t = Jd(Ey.mark(function e() {
                    var t, r, a = this;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return r = hC(t = this.sdks).call(t, function(e) {
                                    var t = a.schemesConfig[e.schemeName];
                                    return NH(function() {
                                        return e.init(t, a.srciTransactionId);
                                    }, 5e3, new bH("ClickToPayService - Timeout during init() of the scheme '".concat(e.schemeName, "'")));
                                }), e.next = 3, Sb.all(r);
                            case 3:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function() {
                    return t.apply(this, arguments);
                })
            }
        ]), e;
    }();
    function wH(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function SH(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = wH(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = wH(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function AH(e, t, r) {
        var a = DH(e);
        if (!a) return null;
        var n = IH(null == t ? void 0 : t.shopperEmail, null == t ? void 0 : t.telephoneNumber), o = Ty(a), i = new uH(o, {
            dpaLocale: null == t ? void 0 : t.locale,
            dpaPresentationName: null == t ? void 0 : t.merchantDisplayName
        });
        return new PH(a, i, r, n, null == t ? void 0 : t.onTimeout);
    }
    var IH = function(e, t) {
        var r = SH({}, e && {
            shopperEmail: e
        });
        return Ty(r).length > 0 ? r : null;
    }, DH = function(e) {
        if (!e) return null;
        var t = e.visaSrciDpaId, r = e.visaSrcInitiatorId, a = e.mcDpaId, n = e.mcSrcClientId, o = SH(SH({}, a && n && {
            mc: {
                srciDpaId: a,
                srcInitiatorId: n
            }
        }), t && r && {
            visa: {
                srciDpaId: t,
                srcInitiatorId: r
            }
        });
        return 0 === Ty(o).length ? null : o;
    }, EH = SN({
        status: null,
        onSubmit: null,
        onSetStatus: null,
        onError: null,
        onReady: null,
        amount: null,
        configuration: null,
        isStandaloneComponent: null,
        isCtpPrimaryPaymentMethod: null,
        isStoringCookies: !1,
        setIsCtpPrimaryPaymentMethod: null,
        logoutShopper: null,
        updateStoreCookiesConsent: null,
        ctpState: null,
        cards: [],
        schemes: [],
        otpMaskedContact: null,
        otpNetwork: null,
        checkout: null,
        verifyIfShopperIsEnrolled: null,
        startIdentityValidation: null,
        finishIdentityValidation: null
    }), RH = function(e) {
        var t, r, a = e.isStandaloneComponent, n = void 0 !== a && a, o = e.clickToPayService, i = e.amount, l = e.configuration, c = e.children, s = e.setClickToPayRef, u = e.onSubmit, d = e.onSetStatus, p = e.onError, m = Vk(fP(o), 1)[0], f = Vk(fP((null == o ? void 0 : o.state) || _H.NotAvailable), 2), h = f[0], v = f[1], y = Vk(fP(!0), 2), g = y[0], b = y[1], k = Vk(fP("ready"), 2), C = k[0], _ = k[1], N = gP({}), P = gP(!1);
        vP(function() {
            s(N.current), N.current.setStatus = _;
        }, []), vP(function() {
            null == m || m.subscribeOnStateChange(function(e) {
                return v(e);
            });
        }, [
            m
        ]);
        var w = kP(function() {
            var e;
            P.current || (null === (e = l.onReady) || void 0 === e || e.call(l), P.current = !0);
        }, [
            l.onReady
        ]), S = kP(function() {
            var e = Jd(Ey.mark(function e(t) {
                return Ey.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            return e.next = 2, null == m ? void 0 : m.finishIdentityValidation(t);
                        case 2:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function(t) {
                return e.apply(this, arguments);
            };
        }(), [
            m
        ]), A = kP(Jd(Ey.mark(function e() {
            var t;
            return Ey.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return e.next = 2, null == m ? void 0 : m.startIdentityValidation();
                    case 2:
                        return t = e.sent, e.abrupt("return", t);
                    case 4:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), [
            m
        ]), I = kP(function() {
            var e = Jd(Ey.mark(function e(t) {
                return Ey.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            return e.next = 2, null == m ? void 0 : m.checkout(t);
                        case 2:
                            return e.abrupt("return", e.sent);
                        case 3:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function(t) {
                return e.apply(this, arguments);
            };
        }(), [
            m
        ]), D = kP(function() {
            var e = Jd(Ey.mark(function e(t) {
                return Ey.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            return e.next = 2, null == m ? void 0 : m.verifyIfShopperIsEnrolled(t);
                        case 2:
                            return e.abrupt("return", e.sent);
                        case 3:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function(t) {
                return e.apply(this, arguments);
            };
        }(), [
            m
        ]), E = kP(Jd(Ey.mark(function e() {
            return Ey.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return e.next = 2, null == m ? void 0 : m.logout();
                    case 2:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), [
            m
        ]), R = kP(function(e) {
            m.updateStoreCookiesConsent(e);
        }, [
            m
        ]);
        return rN(EH.Provider, {
            value: {
                status: C,
                onSubmit: u,
                onError: p,
                onSetStatus: d,
                amount: i,
                configuration: l,
                isStoringCookies: null == m ? void 0 : m.storeCookies,
                isStandaloneComponent: n,
                isCtpPrimaryPaymentMethod: g,
                setIsCtpPrimaryPaymentMethod: b,
                ctpState: h,
                verifyIfShopperIsEnrolled: D,
                cards: null == m ? void 0 : m.shopperCards,
                schemes: null == m ? void 0 : m.schemes,
                otpMaskedContact: null == m || null === (t = m.identityValidationData) || void 0 === t ? void 0 : t.maskedShopperContact,
                otpNetwork: null == m || null === (r = m.identityValidationData) || void 0 === r ? void 0 : r.selectedNetwork,
                checkout: I,
                logoutShopper: E,
                startIdentityValidation: A,
                finishIdentityValidation: S,
                updateStoreCookiesConsent: R,
                onReady: w
            }
        }, c);
    };
    function xH() {
        return CP(EH);
    }
    var FH = {
        otp: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "",
            modes: [
                "blur"
            ]
        },
        default: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "",
            modes: [
                "blur"
            ]
        }
    }, TH = function(e) {
        var t = e.onError, r = e.onResendCode, a = e.disabled, n = Vk(fP(null), 2), o = n[0], i = n[1], l = Vk(fP(!1), 2), c = l[0], s = l[1], u = zP().i18n, d = xH().startIdentityValidation;
        vP(function() {
            var e = null;
            return o > 0 && (e = ZN(function() {
                return i(o - 1);
            }, 1e3)), function() {
                return clearTimeout(e);
            };
        }, [
            o
        ]), vP(function() {
            var e = null;
            return c && (e = ZN(function() {
                s(!1), i(60);
            }, 2e3)), function() {
                return clearTimeout(e);
            };
        }, [
            c
        ]);
        var p = kP(function() {
            var e = Jd(Ey.mark(function e(a) {
                return Ey.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            return a.preventDefault(), e.prev = 1, r(), s(!0), e.next = 6, d();
                        case 6:
                            e.next = 13;
                            break;
                        case 8:
                            e.prev = 8, e.t0 = e.catch(1), t(e.t0.reason), i(0), s(!1);
                        case 13:
                        case "end":
                            return e.stop();
                    }
                }, e, null, [
                    [
                        1,
                        8
                    ]
                ]);
            }));
            return function(t) {
                return e.apply(this, arguments);
            };
        }(), [
            d,
            t,
            r
        ]);
        return c ? rN("div", {
            className: "adyen-checkout-ctp__otp-resend-code--confirmation"
        }, u.get("ctp.otp.codeResent"), rN(aI, {
            type: "checkmark",
            height: 14,
            width: 14
        })) : o > 0 ? rN("div", {
            className: "adyen-checkout-ctp__otp-resend-code--disabled"
        }, u.get("ctp.otp.resendCode"), " -", " ", rN("span", {
            className: "adyen-checkout-ctp__otp-resend-code-counter"
        }, " ", o > 0 && "".concat(o, "s"), " ")) : rN("div", {
            role: "link",
            tabIndex: 0,
            className: aP("adyen-checkout-ctp__otp-resend-code", {
                "adyen-checkout-ctp__otp-resend-code--disabled": a
            }),
            onClick: p
        }, u.get("ctp.otp.resendCode"));
    }, zH = function(e) {
        var t = zP().i18n, r = xH().configuration.disableOtpAutoFocus, a = Vk(fP(null), 2), n = a[0], o = a[1], i = QD({
            schema: [
                "otp"
            ],
            rules: FH
        }), l = i.handleChangeFor, c = i.data, s = i.triggerValidation, u = i.valid, d = i.errors, p = i.isValid, m = i.setData, f = gP({
            validateInput: null
        }), h = gP(null), v = Vk(fP(!1), 2), y = v[0], g = v[1], b = kP(function() {
            g(!0), s();
        }, [
            s
        ]);
        vP(function() {
            c.otp && g(!0);
        }, [
            c.otp
        ]), vP(function() {
            !r && h.current && h.current.focus();
        }, [
            h.current,
            r
        ]), vP(function() {
            f.current.validateInput = b, e.onSetInputHandlers(f.current);
        }, [
            b,
            e.onSetInputHandlers
        ]);
        var k = kP(function() {
            m("otp", ""), o(null), r || h.current.focus(), e.onResendCode();
        }, [
            e.onResendCode,
            h.current,
            r
        ]), C = kP(function(e) {
            var r = t.get("ctp.errors.".concat(e));
            r && o(r);
        }, [
            t
        ]), _ = kP(function(t) {
            "Enter" === t.key && e.onPressEnter();
        }, [
            e.onPressEnter
        ]), N = kP(function(e) {
            "Enter" === e.key && e.preventDefault();
        }, []);
        return vP(function() {
            e.onChange({
                data: c,
                valid: u,
                errors: d,
                isValid: p
            });
        }, [
            c,
            u,
            d
        ]), rN(oD, {
            name: "oneTimePassword",
            label: t.get("ctp.otp.fieldLabel"),
            labelEndAdornment: !e.hideResendOtpButton && rN(TH, {
                disabled: e.isValidatingOtp,
                onError: C,
                onResendCode: k
            }),
            errorMessage: y ? n || e.errorMessage || !!d.otp : null,
            classNameModifiers: [
                "otp"
            ]
        }, rN(oE, {
            name: "otp",
            autocorrect: "off",
            spellcheck: !1,
            value: c.otp,
            disabled: e.disabled,
            onInput: l("otp", "input"),
            onBlur: l("otp", "blur"),
            onKeyUp: _,
            onKeyPress: N,
            setRef: function(e) {
                h.current = e;
            }
        }));
    }, OH = function(e) {
        var t = e.classNameModifiers, r = void 0 === t ? [] : t, a = tI(), n = xH().schemes, o = a()("ctp"), i = a({
            imageFolder: "components/"
        })("pipe");
        return rN("div", {
            className: aP("adyen_checkout-ctp__brand-wrapper", hC(r).call(r, function(e) {
                return "adyen_checkout-ctp__brand-wrapper--".concat(e);
            }))
        }, rN(ST, {
            className: "adyen_checkout-ctp__brand-logo",
            src: o,
            alt: "Logo of Click to Pay"
        }), rN(ST, {
            className: "adyen_checkout-ctp__brand-pipe",
            src: i,
            alt: ""
        }), hC(n).call(n, function(e) {
            return rN(ST, {
                key: e,
                className: aP("adyen_checkout-ctp__brand-scheme", "adyen_checkout-ctp__brand-scheme-".concat(e)),
                src: a()(e),
                alt: "Logo of ".concat(dH[e])
            });
        }));
    }, jH = function(e) {
        var t = e.modalElement, r = e.isOpen, a = e.isDismissible, n = e.focusFirst, o = e.focusAfterClose, i = e.onClose;
        !function(e) {
            var t = e.rootElement, r = e.focusFirst, a = e.shouldTrap, n = void 0 === a || a, o = Vk(fP(r), 2), i = o[0], l = o[1];
            vP(function() {
                n && (null == i || i.focus());
            }, [
                i,
                n
            ]), vP(function() {
                if (n) {
                    var e = t.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'), a = e[0], o = e[e.length - 1];
                    l(r || a);
                    var i = function(e) {
                        if ("Tab" === e.key || 9 === e.keyCode) return e.shiftKey && document.activeElement === a ? (o.focus(), void e.preventDefault()) : document.activeElement === o ? (a.focus(), void e.preventDefault()) : void 0;
                    };
                    return t.addEventListener("keydown", i), function() {
                        l(null), t.removeEventListener("keydown", i);
                    };
                }
            }, [
                t,
                r,
                n
            ]);
        }({
            rootElement: t,
            shouldTrap: r,
            focusFirst: n
        });
        var l = kP(function() {
            o.focus(), i();
        }, [
            i,
            o
        ]), c = kP(function(e) {
            a && e.target instanceof HTMLElement && !t.contains(e.target) && l();
        }, [
            l,
            a,
            t
        ]);
        return vP(function() {
            if (r && t) {
                var e = function(e) {
                    ("Escape" === e.key || "Esc" === e.key || 27 === e.keyCode) && l();
                };
                return t.addEventListener("keydown", e), function() {
                    return t.removeEventListener("keydown", e);
                };
            }
        }, [
            r,
            t,
            l
        ]), {
            closeModal: l,
            handleClickOutside: c
        };
    }, BH = [
        "children",
        "classNameModifiers",
        "isOpen",
        "onClose",
        "isDismissible",
        "labelledBy",
        "describedBy",
        "focusFirst",
        "focusAfterClose"
    ], MH = function(e) {
        var t = e.children, r = e.classNameModifiers, a = void 0 === r ? [] : r, n = e.isOpen, o = e.onClose, i = e.isDismissible, l = void 0 === i || i, c = e.labelledBy, s = e.describedBy, u = e.focusFirst, d = e.focusAfterClose, p = kg(e, BH), m = gP(), f = jH({
            modalElement: m.current,
            isOpen: n,
            isDismissible: l,
            focusFirst: u,
            focusAfterClose: d,
            onClose: o
        }), h = f.closeModal, v = f.handleClickOutside;
        return rN("div", j_({
            className: aP("adyen-checkout__modal-wrapper", hC(a).call(a, function(e) {
                return "adyen-checkout__modal-wrapper--".concat(e);
            }), {
                "adyen-checkout__modal-wrapper--open": n
            }),
            role: "dialog",
            "aria-labelledby": c,
            "aria-describedby": s,
            "aria-modal": "true",
            "aria-hidden": !n,
            onClick: v
        }, p), rN("div", {
            className: "adyen-checkout__modal",
            ref: m
        }, t({
            onCloseModal: h
        })));
    }, LH = eD();
    function VH() {
        return "adyen-".concat(LH += 1);
    }
    var UH = function(e) {
        var t = e.isOpen, r = e.onClose, a = e.focusAfterClose, n = gP(), o = zP().i18n, i = tI(), l = VH(), c = VH();
        return rN(MH, {
            onClose: r,
            isOpen: t,
            classNameModifiers: [
                "ctp"
            ],
            labelledBy: l,
            describedBy: c,
            focusFirst: n.current,
            focusAfterClose: a
        }, function(e) {
            var t = e.onCloseModal;
            return rN(nN, null, rN(ST, {
                className: "adyen-checkout__ctp-modal-header-image",
                src: i({
                    imageFolder: "components/"
                })("ctp_landscape"),
                alt: ""
            }), rN("h1", {
                id: l,
                className: "adyen-checkout__ctp-modal-title"
            }, o.get("ctp.infoPopup.title")), rN("div", {
                id: c
            }, rN("p", {
                tabIndex: -1,
                ref: n,
                className: "adyen-checkout__ctp-modal-text"
            }, o.get("ctp.infoPopup.subtitle")), rN("ul", {
                className: "adyen-checkout__ctp-modal-text adyen-checkout__ctp-modal-benefits",
                type: "disc"
            }, rN("li", null, o.get("ctp.infoPopup.benefit1")), rN("li", null, o.get("ctp.infoPopup.benefit2")), rN("li", null, o.get("ctp.infoPopup.benefit3"))), rN(OH, {
                classNameModifiers: [
                    "popup"
                ]
            })), rN(jP, {
                onClick: t,
                label: o.get("close")
            }));
        });
    }, KH = function() {
        var e = Vk(fP(!1), 2), t = e[0], r = e[1], a = gP(), n = zP().i18n, o = tI()({
            imageFolder: "components/"
        })("info"), i = kP(function() {
            r(!1);
        }, []);
        return rN(nN, null, rN("button", {
            ref: a,
            onClick: kP(function() {
                r(!0);
            }, []),
            className: "adyen-web__ctp-info-button",
            "aria-label": n.get("ctp.aria.infoModalButton"),
            type: "button"
        }, rN(ST, {
            height: "15",
            src: o,
            ariaHidden: !0
        })), rN(UH, {
            isOpen: t,
            onClose: i,
            focusAfterClose: a.current
        }));
    }, HH = function() {
        var e, t = xH(), r = t.ctpState, a = t.logoutShopper, n = t.status, o = t.cards, i = zP().i18n;
        if (!1 === kb(e = [
            _H.Ready,
            _H.OneTimePassword
        ]).call(e, r)) return null;
        var l = bP(function() {
            return r === _H.Ready && o.length > 1 ? i.get("ctp.logout.notYourCards") : r === _H.Ready && 1 === o.length ? i.get("ctp.logout.notYourCard") : r === _H.Ready && 0 === o.length ? i.get("ctp.logout.notYourProfile") : i.get("ctp.logout.notYou");
        }, [
            i,
            r
        ]);
        return rN("span", {
            role: "button",
            tabIndex: 0,
            className: aP("adyen-checkout-ctp__section-logout-button", {
                "adyen-checkout-ctp__section-logout-button--disabled": "loading" === n
            }),
            onClick: a
        }, l);
    }, qH = function(e) {
        var t = e.children, r = xH().isStandaloneComponent;
        return rN("div", {
            className: aP("adyen-checkout-ctp__section", {
                "adyen-checkout-ctp__section--standalone": r
            })
        }, rN("div", {
            className: "adyen-checkout-ctp__section-brand"
        }, rN(OH, null), rN(HH, null)), t);
    };
    qH.Title = function(e) {
        var t = e.endAdornment;
        return rN("div", {
            className: "adyen-checkout-ctp__section-header"
        }, rN("h1", {
            className: "adyen-checkout-ctp__section-header-title"
        }, e.children), t && rN("span", {
            className: "adyen-checkout-ctp__section-header-adornment"
        }, t));
    }, qH.Text = function(e) {
        return rN("p", {
            className: "adyen-checkout-ctp__section-text"
        }, e.children);
    };
    function WH() {
        var e = zP().i18n, t = xH(), r = t.updateStoreCookiesConsent, a = Vk(fP(t.isStoringCookies), 2), n = a[0], o = a[1], i = Vk(fP(window.matchMedia("(max-width: 480px)").matches), 2), l = i[0], c = i[1], s = kP(function() {
            var e = !n;
            o(e), r(e);
        }, [
            r,
            o,
            n
        ]);
        return rN("div", {
            className: aP("adyen-checkout-ctp__otp-checkbox-container", {
                "adyen-checkout-ctp__otp-checkbox-container--checked": n
            })
        }, rN(oD, {
            name: "clickToPayCookiesCheckbox",
            addContextualElement: !1,
            useLabelElement: !1,
            i18n: e
        }, rN(dz, {
            name: "clickToPayCookiesCheckbox",
            onInput: s,
            label: e.get("ctp.otp.saveCookiesCheckbox.label"),
            checked: n,
            "aria-describedby": "adyen-ctp-cookies-info"
        })), rN("p", {
            className: "adyen-checkout-ctp__otp-checkbox-info"
        }, l ? rN(nN, null, rN("span", {
            id: "adyen-ctp-cookies-info"
        }, e.get("ctp.otp.saveCookiesCheckbox.shorterInfo"), " "), rN("button", {
            className: "adyen-checkout-ctp__otp-readmore-button",
            onClick: function() {
                return c(!1);
            }
        }, e.get("readMore"), "..")) : rN("span", {
            id: "adyen-ctp-cookies-info"
        }, e.get("ctp.otp.saveCookiesCheckbox.information"))));
    }
    var GH = function(e) {
        var t = e.onDisplayCardComponent, r = zP().i18n, a = xH(), n = a.finishIdentityValidation, o = a.otpMaskedContact, i = a.otpNetwork, l = a.isCtpPrimaryPaymentMethod, c = Vk(fP(null), 2), s = c[0], u = c[1], d = Vk(fP(!1), 2), p = d[0], m = d[1], f = Vk(fP(!1), 2), h = f[0], v = f[1], y = Vk(fP(null), 2), g = y[0], b = y[1], k = Vk(fP(null), 2), C = k[0], _ = k[1], N = Vk(fP(!1), 2), P = N[0], w = N[1], S = kP(function(e) {
            _(e);
        }, []), A = kP(function(e) {
            var t = e.data, r = e.isValid;
            u(t.otp), m(r);
        }, []), I = kP(function() {
            b(null);
        }, []), D = kP(Jd(Ey.mark(function e() {
            return Ey.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (b(null), p) {
                            e.next = 4;
                            break;
                        }
                        return C.validateInput(), e.abrupt("return");
                    case 4:
                        return v(!0), e.prev = 5, e.next = 8, n(s);
                    case 8:
                        e.next = 15;
                        break;
                    case 10:
                        e.prev = 10, e.t0 = e.catch(5), b(null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.reason), v(!1), "ACCT_INACCESSIBLE" === (null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.reason) && (w(!0), null == t || t());
                    case 15:
                    case "end":
                        return e.stop();
                }
            }, e, null, [
                [
                    5,
                    10
                ]
            ]);
        })), [
            s,
            p,
            C,
            t
        ]), E = r.get("ctp.otp.subtitle").split("%@");
        return rN(nN, null, rN(qH.Title, {
            endAdornment: rN(KH, null)
        }, r.get("ctp.otp.title")), rN(qH.Text, null, E[0], " ", i, " ", E[1], rN("span", {
            className: "adyen-checkout-ctp__otp-subtitle--highlighted"
        }, o), E[2]), rN(zH, {
            hideResendOtpButton: P,
            onChange: A,
            onSetInputHandlers: S,
            disabled: h,
            errorMessage: g && r.get("ctp.errors.".concat(g)),
            onPressEnter: D,
            onResendCode: I,
            isValidatingOtp: h
        }), rN(WH, null), rN(jP, {
            disabled: P,
            label: r.get("continue"),
            variant: l ? "primary" : "secondary",
            onClick: D,
            status: h && "loading"
        }));
    }, YH = function(e) {
        var t = e.card, r = e.errorMessage, a = zP().i18n, n = tI();
        return rN(nN, null, rN("div", {
            className: "adyen-checkout-ctp__card-list-single-card"
        }, rN(ST, {
            src: t.artUri || n()(t.scheme),
            height: 24,
            className: "adyen-checkout-ctp__card-image"
        }), rN("span", {
            className: aP({
                "adyen-checkout-ctp__card-list-single-card-expired": t.isExpired
            })
        }, t.title, " ", "\u2022\u2022\u2022\u2022 ".concat(t.panLastFour)), t.isExpired && rN("span", {
            className: "adyen-checkout-ctp__expired-label"
        }, a.get("ctp.cards.expiredCard"))), r && rN("div", {
            className: "adyen-checkout__error-text"
        }, r));
    }, QH = function() {
        return window.matchMedia("(max-width: 768px)").matches && /Android|iPhone|iPod/.test(navigator.userAgent);
    }, ZH = [
        "srcDigitalCardId"
    ], JH = function(e) {
        var t = e.cardSelected, r = e.cards, a = e.errorMessage, n = e.onChangeCard, o = zP().i18n, i = tI(), l = xH().status, c = QD({
            schema: ZH,
            defaultData: {
                srcDigitalCardId: t.srcDigitalCardId
            }
        }), s = c.handleChangeFor, u = c.data, d = bP(function() {
            return hC(r).call(r, function(e) {
                var t;
                return {
                    icon: e.artUri || i()(e.scheme),
                    name: wb(t = "".concat(QH() ? "" : e.title, " \u2022\u2022\u2022\u2022 ")).call(t, e.panLastFour, " "),
                    secondaryText: e.isExpired && o.get("ctp.cards.expiredCard"),
                    id: e.srcDigitalCardId,
                    disabled: e.isExpired
                };
            });
        }, [
            r
        ]);
        return vP(function() {
            var e = u.srcDigitalCardId, t = zb(r).call(r, function(t) {
                return t.srcDigitalCardId === e;
            });
            n(t);
        }, [
            u,
            n
        ]), rN(oD, {
            name: "clickToPayCards",
            errorMessage: a
        }, rN(OT, {
            items: d,
            selectedValue: u.srcDigitalCardId,
            name: "cards",
            filterable: !1,
            className: "adyen-checkout-ctp__cards-list-dropdown",
            readonly: "loading" === l,
            onChange: s("srcDigitalCardId")
        }));
    };
    function $H(e, t) {
        if (!e) return null;
        var r = t.get("ctp.errors.".concat(e));
        return kb(r).call(r, "ctp.errors") ? t.get("ctp.errors.UNKNOWN_ERROR") : r;
    }
    function XH(e, t, r) {
        return r ? QH() ? null : e.get("payButton.with", {
            values: {
                value: BP(e, t),
                maskedData: "\u2022\u2022\u2022\u2022 ".concat(null == r ? void 0 : r.panLastFour)
            }
        }) : e.get("payButton");
    }
    var eq = function(e) {
        var t = e.onDisplayCardComponent, r = zP().i18n, a = tI(), n = xH(), o = n.amount, i = n.cards, l = n.checkout, c = n.isCtpPrimaryPaymentMethod, s = n.status, u = n.onSubmit, d = n.onSetStatus, p = n.onError, m = Vk(fP(zb(i).call(i, function(e) {
            return !e.isExpired;
        }) || i[0]), 2), f = m[0], h = m[1], v = Vk(fP(null), 2), y = v[0], g = v[1], b = XA(i).call(i, function(e) {
            return e.isExpired;
        }), k = Vk(fP(!1), 2), C = k[0], _ = k[1];
        vP(function() {
            (0 === i.length || b) && (null == t || t());
        }, [
            t,
            b,
            i
        ]);
        var N = kP(Jd(Ey.mark(function e() {
            var t, r, a;
            return Ey.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (f) {
                            e.next = 2;
                            break;
                        }
                        return e.abrupt("return");
                    case 2:
                        return e.prev = 2, _(!0), g(null), d("loading"), e.next = 8, l(f);
                    case 8:
                        t = e.sent, u(t), e.next = 17;
                        break;
                    case 12:
                        e.prev = 12, e.t0 = e.catch(2), e.t0 instanceof YK && (g(null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.reason), console.warn(wb(r = wb(a = "CtP - Checkout: Reason: ".concat(null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.reason, " / Source: ")).call(a, null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.source, " / Scheme: ")).call(r, null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.scheme))), _(!1), p(e.t0);
                    case 17:
                    case "end":
                        return e.stop();
                }
            }, e, null, [
                [
                    2,
                    12
                ]
            ]);
        })), [
            l,
            f
        ]), P = kP(function(e) {
            h(e);
        }, []), w = C && "loading" === s && (null == f ? void 0 : f.isDcfPopupEmbedded), S = "loading" !== s || !w;
        return rN(nN, null, rN(kA, {
            name: mH,
            height: "380",
            width: "100%",
            classNameModifiers: [
                w ? "" : "hidden"
            ]
        }), S && rN(nN, null, rN(qH.Title, null, r.get("ctp.cards.title")), rN(qH.Text, null, r.get("ctp.cards.subtitle")), 0 === i.length && rN("div", {
            className: "adyen-checkout-ctp__empty-cards"
        }, r.get("ctp.emptyProfile.message")), 1 === i.length && rN(YH, {
            card: i[0],
            errorMessage: $H(y, r)
        }), i.length > 1 && rN(JH, {
            cardSelected: f,
            cards: i,
            onChangeCard: P,
            errorMessage: $H(y, r)
        }), rN(UP, {
            disabled: b,
            amount: o,
            label: XH(r, o, f),
            status: s,
            variant: c ? "primary" : "secondary",
            icon: 0 !== i.length && a({
                imageFolder: "components/"
            })(c ? "lock" : "lock_black"),
            onClick: N
        })));
    }, tq = function() {
        var e = zP().i18n;
        return rN(nN, null, rN("div", {
            className: "adyen-checkout-ctp__card-animation"
        }, rN("div", {
            className: "adyen-checkout-ctp__card-animation-layer"
        }), rN("div", {
            className: "adyen-checkout-ctp__card-animation-layer"
        }), rN("div", {
            className: "adyen-checkout-ctp__card-animation-layer"
        })), rN("div", {
            className: "adyen-checkout-ctp__loading-subtitle"
        }, e.get("ctp.loading.intro")));
    }, rq = {
        shopperLogin: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "",
            modes: [
                "blur"
            ]
        },
        default: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "",
            modes: [
                "blur"
            ]
        }
    }, aq = function(e) {
        var t = zP().i18n, r = QD({
            schema: [
                "shopperLogin"
            ],
            rules: rq
        }), a = r.handleChangeFor, n = r.data, o = r.triggerValidation, i = r.valid, l = r.errors, c = r.isValid, s = gP({
            validateInput: null
        }), u = Vk(fP(!1), 2), d = u[0], p = u[1], m = kP(function() {
            p(!0), o();
        }, [
            o
        ]);
        vP(function() {
            n.shopperLogin && p(!0);
        }, [
            n.shopperLogin
        ]), vP(function() {
            s.current.validateInput = m, e.onSetInputHandlers(s.current);
        }, [
            m,
            e.onSetInputHandlers
        ]);
        var f = kP(function(t) {
            "Enter" === t.key && e.onPressEnter();
        }, [
            e.onPressEnter
        ]), h = kP(function(e) {
            "Enter" === e.key && e.preventDefault();
        }, []);
        return vP(function() {
            e.onChange({
                data: n,
                valid: i,
                errors: l,
                isValid: c
            });
        }, [
            n,
            i,
            l
        ]), rN(oD, {
            name: "shopperLogin",
            label: t.get("ctp.login.inputLabel"),
            errorMessage: d ? e.errorMessage || !!l.shopperLogin : null,
            classNameModifiers: [
                "shopperLogin"
            ]
        }, rN(BE, {
            name: "shopperLogin",
            autocorrect: "off",
            spellcheck: !1,
            value: n.shopperLogin,
            disabled: e.disabled,
            onInput: a("shopperLogin", "input"),
            onBlur: a("shopperLogin", "blur"),
            onKeyPress: h,
            onKeyUp: f
        }));
    }, nq = function() {
        var e = zP().i18n, t = xH(), r = t.isCtpPrimaryPaymentMethod, a = t.setIsCtpPrimaryPaymentMethod, n = t.verifyIfShopperIsEnrolled, o = t.startIdentityValidation, i = Vk(fP(null), 2), l = i[0], c = i[1], s = Vk(fP(!1), 2), u = s[0], d = s[1], p = Vk(fP(null), 2), m = p[0], f = p[1], h = Vk(fP(!1), 2), v = h[0], y = h[1], g = Vk(fP(null), 2), b = g[0], k = g[1], C = kP(function(e) {
            k(e);
        }, []), _ = kP(function(e) {
            var t, r = e.data, n = e.isValid;
            c(r.shopperLogin), d(n), (null == r || null === (t = r.shopperLogin) || void 0 === t ? void 0 : t.length) > 0 && a(!0);
        }, []), N = kP(Jd(Ey.mark(function e() {
            var t;
            return Ey.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (f(null), u) {
                            e.next = 4;
                            break;
                        }
                        return b.validateInput(), e.abrupt("return");
                    case 4:
                        return y(!0), e.prev = 5, e.next = 8, n({
                            shopperEmail: l
                        });
                    case 8:
                        if (t = e.sent, !t.isEnrolled) {
                            e.next = 15;
                            break;
                        }
                        return e.next = 13, o();
                    case 13:
                        e.next = 17;
                        break;
                    case 15:
                        f("NOT_FOUND"), y(!1);
                    case 17:
                        e.next = 25;
                        break;
                    case 19:
                        e.prev = 19, e.t0 = e.catch(5), e.t0 instanceof YK && console.warn("CtP - Login error: ".concat(e.t0.toString())), e.t0 instanceof bH && console.warn(e.t0.toString()), f(null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.reason), y(!1);
                    case 25:
                    case "end":
                        return e.stop();
                }
            }, e, null, [
                [
                    5,
                    19
                ]
            ]);
        })), [
            n,
            o,
            l,
            u,
            b
        ]);
        return rN(nN, null, rN(qH.Title, {
            endAdornment: rN(KH, null)
        }, e.get("ctp.login.title")), rN(qH.Text, null, e.get("ctp.login.subtitle")), rN(aq, {
            onChange: _,
            onSetInputHandlers: C,
            disabled: v,
            errorMessage: m && e.get("ctp.errors.".concat(m)),
            onPressEnter: N
        }), rN(jP, {
            label: e.get("continue"),
            variant: r ? "primary" : "secondary",
            status: v && "loading",
            onClick: function() {
                N();
            }
        }));
    }, oq = function(e) {
        var t, r = e.onDisplayCardComponent, a = xH(), n = a.ctpState, o = a.onReady, i = a.startIdentityValidation, l = a.logoutShopper;
        return vP(function() {
            var e;
            kb(e = [
                _H.OneTimePassword,
                _H.Login,
                _H.Ready
            ]).call(e, n) && o();
        }, [
            n,
            o
        ]), vP(function() {
            function e() {
                return e = Jd(Ey.mark(function e() {
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, e.next = 3, i();
                            case 3:
                                e.next = 10;
                                break;
                            case 5:
                                return e.prev = 5, e.t0 = e.catch(0), e.t0 instanceof YK && console.warn("CtP - Identity Validation error: ".concat(e.t0.toString())), e.next = 10, l();
                            case 10:
                            case "end":
                                return e.stop();
                        }
                    }, e, null, [
                        [
                            0,
                            5
                        ]
                    ]);
                })), e.apply(this, arguments);
            }
            n === _H.ShopperIdentified && function() {
                e.apply(this, arguments);
            }();
        }, [
            n
        ]), n === _H.NotAvailable ? null : rN(qH, null, kb(t = [
            _H.Loading,
            _H.ShopperIdentified
        ]).call(t, n) && rN(tq, null), n === _H.OneTimePassword && rN(GH, {
            onDisplayCardComponent: r
        }), n === _H.Ready && rN(eq, {
            onDisplayCardComponent: r
        }), n === _H.Login && rN(nq, null));
    }, iq = function(e) {
        var t = e.children, r = zP().i18n, a = Vk(fP(null), 2), n = a[0], o = a[1], i = xH(), l = i.ctpState, c = i.isCtpPrimaryPaymentMethod, s = i.setIsCtpPrimaryPaymentMethod, u = i.status, d = null === n && null === c;
        vP(function() {
            if (d) {
                if (l === _H.ShopperIdentified || l === _H.Ready) return o(!1), void s(!0);
                l === _H.NotAvailable && (o(!0), s(!1));
            }
        }, [
            l,
            d
        ]);
        var p = kP(function() {
            o(!0), s(!1);
        }, []);
        return l === _H.NotAvailable ? t() : l === _H.Loading || l === _H.ShopperIdentified ? rN(oq, null) : rN(nN, null, rN(oq, {
            onDisplayCardComponent: p
        }), rN(cB, {
            classNames: [
                "adyen-checkout-ctp__separator"
            ],
            label: r.get("ctp.separatorText")
        }), n ? t(!c) : rN(jP, {
            variant: "secondary",
            disabled: "loading" === u,
            label: r.get("ctp.manualCardEntry"),
            onClick: p
        }));
    }, lq = [
        "amount",
        "configuration",
        "clickToPayService",
        "setClickToPayRef",
        "onSetStatus",
        "onSubmit",
        "onError",
        "isStandaloneComponent"
    ], cq = function(e) {
        var t = e.amount, r = e.configuration, a = e.clickToPayService, n = e.setClickToPayRef, o = e.onSetStatus, i = e.onSubmit, l = e.onError, c = e.isStandaloneComponent, s = kg(e, lq);
        return rN(RH, {
            isStandaloneComponent: c,
            configuration: r,
            amount: t,
            clickToPayService: a,
            setClickToPayRef: n,
            onSetStatus: o,
            onSubmit: i,
            onError: l
        }, rN(iq, null, s.children));
    };
    function sq(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function uq(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = sq(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = sq(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function dq(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var pq = function(e) {
        L_(r, e);
        var t = dq(r);
        function r(e) {
            var a, n;
            (Cg(this, r), Sg(B_(a = t.call(this, e)), "clickToPayService", void 0), Sg(B_(a), "clickToPayRef", null), Sg(B_(a), "setClickToPayRef", function(e) {
                a.clickToPayRef = e;
            }), Sg(B_(a), "onBrand", function(e) {
                a.eventEmitter.emit("brand", uq(uq({}, e), {}, {
                    brand: "card" === e.brand ? null : e.brand
                })), a.props.onBrand && a.props.onBrand(e);
            }), Sg(B_(a), "handleClickToPaySubmit", function(e) {
                a.setState({
                    data: uq({}, e),
                    valid: {},
                    errors: {},
                    isValid: !0
                }), a.submit();
            }), Sg(B_(a), "onBinValue", WK(B_(a))), Sg(B_(a), "payButton", function(e) {
                var t, r, n = 0 === (null === (t = a.props.amount) || void 0 === t ? void 0 : t.value), o = (null === (r = a.props.storedPaymentMethodId) || void 0 === r ? void 0 : r.length) > 0;
                return rN(UP, j_({}, e, {
                    amount: a.props.amount,
                    secondaryAmount: a.props.secondaryAmount,
                    label: n && !o ? a.props.i18n.get("payButton.saveDetails") : "",
                    onClick: a.submit
                }));
            }), e._disableClickToPay) || (a.clickToPayService = AH(a.props.configuration, a.props.clickToPayConfiguration, a.props.environment), null === (n = a.clickToPayService) || void 0 === n || n.initialize());
            return a;
        }
        return wg(r, [
            {
                key: "setStatus",
                value: function(e, t) {
                    var r, a;
                    return null !== (r = this.componentRef) && void 0 !== r && r.setStatus && this.componentRef.setStatus(e, t), null !== (a = this.clickToPayRef) && void 0 !== a && a.setStatus && this.clickToPayRef.setStatus(e, t), this;
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    var t, r, a, n, o, i, l, c, s, u, d, p, m, f, h = !(0 === (null === (t = e.amount) || void 0 === t ? void 0 : t.value)) && ((null === (r = e.session) || void 0 === r || null === (r = r.configuration) || void 0 === r ? void 0 : r.enableStoreDetails) || e.enableStoreDetails);
                    return uq(uq({}, e), {}, {
                        holderNameRequired: !!e.hasHolderName && e.holderNameRequired,
                        hasCVC: !(e.brand && "bcmc" === e.brand || e.hideCVC),
                        billingAddressRequired: !e.storedPaymentMethodId && e.billingAddressRequired,
                        type: "scheme" === e.type ? "card" : e.type,
                        countryCode: e.countryCode ? e.countryCode.toLowerCase() : null,
                        configuration: uq(uq({}, e.configuration), {}, {
                            socialSecurityNumberMode: null !== (a = null === (n = e.configuration) || void 0 === n ? void 0 : n.socialSecurityNumberMode) && void 0 !== a ? a : "auto"
                        }),
                        brandsConfiguration: e.brandsConfiguration || (null === (o = e.configuration) || void 0 === o ? void 0 : o.brandsConfiguration) || {},
                        icon: e.icon || (null === (i = e.configuration) || void 0 === i ? void 0 : i.icon),
                        installmentOptions: (null === (l = e.session) || void 0 === l || null === (l = l.configuration) || void 0 === l ? void 0 : l.installmentOptions) || e.installmentOptions,
                        enableStoreDetails: h,
                        clickToPayConfiguration: uq(uq({}, e.clickToPayConfiguration), {}, {
                            disableOtpAutoFocus: (null === (c = e.clickToPayConfiguration) || void 0 === c ? void 0 : c.disableOtpAutoFocus) || !1,
                            shopperEmail: (null === (s = e.clickToPayConfiguration) || void 0 === s ? void 0 : s.shopperEmail) || (null == e || null === (u = e._parentInstance) || void 0 === u || null === (u = u.options) || void 0 === u || null === (u = u.session) || void 0 === u ? void 0 : u.shopperEmail),
                            telephoneNumber: (null === (d = e.clickToPayConfiguration) || void 0 === d ? void 0 : d.telephoneNumber) || (null == e || null === (p = e._parentInstance) || void 0 === p || null === (p = p.options) || void 0 === p || null === (p = p.session) || void 0 === p ? void 0 : p.telephoneNumber),
                            locale: (null === (m = e.clickToPayConfiguration) || void 0 === m ? void 0 : m.locale) || (null === (f = e.i18n) || void 0 === f || null === (f = f.locale) || void 0 === f ? void 0 : f.replace("-", "_"))
                        })
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e, t = this.state.selectedBrandValue || this.props.brand;
                    return uq(uq(uq(uq(uq({
                        paymentMethod: uq(uq(uq(uq({
                            type: r.type
                        }, this.state.data), this.props.storedPaymentMethodId && {
                            storedPaymentMethodId: this.props.storedPaymentMethodId
                        }), t && {
                            brand: t
                        }), this.props.fundingSource && {
                            fundingSource: this.props.fundingSource
                        })
                    }, this.state.billingAddress && {
                        billingAddress: this.state.billingAddress
                    }), this.state.socialSecurityNumber && {
                        socialSecurityNumber: this.state.socialSecurityNumber
                    }), this.storePaymentMethodPayload), ("revolving" === (null == (e = this.state.installments) ? void 0 : e.plan) || (null == e ? void 0 : e.value) > 1) && {
                        installments: this.state.installments
                    }), {}, {
                        browserInfo: this.browserInfo,
                        origin: !!window && window.location.origin
                    });
                }
            },
            {
                key: "updateStyles",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.updateStyles && this.componentRef.updateStyles(e), this;
                }
            },
            {
                key: "setFocusOn",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.setFocusOn && this.componentRef.setFocusOn(e), this;
                }
            },
            {
                key: "processBinLookupResponse",
                value: function(e) {
                    var t, r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    return null !== (t = this.componentRef) && void 0 !== t && t.processBinLookupResponse && this.componentRef.processBinLookupResponse(e, r), this;
                }
            },
            {
                key: "handleUnsupportedCard",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.handleUnsupportedCard && this.componentRef.handleUnsupportedCard(e), this;
                }
            },
            {
                key: "onBinLookup",
                value: function(e) {
                    if (!e.isReset) {
                        var t = kV("supportedBrandsRaw").from(e);
                        this.props.onBinLookup(t);
                    }
                }
            },
            {
                key: "storePaymentMethodPayload",
                get: function() {
                    var e, t;
                    return (null === (e = this.props.storedPaymentMethodId) || void 0 === e ? void 0 : e.length) > 0 ? {} : 0 === (null === (t = this.props.amount) || void 0 === t ? void 0 : t.value) ? {
                        storePaymentMethod: !0
                    } : this.props.enableStoreDetails && void 0 !== this.state.storePaymentMethod ? {
                        storePaymentMethod: Boolean(this.state.storePaymentMethod)
                    } : {};
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "icon",
                get: function() {
                    var e;
                    return null !== (e = this.props.icon) && void 0 !== e ? e : this.resources.getImage()(this.brand);
                }
            },
            {
                key: "brands",
                get: function() {
                    var e = this, t = this.props, r = t.brands, a = t.brandsConfiguration;
                    return r ? hC(r).call(r, function(t) {
                        var r, n;
                        return {
                            icon: null !== (r = null === (n = a[t]) || void 0 === n ? void 0 : n.icon) && void 0 !== r ? r : e.props.modules.resources.getImage()(t),
                            name: t
                        };
                    }) : [];
                }
            },
            {
                key: "brand",
                get: function() {
                    return this.props.brand || this.props.type;
                }
            },
            {
                key: "displayName",
                get: function() {
                    return this.props.storedPaymentMethodId ? "\u2022\u2022\u2022\u2022 ".concat(this.props.lastFour) : this.props.name || r.type;
                }
            },
            {
                key: "accessibleName",
                get: function() {
                    return (this.props.name || r.type) + (this.props.storedPaymentMethodId ? " " + this.props.i18n.get("creditCard.storedCard.description.ariaLabel").replace("%@", this.props.lastFour) : "");
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return cj();
                }
            },
            {
                key: "renderCardInput",
                value: function() {
                    var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                    return rN(HK, j_({
                        setComponentRef: this.setComponentRef
                    }, this.props, this.state, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        onBrand: this.onBrand,
                        onBinValue: this.onBinValue,
                        brand: this.brand,
                        brandsIcons: this.brands,
                        isPayButtonPrimaryVariant: e,
                        resources: this.resources
                    }));
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(qO, {
                        srPanel: this.props.modules.srPanel
                    }, rN(cq, {
                        amount: this.props.amount,
                        configuration: this.props.clickToPayConfiguration,
                        clickToPayService: this.clickToPayService,
                        isStandaloneComponent: !1,
                        setClickToPayRef: this.setClickToPayRef,
                        onSetStatus: this.setElementStatus,
                        onSubmit: this.handleClickToPaySubmit,
                        onError: this.handleError
                    }, function(t) {
                        return e.renderCardInput(t);
                    })));
                }
            }
        ]), r;
    }(gA);
    Sg(pq, "type", "scheme"), Sg(pq, "defaultProps", {
        onBinLookup: function() {},
        showBrandsUnderCardNumber: !0,
        showFormInstruction: !0,
        _disableClickToPay: !1
    });
    var mq = function(e) {
        return e.CustomerDismissed = "CUSTOMER_DISMISSED", e.CustomerRequestApproved = "CUSTOMER_REQUEST_APPROVED", e.CustomerRequestDeclined = "CUSTOMER_REQUEST_DECLINED", e.CustomerRequestFailed = "CUSTOMER_REQUEST_FAILED", e;
    }({});
    function fq(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function hq(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = fq(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = fq(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function vq(e) {
        var t = e.enableStoreDetails, r = e.cashAppService, a = e.onClick, n = e.onChangeStoreDetails, o = e.onAuthorize, i = e.onError, l = gP(null), c = Vk(fP("loading"), 2), s = c[0], u = c[1], d = gP([]), p = Vk(fP(!1), 2), m = p[0], f = p[1];
        this.setStatus = u;
        var h = kP(Jd(Ey.mark(function e() {
            return Ey.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return e.prev = 0, e.next = 3, r.initialize();
                    case 3:
                        return d.current = [
                            r.subscribeToEvent(mq.CustomerDismissed, function() {
                                i(new mA("CANCEL", "Customer dismissed the modal"));
                            }),
                            r.subscribeToEvent(mq.CustomerRequestDeclined, Jd(Ey.mark(function e() {
                                return Ey.wrap(function(e) {
                                    for(;;)switch(e.prev = e.next){
                                        case 0:
                                            return i(new mA("ERROR", "Payment declined by CashAppPay")), e.next = 3, r.restart();
                                        case 3:
                                            return e.next = 5, r.renderButton(l.current);
                                        case 5:
                                        case "end":
                                            return e.stop();
                                    }
                                }, e);
                            }))),
                            r.subscribeToEvent(mq.CustomerRequestApproved, function(e) {
                                var t, r, a = e.customerProfile, n = e.grants, i = hq(hq(hq(hq({}, (null == a ? void 0 : a.id) && {
                                    customerId: a.id
                                }), (null == a ? void 0 : a.cashtag) && {
                                    cashTag: a.cashtag
                                }), (null == n || null === (t = n.payment) || void 0 === t ? void 0 : t.grantId) && {
                                    grantId: n.payment.grantId
                                }), (null == n || null === (r = n.onFile) || void 0 === r ? void 0 : r.grantId) && {
                                    onFileGrantId: n.onFile.grantId
                                });
                                o(i);
                            }),
                            r.subscribeToEvent(mq.CustomerRequestFailed, function() {
                                i(new mA("ERROR", "Customer request failed"));
                            })
                        ], e.next = 6, r.renderButton(l.current);
                    case 6:
                        u("ready"), e.next = 12;
                        break;
                    case 9:
                        e.prev = 9, e.t0 = e.catch(0), i(e.t0);
                    case 12:
                    case "end":
                        return e.stop();
                }
            }, e, null, [
                [
                    0,
                    9
                ]
            ]);
        })), [
            r,
            i,
            o
        ]);
        return vP(function() {
            t && (r.setStorePaymentMethod(m), n(m));
        }, [
            t,
            m
        ]), vP(function() {
            return h(), function() {
                var e;
                r.restart(), Ag(e = d.current).call(e, function(e) {
                    return e();
                });
            };
        }, [
            r,
            h
        ]), rN("div", {
            className: "adyen-checkout__cashapp"
        }, "loading" === s && rN(nP, null), "loading" !== s && t && rN(FK, {
            storeDetails: m,
            onChange: f
        }), rN("div", {
            onClick: a,
            className: "adyen-checkout__cashapp-button",
            ref: l
        }));
    }
    function yq(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function gq(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = yq(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = yq(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var bq = function() {
        function e(t, r) {
            Cg(this, e), Sg(this, "sdkLoader", void 0), Sg(this, "configuration", void 0), Sg(this, "pay", void 0), Sg(this, "startAuthorization", void 0), this.configuration = r, this.sdkLoader = t, r.clientId || console.warn("CashAppService: clientId is missing");
        }
        var t, r, a, n;
        return wg(e, [
            {
                key: "hasOneTimePayment",
                get: function() {
                    var e = this.configuration.amount;
                    return (null == e ? void 0 : e.value) > 0;
                }
            },
            {
                key: "hasOnFilePayment",
                get: function() {
                    return this.configuration.storePaymentMethod;
                }
            },
            {
                key: "setStorePaymentMethod",
                value: function(e) {
                    this.configuration.storePaymentMethod = e;
                }
            },
            {
                key: "initialize",
                value: (n = Jd(Ey.mark(function e() {
                    var t, r, a, n;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, t = this.configuration, r = t.environment, a = t.clientId, e.next = 4, this.sdkLoader.load(r);
                            case 4:
                                return n = e.sent, e.next = 7, n.pay({
                                    clientId: a
                                });
                            case 7:
                                this.pay = e.sent, e.next = 13;
                                break;
                            case 10:
                                throw e.prev = 10, e.t0 = e.catch(0), new mA("ERROR", "Error during initialization", {
                                    cause: e.t0
                                });
                            case 13:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            10
                        ]
                    ]);
                })), function() {
                    return n.apply(this, arguments);
                })
            },
            {
                key: "renderButton",
                value: (a = Jd(Ey.mark(function e(t) {
                    var r, a, n, o, i;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, r = this.configuration, a = r.button, n = r.useCashAppButtonUi, e.next = 4, this.pay.render(t, {
                                    manage: !1,
                                    button: !!n && gq({
                                        width: "full",
                                        shape: "semiround"
                                    }, a)
                                });
                            case 4:
                                o = e.sent, i = o.begin, this.startAuthorization = i, e.next = 12;
                                break;
                            case 9:
                                throw e.prev = 9, e.t0 = e.catch(0), new mA("ERROR", "Error rendering CashAppPay button", {
                                    cause: e.t0
                                });
                            case 12:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            9
                        ]
                    ]);
                })), function(e) {
                    return a.apply(this, arguments);
                })
            },
            {
                key: "begin",
                value: function() {
                    this.startAuthorization ? this.startAuthorization() : console.warn("CashAppService - begin() not available");
                }
            },
            {
                key: "subscribeToEvent",
                value: function(e, t) {
                    var r = this;
                    return this.pay.addEventListener(e, t), function() {
                        r.pay.removeEventListener(e, t);
                    };
                }
            },
            {
                key: "createCustomerRequest",
                value: (r = Jd(Ey.mark(function e() {
                    var t, r, a, n, o, i, l;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.prev = 0, t = this.configuration, r = t.referenceId, a = t.amount, n = t.scopeId, o = t.redirectURL, i = void 0 === o ? window.location.href : o, l = {
                                    referenceId: r,
                                    redirectURL: i,
                                    actions: gq(gq({}, this.hasOneTimePayment && {
                                        payment: {
                                            amount: a,
                                            scopeId: n
                                        }
                                    }), this.hasOnFilePayment && {
                                        onFile: {
                                            scopeId: n
                                        }
                                    })
                                }, e.next = 5, this.pay.customerRequest(l);
                            case 5:
                                e.next = 10;
                                break;
                            case 7:
                                throw e.prev = 7, e.t0 = e.catch(0), new mA("ERROR", "Something went wrong during customerRequest creation", {
                                    cause: e.t0
                                });
                            case 10:
                            case "end":
                                return e.stop();
                        }
                    }, e, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                })), function() {
                    return r.apply(this, arguments);
                })
            },
            {
                key: "restart",
                value: (t = Jd(Ey.mark(function e() {
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return e.next = 2, this.pay.restart();
                            case 2:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function() {
                    return t.apply(this, arguments);
                })
            }
        ]), e;
    }(), kq = function() {
        function e() {
            Cg(this, e);
        }
        var t;
        return wg(e, [
            {
                key: "isSdkIsAvailableOnWindow",
                value: function() {
                    return !!window.CashApp;
                }
            },
            {
                key: "load",
                value: (t = Jd(Ey.mark(function e(t) {
                    var r, a, n;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (a = kb(r = t.toLowerCase()).call(r, "live") ? "https://kit.cash.app/v1/pay.js" : "https://sandbox.kit.cash.app/v1/pay.js", this.isSdkIsAvailableOnWindow()) {
                                    e.next = 5;
                                    break;
                                }
                                return n = new Rj(a), e.next = 5, n.load();
                            case 5:
                                return e.abrupt("return", window.CashApp);
                            case 6:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            }
        ]), e;
    }();
    function Cq(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function _q(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = Cq(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = Cq(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function Nq(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var Pq = function(e) {
        L_(r, e);
        var t = Nq(r);
        function r(e) {
            var a, n, o, i, l;
            return Cg(this, r), Sg(B_(l = t.call(this, e)), "cashAppService", void 0), Sg(B_(l), "submit", function() {
                var e = l.props, t = e.onClick;
                if (e.storedPaymentMethodId) GA((o = B_(l), U_(r.prototype)), "submit", o).call(o);
                else {
                    var a = !1;
                    new Sb(function(e, r) {
                        return t({
                            resolve: e,
                            reject: r
                        });
                    }).catch(function() {
                        throw a = !0, Error("onClick rejected");
                    }).then(function() {
                        return l.cashAppService.createCustomerRequest();
                    }).then(function() {
                        l.cashAppService.begin();
                    }).catch(function(e) {
                        a || l.handleError(e);
                    });
                }
            }), Sg(B_(l), "handleOnChangeStoreDetails", function(e) {
                var t = _q(_q({}, l.state.data), {}, {
                    shopperWantsToStore: e
                });
                l.setState({
                    data: t
                });
            }), Sg(B_(l), "handleAuthorize", function(e) {
                var t = _q(_q({}, l.state.data), e);
                l.setState({
                    data: t,
                    valid: {},
                    errors: {},
                    isValid: !0
                }), GA((i = B_(l), U_(r.prototype)), "submit", i).call(i);
            }), l.props.enableStoreDetails && l.props.storePaymentMethod && console.warn("CashAppPay: enableStoreDetails AND storePaymentMethod configuration properties should not be used together. That can lead to undesired behavior."), l.props.storedPaymentMethodId ? V_(l) : (l.cashAppService = new bq(new kq, {
                storePaymentMethod: l.props.storePaymentMethod,
                useCashAppButtonUi: l.props.showPayButton,
                environment: l.props.environment,
                amount: l.props.amount,
                redirectURL: l.props.redirectURL,
                clientId: null === (a = l.props.configuration) || void 0 === a ? void 0 : a.clientId,
                scopeId: null === (n = l.props.configuration) || void 0 === n ? void 0 : n.scopeId,
                button: l.props.button,
                referenceId: l.props.referenceId
            }), l);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t;
                    return _q(_q({}, e), {}, {
                        enableStoreDetails: (null === (t = e.session) || void 0 === t || null === (t = t.configuration) || void 0 === t ? void 0 : t.enableStoreDetails) || e.enableStoreDetails
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.data || {}, t = e.shopperWantsToStore, a = e.grantId, n = e.onFileGrantId, o = e.cashTag, i = e.customerId, l = this.props, c = l.storePaymentMethod, s = l.storedPaymentMethodId, u = this.props.enableStoreDetails || !this.props.session && c;
                    if (s) return {
                        paymentMethod: {
                            type: r.type,
                            storedPaymentMethodId: s
                        }
                    };
                    var d = n && o;
                    return _q({
                        paymentMethod: _q(_q(_q({
                            type: r.type
                        }, a && {
                            grantId: a
                        }), i && {
                            customerId: i
                        }), d && {
                            onFileGrantId: n,
                            cashtag: o
                        })
                    }, u && {
                        storePaymentMethod: c || t
                    });
                }
            },
            {
                key: "displayName",
                get: function() {
                    return this.props.storedPaymentMethodId && this.props.cashtag ? this.props.cashtag : this.props.name;
                }
            },
            {
                key: "additionalInfo",
                get: function() {
                    return this.props.storedPaymentMethodId ? "Cash App Pay" : "";
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "render",
                value: function() {
                    var e, t = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        resources: this.resources,
                        loadingContext: this.props.loadingContext
                    }, this.props.storedPaymentMethodId ? rN(TL, {
                        label: MP(this.props.i18n, this.props.amount),
                        icon: null === (e = this.resources) || void 0 === e ? void 0 : e.getImage({
                            imageFolder: "components/"
                        })("lock"),
                        name: this.displayName,
                        amount: this.props.amount,
                        payButton: this.payButton,
                        onSubmit: this.submit,
                        ref: function(e) {
                            t.componentRef = e;
                        }
                    }) : rN(vq, {
                        ref: function(e) {
                            t.componentRef = e;
                        },
                        enableStoreDetails: this.props.enableStoreDetails,
                        cashAppService: this.cashAppService,
                        onChangeStoreDetails: this.handleOnChangeStoreDetails,
                        onError: this.handleError,
                        onClick: this.submit,
                        onAuthorize: this.handleAuthorize
                    }));
                }
            }
        ]), r;
    }(gA);
    function wq(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Sq(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = wq(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = wq(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function Aq(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(Pq, "type", "cashapp"), Sg(Pq, "defaultProps", {
        onClick: function(e) {
            e.resolve();
        },
        showPayButton: !0,
        enableStoreDetails: !1,
        storePaymentMethod: !1
    });
    var Iq = function(e) {
        L_(a, e);
        var t, r = Aq(a);
        function a(e) {
            var t, n;
            return Cg(this, a), Sg(B_(n = r.call(this, e)), "clickToPayService", void 0), Sg(B_(n), "ctpConfiguration", void 0), Sg(B_(n), "handleClickToPaySubmit", function(e) {
                n.setState({
                    data: Sq({}, e),
                    valid: {},
                    errors: {},
                    isValid: !0
                }), n.submit();
            }), n.ctpConfiguration = {
                shopperEmail: n.props.shopperEmail,
                telephoneNumber: n.props.telephoneNumber,
                merchantDisplayName: n.props.merchantDisplayName,
                locale: n.props.locale,
                onReady: n.props.onReady,
                onTimeout: n.props.onTimeout
            }, n.clickToPayService = AH(n.props.configuration, n.ctpConfiguration, n.props.environment), null === (t = n.clickToPayService) || void 0 === t || t.initialize().catch(function(e) {
                n.handleError(new mA("ERROR", e.toString(), {
                    cause: e
                }));
            }), n.clickToPayService || console.warn("ClickToPay not initialized - Likely the payment method is not configured or its configuration is missing"), n;
        }
        return wg(a, [
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return cj();
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e, t = this.state.data, r = t.srcScheme, n = t.srcCorrelationId, o = t.srcTokenReference, i = t.srcCheckoutPayload, l = t.srcDigitalCardId;
                    return {
                        paymentMethod: Sq(Sq(Sq(Sq(Sq({
                            type: a.type
                        }, r && {
                            srcScheme: r
                        }), n && {
                            srcCorrelationId: n
                        }), o && {
                            srcTokenReference: o
                        }), i && {
                            srcCheckoutPayload: i
                        }), l && {
                            srcDigitalCardId: l
                        }),
                        browserInfo: this.browserInfo,
                        origin: null === (e = window) || void 0 === e || null === (e = e.location) || void 0 === e ? void 0 : e.origin
                    };
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    var t, r, a;
                    return Sq(Sq({}, e), {}, {
                        disableOtpAutoFocus: e.disableOtpAutoFocus || !1,
                        shopperEmail: e.shopperEmail || (null == e || null === (t = e._parentInstance) || void 0 === t || null === (t = t.options) || void 0 === t || null === (t = t.session) || void 0 === t ? void 0 : t.shopperEmail),
                        telephoneNumber: e.telephoneNumber || (null == e || null === (r = e._parentInstance) || void 0 === r || null === (r = r.options) || void 0 === r || null === (r = r.session) || void 0 === r ? void 0 : r.telephoneNumber),
                        locale: e.locale || (null === (a = e.i18n) || void 0 === a || null === (a = a.locale) || void 0 === a ? void 0 : a.replace("-", "_"))
                    });
                }
            },
            {
                key: "isAvailable",
                value: (t = Jd(Ey.mark(function e() {
                    var t = this;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (this.clickToPayService) {
                                    e.next = 2;
                                    break;
                                }
                                return e.abrupt("return", Sb.reject());
                            case 2:
                                if (!this.clickToPayService.shopperAccountFound) {
                                    e.next = 4;
                                    break;
                                }
                                return e.abrupt("return", Sb.resolve());
                            case 4:
                                return e.abrupt("return", new Sb(function(e, r) {
                                    t.clickToPayService.subscribeOnStateChange(function(a) {
                                        t.clickToPayService.shopperAccountFound && e(), a !== _H.NotAvailable && a !== _H.Login && a !== _H.Idle || r();
                                    });
                                }));
                            case 5:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function() {
                    return t.apply(this, arguments);
                })
            },
            {
                key: "render",
                value: function() {
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(RH, {
                        isStandaloneComponent: !0,
                        configuration: this.ctpConfiguration,
                        amount: this.props.amount,
                        clickToPayService: this.clickToPayService,
                        setClickToPayRef: this.setComponentRef,
                        onSetStatus: this.setElementStatus,
                        onSubmit: this.handleClickToPaySubmit,
                        onError: this.handleError
                    }, rN(oq, null)));
                }
            }
        ]), a;
    }(gA);
    function Dq(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Eq(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = Dq(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = Dq(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function Rq(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(Iq, "type", "clicktopay");
    var xq = function(e) {
        L_(r, e);
        var t = Rq(r);
        function r(e) {
            var a;
            return Cg(this, r), Sg(B_(a = t.call(this, e)), "onBrand", function(e) {
                a.props.onBrand && a.props.onBrand(e);
            }), a;
        }
        return wg(r, [
            {
                key: "formatData",
                value: function() {
                    var e = GA(U_(r.prototype), "formatData", this).call(this);
                    return e.paymentMethod.type = this.constructor.type, e;
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    return Eq(Eq({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        type: "bcmc",
                        cvcPolicy: SI
                    });
                }
            }
        ]), r;
    }(pq);
    function Fq(e) {
        var t = e.description, r = void 0 === t ? "" : t, a = e.name, n = void 0 === a ? "" : a, o = e.logoUrl, i = void 0 === o ? "" : o, l = e.url, c = void 0 === l ? "" : l, s = e.backgroundUrl, u = void 0 === s ? "" : s;
        return rN("div", {
            className: "adyen-checkout__campaign-container"
        }, rN(ST, {
            className: "adyen-checkout__campaign-background-image",
            style: {
                backgroundImage: "linear-gradient(0, #000, #0003), url(".concat(u, ")")
            },
            backgroundUrl: u
        }), rN("div", {
            className: "adyen-checkout__campaign-content"
        }, i && rN("img", {
            src: i,
            className: "adyen-checkout__campaign-logo",
            alt: n
        }), n && rN("div", {
            className: "adyen-checkout__campaign-title"
        }, n), r && rN("div", {
            className: "adyen-checkout__campaign-description"
        }, r, c && " \u203A")));
    }
    function Tq(e) {
        var t = e.url;
        return rN("div", {
            className: "adyen-checkout__campaign"
        }, !t && rN(Fq, e), t && rN("a", {
            href: t,
            className: "adyen-checkout__campaign-link",
            target: "_blank",
            rel: "noopener noreferrer"
        }, rN(Fq, e)));
    }
    Sg(xq, "type", "bcmc"), Sg(xq, "defaultProps", Eq(Eq({}, pq.defaultProps), {}, {
        brands: [
            "bcmc",
            "maestro",
            "visa"
        ]
    }));
    var zq = function(e) {
        var t = e.options, r = void 0 === t ? [] : t, a = e.name, n = e.onChange;
        return rN("div", {
            className: "adyen-checkout__button-group"
        }, hC(r).call(r, function(e, t) {
            var r, o = e.label, i = e.selected, l = e.value, c = e.disabled;
            return rN("label", {
                key: wb(r = "".concat(a)).call(r, t),
                className: aP({
                    "adyen-checkout__button": !0,
                    "adyen-checkout__button--selected": i,
                    "adyen-checkout__button--disabled": c
                })
            }, rN("input", {
                type: "radio",
                className: "adyen-checkout__button-group__input",
                value: l,
                checked: i,
                onChange: n,
                disabled: c
            }), rN("span", {
                className: "adyen-checkout__button-text"
            }, o));
        }));
    };
    function Oq(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function jq(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = Oq(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = Oq(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function Bq(e) {
        var t, r = e.amounts, a = e.onCancel, n = e.onDonate, o = e.showCancelButton, i = void 0 === o || o, l = e.disclaimerMessage, c = zP().i18n, s = tI(), u = r.currency, d = Vk(fP("ready"), 2), p = d[0], m = d[1], f = Vk(fP(!1), 2), h = f[0], v = f[1], y = Vk(fP({
            currency: u,
            value: null
        }), 2), g = y[0], b = y[1];
        this.setStatus = function(e) {
            m(e);
        };
        var k = kP(function(e, t) {
            return c.amount(e, t);
        }, [
            c
        ]);
        return vP(function() {
            e.onChange({
                data: {
                    amount: g
                },
                isValid: h
            });
        }, [
            g,
            h
        ]), "error" === p ? rN("div", {
            className: "adyen-checkout__adyen-giving"
        }, rN(ST, {
            className: "adyen-checkout__status__icon adyen-checkout__status__icon--error",
            src: s({
                imageFolder: "components/"
            })("error"),
            alt: c.get("error.message.unknown")
        }), rN("div", {
            className: "adyen-checkout__status__text"
        }, c.get("error.message.unknown"))) : "success" === p ? rN("div", {
            className: "adyen-checkout__adyen-giving"
        }, rN(ST, {
            className: "adyen-checkout__status__icon adyen-checkout__status__icon--success",
            src: s({
                imageFolder: "components/"
            })("heart"),
            alt: c.get("thanksForYourSupport")
        }), rN("div", {
            className: "adyen-checkout__status__text"
        }, c.get("thanksForYourSupport"))) : rN("div", {
            className: "adyen-checkout__adyen-giving"
        }, rN(Tq, e), rN("div", {
            className: "adyen-checkout__adyen-giving-actions"
        }, rN("div", {
            className: "adyen-checkout__amounts"
        }, rN(zq, {
            options: hC(t = sC(r)).call(t, function(e) {
                return {
                    value: e,
                    label: k(e, u),
                    disabled: "loading" === p,
                    selected: e === g.value
                };
            }),
            name: "amount",
            onChange: function(e) {
                var t = e.target, r = ZC(t.value, 10);
                v(!0), b(function(e) {
                    return jq(jq({}, e), {}, {
                        value: r
                    });
                });
            }
        })), l && rN(CL, {
            message: l.message.replace("%{linkText}", "%#".concat(l.linkText, "%#")),
            urls: [
                l.link
            ]
        }), rN(jP, {
            classNameModifiers: [
                "donate"
            ],
            onClick: function() {
                m("loading"), n({
                    data: {
                        amount: g
                    }
                });
            },
            label: c.get("donateButton"),
            disabled: !g.value,
            status: p
        }), i && rN(jP, {
            classNameModifiers: [
                "decline"
            ],
            variant: "ghost",
            onClick: function() {
                m("loading"), a({
                    data: {
                        amount: g
                    },
                    isValid: h
                });
            },
            disabled: "loading" === p,
            label: "".concat(c.get("notNowButton"), " \u203A")
        })));
    }
    function Mq(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Lq(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = Mq(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = Mq(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function Vq(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Bq.defaultProps = {
        onCancel: function() {},
        onChange: function() {},
        onDonate: function() {},
        amounts: {},
        showCancelButton: !0
    };
    var Uq = function(e) {
        L_(r, e);
        var t = Vq(r);
        function r(e) {
            var a, n;
            return Cg(this, r), Sg(B_(n = t.call(this, e)), "handleRef", function(e) {
                n.componentRef = e;
            }), n.donate = Jg(a = n.donate).call(a, B_(n)), n;
        }
        return wg(r, [
            {
                key: "data",
                get: function() {
                    return this.state.data;
                }
            },
            {
                key: "isValid",
                get: function() {
                    return this.state.isValid;
                }
            },
            {
                key: "setState",
                value: function(e) {
                    this.state = Lq(Lq({}, this.state), e);
                }
            },
            {
                key: "donate",
                value: function() {
                    var e = this.data, t = this.isValid;
                    this.props.onDonate({
                        data: e,
                        isValid: t
                    }, this);
                }
            },
            {
                key: "render",
                value: function() {
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(Bq, j_({}, this.props, {
                        ref: this.handleRef,
                        onChange: this.setState,
                        onDonate: this.donate
                    })));
                }
            }
        ]), r;
    }(gA);
    Sg(Uq, "type", "donation"), Sg(Uq, "defaultProps", {
        onCancel: function() {},
        onDonate: function() {}
    });
    var Kq = function() {
        try {
            if (window.parent.location.href) return window.location !== window.parent.location;
        } catch (e) {
            return !1;
        }
    };
    function Hq(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function qq(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var Wq, Gq = function(e) {
        L_(r, e);
        var t = qq(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "postForm", void 0), a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this, t = new Sb(function(t, r) {
                        return e.props.beforeRedirect(t, r, function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var r, a, n = null != arguments[t] ? arguments[t] : {};
                                t % 2 ? Ag(r = Hq(Object(n), !0)).call(r, function(t) {
                                    Sg(e, t, n[t]);
                                }) : Jy ? ng(e, Jy(n)) : Ag(a = Hq(Object(n))).call(a, function(t) {
                                    og(e, t, Wy(n, t));
                                });
                            }
                            return e;
                        }({
                            url: e.props.url,
                            method: e.props.method
                        }, e.props.data ? {
                            data: e.props.data
                        } : {}));
                    });
                    t.then(function() {
                        var t, r;
                        e.postForm ? e.postForm.submit() : e.props.redirectFromTopWhenInIframe && Kq() ? null === (t = (r = window.top.location).assign) || void 0 === t || t.call(r, e.props.url) : window.location.assign(e.props.url);
                    }).catch(function() {});
                }
            },
            {
                key: "render",
                value: function(e) {
                    var t, r = this, a = e.url, n = e.method, o = e.data, i = void 0 === o ? {} : o;
                    return "POST" === n ? rN("form", j_({
                        method: "post",
                        action: a,
                        style: {
                            display: "none"
                        },
                        ref: function(e) {
                            r.postForm = e;
                        }
                    }, this.props.redirectFromTopWhenInIframe && Kq() && {
                        target: "_top"
                    }), hC(t = Ty(i)).call(t, function(e) {
                        return rN("input", {
                            type: "hidden",
                            name: e,
                            key: e,
                            value: i[e]
                        });
                    })) : null;
                }
            }
        ]), r;
    }(oN);
    function Yq(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Qq(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = Yq(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = Yq(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function Zq(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(Gq, "defaultProps", {
        beforeRedirect: function(e) {
            return e();
        },
        method: "GET"
    });
    var Jq = function(e) {
        L_(r, e);
        var t = Zq(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return Qq(Qq({}, e), {}, {
                        showButton: !!e.showPayButton
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: {
                            type: this.props.type
                        },
                        browserInfo: this.browserInfo
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return cj();
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.url && this.props.method ? rN(Gq, this.props) : this.props.showButton ? rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(TL, j_({}, this.props, {
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }))) : null;
                }
            }
        ]), r;
    }(gA);
    function $q(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Xq(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = $q(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = $q(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function eW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Wq = Jq, Sg(Jq, "type", "redirect"), Sg(Jq, "defaultProps", {
        type: Wq.type,
        showPayButton: !0
    });
    var tW = function(e) {
        L_(r, e);
        var t = eW(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t;
                    return Xq(Xq({}, e), {}, {
                        showPayButton: null !== (t = e.showButton) && void 0 !== t ? t : e.showPayButton
                    });
                }
            },
            {
                key: "displayName",
                get: function() {
                    return this.props.name || this.constructor.type;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.showPayButton ? rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(TL, j_({}, this.props, {
                        name: this.displayName,
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }))) : null;
                }
            }
        ]), r;
    }(Jq);
    Sg(tW, "type", "giropay");
    var rW = 2, aW = 0, nW = "adyen", oW = "https://pay.google.com/gp/p/js/pay.js", iW = [
        "amount",
        "countryCode",
        "totalPriceStatus"
    ], lW = [
        "configuration"
    ];
    function cW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function sW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = cW(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = cW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function uW(e) {
        var t = e.amount, r = e.countryCode, a = void 0 === r ? "US" : r, n = e.totalPriceStatus, o = void 0 === n ? "FINAL" : n, i = kg(e, iW), l = String(t_(t.value, t.currency));
        return sW({
            countryCode: a,
            currencyCode: t.currency,
            totalPrice: l,
            totalPriceStatus: o
        }, i.transactionInfo);
    }
    function dW(e) {
        var t = e.configuration, r = kg(e, lW);
        return {
            apiVersion: rW,
            apiVersionMinor: aW,
            transactionInfo: uW(r),
            merchantInfo: sW(sW({
                merchantId: t.merchantId,
                merchantName: t.merchantName
            }, t.merchantOrigin ? {
                merchantOrigin: t.merchantOrigin
            } : {}), t.authJwt ? {
                authJwt: t.authJwt
            } : {}),
            allowedPaymentMethods: [
                {
                    type: "CARD",
                    tokenizationSpecification: {
                        type: "PAYMENT_GATEWAY",
                        parameters: {
                            gateway: nW,
                            gatewayMerchantId: t.gatewayMerchantId
                        }
                    },
                    parameters: {
                        allowedAuthMethods: r.allowedAuthMethods,
                        allowedCardNetworks: r.allowedCardNetworks,
                        assuranceDetailsRequired: r.assuranceDetailsRequired,
                        allowPrepaidCards: r.allowPrepaidCards,
                        allowCreditCards: r.allowCreditCards,
                        billingAddressRequired: r.billingAddressRequired,
                        billingAddressParameters: r.billingAddressParameters
                    }
                }
            ],
            emailRequired: r.emailRequired,
            shippingAddressRequired: r.shippingAddressRequired,
            shippingAddressParameters: r.shippingAddressParameters,
            shippingOptionRequired: r.shippingOptionRequired,
            shippingOptionParameters: r.shippingOptionParameters,
            callbackIntents: r.callbackIntents
        };
    }
    var pW = [
        "en",
        "ar",
        "bg",
        "ca",
        "cs",
        "da",
        "de",
        "el",
        "es",
        "et",
        "fi",
        "fr",
        "hr",
        "id",
        "it",
        "ja",
        "ko",
        "ms",
        "nl",
        "no",
        "pl",
        "pt",
        "ru",
        "sk",
        "sl",
        "sr",
        "sv",
        "th",
        "tr",
        "uk",
        "zh"
    ];
    var mW = function() {
        function e(t) {
            Cg(this, e), Sg(this, "paymentsClient", void 0);
            var r = function() {
                switch((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "TEST").toLowerCase()){
                    case "production":
                    case "live":
                    case "live-au":
                    case "live-apse":
                    case "live-us":
                    case "live-in":
                        return "PRODUCTION";
                    default:
                        return "TEST";
                }
            }(t.environment);
            this.paymentsClient = this.getGooglePaymentsClient({
                environment: r,
                paymentDataCallbacks: t.paymentDataCallbacks
            });
        }
        var t;
        return wg(e, [
            {
                key: "getGooglePaymentsClient",
                value: (t = Jd(Ey.mark(function e(t) {
                    var r, a;
                    return Ey.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (null !== (r = window.google) && void 0 !== r && r.payments) {
                                    e.next = 4;
                                    break;
                                }
                                return a = new Rj(oW), e.next = 4, a.load();
                            case 4:
                                return e.abrupt("return", new google.payments.api.PaymentsClient(t));
                            case 5:
                            case "end":
                                return e.stop();
                        }
                    }, e);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            },
            {
                key: "isReadyToPay",
                value: function(e) {
                    return this.paymentsClient ? this.paymentsClient.then(function(t) {
                        var r, a, n, o;
                        return t.isReadyToPay((a = (r = e).allowedAuthMethods, n = r.allowedCardNetworks, o = r.existingPaymentMethodRequired, {
                            apiVersion: rW,
                            apiVersionMinor: aW,
                            allowedPaymentMethods: [
                                {
                                    type: "CARD",
                                    parameters: {
                                        allowedAuthMethods: a,
                                        allowedCardNetworks: n
                                    },
                                    tokenizationSpecification: {
                                        type: "PAYMENT_GATEWAY",
                                        parameters: {}
                                    }
                                }
                            ],
                            existingPaymentMethodRequired: void 0 !== o && o
                        }));
                    }) : Sb.reject(new Error("Google Pay is not available"));
                }
            },
            {
                key: "prefetchPaymentData",
                value: function(e) {
                    if (!this.paymentsClient) throw new Error("Google Pay is not available");
                    var t = dW(e);
                    this.paymentsClient.then(function(e) {
                        return e.prefetchPaymentData(t);
                    });
                }
            },
            {
                key: "initiatePayment",
                value: function(e) {
                    if (!this.paymentsClient) throw new Error("Google Pay is not available");
                    var t = dW(e);
                    return this.paymentsClient.then(function(e) {
                        return e.loadPaymentData(t);
                    });
                }
            }
        ]), e;
    }();
    function fW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var hW = function(e) {
        L_(r, e);
        var t = fW(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "paywithgoogleWrapper", void 0), Sg(B_(a), "clicked", !1), Sg(B_(a), "handleClick", function(e) {
                e.preventDefault(), e.stopPropagation(), a.clicked || (a.props.onClick(e), a.clicked = !0, ZN(function() {
                    a.clicked = !1;
                }, 300));
            }), a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this, t = this.props, r = t.buttonColor, a = t.buttonType, n = t.buttonLocale, o = t.buttonSizeMode, i = t.buttonRootNode;
                    t.paymentsClient.then(function(t) {
                        return t.createButton({
                            onClick: e.handleClick,
                            buttonType: a,
                            buttonColor: r,
                            buttonLocale: n,
                            buttonSizeMode: o,
                            buttonRootNode: i
                        });
                    }).then(function(t) {
                        e.paywithgoogleWrapper.appendChild(t);
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN("span", {
                        className: "adyen-checkout__paywithgoogle",
                        ref: function(t) {
                            e.paywithgoogleWrapper = t;
                        }
                    });
                }
            }
        ]), r;
    }(oN);
    Sg(hW, "defaultProps", {
        buttonColor: "default",
        buttonType: "long",
        buttonSizeMode: "static"
    });
    var vW = {
        environment: "TEST",
        existingPaymentMethodRequired: !1,
        buttonColor: "default",
        buttonType: "long",
        buttonSizeMode: void 0,
        showPayButton: !0,
        configuration: {
            gatewayMerchantId: "",
            merchantId: "",
            merchantName: ""
        },
        amount: {
            value: 0,
            currency: "USD"
        },
        countryCode: "US",
        totalPriceStatus: "FINAL",
        onAuthorized: function(e) {
            return e;
        },
        onClick: function(e) {
            return e();
        },
        allowedAuthMethods: [
            "PAN_ONLY",
            "CRYPTOGRAM_3DS"
        ],
        allowedCardNetworks: [
            "AMEX",
            "DISCOVER",
            "JCB",
            "MASTERCARD",
            "VISA"
        ],
        allowCreditCards: !0,
        allowPrepaidCards: !0,
        billingAddressRequired: !1,
        billingAddressParameters: void 0,
        assuranceDetailsRequired: !1,
        emailRequired: !1,
        shippingAddressRequired: !1,
        shippingAddressParameters: void 0,
        shippingOptionRequired: !1,
        shippingOptionParameters: void 0,
        paymentMethods: []
    };
    function yW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function gW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = yW(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = yW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function bW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var kW = function(e) {
        L_(r, e);
        var t = bW(r);
        function r() {
            var e, a, n;
            Cg(this, r);
            for(var o = arguments.length, i = new Array(o), l = 0; l < o; l++)i[l] = arguments[l];
            return Sg(B_(n = t.call.apply(t, wb(e = [
                this
            ]).call(e, i))), "googlePay", new mW(n.props)), Sg(B_(n), "submit", function() {
                var e = n.props.onAuthorized, t = void 0 === e ? function() {} : e;
                return new Sb(function(e, t) {
                    return n.props.onClick(e, t);
                }).then(function() {
                    return n.googlePay.initiatePayment(n.props);
                }).then(function(e) {
                    return n.setState({
                        googlePayToken: e.paymentMethodData.tokenizationData.token,
                        googlePayCardNetwork: e.paymentMethodData.info.cardNetwork
                    }), GA((a = B_(n), U_(r.prototype)), "submit", a).call(a), t(e);
                }).catch(function(e) {
                    "CANCELED" === e.statusCode ? n.handleError(new mA("CANCEL", e.toString(), {
                        cause: e
                    })) : n.handleError(new mA("ERROR", e.toString(), {
                        cause: e
                    }));
                });
            }), Sg(B_(n), "isAvailable", function() {
                return n.isReadyToPay().then(function(e) {
                    if (!e.result) throw new Error("Google Pay is not available");
                    if (!1 === e.paymentMethodPresent) throw new Error("Google Pay - No paymentMethodPresent");
                    return !0;
                }).catch(function() {
                    return !1;
                });
            }), Sg(B_(n), "isReadyToPay", function() {
                return n.googlePay.isReadyToPay(n.props);
            }), Sg(B_(n), "prefetch", function() {
                return n.googlePay.prefetchPaymentData(n.props);
            }), n;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t, r, a, n, o, i, l = null !== (t = e.brands) && void 0 !== t && t.length ? (o = e.brands, i = {
                        mc: "MASTERCARD",
                        amex: "AMEX",
                        visa: "VISA",
                        interac: "INTERAC",
                        discover: "DISCOVER"
                    }, tC(o).call(o, function(e, t) {
                        return i[t] && !kb(e).call(e, i[t]) && e.push(i[t]), e;
                    }, [])) : e.allowedCardNetworks, c = null !== (r = e.buttonSizeMode) && void 0 !== r ? r : e.isDropin ? "fill" : "static", s = function() {
                        var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").toLowerCase().substring(0, 2);
                        return kb(pW).call(pW, e) ? e : null;
                    }(null !== (a = e.buttonLocale) && void 0 !== a ? a : null === (n = e.i18n) || void 0 === n ? void 0 : n.locale);
                    return gW(gW({}, e), {}, {
                        showButton: !0 === e.showPayButton,
                        configuration: e.configuration,
                        allowedCardNetworks: l,
                        buttonSizeMode: c,
                        buttonLocale: s
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e;
                    return {
                        paymentMethod: gW({
                            type: null !== (e = this.props.type) && void 0 !== e ? e : r.type
                        }, this.state),
                        browserInfo: this.browserInfo
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.googlePayToken;
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return cj();
                }
            },
            {
                key: "icon",
                get: function() {
                    var e;
                    return null !== (e = this.props.icon) && void 0 !== e ? e : this.resources.getImage()("googlepay");
                }
            },
            {
                key: "render",
                value: function() {
                    return this.props.showPayButton ? rN(hW, {
                        buttonColor: this.props.buttonColor,
                        buttonType: this.props.buttonType,
                        buttonSizeMode: this.props.buttonSizeMode,
                        buttonLocale: this.props.buttonLocale,
                        buttonRootNode: this.props.buttonRootNode,
                        paymentsClient: this.googlePay.paymentsClient,
                        onClick: this.submit
                    }) : null;
                }
            }
        ]), r;
    }(gA);
    function CW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(kW, "type", "paywithgoogle"), Sg(kW, "defaultProps", vW);
    var _W = function(e) {
        L_(r, e);
        var t = CW(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(BL);
    Sg(_W, "type", "entercash");
    var NW = {
        telephoneNumber: [
            {
                validate: function(e) {
                    return !!e && e.length <= 11;
                },
                errorMessage: "voucher.econtext.telephoneNumber.invalid",
                modes: [
                    "input",
                    "blur"
                ]
            },
            {
                validate: function(e) {
                    return !!e && pE.test(e) && (10 === e.length || 11 === e.length);
                },
                errorMessage: "voucher.econtext.telephoneNumber.invalid",
                modes: [
                    "blur"
                ]
            }
        ]
    }, PW = [
        "personalDetailsRequired",
        "data",
        "onChange",
        "showPayButton",
        "payButton"
    ];
    function wW(e) {
        var t, r = e.personalDetailsRequired, a = void 0 === r || r, n = e.data, o = e.onChange, i = e.showPayButton, l = e.payButton, c = kg(e, PW), s = gP(null), u = zP().i18n, d = Vk(fP("ready"), 2), p = d[0], m = d[1], f = gP({});
        Ty(f.current).length || null === (t = c.setComponentRef) || void 0 === t || t.call(c, f.current);
        return f.current.showValidation = function() {
            var e;
            null === (e = s.current) || void 0 === e || e.showValidation();
        }, f.current.setStatus = m, rN("div", {
            className: "adyen-checkout__econtext-input__field"
        }, a && c.showFormInstruction && rN(IO, null), a && rN(KE, {
            data: n,
            requiredFields: [
                "firstName",
                "lastName",
                "telephoneNumber",
                "shopperEmail"
            ],
            onChange: o,
            namePrefix: "econtext",
            setComponentRef: function(e) {
                s.current = e;
            },
            validationRules: NW
        }), i && l({
            status: p,
            label: u.get("confirmPurchase")
        }));
    }
    function SW(e) {
        var t, r, a = (t = e, (r = document.createElement("textArea")).readOnly = !0, r.value = t, document.body.appendChild(r), r);
        if (window.navigator.userAgent.match(/ipad|iphone/i)) {
            var n = document.createRange();
            n.selectNodeContents(a);
            var o = window.getSelection();
            o.removeAllRanges(), o.addRange(n), a.setSelectionRange(0, 999999);
        } else a.select();
        document.execCommand("copy"), document.body.removeChild(a);
    }
    var AW = [
        "voucherDetails",
        "className"
    ];
    function IW(e) {
        var t, r = e.voucherDetails, a = void 0 === r ? [] : r, n = e.className, o = void 0 === n ? "" : n, i = kg(e, AW), l = zP().i18n, c = tI();
        return rN("div", {
            className: aP("adyen-checkout__voucher-result", "adyen-checkout__voucher-result--".concat(i.paymentMethodType), o)
        }, rN("div", {
            className: "adyen-checkout__voucher-result__top"
        }, rN("div", {
            className: "adyen-checkout__voucher-result__image"
        }, !!i.imageUrl && rN("span", {
            className: "adyen-checkout__voucher-result__image__wrapper"
        }, rN("img", {
            alt: i.paymentMethodType,
            className: "adyen-checkout__voucher-result__image__brand",
            src: i.imageUrl
        })), !!i.issuerImageUrl && rN("span", {
            className: "adyen-checkout__voucher-result__image__wrapper"
        }, rN("img", {
            alt: i.paymentMethodType,
            className: "adyen-checkout__voucher-result__image__issuer",
            src: i.issuerImageUrl
        }))), rN("div", {
            className: "adyen-checkout__voucher-result__introduction"
        }, i.introduction, " ", i.instructionsUrl && rN("a", {
            className: "adyen-checkout__link adyen-checkout__link--voucher-result-instructions",
            href: i.instructionsUrl,
            target: "_blank",
            rel: "noopener noreferrer"
        }, l.get("voucher.readInstructions"), " \u203A")), i.amount && rN("div", {
            className: "adyen-checkout__voucher-result__amount"
        }, i.amount, i.surcharge && rN("span", {
            className: "adyen-checkout__voucher-result__surcharge"
        }, "(", l.get("voucher.surcharge").replace("%@", i.surcharge), ")"))), i.reference && rN("div", {
            className: "adyen-checkout__voucher-result__separator"
        }, rN("div", {
            className: "adyen-checkout__voucher-result__separator__inner"
        }), rN("div", {
            className: "adyen-checkout__voucher-result__code__label"
        }, rN("span", {
            className: "adyen-checkout__voucher-result__code__label__text"
        }, l.get("voucher.paymentReferenceLabel")))), rN("div", {
            className: "adyen-checkout__voucher-result__bottom"
        }, i.reference && rN("div", {
            className: "adyen-checkout__voucher-result__code"
        }, i.barcode && rN("img", {
            alt: l.get("voucher.paymentReferenceLabel"),
            className: "adyen-checkout__voucher-result__code__barcode",
            src: i.barcode
        }), rN("span", null, i.reference)), (!!i.downloadUrl || !!i.copyBtn) && rN("ul", {
            className: "adyen-checkout__voucher-result__actions"
        }, !!i.copyBtn && rN("li", {
            className: "adyen-checkout__voucher-result__actions__item"
        }, rN(jP, {
            inline: !0,
            variant: "action",
            onClick: function(e, t) {
                var r = t.complete;
                SW(i.reference), r();
            },
            icon: c({
                imageFolder: "components/"
            })("copy"),
            label: l.get("button.copy")
        })), !!i.downloadUrl && rN("li", {
            className: "adyen-checkout__voucher-result__actions__item"
        }, rN(jP, {
            inline: !0,
            variant: "action",
            href: i.downloadUrl,
            icon: c({
                imageFolder: "components/"
            })("download"),
            label: i.downloadButtonText || l.get("button.download"),
            target: "_blank",
            rel: "noopener noreferrer"
        }))), rN("ul", {
            className: "adyen-checkout__voucher-result__details"
        }, hC(t = Fg(a).call(a, function(e) {
            var t = e.label, r = e.value;
            return !!t && !!r;
        })).call(t, function(e, t) {
            var r = e.label, a = e.value;
            return rN("li", {
                key: t,
                className: "adyen-checkout__voucher-result__details__item"
            }, rN("span", {
                className: "adyen-checkout__voucher-result__details__label"
            }, r), rN("span", {
                className: "adyen-checkout__voucher-result__details__value"
            }, a));
        }))));
    }
    var DW = function(e) {
        var t = e.reference, r = e.totalAmount, a = e.expiresAt, n = e.paymentMethodType, o = e.maskedTelephoneNumber, i = e.instructionsUrl, l = e.collectionInstitutionNumber, c = zP().i18n, s = tI();
        return rN(IW, {
            paymentMethodType: n,
            reference: t,
            introduction: c.get("voucher.introduction.econtext"),
            imageUrl: s()(n),
            instructionsUrl: i,
            amount: r && c.amount(r.value, r.currency),
            voucherDetails: [
                {
                    label: c.get("voucher.collectionInstitutionNumber"),
                    value: l
                },
                {
                    label: c.get("voucher.expirationDate"),
                    value: c.date(a)
                },
                {
                    label: c.get("voucher.telephoneNumber"),
                    value: o
                }
            ],
            copyBtn: !0
        });
    };
    function EW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function RW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = EW(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = EW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function xW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var FW = function(e) {
        L_(r, e);
        var t = xW(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !this.props.personalDetailsRequired || !!this.state.isValid;
                }
            },
            {
                key: "formatData",
                value: function() {
                    return RW(RW({}, this.state.data), {}, {
                        paymentMethod: {
                            type: this.props.type || r.type
                        }
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.reference ? rN(DW, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props)) : rN(wW, j_({
                        setComponentRef: this.setComponentRef
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(gA);
    Sg(FW, "type", "econtext"), Sg(FW, "defaultProps", {
        personalDetailsRequired: !0,
        showFormInstruction: !0
    });
    var TW = [
        "ES",
        "FR"
    ];
    function zW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function OW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = zW(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = zW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function jW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var BW = function(e) {
        L_(r, e);
        var t = jW(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return OW(OW({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : TW
                    });
                }
            }
        ]), r;
    }(QO);
    function MW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function LW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = MW(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = MW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function VW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(BW, "type", "facilypay_3x");
    var UW = function(e) {
        L_(r, e);
        var t = VW(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return LW(LW({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : TW
                    });
                }
            }
        ]), r;
    }(QO);
    function KW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function HW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = KW(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = KW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function qW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(UW, "type", "facilypay_4x");
    var WW = function(e) {
        L_(r, e);
        var t = qW(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return HW(HW({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : TW
                    });
                }
            }
        ]), r;
    }(QO);
    function GW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function YW(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = GW(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = GW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function QW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(WW, "type", "facilypay_6x");
    var ZW = function(e) {
        L_(r, e);
        var t = QW(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return YW(YW({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : TW
                    });
                }
            }
        ]), r;
    }(QO);
    function JW(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function $W(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = JW(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = JW(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function XW(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(ZW, "type", "facilypay_10x");
    var eG = function(e) {
        L_(r, e);
        var t = XW(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return $W($W({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : TW
                    });
                }
            }
        ]), r;
    }(QO);
    function tG(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(eG, "type", "facilypay_12x");
    var rG = function(e) {
        L_(r, e);
        var t = tG(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(BL);
    Sg(rG, "type", "ideal");
    var aG = [
        "black",
        "white"
    ], nG = [
        "en_US",
        "en_AU",
        "en_GB",
        "fr_CA",
        "es_ES",
        "it_IT",
        "fr_FR",
        "de_DE",
        "pt_BR",
        "zh_CN",
        "da_DK",
        "zh_HK",
        "id_ID",
        "he_IL",
        "ja_JP",
        "ko_KR",
        "nl_NL",
        "no_NO",
        "pl_PL",
        "pt_PT",
        "ru_RU",
        "sv_SE",
        "th_TH",
        "zh_TW"
    ];
    function oG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function iG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = oG(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = oG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var lG = function(e) {
        var t, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return "paypal" === e ? iG({}, r) : tC(t = Ty(r)).call(t, function(e, t) {
            var a = r[t];
            return ("color" !== t || kb(aG).call(aG, a)) && (e[t] = a), e;
        }, {});
    }, cG = function(e) {
        var t = e.amount, r = e.countryCode, a = e.debug, n = e.environment, o = void 0 === n ? "" : n, i = e.locale, l = e.configuration, c = e.commit, s = e.vault, u = e.enableMessages, d = function(e) {
            var t = e ? e.replace("-", "_") : null;
            return kb(nG).call(nG, t) ? t : null;
        }(i), p = t ? t.currency : null, m = "test" === o.toLowerCase(), f = m ? "AXy9hIzWB6h_LjZUHjHmsbsiicSIbL4GKOrcgomEedVjduUinIU4C2llxkW5p0OG0zTNgviYFceaXEnj" : "AU0Z-TP9t5_9196agaBN6ZD3UAwypdP1IX8ZYH3PcNNAQMXUTDQlChruXqQEhyI6-NKBKowN6ydkj477", h = l.merchantId, v = l.intent, y = "buttons,funding-eligibility".concat(u ? ",messages" : "");
        return iG(iG(iG(iG(iG(iG(iG({}, h && {
            "merchant-id": h
        }), d && {
            locale: d
        }), r && m && {
            "buyer-country": r
        }), a && m && {
            debug: a
        }), p && {
            currency: p
        }), v && {
            intent: v
        }), {}, {
            commit: c,
            vault: s,
            "client-id": f,
            "integration-date": "2020-02-01",
            "enable-funding": "paylater,venmo",
            components: y
        });
    }, sG = [
        "onInit",
        "onApprove",
        "onClick",
        "onCancel",
        "onError",
        "onShippingChange",
        "onShippingAddressChange",
        "onShippingOptionsChange",
        "onSubmit",
        "isProcessingPayment",
        "paypalRef",
        "style"
    ];
    function uG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function dG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = uG(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = uG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function pG(e) {
        var t, r = e.onInit, a = e.onApprove, n = e.onClick, o = e.onCancel, i = e.onError, l = e.onShippingChange, c = e.onShippingAddressChange, s = e.onShippingOptionsChange, u = e.onSubmit, d = e.isProcessingPayment, p = e.paypalRef, m = e.style, f = kg(e, sG), h = zP().i18n, v = "tokenize" === (null === (t = f.configuration) || void 0 === t ? void 0 : t.intent), y = gP(null), g = gP(null), b = gP(null), k = gP(null), C = function(e, t) {
            var d = dG(dG(dG(dG(dG(dG({}, v && {
                createBillingAgreement: u
            }), !v && {
                createOrder: u
            }), !v && "venmo" !== e && l && {
                onShippingChange: l
            }), !v && "venmo" !== e && c && {
                onShippingAddressChange: c
            }), !v && "venmo" !== e && s && {
                onShippingOptionsChange: s
            }), {}, {
                fundingSource: e,
                style: lG(e, m),
                onInit: r,
                onClick: n,
                onCancel: o,
                onError: i,
                onApprove: a
            }), f = p.Buttons(d);
            f.isEligible() && f.render(t.current);
        };
        vP(function() {
            l && c && console.warn('PayPal - "onShippingChange" and "onShippingAddressChange" are defined. It is recommended to only use "onShippingAddressChange", as "onShippingChange" is getting deprecated');
        }, [
            l,
            c
        ]), vP(function() {
            var e = p.FUNDING, t = e.PAYPAL, r = e.CREDIT, a = e.PAYLATER, n = e.VENMO;
            C(t, y), f.blockPayPalCreditButton || C(r, g), f.blockPayPalPayLaterButton || C(a, b), f.blockPayPalVenmoButton || C(n, k);
        }, []);
        var _ = !0 === f.commit;
        return rN("div", {
            className: aP("adyen-checkout__paypal__buttons", {
                "adyen-checkout__paypal-processing": d
            })
        }, rN("div", {
            className: "adyen-checkout__paypal__button adyen-checkout__paypal__button--paypal",
            ref: y
        }), rN("div", {
            className: "adyen-checkout__paypal__button adyen-checkout__paypal__button--credit",
            ref: g
        }), rN("div", {
            className: "adyen-checkout__paypal__button adyen-checkout__paypal__button--pay-later",
            ref: b
        }), rN("div", {
            className: "adyen-checkout__paypal__button adyen-checkout__paypal__button--venmo",
            ref: k
        }), d && rN("div", {
            className: "adyen-checkout__paypal"
        }, rN("div", {
            className: "adyen-checkout__paypal__status adyen-checkout__paypal__status--processing"
        }, rN(nP, {
            size: "medium",
            inline: !0
        }), _ && h.get("paypal.processingPayment"))));
    }
    var mG = [
        "onApprove",
        "onCancel",
        "onChange",
        "onError",
        "onSubmit"
    ];
    function fG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function hG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = fG(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = fG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function vG(e) {
        var t = e.onApprove, r = e.onCancel, a = e.onChange, n = e.onError, o = e.onSubmit, i = kg(e, mG), l = Vk(fP("pending"), 2), c = l[0], s = l[1];
        this.setStatus = s;
        var u = kP(function(e, r) {
            s("processing"), t(e, r);
        }, [
            t
        ]), d = function() {
            s("ready");
        };
        return vP(function() {
            var e = function(e) {
                var t, r, a = cG(e), n = decodeURIComponent(hC(t = Ty(a)).call(t, function(e) {
                    var t;
                    return wb(t = "".concat(e, "=")).call(t, a[e]);
                }).join("&"));
                return wb(r = "".concat("https://www.paypal.com/sdk/js", "?")).call(r, n);
            }(i), t = hG({}, i.cspNonce && {
                nonce: i.cspNonce
            }), r = hG({}, i.cspNonce && {
                cspNonce: i.cspNonce
            }), a = new Rj(e, "body", t, r);
            return a.load().then(d), function() {
                a.remove();
            };
        }, []), rN("div", {
            className: "adyen-checkout__paypal"
        }, "pending" === c ? rN("div", {
            className: "adyen-checkout__paypal__status adyen-checkout__paypal__status--pending"
        }, rN(nP, null)) : rN(pG, j_({}, i, {
            onCancel: r,
            onChange: a,
            onError: n,
            onSubmit: o,
            onApprove: u,
            isProcessingPayment: "processing" === c,
            paypalRef: window.paypal
        })));
    }
    var yG = "No token was provided", gG = "Calling submit() is not supported for this payment method", bG = "The instance of the PayPal component being used is not the same which started the payment";
    function kG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function CG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = kG(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = kG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var _G = function(e) {
        var t = e.paypalAddressObject;
        if (!t) return null;
        var r = function() {
            var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            return t && r ? wb(e = "".concat(t, ", ")).call(e, r) : t || r || null;
        }(t.address_line_1, t.address_line_2), a = CG(CG(CG(CG(CG({}, r && {
            street: r
        }), t.admin_area_1 && {
            stateOrProvince: t.admin_area_1
        }), t.admin_area_2 && {
            city: t.admin_area_2
        }), t.postal_code && {
            postalCode: t.postal_code
        }), t.country_code && {
            country: t.country_code
        });
        return Ty(a).length > 0 ? a : null;
    }, NG = [
        "onShippingAddressChange",
        "onShippingOptionsChange"
    ];
    function PG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function wG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = PG(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = PG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function SG(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var AG = function(e) {
        L_(r, e);
        var t = SG(r);
        function r(e) {
            var a, n, o, i;
            return Cg(this, r), Sg(B_(i = t.call(this, e)), "paymentData", null), Sg(B_(i), "resolve", null), Sg(B_(i), "reject", null), Sg(B_(i), "submit", function() {
                i.handleError(new mA("IMPLEMENTATION_ERROR", gG));
            }), Sg(B_(i), "handleAction", function(e) {
                return i.updateWithAction(e);
            }), Sg(B_(i), "updateWithAction", function(e) {
                if (e.paymentMethodType !== i.type) throw new Error("Invalid Action");
                return e.paymentData && (i.paymentData = e.paymentData), e.sdkData && e.sdkData.token ? i.handleResolve(e.sdkData.token) : i.handleReject(yG), null;
            }), Sg(B_(i), "handleCancel", function() {
                i.handleError(new mA("CANCEL"));
            }), Sg(B_(i), "handleOnApprove", function(e, t) {
                var r = i.props.onShopperDetails, a = {
                    data: {
                        details: e,
                        paymentData: i.paymentData
                    }
                };
                if (r) return t.order.get().then(function(e) {
                    var t = function(e) {
                        var t, r, a, n, o, i, l, c;
                        if (!e) return null;
                        var s = {
                            firstName: null == e || null === (t = e.payer) || void 0 === t || null === (t = t.name) || void 0 === t ? void 0 : t.given_name,
                            lastName: null == e || null === (r = e.payer) || void 0 === r || null === (r = r.name) || void 0 === r ? void 0 : r.surname
                        }, u = null == e || null === (a = e.payer) || void 0 === a ? void 0 : a.email_address, d = null == e || null === (n = e.payer) || void 0 === n || null === (n = n.address) || void 0 === n ? void 0 : n.country_code, p = null == e || null === (o = e.payer) || void 0 === o || null === (o = o.phone) || void 0 === o || null === (o = o.phone_number) || void 0 === o ? void 0 : o.national_number, m = null == e || null === (i = e.payer) || void 0 === i ? void 0 : i.birth_date, f = _G({
                            paypalAddressObject: null == e || null === (l = e.payer) || void 0 === l ? void 0 : l.address
                        }), h = _G({
                            paypalAddressObject: null == e || null === (c = e.purchase_units) || void 0 === c || null === (c = c[0].shipping) || void 0 === c ? void 0 : c.address
                        }), v = CG(CG(CG(CG(CG(CG(CG({}, s.firstName && {
                            shopperName: s
                        }), u && {
                            shopperEmail: u
                        }), m && {
                            dateOfBirth: m
                        }), p && {
                            telephoneNumber: p
                        }), d && {
                            countryCode: d
                        }), f && {
                            billingAddress: f
                        }), h && {
                            shippingAddress: h
                        });
                        return Ty(v).length > 0 ? v : null;
                    }(e);
                    return new Sb(function(a, n) {
                        return r(t, e, {
                            resolve: a,
                            reject: n
                        });
                    });
                }).then(function() {
                    return i.handleAdditionalDetails(a);
                }).catch(function(e) {
                    return i.handleError(new mA("ERROR", "Something went wrong while parsing PayPal Order", {
                        cause: e
                    }));
                });
                i.handleAdditionalDetails(a);
            }), i.handleSubmit = Jg(a = i.handleSubmit).call(a, B_(i)), i.handleOnShippingAddressChange = Jg(n = i.handleOnShippingAddressChange).call(n, B_(i)), i.handleOnShippingOptionsChange = Jg(o = i.handleOnShippingOptionsChange).call(o, B_(i)), i;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t, r = e.configuration, a = r.merchantId, n = r.intent, o = 0 === (null === (t = e.amount) || void 0 === t ? void 0 : t.value) ? "tokenize" : e.intent || n, i = "tokenize" === o || e.vault, l = "continue" === e.userAction;
                    return wG(wG({}, e), {}, {
                        commit: !l && e.commit,
                        vault: i,
                        configuration: {
                            intent: o,
                            merchantId: a
                        }
                    });
                }
            },
            {
                key: "updatePaymentData",
                value: function(e) {
                    e || console.warn("PayPal - Updating payment data with an invalid value"), this.paymentData = e;
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.props, t = e.isExpress, a = e.userAction;
                    return {
                        paymentMethod: {
                            type: r.type,
                            userAction: a,
                            subtype: t ? "express" : r.subtype
                        }
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "handleResolve",
                value: function(e) {
                    if (!this.resolve) return this.handleError(new mA("ERROR", bG));
                    this.resolve(e);
                }
            },
            {
                key: "handleReject",
                value: function(e) {
                    if (!this.reject) return this.handleError(new mA("ERROR", bG));
                    this.reject(new Error(e));
                }
            },
            {
                key: "handleSubmit",
                value: function() {
                    var e = this;
                    return GA(U_(r.prototype), "submit", this).call(this), new Sb(function(t, r) {
                        e.resolve = t, e.reject = r;
                    });
                }
            },
            {
                key: "handleOnShippingAddressChange",
                value: function(e, t) {
                    return this.props.onShippingAddressChange(e, t, this);
                }
            },
            {
                key: "handleOnShippingOptionsChange",
                value: function(e, t) {
                    return this.props.onShippingOptionsChange(e, t, this);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    if (!this.props.showPayButton) return null;
                    var t = this.props, r = t.onShippingAddressChange, a = t.onShippingOptionsChange, n = kg(t, NG);
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(vG, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, n, r && {
                        onShippingAddressChange: this.handleOnShippingAddressChange
                    }, a && {
                        onShippingOptionsChange: this.handleOnShippingOptionsChange
                    }, {
                        onCancel: this.handleCancel,
                        onChange: this.setState,
                        onApprove: this.handleOnApprove,
                        onError: function(t) {
                            e.handleError(new mA("ERROR", t.toString(), {
                                cause: t
                            }));
                        },
                        onSubmit: this.handleSubmit
                    })));
                }
            }
        ]), r;
    }(gA);
    function IG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function DG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = IG(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = IG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function EG(e) {
        var t, r, a = zP().i18n, n = Vk(fP("ready"), 2), o = n[0], i = n[1], l = !(null == e || null === (t = e.items) || void 0 === t || !t.length), c = QD({
            schema: wb(r = []).call(r, Uk(l ? [
                "phonePrefix"
            ] : []), [
                "phoneNumber"
            ]),
            defaultData: DG({}, l ? {
                phonePrefix: e.selected
            } : {}),
            rules: {
                phoneNumber: {
                    modes: [
                        "blur"
                    ],
                    errorMessage: "error.va.gen.01",
                    validate: function(e) {
                        return (null == e ? void 0 : e.length) > 6;
                    }
                }
            }
        }), s = c.handleChangeFor, u = c.triggerValidation, d = c.data, p = c.valid, m = c.errors, f = c.isValid;
        return vP(function() {
            e.onChange({
                data: d,
                valid: p,
                errors: m,
                isValid: f
            });
        }, [
            d,
            p,
            m,
            f
        ]), this.showValidation = u, this.setStatus = i, rN("div", {
            className: "adyen-checkout__phone-input"
        }, rN(oD, {
            errorMessage: !!m.phoneNumber,
            label: a.get(e.phoneLabel),
            className: aP({
                "adyen-checkout__input--phone-number": !0
            }),
            inputWrapperModifiers: [
                "phoneInput"
            ],
            name: ""
        }, rN("div", {
            className: "adyen-checkout__input-wrapper"
        }, rN("div", {
            className: aP({
                "adyen-checkout__input": !0,
                "adyen-checkout__input--invalid": !!m.phoneNumber
            })
        }, !!l && rN(oD, {
            inputWrapperModifiers: [
                "phoneInput"
            ],
            name: e.prefixName
        }, rN(OT, {
            className: "adyen-checkout__dropdown--small adyen-checkout__countryFlag",
            filterable: !1,
            items: e.items,
            name: e.prefixName,
            onChange: s("phonePrefix"),
            placeholder: a.get("infix"),
            selectedValue: d.phonePrefix
        }), rN("div", {
            className: "adyen-checkout__phoneNumber"
        }, rN("div", null, d.phonePrefix), rN("input", {
            type: "tel",
            name: e.phoneName,
            value: d.phoneNumber,
            onInput: s("phoneNumber", "input"),
            onBlur: s("phoneNumber", "blur"),
            placeholder: "123 456 789",
            className: "adyen-checkout__input adyen-checkout__input--phoneNumber",
            autoCorrect: "off"
        })))))), this.props.showPayButton && this.props.payButton({
            status: o
        }));
    }
    Sg(AG, "type", "paypal"), Sg(AG, "subtype", "sdk"), Sg(AG, "defaultProps", {
        environment: "TEST",
        status: "loading",
        showPayButton: !0,
        userAction: "pay",
        merchantId: "",
        cspNonce: null,
        intent: null,
        commit: !0,
        vault: !1,
        style: {
            height: 48
        },
        blockPayPalCreditButton: !1,
        blockPayPalPayLaterButton: !1,
        enableMessages: !1,
        blockPayPalVenmoButton: !1,
        isExpress: !1,
        configuration: {
            merchantId: "",
            intent: null
        },
        onInit: function() {},
        onClick: function() {},
        onCancel: function() {},
        onError: function() {}
    }), EG.defaultProps = {
        phoneLabel: "telephoneNumber"
    };
    var RG = Ar, xG = h, FG = na, TG = RangeError, zG = String.fromCharCode, OG = String.fromCodePoint, jG = xG([].join);
    RG({
        target: "String",
        stat: !0,
        arity: 1,
        forced: !!OG && 1 !== OG.length
    }, {
        fromCodePoint: function(e) {
            for(var t, r = [], a = arguments.length, n = 0; a > n;){
                if (t = +arguments[n++], FG(t, 1114111) !== t) throw new TG(t + " is not a valid code point");
                r[n] = t < 65536 ? zG(t) : zG(55296 + ((t -= 65536) >> 10), t % 1024 + 56320);
            }
            return jG(r, "");
        }
    });
    var BG = t(ee.String.fromCodePoint);
    function MG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function LG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = MG(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = MG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var VG, UG = function(e, t) {
        if (e && t) {
            var r = zb(e).call(e, function(e) {
                return e.code === t;
            });
            return !!r && r.id;
        }
        return !1;
    }, KG = [
        {
            id: "+7",
            name: "Russian Federation",
            code: "RU"
        },
        {
            id: "+9955",
            name: "Georgia",
            code: "GE"
        },
        {
            id: "+507",
            name: "Panama",
            code: "PA"
        },
        {
            id: "+44",
            name: "United Kingdom",
            code: "GB"
        },
        {
            id: "+992",
            name: "Tajikistan",
            code: "TJ"
        },
        {
            id: "+370",
            name: "Lithuania",
            code: "LT"
        },
        {
            id: "+972",
            name: "Israel",
            code: "IL"
        },
        {
            id: "+996",
            name: "Kyrgyzstan",
            code: "KG"
        },
        {
            id: "+380",
            name: "Ukraine",
            code: "UA"
        },
        {
            id: "+84",
            name: "Viet Nam",
            code: "VN"
        },
        {
            id: "+90",
            name: "Turkey",
            code: "TR"
        },
        {
            id: "+994",
            name: "Azerbaijan",
            code: "AZ"
        },
        {
            id: "+374",
            name: "Armenia",
            code: "AM"
        },
        {
            id: "+371",
            name: "Latvia",
            code: "LV"
        },
        {
            id: "+91",
            name: "India",
            code: "IN"
        },
        {
            id: "+66",
            name: "Thailand",
            code: "TH"
        },
        {
            id: "+373",
            name: "Moldova",
            code: "MD"
        },
        {
            id: "+1",
            name: "United States",
            code: "US"
        },
        {
            id: "+81",
            name: "Japan",
            code: "JP"
        },
        {
            id: "+998",
            name: "Uzbekistan",
            code: "UZ"
        },
        {
            id: "+77",
            name: "Kazakhstan",
            code: "KZ"
        },
        {
            id: "+375",
            name: "Belarus",
            code: "BY"
        },
        {
            id: "+372",
            name: "Estonia",
            code: "EE"
        },
        {
            id: "+40",
            name: "Romania",
            code: "RO"
        },
        {
            id: "+82",
            name: "Korea",
            code: "KR"
        }
    ];
    function HG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function qG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = HG(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = HG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function WG(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var GG = function(e) {
        L_(r, e);
        var t = WG(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    return qG(qG({
                        onValid: function() {}
                    }, e), {}, {
                        selected: UG(e.items, e.countryCode)
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: {
                            type: r.type,
                            "qiwiwallet.telephoneNumberPrefix": this.state.data ? this.state.data.phonePrefix : "",
                            "qiwiwallet.telephoneNumber": this.state.data ? this.state.data.phoneNumber : ""
                        }
                    };
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(EG, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, this.state, {
                        phoneLabel: "mobileNumber",
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(gA);
    function YG(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function QG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = YG(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = YG(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    Sg(GG, "type", "qiwiwallet"), Sg(GG, "defaultProps", {
        items: Fg(VG = hC(KG).call(KG, function(e) {
            var t, r;
            if (!e) throw new Error("No item passed");
            if (!e.code || !e.id) return !1;
            var a = e.code.toUpperCase().replace(/./g, function(e) {
                return BG ? BG(e.charCodeAt(0) + 127397) : "";
            });
            return LG(LG({}, e), {}, {
                name: wb(t = wb(r = "".concat(a, " ")).call(r, e.name, " (")).call(t, e.id, ")"),
                selectedOptionName: a
            });
        })).call(VG, function(e) {
            return !1 !== e;
        }),
        countryCode: KG[0].code,
        prefixName: "qiwiwallet.telephoneNumberPrefix",
        phoneName: "qiwiwallet.telephoneNumber"
    });
    function ZG(e) {
        var t = this, r = gP(null), a = Vk(fP({}), 2), n = a[0], o = a[1], i = Vk(fP({}), 2), l = i[0], c = i[1], s = Vk(fP({}), 2), u = s[0], d = s[1], p = Vk(fP(!1), 2), m = p[0], f = p[1], h = Vk(fP(null), 2), v = h[0], y = h[1], g = Vk(fP([]), 2), b = g[0], k = g[1], C = Vk(fP(""), 2), _ = C[0], N = C[1], P = bP(function() {
            return GU(e, {
                sfp: r
            }, {
                dualBrandSelectElements: b,
                setDualBrandSelectElements: k,
                setSelectedBrandValue: N,
                issuingCountryCode: v,
                setIssuingCountryCode: y
            });
        }, [
            b,
            v
        ]);
        return this.processBinLookupResponse = function(e, t) {
            P.processBinLookup(e, t);
        }, this.dualBrandingChangeHandler = P.handleDualBrandSelection, vP(function() {
            return t.setFocusOn = r.current.setFocusOn, t.updateStyles = r.current.updateStyles, t.showValidation = r.current.showValidation, t.handleUnsupportedCard = r.current.handleUnsupportedCard, function() {
                r.current.destroy();
            };
        }, []), vP(function() {
            var t = r.current.mapErrorsToValidationRuleResult();
            e.onChange({
                data: u,
                valid: l,
                errors: QG(QG({}, n), t),
                isValid: m,
                selectedBrandValue: _
            });
        }, [
            u,
            l,
            n,
            _
        ]), rN(FU, j_({
            ref: r
        }, JG(e), {
            onChange: function(e) {
                d(QG(QG({}, u), e.data)), o(QG(QG({}, n), e.errors)), c(QG(QG({}, l), e.valid)), f(e.isSfpValid);
            },
            render: function() {
                return null;
            }
        }));
    }
    ZG.defaultProps = {
        onChange: function() {},
        onError: function() {}
    };
    var JG = function(e) {
        return {
            allowedDOMAccess: e.allowedDOMAccess,
            autoFocus: e.autoFocus,
            brands: e.brands,
            brandsConfiguration: e.brandsConfiguration,
            clientKey: e.clientKey,
            i18n: e.i18n,
            implementationType: e.implementationType,
            keypadFix: e.keypadFix,
            legacyInputMode: e.legacyInputMode,
            loadingContext: e.loadingContext,
            minimumExpiryDate: e.minimumExpiryDate,
            onAdditionalSFConfig: e.onAdditionalSFConfig,
            onAdditionalSFRemoved: e.onAdditionalSFRemoved,
            onAllValid: e.onAllValid,
            onAutoComplete: e.onAutoComplete,
            onBinValue: e.onBinValue,
            onBrand: e.onBrand,
            onConfigSuccess: e.onConfigSuccess,
            onError: e.onError,
            onFieldValid: e.onFieldValid,
            onFocus: e.onFocus,
            onLoad: e.onLoad,
            rootNode: e.rootNode,
            showWarnings: e.showWarnings,
            styles: e.styles,
            trimTrailingSeparator: e.trimTrailingSeparator,
            type: e.type,
            resources: e.resources
        };
    };
    function $G(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function XG(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = $G(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = $G(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function eY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var tY = function(e) {
        L_(r, e);
        var t = eY(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "onBinValue", WK(B_(a))), a;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return XG(XG({}, e), {}, {
                        type: "scheme" === e.type || "securedfields" === e.type ? "card" : e.type
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.selectedBrandValue || this.props.brand;
                    return {
                        paymentMethod: XG(XG({
                            type: r.type
                        }, this.state.data), e && {
                            brand: e
                        }),
                        browserInfo: this.browserInfo
                    };
                }
            },
            {
                key: "updateStyles",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.updateStyles && this.componentRef.updateStyles(e), this;
                }
            },
            {
                key: "setFocusOn",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.setFocusOn && this.componentRef.setFocusOn(e), this;
                }
            },
            {
                key: "processBinLookupResponse",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.processBinLookupResponse && this.componentRef.processBinLookupResponse(e), this;
                }
            },
            {
                key: "dualBrandingChangeHandler",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.dualBrandingChangeHandler && this.componentRef.dualBrandingChangeHandler(e), this;
                }
            },
            {
                key: "handleUnsupportedCard",
                value: function(e) {
                    var t;
                    return null !== (t = this.componentRef) && void 0 !== t && t.handleUnsupportedCard && this.componentRef.handleUnsupportedCard(e), this;
                }
            },
            {
                key: "onBinLookup",
                value: function(e) {
                    var t, r = this, a = XG({}, e);
                    (a.rootNode = this._node, a.isReset) || (a.supportedBrandsRaw = null === (t = e.supportedBrandsRaw) || void 0 === t ? void 0 : hC(t).call(t, function(e) {
                        var t, a;
                        return e.brandImageUrl = null !== (t = null === (a = r.props.brandsConfiguration[e.brand]) || void 0 === a ? void 0 : a.icon) && void 0 !== t ? t : yV(e.brand, r.resources), e;
                    }));
                    this.props.onBinLookup(a);
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return cj();
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(ZG, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, this.state, {
                        rootNode: this._node,
                        onChange: this.setState,
                        onBinValue: this.onBinValue,
                        implementationType: "custom",
                        resources: this.resources
                    })));
                }
            }
        ]), r;
    }(gA);
    function rY(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function aY(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = rY(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = rY(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function nY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(tY, "type", "scheme"), Sg(tY, "analyticsType", "custom-scheme"), Sg(tY, "defaultProps", {
        onBinLookup: function() {},
        brandsConfiguration: {}
    });
    var oY = function(e) {
        L_(r, e);
        var t = nY(r);
        function r(e) {
            var a;
            return Cg(this, r), (a = t.call(this, e)).state = aY(aY({}, a.state), {
                data: {
                    ibanNumber: "",
                    ownerName: ""
                }
            }), a;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return aY({
                        holderName: !0
                    }, e);
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: {
                            type: r.type,
                            iban: this.state.data.ibanNumber,
                            ownerName: this.state.data.ownerName
                        }
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.showFormInstruction && rN(IO, null), rN(xz, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(gA);
    function iY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(oY, "type", "sepadirectdebit"), Sg(oY, "defaultProps", {
        showFormInstruction: !0
    });
    var lY = function(e) {
        L_(r, e);
        var t = iY(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "formEl", void 0), a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.formEl.submit();
                }
            },
            {
                key: "render",
                value: function(e) {
                    var t = this, r = e.name, a = e.action, n = e.target, o = e.inputName, i = e.inputValue;
                    return rN("form", {
                        ref: function(e) {
                            t.formEl = e;
                        },
                        method: "POST",
                        className: aP([
                            "adyen-checkout__threeds2__form",
                            "adyen-checkout__threeds2__form--".concat(r)
                        ]),
                        name: r,
                        action: a,
                        target: n,
                        style: {
                            display: "none"
                        }
                    }, rN("input", {
                        name: o,
                        value: i
                    }));
                }
            }
        ]), r;
    }(oN), cY = {
        result: {
            transStatus: "U"
        },
        type: "challengeResult",
        errorCode: "timeout"
    }, sY = {
        result: {
            threeDSCompInd: "N"
        },
        type: "fingerPrintResult",
        errorCode: "timeout"
    }, uY = "unknownError", dY = {
        timeout: "ThreeDS2 timed out",
        wrongOrigin: "Result came in the right format but not from the expected origin",
        HTMLElementError: "No proper HTML element was passed",
        wrongDataType: "Result data was not of the expected type",
        missingProperty: "Result data did not contain the expected properties",
        unknownError: "An unknown error occurred"
    }, pY = {
        "01": [
            "250px",
            "400px"
        ],
        "02": [
            "390px",
            "400px"
        ],
        "03": [
            "500px",
            "600px"
        ],
        "04": [
            "600px",
            "400px"
        ],
        "05": [
            "100%",
            "100%"
        ]
    }, mY = function(e) {
        var t = FA.decode(e);
        try {
            return t && JSON.parse(t);
        } catch (e) {
            throw new Error("Could not decode token");
        }
    }, fY = function(e) {
        if (!e || !Ty(e).length) throw new Error("No (populated) data object to encode");
        return FA.encode(Mb(e));
    }, hY = function(e) {
        var t = 1 === e.length ? "0".concat(e) : e;
        return Object.prototype.hasOwnProperty.call(pY, t) ? t : "02";
    }, vY = function(e, t, r) {
        return {
            data: Sg(Sg({}, e, fY({
                threeDSCompInd: t.threeDSCompInd
            })), "paymentData", r)
        };
    }, yY = function(e, t, r) {
        return {
            data: {
                details: {
                    "threeds2.fingerprint": fY(t)
                },
                paymentData: r
            }
        };
    }, gY = function(e, t, r) {
        return {
            data: {
                details: Sg({}, e, fY({
                    transStatus: t,
                    authorisationToken: r
                }))
            }
        };
    }, bY = function(e, t, r) {
        return {
            data: {
                details: {
                    "threeds2.challengeResult": fY({
                        transStatus: t
                    })
                },
                paymentData: r
            }
        };
    }, kY = function(e, t) {
        return {
            errorCode: e,
            message: dY[e] || t || dY[uY]
        };
    }, CY = function(e) {
        var t = window.btoa(e).split("=")[0];
        return t = (t = t.replace(/\+/g, "-")).replace(/\//g, "_");
    }, _Y = [
        "elementRef"
    ], NY = [
        "createFromAction",
        "onAdditionalDetails"
    ];
    function PY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var wY = "threeDSIframe", SY = function(e) {
        L_(r, e);
        var t = PY(r);
        function r(e) {
            var a;
            Cg(this, r), Sg(B_(a = t.call(this, e)), "processMessageHandler", void 0), Sg(B_(a), "challengePromise", void 0), Sg(B_(a), "iframeCallback", function() {
                a.setState({
                    status: "iframeLoaded"
                }), a.props.onActionHandled({
                    componentType: "3DS2Challenge",
                    actionDescription: "challenge-iframe-loaded"
                });
            });
            var n = Mb(a.props.cReqData), o = CY(n);
            return a.state = {
                base64URLencodedData: o
            }, a;
        }
        return wg(r, [
            {
                key: "get3DS2ChallengePromise",
                value: function() {
                    var e = this;
                    return new Sb(function(t, r) {
                        e.processMessageHandler = SA(e.props.postMessageDomain, t, 0, "challengeResult"), window.addEventListener("message", e.processMessageHandler);
                    });
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.challengePromise = CA(6e5, this.get3DS2ChallengePromise(), cY), this.challengePromise.promise.then(function(t) {
                        window.removeEventListener("message", e.processMessageHandler), e.props.onCompleteChallenge(t);
                    }).catch(function(t) {
                        window.removeEventListener("message", e.processMessageHandler), e.props.onErrorChallenge(t);
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.challengePromise && this.challengePromise.cancel(), window.removeEventListener("message", this.processMessageHandler);
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r = e.acsURL, a = e.cReqData, n = e.iframeSizeArr, o = t.base64URLencodedData, i = t.status, l = Vk(n, 2), c = l[0], s = l[1];
                    return rN("div", {
                        className: aP([
                            "adyen-checkout__threeds2__challenge",
                            "adyen-checkout__threeds2__challenge--".concat(a.challengeWindowSize)
                        ])
                    }, "iframeLoaded" !== i && rN(nP, null), rN(kA, {
                        name: wY,
                        width: c,
                        height: s,
                        callback: this.iframeCallback
                    }), rN(lY, {
                        name: "cReqForm",
                        action: r,
                        target: wY,
                        inputName: "creq",
                        inputValue: o
                    }));
                }
            }
        ]), r;
    }(oN);
    function AY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var IY = function(e) {
        L_(r, e);
        var t = AY(r);
        function r(e) {
            var a;
            if (Cg(this, r), (a = t.call(this, e)).props.token) {
                var n = function(e) {
                    var t, r = e.token, a = e.size, n = mY(r), o = n.acsTransID, i = n.acsURL, l = n.messageVersion, c = n.threeDSNotificationURL, s = n.threeDSServerTransID, u = AA(c);
                    return {
                        acsURL: i,
                        cReqData: {
                            acsTransID: o,
                            messageVersion: l,
                            threeDSServerTransID: s,
                            messageType: "CReq",
                            challengeWindowSize: hY(a)
                        },
                        iframeSizeArr: (t = a, pY[hY(t)]),
                        postMessageDomain: u
                    };
                }({
                    token: a.props.token,
                    size: a.props.challengeWindowSize || a.props.size
                }), o = n.cReqData, i = o.acsTransID, l = o.messageVersion, c = o.threeDSServerTransID;
                if (!(n.acsURL && i && l && c)) return a.setStatusError({
                    errorInfo: "Challenge Data missing one or more of the following properties (acsURL | acsTransID | messageVersion | threeDSServerTransID)",
                    errorObj: n
                }), V_(a);
                a.state = {
                    status: "retrievingChallengeToken",
                    challengeData: n,
                    errorInfo: null
                };
            } else a.setStatusError({
                errorInfo: "Missing challengeToken parameter"
            });
            return a;
        }
        return wg(r, [
            {
                key: "setStatusComplete",
                value: function(e) {
                    var t = this;
                    this.setState({
                        status: "complete"
                    }, function() {
                        var r = (t.props.useOriginalFlow ? bY : gY)(t.props.dataKey, e.transStatus, t.props.paymentData);
                        t.props.onComplete(r);
                    });
                }
            },
            {
                key: "setStatusError",
                value: function(e) {
                    this.setState({
                        status: "error",
                        errorInfo: e.errorInfo
                    }), this.props.onError(e);
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r = this, a = e.onActionHandled, n = t.challengeData, o = tI();
                    return "retrievingChallengeToken" === this.state.status ? rN(SY, j_({
                        onCompleteChallenge: function(e) {
                            if (fA(e.result, "errorCode") && e.result.errorCode.length) {
                                var t = kY(e.result.errorCode, e.result.errorDescription);
                                r.props.onError(t);
                            }
                            r.setStatusComplete(e.result);
                        },
                        onErrorChallenge: function(e) {
                            if (fA(e, "errorCode")) {
                                var t = kY(e.errorCode);
                                return r.props.onError(t), void r.setStatusComplete(e.result);
                            }
                        }
                    }, n, {
                        onActionHandled: a
                    })) : "error" === this.state.status ? rN("div", {
                        className: "adyen-checkout__threeds2-challenge-error"
                    }, rN(ST, {
                        className: "adyen-checkout__status__icon adyen-checkout__status__icon--error",
                        src: o({
                            imageFolder: "components/"
                        })("error"),
                        alt: ""
                    }), rN("div", {
                        className: "adyen-checkout__status__text"
                    }, this.state.errorInfo ? this.state.errorInfo : this.props.i18n.get("error.message.unknown"))) : null;
                }
            }
        ]), r;
    }(oN);
    function DY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(IY, "defaultProps", {
        onComplete: function() {},
        onError: function() {},
        onActionHandled: function() {}
    });
    var EY = function(e) {
        L_(r, e);
        var t = DY(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "onComplete",
                value: function(e) {
                    e && GA(U_(r.prototype), "onComplete", this).call(this, e), this.unmount();
                }
            },
            {
                key: "render",
                value: function() {
                    if (!MO(this.props.paymentData)) {
                        var e = fA(this.props, "useOriginalFlow") ? "paymentData" : "authorisationToken";
                        return this.props.onError({
                            errorCode: "threeds2.challenge",
                            message: "No ".concat(e, " received. Challenge cannot proceed")
                        }), null;
                    }
                    return rN(IY, j_({}, this.props, {
                        onComplete: this.onComplete
                    }));
                }
            }
        ]), r;
    }(gA);
    function RY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(EY, "type", "threeDS2Challenge"), Sg(EY, "defaultProps", {
        dataKey: "threeDSResult",
        size: "02",
        type: "ChallengeShopper"
    });
    var xY = "threeDSMethodIframe", FY = function(e) {
        L_(r, e);
        var t = RY(r);
        function r(e) {
            var a;
            Cg(this, r), Sg(B_(a = t.call(this, e)), "processMessageHandler", void 0), Sg(B_(a), "fingerPrintPromise", void 0);
            var n = a.props, o = n.threeDSServerTransID, i = n.threeDSMethodNotificationURL, l = Mb({
                threeDSServerTransID: o,
                threeDSMethodNotificationURL: i
            }), c = CY(l);
            return a.state = {
                base64URLencodedData: c
            }, a;
        }
        return wg(r, [
            {
                key: "get3DS2MethodPromise",
                value: function() {
                    var e = this;
                    return new Sb(function(t, r) {
                        e.processMessageHandler = SA(e.props.postMessageDomain, t, 0, "fingerPrintResult"), window.addEventListener("message", e.processMessageHandler);
                    });
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.fingerPrintPromise = CA(1e4, this.get3DS2MethodPromise(), sY), this.fingerPrintPromise.promise.then(function(t) {
                        window.removeEventListener("message", e.processMessageHandler), e.props.onCompleteFingerprint(t);
                    }).catch(function(t) {
                        window.removeEventListener("message", e.processMessageHandler), e.props.onErrorFingerprint(t);
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.fingerPrintPromise && this.fingerPrintPromise.cancel(), window.removeEventListener("message", this.processMessageHandler);
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r = e.threeDSMethodURL, a = e.onActionHandled, n = t.base64URLencodedData;
                    return rN("div", {
                        className: "adyen-checkout__3ds2-device-fingerprint"
                    }, this.props.showSpinner && rN(nP, null), rN("div", {
                        style: {
                            display: "none"
                        }
                    }, rN(kA, {
                        name: xY,
                        callback: function() {
                            a({
                                componentType: "3DS2Fingerprint",
                                actionDescription: "fingerprint-iframe-loaded"
                            });
                        }
                    }), rN(lY, {
                        name: "threeDSMethodForm",
                        action: r,
                        target: xY,
                        inputName: "threeDSMethodData",
                        inputValue: n
                    })));
                }
            }
        ]), r;
    }(oN);
    function TY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(FY, "defaultProps", {
        showSpinner: !0
    });
    var zY = function(e) {
        L_(r, e);
        var t = TY(r);
        function r(e) {
            var a;
            Cg(this, r);
            var n = (a = t.call(this, e)).props, o = n.token, i = n.notificationURL;
            if (o) {
                var l = function(e) {
                    var t = e.token, r = e.notificationURL, a = mY(t), n = a.threeDSMethodNotificationURL, o = a.threeDSMethodUrl, i = r || n;
                    return {
                        threeDSServerTransID: a.threeDSServerTransID,
                        threeDSMethodURL: o,
                        threeDSMethodNotificationURL: i,
                        postMessageDomain: AA(i)
                    };
                }({
                    token: o,
                    notificationURL: i
                });
                a.state = {
                    status: "init",
                    fingerPrintData: l
                };
            } else a.state = {
                status: "error"
            }, a.props.onError({
                errorCode: a.props.dataKey,
                message: "Missing fingerprintToken parameter"
            });
            return a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    if (!this.state.fingerPrintData || !this.state.fingerPrintData.threeDSMethodURL) return this.setStatusComplete({
                        threeDSCompInd: "U"
                    }), void console.debug("### PrepareFingerprint3DS2::exiting:: no fingerPrintData or no threeDSMethodURL");
                    this.setState({
                        status: "retrievingFingerPrint"
                    });
                }
            },
            {
                key: "setStatusComplete",
                value: function(e) {
                    var t = this;
                    this.setState({
                        status: "complete"
                    }, function() {
                        var r = (t.props.useOriginalFlow ? yY : vY)(t.props.dataKey, e, t.props.paymentData);
                        t.props.onComplete(r);
                    });
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r = this, a = e.showSpinner, n = e.onActionHandled, o = t.fingerPrintData;
                    return "retrievingFingerPrint" === this.state.status ? rN(FY, j_({
                        onCompleteFingerprint: function(e) {
                            r.setStatusComplete(e.result);
                        },
                        onErrorFingerprint: function(e) {
                            var t = kY(e.errorCode);
                            console.debug("### PrepareFingerprint3DS2::fingerprint timed-out:: errorCodeObject=", t), r.setStatusComplete(e.result);
                        },
                        showSpinner: a
                    }, o, {
                        onActionHandled: n
                    })) : null;
                }
            }
        ]), r;
    }(oN);
    function OY(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function jY(e) {
        var t = this, r = e.data;
        cT({
            path: "v1/submitThreeDS2Fingerprint?token=".concat(this.props.clientKey),
            loadingContext: this.props.loadingContext,
            errorLevel: "fatal"
        }, function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ag(r = OY(Object(n), !0)).call(r, function(t) {
                    Sg(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Ag(a = OY(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({}, r)).then(function(e) {
            var r, a, n, o = null !== (r = t.props.elementRef) && void 0 !== r ? r : t;
            if (o) {
                if (e.action || e.details) {
                    if ("completed" === e.type) {
                        var i = e.details;
                        return t.onComplete({
                            data: {
                                details: i
                            }
                        });
                    }
                    return "threeDS2" === (null === (a = e.action) || void 0 === a ? void 0 : a.type) ? o.handleAction(e.action, bV("challengeWindowSize").from(t.props)) : "redirect" === (null === (n = e.action) || void 0 === n ? void 0 : n.type) ? o.handleAction(e.action) : void 0;
                }
                console.error("Handled Error::callSubmit3DS2Fingerprint::FAILED:: resData=", e);
            } else console.error("Handled Error::callSubmit3DS2Fingerprint::FAILED:: actionHandler=", o);
        }).catch(function(e) {
            t.handleError(e);
        });
    }
    function BY(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(zY, "type", "scheme"), Sg(zY, "defaultProps", {
        onComplete: function() {},
        onError: function() {},
        paymentData: "",
        showSpinner: !0,
        onActionHandled: function() {}
    });
    var MY = function(e) {
        L_(r, e);
        var t = BY(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "callSubmit3DS2Fingerprint", Jg(jY).call(jY, B_(a))), a;
        }
        return wg(r, [
            {
                key: "onComplete",
                value: function(e) {
                    GA(U_(r.prototype), "onComplete", this).call(this, e), this.unmount();
                }
            },
            {
                key: "render",
                value: function() {
                    return MO(this.props.paymentData) ? rN(zY, j_({}, this.props, {
                        onComplete: this.props.useOriginalFlow ? this.onComplete : this.callSubmit3DS2Fingerprint
                    })) : (this.props.onError({
                        errorCode: r.defaultProps.dataKey,
                        message: "No paymentData received. Fingerprinting cannot proceed"
                    }), null);
                }
            }
        ]), r;
    }(gA);
    Sg(MY, "type", "threeDS2Fingerprint"), Sg(MY, "defaultProps", {
        dataKey: "fingerprintResult",
        type: "IdentifyShopper"
    });
    var LY = t(ee.setInterval), VY = ea, UY = vo, KY = G, HY = RangeError, qY = function(e) {
        var t = UY(KY(this)), r = "", a = VY(e);
        if (a < 0 || a === 1 / 0) throw new HY("Wrong number of repetitions");
        for(; a > 0; (a >>>= 1) && (t += t))1 & a && (r += t);
        return r;
    };
    Ar({
        target: "String",
        proto: !0
    }, {
        repeat: qY
    });
    var WY = Cv("String", "repeat"), GY = ie, YY = WY, QY = String.prototype, ZY = t(function(e) {
        var t = e.repeat;
        return "string" == typeof e || e === QY || GY(QY, e) && t === QY.repeat ? YY : t;
    }), JY = function(e) {
        var t, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2;
        if (0 === r) return e;
        var a = String(e);
        return a.length >= r ? a : xA(t = ZY("0").call("0", r) + a).call(t, -1 * r);
    }, $Y = function(e, t) {
        var r = new Date, a = t.getTime() - r.getTime(), n = a / 1e3, o = function(e, t, r) {
            var a = r.getTime() - e.getTime();
            return 100 - Math.round(100 * (t.getTime() - e.getTime()) / a);
        }(e, r, t);
        return {
            total: a,
            minutes: JY(Math.floor(n / 60 % 60)),
            seconds: JY(Math.floor(n % 60)),
            completed: a <= 0,
            percentage: o
        };
    }, XY = function() {
        function e(t) {
            Cg(this, e), Sg(this, "TRANSLATION_KEY", "sr.wechatpay.timetopay"), Sg(this, "LONG_TIMEOUT", 18e4), Sg(this, "MID_TIMEOUT", 6e4), Sg(this, "SHORT_TIMEOUT", 3e4), Sg(this, "srPanel", void 0), Sg(this, "i18n", void 0), Sg(this, "srInterval", void 0), Sg(this, "timeout", void 0), Sg(this, "timeLeft", void 0);
            var r = t.srPanel, a = t.i18n;
            this.srPanel = r, this.i18n = a, this.srPanel.setAriaProps({
                "aria-relevant": "additions text"
            });
        }
        return wg(e, [
            {
                key: "update",
                value: function(e) {
                    var t = e.minutes, r = e.seconds;
                    if ("-" !== t && "-" !== r) {
                        var a = "string" == typeof t ? ZC(t, 10) : t, n = "string" == typeof r ? ZC(r, 10) : r;
                        this.timeLeft = {
                            minutes: a,
                            seconds: n
                        }, a > 5 && this.timeout !== this.LONG_TIMEOUT && (this.timeout = this.LONG_TIMEOUT, this.setInterval(this.timeout)), a >= 1 && a <= 5 && this.timeout !== this.MID_TIMEOUT && (this.timeout = this.MID_TIMEOUT, this.setInterval(this.timeout)), a < 1 && n > 0 && this.timeout !== this.SHORT_TIMEOUT && (this.timeout = this.SHORT_TIMEOUT, this.setInterval(this.timeout));
                    }
                }
            },
            {
                key: "tearDown",
                value: function() {
                    this.clearInterval(), this.srPanel.setAriaProps({
                        "aria-relevant": this.srPanel.constructor.defaultProps.ariaAttributes["aria-relevant"]
                    }), this.srPanel.setMessages(null);
                }
            },
            {
                key: "setInterval",
                value: function(e) {
                    function t(t) {
                        return e.apply(this, arguments);
                    }
                    return t.toString = function() {
                        return e.toString();
                    }, t;
                }(function(e) {
                    var t = this;
                    this.clearInterval();
                    var r = function() {
                        t.srPanel.setMessages(null), t.srPanel.setMessages(t.getSrMessages(t.timeLeft));
                    };
                    r(), this.srInterval = LY(r, e);
                })
            },
            {
                key: "getSrMessages",
                value: function(e) {
                    var t, r = e.minutes, a = e.seconds, n = this.i18n.get(this.TRANSLATION_KEY), o = hC(t = [
                        r,
                        a
                    ]).call(t, function(e) {
                        return 0 !== e ? function(t) {
                            var r;
                            return wb(r = "".concat(e, " ")).call(r, t);
                        } : function() {
                            return "";
                        };
                    });
                    return [
                        IC(n, o).join("")
                    ];
                }
            },
            {
                key: "clearInterval",
                value: function(e) {
                    function t() {
                        return e.apply(this, arguments);
                    }
                    return t.toString = function() {
                        return e.toString();
                    }, t;
                }(function() {
                    this.srInterval && clearInterval(this.srInterval);
                })
            }
        ]), e;
    }(), eQ = function(e) {
        var t = zP().i18n, r = bO().srPanel, a = gP(null);
        vP(function() {
            return a.current = new XY({
                i18n: t,
                srPanel: r
            }), function() {
                a.current.tearDown();
            };
        }, []), vP(function() {
            try {
                if (!a.current) return;
                a.current.update(e);
            } catch (e) {
                throw a.current.tearDown(), a.current = null, e;
            }
        }, [
            e
        ]);
    }, tQ = function(e) {
        var t = 6e4 * e, r = (new Date).getTime();
        return {
            startTime: new Date(r),
            endTime: new Date(r + t)
        };
    };
    function rQ(e) {
        var t = e.minutesFromNow, r = e.onTick, a = void 0 === r ? function() {} : r, n = e.onCompleted, o = void 0 === n ? function() {} : n, i = gP(tQ(t)).current, l = i.startTime, c = i.endTime, s = Vk(fP({
            minutes: "-",
            seconds: "-"
        }), 2), u = s[0], d = s[1];
        return eQ(u), vP(function() {
            var e = LY(function() {
                var e = $Y(l, c), t = e.minutes, r = e.seconds, n = e.percentage;
                if (e.completed) o();
                else {
                    var i = {
                        minutes: t,
                        seconds: r,
                        percentage: n
                    };
                    d(i), a(i);
                }
            }, 1e3);
            return function() {
                clearInterval(e);
            };
        }, []), rN("span", {
            className: "adyen-checkout__countdown",
            role: "timer"
        }, rN("span", {
            className: "countdown__minutes"
        }, u.minutes), rN("span", {
            className: "countdown__separator"
        }, ":"), rN("span", {
            className: "countdown__seconds"
        }, u.seconds));
    }
    function aQ(e, t, r, a) {
        if (!e || !t) throw new Error("Could not check the payment status");
        return cT({
            loadingContext: r,
            path: "services/PaymentInitiation/v1/status?clientKey=".concat(t),
            timeout: a
        }, {
            paymentData: e
        });
    }
    function nQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function oQ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = nQ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = nQ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var iQ = function(e) {
        switch(e.resultCode.toLowerCase()){
            case "refused":
            case "error":
            case "cancelled":
                return {
                    type: "error",
                    props: oQ(oQ({}, e), {}, {
                        message: "error.subtitle.refused"
                    })
                };
            case "unknown":
                return {
                    type: "error",
                    props: oQ(oQ({}, e), {}, {
                        message: "error.message.unknown"
                    })
                };
            case "pending":
            case "received":
                return {
                    type: e.resultCode.toLowerCase(),
                    props: e
                };
            default:
                return {
                    type: "success",
                    props: e
                };
        }
    }, lQ = function(e) {
        if (!e.type && e.resultCode) return iQ(e);
        if (!e.type) return {
            type: "error",
            props: e
        };
        switch(e.type.toLowerCase()){
            case "pending":
                return {
                    type: "pending",
                    props: e
                };
            case "complete":
                return iQ(e);
            default:
                return {
                    type: "error",
                    props: e
                };
        }
    }, cQ = function(e) {
        var t = bO().srPanel;
        vP(function() {
            return t.setAriaProps({
                "aria-relevant": "additions text"
            }), function() {
                t.setMessages(null), t.setAriaProps({
                    "aria-relevant": t.constructor.defaultProps.ariaAttributes["aria-relevant"]
                });
            };
        }, []), vP(function() {
            t.setMessages(e);
        }, [
            e
        ]);
    };
    function sQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var uQ = function(e) {
        L_(r, e);
        var t = sQ(r);
        function r(e) {
            var a;
            return Cg(this, r), Sg(B_(a = t.call(this, e)), "timeoutId", void 0), Sg(B_(a), "redirectToApp", function(e) {
                window.location.assign(e);
            }), Sg(B_(a), "statusInterval", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                if (!a.state.expired && !a.state.completed) {
                    a.setState(function(t) {
                        return {
                            timePassed: t.timePassed + a.props.delay + e
                        };
                    });
                    var t = a.state.timePassed >= a.props.throttleTime ? a.props.throttledInterval : a.state.delay;
                    a.pollStatus(t);
                }
            }), Sg(B_(a), "onTick", function(e) {
                a.setState({
                    percentage: e.percentage
                });
            }), Sg(B_(a), "onTimeUp", function() {
                a.setState({
                    expired: !0
                }), clearTimeout(a.timeoutId), a.props.onError(new mA("ERROR", "Payment Expired"));
            }), Sg(B_(a), "onComplete", function(e) {
                clearTimeout(a.timeoutId), a.setState({
                    completed: !0,
                    loading: !1
                });
                var t = {
                    data: {
                        details: {
                            payload: e.props.payload
                        },
                        paymentData: a.props.paymentData
                    }
                };
                a.props.onComplete(t, B_(a));
            }), Sg(B_(a), "onError", function(e) {
                if (clearTimeout(a.timeoutId), a.setState({
                    expired: !0,
                    loading: !1
                }), e.props.payload) {
                    var t = {
                        data: {
                            details: {
                                payload: e.props.payload
                            },
                            paymentData: a.props.paymentData
                        }
                    };
                    a.props.onComplete(t, B_(a));
                }
                var r = new mA("ERROR", "error result with no payload in response");
                return a.props.onError(r);
            }), Sg(B_(a), "checkStatus", function() {
                var e = a.props;
                return aQ(e.paymentData, e.clientKey, e.loadingContext, e.throttledInterval).then(lQ).catch(function(e) {
                    return {
                        type: "network-error",
                        props: e
                    };
                }).then(function(e) {
                    switch(e.type){
                        case "success":
                            a.onComplete(e);
                            break;
                        case "error":
                            a.onError(e);
                            break;
                        default:
                            a.setState({
                                loading: !1
                            });
                    }
                    return e;
                });
            }), a.state = {
                buttonStatus: "default",
                completed: !1,
                delay: e.delay,
                expired: !1,
                loading: !0,
                percentage: 100,
                timePassed: 0
            }, a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.statusInterval();
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    clearTimeout(this.timeoutId);
                }
            },
            {
                key: "pollStatus",
                value: function(e) {
                    var t = this;
                    clearTimeout(this.timeoutId), this.timeoutId = ZN(Jd(Ey.mark(function e() {
                        var r, a;
                        return Ey.wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    return r = performance.now(), e.next = 3, t.checkStatus();
                                case 3:
                                    a = performance.now(), t.statusInterval(Math.round(a - r));
                                case 5:
                                case "end":
                                    return e.stop();
                            }
                        }, e);
                    })), e);
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r, a, n, o, i, l, c = this, s = e.amount, u = e.url, d = e.brandLogo, p = e.brandName, m = e.countdownTime, f = e.type, h = e.onActionHandled, v = t.expired, y = t.completed, g = t.loading, b = zP(), k = b.i18n, C = b.loadingContext, _ = tI(), N = this.props.qrCodeData ? wb(r = wb(a = "".concat(C)).call(a, "barcode.shtml?barcodeType=qrCode&fileType=png&data=")).call(r, this.props.qrCodeData) : this.props.qrCodeImage, P = function(e, t) {
                        var r = k.get(t);
                        return cQ(r), rN("div", {
                            className: "adyen-checkout__qr-loader adyen-checkout__qr-loader--result"
                        }, rN("img", {
                            className: "adyen-checkout__qr-loader__icon adyen-checkout__qr-loader__icon--result",
                            src: _({
                                imageFolder: "components/"
                            })(e),
                            alt: r
                        }), rN("div", {
                            className: "adyen-checkout__qr-loader__subtitle adyen-checkout__qr-loader__subtitle--result"
                        }, r));
                    };
                    if (v) return P("error", "error.subtitle.payment");
                    if (y) return P("success", "creditCard.success");
                    if (g) return rN("div", {
                        className: "adyen-checkout__qr-loader"
                    }, d && rN("img", {
                        alt: p,
                        src: d,
                        className: "adyen-checkout__qr-loader__brand-logo"
                    }), rN(nP, null));
                    var w, S = k.get(this.props.timeToPay).split("%@"), A = (w = gP(null), vP(function() {
                        var e;
                        null === (e = w.current) || void 0 === e || e.focus();
                    }, []), w);
                    return rN("div", {
                        className: wb(n = "\n                    adyen-checkout__qr-loader\n                    adyen-checkout__qr-loader--".concat(f, "\n                    ")).call(n, hC(o = this.props.classNameModifiers).call(o, function(e) {
                            return "adyen-checkout__qr-loader--".concat(e);
                        }), "\n                ")
                    }, d && rN("img", {
                        src: d,
                        alt: p,
                        className: "adyen-checkout__qr-loader__brand-logo"
                    }), s && s.value && s.currency && rN("div", {
                        className: "adyen-checkout__qr-loader__payment_amount"
                    }, k.amount(s.value, s.currency)), u && rN("div", {
                        className: "adyen-checkout__qr-loader__app-link"
                    }, this.props.redirectIntroduction && rN("div", {
                        className: "adyen-checkout__qr-loader__subtitle"
                    }, k.get(this.props.redirectIntroduction)), rN(jP, {
                        classNameModifiers: [
                            "qr-loader"
                        ],
                        onClick: function() {
                            return c.redirectToApp(u);
                        },
                        label: k.get(this.props.buttonLabel)
                    }), rN(cB, null)), rN("div", {
                        ref: A,
                        tabIndex: 0,
                        className: "adyen-checkout__qr-loader__subtitle"
                    }, k.get(this.props.introduction)), rN("img", {
                        src: N,
                        alt: k.get("wechatpay.scanqrcode"),
                        onLoad: function() {
                            null == h || h({
                                componentType: c.props.type,
                                actionDescription: "qr-code-loaded"
                            });
                        }
                    }), rN("div", {
                        className: "adyen-checkout__qr-loader__progress"
                    }, rN("span", {
                        className: "adyen-checkout__qr-loader__percentage",
                        style: {
                            width: "".concat(this.state.percentage, "%")
                        }
                    })), rN("div", {
                        className: "adyen-checkout__qr-loader__countdown"
                    }, S[0], "\xa0", rN(rQ, {
                        minutesFromNow: m,
                        onTick: this.onTick,
                        onCompleted: this.onTimeUp
                    }), "\xa0", S[1]), "string" == typeof this.props.instructions ? rN("div", {
                        className: "adyen-checkout__qr-loader__instructions"
                    }, k.get(this.props.instructions)) : null === (i = (l = this.props).instructions) || void 0 === i ? void 0 : i.call(l), this.props.copyBtn && rN("div", {
                        className: "adyen-checkout__qr-loader__actions"
                    }, rN(jP, {
                        inline: !0,
                        variant: "action",
                        onClick: function(e, t) {
                            var r = t.complete;
                            SW(c.props.qrCodeData), r();
                        },
                        icon: _({
                            imageFolder: "components/"
                        })("copy"),
                        label: k.get("button.copy")
                    })));
                }
            }
        ]), r;
    }(oN);
    function dQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function pQ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = dQ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = dQ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function mQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(uQ, "defaultProps", {
        delay: 2e3,
        countdownTime: 15,
        onError: function() {},
        onComplete: function() {},
        throttleTime: 6e4,
        classNameModifiers: [],
        throttledInterval: 1e4,
        introduction: "wechatpay.scanqrcode",
        timeToPay: "wechatpay.timetopay",
        buttonLabel: "openApp"
    });
    var fQ = function(e) {
        L_(r, e);
        var t = mQ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: pQ({
                            type: this.props.type || this.constructor.type
                        }, this.state.data)
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "renderQRCode",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(qO, {
                        srPanel: this.props.modules.srPanel
                    }, rN(uQ, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        type: this.constructor.type,
                        brandLogo: this.props.brandLogo || this.icon,
                        delay: this.props.delay,
                        onComplete: this.onComplete,
                        countdownTime: this.props.countdownTime,
                        instructions: this.props.instructions,
                        onActionHandled: this.props.onActionHandled,
                        brandName: this.displayName
                    }))));
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.paymentData ? this.renderQRCode() : this.props.showPayButton ? rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(TL, {
                        name: this.displayName,
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    })) : null;
                }
            }
        ]), r;
    }(gA);
    Sg(fQ, "defaultProps", {
        qrCodeImage: "",
        amount: null,
        paymentData: null,
        onError: function() {},
        onComplete: function() {},
        onActionHandled: function() {}
    });
    function hQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function vQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var yQ = function(e) {
        L_(r, e);
        var t = vQ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Ag(r = hQ(Object(n), !0)).call(r, function(t) {
                                Sg(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Ag(a = hQ(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        delay: 2e3,
                        countdownTime: 15
                    }, GA(U_(r.prototype), "formatProps", this).call(this, e));
                }
            }
        ]), r;
    }(fQ);
    Sg(yQ, "type", "wechatpayQR");
    function gQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function bQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var kQ = function(e) {
        L_(r, e);
        var t = bQ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Ag(r = gQ(Object(n), !0)).call(r, function(t) {
                                Sg(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Ag(a = gQ(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        delay: 2e3,
                        countdownTime: 3
                    }, GA(U_(r.prototype), "formatProps", this).call(this, e));
                }
            }
        ]), r;
    }(fQ);
    Sg(kQ, "type", "paynow");
    function CQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function _Q(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var NQ = function(e) {
        L_(r, e);
        var t = _Q(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Ag(r = CQ(Object(n), !0)).call(r, function(t) {
                                Sg(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Ag(a = CQ(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        delay: 2e3,
                        countdownTime: 15,
                        buttonLabel: window.matchMedia("(max-width: 768px)").matches && /Android|iPhone|iPod/.test(navigator.userAgent) ? "openApp" : "generateQRCode"
                    }, GA(U_(r.prototype), "formatProps", this).call(this, e));
                }
            }
        ]), r;
    }(fQ);
    function PQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(NQ, "type", "bcmc_mobile");
    var wQ = function(e) {
        L_(r, e);
        var t = PQ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(BL);
    function SQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(wQ, "type", "molpay_ebanking_fpx_MY");
    var AQ = function(e) {
        L_(r, e);
        var t = SQ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(BL);
    function IQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(AQ, "type", "molpay_ebanking_TH");
    var DQ = function(e) {
        L_(r, e);
        var t = IQ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(BL);
    function EQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function RQ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = EQ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = EQ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function xQ(e) {
        var t, r, a = zP().i18n, n = tI(), o = function() {
            var t = [
                "dragonpay_ebanking",
                "dragonpay_otc_banking",
                "dragonpay_otc_non_banking"
            ];
            return Kk(t).call(t, e.type) > -1;
        }, i = QD({
            schema: wb(t = []).call(t, Uk(o() ? [
                "issuer"
            ] : []), [
                "shopperEmail"
            ]),
            rules: {
                issuer: {
                    validate: function(e) {
                        return o() && !!e;
                    },
                    modes: [
                        "input",
                        "blur"
                    ]
                },
                shopperEmail: yE.shopperEmail
            }
        }), l = i.handleChangeFor, c = i.triggerValidation, s = i.data, u = i.valid, d = i.errors, p = i.isValid, m = EL({}, e.type, n), f = hC(r = e.items).call(r, function(e) {
            return RQ(RQ({}, e), {}, {
                icon: m(e.id && e.id.toLowerCase())
            });
        }), h = function(e) {
            return "dragonpay_otc_non_banking" === e ? "dragonpay.voucher.non.bank.selectField.placeholder" : "dragonpay.voucher.bank.selectField.placeholder";
        };
        vP(function() {
            e.onChange({
                isValid: p,
                data: s,
                valid: u,
                errors: d
            });
        }, [
            p,
            s,
            u,
            d
        ]);
        var v = Vk(fP("ready"), 2), y = v[0], g = v[1];
        return this.setStatus = g, this.showValidation = c, rN("div", {
            className: "adyen-checkout__dragonpay-input__field"
        }, rN(oD, {
            label: a.get("shopperEmail"),
            errorMessage: !!d.shopperEmail,
            name: "dragonpay-shopperEmail"
        }, rN(BE, {
            name: "dragonpay-shopperEmail",
            autoCorrect: "off",
            value: s.shopperEmail,
            className: "adyen-checkout__input--large",
            spellCheck: !1,
            onInput: l("shopperEmail", "input"),
            onBlur: l("shopperEmail", "blur")
        })), o() && rN(oD, {
            label: a.get(h(e.type)),
            errorMessage: !!d.issuer,
            name: "issuer"
        }, rN(OT, {
            items: f,
            selectedValue: s.issuer,
            placeholder: a.get(h(e.type)),
            name: "issuer",
            className: "adyen-checkout__dropdown--large adyen-checkout__issuer-list__dropdown",
            onChange: l("issuer")
        })), e.showPayButton && e.payButton({
            status: y,
            label: a.get("confirmPurchase")
        }));
    }
    function FQ(e) {
        var t = e.reference, r = e.totalAmount, a = e.surcharge, n = e.expiresAt, o = e.alternativeReference, i = e.instructionsUrl, l = e.icon, c = e.issuer, s = e.paymentMethodType, u = zP().i18n, d = tI(), p = "dragonpay_otc_philippines" !== s ? EL({}, s, d)(c.toLowerCase()) : null;
        return rN(IW, {
            reference: t,
            paymentMethodType: s,
            introduction: u.get("voucher.introduction"),
            imageUrl: l,
            issuerImageUrl: p,
            instructionsUrl: i,
            amount: r && u.amount(r.value, r.currency),
            surcharge: a && u.amount(a.value, a.currency),
            voucherDetails: [
                {
                    label: u.get("voucher.expirationDate"),
                    value: u.date(n)
                },
                {
                    label: u.get("voucher.alternativeReference"),
                    value: o
                }
            ],
            copyBtn: !0
        });
    }
    function TQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function zQ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = TQ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = TQ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function OQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(DQ, "type", "molpay_ebanking_VN"), xQ.defaultProps = {
        data: {},
        items: [],
        onChange: function() {}
    };
    var jQ = function(e) {
        L_(r, e);
        var t = OQ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.data, t = e.issuer, a = e.shopperEmail;
                    return zQ(zQ({}, a && {
                        shopperEmail: a
                    }), {}, {
                        paymentMethod: zQ(zQ({}, t && {
                            issuer: t
                        }), {}, {
                            type: this.props.type || r.type
                        })
                    });
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    var t, r;
                    return zQ(zQ({}, e), {}, {
                        issuers: null !== (t = null === (r = e.details) || void 0 === r || null === (r = zb(r).call(r, function(e) {
                            return "issuer" === e.key;
                        })) || void 0 === r ? void 0 : r.items) && void 0 !== t ? t : e.issuers
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.reference ? rN(FQ, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        icon: this.icon
                    }, this.props)) : rN(xQ, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        items: this.props.issuers
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(gA);
    function BQ(e) {
        var t, r = gP(null), a = zP().i18n, n = Vk(fP("ready"), 2), o = n[0], i = n[1], l = gP({});
        Ty(l.current).length || null === (t = e.setComponentRef) || void 0 === t || t.call(e, l.current);
        return l.current.showValidation = function() {
            var e;
            null === (e = r.current) || void 0 === e || e.showValidation();
        }, l.current.setStatus = i, rN("div", {
            className: "adyen-checkout__doku-input__field"
        }, e.showFormInstruction && rN(IO, null), rN(KE, {
            data: e.data,
            requiredFields: [
                "firstName",
                "lastName",
                "shopperEmail"
            ],
            onChange: e.onChange,
            namePrefix: "doku",
            setComponentRef: function(e) {
                r.current = e;
            }
        }), e.showPayButton && e.payButton({
            status: o,
            label: a.get("confirmPurchase")
        }));
    }
    Sg(jQ, "type", "dragonpay");
    var MQ = function(e) {
        var t = e.reference, r = e.expiresAt, a = e.instructionsUrl, n = e.shopperName, o = e.merchantName, i = e.totalAmount, l = e.paymentMethodType, c = zP().i18n, s = tI();
        return rN(IW, {
            paymentMethodType: l,
            reference: t,
            introduction: c.get("voucher.introduction.doku"),
            imageUrl: s()(l),
            instructionsUrl: a,
            amount: i && c.amount(i.value, i.currency),
            voucherDetails: [
                {
                    label: c.get("voucher.expirationDate"),
                    value: c.date(r)
                },
                {
                    label: c.get("voucher.shopperName"),
                    value: n
                },
                {
                    label: c.get("voucher.merchantName"),
                    value: o
                }
            ],
            copyBtn: !0
        });
    };
    function LQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function VQ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = LQ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = LQ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function UQ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var KQ = function(e) {
        L_(r, e);
        var t = UQ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "formatData",
                value: function() {
                    return VQ(VQ({}, this.state.data), {}, {
                        paymentMethod: {
                            type: this.props.type || r.type
                        }
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.reference ? rN(MQ, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props)) : rN(BQ, j_({
                        setComponentRef: this.setComponentRef
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(gA);
    Sg(KQ, "type", "doku"), Sg(KQ, "defaultProps", {
        showFormInstruction: !0
    });
    var HQ = {
        socialSecurityNumber: {
            validate: MU,
            errorMessage: "error.va.gen.02",
            modes: [
                "blur"
            ]
        },
        shopperEmail: yE.shopperEmail,
        default: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "error.va.gen.02",
            modes: [
                "blur"
            ]
        },
        firstName: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "firstName.invalid",
            modes: [
                "blur"
            ]
        },
        lastName: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "lastName.invalid",
            modes: [
                "blur"
            ]
        }
    }, qQ = {
        socialSecurityNumber: function(e) {
            return BU(e);
        }
    };
    function WQ(e) {
        var t = e.errors, r = e.value, a = e.onInput, n = e.onBlur, o = zP().i18n, i = Vk(fP(!1), 2), l = i[0], c = i[1];
        return rN("div", {
            className: aP("adyen-checkout__fieldset", "adyen-checkout__fieldset--sendCopyToEmail", e.classNames)
        }, rN(oD, {
            classNameModifiers: [
                "sendCopyToEmail"
            ],
            name: "sendCopyToEmail",
            useLabelElement: !1,
            addContextualElement: !1
        }, rN(dz, {
            onChange: function(t) {
                c(t.target.checked), e.onToggle(l);
            },
            label: o.get("boleto.sendCopyToEmail"),
            name: "sendCopyToEmail"
        })), l && rN(oD, {
            label: o.get("shopperEmail"),
            classNameModifiers: [
                "shopperEmail"
            ],
            errorMessage: t && t.errorMessage ? o.get(t.errorMessage) : !!t,
            name: "shopperEmail"
        }, rN(BE, {
            name: "shopperEmail",
            autoCorrect: "off",
            spellCheck: !1,
            value: r,
            onInput: a,
            onBlur: n
        })));
    }
    function GQ(e) {
        var t = e.i18n, r = e.data, a = e.handleChangeFor, n = e.errors, o = e.valid, i = function(e) {
            return e && e.errorMessage ? t.get(e.errorMessage) : !!e;
        };
        return rN("div", {
            className: "adyen-checkout__fieldset adyen-checkout__fieldset--address adyen-checkout__fieldset--personalDetails"
        }, rN("div", {
            className: "adyen-checkout__fieldset__title"
        }, t.get("personalDetails")), rN("div", {
            className: "adyen-checkout__fieldset__fields"
        }, rN(oD, {
            label: t.get("firstName"),
            classNameModifiers: [
                "firstName",
                "col-50"
            ],
            errorMessage: i(n.firstName),
            name: "firstName"
        }, rN(oE, {
            name: "firstName",
            autocorrect: "off",
            spellcheck: !1,
            value: r.firstName,
            onInput: a("firstName", "input"),
            onBlur: a("firstName", "blur")
        })), rN(oD, {
            label: t.get("lastName"),
            classNameModifiers: [
                "lastName",
                "col-50"
            ],
            errorMessage: i(n.lastName),
            name: "lastName"
        }, rN(oE, {
            name: "lastName",
            autocorrect: "off",
            spellcheck: !1,
            value: r.lastName,
            onInput: a("lastName", "input"),
            onBlur: a("lastName", "blur")
        })), rN(RK, {
            data: r.socialSecurityNumber,
            error: n.socialSecurityNumber,
            valid: o.socialSecurityNumber,
            onInput: a("socialSecurityNumber", "input"),
            onBlur: a("socialSecurityNumber", "blur")
        })));
    }
    function YQ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function QQ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = YQ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = YQ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function ZQ(e) {
        var t = zP().i18n, r = gP(null), a = QD({
            schema: [
                "firstName",
                "lastName",
                "socialSecurityNumber",
                "billingAddress",
                "shopperEmail"
            ],
            defaultData: e.data,
            rules: HQ,
            formatters: qQ
        }), n = a.handleChangeFor, o = a.triggerValidation, i = a.setSchema, l = a.setData, c = a.setValid, s = a.setErrors, u = a.data, d = a.valid, p = a.errors, m = a.isValid, f = Vk(fP(!1), 2), h = f[0], v = f[1];
        vP(function() {
            var t, r = wb(t = []).call(t, Uk(e.personalDetailsRequired ? [
                "firstName",
                "lastName",
                "socialSecurityNumber"
            ] : []), Uk(e.billingAddressRequired ? [
                "billingAddress"
            ] : []), Uk(h ? [
                "shopperEmail"
            ] : []));
            i(r);
        }, [
            h,
            e.personalDetailsRequired,
            e.billingAddressRequired
        ]);
        var y, g = Vk(fP("ready"), 2), b = g[0], k = g[1], C = gP({});
        Ty(C.current).length || null === (y = e.setComponentRef) || void 0 === y || y.call(e, C.current);
        C.current.showValidation = function() {
            o(), e.billingAddressRequired && r.current.showValidation();
        }, C.current.setStatus = k, vP(function() {
            var t = !e.billingAddressRequired || Boolean(d.billingAddress);
            e.onChange({
                data: u,
                valid: d,
                errors: p,
                isValid: m && t
            });
        }, [
            u,
            d,
            p
        ]);
        var _ = Uk(e.personalDetailsRequired || e.billingAddressRequired || e.showEmailAddress ? [] : [
            "standalone"
        ]);
        return rN("div", {
            className: "adyen-checkout__boleto-input__field"
        }, e.showFormInstruction && (e.personalDetailsRequired || e.billingAddressRequired) && rN(IO, null), e.personalDetailsRequired && rN(GQ, {
            i18n: t,
            data: u,
            handleChangeFor: n,
            errors: p,
            valid: d
        }), e.billingAddressRequired && rN(cz, {
            allowedCountries: [
                "BR"
            ],
            label: "billingAddress",
            data: QQ(QQ({}, e.data.billingAddress), {}, {
                country: "BR"
            }),
            onChange: function(e) {
                l("billingAddress", e.data), c("billingAddress", e.isValid), s("billingAddress", e.errors);
            },
            requiredFields: [
                "country",
                "street",
                "houseNumberOrName",
                "postalCode",
                "city",
                "stateOrProvince"
            ],
            setComponentRef: function(e) {
                r.current = e;
            }
        }), e.showEmailAddress && rN(WQ, {
            value: u.shopperEmail,
            errors: p.shopperEmail,
            onToggle: function() {
                return v(!h);
            },
            onInput: n("shopperEmail", "input"),
            onBlur: n("shopperEmail", "blur")
        }), e.showPayButton && e.payButton({
            status: b,
            label: t.get("boletobancario.btnLabel"),
            classNameModifiers: _
        }));
    }
    ZQ.defaultProps = {
        data: {},
        showEmailAddress: !0,
        personalDetailsRequired: !0,
        billingAddressRequired: !0,
        showFormInstruction: !0
    };
    var JQ = function(e) {
        var t, r = zP(), a = r.i18n, n = r.loadingContext, o = tI(), i = e.reference, l = e.expiresAt, c = e.totalAmount, s = e.paymentMethodType, u = e.downloadUrl, d = i.replace(/[^\d]/g, "").replace(/^(\d{4})(\d{5})\d{1}(\d{10})\d{1}(\d{10})\d{1}(\d{15})$/, "$1$5$2$3$4");
        return rN(IW, {
            reference: i,
            paymentMethodType: "boletobancario",
            barcode: wb(t = "".concat(n, "barcode.shtml?data=")).call(t, d, "&barcodeType=BT_Int2of5A&fileType=png"),
            introduction: a.get("voucher.introduction"),
            imageUrl: o()(s),
            amount: c && a.amount(c.value, c.currency),
            voucherDetails: [
                {
                    label: a.get("voucher.expirationDate"),
                    value: a.date(l)
                }
            ],
            downloadUrl: u,
            copyBtn: !0
        });
    };
    function $Q(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function XQ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = $Q(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = $Q(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function eZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var tZ = function(e) {
        L_(r, e);
        var t = eZ(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "handleRef", function(e) {
                a.componentRef = e;
            }), a;
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.data, t = void 0 === e ? {} : e, a = t.billingAddress, n = t.shopperEmail, o = t.firstName, i = t.lastName, l = t.socialSecurityNumber, c = void 0 === l ? "" : l;
                    return XQ(XQ(XQ(XQ({
                        paymentMethod: {
                            type: this.props.type || r.type
                        }
                    }, a && {
                        billingAddress: a
                    }), n && {
                        shopperEmail: n
                    }), o && i && {
                        shopperName: {
                            firstName: o,
                            lastName: i
                        }
                    }), c && {
                        socialSecurityNumber: jU(c)
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.reference ? rN(JQ, j_({
                        ref: this.handleRef,
                        icon: this.icon
                    }, this.props)) : rN(ZQ, j_({
                        setComponentRef: this.handleRef
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(gA);
    Sg(tZ, "type", "boletobancario");
    var rZ = function(e) {
        var t, r, a = zP(), n = a.i18n, o = a.loadingContext, i = tI(), l = e.alternativeReference, c = e.reference, s = e.expiresAt, u = e.merchantReference, d = e.totalAmount, p = e.paymentMethodType, m = e.downloadUrl, f = wb(t = "".concat(o, "barcode.shtml?data=")).call(t, c, "&barcodeType=BT_Code128C&fileType=png"), h = wb(r = []).call(r, Uk(s ? [
            {
                label: n.get("voucher.expirationDate"),
                value: n.date(s)
            }
        ] : []), Uk(u ? [
            {
                label: n.get("voucher.shopperReference"),
                value: u
            }
        ] : []), Uk(l ? [
            {
                label: n.get("voucher.alternativeReference"),
                value: l
            }
        ] : []));
        return rN(IW, {
            amount: d && n.amount(d.value, d.currency),
            barcode: f,
            copyBtn: !0,
            downloadUrl: m,
            imageUrl: i()(p),
            introduction: n.get("voucher.introduction"),
            paymentMethodType: "oxxo",
            reference: c,
            voucherDetails: h
        });
    };
    function aZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function nZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = aZ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = aZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function oZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var iZ = function(e) {
        L_(r, e);
        var t = oZ(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "handleRef", function(e) {
                a.componentRef = e;
            }), a;
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: {
                            type: this.props.type || r.type
                        }
                    };
                }
            },
            {
                key: "render",
                value: function() {
                    var e;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.reference ? rN(rZ, j_({
                        ref: this.handleRef
                    }, this.props)) : this.props.showPayButton && this.payButton(nZ(nZ({}, this.props), {}, {
                        classNameModifiers: [
                            "standalone"
                        ],
                        label: wb(e = "".concat(this.props.i18n.get("continueTo"), " ")).call(e, this.props.name),
                        onClick: this.submit
                    })));
                }
            }
        ]), r;
    }(gA);
    Sg(iZ, "type", "oxxo"), Sg(iZ, "defaultProps", {
        showPayButton: !1,
        name: "Oxxo"
    });
    var lZ = function(e) {
        var t, r = zP().i18n, a = tI(), n = e.entity, o = e.reference, i = e.expiresAt, l = e.merchantReference, c = e.totalAmount, s = e.paymentMethodType, u = e.downloadUrl, d = wb(t = []).call(t, Uk(n ? [
            {
                label: r.get("voucher.entity"),
                value: n
            }
        ] : []), Uk(i ? [
            {
                label: r.get("voucher.expirationDate"),
                value: r.date(i)
            }
        ] : []), Uk(l ? [
            {
                label: r.get("voucher.shopperReference"),
                value: l
            }
        ] : []));
        return rN(IW, {
            amount: c && r.amount(c.value, c.currency),
            barcode: null,
            copyBtn: !0,
            downloadUrl: u,
            imageUrl: a()(s),
            introduction: r.get("voucher.introduction"),
            paymentMethodType: "multibanco",
            reference: o,
            voucherDetails: d
        });
    };
    function cZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function sZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = cZ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = cZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function uZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var dZ = function(e) {
        L_(r, e);
        var t = uZ(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "handleRef", function(e) {
                a.componentRef = e;
            }), a;
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    return sZ(sZ({}, e), {}, {
                        name: e.name || "Multibanco"
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: {
                            type: this.props.type || r.type
                        }
                    };
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.reference ? rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(lZ, j_({
                        ref: this.handleRef
                    }, this.props))) : this.props.showPayButton ? rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(TL, {
                        name: this.displayName,
                        amount: this.props.amount,
                        payButton: this.payButton,
                        onSubmit: this.submit,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    })) : null;
                }
            }
        ]), r;
    }(gA);
    function pZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(dZ, "type", "multibanco"), Sg(dZ, "defaultProps", {
        showPayButton: !0
    });
    var mZ = function(e) {
        L_(r, e);
        var t = pZ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(BL);
    function fZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function hZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = fZ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = fZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function vZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(mZ, "type", "dotpay");
    var yZ = function(e) {
        L_(r, e);
        var t = vZ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return hZ(hZ({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1
                    });
                }
            }
        ]), r;
    }(BL);
    function gZ(e) {
        var t = e.children, r = e.classNames, a = void 0 === r ? [] : r, n = e.type, o = void 0 === n ? "error" : n, i = e.icon;
        return rN("div", {
            className: aP("adyen-checkout__alert-message", "adyen-checkout__alert-message--".concat(o), a)
        }, i && rN(aI, {
            className: "adyen-checkout__alert-message__icon",
            type: i
        }), t);
    }
    Sg(yZ, "type", "eps");
    var bZ = [
        "brand",
        "amount",
        "balance",
        "transactionLimit"
    ];
    function kZ(e) {
        e.brand;
        var t = e.amount, r = e.balance, a = e.transactionLimit, n = kg(e, bZ), o = zP().i18n, i = t.value > (null == a ? void 0 : a.value) ? a : t, l = (null == r ? void 0 : r.value) - (null == i ? void 0 : i.value);
        return rN("div", {
            className: "adyen-checkout__giftcard-result"
        }, rN("ul", {
            className: "adyen-checkout__giftcard-result__balance"
        }, rN("li", {
            className: "adyen-checkout__giftcard-result__balance__item"
        }, rN("span", {
            className: "adyen-checkout__giftcard-result__balance__title"
        }, o.get("giftcardBalance")), rN("span", {
            className: "adyen-checkout__giftcard-result__balance__value adyen-checkout__giftcard-result__balance__value--amount"
        }, o.amount(r.value, r.currency))), a && a.value && rN("li", {
            className: "adyen-checkout__giftcard-result__balance__item"
        }, rN("span", {
            className: "adyen-checkout__giftcard-result__balance__title adyen-checkout__giftcard-result__balance__title--transactionLimit"
        }, o.get("giftcardTransactionLimit", {
            values: {
                amount: o.amount(a.value, a.currency)
            }
        })))), this.props.showPayButton && this.props.payButton({
            amount: i,
            status: n.status,
            onClick: n.onSubmit
        }), rN("p", {
            className: "adyen-checkout__giftcard-result__remaining-balance"
        }, o.get("partialPayment.remainingBalance", {
            values: {
                amount: o.amount(l, r.currency)
            }
        })));
    }
    var CZ = function(e) {
        var t, r = e.i18n, a = e.classNameModifiers, n = e.sfpState, o = e.getCardErrorMessage, i = e.focusedElement, l = e.setFocusOn;
        return rN(oD, {
            label: r.get("creditCard.numberField.title"),
            classNameModifiers: wb(t = [
                "number"
            ]).call(t, Uk(a)),
            errorMessage: o(n),
            focused: "encryptedCardNumber" === i,
            onFocusField: function() {
                return l("encryptedCardNumber");
            },
            dir: "ltr",
            name: "encryptedCardNumber",
            errorVisibleToScreenReader: !1
        }, rN(vK, {
            encryptedFieldType: "encryptedCardNumber",
            "data-info": '{"length":"15-32", "maskInterval":4}',
            className: aP({
                "adyen-checkout__input": !0,
                "adyen-checkout__input--large": !0,
                "adyen-checkout__card__cardNumber__input": !0,
                "adyen-checkout__input--error": o(n),
                "adyen-checkout__input--focus": "encryptedCardNumber" === i
            })
        }));
    }, _Z = function(e) {
        var t, r = e.i18n, a = e.classNameModifiers, n = e.sfpState, o = e.focusedElement, i = e.setFocusOn, l = e.label, c = void 0 === l ? r.get("creditCard.pin.title") : l;
        return rN(oD, {
            label: c,
            classNameModifiers: wb(t = [
                "pin"
            ]).call(t, Uk(a)),
            errorMessage: n.errors.encryptedSecurityCode && r.get(n.errors.encryptedSecurityCode),
            focused: "encryptedSecurityCode" === o,
            onFocusField: function() {
                return i("encryptedSecurityCode");
            },
            dir: "ltr",
            name: "encryptedSecurityCode",
            errorVisibleToScreenReader: !1
        }, rN(vK, {
            encryptedFieldType: "encryptedSecurityCode",
            "data-info": '{"length":"3-10", "maskInterval": 0}',
            className: aP({
                "adyen-checkout__input": !0,
                "adyen-checkout__input--large": !0,
                "adyen-checkout__card__cvc__input": !0,
                "adyen-checkout__input--error": n.errors.encryptedSecurityCode,
                "adyen-checkout__input--focus": "encryptedSecurityCode" === o
            })
        }));
    };
    function NZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var PZ = function(e) {
        L_(r, e);
        var t = NZ(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "state", {
                status: "ready",
                data: {},
                balance: null,
                transactionLimit: null,
                focusedElement: !1,
                isValid: !1
            }), Sg(B_(a), "sfp", void 0), Sg(B_(a), "onChange", function(e) {
                a.props.onChange({
                    data: e.data,
                    isValid: e.isSfpValid
                });
            }), Sg(B_(a), "showValidation", function() {
                a.sfp.showValidation();
            }), Sg(B_(a), "handleFocus", function(e) {
                a.setState({
                    focusedElement: e.currentFocusObject
                }), !0 === e.focus ? a.props.onFocus(e) : a.props.onBlur(e);
            }), Sg(B_(a), "setBalance", function(e) {
                var t = e.balance, r = e.transactionLimit;
                a.setState({
                    balance: t,
                    transactionLimit: r
                });
            }), a;
        }
        return wg(r, [
            {
                key: "setStatus",
                value: function(e) {
                    this.setState({
                        status: e
                    });
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r, a = this, n = t.focusedElement, o = t.balance, i = t.transactionLimit, l = zP().i18n, c = (null == i ? void 0 : i.value) < (null == o ? void 0 : o.value) ? i : o, s = (null == c ? void 0 : c.value) >= (null === (r = this.props.amount) || void 0 === r ? void 0 : r.value);
                    if (c && s) return rN(kZ, j_({
                        balance: o,
                        transactionLimit: i,
                        onSubmit: e.onSubmit
                    }, e));
                    var u = function(e) {
                        if (e.errors.encryptedCardNumber) return l.get(e.errors.encryptedCardNumber);
                        switch(a.state.status){
                            case "no-balance":
                                return l.get("error.giftcard.no-balance");
                            case "card-error":
                                return l.get("error.giftcard.card-error");
                            case "currency-error":
                                return l.get("error.giftcard.currency-error");
                            default:
                                return null;
                        }
                    };
                    return rN("div", {
                        className: "adyen-checkout__giftcard"
                    }, "error" === this.state.status && rN(gZ, {
                        icon: "cross"
                    }, l.get("error.message.unknown")), rN(FU, j_({}, this.props, {
                        ref: function(e) {
                            a.sfp = e;
                        },
                        onChange: this.onChange,
                        onFocus: this.handleFocus,
                        type: fI,
                        render: function(e, t) {
                            var r = e.setRootNode, o = e.setFocusOn;
                            return a.props.fieldsLayoutComponent({
                                i18n: l,
                                pinRequired: a.props.pinRequired,
                                focusedElement: n,
                                getCardErrorMessage: u,
                                setRootNode: r,
                                setFocusOn: o,
                                sfpState: t
                            });
                        }
                    })), this.props.showPayButton && this.props.payButton({
                        status: this.state.status,
                        onClick: this.props.onBalanceCheck,
                        label: l.get("applyGiftcard")
                    }));
                }
            }
        ]), r;
    }(oN);
    function wZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function SZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = wZ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = wZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function AZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(PZ, "defaultProps", {
        pinRequired: !0,
        expiryDateRequired: !1,
        onChange: function() {},
        onFocus: function() {},
        onBlur: function() {},
        fieldsLayoutComponent: function(e) {
            var t = e.setRootNode, r = e.pinRequired;
            return rN("div", {
                ref: t,
                className: "adyen-checkout__field-wrapper"
            }, rN(CZ, j_({}, e, {
                classNameModifiers: r ? [
                    "70"
                ] : [
                    "100"
                ]
            })), r && rN(_Z, j_({}, e, {
                classNameModifiers: [
                    "30"
                ]
            })));
        }
    });
    var IZ, DZ = function(e) {
        L_(r, e);
        var t = AZ(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "handleBalanceCheck", function(e) {
                return a.props.onBalanceCheck ? new Sb(function(t, r) {
                    a.props.onBalanceCheck(t, r, e);
                }) : a.props.session ? a.props.session.checkBalance(e) : void 0;
            }), Sg(B_(a), "onOrderRequest", function(e) {
                return a.props.onOrderRequest ? new Sb(function(t, r) {
                    a.props.onOrderRequest(t, r, e);
                }) : a.props.session ? a.props.session.createOrder() : void 0;
            }), Sg(B_(a), "handleOrder", function(e) {
                var t = e.order;
                if (a.updateParent({
                    order: t
                }), a.props.session && a.props.onOrderCreated) return a.props.onOrderCreated(t);
            }), Sg(B_(a), "onBalanceCheck", function() {
                return a.props.session || a.props.onBalanceCheck ? a.isValid ? (a.setStatus("loading"), void a.handleBalanceCheck(a.formatData()).then(function(e) {
                    var t, r = e.balance, n = e.transactionLimit, o = void 0 === n ? {} : n;
                    if (!r) throw new Error("card-error");
                    if ((null == r ? void 0 : r.currency) !== (null === (t = a.props.amount) || void 0 === t ? void 0 : t.currency)) throw new Error("currency-error");
                    if ((null == r ? void 0 : r.value) <= 0) throw new Error("no-balance");
                    if (a.componentRef.setBalance({
                        balance: r,
                        transactionLimit: o
                    }), a.props.amount.value > r.value || a.props.amount.value > o.value) return a.props.order ? a.submit() : a.onOrderRequest(a.data).then(function(e) {
                        a.setState({
                            order: {
                                orderData: e.orderData,
                                pspReference: e.pspReference
                            }
                        }), a.submit();
                    });
                    a.props.onRequiringConfirmation && a.props.onRequiringConfirmation();
                }).catch(function(e) {
                    a.setStatus((null == e ? void 0 : e.message) || "error"), a.props.onError && a.handleError(new mA("ERROR", e));
                })) : (a.showValidation(), !1) : a.submit();
            }), Sg(B_(a), "payButton", function(e) {
                return rN(UP, e);
            }), a;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return SZ(SZ({}, null == e ? void 0 : e.configuration), e);
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e, t;
                    return {
                        paymentMethod: {
                            type: this.constructor.type,
                            brand: this.props.brand,
                            encryptedCardNumber: null === (e = this.state.data) || void 0 === e ? void 0 : e.encryptedCardNumber,
                            encryptedSecurityCode: null === (t = this.state.data) || void 0 === t ? void 0 : t.encryptedSecurityCode
                        }
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "icon",
                get: function() {
                    var e;
                    return (null === (e = this.props.brandsConfiguration[this.props.brand]) || void 0 === e ? void 0 : e.icon) || this.props.icon || this.resources.getImage()(this.props.brand);
                }
            },
            {
                key: "displayName",
                get: function() {
                    var e;
                    return (null === (e = this.props.brandsConfiguration[this.props.brand]) || void 0 === e ? void 0 : e.name) || this.props.name;
                }
            },
            {
                key: "balanceCheck",
                value: function() {
                    return this.onBalanceCheck();
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(PZ, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        onChange: this.setState,
                        onBalanceCheck: this.onBalanceCheck,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(gA);
    function EZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(DZ, "type", "giftcard"), Sg(DZ, "defaultProps", {
        brandsConfiguration: {}
    });
    var RZ = function(e) {
        L_(r, e);
        var t = EZ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(Jq);
    function xZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function FZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = xZ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = xZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function TZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    IZ = RZ, Sg(RZ, "type", "vipps"), Sg(RZ, "defaultProps", {
        type: IZ.type,
        showPayButton: !0,
        name: "Vipps"
    });
    var zZ = function(e) {
        L_(r, e);
        var t = TZ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return FZ(FZ({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1
                    });
                }
            }
        ]), r;
    }(BL);
    function OZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function jZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = OZ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = OZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function BZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(zZ, "type", "payu_IN_cashcard");
    var MZ = function(e) {
        L_(r, e);
        var t = BZ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return jZ(jZ({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1
                    });
                }
            }
        ]), r;
    }(BL);
    Sg(MZ, "type", "payu_IN_nb");
    var LZ = [
        "AT",
        "CH",
        "DE",
        "NL"
    ];
    function VZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function UZ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = VZ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = VZ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function KZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var HZ = function(e) {
        L_(r, e);
        var t = KZ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return UZ(UZ({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : LZ
                    });
                }
            }
        ]), r;
    }(QO);
    function qZ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function WZ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(HZ, "type", "ratepay");
    var GZ = function(e) {
        L_(r, e);
        var t = WZ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Ag(r = qZ(Object(n), !0)).call(r, function(t) {
                                Sg(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Ag(a = qZ(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        delay: 2e3,
                        countdownTime: 3,
                        instructions: "swish.pendingMessage"
                    }, GA(U_(r.prototype), "formatProps", this).call(this, e));
                }
            }
        ]), r;
    }(fQ);
    Sg(GZ, "type", "swish"), iw("Set", function(e) {
        return function() {
            return e(this, arguments.length ? arguments[0] : void 0);
        };
    }, Nw);
    var YZ = t(ee.Set), QZ = function(e) {
        var t = e.paymentMethodComponent, r = e.isLoaded;
        return t && r ? rN("div", {
            className: "adyen-checkout__payment-method__details__content"
        }, t) : null;
    }, ZZ = {
        "adyen-checkout__payment-methods-list": "DropinComponent-module_adyen-checkout__payment-methods-list__mAjAm",
        "adyen-checkout__payment-method": "DropinComponent-module_adyen-checkout__payment-method__nWdwg",
        "adyen-checkout__payment-method__details": "DropinComponent-module_adyen-checkout__payment-method__details__-rsW7",
        "adyen-checkout__payment-method__image": "DropinComponent-module_adyen-checkout__payment-method__image__nB80V",
        "adyen-checkout__payment-method__image__wrapper": "DropinComponent-module_adyen-checkout__payment-method__image__wrapper__6NWzA",
        "adyen-checkout__payment-method--selected": "DropinComponent-module_adyen-checkout__payment-method--selected__6egZF"
    }, JZ = [
        "googlepay",
        "paywithgoogle"
    ], $Z = function(e) {
        var t = e.src, r = e.altDescription, a = e.type, n = e.disabled, o = void 0 !== n && n;
        return rN("span", {
            className: aP("adyen-checkout__payment-method__image__wrapper", ZZ["adyen-checkout__payment-method__image__wrapper"], {
                "adyen-checkout__payment-method__image__wrapper--outline": !kb(JZ).call(JZ, a),
                "adyen-checkout__payment-method__image__wrapper--disabled": !!o
            })
        }, rN(ST, {
            className: "adyen-checkout__payment-method__image ".concat(ZZ["adyen-checkout__payment-method__image"]),
            src: t,
            alt: r
        }));
    }, XZ = function(e) {
        var t = e.id, r = e.open, a = e.onDisable, n = e.onCancel, o = zP().i18n;
        return rN("div", {
            id: t,
            "aria-hidden": !r,
            className: aP({
                "adyen-checkout__payment-method__disable-confirmation": !0,
                "adyen-checkout__payment-method__disable-confirmation--open": r
            })
        }, rN("div", {
            className: "adyen-checkout__payment-method__disable-confirmation__content"
        }, o.get("storedPaymentMethod.disable.confirmation"), rN("div", {
            className: "adyen-checkout__payment-method__disable-confirmation__buttons"
        }, rN("button", {
            type: "button",
            className: aP("adyen-checkout__button", "adyen-checkout__payment-method__disable-confirmation__button", "adyen-checkout__payment-method__disable-confirmation__button--remove"),
            disabled: !r,
            onClick: a
        }, o.get("storedPaymentMethod.disable.confirmButton")), rN("button", {
            type: "button",
            className: aP("adyen-checkout__button", "adyen-checkout__payment-method__disable-confirmation__button", "adyen-checkout__payment-method__disable-confirmation__button--cancel"),
            disabled: !r,
            onClick: n
        }, o.get("storedPaymentMethod.disable.cancelButton")))));
    }, eJ = function(e) {
        var t = e.allowedBrands;
        if (e.isPaymentMethodSelected) return null;
        var r = function(e) {
            var t = e.length <= 4 ? e : xA(e).call(e, 0, 3);
            return {
                visibleBrands: t,
                leftBrandsAmount: e.length - t.length
            };
        }(t), a = r.visibleBrands, n = r.leftBrandsAmount;
        return rN("span", {
            className: "adyen-checkout__payment-method__brands"
        }, hC(a).call(a, function(e) {
            return rN($Z, {
                key: e.name,
                altDescription: cK(e.name),
                type: e.name,
                src: e.icon
            });
        }), 0 !== n && rN("span", {
            className: "adyen-checkout__payment-method__brand-number"
        }, "+", n));
    }, tJ = function(e) {
        var t = e.activeBrand, r = e.brands, a = e.excludedUIBrands, n = e.isPaymentMethodSelected, o = e.isCompactView, i = void 0 === o || o, l = Fg(r).call(r, function(e) {
            return !(null != a && kb(a).call(a, e.name));
        });
        return i ? rN(eJ, {
            allowedBrands: l,
            isPaymentMethodSelected: n
        }) : rN("span", {
            className: "adyen-checkout__payment-method__brands"
        }, hC(l).call(l, function(e) {
            return rN($Z, {
                key: e.name,
                altDescription: cK(e.name),
                type: e.name,
                src: e.icon,
                disabled: t && t !== e.name
            });
        }));
    }, rJ = function(e) {
        var t = e.displayName, r = e.additionalInfo, a = e.isSelected;
        return rN("span", {
            className: "adyen-checkout__payment-method__name_wrapper"
        }, rN("span", {
            className: aP({
                "adyen-checkout__payment-method__name": !0,
                "adyen-checkout__payment-method__name--selected": a
            })
        }, t), r && rN("span", {
            className: aP({
                "adyen-checkout__payment-method__additional-info": !0,
                "adyen-checkout__payment-method__additional-info--selected": a
            })
        }, r));
    };
    function aJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function nJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = aJ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = aJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function oJ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var iJ = function(e) {
        L_(r, e);
        var t = oJ(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "state", {
                showDisableStoredPaymentMethodConfirmation: !1,
                activeBrand: null
            }), Sg(B_(a), "toggleDisableConfirmation", function() {
                a.setState({
                    showDisableStoredPaymentMethodConfirmation: !a.state.showDisableStoredPaymentMethodConfirmation
                });
            }), Sg(B_(a), "onDisableStoredPaymentMethod", function() {
                a.props.onDisableStoredPaymentMethod(a.props.paymentMethod), a.toggleDisableConfirmation();
            }), Sg(B_(a), "handleOnListItemClick", function() {
                var e = a.props;
                (0, e.onSelect)(e.paymentMethod);
            }), a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.paymentMethod.eventEmitter.on("brand", function(t) {
                        e.setState({
                            activeBrand: t.brand
                        });
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e = this;
                    this.props.paymentMethod.eventEmitter.off("brand", function(t) {
                        e.setState({
                            activeBrand: t.brand
                        });
                    });
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r, a = e.paymentMethod, n = e.isSelected, o = e.isDisablingPaymentMethod, i = e.isLoaded, l = e.isLoading, c = e.standalone, s = t.activeBrand, u = zP().i18n;
                    if (!a) return null;
                    var d = "card" === a.props.type || "scheme" === a.props.type, p = aP(nJ(nJ(Sg(Sg({
                        "adyen-checkout__payment-method": !0
                    }, ZZ["adyen-checkout__payment-method"], !0), "adyen-checkout__payment-method--".concat(a.props.type), !0), d && Sg({}, "adyen-checkout__payment-method--".concat(null !== (r = a.props.fundingSource) && void 0 !== r ? r : "credit"), !0)), {}, Sg(Sg(Sg(Sg(Sg(Sg(Sg(Sg({
                        "adyen-checkout__payment-method--selected": n
                    }, ZZ["adyen-checkout__payment-method--selected"], n), "adyen-checkout__payment-method--loading", l), "adyen-checkout__payment-method--disabling", o), "adyen-checkout__payment-method--confirming", this.state.showDisableStoredPaymentMethodConfirmation), "adyen-checkout__payment-method--standalone", c), ZZ["adyen-checkout__payment-method--loading"], l), a._id, !0), this.props.className, !0))), m = this.props.showRemovePaymentMethodButton && a.props.oneClick && n, f = "remove-".concat(a._id), h = "container-".concat(a._id), v = "button-".concat(a._id), y = !a.props.oneClick && a.brands && a.brands.length > 0;
                    return rN("li", {
                        key: a._id,
                        className: p,
                        onClick: this.handleOnListItemClick
                    }, rN("div", {
                        className: "adyen-checkout__payment-method__header"
                    }, rN("button", {
                        className: "adyen-checkout__payment-method__header__title",
                        id: v,
                        role: "radio",
                        "aria-checked": n,
                        type: "button"
                    }, rN("span", {
                        className: aP({
                            "adyen-checkout__payment-method__radio": !0,
                            "adyen-checkout__payment-method__radio--selected": n
                        }),
                        "aria-hidden": "true"
                    }), rN($Z, j_({}, a.props.oneClick && {
                        altDescription: a.props.name
                    }, {
                        type: a.type,
                        src: a.icon
                    })), rN(rJ, {
                        displayName: a.displayName,
                        isSelected: n,
                        additionalInfo: a.additionalInfo
                    })), m && rN("button", {
                        type: "button",
                        className: "adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link",
                        onClick: this.toggleDisableConfirmation,
                        "aria-expanded": this.state.showDisableStoredPaymentMethodConfirmation,
                        "aria-controls": f
                    }, u.get("storedPaymentMethod.disable.button")), y && rN(tJ, {
                        activeBrand: s,
                        brands: a.brands,
                        excludedUIBrands: FI,
                        isPaymentMethodSelected: n,
                        isCompactView: a.props.showBrandsUnderCardNumber
                    })), rN("div", {
                        className: "adyen-checkout__payment-method__details ".concat(ZZ["adyen-checkout__payment-method__details"]),
                        id: h,
                        role: "region"
                    }, m && rN(XZ, {
                        id: f,
                        open: this.state.showDisableStoredPaymentMethodConfirmation,
                        onDisable: this.onDisableStoredPaymentMethod,
                        onCancel: this.toggleDisableConfirmation
                    }), rN(QZ, {
                        paymentMethodComponent: a.render(),
                        isLoaded: i
                    })));
                }
            }
        ]), r;
    }(oN);
    Sg(iJ, "defaultProps", {
        paymentMethod: null,
        isSelected: !1,
        isLoaded: !1,
        isLoading: !1,
        showDisableStoredPaymentMethodConfirmation: !1
    });
    var lJ = function(e) {
        var t, r = e.order, a = e.orderStatus, n = e.onOrderCancel, o = e.brandLogoConfiguration, i = zP().i18n, l = tI();
        return rN("div", null, rN("ul", {
            className: "adyen-checkout__order-payment-methods-list"
        }, null == a || null === (t = a.paymentMethods) || void 0 === t ? void 0 : hC(t).call(t, function(e, t) {
            var a;
            return rN("li", {
                key: wb(a = "".concat(e.type, "-")).call(a, t),
                className: "adyen-checkout__order-payment-method"
            }, rN("div", {
                className: "adyen-checkout__order-payment-method__header"
            }, rN("div", {
                className: "adyen-checkout__payment-method__header__title"
            }, rN($Z, {
                altDescription: e.name,
                type: e.type,
                src: o[e.type] || l()(e.type)
            }), "\u2022\u2022\u2022\u2022 ", e.lastFour), n && rN("button", {
                type: "button",
                className: "adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link",
                onClick: function() {
                    n({
                        order: r
                    });
                }
            }, i.get("storedPaymentMethod.disable.button"))), rN("div", {
                className: "adyen-checkout__order-payment-method__details"
            }, rN("div", {
                className: "adyen-checkout__order-payment-method__deducted-amount"
            }, rN("div", {
                className: "adyen-checkout__order-payment-method__deducted-amount__label"
            }, i.get("deductedBalance")), rN("div", {
                className: "adyen-checkout__order-payment-method__deducted-amount__value"
            }, i.amount(e.amount.value, e.amount.currency)))));
        })), a.remainingAmount && rN("div", {
            className: "adyen-checkout__order-remaining-amount"
        }, i.get("partialPayment.warning"), " ", rN("strong", null, i.amount(a.remainingAmount.value, a.remainingAmount.currency))));
    };
    function cJ(e) {
        var t = e.paymentMethods, r = zP().i18n;
        return rN(nN, null, rN("ul", {
            className: "adyen-checkout__instant-payment-methods-list"
        }, hC(t).call(t, function(e) {
            return rN("li", {
                key: e.type
            }, e.render());
        })), rN(cB, {
            label: r.get("orPayWith")
        }));
    }
    function sJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function uJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = sJ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = sJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function dJ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var pJ = function(e) {
        L_(r, e);
        var t = dJ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    if (this.props.paymentMethods[0]) {
                        var e = this.props.paymentMethods[0];
                        (this.props.openFirstStoredPaymentMethod && !0 === AN(e, "props.oneClick") || this.props.openFirstPaymentMethod) && this.props.onSelect(e);
                    }
                }
            },
            {
                key: "render",
                value: function(e) {
                    var t = this, r = e.paymentMethods, a = e.instantPaymentMethods, n = e.activePaymentMethod, o = e.cachedPaymentMethods, i = e.isLoading, l = e.isDisablingPaymentMethod, c = zP().i18n, s = aP(Sg(Sg(Sg({}, ZZ["adyen-checkout__payment-methods-list"], !0), "adyen-checkout__payment-methods-list", !0), "adyen-checkout__payment-methods-list--loading", i)), u = function(e) {
                        var t = Vk(fP({}), 2), r = t[0], a = t[1];
                        return vP(function() {
                            a(tC(e).call(e, function(e, t) {
                                return uJ(uJ({}, e), t.props.brand && t.icon && Sg({}, t.props.brand, t.icon));
                            }, {}));
                        }, [
                            e
                        ]), r;
                    }(r);
                    return rN(nN, null, this.props.orderStatus && rN(lJ, {
                        order: this.props.order,
                        orderStatus: this.props.orderStatus,
                        onOrderCancel: this.props.onOrderCancel,
                        brandLogoConfiguration: u
                    }), !!a.length && rN(cJ, {
                        paymentMethods: a
                    }), rN("ul", {
                        className: s,
                        role: "radiogroup",
                        "aria-label": c.get("paymentMethodsList.aria.label"),
                        required: !0
                    }, hC(r).call(r, function(e, a, c) {
                        var s = n && n._id === e._id, u = e._id in o, d = n && c[a + 1] && n._id === c[a + 1]._id;
                        return rN(iJ, {
                            className: aP({
                                "adyen-checkout__payment-method--next-selected": d
                            }),
                            standalone: 1 === r.length,
                            paymentMethod: e,
                            isSelected: s,
                            isDisablingPaymentMethod: s && l,
                            isLoaded: u,
                            isLoading: i,
                            onSelect: t.props.onSelect,
                            key: e._id,
                            showRemovePaymentMethodButton: t.props.showRemovePaymentMethodButton,
                            onDisableStoredPaymentMethod: t.props.onDisableStoredPaymentMethod
                        });
                    })));
                }
            }
        ]), r;
    }(oN);
    Sg(pJ, "defaultProps", {
        instantPaymentMethods: [],
        paymentMethods: [],
        activePaymentMethod: null,
        cachedPaymentMethods: {},
        orderStatus: null,
        onSelect: function() {},
        onDisableStoredPaymentMethod: function() {},
        isDisablingPaymentMethod: !1,
        isLoading: !1
    });
    var mJ = function(e) {
        var t = e.message, r = zP().i18n, a = tI(), n = r.get(t || "creditCard.success");
        return cQ(n), rN("div", {
            className: "adyen-checkout__status adyen-checkout__status--success"
        }, rN(ST, {
            height: "88",
            className: "adyen-checkout__status__icon",
            src: a({
                extension: "gif",
                imageFolder: "components/"
            })("success"),
            alt: r.get(t || "creditCard.success")
        }), rN("span", {
            className: "adyen-checkout__status__text"
        }, n));
    }, fJ = function(e) {
        var t = e.message, r = zP().i18n, a = tI(), n = r.get(t || "error.message.unknown");
        return cQ(n), rN("div", {
            className: "adyen-checkout__status adyen-checkout__status--error"
        }, rN(ST, {
            className: "adyen-checkout__status__icon",
            src: a({
                extension: "gif",
                imageFolder: "components/"
            })("error"),
            alt: r.get(t || "error.message.unknown"),
            height: "88"
        }), rN("span", {
            className: "adyen-checkout__status__text"
        }, n));
    };
    function hJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function vJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = hJ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = hJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function yJ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var gJ = function(e) {
        L_(r, e);
        var t = yJ(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "state", {
                elements: [],
                instantPaymentElements: [],
                orderStatus: null,
                isDisabling: !1,
                status: {
                    type: "loading",
                    props: void 0
                },
                activePaymentMethod: null,
                cachedPaymentMethods: {}
            }), Sg(B_(a), "prepareDropinData", function() {
                var e = a.props, t = e.order, r = e.clientKey, n = e.loadingContext, o = Vk(a.props.onCreateElements(), 3), i = o[0], l = o[1], c = o[2], s = t ? function(e, t) {
                    return cT({
                        path: "v1/order/status?clientKey=".concat(e.clientKey),
                        loadingContext: e.loadingContext
                    }, {
                        orderData: t.orderData
                    });
                }({
                    clientKey: r,
                    loadingContext: n
                }, t) : null;
                Sb.all([
                    i,
                    l,
                    c,
                    s
                ]).then(function(e) {
                    var t, r = Vk(e, 4), n = r[0], o = r[1], i = r[2], l = r[3];
                    a.setState({
                        instantPaymentElements: i,
                        elements: wb(t = []).call(t, Uk(n), Uk(o)),
                        orderStatus: l
                    }), a.setStatus("ready"), a.props.modules.analytics && a.props.modules.analytics.send({
                        containerWidth: a.base && a.base.offsetWidth,
                        paymentMethods: hC(o).call(o, function(e) {
                            return e.props.type;
                        }),
                        component: "dropin",
                        flavor: "dropin"
                    });
                }), a.onOrderCancel = a.getOnOrderCancel();
            }), Sg(B_(a), "setStatus", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                a.setState({
                    status: {
                        type: e,
                        props: t
                    }
                });
            }), Sg(B_(a), "setActivePaymentMethod", function(e) {
                a.setState(function(t) {
                    return {
                        activePaymentMethod: e,
                        cachedPaymentMethods: vJ(vJ({}, t.cachedPaymentMethods), {}, Sg({}, e._id, !0))
                    };
                });
            }), Sg(B_(a), "handleOnSelectPaymentMethod", function(e) {
                var t = a.state.activePaymentMethod;
                a.setActivePaymentMethod(e), (t && t._id !== e._id || !t) && a.props.onSelect(e);
            }), Sg(B_(a), "handleDisableStoredPaymentMethod", function(e) {
                a.setState({
                    isDisabling: !0
                }), new Sb(function(t, r) {
                    return a.props.onDisableStoredPaymentMethod(e.props.storedPaymentMethodId, t, r);
                }).then(function() {
                    a.setState(function(t) {
                        var r;
                        return {
                            elements: Fg(r = t.elements).call(r, function(t) {
                                return t._id !== e._id;
                            })
                        };
                    }), a.setState({
                        isDisabling: !1
                    });
                }).catch(function() {
                    a.setState({
                        isDisabling: !1
                    });
                });
            }), Sg(B_(a), "getOnOrderCancel", function() {
                return a.props.onOrderCancel ? function(e) {
                    a.props.onOrderCancel(e);
                } : a.props.session ? function(e) {
                    return a.props.session.cancelOrder(e).then(function() {
                        return a.props._parentInstance.update({
                            order: null
                        });
                    }).catch(function(e) {
                        return a.setStatus((null == e ? void 0 : e.message) || "error");
                    });
                } : null;
            }), Sg(B_(a), "onOrderCancel", void 0), a;
        }
        return wg(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.prepareDropinData();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    t.status.type !== this.state.status.type && this.state.activePaymentMethod && this.state.activePaymentMethod.setStatus(this.state.status.type), "ready" === this.state.status.type && "ready" !== t.status.type && this.props.onReady && this.props.onReady();
                }
            },
            {
                key: "closeActivePaymentMethod",
                value: function() {
                    this.setState({
                        activePaymentMethod: null
                    });
                }
            },
            {
                key: "render",
                value: function(e, t) {
                    var r, a, n, o, i = t.elements, l = t.instantPaymentElements, c = t.status, s = t.activePaymentMethod, u = t.cachedPaymentMethods, d = "loading" === c.type, p = "redirect" === c.type;
                    switch(c.type){
                        case "success":
                            return rN(mJ, {
                                message: 0 === (null == e || null === (r = e.amount) || void 0 === r ? void 0 : r.value) ? "resultMessages.preauthorized" : null === (a = c.props) || void 0 === a ? void 0 : a.message
                            });
                        case "error":
                            return rN(fJ, {
                                message: null === (n = c.props) || void 0 === n ? void 0 : n.message
                            });
                        case "custom":
                            return null === (o = c.props) || void 0 === o || null === (o = o.component) || void 0 === o ? void 0 : o.render();
                        default:
                            return rN("div", {
                                className: "adyen-checkout__dropin adyen-checkout__dropin--".concat(c.type)
                            }, p && c.props.component && c.props.component.render(), d && c.props && c.props.component && c.props.component.render(), i && !!i.length && rN(pJ, {
                                isLoading: d || p,
                                isDisablingPaymentMethod: this.state.isDisabling,
                                paymentMethods: i,
                                instantPaymentMethods: l,
                                activePaymentMethod: s,
                                cachedPaymentMethods: u,
                                order: this.props.order,
                                orderStatus: this.state.orderStatus,
                                onOrderCancel: this.onOrderCancel,
                                onSelect: this.handleOnSelectPaymentMethod,
                                openFirstPaymentMethod: this.props.openFirstPaymentMethod,
                                openFirstStoredPaymentMethod: this.props.openFirstStoredPaymentMethod,
                                onDisableStoredPaymentMethod: this.handleDisableStoredPaymentMethod,
                                showRemovePaymentMethodButton: this.props.showRemovePaymentMethodButton
                            }));
                    }
                }
            }
        ]), r;
    }(oN);
    var bJ = [
        "androidpay",
        "samsungpay",
        "clicktopay"
    ], kJ = function(e) {
        return !kb(bJ).call(bJ, e.constructor.type);
    }, CJ = function(e) {
        return !!e;
    }, _J = function(e) {
        if (e.isAvailable) {
            var t = new Sb(function(e, t) {
                return ZN(t, 5e3);
            });
            return Sb.race([
                e.isAvailable(),
                t
            ]);
        }
        return Sb.resolve(!!e);
    }, NJ = function() {
        var e, t, r, a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], n = arguments.length > 1 ? arguments[1] : void 0, o = arguments.length > 2 ? arguments[2] : void 0, i = Fg(e = Fg(t = hC(a).call(a, function(e) {
            return o(e, n);
        })).call(t, CJ)).call(e, kJ), l = hC(r = hC(i).call(i, _J)).call(r, function(e) {
            return e.catch(function(e) {
                return e;
            });
        });
        return Sb.all(l).then(function(e) {
            return Fg(i).call(i, function(t, r) {
                return !0 === e[r];
            });
        });
    };
    function PJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function wJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = PJ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = PJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function SJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function AJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = SJ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = SJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function IJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function DJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = IJ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = IJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function EJ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var RJ = [
        "paywithgoogle",
        "googlepay",
        "applepay"
    ], xJ = function(e) {
        L_(r, e);
        var t = EJ(r);
        function r(e) {
            var a, n, o;
            return Cg(this, r), Sg(B_(o = t.call(this, e)), "dropinRef", null), Sg(B_(o), "componentFromAction", void 0), Sg(B_(o), "handleCreate", function() {
                var e = o.props, t = e.paymentMethods, r = e.storedPaymentMethods, a = e.showStoredPaymentMethods, n = e.showPaymentMethods, i = e.instantPaymentMethods, l = function(e) {
                    return {
                        beforeSubmit: e.beforeSubmit,
                        onSubmit: e.onSubmit,
                        elementRef: e.elementRef,
                        showPayButton: e.showPayButton,
                        isDropin: !0
                    };
                }(DJ(DJ({}, o.props), {}, {
                    elementRef: o.elementRef
                })), c = a ? function() {
                    var e = arguments.length > 2 ? arguments[2] : void 0;
                    return NJ(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], wJ(wJ({}, arguments.length > 1 ? arguments[1] : void 0), {}, {
                        oneClick: !0
                    }), e);
                }(r, l, o._parentInstance.create) : [], s = n ? NJ(t, l, o._parentInstance.create) : [], u = function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 ? arguments[2] : void 0;
                    return e.length ? NJ(e, AJ(AJ({}, t), {}, {
                        isInstantPayment: !0,
                        showPayButton: !0
                    }), r) : [];
                }(i, l, o._parentInstance.create);
                return [
                    c,
                    s,
                    u
                ];
            }), Sg(B_(o), "handleOrder", function(e) {
                var t = e.order;
                o.updateParent({
                    order: t
                });
            }), o.submit = Jg(a = o.submit).call(a, B_(o)), o.handleAction = Jg(n = o.handleAction).call(n, B_(o)), o;
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t, a, n = Fg(t = OK(new YZ(e.instantPaymentTypes))).call(t, function(e) {
                        return kb(RJ).call(RJ, e);
                    }), o = tC(n).call(n, function(t, r) {
                        var a, n, o = zb(a = e.paymentMethods).call(a, function(e) {
                            return e.type === r;
                        });
                        return o ? wb(n = []).call(n, Uk(t), [
                            o
                        ]) : t;
                    }, []), i = Fg(a = e.paymentMethods).call(a, function(e) {
                        var t = e.type;
                        return !kb(n).call(n, t);
                    });
                    return DJ(DJ({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        instantPaymentTypes: n,
                        instantPaymentMethods: o,
                        paymentMethods: i
                    });
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.dropinRef && !!this.dropinRef.state.activePaymentMethod && !!this.dropinRef.state.activePaymentMethod.isValid;
                }
            },
            {
                key: "showValidation",
                value: function() {
                    return this.dropinRef.state.activePaymentMethod && this.dropinRef.state.activePaymentMethod.showValidation(), this;
                }
            },
            {
                key: "setStatus",
                value: function(e) {
                    var t, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return null === (t = this.dropinRef) || void 0 === t || t.setStatus(e, r), this;
                }
            },
            {
                key: "activePaymentMethod",
                get: function() {
                    var e, t;
                    return null !== (e = this.dropinRef) && void 0 !== e && e.state || null !== (t = this.dropinRef) && void 0 !== t && t.state.activePaymentMethod ? this.dropinRef.state.activePaymentMethod : null;
                }
            },
            {
                key: "data",
                get: function() {
                    return this.activePaymentMethod ? this.dropinRef.state.activePaymentMethod.data : null;
                }
            },
            {
                key: "submit",
                value: function() {
                    if (!this.activePaymentMethod) throw new Error("No active payment method.");
                    this.activePaymentMethod.submit();
                }
            },
            {
                key: "handleAction",
                value: function(e) {
                    var t, a, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (!e || !e.type) {
                        if (fA(e, "action") && fA(e, "resultCode")) throw new Error('handleAction::Invalid Action - the passed action object itself has an "action" property and a "resultCode": have you passed in the whole response object by mistake?');
                        throw new Error('handleAction::Invalid Action - the passed action object does not have a "type" property');
                    }
                    if ("redirect" !== e.type && null !== (t = this.activePaymentMethod) && void 0 !== t && t.updateWithAction) return this.activePaymentMethod.updateWithAction(e);
                    this.elementRef instanceof r && (n = DJ(DJ({}, null === (a = this.elementRef.activePaymentMethod) || void 0 === a ? void 0 : a.props), n));
                    var o = this._parentInstance.createFromAction(e, DJ(DJ({}, n), {}, {
                        elementRef: this.elementRef,
                        onAdditionalDetails: this.handleAdditionalDetails,
                        isDropin: !0
                    }));
                    return o ? (this.setStatus(o.props.statusType, {
                        component: o
                    }), this.componentFromAction = o, this) : null;
                }
            },
            {
                key: "closeActivePaymentMethod",
                value: function() {
                    this.dropinRef.closeActivePaymentMethod();
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(qO, {
                        srPanel: this.props.modules.srPanel
                    }, rN(gJ, j_({}, this.props, {
                        onChange: this.setState,
                        elementRef: this.elementRef,
                        onCreateElements: this.handleCreate,
                        ref: function(t) {
                            e.dropinRef = t;
                        }
                    }))));
                }
            }
        ]), r;
    }(gA);
    Sg(xJ, "type", "dropin"), Sg(xJ, "defaultProps", {
        isDropin: !0,
        onReady: function() {},
        onComplete: function() {},
        onError: function() {},
        onSelect: function() {},
        onDisableStoredPaymentMethod: null,
        onChange: function() {},
        instantPaymentMethods: [],
        amount: {},
        installmentOptions: {},
        paymentMethodsConfiguration: {},
        openFirstPaymentMethod: !0,
        openFirstStoredPaymentMethod: !0,
        showStoredPaymentMethods: !0,
        showPaymentMethods: !0,
        showRemoveStoredPaymentMethodButton: !1,
        showPayButton: !0
    });
    var FJ = "AchInput-module_sf-input__wrapper__lfdiv", TJ = "AchInput-module_adyen-checkout__input__8WwCR", zJ = function(e) {
        var t = e.id, r = e.dataInfo, a = e.className, n = void 0 === a ? "" : a, o = e.label, i = e.focused, l = e.filled, c = e.errorMessage, s = void 0 === c ? "" : c, u = e.isValid, d = void 0 !== u && u, p = e.onFocusField, m = e.dir, f = t.charAt(0).toUpperCase() + xA(t).call(t, 1), h = "encrypted".concat(f);
        return rN(oD, {
            label: o,
            focused: i,
            filled: l,
            classNameModifiers: [
                t
            ],
            onFocusField: function() {
                return p(h);
            },
            errorMessage: s,
            isValid: d,
            className: n,
            dir: m,
            name: t,
            errorVisibleToScreenReader: !1
        }, rN(vK, {
            encryptedFieldType: h,
            "data-info": r,
            className: aP(Sg(Sg(Sg(Sg({
                "adyen-checkout__input": !0,
                "adyen-checkout__input--large": !0
            }, TJ, !0), "adyen-checkout__input--error", s.length), "adyen-checkout__input--focus", i), "adyen-checkout__input--valid", d))
        }));
    }, OJ = function(e) {
        var t = e.focusedElement, r = e.onFocusField, a = e.errors, n = e.valid, o = zP().i18n;
        return rN("div", {
            className: "adyen-checkout__ach-sf__form adyen-checkout__field-wrapper"
        }, rN(zJ, {
            id: "bankAccountNumber",
            focused: "encryptedBankAccountNumber" === t,
            isValid: !!n.encryptedBankAccountNumber,
            label: o.get("ach.accountNumberField.title"),
            onFocusField: r,
            filled: !!a.encryptedBankAccountNumber || !!n.encryptedBankAccountNumber,
            errorMessage: !!a.encryptedBankAccountNumber && o.get(a.encryptedBankAccountNumber),
            dataInfo: '{"length":"4-17"}',
            className: "adyen-checkout__field--50",
            dir: "ltr"
        }), rN(zJ, {
            id: "bankLocationId",
            focused: "encryptedBankLocationId" === t,
            isValid: !!n.encryptedBankLocationId,
            label: o.get("ach.accountLocationField.title"),
            onFocusField: r,
            filled: !!a.encryptedBankLocationId || !!n.encryptedBankLocationId,
            errorMessage: !!a.encryptedBankLocationId && o.get(a.encryptedBankLocationId),
            dataInfo: '{"length":9}',
            className: "adyen-checkout__field--50",
            dir: "ltr"
        }));
    }, jJ = {
        base: {
            caretColor: "#0075FF"
        }
    };
    function BJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function MJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = BJ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = BJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function LJ(e) {
        return !(arguments.length > 1 && void 0 !== arguments[1] && arguments[1]) || !!e && "string" == typeof e && tE(e).call(e).length > 0;
    }
    function VJ(e) {
        var t, r = this, a = zP().i18n, n = e.hasHolderName && (!!e.holderName || !!e.data.holderName), o = Vk(fP({}), 2), i = o[0], l = o[1], c = Vk(fP(MJ({}, e.holderNameRequired && {
            holderName: n
        })), 2), s = c[0], u = c[1], d = Vk(fP(MJ({}, e.hasHolderName && {
            holderName: e.holderName || e.data.holderName
        })), 2), p = d[0], m = d[1], f = Vk(fP(e.billingAddressRequired ? e.data.billingAddress : null), 2), h = f[0], v = f[1], y = Vk(fP(!1), 2), g = y[0], b = y[1], k = Vk(fP(""), 2), C = k[0], _ = k[1], N = Vk(fP(!1), 2), P = N[0], w = N[1], S = function(e) {
            v(MJ(MJ({}, h), e.data)), u(MJ(MJ({}, s), {}, {
                billingAddress: e.isValid
            }));
        }, A = function(t) {
            var r = t.target.value;
            m(MJ(MJ({}, p), {}, {
                holderName: r
            })), l(MJ(MJ({}, i), {}, {
                holderName: !!e.holderNameRequired && !LJ(r)
            })), u(MJ(MJ({}, s), {}, {
                holderName: !e.holderNameRequired || LJ(r, e.holderNameRequired)
            }));
        }, I = gP(null), D = gP(null), E = function(e) {
            D.current = e;
        }, R = Vk(fP("ready"), 2), x = R[0], F = R[1], T = gP({});
        Ty(T.current).length || null === (t = e.setComponentRef) || void 0 === t || t.call(e, T.current);
        return T.current.showValidation = function() {
            I.current.showValidation(), e.holderNameRequired && !s.holderName && l(MJ(MJ({}, i), {}, {
                holderName: !0
            })), D.current && D.current.showValidation();
        }, T.current.setStatus = F, vP(function() {
            return r.setFocusOn = I.current.setFocusOn, r.updateStyles = I.current.updateStyles, function() {
                I.current.destroy();
            };
        }, []), vP(function() {
            var t = LJ(p.holderName, e.holderNameRequired), r = g, a = !e.billingAddressRequired || Boolean(s.billingAddress), n = r && t && a;
            e.onChange({
                data: p,
                isValid: n,
                billingAddress: h,
                storePaymentMethod: P
            });
        }, [
            p,
            s,
            i,
            P
        ]), rN("div", {
            className: "adyen-checkout__ach"
        }, e.showFormInstruction && rN(IO, null), rN(FU, j_({
            ref: I
        }, UJ(e), {
            styles: MJ(MJ({}, jJ), e.styles),
            onChange: function(t) {
                var r = t, a = r.autoCompleteName ? r.autoCompleteName : p.holderName;
                m(MJ(MJ(MJ({}, p), r.data), {}, {
                    holderName: a
                })), l(MJ(MJ({}, i), r.errors)), u(MJ(MJ(MJ({}, s), r.valid), {}, {
                    holderName: !e.holderNameRequired || LJ(a, e.holderNameRequired)
                })), b(r.isSfpValid);
            },
            onFocus: function(t) {
                var r = !0 === t.focus;
                _(t.currentFocusObject), r ? e.onFocus(t) : e.onBlur(t);
            },
            render: function(t, r) {
                var n = t.setRootNode, o = t.setFocusOn;
                return rN("div", {
                    ref: n,
                    className: "adyen-checkout__ach-input ".concat(FJ)
                }, rN(mK, {
                    status: r.status
                }, rN("div", {
                    className: aP([
                        "adyen-checkout__fieldset",
                        "adyen-checkout__fieldset--ach"
                    ])
                }, rN("div", {
                    className: "adyen-checkout__fieldset__title"
                }, a.get("ach.bankAccount")), e.hasHolderName && rN(oD, {
                    label: a.get("ach.accountHolderNameField.title"),
                    className: "adyen-checkout__pm__holderName",
                    errorMessage: !!i.holderName && a.get("ach.accountHolderNameField.invalid"),
                    isValid: !!s.holderName,
                    name: "holderName"
                }, rN(oE, {
                    className: "adyen-checkout__pm__holderName__input ".concat(TJ),
                    placeholder: e.placeholders.holderName || a.get("ach.accountHolderNameField.placeholder"),
                    value: p.holderName,
                    required: e.holderNameRequired,
                    onInput: A
                })), rN(OJ, {
                    focusedElement: C,
                    onFocusField: o,
                    errors: r.errors,
                    valid: r.valid
                })), e.billingAddressRequired && rN(cz, {
                    label: "billingAddress",
                    data: h,
                    onChange: S,
                    allowedCountries: e.billingAddressAllowedCountries,
                    requiredFields: e.billingAddressRequiredFields,
                    setComponentRef: E
                }), e.enableStoreDetails && rN(FK, {
                    onChange: w
                })));
            }
        })), e.showPayButton && e.payButton({
            status: x,
            label: a.get("confirmPurchase")
        }));
    }
    VJ.defaultProps = {
        type: "ach",
        hasHolderName: !0,
        holderNameRequired: !0,
        billingAddressRequired: !0,
        billingAddressAllowedCountries: [
            "US",
            "PR"
        ],
        showFormInstruction: !0,
        onLoad: function() {},
        onConfigSuccess: function() {},
        onAllValid: function() {},
        onFieldValid: function() {},
        onError: function() {},
        onBlur: function() {},
        onFocus: function() {},
        onChange: function() {},
        holderName: "",
        data: {
            holderName: "",
            billingAddress: {}
        },
        styles: {},
        placeholders: {}
    };
    var UJ = function(e) {
        return {
            allowedDOMAccess: e.allowedDOMAccess,
            autoFocus: e.autoFocus,
            clientKey: e.clientKey,
            i18n: e.i18n,
            keypadFix: e.keypadFix,
            legacyInputMode: e.legacyInputMode,
            loadingContext: e.loadingContext,
            onAllValid: e.onAllValid,
            onConfigSuccess: e.onConfigSuccess,
            onError: e.onError,
            onFieldValid: e.onFieldValid,
            onFocus: e.onFocus,
            onLoad: e.onLoad,
            showWarnings: e.showWarnings,
            styles: e.styles,
            type: e.type,
            forceCompat: e.forceCompat,
            resources: e.resources
        };
    };
    function KJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function HJ(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = KJ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = KJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function qJ(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var WJ = function(e) {
        L_(r, e);
        var t = qJ(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t;
                    return HJ(HJ({}, e), {}, {
                        holderNameRequired: null !== (t = e.hasHolderName) && void 0 !== t ? t : e.holderNameRequired
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e, t = !!this.props.storedPaymentMethodId, a = HJ(HJ({
                        type: r.type
                    }, this.state.data), {}, {
                        ownerName: null === (e = this.state.data) || void 0 === e ? void 0 : e.holderName
                    }, t && {
                        storedPaymentMethodId: this.props.storedPaymentMethodId
                    });
                    return delete a.holderName, HJ(HJ({
                        paymentMethod: a
                    }, this.state.billingAddress && {
                        billingAddress: this.state.billingAddress
                    }), this.state.storePaymentMethod && {
                        storePaymentMethod: this.state.storePaymentMethod
                    });
                }
            },
            {
                key: "updateStyles",
                value: function(e) {
                    return this.componentRef && this.componentRef.updateStyles && this.componentRef.updateStyles(e), this;
                }
            },
            {
                key: "setFocusOn",
                value: function(e) {
                    return this.componentRef && this.componentRef.setFocusOn && this.componentRef.setFocusOn(e), this;
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.props.storedPaymentMethodId || !!this.state.isValid;
                }
            },
            {
                key: "displayName",
                get: function() {
                    var e;
                    return this.props.storedPaymentMethodId && this.props.bankAccountNumber ? "\u2022\u2022\u2022\u2022 ".concat(xA(e = this.props.bankAccountNumber).call(e, -4)) : this.props.name;
                }
            },
            {
                key: "additionalInfo",
                get: function() {
                    return this.props.storedPaymentMethodId ? this.props.i18n.get("ach.savedBankAccount") : "";
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.storedPaymentMethodId ? rN(TL, {
                        name: this.displayName,
                        amount: this.props.amount,
                        payButton: this.payButton,
                        onSubmit: this.submit,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }) : rN(VJ, j_({
                        setComponentRef: this.setComponentRef
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        resources: this.resources
                    })));
                }
            }
        ]), r;
    }(gA);
    Sg(WJ, "type", "ach");
    var GJ = /\b(2\d{1}|(9(3|6|2|1)))\d{7}\b/, YJ = /^(\d){4,}$/, QJ = {
        phoneNumber: {
            modes: [
                "blur"
            ],
            validate: function(e, t) {
                var r = "+351" === t.state.data.phonePrefix ? GJ : YJ;
                return bD(e) ? null : r.test(e);
            },
            errorMessage: "invalidPhoneNumber"
        },
        phonePrefix: {
            modes: [
                "blur"
            ],
            validate: function(e) {
                return !!e;
            },
            errorMessage: "invalidCountryCode"
        }
    }, ZJ = {
        phoneNumber: {
            formatterFn: function(e) {
                return e.replace(CD("^\\d", "g"), "");
            }
        }
    };
    function JJ(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function $J(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = JJ(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = JJ(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function XJ(e) {
        var t, r, a, n, o, i, l = zP().i18n, c = e.requiredFields || wb(t = []).call(t, Uk(null != e && null !== (r = e.items) && void 0 !== r && r.length ? [
            "phonePrefix"
        ] : []), [
            "phoneNumber"
        ]), s = kb(c).call(c, "phonePrefix") && !(null == e || null === (a = e.items) || void 0 === a || !a.length), u = kb(c).call(c, "phoneNumber"), d = QD($J($J({
            i18n: l
        }, e), {}, {
            schema: c,
            defaultData: e.data,
            rules: QJ,
            formatters: ZJ
        })), p = d.handleChangeFor, m = d.data, f = d.valid, h = d.errors, v = d.isValid, y = d.triggerValidation, g = d.setSchema;
        vP(function() {
            g(c);
        }, [
            c.toString()
        ]), vP(function() {
            m.phoneNumber && p("phoneNumber", "blur")(m.phoneNumber);
        }, [
            m.phonePrefix
        ]), vP(function() {
            e.onChange({
                data: m,
                valid: f,
                errors: h,
                isValid: v
            });
        }, [
            m,
            f,
            h,
            v
        ]), this.triggerValidation = y;
        var b = function() {
            var e = document.querySelector(".adyen-checkout-phone-input--new [uniqueid]");
            return e ? e.getAttribute("uniqueid") : null;
        }, k = kP(function(t) {
            if (h[t]) {
                var r = "phoneNumber" === t ? "phoneNumberErrorKey" : "phonePrefixErrorKey", a = e[r] ? e[r] : h[t].errorMessage, n = l.get(a);
                return n || null;
            }
            return null;
        }, [
            h
        ]), C = bP(function() {
            return rD("adyen-checkout-phonePrefix");
        }, []), _ = (h.phoneNumber || h.phonePrefix) && !0;
        return rN("div", {
            className: "adyen-checkout-phone-input--new"
        }, rN("label", {
            htmlFor: b()
        }, rN("span", {
            className: aP({
                "adyen-checkout__label__text": !0,
                "adyen-checkout__label__text--error": _
            })
        }, e.phoneNumberKey ? l.get(e.phoneNumberKey) : l.get("telephoneNumber"))), rN(oD, {
            name: "phoneNumber",
            className: aP({
                "adyen-checkout-field": !0,
                "adyen-checkout-field--phone-input": !0
            }),
            inputWrapperModifiers: [
                "phone-input"
            ],
            isValid: f.phoneNumber,
            errorMessage: _,
            showValidIcon: !h.phonePrefix
        }, rN("div", {
            className: aP({
                "adyen-checkout__input": !0,
                "adyen-checkout__input--invalid": !!h.phoneNumber || !!h.phonePrefix,
                "adyen-checkout__input--valid": (!s || f.phonePrefix) && f.phoneNumber,
                "adyen-checkout-input": !0,
                "adyen-checkout-input-holder--phone-input": !0
            })
        }, s && rN(OT, {
            className: "adyen-checkout-dropdown adyen-checkout-dropdown--countrycode-selector",
            items: e.items,
            onChange: p("phonePrefix"),
            placeholder: l.get("infix"),
            selectedValue: m.phonePrefix,
            uniqueId: C
        }), u && rN("div", {
            className: "adyen-checkout-phone-number"
        }, rN("input", {
            id: b(),
            type: "tel",
            value: m.phoneNumber,
            onInput: p("phoneNumber", "input"),
            onBlur: p("phoneNumber", "blur"),
            placeholder: e.placeholders.phoneNumber || "123456789",
            className: "adyen-checkout__input adyen-checkout-input adyen-checkout-input--phone-number",
            autoCorrect: "off",
            "aria-required": !0,
            "aria-label": e.phoneNumberKey ? l.get(e.phoneNumberKey) : l.get("telephoneNumber"),
            "aria-invalid": !f.phoneNumber,
            "aria-describedby": wb(n = "".concat(b())).call(n, zI)
        })))), rN("div", {
            className: "adyen-checkout-phone-input__error-holder"
        }, s && k("phonePrefix") && rN("span", {
            className: "adyen-checkout__error-text",
            "aria-live": "polite",
            id: wb(o = "".concat(C)).call(o, zI)
        }, k("phonePrefix")), u && k("phoneNumber") && rN("span", {
            className: "adyen-checkout__error-text",
            "aria-live": "polite",
            id: wb(i = "".concat(b())).call(i, zI)
        }, k("phoneNumber"))));
    }
    function e$(e) {
        var t, r = zP(), a = r.i18n, n = r.loadingContext, o = gP(null), i = e.allowedCountries, l = void 0 === i ? [] : i, c = Vk(fP("ready"), 2), s = c[0], u = c[1];
        this.setStatus = u, this.showValidation = null == o || null === (t = o.current) || void 0 === t ? void 0 : t.triggerValidation;
        var d = function(e) {
            var t = e.allowedCountries, r = e.loadingContext, a = e.handleError, n = Vk(fP("loading"), 2), o = n[0], i = n[1], l = Vk(fP([]), 2), c = l[0], s = l[1];
            return yP(function() {
                sT("phonenumbers", r).then(function(e) {
                    var r = t.length ? Fg(e).call(e, function(e) {
                        return kb(t).call(t, e.id);
                    }) : e, a = hC(r).call(r, function(e) {
                        var t, r, a, n, o = hC(t = e.id.toUpperCase().split("")).call(t, function(e) {
                            return 127397 + e.charCodeAt(0);
                        }), i = BG ? BG.apply(String, Uk(o)) + "\xa0\xa0" : "";
                        return {
                            id: e.prefix,
                            name: wb(r = wb(a = "".concat(i, " ")).call(a, e.prefix, " (")).call(r, e.id, ")"),
                            selectedOptionName: wb(n = "".concat(i, " ")).call(n, e.prefix)
                        };
                    });
                    s(a || []), i("ready");
                }).catch(function(e) {
                    s([]), i("ready"), null == a || a(new mA("ERROR", e));
                });
            }, []), {
                phonePrefixes: c,
                loadingStatus: o
            };
        }({
            allowedCountries: l,
            loadingContext: n,
            handleError: e.onError
        }), p = d.loadingStatus, m = d.phonePrefixes;
        return rN(mK, {
            status: p
        }, rN("div", {
            className: "adyen-checkout__mb-way"
        }, rN(XJ, j_({}, e, {
            items: m,
            ref: o,
            onChange: function(t) {
                var r = t.data, a = t.valid, n = t.errors, o = t.isValid;
                e.onChange({
                    data: r,
                    valid: a,
                    errors: n,
                    isValid: o
                });
            },
            data: e.data
        })), e.showPayButton && e.payButton({
            status: s,
            label: a.get("confirmPurchase")
        })));
    }
    XJ.defaultProps = {
        phoneLabel: "telephoneNumber"
    }, e$.defaultProps = {
        onChange: function() {},
        phoneNumberKey: "mobileNumber",
        phoneNumberErrorKey: "mobileNumber.invalid"
    };
    var t$ = 2e3, r$ = 15, a$ = 6e4, n$ = 1e4, o$ = "mbway", i$ = "mbway.confirmPayment", l$ = "await.waitForConfirmation", c$ = !1, s$ = [
        "message"
    ];
    function u$(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function d$(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = u$(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = u$(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function p$(e) {
        var t, r = this, a = zP(), n = a.i18n, o = a.loadingContext, i = tI(), l = Vk(fP(!1), 2), c = l[0], s = l[1], u = Vk(fP(!1), 2), d = u[0], p = u[1], m = Vk(fP(!0), 2), f = m[0], h = m[1], v = Vk(fP(!1), 2), y = v[0], g = v[1], b = Vk(fP(e.delay), 2), k = b[0], C = b[1], _ = Vk(fP(100), 2), N = _[0], P = _[1], w = Vk(fP(0), 2), S = w[0], A = w[1], I = Vk(fP(!1), 2), D = I[0], E = I[1], R = Vk(fP(null), 2), x = R[0], F = R[1], T = function() {
            var t = e.paymentData, a = e.clientKey, i = e.throttleInterval;
            y || (e.onActionHandled({
                componentType: e.type,
                actionDescription: "polling-started"
            }), g(!0)), aQ(t, a, o, i).then(lQ).catch(function(e) {
                var t = e.message, r = kg(e, s$);
                return {
                    type: "network-error",
                    props: d$(d$({}, t && {
                        message: n.get(t)
                    }), r)
                };
            }).then(function(t) {
                switch(t.type){
                    case "success":
                        !function(t) {
                            if (t.props.payload) {
                                s(!0);
                                var a = {
                                    data: {
                                        details: {
                                            payload: t.props.payload
                                        },
                                        paymentData: e.paymentData
                                    }
                                };
                                return e.onComplete(a, r);
                            }
                            p(!0), e.onError(new mA("ERROR", "successful result, but no payload in response"));
                        }(t);
                        break;
                    case "error":
                        !function(t) {
                            if (p(!0), t.props.payload) {
                                var a = {
                                    data: {
                                        details: {
                                            payload: t.props.payload
                                        },
                                        paymentData: e.paymentData
                                    }
                                };
                                return e.onComplete(a, r);
                            }
                            e.onError(new mA("ERROR", "error result with no payload in response"));
                        }(t);
                        break;
                    default:
                        h(!1);
                }
            });
        };
        vP(function() {
            return T(), function() {
                clearTimeout(x);
            };
        }, []), vP(function() {
            if (d) return clearTimeout(x);
            if (c) return clearTimeout(x);
            if (!f) F(ZN(function() {
                T();
                var t = S + k;
                A(t), t >= e.throttleTime && !D && (C(e.throttleInterval), E(!0));
            }, k));
        }, [
            f,
            d,
            c,
            S
        ]);
        var z = function(e, t) {
            return rN("div", {
                className: "adyen-checkout__await adyen-checkout__await--result"
            }, rN("img", {
                className: "adyen-checkout__await__icon adyen-checkout__await__icon--result",
                src: i({
                    imageFolder: "components/"
                })(e),
                alt: n.get(t)
            }), rN("div", {
                className: "adyen-checkout__await__subtitle adyen-checkout__await__subtitle--result"
            }, n.get(t)));
        };
        if (d) return z("error", "error.subtitle.payment");
        if (c) return z("success", "creditCard.success");
        if (f) return rN("div", {
            className: "adyen-checkout__await"
        }, e.brandLogo && rN("img", {
            src: e.brandLogo,
            alt: e.type,
            className: "adyen-checkout__await__brand-logo"
        }), rN(nP, {
            inline: !1,
            size: "large"
        }));
        var O = n.get("wechatpay.timetopay").split("%@");
        return rN("div", {
            className: aP("adyen-checkout__await", "adyen-checkout__await--".concat(e.type), hC(t = e.classNameModifiers).call(t, function(e) {
                return "adyen-checkout__await--".concat(e);
            }))
        }, e.brandLogo && rN("img", {
            src: e.brandLogo,
            alt: e.type,
            className: "adyen-checkout__await__brand-logo"
        }), rN("div", {
            className: "adyen-checkout__await__subtitle"
        }, e.messageText), rN("div", {
            className: "adyen-checkout__await__indicator-holder"
        }, rN("div", {
            className: "adyen-checkout__await__indicator-spinner"
        }, rN(nP, {
            inline: !1,
            size: "medium"
        })), rN("div", {
            className: "adyen-checkout__await__indicator-text"
        }, e.awaitText)), e.showCountdownTimer && rN("div", {
            className: "adyen-checkout__await__countdown-holder"
        }, rN("div", {
            className: "adyen-checkout__await__progress"
        }, rN("span", {
            className: "adyen-checkout__await__percentage",
            style: {
                width: "".concat(N, "%")
            }
        })), rN("div", {
            className: "adyen-checkout__await__countdown"
        }, O[0], "\xa0", rN(rQ, {
            minutesFromNow: e.countdownTime,
            onTick: function(e) {
                P(e.percentage);
            },
            onCompleted: function() {
                p(!0), clearTimeout(x), e.onError(new mA("ERROR", "Payment Expired"));
            }
        }), "\xa0", O[1])), e.url && rN("div", {
            className: "adyen-checkout__await__app-link"
        }, rN(cB, null), rN(jP, {
            classNameModifiers: [
                "await"
            ],
            onClick: function() {
                return function(e) {
                    window.location.assign(e);
                }(e.url);
            },
            label: n.get("openApp")
        })));
    }
    function m$(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function f$(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = m$(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = m$(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function h$(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    p$.defaultProps = {
        countdownTime: 15,
        onError: function() {},
        onComplete: function() {},
        onActionHandled: function() {},
        delay: 2e3,
        throttleTime: 6e4,
        throttleInterval: 1e4,
        showCountdownTimer: !0,
        classNameModifiers: [],
        url: null
    };
    var v$ = function(e) {
        L_(r, e);
        var t = h$(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t = e.data, r = void 0 === t ? {} : t, a = e.placeholders, n = void 0 === a ? {} : a;
                    return f$(f$({}, e), {}, {
                        data: {
                            phoneNumber: r.telephoneNumber || r.phoneNumber,
                            phonePrefix: r.phonePrefix || "+351"
                        },
                        placeholders: {
                            phoneNumber: n.telephoneNumber || n.phoneNumber || "932123456"
                        }
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e;
                    return {
                        paymentMethod: f$({
                            type: r.type
                        }, (null === (e = this.state.data) || void 0 === e ? void 0 : e.phoneNumber) && {
                            telephoneNumber: this.state.data.phonePrefix + this.state.data.phoneNumber
                        })
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "displayName",
                get: function() {
                    return this.props.name;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.paymentData ? rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(qO, {
                        srPanel: this.props.modules.srPanel
                    }, rN(p$, {
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        clientKey: this.props.clientKey,
                        paymentData: this.props.paymentData,
                        onError: this.props.onError,
                        onComplete: this.onComplete,
                        brandLogo: this.icon,
                        type: o$,
                        messageText: this.props.i18n.get(i$),
                        awaitText: this.props.i18n.get(l$),
                        showCountdownTimer: c$,
                        delay: t$,
                        countdownTime: r$,
                        throttleTime: a$,
                        throttleInterval: n$,
                        onActionHandled: this.props.onActionHandled
                    }))) : rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(e$, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(gA);
    Sg(v$, "type", "mbway");
    var y$ = function(e) {
        return e.replace(/[^0-9]/g, "");
    };
    function g$(e) {
        var t = this, r = zP().i18n, a = tI(), n = QD({
            schema: [
                "blikCode"
            ],
            rules: {
                blikCode: {
                    validate: function(e) {
                        return 6 === (null == e ? void 0 : e.length);
                    },
                    errorMessage: "blik.invalid",
                    modes: [
                        "blur"
                    ]
                }
            },
            formatters: {
                blikCode: y$
            }
        }), o = n.handleChangeFor, i = n.triggerValidation, l = n.data, c = n.valid, s = n.errors, u = n.isValid;
        vP(function() {
            e.onChange({
                data: l,
                errors: s,
                valid: c,
                isValid: u
            }, t);
        }, [
            l,
            c,
            s,
            u
        ]);
        var d = Vk(fP("ready"), 2), p = d[0], m = d[1];
        return this.setStatus = m, this.showValidation = i, rN("div", {
            className: "adyen-checkout__blik"
        }, rN("p", {
            className: "adyen-checkout__blik__helper"
        }, r.get("blik.help")), rN(oD, {
            errorMessage: !!s.blikCode && r.get(s.blikCode.errorMessage),
            label: r.get("blik.code"),
            classNameModifiers: [
                "blikCode",
                "50"
            ],
            isValid: c.blikCode,
            dir: "ltr",
            name: "blikCode"
        }, rN(oE, {
            value: l.blikCode,
            name: "blikCode",
            spellcheck: !1,
            required: !0,
            autocorrect: "off",
            autocomplete: "off",
            onInput: o("blikCode", "input"),
            onBlur: o("blikCode", "blur"),
            placeholder: "123456",
            inputMode: "numeric",
            maxLength: 6
        })), e.showPayButton && e.payButton({
            status: p,
            icon: a({
                imageFolder: "components/"
            })("lock")
        }));
    }
    g$.defaultProps = {
        data: {
            blikCode: ""
        }
    };
    var b$ = 2e3, k$ = 15, C$ = 6e4, _$ = 1e4, N$ = "blik", P$ = "blik.confirmPayment", w$ = "await.waitForConfirmation", S$ = !1;
    function A$(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function I$(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = A$(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = A$(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function D$(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var E$ = function(e) {
        L_(r, e);
        var t = D$(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatData",
                value: function() {
                    var e, t = !!this.props.storedPaymentMethodId;
                    return {
                        paymentMethod: I$(I$({
                            type: r.type
                        }, !t && {
                            blikCode: null === (e = this.state) || void 0 === e || null === (e = e.data) || void 0 === e ? void 0 : e.blikCode
                        }), t && {
                            storedPaymentMethodId: this.props.storedPaymentMethodId
                        })
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.props.storedPaymentMethodId || !!this.state.isValid;
                }
            },
            {
                key: "displayName",
                get: function() {
                    return this.props.storedPaymentMethodId && this.props.label ? this.props.label : this.props.name;
                }
            },
            {
                key: "additionalInfo",
                get: function() {
                    return this.props.storedPaymentMethodId && this.props.label ? this.props.name : null;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.paymentData ? rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(qO, {
                        srPanel: this.props.modules.srPanel
                    }, rN(p$, {
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        clientKey: this.props.clientKey,
                        paymentData: this.props.paymentData,
                        onError: this.handleError,
                        onComplete: this.onComplete,
                        brandLogo: this.icon,
                        type: N$,
                        messageText: this.props.i18n.get(P$),
                        awaitText: this.props.i18n.get(w$),
                        showCountdownTimer: S$,
                        delay: b$,
                        countdownTime: k$,
                        throttleTime: C$,
                        throttleInterval: _$,
                        onActionHandled: this.props.onActionHandled
                    }))) : rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.storedPaymentMethodId ? rN(TL, {
                        name: this.displayName,
                        amount: this.props.amount,
                        payButton: this.payButton,
                        onSubmit: this.submit,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }) : rN(g$, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        onChange: this.setState,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(gA);
    function R$(e) {
        var t = e.reference, r = e.totalAmount, a = e.paymentMethodType, n = zP().i18n, o = tI();
        return rN(IW, {
            paymentMethodType: a,
            introduction: n.get("bankTransfer.instructions"),
            imageUrl: o()(a),
            amount: r && n.amount(r.value, r.currency),
            voucherDetails: [
                {
                    label: n.get("bankTransfer.beneficiary"),
                    value: e.beneficiary
                },
                {
                    label: n.get("bankTransfer.iban"),
                    value: e.iban
                },
                {
                    label: n.get("bankTransfer.bic"),
                    value: e.bic
                },
                {
                    label: n.get("bankTransfer.reference"),
                    value: t
                }
            ]
        });
    }
    function x$(e) {
        var t = zP().i18n, r = Vk(fP(!1), 2), a = r[0], n = r[1], o = QD({
            schema: [],
            defaultData: e.data,
            rules: {
                shopperEmail: yE.shopperEmail
            }
        }), i = o.handleChangeFor, l = o.triggerValidation, c = o.data, s = o.valid, u = o.errors, d = o.isValid, p = o.setSchema;
        return vP(function() {
            p(a ? [
                "shopperEmail"
            ] : []);
        }, [
            a
        ]), this.showValidation = l, vP(function() {
            e.onChange({
                data: c,
                errors: u,
                valid: s,
                isValid: d
            });
        }, [
            c,
            s,
            u,
            a,
            d
        ]), rN("div", {
            className: "adyen-checkout__bankTransfer"
        }, rN("p", {
            className: "adyen-checkout__bankTransfer__introduction"
        }, t.get("bankTransfer.introduction")), rN(WQ, {
            classNames: "adyen-checkout__bankTransfer__emailField",
            value: c.shopperEmail,
            errors: u.shopperEmail,
            onToggle: function() {
                return n(!a);
            },
            onInput: i("shopperEmail", "input"),
            onBlur: i("shopperEmail", "blur")
        }));
    }
    function F$(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function T$(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(E$, "type", "blik");
    var z$ = function(e) {
        L_(r, e);
        var t = T$(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "state", {
                isValid: !a.props.showEmailAddress,
                data: {}
            }), Sg(B_(a), "handleRef", function(e) {
                a.componentRef = e;
            }), a;
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.data.shopperEmail;
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Ag(r = F$(Object(n), !0)).call(r, function(t) {
                                Sg(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Ag(a = F$(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        paymentMethod: {
                            type: r.type
                        }
                    }, e && {
                        shopperEmail: e
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    return this.props.reference ? rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(R$, j_({
                        ref: this.handleRef
                    }, this.props))) : rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.showEmailAddress && rN(x$, j_({
                        ref: this.handleRef
                    }, this.props, {
                        onChange: this.setState
                    })), this.props.showPayButton && rN(TL, j_({}, this.props, {
                        name: this.displayName,
                        onSubmit: this.submit,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(gA);
    Sg(z$, "type", "bankTransfer_IBAN"), Sg(z$, "defaultProps", {
        showPayButton: !0,
        showEmailAddress: !0
    });
    var O$ = [
        "CA",
        "US"
    ];
    function j$(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function B$(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = j$(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = j$(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function M$(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var L$ = function(e) {
        L_(r, e);
        var t = M$(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return B$(B$({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        allowedCountries: O$,
                        personalDetailsRequiredFields: [
                            "firstName",
                            "lastName",
                            "telephoneNumber",
                            "shopperEmail"
                        ]
                    });
                }
            }
        ]), r;
    }(QO);
    Sg(L$, "type", "affirm");
    var V$ = {
        socialSecurityNumber: {
            validate: MU,
            errorMessage: "",
            modes: [
                "blur"
            ]
        },
        default: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "",
            modes: [
                "blur"
            ]
        }
    }, U$ = {
        socialSecurityNumber: function(e) {
            return BU(e);
        }
    };
    function K$(e) {
        var t, r = e.name, a = e.data, n = e.personalDetailsRequired, o = e.showPayButton, i = void 0 !== o && o, l = e.onChange, c = e.payButton, s = zP().i18n, u = [
            "firstName",
            "lastName",
            "socialSecurityNumber"
        ], d = QD({
            schema: u,
            defaultData: a,
            rules: V$,
            formatters: U$
        }), p = d.handleChangeFor, m = d.triggerValidation, f = d.setSchema, h = d.data, v = d.valid, y = d.errors, g = d.isValid;
        vP(function() {
            var e, t = n ? wb(e = []).call(e, u) : [];
            f(t);
        }, [
            n
        ]);
        var b = Vk(fP("ready"), 2), k = b[0], C = b[1];
        this.setStatus = C, this.showValidation = function() {
            m();
        }, vP(function() {
            l({
                data: h,
                valid: v,
                errors: y,
                isValid: g
            });
        }, [
            l,
            h,
            v,
            y
        ]);
        var _ = n ? [] : [
            "standalone"
        ];
        return rN("div", {
            className: "adyen-checkout__pix-input__field",
            style: i || n ? null : {
                display: "none"
            }
        }, n && rN(GQ, {
            i18n: s,
            data: h,
            handleChangeFor: p,
            errors: y,
            valid: v
        }), i && c({
            status: k,
            label: wb(t = "".concat(s.get("continueTo"), " ")).call(t, r),
            classNameModifiers: _
        }));
    }
    function H$(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function q$(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = H$(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = H$(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function W$(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var G$ = function(e) {
        L_(r, e);
        var t = W$(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "formatProps",
                value: function(e) {
                    return q$({
                        copyBtn: !0,
                        introduction: "pix.instructions"
                    }, GA(U_(r.prototype), "formatProps", this).call(this, e));
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.data, t = void 0 === e ? {} : e, r = t.firstName, a = t.lastName, n = t.socialSecurityNumber, o = void 0 === n ? "" : n;
                    return q$(q$({
                        paymentMethod: {
                            type: this.props.type || this.constructor.type
                        }
                    }, r && a && {
                        shopperName: {
                            firstName: r,
                            lastName: a
                        }
                    }), o && {
                        socialSecurityNumber: jU(o)
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.paymentData ? this.renderQRCode() : rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(K$, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        showPayButton: this.props.showPayButton,
                        personalDetailsRequired: this.props.personalDetailsRequired,
                        name: this.displayName,
                        onChange: this.setState,
                        payButton: this.payButton
                    })));
                }
            }
        ]), r;
    }(fQ);
    Sg(G$, "type", "pix"), Sg(G$, "defaultProps", q$({
        showPayButton: !1,
        personalDetailsRequired: !1,
        countdownTime: 15,
        delay: 2e3
    }, fQ.defaultProps));
    var Y$ = /^(\d){1,8}$/, Q$ = /^(\d){6}$/, Z$ = {
        bankAccountNumber: {
            modes: [
                "blur",
                "input"
            ],
            validate: function(e) {
                return !!e && Y$.test(e);
            }
        },
        bankLocationId: [
            {
                modes: [
                    "input"
                ],
                validate: function(e) {
                    return !!e && /^(\d){1,6}$/.test(e);
                }
            },
            {
                modes: [
                    "blur"
                ],
                validate: function(e) {
                    return !!e && Q$.test(e);
                }
            }
        ],
        amountConsentCheckbox: {
            modes: [
                "blur"
            ],
            validate: function(e) {
                return !!e;
            }
        },
        accountConsentCheckbox: {
            modes: [
                "blur"
            ],
            validate: function(e) {
                return !!e;
            }
        },
        shopperEmail: yE.shopperEmail,
        default: {
            modes: [
                "blur"
            ],
            validate: function(e) {
                return !!e && e.length > 0;
            }
        }
    }, J$ = {
        bankAccountNumber: y$,
        bankLocationId: y$
    }, $$ = "enter-data", X$ = "confirm-data";
    function eX(e) {
        var t, r, a, n = this, o = zP().i18n, i = tI(), l = QD({
            schema: [
                "holderName",
                "bankAccountNumber",
                "bankLocationId",
                "shopperEmail",
                "amountConsentCheckbox",
                "accountConsentCheckbox"
            ],
            defaultData: e.data,
            formatters: J$,
            rules: Z$
        }), c = l.handleChangeFor, s = l.triggerValidation, u = l.data, d = l.valid, p = l.errors, m = l.isValid, f = Vk(fP($$), 2), h = f[0], v = f[1];
        this.setStatus = v, this.showValidation = s;
        return vP(function() {
            e.onChange({
                data: u,
                valid: d,
                errors: p,
                isValid: m
            });
        }, [
            u,
            d,
            p,
            m
        ]), rN("div", {
            className: aP({
                "adyen-checkout__bacs": !0,
                "adyen-checkout__bacs--confirm": h === X$ || "loading" === h
            })
        }, e.showFormInstruction && rN(IO, null), h == X$ && rN("div", {
            className: aP({
                "adyen-checkout__bacs--edit": !0,
                "adyen-checkout__bacs--edit-dropin": e.isDropin
            })
        }, rN(oE, {
            name: "bacsEdit",
            className: "adyen-checkout__bacs--edit-button",
            value: o.get("edit"),
            "aria-label": o.get("edit"),
            readonly: !0,
            onClick: function() {
                return n.setStatus($$);
            }
        })), rN(oD, {
            className: aP({
                "adyen-checkout__bacs--holder-name": !0,
                "adyen-checkout__field--inactive": h === X$ || "loading" === h
            }),
            label: o.get("bacs.accountHolderName"),
            errorMessage: !!p.holderName && o.get("bacs.accountHolderName.invalid"),
            isValid: d.holderName,
            name: "accountHolderName",
            i18n: o
        }, rN(oE, {
            name: "bacs.accountHolderName",
            className: "adyen-checkout__bacs-input--holder-name",
            placeholder: e.placeholders.holderName,
            value: u.holderName,
            "aria-invalid": !d.holderName,
            "aria-label": o.get("bacs.accountHolderName"),
            "aria-required": "true",
            required: !0,
            readonly: h === X$ || "loading" === h,
            autocorrect: "off",
            onBlur: c("holderName", "blur"),
            onInput: c("holderName", "input")
        })), rN("div", {
            className: "adyen-checkout__bacs__num-id adyen-checkout__field-wrapper"
        }, rN(oD, {
            errorMessage: !!p.bankAccountNumber && o.get("bacs.accountNumber.invalid"),
            label: o.get("bacs.accountNumber"),
            className: aP({
                "adyen-checkout__bacs--bank-account-number": !0,
                "adyen-checkout__field--inactive": h === X$ || "loading" === h
            }),
            classNameModifiers: [
                "col-70"
            ],
            isValid: d.bankAccountNumber,
            name: "bankAccountNumber",
            i18n: o
        }, rN(oE, {
            value: u.bankAccountNumber,
            className: "adyen-checkout__bacs-input--bank-account-number",
            placeholder: e.placeholders.bankAccountNumber,
            "aria-invalid": !d.bankAccountNumber,
            "aria-label": o.get("bacs.accountNumber"),
            "aria-required": "true",
            required: !0,
            readonly: h === X$ || "loading" === h,
            autocorrect: "off",
            onBlur: c("bankAccountNumber", "blur"),
            onInput: c("bankAccountNumber", "input")
        })), rN(oD, {
            errorMessage: !!p.bankLocationId && o.get("bacs.bankLocationId.invalid"),
            label: o.get("bacs.bankLocationId"),
            className: aP({
                "adyen-checkout__bacs--bank-location-id": !0,
                "adyen-checkout__field--inactive": h === X$ || "loading" === h
            }),
            classNameModifiers: [
                "col-30"
            ],
            isValid: d.bankLocationId,
            name: "bankLocationId",
            i18n: o
        }, rN(oE, {
            value: u.bankLocationId,
            className: "adyen-checkout__bacs-input--bank-location-id",
            placeholder: e.placeholders.bankLocationId,
            "aria-invalid": !d.bankLocationId,
            "aria-label": o.get("bacs.bankLocationId"),
            "aria-required": "true",
            required: !0,
            readonly: h === X$ || "loading" === h,
            autocorrect: "off",
            onBlur: c("bankLocationId", "blur"),
            onInput: c("bankLocationId", "input")
        }))), rN(oD, {
            errorMessage: !!p.shopperEmail && o.get("shopperEmail.invalid"),
            label: o.get("shopperEmail"),
            className: aP({
                "adyen-checkout__bacs--shopper-email": !0,
                "adyen-checkout__field--inactive": h === X$ || "loading" === h
            }),
            isValid: d.shopperEmail,
            name: "emailAddress",
            i18n: o
        }, rN(BE, {
            value: u.shopperEmail,
            name: "shopperEmail",
            className: "adyen-checkout__bacs-input--shopper-email",
            classNameModifiers: [
                "large"
            ],
            placeholder: e.placeholders.shopperEmail,
            spellcheck: !1,
            "aria-invalid": !d.shopperEmail,
            "aria-label": o.get("shopperEmail"),
            "aria-required": "true",
            required: !0,
            readonly: h === X$ || "loading" === h,
            autocorrect: "off",
            onInput: c("shopperEmail", "input"),
            onBlur: c("shopperEmail", "blur")
        })), h === $$ && rN(mz, {
            classNameModifiers: [
                "amountConsentCheckbox"
            ],
            errorMessage: !!p.amountConsentCheckbox,
            label: o.get("bacs.consent.amount"),
            onChange: c("amountConsentCheckbox"),
            checked: !!u.amountConsentCheckbox,
            i18n: o
        }), h === $$ && rN(mz, {
            classNameModifiers: [
                "accountConsentCheckbox"
            ],
            errorMessage: !!p.accountConsentCheckbox,
            label: o.get("bacs.consent.account"),
            onChange: c("accountConsentCheckbox"),
            checked: !!u.accountConsentCheckbox,
            i18n: o
        }), e.showPayButton && e.payButton({
            status: h,
            label: h === $$ ? o.get("continue") : wb(t = "".concat(o.get("bacs.confirm"), " ")).call(t, null !== (r = e.amount) && void 0 !== r && r.value && null !== (a = e.amount) && void 0 !== a && a.currency ? o.amount(e.amount.value, e.amount.currency) : ""),
            icon: i({
                imageFolder: "components/"
            })("lock"),
            onClick: function() {
                return m ? h === $$ ? n.setStatus(X$) : h === X$ ? e.onSubmit() : void 0 : n.showValidation();
            }
        }));
    }
    eX.defaultProps = {
        data: {},
        placeholders: {}
    };
    var tX = function(e) {
        var t = zP().i18n, r = tI(), a = e.url, n = e.paymentMethodType;
        return rN(IW, {
            paymentMethodType: n,
            introduction: t.get("bacs.result.introduction"),
            imageUrl: r()(n),
            downloadUrl: a,
            downloadButtonText: t.get("download.pdf")
        });
    };
    function rX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function aX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = rX(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = rX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function nX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var oX = function(e) {
        L_(r, e);
        var t = nX(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "payButton", function(e) {
                return rN(UP, j_({
                    amount: a.props.amount,
                    onClick: a.submit
                }, e));
            }), a;
        }
        return wg(r, [
            {
                key: "formatData",
                value: function() {
                    var e, t, a, n;
                    return aX({
                        paymentMethod: aX(aX(aX({
                            type: r.type
                        }, (null === (e = this.state.data) || void 0 === e ? void 0 : e.holderName) && {
                            holderName: this.state.data.holderName
                        }), (null === (t = this.state.data) || void 0 === t ? void 0 : t.bankAccountNumber) && {
                            bankAccountNumber: this.state.data.bankAccountNumber
                        }), (null === (a = this.state.data) || void 0 === a ? void 0 : a.bankLocationId) && {
                            bankLocationId: this.state.data.bankLocationId
                        })
                    }, (null === (n = this.state.data) || void 0 === n ? void 0 : n.shopperEmail) && {
                        shopperEmail: this.state.data.shopperEmail
                    });
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.url ? rN(tX, {
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        icon: this.icon,
                        url: this.props.url,
                        paymentMethodType: this.props.paymentMethodType
                    }) : rN(eX, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        onChange: this.setState,
                        payButton: this.payButton,
                        onSubmit: this.submit
                    })));
                }
            }
        ]), r;
    }(gA);
    function iX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(oX, "type", "directdebit_GB"), Sg(oX, "defaultProps", {
        showFormInstruction: !0
    });
    var lX = function(e) {
        L_(r, e);
        var t = iX(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "data",
                get: function() {
                    return this.state.data;
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "render",
                value: function() {
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(cz, j_({
                        setComponentRef: this.setComponentRef
                    }, this.props, {
                        onChange: this.setState
                    }, !1)));
                }
            }
        ]), r;
    }(gA);
    function cX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var sX = function(e) {
        L_(r, e);
        var t = cX(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "data",
                get: function() {
                    return this.state.data;
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "render",
                value: function() {
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, this.props.showFormInstruction && rN(IO, null), rN(KE, j_({
                        setComponentRef: this.setComponentRef
                    }, this.props, {
                        onChange: this.setState
                    }, !1)));
                }
            }
        ]), r;
    }(gA);
    Sg(sX, "defaultProps", {
        showFormInstruction: !0
    });
    var uX = "https://x.klarnacdn.net/kp/lib/v1/api.js", dX = [
        "sdkData",
        "paymentMethodType",
        "payButton"
    ];
    function pX(e) {
        var t = e.sdkData;
        e.paymentMethodType;
        var r = e.payButton, a = kg(e, dX), n = gP(null), o = Vk(fP("ready"), 2), i = o[0], l = o[1], c = function() {
            l("error"), a.onComplete({
                data: {
                    paymentData: a.paymentData,
                    details: {}
                }
            });
        };
        return vP(function() {
            window.klarnaAsyncCallback = function() {
                window.Klarna.Payments.init({
                    client_token: t.client_token
                }), window.Klarna.Payments.load({
                    container: n.current,
                    payment_method_category: t.payment_method_category
                }, function(e) {
                    !e.show_form || e.error ? c() : a.onLoaded();
                });
            };
            var e = new Rj(uX);
            return e.load(), function() {
                e.remove();
            };
        }, []), "error" !== i && "success" !== i ? rN("div", {
            className: "adyen-checkout__klarna-widget"
        }, rN("div", {
            ref: n
        }), r({
            status: i,
            disabled: "loading" === i,
            onClick: function() {
                l("loading");
                try {
                    window.Klarna.Payments.authorize({
                        payment_method_category: t.payment_method_category
                    }, function(e) {
                        !0 === e.approved && !0 === e.show_form ? (l("success"), a.onComplete({
                            data: {
                                paymentData: a.paymentData,
                                details: {
                                    token: e.authorization_token,
                                    authorization_token: e.authorization_token
                                }
                            }
                        })) : e.approved || !0 !== e.show_form ? c() : (l("ready"), a.onError(e));
                    });
                } catch (e) {
                    c();
                }
            }
        })) : null;
    }
    function mX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function fX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = mX(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = mX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function hX(e) {
        var t, r = Vk(fP({
            sdkData: e.sdkData,
            paymentMethodType: e.paymentMethodType,
            paymentData: e.paymentData
        }), 2), a = r[0], n = r[1], o = Vk(fP("ready"), 2), i = o[0], l = o[1];
        return this.setAction = n, this.setStatus = l, a.sdkData ? rN(pX, {
            sdkData: a.sdkData,
            paymentMethodType: a.paymentMethodType,
            paymentData: a.paymentData,
            payButton: e.payButton,
            onComplete: e.onComplete,
            onError: e.onError,
            onLoaded: e.onLoaded
        }) : e.showPayButton ? e.payButton(fX(fX({}, e), {}, {
            status: i,
            disabled: "loading" === i,
            classNameModifiers: [
                "standalone"
            ],
            label: wb(t = "".concat(this.props.i18n.get("continueTo"), " ")).call(t, e.displayName)
        })) : null;
    }
    function vX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function yX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = vX(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = vX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function gX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var bX, kX = function(e) {
        L_(r, e);
        var t = gX(r);
        function r(e) {
            var a, n, o, i, l;
            return Cg(this, r), Sg(B_(l = t.call(this, e)), "payButton", function(e) {
                return rN(UP, j_({
                    amount: l.props.amount,
                    onClick: l.submit
                }, e));
            }), l.onComplete = Jg(a = l.onComplete).call(a, B_(l)), l.updateWithAction = Jg(n = l.updateWithAction).call(n, B_(l)), l.submit = Jg(o = l.submit).call(o, B_(l)), l.onLoaded = Jg(i = l.onLoaded).call(i, B_(l)), l;
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return !0;
                }
            },
            {
                key: "formatData",
                value: function() {
                    return {
                        paymentMethod: yX({
                            type: this.type
                        }, this.props.useKlarnaWidget ? {
                            subtype: "sdk"
                        } : {})
                    };
                }
            },
            {
                key: "updateWithAction",
                value: function(e) {
                    if (e.paymentMethodType !== this.type) throw new Error("Invalid Action");
                    this.componentRef.setAction(e);
                }
            },
            {
                key: "onLoaded",
                value: function() {
                    this.setElementStatus("ready");
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(hX, j_({}, this.props, {
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        displayName: this.displayName,
                        onComplete: function(t) {
                            return e.handleAdditionalDetails(t);
                        },
                        onError: this.props.onError,
                        payButton: this.payButton,
                        onLoaded: this.onLoaded
                    })));
                }
            }
        ]), r;
    }(gA);
    function CX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(kX, "type", "klarna"), Sg(kX, "defaultProps", {
        useKlarnaWidget: !1
    });
    var _X = function(e) {
        L_(r, e);
        var t = CX(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "payButton", function(e) {
                return rN(UP, j_({}, e, {
                    label: a.payButtonLabel(),
                    onClick: a.submit
                }));
            }), a;
        }
        return wg(r, [
            {
                key: "displayName",
                get: function() {
                    var e, t = this.props, r = t.i18n, a = t.name;
                    return t.storedPaymentMethodId ? wb(e = "".concat(a, " ")).call(e, r.get("twint.saved")) : a || this.constructor.type;
                }
            },
            {
                key: "payButtonLabel",
                value: function() {
                    var e, t = this.props, r = t.i18n, a = t.amount, n = t.storedPaymentMethodId, o = t.name;
                    return n ? MP(r, a) : wb(e = "".concat(r.get("continueTo"), " ")).call(e, o);
                }
            }
        ]), r;
    }(Jq);
    bX = _X, Sg(_X, "type", "twint"), Sg(_X, "defaultProps", {
        type: bX.type,
        showPayButton: !0
    });
    var NX = function(e) {
        var t = e.i18n, r = e.sfpState, a = e.focusedElement, n = e.setFocusOn;
        return rN(oD, {
            label: t.get("creditCard.expiryDateField.title"),
            classNameModifiers: [
                "expireDate",
                "50"
            ],
            errorMessage: r.errors.encryptedExpiryDate && t.get(r.errors.encryptedExpiryDate),
            focused: "encryptedExpiryDate" === a,
            onFocusField: function() {
                return n("encryptedExpiryDate");
            },
            dir: "ltr",
            name: "encryptedExpiryDate",
            errorVisibleToScreenReader: !1
        }, rN(vK, {
            encryptedFieldType: "encryptedExpiryDate",
            className: aP("adyen-checkout__input", "adyen-checkout__input--small", "adyen-checkout__card__exp-date__input", [
                hK["adyen-checkout__input"]
            ], {
                "adyen-checkout__input--error": r.errors.encryptedExpiryDate,
                "adyen-checkout__input--focus": "encryptedExpiryDate" === a,
                "adyen-checkout__input--valid": !!r.valid.encryptedExpiryMonth && !!r.valid.encryptedExpiryYear
            })
        }));
    };
    function PX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function wX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = PX(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = PX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var SX = function(e) {
        var t = e.setRootNode, r = wX(wX({}, e), {}, {
            label: e.i18n.get("creditCard.cvcField.title")
        });
        return rN("div", {
            ref: t
        }, rN(CZ, j_({}, e, {
            classNameModifiers: [
                "100"
            ]
        })), rN("div", {
            className: "adyen-checkout__field-wrapper"
        }, rN(NX, e), rN(_Z, j_({}, r, {
            classNameModifiers: [
                "50"
            ]
        }))));
    };
    function AX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function IX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = AX(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = AX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function DX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var EX = function(e) {
        L_(r, e);
        var t = DX(r);
        function r(e) {
            return Cg(this, r), t.call(this, IX(IX({}, e), {}, {
                pinRequired: !0,
                expiryDateRequired: !0,
                fieldsLayoutComponent: SX
            }));
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return IX({
                        brand: e.type
                    }, e);
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e, t, r, a;
                    return {
                        paymentMethod: {
                            type: this.constructor.type,
                            brand: this.props.brand,
                            encryptedCardNumber: null === (e = this.state.data) || void 0 === e ? void 0 : e.encryptedCardNumber,
                            encryptedSecurityCode: null === (t = this.state.data) || void 0 === t ? void 0 : t.encryptedSecurityCode,
                            encryptedExpiryMonth: null === (r = this.state.data) || void 0 === r ? void 0 : r.encryptedExpiryMonth,
                            encryptedExpiryYear: null === (a = this.state.data) || void 0 === a ? void 0 : a.encryptedExpiryYear
                        }
                    };
                }
            }
        ]), r;
    }(DZ);
    function RX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function xX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = RX(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = RX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function FX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(EX, "type", "mealVoucher_FR");
    var TX, zX = function(e) {
        L_(r, e);
        var t = FX(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return xX(xX({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    return xX(xX({}, GA(U_(r.prototype), "formatData", this).call(this)), {}, {
                        browserInfo: this.browserInfo
                    });
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return cj();
                }
            }
        ]), r;
    }(BL);
    function OX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function jX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = OX(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = OX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function BX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(zX, "type", "onlinebanking_IN");
    var MX = function(e) {
        L_(r, e);
        var t = BX(r);
        function r(e) {
            return Cg(this, r), t.call(this, jX(jX({}, e), {}, {
                termsAndConditions: r.termsAndConditions
            }));
        }
        return wg(r);
    }(BL);
    function LX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function VX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = LX(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = LX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function UX(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    TX = MX, Sg(MX, "type", "onlineBanking_PL"), Sg(MX, "disclaimerUrlsMap", {
        regulation: "https://www.przelewy24.pl/regulamin",
        obligation: "https://www.przelewy24.pl/obowiazek-informacyjny-rodo-platnicy"
    }), Sg(MX, "termsAndConditions", {
        translationKey: "onlineBankingPL.termsAndConditions",
        urls: [
            TX.disclaimerUrlsMap.regulation,
            TX.disclaimerUrlsMap.obligation
        ]
    });
    var KX = function(e) {
        L_(r, e);
        var t = UX(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return VX(VX({}, GA(U_(r.prototype), "formatProps", this).call(this, VX(VX({}, e), {
                        visibility: {
                            bankAccount: "editable"
                        }
                    }))), {}, {
                        allowedCountries: e.countryCode ? [
                            e.countryCode
                        ] : LZ
                    });
                }
            }
        ]), r;
    }(QO);
    Sg(KX, "type", "ratepay_directdebit");
    var HX = {
        virtualPaymentAddress: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "",
            modes: [
                "blur"
            ]
        },
        default: {
            validate: function(e) {
                return !!e && e.length > 0;
            },
            errorMessage: "",
            modes: [
                "blur"
            ]
        }
    }, qX = function(e) {
        var t = QD({
            schema: [
                "virtualPaymentAddress"
            ],
            defaultData: e.data,
            rules: HX
        }), r = t.handleChangeFor, a = t.triggerValidation, n = t.data, o = t.valid, i = t.errors, l = t.isValid, c = gP({
            validateInput: null
        }), s = kP(function() {
            a();
        }, [
            a
        ]);
        return vP(function() {
            c.current.validateInput = s, e.onSetInputHandlers(c.current);
        }, [
            s,
            e.onSetInputHandlers
        ]), vP(function() {
            e.onChange({
                data: n,
                valid: o,
                errors: i,
                isValid: l
            });
        }, [
            n,
            o,
            i,
            l
        ]), rN(oD, {
            label: "Virtual Payment Address",
            errorMessage: !!i.virtualPaymentAddress,
            classNameModifiers: [
                "vpa"
            ],
            name: "virtualPaymentAddress"
        }, rN(oE, {
            name: "virtualPaymentAddress",
            autocorrect: "off",
            spellcheck: !1,
            disabled: e.disabled,
            value: n.virtualPaymentAddress,
            onInput: r("virtualPaymentAddress", "input"),
            onBlur: r("virtualPaymentAddress", "blur")
        }));
    };
    function WX(e) {
        var t, r = e.classNameModifiers, a = e.selectedValue, n = e.disabled, o = void 0 !== n && n, i = e.options, l = e.onChange;
        return i && 0 !== i.length ? rN("div", {
            className: aP.apply(void 0, wb(t = [
                "adyen-checkout__segmented-control",
                {
                    "adyen-checkout__segmented-control--disabled": o
                }
            ]).call(t, Uk(hC(r).call(r, function(e) {
                return "adyen-checkout__segmented-control--".concat(e);
            })))),
            role: "group"
        }, hC(i).call(i, function(e) {
            var t = e.label, r = e.value, n = e.htmlProps;
            return rN("button", j_({
                disabled: o,
                key: r,
                onClick: function(e) {
                    return l(r, e);
                },
                className: aP("adyen-checkout__segmented-control-segment", {
                    "adyen-checkout__segmented-control-segment--selected": a === r
                }),
                type: "button"
            }, n), t);
        })) : null;
    }
    var GX = function(e) {
        return e.Vpa = "vpa", e.QrCode = "qrCode", e;
    }({}), YX = {
        ButtonId: {
            VPA: "upi-button-".concat(GX.Vpa),
            QR: "upi-button-".concat(GX.QrCode)
        },
        AreaId: {
            VPA: "upi-area-".concat(GX.Vpa),
            QR: "upi-area-".concat(GX.QrCode)
        }
    };
    function QX(e) {
        var t = e.defaultMode, r = e.onChange, a = e.onUpdateMode, n = e.payButton, o = e.showPayButton, i = zP().i18n, l = tI(), c = Vk(fP(null), 2), s = c[0], u = c[1], d = Vk(fP("ready"), 2), p = d[0], m = d[1], f = Vk(fP(t), 2), h = f[0], v = f[1];
        this.setStatus = function(e) {
            m(e);
        }, this.showValidation = function() {
            s.validateInput();
        };
        var y = kP(function(e) {
            u(e);
        }, []), g = kP(function(e) {
            v(e), a(e);
        }, [
            a
        ]);
        return rN(nN, null, rN("p", {
            className: "adyen-checkout_upi-mode-selection-text"
        }, i.get("upi.modeSelection")), rN(WX, {
            onChange: g,
            selectedValue: h,
            disabled: "loading" === p,
            classNameModifiers: [
                "upi-margin-bottom"
            ],
            options: [
                {
                    label: QH() ? "VPA" : "Virtual Payment Address",
                    value: GX.Vpa,
                    htmlProps: {
                        id: YX.ButtonId.VPA,
                        "aria-expanded": h === GX.Vpa,
                        "aria-controls": YX.AreaId.VPA
                    }
                },
                {
                    label: "QR Code",
                    value: GX.QrCode,
                    htmlProps: {
                        id: YX.ButtonId.QR,
                        "aria-expanded": h === GX.QrCode,
                        "aria-controls": YX.AreaId.QR
                    }
                }
            ]
        }), h === GX.Vpa ? rN("div", {
            id: YX.AreaId.VPA,
            "aria-labelledby": YX.ButtonId.VPA,
            role: "region"
        }, rN(qX, {
            disabled: "loading" === p,
            onChange: r,
            onSetInputHandlers: y
        }), o && n({
            label: i.get("continue"),
            status: p
        })) : rN("div", {
            id: YX.AreaId.QR,
            "aria-labelledby": YX.ButtonId.QR,
            role: "region"
        }, o && n({
            label: i.get("generateQRCode"),
            icon: l({
                imageFolder: "components/"
            })("qr"),
            status: p
        })));
    }
    function ZX(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function JX(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = ZX(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = ZX(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function $X(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var XX = function(e) {
        return e.UpiCollect = "upi_collect", e.UpiQr = "upi_qr", e;
    }(XX || {}), e0 = function(e) {
        L_(r, e);
        var t = $X(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "useQrCodeVariant", void 0), Sg(B_(a), "onUpdateMode", function(e) {
                e === GX.QrCode ? (a.useQrCodeVariant = !0, a.setState({
                    data: {},
                    valid: {},
                    errors: {},
                    isValid: !0
                })) : a.useQrCodeVariant = !1;
            }), a;
        }
        return wg(r, [
            {
                key: "isValid",
                get: function() {
                    return this.useQrCodeVariant || !!this.state.isValid;
                }
            },
            {
                key: "formatData",
                value: function() {
                    var e = this.state.data.virtualPaymentAddress;
                    return {
                        paymentMethod: JX({
                            type: this.useQrCodeVariant ? XX.UpiQr : XX.UpiCollect
                        }, e && !this.useQrCodeVariant && {
                            virtualPaymentAddress: e
                        })
                    };
                }
            },
            {
                key: "renderContent",
                value: function(e) {
                    var t = this;
                    switch(e){
                        case "qrCode":
                            return rN(uQ, j_({
                                ref: function(e) {
                                    t.componentRef = e;
                                }
                            }, this.props, {
                                qrCodeData: this.props.qrCodeData ? encodeURIComponent(this.props.qrCodeData) : null,
                                type: XX.UpiQr,
                                brandLogo: this.props.brandLogo || this.icon,
                                onComplete: this.onComplete,
                                introduction: this.props.i18n.get("upi.qrCodeWaitingMessage"),
                                countdownTime: 5,
                                onActionHandled: this.props.onActionHandled
                            }));
                        case "await":
                            return rN(p$, {
                                ref: function(e) {
                                    t.componentRef = e;
                                },
                                onError: this.props.onError,
                                clientKey: this.props.clientKey,
                                paymentData: this.props.paymentData,
                                onComplete: this.onComplete,
                                brandLogo: this.icon,
                                type: XX.UpiCollect,
                                messageText: this.props.i18n.get("upi.vpaWaitingMessage"),
                                awaitText: this.props.i18n.get("await.waitForConfirmation"),
                                showCountdownTimer: !0,
                                countdownTime: 5,
                                onActionHandled: this.props.onActionHandled
                            });
                        default:
                            return rN(QX, {
                                ref: function(e) {
                                    t.componentRef = e;
                                },
                                payButton: this.payButton,
                                onChange: this.setState,
                                onUpdateMode: this.onUpdateMode,
                                defaultMode: this.props.defaultMode,
                                showPayButton: this.props.showPayButton
                            });
                    }
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.type;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(qO, {
                        srPanel: this.props.modules.srPanel
                    }, this.renderContent(e)));
                }
            }
        ]), r;
    }(gA);
    function t0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function r0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = t0(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = t0(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function a0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(e0, "type", "upi"), Sg(e0, "defaultProps", {
        defaultMode: GX.Vpa
    });
    var n0 = function(e) {
        L_(r, e);
        var t = a0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return r0(r0({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1
                    });
                }
            },
            {
                key: "formatData",
                value: function() {
                    return r0(r0({}, GA(U_(r.prototype), "formatData", this).call(this)), {}, {
                        browserInfo: this.browserInfo
                    });
                }
            },
            {
                key: "browserInfo",
                get: function() {
                    return cj();
                }
            }
        ]), r;
    }(BL);
    function o0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function i0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = o0(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = o0(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function l0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(n0, "type", "wallet_IN");
    var c0 = function(e) {
        L_(r, e);
        var t = l0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return i0(i0({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1,
                        termsAndConditions: r.termsAndConditions
                    });
                }
            },
            {
                key: "icon",
                get: function() {
                    var e;
                    return null !== (e = this.props.icon) && void 0 !== e ? e : this.resources.getImage()("bankTransfer_IBAN");
                }
            }
        ]), r;
    }(BL);
    function s0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function u0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = s0(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = s0(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function d0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(c0, "type", "onlineBanking_CZ"), Sg(c0, "termsAndConditions", {
        translationKey: "onlineBanking.termsAndConditions",
        urls: [
            "https://static.payu.com/sites/terms/files/payu_privacy_policy_cs.pdf"
        ]
    });
    var p0 = function(e) {
        L_(r, e);
        var t = d0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return u0(u0({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        showImage: !1,
                        termsAndConditions: r.termsAndConditions
                    });
                }
            },
            {
                key: "icon",
                get: function() {
                    var e;
                    return null !== (e = this.props.icon) && void 0 !== e ? e : this.resources.getImage()("bankTransfer_IBAN");
                }
            }
        ]), r;
    }(BL);
    function m0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function f0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = m0(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = m0(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function h0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(p0, "type", "onlineBanking_SK"), Sg(p0, "termsAndConditions", {
        translationKey: "onlineBanking.termsAndConditions",
        urls: [
            "https://static.payu.com/sites/terms/files/payu_privacy_policy_sk.pdf"
        ]
    });
    var v0 = function(e) {
        L_(r, e);
        var t = h0(r);
        function r(e) {
            return Cg(this, r), t.call(this, f0(f0({}, e), {}, {
                showPaymentMethodItemImages: !0
            }));
        }
        return wg(r);
    }(BL);
    Sg(v0, "type", "paybybank");
    function y0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function g0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var b0 = function(e) {
        L_(r, e);
        var t = g0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Ag(r = y0(Object(n), !0)).call(r, function(t) {
                                Sg(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Ag(a = y0(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        delay: 2e3,
                        countdownTime: 1.5
                    }, GA(U_(r.prototype), "formatProps", this).call(this, e));
                }
            }
        ]), r;
    }(fQ);
    Sg(b0, "type", "promptpay");
    function k0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function C0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var _0 = function(e) {
        L_(r, e);
        var t = C0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Ag(r = k0(Object(n), !0)).call(r, function(t) {
                                Sg(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Ag(a = k0(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        delay: 2e3,
                        countdownTime: 1.5
                    }, GA(U_(r.prototype), "formatProps", this).call(this, e));
                }
            }
        ]), r;
    }(fQ);
    Sg(_0, "type", "duitnow");
    var N0 = {
        beneficiaryId: {
            validate: function(e) {
                return vE(e) || /^\d{11}$/.test(e);
            },
            errorMessage: "ancv.beneficiaryId.invalid",
            modes: [
                "blur"
            ]
        }
    };
    function P0(e) {
        var t = this, r = e.showPayButton, a = e.payButton, n = e.onChange, o = e.onSubmit, i = zP().i18n, l = QD({
            schema: [
                "beneficiaryId"
            ],
            rules: N0
        }), c = l.handleChangeFor, s = l.triggerValidation, u = l.data, d = l.valid, p = l.errors, m = l.isValid;
        vP(function() {
            n({
                data: u,
                errors: p,
                valid: d,
                isValid: m
            }, t);
        }, [
            u,
            d,
            p,
            m
        ]);
        var f = Vk(fP("ready"), 2), h = f[0], v = f[1];
        return this.setStatus = v, this.showValidation = s, rN(mK, null, rN("div", {
            className: "adyen-checkout__ancv"
        }, rN("p", {
            className: "adyen-checkout-form-instruction"
        }, i.get("ancv.form.instruction")), rN(oD, {
            errorMessage: !!p.beneficiaryId && i.get(p.beneficiaryId.errorMessage),
            label: i.get("ancv.input.label"),
            isValid: d.beneficiaryId,
            name: "beneficiaryId"
        }, rN(oE, {
            value: u.beneficiaryId,
            name: "beneficiaryId",
            spellcheck: !0,
            required: !0,
            onInput: c("beneficiaryId", "input"),
            onBlur: c("beneficiaryId", "blur")
        })), r && a({
            status: h,
            label: i.get("confirmPurchase"),
            onClick: o
        })));
    }
    P0.defaultProps = {};
    var w0 = 6e4, S0 = 1e4, A0 = !1;
    function I0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var D0 = function(e) {
        L_(r, e);
        var t = I0(r);
        function r() {
            var e, a;
            Cg(this, r);
            for(var n = arguments.length, o = new Array(n), i = 0; i < n; i++)o[i] = arguments[i];
            return Sg(B_(a = t.call.apply(t, wb(e = [
                this
            ]).call(e, o))), "onOrderRequest", function(e) {
                return a.props.onOrderRequest ? new Sb(function(t, r) {
                    a.props.onOrderRequest(t, r, e);
                }) : a.props.session ? a.props.session.createOrder() : void 0;
            }), Sg(B_(a), "handleOrder", function(e) {
                var t = e.order;
                if (a.updateParent({
                    order: t
                }), a.props.session && a.props.onOrderCreated) return a.props.onOrderCreated(t);
            }), Sg(B_(a), "createOrder", function() {
                return a.isValid ? (a.setStatus("loading"), a.onOrderRequest(a.data).then(function(e) {
                    a.setState({
                        order: {
                            orderData: e.orderData,
                            pspReference: e.pspReference
                        }
                    }), a.submit();
                }).catch(function(e) {
                    a.setStatus((null == e ? void 0 : e.message) || "error"), a.props.onError && a.handleError(new mA("ERROR", e));
                })) : (a.showValidation(), !1);
            }), Sg(B_(a), "payButton", function(e) {
                return rN(UP, e);
            }), a;
        }
        return wg(r, [
            {
                key: "formatData",
                value: function() {
                    var e;
                    return {
                        paymentMethod: {
                            type: r.type,
                            beneficiaryId: null === (e = this.state.data) || void 0 === e ? void 0 : e.beneficiaryId
                        }
                    };
                }
            },
            {
                key: "isValid",
                get: function() {
                    return !!this.state.isValid;
                }
            },
            {
                key: "displayName",
                get: function() {
                    return this.props.name;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return this.props.paymentData ? rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(qO, {
                        srPanel: this.props.modules.srPanel
                    }, rN(p$, {
                        ref: function(t) {
                            e.componentRef = t;
                        },
                        clientKey: this.props.clientKey,
                        paymentData: this.props.paymentData,
                        onError: this.props.onError,
                        onComplete: this.onComplete,
                        brandLogo: this.icon,
                        type: this.constructor.type,
                        messageText: this.props.i18n.get("ancv.confirmPayment"),
                        awaitText: this.props.i18n.get("await.waitForConfirmation"),
                        showCountdownTimer: A0,
                        throttleTime: w0,
                        throttleInterval: S0,
                        onActionHandled: this.props.onActionHandled
                    }))) : rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN(P0, j_({
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    }, this.props, {
                        onSubmit: this.createOrder,
                        onChange: this.setState,
                        payButton: this.payButton,
                        showPayButton: this.props.showPayButton
                    })));
                }
            }
        ]), r;
    }(gA);
    function E0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(D0, "type", "ancv");
    var R0 = function(e) {
        L_(r, e);
        var t = E0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "displayName",
                get: function() {
                    return this.props.name || this.constructor.type;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return rN(zO, {
                        i18n: this.props.i18n,
                        loadingContext: this.props.loadingContext,
                        resources: this.resources
                    }, rN("div", {
                        className: "adyen-checkout-trustly"
                    }, rN("p", {
                        className: "adyen-checkout-trustly__descriptor"
                    }, this.props.i18n.get("trustly.descriptor")), rN("ul", {
                        className: "adyen-checkout-trustly__description-list"
                    }, rN("li", null, this.props.i18n.get("trustly.description1")), rN("li", null, this.props.i18n.get("trustly.description2")))), this.props.showPayButton && rN(TL, j_({}, this.props, {
                        name: this.displayName,
                        onSubmit: this.submit,
                        payButton: this.payButton,
                        ref: function(t) {
                            e.componentRef = t;
                        }
                    })));
                }
            }
        ]), r;
    }(Jq);
    function x0() {
        var e, t = zP().i18n, r = t.get("payme.instructions.steps"), a = t.get("payme.instructions.footnote");
        return rN("div", {
            className: "adyen-checkout-payme-instructions"
        }, rN("ol", {
            className: "adyen-checkout-payme-instructions__steps"
        }, hC(e = r.split("%@")).call(e, function(e, t) {
            return rN("li", {
                key: "instruction-".concat(t)
            }, e);
        })), rN("span", null, a));
    }
    function F0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function T0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(R0, "type", "trustly");
    var z0 = function(e) {
        L_(r, e);
        var t = T0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    return function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r, a, n = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? Ag(r = F0(Object(n), !0)).call(r, function(t) {
                                Sg(e, t, n[t]);
                            }) : Jy ? ng(e, Jy(n)) : Ag(a = F0(Object(n))).call(a, function(t) {
                                og(e, t, Wy(n, t));
                            });
                        }
                        return e;
                    }({
                        delay: r.defaultDelay,
                        countdownTime: r.defaultCountdown,
                        redirectIntroduction: "payme.openPayMeApp",
                        introduction: "payme.scanQrCode",
                        timeToPay: "payme.timeToPay",
                        buttonLabel: "payme.redirectButtonLabel",
                        instructions: x0
                    }, GA(U_(r.prototype), "formatProps", this).call(this, e));
                }
            }
        ]), r;
    }(fQ);
    function O0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    Sg(z0, "type", "payme"), Sg(z0, "defaultCountdown", 10), Sg(z0, "defaultDelay", 2e3);
    var j0 = function(e) {
        L_(r, e);
        var t = O0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r);
    }(BL);
    Sg(j0, "type", "ebanking_FI");
    var B0 = [
        "AT",
        "CH",
        "DE"
    ], M0 = [
        "NO",
        "SE",
        "FI",
        "DK",
        "DE",
        "AT",
        "CH",
        "NL",
        "BE"
    ], L0 = {
        default: {
            labels: Sg(Sg({}, $E, "deliveryAddress.firstName"), XE, "deliveryAddress.lastName"),
            schema: [
                JE,
                [
                    [
                        $E,
                        50
                    ],
                    [
                        XE,
                        50
                    ]
                ],
                [
                    [
                        WE,
                        70
                    ],
                    [
                        GE,
                        30
                    ]
                ],
                [
                    [
                        YE,
                        30
                    ],
                    [
                        QE,
                        70
                    ]
                ]
            ]
        }
    }, V0 = {
        at: {
            en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/at_en",
            de: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/at_de"
        },
        ch: {
            en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/ch_en",
            de: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/ch_de",
            fr: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/ch_fr"
        },
        de: {
            en: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/de_en",
            de: "https://documents.riverty.com/terms_conditions/payment_methods/invoice/de_de"
        }
    };
    function U0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function K0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = U0(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = U0(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function H0(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var q0 = function(e) {
        L_(r, e);
        var t = H0(r);
        function r() {
            return Cg(this, r), t.apply(this, arguments);
        }
        return wg(r, [
            {
                key: "formatProps",
                value: function(e) {
                    var t;
                    return K0(K0({}, GA(U_(r.prototype), "formatProps", this).call(this, e)), {}, {
                        billingAddressSpecification: K0(K0({}, e.billingAddressSpecification), {}, {
                            allowedCountries: e.countryCode ? [
                                e.countryCode
                            ] : B0
                        }),
                        deliveryAddressSpecification: K0(K0({}, e.deliveryAddressSpecification), {}, {
                            allowedCountries: M0
                        }),
                        consentCheckboxLabel: rN(ZO, {
                            url: XO(e.countryCode, null === (t = e.i18n) || void 0 === t ? void 0 : t.locale, V0)
                        })
                    });
                }
            }
        ]), r;
    }(QO);
    function W0(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function G0(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = W0(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = W0(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    Sg(q0, "type", "riverty"), Sg(q0, "defaultProps", K0({
        personalDetailsRequiredFields: [
            "firstName",
            "lastName",
            "dateOfBirth",
            "shopperEmail",
            "telephoneNumber"
        ],
        deliveryAddressSpecification: L0
    }, QO.defaultProps));
    var Y0 = {
        address: lX,
        bankTransfer_IBAN: z$,
        donation: Uq,
        dropin: xJ,
        personal_details: sX,
        amex: pq,
        bcmc: xq,
        card: pq,
        diners: pq,
        discover: pq,
        jcb: pq,
        kcp: pq,
        maestro: pq,
        mc: pq,
        scheme: pq,
        storedCard: pq,
        securedfields: tY,
        threeDS2Challenge: EY,
        threeDS2DeviceFingerprint: MY,
        visa: pq,
        ach: WJ,
        directdebit_GB: oX,
        sepadirectdebit: oY,
        affirm: L$,
        afterpay: aj,
        afterpay_default: aj,
        afterpay_b2b: lj,
        atome: oB,
        facilypay_3x: BW,
        facilypay_4x: UW,
        facilypay_6x: WW,
        facilypay_10x: ZW,
        facilypay_12x: eG,
        ratepay: HZ,
        ratepay_directdebit: KX,
        riverty: q0,
        amazonpay: jj,
        applepay: Zj,
        cashapp: Pq,
        clicktopay: Iq,
        googlepay: kW,
        paypal: AG,
        paywithgoogle: kW,
        qiwiwallet: GG,
        boletobancario: tZ,
        boletobancario_bancodobrasil: tZ,
        boletobancario_bradesco: tZ,
        boletobancario_hsbc: tZ,
        boletobancario_itau: tZ,
        boletobancario_santander: tZ,
        doku: KQ,
        doku_alfamart: KQ,
        doku_permata_lite_atm: KQ,
        doku_indomaret: KQ,
        doku_atm_mandiri_va: KQ,
        doku_sinarmas_va: KQ,
        doku_mandiri_va: KQ,
        doku_cimb_va: KQ,
        doku_danamon_va: KQ,
        doku_bri_va: KQ,
        doku_bni_va: KQ,
        doku_bca_va: KQ,
        doku_wallet: KQ,
        oxxo: iZ,
        primeiropay_boleto: tZ,
        billdesk_online: UL,
        billdesk_wallet: WL,
        dotpay: mZ,
        entercash: _W,
        eps: yZ,
        ideal: rG,
        molpay_ebanking_fpx_MY: wQ,
        molpay_ebanking_TH: AQ,
        molpay_ebanking_VN: DQ,
        onlineBanking: mZ,
        onlineBanking_CZ: c0,
        onlinebanking_IN: zX,
        onlineBanking_PL: MX,
        onlineBanking_SK: p0,
        paybybank: v0,
        payu_IN_cashcard: zZ,
        payu_IN_nb: MZ,
        wallet_IN: n0,
        ebanking_FI: j0,
        dragonpay_ebanking: jQ,
        dragonpay_otc_banking: jQ,
        dragonpay_otc_non_banking: jQ,
        dragonpay_otc_philippines: jQ,
        econtext_atm: FW,
        econtext_online: FW,
        econtext_seven_eleven: FW,
        econtext_stores: FW,
        giropay: tW,
        multibanco: dZ,
        redirect: Jq,
        twint: _X,
        vipps: RZ,
        trustly: R0,
        klarna: kX,
        klarna_b2b: kX,
        klarna_account: kX,
        klarna_paynow: kX,
        bcmc_mobile: NQ,
        bcmc_mobile_QR: NQ,
        pix: G$,
        swish: GZ,
        wechatpay: yQ,
        wechatpayQR: yQ,
        promptpay: b0,
        paynow: kQ,
        duitnow: _0,
        payme: z0,
        blik: E$,
        mbway: v$,
        upi: e0,
        upi_qr: e0,
        upi_collect: e0,
        ancv: D0,
        giftcard: DZ,
        mealVoucher_FR_natixis: EX,
        mealVoucher_FR_sodexo: EX,
        mealVoucher_FR_groupeup: EX,
        default: null
    }, Q0 = function(e, t) {
        var r, a = Y0[e] || Y0.default;
        return a ? new a(G0(G0({}, t), {}, {
            id: wb(r = "".concat(e, "-")).call(r, DN())
        })) : null;
    }, Z0 = function(e) {
        var t = e;
        return "scheme" === e && (t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2] ? "storedCard" : "card"), (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {})[t] || {};
    };
    function J0(e) {
        return !this.length || Kk(this).call(this, e.type) > -1;
    }
    function $0(e) {
        return !this.length || Kk(this).call(this, e.type) < 0;
    }
    function X0(e) {
        var t;
        return !!e && !!e.supportedShopperInteractions && kb(t = e.supportedShopperInteractions).call(t, "Ecommerce");
    }
    var e1 = [
        "scheme",
        "blik",
        "twint",
        "ach",
        "cashapp"
    ];
    function t1(e) {
        return !!e && !!e.type && kb(e1).call(e1, e.type);
    }
    function r1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function a1(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = r1(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = r1(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var n1 = function(e) {
        return a1(a1({}, e), {}, {
            storedPaymentMethodId: e.id
        });
    }, o1 = function() {
        function e(t) {
            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            Cg(this, e), Sg(this, "paymentMethods", []), Sg(this, "storedPaymentMethods", []), function(e) {
                var t, r;
                if ("string" == typeof e) throw new Error('paymentMethodsResponse was provided but of an incorrect type (should be an object but a string was provided).Try JSON.parse("{...}") your paymentMethodsResponse.');
                if (e instanceof Array) throw new Error("paymentMethodsResponse was provided but of an incorrect type (should be an object but an array was provided).Please check you are passing the whole response.");
                !e || null != e && null !== (t = e.paymentMethods) && void 0 !== t && t.length || null != e && null !== (r = e.storedPaymentMethods) && void 0 !== r && r.length || console.warn("paymentMethodsResponse was provided but no payment methods were found.");
            }(t), this.paymentMethods = t ? function(e, t) {
                var r, a = t.allowPaymentMethods, n = void 0 === a ? [] : a, o = t.removePaymentMethods, i = void 0 === o ? [] : o;
                return e ? Fg(r = Fg(e).call(e, J0, n)).call(r, $0, i) : [];
            }(t.paymentMethods, r) : [], this.storedPaymentMethods = t ? function(e, t) {
                var r, a, n, o, i = t.allowPaymentMethods, l = void 0 === i ? [] : i, c = t.removePaymentMethods, s = void 0 === c ? [] : c;
                return e ? hC(r = Fg(a = Fg(n = Fg(o = Fg(e).call(e, t1)).call(o, J0, l)).call(n, $0, s)).call(a, X0)).call(r, n1) : [];
            }(t.storedPaymentMethods, r) : [];
        }
        return wg(e, [
            {
                key: "mapCreatedComponentType",
                value: function(e) {
                    return "card" === e ? "scheme" : e;
                }
            },
            {
                key: "has",
                value: function(e) {
                    var t, r = this;
                    return Boolean(zb(t = this.paymentMethods).call(t, function(t) {
                        return t.type === r.mapCreatedComponentType(e);
                    }));
                }
            },
            {
                key: "find",
                value: function(e) {
                    var t, r = this;
                    return zb(t = this.paymentMethods).call(t, function(t) {
                        return t.type === r.mapCreatedComponentType(e);
                    });
                }
            }
        ]), e;
    }();
    function i1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function l1(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = i1(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = i1(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var c1 = function(e) {
        return function(t, r) {
            return Q0(t.paymentMethodType, l1(l1(l1({}, r), t), {}, {
                onComplete: r.onAdditionalDetails,
                onError: r.onError,
                statusType: e
            }));
        };
    }, s1 = {
        redirect: function(e, t) {
            return Q0("redirect", l1(l1(l1({}, t), e), {}, {
                statusType: "redirect"
            }));
        },
        threeDS2Fingerprint: function(e, t) {
            return Q0("threeDS2DeviceFingerprint", l1(l1({
                createFromAction: t.createFromAction,
                token: e.token,
                paymentData: e.paymentData,
                onError: t.onError,
                showSpinner: !t.isDropin,
                isDropin: !!t.isDropin
            }, t), {}, {
                type: "IdentifyShopper",
                onComplete: t.onAdditionalDetails,
                statusType: "loading",
                useOriginalFlow: !0
            }));
        },
        threeDS2Challenge: function(e, t) {
            var r;
            return Q0("threeDS2Challenge", l1(l1({}, t), {}, {
                token: e.token,
                paymentData: e.paymentData,
                onComplete: t.onAdditionalDetails,
                onError: t.onError,
                size: null !== (r = t.size) && void 0 !== r ? r : "02",
                isDropin: !!t.isDropin,
                type: "ChallengeShopper",
                statusType: "custom",
                useOriginalFlow: !0
            }));
        },
        threeDS2: function(e, t) {
            var r = "fingerprint" === e.subtype ? "threeDS2DeviceFingerprint" : "threeDS2Challenge", a = "fingerprint" === e.subtype ? e.paymentData : e.authorisationToken, n = l1({
                token: e.token,
                paymentData: a,
                onActionHandled: t.onActionHandled,
                onComplete: t.onAdditionalDetails,
                onError: t.onError,
                isDropin: !!t.isDropin,
                loadingContext: t.loadingContext,
                clientKey: t.clientKey,
                _parentInstance: t._parentInstance,
                paymentMethodType: t.paymentMethodType,
                challengeWindowSize: t.challengeWindowSize
            }, function(e, t) {
                if ("fingerprint" === e) {
                    var r = bV(t.elementRef ? _Y : NY).from(t);
                    return r.showSpinner = !t.isDropin, r.statusType = "loading", r;
                }
                return {
                    statusType: "custom",
                    i18n: t.i18n
                };
            }(e.subtype, t));
            return Q0(r, n);
        },
        voucher: c1("custom"),
        qrCode: c1("custom"),
        await: c1("custom"),
        bankTransfer: c1("custom"),
        sdk: c1("custom")
    };
    function u1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var d1 = function(e) {
        return function(t) {
            var r, a, n = function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r, a, n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Ag(r = u1(Object(n), !0)).call(r, function(t) {
                        Sg(e, t, n[t]);
                    }) : Jy ? ng(e, Jy(n)) : Ag(a = u1(Object(n))).call(a, function(t) {
                        og(e, t, Wy(n, t));
                    });
                }
                return e;
            }({
                version: "5.59.0",
                payload_version: 1,
                platform: "web",
                locale: e.locale
            }, t), o = hC(r = Ty(n)).call(r, function(e) {
                var t;
                return wb(t = "".concat(encodeURIComponent(e), "=")).call(t, encodeURIComponent(n[e]));
            }).join("&");
            (new Image).src = wb(a = "".concat(e.loadingContext, "images/analytics.png?")).call(a, o);
        };
    };
    function p1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var m1 = function(e) {
        return function(t) {
            var r, a;
            if (!e.clientKey) return Sb.reject();
            var n = {
                errorLevel: "silent",
                loadingContext: e.loadingContext,
                path: "v2/analytics/log?clientKey=".concat(e.clientKey)
            }, o = function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r, a, n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Ag(r = p1(Object(n), !0)).call(r, function(t) {
                        Sg(e, t, n[t]);
                    }) : Jy ? ng(e, Jy(n)) : Ag(a = p1(Object(n))).call(a, function(t) {
                        og(e, t, Wy(n, t));
                    });
                }
                return e;
            }({
                amount: {
                    value: (null === (r = e.amount) || void 0 === r ? void 0 : r.value) || 0,
                    currency: null === (a = e.amount) || void 0 === a ? void 0 : a.currency
                },
                version: "5.59.0",
                channel: "Web",
                locale: e.locale,
                flavor: "components",
                userAgent: navigator.userAgent,
                referrer: window.location.href,
                screenWidth: window.screen.width
            }, t);
            return cT(n, o);
        };
    }, f1 = function() {
        function e() {
            Cg(this, e), Sg(this, "storage", void 0), this.storage = {};
        }
        return wg(e, [
            {
                key: "length",
                get: function() {
                    return Ty(this.storage).length;
                }
            },
            {
                key: "key",
                value: function(e) {
                    var t;
                    return Kk(t = Ty(this.storage)).call(t, e);
                }
            },
            {
                key: "getItem",
                value: function(e) {
                    return this.storage[e] || null;
                }
            },
            {
                key: "setItem",
                value: function(e, t) {
                    return this.storage[e] = t;
                }
            },
            {
                key: "removeItem",
                value: function(e) {
                    delete this.storage[e];
                }
            },
            {
                key: "clear",
                value: function() {
                    this.storage = {};
                }
            }
        ]), e;
    }(), h1 = function() {
        function e(t, r) {
            Cg(this, e), Sg(this, "prefix", "adyen-checkout__"), Sg(this, "key", void 0), Sg(this, "storage", void 0);
            try {
                this.storage = r ? window[r] : window.localStorage;
            } catch (e) {
                this.storage = new f1;
            }
            this.key = this.prefix + t;
        }
        return wg(e, [
            {
                key: "get",
                value: function() {
                    try {
                        return JSON.parse(this.storage.getItem(this.key));
                    } catch (e) {
                        return null;
                    }
                }
            },
            {
                key: "set",
                value: function(e) {
                    this.storage.setItem(this.key, Mb(e));
                }
            },
            {
                key: "remove",
                value: function() {
                    this.storage.removeItem(this.key);
                }
            }
        ]), e;
    }();
    var v1 = function(e) {
        var t, r = e.loadingContext, a = e.clientKey, n = e.experiments, o = {
            errorLevel: "silent",
            loadingContext: r,
            path: "v2/analytics/id?clientKey=".concat(a)
        };
        return function() {
            if (t) return t;
            if (!a) return Sb.reject();
            var e = new h1("checkout-attempt-id", "sessionStorage"), r = e.get();
            return function(e) {
                if (null == e || !e.id) return !1;
                var t = eD() - 9e5;
                return e.timestamp > t;
            }(r) ? Sb.resolve(r.id) : t = cT(o, {
                experiments: n
            }).then(function(t) {
                if (t.id) return e.set({
                    id: t.id,
                    timestamp: eD()
                }), t.id;
            }).catch(function() {});
        };
    }, y1 = function() {
        function e() {
            Cg(this, e), Sg(this, "events", []);
        }
        return wg(e, [
            {
                key: "add",
                value: function(e) {
                    this.events.push(e);
                }
            },
            {
                key: "run",
                value: function(e) {
                    var t, r = hC(t = this.events).call(t, function(t) {
                        return t(e);
                    });
                    return this.events = [], Sb.all(r);
                }
            }
        ]), e;
    }();
    function g1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function b1(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = g1(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = g1(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var k1 = function() {
        function e(t) {
            var r = t.loadingContext, a = t.locale, n = t.clientKey, o = t.analytics, i = t.amount;
            Cg(this, e), Sg(this, "checkoutAttemptId", null), Sg(this, "props", void 0), Sg(this, "logEvent", void 0), Sg(this, "logTelemetry", void 0), Sg(this, "queue", new y1), Sg(this, "collectId", void 0), this.props = b1(b1({}, e.defaultProps), o), this.logEvent = d1({
                loadingContext: r,
                locale: a
            }), this.logTelemetry = m1({
                loadingContext: r,
                locale: a,
                clientKey: n,
                amount: i
            }), this.collectId = v1({
                loadingContext: r,
                clientKey: n,
                experiments: this.props.experiments
            });
            var l = this.props, c = l.telemetry, s = l.enabled;
            !0 === c && !0 === s && this.props.checkoutAttemptId && (this.checkoutAttemptId = this.props.checkoutAttemptId, this.queue.run(this.checkoutAttemptId));
        }
        return wg(e, [
            {
                key: "send",
                value: function(e) {
                    var t = this, r = this.props, a = r.enabled, n = r.payload, o = r.telemetry;
                    if (!0 === a) {
                        if (!0 !== o || this.checkoutAttemptId || this.collectId().then(function(e) {
                            t.checkoutAttemptId = e, t.queue.run(t.checkoutAttemptId);
                        }).catch(function(e) {
                            console.warn("Fetching checkoutAttemptId failed.".concat(e ? " Error=".concat(e) : ""));
                        }), !0 === o) this.queue.add(function(r) {
                            return t.logTelemetry(b1(b1(b1({}, e), n && b1({}, n)), {}, {
                                checkoutAttemptId: r
                            })).catch(function() {});
                        }), this.checkoutAttemptId && this.queue.run(this.checkoutAttemptId);
                        this.logEvent(e);
                    }
                }
            }
        ]), e;
    }();
    function C1(e) {
        var t;
        return tC(t = Ty(e)).call(t, function(t, r) {
            return kb(tT).call(tT, r) && (t[r] = e[r]), t;
        }, {});
    }
    Sg(k1, "defaultProps", {
        enabled: !0,
        telemetry: !0,
        checkoutAttemptId: null,
        experiments: []
    });
    var _1 = "v1";
    function N1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function P1(e, t) {
        var r, a, n = wb(r = wb(a = "".concat(_1, "/sessions/")).call(a, t.id, "/payments?clientKey=")).call(r, t.clientKey), o = function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ag(r = N1(Object(n), !0)).call(r, function(t) {
                    Sg(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Ag(a = N1(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({
            sessionData: t.data
        }, e);
        return cT({
            loadingContext: t.loadingContext,
            path: n,
            errorLevel: "fatal"
        }, o);
    }
    function w1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function S1(e, t) {
        var r, a, n = wb(r = wb(a = "".concat(_1, "/sessions/")).call(a, t.id, "/paymentDetails?clientKey=")).call(r, t.clientKey), o = function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ag(r = w1(Object(n), !0)).call(r, function(t) {
                    Sg(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Ag(a = w1(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({
            sessionData: t.data
        }, e);
        return cT({
            loadingContext: t.loadingContext,
            path: n,
            errorLevel: "fatal"
        }, o);
    }
    function A1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function I1(e, t) {
        var r, a, n = wb(r = wb(a = "".concat(_1, "/sessions/")).call(a, e.id, "/setup?clientKey=")).call(r, e.clientKey), o = function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ag(r = A1(Object(n), !0)).call(r, function(t) {
                    Sg(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Ag(a = A1(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({
            sessionData: e.data
        }, t.order ? {
            order: {
                orderData: t.order.orderData,
                pspReference: t.order.pspReference
            }
        } : {});
        return cT({
            loadingContext: e.loadingContext,
            path: n,
            errorLevel: "fatal",
            errorMessage: "ERROR: Invalid ClientKey"
        }, o);
    }
    function D1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function E1(e, t) {
        var r, a, n = wb(r = wb(a = "".concat(_1, "/sessions/")).call(a, t.id, "/paymentMethodBalance?clientKey=")).call(r, t.clientKey), o = function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ag(r = D1(Object(n), !0)).call(r, function(t) {
                    Sg(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Ag(a = D1(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({
            sessionData: t.data
        }, e);
        return cT({
            loadingContext: t.loadingContext,
            path: n,
            errorLevel: "fatal"
        }, o);
    }
    function R1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function x1(e) {
        if (!e || !e.id) throw new Error("Invalid session");
        return function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r, a, n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ag(r = R1(Object(n), !0)).call(r, function(t) {
                    Sg(e, t, n[t]);
                }) : Jy ? ng(e, Jy(n)) : Ag(a = R1(Object(n))).call(a, function(t) {
                    og(e, t, Wy(n, t));
                });
            }
            return e;
        }({
            id: e.id
        }, e.sessionData ? {
            sessionData: e.sessionData
        } : {});
    }
    function F1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    var T1 = function() {
        function e(t, r, a) {
            Cg(this, e), Sg(this, "session", void 0), Sg(this, "storage", void 0), Sg(this, "clientKey", void 0), Sg(this, "loadingContext", void 0), Sg(this, "configuration", void 0);
            var n = x1(t);
            if (!r) throw new Error("No clientKey available");
            if (!a) throw new Error("No loadingContext available");
            this.storage = new h1("session", "localStorage"), this.clientKey = r, this.loadingContext = a, this.session = n, this.session.sessionData ? this.storeSession() : this.session = this.getStoredSession();
        }
        return wg(e, [
            {
                key: "id",
                get: function() {
                    return this.session.id;
                }
            },
            {
                key: "data",
                get: function() {
                    return this.session.sessionData;
                }
            },
            {
                key: "updateSessionData",
                value: function(e) {
                    this.session.sessionData = e, this.storeSession();
                }
            },
            {
                key: "setupSession",
                value: function(e) {
                    var t = this;
                    return I1(this, e).then(function(e) {
                        return e.configuration && (t.configuration = function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var r, a, n = null != arguments[t] ? arguments[t] : {};
                                t % 2 ? Ag(r = F1(Object(n), !0)).call(r, function(t) {
                                    Sg(e, t, n[t]);
                                }) : Jy ? ng(e, Jy(n)) : Ag(a = F1(Object(n))).call(a, function(t) {
                                    og(e, t, Wy(n, t));
                                });
                            }
                            return e;
                        }({}, e.configuration)), e.sessionData && t.updateSessionData(e.sessionData), e;
                    });
                }
            },
            {
                key: "submitPayment",
                value: function(e) {
                    var t = this;
                    return P1(e, this).then(function(e) {
                        return e.sessionData && t.updateSessionData(e.sessionData), e;
                    });
                }
            },
            {
                key: "submitDetails",
                value: function(e) {
                    var t = this;
                    return S1(e, this).then(function(e) {
                        return e.sessionData && t.updateSessionData(e.sessionData), e;
                    });
                }
            },
            {
                key: "checkBalance",
                value: function(e) {
                    var t = this;
                    return E1(e, this).then(function(e) {
                        return e.sessionData && t.updateSessionData(e.sessionData), e;
                    });
                }
            },
            {
                key: "createOrder",
                value: function() {
                    var e = this;
                    return (function(e) {
                        var t, r, a = wb(t = wb(r = "".concat(_1, "/sessions/")).call(r, e.id, "/orders?clientKey=")).call(t, e.clientKey), n = {
                            sessionData: e.data
                        };
                        return cT({
                            loadingContext: e.loadingContext,
                            path: a,
                            errorLevel: "fatal"
                        }, n);
                    })(this).then(function(t) {
                        return t.sessionData && e.updateSessionData(t.sessionData), t;
                    });
                }
            },
            {
                key: "cancelOrder",
                value: function(e) {
                    var t = this;
                    return (function(e, t) {
                        var r, a, n = wb(r = wb(a = "".concat(_1, "/sessions/")).call(a, t.id, "/orders/cancel?clientKey=")).call(r, t.clientKey), o = {
                            sessionData: t.data,
                            order: e
                        };
                        return cT({
                            loadingContext: t.loadingContext,
                            path: n,
                            errorLevel: "fatal"
                        }, o);
                    })(e.order, this).then(function(e) {
                        return e.sessionData && t.updateSessionData(e.sessionData), e;
                    });
                }
            },
            {
                key: "getStoredSession",
                value: function() {
                    var e = this.storage.get();
                    return this.id === (null == e ? void 0 : e.id) ? e : this.session;
                }
            },
            {
                key: "storeSession",
                value: function() {
                    this.storage.set({
                        id: this.session.id,
                        sessionData: this.session.sessionData
                    });
                }
            },
            {
                key: "removeStoredSession",
                value: function() {
                    this.storage.remove();
                }
            }
        ]), e;
    }();
    function z1(e) {
        var t = e.setComponentRef, r = gP({});
        Ty(r.current).length || null == t || t(r.current);
        var a = Vk(fP(null), 2), n = a[0], o = a[1];
        return r.current.setMessages = function(e) {
            o(e);
        }, n ? rN(nN, null, hC(n).call(n, function(e) {
            return rN("div", j_({
                key: e,
                className: "adyen-checkout-sr-panel__msg"
            }, !1), e);
        })) : null;
    }
    function O1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function j1(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = O1(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = O1(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    function B1(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !b_) return !1;
            if (b_.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(b_(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = U_(e);
            if (t) {
                var n = U_(this).constructor;
                r = b_(a, arguments, n);
            } else r = a.apply(this, arguments);
            return V_(this, r);
        };
    }
    var M1 = function(e) {
        L_(r, e);
        var t = B1(r);
        function r(e) {
            var a, n;
            if (Cg(this, r), Sg(B_(n = t.call(this, e)), "srPanelContainer", null), Sg(B_(n), "id", void 0), Sg(B_(n), "showPanel", void 0), Sg(B_(n), "_enabled", void 0), Sg(B_(n), "_moveFocus", void 0), Sg(B_(n), "componentRef", void 0), Sg(B_(n), "setComponentRef", function(e) {
                n.componentRef = e;
            }), Sg(B_(n), "setMessages", function(e) {
                if (n.props.enabled) {
                    var t = null;
                    e && (t = JN(e) ? e : [
                        e
                    ]), n.componentRef.setMessages(t);
                }
            }), n.id = n.props.id, n.showPanel = !1, n._enabled = !1, n._moveFocus = null === (a = n.props.moveFocus) || void 0 === a || a, n.props.enabled) {
                if (n._enabled = !0, !document.querySelector(n.props.node)) throw new Error("Component could not mount. Root node was not found.");
                var o = document.getElementById(n.id);
                o && document.querySelector(n.props.node).removeChild(o), n.srPanelContainer = document.createElement("div"), n.srPanelContainer.className = "sr-panel-holder", n.srPanelContainer.id = n.id, document.querySelector(n.props.node).appendChild(n.srPanelContainer), n.mount(n.srPanelContainer);
            }
            return n;
        }
        return wg(r, [
            {
                key: "enabled",
                get: function() {
                    return this._enabled;
                }
            },
            {
                key: "moveFocus",
                get: function() {
                    return this._moveFocus;
                }
            },
            {
                key: "setAriaProps",
                value: function(e) {
                    for(var t = document.querySelector('[class^="adyen-checkout-sr-panel"]'), r = 0, a = Tz(e); r < a.length; r++){
                        var n = Vk(a[r], 2), o = n[0], i = n[1];
                        t.setAttribute(o, i);
                    }
                    this.props = j1(j1({}, this.props), {}, {
                        ariaAttributes: j1(j1({}, this.props.ariaAttributes), e)
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    return this.props.enabled ? rN("div", j_({
                        className: this.showPanel ? "adyen-checkout-sr-panel" : "adyen-checkout-sr-panel--sr-only",
                        role: "log"
                    }, this.props.ariaAttributes, !1), rN(z1, {
                        setComponentRef: this.setComponentRef
                    })) : null;
                }
            }
        ]), r;
    }(xN);
    Sg(M1, "type", "srPanel"), Sg(M1, "defaultProps", {
        enabled: !0,
        node: "body",
        showPanel: !1,
        id: "ariaLiveSRPanel",
        ariaAttributes: {
            "aria-relevant": "all",
            "aria-live": "polite",
            "aria-atomic": "true"
        }
    });
    var L1 = [
        "amount",
        "shopperLocale",
        "paymentMethods"
    ];
    function V1(e, t) {
        var r = Ty(e);
        if (Oy) {
            var a = Oy(e);
            t && (a = Fg(a).call(a, function(t) {
                return Wy(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function U1(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, a, n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ag(r = V1(Object(n), !0)).call(r, function(t) {
                Sg(e, t, n[t]);
            }) : Jy ? ng(e, Jy(n)) : Ag(a = V1(Object(n))).call(a, function(t) {
                og(e, t, Wy(n, t));
            });
        }
        return e;
    }
    var K1 = function() {
        function e(t) {
            var r, a, n, o, i, l, c = this;
            Cg(this, e), Sg(this, "session", void 0), Sg(this, "paymentMethodsResponse", void 0), Sg(this, "modules", void 0), Sg(this, "options", void 0), Sg(this, "components", []), Sg(this, "loadingContext", void 0), Sg(this, "cdnContext", void 0), Sg(this, "update", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return c.setOptions(e), c.initialize().then(function() {
                    var e;
                    return Ag(e = c.components).call(e, function(e) {
                        return e.update(c.getPropsForComponent(c.options));
                    }), c;
                });
            }), Sg(this, "remove", function(e) {
                var t;
                return c.components = Fg(t = c.components).call(t, function(t) {
                    return t._id !== e._id;
                }), e.unmount(), c;
            }), Sg(this, "setOptions", function(e) {
                fA(null == e ? void 0 : e.paymentMethodsConfiguration, "scheme") && console.warn('WARNING: You cannot define a property "scheme" on the paymentMethodsConfiguration object - it should be defined as "card" otherwise it will be ignored'), fA(e, "installmentOptions") && console.warn("WARNING: you are setting installmentOptions directly in the top level configuration object. They should be set via the 'paymentMethodsConfiguration' object or directly on the 'card' component."), c.options = U1(U1({}, c.options), e);
            }), this.create = Jg(r = this.create).call(r, this), this.createFromAction = Jg(a = this.createFromAction).call(a, this), this.setOptions(t), this.loadingContext = function() {
                var e = arguments.length > 1 ? arguments[1] : void 0;
                return e || ({
                    test: "https://checkoutshopper-test.adyen.com/checkoutshopper/",
                    live: "https://checkoutshopper-live.adyen.com/checkoutshopper/",
                    "live-us": "https://checkoutshopper-live-us.adyen.com/checkoutshopper/",
                    "live-au": "https://checkoutshopper-live-au.adyen.com/checkoutshopper/",
                    "live-apse": "https://checkoutshopper-live-apse.adyen.com/checkoutshopper/",
                    "live-in": "https://checkoutshopper-live-in.adyen.com/checkoutshopper/"
                })[(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").toLowerCase()] || "https://checkoutshopper-live.adyen.com/checkoutshopper/";
            }(this.options.environment, null === (n = this.options.environmentUrls) || void 0 === n ? void 0 : n.api), this.cdnContext = function() {
                var e = arguments.length > 1 ? arguments[1] : void 0;
                return e || ({
                    beta: "https://cdf6519016.cdn.adyen.com/checkoutshopper/",
                    test: "https://checkoutshopper-test.adyen.com/checkoutshopper/",
                    live: "https://checkoutshopper-live.adyen.com/checkoutshopper/",
                    "live-us": "https://checkoutshopper-live-us.adyen.com/checkoutshopper/",
                    "live-au": "https://checkoutshopper-live-au.adyen.com/checkoutshopper/",
                    "live-apse": "https://checkoutshopper-live-apse.adyen.com/checkoutshopper/",
                    "live-in": "https://checkoutshopper-live-in.adyen.com/checkoutshopper/"
                })[(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").toLowerCase()] || DP;
            }(this.options.resourceEnvironment || this.options.environment, null === (o = this.options.environmentUrls) || void 0 === o ? void 0 : o.api);
            var s, u = null === (i = this.options.clientKey) || void 0 === i ? void 0 : i.substr(0, 4);
            if (("test" === u || "live" === u) && !kb(l = this.loadingContext).call(l, u)) throw new Error(wb(s = "Error: you are using a '".concat(u, "' clientKey against the '")).call(s, this.options.environment, "' environment"));
            window.adyenWebVersion = e.version.version;
        }
        return wg(e, [
            {
                key: "initialize",
                value: function() {
                    var e = this;
                    return this.options.session ? (this.session = new T1(this.options.session, this.options.clientKey, this.loadingContext), this.session.setupSession(this.options).then(function(t) {
                        var r = t.amount, a = t.shopperLocale, n = t.paymentMethods, o = kg(t, L1);
                        return e.setOptions(U1(U1({}, o), {}, {
                            amount: e.options.order ? e.options.order.remainingAmount : r,
                            locale: e.options.locale || a
                        })), e.createPaymentMethodsList(n), e.createCoreModules(), e;
                    }).catch(function(t) {
                        return e.options.onError && e.options.onError(t), e;
                    })) : (this.createCoreModules(), this.createPaymentMethodsList(), Sb.resolve(this));
                }
            },
            {
                key: "submitDetails",
                value: function(e) {
                    var t = this;
                    if (this.options.onAdditionalDetails) return this.options.onAdditionalDetails(e);
                    this.session && this.session.submitDetails(e).then(function(e) {
                        var r, a;
                        null === (r = (a = t.options).onPaymentCompleted) || void 0 === r || r.call(a, e);
                    }).catch(function(e) {
                        var r, a;
                        null === (r = (a = t.options).onError) || void 0 === r || r.call(a, e);
                    });
                }
            },
            {
                key: "create",
                value: function(e, t) {
                    var r = this.getPropsForComponent(t);
                    return e ? this.handleCreate(e, r) : this.handleCreateError();
                }
            },
            {
                key: "createFromAction",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (!e || !e.type) {
                        if (fA(e, "action") && fA(e, "resultCode")) throw new Error('createFromAction::Invalid Action - the passed action object itself has an "action" property and a "resultCode": have you passed in the whole response object by mistake?');
                        throw new Error('createFromAction::Invalid Action - the passed action object does not have a "type" property');
                    }
                    if (e.type) {
                        var r = Z0(e.type, this.options.paymentMethodsConfiguration);
                        return function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = s1[e.type];
                            if (r && "function" == typeof r) return r(e, t);
                            throw new Error("Invalid Action");
                        }(e, U1(U1(U1({}, C1(this.options)), r), this.getPropsForComponent(t)));
                    }
                    return this.handleCreateError();
                }
            },
            {
                key: "getPropsForComponent",
                value: function(e) {
                    return U1(U1(U1({
                        paymentMethods: this.paymentMethodsResponse.paymentMethods,
                        storedPaymentMethods: this.paymentMethodsResponse.storedPaymentMethods
                    }, "FI" === this.options.countryCode ? {
                        openFirstPaymentMethod: !1,
                        openFirstStoredPaymentMethod: !1
                    } : {}), e), {}, {
                        i18n: this.modules.i18n,
                        modules: this.modules,
                        session: this.session,
                        loadingContext: this.loadingContext,
                        cdnContext: this.cdnContext,
                        createFromAction: this.createFromAction,
                        _parentInstance: this
                    });
                }
            },
            {
                key: "handleCreate",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (e.prototype instanceof gA) {
                        var r, a = "dropin" !== t.type && !t.isDropin, n = a && !t.supportedShopperInteractions ? zb(r = this.paymentMethodsResponse).call(r, t.type) : {}, o = a ? Z0(t.type, this.options.paymentMethodsConfiguration, !!t.storedPaymentMethodId) : {}, i = new e(U1(U1(U1(U1({}, C1(this.options)), n), o), t));
                        return t.isDropin || this.components.push(i), i;
                    }
                    if ("string" == typeof e && Y0[e]) return "dropin" === e && fA(t, "paymentMethodsConfiguration") && console.warn("WARNING: You are setting a 'paymentMethodsConfiguration' object in the Dropin configuration options. This object will be ignored."), this.handleCreate(Y0[e], U1({
                        type: e
                    }, t));
                    if ("string" == typeof e && this.paymentMethodsResponse.has(e)) return this.handleCreate(Y0.redirect, U1({
                        type: e
                    }, t));
                    if ("object" === ig(e) && "string" == typeof e.type) {
                        var l = Z0(e.type, this.options.paymentMethodsConfiguration, !!e.storedPaymentMethodId);
                        return this.handleCreate(e.type, U1(U1(U1({}, e), t), l));
                    }
                    return this.handleCreateError(e);
                }
            },
            {
                key: "handleCreateError",
                value: function(e) {
                    var t, r = e && e.name ? e.name : "The passed payment method", a = e ? wb(t = "".concat(r, " is not a valid Checkout Component. What was passed as a txVariant was: ")).call(t, Mb(e), ". Check if this payment method is configured in the Backoffice or if the txVariant is a valid one") : "No Payment Method component was passed";
                    throw new Error(a);
                }
            },
            {
                key: "createPaymentMethodsList",
                value: function(e) {
                    this.paymentMethodsResponse = new o1(this.options.paymentMethodsResponse || e, this.options);
                }
            },
            {
                key: "createCoreModules",
                value: function() {
                    this.modules || (this.modules = yk({
                        risk: new jA(U1(U1({}, this.options), {}, {
                            loadingContext: this.loadingContext
                        })),
                        analytics: new k1({
                            loadingContext: this.loadingContext,
                            clientKey: this.options.clientKey,
                            locale: this.options.locale,
                            analytics: this.options.analytics,
                            amount: this.options.amount
                        }),
                        resources: new FP(this.cdnContext),
                        i18n: new a_(this.options.locale, this.options.translations),
                        srPanel: new M1(this.options.srConfig)
                    }));
                }
            }
        ]), e;
    }();
    function H1() {
        return H1 = Jd(Ey.mark(function e(t) {
            var r;
            return Ey.wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return r = new K1(t), e.next = 3, r.initialize();
                    case 3:
                        return e.abrupt("return", e.sent);
                    case 4:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), H1.apply(this, arguments);
    }
    Sg(K1, "version", {
        version: "5.59.0",
        revision: "5aa9dae",
        branch: "HEAD",
        buildId: "@adyen/adyen-web-e4d570aa-a8a0-4124-8725-edea34f94954"
    });
    var q1 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "\u062F\u0641\u0639",
            "payButton.redirecting": "\u062C\u0627\u0631\u0650 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0648\u062C\u064A\u0647...",
            "payButton.with": "\u0627\u062F\u0641\u0639 %{value} \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 %{maskedData}",
            "payButton.saveDetails": "\u062D\u0641\u0638 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644",
            close: "\u0625\u063A\u0644\u0627\u0642",
            storeDetails: "\u062D\u0641\u0638 \u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A\u064A \u0627\u0644\u0642\u0627\u062F\u0645\u0629",
            readMore: "\u0627\u0642\u0631\u0623 \u0627\u0644\u0645\u0632\u064A\u062F",
            "creditCard.holderName": "\u0627\u0644\u0627\u0633\u0645 \u0639\u0644\u0649 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "creditCard.holderName.placeholder": "\u062C\u0645\u064A\u0644 \u0633\u0639\u064A\u062F",
            "creditCard.holderName.invalid": "\u0623\u062F\u062E\u0644 \u0627\u0644\u0627\u0633\u0645 \u0643\u0645\u0627 \u0647\u0648 \u0645\u0648\u0636\u062D \u0639\u0644\u0649 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "creditCard.numberField.title": "\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "creditCard.numberField.placeholder": "3456 9012 5678 1234",
            "creditCard.expiryDateField.title": "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "creditCard.expiryDateField.placeholder": "\u0634\u0647\u0631/\u0633\u0646\u0629",
            "creditCard.expiryDateField.month": "\u0634\u0647\u0631",
            "creditCard.expiryDateField.month.placeholder": "\u0634\u0647\u0631",
            "creditCard.expiryDateField.year.placeholder": "\u0633\u0646\u0629",
            "creditCard.expiryDateField.year": "\u0633\u0646\u0629",
            "creditCard.cvcField.title": "\u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "\u0627\u062D\u062A\u0641\u0638 \u0628\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0644\u0645\u0631\u0629 \u0627\u0644\u0642\u0627\u062F\u0645\u0629",
            "creditCard.cvcField.placeholder.4digits": "4 \u0623\u0631\u0642\u0627\u0645",
            "creditCard.cvcField.placeholder.3digits": "3 \u0623\u0631\u0642\u0627\u0645",
            "creditCard.taxNumber.placeholder": "\u064A\u0648\u0645 \u0634\u0647\u0631 \u0633\u0646\u0629 / 0123456789",
            installments: "\u0639\u062F\u062F \u0627\u0644\u0623\u0642\u0633\u0627\u0637",
            installmentOption: "%{times} \xd7 %{partialValue}",
            installmentOptionMonths: "%{times} \u0623\u0634\u0647\u0631",
            "installments.oneTime": "\u0627\u0644\u062F\u0641\u0639 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629",
            "installments.installments": "\u0627\u0644\u062F\u0641\u0639 \u0639\u0644\u0649 \u0623\u0642\u0633\u0627\u0637",
            "installments.revolving": "\u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u062F\u0648\u0631\u064A",
            "sepaDirectDebit.ibanField.invalid": "\u0631\u0642\u0645 \u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "sepaDirectDebit.nameField.placeholder": "\u062C\u0645\u064A\u0644 \u0633\u0639\u064A\u062F",
            "sepa.ownerName": "\u0635\u0627\u062D\u0628 \u0627\u0644\u062D\u0633\u0627\u0628",
            "sepa.ibanNumber": "\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 (IBAN)",
            "error.title": "\u062E\u0637\u0623",
            "error.subtitle.redirect": "\u0641\u0634\u0644 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0648\u062C\u064A\u0647",
            "error.subtitle.payment": "\u0641\u0634\u0644 \u0627\u0644\u062F\u0641\u0639",
            "error.subtitle.refused": "\u062A\u0645 \u0631\u0641\u0636 \u0627\u0644\u062F\u0641\u0639",
            "error.message.unknown": "\u062D\u062F\u062B \u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641",
            "errorPanel.title": "\u0627\u0644\u0623\u062E\u0637\u0627\u0621 \u0627\u0644\u0645\u0648\u062C\u0648\u062F\u0629",
            "idealIssuer.selectField.title": "\u0627\u0644\u0628\u0646\u0643",
            "idealIssuer.selectField.placeholder": "\u062D\u062F\u062F \u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u0630\u064A \u062A\u062A\u0639\u0627\u0645\u0644 \u0645\u0639\u0647",
            "creditCard.success": "\u0646\u062C\u062D \u0627\u0644\u062F\u0641\u0639",
            loading: "\u062C\u0627\u0631\u0650 \u0627\u0644\u062A\u062D\u0645\u064A\u0644...",
            continue: "\u0645\u062A\u0627\u0628\u0639\u0629",
            continueTo: "\u0645\u062A\u0627\u0628\u0639\u0629 \u0625\u0644\u0649",
            "wechatpay.timetopay": "\u0644\u062F\u064A\u0643 %@ \u0644\u0644\u062F\u0641\u0639",
            "sr.wechatpay.timetopay": "\u0644\u062F\u064A\u0643 %#\u062F\u0642\u0627\u0626\u0642%# %#\u062B\u0648\u0627\u0646%# \u0644\u0644\u062F\u0641\u0639",
            "wechatpay.scanqrcode": "\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629",
            personalDetails: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0634\u062E\u0635\u064A\u0629",
            companyDetails: "\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0634\u0631\u0643\u0629",
            "companyDetails.name": "\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629",
            "companyDetails.registrationNumber": "\u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
            socialSecurityNumber: "\u0631\u0642\u0645 \u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u064A",
            firstName: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644",
            "firstName.invalid": "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645\u0643 \u0627\u0644\u0623\u0648\u0644",
            infix: "\u0628\u0627\u062F\u0626\u0629",
            lastName: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u062E\u064A\u0631",
            "lastName.invalid": "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645\u0643 \u0627\u0644\u0623\u062E\u064A\u0631",
            mobileNumber: "\u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644",
            "mobileNumber.invalid": "\u0631\u0642\u0645 \u062C\u0648\u0627\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            city: "\u0627\u0644\u0645\u062F\u064A\u0646\u0629",
            postalCode: "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A",
            "postalCode.optional": "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
            countryCode: "\u0631\u0645\u0632 \u0627\u0644\u0628\u0644\u062F",
            telephoneNumber: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641",
            dateOfBirth: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
            shopperEmail: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
            gender: "\u0627\u0644\u0646\u0648\u0639",
            "gender.notselected": "\u062D\u062F\u062F \u0646\u0648\u0639\u0643",
            male: "\u0630\u0643\u0631",
            female: "\u0623\u0646\u062B\u0649",
            billingAddress: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
            street: "\u0627\u0644\u0634\u0627\u0631\u0639",
            stateOrProvince: "\u0627\u0644\u0648\u0644\u0627\u064A\u0629 \u0623\u0648 \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629",
            country: "\u0627\u0644\u0628\u0644\u062F",
            houseNumberOrName: "\u0631\u0642\u0645 \u0627\u0644\u0645\u0646\u0632\u0644",
            separateDeliveryAddress: "\u062D\u062F\u062F \u0639\u0646\u0648\u0627\u0646 \u062A\u0633\u0644\u064A\u0645 \u0645\u0646\u0641\u0635\u0644",
            deliveryAddress: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u062A\u0633\u0644\u064A\u0645",
            "deliveryAddress.firstName": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 \u0644\u0644\u0645\u0633\u062A\u0644\u0645",
            "deliveryAddress.lastName": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u062E\u064A\u0631 \u0644\u0644\u0645\u0633\u062A\u0644\u0645",
            zipCode: "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A",
            apartmentSuite: "\u0627\u0644\u0634\u0642\u0629 / \u0627\u0644\u062C\u0646\u0627\u062D",
            provinceOrTerritory: "\u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629 \u0623\u0648 \u0627\u0644\u0625\u0642\u0644\u064A\u0645",
            cityTown: "\u0627\u0644\u0645\u062F\u064A\u0646\u0629 / \u0627\u0644\u0628\u0644\u062F\u0629",
            address: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
            "address.placeholder": "\u0627\u0628\u062D\u062B \u0639\u0646 \u0639\u0646\u0648\u0627\u0646\u0643",
            "address.errors.incomplete": "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646\u064B\u0627 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629",
            "address.enterManually": "\u0623\u062F\u062E\u0644 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u064A\u062F\u0648\u064A\u064B\u0627",
            state: "\u0627\u0644\u0648\u0644\u0627\u064A\u0629",
            "field.title.optional": "(\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
            "creditCard.cvcField.title.optional": "\u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
            "issuerList.wallet.placeholder": "\u062D\u062F\u062F \u0645\u062D\u0641\u0638\u062A\u0643",
            privacyPolicy: "\u0633\u064A\u0627\u0633\u0629 \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629",
            "afterPay.agreement": "\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u066A @ \u0644\u0634\u0631\u0643\u0629 Riverty",
            paymentConditions: "\u0634\u0631\u0648\u0637 \u0627\u0644\u062F\u0641\u0639",
            openApp: "\u0641\u062A\u062D \u0627\u0644\u062A\u0637\u0628\u064A\u0642",
            "voucher.readInstructions": "\u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u0627\u062A",
            "voucher.introduction": "\u0634\u0643\u0631\u064B\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060C \u064A\u0631\u062C\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0642\u0633\u064A\u0645\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0644\u0625\u062A\u0645\u0627\u0645 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639.",
            "voucher.expirationDate": "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "voucher.alternativeReference": "\u0627\u0644\u0645\u0631\u062C\u0639 \u0627\u0644\u0628\u062F\u064A\u0644",
            "dragonpay.voucher.non.bank.selectField.placeholder": "\u062D\u062F\u062F \u0645\u0642\u062F\u0645 \u0627\u0644\u062E\u062F\u0645\u0629",
            "dragonpay.voucher.bank.selectField.placeholder": "\u062D\u062F\u062F \u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u0630\u064A \u062A\u062A\u0639\u0627\u0645\u0644 \u0645\u0639\u0647",
            "voucher.paymentReferenceLabel": "\u0645\u0631\u062C\u0639 \u0627\u0644\u062F\u0641\u0639",
            "voucher.surcharge": "\u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 %@ \u0631\u0633\u0645\u064B\u0627 \u0625\u0636\u0627\u0641\u064A\u064B\u0627",
            "voucher.introduction.doku": "\u0634\u0643\u0631\u064B\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060C \u064A\u0631\u062C\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0644\u0625\u062A\u0645\u0627\u0645 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639.",
            "voucher.shopperName": "\u0627\u0633\u0645 \u0627\u0644\u0645\u062A\u0633\u0648\u0642",
            "voucher.merchantName": "\u0627\u0644\u062A\u0627\u062C\u0631",
            "voucher.introduction.econtext": "\u0634\u0643\u0631\u064B\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060C \u064A\u0631\u062C\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0644\u0625\u062A\u0645\u0627\u0645 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639.",
            "voucher.telephoneNumber": "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641",
            "voucher.shopperReference": "\u0645\u0631\u062C\u0639 \u0627\u0644\u0645\u062A\u0633\u0648\u0642",
            "voucher.collectionInstitutionNumber": "\u0631\u0642\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0643\u0644\u0641\u0629 \u0628\u0627\u0644\u062A\u062D\u0635\u064A\u0644",
            "voucher.econtext.telephoneNumber.invalid": "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0628\u0637\u0648\u0644 10 \u0623\u0648 11 \u0631\u0642\u0645\u064B\u0627",
            "boletobancario.btnLabel": "\u0625\u0646\u0634\u0627\u0621 \u0637\u0631\u064A\u0642\u0629 \u062F\u0641\u0639 Boleto",
            "boleto.sendCopyToEmail": "\u0625\u0631\u0633\u0627\u0644 \u0646\u0633\u062E\u0629 \u0625\u0644\u0649 \u0628\u0631\u064A\u062F\u064A \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
            "button.copy": "\u0646\u0633\u062E",
            "button.download": "\u062A\u0646\u0632\u064A\u0644",
            "boleto.socialSecurityNumber.invalid": "\u0627\u0644\u062D\u0642\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "creditCard.storedCard.description.ariaLabel": "\u062A\u0646\u062A\u0647\u064A \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u062E\u0632\u0646\u0629 \u0641\u064A %@",
            "voucher.entity": "\u0627\u0644\u0643\u064A\u0627\u0646",
            donateButton: "\u0627\u0644\u062A\u0628\u0631\u0639",
            notNowButton: "\u0644\u064A\u0633 \u0627\u0644\u0622\u0646",
            thanksForYourSupport: "\u0634\u0643\u0631\u064B\u0627 \u0639\u0644\u0649 \u062F\u0639\u0645\u0643!",
            "resultMessages.preauthorized": "\u062A\u0645 \u062D\u0641\u0638 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644",
            preauthorizeWith: "\u062A\u0641\u0648\u064A\u0636 \u0645\u0633\u0628\u0642 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
            confirmPreauthorization: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062A\u0641\u0648\u064A\u0636 \u0627\u0644\u0645\u0633\u0628\u0642",
            confirmPurchase: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0634\u0631\u0627\u0621",
            applyGiftcard: "\u0627\u0633\u062A\u0631\u062F\u0627\u062F",
            giftcardBalance: "\u0631\u0635\u064A\u062F \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062F\u0627\u064A\u0627",
            deductedBalance: "\u0627\u0644\u0631\u0635\u064A\u062F \u0627\u0644\u0645\u062E\u0635\u0648\u0645",
            "creditCard.pin.title": "\u0631\u0642\u0645 \u0627\u0644\u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
            "creditCard.encryptedPassword.label": "\u0623\u0648\u0644 \u0631\u0642\u0645\u0627\u0646 \u0645\u0646 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
            "creditCard.taxNumber": "\u062A\u0627\u0631\u064A\u062E \u0645\u064A\u0644\u0627\u062F \u062D\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0623\u0648 \u0631\u0642\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0629",
            "creditCard.taxNumber.label": "\u062A\u0627\u0631\u064A\u062E \u0645\u064A\u0644\u0627\u062F \u062D\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 (\u064A\u0648\u0645 \u0634\u0647\u0631 \u0633\u0646\u0629) \u0623\u0648 \u0631\u0642\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 (10 \u0623\u0631\u0642\u0627\u0645)",
            "creditCard.taxNumber.labelAlt": "\u0631\u0642\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 (10 \u0623\u0631\u0642\u0627\u0645)",
            "creditCard.taxNumber.invalid": "\u062A\u0627\u0631\u064A\u062E \u0645\u064A\u0644\u0627\u062F \u062D\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0623\u0648 \u0631\u0642\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "storedPaymentMethod.disable.button": "\u0625\u0632\u0627\u0644\u0629",
            "storedPaymentMethod.disable.confirmation": "\u0625\u0632\u0627\u0644\u0629 \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0645\u062E\u0632\u0646\u0629",
            "storedPaymentMethod.disable.confirmButton": "\u0646\u0639\u0645\u060C \u0623\u0631\u063A\u0628 \u0641\u064A \u0625\u0632\u0627\u0644\u062A\u0647\u0627",
            "storedPaymentMethod.disable.cancelButton": "\u0625\u0644\u063A\u0627\u0621",
            "ach.bankAccount": "\u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064A",
            "ach.accountHolderNameField.title": "\u0627\u0633\u0645 \u0635\u0627\u062D\u0628 \u0627\u0644\u062D\u0633\u0627\u0628",
            "ach.accountHolderNameField.placeholder": "\u062C\u0645\u064A\u0644 \u0633\u0639\u064A\u062F",
            "ach.accountHolderNameField.invalid": "\u0627\u0633\u0645 \u0635\u0627\u062D\u0628 \u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "ach.accountNumberField.title": "\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628",
            "ach.accountNumberField.invalid": "\u0631\u0642\u0645 \u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "ach.accountLocationField.title": "\u0631\u0642\u0645 \u062A\u0648\u062C\u064A\u0647 ABA",
            "ach.accountLocationField.invalid": "\u0631\u0642\u0645 \u062A\u0648\u062C\u064A\u0647 ABA \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "ach.savedBankAccount": "\u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064A \u0627\u0644\u0645\u062D\u0641\u0648\u0638",
            "select.state": "\u062D\u062F\u062F \u0627\u0644\u0648\u0644\u0627\u064A\u0629",
            "select.stateOrProvince": "\u062D\u062F\u062F \u0627\u0644\u0648\u0644\u0627\u064A\u0629 \u0623\u0648 \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629",
            "select.provinceOrTerritory": "\u062D\u062F\u062F \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629 \u0623\u0648 \u0627\u0644\u0625\u0642\u0644\u064A\u0645",
            "select.country": "\u062D\u062F\u062F \u0627\u0644\u0628\u0644\u062F",
            "select.noOptionsFound": "\u0644\u0627 \u062A\u0648\u062C\u062F \u062E\u064A\u0627\u0631\u0627\u062A",
            "select.filter.placeholder": "\u0628\u062D\u062B...",
            "telephoneNumber.invalid": "\u0631\u0642\u0645 \u0647\u0627\u062A\u0641 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            qrCodeOrApp: "\u0623\u0648",
            "paypal.processingPayment": "\u062C\u0627\u0631\u0650 \u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A...",
            generateQRCode: "\u0625\u0646\u0634\u0627\u0621 \u0631\u0645\u0632 \u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0633\u0631\u064A\u0639\u0629",
            "await.waitForConfirmation": "\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u062A\u0623\u0643\u064A\u062F",
            "mbway.confirmPayment": "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062F\u0641\u0639 \u0639\u0644\u0649 \u062A\u0637\u0628\u064A\u0642 MB WAY",
            "shopperEmail.invalid": "\u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "dateOfBirth.format": "\u064A\u0648\u0645/\u0634\u0647\u0631/\u0633\u0646\u0629",
            "dateOfBirth.invalid": "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0645\u064A\u0644\u0627\u062F \u0635\u062D\u064A\u062D \u064A\u0634\u064A\u0631 \u0625\u0644\u0649 \u0623\u0646 \u0639\u0645\u0631\u0643 \u0644\u0627 \u064A\u0642\u0644 \u0639\u0646 18 \u0639\u0627\u0645\u064B\u0627",
            "blik.confirmPayment": "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642\u0643 \u0627\u0644\u0628\u0646\u0643\u064A \u0644\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062F\u0641\u0639.",
            "blik.invalid": "\u0623\u062F\u062E\u0644 6 \u0623\u0631\u0642\u0627\u0645",
            "blik.code": "\u0631\u0645\u0632 \u0645\u0643\u0648\u0646 \u0645\u0646 6 \u0623\u0631\u0642\u0627\u0645",
            "blik.help": "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0627\u0644\u0631\u0645\u0632 \u0645\u0646 \u062A\u0637\u0628\u064A\u0642\u0643 \u0627\u0644\u0628\u0646\u0643\u064A.",
            "swish.pendingMessage": "\u0628\u0639\u062F \u0642\u064A\u0627\u0645\u0643 \u0628\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0636\u0648\u0626\u064A\u064B\u0627\u060C \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u0638\u0644 \u0627\u0644\u062D\u0627\u0644\u0629 \u0645\u0639\u0644\u0642\u0629 \u0644\u0645\u062F\u0629 \u062A\u0635\u0644 \u0625\u0644\u0649 10 \u062F\u0642\u0627\u0626\u0642. \u0642\u062F \u062A\u0624\u062F\u064A \u0645\u062D\u0627\u0648\u0644\u0629 \u0627\u0644\u062F\u0641\u0639 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u062E\u0644\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u0648\u0642\u062A \u0625\u0644\u0649 \u0641\u0631\u0636 \u0631\u0633\u0648\u0645 \u0645\u062A\u0639\u062F\u062F\u0629.",
            "field.valid": "\u062D\u0642\u0644 \u0635\u062D\u064A\u062D",
            "field.invalid": "\u062D\u0642\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "error.va.gen.01": "\u062D\u0642\u0644 \u063A\u064A\u0631 \u0645\u0643\u062A\u0645\u0644",
            "error.va.gen.02": "\u062D\u0642\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "error.va.sf-cc-num.01": "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0628\u0637\u0627\u0642\u0629 \u0635\u062D\u064A\u062D",
            "error.va.sf-cc-num.02": "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "error.va.sf-cc-num.03": "\u0623\u062F\u062E\u0644 \u0639\u0644\u0627\u0645\u0629 \u062A\u062C\u0627\u0631\u064A\u0629 \u0644\u0628\u0637\u0627\u0642\u0629 \u0645\u062F\u0639\u0648\u0645\u0629",
            "error.va.sf-cc-num.04": "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0628\u0627\u0644\u0643\u0627\u0645\u0644",
            "error.va.sf-cc-dat.01": "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0635\u062D\u064A\u062D",
            "error.va.sf-cc-dat.02": "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u0635\u062D\u064A\u062D",
            "error.va.sf-cc-dat.03": "\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0627\u0626\u062A\u0645\u0627\u0646 \u0639\u0644\u0649 \u0648\u0634\u0643 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "error.va.sf-cc-dat.04": "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "error.va.sf-cc-dat.05": "\u0623\u062F\u062E\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0628\u0627\u0644\u0643\u0627\u0645\u0644",
            "error.va.sf-cc-mth.01": "\u0623\u062F\u062E\u0644 \u0634\u0647\u0631 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "error.va.sf-cc-yr.01": "\u0623\u062F\u062E\u0644 \u0633\u0646\u0629 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "error.va.sf-cc-yr.02": "\u0623\u062F\u062E\u0644 \u0633\u0646\u0629 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0628\u0627\u0644\u0643\u0627\u0645\u0644",
            "error.va.sf-cc-cvc.01": "\u0623\u062F\u062E\u0644 \u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646",
            "error.va.sf-cc-cvc.02": "\u0623\u062F\u062E\u0644 \u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646 \u0628\u0627\u0644\u0643\u0627\u0645\u0644",
            "error.va.sf-ach-num.01": "\u062D\u0642\u0644 \u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064A \u0641\u0627\u0631\u063A",
            "error.va.sf-ach-num.02": "\u0637\u0648\u0644 \u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064A \u062E\u0637\u0623",
            "error.va.sf-ach-loc.01": "\u062D\u0642\u0644 \u0631\u0642\u0645 \u0627\u0644\u062A\u0648\u062C\u064A\u0647 \u0627\u0644\u0628\u0646\u0643\u064A \u0641\u0627\u0631\u063A",
            "error.va.sf-ach-loc.02": "\u0637\u0648\u0644 \u0631\u0642\u0645 \u0627\u0644\u062A\u0648\u062C\u064A\u0647 \u0627\u0644\u0628\u0646\u0643\u064A \u062E\u0637\u0623",
            "error.va.sf-kcp-pwd.01": "\u062D\u0642\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0641\u0627\u0631\u063A",
            "error.va.sf-kcp-pwd.02": "\u0637\u0648\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u062E\u0637\u0623",
            "error.giftcard.no-balance": "\u0644\u0627 \u064A\u0648\u062C\u062F \u0631\u0635\u064A\u062F \u0628\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062F\u0627\u064A\u0627 \u0647\u0630\u0647",
            "error.giftcard.card-error": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u0633\u062C\u0644\u0627\u062A\u0646\u0627 \u0628\u0637\u0627\u0642\u0629 \u0647\u062F\u0627\u064A\u0627 \u062A\u062D\u0645\u0644 \u0647\u0630\u0627 \u0627\u0644\u0631\u0642\u0645",
            "error.giftcard.currency-error": "\u0644\u0627 \u062A\u0633\u0631\u064A \u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0647\u062F\u0627\u064A\u0627 \u0625\u0644\u0627 \u0628\u0627\u0644\u0639\u0645\u0644\u0629 \u0627\u0644\u062A\u064A \u0635\u062F\u0631\u062A \u0628\u0647\u0627",
            "amazonpay.signout": "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 \u0645\u0648\u0642\u0639 Amazon",
            "amazonpay.changePaymentDetails": "\u062A\u063A\u064A\u064A\u0631 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062F\u0641\u0639",
            "partialPayment.warning": "\u062A\u062D\u062F\u064A\u062F \u0637\u0631\u064A\u0642\u0629 \u062F\u0641\u0639 \u0623\u062E\u0631\u0649 \u0644\u062A\u0633\u062F\u064A\u062F \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u062A\u0628\u0642\u064A",
            "partialPayment.remainingBalance": "\u0633\u064A\u0628\u0644\u063A \u0627\u0644\u0631\u0635\u064A\u062F \u0627\u0644\u0645\u062A\u0628\u0642\u064A %{amount}",
            "bankTransfer.beneficiary": "\u0627\u0644\u0645\u0633\u062A\u0641\u064A\u062F",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "\u0643\u0648\u062F \u0627\u0644\u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0628\u0646\u0643\u064A",
            "bankTransfer.reference": "\u0627\u0644\u0645\u0631\u062C\u0639",
            "bankTransfer.introduction": "\u0642\u0645 \u0628\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u062F\u0641\u0648\u0639\u0627\u062A \u062A\u062D\u0648\u064A\u0644 \u0628\u0646\u0643\u064A\u0629 \u062C\u062F\u064A\u062F\u0629. \u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0648\u0627\u0631\u062F\u0629 \u0641\u064A \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0644\u0625\u062A\u0645\u0627\u0645 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639.",
            "bankTransfer.instructions": "\u0634\u0643\u0631\u064B\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060C \u064A\u0631\u062C\u0649 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0644\u0625\u062A\u0645\u0627\u0645 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639.",
            "bacs.accountHolderName": "\u0627\u0633\u0645 \u0635\u0627\u062D\u0628 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064A",
            "bacs.accountHolderName.invalid": "\u0627\u0633\u0645 \u0635\u0627\u062D\u0628 \u062D\u0633\u0627\u0628 \u0628\u0646\u0643\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "bacs.accountNumber": "\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064A",
            "bacs.accountNumber.invalid": "\u0631\u0642\u0645 \u062D\u0633\u0627\u0628 \u0628\u0646\u0643\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "bacs.bankLocationId": "\u0631\u0645\u0632 \u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0628\u0646\u0643",
            "bacs.bankLocationId.invalid": "\u0631\u0645\u0632 \u062A\u0639\u0631\u064A\u0641 \u0628\u0646\u0643 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "bacs.consent.amount": "\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u062E\u0635\u0645 \u0627\u0644\u0645\u0628\u0644\u063A \u0623\u0639\u0644\u0627\u0647 \u0645\u0646 \u062D\u0633\u0627\u0628\u064A \u0627\u0644\u0628\u0646\u0643\u064A.",
            "bacs.consent.account": "\u0623\u0624\u0643\u062F \u0623\u0646 \u0627\u0644\u062D\u0633\u0627\u0628 \u0628\u0627\u0633\u0645\u064A \u0648\u0623\u0646\u0627 \u0648\u062D\u062F\u064A \u0635\u0627\u062D\u0628 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0645\u0637\u0627\u0644\u0628 \u0628\u0627\u0644\u0625\u0630\u0646 \u0628\u0627\u0644\u062E\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628.",
            edit: "\u062A\u062D\u0631\u064A\u0631",
            "bacs.confirm": "\u062A\u0623\u0643\u064A\u062F \u0648\u062F\u0641\u0639",
            "bacs.result.introduction": "\u062A\u0646\u0632\u064A\u0644 \u062A\u0639\u0644\u064A\u0645\u0627\u062A \u0627\u0644\u062E\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 (\u062A\u0639\u0644\u064A\u0645\u0627\u062A / \u062A\u0641\u0648\u064A\u0636 DDI)",
            "download.pdf": "\u062A\u0646\u0632\u064A\u0644 \u0645\u0644\u0641 PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "creditCard.encryptedCardNumber.aria.label": "\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "creditCard.encryptedExpiryDate.aria.label": "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0634\u0647\u0631 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "creditCard.encryptedExpiryMonth.aria.label": "\u0634\u0647\u0631 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0633\u0646\u0629 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "creditCard.encryptedExpiryYear.aria.label": "\u0633\u0646\u0629 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646",
            "creditCard.encryptedSecurityCode.aria.label": "\u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646",
            "creditCard.encryptedPassword.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
            "creditCard.encryptedPassword.aria.label": "\u0623\u0648\u0644 \u0631\u0642\u0645\u0627\u0646 \u0645\u0646 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "giftcard.encryptedCardNumber.aria.label": "\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
            "giftcard.encryptedSecurityCode.aria.label": "\u0631\u0642\u0645 \u0627\u0644\u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
            giftcardTransactionLimit: "\u064A\u0633\u0645\u062D \u0641\u0642\u0637 \u0628\u062D\u062F \u0623\u0642\u0635\u0649 %{amount} \u0644\u0643\u0644 \u0645\u0639\u0627\u0645\u0644\u0629 \u0639\u0644\u0649 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062F\u0627\u064A\u0627 \u0647\u0630\u0647",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064A",
            "ach.encryptedBankAccountNumber.aria.label": "\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628",
            "ach.encryptedBankLocationId.aria.iframeTitle": "\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u062A\u0648\u062C\u064A\u0647 \u0627\u0644\u0628\u0646\u0643\u064A",
            "ach.encryptedBankLocationId.aria.label": "\u0631\u0642\u0645 \u062A\u0648\u062C\u064A\u0647 ABA",
            "pix.instructions": "\u0627\u0641\u062A\u062D \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0641\u062A\u0627\u062D PIX \u0627\u0644\u0645\u0633\u062C\u0644\u060C \u0648\u0627\u062E\u062A\u0631 \u0627\u0644\u062F\u0641\u0639 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 PIX \u0648\u0627\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0636\u0648\u0626\u064A\u064B\u0627 \u0623\u0648 \u0627\u0646\u0633\u062E \u0627\u0644\u0631\u0645\u0632 \u0648\u0627\u0644\u0635\u0642\u0647",
            "twint.saved": "\u0627\u0644\u0645\u062D\u0641\u0648\u0638\u0629",
            orPayWith: "\u0623\u0648 \u0627\u0644\u062F\u0641\u0639 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
            invalidFormatExpects: "\u062A\u0646\u0633\u064A\u0642 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D. \u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u0627\u0644\u0645\u062A\u0648\u0642\u0639: %{format}",
            "upi.qrCodeWaitingMessage": "\u0627\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062A\u0637\u0628\u064A\u0642 UPI \u0627\u0644\u0630\u064A \u062A\u064F\u0641\u0636\u0644\u0647 \u0644\u0625\u062A\u0645\u0627\u0645 \u0627\u0644\u062F\u0641\u0639",
            "upi.vpaWaitingMessage": "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 UPI \u0644\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062F\u0641\u0639",
            "upi.modeSelection": "\u062D\u062F\u062F \u0643\u064A\u0641 \u062A\u0631\u063A\u0628 \u0641\u064A \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062A\u0637\u0628\u064A\u0642 UPI.",
            "onlineBanking.termsAndConditions": "\u0628\u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629\u060C \u0641\u0625\u0646\u0643 \u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 %#\u0627\u0644\u0634\u0631\u0648\u0637 \u0648 \u0627\u0644\u0623\u062D\u0643\u0627\u0645%#",
            "onlineBankingPL.termsAndConditions": "\u0628\u0627\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631\u060C \u0641\u0625\u0646\u0643 \u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 %#\u0627\u0644\u0642\u0648\u0627\u0639\u062F%# \u0648%#\u0627\u0644\u0627\u0644\u062A\u0632\u0627\u0645\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A\u064A\u0629%# \u0644\u0645\u0624\u0633\u0633\u0629 Przelewy24",
            "ctp.loading.poweredByCtp": "\u0628\u062F\u0639\u0645 \u0645\u0646 Click to Pay",
            "ctp.loading.intro": "\u0646\u062A\u062D\u0642\u0642 \u0644\u0645\u0639\u0631\u0641\u0629 \u0645\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0644\u062F\u064A\u0643 \u0623\u064A \u0628\u0637\u0627\u0642\u0627\u062A \u0645\u062D\u0641\u0648\u0638\u0629 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 Click to Pay...",
            "ctp.login.title": "\u062A\u0627\u0628\u0639 \u0625\u0644\u0649 Click to Pay",
            "ctp.login.subtitle": "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u0645\u0642\u062A\u0631\u0646 \u0628\u0637\u0631\u064A\u0642\u0629 Click to Pay \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
            "ctp.login.inputLabel": "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
            "ctp.logout.notYou": "\u0644\u064A\u0633 \u0623\u0646\u062A\u061F",
            "ctp.logout.notYourCards": "\u0644\u064A\u0633\u062A \u0628\u0637\u0627\u0642\u0627\u062A\u0643\u061F",
            "ctp.logout.notYourCard": "\u0644\u064A\u0633\u062A \u0628\u0637\u0627\u0642\u062A\u0643\u061F",
            "ctp.logout.notYourProfile": "\u0644\u064A\u0633 \u0645\u0644\u0641\u0643 \u0627\u0644\u062A\u0639\u0631\u064A\u0641\u064A\u061F",
            "ctp.otp.fieldLabel": "\u0631\u0645\u0632 \u064A\u0633\u062A\u062E\u062F\u0645 \u0644\u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629",
            "ctp.otp.resendCode": "\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0645\u0632",
            "ctp.otp.codeResent": "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0645\u0632",
            "ctp.otp.title": "\u062A\u0645\u062A\u0639 \u0628\u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0628\u0637\u0627\u0642\u0627\u062A Click to Pay \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643",
            "ctp.otp.subtitle": "\u0623\u062F\u062E\u0644 \u0627\u0644\u0631\u0645\u0632 %@ \u0627\u0644\u0630\u064A \u0623\u0631\u0633\u0644\u0646\u0627\u0647 \u0625\u0644\u0649 \u066A@ \u0644\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0647\u0648\u064A\u062A\u0643.",
            "ctp.otp.saveCookiesCheckbox.label": "\u062A\u062E\u0637\u064A \u0627\u0644\u062A\u062D\u0642\u0642 \u0641\u064A \u0627\u0644\u0645\u0631\u0629 \u0627\u0644\u0642\u0627\u062F\u0645\u0629",
            "ctp.otp.saveCookiesCheckbox.information": "\u062D\u062F\u062F \u062D\u0641\u0638 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u0643 \u0648\u0645\u062A\u0635\u0641\u062D\u0643 \u0641\u064A \u0627\u0644\u0645\u062A\u0627\u062C\u0631 \u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0629 \u0644\u0625\u062A\u0645\u0627\u0645 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639 \u0628\u0634\u0643\u0644 \u0623\u0633\u0631\u0639. \u0644\u0627 \u064A\u0648\u0635\u0649 \u0628\u0647 \u0644\u0644\u0623\u062C\u0647\u0632\u0629 \u0627\u0644\u0645\u0634\u062A\u0631\u0643\u0629.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "\u062D\u062F\u062F \u062A\u0630\u0643\u0631\u0646\u064A \u0639\u0644\u0649 \u062C\u0647\u0627\u0632\u0643 \u0648\u0645\u062A\u0635\u0641\u062D\u0643.",
            "ctp.emptyProfile.message": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u0637\u0627\u0642\u0627\u062A \u0645\u0633\u062C\u0644\u0629 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u062A\u0639\u0631\u064A\u0641\u064A \u0639\u0644\u0649 Click to Pay",
            "ctp.separatorText": "\u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645",
            "ctp.cards.title": "\u0623\u0643\u0645\u0644 \u0627\u0644\u062F\u0641\u0639 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0628\u0637\u0627\u0642\u0629 Click to Pay",
            "ctp.cards.subtitle": "\u062D\u062F\u062F \u0628\u0637\u0627\u0642\u0629 \u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627.",
            "ctp.cards.expiredCard": "\u0645\u0646\u062A\u0647\u064A \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629",
            "ctp.manualCardEntry": "\u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "ctp.aria.infoModalButton": "\u0645\u0627 \u0627\u0644\u0645\u0642\u0635\u0648\u062F \u0628\u0628\u0637\u0627\u0642\u0629 Click to Pay\u061F",
            "ctp.infoPopup.title": "\u062A\u062A\u064A\u062D \u0628\u0637\u0627\u0642\u0627\u062A Click to Pay \u0633\u0647\u0648\u0644\u0629 \u0627\u0644\u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u0644\u0627\u062A\u0644\u0627\u0645\u0633\u064A\u0629 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
            "ctp.infoPopup.subtitle": "\u0637\u0631\u064A\u0642\u0629 \u062F\u0641\u0639 \u0633\u0631\u064A\u0639\u0629 \u0648\u0622\u0645\u0646\u0629 \u0645\u062F\u0639\u0648\u0645\u0629 \u0645\u0646 Mastercard \u0648Visa \u0648\u0628\u0637\u0627\u0642\u0627\u062A \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0623\u062E\u0631\u0649.",
            "ctp.infoPopup.benefit1": "\u062A\u0633\u062A\u062E\u062F\u0645 \u0628\u0637\u0627\u0642\u0627\u062A Click to Pay \u0627\u0644\u062A\u0634\u0641\u064A\u0631 \u0644\u0644\u062D\u0641\u0627\u0638 \u0639\u0644\u0649 \u0623\u0645\u0646 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u0643 \u0648\u0633\u0644\u0627\u0645\u062A\u0647\u0627",
            "ctp.infoPopup.benefit2": "\u0627\u0633\u062A\u062E\u062F\u0645\u0647\u0627 \u0644\u0644\u062F\u0641\u0639 \u0644\u0644\u062A\u062C\u0627\u0631 \u0641\u064A \u062C\u0645\u064A\u0639 \u0623\u0646\u062D\u0627\u0621 \u0627\u0644\u0639\u0627\u0644\u0645",
            "ctp.infoPopup.benefit3": "\u0642\u0645 \u0628\u0627\u0644\u0625\u0639\u062F\u0627\u062F \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0644\u0625\u062C\u0631\u0627\u0621 \u0645\u062F\u0641\u0648\u0639\u0627\u062A \u062F\u0648\u0646 \u062A\u0639\u0642\u064A\u062F\u0627\u062A \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0642\u0628\u0644",
            "ctp.errors.AUTH_INVALID": "\u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
            "ctp.errors.NOT_FOUND": "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u062D\u0633\u0627\u0628\u060C \u0623\u062F\u062E\u0644 \u0628\u0631\u064A\u062F\u064B\u0627 \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u064B\u0627 \u0635\u062D\u064A\u062D\u064B\u0627 \u0623\u0648 \u0627\u0633\u062A\u0645\u0631 \u0641\u064A \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "\u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u063A\u064A\u0631 \u0645\u062F\u0639\u0648\u0645",
            "ctp.errors.FRAUD": "\u062A\u0645 \u0625\u063A\u0644\u0627\u0642 \u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0623\u0648 \u062A\u0639\u0637\u064A\u0644\u0647",
            "ctp.errors.CONSUMER_ID_MISSING": "\u0647\u0648\u064A\u0629 \u0627\u0644\u0645\u0633\u062A\u0647\u0644\u0643 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u064A \u0627\u0644\u0637\u0644\u0628",
            "ctp.errors.ACCT_INACCESSIBLE": "\u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u062D\u0627\u0644\u064A\u064B\u0627\u060C \u0639\u0644\u0649 \u0633\u0628\u064A\u0644 \u0627\u0644\u0645\u062B\u0627\u0644\u060C \u0627\u0644\u062D\u0633\u0627\u0628 \u0645\u063A\u0644\u0642",
            "ctp.errors.CODE_INVALID": "\u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
            "ctp.errors.CODE_EXPIRED": "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632",
            "ctp.errors.RETRIES_EXCEEDED": "\u062A\u0645 \u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0639\u062F\u062F \u0639\u0645\u0644\u064A\u0627\u062A \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0644\u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629",
            "ctp.errors.OTP_SEND_FAILED": "\u062A\u0639\u0630\u0631 \u0625\u0631\u0633\u0627\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0644\u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u0644\u0645",
            "ctp.errors.REQUEST_TIMEOUT": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "ctp.errors.UNKNOWN_ERROR": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "ctp.errors.SERVICE_ERROR": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "ctp.errors.SERVER_ERROR": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "ctp.errors.INVALID_PARAMETER": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "ctp.errors.AUTH_ERROR": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0628\u0637\u0627\u0642\u0629",
            "paymentMethodsList.aria.label": "\u0627\u062E\u062A\u0631 \u0637\u0631\u064A\u0642\u0629 \u062F\u0641\u0639",
            "companyDetails.name.invalid": "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629",
            "companyDetails.registrationNumber.invalid": "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
            "consent.checkbox.invalid": "\u064A\u062C\u0628 \u0623\u0646 \u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0634\u0631\u0648\u0637 \u0648\u0627\u0644\u0623\u062D\u0643\u0627\u0645",
            "form.instruction": "\u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0642\u0648\u0644 \u0645\u0637\u0644\u0648\u0628\u0629 \u0645\u0627 \u0644\u0645 \u064A\u062A\u0645 \u0648\u0636\u0639 \u0639\u0644\u0627\u0645\u0629 \u062E\u0644\u0627\u0641 \u0630\u0644\u0643.",
            "trustly.descriptor": "\u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0645\u0635\u0631\u0641\u064A \u0627\u0644\u0641\u0648\u0631\u064A",
            "trustly.description1": "\u0627\u062F\u0641\u0639 \u0645\u0628\u0627\u0634\u0631\u0629 \u0645\u0646 \u0623\u064A \u0645\u0646 \u062D\u0633\u0627\u0628\u0627\u062A\u0643 \u0627\u0644\u0645\u0635\u0631\u0641\u064A\u0629\u060C \u0645\u062F\u0639\u0648\u0645\u064B\u0627 \u0628\u0623\u0645\u0627\u0646 \u0639\u0644\u0649 \u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u0628\u0646\u0643",
            "trustly.description2": "\u0644\u0627 \u062A\u0648\u062C\u062F \u062D\u0627\u062C\u0629 \u0644\u0644\u0628\u0637\u0627\u0642\u0627\u062A \u0623\u0648 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0637\u0628\u064A\u0642\u0627\u062A \u0623\u0648 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
            "ancv.input.label": "\u062A\u0639\u0631\u064A\u0641 ANCV \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
            "ancv.confirmPayment": "\u0627\u0633\u062A\u062E\u062F\u0645 \u062A\u0637\u0628\u064A\u0642 ANCV \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0644\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062F\u0641\u0639.",
            "ancv.form.instruction": "\u064A\u0639\u062F \u062A\u0637\u0628\u064A\u0642 Cheque-Vacances \u0636\u0631\u0648\u0631\u064A\u064B\u0627 \u0644\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A.",
            "ancv.beneficiaryId.invalid": "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0635\u062D\u064A\u062D\u064B\u0627 \u0623\u0648 \u0645\u0639\u0631\u0641 ANCV",
            "payme.openPayMeApp": "\u0623\u0643\u0645\u0644 \u0627\u0644\u062F\u0641\u0639 \u0641\u064A \u062A\u0637\u0628\u064A\u0642 PayMe \u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0644\u0625\u0630\u0646 \u0628\u0627\u0644\u062F\u0641\u0639 \u0641\u064A \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0648\u0627\u0646\u062A\u0638\u0631 \u0627\u0644\u062A\u0623\u0643\u064A\u062F.",
            "payme.redirectButtonLabel": "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 PayMe",
            "payme.scanQrCode": "\u0623\u0643\u0645\u0644 \u0627\u0644\u062F\u0641\u0639 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629",
            "payme.timeToPay": "\u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0647\u0630\u0627 \u0635\u0627\u0644\u062D \u0644\u0640 %@",
            "payme.instructions.steps": "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 PayMe. %@\u0627\u0645\u0633\u062D \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0636\u0648\u0626\u064A\u064B\u0627 \u0644\u0644\u0625\u0630\u0646 \u0628\u0627\u0644\u062F\u0641\u0639. %@\u0623\u0643\u0645\u0644 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639 \u0641\u064A \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0648\u0627\u0646\u062A\u0638\u0631 \u0627\u0644\u062A\u0623\u0643\u064A\u062F.",
            "payme.instructions.footnote": "\u064A\u0631\u062C\u0649 \u0639\u062F\u0645 \u0625\u063A\u0644\u0627\u0642 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629 \u0642\u0628\u0644 \u0625\u062A\u0645\u0627\u0645 \u0627\u0644\u062F\u0641\u0639"
        }
    }), W1 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Zaplatit",
            "payButton.redirecting": "P\u0159esm\u011Brov\xe1n\xed...",
            "payButton.with": "Zaplatit %{value} pomoc\xed %{maskedData}",
            "payButton.saveDetails": "Ulo\u017Eit podrobnosti",
            close: "Zav\u0159\xedt",
            storeDetails: "Ulo\u017Eit pro\xa0p\u0159\xed\u0161t\xed platby",
            readMore: "P\u0159e\u010Dt\u011Bte si v\xedce",
            "creditCard.holderName": "Jm\xe9no na\xa0kart\u011B",
            "creditCard.holderName.placeholder": "Jan Nov\xe1k",
            "creditCard.holderName.invalid": "Zadejte jm\xe9no, jak je uvedeno na kart\u011B",
            "creditCard.numberField.title": "\u010C\xedslo karty",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Konec platnosti",
            "creditCard.expiryDateField.placeholder": "MM/RR",
            "creditCard.expiryDateField.month": "M\u011Bs\xedc",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "RR",
            "creditCard.expiryDateField.year": "Rok",
            "creditCard.cvcField.title": "Bezpe\u010Dnostn\xed k\xf3d",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Zapamatovat si pro\xa0p\u0159\xed\u0161t\u011B",
            "creditCard.cvcField.placeholder.4digits": "4 \u010D\xedslice",
            "creditCard.cvcField.placeholder.3digits": "3 \u010D\xedslice",
            "creditCard.taxNumber.placeholder": "RRMMDD / 0123456789",
            installments: "Po\u010Det spl\xe1tek",
            installmentOption: "%{times}\xd7 %{partialValue}",
            installmentOptionMonths: "%{times} m\u011Bs\xedc\u016F",
            "installments.oneTime": "Jednor\xe1zov\xe1 platba",
            "installments.installments": "Platba na\xa0spl\xe1tky",
            "installments.revolving": "Opakuj\xedc\xed se platba",
            "sepaDirectDebit.ibanField.invalid": "Neplatn\xe9 \u010D\xedslo \xfa\u010Dtu",
            "sepaDirectDebit.nameField.placeholder": "Jan Nov\xe1k",
            "sepa.ownerName": "Jm\xe9no dr\u017Eitele \xfa\u010Dtu",
            "sepa.ibanNumber": "\u010C\xedslo \xfa\u010Dtu (IBAN)",
            "error.title": "Chyba",
            "error.subtitle.redirect": "P\u0159esm\u011Brov\xe1n\xed selhalo",
            "error.subtitle.payment": "Platba selhala",
            "error.subtitle.refused": "Platba zam\xedtnuta",
            "error.message.unknown": "Do\u0161lo k\xa0nezn\xe1m\xe9 chyb\u011B",
            "errorPanel.title": "St\xe1vaj\xedc\xed chyby",
            "idealIssuer.selectField.title": "Banka",
            "idealIssuer.selectField.placeholder": "Vyberte svou banku",
            "creditCard.success": "Platba prob\u011Bhla \xfasp\u011B\u0161n\u011B",
            loading: "Na\u010D\xedt\xe1n\xed\u2026",
            continue: "Pokra\u010Dovat",
            continueTo: "Pokra\u010Dovat k",
            "wechatpay.timetopay": "Na zaplacen\xed v\xe1m zb\xfdv\xe1 %@",
            "sr.wechatpay.timetopay": "Na zaplacen\xed m\xe1te %#minut%# %#sekund%#",
            "wechatpay.scanqrcode": "Naskenovat QR k\xf3d",
            personalDetails: "Osobn\xed \xfadaje",
            companyDetails: "\xdadaje o\xa0spole\u010Dnosti",
            "companyDetails.name": "N\xe1zev spole\u010Dnosti",
            "companyDetails.registrationNumber": "Registra\u010Dn\xed \u010D\xedslo",
            socialSecurityNumber: "Rodn\xe9 \u010D\xedslo",
            firstName: "Jm\xe9no",
            "firstName.invalid": "Zadejte sv\xe9 k\u0159estn\xed jm\xe9no",
            infix: "Prefix",
            lastName: "P\u0159\xedjmen\xed",
            "lastName.invalid": "Zadejte sv\xe9 p\u0159\xedjmen\xed",
            mobileNumber: "\u010C\xedslo na mobil",
            "mobileNumber.invalid": "Neplatn\xe9 \u010D\xedslo mobiln\xedho telefonu",
            city: "M\u011Bsto",
            postalCode: "PS\u010C",
            "postalCode.optional": "Po\u0161tovn\xed sm\u011Brovac\xed \u010D\xedslo (nepovinn\xe9)",
            countryCode: "K\xf3d zem\u011B",
            telephoneNumber: "Telefonn\xed \u010D\xedslo",
            dateOfBirth: "Datum narozen\xed",
            shopperEmail: "E-mailov\xe1 adresa",
            gender: "Pohlav\xed",
            "gender.notselected": "Vyberte pohlav\xed",
            male: "Mu\u017E",
            female: "\u017Dena",
            billingAddress: "Faktura\u010Dn\xed adresa",
            street: "Ulice",
            stateOrProvince: "Kraj nebo okres",
            country: "Zem\u011B",
            houseNumberOrName: "\u010C\xedslo popisn\xe9",
            separateDeliveryAddress: "Zadat dodac\xed adresu odli\u0161nou od faktura\u010Dn\xed",
            deliveryAddress: "Dodac\xed adresa",
            "deliveryAddress.firstName": "Jm\xe9no p\u0159\xedjemce",
            "deliveryAddress.lastName": "P\u0159\xedjmen\xed p\u0159\xedjemce",
            zipCode: "PS\u010C",
            apartmentSuite: "Byt",
            provinceOrTerritory: "Provincie nebo teritorium",
            cityTown: "M\u011Bsto",
            address: "Adresa",
            "address.placeholder": "Najd\u011Bte svou adresu",
            "address.errors.incomplete": "Chcete-li pokra\u010Dovat, zadejte adresu",
            "address.enterManually": "Zadejte adresu ru\u010Dn\u011B",
            state: "St\xe1t",
            "field.title.optional": "(nepovinn\xe9)",
            "creditCard.cvcField.title.optional": "Bezpe\u010Dnostn\xed k\xf3d (voliteln\xfd)",
            "issuerList.wallet.placeholder": "Vyberte svou pen\u011B\u017Eenku",
            privacyPolicy: "Z\xe1sady ochrany osobn\xedch \xfadaj\u016F",
            "afterPay.agreement": "Souhlas\xedm s %@ of Riverty",
            paymentConditions: "platebn\xedmi podm\xednkami",
            openApp: "Otev\u0159ete aplikaci",
            "voucher.readInstructions": "P\u0159e\u010Dt\u011Bte si pokyny",
            "voucher.introduction": "D\u011Bkujeme za\xa0n\xe1kup. K\xa0dokon\u010Den\xed platby pou\u017Eijte pros\xedm n\xe1sleduj\xedc\xed kup\xf3n.",
            "voucher.expirationDate": "Datum konce platnosti",
            "voucher.alternativeReference": "N\xe1hradn\xed \u010D\xedslo",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Vyberte sv\xe9ho poskytovatele",
            "dragonpay.voucher.bank.selectField.placeholder": "Vyberte svou banku",
            "voucher.paymentReferenceLabel": "\u010C\xedslo platby",
            "voucher.surcharge": "V\u010Detn\u011B p\u0159ir\xe1\u017Eky %@",
            "voucher.introduction.doku": "D\u011Bkujeme za n\xe1kup. K dokon\u010Den\xed platby pou\u017Eijte pros\xedm n\xe1sleduj\xedc\xed informace.",
            "voucher.shopperName": "Jm\xe9no kupuj\xedc\xedho",
            "voucher.merchantName": "Obchodn\xedk",
            "voucher.introduction.econtext": "D\u011Bkujeme za n\xe1kup. K dokon\u010Den\xed platby pou\u017Eijte pros\xedm n\xe1sleduj\xedc\xed informace.",
            "voucher.telephoneNumber": "Telefonn\xed \u010D\xedslo",
            "voucher.shopperReference": "\u010C\xedslo kupuj\xedc\xedho",
            "voucher.collectionInstitutionNumber": "\u010C\xedslo inkasn\xed instituce",
            "voucher.econtext.telephoneNumber.invalid": "Telefonn\xed \u010D\xedslo mus\xed obsahovat 10 nebo 11 \u010D\xedslic.",
            "boletobancario.btnLabel": "Vygenerovat Boleto",
            "boleto.sendCopyToEmail": "Poslat mi kopii na e-mail",
            "button.copy": "Kop\xedrovat",
            "button.download": "St\xe1hnout",
            "boleto.socialSecurityNumber.invalid": "Pole nen\xed platn\xe9",
            "creditCard.storedCard.description.ariaLabel": "Ulo\u017Een\xe1 karta kon\u010D\xed na %@",
            "voucher.entity": "Subjekt",
            donateButton: "P\u0159isp\u011Bt",
            notNowButton: "Te\u010F ne",
            thanksForYourSupport: "D\u011Bkujeme v\xe1m za podporu!",
            "resultMessages.preauthorized": "Ulo\u017Een\xe9 podrobnosti",
            preauthorizeWith: "P\u0159edautorizovat pomoc\xed",
            confirmPreauthorization: "Potvrdit p\u0159edautorizaci",
            confirmPurchase: "Potvrdit n\xe1kup",
            applyGiftcard: "Uplatnit",
            giftcardBalance: "Z\u016Fstatek na d\xe1rkov\xe9 kart\u011B",
            deductedBalance: "Ode\u010Dten\xfd z\u016Fstatek",
            "creditCard.pin.title": "Pin",
            "creditCard.encryptedPassword.label": "Prvn\xed 2 \u010D\xedslice hesla karty",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Neplatn\xe9 heslo",
            "creditCard.taxNumber": "Datum narozen\xed dr\u017Eitele karty nebo registra\u010Dn\xed \u010D\xedslo spole\u010Dnosti",
            "creditCard.taxNumber.label": "Datum narozen\xed dr\u017Eitele karty (RRMMDD) nebo registra\u010Dn\xed \u010D\xedslo spole\u010Dnosti (10 \u010D\xedslic)",
            "creditCard.taxNumber.labelAlt": "Registra\u010Dn\xed \u010D\xedslo spole\u010Dnosti (10 \u010D\xedslic)",
            "creditCard.taxNumber.invalid": "Neplatn\xe9 datum narozen\xed dr\u017Eitele karty nebo registra\u010Dn\xed \u010D\xedslo spole\u010Dnosti",
            "storedPaymentMethod.disable.button": "Odebrat",
            "storedPaymentMethod.disable.confirmation": "Odebrat ulo\u017Een\xfd zp\u016Fsob platby",
            "storedPaymentMethod.disable.confirmButton": "Ano, odebrat",
            "storedPaymentMethod.disable.cancelButton": "Zru\u0161it",
            "ach.bankAccount": "Bankovn\xed \xfa\u010Det",
            "ach.accountHolderNameField.title": "Jm\xe9no dr\u017Eitele \xfa\u010Dtu",
            "ach.accountHolderNameField.placeholder": "Jan Nov\xe1k",
            "ach.accountHolderNameField.invalid": "Neplatn\xe9 jm\xe9no dr\u017Eitele \xfa\u010Dtu",
            "ach.accountNumberField.title": "\u010C\xedslo \xfa\u010Dtu",
            "ach.accountNumberField.invalid": "Neplatn\xe9 \u010D\xedslo \xfa\u010Dtu",
            "ach.accountLocationField.title": "Sm\u011Brovac\xed tranzitn\xed \u010D\xedslo ABA",
            "ach.accountLocationField.invalid": "Neplatn\xe9 sm\u011Brovac\xed tranzitn\xed \u010D\xedslo ABA",
            "ach.savedBankAccount": "Ulo\u017Een\xfd bankovn\xed \xfa\u010Det",
            "select.state": "Vyberte st\xe1t",
            "select.stateOrProvince": "Vyberte kraj nebo okres",
            "select.provinceOrTerritory": "Vyberte provincii nebo teritorium",
            "select.country": "Vyberte zemi",
            "select.noOptionsFound": "Nebyly nalezeny \u017E\xe1dn\xe9 mo\u017Enosti",
            "select.filter.placeholder": "Hledat...",
            "telephoneNumber.invalid": "Neplatn\xe9 telefonn\xed \u010D\xedslo",
            qrCodeOrApp: "nebo",
            "paypal.processingPayment": "Zpracov\xe1n\xed platby...",
            generateQRCode: "Vygenerovat QR k\xf3d",
            "await.waitForConfirmation": "\u010Cek\xe1 se na\xa0potvrzen\xed",
            "mbway.confirmPayment": "Potvr\u010Fte platbu v\xa0aplikaci MB WAY",
            "shopperEmail.invalid": "Neplatn\xe1 e-mailov\xe1 adresa",
            "dateOfBirth.format": "DD/MM/RRRR",
            "dateOfBirth.invalid": "Zadejte platn\xe9 datum narozen\xed, ze kter\xe9ho vypl\xfdv\xe1, \u017Ee je v\xe1m alespo\u0148 18 let",
            "blik.confirmPayment": "Spus\u0165te bankovn\xed aplikaci a potvr\u010Fte platbu.",
            "blik.invalid": "Zadejte 6 \u010D\xedsel",
            "blik.code": "\u0160estim\xedstn\xfd k\xf3d",
            "blik.help": "Z\xedskejte k\xf3d z bankovn\xed aplikace.",
            "swish.pendingMessage": "Po naskenov\xe1n\xed QR k\xf3du m\u016F\u017Ee trvat a\u017E 10 minut, ne\u017E se stav zm\u011Bn\xed. Pokud budete zkou\u0161et b\u011Bhem t\xe9to doby platbu opakovat, m\u016F\u017Ee b\xfdt \u010D\xe1stka zaplacena v\xedcekr\xe1t.",
            "field.valid": "Platn\xe9 pole",
            "field.invalid": "Pole nen\xed platn\xe9",
            "error.va.gen.01": "Ne\xfapln\xe9 pole",
            "error.va.gen.02": "Pole nen\xed platn\xe9",
            "error.va.sf-cc-num.01": "Zadejte platn\xe9 \u010D\xedslo karty",
            "error.va.sf-cc-num.02": "Zadejte \u010D\xedslo karty",
            "error.va.sf-cc-num.03": "Zadejte podporovanou zna\u010Dku karty",
            "error.va.sf-cc-num.04": "Zadejte cel\xe9 \u010D\xedslo karty",
            "error.va.sf-cc-dat.01": "Zadejte platn\xe9 datum vypr\u0161en\xed platnosti",
            "error.va.sf-cc-dat.02": "Zadejte platn\xe9 datum vypr\u0161en\xed platnosti",
            "error.va.sf-cc-dat.03": "Platnost kreditn\xed karty brzy vypr\u0161\xed",
            "error.va.sf-cc-dat.04": "Zadejte datum vypr\u0161en\xed platnosti",
            "error.va.sf-cc-dat.05": "Zadejte cel\xe9 datum vypr\u0161en\xed platnosti",
            "error.va.sf-cc-mth.01": "Zadejte m\u011Bs\xedc vypr\u0161en\xed platnosti",
            "error.va.sf-cc-yr.01": "Zadejte rok vypr\u0161en\xed platnosti",
            "error.va.sf-cc-yr.02": "Zadejte cel\xfd rok vypr\u0161en\xed platnosti",
            "error.va.sf-cc-cvc.01": "Zadejte bezpe\u010Dnostn\xed k\xf3d",
            "error.va.sf-cc-cvc.02": "Zadejte cel\xfd bezpe\u010Dnostn\xed k\xf3d",
            "error.va.sf-ach-num.01": "Pole \u010D\xedsla bankovn\xedho \xfa\u010Dtu je pr\xe1zdn\xe9",
            "error.va.sf-ach-num.02": "\u010C\xedslo bankovn\xedho \xfa\u010Dtu m\xe1 nespr\xe1vnou d\xe9lku",
            "error.va.sf-ach-loc.01": "Pole bankovn\xedho sm\u011Brovac\xedho \u010D\xedsla je pr\xe1zdn\xe9",
            "error.va.sf-ach-loc.02": "Bankovn\xed sm\u011Brovac\xed \u010D\xedslo m\xe1 nespr\xe1vnou d\xe9lku",
            "error.va.sf-kcp-pwd.01": "Pole hesla je pr\xe1zdn\xe9",
            "error.va.sf-kcp-pwd.02": "Heslo m\xe1 nespr\xe1vnou d\xe9lku",
            "error.giftcard.no-balance": "Na d\xe1rkov\xe9 kart\u011B je nulov\xfd z\u016Fstatek",
            "error.giftcard.card-error": "V\xa0na\u0161ich z\xe1znamech nen\xed \u017E\xe1dn\xe1 d\xe1rkov\xe1 karta s\xa0t\xedmto \u010D\xedslem",
            "error.giftcard.currency-error": "D\xe1rkov\xe9 karty jsou platn\xe9 jenom v\xa0m\u011Bn\u011B, ve kter\xe9 byly vystaven\xe9",
            "amazonpay.signout": "Odhl\xe1sit se z Amazonu",
            "amazonpay.changePaymentDetails": "Zm\u011Bnit \xfadaje o platb\u011B",
            "partialPayment.warning": "Zvolte jin\xfd zp\u016Fsob platby pro platbu zb\xfdvaj\xedc\xedch",
            "partialPayment.remainingBalance": "Zb\xfdvaj\xedc\xed z\u016Fstatek bude %{amount}",
            "bankTransfer.beneficiary": "P\u0159\xedjemce",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Odkaz",
            "bankTransfer.introduction": "Vytvo\u0159te novou platbu bankovn\xedm p\u0159evodem. K dokon\u010Den\xed t\xe9to platby m\u016F\u017Eete pou\u017E\xedt \xfadaje na n\xe1sleduj\xedc\xed obrazovce.",
            "bankTransfer.instructions": "D\u011Bkujeme za n\xe1kup. K dokon\u010Den\xed platby pou\u017Eijte pros\xedm n\xe1sleduj\xedc\xed informace.",
            "bacs.accountHolderName": "Jm\xe9no dr\u017Eitele bankovn\xedho \xfa\u010Dtu",
            "bacs.accountHolderName.invalid": "Neplatn\xe9 jm\xe9no dr\u017Eitele bankovn\xedho \xfa\u010Dtu",
            "bacs.accountNumber": "\u010C\xedslo bankovn\xedho \xfa\u010Dtu",
            "bacs.accountNumber.invalid": "Neplatn\xe9 \u010D\xedslo bankovn\xedho \xfa\u010Dtu",
            "bacs.bankLocationId": "K\xf3d Sort",
            "bacs.bankLocationId.invalid": "Neplatn\xfd k\xf3d Sort",
            "bacs.consent.amount": "Souhlas\xedm s\xa0t\xedm, \u017Ee mi bude n\xe1sleduj\xedc\xed \u010D\xe1stka ode\u010Dtena z\xa0bankovn\xedho \xfa\u010Dtu.",
            "bacs.consent.account": "Potvrzuji, \u017Ee \xfa\u010Det je veden na moje jm\xe9no a\xa0jsem jedin\xfdm disponentem, jeho\u017E podpis je nutn\xfd ke schv\xe1len\xed p\u0159\xedm\xe9ho inkasa.",
            edit: "Editovat",
            "bacs.confirm": "Potvrdit a\xa0zaplatit",
            "bacs.result.introduction": "St\xe1hn\u011Bte si pokyny k\xa0p\u0159\xedm\xe9mu inkasu (DDI / podpisov\xe9 pr\xe1vo)",
            "download.pdf": "St\xe1hnout PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe pro \u010D\xedslo karty",
            "creditCard.encryptedCardNumber.aria.label": "\u010C\xedslo karty",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe pro datum vypr\u0161en\xed platnosti",
            "creditCard.encryptedExpiryDate.aria.label": "Konec platnosti",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe pro m\u011Bs\xedc vypr\u0161en\xed platnosti",
            "creditCard.encryptedExpiryMonth.aria.label": "M\u011Bs\xedc konce platnosti",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe pro rok vypr\u0161en\xed platnosti",
            "creditCard.encryptedExpiryYear.aria.label": "Rok konce platnosti",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe pro bezpe\u010Dnostn\xed k\xf3d",
            "creditCard.encryptedSecurityCode.aria.label": "Bezpe\u010Dnostn\xed k\xf3d",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe pro heslo",
            "creditCard.encryptedPassword.aria.label": "Prvn\xed 2 \u010D\xedslice hesla karty",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe pro \u010D\xedslo karty",
            "giftcard.encryptedCardNumber.aria.label": "\u010C\xedslo karty",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe pro pin",
            "giftcard.encryptedSecurityCode.aria.label": "Pin",
            giftcardTransactionLimit: "Maxim\xe1ln\xed povolen\xe1 \u010D\xe1stka za jednu transakci touto d\xe1rkovou kartou je %{amount}.",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe pro \u010D\xedslo bankovn\xedho \xfa\u010Dtu",
            "ach.encryptedBankAccountNumber.aria.label": "\u010C\xedslo \xfa\u010Dtu",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe pro sm\u011Brovac\xed \u010D\xedslo banky",
            "ach.encryptedBankLocationId.aria.label": "Sm\u011Brovac\xed tranzitn\xed \u010D\xedslo ABA",
            "twint.saved": "ulo\u017Eeno",
            orPayWith: "nebo zapla\u0165te pomoc\xed",
            invalidFormatExpects: "Neplatn\xfd form\xe1t. O\u010Dek\xe1van\xfd form\xe1t: %{format}",
            "upi.qrCodeWaitingMessage": "Platbu dokon\u010Dete naskenov\xe1n\xedm QR k\xf3du ve\xa0sv\xe9 obl\xedben\xe9 platebn\xed UPI aplikaci",
            "upi.vpaWaitingMessage": "Otev\u0159ete platebn\xed aplikaci UPI a potvr\u010Fte platbu",
            "upi.modeSelection": "Vyberte si, jak chcete platebn\xed aplikaci UPI pou\u017E\xedvat.",
            "onlineBanking.termsAndConditions": "Pokra\u010Dov\xe1n\xedm souhlas\xedte se %#smluvn\xedmi podm\xednkami%#",
            "onlineBankingPL.termsAndConditions": "Pokra\u010Dov\xe1n\xedm souhlas\xedte s %#pravidly%# a %#informa\u010Dn\xed povinnost\xed%# spole\u010Dnosti Przelewy24.",
            "ctp.loading.poweredByCtp": "Prov\xe1d\u011Bno prost\u0159ednictv\xedm Click to Pay",
            "ctp.loading.intro": "Zji\u0161\u0165ujeme, zda m\xe1te ulo\u017Een\xe9 karty s funkc\xed Click to Pay...",
            "ctp.login.title": "Pokra\u010Dujte na Click to Pay",
            "ctp.login.subtitle": "Pro pokra\u010Dov\xe1n\xed zadejte e-mailovou adresu, kter\xe1 je p\u0159ipojena k \xfa\u010Dtu Click to Pay.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "Nejste to vy?",
            "ctp.logout.notYourCards": "Nejsou to va\u0161e karty?",
            "ctp.logout.notYourCard": "Nen\xed to va\u0161e karta?",
            "ctp.logout.notYourProfile": "Nen\xed to v\xe1\u0161 profil?",
            "ctp.otp.fieldLabel": "Jednor\xe1zov\xfd k\xf3d",
            "ctp.otp.resendCode": "Znovu odeslat k\xf3d",
            "ctp.otp.codeResent": "K\xf3d odesl\xe1n",
            "ctp.otp.title": "Z\xedskejte p\u0159\xedstup ke sv\xfdm kart\xe1m Click to Pay",
            "ctp.otp.subtitle": "Zadejte k\xf3d %@, kter\xfd jsme v\xe1m odeslali na %@ a ov\u011B\u0159te sami sebe.",
            "ctp.otp.saveCookiesCheckbox.label": "P\u0159\xed\u0161t\u011B p\u0159esko\u010Dte ov\u011B\u0159ov\xe1n\xed",
            "ctp.otp.saveCookiesCheckbox.information": "Zvolte, \u017Ee si je chcete zapamatovat ve sv\xe9m za\u0159\xedzen\xed a prohl\xed\u017Ee\u010Di v z\xfa\u010Dastn\u011Bn\xfdch obchodech, abyste se rychleji odhl\xe1sili. Nedoporu\u010Duje se pro sd\xedlen\xe1 za\u0159\xedzen\xed.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Vyberte, abyste si je zapamatovali ve sv\xe9m za\u0159\xedzen\xed a prohl\xed\u017Ee\u010Di",
            "ctp.emptyProfile.message": "V tomto profilu Click to Pay nejsou zaregistrov\xe1ny \u017E\xe1dn\xe9 karty",
            "ctp.separatorText": "nebo pou\u017Eijte",
            "ctp.cards.title": "Dokon\u010Dete platbu pomoc\xed Click to Pay",
            "ctp.cards.subtitle": "Vyberte kartu, kterou chcete pou\u017E\xedt.",
            "ctp.cards.expiredCard": "Platnost vypr\u0161ela",
            "ctp.manualCardEntry": "Ru\u010Dn\xed zad\xe1v\xe1n\xed karty",
            "ctp.aria.infoModalButton": "Co je Click to Pay",
            "ctp.infoPopup.title": "Click to Pay p\u0159in\xe1\u0161\xed jednoduchost bezkontaktn\xed platby, online",
            "ctp.infoPopup.subtitle": "Rychl\xfd a bezpe\u010Dn\xfd zp\u016Fsob platby podporovan\xfd kartami Mastercard, Visa a dal\u0161\xedmi platebn\xedmi kartami.",
            "ctp.infoPopup.benefit1": "Slu\u017Eba Click to Pay pou\u017E\xedv\xe1 \u0161ifrov\xe1n\xed, aby va\u0161e informace byly zabezpe\u010Den\xe9.",
            "ctp.infoPopup.benefit2": "Pou\u017E\xedvejte ji u obchodn\xedk\u016F po cel\xe9m sv\u011Bt\u011B",
            "ctp.infoPopup.benefit3": "Nastavte jednou pro bezprobl\xe9mov\xe9 platby v budoucnu",
            "ctp.errors.AUTH_INVALID": "Ov\u011B\u0159ov\xe1n\xed neplatn\xe9",
            "ctp.errors.NOT_FOUND": "Nebyl nalezen \u017E\xe1dn\xfd \xfa\u010Det, zadejte platn\xfd e-mail nebo pokra\u010Dujte ru\u010Dn\xedm zad\xe1n\xedm karty.",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Form\xe1t nen\xed podporov\xe1n",
            "ctp.errors.FRAUD": "U\u017Eivatelsk\xfd \xfa\u010Det byl uzam\u010Den nebo vypnut",
            "ctp.errors.CONSUMER_ID_MISSING": "V po\u017Eadavku chyb\xed identita spot\u0159ebitele",
            "ctp.errors.ACCT_INACCESSIBLE": "Tento \xfa\u010Det je moment\xe1ln\u011B nedostupn\xfd, nap\u0159. je uzam\u010Den",
            "ctp.errors.CODE_INVALID": "Nespr\xe1vn\xfd ov\u011B\u0159ovac\xed k\xf3d",
            "ctp.errors.CODE_EXPIRED": "Platnost tohoto k\xf3du vypr\u0161ela",
            "ctp.errors.RETRIES_EXCEEDED": "Limit pro po\u010Det opakov\xe1n\xed pro generov\xe1n\xed jednor\xe1zov\xe9ho hesla byl p\u0159ekro\u010Den",
            "ctp.errors.OTP_SEND_FAILED": "Jednor\xe1zov\xe9 heslo nebylo mo\u017En\xe9 odeslat p\u0159\xedjemci",
            "ctp.errors.REQUEST_TIMEOUT": "N\u011Bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010Dn\u011B",
            "ctp.errors.UNKNOWN_ERROR": "N\u011Bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010Dn\u011B",
            "ctp.errors.SERVICE_ERROR": "N\u011Bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010Dn\u011B",
            "ctp.errors.SERVER_ERROR": "N\u011Bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010Dn\u011B",
            "ctp.errors.INVALID_PARAMETER": "N\u011Bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010Dn\u011B",
            "ctp.errors.AUTH_ERROR": "N\u011Bco se pokazilo, zkuste to znovu nebo kartu zadejte ru\u010Dn\u011B",
            "paymentMethodsList.aria.label": "Zvolte zp\u016Fsob platby",
            "companyDetails.name.invalid": "Zadejte n\xe1zev spole\u010Dnosti",
            "companyDetails.registrationNumber.invalid": "Zadejte registra\u010Dn\xed \u010D\xedslo",
            "consent.checkbox.invalid": "Mus\xedte souhlasit se smluvn\xedmi podm\xednkami",
            "form.instruction": "V\u0161echna pole jsou povinn\xe1, pokud nen\xed uvedeno jinak.",
            "ancv.input.label": "Va\u0161e identifikace ANCV",
            "ancv.confirmPayment": "Pro potvrzen\xed platby pou\u017Eijte aplikaci ANCV.",
            "ancv.form.instruction": "K potvrzen\xed t\xe9to platby je nutn\xe1 aplikace Cheque-Vacances.",
            "ancv.beneficiaryId.invalid": "Zadejte platnou e-mailovou adresu nebo ID ANCV",
            "payme.openPayMeApp": "Dokon\u010Dete platbu autorizac\xed v\xa0aplikaci PayMe a\xa0po\u010Dkejte na potvrzen\xed.",
            "payme.redirectButtonLabel": "Otev\u0159ete aplikaci PayMe",
            "payme.scanQrCode": "Dokon\u010Dete platbu pomoc\xed QR k\xf3du",
            "payme.timeToPay": "Tento QR k\xf3d je platn\xfd pro %@",
            "payme.instructions.steps": "Otev\u0159ete aplikaci PayMe.%@Autorizujte platbu naskenov\xe1n\xedm QR k\xf3du.%@Dokon\u010Dete platbu v\xa0aplikaci a\xa0po\u010Dkejte na potvrzen\xed.",
            "payme.instructions.footnote": "Nezav\xedrejte pros\xedm tuto str\xe1nku p\u0159ed dokon\u010Den\xedm platby."
        }
    }), G1 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Betal",
            "payButton.redirecting": "Omdirigerer...",
            "payButton.with": "Betal %{value} med %{maskedData}",
            "payButton.saveDetails": "Gem oplysninger",
            close: "Luk",
            storeDetails: "Gem til min n\xe6ste betaling",
            readMore: "L\xe6s mere",
            "creditCard.holderName": "Navn p\xe5 kort",
            "creditCard.holderName.placeholder": "J. Hansen",
            "creditCard.holderName.invalid": "Indtast navn som vist p\xe5 kortet",
            "creditCard.numberField.title": "Kortnummer",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Udl\xf8bsdato",
            "creditCard.expiryDateField.placeholder": "MM/\xc5\xc5",
            "creditCard.expiryDateField.month": "M\xe5ned",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "\xc5\xc5",
            "creditCard.expiryDateField.year": "\xc5r",
            "creditCard.cvcField.title": "Sikkerhedskode",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Husk til n\xe6ste gang",
            "creditCard.cvcField.placeholder.4digits": "4 cifre",
            "creditCard.cvcField.placeholder.3digits": "3 cifre",
            "creditCard.taxNumber.placeholder": "\xc5\xc5MMDD/0123456789",
            installments: "Antal rater",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} m\xe5neder",
            "installments.oneTime": "Engangsbetaling",
            "installments.installments": "Afdragsbetaling",
            "installments.revolving": "L\xf8bende betaling",
            "sepaDirectDebit.ibanField.invalid": "Ugyldigt kontonummer",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "Kontohavernavn",
            "sepa.ibanNumber": "Kontonummer (IBAN)",
            "error.title": "Fejl",
            "error.subtitle.redirect": "Omdirigering fejlede",
            "error.subtitle.payment": "Betaling fejlede",
            "error.subtitle.refused": "Betaling afvist",
            "error.message.unknown": "Der opstod en ukendt fejl",
            "errorPanel.title": "Eksisterende fejl",
            "idealIssuer.selectField.title": "Bank",
            "idealIssuer.selectField.placeholder": "V\xe6lg din bank",
            "creditCard.success": "Betaling gennemf\xf8rt",
            loading: "Indl\xe6ser\u2026",
            continue: "Forts\xe6t",
            continueTo: "Forts\xe6t til",
            "wechatpay.timetopay": "Du har %@ at betale",
            "sr.wechatpay.timetopay": "Du har %#minutes%# %#seconds%# til at betale",
            "wechatpay.scanqrcode": "Scan QR-kode",
            personalDetails: "Personlige oplysninger",
            companyDetails: "Virksomhedsoplysninger",
            "companyDetails.name": "Virksomhedsnavn",
            "companyDetails.registrationNumber": "CVR-nummer",
            socialSecurityNumber: "CPR-nummer",
            firstName: "Fornavn",
            "firstName.invalid": "Indtast dit fornavn",
            infix: "Pr\xe6fiks",
            lastName: "Efternavn",
            "lastName.invalid": "Indtast dit efternavn",
            mobileNumber: "Mobilnummer",
            "mobileNumber.invalid": "Ugyldigt mobilnummer",
            city: "By",
            postalCode: "Postnummer",
            "postalCode.optional": "Postnummer (valgfrit)",
            countryCode: "Landekode",
            telephoneNumber: "Telefonnummer",
            dateOfBirth: "F\xf8dselsdato",
            shopperEmail: "E-mailadresse",
            gender: "K\xf8n",
            "gender.notselected": "V\xe6lg dit k\xf8n",
            male: "Mand",
            female: "Kvinde",
            billingAddress: "Faktureringsadresse",
            street: "Gade",
            stateOrProvince: "Region eller kommune",
            country: "Land",
            houseNumberOrName: "Husnummer",
            separateDeliveryAddress: "Angiv en separat leveringsadresse",
            deliveryAddress: "Leveringsadresse",
            "deliveryAddress.firstName": "Modtagers fornavn",
            "deliveryAddress.lastName": "Modtagers efternavn",
            zipCode: "Postnummer",
            apartmentSuite: "Lejlighed/suite",
            provinceOrTerritory: "Provins eller territorium",
            cityTown: "By",
            address: "Adresse",
            "address.placeholder": "Find din adresse",
            "address.errors.incomplete": "Indtast en adresse for at forts\xe6tte",
            "address.enterManually": "Indtast adresse manuelt",
            state: "Stat",
            "field.title.optional": "(valgfrit)",
            "creditCard.cvcField.title.optional": "Sikkerhedskode (valgfrit)",
            "issuerList.wallet.placeholder": "V\xe6lg tegnebog",
            privacyPolicy: "Politik om privatlivets fred",
            "afterPay.agreement": "Jeg accepterer %@ fra Riverty",
            paymentConditions: "betalingsbetingelser",
            openApp: "\xc5bn appen",
            "voucher.readInstructions": "L\xe6s anvisningerne",
            "voucher.introduction": "Tak for dit k\xf8b. Brug f\xf8lgende kupon til at gennemf\xf8re din betaling.",
            "voucher.expirationDate": "Udl\xf8bsdato",
            "voucher.alternativeReference": "Alternativ reference",
            "dragonpay.voucher.non.bank.selectField.placeholder": "V\xe6lg din udbyder",
            "dragonpay.voucher.bank.selectField.placeholder": "V\xe6lg din bank",
            "voucher.paymentReferenceLabel": "Betalingsreference",
            "voucher.surcharge": "Inkl. till\xe6gsbegyr p\xe5 %@",
            "voucher.introduction.doku": "Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.",
            "voucher.shopperName": "Kundenavn",
            "voucher.merchantName": "S\xe6lger",
            "voucher.introduction.econtext": "Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.",
            "voucher.telephoneNumber": "Telefonnummer",
            "voucher.shopperReference": "K\xf8bers reference",
            "voucher.collectionInstitutionNumber": "Id-nummer til opkr\xe6vningsinstitution",
            "voucher.econtext.telephoneNumber.invalid": "Telefonnummer skal best\xe5 af 10 eller 11 cifre",
            "boletobancario.btnLabel": "Gener\xe9r Boleto",
            "boleto.sendCopyToEmail": "Send en kopi til min e-mail",
            "button.copy": "Kopi\xe9r",
            "button.download": "Download",
            "boleto.socialSecurityNumber": "CPF / CNPJ",
            "boleto.socialSecurityNumber.invalid": "Feltet er ugyldigt",
            "creditCard.storedCard.description.ariaLabel": "Gemt kort ender p\xe5 %@",
            "voucher.entity": "Enhed",
            donateButton: "Giv et bidrag",
            notNowButton: "Ikke nu",
            thanksForYourSupport: "Tak for din st\xf8tte!",
            "resultMessages.preauthorized": "Oplysningerne er gemt",
            preauthorizeWith: "Forh\xe5ndsgodkend med",
            confirmPreauthorization: "Bekr\xe6ft forh\xe5ndsgodkendelse",
            confirmPurchase: "Bekr\xe6ft k\xf8b",
            applyGiftcard: "Indl\xf8s",
            giftcardBalance: "Saldo p\xe5 gavekort",
            deductedBalance: "Fratrukket saldo",
            "creditCard.pin.title": "Pinkode",
            "creditCard.encryptedPassword.label": "F\xf8rste 2 cifre i adgangskode til kort",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Ugyldig adgangskode",
            "creditCard.taxNumber": "Kortholders f\xf8dselsdag eller virksomhedsregistreringsnummer",
            "creditCard.taxNumber.label": "Kortholders f\xf8dselsdato (\xc5\xc5MMDD) eller virksomheds registreringsnummer (10 cifre)",
            "creditCard.taxNumber.labelAlt": "Virksomheds registreringsnummer (10 cifre)",
            "creditCard.taxNumber.invalid": "Ugyldig f\xf8dselsdato for kortholder eller virksomheds registreringsnummer",
            "storedPaymentMethod.disable.button": "Fjern",
            "storedPaymentMethod.disable.confirmation": "Fjern gemt betalingsm\xe5de",
            "storedPaymentMethod.disable.confirmButton": "Ja, fjern",
            "storedPaymentMethod.disable.cancelButton": "Annuller",
            "ach.bankAccount": "Bankkonto",
            "ach.accountHolderNameField.title": "Kontohavers navn",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Ugyldigt kontohavernavn",
            "ach.accountNumberField.title": "Kontonummer",
            "ach.accountNumberField.invalid": "Ugyldigt kontonummer",
            "ach.accountLocationField.title": "ABA-registreringsnummer",
            "ach.accountLocationField.invalid": "Ugyldigt ABA-registreringsnummer",
            "ach.savedBankAccount": "Gemt bankkonto",
            "select.state": "V\xe6lg stat",
            "select.stateOrProvince": "V\xe6lg region eller kommune",
            "select.provinceOrTerritory": "V\xe6lg provins eller territorium",
            "select.country": "V\xe6lg land",
            "select.noOptionsFound": "Ingen muligheder fundet",
            "select.filter.placeholder": "S\xf8g...",
            "telephoneNumber.invalid": "Ugyldigt telefonnummer",
            qrCodeOrApp: "eller",
            "paypal.processingPayment": "Behandler betaling...",
            generateQRCode: "Gener\xe9r QR-kode",
            "await.waitForConfirmation": "Venter p\xe5 bekr\xe6ftelse",
            "mbway.confirmPayment": "Bekr\xe6ft din betaling p\xe5 appen MB WAY",
            "shopperEmail.invalid": "Ugyldig e-mailadresse",
            "dateOfBirth.format": "DD/MM/\xc5\xc5\xc5\xc5",
            "dateOfBirth.invalid": "Indtast en gyldig f\xf8dselsdato, der viser, at du er mindst 18 \xe5r gammel",
            "blik.confirmPayment": "\xc5bn din bankapp for at bekr\xe6fte betalingen.",
            "blik.invalid": "Indtast 6 tal",
            "blik.code": "6-cifret kode",
            "blik.help": "F\xe5 koden fra din bankapp.",
            "swish.pendingMessage": "Visning af status kan tage op til 10 minutter efter scanning. Et nyt fors\xf8g p\xe5 betaling inden for dette tidsrum kan muligvis medf\xf8re flere gebyrer.",
            "field.valid": "Gyldigt felt",
            "field.invalid": "Ugyldigt felt",
            "error.va.gen.01": "Felt ikke udfyldt",
            "error.va.gen.02": "Ugyldigt felt",
            "error.va.sf-cc-num.01": "Indtast et gyldigt kortnummer",
            "error.va.sf-cc-num.02": "Indtast kortnummeret",
            "error.va.sf-cc-num.03": "Indtast et underst\xf8ttet kort",
            "error.va.sf-cc-num.04": "Indtast det fulde kortnummer",
            "error.va.sf-cc-dat.01": "Indtast en gyldig udl\xf8bsdato",
            "error.va.sf-cc-dat.02": "Indtast en gyldig udl\xf8bsdato",
            "error.va.sf-cc-dat.03": "Kreditkort udl\xf8ber snart",
            "error.va.sf-cc-dat.04": "Indtast udl\xf8bsdatoen",
            "error.va.sf-cc-dat.05": "Indtast den fulde udl\xf8bsdato",
            "error.va.sf-cc-mth.01": "Indtast udl\xf8bsm\xe5neden",
            "error.va.sf-cc-yr.01": "Indtast udl\xf8bs\xe5ret",
            "error.va.sf-cc-yr.02": "Indtast det fulde udl\xf8bs\xe5r",
            "error.va.sf-cc-cvc.01": "Indtast sikkerhedskoden",
            "error.va.sf-cc-cvc.02": "Indtast den fulde sikkerhedskode",
            "error.va.sf-ach-num.01": "Feltet til bankkontonummer er tomt",
            "error.va.sf-ach-num.02": "Bankkontonummer har den forkerte l\xe6ngde",
            "error.va.sf-ach-loc.01": "Feltet til registreringsnummeret er tomt",
            "error.va.sf-ach-loc.02": "Registreringsnummeret har den forkerte l\xe6ngde",
            "error.va.sf-kcp-pwd.01": "Feltet til adgangskode er tomt",
            "error.va.sf-kcp-pwd.02": "Adgangskoden har den forkerte l\xe6ngde",
            "error.giftcard.no-balance": "Saldoen p\xe5 gavekortet er 0",
            "error.giftcard.card-error": "Vi har ikke et gavekort med dette nummer i vores optegnelser",
            "error.giftcard.currency-error": "Gavekort er kun gyldige i udstedelsesvalutaen",
            "amazonpay.signout": "Log ud af Amazon",
            "amazonpay.changePaymentDetails": "Skift betalingsoplysninger",
            "partialPayment.warning": "V\xe6lg en anden betalingsm\xe5de til betaling af restbel\xf8bet",
            "partialPayment.remainingBalance": "Restbel\xf8bet vil v\xe6re %{amount}",
            "bankTransfer.beneficiary": "Betalingsmodtager",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Reference",
            "bankTransfer.introduction": "Forts\xe6t med at oprette ny betalingsoverf\xf8rsel via bank. Du kan bruge oplysningerne p\xe5 den f\xf8lgende sk\xe6rm til at afslutte betalingen.",
            "bankTransfer.instructions": "Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.",
            "bacs.accountHolderName": "Bankkontohavers navn",
            "bacs.accountHolderName.invalid": "Ugyldigt navn p\xe5 bankkontohaver",
            "bacs.accountNumber": "Bankkontonummer",
            "bacs.accountNumber.invalid": "Ugyldigt bankkontonummer",
            "bacs.bankLocationId": "Registreringsnummer",
            "bacs.bankLocationId.invalid": "Ugyldigt registreringsnummer",
            "bacs.consent.amount": "Jeg accepterer, at bel\xf8bet ovenfor tr\xe6kkes p\xe5 min bankkonto.",
            "bacs.consent.account": "Jeg bekr\xe6fter, at kontoen er i mit navn, og at jeg er den eneste underskriver, der kr\xe6ves for at godkende direkte debitering af kontoen.",
            edit: "Rediger",
            "bacs.confirm": "Bekr\xe6ft, og betal",
            "bacs.result.introduction": "Download vejledningen til direkte debitering (fuldmagt til direkte debitering)",
            "download.pdf": "Download PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe til kortnummer",
            "creditCard.encryptedCardNumber.aria.label": "Kortnummer",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe til udl\xf8bsdato",
            "creditCard.encryptedExpiryDate.aria.label": "Udl\xf8bsdato",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe til udl\xf8bsm\xe5ned",
            "creditCard.encryptedExpiryMonth.aria.label": "Udl\xf8bsm\xe5ned",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe til udl\xf8bs\xe5r",
            "creditCard.encryptedExpiryYear.aria.label": "Udl\xf8bs\xe5r",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe til sikkerhedskode",
            "creditCard.encryptedSecurityCode.aria.label": "Sikkerhedskode",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe til adgangskode",
            "creditCard.encryptedPassword.aria.label": "F\xf8rste 2 cifre i adgangskode til kort",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe til kortnummer",
            "giftcard.encryptedCardNumber.aria.label": "Kortnummer",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe til pin",
            "giftcard.encryptedSecurityCode.aria.label": "Pinkode",
            giftcardTransactionLimit: "Maks. %{amount} tilladt pr. transaktion p\xe5 dette gavekort",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe til bankkontonummer",
            "ach.encryptedBankAccountNumber.aria.label": "Kontonummer",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe til bankroutingnummer",
            "ach.encryptedBankLocationId.aria.label": "ABA-registreringsnummer",
            "twint.saved": "gemt",
            orPayWith: "eller betal med",
            invalidFormatExpects: "Ugyldigt format. Forventet format: %{format}",
            "upi.qrCodeWaitingMessage": "Scan QR-koden via din foretrukne UPI-app for at gennemf\xf8re betalingen",
            "upi.vpaWaitingMessage": "\xc5bn din UPI-app for at bekr\xe6fte betalingen",
            "upi.modeSelection": "Foretag et valg om, hvordan du vil bruge UPI.",
            "onlineBanking.termsAndConditions": "Ved at forts\xe6tte accepterer du %#vilk\xe5r og betingelser%#",
            "onlineBankingPL.termsAndConditions": "Hvis du forts\xe6tter, accepterer du %#regulativer%# og %#informationspligten%# for Przelewy24",
            "ctp.loading.poweredByCtp": "Drevet af Click to Pay",
            "ctp.loading.intro": "Vi tjekker, om du har gemte kort med Click to Pay...",
            "ctp.login.title": "Forts\xe6t med Click to Pay",
            "ctp.login.subtitle": "Indtast den e-mailadresse, der er knyttet til Click to Pay, for at forts\xe6tte.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "Ikke dig?",
            "ctp.logout.notYourCards": "Ikke dine kort?",
            "ctp.logout.notYourCard": "Ikke dit kort?",
            "ctp.logout.notYourProfile": "Ikke din profil?",
            "ctp.otp.fieldLabel": "Engangskode",
            "ctp.otp.resendCode": "Send kode igen",
            "ctp.otp.codeResent": "Kode er sendt igen",
            "ctp.otp.title": "F\xe5 adgang til dine Click to Pay-kort",
            "ctp.otp.subtitle": "Indtast den kode, vi har sendt til %@ for at bekr\xe6fte, at det er dig.",
            "ctp.otp.saveCookiesCheckbox.label": "Spring bekr\xe6ftelse over n\xe6ste gang",
            "ctp.otp.saveCookiesCheckbox.information": "V\xe6lg dette for at blive husket p\xe5 din enhed og browser i deltagende butikker for hurtigere betaling. Anbefales ikke p\xe5 delte enheder.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "V\xe6lg dette for at blive husket p\xe5 din enhed og browser",
            "ctp.emptyProfile.message": "Ingen kort registreret i denne Click to Pay-profil",
            "ctp.separatorText": "eller brug",
            "ctp.cards.title": "Gennemf\xf8r betaling med Click to Pay",
            "ctp.cards.subtitle": "V\xe6lg et kort, der skal bruges.",
            "ctp.cards.expiredCard": "Udl\xf8bet",
            "ctp.manualCardEntry": "Manuel kortindtastning",
            "ctp.aria.infoModalButton": "Hvad er Click to Pay?",
            "ctp.infoPopup.title": "Med Click to Pay f\xe5r du letheden fra kontaktl\xf8s betaling, online",
            "ctp.infoPopup.subtitle": "En hurtig og sikker betalingsmetode, der underst\xf8ttes af Mastercard, Visa og andre betalingskort.",
            "ctp.infoPopup.benefit1": "Click to Pay bruger kryptering for at holde dine oplysninger sikre og beskyttede",
            "ctp.infoPopup.benefit2": "Brug det med forhandlere i hele verden",
            "ctp.infoPopup.benefit3": "Konfigurer \xe9n gang for betalinger uden problemer i fremtiden",
            "ctp.errors.AUTH_INVALID": "Ugyldig godkendelse",
            "ctp.errors.NOT_FOUND": "Ingen konto fundet, indtast en gyldig e-mail eller forts\xe6t med manuel kortindtastning",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formatet er ikke underst\xf8ttet",
            "ctp.errors.FRAUD": "Brugerkontoen er l\xe5st eller deaktiveret",
            "ctp.errors.CONSUMER_ID_MISSING": "Forbrugeridentitet mangler i anmodningen",
            "ctp.errors.ACCT_INACCESSIBLE": "Denne konto er i \xf8jeblikket ikke tilg\xe6ngelig, f.eks. fordi den er l\xe5st",
            "ctp.errors.CODE_INVALID": "Forkert bekr\xe6ftelsekode",
            "ctp.errors.CODE_EXPIRED": "Denne kode er udl\xf8bet",
            "ctp.errors.RETRIES_EXCEEDED": "Gr\xe6nsen for antallet af fors\xf8g til generering af engangsadgangskode er overskredet",
            "ctp.errors.OTP_SEND_FAILED": "Engangsadgangskoden kunne ikke sendes til modtageren",
            "ctp.errors.REQUEST_TIMEOUT": "Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning",
            "ctp.errors.UNKNOWN_ERROR": "Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning",
            "ctp.errors.SERVICE_ERROR": "Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning",
            "ctp.errors.SERVER_ERROR": "Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning",
            "ctp.errors.INVALID_PARAMETER": "Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning",
            "ctp.errors.AUTH_ERROR": "Noget gik galt, pr\xf8v igen, eller brug den manuelle kortindtastning",
            "paymentMethodsList.aria.label": "V\xe6lg en betalingsmetode",
            "companyDetails.name.invalid": "Indtast virksomhedsnavnet",
            "companyDetails.registrationNumber.invalid": "Indtast registreringsnummeret",
            "consent.checkbox.invalid": "Du skal acceptere vilk\xe5r og betingelser",
            "form.instruction": "Alle felter er obligatoriske, medmindre andet er markeret.",
            "ancv.input.label": "Din ANCV-identifikation",
            "ancv.confirmPayment": "Brug din ANCV-applikation til at bekr\xe6fte betalingen.",
            "ancv.form.instruction": "Cheque-Vacances-applikationen er n\xf8dvendig for at validere denne betaling.",
            "ancv.beneficiaryId.invalid": "Indtast en gyldig e-mailadresse eller ANCV-id",
            "payme.openPayMeApp": "Gennemf\xf8r betalingen i PayMe-appen ved at godkende betalingen i appen og afvente bekr\xe6ftelsen.",
            "payme.redirectButtonLabel": "\xc5bn PayMe-appen",
            "payme.scanQrCode": "Gennemf\xf8r din betaling med QR-kode",
            "payme.timeToPay": "Denne QR-kode er gyldig i %@",
            "payme.instructions.steps": "\xc5bn PayMe-appen.%@Scan QR-koden for at godkende betalingen.%@Gennemf\xf8r betalingen i appen, og afvent bekr\xe6ftelse.",
            "payme.instructions.footnote": "Luk ikke denne side, f\xf8r betalingen er gennemf\xf8rt"
        }
    }), Y1 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Zahle",
            "payButton.redirecting": "Umleiten\u2026",
            "payButton.with": "%{value} mit %{maskedData} zahlen",
            "payButton.saveDetails": "Angaben speichern",
            close: "Schlie\xdfen",
            storeDetails: "F\xfcr zuk\xfcnftige Zahlvorg\xe4nge speichern",
            readMore: "Mehr lesen",
            "creditCard.holderName": "Name auf der Karte",
            "creditCard.holderName.placeholder": "A. M\xfcller",
            "creditCard.holderName.invalid": "Geben Sie den Namen wie auf der Karte gezeigt ein",
            "creditCard.numberField.title": "Kartennummer",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Ablaufdatum",
            "creditCard.expiryDateField.placeholder": "MM/JJ",
            "creditCard.expiryDateField.month": "Monat",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "JJ",
            "creditCard.expiryDateField.year": "Jahr",
            "creditCard.cvcField.title": "Sicherheitscode",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "F\xfcr das n\xe4chste Mal speichern",
            "creditCard.cvcField.placeholder.4digits": "4 Stellen",
            "creditCard.cvcField.placeholder.3digits": "3 Stellen",
            "creditCard.taxNumber.placeholder": "JJMMTT/0123456789",
            installments: "Anzahl der Raten",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} Monate",
            "installments.oneTime": "Einmalige Zahlung",
            "installments.installments": "Ratenzahlung",
            "installments.revolving": "Ratenzahlung",
            "sepaDirectDebit.ibanField.invalid": "Ung\xfcltige Kontonummer",
            "sepaDirectDebit.nameField.placeholder": "A. M\xfcller",
            "sepa.ownerName": "Name des Kontoinhabers",
            "sepa.ibanNumber": "Kontonummer (IBAN)",
            "error.title": "Fehler",
            "error.subtitle.redirect": "Weiterleitung fehlgeschlagen",
            "error.subtitle.payment": "Zahlung fehlgeschlagen",
            "error.subtitle.refused": "Zahlvorgang verweigert",
            "error.message.unknown": "Es ist ein unbekannter Fehler aufgetreten.",
            "errorPanel.title": "Bestehende Fehler",
            "idealIssuer.selectField.title": "Bank",
            "idealIssuer.selectField.placeholder": "Bank ausw\xe4hlen",
            "creditCard.success": "Zahlung erfolgreich",
            loading: "Laden\u2026",
            continue: "Weiter",
            continueTo: "Weiter zu",
            "wechatpay.timetopay": "Sie haben noch %@ um zu zahlen",
            "sr.wechatpay.timetopay": "Sie haben %#Minuten%# %#Sekunden%# Zeit, um zu bezahlen",
            "wechatpay.scanqrcode": "QR-Code scannen",
            personalDetails: "Pers\xf6nliche Angaben",
            companyDetails: "Unternehmensdaten",
            "companyDetails.name": "Unternehmensname",
            "companyDetails.registrationNumber": "Registrierungsnummer",
            socialSecurityNumber: "Sozialversicherungsnummer",
            firstName: "Vorname",
            "firstName.invalid": "Geben Sie Ihren Vornamen ein",
            infix: "Vorwahl",
            lastName: "Nachname",
            "lastName.invalid": "Geben Sie Ihren Nachnamen ein",
            mobileNumber: "Handynummer",
            "mobileNumber.invalid": "Ung\xfcltige Handynummer",
            city: "Stadt",
            postalCode: "Postleitzahl",
            "postalCode.optional": "Postleitzahl (optional)",
            countryCode: "Landesvorwahl",
            telephoneNumber: "Telefonnummer",
            dateOfBirth: "Geburtsdatum",
            shopperEmail: "E-Mail-Adresse",
            gender: "Geschlecht",
            "gender.notselected": "W\xe4hlen Sie Ihr Geschlecht",
            male: "M\xe4nnlich",
            female: "Weiblich",
            billingAddress: "Rechnungsadresse",
            street: "Stra\xdfe",
            stateOrProvince: "Bundesland",
            country: "Land",
            houseNumberOrName: "Hausnummer",
            separateDeliveryAddress: "Abweichende Lieferadresse angeben",
            deliveryAddress: "Lieferadresse",
            "deliveryAddress.firstName": "Vorname des Empf\xe4ngers",
            "deliveryAddress.lastName": "Nachname des Empf\xe4ngers",
            zipCode: "PLZ",
            apartmentSuite: "Wohnung/Geschoss",
            provinceOrTerritory: "Provinz oder Territorium",
            cityTown: "Ort",
            address: "Stra\xdfe und Hausnummer",
            "address.placeholder": "Suchen Sie Ihre Adresse",
            "address.errors.incomplete": "Geben Sie eine Adresse ein, um fortzufahren",
            "address.enterManually": "Geben Sie die Adresse manuell ein",
            state: "Bundesstaat",
            "field.title.optional": "(optional)",
            "creditCard.cvcField.title.optional": "Sicherheitscode (optional)",
            "issuerList.wallet.placeholder": "Virtuelle Brieftasche ausw\xe4hlen",
            privacyPolicy: "Datenschutz",
            "afterPay.agreement": "Ich stimme den %@ von Riverty zu",
            paymentConditions: "Zahlungsbedingungen",
            openApp: "App \xf6ffnen",
            "voucher.readInstructions": "Anweisungen lesen",
            "voucher.introduction": "Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung des folgenden Gutscheins ab.",
            "voucher.expirationDate": "G\xfcltig bis",
            "voucher.alternativeReference": "Alternative Referenz",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Anbieter ausw\xe4hlen",
            "dragonpay.voucher.bank.selectField.placeholder": "Bank ausw\xe4hlen",
            "voucher.paymentReferenceLabel": "Zahlungsreferenz",
            "voucher.surcharge": "Inkl. % @Zuschlag",
            "voucher.introduction.doku": "Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.",
            "voucher.shopperName": "Name des K\xe4ufers",
            "voucher.merchantName": "H\xe4ndler",
            "voucher.introduction.econtext": "Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.",
            "voucher.telephoneNumber": "Telefonnummer",
            "voucher.shopperReference": "Kundenreferenz",
            "voucher.collectionInstitutionNumber": "Nummer der Zahlungsannahmestelle",
            "voucher.econtext.telephoneNumber.invalid": "Die Telefonnummer muss 10- oder 11-stellig sein",
            "boletobancario.btnLabel": "Boleto generieren",
            "boleto.sendCopyToEmail": "Eine Kopie an meine E-Mail-Adresse senden",
            "button.copy": "Kopieren",
            "button.download": "Herunterladen",
            "boleto.socialSecurityNumber.invalid": "Feld ist ung\xfcltig",
            "creditCard.storedCard.description.ariaLabel": "Gespeicherte Karte endet auf %@",
            "voucher.entity": "Entit\xe4t",
            donateButton: "Spenden",
            notNowButton: "Nicht jetzt",
            thanksForYourSupport: "Danke f\xfcr Ihre Unterst\xfctzung!",
            "resultMessages.preauthorized": "Angaben gespeichert",
            preauthorizeWith: "Vorautorisieren mit",
            confirmPreauthorization: "Vorautorisierung best\xe4tigen",
            confirmPurchase: "Kauf best\xe4tigen",
            applyGiftcard: "Einl\xf6sen",
            giftcardBalance: "Saldo der Geschenkkarte",
            deductedBalance: "Abgezogener Betrag",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "Die ersten zwei Ziffern des Kartenpassworts",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Ung\xfcltiges Passwort",
            "creditCard.taxNumber": "Geburtsdatum des Karteninhabers oder der Unternehmensregistrierungsnummer",
            "creditCard.taxNumber.label": "Geburtsdatum des Karteninhabers (JJMMTT) oder Unternehmensregistrierungsnummer (10-stellig)",
            "creditCard.taxNumber.labelAlt": "Unternehmensregistrierungsnummer (10-stellig)",
            "creditCard.taxNumber.invalid": "Ung\xfcltiges Geburtsdatum des Karteninhabers oder ung\xfcltige Unternehmensregistrierungsnummer",
            "storedPaymentMethod.disable.button": "Entfernen",
            "storedPaymentMethod.disable.confirmation": "Gespeicherte Zahlungsmethode entfernen",
            "storedPaymentMethod.disable.confirmButton": "Ja, entfernen",
            "storedPaymentMethod.disable.cancelButton": "Abbrechen",
            "ach.bankAccount": "Bankkonto",
            "ach.accountHolderNameField.title": "Name des Kontoinhabers",
            "ach.accountHolderNameField.placeholder": "A. M\xfcller",
            "ach.accountHolderNameField.invalid": "Ung\xfcltiger Kontoinhabername",
            "ach.accountNumberField.title": "Kontonummer",
            "ach.accountNumberField.invalid": "Ung\xfcltige Kontonummer",
            "ach.accountLocationField.title": "ABA-Nummer",
            "ach.accountLocationField.invalid": "Ung\xfcltige ABA-Nummer",
            "ach.savedBankAccount": "Gespeichertes Bankkonto",
            "select.state": "Bundesstaat ausw\xe4hlen",
            "select.stateOrProvince": "Bundesland oder Provinz/Region ausw\xe4hlen",
            "select.provinceOrTerritory": "Provinz oder Territorium ausw\xe4hlen",
            "select.country": "Land ausw\xe4hlen",
            "select.noOptionsFound": "Keine Optionen gefunden",
            "select.filter.placeholder": "Suche\u2026",
            "telephoneNumber.invalid": "Ung\xfcltige Telefonnummer",
            qrCodeOrApp: "oder",
            "paypal.processingPayment": "Zahlung wird verarbeitet\u2026",
            generateQRCode: "QR-Code generieren",
            "await.waitForConfirmation": "Warten auf Best\xe4tigung",
            "mbway.confirmPayment": "Best\xe4tigen Sie Ihre Zahlung in der MB WAY-App",
            "shopperEmail.invalid": "Ung\xfcltige E-Mail-Adresse",
            "dateOfBirth.format": "TT.MM.JJJJ",
            "dateOfBirth.invalid": "Geben Sie ein g\xfcltiges Geburtsdatum ein, das angibt, dass Sie mindestens 18 Jahre alt sind.",
            "blik.confirmPayment": "\xd6ffnen Sie Ihre Banking-App, um die Zahlung zu best\xe4tigen.",
            "blik.invalid": "6 Zahlen eingeben",
            "blik.code": "6-stelliger Code",
            "blik.help": "Rufen Sie den Code \xfcber Ihre Banking-App ab.",
            "swish.pendingMessage": "Es kann sein, dass der Status bis zu 10 Minuten nach dem Scan \u201Eausstehend\u201C lautet. Wenn Sie w\xe4hrenddessen einen neuen Zahlungsversuch unternehmen, kann es sein, dass Ihnen mehrere Betr\xe4ge in Rechnung gestellt werden.",
            "field.valid": "Feld g\xfcltig",
            "field.invalid": "Feld ung\xfcltig",
            "error.va.gen.01": "Feld nicht ausgef\xfcllt",
            "error.va.gen.02": "Feld ung\xfcltig",
            "error.va.sf-cc-num.01": "Geben Sie eine g\xfcltige Kartennummer ein",
            "error.va.sf-cc-num.02": "Geben Sie die Kartennummer ein",
            "error.va.sf-cc-num.03": "Geben Sie eine unterst\xfctzte Kartenmarke ein",
            "error.va.sf-cc-num.04": "Geben Sie die vollst\xe4ndige Kartennummer ein",
            "error.va.sf-cc-dat.01": "Geben Sie ein g\xfcltiges Ablaufdatum ein",
            "error.va.sf-cc-dat.02": "Geben Sie ein g\xfcltiges Ablaufdatum ein",
            "error.va.sf-cc-dat.03": "Kreditkarte l\xe4uft bald ab",
            "error.va.sf-cc-dat.04": "Geben Sie das Ablaufdatum ein",
            "error.va.sf-cc-dat.05": "Geben Sie das vollst\xe4ndige Ablaufdatum ein",
            "error.va.sf-cc-mth.01": "Geben Sie den Ablaufmonat ein",
            "error.va.sf-cc-yr.01": "Geben Sie das Ablaufjahr ein",
            "error.va.sf-cc-yr.02": "Geben Sie das vollst\xe4ndige Ablaufjahr ein",
            "error.va.sf-cc-cvc.01": "Geben Sie den Sicherheitscode ein",
            "error.va.sf-cc-cvc.02": "Geben Sie den vollst\xe4ndigen Sicherheitscode ein",
            "error.va.sf-ach-num.01": "Das Feld f\xfcr die Bankkontonummer ist leer",
            "error.va.sf-ach-num.02": "Die Bankkontonummer hat die falsche L\xe4nge",
            "error.va.sf-ach-loc.01": "Das Feld f\xfcr die Bankleitzahl ist leer",
            "error.va.sf-ach-loc.02": "Die Bankleitzahl hat die falsche L\xe4nge",
            "error.va.sf-kcp-pwd.01": "Das Passwortfeld ist leer",
            "error.va.sf-kcp-pwd.02": "Das Passwort hat die falsche L\xe4nge",
            "error.giftcard.no-balance": "Auf dieser Geschenkkarte ist kein Guthaben vorhanden",
            "error.giftcard.card-error": "Es gibt in unserem System keine Geschenkkarte mit dieser Nummer",
            "error.giftcard.currency-error": "Geschenkkarten sind nur in der W\xe4hrung g\xfcltig, in der sie ausgestellt wurden",
            "amazonpay.signout": "Von Amazon abmelden",
            "amazonpay.changePaymentDetails": "Zahlungsinformationen \xe4ndern",
            "partialPayment.warning": "W\xe4hlen Sie eine andere Zahlungsmethode zur Zahlung des Restbetrags",
            "partialPayment.remainingBalance": "Es verbleibt ein Restbetrag von %{amount}",
            "bankTransfer.beneficiary": "Empf\xe4nger",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Referenz",
            "bankTransfer.introduction": "Fortfahren, um eine neue Bank\xfcberweisungszahlung zu erstellen. Sie k\xf6nnen die Informationen auf dem n\xe4chsten Bildschirm verwenden, um diese Zahlung abzuschlie\xdfen.",
            "bankTransfer.instructions": "Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.",
            "bacs.accountHolderName": "Name des Bankkontoinhabers",
            "bacs.accountHolderName.invalid": "Ung\xfcltiger Bankkontoinhabername",
            "bacs.accountNumber": "Bankkontonummer",
            "bacs.accountNumber.invalid": "Ung\xfcltige Bankkontonummer",
            "bacs.bankLocationId": "Bankleitzahl",
            "bacs.bankLocationId.invalid": "Ung\xfcltige Bankleitzahl",
            "bacs.consent.amount": "Ich bin damit einverstanden, dass der oben genannte Betrag von meinem Bankkonto abgebucht wird.",
            "bacs.consent.account": "Ich best\xe4tige, dass das Konto unter meinem Namen l\xe4uft und ich der einzige erforderliche Unterzeichner bin, um die Lastschrift f\xfcr dieses Konto zu autorisieren.",
            edit: "Bearbeiten",
            "bacs.confirm": "Best\xe4tigen und bezahlen",
            "bacs.result.introduction": "Laden Sie Ihre Lastschriftanweisung (DDI/Einzugserm\xe4chtigung) herunter",
            "download.pdf": "PDF herunterladen",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe f\xfcr Kartennummer",
            "creditCard.encryptedCardNumber.aria.label": "Kartennummer",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe f\xfcr Ablaufdatum",
            "creditCard.encryptedExpiryDate.aria.label": "Ablaufdatum",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe f\xfcr Ablaufmonat",
            "creditCard.encryptedExpiryMonth.aria.label": "Monat des Ablaufdatums",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe f\xfcr Ablaufjahr",
            "creditCard.encryptedExpiryYear.aria.label": "Jahr des Ablaufdatums",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe f\xfcr Sicherheitscode",
            "creditCard.encryptedSecurityCode.aria.label": "Sicherheitscode",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe f\xfcr Passwort",
            "creditCard.encryptedPassword.aria.label": "Die ersten zwei Ziffern des Kartenpassworts",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe f\xfcr Kartennummer",
            "giftcard.encryptedCardNumber.aria.label": "Kartennummer",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe f\xfcr Stift",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Der zul\xe4ssige H\xf6chstbetrag pro Transaktion f\xfcr diese Geschenkkarte ist %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe f\xfcr Bankkontonummer",
            "ach.encryptedBankAccountNumber.aria.label": "Kontonummer",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe f\xfcr Bankleitzahl",
            "ach.encryptedBankLocationId.aria.label": "ABA-Nummer",
            "twint.saved": "hinterlegt",
            orPayWith: "oder bezahlen Sie mit",
            invalidFormatExpects: "Ung\xfcltiges Format. Erwartetes Format: %{format}",
            "upi.qrCodeWaitingMessage": "Scannen Sie den QR-Code mit Ihrer bevorzugten UPI-App, um die Zahlung abzuschlie\xdfen.",
            "upi.vpaWaitingMessage": "\xd6ffnen Sie Ihre UPI-App, um die Zahlung zu best\xe4tigen.",
            "upi.modeSelection": "Legen Sie fest, wie Sie UPI nutzen m\xf6chten.",
            "onlineBanking.termsAndConditions": "Wenn Sie fortfahren, stimmen Sie den %#Allgemeinen Gesch\xe4ftsbedingungen%# zu",
            "onlineBankingPL.termsAndConditions": "Indem Sie fortfahren, stimmen Sie den %#Vorschriften%# und der %#Auskunftspflicht%# von Przelewy24 zu",
            "ctp.loading.poweredByCtp": "Unterst\xfctzt von Click to Pay",
            "ctp.loading.intro": "Wir \xfcberpr\xfcfen gerade, ob Sie bereits gespeicherte Click-to-Pay-Karten haben\u2026",
            "ctp.login.title": "Weiter zu Click to Pay",
            "ctp.login.subtitle": "Geben Sie die mit Click to Pay verbundene E-Mail-Adresse ein, um fortzufahren.",
            "ctp.login.inputLabel": "E-Mail-Adresse",
            "ctp.logout.notYou": "Sind das nicht Sie?",
            "ctp.logout.notYourCards": "Sind das nicht Ihre Karten?",
            "ctp.logout.notYourCard": "Das ist nicht Ihre Karte?",
            "ctp.logout.notYourProfile": "Das ist nicht Ihr Profil?",
            "ctp.otp.fieldLabel": "Einmaliger Code",
            "ctp.otp.resendCode": "Code erneut senden",
            "ctp.otp.codeResent": "Code erneut gesendet",
            "ctp.otp.title": "Zugriff auf Ihre Click-to-Pay-Karten",
            "ctp.otp.subtitle": "Geben Sie den Code ein, der von %@ an %@ gesendet wurde, um Ihre Identit\xe4t zu best\xe4tigen.",
            "ctp.otp.saveCookiesCheckbox.label": "Verifizierung beim n\xe4chsten Mal \xfcberspringen",
            "ctp.otp.saveCookiesCheckbox.information": "W\xe4hlen Sie diese Option, um bei teilnehmenden Gesch\xe4ften auf Ihrem Ger\xe4t und Browser gespeichert zu werden, um den Bestellvorgang zu beschleunigen. Nicht f\xfcr gemeinsam genutzte Ger\xe4te empfohlen.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "W\xe4hlen Sie diese Option aus, um auf Ihrem Ger\xe4t und Browser gespeichert zu werden",
            "ctp.emptyProfile.message": "In diesem Click-to-Pay-Profil sind keine Karten registriert",
            "ctp.separatorText": "oder verwenden",
            "ctp.cards.title": "Zahlung mit Click to Pay abschlie\xdfen",
            "ctp.cards.subtitle": "W\xe4hlen Sie die Karte aus, die Sie verwenden m\xf6chten.",
            "ctp.cards.expiredCard": "Abgelaufen",
            "ctp.manualCardEntry": "Manuelle Karteneingabe",
            "ctp.aria.infoModalButton": "Was ist Click to Pay?",
            "ctp.infoPopup.title": "Click to Pay ist so einfach wie kontaktloses Bezahlen, nur online",
            "ctp.infoPopup.subtitle": "Eine schnelle, sichere Zahlungsmethode mit Mastercard, Visa und anderen Zahlungskarten.",
            "ctp.infoPopup.benefit1": "Click to Pay nutzt Verschl\xfcsselung zum Schutz Ihrer Daten",
            "ctp.infoPopup.benefit2": "Verf\xfcgbar bei H\xe4ndlern auf der ganzen Welt",
            "ctp.infoPopup.benefit3": "Nach einmaliger Einrichtung bezahlen Sie in Zukunft mit nur einem Klick.",
            "ctp.errors.AUTH_INVALID": "Authentifizierung ung\xfcltig",
            "ctp.errors.NOT_FOUND": "Kein Konto gefunden, geben Sie eine g\xfcltige E-Mail-Adresse ein oder fahren Sie mit der manuellen Karteneingabe fort.",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Format wird nicht unterst\xfctzt",
            "ctp.errors.FRAUD": "Das Benutzerkonto wurde gesperrt oder deaktiviert",
            "ctp.errors.CONSUMER_ID_MISSING": "Die Identit\xe4t des Verbrauchers fehlt in der Anfrage",
            "ctp.errors.ACCT_INACCESSIBLE": "Dieses Konto ist derzeit nicht verf\xfcgbar; es kann z.\xa0B. gesperrt sein.",
            "ctp.errors.CODE_INVALID": "Falscher Verifizierungscode",
            "ctp.errors.CODE_EXPIRED": "Dieser Code ist abgelaufen",
            "ctp.errors.RETRIES_EXCEEDED": "Das Limit f\xfcr die Anzahl der Wiederholungen f\xfcr das Generieren von Einmalpassw\xf6rtern (OTPs) wurde \xfcberschritten",
            "ctp.errors.OTP_SEND_FAILED": "Das Einmalpasswort (OTP) konnte nicht an den Empf\xe4nger gesendet werden",
            "ctp.errors.REQUEST_TIMEOUT": "Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.",
            "ctp.errors.UNKNOWN_ERROR": "Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.",
            "ctp.errors.SERVICE_ERROR": "Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.",
            "ctp.errors.SERVER_ERROR": "Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.",
            "ctp.errors.INVALID_PARAMETER": "Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.",
            "ctp.errors.AUTH_ERROR": "Ein Fehler ist aufgetreten, versuchen Sie es erneut oder nutzen Sie die manuelle Karteneingabe.",
            "paymentMethodsList.aria.label": "W\xe4hlen Sie eine Zahlungsmethode aus",
            "companyDetails.name.invalid": "Geben Sie den Firmennamen ein",
            "companyDetails.registrationNumber.invalid": "Geben Sie die Registrierungsnummer ein",
            "consent.checkbox.invalid": "Sie m\xfcssen den Gesch\xe4ftsbedingungen zustimmen",
            "form.instruction": "Alle Felder sind Pflichtfelder, sofern nicht anders gekennzeichnet.",
            "ancv.input.label": "Ihre ANCV-Identifikation",
            "ancv.confirmPayment": "Best\xe4tigen Sie die Zahlung mit Ihrem ANCV-Antrag.",
            "ancv.form.instruction": "Zur Validierung dieser Zahlung ist der Antrag \u201ECheque-Vacances\u201C erforderlich.",
            "ancv.beneficiaryId.invalid": "Geben Sie eine g\xfcltige E-Mail-Adresse oder ANCV-ID ein",
            "payme.openPayMeApp": "Schlie\xdfen Sie Ihre Zahlung in der PayMe-App ab, indem Sie die Zahlung in der App autorisieren und auf die Best\xe4tigung warten.",
            "payme.redirectButtonLabel": "\xd6ffnen Sie die PayMe-App",
            "payme.scanQrCode": "Schlie\xdfen Sie Ihre Zahlung per QR-Code ab",
            "payme.timeToPay": "Dieser QR-Code gilt f\xfcr %@",
            "payme.instructions.steps": "\xd6ffnen Sie die PayMe-App.%@Scannen Sie den QR-Code, um die Zahlung zu autorisieren.%@Schlie\xdfen Sie die Zahlung in der App ab und warten Sie auf eine Best\xe4tigung.",
            "payme.instructions.footnote": "Bitte schlie\xdfen Sie diese Seite nicht, bevor die Zahlung abgeschlossen ist"
        }
    }), Q1 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE",
            "payButton.redirecting": "\u0391\u03BD\u03B1\u03BA\u03B1\u03C4\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7...",
            "payButton.with": "\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE %{value} \u03BC\u03B5 %{maskedData}",
            "payButton.saveDetails": "\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03C9\u03BD",
            close: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF",
            storeDetails: "\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BC\u03BF\u03C5",
            readMore: "\u0391\u03BD\u03AC\u03B3\u03BD\u03C9\u03C3\u03B7 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03C9\u03BD",
            "creditCard.holderName": "\u038C\u03BD\u03BF\u03BC\u03B1 \u03C3\u03C4\u03B7\u03BD \u03BA\u03AC\u03C1\u03C4\u03B1",
            "creditCard.holderName.placeholder": "\u0393. \u03A0\u03B1\u03C0\u03B1\u03B4\u03AC\u03BA\u03B7\u03C2",
            "creditCard.holderName.invalid": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03CC\u03C0\u03C9\u03C2 \u03B1\u03BD\u03B1\u03B3\u03C1\u03AC\u03C6\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B7\u03BD \u03BA\u03AC\u03C1\u03C4\u03B1",
            "creditCard.numberField.title": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "creditCard.expiryDateField.placeholder": "\u039C\u039C/\u0395\u0395",
            "creditCard.expiryDateField.month": "\u039C\u03AE\u03BD\u03B1\u03C2",
            "creditCard.expiryDateField.month.placeholder": "\u039C\u039C",
            "creditCard.expiryDateField.year.placeholder": "\u0395\u0395",
            "creditCard.expiryDateField.year": "\u0388\u03C4\u03BF\u03C2",
            "creditCard.cvcField.title": "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "\u0391\u03C0\u03BF\u03BC\u03BD\u03B7\u03BC\u03CC\u03BD\u03B5\u03C5\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03C6\u03BF\u03C1\u03AC",
            "creditCard.cvcField.placeholder.4digits": "4\u03C8\u03AE\u03C6\u03B9\u03BF\u03C2",
            "creditCard.cvcField.placeholder.3digits": "3\u03C8\u03AE\u03C6\u03B9\u03BF\u03C2",
            "creditCard.taxNumber.placeholder": "\u0395\u0395\u039C\u039C\u0397\u0397 / 0123456789",
            installments: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B4\u03CC\u03C3\u03B5\u03C9\u03BD",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} \u03BC\u03AE\u03BD\u03B5\u03C2",
            "installments.oneTime": "\u0395\u03C6\u03AC\u03C0\u03B1\u03BE \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE",
            "installments.installments": "\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BC\u03B5 \u03B4\u03CC\u03C3\u03B5\u03B9\u03C2",
            "installments.revolving": "\u0391\u03BD\u03B1\u03BA\u03C5\u03BA\u03BB\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE",
            "sepaDirectDebit.ibanField.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "sepaDirectDebit.nameField.placeholder": "\u0393. \u03A0\u03B1\u03C0\u03B1\u03B4\u03AC\u03BA\u03B7\u03C2",
            "sepa.ownerName": "\u038C\u03BD\u03BF\u03BC\u03B1 \u03BA\u03B1\u03C4\u03CC\u03C7\u03BF\u03C5",
            "sepa.ibanNumber": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD (IBAN)",
            "error.title": "\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1",
            "error.subtitle.redirect": "\u0397 \u03B1\u03BD\u03B1\u03BA\u03B1\u03C4\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B1\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5",
            "error.subtitle.payment": "\u0397 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03B1\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5",
            "error.subtitle.refused": "\u0397 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03B1\u03C0\u03BF\u03C1\u03C1\u03AF\u03C6\u03B8\u03B7\u03BA\u03B5",
            "error.message.unknown": "\u03A0\u03C1\u03BF\u03AD\u03BA\u03C5\u03C8\u03B5 \u03AC\u03B3\u03BD\u03C9\u03C3\u03C4\u03BF \u03C3\u03C6\u03AC\u03BB\u03BC\u03B1",
            "errorPanel.title": "\u03A5\u03C0\u03AC\u03C1\u03C7\u03BF\u03BD\u03C4\u03B1 \u03C3\u03C6\u03AC\u03BB\u03BC\u03B1\u03C4\u03B1",
            "idealIssuer.selectField.title": "\u03A4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1",
            "idealIssuer.selectField.placeholder": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03AC \u03C3\u03B1\u03C2",
            "creditCard.success": "\u0397 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03CE\u03C2",
            loading: "\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7...",
            continue: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1",
            continueTo: "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BD",
            "wechatpay.timetopay": "\u0388\u03C7\u03B5\u03C4\u03B5 \u03C3\u03C4\u03B7 \u03B4\u03B9\u03AC\u03B8\u03B5\u03C3\u03AE \u03C3\u03B1\u03C2 %@ \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE",
            "sr.wechatpay.timetopay": "\u0388\u03C7\u03B5\u03C4\u03B5 %#\u03BB\u03B5\u03C0\u03C4\u03AC%# %#\u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1%# \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5",
            "wechatpay.scanqrcode": "\u03A3\u03AC\u03C1\u03C9\u03C3\u03B7 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD QR",
            personalDetails: "\u03A0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03AC \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1",
            companyDetails: "\u03A3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2",
            "companyDetails.name": "\u038C\u03BD\u03BF\u03BC\u03B1 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2",
            "companyDetails.registrationNumber": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5",
            socialSecurityNumber: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C6\u03BF\u03C1\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03BF\u03CD \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5",
            firstName: "\u038C\u03BD\u03BF\u03BC\u03B1",
            "firstName.invalid": "\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03CC\u03BD\u03BF\u03BC\u03AC \u03C3\u03B1\u03C2",
            infix: "\u03A0\u03C1\u03CC\u03B8\u03B5\u03BC\u03B1",
            lastName: "\u0395\u03C0\u03CE\u03BD\u03C5\u03BC\u03BF",
            "lastName.invalid": "\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03B5\u03C0\u03CE\u03BD\u03C5\u03BC\u03CC \u03C3\u03B1\u03C2",
            mobileNumber: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BA\u03B9\u03BD\u03B7\u03C4\u03BF\u03CD",
            "mobileNumber.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BA\u03B9\u03BD\u03B7\u03C4\u03BF\u03CD",
            city: "\u03A0\u03CC\u03BB\u03B7",
            postalCode: "\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2",
            "postalCode.optional": "\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 (\u03C0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC)",
            countryCode: "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C7\u03CE\u03C1\u03B1\u03C2",
            telephoneNumber: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5",
            dateOfBirth: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2",
            shopperEmail: "\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email",
            gender: "\u03A6\u03CD\u03BB\u03BF",
            "gender.notselected": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03BF \u03C6\u03CD\u03BB\u03BF \u03C3\u03B1\u03C2",
            male: "\u0386\u03BD\u03C4\u03C1\u03B1\u03C2",
            female: "\u0393\u03C5\u03BD\u03B1\u03AF\u03BA\u03B1",
            billingAddress: "\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03C4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2",
            street: "\u039F\u03B4\u03CC\u03C2",
            stateOrProvince: "\u03A0\u03BF\u03BB\u03B9\u03C4\u03B5\u03AF\u03B1 \u03AE \u03B5\u03C0\u03B1\u03C1\u03C7\u03AF\u03B1",
            country: "\u03A7\u03CE\u03C1\u03B1",
            houseNumberOrName: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BF\u03B9\u03BA\u03AF\u03B1\u03C2",
            separateDeliveryAddress: "\u039A\u03B1\u03B8\u03BF\u03C1\u03AF\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03BE\u03B5\u03C7\u03C9\u03C1\u03B9\u03C3\u03C4\u03AE \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03C0\u03B1\u03C1\u03AC\u03B4\u03BF\u03C3\u03B7\u03C2",
            deliveryAddress: "\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03C0\u03B1\u03C1\u03AC\u03B4\u03BF\u03C3\u03B7\u03C2",
            "deliveryAddress.firstName": "\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03B1\u03C1\u03B1\u03BB\u03AE\u03C0\u03C4\u03B7",
            "deliveryAddress.lastName": "\u0395\u03C0\u03CE\u03BD\u03C5\u03BC\u03BF \u03C0\u03B1\u03C1\u03B1\u03BB\u03AE\u03C0\u03C4\u03B7",
            zipCode: "\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u03BA\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2",
            apartmentSuite: "\u0394\u03B9\u03B1\u03BC\u03AD\u03C1\u03B9\u03C3\u03BC\u03B1/\u0393\u03C1\u03B1\u03C6\u03B5\u03AF\u03BF",
            provinceOrTerritory: "\u0395\u03C0\u03B1\u03C1\u03C7\u03AF\u03B1 \u03AE \u03C0\u03B5\u03C1\u03B9\u03C6\u03AD\u03C1\u03B5\u03B9\u03B1",
            cityTown: "\u03A0\u03CC\u03BB\u03B7 / \u039A\u03BF\u03B9\u03BD\u03CC\u03C4\u03B7\u03C4\u03B1",
            address: "\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7",
            "address.placeholder": "\u0392\u03C1\u03B5\u03AF\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03AE \u03C3\u03B1\u03C2",
            "address.errors.incomplete": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5",
            "address.enterManually": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03BC\u03B7 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B1",
            state: "\u03A0\u03BF\u03BB\u03B9\u03C4\u03B5\u03AF\u03B1",
            "field.title.optional": "(\u03C0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC)",
            "creditCard.cvcField.title.optional": "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2 (\u03C0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC)",
            "issuerList.wallet.placeholder": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2",
            privacyPolicy: "\u03A0\u03BF\u03BB\u03B9\u03C4\u03B9\u03BA\u03AE \u03B1\u03C0\u03BF\u03C1\u03C1\u03AE\u03C4\u03BF\u03C5",
            "afterPay.agreement": "\u0391\u03C0\u03BF\u03B4\u03AD\u03C7\u03BF\u03BC\u03B1\u03B9 \u03C4\u03BF\u03C5\u03C2 %@ \u03C4\u03BF\u03C5 Riverty",
            paymentConditions: "\u03CC\u03C1\u03BF\u03C5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
            openApp: "\u0386\u03BD\u03BF\u03B9\u03B3\u03BC\u03B1 \u03C4\u03B7\u03C2 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE\u03C2",
            "voucher.readInstructions": "\u0394\u03B9\u03B1\u03B2\u03AC\u03C3\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03BF\u03B4\u03B7\u03B3\u03AF\u03B5\u03C2",
            "voucher.introduction": "\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B1\u03B3\u03BF\u03C1\u03AC. \u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03BA\u03BF\u03C5\u03C0\u03CC\u03BD\u03B9 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE.",
            "voucher.expirationDate": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "voucher.alternativeReference": "\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03BA\u03C4\u03B9\u03BA\u03AE \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC",
            "dragonpay.voucher.non.bank.selectField.placeholder": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C0\u03AC\u03C1\u03BF\u03C7\u03CC \u03C3\u03B1\u03C2",
            "dragonpay.voucher.bank.selectField.placeholder": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03AC \u03C3\u03B1\u03C2",
            "voucher.paymentReferenceLabel": "\u0391\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
            "voucher.surcharge": "\u03A0\u03B5\u03C1\u03B9\u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03C4\u03B1\u03B9 \u03C0\u03C1\u03CC\u03C3\u03B8\u03B5\u03C4\u03B7 \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7 %@",
            "voucher.introduction.doku": "\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B1\u03B3\u03BF\u03C1\u03AC. \u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE.",
            "voucher.shopperName": "\u038C\u03BD\u03BF\u03BC\u03B1 \u03B1\u03B3\u03BF\u03C1\u03B1\u03C3\u03C4\u03AE",
            "voucher.merchantName": "\u0388\u03BC\u03C0\u03BF\u03C1\u03BF\u03C2",
            "voucher.introduction.econtext": "\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B1\u03B3\u03BF\u03C1\u03AC. \u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE.",
            "voucher.telephoneNumber": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5",
            "voucher.shopperReference": "\u0391\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03B1\u03B3\u03BF\u03C1\u03B1\u03C3\u03C4\u03AE",
            "voucher.collectionInstitutionNumber": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C0\u03C1\u03B1\u03BA\u03C4\u03BF\u03C1\u03B5\u03AF\u03BF\u03C5 \u03B5\u03B9\u03C3\u03C0\u03C1\u03AC\u03BE\u03B5\u03C9\u03BD",
            "voucher.econtext.telephoneNumber.invalid": "\u039F \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9 10 \u03AE 11 \u03C8\u03B7\u03C6\u03AF\u03B1",
            "boletobancario.btnLabel": "\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 Boleto",
            "boleto.sendCopyToEmail": "\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C6\u03BF\u03C5 \u03C3\u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03BC\u03BF\u03C5",
            "button.copy": "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE",
            "button.download": "\u039B\u03AE\u03C8\u03B7",
            "boleto.socialSecurityNumber.invalid": "\u03A4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF",
            "creditCard.storedCard.description.ariaLabel": "\u0397 \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03C5\u03BC\u03AD\u03BD\u03B7 \u03BA\u03AC\u03C1\u03C4\u03B1 \u03C4\u03B5\u03BB\u03B5\u03B9\u03CE\u03BD\u03B5\u03B9 \u03C3\u03B5 %@",
            "voucher.entity": "\u039F\u03BD\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1",
            donateButton: "\u0394\u03C9\u03C1\u03B5\u03AC",
            notNowButton: "\u038C\u03C7\u03B9 \u03C4\u03CE\u03C1\u03B1",
            thanksForYourSupport: "\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C5\u03C0\u03BF\u03C3\u03C4\u03AE\u03C1\u03B9\u03BE\u03B7!",
            "resultMessages.preauthorized": "\u03A4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03CD\u03C4\u03B7\u03BA\u03B1\u03BD",
            preauthorizeWith: "\u03A0\u03C1\u03BF\u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03CC\u03C4\u03B7\u03C3\u03B7 \u03BC\u03B5",
            confirmPreauthorization: "\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03C0\u03C1\u03BF\u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03CC\u03C4\u03B7\u03C3\u03B7\u03C2",
            confirmPurchase: "\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03B1\u03B3\u03BF\u03C1\u03AC\u03C2",
            applyGiftcard: "\u0395\u03BE\u03B1\u03C1\u03B3\u03CD\u03C1\u03C9\u03C3\u03B7",
            giftcardBalance: "\u03A5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF \u03B4\u03C9\u03C1\u03BF\u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            deductedBalance: "\u03A5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF \u03C0\u03BF\u03C5 \u03B1\u03C6\u03B1\u03B9\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5",
            "creditCard.pin.title": "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 PIN",
            "creditCard.encryptedPassword.label": "\u03A4\u03B1 \u03C0\u03C1\u03CE\u03C4\u03B1 2 \u03C8\u03B7\u03C6\u03AF\u03B1 \u03C4\u03BF\u03C5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03C4\u03B7\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
            "creditCard.taxNumber": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2 \u03BA\u03B1\u03C4\u03CC\u03C7\u03BF\u03C5 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2 \u03AE \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03B9\u03CE\u03BD",
            "creditCard.taxNumber.label": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2 \u03BA\u03B1\u03C4\u03CC\u03C7\u03BF\u03C5 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2 (YYMMDD) \u03AE \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03B9\u03CE\u03BD (10 \u03C8\u03B7\u03C6\u03AF\u03B1)",
            "creditCard.taxNumber.labelAlt": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03B9\u03CE\u03BD (10 \u03C8\u03B7\u03C6\u03AF\u03B1)",
            "creditCard.taxNumber.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2 \u03BA\u03B1\u03C4\u03CC\u03C7\u03BF\u03C5 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2 \u03AE \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03B9\u03CE\u03BD",
            "storedPaymentMethod.disable.button": "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7",
            "storedPaymentMethod.disable.confirmation": "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03C5\u03BC\u03AD\u03BD\u03BF\u03C5 \u03C4\u03C1\u03CC\u03C0\u03BF\u03C5 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
            "storedPaymentMethod.disable.confirmButton": "\u039D\u03B1\u03B9, \u03B1\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7",
            "storedPaymentMethod.disable.cancelButton": "\u0386\u03BA\u03C5\u03C1\u03BF",
            "ach.bankAccount": "\u03A4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2",
            "ach.accountHolderNameField.title": "\u038C\u03BD\u03BF\u03BC\u03B1 \u03BA\u03B1\u03C4\u03CC\u03C7\u03BF\u03C5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "ach.accountHolderNameField.placeholder": "\u0393. \u03A0\u03B1\u03C0\u03B1\u03B4\u03AC\u03BA\u03B7\u03C2",
            "ach.accountHolderNameField.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03BA\u03B1\u03C4\u03CC\u03C7\u03BF\u03C5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "ach.accountNumberField.title": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "ach.accountNumberField.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "ach.accountLocationField.title": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B4\u03C1\u03BF\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2 ABA",
            "ach.accountLocationField.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B4\u03C1\u03BF\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2 ABA",
            "ach.savedBankAccount": "\u0391\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03C5\u03BC\u03AD\u03BD\u03BF\u03C2 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2",
            "select.state": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C0\u03BF\u03BB\u03B9\u03C4\u03B5\u03AF\u03B1",
            "select.stateOrProvince": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C0\u03BF\u03BB\u03B9\u03C4\u03B5\u03AF\u03B1 \u03AE \u03B5\u03C0\u03B1\u03C1\u03C7\u03AF\u03B1",
            "select.provinceOrTerritory": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B5\u03C0\u03B1\u03C1\u03C7\u03AF\u03B1 \u03AE \u03C0\u03B5\u03C1\u03B9\u03C6\u03AD\u03C1\u03B5\u03B9\u03B1",
            "select.country": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C7\u03CE\u03C1\u03B1",
            "select.noOptionsFound": "\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2",
            "select.filter.placeholder": "\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7...",
            "telephoneNumber.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B7\u03BB\u03B5\u03C6\u03CE\u03BD\u03BF\u03C5",
            qrCodeOrApp: "\u03AE",
            "paypal.processingPayment": "\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2...",
            generateQRCode: "\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD QR",
            "await.waitForConfirmation": "\u0391\u03BD\u03B1\u03BC\u03BF\u03BD\u03AE \u03B3\u03B9\u03B1 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7\u2026",
            "mbway.confirmPayment": "\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE MB WAY",
            "shopperEmail.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email",
            "dateOfBirth.format": "\u0397\u0397/\u039C\u039C/\u0395\u0395\u0395\u0395",
            "dateOfBirth.invalid": "\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B3\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2 \u03C0\u03BF\u03C5 \u03C5\u03C0\u03BF\u03B4\u03B7\u03BB\u03CE\u03BD\u03B5\u03B9 \u03CC\u03C4\u03B9 \u03B5\u03AF\u03C3\u03C4\u03B5 \u03B7\u03BB\u03B9\u03BA\u03AF\u03B1\u03C2 \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD 18 \u03B5\u03C4\u03CE\u03BD",
            "blik.confirmPayment": "\u0391\u03BD\u03BF\u03AF\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE.",
            "blik.invalid": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 6 \u03C8\u03B7\u03C6\u03AF\u03B1",
            "blik.code": "6\u03C8\u03AE\u03C6\u03B9\u03BF\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2",
            "blik.help": "\u039B\u03AC\u03B2\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE\u03C2 \u03C3\u03B1\u03C2.",
            "swish.pendingMessage": "\u039C\u03B5\u03C4\u03AC \u03C4\u03B7 \u03C3\u03AC\u03C1\u03C9\u03C3\u03B7, \u03B7 \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03AE\u03C2 \u03B3\u03B9\u03B1 \u03AD\u03C9\u03C2 10 \u03BB\u03B5\u03C0\u03C4\u03AC. \u0397 \u03B1\u03C0\u03CC\u03C0\u03B5\u03B9\u03C1\u03B1 \u03B5\u03BA \u03BD\u03AD\u03BF\u03C5 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03B5\u03BD\u03C4\u03CC\u03C2 \u03B1\u03C5\u03C4\u03BF\u03CD \u03C4\u03BF\u03C5 \u03C7\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03B4\u03B9\u03B1\u03C3\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03B5\u03BD\u03B4\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03BA\u03B1\u03BB\u03AD\u03C3\u03B5\u03B9 \u03C0\u03C1\u03CC\u03C3\u03B8\u03B5\u03C4\u03B7 \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7.",
            "field.valid": "\u03A4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF",
            "field.invalid": "\u03A4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF",
            "error.va.gen.01": "\u0395\u03BB\u03BB\u03B9\u03C0\u03AD\u03C2 \u03C0\u03B5\u03B4\u03AF\u03BF",
            "error.va.gen.02": "\u03A4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF",
            "error.va.sf-cc-num.01": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "error.va.sf-cc-num.02": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C4\u03B7\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "error.va.sf-cc-num.03": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03B9\u03B6\u03CC\u03BC\u03B5\u03BD\u03B7 \u03B5\u03C0\u03C9\u03BD\u03C5\u03BC\u03AF\u03B1 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "error.va.sf-cc-num.04": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C0\u03BB\u03AE\u03C1\u03B7 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C4\u03B7\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "error.va.sf-cc-dat.01": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "error.va.sf-cc-dat.02": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "error.va.sf-cc-dat.03": "\u0397 \u03C0\u03B9\u03C3\u03C4\u03C9\u03C4\u03B9\u03BA\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1 \u03C0\u03C1\u03CC\u03BA\u03B5\u03B9\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03BB\u03AE\u03BE\u03B5\u03B9 \u03C3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B1",
            "error.va.sf-cc-dat.04": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "error.va.sf-cc-dat.05": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03AE\u03C1\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "error.va.sf-cc-mth.01": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BC\u03AE\u03BD\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "error.va.sf-cc-yr.01": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03AD\u03C4\u03BF\u03C2 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "error.va.sf-cc-yr.02": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BB\u03AE\u03C1\u03B5\u03C2 \u03AD\u03C4\u03BF\u03C2 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "error.va.sf-cc-cvc.01": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2",
            "error.va.sf-cc-cvc.02": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C0\u03BB\u03AE\u03C1\u03B7 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2",
            "error.va.sf-ach-num.01": "\u03A4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03CD \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03B5\u03BD\u03CC",
            "error.va.sf-ach-num.02": "\u039F \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD \u03B4\u03B5\u03BD \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9 \u03C4\u03BF\u03BD \u03C3\u03C9\u03C3\u03C4\u03CC \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03C9\u03BD",
            "error.va.sf-ach-loc.01": "\u03A4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03CD \u03B4\u03C1\u03BF\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2 \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03B5\u03BD\u03CC",
            "error.va.sf-ach-loc.02": "\u039F \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B4\u03C1\u03BF\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2 \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1\u03C2 \u03B4\u03B5\u03BD \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9 \u03C4\u03BF\u03BD \u03C3\u03C9\u03C3\u03C4\u03CC \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03C9\u03BD",
            "error.va.sf-kcp-pwd.01": "\u03A4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03B5\u03BD\u03CC",
            "error.va.sf-kcp-pwd.02": "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03B4\u03B5\u03BD \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9 \u03C4\u03BF\u03BD \u03C3\u03C9\u03C3\u03C4\u03CC \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03C9\u03BD",
            "error.giftcard.no-balance": "\u0397 \u03C3\u03C5\u03B3\u03BA\u03B5\u03BA\u03C1\u03B9\u03BC\u03AD\u03BD\u03B7 \u03B4\u03C9\u03C1\u03BF\u03BA\u03AC\u03C1\u03C4\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03BC\u03B7\u03B4\u03B5\u03BD\u03B9\u03BA\u03CC \u03C5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF",
            "error.giftcard.card-error": "\u03A3\u03C4\u03B1 \u03B1\u03C1\u03C7\u03B5\u03AF\u03B1 \u03BC\u03B1\u03C2 \u03B4\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03B4\u03C9\u03C1\u03BF\u03BA\u03AC\u03C1\u03C4\u03B1 \u03BC\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC",
            "error.giftcard.currency-error": "\u039F\u03B9 \u03B4\u03C9\u03C1\u03BF\u03BA\u03AC\u03C1\u03C4\u03B5\u03C2 \u03B9\u03C3\u03C7\u03CD\u03BF\u03C5\u03BD \u03BC\u03CC\u03BD\u03BF \u03B3\u03B9\u03B1 \u03C4\u03BF \u03BD\u03CC\u03BC\u03B9\u03C3\u03BC\u03B1 \u03C3\u03C4\u03BF \u03BF\u03C0\u03BF\u03AF\u03BF \u03B5\u03BA\u03B4\u03CC\u03B8\u03B7\u03BA\u03B1\u03BD",
            "amazonpay.signout": "\u0391\u03C0\u03BF\u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03B1\u03C0\u03CC \u03C4\u03BF Amazon",
            "amazonpay.changePaymentDetails": "\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03C9\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
            "partialPayment.warning": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03AC\u03BB\u03BB\u03BF \u03C4\u03C1\u03CC\u03C0\u03BF \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03B3\u03B9\u03B1 \u03BA\u03B1\u03C4\u03B1\u03B2\u03BF\u03BB\u03AE \u03C4\u03BF\u03C5 \u03B5\u03BD\u03B1\u03C0\u03BF\u03BC\u03B5\u03AF\u03BD\u03B1\u03BD\u03C4\u03BF\u03C2 \u03C0\u03BF\u03C3\u03BF\u03CD",
            "partialPayment.remainingBalance": "\u03A4\u03BF \u03C5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF \u03B8\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 %{amount}",
            "bankTransfer.beneficiary": "\u0394\u03B9\u03BA\u03B1\u03B9\u03BF\u03CD\u03C7\u03BF\u03C2",
            "bankTransfer.iban": "\u0399\u0392\u0391\u039D",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "\u0391\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC",
            "bankTransfer.introduction": "\u03A3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BD\u03AD\u03B1 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BC\u03AD\u03C3\u03C9 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE\u03C2 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2. \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C3\u03C4\u03B7\u03BD \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B7 \u03BF\u03B8\u03CC\u03BD\u03B7 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE.",
            "bankTransfer.instructions": "\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B1\u03B3\u03BF\u03C1\u03AC. \u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE.",
            "bacs.accountHolderName": "\u038C\u03BD\u03BF\u03BC\u03B1 \u03B4\u03B9\u03BA\u03B1\u03B9\u03BF\u03CD\u03C7\u03BF\u03C5 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "bacs.accountHolderName.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03B4\u03B9\u03BA\u03B1\u03B9\u03BF\u03CD\u03C7\u03BF\u03C5 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "bacs.accountNumber": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "bacs.accountNumber.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "bacs.bankLocationId": "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1\u03C2",
            "bacs.bankLocationId.invalid": "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1\u03C2",
            "bacs.consent.amount": "\u0391\u03C0\u03BF\u03B4\u03AD\u03C7\u03BF\u03BC\u03B1\u03B9 \u03CC\u03C4\u03B9 \u03C4\u03BF \u03C0\u03B9\u03BF \u03C0\u03AC\u03BD\u03C9 \u03C0\u03BF\u03C3\u03CC \u03B8\u03B1 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03B8\u03B5\u03AF \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03BC\u03BF\u03C5.",
            "bacs.consent.account": "\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03BD\u03C9 \u03CC\u03C4\u03B9 \u03BF \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C4\u03BF \u03CC\u03BD\u03BF\u03BC\u03AC \u03BC\u03BF\u03C5 \u03BA\u03B1\u03B9 \u03C0\u03C9\u03C2 \u03B5\u03AF\u03BC\u03B1\u03B9 \u03BF/\u03B7 \u03BC\u03BF\u03BD\u03B1\u03B4\u03B9\u03BA\u03CC\u03C2/\u03BC\u03BF\u03BD\u03B1\u03B4\u03B9\u03BA\u03AE \u03C5\u03C0\u03BF\u03B3\u03C1\u03AC\u03C6\u03C9\u03BD/\u03C5\u03C0\u03BF\u03B3\u03C1\u03AC\u03C6\u03BF\u03C5\u03C3\u03B1 \u03C0\u03BF\u03C5 \u03B1\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u03B3\u03B9\u03B1 \u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03CC\u03C4\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u0386\u03BC\u03B5\u03C3\u03B7\u03C2 \u03A7\u03C1\u03AD\u03C9\u03C3\u03B7\u03C2 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC.",
            edit: "\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1",
            "bacs.confirm": "\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03BA\u03B1\u03B9 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE",
            "bacs.result.introduction": "\u039A\u03B1\u03C4\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u0395\u03BD\u03C4\u03BF\u03BB\u03AE \u0386\u03BC\u03B5\u03C3\u03B7\u03C2 \u03A7\u03C1\u03AD\u03C9\u03C3\u03B7\u03C2 (DDI/\u0395\u03BD\u03C4\u03BF\u03BB\u03AE)",
            "download.pdf": "\u039B\u03AE\u03C8\u03B7 PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "creditCard.encryptedCardNumber.aria.label": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "creditCard.encryptedExpiryDate.aria.label": "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03BC\u03AE\u03BD\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "creditCard.encryptedExpiryMonth.aria.label": "\u039C\u03AE\u03BD\u03B1\u03C2 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03AD\u03C4\u03BF\u03C2 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "creditCard.encryptedExpiryYear.aria.label": "\u0388\u03C4\u03BF\u03C2 \u03BB\u03AE\u03BE\u03B7\u03C2",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2",
            "creditCard.encryptedSecurityCode.aria.label": "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03B1\u03C2",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2",
            "creditCard.encryptedPassword.aria.label": "\u03A4\u03B1 \u03C0\u03C1\u03CE\u03C4\u03B1 2 \u03C8\u03B7\u03C6\u03AF\u03B1 \u03C4\u03BF\u03C5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03C4\u03B7\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "giftcard.encryptedCardNumber.aria.label": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 PIN",
            "giftcard.encryptedSecurityCode.aria.label": "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 PIN",
            giftcardTransactionLimit: "\u03A4\u03BF \u03BC\u03AD\u03B3\u03B9\u03C3\u03C4\u03BF \u03B5\u03C0\u03B9\u03C4\u03C1\u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF \u03C0\u03BF\u03C3\u03CC \u03B1\u03BD\u03AC \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03B4\u03C9\u03C1\u03BF\u03BA\u03AC\u03C1\u03C4\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "ach.encryptedBankAccountNumber.aria.label": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe \u03B3\u03B9\u03B1 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C5\u03C0\u03BF\u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1\u03C2",
            "ach.encryptedBankLocationId.aria.label": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B4\u03C1\u03BF\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2 ABA",
            "twint.saved": "\u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03CD\u03C4\u03B7\u03BA\u03B5",
            orPayWith: "\u03AE \u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03BC\u03B5",
            invalidFormatExpects: "\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03BC\u03BF\u03C1\u03C6\u03AE. \u0391\u03BD\u03B1\u03BC\u03B5\u03BD\u03CC\u03BC\u03B5\u03BD\u03B7 \u03BC\u03BF\u03C1\u03C6\u03AE: %{format}",
            "upi.qrCodeWaitingMessage": "\u03A3\u03B1\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC QR \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03C4\u03B9\u03BC\u03CE\u03BC\u03B5\u03BD\u03B7 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE UPI \u03B3\u03B9\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
            "upi.vpaWaitingMessage": "\u0391\u03BD\u03BF\u03AF\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE UPI \u03B3\u03B9\u03B1 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
            "upi.modeSelection": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03C1\u03CD\u03B8\u03BC\u03B9\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03BD \u03C4\u03C1\u03CC\u03C0\u03BF \u03C7\u03C1\u03AE\u03C3\u03B7\u03C2 \u03C4\u03BF\u03C5 UPI.",
            "onlineBanking.termsAndConditions": "\u0391\u03BD \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5, \u03C3\u03C5\u03BD\u03B5\u03C0\u03AC\u03B3\u03B5\u03C4\u03B1\u03B9 \u03CC\u03C4\u03B9 \u03B1\u03C0\u03BF\u03B4\u03AD\u03C7\u03B5\u03C3\u03C4\u03B5 \u03C4\u03BF\u03C5\u03C2 %#\u038C\u03C1\u03BF\u03C5\u03C2 \u03BA\u03B1\u03B9 \u03C0\u03C1\u03BF\u03CB\u03C0\u03BF\u03B8\u03AD\u03C3\u03B5\u03B9\u03C2%#",
            "onlineBankingPL.termsAndConditions": "\u03A3\u03C5\u03BD\u03B5\u03C7\u03AF\u03B6\u03BF\u03BD\u03C4\u03B1\u03C2, \u03C3\u03C5\u03BC\u03C6\u03C9\u03BD\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF\u03C5\u03C2 %#\u03BA\u03B1\u03BD\u03BF\u03BD\u03B9\u03C3\u03BC\u03BF\u03CD\u03C2%# \u03BA\u03B1\u03B9 \u03C4\u03B7\u03BD %#\u03C5\u03C0\u03BF\u03C7\u03C1\u03AD\u03C9\u03C3\u03B7 \u03B5\u03BD\u03B7\u03BC\u03AD\u03C1\u03C9\u03C3\u03B7\u03C2%# \u03C4\u03B7\u03C2 Przelewy24",
            "ctp.loading.poweredByCtp": "\u039C\u03B5 \u03C4\u03B7\u03BD \u03C5\u03C0\u03BF\u03C3\u03C4\u03AE\u03C1\u03B9\u03BE\u03B7 \u03C4\u03BF\u03C5 Click to Pay",
            "ctp.loading.intro": "\u0388\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03C0\u03B9\u03C3\u03C4\u03C9\u03B8\u03B5\u03AF \u03B1\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03C5\u03BC\u03AD\u03BD\u03B5\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B5\u03C2 \u03BC\u03B5 Click to Pay...",
            "ctp.login.title": "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1 \u03C3\u03C4\u03BF Click to Pay",
            "ctp.login.subtitle": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03C0\u03BF\u03C5 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03B7 \u03BC\u03B5 \u03C4\u03BF Click to Pay \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5.",
            "ctp.login.inputLabel": "Email",
            "ctp.logout.notYou": "\u0394\u03B5\u03BD \u03B5\u03AF\u03C3\u03C4\u03B5 \u03B5\u03C3\u03B5\u03AF\u03C2 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03AC\u03C4\u03BF\u03BC\u03BF;",
            "ctp.logout.notYourCards": "\u0391\u03C5\u03C4\u03AD\u03C2 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BF\u03B9 \u03BA\u03AC\u03C1\u03C4\u03B5\u03C2 \u03C3\u03B1\u03C2;",
            "ctp.logout.notYourCard": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B7 \u03BA\u03AC\u03C1\u03C4\u03B1 \u03C3\u03B1\u03C2;",
            "ctp.logout.notYourProfile": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB \u03C3\u03B1\u03C2;",
            "ctp.otp.fieldLabel": "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03BC\u03B9\u03B1\u03C2 \u03C7\u03C1\u03AE\u03C3\u03B7\u03C2",
            "ctp.otp.resendCode": "\u0395\u03BA \u03BD\u03AD\u03BF\u03C5 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD",
            "ctp.otp.codeResent": "\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C3\u03C4\u03AC\u03BB\u03B8\u03B7\u03BA\u03B5 \u03B5\u03BA \u03BD\u03AD\u03BF\u03C5",
            "ctp.otp.title": "\u03A0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B9\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B5\u03C2 Click to Pay \u03C3\u03B1\u03C2",
            "ctp.otp.subtitle": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC %@ \u03C0\u03BF\u03C5 \u03C3\u03C4\u03AC\u03BB\u03B8\u03B7\u03BA\u03B5 \u03C3\u03C4\u03BF %@ \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03CD\u03C3\u03B5\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03B5\u03AF\u03C3\u03C4\u03B5 \u03B5\u03C3\u03B5\u03AF\u03C2.",
            "ctp.otp.saveCookiesCheckbox.label": "\u03A0\u03B1\u03C1\u03AC\u03B2\u03BB\u03B5\u03C8\u03B7 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C4\u03B7\u03BD \u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03C6\u03BF\u03C1\u03AC",
            "ctp.otp.saveCookiesCheckbox.information": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03BC\u03BD\u03B7\u03BC\u03BF\u03BD\u03B5\u03CD\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03BA\u03B1\u03B9 \u03C3\u03C4\u03BF \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AE\u03B3\u03B7\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03C3\u03C4\u03B1 \u03C3\u03C5\u03BC\u03BC\u03B5\u03C4\u03AD\u03C7\u03BF\u03BD\u03C4\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AE\u03BC\u03B1\u03C4\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B1\u03C7\u03CD\u03C4\u03B5\u03C1\u03B7 \u03BF\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2. \u0394\u03B5\u03BD \u03C3\u03C5\u03BD\u03B9\u03C3\u03C4\u03AC\u03C4\u03B1\u03B9 \u03B3\u03B9\u03B1 \u03BA\u03BF\u03B9\u03BD\u03CC\u03C7\u03C1\u03B7\u03C3\u03C4\u03B5\u03C2 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AD\u03C2.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03BC\u03BD\u03B7\u03BC\u03BF\u03BD\u03B5\u03CD\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03BA\u03B1\u03B9 \u03C3\u03C4\u03BF \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AE\u03B3\u03B7\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2",
            "ctp.emptyProfile.message": "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03BA\u03B1\u03C4\u03B1\u03C7\u03C9\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B5\u03C2 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB Click to Pay",
            "ctp.separatorText": "\u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF",
            "ctp.cards.title": "\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BC\u03B5 \u03C4\u03BF Click to Pay",
            "ctp.cards.subtitle": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03BA\u03AC\u03C1\u03C4\u03B1 \u03C0\u03C1\u03BF\u03C2 \u03C7\u03C1\u03AE\u03C3\u03B7.",
            "ctp.cards.expiredCard": "\u0388\u03BB\u03B7\u03BE\u03B5",
            "ctp.manualCardEntry": "\u03A7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03BA\u03B1\u03C4\u03B1\u03C7\u03CE\u03C1\u03B9\u03C3\u03B7 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "ctp.aria.infoModalButton": "\u03A4\u03B9 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03BF Click to Pay",
            "ctp.infoPopup.title": "\u03A4\u03BF Click to Pay \u03C0\u03C1\u03BF\u03C3\u03C6\u03AD\u03C1\u03B5\u03B9 \u03C4\u03B7\u03BD \u03B5\u03C5\u03BA\u03BF\u03BB\u03AF\u03B1 \u03B1\u03BD\u03AD\u03C0\u03B1\u03C6\u03C9\u03BD \u03B4\u03B9\u03B1\u03B4\u03B9\u03BA\u03C4\u03C5\u03B1\u03BA\u03CE\u03BD",
            "ctp.infoPopup.subtitle": "\u0388\u03BD\u03B1\u03C2 \u03B3\u03C1\u03AE\u03B3\u03BF\u03C1\u03BF\u03C2, \u03B1\u03C3\u03C6\u03B1\u03BB\u03AE\u03C2 \u03C4\u03C1\u03CC\u03C0\u03BF\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03C0\u03BF\u03C5 \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B5\u03C2 Mastercard, Visa \u03BA\u03B1\u03B9 \u03AC\u03BB\u03BB\u03B5\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03CE\u03BD.",
            "ctp.infoPopup.benefit1": "\u03A4\u03BF Click to Pay \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03B5\u03AF \u03BA\u03C1\u03C5\u03C0\u03C4\u03BF\u03B3\u03C1\u03AC\u03C6\u03B7\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03C4\u03B7\u03C1\u03B5\u03AF \u03C4\u03B9\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03C3\u03B1\u03C2 \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03C2",
            "ctp.infoPopup.benefit2": "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C3\u03B5 \u03B5\u03BC\u03C0\u03CC\u03C1\u03BF\u03C5\u03C2 \u03B1\u03BD\u03AC \u03C4\u03BF\u03BD \u03BA\u03CC\u03C3\u03BC\u03BF",
            "ctp.infoPopup.benefit3": "\u0395\u03CD\u03BA\u03BF\u03BB\u03B7 \u03B4\u03B9\u03B1\u03BC\u03CC\u03C1\u03C6\u03C9\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03AC\u03BD\u03B5\u03C4\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2 \u03B1\u03BD\u03AC \u03C0\u03AC\u03C3\u03B1 \u03C3\u03C4\u03B9\u03B3\u03BC\u03AE",
            "ctp.errors.AUTH_INVALID": "\u039F \u03AD\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03B4\u03B5\u03BD \u03AE\u03C4\u03B1\u03BD \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF\u03C2",
            "ctp.errors.NOT_FOUND": "\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2, \u03B5\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03AE \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "\u0397 \u03BC\u03BF\u03C1\u03C6\u03AE \u03B4\u03B5\u03BD \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9",
            "ctp.errors.FRAUD": "\u039F \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7 \u03BA\u03BB\u03B5\u03B9\u03B4\u03CE\u03B8\u03B7\u03BA\u03B5 \u03AE \u03B1\u03C0\u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03AE\u03B8\u03B7\u03BA\u03B5",
            "ctp.errors.CONSUMER_ID_MISSING": "\u0397 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03BA\u03B1\u03C4\u03B1\u03BD\u03B1\u03BB\u03C9\u03C4\u03AE \u03BB\u03B5\u03AF\u03C0\u03B5\u03B9 \u03C3\u03C4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1",
            "ctp.errors.ACCT_INACCESSIBLE": "\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF\u03C2 \u03C4\u03CE\u03C1\u03B1, \u03C0.\u03C7. \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03BB\u03B5\u03B9\u03B4\u03C9\u03BC\u03AD\u03BD\u03BF\u03C2",
            "ctp.errors.CODE_INVALID": "\u039B\u03B1\u03BD\u03B8\u03B1\u03C3\u03BC\u03AD\u03BD\u03BF\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2",
            "ctp.errors.CODE_EXPIRED": "\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03BB\u03AE\u03BE\u03B5\u03B9",
            "ctp.errors.RETRIES_EXCEEDED": "\u03A3\u03B7\u03BC\u03B5\u03B9\u03CE\u03B8\u03B7\u03BA\u03B5 \u03C5\u03C0\u03AD\u03C1\u03B2\u03B1\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03CD \u03BD\u03AD\u03C9\u03BD \u03B1\u03C0\u03BF\u03C0\u03B5\u03B9\u03C1\u03CE\u03BD \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1\u03C2 OTP",
            "ctp.errors.OTP_SEND_FAILED": "\u0394\u03B5\u03BD \u03AE\u03C4\u03B1\u03BD \u03B4\u03C5\u03BD\u03B1\u03C4\u03AE \u03B7 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03C4\u03BF\u03C5 OTP \u03C3\u03C4\u03BF\u03BD \u03C0\u03B1\u03C1\u03B1\u03BB\u03AE\u03C0\u03C4\u03B7",
            "ctp.errors.REQUEST_TIMEOUT": "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1, \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "ctp.errors.UNKNOWN_ERROR": "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1, \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "ctp.errors.SERVICE_ERROR": "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1, \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "ctp.errors.SERVER_ERROR": "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1, \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "ctp.errors.INVALID_PARAMETER": "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1, \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "ctp.errors.AUTH_ERROR": "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1, \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2",
            "paymentMethodsList.aria.label": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03C4\u03C1\u03CC\u03C0\u03BF \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
            "companyDetails.name.invalid": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C4\u03B7\u03C2 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2",
            "companyDetails.registrationNumber.invalid": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5",
            "consent.checkbox.invalid": "\u03A0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C3\u03C5\u03BC\u03C6\u03C9\u03BD\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03CC\u03C1\u03BF\u03C5\u03C2 \u03BA\u03B1\u03B9 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03CB\u03C0\u03BF\u03B8\u03AD\u03C3\u03B5\u03B9\u03C2",
            "form.instruction": "\u038C\u03BB\u03B1 \u03C4\u03B1 \u03C0\u03B5\u03B4\u03AF\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03AC, \u03B5\u03BA\u03C4\u03CC\u03C2 \u03B5\u03AC\u03BD \u03B5\u03C0\u03B9\u03C3\u03B7\u03BC\u03B1\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03AC.",
            "trustly.descriptor": "\u0386\u03BC\u03B5\u03C3\u03B7 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE",
            "trustly.description1": "\u03A0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03B1\u03C0\u03B5\u03C5\u03B8\u03B5\u03AF\u03B1\u03C2 \u03B1\u03C0\u03CC \u03BF\u03C0\u03BF\u03B9\u03BF\u03BD\u03B4\u03AE\u03C0\u03BF\u03C4\u03B5 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2, \u03BC\u03B5 \u03B1\u03C3\u03C6\u03AC\u03BB\u03B5\u03B9\u03B1 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03B5\u03C0\u03B9\u03C0\u03AD\u03B4\u03BF\u03C5",
            "trustly.description2": "\u03A7\u03C9\u03C1\u03AF\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B5\u03C2, \u03C7\u03C9\u03C1\u03AF\u03C2 \u03BB\u03AE\u03C8\u03B7 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE\u03C2, \u03C7\u03C9\u03C1\u03AF\u03C2 \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE",
            "ancv.input.label": "\u0397 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03AC \u03C3\u03B1\u03C2 ANCV",
            "ancv.confirmPayment": "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE ANCV \u03B3\u03B9\u03B1 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2.",
            "ancv.form.instruction": "\u0397 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE Cheque-Vacances \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C0\u03B1\u03C1\u03B1\u03AF\u03C4\u03B7\u03C4\u03B7 \u03B3\u03B9\u03B1 \u03B5\u03C0\u03B9\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03B1\u03C5\u03C4\u03AE\u03C2.",
            "ancv.beneficiaryId.invalid": "\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03AE \u03B1\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC ANCV",
            "payme.openPayMeApp": "\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03B1\u03C2 \u03C3\u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE PayMe \u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03BF\u03C4\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03BA\u03B1\u03B9 \u03C0\u03B5\u03C1\u03B9\u03BC\u03AD\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7.",
            "payme.redirectButtonLabel": "\u0391\u03BD\u03BF\u03AF\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE PayMe",
            "payme.scanQrCode": "\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03B1\u03C2 \u03BC\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC QR",
            "payme.timeToPay": "\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 QR \u03B9\u03C3\u03C7\u03CD\u03B5\u03B9 \u03B3\u03B9\u03B1 %@",
            "payme.instructions.steps": "\u0391\u03BD\u03BF\u03AF\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE PayMe.%@\u03A3\u03BA\u03B1\u03BD\u03AC\u03C1\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC QR \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03BF\u03C4\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE.%@\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03BA\u03B1\u03B9 \u03C0\u03B5\u03C1\u03B9\u03BC\u03AD\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7.",
            "payme.instructions.footnote": "\u039C\u03B7\u03BD \u03BA\u03BB\u03B5\u03AF\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03C0\u03C1\u03BF\u03C4\u03BF\u03CD \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03C9\u03B8\u03B5\u03AF \u03B7 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE."
        }
    }), Z1 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Pagar",
            "payButton.redirecting": "Redirigiendo...",
            "payButton.with": "Pague %{value} con %{maskedData}",
            "payButton.saveDetails": "Guardar los detalles",
            close: "Cerrar",
            storeDetails: "Recordar para mi pr\xf3ximo pago",
            readMore: "Leer m\xe1s",
            "creditCard.holderName": "Nombre en la tarjeta",
            "creditCard.holderName.placeholder": "Juan P\xe9rez",
            "creditCard.holderName.invalid": "Introduzca el nombre como se muestra en la tarjeta",
            "creditCard.numberField.title": "N\xfamero de tarjeta",
            "creditCard.expiryDateField.title": "Fecha de expiraci\xf3n",
            "creditCard.expiryDateField.placeholder": "MM/AA",
            "creditCard.expiryDateField.month": "Mes",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "AA",
            "creditCard.expiryDateField.year": "A\xf1o",
            "creditCard.cvcField.title": "C\xf3digo de seguridad",
            "creditCard.storeDetailsButton": "Recordar para la pr\xf3xima vez",
            "creditCard.cvcField.placeholder.4digits": "4 d\xedgitos",
            "creditCard.cvcField.placeholder.3digits": "3 d\xedgitos",
            "creditCard.taxNumber.placeholder": "AAMMDD / 0123456789",
            installments: "N\xfamero de plazos",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times}\xa0meses",
            "installments.oneTime": "Pago \xfanico",
            "installments.installments": "Pago fraccionado",
            "installments.revolving": "Pago rotativo",
            "sepaDirectDebit.ibanField.invalid": "N\xfamero de cuenta no v\xe1lido",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "Nombre del titular de cuenta",
            "sepa.ibanNumber": "N\xfamero de cuenta (IBAN)",
            "error.title": "Error",
            "error.subtitle.redirect": "Redirecci\xf3n fallida",
            "error.subtitle.payment": "Pago fallido",
            "error.subtitle.refused": "Pago rechazado",
            "error.message.unknown": "Se ha producido un error desconocido",
            "errorPanel.title": "Errores existentes",
            "idealIssuer.selectField.title": "Banco",
            "idealIssuer.selectField.placeholder": "Seleccione su banco",
            "creditCard.success": "Pago realizado correctamente",
            loading: "Cargando...",
            continue: "Continuar",
            continueTo: "Continuar a",
            "wechatpay.timetopay": "Tiene %@ para pagar",
            "sr.wechatpay.timetopay": "Tiene %#minutos%# %#segundos%# para pagar",
            "wechatpay.scanqrcode": "Escanear c\xf3digo QR",
            personalDetails: "Datos personales",
            companyDetails: "Datos de la empresa",
            "companyDetails.name": "Nombre de la empresa",
            "companyDetails.registrationNumber": "N\xfamero de registro",
            socialSecurityNumber: "N\xfamero de seguridad social",
            firstName: "Nombre",
            "firstName.invalid": "Introduzca su nombre",
            infix: "Prefijo",
            lastName: "Apellidos",
            "lastName.invalid": "Introduzca su apellido",
            mobileNumber: "Tel\xe9fono m\xf3vil",
            "mobileNumber.invalid": "N\xfamero de m\xf3vil no v\xe1lido",
            city: "Ciudad",
            postalCode: "C\xf3digo postal",
            "postalCode.optional": "C\xf3digo postal (opcional)",
            countryCode: "Prefijo internacional",
            telephoneNumber: "N\xfamero de tel\xe9fono",
            dateOfBirth: "Fecha de nacimiento",
            shopperEmail: "Direcci\xf3n de correo electr\xf3nico",
            gender: "G\xe9nero",
            "gender.notselected": "Seleccione su g\xe9nero",
            male: "Masculino",
            female: "Femenino",
            billingAddress: "Direcci\xf3n de facturaci\xf3n",
            street: "Calle",
            stateOrProvince: "Provincia o estado",
            country: "Pa\xeds",
            houseNumberOrName: "N\xfamero de vivienda",
            separateDeliveryAddress: "Especificar otra direcci\xf3n de env\xedo",
            deliveryAddress: "Direcci\xf3n de env\xedo",
            "deliveryAddress.firstName": "Nombre del destinatario",
            "deliveryAddress.lastName": "Apellidos del destinatario",
            zipCode: "C\xf3digo postal",
            apartmentSuite: "Apartamento/suite",
            provinceOrTerritory: "Provincia o territorio",
            cityTown: "Ciudad/poblaci\xf3n",
            address: "Direcci\xf3n",
            "address.placeholder": "Encuentre su direcci\xf3n",
            "address.errors.incomplete": "Introduzca una direcci\xf3n para continuar",
            "address.enterManually": "Introduzca la direcci\xf3n manualmente",
            state: "Estado",
            "field.title.optional": "(opcional)",
            "creditCard.cvcField.title.optional": "C\xf3digo de seguridad (opcional)",
            "issuerList.wallet.placeholder": "Seleccione su monedero electr\xf3nico",
            privacyPolicy: "Pol\xedtica de privacidad",
            "afterPay.agreement": "S\xed, acepto las %@ de Riverty",
            paymentConditions: "condiciones de pago",
            openApp: "Abrir la aplicaci\xf3n",
            "voucher.readInstructions": "Leer instrucciones",
            "voucher.introduction": "Gracias por su compra. Use el siguiente cup\xf3n para completar su pago.",
            "voucher.expirationDate": "Fecha de caducidad",
            "voucher.alternativeReference": "Referencia alternativa",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Seleccione su proveedor",
            "dragonpay.voucher.bank.selectField.placeholder": "Seleccione su banco",
            "voucher.paymentReferenceLabel": "Referencia de pago",
            "voucher.surcharge": "Incluye recargo de %@",
            "voucher.introduction.doku": "Gracias por su compra. Use la informaci\xf3n siguiente para completar su pago.",
            "voucher.shopperName": "Nombre del comprador",
            "voucher.merchantName": "Vendedor",
            "voucher.introduction.econtext": "Gracias por su compra. Use la informaci\xf3n siguiente para completar su pago.",
            "voucher.telephoneNumber": "N\xfamero de tel\xe9fono",
            "voucher.shopperReference": "Referencia cliente",
            "voucher.collectionInstitutionNumber": "N\xfamero de instituci\xf3n de cobro",
            "voucher.econtext.telephoneNumber.invalid": "El n\xfamero de tel\xe9fono debe tener 10 u 11 d\xedgitos",
            "boletobancario.btnLabel": "Generar Boleto",
            "boleto.sendCopyToEmail": "Enviar copia a mi correo electr\xf3nico",
            "button.copy": "Copiar",
            "button.download": "Descargar",
            "boleto.socialSecurityNumber.invalid": "Campo no v\xe1lido",
            "creditCard.storedCard.description.ariaLabel": "La tarjeta almacenada termina en %@",
            "voucher.entity": "Entidad",
            donateButton: "Donar",
            notNowButton: "Ahora no",
            thanksForYourSupport: "\xa1Gracias por su contribuci\xf3n!",
            "resultMessages.preauthorized": "Se han guardado los detalles",
            preauthorizeWith: "Preautorizar con",
            confirmPreauthorization: "Confirmar preautorizaci\xf3n",
            confirmPurchase: "Confirmar compra",
            applyGiftcard: "Canjear",
            giftcardBalance: "Saldo de la tarjeta regalo",
            deductedBalance: "Saldo deducido",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "Primeros 2 d\xedgitos de la contrase\xf1a de la tarjeta",
            "creditCard.encryptedPassword.invalid": "Contrase\xf1a incorrecta",
            "creditCard.taxNumber": "Fecha de nacimiento del titular o n\xfamero de registro comercial",
            "creditCard.taxNumber.label": "Fecha de nacimiento del titular de la tarjeta (AAMMDD) o n\xfamero de registro comercial (10 d\xedgitos)",
            "creditCard.taxNumber.labelAlt": "N\xfamero de registro comercial (10 d\xedgitos)",
            "creditCard.taxNumber.invalid": "Fecha de nacimiento del titular o n\xfamero de registro comercial incorrectos",
            "storedPaymentMethod.disable.button": "Eliminar",
            "storedPaymentMethod.disable.confirmation": "Eliminar m\xe9todo de pago almacenado",
            "storedPaymentMethod.disable.confirmButton": "S\xed, eliminar",
            "storedPaymentMethod.disable.cancelButton": "Cancelar",
            "ach.bankAccount": "Cuenta bancaria",
            "ach.accountHolderNameField.title": "Nombre del titular de la cuenta",
            "ach.accountHolderNameField.placeholder": "Juan P\xe9rez",
            "ach.accountHolderNameField.invalid": "El nombre del titular de la cuenta no es v\xe1lido",
            "ach.accountNumberField.title": "N\xfamero de cuenta",
            "ach.accountNumberField.invalid": "N\xfamero de cuenta no v\xe1lido",
            "ach.accountLocationField.title": "N\xfamero de ruta ABA",
            "ach.accountLocationField.invalid": "El n\xfamero de ruta ABA no es v\xe1lido",
            "ach.savedBankAccount": "Se ha guardado la cuenta bancaria",
            "select.state": "Seleccione el estado",
            "select.stateOrProvince": "Seleccione el estado o provincia",
            "select.provinceOrTerritory": "Seleccione la provincia o territorio",
            "select.country": "Seleccione el pa\xeds",
            "select.noOptionsFound": "No se encontraron opciones",
            "select.filter.placeholder": "Buscar...",
            "telephoneNumber.invalid": "El n\xfamero de tel\xe9fono no es v\xe1lido",
            qrCodeOrApp: "o",
            "paypal.processingPayment": "Procesando pago...",
            generateQRCode: "Generar c\xf3digo QR",
            "await.waitForConfirmation": "Esperando confirmaci\xf3n",
            "mbway.confirmPayment": "Confirme su pago en la aplicaci\xf3n MB WAY",
            "shopperEmail.invalid": "La direcci\xf3n de correo electr\xf3nico no es v\xe1lida",
            "dateOfBirth.format": "DD/MM/AAAA",
            "dateOfBirth.invalid": "Introduzca una fecha de nacimiento v\xe1lida que indique que tiene al menos 18 a\xf1os",
            "blik.confirmPayment": "Abra la aplicaci\xf3n de su banco para confirmar el pago.",
            "blik.invalid": "Introduzca 6 d\xedgitos",
            "blik.code": "C\xf3digo de 6 d\xedgitos",
            "blik.help": "Consiga el c\xf3digo en la aplicaci\xf3n de su banco.",
            "swish.pendingMessage": "Tras escanearlo, su estado puede seguir en pendiente hasta 10\xa0minutos. Podr\xedan realizarse varios cargos si se intenta pagar de nuevo durante este periodo.",
            "field.valid": "Campo v\xe1lido",
            "field.invalid": "Campo no v\xe1lido",
            "error.va.gen.01": "Campo incompleto",
            "error.va.gen.02": "Campo no v\xe1lido",
            "error.va.sf-cc-num.01": "Introduzca un n\xfamero de tarjeta v\xe1lido",
            "error.va.sf-cc-num.02": "Introduzca el n\xfamero de tarjeta",
            "error.va.sf-cc-num.03": "Introduzca una marca de tarjeta admitida",
            "error.va.sf-cc-num.04": "Introduzca el n\xfamero de tarjeta completo",
            "error.va.sf-cc-dat.01": "Introduzca una fecha de caducidad v\xe1lida",
            "error.va.sf-cc-dat.02": "Introduzca una fecha de caducidad v\xe1lida",
            "error.va.sf-cc-dat.03": "La tarjeta de cr\xe9dito est\xe1 a punto de caducar",
            "error.va.sf-cc-dat.04": "Introduzca la fecha de caducidad",
            "error.va.sf-cc-dat.05": "Introduzca la fecha de caducidad completa",
            "error.va.sf-cc-mth.01": "Introduzca el mes de caducidad",
            "error.va.sf-cc-yr.01": "Introduzca el a\xf1o de caducidad",
            "error.va.sf-cc-yr.02": "Introduzca el a\xf1o de caducidad completo",
            "error.va.sf-cc-cvc.01": "Introduzca el c\xf3digo de seguridad",
            "error.va.sf-cc-cvc.02": "Introduzca el c\xf3digo de seguridad completo",
            "error.va.sf-ach-num.01": "El campo del n\xfamero de cuenta bancaria est\xe1 vac\xedo",
            "error.va.sf-ach-num.02": "El n\xfamero de cuenta bancaria no tiene la longitud correcta",
            "error.va.sf-ach-loc.01": "El campo del n\xfamero de ruta bancaria est\xe1 vac\xedo",
            "error.va.sf-ach-loc.02": "El n\xfamero de ruta bancaria no tiene la longitud correcta",
            "error.va.sf-kcp-pwd.01": "El campo de la contrase\xf1a est\xe1 vac\xedo",
            "error.va.sf-kcp-pwd.02": "La contrase\xf1a no tiene la longitud correcta",
            "error.giftcard.no-balance": "Esta tarjeta regalo no tiene saldo",
            "error.giftcard.card-error": "No tenemos ninguna tarjeta regalo con este n\xfamero en nuestros registros.",
            "error.giftcard.currency-error": "Las tarjetas regalo solo son v\xe1lidas en la moneda en que fueron emitidas",
            "amazonpay.signout": "Salir de Amazon",
            "amazonpay.changePaymentDetails": "Cambiar detalles de pago",
            "partialPayment.warning": "Seleccione otro m\xe9todo de pago para pagar la cantidad restante",
            "partialPayment.remainingBalance": "El saldo restante ser\xe1 %{amount}",
            "bankTransfer.beneficiary": "Beneficiario",
            "bankTransfer.reference": "referencia",
            "bankTransfer.introduction": "Contin\xfae para crear un nuevo pago mediante transferencia bancaria. Puede utilizar los detalles en la siguiente pantalla para finalizar este pago.",
            "bankTransfer.instructions": "Gracias por su compra. Use la siguiente informaci\xf3n para completar su pago.",
            "bacs.accountHolderName": "Nombre del titular de la cuenta bancaria",
            "bacs.accountHolderName.invalid": "El nombre del titular de la cuenta bancaria no es v\xe1lido",
            "bacs.accountNumber": "N\xfamero de cuenta bancaria",
            "bacs.accountNumber.invalid": "El n\xfamero de cuenta bancaria no es v\xe1lido",
            "bacs.bankLocationId": "C\xf3digo de sucursal",
            "bacs.bankLocationId.invalid": "El c\xf3digo de sucursal no es v\xe1lido",
            "bacs.consent.amount": "Estoy de acuerdo con que la cantidad anterior se deduzca de mi cuenta bancaria.",
            "bacs.consent.account": "Confirmo que la cuenta est\xe1 a mi nombre y soy el \xfanico firmante necesario para autorizar d\xe9bitos directos en esta cuenta.",
            edit: "Editar",
            "bacs.confirm": "Confirmar y pagar",
            "bacs.result.introduction": "Descargue su instrucci\xf3n de d\xe9bito directo (IDD/mandato)",
            "download.pdf": "Descargar PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Utilice Iframe para el n\xfamero de tarjeta",
            "creditCard.encryptedCardNumber.aria.label": "N\xfamero de tarjeta",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Utilice iframe para la fecha de caducidad",
            "creditCard.encryptedExpiryDate.aria.label": "Fecha de expiraci\xf3n",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Utilice iframe para el mes de caducidad",
            "creditCard.encryptedExpiryMonth.aria.label": "Mes de caducidad",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Utilice iframe para el a\xf1o de caducidad",
            "creditCard.encryptedExpiryYear.aria.label": "A\xf1o de caducidad",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Utilice iframe para el c\xf3digo de seguridad",
            "creditCard.encryptedSecurityCode.aria.label": "C\xf3digo de seguridad",
            "creditCard.encryptedPassword.aria.iframeTitle": "Utilice iframe para la contrase\xf1a",
            "creditCard.encryptedPassword.aria.label": "Primeros 2 d\xedgitos de la contrase\xf1a de la tarjeta",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Utilice iframe para el n\xfamero de tarjeta",
            "giftcard.encryptedCardNumber.aria.label": "N\xfamero de tarjeta",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Utilice iframe para el PIN",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Se permite un m\xe1ximo de %{amount} por transacci\xf3n en esta tarjeta regalo",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Utilice iframe para el n\xfamero de cuenta bancaria",
            "ach.encryptedBankAccountNumber.aria.label": "N\xfamero de cuenta",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Utilice iframe para el n\xfamero de ruta bancaria",
            "ach.encryptedBankLocationId.aria.label": "N\xfamero de ruta ABA",
            "twint.saved": "guardado",
            orPayWith: "o pague con",
            invalidFormatExpects: "Formato no v\xe1lido. Formato correcto: %{format}",
            "upi.qrCodeWaitingMessage": "Escanee el c\xf3digo QR con la aplicaci\xf3n UPI que prefiera para completar el pago",
            "upi.vpaWaitingMessage": "Abra la aplicaci\xf3n UPI para confirmar el pago",
            "upi.modeSelection": "Seleccione c\xf3mo le gustar\xeda usar UPI.",
            "onlineBanking.termsAndConditions": "Al continuar, usted acepta los %#T\xe9rminos y condiciones%#",
            "onlineBankingPL.termsAndConditions": "Al continuar, acepta las %#regulaciones%# y la %#obligaci\xf3n de informaci\xf3n%# de Przelewy24",
            "ctp.loading.poweredByCtp": "Con tecnolog\xeda de Click to Pay",
            "ctp.loading.intro": "Estamos comprobando si tiene alguna tarjeta guardada con Click to Pay...",
            "ctp.login.title": "Contin\xfae con Click to Pay",
            "ctp.login.subtitle": "Introduzca la direcci\xf3n de correo electr\xf3nico que tiene conectada a Click to Pay para continuar.",
            "ctp.login.inputLabel": "Correo electr\xf3nico",
            "ctp.logout.notYou": "\xbfNo es usted?",
            "ctp.logout.notYourCards": "\xbfNo son sus tarjetas?",
            "ctp.logout.notYourCard": "\xbfNo es su tarjeta?",
            "ctp.logout.notYourProfile": "\xbfNo es su perfil?",
            "ctp.otp.fieldLabel": "C\xf3digo \xfanico",
            "ctp.otp.resendCode": "Reenviar c\xf3digo",
            "ctp.otp.codeResent": "C\xf3digo reenviado",
            "ctp.otp.title": "Acceda a sus tarjetas Click to Pay",
            "ctp.otp.subtitle": "Introduzca el c\xf3digo %@ que le hemos enviado a %@ para verificar que es usted.",
            "ctp.otp.saveCookiesCheckbox.label": "Omitir verificaci\xf3n la pr\xf3xima vez",
            "ctp.otp.saveCookiesCheckbox.information": "Seleccione esta opci\xf3n para recordarle en su dispositivo y navegador en las tiendas participantes para agilizar el proceso de pago. No lo recomendamos para dispositivos compartidos.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Seleccione esta opci\xf3n para recordarle en su dispositivo y navegador",
            "ctp.emptyProfile.message": "No hay tarjetas registradas en este perfil de Click to Pay",
            "ctp.separatorText": "o utilice",
            "ctp.cards.title": "Completar el pago con Click to Pay",
            "ctp.cards.subtitle": "Seleccione una tarjeta para usar.",
            "ctp.cards.expiredCard": "Caducada",
            "ctp.manualCardEntry": "Introducci\xf3n manual de tarjeta",
            "ctp.aria.infoModalButton": "Qu\xe9 es Click to Pay",
            "ctp.infoPopup.title": "Click to Pay ofrece la comodidad de la funci\xf3n sin contacto en internet",
            "ctp.infoPopup.subtitle": "Un m\xe9todo de pago r\xe1pido y seguro compatible con Mastercard, Visa y otras tarjetas de pago.",
            "ctp.infoPopup.benefit1": "Click to Pay utiliza cifrado para mantener su informaci\xf3n segura y protegida",
            "ctp.infoPopup.benefit2": "Util\xedcelo con vendedores de todo el mundo",
            "ctp.infoPopup.benefit3": "Config\xfarela una vez para realizar pagos sin complicaciones en el futuro",
            "ctp.errors.AUTH_INVALID": "Autenticaci\xf3n no v\xe1lida",
            "ctp.errors.NOT_FOUND": "No se ha encontrado ninguna cuenta, escriba un correo electr\xf3nico v\xe1lido o contin\xfae usando la escritura manual de la tarjeta",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formato no compatible",
            "ctp.errors.FRAUD": "Se ha bloqueado o desactivado la cuenta de usuario",
            "ctp.errors.CONSUMER_ID_MISSING": "Falta la identidad del consumidor en la solicitud",
            "ctp.errors.ACCT_INACCESSIBLE": "Esta cuenta no est\xe1 disponible en este momento, por ejemplo, est\xe1 bloqueada",
            "ctp.errors.CODE_INVALID": "C\xf3digo de verificaci\xf3n incorrecto",
            "ctp.errors.CODE_EXPIRED": "Este c\xf3digo ha caducado",
            "ctp.errors.RETRIES_EXCEEDED": "Se ha excedido el l\xedmite de reintentos para la generaci\xf3n de una contrase\xf1a de un solo uso",
            "ctp.errors.OTP_SEND_FAILED": "No se ha podido enviar la contrase\xf1a de un solo uso al destinatario",
            "ctp.errors.REQUEST_TIMEOUT": "Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta",
            "ctp.errors.UNKNOWN_ERROR": "Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta",
            "ctp.errors.SERVICE_ERROR": "Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta",
            "ctp.errors.SERVER_ERROR": "Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta",
            "ctp.errors.INVALID_PARAMETER": "Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta",
            "ctp.errors.AUTH_ERROR": "Se ha producido un error, int\xe9ntelo de nuevo o utilice la escritura manual de la tarjeta",
            "paymentMethodsList.aria.label": "Elija un m\xe9todo de pago",
            "companyDetails.name.invalid": "Introduzca el nombre de la empresa",
            "companyDetails.registrationNumber.invalid": "Introduzca el n\xfamero de registro",
            "consent.checkbox.invalid": "Debe aceptar los t\xe9rminos y condiciones",
            "form.instruction": "Todos los campos son obligatorios a menos que se indique lo contrario.",
            "ancv.input.label": "Su identificaci\xf3n de la ANCV",
            "ancv.confirmPayment": "Utilice su solicitud de la ANCV para confirmar el pago.",
            "ancv.form.instruction": "La aplicaci\xf3n de Cheque-Vacances es necesaria para validar este pago.",
            "ancv.beneficiaryId.invalid": "Introduzca una direcci\xf3n de correo electr\xf3nico v\xe1lida o un documento de identidad de la ANCV",
            "payme.openPayMeApp": "Completa tu pago en la aplicaci\xf3n PayMe autorizando el pago en la aplicaci\xf3n y espera por la confirmaci\xf3n.",
            "payme.redirectButtonLabel": "Abrir aplicaci\xf3n PayMe",
            "payme.scanQrCode": "Completa tu pago con c\xf3digo QR",
            "payme.timeToPay": "Este c\xf3digo QR es v\xe1lido para %@",
            "payme.instructions.steps": "Abre la aplicaci\xf3n PayMe.%@Escanea el c\xf3digo QR para autorizar el pago.%@Completa el pago en la aplicaci\xf3n y espera por la confirmaci\xf3n.",
            "payme.instructions.footnote": "No cierres esta p\xe1gina antes de que se complete el pago"
        }
    }), J1 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Maksa",
            "payButton.redirecting": "Uudelleenohjataan...",
            "payButton.with": "Maksa %{value} k\xe4ytt\xe4en maksutapaa %{maskedData}",
            "payButton.saveDetails": "Tallenna tiedot",
            close: "Sulje",
            storeDetails: "Tallenna seuraavaa maksuani varten",
            readMore: "Lue lis\xe4\xe4",
            "creditCard.holderName": "Nimi kortilla",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "Sy\xf6t\xe4 nimi sellaisena kuin se on kortissa",
            "creditCard.numberField.title": "Kortin numero",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Voimassaolop\xe4iv\xe4m\xe4\xe4r\xe4",
            "creditCard.expiryDateField.placeholder": "KK / VV",
            "creditCard.expiryDateField.month": "Kuukausi",
            "creditCard.expiryDateField.month.placeholder": "KK",
            "creditCard.expiryDateField.year.placeholder": "VV",
            "creditCard.expiryDateField.year": "Vuosi",
            "creditCard.cvcField.title": "Turvakoodi",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Muista seuraavalla kerralla",
            "creditCard.cvcField.placeholder.4digits": "4 lukua",
            "creditCard.cvcField.placeholder.3digits": "3 lukua",
            "creditCard.taxNumber.placeholder": "VVKKPP / 0123456789",
            installments: "Asennusten m\xe4\xe4r\xe4",
            installmentOption: "% {kertaa} x% {osittainenarvo}",
            installmentOptionMonths: "% {kertaa} kuukautta",
            "installments.oneTime": "Kertamaksu",
            "installments.installments": "Er\xe4maksu",
            "installments.revolving": "Toistuva maksu",
            "sepaDirectDebit.ibanField.invalid": "V\xe4\xe4r\xe4 tilin numero",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "Haltijan nimi",
            "sepa.ibanNumber": "Tilinumero (IBAN)",
            "error.title": "Virhe",
            "error.subtitle.redirect": "Uuteen kohteeseen siirto ep\xe4onnistui",
            "error.subtitle.payment": "Maksu ep\xe4nnistui",
            "error.subtitle.refused": "Maksu hyl\xe4tty",
            "error.message.unknown": "Tapahtui tuntematon virhe",
            "errorPanel.title": "Olemassa olevat virheet",
            "idealIssuer.selectField.title": "Pankki",
            "idealIssuer.selectField.placeholder": "Valitse pankkisi",
            "creditCard.success": "Maksu onnistui",
            loading: "Ladataan...",
            continue: "Jatka",
            continueTo: "Jatka kohteeseen",
            "wechatpay.timetopay": "Sinulla on %@ maksettavana",
            "sr.wechatpay.timetopay": "Maksuaikaa on j\xe4ljell\xe4 %#minuuttia%# %#sekuntia%#",
            "wechatpay.scanqrcode": "Skannaa QR-koodi",
            personalDetails: "Henkil\xf6tiedot",
            companyDetails: "Yhti\xf6n tiedot",
            "companyDetails.name": "Yhti\xf6n nimi",
            "companyDetails.registrationNumber": "Rekisterinumero",
            socialSecurityNumber: "Sosiaaliturvatunnus",
            firstName: "Etunimi",
            "firstName.invalid": "Sy\xf6t\xe4 etunimesi",
            infix: "Etuliite",
            lastName: "Sukunimi",
            "lastName.invalid": "Sy\xf6t\xe4 sukunimesi",
            mobileNumber: "Matkapuhelinnumero",
            "mobileNumber.invalid": "Ei-kelvollinen matkapuhelinnumero",
            city: "Kaupunki",
            postalCode: "Postinumero",
            "postalCode.optional": "Postinumero (valinnainen)",
            countryCode: "Maakoodi",
            telephoneNumber: "Puhelinnumero",
            dateOfBirth: "Syntym\xe4aika",
            shopperEmail: "S\xe4hk\xf6postiosoite",
            gender: "Sukupuoli",
            "gender.notselected": "Valitse sukupuoli",
            male: "Mies",
            female: "Nainen",
            billingAddress: "Laskutusosoite",
            street: "Katu",
            stateOrProvince: "Osavaltio tai l\xe4\xe4ni",
            country: "Maa",
            houseNumberOrName: "Talon numero",
            separateDeliveryAddress: "M\xe4\xe4rit\xe4 erillinen toimitusosoite",
            deliveryAddress: "Toimitusosoite",
            "deliveryAddress.firstName": "Vastaanottajan etunimi",
            "deliveryAddress.lastName": "Vastaanottajan sukunimi",
            zipCode: "Postinumero",
            apartmentSuite: "Huoneisto / sviitti",
            provinceOrTerritory: "Maakunta tai alue",
            cityTown: "Kaupunki / taajama",
            address: "Osoite",
            "address.placeholder": "L\xf6yd\xe4 osoitteesi",
            "address.errors.incomplete": "Sy\xf6t\xe4 osoite jatkaaksesi",
            "address.enterManually": "Sy\xf6t\xe4 osoite manuaalisesti",
            state: "Osavaltio",
            "field.title.optional": "(valinnainen)",
            "creditCard.cvcField.title.optional": "Turvakoodi (valinnainen)",
            "issuerList.wallet.placeholder": "Valitse lompakkosi",
            privacyPolicy: "Tietosuojamenettely",
            "afterPay.agreement": "Hyv\xe4ksyn Rivertyn %@",
            paymentConditions: "maksuehdot",
            openApp: "Avaa sovellus",
            "voucher.readInstructions": "Lue ohjeet",
            "voucher.introduction": "Kiitos hankinnastasi, k\xe4yt\xe4 seuraavaa kuponkia vied\xe4ksesi maksusi p\xe4\xe4t\xf6kseen.",
            "voucher.expirationDate": "Vanhenemisp\xe4iv\xe4m\xe4\xe4r\xe4",
            "voucher.alternativeReference": "Vaihtoehtoinen viite",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Valitse toimittajasi",
            "dragonpay.voucher.bank.selectField.placeholder": "Valitse pankkisi",
            "voucher.paymentReferenceLabel": "Maksun viite",
            "voucher.surcharge": "Sis. %@ lis\xe4maksun",
            "voucher.introduction.doku": "Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.",
            "voucher.shopperName": "Ostajan nimi",
            "voucher.merchantName": "Kauppias",
            "voucher.introduction.econtext": "Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.",
            "voucher.telephoneNumber": "Puhelinnumero",
            "voucher.shopperReference": "Ostajan viite",
            "voucher.collectionInstitutionNumber": "Ker\xe4\xe4v\xe4n laitoksen numero",
            "voucher.econtext.telephoneNumber.invalid": "Puhelinnumeron on oltava 10 tai 11 numeroa pitk\xe4",
            "boletobancario.btnLabel": "Luo Boleto",
            "boleto.sendCopyToEmail": "L\xe4het\xe4 kopio s\xe4hk\xf6postiini",
            "button.copy": "Kopio",
            "button.download": "Lataa",
            "boleto.socialSecurityNumber.invalid": "Kentt\xe4 ei kelpaa",
            "creditCard.storedCard.description.ariaLabel": "Tallennetun kortin viimeiset luvut ovat %@",
            "voucher.entity": "Kokonaisuus",
            donateButton: "Lahjoita",
            notNowButton: "Ei nyt",
            thanksForYourSupport: "Kiitos tuestasi!",
            "resultMessages.preauthorized": "Tiedot tallennettu",
            preauthorizeWith: "Ennkkolupa k\xe4ytt\xe4j\xe4n kanssa",
            confirmPreauthorization: "Vahvista ennakkolupa",
            confirmPurchase: "Vahvista hankinta",
            applyGiftcard: "Lunasta",
            giftcardBalance: "Lahjakortin saldo",
            deductedBalance: "V\xe4hennetty saldo",
            "creditCard.pin.title": "Pin-tunnus",
            "creditCard.encryptedPassword.label": "Kortin salasanan ensimm\xe4iset 2 lukua",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Kelpaamaton salasana",
            "creditCard.taxNumber": "Kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero",
            "creditCard.taxNumber.label": "Kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero (10 lukua)",
            "creditCard.taxNumber.labelAlt": "Yrityksen rekisterinumero (10 lukua)",
            "creditCard.taxNumber.invalid": "Kelpaamaton kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero",
            "storedPaymentMethod.disable.button": "Poista",
            "storedPaymentMethod.disable.confirmation": "Poista tallennettu maksutapa",
            "storedPaymentMethod.disable.confirmButton": "Kyll\xe4, poista",
            "storedPaymentMethod.disable.cancelButton": "Peruuta",
            "ach.bankAccount": "Pankkitili",
            "ach.accountHolderNameField.title": "Tilinhaltijan nimi",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Ei-kelvollinen tilinhaltijan nimi",
            "ach.accountNumberField.title": "Tilinumero",
            "ach.accountNumberField.invalid": "V\xe4\xe4r\xe4 tilin numero",
            "ach.accountLocationField.title": "ABA-reititysnumero",
            "ach.accountLocationField.invalid": "Ei-kelvollinen ABA-reititysnumero",
            "ach.savedBankAccount": "Tallennettu pankkitili",
            "select.state": "Valitse osavaltio",
            "select.stateOrProvince": "Valitse osavaltio tai l\xe4\xe4ni",
            "select.provinceOrTerritory": "Valitse maakunta tai alue",
            "select.country": "Valitse maa",
            "select.noOptionsFound": "Vaihtoehtoja ei l\xf6ytynyt",
            "select.filter.placeholder": "Hae...",
            "telephoneNumber.invalid": "Ei-kelvollinen puhelinnumero",
            qrCodeOrApp: "tai",
            "paypal.processingPayment": "Maksua k\xe4sitell\xe4\xe4n...",
            generateQRCode: "Tuota QR-koodi",
            "await.waitForConfirmation": "Odottaa vahvistusta",
            "mbway.confirmPayment": "Vahvista maksusi MB WAY -sovelluksella",
            "shopperEmail.invalid": "Ei-kelvollinen s\xe4hk\xf6postiosoite",
            "dateOfBirth.format": "PP/KK/VVVV",
            "dateOfBirth.invalid": "Anna kelvollinen syntym\xe4aika, joka osoittaa, ett\xe4 olet v\xe4hint\xe4\xe4n 18-vuotias",
            "blik.confirmPayment": "Avaa pankkisovelluksesi vahvistaaksesi maksun.",
            "blik.invalid": "Sy\xf6t\xe4 6 lukua",
            "blik.code": "6-numeroinen koodi",
            "blik.help": "Hanki koodi pankkisovelluksestasi.",
            "swish.pendingMessage": "Skannattuasi, tila voi odottaa jopa 10 minuuttia. Yritys maksaa uudelleen t\xe4ss\xe4 ajassa voi tuottaa moninkertaisia maksuja.",
            "field.valid": "Kentt\xe4 kelvollinen",
            "field.invalid": "Kentt\xe4 ei kelpaa",
            "error.va.gen.01": "T\xe4ydent\xe4m\xe4t\xf6n kentt\xe4",
            "error.va.gen.02": "Kentt\xe4 ei kelpaa",
            "error.va.sf-cc-num.01": "Sy\xf6t\xe4 kelvollinen kortin numero",
            "error.va.sf-cc-num.02": "Sy\xf6t\xe4 kortin numero",
            "error.va.sf-cc-num.03": "Sy\xf6t\xe4 tuettu korttimerkki",
            "error.va.sf-cc-num.04": "Sy\xf6t\xe4 kortin numero kokonaan",
            "error.va.sf-cc-dat.01": "Sy\xf6t\xe4 kelvollinen viimeinen voimassaolop\xe4iv\xe4",
            "error.va.sf-cc-dat.02": "Sy\xf6t\xe4 kelvollinen viimeinen voimassaolop\xe4iv\xe4",
            "error.va.sf-cc-dat.03": "Luottokortin voimassaolo p\xe4\xe4ttyy pian",
            "error.va.sf-cc-dat.04": "Sy\xf6t\xe4 viimeinen voimassaolop\xe4iv\xe4",
            "error.va.sf-cc-dat.05": "Sy\xf6t\xe4 viimeinen voimassaolop\xe4iv\xe4 kokonaan",
            "error.va.sf-cc-mth.01": "Sy\xf6t\xe4 viimeinen voimassaolokuukausi",
            "error.va.sf-cc-yr.01": "Sy\xf6t\xe4 viimeinen voimassaolovuosi",
            "error.va.sf-cc-yr.02": "Sy\xf6t\xe4 viimeinen voimassaolovuosi kokonaan",
            "error.va.sf-cc-cvc.01": "Sy\xf6t\xe4 turvakoodi",
            "error.va.sf-cc-cvc.02": "Sy\xf6t\xe4 turvakoodi kokonaan",
            "error.va.sf-ach-num.01": "Pankkitilin numero -kentt\xe4 on tyhj\xe4",
            "error.va.sf-ach-num.02": "Pankkitilin numero on v\xe4\xe4r\xe4n pituinen",
            "error.va.sf-ach-loc.01": "Pankin reititysnumeron kentt\xe4 on tyhj\xe4",
            "error.va.sf-ach-loc.02": "Pankin reititysnumero on v\xe4\xe4r\xe4n pituinen",
            "error.va.sf-kcp-pwd.01": "Salasanakentt\xe4 on tyhj\xe4",
            "error.va.sf-kcp-pwd.02": "Salasana on v\xe4\xe4r\xe4n pituinen",
            "error.giftcard.no-balance": "Lahjakortin saldo on nolla",
            "error.giftcard.card-error": "Asiakirjoissamme ei ole t\xe4m\xe4n numeron lahjakorttia",
            "error.giftcard.currency-error": "Gift cards are only valid in the currency they were issued in",
            "amazonpay.signout": "Kirjaudu ulos Amazonista",
            "amazonpay.changePaymentDetails": "Muuta maksutietoja",
            "partialPayment.warning": "Valitse toinen maksutapa j\xe4\xe4nn\xf6ksen maksamiseksi",
            "partialPayment.remainingBalance": "J\xe4ljell\xe4 oleva saldo on %{summa}",
            "bankTransfer.beneficiary": "Edunsaaja",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Viite",
            "bankTransfer.introduction": "Jatka uuden pankkisiirtomaksun luomista. Voit viimeistell\xe4 t\xe4m\xe4n maksun seuraavan n\xe4yt\xf6n tietojen avulla.",
            "bankTransfer.instructions": "Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.",
            "bacs.accountHolderName": "Tilinhaltijan nimi",
            "bacs.accountHolderName.invalid": "Ei-kelvollinen tilinhaltijan nimi",
            "bacs.accountNumber": "Pankkitilinumero",
            "bacs.accountNumber.invalid": "V\xe4\xe4r\xe4 tilin numero",
            "bacs.bankLocationId": "Lajittelukoodi",
            "bacs.bankLocationId.invalid": "Ei-kelvollinen lajittelukoodi",
            "bacs.consent.amount": "Hyv\xe4ksyn, ett\xe4 alla oleva summa veloitetaan pankkitililt\xe4ni.",
            "bacs.consent.account": "Vahvistan, ett\xe4 tili on nimess\xe4ni ja olen ainoa allekirjoittaja, joka vaaditaan valtuuttamaan suoraveloitus t\xe4ll\xe4 tilill\xe4.",
            edit: "Muokkaa",
            "bacs.confirm": "Vahvista ja maksa",
            "bacs.result.introduction": "Lataa suoraveloitusohjeet (DDI / Mandate)",
            "download.pdf": "Lataa PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe kortin numerolle",
            "creditCard.encryptedCardNumber.aria.label": "Kortin numero",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe viimeiselle voimassaolop\xe4iv\xe4lle",
            "creditCard.encryptedExpiryDate.aria.label": "Voimassaolop\xe4iv\xe4m\xe4\xe4r\xe4",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe viimeiselle voimassaolokuukaudelle",
            "creditCard.encryptedExpiryMonth.aria.label": "Vanhenemiskuukausi",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe viimeiselle voimassaolovuodelle",
            "creditCard.encryptedExpiryYear.aria.label": "Vanhenemisvuosi",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe turvakoodille",
            "creditCard.encryptedSecurityCode.aria.label": "Turvakoodi",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe salasanalle",
            "creditCard.encryptedPassword.aria.label": "Kortin salasanan ensimm\xe4iset 2 lukua",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe kortin numerolle",
            "giftcard.encryptedCardNumber.aria.label": "Kortin numero",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe pin-koodille",
            "giftcard.encryptedSecurityCode.aria.label": "Pin-tunnus",
            giftcardTransactionLimit: "Maks. % {summa} sallittu tapahtumaa kohti t\xe4ll\xe4 lahjakortilla",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe pankkitilinumeroa varten",
            "ach.encryptedBankAccountNumber.aria.label": "Tilinumero",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe pankin reititysnumeroa varten",
            "ach.encryptedBankLocationId.aria.label": "ABA-reititysnumero",
            "twint.saved": "tallennettu",
            orPayWith: "tai maksa",
            invalidFormatExpects: "Ei-kelvollinen muoto. Odotettu muoto: %{format}",
            "upi.qrCodeWaitingMessage": "Suorita maksu loppuun skannaamalla QR-koodi haluamallasi UPI-sovelluksella",
            "upi.vpaWaitingMessage": "Avaa UPI-sovellus vahvistaaksesi maksun",
            "upi.modeSelection": "Valitse, kuinka haluat k\xe4ytt\xe4\xe4 UPI-sovellusta.",
            "onlineBanking.termsAndConditions": "Jatkamalla hyv\xe4ksyt %#k\xe4ytt\xf6ehdot%#",
            "onlineBankingPL.termsAndConditions": "Jatkamalla hyv\xe4ksyt Przelewy24:n %#s\xe4\xe4nn\xf6t%# ja %#tiedonantovelvollisuuden%#",
            "ctp.loading.poweredByCtp": "Palvelun tarjoaa Click to Pay",
            "ctp.loading.intro": "Tarkistamme, onko sinulla tallennettuja Click to Pay -kortteja...",
            "ctp.login.title": "Jatka Click to Pay -palveluun",
            "ctp.login.subtitle": "Jatka antamalla Click to Pay -palveluun liitetty s\xe4hk\xf6postiosoite.",
            "ctp.login.inputLabel": "S\xe4hk\xf6posti",
            "ctp.logout.notYou": "Etk\xf6 t\xe4m\xe4 ole sin\xe4?",
            "ctp.logout.notYourCards": "Eik\xf6 t\xe4m\xe4 ole korttisi?",
            "ctp.logout.notYourCard": "Eik\xf6 t\xe4m\xe4 ole korttisi?",
            "ctp.logout.notYourProfile": "Eik\xf6 t\xe4m\xe4 ole profiilisi?",
            "ctp.otp.fieldLabel": "Kertakoodi",
            "ctp.otp.resendCode": "L\xe4het\xe4 koodi uudelleen",
            "ctp.otp.codeResent": "Koodi l\xe4hetetty uudelleen",
            "ctp.otp.title": "Hanki p\xe4\xe4sy Click to Pay -kortteihisi",
            "ctp.otp.subtitle": "Sy\xf6t\xe4 koodi, jonka %@ l\xe4hetti osoitteeseen %@ vahvistaaksesi, ett\xe4 kyseess\xe4 olet sin\xe4.",
            "ctp.otp.saveCookiesCheckbox.label": "Ohita vahvistus seuraavalla kerralla",
            "ctp.otp.saveCookiesCheckbox.information": "Valitse, ett\xe4 sinut muistetaan laitteellasi ja selaimessa osallistuvissa myym\xe4l\xf6iss\xe4, jotta voit maksaa nopeammin. Ei suositella jaetuilla laitteilla.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Valitse, jotta sinut muistetaan laitteellasi ja selaimessa",
            "ctp.emptyProfile.message": "T\xe4h\xe4n Click to Pay -profiiliin ei ole rekister\xf6ity kortteja",
            "ctp.separatorText": "tai k\xe4yt\xe4",
            "ctp.cards.title": "Suorita maksu Click to Paylla",
            "ctp.cards.subtitle": "Valitse k\xe4ytett\xe4v\xe4 kortti.",
            "ctp.cards.expiredCard": "Vanhentunut",
            "ctp.manualCardEntry": "Manuaalinen kortin sy\xf6tt\xf6",
            "ctp.aria.infoModalButton": "Mik\xe4 on Click to Pay",
            "ctp.infoPopup.title": "Click to Pay tuo l\xe4himaksujen helppouden verkkoon",
            "ctp.infoPopup.subtitle": "Nopea ja turvallinen maksutapa, jota tukevat Mastercard, Visa ja muut maksukortit.",
            "ctp.infoPopup.benefit1": "Click to Pay k\xe4ytt\xe4\xe4 salausta tietojesi turvaamiseen",
            "ctp.infoPopup.benefit2": "K\xe4yt\xe4 sit\xe4 kauppiailla kaikkialla maailmassa",
            "ctp.infoPopup.benefit3": "M\xe4\xe4rit\xe4 kerran, jotta voit maksaa vaivattomasti jatkossa",
            "ctp.errors.AUTH_INVALID": "Virheellinen todennus",
            "ctp.errors.NOT_FOUND": "Tili\xe4 ei l\xf6ytynyt. Anna kelvollinen s\xe4hk\xf6postiosoite tai jatka manuaalista kortin sy\xf6tt\xf6\xe4",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Muoto ei tuettu",
            "ctp.errors.FRAUD": "K\xe4ytt\xe4j\xe4tili oli lukittu tai poistettu k\xe4yt\xf6st\xe4",
            "ctp.errors.CONSUMER_ID_MISSING": "Pyynn\xf6st\xe4 puuttuu kuluttajan henkil\xf6llisyys",
            "ctp.errors.ACCT_INACCESSIBLE": "T\xe4m\xe4 tili ei ole t\xe4ll\xe4 hetkell\xe4 k\xe4ytett\xe4viss\xe4, se voi esimerkiksi olla lukittu",
            "ctp.errors.CODE_INVALID": "Virheellinen vahvistuskoodi",
            "ctp.errors.CODE_EXPIRED": "T\xe4m\xe4 koodi on vanhentunut",
            "ctp.errors.RETRIES_EXCEEDED": "Kertak\xe4ytt\xf6isen salasanan luomisen uusintayritysten m\xe4\xe4r\xe4 ylittyi",
            "ctp.errors.OTP_SEND_FAILED": "Kertak\xe4ytt\xf6ist\xe4 salasanaa ei voitu l\xe4hett\xe4\xe4 vastaanottajalle",
            "ctp.errors.REQUEST_TIMEOUT": "Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4",
            "ctp.errors.UNKNOWN_ERROR": "Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4",
            "ctp.errors.SERVICE_ERROR": "Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4",
            "ctp.errors.SERVER_ERROR": "Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4",
            "ctp.errors.INVALID_PARAMETER": "Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4",
            "ctp.errors.AUTH_ERROR": "Jokin meni vikaan. Yrit\xe4 uudelleen tai k\xe4yt\xe4 manuaalista kortin sy\xf6tt\xf6\xe4",
            "paymentMethodsList.aria.label": "Valitse maksutapa",
            "companyDetails.name.invalid": "Sy\xf6t\xe4 yrityksen nimi",
            "companyDetails.registrationNumber.invalid": "Sy\xf6t\xe4 rekisterinumero",
            "consent.checkbox.invalid": "Sinun on hyv\xe4ksytt\xe4v\xe4 k\xe4ytt\xf6ehdot",
            "form.instruction": "Kaikki kent\xe4t ovat pakollisia, ellei toisin ole merkitty.",
            "ancv.input.label": "ANCV-tunnuksesi",
            "ancv.confirmPayment": "Vahvista maksusi ANCV-sovelluksella.",
            "ancv.form.instruction": "T\xe4m\xe4n maksun vahvistaminen edellytt\xe4\xe4 Cheque-Vacances -sovelluksen.",
            "ancv.beneficiaryId.invalid": "Anna kelvollinen s\xe4hk\xf6postiosoite tai ANCV-tunnus",
            "payme.openPayMeApp": "Viimeistele maksu PayMe-sovelluksessa hyv\xe4ksym\xe4ll\xe4 maksu sovelluksessa, ja odota vahvistusta.",
            "payme.redirectButtonLabel": "Avaa PayMe-sovellus",
            "payme.scanQrCode": "Viimeistele maksusi QR-koodilla",
            "payme.timeToPay": "T\xe4m\xe4 QR-koodi on voimassa %@",
            "payme.instructions.steps": "Avaa PayMe-sovellus.%@Hyv\xe4ksy maksu skannaamalla QR-koodi.%@Viimeistele maksu sovelluksessa, ja odota vahvistusta.",
            "payme.instructions.footnote": "\xc4l\xe4 sulje t\xe4t\xe4 sivua ennen kuin maksu on suoritettu"
        }
    }), $1 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Payer",
            "payButton.redirecting": "Redirection...",
            "payButton.with": "Payer %{value} avec %{maskedData}",
            "payButton.saveDetails": "Enregistrer les d\xe9tails",
            close: "Fermer",
            storeDetails: "Sauvegarder pour mon prochain paiement",
            readMore: "Lire la suite",
            "creditCard.holderName": "Nom sur la carte",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "Entrez le nom tel qu'il appara\xeet sur la carte",
            "creditCard.numberField.title": "Num\xe9ro de la carte",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Date d'expiration",
            "creditCard.expiryDateField.placeholder": "MM/AA",
            "creditCard.expiryDateField.month": "Mois",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "AA",
            "creditCard.expiryDateField.year": "Ann\xe9e",
            "creditCard.cvcField.title": "Code de s\xe9curit\xe9",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Enregistrer pour la prochaine fois",
            "creditCard.cvcField.placeholder.4digits": "4\xa0chiffres",
            "creditCard.cvcField.placeholder.3digits": "3\xa0chiffres",
            "creditCard.taxNumber.placeholder": "AAMMJJ / 0123456789",
            installments: "Nombre de versements",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times}\xa0mois",
            "installments.oneTime": "Paiement unique",
            "installments.installments": "Paiement \xe9chelonn\xe9",
            "installments.revolving": "Paiement en plusieurs fois",
            "sepaDirectDebit.ibanField.invalid": "Num\xe9ro de compte non valide",
            "sepaDirectDebit.nameField.placeholder": "N. Bernard",
            "sepa.ownerName": "Au nom de",
            "sepa.ibanNumber": "Num\xe9ro de compte (IBAN)",
            "error.title": "Erreur",
            "error.subtitle.redirect": "\xc9chec de la redirection",
            "error.subtitle.payment": "\xc9chec du paiement",
            "error.subtitle.refused": "Paiement refus\xe9",
            "error.message.unknown": "Une erreur inconnue s'est produite",
            "errorPanel.title": "Erreurs existantes",
            "idealIssuer.selectField.title": "Banque",
            "idealIssuer.selectField.placeholder": "S\xe9lectionnez votre banque",
            "creditCard.success": "Paiement r\xe9ussi",
            loading: "Chargement en cours...",
            continue: "Continuer",
            continueTo: "Poursuivre vers",
            "wechatpay.timetopay": "Vous avez %@ pour payer cette somme",
            "sr.wechatpay.timetopay": "Vous disposez de %#\xa0minutes%# et %#\xa0secondes%# pour effectuer le paiement",
            "wechatpay.scanqrcode": "Scanner le code QR",
            personalDetails: "Informations personnelles",
            companyDetails: "Coordonn\xe9es de l'entreprise",
            "companyDetails.name": "Nom de l'entreprise",
            "companyDetails.registrationNumber": "Num\xe9ro d'enregistrement",
            socialSecurityNumber: "Num\xe9ro de s\xe9curit\xe9 sociale",
            firstName: "Pr\xe9nom",
            "firstName.invalid": "Entrez votre pr\xe9nom",
            infix: "Pr\xe9fixe",
            lastName: "Nom de famille",
            "lastName.invalid": "Entrez votre nom",
            mobileNumber: "Num\xe9ro de portable",
            "mobileNumber.invalid": "Num\xe9ro de portable non valide",
            city: "Ville",
            postalCode: "Code postal",
            "postalCode.optional": "Code postal (facultatif)",
            countryCode: "Code pays",
            telephoneNumber: "Num\xe9ro de t\xe9l\xe9phone",
            dateOfBirth: "Date de naissance",
            shopperEmail: "Adresse e-mail",
            gender: "Sexe",
            "gender.notselected": "S\xe9lectionnez votre sexe",
            male: "Homme",
            female: "Femme",
            billingAddress: "Adresse de facturation",
            street: "Rue",
            stateOrProvince: "\xc9tat ou province",
            country: "Pays",
            houseNumberOrName: "Num\xe9ro de rue",
            separateDeliveryAddress: "Indiquer une adresse de livraison distincte",
            deliveryAddress: "Adresse de livraison",
            "deliveryAddress.firstName": "Pr\xe9nom du destinataire",
            "deliveryAddress.lastName": "Nom du destinataire",
            zipCode: "Code postal",
            apartmentSuite: "Appartement",
            provinceOrTerritory: "Province ou territoire",
            cityTown: "Ville",
            address: "Adresse",
            "address.placeholder": "Trouvez votre adresse",
            "address.errors.incomplete": "Saisissez une adresse pour continuer",
            "address.enterManually": "Saisissez l'adresse manuellement",
            state: "\xc9tat",
            "field.title.optional": "(facultatif)",
            "creditCard.cvcField.title.optional": "Code de s\xe9curit\xe9 (facultatif)",
            "issuerList.wallet.placeholder": "S\xe9lectionnez votre portefeuille",
            privacyPolicy: "Politique de confidentialit\xe9",
            "afterPay.agreement": "J'accepte les %@ de Riverty",
            paymentConditions: "conditions de paiement",
            openApp: "Ouvrir l'application",
            "voucher.readInstructions": "Lire les instructions",
            "voucher.introduction": "Merci pour votre achat, veuillez utiliser le coupon suivant pour finaliser votre paiement.",
            "voucher.expirationDate": "Date d'expiration",
            "voucher.alternativeReference": "Autre r\xe9f\xe9rence",
            "dragonpay.voucher.non.bank.selectField.placeholder": "S\xe9lectionnez votre fournisseur",
            "dragonpay.voucher.bank.selectField.placeholder": "S\xe9lectionnez votre banque",
            "voucher.paymentReferenceLabel": "R\xe9f\xe9rence du paiement",
            "voucher.surcharge": "Comprend une surcharge de %@",
            "voucher.introduction.doku": "Nous vous remercions de votre achat. Veuillez finaliser votre paiement \xe0 l'aide des informations suivantes.",
            "voucher.shopperName": "Nom de l'acheteur",
            "voucher.merchantName": "Marchand",
            "voucher.introduction.econtext": "Nous vous remercions de votre achat. Veuillez finaliser votre paiement \xe0 l'aide des informations suivantes.",
            "voucher.telephoneNumber": "Num\xe9ro de t\xe9l\xe9phone",
            "voucher.shopperReference": "R\xe9f\xe9rence client",
            "voucher.collectionInstitutionNumber": "Num\xe9ro du point de paiement",
            "voucher.econtext.telephoneNumber.invalid": "Le num\xe9ro de t\xe9l\xe9phone doit comporter 10 ou 11\xa0chiffres",
            "boletobancario.btnLabel": "G\xe9n\xe9rer un Boleto",
            "boleto.sendCopyToEmail": "Envoyer une copie \xe0 mon adresse e-mail",
            "button.copy": "Copier",
            "button.download": "T\xe9l\xe9charger",
            "boleto.socialSecurityNumber.invalid": "Champ non valide",
            "creditCard.storedCard.description.ariaLabel": "La carte enregistr\xe9e se termine en %@",
            "voucher.entity": "Entit\xe9",
            donateButton: "Faire un don",
            notNowButton: "Pas maintenant",
            thanksForYourSupport: "Merci de votre soutien\xa0!",
            "resultMessages.preauthorized": "D\xe9tails enregistr\xe9s",
            preauthorizeWith: "Pr\xe9-autoriser avec",
            confirmPreauthorization: "Confirmer la pr\xe9-autorisation",
            confirmPurchase: "Confirmer l'achat",
            applyGiftcard: "Utiliser",
            giftcardBalance: "Solde de la carte cadeau",
            deductedBalance: "Solde d\xe9duit",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "Les deux premiers chiffres du code de votre carte",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Code incorrect",
            "creditCard.taxNumber": "Date de naissance du porteur de carte ou num\xe9ro d'identification de l'entreprise",
            "creditCard.taxNumber.label": "Date de naissance du porteur de carte (au format AAMMJJ) ou num\xe9ro d'identification de l'entreprise (\xe0 10\xa0chiffres)",
            "creditCard.taxNumber.labelAlt": "Num\xe9ro d'identification de l'entreprise (\xe0 10\xa0chiffres)",
            "creditCard.taxNumber.invalid": "Date de naissance du porteur de carte ou num\xe9ro d'identification de l'entreprise incorrect(e)",
            "storedPaymentMethod.disable.button": "Supprimer",
            "storedPaymentMethod.disable.confirmation": "Supprimer le mode de paiement enregistr\xe9",
            "storedPaymentMethod.disable.confirmButton": "Oui, supprimer",
            "storedPaymentMethod.disable.cancelButton": "Annuler",
            "ach.bankAccount": "Compte bancaire",
            "ach.accountHolderNameField.title": "Nom du titulaire du compte",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Nom du titulaire du compte incorrect",
            "ach.accountNumberField.title": "Num\xe9ro du compte",
            "ach.accountNumberField.invalid": "Num\xe9ro du compte incorrect",
            "ach.accountLocationField.title": "Code ABA",
            "ach.accountLocationField.invalid": "Code ABA incorrect",
            "ach.savedBankAccount": "Compte bancaire enregistr\xe9",
            "select.state": "S\xe9lectionnez l'\xc9tat",
            "select.stateOrProvince": "S\xe9lectionnez l'\xc9tat ou la province",
            "select.provinceOrTerritory": "S\xe9lectionnez la province ou le territoire",
            "select.country": "S\xe9lectionnez le pays",
            "select.noOptionsFound": "Aucune option trouv\xe9e",
            "select.filter.placeholder": "Recherche...",
            "telephoneNumber.invalid": "Num\xe9ro de t\xe9l\xe9phone incorrect",
            qrCodeOrApp: "ou",
            "paypal.processingPayment": "Traitement du paiement en cours...",
            generateQRCode: "G\xe9n\xe9rer un code QR",
            "await.waitForConfirmation": "En attente de confirmation",
            "mbway.confirmPayment": "Confirmez votre paiement sur l'application MB WAY",
            "shopperEmail.invalid": "Adresse e-mail incorrecte",
            "dateOfBirth.format": "JJ/MM/AAAA",
            "dateOfBirth.invalid": "Saisissez une date de naissance valide indiquant que vous avez au moins 18\xa0ans",
            "blik.confirmPayment": "Ouvrez votre application bancaire pour confirmer le paiement.",
            "blik.invalid": "Saisissez les 6\xa0chiffres",
            "blik.code": "Code \xe0 6\xa0chiffres",
            "blik.help": "Ouvrez votre application bancaire pour obtenir le code.",
            "swish.pendingMessage": "Apr\xe8s avoir scann\xe9 le code QR, la mise \xe0 jour du statut de paiement peut prendre jusqu'\xe0 10\xa0minutes. Si vous effectuez une nouvelle tentative de paiement dans ce d\xe9lai, cela pourrait occasionner plusieurs d\xe9bits.",
            "field.valid": "Champ valide",
            "field.invalid": "Champ non valide",
            "error.va.gen.01": "Champ incomplet",
            "error.va.gen.02": "Champ non valide",
            "error.va.sf-cc-num.01": "Entrez un num\xe9ro de carte valide",
            "error.va.sf-cc-num.02": "Entrez le num\xe9ro de la carte",
            "error.va.sf-cc-num.03": "Entrez un \xe9metteur de carte pris en charge",
            "error.va.sf-cc-num.04": "Entrez le num\xe9ro de carte complet",
            "error.va.sf-cc-dat.01": "Entrez une date d'expiration valide",
            "error.va.sf-cc-dat.02": "Entrez une date d'expiration valide",
            "error.va.sf-cc-dat.03": "La carte de cr\xe9dit arrive \xe0 expiration",
            "error.va.sf-cc-dat.04": "Entrez la date d'expiration",
            "error.va.sf-cc-dat.05": "Entrez la date d'expiration compl\xe8te",
            "error.va.sf-cc-mth.01": "Entrez le mois d'expiration",
            "error.va.sf-cc-yr.01": "Entrez l'ann\xe9e d'expiration",
            "error.va.sf-cc-yr.02": "Entrez l'ann\xe9e d'expiration compl\xe8te",
            "error.va.sf-cc-cvc.01": "Entrez le code de s\xe9curit\xe9",
            "error.va.sf-cc-cvc.02": "Entrez le code de s\xe9curit\xe9 complet",
            "error.va.sf-ach-num.01": "Veuillez renseigner un num\xe9ro de compte bancaire",
            "error.va.sf-ach-num.02": "Longueur du num\xe9ro de compte bancaire incorrecte",
            "error.va.sf-ach-loc.01": "Veuillez renseigner un num\xe9ro de routage",
            "error.va.sf-ach-loc.02": "Longueur du num\xe9ro de routage incorrecte",
            "error.va.sf-kcp-pwd.01": "Veuillez renseigner un mot de passe",
            "error.va.sf-kcp-pwd.02": "Longueur du mot de passe incorrecte",
            "error.giftcard.no-balance": "Aucun solde n'est disponible sur cette carte cadeau",
            "error.giftcard.card-error": "Aucune carte cadeau ne correspond \xe0 ce num\xe9ro",
            "error.giftcard.currency-error": "Les cartes cadeaux sont valables uniquement dans la devise dans laquelle elles ont \xe9t\xe9 \xe9mises",
            "amazonpay.signout": "Se d\xe9connecter d'Amazon",
            "amazonpay.changePaymentDetails": "Modifier les informations de paiement",
            "partialPayment.warning": "S\xe9lectionnez un autre mode de paiement pour r\xe9gler le solde",
            "partialPayment.remainingBalance": "Le solde restant sera de %{amount}",
            "bankTransfer.beneficiary": "B\xe9n\xe9ficiaire",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "R\xe9f\xe9rence",
            "bankTransfer.introduction": "Continuez \xe0 cr\xe9er un nouveau paiement par virement bancaire. Utilisez les informations de l'\xe9cran suivant pour finaliser ce paiement.",
            "bankTransfer.instructions": "Merci pour votre achat\xa0! Veuillez utiliser les informations suivantes pour finaliser votre paiement.",
            "bacs.accountHolderName": "Nom du titulaire du compte bancaire",
            "bacs.accountHolderName.invalid": "Nom du titulaire du compte bancaire incorrect",
            "bacs.accountNumber": "Num\xe9ro du compte bancaire",
            "bacs.accountNumber.invalid": "Num\xe9ro du compte bancaire incorrect",
            "bacs.bankLocationId": "Code de tri (sort code)",
            "bacs.bankLocationId.invalid": "Code de tri (sort code) non valide",
            "bacs.consent.amount": "J'accepte que le montant ci-dessus soit d\xe9duit de mon compte bancaire.",
            "bacs.consent.account": "Je confirme \xeatre le titulaire du compte et qu'aucune autre signature que la mienne n'est requise pour autoriser un pr\xe9l\xe8vement sur ce compte.",
            edit: "Modifier",
            "bacs.confirm": "Confirmer et payer",
            "bacs.result.introduction": "T\xe9l\xe9chargez votre mandat de pr\xe9l\xe8vement (DDI)",
            "download.pdf": "T\xe9l\xe9charger le PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe pour le num\xe9ro de carte",
            "creditCard.encryptedCardNumber.aria.label": "Num\xe9ro de la carte",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe pour la date d'expiration",
            "creditCard.encryptedExpiryDate.aria.label": "Date d'expiration",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe pour le mois d'expiration",
            "creditCard.encryptedExpiryMonth.aria.label": "Mois d'expiration",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe pour l'ann\xe9e d'expiration",
            "creditCard.encryptedExpiryYear.aria.label": "Ann\xe9e d'expiration",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe pour le code de s\xe9curit\xe9",
            "creditCard.encryptedSecurityCode.aria.label": "Code de s\xe9curit\xe9",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe pour le mot de passe",
            "creditCard.encryptedPassword.aria.label": "Les deux premiers chiffres du code de votre carte",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe pour le num\xe9ro de carte",
            "giftcard.encryptedCardNumber.aria.label": "Num\xe9ro de la carte",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe pour le code secret",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Montant maximum autoris\xe9 par transaction avec cette carte cadeau\xa0: %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe pour le num\xe9ro de compte bancaire",
            "ach.encryptedBankAccountNumber.aria.label": "Num\xe9ro du compte",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe pour le num\xe9ro de routage bancaire",
            "ach.encryptedBankLocationId.aria.label": "Code ABA",
            "twint.saved": "stock\xe9",
            orPayWith: "ou payez avec",
            invalidFormatExpects: "Format non valide. Format requis\xa0: %{format}",
            "upi.qrCodeWaitingMessage": "Scannez le code QR \xe0 l'aide de votre application UPI pr\xe9f\xe9r\xe9e pour effectuer le paiement",
            "upi.vpaWaitingMessage": "Ouvrez votre application UPI pour confirmer le paiement",
            "upi.modeSelection": "Choisissez la fa\xe7on dont vous souhaitez utiliser l'application UPI.",
            "onlineBanking.termsAndConditions": "En continuant, vous acceptez les %#conditions g\xe9n\xe9rales%#",
            "onlineBankingPL.termsAndConditions": "En continuant, vous acceptez les %#r\xe9glementations%# et l'%#obligation d'information%# de Przelewy24",
            "ctp.loading.poweredByCtp": "Avec la technologie Click to Pay",
            "ctp.loading.intro": "Nous v\xe9rifions si vous avez des cartes enregistr\xe9es avec Click to Pay...",
            "ctp.login.title": "Acc\xe9der \xe0 Click to Pay",
            "ctp.login.subtitle": "Saisissez l'adresse e-mail de votre profil Click to Pay pour continuer.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "Ce n'est pas votre compte\xa0?",
            "ctp.logout.notYourCards": "Ce ne sont pas vos cartes\xa0?",
            "ctp.logout.notYourCard": "Ce n'est pas votre carte\xa0?",
            "ctp.logout.notYourProfile": "Ce n'est pas votre profil\xa0?",
            "ctp.otp.fieldLabel": "Code \xe0 usage unique",
            "ctp.otp.resendCode": "Renvoyer le code",
            "ctp.otp.codeResent": "Code renvoy\xe9",
            "ctp.otp.title": "Acc\xe9dez \xe0 vos cartes Click to Pay",
            "ctp.otp.subtitle": "Saisissez le code %@ envoy\xe9 \xe0 %@ pour v\xe9rifier votre identit\xe9.",
            "ctp.otp.saveCookiesCheckbox.label": "Ignorer la v\xe9rification la prochaine fois",
            "ctp.otp.saveCookiesCheckbox.information": "S\xe9lectionnez cette option pour m\xe9moriser les informations sur votre appareil et votre navigateur afin d'acc\xe9l\xe9rer le paiement dans les magasins participants. Non recommand\xe9 pour les appareils partag\xe9s.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "S\xe9lectionner cette option pour m\xe9moriser les informations sur votre appareil et votre navigateur",
            "ctp.emptyProfile.message": "Aucune carte enregistr\xe9e dans ce profil Click to Pay",
            "ctp.separatorText": "ou utilisez",
            "ctp.cards.title": "Terminez le paiement avec Click to Pay",
            "ctp.cards.subtitle": "S\xe9lectionnez la carte \xe0 utiliser.",
            "ctp.cards.expiredCard": "Expir\xe9",
            "ctp.manualCardEntry": "Saisie manuelle de la carte",
            "ctp.aria.infoModalButton": "Qu'est-ce que Click to Pay\xa0?",
            "ctp.infoPopup.title": "Click to Pay offre la simplicit\xe9 du sans contact sur Internet",
            "ctp.infoPopup.subtitle": "Un mode de paiement rapide et s\xe9curis\xe9 compatible avec les cartes Mastercard, Visa et autres fournisseurs.",
            "ctp.infoPopup.benefit1": "Click to Pay utilise le chiffrement pour assurer la s\xe9curit\xe9 de vos informations",
            "ctp.infoPopup.benefit2": "Utilisez-le pour vos achats dans le monde entier",
            "ctp.infoPopup.benefit3": "Enregistrez votre carte une fois et simplifiez vos paiements pour toujours",
            "ctp.errors.AUTH_INVALID": "Authentification non valide",
            "ctp.errors.NOT_FOUND": "Aucun compte trouv\xe9, v\xe9rifiez l'adresse e-mail ou saisissez manuellement les informations de votre carte",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Format non pris en charge",
            "ctp.errors.FRAUD": "Le compte utilisateur a \xe9t\xe9 verrouill\xe9 ou d\xe9sactiv\xe9",
            "ctp.errors.CONSUMER_ID_MISSING": "L'identit\xe9 du client n'est pas indiqu\xe9e dans la demande",
            "ctp.errors.ACCT_INACCESSIBLE": "Ce compte n'est pas disponible actuellement car il est verrouill\xe9",
            "ctp.errors.CODE_INVALID": "Code de v\xe9rification incorrect",
            "ctp.errors.CODE_EXPIRED": "Ce code a expir\xe9",
            "ctp.errors.RETRIES_EXCEEDED": "La limite du nombre de tentatives pour la g\xe9n\xe9ration de l'OTP a \xe9t\xe9 d\xe9pass\xe9e",
            "ctp.errors.OTP_SEND_FAILED": "Impossible d'envoyer l'OTP au destinataire",
            "ctp.errors.REQUEST_TIMEOUT": "Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte",
            "ctp.errors.UNKNOWN_ERROR": "Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte",
            "ctp.errors.SERVICE_ERROR": "Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte",
            "ctp.errors.SERVER_ERROR": "Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte",
            "ctp.errors.INVALID_PARAMETER": "Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte",
            "ctp.errors.AUTH_ERROR": "Une erreur s'est produite, r\xe9essayez ou saisissez manuellement les informations de votre carte",
            "paymentMethodsList.aria.label": "Choisissez un mode de paiement",
            "companyDetails.name.invalid": "Entrez le nom de l'entreprise",
            "companyDetails.registrationNumber.invalid": "Entrez le num\xe9ro d'identification",
            "consent.checkbox.invalid": "Vous devez accepter les conditions g\xe9n\xe9rales",
            "form.instruction": "Tous les champs sont obligatoires, sauf indication contraire.",
            "trustly.descriptor": "Paiement bancaire instantan\xe9",
            "trustly.description1": "Payez directement \xe0 partir de n'importe lequel de vos comptes bancaires, avec une s\xe9curit\xe9 de niveau bancaire",
            "trustly.description2": "Aucune carte, aucun t\xe9l\xe9chargement d'application, aucune inscription",
            "ancv.input.label": "Votre identification ANCV",
            "ancv.confirmPayment": "Utilisez votre application ANCV pour confirmer le paiement.",
            "ancv.form.instruction": "L'application Ch\xe8que-Vacances est n\xe9cessaire pour valider ce paiement.",
            "ancv.beneficiaryId.invalid": "Saisissez une adresse e-mail ou un identifiant ANCV valide",
            "payme.openPayMeApp": "Finalisez votre paiement dans l'application PayMe en autorisant le paiement dans l'application, puis attendez la confirmation.",
            "payme.redirectButtonLabel": "Ouvrir l'application PayMe",
            "payme.scanQrCode": "Effectuez votre paiement avec un code\xa0QR",
            "payme.timeToPay": "Ce code QR est valide pendant %@",
            "payme.instructions.steps": "Ouvrez l'application PayMe.%@Scannez le code\xa0QR pour autoriser le paiement.%@Effectuez le paiement dans l'application et attendez la confirmation.",
            "payme.instructions.footnote": "Veuillez ne pas fermer cette page avant que le paiement ne soit termin\xe9."
        }
    }), X1 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Platiti",
            "payButton.redirecting": "Preusmjeravanje...",
            "payButton.with": "Platite iznos od %{value} uporabom stavke %{maskedData}",
            "payButton.saveDetails": "Spremi pojedinosti",
            close: "Zatvori",
            storeDetails: "Pohrani za moje sljede\u0107e pla\u0107anje",
            readMore: "Op\u0161irnije",
            "creditCard.holderName": "Ime na kartici",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "Unesite ime kako je prikazano na kartici",
            "creditCard.numberField.title": "Broj kartice",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Datum isteka",
            "creditCard.expiryDateField.placeholder": "MM/GG",
            "creditCard.expiryDateField.month": "Mjesec",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "GG",
            "creditCard.expiryDateField.year": "Godina",
            "creditCard.cvcField.title": "Sigurnosni k\xf4d",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Zapamtiti za sljede\u0107i put",
            "creditCard.cvcField.placeholder.4digits": "4 znamenke",
            "creditCard.cvcField.placeholder.3digits": "3 znamenke",
            "creditCard.taxNumber.placeholder": "YYMMDD / 0123456789",
            installments: "Broj rata",
            installmentOption: "%{times} x %{partialValue}",
            installmentOptionMonths: "Mjeseci: %{times}",
            "installments.oneTime": "Jednokratno pla\u0107anje",
            "installments.installments": "Pla\u0107anje na rate",
            "installments.revolving": "Obnovljivo pla\u0107anje",
            "sepaDirectDebit.ibanField.invalid": "Neva\u017Ee\u0107i broj ra\u010Duna",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "Ime vlasnika",
            "sepa.ibanNumber": "Broj ra\u010Duna (IBAN)",
            "error.title": "Gre\u0161ka",
            "error.subtitle.redirect": "Preusmjeravanje nije uspjelo",
            "error.subtitle.payment": "Pla\u0107anje nije uspjelo",
            "error.subtitle.refused": "Pla\u0107anje odbijeno",
            "error.message.unknown": "Dogodila se nepoznata gre\u0161ka",
            "errorPanel.title": "Postoje\u0107e gre\u0161ke",
            "idealIssuer.selectField.title": "Banka",
            "idealIssuer.selectField.placeholder": "Odaberite banku",
            "creditCard.success": "Pla\u0107anje uspje\u0161no",
            loading: "U\u010Ditavanje\u2026",
            continue: "Nastavi",
            continueTo: "Nastavi na",
            "wechatpay.timetopay": "Imate %@ za pla\u0107anje",
            "sr.wechatpay.timetopay": "Imate %#minuta%# i %#sekundi%# za pla\u0107anje",
            "wechatpay.scanqrcode": "Skeniraj QR k\xf4d",
            personalDetails: "Osobni podatci",
            companyDetails: "Detalji tvrtke",
            "companyDetails.name": "Naziv tvrtke",
            "companyDetails.registrationNumber": "Mati\u010Dni broj",
            socialSecurityNumber: "Broj socijalnog osiguranja",
            firstName: "Ime",
            "firstName.invalid": "Unesite svoje ime",
            infix: "Prefiks",
            lastName: "Prezime",
            "lastName.invalid": "Unesite svoje prezime",
            mobileNumber: "Broj mobilnog telefona",
            "mobileNumber.invalid": "Neva\u017Ee\u0107i broj mobilnog telefona",
            city: "Grad",
            postalCode: "Po\u0161tanski broj",
            "postalCode.optional": "Po\u0161tanski broj (nije obvezno)",
            countryCode: "Pozivni broj dr\u017Eave",
            telephoneNumber: "Telefonski broj",
            dateOfBirth: "Datum ro\u0111enja",
            shopperEmail: "Adresa e-po\u0161te",
            gender: "Spol",
            "gender.notselected": "Odaberite svoj spol",
            male: "Mu\u0161karac",
            female: "\u017Dena",
            billingAddress: "Adresa za ra\u010Dun",
            street: "Ulica",
            stateOrProvince: "Dr\u017Eava ili pokrajina",
            country: "Zemlja",
            houseNumberOrName: "Ku\u0107ni broj",
            separateDeliveryAddress: "Navedite zasebnu adresu za dostavu",
            deliveryAddress: "Adresa za dostavu",
            "deliveryAddress.firstName": "Ime primatelja",
            "deliveryAddress.lastName": "Prezime primatelja",
            zipCode: "Po\u0161tanski broj",
            apartmentSuite: "Stan/apartman",
            provinceOrTerritory: "Pokrajina ili teritorij",
            cityTown: "Grad",
            address: "Adresa",
            "address.placeholder": "Prona\u0111ite adresu",
            "address.errors.incomplete": "Unesite adresu za nastavak",
            "address.enterManually": "Ru\u010Dno unesite adresu",
            state: "Savezna dr\u017Eava",
            "field.title.optional": "(neobavezno)",
            "creditCard.cvcField.title.optional": "Sigurnosni k\xf4d (neobvezno)",
            "issuerList.wallet.placeholder": "Odaberite svoju nov\u010Danik",
            privacyPolicy: "Politika privatnosti",
            "afterPay.agreement": "Sla\u017Eem se s %@ Rivertyja",
            paymentConditions: "uvjetima pla\u0107anja",
            openApp: "Otvorite aplikaciju",
            "voucher.readInstructions": "Pro\u010Ditajte upute",
            "voucher.introduction": "Zahvaljujemo na kupnji, upotrijebite sljede\u0107i kupon za dovr\u0161etak pla\u0107anja.",
            "voucher.expirationDate": "Datum isteka",
            "voucher.alternativeReference": "Alternativna referenca",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Odaberite davatelja usluge",
            "dragonpay.voucher.bank.selectField.placeholder": "Odaberite banku",
            "voucher.paymentReferenceLabel": "Referenca za pla\u0107anje",
            "voucher.surcharge": "Uklju\u010Duje %@ nadoplate",
            "voucher.introduction.doku": "Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.",
            "voucher.shopperName": "Ime kupca",
            "voucher.merchantName": "Trgovac",
            "voucher.introduction.econtext": "Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.",
            "voucher.telephoneNumber": "Broj telefona",
            "voucher.shopperReference": "Referenca kupca",
            "voucher.collectionInstitutionNumber": "Broj ustanove za prikupljanje",
            "voucher.econtext.telephoneNumber.invalid": "Telefonski broj mora imati 10 ili 11 znamenki",
            "boletobancario.btnLabel": "Generiraj Boleto",
            "boleto.sendCopyToEmail": "Po\u0161alji kopiju na moju e-po\u0161tu",
            "button.copy": "Kopiraj",
            "button.download": "Preuzmi",
            "boleto.socialSecurityNumber.invalid": "Polje je neva\u017Ee\u0107e",
            "creditCard.storedCard.description.ariaLabel": "Pohranjena kartica zavr\u0161ava na %@",
            "voucher.entity": "Entitet",
            donateButton: "Doniraj",
            notNowButton: "Ne sada",
            thanksForYourSupport: "Hvala na podr\u0161ci!",
            "resultMessages.preauthorized": "Spremljeni podatci",
            preauthorizeWith: "Prethodno odobri s",
            confirmPreauthorization: "Potvrdite prethodno odobrenje",
            confirmPurchase: "Potvrdite kupnju",
            applyGiftcard: "Iskoristite",
            giftcardBalance: "Stanje na poklon-kartici",
            deductedBalance: "Potro\u0161eni iznos",
            "creditCard.pin.title": "Pin",
            "creditCard.encryptedPassword.label": "Prve 2 znamenke lozinke kartice",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Lozinka je neto\u010Dna",
            "creditCard.taxNumber": "Datum ro\u0111enja vlasnika kartice ili registracijski broj tvrtke",
            "creditCard.taxNumber.label": "Datum ro\u0111enja vlasnika kartice (GGMMDD) ili registracijski broj tvrtke (10 znamenki)",
            "creditCard.taxNumber.labelAlt": "Registracijski broj tvrtke (10 znamenki)",
            "creditCard.taxNumber.invalid": "Neto\u010Dan datum ro\u0111enja vlasnika kartice (GGMMDD) ili registracijski broj tvrtke (10 znamenki)",
            "storedPaymentMethod.disable.button": "Ukloni",
            "storedPaymentMethod.disable.confirmation": "Uklonite pohranjeni na\u010Din pla\u0107anja",
            "storedPaymentMethod.disable.confirmButton": "Da, ukloni",
            "storedPaymentMethod.disable.cancelButton": "Otka\u017Ei",
            "ach.bankAccount": "Bankovni ra\u010Dun",
            "ach.accountHolderNameField.title": "Ime vlasnika ra\u010Duna",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Neva\u017Ee\u0107e ime vlasnika ra\u010Duna",
            "ach.accountNumberField.title": "Broj ra\u010Duna",
            "ach.accountNumberField.invalid": "Neva\u017Ee\u0107i broj ra\u010Duna",
            "ach.accountLocationField.title": "ABA identifikacijski broj",
            "ach.accountLocationField.invalid": "Neva\u017Ee\u0107i ABA identifikacijski broj",
            "ach.savedBankAccount": "Spremljeni bankovni ra\u010Dun",
            "select.state": "Odaberite saveznu dr\u017Eavu",
            "select.stateOrProvince": "Odaberite dr\u017Eavu ili provinciju",
            "select.provinceOrTerritory": "Odaberite provinciju ili teritorij",
            "select.country": "Odaberite dr\u017Eavu",
            "select.noOptionsFound": "Nije prona\u0111ena nijedna opcija",
            "select.filter.placeholder": "Tra\u017Ei...",
            "telephoneNumber.invalid": "Neva\u017Ee\u0107i telefonski broj",
            qrCodeOrApp: "ili",
            "paypal.processingPayment": "Obrada pla\u0107anja u tijeku...",
            generateQRCode: "Generirajte QR k\xf4d",
            "await.waitForConfirmation": "\u010Ceka se potvrda",
            "mbway.confirmPayment": "Potvrdite uplatu u aplikaciji MB WAY",
            "shopperEmail.invalid": "Neva\u017Ee\u0107a adresa e-po\u0161te",
            "dateOfBirth.format": "DD/MM/GGGG",
            "dateOfBirth.invalid": "Unesite va\u017Ee\u0107i datum ro\u0111enja koji pokazuje da imate najmanje 18 godina",
            "blik.confirmPayment": "Otvorite svoju bankovnu aplikaciju kako biste potvrdili pla\u0107anje.",
            "blik.invalid": "Unesite 6 znamenki",
            "blik.code": "6-znamenkasti k\xf4d",
            "blik.help": "Preuzmite k\xf4d iz bankovne aplikacije.",
            "swish.pendingMessage": "Nakon skeniranja status mo\u017Ee biti na \u010Dekanju do 10 minuta. Poku\u0161aj ponovnog pla\u0107anja u istom periodu mo\u017Ee rezultirati vi\u0161estrukim naplatama.",
            "field.valid": "Valjano polje",
            "field.invalid": "Neva\u017Ee\u0107e polje",
            "error.va.gen.01": "Nepotpuno polje",
            "error.va.gen.02": "Neva\u017Ee\u0107e polje",
            "error.va.sf-cc-num.01": "Unesite valjani broj kartice",
            "error.va.sf-cc-num.02": "Unesite broj kartice",
            "error.va.sf-cc-num.03": "Unesite podr\u017Eanu marku kartice",
            "error.va.sf-cc-num.04": "Unesite potpuni broj kartice",
            "error.va.sf-cc-dat.01": "Unesite valjani datum isteka",
            "error.va.sf-cc-dat.02": "Unesite valjani datum isteka",
            "error.va.sf-cc-dat.03": "Kreditna kartica uskoro istje\u010De",
            "error.va.sf-cc-dat.04": "Unesite datum isteka",
            "error.va.sf-cc-dat.05": "Unesite potpuni datum isteka",
            "error.va.sf-cc-mth.01": "Unesite mjesec isteka",
            "error.va.sf-cc-yr.01": "Unesite godinu isteka",
            "error.va.sf-cc-yr.02": "Unesite potpunu godinu isteka",
            "error.va.sf-cc-cvc.01": "Unesite sigurnosni k\xf4d",
            "error.va.sf-cc-cvc.02": "Unesite potpuni sigurnosni k\xf4d",
            "error.va.sf-ach-num.01": "Polje za broj bankovnog ra\u010Duna je prazno",
            "error.va.sf-ach-num.02": "Broj je bankovnog ra\u010Duna pogre\u0161ne duljine",
            "error.va.sf-ach-loc.01": "Polje je broja usmjeravanja prazno",
            "error.va.sf-ach-loc.02": "Broj je usmjeravanja pogre\u0161ne duljine",
            "error.va.sf-kcp-pwd.01": "Polje je lozinke prazno",
            "error.va.sf-kcp-pwd.02": "Lozinka je pogre\u0161ne duljine",
            "error.giftcard.no-balance": "Stanje na ovoj poklon-kartici iznosi nula",
            "error.giftcard.card-error": "U na\u0161oj evidenciji nemamo poklon-karticu s ovim brojem",
            "error.giftcard.currency-error": "Poklon-kartice vrijede samo u valuti u kojoj su izdane",
            "amazonpay.signout": "Odjava iz Amazona",
            "amazonpay.changePaymentDetails": "Promijenite pojedinosti o pla\u0107anju",
            "partialPayment.warning": "Odaberite drugi na\u010Din pla\u0107anja da biste platili preostali iznos",
            "partialPayment.remainingBalance": "Preostalo stanje na ra\u010Dunu iznosit \u0107e %{amount}",
            "bankTransfer.beneficiary": "Primatelj",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Referenca",
            "bankTransfer.introduction": "Nastavite da biste kreirali novu uplatu putem bankovne transakcije. Za finaliziranje ovog pla\u0107anja mo\u017Eete se koristiti pojedinostima na sljede\u0107em zaslonu.",
            "bankTransfer.instructions": "Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.",
            "bacs.accountHolderName": "Ime vlasnika bankovnog ra\u010Duna",
            "bacs.accountHolderName.invalid": "Neva\u017Ee\u0107e ime vlasnika bankovnog ra\u010Duna",
            "bacs.accountNumber": "Broj bankovnog ra\u010Duna",
            "bacs.accountNumber.invalid": "Neva\u017Ee\u0107i broj bankovnog ra\u010Duna",
            "bacs.bankLocationId": "Identifikacijski k\xf4d banke (UK)",
            "bacs.bankLocationId.invalid": "Neva\u017Ee\u0107i identifikacijski k\xf4d banke (UK)",
            "bacs.consent.amount": "Sla\u017Eem se da se gore navedeni iznos oduzme s mog bankovnog ra\u010Duna.",
            "bacs.consent.account": "Potvr\u0111ujem da je ra\u010Dun na moje ime i da sam jedini potpisnik potreban za autorizaciju izravnog tere\u0107enja na ovom ra\u010Dunu.",
            edit: "Uredi",
            "bacs.confirm": "Potvrdi i plati",
            "bacs.result.introduction": "Preuzmite upute za izravno tere\u0107enje (DDI / mandat)",
            "download.pdf": "Preuzmite PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe za broj kartice",
            "creditCard.encryptedCardNumber.aria.label": "Broj kartice",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe za datum isteka",
            "creditCard.encryptedExpiryDate.aria.label": "Datum isteka",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe za mjesec isteka",
            "creditCard.encryptedExpiryMonth.aria.label": "Mjesec isteka",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe za godinu isteka",
            "creditCard.encryptedExpiryYear.aria.label": "Godina isteka",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe za sigurnosni k\xf4d",
            "creditCard.encryptedSecurityCode.aria.label": "Sigurnosni k\xf4d",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe za lozinku",
            "creditCard.encryptedPassword.aria.label": "Prve 2 znamenke lozinke kartice",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe za broj kartice",
            "giftcard.encryptedCardNumber.aria.label": "Broj kartice",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe za pin",
            "giftcard.encryptedSecurityCode.aria.label": "Pin",
            giftcardTransactionLimit: "Na ovoj je poklon-kartici maks. dopu\u0161teno %{amount} po transakciji",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe za broj bankovnog ra\u010Duna",
            "ach.encryptedBankAccountNumber.aria.label": "Broj ra\u010Duna",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe za bankovni broj usmjeravanja",
            "ach.encryptedBankLocationId.aria.label": "ABA identifikacijski broj",
            "twint.saved": "spremljeno",
            orPayWith: "ili platite s",
            invalidFormatExpects: "Neva\u017Ee\u0107i format. O\u010Dekivani format: %{format}",
            "upi.qrCodeWaitingMessage": "Skenirajte QR k\xf4d pomo\u0107u \u017Eeljene UPI aplikacije kako biste dovr\u0161ili pla\u0107anje",
            "upi.vpaWaitingMessage": "Otvorite svoju UPI aplikaciju kako biste potvrdili pla\u0107anje",
            "upi.modeSelection": "Odaberite kako \u017Eelite koristiti UPI.",
            "onlineBanking.termsAndConditions": "Nastavkom prihva\u0107ate %#uvjete i odredbe%#",
            "onlineBankingPL.termsAndConditions": "Nastavljanjem prihva\u0107ate %#propise%# i %#obvezu informiranja%# tvrtke Przelewy24",
            "ctp.loading.poweredByCtp": "Pokre\u0107e se uslugom Click to Pay",
            "ctp.loading.intro": "Provjeravamo imate li spremljenih kartica u sklopu usluge Click to Pay...",
            "ctp.login.title": "Nastavite na uslugu Click to Pay",
            "ctp.login.subtitle": "Za nastavak upi\u0161ite adresu e-po\u0161te koja je povezana s uslugom Click to Pay.",
            "ctp.login.inputLabel": "E-po\u0161ta",
            "ctp.logout.notYou": "Niste vi?",
            "ctp.logout.notYourCards": "Nisu va\u0161e kartice?",
            "ctp.logout.notYourCard": "Nije va\u0161a kartica?",
            "ctp.logout.notYourProfile": "Nije va\u0161 profil?",
            "ctp.otp.fieldLabel": "Jednokratni k\xf4d",
            "ctp.otp.resendCode": "Ponovno po\u0161alji k\xf4d",
            "ctp.otp.codeResent": "K\xf4d je ponovno poslan",
            "ctp.otp.title": "Pristupite svojim karticama za uslugu Click to Pay",
            "ctp.otp.subtitle": "Upi\u0161ite k\xf4d %@ koji smo poslali na %@ da bismo potvrdili da ste to vi.",
            "ctp.otp.saveCookiesCheckbox.label": "Sljede\u0107i puta presko\u010Di provjeru",
            "ctp.otp.saveCookiesCheckbox.information": "Odaberite kako biste bili zapam\u0107eni na svom ure\u0111aju i pregledniku u uklju\u010Denim trgovinama za br\u017Eu naplatu. Ne preporu\u010Duje se za zajedni\u010Dke ure\u0111aje.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Odaberite ako \u017Eelite da vas se zapamti na va\u0161em ure\u0111aju i pregledniku",
            "ctp.emptyProfile.message": "Nema kartica registriranih u sklopu ovog profila usluge Click to Pay",
            "ctp.separatorText": "ili upotrijebite",
            "ctp.cards.title": "Dovr\u0161i pla\u0107anje uslugom Click to Pay",
            "ctp.cards.subtitle": "Odaberite karticu za upotrebu.",
            "ctp.cards.expiredCard": "Istekla",
            "ctp.manualCardEntry": "Ru\u010Dni upis kartice",
            "ctp.aria.infoModalButton": "\u0160to je usluga Click to Pay",
            "ctp.infoPopup.title": "Uslugom Click to Pay nudi se jednostavnost mre\u017Enog beskontaktnog pla\u0107anja",
            "ctp.infoPopup.subtitle": "Brza i sigurna metoda pla\u0107anja koja se podr\u017Eava platnim karticama Mastercard, Visa i drugim.",
            "ctp.infoPopup.benefit1": "Uslugom Click to Pay upotrebljava se \u0161ifriranje da bi va\u0161i podatci bili sigurni i za\u0161ti\u0107eni",
            "ctp.infoPopup.benefit2": "Upotrebljavajte je za trgovce diljem svijeta",
            "ctp.infoPopup.benefit3": "Postavljanje obavite samo jednom za nesmetana pla\u0107anja u budu\u0107nosti",
            "ctp.errors.AUTH_INVALID": "Neva\u017Ee\u0107a provjera autenti\u010Dnosti",
            "ctp.errors.NOT_FOUND": "Ra\u010Dun nije prona\u0111en, upi\u0161ite valjanu adresu e-po\u0161te ili nastavite s ru\u010Dnim upisom kartice",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Nepodr\u017Ean format",
            "ctp.errors.FRAUD": "Korisni\u010Dki je ra\u010Dun zaklju\u010Dan ili onemogu\u0107en",
            "ctp.errors.CONSUMER_ID_MISSING": "Identitet potro\u0161a\u010Da nedostaje u zahtjevu",
            "ctp.errors.ACCT_INACCESSIBLE": "Ovaj ra\u010Dun trenuta\u010Dno nije dostupan, npr. zaklju\u010Dan je",
            "ctp.errors.CODE_INVALID": "Neispravan kontrolni k\xf4d",
            "ctp.errors.CODE_EXPIRED": "Ovaj je k\xf4d istekao",
            "ctp.errors.RETRIES_EXCEEDED": "Prekora\u010Deno je ograni\u010Denje broja ponovnih poku\u0161aja za stvaranje jednokratne lozinke",
            "ctp.errors.OTP_SEND_FAILED": "Jednokratna se lozinka nije mogla poslati primatelju",
            "ctp.errors.REQUEST_TIMEOUT": "Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010Dni upis kartice",
            "ctp.errors.UNKNOWN_ERROR": "Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010Dni upis kartice",
            "ctp.errors.SERVICE_ERROR": "Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010Dni upis kartice",
            "ctp.errors.SERVER_ERROR": "Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010Dni upis kartice",
            "ctp.errors.INVALID_PARAMETER": "Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010Dni upis kartice",
            "ctp.errors.AUTH_ERROR": "Ne\u0161to nije u redu, poku\u0161ajte ponovno ili upotrijebite ru\u010Dni upis kartice",
            "paymentMethodsList.aria.label": "Odaberi na\u010Din pla\u0107anja",
            "companyDetails.name.invalid": "Unesite naziv tvrtke",
            "companyDetails.registrationNumber.invalid": "Unesite registracijski broj",
            "consent.checkbox.invalid": "Morate se slo\u017Eiti s odredbama i uvjetima",
            "form.instruction": "Sva su polja obavezna, osim ako nije druga\u010Dije ozna\u010Deno.",
            "trustly.descriptor": "Trenuta\u010Dno bankovno pla\u0107anje",
            "trustly.description1": "Pla\u0107ajte izravno s bilo kojeg od svojih bankovnih ra\u010Duna, uz sigurnost na razini banke",
            "trustly.description2": "Bez kartica, bez preuzimanja aplikacija, bez registracije",
            "ancv.input.label": "Va\u0161a ANCV identifikacija",
            "ancv.confirmPayment": "Koristite svoju ANCV aplikaciju za potvrdu pla\u0107anja.",
            "ancv.form.instruction": "Za potvrdu ove uplate neophodna je aplikacija Cheque-Vacances.",
            "ancv.beneficiaryId.invalid": "Unesite valjanu adresu e-po\u0161te ili ANCV ID",
            "payme.openPayMeApp": "Dovr\u0161ite pla\u0107anje u aplikaciji PayMe: autorizirajte pla\u0107anje u aplikaciji i pri\u010Dekajte potvrdu.",
            "payme.redirectButtonLabel": "Otvaranje aplikacije PayMe",
            "payme.scanQrCode": "Dovr\u0161ite svoje pla\u0107anja QR kodom",
            "payme.timeToPay": "Ovaj QR k\xf4d vrijedi za %@",
            "payme.instructions.steps": "Otvorite aplikaciju PayMe.%@Skenirajte QR kod za autorizaciju pla\u0107anja.%@Dovr\u0161ite pla\u0107anje u aplikaciji i pri\u010Dekajte potvrdu.",
            "payme.instructions.footnote": "Ne zatvarajte ovu stranicu prije nego \u0161to se pla\u0107anje zavr\u0161i"
        }
    }), e2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Fizet\xe9s",
            "payButton.redirecting": "\xc1tir\xe1ny\xedt\xe1s...",
            "payButton.with": "%{value} fizet\xe9se a k\xf6vetkez\u0151vel: %{maskedData}",
            "payButton.saveDetails": "R\xe9szletek ment\xe9se",
            close: "Bez\xe1r\xe1s",
            storeDetails: "Ment\xe9s a k\xf6vetkez\u0151 fizet\xe9shez",
            readMore: "B\u0151vebben",
            "creditCard.holderName": "A k\xe1rty\xe1n szerepl\u0151 n\xe9v",
            "creditCard.holderName.placeholder": "Gipsz Jakab",
            "creditCard.holderName.invalid": "Adja meg a k\xe1rty\xe1n szerepl\u0151 nevet",
            "creditCard.numberField.title": "K\xe1rtyasz\xe1m",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Lej\xe1rati d\xe1tum",
            "creditCard.expiryDateField.placeholder": "HH/\xc9\xc9",
            "creditCard.expiryDateField.month": "H\xf3nap",
            "creditCard.expiryDateField.month.placeholder": "HH",
            "creditCard.expiryDateField.year.placeholder": "\xc9\xc9",
            "creditCard.expiryDateField.year": "\xc9v",
            "creditCard.cvcField.title": "Biztons\xe1gi k\xf3d",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Megjegyz\xe9s a k\xf6vetkez\u0151 alkalomra",
            "creditCard.cvcField.placeholder.4digits": "4 sz\xe1mjegy\u0171",
            "creditCard.cvcField.placeholder.3digits": "3 sz\xe1mjegy\u0171",
            "creditCard.taxNumber.placeholder": "\xc9\xc9HHNN / 0123456789",
            installments: "R\xe9szletek sz\xe1ma",
            installmentOption: "%{times} x %{partialValue}",
            installmentOptionMonths: "%{times} h\xf3nap",
            "installments.oneTime": "Egy\xf6sszeg\u0171 fizet\xe9s",
            "installments.installments": "R\xe9szletfizet\xe9s",
            "installments.revolving": "T\xf6bb\xf6sszeg\u0171 fizet\xe9s",
            "sepaDirectDebit.ibanField.invalid": "\xc9rv\xe9nytelen sz\xe1mlasz\xe1m",
            "sepaDirectDebit.nameField.placeholder": "Gipsz Jakab",
            "sepa.ownerName": "Sz\xe1mlatulajdonos neve",
            "sepa.ibanNumber": "Sz\xe1mlasz\xe1m (IBAN)",
            "error.title": "Hiba",
            "error.subtitle.redirect": "Sikertelen \xe1tir\xe1ny\xedt\xe1s",
            "error.subtitle.payment": "Sikertelen fizet\xe9s",
            "error.subtitle.refused": "A fizet\xe9s elutas\xedtva",
            "error.message.unknown": "Ismeretlen hiba t\xf6rt\xe9nt",
            "errorPanel.title": "Megl\xe9v\u0151 hib\xe1k",
            "idealIssuer.selectField.title": "Bank",
            "idealIssuer.selectField.placeholder": "Bank kiv\xe1laszt\xe1sa",
            "creditCard.success": "Sikeres fizet\xe9s",
            loading: "Bet\xf6lt\xe9s\u2026",
            continue: "Folytat\xe1s",
            continueTo: "Folytat\xe1s a k\xf6vetkez\u0151vel:",
            "wechatpay.timetopay": "Fizet\xe9shez rendelkez\xe9sre \xe1ll\xf3 id\u0151: %@",
            "sr.wechatpay.timetopay": "Fizet\xe9sre rendelkez\xe9sre \xe1ll\xf3 id\u0151: %#perc%# %#m\xe1sodperc%#",
            "wechatpay.scanqrcode": "QR-k\xf3d beolvas\xe1sa",
            personalDetails: "Szem\xe9lyes adatok",
            companyDetails: "C\xe9g adatai",
            "companyDetails.name": "C\xe9gn\xe9v",
            "companyDetails.registrationNumber": "C\xe9gjegyz\xe9ksz\xe1m",
            socialSecurityNumber: "Szem\xe9lyi igazolv\xe1ny sz\xe1ma",
            firstName: "Keresztn\xe9v",
            "firstName.invalid": "Adja meg a keresztnev\xe9t",
            infix: "El\u0151tag",
            lastName: "Vezet\xe9kn\xe9v",
            "lastName.invalid": "Adja meg a vezet\xe9knev\xe9t",
            mobileNumber: "Mobiltelefonsz\xe1m",
            "mobileNumber.invalid": "\xc9rv\xe9nytelen mobilsz\xe1m",
            city: "V\xe1ros",
            postalCode: "Ir\xe1ny\xedt\xf3sz\xe1m",
            "postalCode.optional": "Ir\xe1ny\xedt\xf3sz\xe1m (nem k\xf6telez\u0151)",
            countryCode: "Orsz\xe1gk\xf3d",
            telephoneNumber: "Telefonsz\xe1m",
            dateOfBirth: "Sz\xfclet\xe9si d\xe1tum",
            shopperEmail: "E-mail-c\xedm",
            gender: "Nem",
            "gender.notselected": "V\xe1lassza ki a nem\xe9t",
            male: "F\xe9rfi",
            female: "N\u0151",
            billingAddress: "Sz\xe1ml\xe1z\xe1si c\xedm",
            street: "Utca",
            stateOrProvince: "\xc1llam vagy tartom\xe1ny",
            country: "Orsz\xe1g",
            houseNumberOrName: "H\xe1zsz\xe1m",
            separateDeliveryAddress: "Elt\xe9r\u0151 sz\xe1ll\xedt\xe1si c\xedm megad\xe1sa",
            deliveryAddress: "Sz\xe1ll\xedt\xe1si c\xedm",
            "deliveryAddress.firstName": "C\xedmzett keresztneve",
            "deliveryAddress.lastName": "C\xedmzett vezet\xe9kneve",
            zipCode: "Ir\xe1ny\xedt\xf3sz\xe1m",
            apartmentSuite: "Lak\xe1s/ajt\xf3sz\xe1m",
            provinceOrTerritory: "Tartom\xe1ny vagy ter\xfclet",
            cityTown: "V\xe1ros",
            address: "C\xedm",
            "address.placeholder": "Keresse meg a c\xedm\xe9t",
            "address.errors.incomplete": "A folytat\xe1shoz \xedrjon be egy c\xedmet",
            "address.enterManually": "Manu\xe1lisan \xedrjon be egy c\xedmet",
            state: "\xc1llam",
            "field.title.optional": "(nem k\xf6telez\u0151)",
            "creditCard.cvcField.title.optional": "Biztons\xe1gi k\xf3d (nem k\xf6telez\u0151)",
            "issuerList.wallet.placeholder": "P\xe9nzt\xe1rca kiv\xe1laszt\xe1sa",
            privacyPolicy: "Adatv\xe9delmi szab\xe1lyzat",
            "afterPay.agreement": "Elfogadom a k\xf6vetkez\u0151t: Riverty %@",
            paymentConditions: "fizet\xe9si felt\xe9teleit",
            openApp: "Alkalmaz\xe1s megnyit\xe1sa",
            "voucher.readInstructions": "Olvassa el az utas\xedt\xe1sokat",
            "voucher.introduction": "K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 kupont.",
            "voucher.expirationDate": "Lej\xe1rati d\xe1tum",
            "voucher.alternativeReference": "Alternat\xedv hivatkoz\xe1s",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Szolg\xe1ltat\xf3 kiv\xe1laszt\xe1sa",
            "dragonpay.voucher.bank.selectField.placeholder": "Bank kiv\xe1laszt\xe1sa",
            "voucher.paymentReferenceLabel": "Fizet\xe9si referencia",
            "voucher.surcharge": "%@ p\xf3td\xedjat tartalmaz",
            "voucher.introduction.doku": "K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.",
            "voucher.shopperName": "V\xe1s\xe1rl\xf3 neve",
            "voucher.merchantName": "Keresked\u0151",
            "voucher.introduction.econtext": "K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.",
            "voucher.telephoneNumber": "Telefonsz\xe1m",
            "voucher.shopperReference": "V\xe1s\xe1rl\xf3i referencia",
            "voucher.collectionInstitutionNumber": "Beszed\u0151 c\xe9g sz\xe1ma",
            "voucher.econtext.telephoneNumber.invalid": "A telefonsz\xe1mnak 10 vagy 11 sz\xe1mjegyb\u0151l kell \xe1llnia",
            "boletobancario.btnLabel": "Boleto l\xe9trehoz\xe1sa",
            "boleto.sendCopyToEmail": "M\xe1solat k\xfcld\xe9se az e-mail-c\xedmemre",
            "button.copy": "M\xe1sol\xe1s",
            "button.download": "Let\xf6lt\xe9s",
            "boleto.socialSecurityNumber.invalid": "\xc9rv\xe9nytelen mez\u0151",
            "creditCard.storedCard.description.ariaLabel": "A t\xe1rolt k\xe1rtya sz\xe1m\xe1nak v\xe9gz\u0151d\xe9se: %@",
            "voucher.entity": "Entit\xe1s",
            donateButton: "Adom\xe1nyoz\xe1s",
            notNowButton: "Most nem",
            thanksForYourSupport: "K\xf6sz\xf6nj\xfck a t\xe1mogat\xe1s\xe1t!",
            "resultMessages.preauthorized": "R\xe9szletek mentve",
            preauthorizeWith: "El\u0151zetes meghatalmaz\xe1s a k\xf6vetkez\u0151vel:",
            confirmPreauthorization: "El\u0151zetes meghatalmaz\xe1s j\xf3v\xe1hagy\xe1sa",
            confirmPurchase: "Fizet\xe9s j\xf3v\xe1hagy\xe1sa",
            applyGiftcard: "Bev\xe1lt\xe1s",
            giftcardBalance: "Aj\xe1nd\xe9kk\xe1rtya egyenlege",
            deductedBalance: "Levont egyenleg",
            "creditCard.pin.title": "PIN-k\xf3d",
            "creditCard.encryptedPassword.label": "K\xe1rtya jelszav\xe1nak els\u0151 2 sz\xe1mjegye",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "\xc9rv\xe9nytelen jelsz\xf3",
            "creditCard.taxNumber": "K\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma vagy c\xe9gjegyz\xe9ksz\xe1m",
            "creditCard.taxNumber.label": "K\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma (\xc9\xc9HHNN) vagy c\xe9gjegyz\xe9ksz\xe1m (10 sz\xe1mjegy\u0171)",
            "creditCard.taxNumber.labelAlt": "C\xe9gjegyz\xe9ksz\xe1m (10 sz\xe1mjegy\u0171)",
            "creditCard.taxNumber.invalid": "A k\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma vagy a c\xe9gjegyz\xe9ksz\xe1m \xe9rv\xe9nytelen",
            "storedPaymentMethod.disable.button": "Elt\xe1vol\xedt\xe1s",
            "storedPaymentMethod.disable.confirmation": "T\xe1rolt fizet\xe9si m\xf3d elt\xe1vol\xedt\xe1sa",
            "storedPaymentMethod.disable.confirmButton": "Igen, elt\xe1vol\xedtom",
            "storedPaymentMethod.disable.cancelButton": "M\xe9gse",
            "ach.bankAccount": "Banksz\xe1mla",
            "ach.accountHolderNameField.title": "Sz\xe1mlatulajdonos neve",
            "ach.accountHolderNameField.placeholder": "Gipsz Jakab",
            "ach.accountHolderNameField.invalid": "A sz\xe1mlatulajdonos neve \xe9rv\xe9nytelen",
            "ach.accountNumberField.title": "Sz\xe1mlasz\xe1m",
            "ach.accountNumberField.invalid": "\xc9rv\xe9nytelen sz\xe1mlasz\xe1m",
            "ach.accountLocationField.title": "ABA-ir\xe1ny\xedt\xf3sz\xe1m",
            "ach.accountLocationField.invalid": "\xc9rv\xe9nytelen ABA-ir\xe1ny\xedt\xf3sz\xe1m",
            "ach.savedBankAccount": "Mentett banksz\xe1mla",
            "select.state": "\xc1llam kiv\xe1laszt\xe1sa",
            "select.stateOrProvince": "\xc1llam vagy tartom\xe1ny kiv\xe1laszt\xe1sa",
            "select.provinceOrTerritory": "Tartom\xe1ny vagy ter\xfclet kiv\xe1laszt\xe1sa",
            "select.country": "Orsz\xe1g kiv\xe1laszt\xe1sa",
            "select.noOptionsFound": "Nincsenek tal\xe1latok",
            "select.filter.placeholder": "Keres\xe9s...",
            "telephoneNumber.invalid": "\xc9rv\xe9nytelen telefonsz\xe1m",
            qrCodeOrApp: "vagy",
            "paypal.processingPayment": "Fizet\xe9s feldolgoz\xe1sa\u2026",
            generateQRCode: "QR-k\xf3d l\xe9trehoz\xe1sa",
            "await.waitForConfirmation": "V\xe1rakoz\xe1s a j\xf3v\xe1hagy\xe1sra",
            "mbway.confirmPayment": "Fizet\xe9s j\xf3v\xe1hagy\xe1sa az MB WAY alkalmaz\xe1sban",
            "shopperEmail.invalid": "\xc9rv\xe9nytelen e-mail-c\xedm",
            "dateOfBirth.format": "NN/HH/\xc9\xc9\xc9\xc9",
            "dateOfBirth.invalid": "Adjon meg egy \xe9rv\xe9nyes sz\xfclet\xe9si d\xe1tumot, amelyb\u0151l kider\xfcl, hogy elm\xfalt 18 \xe9ves",
            "blik.confirmPayment": "A fizet\xe9s j\xf3v\xe1hagy\xe1s\xe1hoz nyissa meg a banki alkalmaz\xe1st.",
            "blik.invalid": "Adjon meg 6 sz\xe1mjegyet",
            "blik.code": "6 sz\xe1mjegy\u0171 k\xf3d",
            "blik.help": "K\xf3d lek\xe9r\xe9se a banki alkalmaz\xe1sb\xf3l.",
            "swish.pendingMessage": "A QR-k\xf3d beolvas\xe1s\xe1t k\xf6vet\u0151en az \xe1llapot ak\xe1r 10 percig is f\xfcgg\u0151ben lehet. Ha ek\xf6zben \xfajb\xf3l fizet\xe9st k\xeds\xe9rel meg, az t\xf6bbsz\xf6ri fizet\xe9st eredm\xe9nyezhet.",
            "field.valid": "\xc9rv\xe9nyes mez\u0151",
            "field.invalid": "\xc9rv\xe9nytelen mez\u0151",
            "error.va.gen.01": "Hi\xe1nyos mez\u0151",
            "error.va.gen.02": "\xc9rv\xe9nytelen mez\u0151",
            "error.va.sf-cc-num.01": "Adjon meg egy \xe9rv\xe9nyes k\xe1rtyasz\xe1mot",
            "error.va.sf-cc-num.02": "Adja meg a k\xe1rtya sz\xe1m\xe1t",
            "error.va.sf-cc-num.03": "Adjon meg egy elfogadott k\xe1rtyakibocs\xe1t\xf3t",
            "error.va.sf-cc-num.04": "Adja meg a teljes k\xe1rtyasz\xe1mot",
            "error.va.sf-cc-dat.01": "Adjon meg egy \xe9rv\xe9nyes lej\xe1rati d\xe1tumot",
            "error.va.sf-cc-dat.02": "Adjon meg egy \xe9rv\xe9nyes lej\xe1rati d\xe1tumot",
            "error.va.sf-cc-dat.03": "Hamarosan lej\xe1r\xf3 hitelk\xe1rtya",
            "error.va.sf-cc-dat.04": "Adja meg a lej\xe1rati d\xe1tumot",
            "error.va.sf-cc-dat.05": "Adja meg a teljes lej\xe1rati d\xe1tumot",
            "error.va.sf-cc-mth.01": "Adja meg a lej\xe1rati h\xf3napot",
            "error.va.sf-cc-yr.01": "Adja meg a lej\xe1rat \xe9vet",
            "error.va.sf-cc-yr.02": "Adja meg a teljes lej\xe1rati \xe9vet",
            "error.va.sf-cc-cvc.01": "Adja meg a biztons\xe1gi k\xf3dot",
            "error.va.sf-cc-cvc.02": "Adja meg a teljes biztons\xe1gi k\xf3dot",
            "error.va.sf-ach-num.01": "A banksz\xe1mlasz\xe1m mez\u0151je \xfcres",
            "error.va.sf-ach-num.02": "A banksz\xe1mlasz\xe1m nem megfelel\u0151 hossz\xfas\xe1g\xfa",
            "error.va.sf-ach-loc.01": "A bankazonos\xedt\xf3 k\xf3d mez\u0151je \xfcres",
            "error.va.sf-ach-loc.02": "A bankazonos\xedt\xf3 k\xf3d nem megfelel\u0151 hossz\xfas\xe1g\xfa",
            "error.va.sf-kcp-pwd.01": "A jelsz\xf3 mez\u0151je \xfcres",
            "error.va.sf-kcp-pwd.02": "A jelsz\xf3 nem megfelel\u0151 hossz\xfas\xe1g\xfa",
            "error.giftcard.no-balance": "Az aj\xe1nd\xe9kk\xe1rtya egyenlege nulla",
            "error.giftcard.card-error": "Nyilv\xe1ntart\xe1sunkban nem szerepel ilyen sz\xe1m\xfa aj\xe1nd\xe9kk\xe1rtya",
            "error.giftcard.currency-error": "Az aj\xe1nd\xe9kk\xe1rty\xe1k csak abban a p\xe9nznemben \xe9rv\xe9nyesek, amelyre ki\xe1ll\xedtott\xe1k azokat",
            "amazonpay.signout": "Kijelentkez\xe9s az Amazonr\xf3l",
            "amazonpay.changePaymentDetails": "Fizet\xe9si adatok m\xf3dos\xedt\xe1sa",
            "partialPayment.warning": "M\xe1sik fizet\xe9si m\xf3d v\xe1laszt\xe1sa a fennmarad\xf3 r\xe9sz fizet\xe9s\xe9hez",
            "partialPayment.remainingBalance": "A fennmarad\xf3 egyenleg %{amount} lesz",
            "bankTransfer.beneficiary": "Kedvezm\xe9nyezett",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Referencia",
            "bankTransfer.introduction": "Folytassa, hogy elind\xedtson egy \xfaj banki \xe1tutal\xe1sos fizet\xe9st. A fizet\xe9s v\xe9gleges\xedt\xe9s\xe9hez felhaszn\xe1lhatja a k\xf6vetkez\u0151 k\xe9perny\u0151n megjelen\u0151 adatokat.",
            "bankTransfer.instructions": "K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.",
            "bacs.accountHolderName": "Banksz\xe1mla-tulajdonos neve",
            "bacs.accountHolderName.invalid": "A banksz\xe1mla-tulajdonos neve \xe9rv\xe9nytelen",
            "bacs.accountNumber": "Banksz\xe1mlasz\xe1m",
            "bacs.accountNumber.invalid": "\xc9rv\xe9nytelen banksz\xe1mlasz\xe1m",
            "bacs.bankLocationId": "Banki azonos\xedt\xf3",
            "bacs.bankLocationId.invalid": "\xc9rv\xe9nytelen banki azonos\xedt\xf3",
            "bacs.consent.amount": "Elfogadom, hogy a fenti \xf6sszeget levonj\xe1k a banksz\xe1ml\xe1mr\xf3l.",
            "bacs.consent.account": "Meger\u0151s\xedtem, hogy a banksz\xe1mla az \xe9n nevemen van, \xe9s \xe9n vagyok a banksz\xe1ml\xe1t \xe9rint\u0151 beszed\xe9si megb\xedz\xe1s j\xf3v\xe1hagy\xe1s\xe1hoz sz\xfcks\xe9ges egyetlen al\xe1\xedr\xf3.",
            edit: "Szerkeszt\xe9s",
            "bacs.confirm": "Meger\u0151s\xedt\xe9s \xe9s fizet\xe9s",
            "bacs.result.introduction": "Beszed\xe9si megb\xedz\xe1si utas\xedt\xe1s (meghatalmaz\xe1s) let\xf6lt\xe9se",
            "download.pdf": "PDF let\xf6lt\xe9se",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe a k\xe1rtyasz\xe1mhoz",
            "creditCard.encryptedCardNumber.aria.label": "K\xe1rtyasz\xe1m",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe a lej\xe1rati d\xe1tumhoz",
            "creditCard.encryptedExpiryDate.aria.label": "Lej\xe1rati d\xe1tum",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe a lej\xe1rati h\xf3naphoz",
            "creditCard.encryptedExpiryMonth.aria.label": "Lej\xe1rati h\xf3nap",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe a lej\xe1rati \xe9vhez",
            "creditCard.encryptedExpiryYear.aria.label": "Lej\xe1rati \xe9v",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe a biztons\xe1gi k\xf3dhoz",
            "creditCard.encryptedSecurityCode.aria.label": "Biztons\xe1gi k\xf3d",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe a jelsz\xf3hoz",
            "creditCard.encryptedPassword.aria.label": "K\xe1rtya jelszav\xe1nak els\u0151 2 sz\xe1mjegye",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe a k\xe1rtyasz\xe1mhoz",
            "giftcard.encryptedCardNumber.aria.label": "K\xe1rtyasz\xe1m",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe a PIN-k\xf3dhoz",
            "giftcard.encryptedSecurityCode.aria.label": "PIN-k\xf3d",
            giftcardTransactionLimit: "Ezen az aj\xe1nd\xe9kk\xe1rty\xe1n a tranzakci\xf3nk\xe9nt enged\xe9lyezett maxim\xe1lis \xf6sszeg %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe a banksz\xe1mlasz\xe1mhoz",
            "ach.encryptedBankAccountNumber.aria.label": "Sz\xe1mlasz\xe1m",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe a bankazonos\xedt\xf3 k\xf3dhoz",
            "ach.encryptedBankLocationId.aria.label": "ABA-ir\xe1ny\xedt\xf3sz\xe1m",
            "twint.saved": "mentve",
            orPayWith: "vagy fizessen ezzel:",
            invalidFormatExpects: "\xc9rv\xe9nytelen form\xe1tum. V\xe1rt form\xe1tum: %{format}",
            "upi.qrCodeWaitingMessage": "A fizet\xe9s befejez\xe9s\xe9hez olvassa be a QR-k\xf3dot a k\xedv\xe1nt UPI-alkalmaz\xe1ssal",
            "upi.vpaWaitingMessage": "A fizet\xe9s meger\u0151s\xedt\xe9s\xe9hez nyissa meg UPI-alkalmaz\xe1st",
            "upi.modeSelection": "Jel\xf6lje meg, hogyan szeretn\xe9 haszn\xe1lni az UPI-t.",
            "onlineBanking.termsAndConditions": "A folytat\xe1ssal elfogadja az %#\xe1ltal\xe1nos szerz\u0151d\xe9si felt\xe9teleket%#",
            "onlineBankingPL.termsAndConditions": "A folytat\xe1ssal elfogadja a Przelewy24 %#szab\xe1lyait%# \xe9s %#t\xe1j\xe9koztat\xe1si k\xf6telezetts\xe9g\xe9t%#",
            "ctp.loading.poweredByCtp": "Szolg\xe1ltat\xf3: Click to Pay",
            "ctp.loading.intro": "Ellen\u0151rizz\xfck, hogy van-e mentett Click\xa0to\xa0Pay-k\xe1rty\xe1ja\u2026",
            "ctp.login.title": "Tov\xe1bb a Click to Pay fel\xfclet\xe9re",
            "ctp.login.subtitle": "A folytat\xe1shoz adja meg a Click to Payhez kapcsol\xf3d\xf3 e-mail-c\xedmet.",
            "ctp.login.inputLabel": "E-mail-c\xedm",
            "ctp.logout.notYou": "Nem \xd6n az?",
            "ctp.logout.notYourCards": "Nem az \xd6n k\xe1rty\xe1i?",
            "ctp.logout.notYourCard": "Nem az \xd6n k\xe1rty\xe1ja?",
            "ctp.logout.notYourProfile": "Nem az \xd6n profilja?",
            "ctp.otp.fieldLabel": "Egyszeri k\xf3d",
            "ctp.otp.resendCode": "K\xf3d \xfajrak\xfcld\xe9se",
            "ctp.otp.codeResent": "K\xf3d \xfajrak\xfcldve",
            "ctp.otp.title": "Hozz\xe1f\xe9r\xe9s a Click to Pay-k\xe1rty\xe1ihoz",
            "ctp.otp.subtitle": "\xcdrja be a k\xf3dot, amit a(z) %@ k\xfcld\xf6tt %@ r\xe9sz\xe9re ellen\u0151rz\xe9s c\xe9lj\xe1b\xf3l.",
            "ctp.otp.saveCookiesCheckbox.label": "Ellen\u0151rz\xe9s kihagy\xe1sa a k\xf6vetkez\u0151 alkalommal",
            "ctp.otp.saveCookiesCheckbox.information": "Jel\xf6lje be, hogy a r\xe9sztvev\u0151 \xfczletek a gyorsabb fizet\xe9s \xe9rdek\xe9ben eml\xe9kezzenek az eszk\xf6zre \xe9s a b\xf6ng\xe9sz\u0151re. Megosztott eszk\xf6z\xf6k eset\xe9n nem aj\xe1nlott.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Jel\xf6lje be, hogy a rendszer eml\xe9kezzen az eszk\xf6zre \xe9s a b\xf6ng\xe9sz\u0151re",
            "ctp.emptyProfile.message": "Ebben a Click to Pay-profilban nincs regisztr\xe1lt k\xe1rtya",
            "ctp.separatorText": "vagy haszn\xe1lja a k\xf6vetkez\u0151t",
            "ctp.cards.title": "Fizet\xe9s Click to Pay haszn\xe1lat\xe1val",
            "ctp.cards.subtitle": "V\xe1lassza ki a haszn\xe1lni k\xedv\xe1nt k\xe1rty\xe1t.",
            "ctp.cards.expiredCard": "Lej\xe1rt",
            "ctp.manualCardEntry": "K\xe1rtya adatainak k\xe9zi megad\xe1sa",
            "ctp.aria.infoModalButton": "Mi az a Click to Pay",
            "ctp.infoPopup.title": "A Click to Pay megk\xf6nny\xedti az \xe9rint\xe9s n\xe9lk\xfcli online fizet\xe9st",
            "ctp.infoPopup.subtitle": "A Mastercard, a Visa \xe9s m\xe1s fizet\xe9si k\xe1rty\xe1k \xe1ltal t\xe1mogatott gyors \xe9s biztons\xe1gos fizet\xe9si m\xf3d.",
            "ctp.infoPopup.benefit1": "A Click to Pay az adatok biztons\xe1ga \xe9rdek\xe9ben titkos\xedt\xe1st haszn\xe1l",
            "ctp.infoPopup.benefit2": "Vil\xe1gszerte haszn\xe1lhat\xf3 a keresked\u0151kn\xe9l",
            "ctp.infoPopup.benefit3": "Egyszer kell be\xe1ll\xedtani, hogy a j\xf6v\u0151ben probl\xe9mamentesen fizethessen",
            "ctp.errors.AUTH_INVALID": "\xc9rv\xe9nytelen hiteles\xedt\xe9s",
            "ctp.errors.NOT_FOUND": "Nem tal\xe1lhat\xf3 fi\xf3k, adjon meg egy \xe9rv\xe9nyes e-mail-c\xedmet, vagy folytassa a k\xe1rtyaadatok manu\xe1lis bevitel\xe9vel",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Nem t\xe1mogatott form\xe1tum",
            "ctp.errors.FRAUD": "A felhaszn\xe1l\xf3i fi\xf3k z\xe1rolva volt vagy le volt tiltva",
            "ctp.errors.CONSUMER_ID_MISSING": "A k\xe9r\xe9sb\u0151l hi\xe1nyzik az \xfcgyf\xe9l-azonos\xedt\xf3",
            "ctp.errors.ACCT_INACCESSIBLE": "A fi\xf3k jelenleg nem \xe9rhet\u0151 el, pl. az\xe9rt, mert z\xe1rolva van",
            "ctp.errors.CODE_INVALID": "Helytelen ellen\u0151rz\u0151 k\xf3d",
            "ctp.errors.CODE_EXPIRED": "A k\xf3d lej\xe1rt",
            "ctp.errors.RETRIES_EXCEEDED": "T\xfall\xe9pte az egyszeri jelsz\xf3 l\xe9trehoz\xe1s\xe1ra tett lehets\xe9ges pr\xf3b\xe1lkoz\xe1sok maxim\xe1lis sz\xe1m\xe1t",
            "ctp.errors.OTP_SEND_FAILED": "Az egyszeri jelsz\xf3t nem siker\xfclt elk\xfcldeni a c\xedmzettnek",
            "ctp.errors.REQUEST_TIMEOUT": "Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan vigye be a k\xe1rty\xe1t",
            "ctp.errors.UNKNOWN_ERROR": "Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat",
            "ctp.errors.SERVICE_ERROR": "Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat",
            "ctp.errors.SERVER_ERROR": "Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat",
            "ctp.errors.INVALID_PARAMETER": "Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat",
            "ctp.errors.AUTH_ERROR": "Hiba t\xf6rt\xe9nt, pr\xf3b\xe1lkozzon \xfajra, vagy manu\xe1lisan adja meg a k\xe1rtyaadatokat",
            "paymentMethodsList.aria.label": "V\xe1lasszon fizet\xe9si m\xf3dot",
            "companyDetails.name.invalid": "Adja meg a c\xe9g nev\xe9t",
            "companyDetails.registrationNumber.invalid": "Adja meg a c\xe9gjegyz\xe9ksz\xe1mot",
            "consent.checkbox.invalid": "El kell fogadnia az \xe1ltal\xe1nos szerz\u0151d\xe9si felt\xe9teleket",
            "form.instruction": "Minden mez\u0151 kit\xf6lt\xe9se k\xf6telez\u0151, hacsak nincs m\xe1sk\xe9pp jel\xf6lve.",
            "trustly.descriptor": "Azonnali banki fizet\xe9s",
            "trustly.description1": "Fizessen k\xf6zvetlen\xfcl b\xe1rmelyik banksz\xe1ml\xe1j\xe1r\xf3l, banki szint\u0171 biztons\xe1g mellett",
            "trustly.description2": "Nincs sz\xfcks\xe9g k\xe1rty\xe1ra, alkalmaz\xe1s let\xf6lt\xe9s\xe9re \xe9s regisztr\xe1ci\xf3ra",
            "ancv.input.label": "Az \xd6n ANCV-azonos\xedt\xf3ja",
            "ancv.confirmPayment": "A fizet\xe9s meger\u0151s\xedt\xe9s\xe9hez haszn\xe1lja az ANCV alkalmaz\xe1st.",
            "ancv.form.instruction": "A fizet\xe9s \xe9rv\xe9nyes\xedt\xe9s\xe9hez a Cheque-Vacances alkalmaz\xe1s sz\xfcks\xe9ges.",
            "ancv.beneficiaryId.invalid": "Adjon meg egy \xe9rv\xe9nyes e-mail-c\xedmet vagy ANCV-azonos\xedt\xf3t",
            "payme.openPayMeApp": "A fizet\xe9snek a PayMe alkalmaz\xe1sban val\xf3 enged\xe9lyez\xe9s\xe9vel hajtsa v\xe9gre a fizet\xe9st, \xe9s v\xe1rja meg a visszaigazol\xe1st.",
            "payme.redirectButtonLabel": "PayMe alkalmaz\xe1s megnyit\xe1sa",
            "payme.scanQrCode": "Fizet\xe9s v\xe9grehajt\xe1sa QR-k\xf3ddal",
            "payme.timeToPay": "A QR-k\xf3d ennyi ideig \xe9rv\xe9nyes: %@",
            "payme.instructions.steps": "Nyissa meg a PayMe alkalmaz\xe1st.%@A fizet\xe9s enged\xe9lyez\xe9s\xe9hez olvassa be a QR-k\xf3dot.%@Hajtsa v\xe9gre a fizet\xe9st az alkalmaz\xe1sban, \xe9s v\xe1rja meg a visszaigazol\xe1st.",
            "payme.instructions.footnote": "A fizet\xe9s befejez\xe9se el\u0151tt ne z\xe1rja be ezt az oldalt"
        }
    }), t2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Paga",
            "payButton.redirecting": "Reindirizzamento...",
            "payButton.with": "Paga %{value} con %{maskedData}",
            "payButton.saveDetails": "Salva dettagli",
            close: "Chiudi",
            storeDetails: "Salva per il prossimo pagamento",
            readMore: "Leggi di pi\xf9",
            "creditCard.holderName": "Titolare carta",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "Immetti il nome riportato sulla carta",
            "creditCard.numberField.title": "Numero carta",
            "creditCard.expiryDateField.title": "Data di scadenza",
            "creditCard.expiryDateField.placeholder": "MM/AA",
            "creditCard.expiryDateField.month": "Mese",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "AA",
            "creditCard.expiryDateField.year": "Anno",
            "creditCard.cvcField.title": "Codice di sicurezza",
            "creditCard.storeDetailsButton": "Ricorda per la prossima volta",
            "creditCard.cvcField.placeholder.4digits": "4 cifre",
            "creditCard.cvcField.placeholder.3digits": "3 cifre",
            "creditCard.taxNumber.placeholder": "AAMMGG/0123456789",
            installments: "Numero di rate",
            installmentOption: "%{partialValue} x%{times}",
            installmentOptionMonths: "%{times} mesi",
            "installments.oneTime": "Pagamento una tantum",
            "installments.installments": "Pagamento rateale",
            "installments.revolving": "Pagamento ricorrente",
            "sepaDirectDebit.ibanField.invalid": "Numero di conto non valido",
            "sepaDirectDebit.nameField.placeholder": "A. Bianchi",
            "sepa.ownerName": "Nome Intestatario Conto",
            "sepa.ibanNumber": "Numero di conto (IBAN)",
            "error.title": "Errore",
            "error.subtitle.redirect": "Reindirizzamento non riuscito",
            "error.subtitle.payment": "Pagamento non riuscito",
            "error.subtitle.refused": "Pagamento respinto",
            "error.message.unknown": "Si \xe8 verificato un errore sconosciuto",
            "errorPanel.title": "Errori presenti",
            "idealIssuer.selectField.title": "Banca",
            "idealIssuer.selectField.placeholder": "Seleziona la banca",
            "creditCard.success": "Pagamento riuscito",
            loading: "Caricamento in corso...",
            continue: "Continua",
            continueTo: "Procedi verso",
            "wechatpay.timetopay": "Devi pagare %@",
            "sr.wechatpay.timetopay": "Hai %#minuti%# %#secondi%# per pagare",
            "wechatpay.scanqrcode": "Scansiona il codice QR",
            personalDetails: "Dati personali",
            companyDetails: "Informazioni dell'azienda",
            "companyDetails.name": "Ragione sociale",
            "companyDetails.registrationNumber": "Numero di registrazione",
            socialSecurityNumber: "Numero di previdenza sociale",
            firstName: "Nome",
            "firstName.invalid": "Immetti il tuo nome",
            infix: "Prefisso",
            lastName: "Cognome",
            "lastName.invalid": "Immetti il tuo cognome",
            mobileNumber: "Numero di cellulare",
            "mobileNumber.invalid": "Numero di cellulare non valido",
            city: "Citt\xe0",
            postalCode: "Codice postale",
            "postalCode.optional": "Codice postale (facoltativo)",
            countryCode: "Codice nazionale",
            telephoneNumber: "Numero di telefono",
            dateOfBirth: "Data di nascita",
            shopperEmail: "Indirizzo e-mail",
            gender: "Sesso",
            "gender.notselected": "Seleziona il tuo sesso",
            male: "Uomo",
            female: "Donna",
            billingAddress: "Indirizzo di fatturazione",
            street: "Via",
            stateOrProvince: "Stato o provincia",
            country: "Paese",
            houseNumberOrName: "Numero civico",
            separateDeliveryAddress: "Specifica un indirizzo di consegna alternativo",
            deliveryAddress: "Indirizzo di consegna",
            "deliveryAddress.firstName": "Nome del destinatario",
            "deliveryAddress.lastName": "Cognome del destinatario",
            zipCode: "CAP",
            apartmentSuite: "Appartamento/suite",
            provinceOrTerritory: "Provincia o territorio",
            cityTown: "Citt\xe0",
            address: "Indirizzo",
            "address.placeholder": "Trova il tuo indirizzo",
            "address.errors.incomplete": "Inserisci un indirizzo per continuare",
            "address.enterManually": "Inserisci l'indirizzo manualmente",
            state: "Stato",
            "field.title.optional": "(facoltativo)",
            "creditCard.cvcField.title.optional": "Codice di sicurezza (facoltativo)",
            "issuerList.wallet.placeholder": "Seleziona il tuo portafoglio",
            privacyPolicy: "Informativa sulla privacy",
            "afterPay.agreement": "Accetto i %@ di Riverty",
            paymentConditions: "termini di pagamento",
            openApp: "Apri l'app",
            "voucher.readInstructions": "Leggi le istruzioni",
            "voucher.introduction": "Grazie per il tuo acquisto, utilizza il seguente coupon per completare il pagamento.",
            "voucher.expirationDate": "Data di scadenza",
            "voucher.alternativeReference": "Riferimento alternativo",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Seleziona il tuo fornitore",
            "dragonpay.voucher.bank.selectField.placeholder": "Seleziona la banca",
            "voucher.paymentReferenceLabel": "Riferimento del pagamento",
            "voucher.surcharge": "Include un sovrapprezzo di %@",
            "voucher.introduction.doku": "Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.",
            "voucher.shopperName": "Nome dell'acquirente",
            "voucher.merchantName": "Esercente",
            "voucher.introduction.econtext": "Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.",
            "voucher.telephoneNumber": "Numero di telefono",
            "voucher.shopperReference": "Riferimento dell'acquirente",
            "voucher.collectionInstitutionNumber": "Codice identificativo del negozio",
            "voucher.econtext.telephoneNumber.invalid": "Il numero di telefono deve essere di 10 o 11 cifre",
            "boletobancario.btnLabel": "Genera Boleto",
            "boleto.sendCopyToEmail": "Invia una copia alla mia e-mail",
            "button.copy": "Copia",
            "button.download": "Scarica",
            "boleto.socialSecurityNumber.invalid": "Il campo non \xe8 valido",
            "creditCard.storedCard.description.ariaLabel": "La carta memorizzata termina in %@",
            "voucher.entity": "Entit\xe0",
            donateButton: "Dona",
            notNowButton: "Non ora",
            thanksForYourSupport: "Grazie per il tuo sostegno!",
            "resultMessages.preauthorized": "Dettagli salvati",
            preauthorizeWith: "Preautorizza con",
            confirmPreauthorization: "Conferma preautorizzazione",
            confirmPurchase: "Conferma acquisto",
            applyGiftcard: "Riscatta",
            giftcardBalance: "Saldo del buono",
            deductedBalance: "Importo detratto",
            "creditCard.pin.title": "Pin",
            "creditCard.encryptedPassword.label": "Prime 2 cifre della password della carta",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Password non valida",
            "creditCard.taxNumber": "Data di nascita del titolare della carta o numero di registrazione aziendale",
            "creditCard.taxNumber.label": "Data di nascita del titolare della carta (AAMMGG) o numero di registrazione aziendale (10 cifre)",
            "creditCard.taxNumber.labelAlt": "Numero di registrazione aziendale (10 cifre)",
            "creditCard.taxNumber.invalid": "Data di nascita del titolare della carta o numero di registrazione aziendale non validi",
            "storedPaymentMethod.disable.button": "Rimuovi",
            "storedPaymentMethod.disable.confirmation": "Rimuovi il metodo di pagamento archiviato",
            "storedPaymentMethod.disable.confirmButton": "S\xec, rimuoverli",
            "storedPaymentMethod.disable.cancelButton": "Cancella",
            "ach.bankAccount": "Conto bancario",
            "ach.accountHolderNameField.title": "Nome del titolare del conto",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Nome del titolare del conto non valido",
            "ach.accountNumberField.title": "Numero di conto",
            "ach.accountNumberField.invalid": "Numero di conto non valido",
            "ach.accountLocationField.title": "Codice ABA",
            "ach.accountLocationField.invalid": "Codice ABA non valido",
            "ach.savedBankAccount": "Conto corrente salvato",
            "select.state": "Seleziona stato",
            "select.stateOrProvince": "Seleziona stato o provincia",
            "select.provinceOrTerritory": "Seleziona provincia o territorio",
            "select.country": "Seleziona paese",
            "select.noOptionsFound": "Nessuna opzione trovata",
            "select.filter.placeholder": "Cerca...",
            "telephoneNumber.invalid": "Numero di telefono non valido",
            qrCodeOrApp: "o",
            "paypal.processingPayment": "Elaborazione del pagamento in corso...",
            generateQRCode: "Genera codice QR",
            "await.waitForConfirmation": "In attesa di conferma",
            "mbway.confirmPayment": "Conferma il pagamento con l'app MB WAY",
            "shopperEmail.invalid": "Indirizzo e-mail non valido",
            "dateOfBirth.format": "GG/MM/AAAA",
            "dateOfBirth.invalid": "Inserisci una data di nascita valida in cui risulti che hai almeno 18 anni.",
            "blik.confirmPayment": "Apri l'app della tua banca per confermare il pagamento.",
            "blik.invalid": "Inserisci 6 numeri",
            "blik.code": "Codice a 6 cifre",
            "blik.help": "Ottieni il codice dalla app della tua banca.",
            "swish.pendingMessage": "In seguito alla scansione, lo stato della transazione pu\xf2 rimanere in sospeso per un massimo di 10 minuti. Un nuovo tentativo di pagamento durante questo lasso di tempo pu\xf2 comportare pagamenti multipli.",
            "field.valid": "Campo valido",
            "field.invalid": "Campo non valido",
            "error.va.gen.01": "Campo incompleto",
            "error.va.gen.02": "Campo non valido",
            "error.va.sf-cc-num.01": "Immetti un numero di carta valido",
            "error.va.sf-cc-num.02": "Immetti il numero della carta",
            "error.va.sf-cc-num.03": "Immetti un marchio di carta supportato",
            "error.va.sf-cc-num.04": "Immetti il numero completo della carta",
            "error.va.sf-cc-dat.01": "Immetti una data di scadenza valida",
            "error.va.sf-cc-dat.02": "Immetti una data di scadenza valida",
            "error.va.sf-cc-dat.03": "Carta di credito in scadenza",
            "error.va.sf-cc-dat.04": "Immetti la data di scadenza",
            "error.va.sf-cc-dat.05": "Immetti la data di scadenza completa",
            "error.va.sf-cc-mth.01": "Immetti il mese di scadenza",
            "error.va.sf-cc-yr.01": "Immetti l'anno di scadenza",
            "error.va.sf-cc-yr.02": "Immetti l'anno di scadenza completo",
            "error.va.sf-cc-cvc.01": "Immetti il codice di sicurezza",
            "error.va.sf-cc-cvc.02": "Immetti il codice di sicurezza completo",
            "error.va.sf-ach-num.01": "Il campo Numero di conto corrente bancario \xe8 vuoto",
            "error.va.sf-ach-num.02": "La lunghezza del numero di conto corrente bancario non \xe8 corretta",
            "error.va.sf-ach-loc.01": "Il campo Numero di routing bancario \xe8 vuoto",
            "error.va.sf-ach-loc.02": "La lunghezza del numero di routing bancario non \xe8 corretta",
            "error.va.sf-kcp-pwd.01": "Il campo Password \xe8 vuoto",
            "error.va.sf-kcp-pwd.02": "La lunghezza della password non \xe8 corretta",
            "error.giftcard.no-balance": "Questo buono regalo ha un saldo pari a zero",
            "error.giftcard.card-error": "Non abbiamo alcun buono regalo con questo numero nei nostri archivi",
            "error.giftcard.currency-error": "I buono regalo sono validi solo nella valuta in cui sono state emessi",
            "amazonpay.signout": "Esci da Amazon",
            "amazonpay.changePaymentDetails": "Modifica i dettagli di pagamento",
            "partialPayment.warning": "Seleziona un altro metodo di pagamento per pagare l'importo rimanente",
            "partialPayment.remainingBalance": "Il saldo rimanente sar\xe0 di %{amount}",
            "bankTransfer.beneficiary": "Beneficiario",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Riferimento",
            "bankTransfer.introduction": "Continua per creare un nuovo pagamento tramite bonifico bancario. Puoi utilizzare i dettagli nella schermata seguente per completare l'operazione.",
            "bankTransfer.instructions": "Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.",
            "bacs.accountHolderName": "Nome del titolare del conto bancario",
            "bacs.accountHolderName.invalid": "Nome del titolare del conto bancario non valido",
            "bacs.accountNumber": "Numero di conto bancario",
            "bacs.accountNumber.invalid": "Numero di conto bancario non valido",
            "bacs.bankLocationId": "Sort code",
            "bacs.bankLocationId.invalid": "Sort code non valido",
            "bacs.consent.amount": "Accetto che l'importo sopra indicato venga detratto dal mio conto bancario.",
            "bacs.consent.account": "Confermo che il conto \xe8 intestato al sottoscritto e che sono l'unico firmatario a dover autorizzare l'addebito diretto su questo conto.",
            edit: "Modifica",
            "bacs.confirm": "Conferma e paga",
            "bacs.result.introduction": "Scarica le Istruzioni per l'addebito diretto (DDI / Mandato)",
            "download.pdf": "Scarica PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe per il numero di carta",
            "creditCard.encryptedCardNumber.aria.label": "Numero carta",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe per data di scadenza",
            "creditCard.encryptedExpiryDate.aria.label": "Data di scadenza",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe per il mese di scadenza",
            "creditCard.encryptedExpiryMonth.aria.label": "Mese di scadenza",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe per l'anno di scadenza",
            "creditCard.encryptedExpiryYear.aria.label": "Anno di scadenza",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe per il codice di sicurezza",
            "creditCard.encryptedSecurityCode.aria.label": "Codice di sicurezza",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe per la password",
            "creditCard.encryptedPassword.aria.label": "Prime 2 cifre della password della carta",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe per il numero di carta",
            "giftcard.encryptedCardNumber.aria.label": "Numero carta",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe per il pin",
            "giftcard.encryptedSecurityCode.aria.label": "Pin",
            giftcardTransactionLimit: "Importo massimo di %{amount} per transazione su questo buono regalo",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe per il numero di conto bancario",
            "ach.encryptedBankAccountNumber.aria.label": "Numero di conto",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe per il numero di routing bancario",
            "ach.encryptedBankLocationId.aria.label": "Codice ABA",
            "twint.saved": "memorizzato",
            orPayWith: "oppure paga con",
            invalidFormatExpects: "Formato non valido. Formato previsto: %{format}",
            "upi.qrCodeWaitingMessage": "Per completare il pagamento, scansiona il codice QR utilizzando la tua app UPI preferita",
            "upi.vpaWaitingMessage": "Apri l'app UPI per confermare il pagamento",
            "upi.modeSelection": "Scegli la modalit\xe0 di utilizzo di UPI.",
            "onlineBanking.termsAndConditions": "Facendo clic, accetti i %#termini e le condizioni%#",
            "onlineBankingPL.termsAndConditions": "Continuando accetti il %#regolamento%# e l'%#obbligo di informativa%# di Przelewy24",
            "ctp.loading.poweredByCtp": "Realizzato da Click to Pay",
            "ctp.loading.intro": "Stiamo verificando se hai delle carte salvate con Click to Pay...",
            "ctp.login.title": "Continua su Click to Pay",
            "ctp.login.subtitle": "Per continuare, inserisci l'indirizzo e-mail collegato a Click to Pay.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "Non sei tu?",
            "ctp.logout.notYourCards": "Non sono le tue carte?",
            "ctp.logout.notYourCard": "Non \xe8 la tua carta?",
            "ctp.logout.notYourProfile": "Non \xe8 il tuo profilo?",
            "ctp.otp.fieldLabel": "Codice monouso",
            "ctp.otp.resendCode": "Invia nuovamente il codice",
            "ctp.otp.codeResent": "Codice inviato",
            "ctp.otp.title": "Accedi alle tue carte Click to Pay",
            "ctp.otp.subtitle": "Inserisci il codice che %@ ha inviato a %@ per verificare la tua identit\xe0.",
            "ctp.otp.saveCookiesCheckbox.label": "Salta la verifica la prossima volta",
            "ctp.otp.saveCookiesCheckbox.information": "Scegli di essere ricordato sul dispositivo e il browser che utilizzi per velocizzare il pagamento nei negozi partecipanti. Non consigliato per dispositivi condivisi.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Seleziona per essere ricordato sul tuo dispositivo e sul browser",
            "ctp.emptyProfile.message": "Non esistono carte registrate in questo profilo Click to Pay",
            "ctp.separatorText": "o utilizza",
            "ctp.cards.title": "Completa il pagamento con Click to Pay",
            "ctp.cards.subtitle": "Seleziona una carta da utilizzare.",
            "ctp.cards.expiredCard": "Scaduta",
            "ctp.manualCardEntry": "Inserimento manuale della carta",
            "ctp.aria.infoModalButton": "Che cos'\xe8 Click to Pay",
            "ctp.infoPopup.title": "Click to Pay offre la facilit\xe0 del contactless online",
            "ctp.infoPopup.subtitle": "Un metodo di pagamento veloce e sicuro supportato da Mastercard, Visa e altre carte di pagamento.",
            "ctp.infoPopup.benefit1": "Click to Pay si avvale della crittografia per garantire la sicurezza delle tue informazioni",
            "ctp.infoPopup.benefit2": "Usa questo strumento con i commercianti di tutto il mondo",
            "ctp.infoPopup.benefit3": "Effettua una sola configurazione per avere la possibilit\xe0 di effettuare pagamenti pi\xf9 agevoli in futuro",
            "ctp.errors.AUTH_INVALID": "Autenticazione non valida",
            "ctp.errors.NOT_FOUND": "Nessun account trovato. Inserisci un'e-mail valida o procedi con l'inserimento manuale della carta.",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formato non supportato",
            "ctp.errors.FRAUD": "L'account utente \xe8 stato bloccato o disattivato",
            "ctp.errors.CONSUMER_ID_MISSING": "L'identit\xe0 del consumatore non \xe8 presente nella richiesta",
            "ctp.errors.ACCT_INACCESSIBLE": "Questo account non \xe8 attualmente disponibile, ad esempio perch\xe9 \xe8 bloccato",
            "ctp.errors.CODE_INVALID": "Codice di verifica non corretto",
            "ctp.errors.CODE_EXPIRED": "Questo codice \xe8 scaduto",
            "ctp.errors.RETRIES_EXCEEDED": "\xc8 stato superato il limite di tentativi per la generazione del codice OTP",
            "ctp.errors.OTP_SEND_FAILED": "Impossibile inviare il codice OTP al destinatario",
            "ctp.errors.REQUEST_TIMEOUT": "Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta",
            "ctp.errors.UNKNOWN_ERROR": "Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta",
            "ctp.errors.SERVICE_ERROR": "Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta",
            "ctp.errors.SERVER_ERROR": "Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta",
            "ctp.errors.INVALID_PARAMETER": "Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta",
            "ctp.errors.AUTH_ERROR": "Si \xe8 verificato un errore. Riprova o inserisci manualmente la carta",
            "paymentMethodsList.aria.label": "Scegli un metodo di pagamento",
            "companyDetails.name.invalid": "Immetti il nome dell'azienda",
            "companyDetails.registrationNumber.invalid": "Immetti il numero di registrazione",
            "consent.checkbox.invalid": "\xc8 necessario accettare i termini e le condizioni",
            "form.instruction": "Se non diversamente indicato, tutti i campi sono obbligatori.",
            "trustly.descriptor": "Pagamento bancario istantaneo",
            "trustly.description1": "Paga direttamente da uno qualsiasi dei tuoi conti bancari, garantito da una sicurezza di livello bancario",
            "trustly.description2": "Nessuna carta, nessun download di app, nessuna registrazione",
            "ancv.input.label": "Il tuo identificativo ANCV",
            "ancv.confirmPayment": "Utilizza la tua richiesta ANCV per confermare il pagamento.",
            "ancv.form.instruction": "Per confermare il pagamento \xe8 necessario utilizzare la richiesta Cheque-Vacances.",
            "ancv.beneficiaryId.invalid": "Inserisci un indirizzo e-mail o un identificativo ANCV valido",
            "payme.openPayMeApp": "Completa il pagamento nell'app PayMe concedendo l'autorizzazione e attendendo il messaggio di conferma.",
            "payme.redirectButtonLabel": "Apri l'app PayMe",
            "payme.scanQrCode": "Completa il pagamento con il codice QR",
            "payme.timeToPay": "Questo codice QR \xe8 valido per %@",
            "payme.instructions.steps": "Apri l'app PayMe.%@Scansiona il codice QR per autorizzare il pagamento.%@Completa il pagamento nell'app e attendi la conferma.",
            "payme.instructions.footnote": "Rimani su questa pagina fino a quando il pagamento sar\xe0 completato"
        }
    }), r2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "\u652F\u6255\u3046",
            "payButton.redirecting": "\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3057\u3066\u3044\u307E\u3059...",
            "payButton.with": "%{value}\u3092%{maskedData}\u3067\u652F\u6255\u3046",
            "payButton.saveDetails": "\u8A73\u7D30\u3092\u4FDD\u5B58",
            close: "\u7D42\u4E86",
            storeDetails: "\u6B21\u56DE\u306E\u304A\u652F\u6255\u3044\u306E\u305F\u3081\u8A73\u7D30\u3092\u4FDD\u5B58",
            readMore: "\u8A73\u7D30\u3092\u78BA\u8A8D",
            "creditCard.holderName": "\u30AB\u30FC\u30C9\u4E0A\u306E\u540D\u524D",
            "creditCard.holderName.placeholder": "Taro Yamada",
            "creditCard.holderName.invalid": "\u30AB\u30FC\u30C9\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u308B\u540D\u524D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "creditCard.numberField.title": "\u30AB\u30FC\u30C9\u756A\u53F7",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "\u6709\u52B9\u671F\u9650",
            "creditCard.expiryDateField.placeholder": "MM/YY",
            "creditCard.expiryDateField.month": "\u6708",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "YY",
            "creditCard.expiryDateField.year": "\u5E74",
            "creditCard.cvcField.title": "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "\u6B21\u56DE\u306E\u305F\u3081\u306B\u4FDD\u5B58\u3057\u307E\u3059",
            "creditCard.cvcField.placeholder.4digits": "4\u6841",
            "creditCard.cvcField.placeholder.3digits": "3\u6841",
            "creditCard.taxNumber.placeholder": "\u5E74\u6708\u65E5\uFF08YYMMDD\uFF09/ 0123456789",
            installments: "\u5206\u5272\u56DE\u6570",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times}\u304B\u6708",
            "installments.oneTime": "\u4E00\u62EC\u6255\u3044",
            "installments.installments": "\u5206\u5272\u6255\u3044",
            "installments.revolving": "\u30EA\u30DC\u6255\u3044",
            "sepaDirectDebit.ibanField.invalid": "\u53E3\u5EA7\u756A\u53F7\u306E\u5165\u529B\u9593\u9055\u3044",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "\u540D\u7FA9",
            "sepa.ibanNumber": "\u53E3\u5EA7\u756A\u53F7 (IBAN)",
            "error.title": "\u30A8\u30E9\u30FC",
            "error.subtitle.redirect": "\u753B\u9762\u306E\u5207\u308A\u66FF\u3048\u5931\u6557\u306B\u3057\u307E\u3057\u305F",
            "error.subtitle.payment": "\u652F\u6255\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
            "error.subtitle.refused": "\u30AB\u30FC\u30C9\u4F1A\u793E\u3067\u53D6\u5F15\u304C\u627F\u8A8D\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
            "error.message.unknown": "\u4E0D\u660E\u306A\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
            "errorPanel.title": "\u65E2\u5B58\u306E\u30A8\u30E9\u30FC",
            "idealIssuer.selectField.title": "\u9280\u884C",
            "idealIssuer.selectField.placeholder": "\u9280\u884C\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "creditCard.success": "\u8A8D\u8A3C\u304C\u6210\u529F\u3057\u307E\u3057\u305F",
            loading: "\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...",
            continue: "\u7D9A\u3051\u308B",
            continueTo: "\u6B21\u3078\u9032\u3080\uFF1A",
            "wechatpay.timetopay": "%@\u3092\u304A\u652F\u6255\u3044\u4E0B\u3055\u3044\u3002",
            "sr.wechatpay.timetopay": "\u652F\u6255\u3044\u307E\u3067\u6B8B\u308A%#\u5206%# %#\u79D2%#",
            "wechatpay.scanqrcode": "QR \u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3059\u308B",
            personalDetails: "\u500B\u4EBA\u60C5\u5831",
            companyDetails: "\u4F1A\u793E\u60C5\u5831",
            "companyDetails.name": "\u4F1A\u793E\u540D",
            "companyDetails.registrationNumber": "\u767B\u9332\u756A\u53F7",
            socialSecurityNumber: "\u30BD\u30FC\u30B7\u30E3\u30EB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30FC\u756A\u53F7",
            firstName: "\u540D",
            "firstName.invalid": "\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            infix: "\u656C\u79F0",
            lastName: "\u59D3",
            "lastName.invalid": "\u59D3\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            mobileNumber: "\u643A\u5E2F\u756A\u53F7",
            "mobileNumber.invalid": "\u7121\u52B9\u306A\u643A\u5E2F\u96FB\u8A71\u756A\u53F7",
            city: "\u5E02\u533A",
            postalCode: "\u90F5\u4FBF\u756A\u53F7",
            "postalCode.optional": "\u90F5\u4FBF\u756A\u53F7 (\u4EFB\u610F)",
            countryCode: "\u56FD\u30B3\u30FC\u30C9",
            telephoneNumber: "\u96FB\u8A71\u756A\u53F7",
            dateOfBirth: "\u751F\u5E74\u6708\u65E5",
            shopperEmail: "E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
            gender: "\u6027\u5225",
            "gender.notselected": "\u6027\u5225\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            male: "\u7537\u6027",
            female: "\u5973\u6027",
            billingAddress: "\u3054\u8ACB\u6C42\u4F4F\u6240",
            street: "\u756A\u5730",
            stateOrProvince: "\u90FD\u9053\u5E9C\u770C",
            country: "\u56FD",
            houseNumberOrName: "\u90E8\u5C4B\u756A\u53F7",
            separateDeliveryAddress: "\u5225\u306E\u914D\u9001\u5148\u4F4F\u6240\u3092\u6307\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044",
            deliveryAddress: "\u914D\u9001\u5148\u4F4F\u6240",
            "deliveryAddress.firstName": "\u53D7\u4FE1\u8005\u306E\u540D",
            "deliveryAddress.lastName": "\u53D7\u4FE1\u8005\u306E\u59D3",
            zipCode: "\u90F5\u4FBF\u756A\u53F7",
            apartmentSuite: "\u30A2\u30D1\u30FC\u30C8\u540D/\u90E8\u5C4B\u540D",
            provinceOrTerritory: "\u5DDE\u307E\u305F\u306F\u6E96\u5DDE",
            cityTown: "\u5E02\u533A\u753A\u6751",
            address: "\u4F4F\u6240",
            "address.placeholder": "\u4F4F\u6240\u3092\u691C\u7D22\u3057\u3066\u304F\u3060\u3055\u3044",
            "address.errors.incomplete": "\u7D9A\u884C\u3059\u308B\u306B\u306F\u3001\u4F4F\u6240\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "address.enterManually": "\u4F4F\u6240\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            state: "\u90FD\u9053\u5E9C\u770C",
            "field.title.optional": "\uFF08\u4EFB\u610F\uFF09",
            "creditCard.cvcField.title.optional": "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9\uFF08\u4EFB\u610F\uFF09",
            "issuerList.wallet.placeholder": "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            privacyPolicy: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC",
            "afterPay.agreement": "Riverty\u306E%@\u3067\u540C\u610F",
            paymentConditions: "\u652F\u6255\u6761\u4EF6",
            openApp: "\u30A2\u30D7\u30EA\u3092\u958B\u304F",
            "voucher.readInstructions": "\u624B\u9806\u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044",
            "voucher.introduction": "\u304A\u8CB7\u3044\u4E0A\u3052\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u4EE5\u4E0B\u306E\u30AF\u30FC\u30DD\u30F3\u3092\u4F7F\u7528\u3057\u3066\u3001\u304A\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "voucher.expirationDate": "\u6709\u52B9\u671F\u9650",
            "voucher.alternativeReference": "\u5225\u306E\u53C2\u7167",
            "dragonpay.voucher.non.bank.selectField.placeholder": "\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "dragonpay.voucher.bank.selectField.placeholder": "\u9280\u884C\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "voucher.paymentReferenceLabel": "\u78BA\u8A8D\u756A\u53F7",
            "voucher.surcharge": "%@ \u306E\u8FFD\u52A0\u6599\u91D1\u3092\u542B\u3080",
            "voucher.introduction.doku": "\u304A\u8CB7\u3044\u4E0A\u3052\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u4EE5\u4E0B\u306E\u60C5\u5831\u3092\u4F7F\u7528\u3057\u3066\u3001\u304A\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "voucher.shopperName": "\u8CFC\u5165\u8005\u6C0F\u540D",
            "voucher.merchantName": "\u696D\u8005",
            "voucher.introduction.econtext": "\u304A\u8CB7\u3044\u4E0A\u3052\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u4EE5\u4E0B\u306E\u60C5\u5831\u3092\u4F7F\u7528\u3057\u3066\u3001\u304A\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "voucher.telephoneNumber": "\u96FB\u8A71\u756A\u53F7\uFF08\u304A\u5BA2\u69D8\u756A\u53F7\uFF09",
            "voucher.shopperReference": "\u8CFC\u5165\u8005\u5411\u3051\u53C2\u8003\u60C5\u5831",
            "voucher.collectionInstitutionNumber": "\u53CE\u7D0D\u6A5F\u95A2\u756A\u53F7",
            "voucher.econtext.telephoneNumber.invalid": "\u96FB\u8A71\u756A\u53F7\u306F10\u6841\u307E\u305F\u306F11\u6841\u306B\u3057\u3066\u304F\u3060\u3055\u3044",
            "boletobancario.btnLabel": "Boleto\u3092\u751F\u6210\u3059\u308B",
            "boleto.sendCopyToEmail": "\u81EA\u5206\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u30B3\u30D4\u30FC\u3092\u9001\u4FE1\u3059\u308B",
            "button.copy": "\u30B3\u30D4\u30FC",
            "button.download": "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
            "boleto.socialSecurityNumber.invalid": "\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u7121\u52B9\u3067\u3059",
            "creditCard.storedCard.description.ariaLabel": "\u4FDD\u5B58\u3055\u308C\u305F\u30AB\u30FC\u30C9\u306F\uFF05@\u306B\u7D42\u4E86\u3057\u307E\u3059",
            "voucher.entity": "\u30A8\u30F3\u30C6\u30A3\u30C6\u30A3",
            donateButton: "\u5BC4\u4ED8\u3059\u308B",
            notNowButton: "\u4ECA\u306F\u3057\u306A\u3044",
            thanksForYourSupport: "\u3054\u652F\u63F4\u3044\u305F\u3060\u304D\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002",
            "resultMessages.preauthorized": "\u8A73\u7D30\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F",
            preauthorizeWith: "\u6B21\u3067\u4E8B\u524D\u8A8D\u8A3C\u3059\u308B\uFF1A",
            confirmPreauthorization: "\u4E8B\u524D\u627F\u8A8D\u3092\u78BA\u8A8D\u3059\u308B",
            confirmPurchase: "\u8CFC\u5165\u3092\u78BA\u8A8D\u3059\u308B",
            applyGiftcard: "\u5229\u7528\u3059\u308B",
            giftcardBalance: "\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u306E\u6B8B\u9AD8",
            deductedBalance: "\u5DEE\u3057\u5F15\u304D\u5F8C\u6B8B\u9AD8",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "\u30AB\u30FC\u30C9\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u6700\u521D\u306E2\u6841",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u7121\u52B9\u3067\u3059",
            "creditCard.taxNumber": "\u30AB\u30FC\u30C9\u6240\u6709\u8005\u306E\u751F\u5E74\u6708\u65E5\u307E\u305F\u306F\u6CD5\u4EBA\u767B\u9332\u756A\u53F7",
            "creditCard.taxNumber.label": "\u30AB\u30FC\u30C9\u6240\u6709\u8005\u306E\u751F\u5E74\u6708\u65E5\uFF08YYMMDD\uFF09\u307E\u305F\u306F\u6CD5\u4EBA\u767B\u9332\u756A\u53F7\uFF0810\u6841\uFF09",
            "creditCard.taxNumber.labelAlt": "\u6CD5\u4EBA\u767B\u9332\u756A\u53F7\uFF0810\u6841\uFF09",
            "creditCard.taxNumber.invalid": "\u30AB\u30FC\u30C9\u6240\u6709\u8005\u306E\u751F\u5E74\u6708\u65E5\u307E\u305F\u306F\u6CD5\u4EBA\u767B\u9332\u756A\u53F7\u304C\u7121\u52B9\u3067\u3059",
            "storedPaymentMethod.disable.button": "\u524A\u9664",
            "storedPaymentMethod.disable.confirmation": "\u4FDD\u5B58\u3055\u308C\u3066\u3044\u308B\u652F\u6255\u65B9\u6CD5\u3092\u524A\u9664\u3059\u308B",
            "storedPaymentMethod.disable.confirmButton": "\u306F\u3044\u3001\u524A\u9664\u3057\u307E\u3059",
            "storedPaymentMethod.disable.cancelButton": "\u30AD\u30E3\u30F3\u30BB\u30EB",
            "ach.bankAccount": "\u9280\u884C\u53E3\u5EA7",
            "ach.accountHolderNameField.title": "\u53E3\u5EA7\u540D\u7FA9",
            "ach.accountHolderNameField.placeholder": "Taro Yamada",
            "ach.accountHolderNameField.invalid": "\u7121\u52B9\u306A\u53E3\u5EA7\u540D\u7FA9",
            "ach.accountNumberField.title": "\u53E3\u5EA7\u756A\u53F7",
            "ach.accountNumberField.invalid": "\u53E3\u5EA7\u756A\u53F7\u306E\u5165\u529B\u9593\u9055\u3044",
            "ach.accountLocationField.title": "ABA\u30CA\u30F3\u30D0\u30FC",
            "ach.accountLocationField.invalid": "\u7121\u52B9\u306AABA\u30CA\u30F3\u30D0\u30FC",
            "ach.savedBankAccount": "\u4FDD\u5B58\u6E08\u307F\u306E\u9280\u884C\u53E3\u5EA7",
            "select.state": "\u90FD\u9053\u5E9C\u770C\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "select.stateOrProvince": "\u90FD\u9053\u5E9C\u770C\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "select.provinceOrTerritory": "\u5DDE\u307E\u305F\u306F\u6E96\u5DDE\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "select.country": "\u56FD\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "select.noOptionsFound": "\u30AA\u30D7\u30B7\u30E7\u30F3\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
            "select.filter.placeholder": "\u691C\u7D22...",
            "telephoneNumber.invalid": "\u7121\u52B9\u306A\u96FB\u8A71\u756A\u53F7",
            qrCodeOrApp: "\u307E\u305F\u306F",
            "paypal.processingPayment": "\u652F\u6255\u3044\u3092\u51E6\u7406\u3057\u3066\u3044\u307E\u3059...",
            generateQRCode: "QR\u30B3\u30FC\u30C9\u3092\u751F\u6210\u3059\u308B",
            "await.waitForConfirmation": "\u78BA\u8A8D\u3092\u5F85\u3063\u3066\u3044\u307E\u3059",
            "mbway.confirmPayment": "MB WAY\u30A2\u30D7\u30EA\u3067\u652F\u6255\u3092\u78BA\u8A8D\u3059\u308B",
            "shopperEmail.invalid": "E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u304C\u7121\u52B9\u3067\u3059",
            "dateOfBirth.format": "DD/MM/YYYY",
            "dateOfBirth.invalid": "18\u6B73\u4EE5\u4E0A\u3067\u3042\u308B\u3053\u3068\u3092\u793A\u3059\u6709\u52B9\u306A\u751F\u5E74\u6708\u65E5\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "blik.confirmPayment": "\u30D0\u30F3\u30AD\u30F3\u30B0\u30A2\u30D7\u30EA\u3092\u958B\u3044\u3066\u3001\u652F\u6255\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "blik.invalid": "6\u3064\u306E\u6570\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "blik.code": "6\u6841\u306E\u30B3\u30FC\u30C9",
            "blik.help": "\u30D0\u30F3\u30AD\u30F3\u30B0\u30A2\u30D7\u30EA\u304B\u3089\u30B3\u30FC\u30C9\u3092\u53D6\u5F97\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "swish.pendingMessage": "\u30B9\u30AD\u30E3\u30F3\u5F8C\u3001\u30B9\u30C6\u30FC\u30BF\u30B9\u306F\u6700\u592710\u5206\u9593\u4FDD\u7559\u72B6\u614B\u306B\u306A\u308A\u307E\u3059\u3002\u3053\u306E\u9593\u306B\u518D\u5EA6\u304A\u652F\u6255\u3044\u3044\u305F\u3060\u3053\u3046\u3068\u3059\u308B\u3068\u3001\u8907\u6570\u306E\u8ACB\u6C42\u304C\u767A\u751F\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002",
            "field.valid": "\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u6709\u52B9\u3067\u3059",
            "field.invalid": "\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u7121\u52B9\u3067\u3059",
            "error.va.gen.01": "\u4E0D\u5B8C\u5168\u306A\u30D5\u30A3\u30FC\u30EB\u30C9",
            "error.va.gen.02": "\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u7121\u52B9\u3067\u3059",
            "error.va.sf-cc-num.01": "\u6709\u52B9\u306A\u30AB\u30FC\u30C9\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-num.02": "\u30AB\u30FC\u30C9\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-num.03": "\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u308B\u30AB\u30FC\u30C9\u30D6\u30E9\u30F3\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-num.04": "\u5B8C\u5168\u306A\u30AB\u30FC\u30C9\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-dat.01": "\u6709\u52B9\u306A\u6709\u52B9\u671F\u9650\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-dat.02": "\u6709\u52B9\u306A\u6709\u52B9\u671F\u9650\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-dat.03": "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u304C\u8FD1\u3065\u3044\u3066\u3044\u307E\u3059",
            "error.va.sf-cc-dat.04": "\u6709\u52B9\u671F\u9650\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-dat.05": "\u5B8C\u5168\u306A\u6709\u52B9\u671F\u9650\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-mth.01": "\u6709\u52B9\u671F\u9650\u6708\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-yr.01": "\u6709\u52B9\u671F\u9650\u5E74\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-yr.02": "\u5B8C\u5168\u306A\u6709\u52B9\u671F\u9650\u5E74\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-cvc.01": "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-cc-cvc.02": "\u5B8C\u5168\u306A\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "error.va.sf-ach-num.01": "\u9280\u884C\u53E3\u5EA7\u756A\u53F7\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u7A7A\u3067\u3059",
            "error.va.sf-ach-num.02": "\u9280\u884C\u53E3\u5EA7\u756A\u53F7\u306E\u9577\u3055\u304C\u4E0D\u6B63\u3067\u3059",
            "error.va.sf-ach-loc.01": "\u9280\u884C\u652F\u5E97\u756A\u53F7\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u7A7A\u3067\u3059",
            "error.va.sf-ach-loc.02": "\u9280\u884C\u652F\u5E97\u756A\u53F7\u306E\u9577\u3055\u304C\u4E0D\u6B63\u3067\u3059",
            "error.va.sf-kcp-pwd.01": "\u30D1\u30B9\u30EF\u30FC\u30C9\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u7A7A\u3067\u3059",
            "error.va.sf-kcp-pwd.02": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u9577\u3055\u304C\u4E0D\u6B63\u3067\u3059",
            "error.giftcard.no-balance": "\u3053\u306E\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u306E\u6B8B\u9AD8\u306F\u30BC\u30ED\u3067\u3059",
            "error.giftcard.card-error": "\u8A18\u9332\u3067\u306F\u3001\u3053\u306E\u756A\u53F7\u306E\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u306F\u3042\u308A\u307E\u305B\u3093",
            "error.giftcard.currency-error": "\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u306F\u3001\u767A\u884C\u3055\u308C\u305F\u901A\u8CA8\u3067\u306E\u307F\u6709\u52B9\u3067\u3059\u3002",
            "amazonpay.signout": "Amazon\u304B\u3089\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8\u3059\u308B",
            "amazonpay.changePaymentDetails": "\u652F\u6255\u660E\u7D30\u3092\u5909\u66F4\u3059\u308B",
            "partialPayment.warning": "\u6B8B\u91D1\u3092\u652F\u6255\u3046\u5225\u306E\u652F\u6255\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "partialPayment.remainingBalance": "\u6B8B\u308A\u306E\u6B8B\u9AD8\u306F%{amount}\u306B\u306A\u308A\u307E\u3059",
            "bankTransfer.beneficiary": "\u53D7\u76CA\u8005",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "\u53C2\u7167",
            "bankTransfer.introduction": "\u65B0\u3057\u3044\u9280\u884C\u632F\u8FBC\u306B\u3088\u308B\u304A\u652F\u6255\u306E\u4F5C\u6210\u3092\u7D9A\u884C\u3057\u307E\u3059\u3002\u6B21\u306E\u753B\u9762\u306E\u8A73\u7D30\u3092\u4F7F\u7528\u3057\u3066\u3001\u3053\u306E\u304A\u652F\u6255\u3044\u3092\u78BA\u5B9A\u3067\u304D\u307E\u3059\u3002",
            "bankTransfer.instructions": "\u304A\u8CB7\u3044\u4E0A\u3052\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u4EE5\u4E0B\u306E\u60C5\u5831\u3092\u4F7F\u7528\u3057\u3066\u3001\u304A\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "bacs.accountHolderName": "\u9280\u884C\u53E3\u5EA7\u540D\u7FA9",
            "bacs.accountHolderName.invalid": "\u9280\u884C\u53E3\u5EA7\u540D\u7FA9\u304C\u7121\u52B9\u3067\u3059",
            "bacs.accountNumber": "\u9280\u884C\u53E3\u5EA7\u756A\u53F7",
            "bacs.accountNumber.invalid": "\u9280\u884C\u53E3\u5EA7\u756A\u53F7\u304C\u7121\u52B9\u3067\u3059",
            "bacs.bankLocationId": "\u30BD\u30FC\u30C8\u30B3\u30FC\u30C9",
            "bacs.bankLocationId.invalid": "\u30BD\u30FC\u30C8\u30B3\u30FC\u30C9\u304C\u7121\u52B9\u3067\u3059",
            "bacs.consent.amount": "\u4E0A\u8A18\u306E\u91D1\u984D\u304C\u79C1\u306E\u9280\u884C\u53E3\u5EA7\u304B\u3089\u5F15\u304D\u843D\u3068\u3055\u308C\u308B\u3053\u3068\u306B\u540C\u610F\u3057\u307E\u3059\u3002",
            "bacs.consent.account": "\u53E3\u5EA7\u304C\u79C1\u306E\u540D\u7FA9\u3067\u3042\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3001\u3053\u306E\u53E3\u5EA7\u304B\u3089\u306E\u81EA\u52D5\u5F15\u304D\u843D\u3068\u3057\u3092\u627F\u8A8D\u3059\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u552F\u4E00\u306E\u7F72\u540D\u8005\u3067\u3042\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002",
            edit: "\u7DE8\u96C6",
            "bacs.confirm": "\u78BA\u8A8D\u3057\u3066\u652F\u6255\u3046",
            "bacs.result.introduction": "\u81EA\u52D5\u5F15\u304D\u843D\u3068\u3057\u306E\u8AAC\u660E (DDI/\u59D4\u4EFB\u72B6) \u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B",
            "download.pdf": "PDF\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "\u30AB\u30FC\u30C9\u756A\u53F7\u306Eiframe",
            "creditCard.encryptedCardNumber.aria.label": "\u30AB\u30FC\u30C9\u756A\u53F7",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "\u6709\u52B9\u671F\u9650\u306Eiframe",
            "creditCard.encryptedExpiryDate.aria.label": "\u6709\u52B9\u671F\u9650",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "\u6709\u52B9\u671F\u9650\u6708\u306Eiframe",
            "creditCard.encryptedExpiryMonth.aria.label": "\u6709\u52B9\u671F\u9650\u6708",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "\u6709\u52B9\u671F\u9650\u5E74\u306Eiframe",
            "creditCard.encryptedExpiryYear.aria.label": "\u6709\u52B9\u671F\u9650\u5E74",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9\u306Eiframe",
            "creditCard.encryptedSecurityCode.aria.label": "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9",
            "creditCard.encryptedPassword.aria.iframeTitle": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306Eiframe",
            "creditCard.encryptedPassword.aria.label": "\u30AB\u30FC\u30C9\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u6700\u521D\u306E2\u6841",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "\u30AB\u30FC\u30C9\u756A\u53F7\u306Eiframe",
            "giftcard.encryptedCardNumber.aria.label": "\u30AB\u30FC\u30C9\u756A\u53F7",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "PIN\u306Eiframe",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "\u3053\u306E\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u3067\u306E\u53D6\u5F15\u3054\u3068\u306B\u8A31\u53EF\u3055\u308C\u308B\u6700\u5927%{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "\u9280\u884C\u53E3\u5EA7\u756A\u53F7\u306Eiframe",
            "ach.encryptedBankAccountNumber.aria.label": "\u53E3\u5EA7\u756A\u53F7",
            "ach.encryptedBankLocationId.aria.iframeTitle": "\u9280\u884C\u652F\u5E97\u756A\u53F7\u306Eiframe",
            "ach.encryptedBankLocationId.aria.label": "ABA\u30CA\u30F3\u30D0\u30FC",
            "twint.saved": "\u3092\u4FDD\u5B58\u3057\u307E\u3057\u305F",
            orPayWith: "\u307E\u305F\u306F\u6B21\u306E\u65B9\u6CD5\u3067\u652F\u6255\u3046",
            invalidFormatExpects: "\u7121\u52B9\u306A\u5F62\u5F0F\u3067\u3059\u3002\u671F\u5F85\u3055\u308C\u308B\u5F62\u5F0F\uFF1A %{format}",
            "upi.qrCodeWaitingMessage": "\u304A\u597D\u307F\u306EUPI\u30A2\u30D7\u30EA\u3092\u4F7F\u7528\u3057\u3066QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3001\u652F\u6255\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044",
            "upi.vpaWaitingMessage": "UPI\u30A2\u30D7\u30EA\u3092\u958B\u3044\u3066\u3001\u652F\u6255\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044",
            "upi.modeSelection": "UPI\u306E\u4F7F\u7528\u65B9\u6CD5\u3092\u9078\u629E\u3057\u307E\u3059\u3002",
            "onlineBanking.termsAndConditions": "\u7D9A\u884C\u3059\u308B\u3068\u3001%#\u5229\u7528\u898F\u7D04%#\u306B\u540C\u610F\u3057\u305F\u3053\u3068\u306B\u306A\u308A\u307E\u3059",
            "onlineBankingPL.termsAndConditions": "\u7D9A\u884C\u3059\u308B\u3068\u3001Przelewy24\u306E%#\u898F\u5236%#\u3068%#\u60C5\u5831\u63D0\u4F9B\u7FA9\u52D9%#\u306B\u540C\u610F\u3057\u305F\u3053\u3068\u306B\u306A\u308A\u307E\u3059",
            "ctp.loading.poweredByCtp": "Click to Pay\u63D0\u4F9B",
            "ctp.loading.intro": "Click to Pay\u306B\u30AB\u30FC\u30C9\u304C\u4FDD\u5B58\u3055\u308C\u3066\u3044\u308B\u304B\u3069\u3046\u304B\u3092\u78BA\u8A8D\u3057\u3066\u3044\u307E\u3059...",
            "ctp.login.title": "Click to Pay\u306B\u9032\u3080",
            "ctp.login.subtitle": "\u7D9A\u884C\u3059\u308B\u306B\u306F\u3001Click to Pay\u306B\u9023\u643A\u3055\u308C\u3066\u3044\u308B\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.login.inputLabel": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
            "ctp.logout.notYou": "\u3054\u81EA\u5206\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F",
            "ctp.logout.notYourCards": "\u3054\u81EA\u5206\u306E\u30AB\u30FC\u30C9\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F",
            "ctp.logout.notYourCard": "\u3054\u81EA\u5206\u306E\u30AB\u30FC\u30C9\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F",
            "ctp.logout.notYourProfile": "\u3054\u81EA\u5206\u306E\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F",
            "ctp.otp.fieldLabel": "\u30EF\u30F3\u30BF\u30A4\u30E0\u30B3\u30FC\u30C9",
            "ctp.otp.resendCode": "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1\u3059\u308B",
            "ctp.otp.codeResent": "\u30B3\u30FC\u30C9\u304C\u518D\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F",
            "ctp.otp.title": "Click to Pay\u30AB\u30FC\u30C9\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B",
            "ctp.otp.subtitle": "%@\u304B\u3089%@\u306B\u9001\u4FE1\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u3001\u3054\u672C\u4EBA\u3067\u3042\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.otp.saveCookiesCheckbox.label": "\u6B21\u56DE\u306F\u691C\u8A3C\u3092\u30B9\u30AD\u30C3\u30D7\u3059\u308B",
            "ctp.otp.saveCookiesCheckbox.information": "\u5BFE\u8C61\u5E97\u8217\u3067\u3001\u304A\u4F7F\u3044\u306E\u30C7\u30D0\u30A4\u30B9\u3068\u30D6\u30E9\u30A6\u30B6\u3067\u8A18\u61B6\u3055\u305B\u308B\u3088\u3046\u306B\u9078\u629E\u3059\u308B\u3068\u3001\u3088\u308A\u8FC5\u901F\u306A\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u304C\u53EF\u80FD\u306B\u306A\u308A\u307E\u3059\u3002\u5171\u6709\u30C7\u30D0\u30A4\u30B9\u3067\u306F\u63A8\u5968\u3055\u308C\u307E\u305B\u3093\u3002",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "\u9078\u629E\u3059\u308B\u3068\u3001\u304A\u4F7F\u3044\u306E\u30C7\u30D0\u30A4\u30B9\u3068\u30D6\u30E9\u30A6\u30B6\u306B\u8A18\u61B6\u3055\u308C\u307E\u3059",
            "ctp.emptyProfile.message": "\u3053\u306EClick to Pay\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u306B\u767B\u9332\u3055\u308C\u3066\u3044\u308B\u30AB\u30FC\u30C9\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
            "ctp.separatorText": "\u307E\u305F\u306F\u4EE5\u4E0B\u3092\u4F7F\u7528",
            "ctp.cards.title": "Click to Pay\u3067\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3059\u308B",
            "ctp.cards.subtitle": "\u4F7F\u7528\u3059\u308B\u30AB\u30FC\u30C9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.cards.expiredCard": "\u671F\u9650\u5207\u308C",
            "ctp.manualCardEntry": "\u624B\u52D5\u30AB\u30FC\u30C9\u5165\u529B",
            "ctp.aria.infoModalButton": "Click to Pay\u3068\u306F",
            "ctp.infoPopup.title": "Click to Pay\u306F\u30AA\u30F3\u30E9\u30A4\u30F3\u3067\u975E\u63A5\u89E6\u578B\u30AB\u30FC\u30C9\u306E\u4F7F\u3044\u3084\u3059\u3055\u3092\u5B9F\u73FE\u3057\u307E\u3059",
            "ctp.infoPopup.subtitle": "Mastercard\u3001Visa\u3001\u305D\u306E\u4ED6\u306E\u652F\u6255\u30AB\u30FC\u30C9\u3067\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u308B\u9AD8\u901F\u3067\u5B89\u5168\u306A\u652F\u6255\u65B9\u6CD5\u3002",
            "ctp.infoPopup.benefit1": "Click to Pay\u306F\u6697\u53F7\u5316\u3092\u4F7F\u7528\u3057\u3066\u60C5\u5831\u3092\u5B89\u5168\u306B\u4FDD\u8B77\u3057\u307E\u3059",
            "ctp.infoPopup.benefit2": "\u4E16\u754C\u4E2D\u306E\u696D\u8005\u3067\u4F7F\u7528\u3067\u304D\u307E\u3059",
            "ctp.infoPopup.benefit3": "\u4E00\u5EA6\u8A2D\u5B9A\u3059\u308B\u3060\u3051\u3067\u3001\u4ECA\u5F8C\u306E\u652F\u6255\u3044\u304C\u7C21\u5358\u306B\u306A\u308A\u307E\u3059",
            "ctp.errors.AUTH_INVALID": "\u8A8D\u8A3C\u304C\u7121\u52B9\u3067\u3059",
            "ctp.errors.NOT_FOUND": "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002\u6709\u52B9\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3059\u308B\u304B\u3001\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u306A\u3044\u5F62\u5F0F\u3067\u3059",
            "ctp.errors.FRAUD": "\u30E6\u30FC\u30B6\u30FC\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u308B\u304B\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059",
            "ctp.errors.CONSUMER_ID_MISSING": "\u30EA\u30AF\u30A8\u30B9\u30C8\u306B\u30B3\u30F3\u30B7\u30E5\u30FC\u30DE\u30FCID\u304C\u3042\u308A\u307E\u305B\u3093",
            "ctp.errors.ACCT_INACCESSIBLE": "\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u308B\u306A\u3069\u306E\u7406\u7531\u306B\u3088\u308A\u3001\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u73FE\u5728\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002",
            "ctp.errors.CODE_INVALID": "\u78BA\u8A8D\u30B3\u30FC\u30C9\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093",
            "ctp.errors.CODE_EXPIRED": "\u3053\u306E\u30B3\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059",
            "ctp.errors.RETRIES_EXCEEDED": "\u30EF\u30F3\u30BF\u30A4\u30E0\u30D1\u30B9\u30EF\u30FC\u30C9\u751F\u6210\u306E\u30EA\u30C8\u30E9\u30A4\u56DE\u6570\u304C\u4E0A\u9650\u3092\u8D85\u3048\u307E\u3057\u305F",
            "ctp.errors.OTP_SEND_FAILED": "\u30EF\u30F3\u30BF\u30A4\u30E0\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u53D7\u4FE1\u8005\u306B\u9001\u4FE1\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
            "ctp.errors.REQUEST_TIMEOUT": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.errors.UNKNOWN_ERROR": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.errors.SERVICE_ERROR": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.errors.SERVER_ERROR": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.errors.INVALID_PARAMETER": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ctp.errors.AUTH_ERROR": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "paymentMethodsList.aria.label": "\u304A\u652F\u6255\u3044\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            "companyDetails.name.invalid": "\u4F1A\u793E\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "companyDetails.registrationNumber.invalid": "\u767B\u9332\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "consent.checkbox.invalid": "\u5229\u7528\u898F\u7D04\u306B\u540C\u610F\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059",
            "form.instruction": "\u7279\u306B\u660E\u8A18\u3055\u308C\u3066\u3044\u306A\u3044\u9650\u308A\u3001\u3059\u3079\u3066\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306F\u5FC5\u9808\u3067\u3059\u3002",
            "trustly.descriptor": "\u5373\u6642\u9280\u884C\u652F\u6255",
            "trustly.description1": "\u3054\u5229\u7528\u306E\u9280\u884C\u53E3\u5EA7\u304B\u3089\u76F4\u63A5\u304A\u652F\u6255\u3044\u53EF\u80FD\uFF08\u9280\u884C\u30EC\u30D9\u30EB\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3067\u4FDD\u8B77\u3055\u308C\u3066\u3044\u307E\u3059\uFF09",
            "trustly.description2": "\u30AB\u30FC\u30C9\u306A\u3057\u3001\u30A2\u30D7\u30EA\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u306A\u3057\u3001\u767B\u9332\u306A\u3057",
            "ancv.input.label": "ANCV ID",
            "ancv.confirmPayment": "ANCV\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u3001\u652F\u6255\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            "ancv.form.instruction": "\u3053\u306E\u652F\u6255\u3092\u691C\u8A3C\u3059\u308B\u306B\u306F\u3001Cheque-Vacances\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u304C\u5FC5\u8981\u3067\u3059\u3002",
            "ancv.beneficiaryId.invalid": "\u6709\u52B9\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u307E\u305F\u306FANCV ID\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            "payme.openPayMeApp": "PayMe\u30A2\u30D7\u30EA\u3067\u627F\u8A8D\u3057\u3066\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3057\u3001\u78BA\u8A8D\u3092\u5F85\u3061\u307E\u3059\u3002",
            "payme.redirectButtonLabel": "PayMe\u30A2\u30D7\u30EA\u3092\u958B\u304F",
            "payme.scanQrCode": "QR\u30B3\u30FC\u30C9\u3067\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3059\u308B",
            "payme.timeToPay": "\u3053\u306EQR\u30B3\u30FC\u30C9\u306F%@\u6709\u52B9\u3067\u3059",
            "payme.instructions.steps": "PayMe\u30A2\u30D7\u30EA\u3092\u958B\u304D\u307E\u3059\u3002%@QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u652F\u6255\u3044\u3092\u627F\u8A8D\u3057\u307E\u3059\u3002%@\u30A2\u30D7\u30EA\u3067\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3057\u3001\u78BA\u8A8D\u3092\u5F85\u3061\u307E\u3059\u3002",
            "payme.instructions.footnote": "\u652F\u6255\u3044\u304C\u5B8C\u4E86\u3059\u308B\u307E\u3067\u3053\u306E\u30DA\u30FC\u30B8\u3092\u9589\u3058\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
        }
    }), a2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "\uACB0\uC81C",
            "payButton.redirecting": "\uB9AC\uB514\uB809\uC158 \uC911...",
            "payButton.with": "%{maskedData}(\uC73C)\uB85C %{value} \uACB0\uC81C",
            "payButton.saveDetails": "\uC138\uBD80 \uC815\uBCF4 \uC800\uC7A5",
            close: "\uB2EB\uAE30",
            storeDetails: "\uB2E4\uC74C \uACB0\uC81C\uB97C \uC704\uD574 \uC774 \uC218\uB2E8 \uC800\uC7A5",
            readMore: "\uC790\uC138\uD788 \uBCF4\uAE30",
            "creditCard.holderName": "\uCE74\uB4DC\uC0C1\uC758 \uC774\uB984",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "\uCE74\uB4DC\uC5D0 \uD45C\uC2DC\uB41C \uB300\uB85C \uC774\uB984\uC744 \uC785\uB825\uD569\uB2C8\uB2E4.",
            "creditCard.numberField.title": "\uCE74\uB4DC \uBC88\uD638",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "\uB9CC\uB8CC\uC77C",
            "creditCard.expiryDateField.placeholder": "MM/YY",
            "creditCard.expiryDateField.month": "\uC6D4",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "YY",
            "creditCard.expiryDateField.year": "\uC5F0\uB3C4",
            "creditCard.cvcField.title": "\uBCF4\uC548 \uCF54\uB4DC",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "\uB2E4\uC74C\uC744 \uC704\uD574 \uC800\uC7A5",
            "creditCard.cvcField.placeholder.4digits": "4\uC790\uB9AC",
            "creditCard.cvcField.placeholder.3digits": "3\uC790\uB9AC",
            "creditCard.taxNumber.placeholder": "YYMMDD / 0123456789",
            installments: "\uD560\uBD80 \uAC1C\uC6D4 \uC218",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times}\uAC1C\uC6D4",
            "installments.oneTime": "\uC77C\uC2DC\uBD88 \uACB0\uC81C",
            "installments.installments": "\uD560\uBD80 \uACB0\uC81C",
            "installments.revolving": "\uB9AC\uBCFC\uBE59 \uACB0\uC81C",
            "sepaDirectDebit.ibanField.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uACC4\uC88C \uBC88\uD638",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "\uC18C\uC720\uC790 \uC774\uB984",
            "sepa.ibanNumber": "\uACC4\uC88C \uBC88\uD638(IBAN)",
            "error.title": "\uC624\uB958",
            "error.subtitle.redirect": "\uB9AC\uB514\uB809\uC158 \uC2E4\uD328",
            "error.subtitle.payment": "\uACB0\uC81C \uC2E4\uD328",
            "error.subtitle.refused": "\uACB0\uC81C \uAC70\uBD80",
            "error.message.unknown": "\uC54C \uC218 \uC5C6\uB294 \uC624\uB958 \uBC1C\uC0DD",
            "errorPanel.title": "\uAE30\uC874 \uC624\uB958",
            "idealIssuer.selectField.title": "\uC740\uD589",
            "idealIssuer.selectField.placeholder": "\uC740\uD589 \uC120\uD0DD",
            "creditCard.success": "\uACB0\uC81C \uC131\uACF5",
            loading: "\uB85C\uB4DC \uC911\u2026",
            continue: "\uACC4\uC18D",
            continueTo: "\uB2E4\uC74C\uC73C\uB85C \uACC4\uC18D:",
            "wechatpay.timetopay": "\uB0A8\uC740 \uACB0\uC81C \uC2DC\uD55C: %@",
            "sr.wechatpay.timetopay": "%#\uBD84%# %#\uCD08%# \uB0B4\uB85C \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uC138\uC694.",
            "wechatpay.scanqrcode": "QR \uCF54\uB4DC \uC2A4\uCE94",
            personalDetails: "\uAC1C\uC778 \uC815\uBCF4",
            companyDetails: "\uD68C\uC0AC \uC815\uBCF4",
            "companyDetails.name": "\uD68C\uC0AC\uBA85",
            "companyDetails.registrationNumber": "\uB4F1\uB85D \uBC88\uD638",
            socialSecurityNumber: "\uC0AC\uD68C \uBCF4\uC7A5 \uBC88\uD638(\uC8FC\uBBFC\uB4F1\uB85D\uBC88\uD638)",
            firstName: "\uC774\uB984",
            "firstName.invalid": "\uC774\uB984\uC744 \uC785\uB825\uD558\uC138\uC694.",
            infix: "\uBA85\uCE6D",
            lastName: "\uC131",
            "lastName.invalid": "\uC131\uC744 \uC785\uB825\uD558\uC138\uC694.",
            mobileNumber: "\uD734\uB300\uD3F0 \uBC88\uD638",
            "mobileNumber.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uD734\uB300\uD3F0 \uBC88\uD638",
            city: "\uC2DC",
            postalCode: "\uC6B0\uD3B8\uBC88\uD638",
            "postalCode.optional": "\uC6B0\uD3B8\uBC88\uD638(\uC120\uD0DD \uC0AC\uD56D)",
            countryCode: "\uAD6D\uAC00 \uCF54\uB4DC",
            telephoneNumber: "\uC804\uD654\uBC88\uD638",
            dateOfBirth: "\uC0DD\uB144\uC6D4\uC77C",
            shopperEmail: "\uC774\uBA54\uC77C \uC8FC\uC18C",
            gender: "\uC131\uBCC4",
            "gender.notselected": "\uC131\uBCC4 \uC120\uD0DD",
            male: "\uB0A8\uC131",
            female: "\uC5EC\uC131",
            billingAddress: "\uCCAD\uAD6C\uC9C0 \uC8FC\uC18C",
            street: "\uB3C4\uB85C\uBA85",
            stateOrProvince: "\uC8FC/\uB3C4",
            country: "\uAD6D\uAC00",
            houseNumberOrName: "\uC9D1 \uC804\uD654\uBC88\uD638",
            separateDeliveryAddress: "\uBC30\uC1A1 \uC8FC\uC18C \uBCC4\uB3C4 \uC9C0\uC815",
            deliveryAddress: "\uBC30\uC1A1 \uC8FC\uC18C",
            "deliveryAddress.firstName": "\uBC1B\uB294 \uC0AC\uB78C \uC774\uB984",
            "deliveryAddress.lastName": "\uBC1B\uB294 \uC0AC\uB78C \uC131",
            zipCode: "\uC6B0\uD3B8\uBC88\uD638",
            apartmentSuite: "\uC544\uD30C\uD2B8/\uAC74\uBB3C",
            provinceOrTerritory: "\uB3C4",
            cityTown: "\uC2DC/\uAD6C",
            address: "\uC8FC\uC18C",
            "address.placeholder": "\uC8FC\uC18C \uCC3E\uAE30",
            "address.errors.incomplete": "\uACC4\uC18D \uC9C4\uD589\uD558\uB824\uBA74 \uC8FC\uC18C \uC785\uB825",
            "address.enterManually": "\uC218\uB3D9\uC73C\uB85C \uC8FC\uC18C \uC785\uB825",
            state: "\uC8FC",
            "field.title.optional": "(\uC120\uD0DD \uC0AC\uD56D)",
            "creditCard.cvcField.title.optional": "\uBCF4\uC548 \uCF54\uB4DC(\uC120\uD0DD \uC0AC\uD56D)",
            "issuerList.wallet.placeholder": "\uC804\uC790 \uC9C0\uAC11 \uC120\uD0DD",
            privacyPolicy: "\uAC1C\uC778\uC815\uBCF4 \uBCF4\uD638\uC815\uCC45",
            "afterPay.agreement": "Riverty\uC758 %@\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4.",
            paymentConditions: "\uACB0\uC81C \uC870\uAC74",
            openApp: "\uC571 \uC5F4\uAE30",
            "voucher.readInstructions": "\uC548\uB0B4 \uC77D\uAE30",
            "voucher.introduction": "\uAD6C\uB9E4\uD574 \uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4. \uB2E4\uC74C \uCFE0\uD3F0\uC744 \uC0AC\uC6A9\uD558\uC5EC \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uC2ED\uC2DC\uC624.",
            "voucher.expirationDate": "\uB9CC\uB8CC\uC77C",
            "voucher.alternativeReference": "\uB300\uCCB4 \uCC38\uC870\uBC88\uD638",
            "dragonpay.voucher.non.bank.selectField.placeholder": "\uC81C\uACF5 \uC5C5\uCCB4 \uC120\uD0DD",
            "dragonpay.voucher.bank.selectField.placeholder": "\uC740\uD589 \uC120\uD0DD",
            "voucher.paymentReferenceLabel": "\uACB0\uC81C \uCC38\uC870\uBC88\uD638",
            "voucher.surcharge": "%@ \uD560\uC99D\uB8CC \uD3EC\uD568",
            "voucher.introduction.doku": "\uAD6C\uB9E4\uD574 \uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4. \uB2E4\uC74C \uC815\uBCF4\uB97C \uC774\uC6A9\uD558\uC5EC \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uC2ED\uC2DC\uC624.",
            "voucher.shopperName": "\uAD6C\uB9E4\uC790 \uC774\uB984",
            "voucher.merchantName": "\uAC00\uB9F9\uC810",
            "voucher.introduction.econtext": "\uAD6C\uB9E4\uD574 \uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4. \uB2E4\uC74C \uC815\uBCF4\uB97C \uC774\uC6A9\uD558\uC5EC \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uC2ED\uC2DC\uC624.",
            "voucher.telephoneNumber": "\uC804\uD654\uBC88\uD638",
            "voucher.shopperReference": "\uAD6C\uB9E4\uC790 \uCC38\uC870\uBC88\uD638",
            "voucher.collectionInstitutionNumber": "\uC218\uAE08 \uAE30\uAD00 \uBC88\uD638",
            "voucher.econtext.telephoneNumber.invalid": "\uC804\uD654\uBC88\uD638\uB294 10\uC790\uB9AC \uB610\uB294 11\uC790\uB9AC \uC22B\uC790\uC5EC\uC57C \uD569\uB2C8\uB2E4",
            "boletobancario.btnLabel": "Boleto \uC0DD\uC131",
            "boleto.sendCopyToEmail": "\uB0B4 \uC774\uBA54\uC77C\uB85C \uC0AC\uBCF8 \uBCF4\uB0B4\uAE30",
            "button.copy": "\uBCF5\uC0AC",
            "button.download": "\uB2E4\uC6B4\uB85C\uB4DC",
            "boleto.socialSecurityNumber.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uD544\uB4DC\uC785\uB2C8\uB2E4",
            "creditCard.storedCard.description.ariaLabel": "\uC800\uC7A5\uB41C \uCE74\uB4DC\uB294 %@ \uD6C4 \uC885\uB8CC\uB429\uB2C8\uB2E4.",
            "voucher.entity": "\uBC1C\uAE09\uC0AC",
            donateButton: "\uAE30\uBD80\uD558\uAE30",
            notNowButton: "\uB2E4\uC74C\uC5D0 \uD558\uAE30",
            thanksForYourSupport: "\uB3C4\uC640\uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4!",
            "resultMessages.preauthorized": "\uC138\uBD80 \uC815\uBCF4 \uC800\uC7A5\uB428",
            preauthorizeWith: "\uC0AC\uC804 \uC2B9\uC778 \uBC29\uBC95:",
            confirmPreauthorization: "\uC0AC\uC804 \uC2B9\uC778 \uD655\uC778",
            confirmPurchase: "\uAD6C\uB9E4 \uD655\uC778",
            applyGiftcard: "\uAE30\uD504\uD2B8 \uCE74\uB4DC\uB85C \uACB0\uC81C",
            giftcardBalance: "\uAE30\uD504\uD2B8 \uCE74\uB4DC \uC794\uC561",
            deductedBalance: "\uACF5\uC81C \uC794\uC561",
            "creditCard.pin.title": "\uBE44\uBC00\uBC88\uD638",
            "creditCard.encryptedPassword.label": "\uCE74\uB4DC \uBE44\uBC00\uBC88\uD638 \uCCAB 2\uC790\uB9AC",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uBC88\uD638",
            "creditCard.taxNumber": "\uCE74\uB4DC \uC18C\uC720\uC790 \uC0DD\uB144\uC6D4\uC77C \uB610\uB294 \uBC95\uC778 \uB4F1\uB85D \uBC88\uD638",
            "creditCard.taxNumber.label": "\uCE74\uB4DC \uC18C\uC720\uC790 \uC0DD\uB144\uC6D4\uC77C(\uC608: 870130) \uB610\uB294 \uBC95\uC778 \uB4F1\uB85D \uBC88\uD638(10\uC790\uB9AC)",
            "creditCard.taxNumber.labelAlt": "\uBC95\uC778 \uB4F1\uB85D \uBC88\uD638(10\uC790\uB9AC)",
            "creditCard.taxNumber.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uCE74\uB4DC \uC18C\uC720\uC790 \uC0DD\uB144\uC6D4\uC77C \uB610\uB294 \uBC95\uC778 \uB4F1\uB85D \uBC88\uD638",
            "storedPaymentMethod.disable.button": "\uC0AD\uC81C",
            "storedPaymentMethod.disable.confirmation": "\uC800\uC7A5\uB41C \uACB0\uC81C \uC218\uB2E8 \uC0AD\uC81C",
            "storedPaymentMethod.disable.confirmButton": "\uC608, \uC0AD\uC81C\uD569\uB2C8\uB2E4",
            "storedPaymentMethod.disable.cancelButton": "\uCDE8\uC18C",
            "ach.bankAccount": "\uC740\uD589 \uACC4\uC88C",
            "ach.accountHolderNameField.title": "\uACC4\uC88C \uC18C\uC720\uC790 \uC774\uB984",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uACC4\uC88C \uC18C\uC720\uC790 \uC774\uB984",
            "ach.accountNumberField.title": "\uACC4\uC88C \uBC88\uD638",
            "ach.accountNumberField.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uACC4\uC88C \uBC88\uD638",
            "ach.accountLocationField.title": "ABA \uB77C\uC6B0\uD305 \uBC88\uD638",
            "ach.accountLocationField.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 ABA \uB77C\uC6B0\uD305 \uBC88\uD638",
            "ach.savedBankAccount": "\uC800\uC7A5\uB41C \uC740\uD589 \uACC4\uC88C",
            "select.state": "\uC8FC \uC120\uD0DD",
            "select.stateOrProvince": "\uC8FC/\uB3C4 \uC120\uD0DD",
            "select.provinceOrTerritory": "\uB3C4 \uC120\uD0DD",
            "select.country": "\uAD6D\uAC00 \uC120\uD0DD",
            "select.noOptionsFound": "\uAC80\uC0C9\uB41C \uC635\uC158 \uC5C6\uC74C",
            "select.filter.placeholder": "\uAC80\uC0C9...",
            "telephoneNumber.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC804\uD654\uBC88\uD638",
            qrCodeOrApp: "\uB610\uB294",
            "paypal.processingPayment": "\uACB0\uC81C \uCC98\uB9AC \uC911...",
            generateQRCode: "QR \uCF54\uB4DC \uC0DD\uC131",
            "await.waitForConfirmation": "\uD655\uC778 \uB300\uAE30\uC911",
            "mbway.confirmPayment": "MB WAY \uC571\uC5D0\uC11C \uACB0\uC81C\uB97C \uD655\uC778\uD558\uC2ED\uC2DC\uC624",
            "shopperEmail.invalid": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC774\uBA54\uC77C \uC8FC\uC18C",
            "dateOfBirth.format": "DD(\uC77C)/MM(\uC6D4)/YYYY(\uC5F0\uB3C4)",
            "dateOfBirth.invalid": "\uB9CC 18\uC138 \uC774\uC0C1\uC784\uC744 \uB098\uD0C0\uB0B4\uB294 \uC720\uD6A8\uD55C \uC0DD\uB144\uC6D4\uC77C\uC744 \uC785\uB825\uD569\uB2C8\uB2E4.",
            "blik.confirmPayment": "\uBC45\uD0B9 \uC571\uC744 \uC5F4\uC5B4\uC11C \uACB0\uC81C\uB97C \uD655\uC778\uD558\uC138\uC694.",
            "blik.invalid": "6\uC790\uB9AC \uC22B\uC790 \uC785\uB825",
            "blik.code": "6\uC790\uB9AC \uCF54\uB4DC",
            "blik.help": "\uBC45\uD0B9 \uC571\uC5D0\uC11C \uCF54\uB4DC\uB97C \uAC00\uC838\uC624\uC138\uC694.",
            "swish.pendingMessage": "\uC2A4\uCE94 \uD6C4 \uCD5C\uB300 10\uBD84 \uB3D9\uC548 \uC0C1\uD0DC\uAC00 \uBCF4\uB958\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. 10\uBD84 \uB0B4\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD560 \uACBD\uC6B0 \uAE08\uC561\uC774 \uC5EC\uB7EC \uBC88 \uCCAD\uAD6C\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
            "field.valid": "\uD544\uB4DC\uAC00 \uC720\uD6A8\uD569\uB2C8\uB2E4",
            "field.invalid": "\uD544\uB4DC\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "error.va.gen.01": "\uBBF8\uC644\uB8CC \uD544\uB4DC",
            "error.va.gen.02": "\uD544\uB4DC\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "error.va.sf-cc-num.01": "\uC62C\uBC14\uB978 \uCE74\uB4DC \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-num.02": "\uCE74\uB4DC \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-num.03": "\uC9C0\uC6D0\uB418\uB294 \uCE74\uB4DC \uBE0C\uB79C\uB4DC\uB97C \uD558\uC138\uC694.",
            "error.va.sf-cc-num.04": "\uC804\uCCB4 \uCE74\uB4DC \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-dat.01": "\uC62C\uBC14\uB978 \uB9CC\uB8CC\uC77C\uC744 \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-dat.02": "\uC62C\uBC14\uB978 \uB9CC\uB8CC\uC77C\uC744 \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-dat.03": "\uC2E0\uC6A9 \uCE74\uB4DC\uAC00 \uACE7 \uB9CC\uB8CC\uB429\uB2C8\uB2E4.",
            "error.va.sf-cc-dat.04": "\uB9CC\uB8CC\uC77C\uC744 \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-dat.05": "\uC804\uCCB4 \uB9CC\uB8CC\uC77C\uC744 \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-mth.01": "\uB9CC\uB8CC \uC6D4\uC744 \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-yr.01": "\uB9CC\uB8CC \uC5F0\uB3C4\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-yr.02": "\uC804\uCCB4 \uB9CC\uB8CC \uC5F0\uB3C4\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-cvc.01": "\uBCF4\uC548 \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-cc-cvc.02": "\uC804\uCCB4 \uBCF4\uC548 \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "error.va.sf-ach-num.01": "\uACC4\uC88C \uBC88\uD638 \uC785\uB825\uB780\uC774 \uBE44\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
            "error.va.sf-ach-num.02": "\uACC4\uC88C \uBC88\uD638 \uAE38\uC774\uAC00 \uC815\uD655\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "error.va.sf-ach-loc.01": "\uC740\uD589 \uB77C\uC6B0\uD305 \uBC88\uD638 \uC785\uB825\uB780\uC774 \uBE44\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
            "error.va.sf-ach-loc.02": "\uC740\uD589 \uB77C\uC6B0\uD305 \uBC88\uD638 \uAE38\uC774\uAC00 \uC815\uD655\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "error.va.sf-kcp-pwd.01": "\uBE44\uBC00\uBC88\uD638 \uC785\uB825\uB780\uC774 \uBE44\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
            "error.va.sf-kcp-pwd.02": "\uBE44\uBC00\uBC88\uD638 \uAE38\uC774\uAC00 \uC798\uBABB\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
            "error.giftcard.no-balance": "\uC774 \uAE30\uD504\uD2B8 \uCE74\uB4DC\uC5D0\uB294 \uC794\uC561\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
            "error.giftcard.card-error": "\uC774 \uAE30\uD504\uD2B8 \uCE74\uB4DC \uBC88\uD638\uB294 \uB2F9\uC0AC\uC5D0 \uB4F1\uB85D\uB418\uC5B4 \uC788\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "error.giftcard.currency-error": "\uAE30\uD504\uD2B8 \uCE74\uB4DC\uB294 \uBC1C\uAE09\uB41C \uD1B5\uD654\uB85C\uB9CC \uC0AC\uC6A9\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
            "amazonpay.signout": "Amazon\uC5D0\uC11C \uB85C\uADF8\uC544\uC6C3",
            "amazonpay.changePaymentDetails": "\uACB0\uC81C \uC815\uBCF4 \uBCC0\uACBD",
            "partialPayment.warning": "\uB098\uBA38\uC9C0 \uBE44\uC6A9 \uC9C0\uBD88\uC5D0 \uC0AC\uC6A9\uD560 \uB2E4\uB978 \uACB0\uC81C \uC218\uB2E8 \uC120\uD0DD\uD558\uAE30",
            "partialPayment.remainingBalance": "\uB0A8\uC740 \uC794\uC561\uC740 %{amount}\uC785\uB2C8\uB2E4",
            "bankTransfer.beneficiary": "\uC218\uB839\uC778",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "\uCC38\uC870 \uBC88\uD638",
            "bankTransfer.introduction": "\uC0C8 \uACC4\uC88C \uC774\uCCB4 \uAC74\uC744 \uACC4\uC18D \uC9C4\uD589\uD569\uB2C8\uB2E4. \uB2E4\uC74C \uD654\uBA74\uC5D0 \uB098\uC624\uB294 \uC815\uBCF4\uB97C \uC774\uC6A9\uD574 \uC774\uCCB4\uB97C \uC644\uB8CC\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
            "bankTransfer.instructions": "\uAD6C\uB9E4\uD574 \uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4. \uB2E4\uC74C \uC815\uBCF4\uB97C \uC774\uC6A9\uD558\uC5EC \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uC2ED\uC2DC\uC624.",
            "bacs.accountHolderName": "\uC608\uAE08\uC8FC \uC774\uB984",
            "bacs.accountHolderName.invalid": "\uC608\uAE08\uC8FC \uC774\uB984\uC774 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "bacs.accountNumber": "\uACC4\uC88C \uBC88\uD638",
            "bacs.accountNumber.invalid": "\uACC4\uC88C \uBC88\uD638\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "bacs.bankLocationId": "\uC740\uD589 \uC2DD\uBCC4 \uCF54\uB4DC",
            "bacs.bankLocationId.invalid": "\uC740\uD589 \uC2DD\uBCC4 \uCF54\uB4DC\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
            "bacs.consent.amount": "\uACC4\uC88C\uC5D0\uC11C \uC704\uC758 \uAE08\uC561\uC744 \uC774\uCCB4\uD558\uB294 \uAC83\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4.",
            "bacs.consent.account": "\uBCF8\uC778\uC774 \uC774 \uACC4\uC88C\uC758 \uC608\uAE08\uC8FC\uC774\uBA70, \uC774 \uACC4\uC88C\uC5D0\uC11C\uC758 \uC790\uB3D9 \uC774\uCCB4\uB97C \uC2B9\uC778\uD558\uAE30 \uC704\uD574 \uD544\uC694\uD55C \uC720\uC77C\uD55C \uC11C\uBA85\uC778\uC785\uB2C8\uB2E4.",
            edit: "\uC218\uC815",
            "bacs.confirm": "\uD655\uC778 \uBC0F \uACB0\uC81C",
            "bacs.result.introduction": "\uC790\uB3D9 \uC774\uCCB4 \uC548\uB0B4(DDI/\uD544\uC218) \uB2E4\uC6B4\uB85C\uB4DC",
            "download.pdf": "PDF \uB2E4\uC6B4\uB85C\uB4DC",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "\uCE74\uB4DC \uBC88\uD638\uC6A9 Iframe",
            "creditCard.encryptedCardNumber.aria.label": "\uCE74\uB4DC \uBC88\uD638",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "\uB9CC\uB8CC \uB0A0\uC9DC\uC6A9 Iframe",
            "creditCard.encryptedExpiryDate.aria.label": "\uB9CC\uB8CC\uC77C",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "\uB9CC\uB8CC \uC6D4\uC6A9 Iframe",
            "creditCard.encryptedExpiryMonth.aria.label": "\uB9CC\uB8CC \uC6D4",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "\uB9CC\uB8CC \uC5F0\uB3C4\uC6A9 Iframe",
            "creditCard.encryptedExpiryYear.aria.label": "\uB9CC\uB8CC \uC5F0\uB3C4",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "\uBCF4\uC548 \uCF54\uB4DC\uC6A9 Iframe",
            "creditCard.encryptedSecurityCode.aria.label": "\uBCF4\uC548 \uCF54\uB4DC",
            "creditCard.encryptedPassword.aria.iframeTitle": "\uBE44\uBC00\uBC88\uD638\uC6A9 Iframe",
            "creditCard.encryptedPassword.aria.label": "\uCE74\uB4DC \uBE44\uBC00\uBC88\uD638 \uCCAB 2\uC790\uB9AC",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "\uCE74\uB4DC \uBC88\uD638\uC6A9 Iframe",
            "giftcard.encryptedCardNumber.aria.label": "\uCE74\uB4DC \uBC88\uD638",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "\uD540\uC6A9 Iframe",
            "giftcard.encryptedSecurityCode.aria.label": "\uBE44\uBC00\uBC88\uD638",
            giftcardTransactionLimit: "\uC774 \uAE30\uD504\uD2B8\uCE74\uB4DC\uB85C \uAC74\uB2F9 \uACB0\uC81C \uAC00\uB2A5\uD55C \uCD5C\uACE0 \uC561\uC218\uB294 %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "\uC740\uD589 \uACC4\uC88C \uBC88\uD638\uC6A9 Iframe",
            "ach.encryptedBankAccountNumber.aria.label": "\uACC4\uC88C \uBC88\uD638",
            "ach.encryptedBankLocationId.aria.iframeTitle": "\uC740\uD589 \uB77C\uC6B0\uD305 \uBC88\uD638\uC6A9 Iframe",
            "ach.encryptedBankLocationId.aria.label": "ABA \uB77C\uC6B0\uD305 \uBC88\uD638",
            "twint.saved": "\uC800\uC7A5\uB428",
            orPayWith: "\uAE30\uD0C0 \uACB0\uC81C \uC218\uB2E8:",
            invalidFormatExpects: "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uD615\uC2DD\uC785\uB2C8\uB2E4. \uC608\uC0C1 \uD615\uC2DD: %{format}",
            "upi.qrCodeWaitingMessage": "\uC990\uACA8 \uC4F0\uB294 UPI \uC571\uC73C\uB85C QR \uCF54\uB4DC\uB97C \uC2A4\uCE94\uD558\uC5EC \uACB0\uC81C\uD558\uC138\uC694",
            "upi.vpaWaitingMessage": "UPI \uC571\uC744 \uC5F4\uC5B4 \uACB0\uC81C\uB97C \uD655\uC778\uD558\uC138\uC694",
            "upi.modeSelection": "UPI\uB97C \uC0AC\uC6A9\uD560 \uBC29\uC2DD\uC744 \uC120\uD0DD\uD558\uC138\uC694.",
            "onlineBanking.termsAndConditions": "\uACC4\uC18D \uC9C4\uD589\uD558\uB294 \uACBD\uC6B0 %#\uC774\uC6A9\uC57D\uAD00%#\uC5D0 \uB3D9\uC758\uD558\uAC8C \uB429\uB2C8\uB2E4.",
            "onlineBankingPL.termsAndConditions": "\uACC4\uC18D \uC9C4\uD589\uD568\uC73C\uB85C\uC368 \uADC0\uD558\uB294 Przelewy24\uC758 %#\uADDC\uC815%# \uBC0F %#\uC815\uBCF4 \uC758\uBB34%#\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4.",
            "ctp.loading.poweredByCtp": "Click to Pay \uC81C\uACF5",
            "ctp.loading.intro": "Click to Pay\uB85C \uC800\uC7A5\uB41C \uCE74\uB4DC\uAC00 \uC788\uB294\uC9C0 \uD655\uC778 \uC911\uC785\uB2C8\uB2E4...",
            "ctp.login.title": "Click to Pay \uACC4\uC18D \uC9C4\uD589",
            "ctp.login.subtitle": "\uACC4\uC18D\uD558\uB824\uBA74 Click to Pay\uC5D0 \uC5F0\uACB0\uB41C \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "ctp.login.inputLabel": "\uC774\uBA54\uC77C",
            "ctp.logout.notYou": "\uBCF8\uC778\uC774 \uC544\uB2C8\uC2E0\uAC00\uC694?",
            "ctp.logout.notYourCards": "\uBCF8\uC778\uC758 \uCE74\uB4DC\uAC00 \uC544\uB2CC\uAC00\uC694?",
            "ctp.logout.notYourCard": "\uBCF8\uC778\uC758 \uCE74\uB4DC\uAC00 \uC544\uB2CC\uAC00\uC694?",
            "ctp.logout.notYourProfile": "\uBCF8\uC778\uC758 \uD504\uB85C\uD544\uC774 \uC544\uB2CC\uAC00\uC694?",
            "ctp.otp.fieldLabel": "\uC77C\uD68C\uC131 \uCF54\uB4DC",
            "ctp.otp.resendCode": "\uCF54\uB4DC \uC7AC\uC804\uC1A1",
            "ctp.otp.codeResent": "\uCF54\uB4DC \uC7AC\uC804\uC1A1\uB428",
            "ctp.otp.title": "Click to Pay \uCE74\uB4DC\uC5D0 \uC811\uADFC",
            "ctp.otp.subtitle": "%@\uB85C \uC804\uC1A1\uB41C %@ \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC5EC \uBCF8\uC778 \uC778\uC99D\uC744 \uC9C4\uD589\uD569\uB2C8\uB2E4.",
            "ctp.otp.saveCookiesCheckbox.label": "\uB2E4\uC74C \uBC88\uC5D0\uB294 \uC778\uC99D \uAC74\uB108\uB6F0\uAE30",
            "ctp.otp.saveCookiesCheckbox.information": "\uB354 \uBE60\uB978 \uACB0\uC81C\uB97C \uC704\uD574 \uC0AC\uC6A9\uC790 \uAE30\uAE30\uC640 \uCC38\uC5EC \uB9E4\uC7A5\uC758 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uC815\uBCF4\uB97C \uAE30\uC5B5\uD558\uB3C4\uB85D \uC120\uD0DD\uD558\uC138\uC694. \uACF5\uC720 \uAE30\uAE30\uC5D0\uB294 \uAD8C\uC7A5\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "\uC7A5\uCE58\uC640 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uAE30\uC5B5\uB418\uB3C4\uB85D \uC120\uD0DD\uD558\uAE30",
            "ctp.emptyProfile.message": "\uD574\uB2F9 Click to Pay \uD504\uB85C\uD544\uC5D0 \uB4F1\uB85D\uB41C \uCE74\uB4DC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4",
            "ctp.separatorText": "\uB610\uB294 \uC0AC\uC6A9",
            "ctp.cards.title": "Click to Pay\uB85C \uACB0\uC81C \uC644\uB8CC",
            "ctp.cards.subtitle": "\uC0AC\uC6A9\uD560 \uCE74\uB4DC\uB97C \uC120\uD0DD\uD558\uC138\uC694.",
            "ctp.cards.expiredCard": "\uB9CC\uB8CC\uB428",
            "ctp.manualCardEntry": "\uCE74\uB4DC \uC9C1\uC811 \uC785\uB825",
            "ctp.aria.infoModalButton": "Click to Pay\uB780?",
            "ctp.infoPopup.title": "Click to Pay\uB294 \uBE44\uC811\uCD09 \uACB0\uC81C\uC758 \uD3B8\uB9AC\uD568\uC744 \uC628\uB77C\uC778\uC73C\uB85C \uAC00\uC838\uC628 \uC11C\uBE44\uC2A4\uC785\uB2C8\uB2E4",
            "ctp.infoPopup.subtitle": "Mastercard, Visa, \uAE30\uD0C0 \uACB0\uC81C \uCE74\uB4DC\uB97C \uC9C0\uC6D0\uD558\uB294 \uBE60\uB974\uACE0 \uC548\uC804\uD55C \uACB0\uC81C \uC218\uB2E8\uC785\uB2C8\uB2E4.",
            "ctp.infoPopup.benefit1": "Click to Pay\uB294 \uC554\uD638\uD654\uB97C \uD1B5\uD574 \uC815\uBCF4\uB97C \uC548\uC804\uD558\uAC8C \uBCF4\uD638\uD569\uB2C8\uB2E4",
            "ctp.infoPopup.benefit2": "\uC804 \uC138\uACC4 \uAC00\uB9F9\uC810\uC5D0\uC11C \uC0AC\uC6A9\uD558\uC138\uC694",
            "ctp.infoPopup.benefit3": "\uD55C \uBC88\uB9CC \uC124\uC815\uD558\uBA74 \uC55E\uC73C\uB85C\uC758 \uACB0\uC81C\uAC00 \uAC04\uD3B8\uD574\uC9D1\uB2C8\uB2E4",
            "ctp.errors.AUTH_INVALID": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC778\uC99D\uC785\uB2C8\uB2E4",
            "ctp.errors.NOT_FOUND": "\uACC4\uC815\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC720\uD6A8\uD55C \uC774\uBA54\uC77C\uC744 \uC785\uB825\uD558\uAC70\uB098 \uCE74\uB4DC \uC815\uBCF4\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC5EC \uC9C4\uD589\uD558\uC138\uC694.",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "\uC9C0\uC6D0\uB418\uC9C0 \uC54A\uB294 \uD615\uC2DD\uC785\uB2C8\uB2E4",
            "ctp.errors.FRAUD": "\uC0AC\uC6A9\uC790 \uACC4\uC815\uC774 \uC7A0\uACA8 \uC788\uAC70\uB098 \uBE44\uD65C\uC131\uD654\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
            "ctp.errors.CONSUMER_ID_MISSING": "\uC694\uCCAD\uC5D0 \uC18C\uBE44\uC790 ID\uAC00 \uB204\uB77D\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
            "ctp.errors.ACCT_INACCESSIBLE": "\uC774 \uACC4\uC815\uC740 \uD604\uC7AC \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4(\uC608: \uC7A0\uACA8 \uC788\uC74C).",
            "ctp.errors.CODE_INVALID": "\uC798\uBABB\uB41C \uC778\uC99D \uCF54\uB4DC\uC785\uB2C8\uB2E4",
            "ctp.errors.CODE_EXPIRED": "\uB9CC\uB8CC\uB41C \uCF54\uB4DC\uC785\uB2C8\uB2E4",
            "ctp.errors.RETRIES_EXCEEDED": "OTP \uC0DD\uC131 \uC7AC\uC2DC\uB3C4 \uD69F\uC218 \uC81C\uD55C\uC744 \uCD08\uACFC\uD588\uC2B5\uB2C8\uB2E4",
            "ctp.errors.OTP_SEND_FAILED": "OTP\uB97C \uC218\uC2E0\uC778\uC5D0\uAC8C \uC804\uC1A1\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
            "ctp.errors.REQUEST_TIMEOUT": "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uCE74\uB4DC \uC815\uBCF4\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.",
            "ctp.errors.UNKNOWN_ERROR": "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uCE74\uB4DC \uC815\uBCF4\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.",
            "ctp.errors.SERVICE_ERROR": "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uCE74\uB4DC \uC815\uBCF4\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.",
            "ctp.errors.SERVER_ERROR": "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uCE74\uB4DC \uC815\uBCF4\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.",
            "ctp.errors.INVALID_PARAMETER": "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uCE74\uB4DC \uC815\uBCF4\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.",
            "ctp.errors.AUTH_ERROR": "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uCE74\uB4DC \uC815\uBCF4\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC138\uC694.",
            "paymentMethodsList.aria.label": "\uACB0\uC81C \uC218\uB2E8\uC744 \uC120\uD0DD\uD558\uC138\uC694",
            "companyDetails.name.invalid": "\uD68C\uC0AC \uC774\uB984\uC744 \uC785\uB825\uD558\uC138\uC694.",
            "companyDetails.registrationNumber.invalid": "\uB4F1\uB85D \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "consent.checkbox.invalid": "\uC774\uC6A9 \uC57D\uAD00\uC5D0 \uB3D9\uC758\uD574\uC57C \uD569\uB2C8\uB2E4.",
            "form.instruction": "\uBCC4\uB3C4\uB85C \uD45C\uC2DC\uB418\uC5B4 \uC788\uC9C0 \uC54A\uB294 \uD55C \uBAA8\uB4E0 \uD544\uB4DC\uB294 \uD544\uC218\uC785\uB2C8\uB2E4.",
            "trustly.descriptor": "\uC989\uC2DC \uC740\uD589 \uACB0\uC81C",
            "trustly.description1": "\uC740\uD589 \uC218\uC900\uC758 \uBCF4\uC548\uC774 \uC9C0\uC6D0\uB418\uB294 \uC740\uD589 \uACC4\uC88C\uC5D0\uC11C \uC9C1\uC811 \uACB0\uC81C\uD558\uC138\uC694.",
            "trustly.description2": "\uCE74\uB4DC, \uC571 \uB2E4\uC6B4\uB85C\uB4DC, \uB4F1\uB85D \uD544\uC694 \uC5C6\uC74C",
            "ancv.input.label": "\uB098\uC758 ANCV ID",
            "ancv.confirmPayment": "ANCV \uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC744 \uC0AC\uC6A9\uD574 \uACB0\uC81C\uB97C \uD655\uC778\uD558\uC138\uC694.",
            "ancv.form.instruction": "\uC774 \uACB0\uC81C\uB97C \uC778\uC99D\uD558\uB824\uBA74 Cheque-Vacances \uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC774 \uD544\uC694\uD569\uB2C8\uB2E4.",
            "ancv.beneficiaryId.invalid": "\uC720\uD6A8\uD55C \uC774\uBA54\uC77C \uC8FC\uC18C\uB098 ANCV ID\uB97C \uC785\uB825\uD558\uC138\uC694.",
            "payme.openPayMeApp": "PayMe \uC571\uC5D0\uC11C \uACB0\uC81C\uB97C \uC2B9\uC778\uD558\uC5EC \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uACE0 \uD655\uC778\uC744 \uAE30\uB2E4\uB9BD\uB2C8\uB2E4.",
            "payme.redirectButtonLabel": "PayMe \uC571 \uC5F4\uAE30",
            "payme.scanQrCode": "QR \uCF54\uB4DC\uB85C \uACB0\uC81C \uC644\uB8CC",
            "payme.timeToPay": "\uC774 QR \uCF54\uB4DC\uB294 %@ \uB3D9\uC548 \uC720\uD6A8\uD569\uB2C8\uB2E4",
            "payme.instructions.steps": "PayMe \uC571\uC744 \uC5FD\uB2C8\uB2E4.%@QR \uCF54\uB4DC\uB97C \uC2A4\uCE94\uD558\uC5EC \uACB0\uC81C\uB97C \uC2B9\uC778\uD569\uB2C8\uB2E4.%@\uC571\uC5D0\uC11C \uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uACE0 \uD655\uC778\uC744 \uAE30\uB2E4\uB9BD\uB2C8\uB2E4.",
            "payme.instructions.footnote": "\uACB0\uC81C\uAC00 \uC644\uB8CC\uB418\uAE30 \uC804\uC5D0 \uC774 \uD398\uC774\uC9C0\uB97C \uB2EB\uC9C0 \uB9C8\uC138\uC694."
        }
    }), n2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Betaal",
            "payButton.redirecting": "U wordt doorverwezen...",
            "payButton.with": "Betaal %{value} met %{maskedData}",
            "payButton.saveDetails": "Gegevens opslaan",
            close: "Sluiten",
            storeDetails: "Bewaar voor mijn volgende betaling",
            readMore: "Verder lezen",
            "creditCard.holderName": "Naam op kaart",
            "creditCard.holderName.placeholder": "J. Janssen",
            "creditCard.holderName.invalid": "Voer naam in zoals weergegeven op kaart",
            "creditCard.numberField.title": "Kaartnummer",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Vervaldatum",
            "creditCard.expiryDateField.placeholder": "MM/JJ",
            "creditCard.expiryDateField.month": "Maand",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "JJ",
            "creditCard.expiryDateField.year": "Jaar",
            "creditCard.cvcField.title": "Beveiligingscode",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Onthouden voor de volgende keer",
            "creditCard.cvcField.placeholder.4digits": "4 cijfers",
            "creditCard.cvcField.placeholder.3digits": "3 cijfers",
            "creditCard.taxNumber.placeholder": "JJMMDD / 0123456789",
            installments: "Aantal termijnen",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} maanden",
            "installments.oneTime": "Eenmalige betaling",
            "installments.installments": "Betaling termijnen",
            "installments.revolving": "Terugkerende betaling",
            "sepaDirectDebit.ibanField.invalid": "Ongeldig rekeningnummer",
            "sepaDirectDebit.nameField.placeholder": "J. Janssen",
            "sepa.ownerName": "Ten name van",
            "sepa.ibanNumber": "Rekeningnummer (IBAN)",
            "error.title": "Fout",
            "error.subtitle.redirect": "Doorsturen niet gelukt",
            "error.subtitle.payment": "Betaling is niet geslaagd",
            "error.subtitle.refused": "Betaling geweigerd",
            "error.message.unknown": "Er is een onbekende fout opgetreden",
            "errorPanel.title": "Bestaande fouten",
            "idealIssuer.selectField.title": "Bank",
            "idealIssuer.selectField.placeholder": "Selecteer uw bank",
            "creditCard.success": "Betaling geslaagd",
            loading: "Laden...",
            continue: "Doorgaan",
            continueTo: "Doorgaan naar",
            "wechatpay.timetopay": "U heeft %@ om te betalen",
            "sr.wechatpay.timetopay": "U hebt %#minuten%# %#seconden%# om te betalen",
            "wechatpay.scanqrcode": "QR-code scannen",
            personalDetails: "Persoonlijke gegevens",
            companyDetails: "Bedrijfsgegevens",
            "companyDetails.name": "Bedrijfsnaam",
            "companyDetails.registrationNumber": "Registratienummer",
            socialSecurityNumber: "Burgerservicenummer",
            firstName: "Voornaam",
            "firstName.invalid": "Voer je voornaam in",
            infix: "Voorvoegsel",
            lastName: "Achternaam",
            "lastName.invalid": "Voer je achternaam in",
            mobileNumber: "Telefoonnummer mobiel",
            "mobileNumber.invalid": "Ongeldig mobiel nummer",
            city: "Stad",
            postalCode: "Postcode",
            "postalCode.optional": "Postcode (optioneel)",
            countryCode: "Landcode",
            telephoneNumber: "Telefoonnummer",
            dateOfBirth: "Geboortedatum",
            shopperEmail: "E-mailadres",
            gender: "Geslacht",
            "gender.notselected": "Selecteer uw geslacht",
            male: "Man",
            female: "Vrouw",
            billingAddress: "Factuuradres",
            street: "Straatnaam",
            stateOrProvince: "Staat of provincie",
            country: "Land",
            houseNumberOrName: "Huisnummer",
            separateDeliveryAddress: "Een afwijkend bezorgadres opgeven",
            deliveryAddress: "Bezorgadres",
            "deliveryAddress.firstName": "Voornaam ontvanger",
            "deliveryAddress.lastName": "Achternaam ontvanger",
            zipCode: "Postcode",
            apartmentSuite: "Appartement/Suite",
            provinceOrTerritory: "Provincie of territorium",
            cityTown: "Stad",
            address: "Adres",
            "address.placeholder": "Zoek uw adres",
            "address.errors.incomplete": "Voer een adres in om verder te gaan",
            "address.enterManually": "Voer het adres handmatig in",
            state: "Staat",
            "field.title.optional": "(optioneel)",
            "creditCard.cvcField.title.optional": "Beveiligingscode (optioneel)",
            "issuerList.wallet.placeholder": "Selecteer uw portemonnee",
            privacyPolicy: "Privacybeleid",
            "afterPay.agreement": "Ik ga akkoord met de %@ van Riverty",
            paymentConditions: "betalingsvoorwaarden",
            openApp: "Open de app",
            "voucher.readInstructions": "Instructies lezen",
            "voucher.introduction": "Bedankt voor uw aankoop. Gebruik deze coupon om uw betaling te voltooien.",
            "voucher.expirationDate": "Vervaldatum",
            "voucher.alternativeReference": "Alternatieve referentie",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Selecteer uw aanbieder",
            "dragonpay.voucher.bank.selectField.placeholder": "Selecteer uw bank",
            "voucher.paymentReferenceLabel": "Betalingsreferentie",
            "voucher.surcharge": "Inclusief %@ toeslag",
            "voucher.introduction.doku": "Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.",
            "voucher.shopperName": "Klantnaam",
            "voucher.merchantName": "Verkoper",
            "voucher.introduction.econtext": "Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.",
            "voucher.telephoneNumber": "Telefoonnummer",
            "voucher.shopperReference": "Klant referentie",
            "voucher.collectionInstitutionNumber": "Nummer ophaallocatie",
            "voucher.econtext.telephoneNumber.invalid": "Het telefoonnummer moet uit 10 of 11 cijfers bestaan",
            "boletobancario.btnLabel": "Boleto genereren",
            "boleto.sendCopyToEmail": "Stuur een kopie naar mijn e-mailadres",
            "button.copy": "Kopi\xebren",
            "button.download": "Downloaden",
            "boleto.socialSecurityNumber.invalid": "Veld niet geldig",
            "creditCard.storedCard.description.ariaLabel": "Opgeslagen kaart eindigt op %@",
            "voucher.entity": "Entiteit",
            donateButton: "Doneren",
            notNowButton: "Niet nu",
            thanksForYourSupport: "Bedankt voor uw donatie!",
            "resultMessages.preauthorized": "Gegevens opgeslagen",
            preauthorizeWith: "Preautorisatie uitvoeren met",
            confirmPreauthorization: "Preautorisatie bevestigen",
            confirmPurchase: "Aankoop bevestigen",
            applyGiftcard: "Inwisselen",
            giftcardBalance: "Saldo cadeaukaart",
            deductedBalance: "Afgetrokken bedrag",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "Eerste twee cijfers van het wachtwoord van de kaart",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Ongeldig wachtwoord",
            "creditCard.taxNumber": "Geboortedatum of bedrijfsregistratienummer van kaarthouder",
            "creditCard.taxNumber.label": "Geboortedatum (JJ-MM-DD) of bedrijfsregistratienummer (10 cijfers) van kaarthouder",
            "creditCard.taxNumber.labelAlt": "Bedrijfsregistratienummer (10 cijfers)",
            "creditCard.taxNumber.invalid": "Geboortedatum of bedrijfsregistratienummer van kaarthouder is ongeldig",
            "storedPaymentMethod.disable.button": "Verwijderen",
            "storedPaymentMethod.disable.confirmation": "Opgeslagen betalingsmethode verwijderen",
            "storedPaymentMethod.disable.confirmButton": "Ja, verwijderen",
            "storedPaymentMethod.disable.cancelButton": "Annuleren",
            "ach.bankAccount": "Bankrekening",
            "ach.accountHolderNameField.title": "Naam rekeninghouder",
            "ach.accountHolderNameField.placeholder": "J. Janssen",
            "ach.accountHolderNameField.invalid": "Ongeldige naam rekeninghouder",
            "ach.accountNumberField.title": "Rekeningnummer",
            "ach.accountNumberField.invalid": "Ongeldig rekeningnummer",
            "ach.accountLocationField.title": "Routingnummer (ABA)",
            "ach.accountLocationField.invalid": "Ongeldig routingnummer (ABA)",
            "ach.savedBankAccount": "Opgeslagen bankrekening",
            "select.state": "Selecteer staat",
            "select.stateOrProvince": "Selecteer staat of provincie",
            "select.provinceOrTerritory": "Selecteer provincie of territorium",
            "select.country": "Selecteer land",
            "select.noOptionsFound": "Geen opties gevonden",
            "select.filter.placeholder": "Zoeken...",
            "telephoneNumber.invalid": "Ongeldig telefoonnummer",
            qrCodeOrApp: "of",
            "paypal.processingPayment": "Betaling wordt verwerkt...",
            generateQRCode: "Genereer QR-code",
            "await.waitForConfirmation": "Wacht op bevestiging",
            "mbway.confirmPayment": "Bevestig uw betaling via de MB WAY-app",
            "shopperEmail.invalid": "Ongeldig e-mailadres",
            "dateOfBirth.format": "DD/MM/JJJJ",
            "dateOfBirth.invalid": "Voer een geldige geboortedatum in die aangeeft dat u ten minste 18 jaar oud bent",
            "blik.confirmPayment": "Open uw bankapp om de betaling te bevestigen.",
            "blik.invalid": "Voer 6 cijfers in",
            "blik.code": "6-cijferige code",
            "blik.help": "Haal de code op in uw bankapp.",
            "swish.pendingMessage": "Nadat u hebt gescand, kan de status maximaal 10 minuten in behandeling zijn. Als u binnen deze periode opnieuw probeert te betalen, kunnen er meerdere keren kosten in rekening worden gebracht.",
            "field.valid": "Geldig veld",
            "field.invalid": "Veld niet geldig",
            "error.va.gen.01": "Onvolledig veld",
            "error.va.gen.02": "Veld niet geldig",
            "error.va.sf-cc-num.01": "Voer een geldig kaartnummer in",
            "error.va.sf-cc-num.02": "Voer het kaartnummer in",
            "error.va.sf-cc-num.03": "Voer een ondersteund kaartmerk in",
            "error.va.sf-cc-num.04": "Voer het volledige kaartnummer in",
            "error.va.sf-cc-dat.01": "Voer een geldige vervaldatum in",
            "error.va.sf-cc-dat.02": "Voer een geldige vervaldatum in",
            "error.va.sf-cc-dat.03": "Creditcard vervalt bijna",
            "error.va.sf-cc-dat.04": "Voer de vervaldatum in",
            "error.va.sf-cc-dat.05": "Voer de volledige vervaldatum in",
            "error.va.sf-cc-mth.01": "Voer de vervalmaand in",
            "error.va.sf-cc-yr.01": "Voer het vervaljaar in",
            "error.va.sf-cc-yr.02": "Voer het volledige vervaljaar in",
            "error.va.sf-cc-cvc.01": "Voer de beveiligingscode in",
            "error.va.sf-cc-cvc.02": "Voer de volledige beveiligingscode in",
            "error.va.sf-ach-num.01": "Leeg veld voor bankrekeningnummer",
            "error.va.sf-ach-num.02": "Bankrekeningnummer heeft de verkeerde lengte",
            "error.va.sf-ach-loc.01": "Leeg veld voor swiftcode van de bank",
            "error.va.sf-ach-loc.02": "Swiftcode van de bank heeft de verkeerde lengte",
            "error.va.sf-kcp-pwd.01": "Leeg wachtwoordveld",
            "error.va.sf-kcp-pwd.02": "Wachtwoord heeft de verkeerde lengte",
            "error.giftcard.no-balance": "Deze cadeaukaart heeft geen saldo",
            "error.giftcard.card-error": "We hebben geen cadeaukaart met dit nummer in onze administratie",
            "error.giftcard.currency-error": "Cadeaukaarten zijn alleen geldig in de valuta waarin ze zijn uitgegeven",
            "amazonpay.signout": "Afmelden bij Amazon",
            "amazonpay.changePaymentDetails": "Betalingsgegevens wijzigen",
            "partialPayment.warning": "Selecteer een andere betaalmethode om het resterende deel te betalen",
            "partialPayment.remainingBalance": "Het resterende saldo is %{amount}",
            "bankTransfer.beneficiary": "Begunstigde",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Referentie",
            "bankTransfer.introduction": "Ga door om een nieuwe overschrijving aan te maken. U kunt de gegevens in het volgende scherm gebruiken om deze betaling af te ronden.",
            "bankTransfer.instructions": "Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.",
            "bacs.accountHolderName": "Naam bankrekeninghouder",
            "bacs.accountHolderName.invalid": "Ongeldige naam bankrekeninghouder",
            "bacs.accountNumber": "Bankrekeningnummer",
            "bacs.accountNumber.invalid": "Ongeldig bankrekeningnummer",
            "bacs.bankLocationId": "Bankcode",
            "bacs.bankLocationId.invalid": "Ongeldige bankcode",
            "bacs.consent.amount": "Ik ga ermee akkoord dat het bovengenoemde bedrag van mijn bankrekening wordt afgeschreven.",
            "bacs.consent.account": "Ik bevestig dat de rekening op mijn naam staat en dat ik de enige ondertekenaar ben die toestemming kan geven voor automatische incasso's vanaf deze rekening.",
            edit: "Bewerken",
            "bacs.confirm": "Bevestigen en betalen",
            "bacs.result.introduction": "Download uw machtiging automatische incasso",
            "download.pdf": "PDF downloaden",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe voor kaartnummer",
            "creditCard.encryptedCardNumber.aria.label": "Kaartnummer",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe voor vervaldatum",
            "creditCard.encryptedExpiryDate.aria.label": "Vervaldatum",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe voor vervalmaand",
            "creditCard.encryptedExpiryMonth.aria.label": "Vervalmaand",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe voor vervaljaar",
            "creditCard.encryptedExpiryYear.aria.label": "Vervaljaar",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe voor beveiligingscode",
            "creditCard.encryptedSecurityCode.aria.label": "Beveiligingscode",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe voor wachtwoord",
            "creditCard.encryptedPassword.aria.label": "Eerste twee cijfers van het wachtwoord van de kaart",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe voor kaartnummer",
            "giftcard.encryptedCardNumber.aria.label": "Kaartnummer",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe voor PIN",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Max. %{amount} toegestaan per transactie met deze cadeaubon",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe voor bankrekeningnummer",
            "ach.encryptedBankAccountNumber.aria.label": "Rekeningnummer",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe voor bankroutingnummer",
            "ach.encryptedBankLocationId.aria.label": "Routingnummer (ABA)",
            "twint.saved": "opgeslagen",
            orPayWith: "of betaal met",
            invalidFormatExpects: "Ongeldige indeling. Verwachte indeling: %{format}",
            "upi.qrCodeWaitingMessage": "Scan de QR-code met je favoriete UPI-app om de betaling te voltooien",
            "upi.vpaWaitingMessage": "Open je UPI-app om de betaling te bevestigen",
            "upi.modeSelection": "Maak een selectie over hoe u UPI wilt gebruiken.",
            "onlineBanking.termsAndConditions": "Door verder te gaan gaat u akkoord met de %#algemene voorwaarden%#",
            "onlineBankingPL.termsAndConditions": "Door verder te gaan stemt u in met de %#richtlijnen%# en %#informatieverplichting%# van Przelewy24",
            "ctp.loading.poweredByCtp": "Mogelijk gemaakt door Click to Pay",
            "ctp.loading.intro": "We controleren of u opgeslagen kaarten heeft bij Click to Pay...",
            "ctp.login.title": "Ga verder naar Click to Pay",
            "ctp.login.subtitle": "Voer het aan Click to Pay gekoppelde e-mailadres in om verder te gaan.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "Bent u dit niet?",
            "ctp.logout.notYourCards": "Niet uw kaarten?",
            "ctp.logout.notYourCard": "Niet uw kaart?",
            "ctp.logout.notYourProfile": "Niet uw profiel?",
            "ctp.otp.fieldLabel": "Eenmalige code",
            "ctp.otp.resendCode": "Code opnieuw verzenden",
            "ctp.otp.codeResent": "Code opnieuw verzonden",
            "ctp.otp.title": "Ga naar uw Click to Pay-kaarten",
            "ctp.otp.subtitle": "Voer de code %@ in die naar %@ is gestuurd, zodat we kunnen verifi\xebren dat u het bent.",
            "ctp.otp.saveCookiesCheckbox.label": "Verificatie de volgende keer overslaan",
            "ctp.otp.saveCookiesCheckbox.information": "Selecteer om te worden onthouden op uw apparaat en in uw browser bij deelnemende winkels, zodat u sneller kunt afrekenen. Niet aanbevolen voor gedeelde apparaten.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Selecteer om onthouden te worden op uw apparaat en browser",
            "ctp.emptyProfile.message": "Geen kaarten geregistreerd voor dit Click to Pay-profiel",
            "ctp.separatorText": "of gebruik",
            "ctp.cards.title": "Voltooi de betaling met Click to Pay",
            "ctp.cards.subtitle": "Selecteer een kaart om te gebruiken.",
            "ctp.cards.expiredCard": "Verlopen",
            "ctp.manualCardEntry": "Handmatige kaartinvoer",
            "ctp.aria.infoModalButton": "Wat is Click to Pay?",
            "ctp.infoPopup.title": "Met Click to Pay betaalt u nu ook contactloos online",
            "ctp.infoPopup.subtitle": "Een snelle en veilige betaalmethode, ondersteund door Mastercard, Visa en andere betaalkaarten.",
            "ctp.infoPopup.benefit1": "Click to Pay maakt gebruik van versleuteling om uw informatie veilig te houden",
            "ctp.infoPopup.benefit2": "Gebruik het bij winkeliers over de hele wereld",
            "ctp.infoPopup.benefit3": "E\xe9n keer instellen voor probleemloze betalingen",
            "ctp.errors.AUTH_INVALID": "Authenticatie ongeldig",
            "ctp.errors.NOT_FOUND": "Geen account gevonden, voer een geldig e-mailadres in of ga door met het handmatig invoeren van kaarten",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formaat wordt niet ondersteund",
            "ctp.errors.FRAUD": "Gebruikersaccount vergrendeld of uitgeschakeld",
            "ctp.errors.CONSUMER_ID_MISSING": "Identiteit van de consument ontbreekt in het verzoek",
            "ctp.errors.ACCT_INACCESSIBLE": "Dit account is momenteel niet beschikbaar, omdat het bijvoorbeeld is vergrendeld",
            "ctp.errors.CODE_INVALID": "Onjuiste verificatiecode",
            "ctp.errors.CODE_EXPIRED": "Deze code is verlopen",
            "ctp.errors.RETRIES_EXCEEDED": "De limiet voor het aantal pogingen voor het genereren van een OTP is overschreden",
            "ctp.errors.OTP_SEND_FAILED": "Het OTP kan niet naar de ontvanger worden verzonden",
            "ctp.errors.REQUEST_TIMEOUT": "Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer",
            "ctp.errors.UNKNOWN_ERROR": "Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer",
            "ctp.errors.SERVICE_ERROR": "Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer",
            "ctp.errors.SERVER_ERROR": "Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer",
            "ctp.errors.INVALID_PARAMETER": "Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer",
            "ctp.errors.AUTH_ERROR": "Er is iets fout gegaan, probeer het opnieuw of gebruik de handmatige kaartinvoer",
            "paymentMethodsList.aria.label": "Kies een betaalmethode",
            "companyDetails.name.invalid": "Voer de bedrijfsnaam in",
            "companyDetails.registrationNumber.invalid": "Voer het registratienummer in",
            "consent.checkbox.invalid": "Je moet akkoord gaan met de algemene voorwaarden",
            "form.instruction": "Alle velden zijn verplicht, tenzij anders aangegeven.",
            "ancv.input.label": "Uw ANCV-identificatie",
            "ancv.confirmPayment": "Gebruik uw ANCV-toepassing om de betaling te bevestigen.",
            "ancv.form.instruction": "De Cheque-Vacances applicatie is nodig om deze betaling te valideren.",
            "ancv.beneficiaryId.invalid": "Voer een geldig e-mailadres of ANCV-id in",
            "payme.openPayMeApp": "Voltooi uw betaling door deze te autoriseren in de PayMe-app en de bevestiging af te wachten.",
            "payme.redirectButtonLabel": "Open de PayMe-app",
            "payme.scanQrCode": "Voltooi uw betaling met een QR-code",
            "payme.timeToPay": "Deze QR-code is %@ geldig",
            "payme.instructions.steps": "Open de PayMe-app.%@Scan de QR-code om de betaling te autoriseren.%@Voltooi de betaling in de app en wacht de bevestiging af.",
            "payme.instructions.footnote": "Sluit deze pagina niet voordat de betaling is voltooid"
        }
    }), o2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Betal",
            "payButton.redirecting": "Omdirigerer...",
            "payButton.with": "Betal %{value} med %{maskedData}",
            "payButton.saveDetails": "Lagre detaljer",
            close: "Lukk",
            storeDetails: "Lagre til min neste betaling",
            readMore: "Les mer",
            "creditCard.holderName": "Navn p\xe5 kortet",
            "creditCard.holderName.placeholder": "O. Nordmann",
            "creditCard.holderName.invalid": "Skriv inn navnet som vist p\xe5 kortet",
            "creditCard.numberField.title": "Kortnummer",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Utl\xf8psdato",
            "creditCard.expiryDateField.placeholder": "MM/\xc5\xc5",
            "creditCard.expiryDateField.month": "M\xe5ned",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "\xc5\xc5",
            "creditCard.expiryDateField.year": "\xc5r",
            "creditCard.cvcField.title": "Sikkerhetskode",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Husk til neste gang",
            "creditCard.cvcField.placeholder.4digits": "4 siffer",
            "creditCard.cvcField.placeholder.3digits": "3 siffer",
            "creditCard.taxNumber.placeholder": "YYMMDD / 0123456789",
            installments: "Antall avdrag",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} m\xe5neder",
            "installments.oneTime": "Engangsbetaling",
            "installments.installments": "Avdragsbetaling",
            "installments.revolving": "Gjentakende betaling",
            "sepaDirectDebit.ibanField.invalid": "Ugyldig kontonummer",
            "sepaDirectDebit.nameField.placeholder": "O. Nordmann",
            "sepa.ownerName": "Kortholders navn",
            "sepa.ibanNumber": "Kontonummer (IBAN)",
            "error.title": "Feil",
            "error.subtitle.redirect": "Videresending feilet",
            "error.subtitle.payment": "Betaling feilet",
            "error.subtitle.refused": "Betaling avvist",
            "error.message.unknown": "En ukjent feil oppstod",
            "errorPanel.title": "Eksisterende feil",
            "idealIssuer.selectField.title": "Bank",
            "idealIssuer.selectField.placeholder": "Velg din bank",
            "creditCard.success": "Betalingen var vellykket",
            loading: "Laster...",
            continue: "Fortsett",
            continueTo: "Fortsett til",
            "wechatpay.timetopay": "Du har %@ igjen til \xe5 betale",
            "sr.wechatpay.timetopay": "Du har %#minutter%# og %#sekunder%# p\xe5 deg til \xe5 betale",
            "wechatpay.scanqrcode": "Skann QR-kode",
            personalDetails: "Personopplysninger",
            companyDetails: "Firmadetaljer",
            "companyDetails.name": "Firmanavn",
            "companyDetails.registrationNumber": "Registreringsnummer",
            socialSecurityNumber: "Personnummer",
            firstName: "Fornavn",
            "firstName.invalid": "Skriv inn fornavnet ditt",
            infix: "Prefiks",
            lastName: "Etternavn",
            "lastName.invalid": "Skriv inn etternavnet ditt",
            mobileNumber: "Mobilnummer",
            "mobileNumber.invalid": "Ugyldig mobilnummer",
            city: "Poststed",
            postalCode: "Postnummer",
            "postalCode.optional": "Postnummer (valgfritt)",
            countryCode: "Landkode",
            telephoneNumber: "Telefonnummer",
            dateOfBirth: "F\xf8dselsdato",
            shopperEmail: "E-postadresse",
            gender: "Kj\xf8nn",
            "gender.notselected": "Velg kj\xf8nn",
            male: "Mann",
            female: "Kvinne",
            billingAddress: "Faktureringsadresse",
            street: "Gate",
            stateOrProvince: "Fylke",
            country: "Land",
            houseNumberOrName: "Husnummer",
            separateDeliveryAddress: "Spesifiser en separat leveringsadresse",
            deliveryAddress: "Leveringsadresse",
            "deliveryAddress.firstName": "Mottakerens fornavn",
            "deliveryAddress.lastName": "Mottakerens etternavn",
            zipCode: "Postnummer",
            apartmentSuite: "Leilighet/suite",
            provinceOrTerritory: "Provins eller territorium",
            cityTown: "By",
            address: "Adresse",
            "address.placeholder": "Finn adressen din",
            "address.errors.incomplete": "Skriv inn en adresse for \xe5 fortsette",
            "address.enterManually": "Skriv inn adressen manuelt",
            state: "Delstat",
            "field.title.optional": "(valgfritt)",
            "creditCard.cvcField.title.optional": "Sikkerhetskode (valgfritt)",
            "issuerList.wallet.placeholder": "Velg lommebok",
            privacyPolicy: "Retningslinjer for personvern",
            "afterPay.agreement": "Jeg godtar Rivertys %@",
            paymentConditions: "betalingsbetingelser",
            openApp: "\xc5pne appen",
            "voucher.readInstructions": "Les instruksjoner",
            "voucher.introduction": "Takk for ditt kj\xf8p. Vennligst bruk den f\xf8lgende kupongen til \xe5 fullf\xf8re betalingen.",
            "voucher.expirationDate": "Utl\xf8psdato",
            "voucher.alternativeReference": "Alternativ referanse",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Velg din leverand\xf8r",
            "dragonpay.voucher.bank.selectField.placeholder": "Velg din bank",
            "voucher.paymentReferenceLabel": "Betalingsreferanse",
            "voucher.surcharge": "Inkl. %@ tilleggsavgift",
            "voucher.introduction.doku": "Takk for ditt kj\xf8p, vennligst bruk den f\xf8lgende informasjonen for \xe5 fullf\xf8re betalingen.",
            "voucher.shopperName": "Kundenavn",
            "voucher.merchantName": "Forhandler",
            "voucher.introduction.econtext": "Takk for ditt kj\xf8p, vennligst bruk den f\xf8lgende informasjonen for \xe5 fullf\xf8re betalingen.",
            "voucher.telephoneNumber": "Telefonnummer",
            "voucher.shopperReference": "Kundereferanse",
            "voucher.collectionInstitutionNumber": "Innbetalingslokasjonsnummer",
            "voucher.econtext.telephoneNumber.invalid": "Telefonnummeret m\xe5 v\xe6re 10 eller 11 sifre langt",
            "boletobancario.btnLabel": "Generer Boleto",
            "boleto.sendCopyToEmail": "Send meg en kopi p\xe5 e-post",
            "button.copy": "Kopier",
            "button.download": "Last ned",
            "boleto.socialSecurityNumber.invalid": "Feltet er ikke gyldig",
            "creditCard.storedCard.description.ariaLabel": "Lagret kort slutter p\xe5 %@",
            "voucher.entity": "Enhet",
            donateButton: "Don\xe9r",
            notNowButton: "Ikke n\xe5",
            thanksForYourSupport: "Takk for din st\xf8tte!",
            "resultMessages.preauthorized": "Detaljer lagret",
            preauthorizeWith: "Forh\xe5ndsgodkjenn med",
            confirmPreauthorization: "Bekreft forh\xe5ndsgodkjenning",
            confirmPurchase: "Bekreft kj\xf8p",
            applyGiftcard: "L\xf8s inn",
            giftcardBalance: "Gavekortsaldo",
            deductedBalance: "Fratrukket bel\xf8p",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "F\xf8rste 2 sifre av kortpassord",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Ugyldig passord",
            "creditCard.taxNumber": "Kortholders f\xf8dselsdato eller bedriftsregistreringsnummer",
            "creditCard.taxNumber.label": "Kortholders f\xf8dselsdato (YYMMDD) eller bedriftsregistreringsnummer (10 siffer)",
            "creditCard.taxNumber.labelAlt": "Bedriftsregistreringsnummer (10 siffer)",
            "creditCard.taxNumber.invalid": "Ugyldig kortholders f\xf8dselsdato eller bedriftsregistreringsnummer",
            "storedPaymentMethod.disable.button": "Fjern",
            "storedPaymentMethod.disable.confirmation": "Fjern lagret betalingsmetode",
            "storedPaymentMethod.disable.confirmButton": "Ja, fjern",
            "storedPaymentMethod.disable.cancelButton": "Avbryt",
            "ach.bankAccount": "Bankkonto",
            "ach.accountHolderNameField.title": "Kontoholders navn",
            "ach.accountHolderNameField.placeholder": "O. Nordmann",
            "ach.accountHolderNameField.invalid": "Ugyldig navn p\xe5 kontoholder",
            "ach.accountNumberField.title": "Kontonummer",
            "ach.accountNumberField.invalid": "Ugyldig kontonummer",
            "ach.accountLocationField.title": "ABA-dirigeringsnummer",
            "ach.accountLocationField.invalid": "Ugyldig ABA-dirigeringsnummer",
            "ach.savedBankAccount": "Lagret bankkonto",
            "select.state": "Velg delstat",
            "select.stateOrProvince": "Velg delstat eller provins",
            "select.provinceOrTerritory": "Velg provins eller territorium",
            "select.country": "Velg land",
            "select.noOptionsFound": "Ingen alternativer funnet",
            "select.filter.placeholder": "S\xf8k\u2026",
            "telephoneNumber.invalid": "Ugyldig telefonnummer",
            qrCodeOrApp: "eller",
            "paypal.processingPayment": "Behandler betaling\u2026",
            generateQRCode: "Generer QR-kode",
            "await.waitForConfirmation": "Venter p\xe5 bekreftelse",
            "mbway.confirmPayment": "Bekreft betalingen din i MB WAY-appen",
            "shopperEmail.invalid": "Ugyldig e-postadresse",
            "dateOfBirth.format": "DD/MM/\xc5\xc5\xc5\xc5",
            "dateOfBirth.invalid": "Skriv inn en gyldig f\xf8dselsdato som viser at du er minst 18 \xe5r gammel",
            "blik.confirmPayment": "\xc5pne bank-appen din for \xe5 bekrefte betalingen.",
            "blik.invalid": "Tast inn 6 tall",
            "blik.code": "6-sifret kode",
            "blik.help": "Hent koden fra bank-appen din.",
            "swish.pendingMessage": "Etter at du har skannet koden kan det ta opptil 10 minutter f\xf8r betalingen vises som bekreftet. Fors\xf8k p\xe5 \xe5 betale igjen kan f\xf8re til flere innbetalinger.",
            "field.valid": "Feltet er gyldig",
            "field.invalid": "Feltet er ikke gyldig",
            "error.va.gen.01": "Ufullstendig felt",
            "error.va.gen.02": "Feltet er ikke gyldig",
            "error.va.sf-cc-num.01": "Angi et gyldig kortnummer",
            "error.va.sf-cc-num.02": "Angi kortnummeret",
            "error.va.sf-cc-num.03": "Angi et st\xf8ttet kortmerke",
            "error.va.sf-cc-num.04": "Angi hele kortnummeret",
            "error.va.sf-cc-dat.01": "Angi en gyldig utl\xf8psdato",
            "error.va.sf-cc-dat.02": "Angi en gyldig utl\xf8psdato",
            "error.va.sf-cc-dat.03": "Kredittkortet er i ferd med \xe5 utl\xf8pe",
            "error.va.sf-cc-dat.04": "Angi utl\xf8psdatoen",
            "error.va.sf-cc-dat.05": "Angi den fullstendige utl\xf8psdatoen",
            "error.va.sf-cc-mth.01": "Angi utl\xf8psm\xe5neden",
            "error.va.sf-cc-yr.01": "Angi utl\xf8ps\xe5ret",
            "error.va.sf-cc-yr.02": "Angi det fullstendige utl\xf8ps\xe5ret",
            "error.va.sf-cc-cvc.01": "Angi sikkerhetskoden",
            "error.va.sf-cc-cvc.02": "Angi den fullstendige sikkerhetskoden",
            "error.va.sf-ach-num.01": "Feltet for bankkontonummer er tomt",
            "error.va.sf-ach-num.02": "Bankkontonummeret har feil lengde",
            "error.va.sf-ach-loc.01": "Feltet for bankens routingnummer er tomt",
            "error.va.sf-ach-loc.02": "Bankens routingnummer har feil lengde",
            "error.va.sf-kcp-pwd.01": "Passordfeltet er tomt",
            "error.va.sf-kcp-pwd.02": "Passordet har feil lengde",
            "error.giftcard.no-balance": "Dette gavekortet har en saldo p\xe5 null",
            "error.giftcard.card-error": "Vi har ikke noe gavekort med dette nummeret i registrene v\xe5re",
            "error.giftcard.currency-error": "Gavekort er kun gyldige i den valutaen de ble utstedt i",
            "amazonpay.signout": "Logg ut av Amazon",
            "amazonpay.changePaymentDetails": "Endre betalingsdetaljer",
            "partialPayment.warning": "Velg en annen betalingsmetode for \xe5 betale det gjenv\xe6rende",
            "partialPayment.remainingBalance": "Gjenv\xe6rende saldo vil v\xe6re %{amount}",
            "bankTransfer.beneficiary": "Mottaker",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "referanse",
            "bankTransfer.introduction": "Fortsett for \xe5 opprette en ny betaling via bankoverf\xf8ring. Du kan bruke detaljene i det f\xf8lgende skjermbildet for \xe5 fullf\xf8re betalingen.",
            "bankTransfer.instructions": "Takk for kj\xf8pet. Vennligst benytt den f\xf8lgende informasjonen til \xe5 fullf\xf8re betalingen.",
            "bacs.accountHolderName": "Kontoholders navn",
            "bacs.accountHolderName.invalid": "Ugyldig kontoholdernavn",
            "bacs.accountNumber": "Bankkontonummer",
            "bacs.accountNumber.invalid": "Ugyldig bankkontonummer",
            "bacs.bankLocationId": "Sorteringskode",
            "bacs.bankLocationId.invalid": "Ugyldig sorteringskode",
            "bacs.consent.amount": "Jeg samtykker til at bel\xf8pet ovenfor blir trukket fra bankkontoen min.",
            "bacs.consent.account": "Jeg bekrefter at kontoen st\xe5r i mitt navn, og at jeg er den eneste signataren som kreves for \xe5 autorisere direktebelastningen p\xe5 denne kontoen.",
            edit: "Endre",
            "bacs.confirm": "Bekreft og betal",
            "bacs.result.introduction": "Last ned instruksjoner for direktebelastning (DDI/ mandat)",
            "download.pdf": "Last ned PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe for kortnummer",
            "creditCard.encryptedCardNumber.aria.label": "Kortnummer",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe for utl\xf8psdato",
            "creditCard.encryptedExpiryDate.aria.label": "Utl\xf8psdato",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe for utl\xf8psm\xe5ned",
            "creditCard.encryptedExpiryMonth.aria.label": "Utl\xf8psm\xe5ned",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe for utl\xf8ps\xe5r",
            "creditCard.encryptedExpiryYear.aria.label": "Utl\xf8ps\xe5r",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe for sikkerhetskode",
            "creditCard.encryptedSecurityCode.aria.label": "Sikkerhetskode",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe for passord",
            "creditCard.encryptedPassword.aria.label": "F\xf8rste 2 sifre av kortpassord",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe for kortnummer",
            "giftcard.encryptedCardNumber.aria.label": "Kortnummer",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe for PIN-kode",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Maksimalt %{amount} per transaksjon er tillatt p\xe5 dette gavekortet",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe for bankkontonummer",
            "ach.encryptedBankAccountNumber.aria.label": "Kontonummer",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe for bankens routingnummer",
            "ach.encryptedBankLocationId.aria.label": "ABA-dirigeringsnummer",
            "twint.saved": "lagret",
            orPayWith: "eller betal med",
            invalidFormatExpects: "Ugyldig format. Forventet format: %{format}",
            "upi.qrCodeWaitingMessage": "Skann QR-koden ved \xe5 bruke din foretrukne UPI-app for \xe5 fullf\xf8re betalingen",
            "upi.vpaWaitingMessage": "\xc5pne UPI-appen for \xe5 bekrefte betalingen",
            "upi.modeSelection": "Velg hvordan du vil bruke UPI.",
            "onlineBanking.termsAndConditions": "Ved \xe5 fortsette godtar du %#terms and conditions%#",
            "onlineBankingPL.termsAndConditions": "Ved \xe5 fortsette godtar du %#reglene%# og %#informasjonsplikten%# til Przelewy24.",
            "ctp.loading.poweredByCtp": "Drevet av Click to Pay",
            "ctp.loading.intro": "Vi sjekker om du har noen lagrede kort med Click to Pay\u2026",
            "ctp.login.title": "Fortsett til Click to Pay",
            "ctp.login.subtitle": "Skriv inn e-postadressen som er tilknyttet Click to Pay, for \xe5 fortsette.",
            "ctp.login.inputLabel": "E-postadresse",
            "ctp.logout.notYou": "Ikke deg?",
            "ctp.logout.notYourCards": "Ikke dine kort?",
            "ctp.logout.notYourCard": "Ikke ditt kort?",
            "ctp.logout.notYourProfile": "Ikke din profil?",
            "ctp.otp.fieldLabel": "Engangskode",
            "ctp.otp.resendCode": "Send kode p\xe5 nytt",
            "ctp.otp.codeResent": "Kode er sendt p\xe5 nytt",
            "ctp.otp.title": "F\xe5 tilgang til Click to Pay-kortene dine",
            "ctp.otp.subtitle": "Tast inn koden vi sendte til %@, for \xe5 verifisere at det er deg.",
            "ctp.otp.saveCookiesCheckbox.label": "Hopp over verifisering neste gang",
            "ctp.otp.saveCookiesCheckbox.information": "Velg for \xe5 bli husket p\xe5 enheten og i nettleseren din i deltakende butikker for raskere betaling. Anbefales ikke for delte enheter.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Velg for \xe5 bli husket p\xe5 enheten og i nettleseren din",
            "ctp.emptyProfile.message": "Ingen kort er registrert i denne Click to Pay-profilen",
            "ctp.separatorText": "eller bruk",
            "ctp.cards.title": "Fullf\xf8r betalingen med Click to Pay",
            "ctp.cards.subtitle": "Velg et kort du vil bruke.",
            "ctp.cards.expiredCard": "Utl\xf8pt",
            "ctp.manualCardEntry": "Manuell inntasting av kort",
            "ctp.aria.infoModalButton": "Hva er Click to Pay",
            "ctp.infoPopup.title": "Click to Pay gj\xf8r kontaktl\xf8st mulig ogs\xe5 p\xe5 nettet",
            "ctp.infoPopup.subtitle": "En rask, sikker betalingsmetode st\xf8ttet av Mastercard, Visa og andre betalingskort.",
            "ctp.infoPopup.benefit1": "Click to Pay bruker kryptering for \xe5 holde informasjonen din sikker",
            "ctp.infoPopup.benefit2": "Bruk den hos forhandlere over hele verden",
            "ctp.infoPopup.benefit3": "Konfigurer \xe9n gang for lettvinte betalinger i fremtiden",
            "ctp.errors.AUTH_INVALID": "Autentiseringen er ugyldig",
            "ctp.errors.NOT_FOUND": "Vi finner ingen konto. Skriv inn en gyldig e-postadresse eller fortsett ved hjelp av manuell kortinntasting",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formatet st\xf8ttes ikke",
            "ctp.errors.FRAUD": "Brukerkontoen er l\xe5st eller deaktivert",
            "ctp.errors.CONSUMER_ID_MISSING": "Forbrukerens identitet mangler i foresp\xf8rselen",
            "ctp.errors.ACCT_INACCESSIBLE": "Denne kontoen er for \xf8yeblikket ikke tilgjengelig, f.eks. kan den v\xe6re l\xe5st",
            "ctp.errors.CODE_INVALID": "Feil verifiseringskode",
            "ctp.errors.CODE_EXPIRED": "Denne koden er utl\xf8pt",
            "ctp.errors.RETRIES_EXCEEDED": "Grensen for antall fors\xf8k p\xe5 generering av engangspassord er overskredet",
            "ctp.errors.OTP_SEND_FAILED": "Engangspassordet kunne ikke sendes til mottakeren",
            "ctp.errors.REQUEST_TIMEOUT": "Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen",
            "ctp.errors.UNKNOWN_ERROR": "Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen",
            "ctp.errors.SERVICE_ERROR": "Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen",
            "ctp.errors.SERVER_ERROR": "Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen",
            "ctp.errors.INVALID_PARAMETER": "Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen",
            "ctp.errors.AUTH_ERROR": "Noe gikk galt, pr\xf8v igjen eller bruk den manuelle kortinntastingen",
            "paymentMethodsList.aria.label": "Velg en betalingsmetode",
            "companyDetails.name.invalid": "Skriv inn firmanavnet",
            "companyDetails.registrationNumber.invalid": "Angi registreringsnummeret",
            "consent.checkbox.invalid": "Du m\xe5 godta vilk\xe5rene",
            "form.instruction": "Alle felt er obligatoriske med mindre annet er angitt.",
            "ancv.input.label": "ANCV-identifikasjonen din",
            "ancv.confirmPayment": "Bruk ANCV-appen for \xe5 bekrefte betalingen.",
            "ancv.form.instruction": "Cheque-Vacances-appen er n\xf8dvendig for \xe5 validere denne betalingen.",
            "ancv.beneficiaryId.invalid": "Oppgi en gyldig e-postadresse eller ANCV-ID",
            "payme.openPayMeApp": "Fullf\xf8r betalingen i PayMe-appen ved \xe5 godkjenne betalingen i appen og vente p\xe5 bekreftelse.",
            "payme.redirectButtonLabel": "\xc5pne PayMe-appen",
            "payme.scanQrCode": "Fullf\xf8r betalingen via QR-kode",
            "payme.timeToPay": "Denne QR-koden er gyldig i %@",
            "payme.instructions.steps": "\xc5pne PayMe-appen.%@Skann QR-koden for \xe5 autorisere betalingen.%@Fullf\xf8r betalingen i appen, og vent p\xe5 bekreftelsen.",
            "payme.instructions.footnote": "Ikke lukk denne siden f\xf8r betalingen er fullf\xf8rt"
        }
    }), i2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Zap\u0142a\u0107",
            "payButton.redirecting": "Przekierowywanie...",
            "payButton.with": "Zap\u0142a\u0107 %{value} za pomoc\u0105 %{maskedData}",
            "payButton.saveDetails": "Zapisz dane",
            close: "Zamknij",
            storeDetails: "Zapisz na potrzeby nast\u0119pnej p\u0142atno\u015Bci",
            readMore: "Czytaj wi\u0119cej",
            "creditCard.holderName": "Imi\u0119 i nazwisko na karcie",
            "creditCard.holderName.placeholder": "J. Kowalski",
            "creditCard.holderName.invalid": "Wpisz imi\u0119 i nazwisko w takim formacie, jak na karcie",
            "creditCard.numberField.title": "Numer karty ",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Data wa\u017Cno\u015Bci",
            "creditCard.expiryDateField.placeholder": "MM/RR",
            "creditCard.expiryDateField.month": "Miesi\u0105c",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "RR",
            "creditCard.expiryDateField.year": "Rok",
            "creditCard.cvcField.title": "Kod zabezpieczaj\u0105cy",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Zapami\u0119taj na przysz\u0142o\u015B\u0107",
            "creditCard.cvcField.placeholder.4digits": "4 cyfry",
            "creditCard.cvcField.placeholder.3digits": "3 cyfry",
            "creditCard.taxNumber.placeholder": "RRMMDD / 0123456789",
            installments: "Liczba rat",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} miesi\u0119cy",
            "installments.oneTime": "P\u0142atno\u015B\u0107 jednorazowa",
            "installments.installments": "P\u0142atno\u015B\u0107 ratalna",
            "installments.revolving": "P\u0142atno\u015B\u0107 odnawialna",
            "sepaDirectDebit.ibanField.invalid": "Nieprawid\u0142owy numer rachunku",
            "sepaDirectDebit.nameField.placeholder": "J. Kowalski",
            "sepa.ownerName": "Imi\u0119 i nazwisko posiadacza karty",
            "sepa.ibanNumber": "Numer rachunku (IBAN)",
            "error.title": "B\u0142\u0105d",
            "error.subtitle.redirect": "Przekierowanie nie powiod\u0142o si\u0119",
            "error.subtitle.payment": "P\u0142atno\u015B\u0107 nie powiod\u0142a si\u0119",
            "error.subtitle.refused": "P\u0142atno\u015B\u0107 zosta\u0142a odrzucona",
            "error.message.unknown": "Wyst\u0105pi\u0142 nieoczekiwany b\u0142\u0105d",
            "errorPanel.title": "Istniej\u0105ce b\u0142\u0119dy",
            "idealIssuer.selectField.title": "Bank",
            "idealIssuer.selectField.placeholder": "Wybierz sw\xf3j bank",
            "creditCard.success": "P\u0142atno\u015B\u0107 zako\u0144czona sukcesem",
            loading: "\u0141adowanie...",
            continue: "Kontynuuj",
            continueTo: "Przejd\u017A do",
            "wechatpay.timetopay": "Masz do zap\u0142acenia %@",
            "sr.wechatpay.timetopay": "Masz %#min%# %#s%#, aby zap\u0142aci\u0107",
            "wechatpay.scanqrcode": "Zeskanuj kod QR",
            personalDetails: "Dane osobowe",
            companyDetails: "Dane firmy",
            "companyDetails.name": "Nazwa firmy",
            "companyDetails.registrationNumber": "Numer w rejestrze",
            socialSecurityNumber: "Numer dowodu osobistego",
            firstName: "Imi\u0119",
            "firstName.invalid": "Wpisz imi\u0119",
            infix: "Prefiks",
            lastName: "Nazwisko",
            "lastName.invalid": "Wpisz nazwisko",
            mobileNumber: "Numer telefonu kom\xf3rkowego",
            "mobileNumber.invalid": "Nieprawid\u0142owy numer telefonu kom\xf3rkowego",
            city: "Miasto",
            postalCode: "Kod pocztowy",
            "postalCode.optional": "Kod pocztowy (opcjonalnie)",
            countryCode: "Kod kraju",
            telephoneNumber: "Numer telefonu",
            dateOfBirth: "Data urodzenia",
            shopperEmail: "Adres e-mail",
            gender: "P\u0142e\u0107",
            "gender.notselected": "Wybierz p\u0142e\u0107",
            male: "M\u0119\u017Cczyzna",
            female: "Kobieta",
            billingAddress: "Adres rozliczeniowy",
            street: "Ulica",
            stateOrProvince: "Wojew\xf3dztwo",
            country: "Kraj",
            houseNumberOrName: "Numer domu i mieszkania",
            separateDeliveryAddress: "Podaj osobny adres dostawy",
            deliveryAddress: "Adres dostawy",
            "deliveryAddress.firstName": "Imi\u0119 odbiorcy",
            "deliveryAddress.lastName": "Nazwisko odbiorcy",
            zipCode: "Kod pocztowy",
            apartmentSuite: "Numer domu/mieszkania",
            provinceOrTerritory: "Region lub terytorium",
            cityTown: "Miejscowo\u015B\u0107",
            address: "Adres",
            "address.placeholder": "Znajd\u017A sw\xf3j adres",
            "address.errors.incomplete": "Wprowad\u017A adres, aby kontynuowa\u0107",
            "address.enterManually": "Wprowad\u017A adres r\u0119cznie",
            state: "Stan",
            "field.title.optional": "(opcjonalnie)",
            "creditCard.cvcField.title.optional": "Kod zabezpieczaj\u0105cy (opcjonalnie)",
            "issuerList.wallet.placeholder": "Wybierz sw\xf3j portfel",
            privacyPolicy: "Polityka prywatno\u015Bci.",
            "afterPay.agreement": "Zgadzam si\u0119 z %@ Riverty",
            paymentConditions: "warunki p\u0142atno\u015Bci",
            openApp: "Otw\xf3rz aplikacj\u0119",
            "voucher.readInstructions": "Przeczytaj instrukcje",
            "voucher.introduction": "Dzi\u0119kujemy za zakup, doko\u0144cz p\u0142atno\u015B\u0107 przy u\u017Cyciu tego kuponu.",
            "voucher.expirationDate": "Data wa\u017Cno\u015Bci",
            "voucher.alternativeReference": "Dodatkowy numer referencyjny",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Wybierz dostawc\u0119",
            "dragonpay.voucher.bank.selectField.placeholder": "Wybierz sw\xf3j bank",
            "voucher.paymentReferenceLabel": "Nr referencyjny p\u0142atno\u015Bci",
            "voucher.surcharge": "Zawiera %@ op\u0142aty dodatkowej",
            "voucher.introduction.doku": "Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015B\u0107 przy u\u017Cyciu poni\u017Cszych informacji.",
            "voucher.shopperName": "Imi\u0119 i nazwisko klienta",
            "voucher.merchantName": "Sprzedaj\u0105cy",
            "voucher.introduction.econtext": "Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015B\u0107 przy u\u017Cyciu poni\u017Cszych informacji.",
            "voucher.telephoneNumber": "Numer telefonu",
            "voucher.shopperReference": "Dane referencyjne kupuj\u0105cych",
            "voucher.collectionInstitutionNumber": "Numer instytucji pobieraj\u0105cej op\u0142at\u0119",
            "voucher.econtext.telephoneNumber.invalid": "Numer telefonu musi mie\u0107 10 lub 11 cyfr",
            "boletobancario.btnLabel": "Wygeneruj p\u0142atno\u015B\u0107 Boleto",
            "boleto.sendCopyToEmail": "Wy\u015Blij kopi\u0119 na m\xf3j e-mail",
            "button.copy": "Kopiuj",
            "button.download": "Pobierz",
            "boleto.socialSecurityNumber.invalid": "Pole jest nieprawid\u0142owe",
            "creditCard.storedCard.description.ariaLabel": "Zapisana karta ko\u0144czy si\u0119 na % @",
            "voucher.entity": "Pozycja",
            donateButton: "Przeka\u017C darowizn\u0119",
            notNowButton: "Nie teraz",
            thanksForYourSupport: "Dzi\u0119kujemy za wsparcie!",
            "resultMessages.preauthorized": "Zapisano dane",
            preauthorizeWith: "Autoryzuj wst\u0119pnie za pomoc\u0105:",
            confirmPreauthorization: "Potwierd\u017A autoryzacj\u0119 wst\u0119pn\u0105",
            confirmPurchase: "Potwierd\u017A zakup",
            applyGiftcard: "Wykorzystaj",
            giftcardBalance: "Saldo karty podarunkowej",
            deductedBalance: "Saldo potr\u0105cone",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "Pierwsze 2 cyfry has\u0142a karty",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Nieprawid\u0142owe has\u0142o",
            "creditCard.taxNumber": "Data urodzenia posiadacza karty lub firmowy numer rejestracyjny",
            "creditCard.taxNumber.label": "Data urodzenia posiadacza karty (RRMMDD) lub firmowy numer rejestracyjny (10 cyfr)",
            "creditCard.taxNumber.labelAlt": "Firmowy numer rejestracyjny (10 cyfr)",
            "creditCard.taxNumber.invalid": "Nieprawid\u0142owa data urodzenia posiadacza karty lub nieprawid\u0142owy firmowy numer rejestracyjny",
            "storedPaymentMethod.disable.button": "Usu\u0144",
            "storedPaymentMethod.disable.confirmation": "Usu\u0144 zapisan\u0105 metod\u0119 p\u0142atno\u015Bci",
            "storedPaymentMethod.disable.confirmButton": "Tak, usu\u0144",
            "storedPaymentMethod.disable.cancelButton": "Anuluj",
            "ach.bankAccount": "Rachunek bankowy",
            "ach.accountHolderNameField.title": "Imi\u0119 i nazwisko posiadacza rachunku",
            "ach.accountHolderNameField.placeholder": "J. Kowalski",
            "ach.accountHolderNameField.invalid": "Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza rachunku",
            "ach.accountNumberField.title": "Numer rachunku",
            "ach.accountNumberField.invalid": "Nieprawid\u0142owy numer rachunku",
            "ach.accountLocationField.title": "Kod bankowy ABA Routing Number",
            "ach.accountLocationField.invalid": "Nieprawid\u0142owy kod bankowy ABA Routing Number",
            "ach.savedBankAccount": "Zapisane konto bankowe",
            "select.state": "Wybierz stan",
            "select.stateOrProvince": "Wybierz stan/wojew\xf3dztwo",
            "select.provinceOrTerritory": "Wybierz region/terytorium",
            "select.country": "Wybierz kraj",
            "select.noOptionsFound": "Nie znaleziono opcji",
            "select.filter.placeholder": "Szukaj...",
            "telephoneNumber.invalid": "Nieprawid\u0142owy numer telefonu",
            qrCodeOrApp: "lub",
            "paypal.processingPayment": "Przetwarzanie p\u0142atno\u015Bci...",
            generateQRCode: "Wygeneruj kod QR",
            "await.waitForConfirmation": "Oczekiwanie na potwierdzenie",
            "mbway.confirmPayment": "Potwierd\u017A p\u0142atno\u015B\u0107 w aplikacji MB WAY",
            "shopperEmail.invalid": "Niepoprawny adres email",
            "dateOfBirth.format": "DD/MM/RRRR",
            "dateOfBirth.invalid": "Podaj prawid\u0142ow\u0105 dat\u0119 urodzenia, \u015Bwiadcz\u0105c\u0105 o przekroczeniu 18 roku \u017Cycia.",
            "blik.confirmPayment": "Otw\xf3rz aplikacj\u0119 bankow\u0105, aby potwierdzi\u0107 p\u0142atno\u015B\u0107.",
            "blik.invalid": "Wpisz 6 cyfr",
            "blik.code": "6-cyfrowy kod",
            "blik.help": "Uzyskaj kod ze swojej aplikacji bankowej.",
            "swish.pendingMessage": "Po zeskanowaniu transakcja mo\u017Ce mie\u0107 status \u201EOczekuj\u0105ca\u201D do 10 minut. Pr\xf3ba ponownego dokonania p\u0142atno\u015Bci w tym czasie mo\u017Ce spowodowa\u0107 wielokrotne naliczenie op\u0142aty.",
            "field.valid": "Pole prawid\u0142owe",
            "field.invalid": "Dane w polu s\u0105 nieprawid\u0142owe",
            "error.va.gen.01": "Niekompletne dane w polu",
            "error.va.gen.02": "Dane w polu s\u0105 nieprawid\u0142owe",
            "error.va.sf-cc-num.01": "Wprowad\u017A prawid\u0142owy numer karty",
            "error.va.sf-cc-num.02": "Wprowad\u017A numer karty",
            "error.va.sf-cc-num.03": "Wprowad\u017A obs\u0142ugiwan\u0105 mark\u0119 karty",
            "error.va.sf-cc-num.04": "Wprowad\u017A pe\u0142ny numer karty",
            "error.va.sf-cc-dat.01": "Wprowad\u017A prawid\u0142ow\u0105 dat\u0119 wa\u017Cno\u015Bci",
            "error.va.sf-cc-dat.02": "Wprowad\u017A prawid\u0142ow\u0105 dat\u0119 wa\u017Cno\u015Bci",
            "error.va.sf-cc-dat.03": "Karta kredytowa wkr\xf3tce straci wa\u017Cno\u015B\u0107",
            "error.va.sf-cc-dat.04": "Wprowad\u017A dat\u0119 wa\u017Cno\u015Bci",
            "error.va.sf-cc-dat.05": "Wprowad\u017A pe\u0142n\u0105 dat\u0119 wa\u017Cno\u015Bci",
            "error.va.sf-cc-mth.01": "Wprowad\u017A miesi\u0105c daty wa\u017Cno\u015Bci",
            "error.va.sf-cc-yr.01": "Wprowad\u017A rok daty wa\u017Cno\u015Bci",
            "error.va.sf-cc-yr.02": "Wprowad\u017A pe\u0142ny rok daty wa\u017Cno\u015Bci",
            "error.va.sf-cc-cvc.01": "Wprowad\u017A kod zabezpieczaj\u0105cy",
            "error.va.sf-cc-cvc.02": "Wprowad\u017A pe\u0142ny kod zabezpieczaj\u0105cy",
            "error.va.sf-ach-num.01": "Pole Numer rachunku jest puste",
            "error.va.sf-ach-num.02": "Numer rachunku ma nieprawid\u0142ow\u0105 d\u0142ugo\u015B\u0107",
            "error.va.sf-ach-loc.01": "Pole Numer rozliczeniowy banku jest puste",
            "error.va.sf-ach-loc.02": "Numer rozliczeniowy banku ma nieprawid\u0142ow\u0105 d\u0142ugo\u015B\u0107",
            "error.va.sf-kcp-pwd.01": "Pole Has\u0142o jest puste",
            "error.va.sf-kcp-pwd.02": "Has\u0142o ma nieprawid\u0142ow\u0105 d\u0142ugo\u015B\u0107",
            "error.giftcard.no-balance": "Saldo karty podarunkowej jest puste",
            "error.giftcard.card-error": "W naszych rejestrach nie ma karty podarunkowej o tym numerze",
            "error.giftcard.currency-error": "Karty podarunkowe s\u0105 wa\u017Cne tylko w walucie, w kt\xf3rej zosta\u0142y wydane",
            "amazonpay.signout": "Wyloguj si\u0119 z Amazon",
            "amazonpay.changePaymentDetails": "Zmie\u0144 szczeg\xf3\u0142y p\u0142atno\u015Bci",
            "partialPayment.warning": "Wybierz inn\u0105 metod\u0119 p\u0142atno\u015Bci, aby zap\u0142aci\u0107 pozosta\u0142\u0105 kwot\u0119",
            "partialPayment.remainingBalance": "Pozosta\u0142e saldo wynosi %{kwota}",
            "bankTransfer.beneficiary": "Beneficjent",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Ref. sprze.",
            "bankTransfer.introduction": "Kontynuuj tworzenie nowej p\u0142atno\u015Bci przelewem bankowym. Mo\u017Cesz u\u017Cy\u0107 szczeg\xf3\u0142\xf3w na nast\u0119pnym ekranie, aby sfinalizowa\u0107 t\u0119 p\u0142atno\u015B\u0107.",
            "bankTransfer.instructions": "Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015B\u0107 przy u\u017Cyciu poni\u017Cszych informacji.",
            "bacs.accountHolderName": "Imi\u0119 i nazwisko posiadacza rachunku",
            "bacs.accountHolderName.invalid": "Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza rachunku",
            "bacs.accountNumber": "Numer rachunku",
            "bacs.accountNumber.invalid": "Nieprawid\u0142owy numer rachunku",
            "bacs.bankLocationId": "Numer rozliczeniowy SORT",
            "bacs.bankLocationId.invalid": "Nieprawid\u0142owy numer rozliczeniowy SORT",
            "bacs.consent.amount": "Wyra\u017Cam zgod\u0119 na pobranie powy\u017Cszej kwoty z mojego rachunku bankowego.",
            "bacs.consent.account": "Potwierdzam, \u017Ce konto jest zarejestrowane na moje nazwisko i jestem jedynym sygnatariuszem wymaganym do autoryzacji polecenia zap\u0142aty na tym koncie.",
            edit: "Edytuj",
            "bacs.confirm": "Potwierd\u017A i zap\u0142a\u0107",
            "bacs.result.introduction": "Pobierz dyspozycj\u0119 polecenia zap\u0142aty (DDI/upowa\u017Cnienie)",
            "download.pdf": "Pobierz PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Element Iframe dla numeru karty",
            "creditCard.encryptedCardNumber.aria.label": "Numer karty ",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Element Iframe dla daty wa\u017Cno\u015Bci",
            "creditCard.encryptedExpiryDate.aria.label": "Data wa\u017Cno\u015Bci",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Element Iframe dla miesi\u0105ca daty wa\u017Cno\u015Bci",
            "creditCard.encryptedExpiryMonth.aria.label": "Data wa\u017Cno\u015Bci - miesi\u0105c",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Element Iframe dla roku daty wa\u017Cno\u015Bci",
            "creditCard.encryptedExpiryYear.aria.label": "Data wa\u017Cno\u015Bci - rok",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Element Iframe dla kodu zabezpieczaj\u0105cego",
            "creditCard.encryptedSecurityCode.aria.label": "Kod zabezpieczaj\u0105cy",
            "creditCard.encryptedPassword.aria.iframeTitle": "Element Iframe dla has\u0142a",
            "creditCard.encryptedPassword.aria.label": "Pierwsze 2 cyfry has\u0142a karty",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Element Iframe dla numeru karty",
            "giftcard.encryptedCardNumber.aria.label": "Numer karty ",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Element Iframe dla kodu PIN",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Maks. dozwolona kwota (%{amount}) na transakcj\u0119 t\u0105 kart\u0105 upominkow\u0105",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Element Iframe dla numeru konta bankowego",
            "ach.encryptedBankAccountNumber.aria.label": "Numer rachunku",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Element Iframe dla numeru rozliczeniowego banku",
            "ach.encryptedBankLocationId.aria.label": "Kod bankowy ABA Routing Number",
            "twint.saved": "zapisano",
            orPayWith: "lub zap\u0142a\u0107",
            invalidFormatExpects: "Niepoprawny format. Oczekiwany format: %{format}",
            "upi.qrCodeWaitingMessage": "Zeskanuj kod QR za pomoc\u0105 preferowanej aplikacji UPI, aby doko\u0144czy\u0107 p\u0142atno\u015B\u0107",
            "upi.vpaWaitingMessage": "Otw\xf3rz aplikacj\u0119 UPI, aby potwierdzi\u0107 p\u0142atno\u015B\u0107",
            "upi.modeSelection": "Dokonaj wyboru sposobu korzystania z UPI.",
            "onlineBanking.termsAndConditions": "Kontynuuj\u0105c, zgadzasz si\u0119 z %#Warunkami \u015Bwiadczenia us\u0142ug%#.",
            "onlineBankingPL.termsAndConditions": "Kontynuuj\u0105c, akceptujesz %#przepisy%# oraz %#obowi\u0105zek informacyjny%# firmy Przelewy24",
            "ctp.loading.poweredByCtp": "Dzia\u0142a w oparciu o us\u0142ug\u0119 Click to Pay",
            "ctp.loading.intro": "Sprawdzamy, czy masz zapisane karty Click to Pay...",
            "ctp.login.title": "Przejd\u017A do Click to Pay",
            "ctp.login.subtitle": "Wprowad\u017A adres e-mail po\u0142\u0105czony z Click to Pay, aby kontynuowa\u0107.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "To nie Ty?",
            "ctp.logout.notYourCards": "To nie Twoje karty?",
            "ctp.logout.notYourCard": "To nie Twoja karta?",
            "ctp.logout.notYourProfile": "To nie Tw\xf3j profil?",
            "ctp.otp.fieldLabel": "Kod jednorazowy",
            "ctp.otp.resendCode": "Ponowne wys\u0142anie kodu",
            "ctp.otp.codeResent": "Wys\u0142ano kod ponownie",
            "ctp.otp.title": "Przejd\u017A do kart Click to Pay",
            "ctp.otp.subtitle": "Wprowad\u017A kod %@ wys\u0142any na adres %@, aby potwierdzi\u0107 swoj\u0105 to\u017Csamo\u015B\u0107.",
            "ctp.otp.saveCookiesCheckbox.label": "Nast\u0119pnym razem pomi\u0144 weryfikacj\u0119",
            "ctp.otp.saveCookiesCheckbox.information": "Wybierz opcj\u0119 zapami\u0119tywania na urz\u0105dzeniu i w przegl\u0105darce w sklepach uczestnicz\u0105cych w programie, aby przyspieszy\u0107 realizacj\u0119 transakcji. Niezalecane dla wsp\xf3\u0142u\u017Cytkowanych urz\u0105dze\u0144.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Wybierz, aby zapami\u0119ta\u0107 dane logowania na Twoim urz\u0105dzeniu i przegl\u0105darce",
            "ctp.emptyProfile.message": "W tym profilu Click to Pay nie zarejestrowano \u017Cadnych kart",
            "ctp.separatorText": "lub przypadk\xf3w jej u\u017Cycia",
            "ctp.cards.title": "Doko\u0144cz p\u0142atno\u015B\u0107 za pomoc\u0105 funkcji Click to Pay",
            "ctp.cards.subtitle": "Wybierz kart\u0119, kt\xf3rej chcesz u\u017Cy\u0107.",
            "ctp.cards.expiredCard": "Okres wa\u017Cno\u015Bci min\u0105\u0142",
            "ctp.manualCardEntry": "R\u0119czne wprowadzanie kart",
            "ctp.aria.infoModalButton": "Co to jest Click to Pay",
            "ctp.infoPopup.title": "Click to Pay zapewnia wygod\u0119 p\u0142atno\u015Bci zbli\u017Ceniowych w Internecie",
            "ctp.infoPopup.subtitle": "Szybka i bezpieczna metoda p\u0142atno\u015Bci obs\u0142ugiwana przez karty p\u0142atnicze Mastercard, Visa i inne.",
            "ctp.infoPopup.benefit1": "Click to Pay zabezpiecza Twoje informacje za pomoc\u0105 szyfrowania",
            "ctp.infoPopup.benefit2": "U\u017Cywaj tej funkcji u sprzedawc\xf3w na ca\u0142ym \u015Bwiecie",
            "ctp.infoPopup.benefit3": "Skonfiguruj raz i p\u0142a\u0107 bezproblemowo w przysz\u0142o\u015Bci",
            "ctp.errors.AUTH_INVALID": "Nieprawid\u0142owe dane uwierzytelniaj\u0105ce",
            "ctp.errors.NOT_FOUND": "Nie znaleziono konta, wprowad\u017A prawid\u0142owy adres e-mail lub kontynuuj, r\u0119cznie wprowadzaj\u0105c kart\u0119",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Format nie jest obs\u0142ugiwany",
            "ctp.errors.FRAUD": "Konto u\u017Cytkownika zosta\u0142o zablokowane lub wy\u0142\u0105czone",
            "ctp.errors.CONSUMER_ID_MISSING": "We wniosku brakuje danych dotycz\u0105cych to\u017Csamo\u015Bci konsumenta",
            "ctp.errors.ACCT_INACCESSIBLE": "To konto jest obecnie niedost\u0119pne, np. jest zablokowane",
            "ctp.errors.CODE_INVALID": "Nieprawid\u0142owy kod weryfikacyjny",
            "ctp.errors.CODE_EXPIRED": "Kod wygas\u0142",
            "ctp.errors.RETRIES_EXCEEDED": "Przekroczono limit pr\xf3b generowania has\u0142a jednorazowego",
            "ctp.errors.OTP_SEND_FAILED": "Nie uda\u0142o si\u0119 wys\u0142a\u0107 has\u0142a jednorazowego do odbiorcy",
            "ctp.errors.REQUEST_TIMEOUT": "Co\u015B posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty",
            "ctp.errors.UNKNOWN_ERROR": "Co\u015B posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty",
            "ctp.errors.SERVICE_ERROR": "Co\u015B posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty",
            "ctp.errors.SERVER_ERROR": "Co\u015B posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty",
            "ctp.errors.INVALID_PARAMETER": "Co\u015B posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty",
            "ctp.errors.AUTH_ERROR": "Co\u015B posz\u0142o nie tak, spr\xf3buj ponownie lub skorzystaj z r\u0119cznego wprowadzania karty",
            "paymentMethodsList.aria.label": "Wybierz metod\u0119 p\u0142atno\u015Bci",
            "companyDetails.name.invalid": "Wpisz nazw\u0119 firmy",
            "companyDetails.registrationNumber.invalid": "Wprowad\u017A numer w rejestrze",
            "consent.checkbox.invalid": "Musisz zaakceptowa\u0107 Warunki i postanowienia",
            "form.instruction": "Wszystkie pola s\u0105 wymagane, chyba \u017Ce zaznaczono inaczej.",
            "trustly.descriptor": "B\u0142yskawiczna p\u0142atno\u015B\u0107 bankowa",
            "trustly.description1": "P\u0142a\u0107 bezpo\u015Brednio z dowolnego rachunku bankowego, korzystaj\u0105c z zabezpiecze\u0144 na poziomie bankowym",
            "trustly.description2": "Bez kart, bez pobierania aplikacji, bez rejestracji",
            "ancv.input.label": "Tw\xf3j identyfikator ANCV",
            "ancv.confirmPayment": "U\u017Cyj aplikacji ANCV, aby potwierdzi\u0107 p\u0142atno\u015B\u0107.",
            "ancv.form.instruction": "Do zatwierdzenia tej p\u0142atno\u015Bci konieczna jest aplikacja Cheque-Vacances.",
            "ancv.beneficiaryId.invalid": "Wprowad\u017A poprawny adres e-mail lub identyfikator ANCV",
            "payme.openPayMeApp": "Doko\u0144cz p\u0142atno\u015B\u0107 w aplikacji PayMe, autoryzuj\u0105c p\u0142atno\u015B\u0107 w aplikacji, i poczekaj na potwierdzenie.",
            "payme.redirectButtonLabel": "Otw\xf3rz aplikacj\u0119 PayMe",
            "payme.scanQrCode": "Doko\u0144cz p\u0142atno\u015B\u0107 za pomoc\u0105 kodu QR",
            "payme.timeToPay": "Okres wa\u017Cno\u015Bci kodu QR: %@",
            "payme.instructions.steps": "Otw\xf3rz aplikacj\u0119 PayMe.%@Zeskanuj kod QR, aby autoryzowa\u0107 p\u0142atno\u015B\u0107.%@Doko\u0144cz p\u0142atno\u015B\u0107 w aplikacji i poczekaj na potwierdzenie.",
            "payme.instructions.footnote": "Nie zamykaj tej strony, dop\xf3ki p\u0142atno\u015B\u0107 nie zostanie zako\u0144czona"
        }
    }), l2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Pagar",
            "payButton.redirecting": "Redirecionando...",
            "payButton.with": "Pague %{value} com %{maskedData}",
            "payButton.saveDetails": "Salvar informa\xe7\xf5es",
            close: "Fechar",
            storeDetails: "Salvar para meu pr\xf3ximo pagamento",
            readMore: "Leia mais",
            "creditCard.holderName": "Nome no cart\xe3o",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "Digite o nome conforme mostrado no cart\xe3o",
            "creditCard.numberField.title": "N\xfamero do cart\xe3o",
            "creditCard.expiryDateField.title": "Data de validade",
            "creditCard.expiryDateField.placeholder": "MM/AA",
            "creditCard.expiryDateField.month": "M\xeas",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "AA",
            "creditCard.expiryDateField.year": "Ano",
            "creditCard.cvcField.title": "C\xf3digo de seguran\xe7a",
            "creditCard.storeDetailsButton": "Lembrar para a pr\xf3xima vez",
            "creditCard.cvcField.placeholder.4digits": "4 d\xedgitos",
            "creditCard.cvcField.placeholder.3digits": "3 d\xedgitos",
            "creditCard.taxNumber.placeholder": "AAAMMDD / 0123456789",
            installments: "Op\xe7\xf5es de Parcelamento",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} meses",
            "installments.oneTime": "Pagamento \xe0 vista",
            "installments.installments": "Pagamento parcelado",
            "installments.revolving": "Pagamento rotativo",
            "sepaDirectDebit.ibanField.invalid": "N\xfamero de conta inv\xe1lido",
            "sepaDirectDebit.nameField.placeholder": "J. Silva",
            "sepa.ownerName": "Nome do titular da conta banc\xe1ria",
            "sepa.ibanNumber": "N\xfamero de conta (NIB)",
            "error.title": "Erro",
            "error.subtitle.redirect": "Falha no redirecionamento",
            "error.subtitle.payment": "Falha no pagamento",
            "error.subtitle.refused": "Pagamento recusado",
            "error.message.unknown": "Ocorreu um erro desconhecido",
            "errorPanel.title": "Erros existentes",
            "idealIssuer.selectField.title": "Banco",
            "idealIssuer.selectField.placeholder": "Selecione seu banco",
            "creditCard.success": "Pagamento bem-sucedido",
            loading: "Carregando...",
            continue: "Continuar",
            continueTo: "Continuar para",
            "wechatpay.timetopay": "Voc\xea tem %@ para pagar",
            "sr.wechatpay.timetopay": "Voc\xea tem %#minutos%# e %#segundos%# para pagar",
            "wechatpay.scanqrcode": "Escanear c\xf3digo QR",
            personalDetails: "Informa\xe7\xf5es pessoais",
            companyDetails: "Dados da empresa",
            "companyDetails.name": "Nome da empresa",
            "companyDetails.registrationNumber": "N\xfamero de registro",
            socialSecurityNumber: "CPF",
            firstName: "Nome",
            "firstName.invalid": "Digite seu nome",
            infix: "Prefixo",
            lastName: "Sobrenome",
            "lastName.invalid": "Digite seu sobrenome",
            mobileNumber: "Celular",
            "mobileNumber.invalid": "N\xfamero de celular inv\xe1lido",
            city: "Cidade",
            postalCode: "CEP",
            "postalCode.optional": "C\xf3digo postal (opcional)",
            countryCode: "C\xf3digo do pa\xeds",
            telephoneNumber: "N\xfamero de telefone",
            dateOfBirth: "Data de nascimento",
            shopperEmail: "Endere\xe7o de e-mail",
            gender: "G\xeanero",
            "gender.notselected": "Selecione seu g\xeanero",
            male: "Masculino",
            female: "Feminino",
            billingAddress: "Endere\xe7o de cobran\xe7a",
            street: "Rua",
            stateOrProvince: "Estado ou prov\xedncia",
            country: "Pa\xeds",
            houseNumberOrName: "N\xfamero da casa",
            separateDeliveryAddress: "Especificar um endere\xe7o de entrega separado",
            deliveryAddress: "Endere\xe7o de entrega",
            "deliveryAddress.firstName": "Nome do destinat\xe1rio",
            "deliveryAddress.lastName": "Sobrenome do destinat\xe1rio",
            zipCode: "C\xf3digo postal",
            apartmentSuite: "Apartamento/Conjunto",
            provinceOrTerritory: "Prov\xedncia ou territ\xf3rio",
            cityTown: "Cidade",
            address: "Endere\xe7o",
            "address.placeholder": "Encontre seu endere\xe7o",
            "address.errors.incomplete": "Insira um endere\xe7o para continuar",
            "address.enterManually": "Inserir endere\xe7o manualmente",
            state: "Estado",
            "field.title.optional": "(opcional)",
            "creditCard.cvcField.title.optional": "C\xf3digo de seguran\xe7a (opcional)",
            "issuerList.wallet.placeholder": "Selecione uma carteira",
            privacyPolicy: "Pol\xedtica de Privacidade",
            "afterPay.agreement": "Concordo com o %@ da Riverty",
            paymentConditions: "condi\xe7\xf5es de pagamento",
            openApp: "Abrir o aplicativo",
            "voucher.readInstructions": "Leia as instru\xe7\xf5es",
            "voucher.introduction": "Obrigado pela sua compra, use o cupom a seguir para concluir o seu pagamento.",
            "voucher.expirationDate": "Data de validade",
            "voucher.alternativeReference": "Refer\xeancia alternativa",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Selecione o seu fornecedor",
            "dragonpay.voucher.bank.selectField.placeholder": "Selecione seu banco",
            "voucher.paymentReferenceLabel": "Refer\xeancia de pagamento",
            "voucher.surcharge": "Inclui %@ de sobretaxa",
            "voucher.introduction.doku": "Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.",
            "voucher.shopperName": "Nome do consumidor",
            "voucher.merchantName": "Comerciante online",
            "voucher.introduction.econtext": "Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.",
            "voucher.telephoneNumber": "N\xfamero de telefone",
            "voucher.shopperReference": "Refer\xeancia do consumidor",
            "voucher.collectionInstitutionNumber": "N\xfamero da institui\xe7\xe3o de cobran\xe7a",
            "voucher.econtext.telephoneNumber.invalid": "O n\xfamero de telefone deve ter 10 ou 11 d\xedgitos",
            "boletobancario.btnLabel": "Gerar Boleto",
            "boleto.sendCopyToEmail": "Enviar uma c\xf3pia por e-mail",
            "button.copy": "Copiar",
            "button.download": "Baixar",
            "boleto.socialSecurityNumber.invalid": "O campo n\xe3o \xe9 v\xe1lido",
            "creditCard.storedCard.description.ariaLabel": "O cart\xe3o armazenado termina em %@",
            "voucher.entity": "Entidade",
            donateButton: "Doar",
            notNowButton: "Agora n\xe3o",
            thanksForYourSupport: "Obrigado pelo apoio!",
            "resultMessages.preauthorized": "Informa\xe7\xf5es salvas",
            preauthorizeWith: "Pr\xe9-autorizar com",
            confirmPreauthorization: "Confirmar pr\xe9-autoriza\xe7\xe3o",
            confirmPurchase: "Confirmar compra",
            applyGiftcard: "Resgatar",
            giftcardBalance: "Saldo do vale-presente",
            deductedBalance: "Saldo debitado",
            "creditCard.pin.title": "Pin",
            "creditCard.encryptedPassword.label": "Primeiros dois d\xedgitos da senha do cart\xe3o",
            "creditCard.encryptedPassword.invalid": "Senha inv\xe1lida",
            "creditCard.taxNumber": "Data de nascimento do titular do cart\xe3o ou n\xfamero de registro corporativo",
            "creditCard.taxNumber.label": "Data de nascimento do titular do cart\xe3o (AAMMDD) ou n\xfamero de registro corporativo (10 d\xedgitos)",
            "creditCard.taxNumber.labelAlt": "N\xfamero de registro corporativo (10 d\xedgitos)",
            "creditCard.taxNumber.invalid": "Data de nascimento do titular do cart\xe3o ou n\xfamero de registro corporativo inv\xe1lidos",
            "storedPaymentMethod.disable.button": "Remover",
            "storedPaymentMethod.disable.confirmation": "Remover m\xe9todo de pagamento armazenado",
            "storedPaymentMethod.disable.confirmButton": "Sim, remover",
            "storedPaymentMethod.disable.cancelButton": "Cancelar",
            "ach.bankAccount": "Conta banc\xe1ria",
            "ach.accountHolderNameField.title": "Nome do titular da conta",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Nome do titular da conta inv\xe1lido",
            "ach.accountNumberField.title": "N\xfamero da conta",
            "ach.accountNumberField.invalid": "N\xfamero de conta inv\xe1lido",
            "ach.accountLocationField.title": "N\xfamero de roteamento ABA",
            "ach.accountLocationField.invalid": "N\xfamero de roteamento ABA inv\xe1lido",
            "ach.savedBankAccount": "Conta banc\xe1ria cadastrada",
            "select.state": "Selecionar estado",
            "select.stateOrProvince": "Selecione estado ou prov\xedncia",
            "select.provinceOrTerritory": "Selecionar prov\xedncia ou territ\xf3rio",
            "select.country": "Selecione o pa\xeds",
            "select.noOptionsFound": "Nenhuma op\xe7\xe3o encontrada",
            "select.filter.placeholder": "Pesquisar...",
            "telephoneNumber.invalid": "N\xfamero de telefone inv\xe1lido",
            qrCodeOrApp: "ou",
            "paypal.processingPayment": "Processando pagamento...",
            generateQRCode: "Gerar c\xf3digo QR",
            "await.waitForConfirmation": "Aguardando confirma\xe7\xe3o",
            "mbway.confirmPayment": "Confirme seu pagamento no aplicativo MB WAY",
            "shopperEmail.invalid": "Endere\xe7o de e-mail inv\xe1lido",
            "dateOfBirth.format": "DD/MM/AAAA",
            "dateOfBirth.invalid": "Insira uma data de nascimento v\xe1lida que indique que voc\xea tem pelo menos 18 anos",
            "blik.confirmPayment": "Abra o aplicativo do seu banco para confirmar o pagamento.",
            "blik.invalid": "Digite 6 n\xfameros",
            "blik.code": "C\xf3digo de 6 d\xedgitos",
            "blik.help": "Obtenha o c\xf3digo no aplicativo do seu banco.",
            "swish.pendingMessage": "Depois de escanear o QR, o status pode ficar pendente por at\xe9 10 minutos. N\xe3o tente refazer o pagamento antes desse per\xedodo para evitar cobran\xe7a duplicada.",
            "field.valid": "Campo v\xe1lido",
            "field.invalid": "Campo inv\xe1lido",
            "error.va.gen.01": "Campo incompleto",
            "error.va.gen.02": "Campo inv\xe1lido",
            "error.va.sf-cc-num.01": "Digite um n\xfamero de cart\xe3o v\xe1lido",
            "error.va.sf-cc-num.02": "Digite o n\xfamero do cart\xe3o",
            "error.va.sf-cc-num.03": "Digite uma bandeira de cart\xe3o aceita",
            "error.va.sf-cc-num.04": "Digite o n\xfamero completo do cart\xe3o",
            "error.va.sf-cc-dat.01": "Digite uma data v\xe1lida",
            "error.va.sf-cc-dat.02": "Digite uma data v\xe1lida",
            "error.va.sf-cc-dat.03": "Cart\xe3o de cr\xe9dito prestes a vencer",
            "error.va.sf-cc-dat.04": "Digite a data de validade",
            "error.va.sf-cc-dat.05": "Digite a data de validade completa",
            "error.va.sf-cc-mth.01": "Digite o m\xeas de validade",
            "error.va.sf-cc-yr.01": "Digite o ano de validade",
            "error.va.sf-cc-yr.02": "Digite o ano de validade completo",
            "error.va.sf-cc-cvc.01": "Digite o c\xf3digo de seguran\xe7a",
            "error.va.sf-cc-cvc.02": "Digite o c\xf3digo de seguran\xe7a completo",
            "error.va.sf-ach-num.01": "O campo do n\xfamero da conta banc\xe1ria est\xe1 vazio",
            "error.va.sf-ach-num.02": "O n\xfamero da conta banc\xe1ria tem o comprimento errado",
            "error.va.sf-ach-loc.01": "O campo do n\xfamero de identifica\xe7\xe3o do banco est\xe1 vazio",
            "error.va.sf-ach-loc.02": "O n\xfamero de identifica\xe7\xe3o do banco tem o comprimento errado",
            "error.va.sf-kcp-pwd.01": "O campo da senha est\xe1 vazio",
            "error.va.sf-kcp-pwd.02": "A senha tem o comprimento errado",
            "error.giftcard.no-balance": "Este vale-presente tem saldo zero",
            "error.giftcard.card-error": "N\xe3o existe um vale-presente com esse n\xfamero em nossos registros",
            "error.giftcard.currency-error": "Os vales-presente s\xe3o v\xe1lidos somente na moeda em que foram emitidos",
            "amazonpay.signout": "Sair do Amazon",
            "amazonpay.changePaymentDetails": "Alterar dados de pagamento",
            "partialPayment.warning": "Selecione outro m\xe9todo de pagamento para pagar o restante",
            "partialPayment.remainingBalance": "O saldo restante ser\xe1 %{amount}",
            "bankTransfer.beneficiary": "Benefici\xe1rio",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Refer\xeancia",
            "bankTransfer.introduction": "Continue criando o novo pagamento por transfer\xeancia banc\xe1ria. Use as informa\xe7\xf5es na tela a seguir para conclu\xed-lo.",
            "bankTransfer.instructions": "Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.",
            "bacs.accountHolderName": "Nome do titular da conta banc\xe1ria",
            "bacs.accountHolderName.invalid": "Nome do titular da conta banc\xe1ria inv\xe1lido",
            "bacs.accountNumber": "N\xfamero da conta banc\xe1ria",
            "bacs.accountNumber.invalid": "N\xfamero da conta banc\xe1ria inv\xe1lido",
            "bacs.bankLocationId": "C\xf3digo de classifica\xe7\xe3o",
            "bacs.bankLocationId.invalid": "C\xf3digo de classifica\xe7\xe3o inv\xe1lido",
            "bacs.consent.amount": "Concordo que o valor acima seja deduzido da minha conta banc\xe1ria.",
            "bacs.consent.account": "Confirmo que a conta est\xe1 em meu nome e que sou o \xfanico signat\xe1rio que deve autorizar o d\xe9bito direto nessa conta.",
            edit: "Editar",
            "bacs.confirm": "Confirmar e pagar",
            "bacs.result.introduction": "Baixar instru\xe7\xe3o de d\xe9bito direto (DDI)",
            "download.pdf": "Baixar PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe para n\xfamero do cart\xe3o",
            "creditCard.encryptedCardNumber.aria.label": "N\xfamero do cart\xe3o",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe para data de validade",
            "creditCard.encryptedExpiryDate.aria.label": "Data de validade",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe para m\xeas de validade",
            "creditCard.encryptedExpiryMonth.aria.label": "M\xeas de vencimento",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe para ano de validade",
            "creditCard.encryptedExpiryYear.aria.label": "Ano de vencimento",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe para c\xf3digo de seguran\xe7a",
            "creditCard.encryptedSecurityCode.aria.label": "C\xf3digo de seguran\xe7a",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe para senha",
            "creditCard.encryptedPassword.aria.label": "Primeiros dois d\xedgitos da senha do cart\xe3o",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe para n\xfamero do cart\xe3o",
            "giftcard.encryptedCardNumber.aria.label": "N\xfamero do cart\xe3o",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe para pin",
            "giftcard.encryptedSecurityCode.aria.label": "Pin",
            giftcardTransactionLimit: "M\xe1ximo de %{amount} permitido por transa\xe7\xe3o neste cart\xe3o-presente",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe para n\xfamero da conta banc\xe1ria",
            "ach.encryptedBankAccountNumber.aria.label": "N\xfamero da conta",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe para n\xfamero de identifica\xe7\xe3o do banco",
            "ach.encryptedBankLocationId.aria.label": "N\xfamero de roteamento ABA",
            "pix.instructions": "Abra o app com sua chave PIX cadastrada, escolha Pagar com Pix e escaneie o QR Code ou copie e cole o c\xf3digo",
            "twint.saved": "salvo",
            orPayWith: "ou pague com",
            invalidFormatExpects: "Formato inv\xe1lido. Formato esperado: %{format}",
            "upi.qrCodeWaitingMessage": "Escaneie o QR code com o aplicativo UPI de sua prefer\xeancia para concluir o pagamento",
            "upi.vpaWaitingMessage": "Abra o aplicativo UPI para confirmar o pagamento",
            "upi.modeSelection": "Selecione como voc\xea gostaria de usar o UPI.",
            "onlineBanking.termsAndConditions": "Ao continuar, voc\xea concorda com os %#termos e condi\xe7\xf5es%#",
            "onlineBankingPL.termsAndConditions": "Ao continuar, voc\xea concorda com as %#condi\xe7\xf5es%# e as %#informa\xe7\xf5es obrigat\xf3rias%# da Przelewy24",
            "ctp.loading.poweredByCtp": "Desenvolvido por Click to Pay",
            "ctp.loading.intro": "Estamos verificando se voc\xea tem algum cart\xe3o salvo no Click to Pay...",
            "ctp.login.title": "Continuar para o Click to Pay",
            "ctp.login.subtitle": "Digite o endere\xe7o de e-mail associado ao Click to Pay para continuar.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "N\xe3o \xe9 voc\xea?",
            "ctp.logout.notYourCards": "N\xe3o \xe9 o seu cart\xe3o?",
            "ctp.logout.notYourCard": "N\xe3o \xe9 o seu cart\xe3o?",
            "ctp.logout.notYourProfile": "N\xe3o \xe9 o seu perfil?",
            "ctp.otp.fieldLabel": "C\xf3digo de acesso \xfanico",
            "ctp.otp.resendCode": "Reenviar c\xf3digo",
            "ctp.otp.codeResent": "C\xf3digo reenviado",
            "ctp.otp.title": "Acesse seus cart\xf5es Click to Pay",
            "ctp.otp.subtitle": "Digite o c\xf3digo %@ enviado para %@ para confirmar que \xe9 voc\xea.",
            "ctp.otp.saveCookiesCheckbox.label": "Ignorar verifica\xe7\xe3o da pr\xf3xima vez",
            "ctp.otp.saveCookiesCheckbox.information": "Selecione esta op\xe7\xe3o para ser lembrado no seu dispositivo e navegador, agilizando o pagamento nas lojas participantes. N\xe3o recomendado para dispositivos compartilhados.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Selecione para ser lembrado em seu dispositivo e navegador",
            "ctp.emptyProfile.message": "N\xe3o h\xe1 nenhum cart\xe3o cadastrado neste perfil do Click to Pay",
            "ctp.separatorText": "ou use",
            "ctp.cards.title": "Concluir o pagamento com o Click to Pay",
            "ctp.cards.subtitle": "Selecione um cart\xe3o para usar.",
            "ctp.cards.expiredCard": "Vencido",
            "ctp.manualCardEntry": "Entrada manual do cart\xe3o",
            "ctp.aria.infoModalButton": "O que \xe9 Click to Pay",
            "ctp.infoPopup.title": "O Click to Pay traz a facilidade do pagamento online sem contato",
            "ctp.infoPopup.subtitle": "Um m\xe9todo de pagamento r\xe1pido e seguro, compat\xedvel com Mastercard, Visa e outros cart\xf5es.",
            "ctp.infoPopup.benefit1": "O Click to Pay usa criptografia para manter suas informa\xe7\xf5es seguras e protegidas",
            "ctp.infoPopup.benefit2": "Use com comerciantes no mundo todo",
            "ctp.infoPopup.benefit3": "Configure apenas uma vez e simplifique seus pagamentos no futuro",
            "ctp.errors.AUTH_INVALID": "Autentica\xe7\xe3o inv\xe1lida",
            "ctp.errors.NOT_FOUND": "Nenhuma conta foi encontrada. Informe um e-mail v\xe1lido ou continue inserindo os dados do cart\xe3o manualmente",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formato n\xe3o compat\xedvel",
            "ctp.errors.FRAUD": "A conta do usu\xe1rio foi bloqueada ou desativada",
            "ctp.errors.CONSUMER_ID_MISSING": "A identidade do consumidor est\xe1 ausente na solicita\xe7\xe3o",
            "ctp.errors.ACCT_INACCESSIBLE": "Esta conta n\xe3o est\xe1 dispon\xedvel no momento. Ela pode estar bloqueada, por exemplo",
            "ctp.errors.CODE_INVALID": "C\xf3digo de verifica\xe7\xe3o incorreto",
            "ctp.errors.CODE_EXPIRED": "Esse c\xf3digo expirou",
            "ctp.errors.RETRIES_EXCEEDED": "O limite de tentativas para gerar a senha de uso \xfanico foi excedido",
            "ctp.errors.OTP_SEND_FAILED": "N\xe3o foi poss\xedvel enviar a senha de uso \xfanico ao destinat\xe1rio",
            "ctp.errors.REQUEST_TIMEOUT": "Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente",
            "ctp.errors.UNKNOWN_ERROR": "Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente",
            "ctp.errors.SERVICE_ERROR": "Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente",
            "ctp.errors.SERVER_ERROR": "Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente",
            "ctp.errors.INVALID_PARAMETER": "Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente",
            "ctp.errors.AUTH_ERROR": "Algo deu errado. Tente de novo ou insira os dados do cart\xe3o manualmente",
            "paymentMethodsList.aria.label": "Escolha um m\xe9todo de pagamento",
            "companyDetails.name.invalid": "Digite o nome da empresa",
            "companyDetails.registrationNumber.invalid": "Digite o n\xfamero de registro",
            "consent.checkbox.invalid": "Voc\xea precisa concordar com os termos e condi\xe7\xf5es",
            "form.instruction": "Todos os campos s\xe3o obrigat\xf3rios, a menos que marcados em contr\xe1rio.",
            "trustly.descriptor": "Pagamento instant\xe2neo",
            "trustly.description1": "Pague diretamente de qualquer conta, com a seguran\xe7a do seu banco",
            "trustly.description2": "Sem cart\xe3o, sem download de aplicativo, sem cadastro",
            "ancv.input.label": "Sua identifica\xe7\xe3o da ANCV",
            "ancv.confirmPayment": "Use o aplicativo da ANCV para confirmar o pagamento.",
            "ancv.form.instruction": "\xc9 necess\xe1rio ter o aplicativo da Cheque-Vacances para validar este pagamento.",
            "ancv.beneficiaryId.invalid": "Insira um endere\xe7o de e-mail v\xe1lido ou uma ID da ANCV",
            "payme.openPayMeApp": "Para concluir o pagamento no PayMe, autorize-o no aplicativo e aguarde a confirma\xe7\xe3o.",
            "payme.redirectButtonLabel": "Abrir o aplicativo PayMe",
            "payme.scanQrCode": "Concluir o pagamento com um c\xf3digo QR",
            "payme.timeToPay": "Este QR code \xe9 v\xe1lido para %@",
            "payme.instructions.steps": "Abra o aplicativo PayMe.%@Escaneie o QR code para autorizar o pagamento.%@Conclua o pagamento no aplicativo e aguarde a confirma\xe7\xe3o.",
            "payme.instructions.footnote": "N\xe3o feche esta p\xe1gina antes de concluir o pagamento"
        }
    }), c2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Pagar",
            "payButton.redirecting": "Redirecionar...",
            "payButton.with": "Pagar %{value} com %{maskedData}",
            "payButton.saveDetails": "Guardar detalhes",
            close: "Fechar",
            storeDetails: "Guardar para o meu pr\xf3ximo pagamento",
            readMore: "Ler mais",
            "creditCard.holderName": "Nome no cart\xe3o",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "Introduzir o nome como mostrado no cart\xe3o",
            "creditCard.numberField.title": "N\xfamero de cart\xe3o",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Data de validade",
            "creditCard.expiryDateField.placeholder": "MM/AA",
            "creditCard.expiryDateField.month": "M\xeas",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "AA",
            "creditCard.expiryDateField.year": "Ano",
            "creditCard.cvcField.title": "C\xf3digo de seguran\xe7a",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Lembre-se para a pr\xf3xima vez",
            "creditCard.cvcField.placeholder.4digits": "4 d\xedgitos",
            "creditCard.cvcField.placeholder.3digits": "3 d\xedgitos",
            "creditCard.taxNumber.placeholder": "AAMMDD / 0123456789",
            installments: "N\xfamero de presta\xe7\xf5es",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} meses",
            "installments.oneTime": "Pagamento \xfanico",
            "installments.installments": "Pagamento em presta\xe7\xf5es",
            "installments.revolving": "Pagamento rotativo",
            "sepaDirectDebit.ibanField.invalid": "N\xfamero de conta inv\xe1lido",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "Nome do Titular",
            "sepa.ibanNumber": "N\xfamero da conta (IBAN)",
            "error.title": "Erro",
            "error.subtitle.redirect": "Falha ao redirecionar",
            "error.subtitle.payment": "O pagamento falhou",
            "error.subtitle.refused": "Pagamento recusado",
            "error.message.unknown": "Ocorreu um erro desconhecido",
            "errorPanel.title": "Erros existentes",
            "idealIssuer.selectField.title": "Banco",
            "idealIssuer.selectField.placeholder": "Selecione o seu banco",
            "creditCard.success": "Pagamento bem-sucedido",
            loading: "A carregar",
            continue: "Continuar",
            continueTo: "Continuar para",
            "wechatpay.timetopay": "Tem %@ para pagar",
            "sr.wechatpay.timetopay": "Tem %#minutos%# %#segundos%# para pagar",
            "wechatpay.scanqrcode": "Digitalizar c\xf3digo QR",
            personalDetails: "Detalhes pessoais",
            companyDetails: "Detalhes da empresa",
            "companyDetails.name": "Nome da empresa",
            "companyDetails.registrationNumber": "N\xfamero de registo",
            socialSecurityNumber: "N\xfamero de previd\xeancia social",
            firstName: "Nome pr\xf3prio",
            "firstName.invalid": "Introduza o seu nome pr\xf3prio",
            infix: "Prefixo",
            lastName: "Apelido",
            "lastName.invalid": "Introduza o seu apelido",
            mobileNumber: "N\xfamero de telem\xf3vel",
            "mobileNumber.invalid": "N\xfamero de telem\xf3vel inv\xe1lido",
            city: "Cidade",
            postalCode: "C\xf3digo postal",
            "postalCode.optional": "C\xf3digo postal (opcional)",
            countryCode: "C\xf3digo do pa\xeds",
            telephoneNumber: "N\xfamero de telefone",
            dateOfBirth: "Data de nascimento",
            shopperEmail: "Endere\xe7o de correio eletr\xf3nico",
            gender: "G\xe9nero",
            "gender.notselected": "Selecione o seu g\xe9nero",
            male: "Homem",
            female: "Feminino",
            billingAddress: "Morada de cobran\xe7a",
            street: "Rua",
            stateOrProvince: "Estado ou prov\xedncia",
            country: "Pa\xeds",
            houseNumberOrName: "N\xfamero de porta",
            separateDeliveryAddress: "Especifique uma morada de entrega separada",
            deliveryAddress: "Morada de entrega",
            "deliveryAddress.firstName": "Nome pr\xf3prio do destinat\xe1rio",
            "deliveryAddress.lastName": "Apelido do destinat\xe1rio",
            zipCode: "C\xf3digo postal",
            apartmentSuite: "Apartamento/Suite",
            provinceOrTerritory: "Prov\xedncia ou Territ\xf3rio",
            cityTown: "Cidade/cidade",
            address: "Morada",
            "address.placeholder": "Encontre o seu endere\xe7o",
            "address.errors.incomplete": "Introduza um endere\xe7o para continuar",
            "address.enterManually": "Introduza o endere\xe7o manualmente",
            state: "Estado",
            "field.title.optional": "(opcional)",
            "creditCard.cvcField.title.optional": "C\xf3digo de seguran\xe7a (opcional)",
            "issuerList.wallet.placeholder": "Selecione a sua carteira",
            privacyPolicy: "Pol\xedtica de Privacidade",
            "afterPay.agreement": "Concordo com o %@ da Riverty",
            paymentConditions: "condi\xe7\xf5es de pagamento",
            openApp: "Abra a aplica\xe7\xe3o",
            "voucher.readInstructions": "Ler instru\xe7\xf5es",
            "voucher.introduction": "Obrigado pela sua compra, utilize o seguinte cup\xe3o para completar o seu pagamento.",
            "voucher.expirationDate": "Data de validade",
            "voucher.alternativeReference": "Refer\xeancia alternativa",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Selecione seu fornecedor",
            "dragonpay.voucher.bank.selectField.placeholder": "Selecione o seu banco",
            "voucher.paymentReferenceLabel": "Refer\xeancia de pagamento",
            "voucher.surcharge": "Incl. %@ sobretaxa",
            "voucher.introduction.doku": "Obrigado pela sua compra, use as seguintes informa\xe7\xf5es para concluir o seu pagamento.",
            "voucher.shopperName": "Nome do comprador",
            "voucher.merchantName": "Comerciante",
            "voucher.introduction.econtext": "Obrigado pela sua compra, use as seguintes informa\xe7\xf5es para concluir o seu pagamento.",
            "voucher.telephoneNumber": "N\xfamero de telefone",
            "voucher.shopperReference": "Refer\xeancia do consumidor",
            "voucher.collectionInstitutionNumber": "N\xfamero da institui\xe7\xe3o de recolha",
            "voucher.econtext.telephoneNumber.invalid": "O n\xfamero de telefone deve ter 10 ou 11 d\xedgitos",
            "boletobancario.btnLabel": "Gerar comprovativo",
            "boleto.sendCopyToEmail": "Enviar uma c\xf3pia para o meu e-mail",
            "button.copy": "Copiar",
            "button.download": "Download",
            "boleto.socialSecurityNumber": "CPF/CNPJ",
            "boleto.socialSecurityNumber.invalid": "O campo n\xe3o \xe9 v\xe1lido",
            "creditCard.storedCard.description.ariaLabel": "O cart\xe3o armazenado termina em %@",
            "voucher.entity": "Entidade",
            donateButton: "Doar",
            notNowButton: "Agora n\xe3o",
            thanksForYourSupport: "Obrigado pelo seu apoio!",
            "resultMessages.preauthorized": "Detalhes guardados",
            preauthorizeWith: "Pr\xe9-autorizar com",
            confirmPreauthorization: "Confirmar pr\xe9-autoriza\xe7\xe3o",
            confirmPurchase: "Confirmar compra",
            applyGiftcard: "Resgatar",
            giftcardBalance: "Saldo do cart\xe3o-presente",
            deductedBalance: "Saldo deduzido",
            "creditCard.pin.title": "Pin",
            "creditCard.encryptedPassword.label": "Primeiros 2 d\xedgitos da palavra-passe do cart\xe3o",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Palavra-passe inv\xe1lida",
            "creditCard.taxNumber": "Data de nascimento do titular do cart\xe3o ou n\xfamero de registo da Empresa",
            "creditCard.taxNumber.label": "Data de nascimento do titular do cart\xe3o (AAMMDD) ou n\xfamero de registo da Empresa (10 d\xedgitos)",
            "creditCard.taxNumber.labelAlt": "N\xfamero de registo da empresa (10 d\xedgitos)",
            "creditCard.taxNumber.invalid": "Data de nascimento do titular do cart\xe3o ou n\xfamero de registo empresarial inv\xe1lido",
            "storedPaymentMethod.disable.button": "Remover",
            "storedPaymentMethod.disable.confirmation": "Remover m\xe9todo de pagamento guardado",
            "storedPaymentMethod.disable.confirmButton": "Sim, remover",
            "storedPaymentMethod.disable.cancelButton": "Cancelar",
            "ach.bankAccount": "Conta banc\xe1ria",
            "ach.accountHolderNameField.title": "Nome do titular da conta",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Nome do titular da conta inv\xe1lido",
            "ach.accountNumberField.title": "N\xfamero da conta",
            "ach.accountNumberField.invalid": "N\xfamero de conta inv\xe1lido",
            "ach.accountLocationField.title": "N\xfamero de encaminhamento da ABA",
            "ach.accountLocationField.invalid": "N\xfamero de encaminhamento ABA inv\xe1lido",
            "ach.savedBankAccount": "Conta banc\xe1ria guardada",
            "select.state": "Selecione estado",
            "select.stateOrProvince": "Selecione estado ou prov\xedncia",
            "select.provinceOrTerritory": "Selecionar prov\xedncia ou territ\xf3rio",
            "select.country": "Selecionar pa\xeds",
            "select.noOptionsFound": "Nenhuma op\xe7\xe3o encontrada",
            "select.filter.placeholder": "Pesquisar...",
            "telephoneNumber.invalid": "N\xfamero de telefone inv\xe1lido",
            qrCodeOrApp: "ou",
            "paypal.processingPayment": "A processar pagamento...",
            generateQRCode: "Gerar c\xf3digo QR",
            "await.waitForConfirmation": "A aguardar confirma\xe7\xe3o",
            "mbway.confirmPayment": "Confirme o seu pagamento na aplica\xe7\xe3o MB WAY",
            "shopperEmail.invalid": "Endere\xe7o de e-mail inv\xe1lido",
            "dateOfBirth.format": "DD/MM/AAAA",
            "dateOfBirth.invalid": "Insira uma data de nascimento v\xe1lida que indique que tem pelo menos 18 anos",
            "blik.confirmPayment": "Abra a sua aplica\xe7\xe3o banc\xe1ria para confirmar o pagamento.",
            "blik.invalid": "Digite 6 n\xfameros",
            "blik.code": "C\xf3digo de 6 d\xedgitos",
            "blik.help": "Obtenha o c\xf3digo da sua aplica\xe7\xe3o banc\xe1ria.",
            "swish.pendingMessage": "Ap\xf3s a leitura, o estado pode estar pendente por at\xe9 10 minutos. Tentar pagar novamente dentro desse prazo pode resultar em v\xe1rias cobran\xe7as.",
            "field.valid": "Campo v\xe1lido",
            "field.invalid": "Campo inv\xe1lido",
            "error.va.gen.01": "Campo incompleto",
            "error.va.gen.02": "Campo inv\xe1lido",
            "error.va.sf-cc-num.01": "Introduza um n\xfamero de cart\xe3o v\xe1lido",
            "error.va.sf-cc-num.02": "Introduza o n\xfamero do cart\xe3o",
            "error.va.sf-cc-num.03": "Introduza uma marca de cart\xe3o suportada",
            "error.va.sf-cc-num.04": "Introduza o n\xfamero do cart\xe3o completo",
            "error.va.sf-cc-dat.01": "Introduza uma data de validade v\xe1lida",
            "error.va.sf-cc-dat.02": "Introduza uma data de validade v\xe1lida",
            "error.va.sf-cc-dat.03": "Cart\xe3o de cr\xe9dito prestes a expirar",
            "error.va.sf-cc-dat.04": "Introduza a data de validade",
            "error.va.sf-cc-dat.05": "Introduza a data de validade completa",
            "error.va.sf-cc-mth.01": "Introduza o m\xeas de validade",
            "error.va.sf-cc-yr.01": "Introduza o ano de validade",
            "error.va.sf-cc-yr.02": "Introduza o ano de validade completa",
            "error.va.sf-cc-cvc.01": "Introduza o c\xf3digo de seguran\xe7a",
            "error.va.sf-cc-cvc.02": "Introduza o c\xf3digo de seguran\xe7a completo",
            "error.va.sf-ach-num.01": "O campo de n\xfamero da conta banc\xe1ria est\xe1 vazio",
            "error.va.sf-ach-num.02": "O n\xfamero da conta banc\xe1ria tem o comprimento errado",
            "error.va.sf-ach-loc.01": "O campo do n\xfamero de encaminhamento banc\xe1rio est\xe1 vazio",
            "error.va.sf-ach-loc.02": "O n\xfamero de identifica\xe7\xe3o banc\xe1ria tem o comprimento errado",
            "error.va.sf-kcp-pwd.01": "O campo de palavra-passe est\xe1 vazio",
            "error.va.sf-kcp-pwd.02": "A palavra-passe tem o comprimento errado",
            "error.giftcard.no-balance": "Este cart\xe3o oferta tem saldo zero",
            "error.giftcard.card-error": "Nos nossos registos n\xe3o temos qualquer cart\xe3o oferta com este n\xfamero",
            "error.giftcard.currency-error": "Os cart\xf5es oferta s\xf3 s\xe3o v\xe1lidos na moeda em que foram emitidos",
            "amazonpay.signout": "Sair da Amazon",
            "amazonpay.changePaymentDetails": "Alterar detalhes de pagamento",
            "partialPayment.warning": "Selecione outro m\xe9todo de pagamento para pagar o restante",
            "partialPayment.remainingBalance": "O saldo restante ser\xe1 de %{amount}",
            "bankTransfer.beneficiary": "Benefici\xe1rio(a)",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Refer\xeancia",
            "bankTransfer.introduction": "Continue para criar um novo pagamento de transfer\xeancia banc\xe1ria. Pode usar os detalhes no ecr\xe3 a seguir para finalizar este pagamento.",
            "bankTransfer.instructions": "Obrigado pela sua compra, use as seguintes informa\xe7\xf5es para concluir o seu pagamento.",
            "bacs.accountHolderName": "Nome do titular da conta banc\xe1ria",
            "bacs.accountHolderName.invalid": "Nome do titular da conta banc\xe1ria inv\xe1lido",
            "bacs.accountNumber": "N\xfamero da conta banc\xe1ria",
            "bacs.accountNumber.invalid": "N\xfamero de conta banc\xe1ria inv\xe1lido",
            "bacs.bankLocationId": "C\xf3digo de classifica\xe7\xe3o",
            "bacs.bankLocationId.invalid": "C\xf3digo de classifica\xe7\xe3o inv\xe1lido",
            "bacs.consent.amount": "Concordo que o valor acima seja deduzido da minha conta banc\xe1ria.",
            "bacs.consent.account": "Confirmo que a conta est\xe1 em meu nome e sou o \xfanico signat\xe1rio necess\xe1rio para autorizar o d\xe9bito autom\xe1tico nesta conta.",
            edit: "Editar",
            "bacs.confirm": "Confirmar e pagar",
            "bacs.result.introduction": "Descarregue a sua Instru\xe7\xe3o de D\xe9bito Direto (DDI / Mandato)",
            "download.pdf": "Descarregar PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe para o n\xfamero do cart\xe3o",
            "creditCard.encryptedCardNumber.aria.label": "N\xfamero de cart\xe3o",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe para data de validade",
            "creditCard.encryptedExpiryDate.aria.label": "Data de validade",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe para o m\xeas de validade",
            "creditCard.encryptedExpiryMonth.aria.label": "M\xeas de validade",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe para o ano de validade",
            "creditCard.encryptedExpiryYear.aria.label": "Ano de validade",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe para c\xf3digo de seguran\xe7a",
            "creditCard.encryptedSecurityCode.aria.label": "C\xf3digo de seguran\xe7a",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe para palavra-passe",
            "creditCard.encryptedPassword.aria.label": "Primeiros 2 d\xedgitos da palavra-passe do cart\xe3o",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe para o n\xfamero do cart\xe3o",
            "giftcard.encryptedCardNumber.aria.label": "N\xfamero de cart\xe3o",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe para pin",
            "giftcard.encryptedSecurityCode.aria.label": "Pin",
            giftcardTransactionLimit: "M\xe1ximo de %{amount} permitido por transa\xe7\xe3o neste cart\xe3o presente",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe para n\xfamero de conta banc\xe1ria",
            "ach.encryptedBankAccountNumber.aria.label": "N\xfamero da conta",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe para n\xfamero de identifica\xe7\xe3o banc\xe1ria",
            "ach.encryptedBankLocationId.aria.label": "N\xfamero de encaminhamento da ABA",
            "pix.instructions": "Abra a aplica\xe7\xe3o com a chave registada PIX, escolha Pagar com PIX e digitalize o QR Code ou copie e cole o c\xf3digo",
            "twint.saved": "salvou",
            orPayWith: "ou pague com",
            invalidFormatExpects: "Formato inv\xe1lido. Formato esperado: %{format}",
            "upi.qrCodeWaitingMessage": "Digitalize o c\xf3digo QR usando a sua aplica\xe7\xe3o UPI preferida para concluir o pagamento",
            "upi.vpaWaitingMessage": "Abra a aplica\xe7\xe3o UPI para confirmar o pagamento",
            "upi.modeSelection": "Fa\xe7a uma sele\xe7\xe3o de como gostaria de usar a UPI.",
            "onlineBanking.termsAndConditions": "Ao continuar, concorda com os %#termos e condi\xe7\xf5es%#",
            "onlineBankingPL.termsAndConditions": "Ao continuar, concorda com o %#regulamento%# e a %#obriga\xe7\xe3o de informa\xe7\xe3o%# da Przelewy24",
            "ctp.loading.poweredByCtp": "Fornecido pelo Click to Pay",
            "ctp.loading.intro": "Estamos a verificar se tem algum cart\xe3o Click to Pay guardado...",
            "ctp.login.title": "Continuar para o Click to Pay",
            "ctp.login.subtitle": "Introduza o endere\xe7o de e-mail associado ao Click to Pay para continuar.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "N\xe3o \xe9 voc\xea?",
            "ctp.logout.notYourCards": "N\xe3o s\xe3o os seus cart\xf5es?",
            "ctp.logout.notYourCard": "N\xe3o \xe9 o seu cart\xe3o?",
            "ctp.logout.notYourProfile": "N\xe3o \xe9 o seu perfil?",
            "ctp.otp.fieldLabel": "C\xf3digo \xfanico",
            "ctp.otp.resendCode": "Reenviar c\xf3digo",
            "ctp.otp.codeResent": "C\xf3digo reenviado",
            "ctp.otp.title": "Aceda aos seus cart\xf5es Click to Pay",
            "ctp.otp.subtitle": "Introduza o c\xf3digo %@ enviado para %@ para verificar se \xe9 voc\xea.",
            "ctp.otp.saveCookiesCheckbox.label": "Saltar verifica\xe7\xe3o da pr\xf3xima vez",
            "ctp.otp.saveCookiesCheckbox.information": "Selecione para ser memorizado no seu dispositivo e navegador nas lojas participantes, para uma finaliza\xe7\xe3o de compra mais r\xe1pida. N\xe3o recomendado para dispositivos partilhados.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Selecione para ser memorizado no seu dispositivo e navegador",
            "ctp.emptyProfile.message": "Nenhum cart\xe3o registado neste perfil Click to Pay",
            "ctp.separatorText": "ou utilize",
            "ctp.cards.title": "Pagamento completo com Click to Pay",
            "ctp.cards.subtitle": "Selecione um cart\xe3o para usar.",
            "ctp.cards.expiredCard": "Expirado",
            "ctp.manualCardEntry": "Introdu\xe7\xe3o manual do cart\xe3o",
            "ctp.aria.infoModalButton": "O que \xe9 Click to Pay",
            "ctp.infoPopup.title": "O Click to Pay traz a facilidade do contactless online",
            "ctp.infoPopup.subtitle": "Um m\xe9todo de pagamento r\xe1pido e seguro suportado pela Mastercard, Visa e outros cart\xf5es de pagamento.",
            "ctp.infoPopup.benefit1": "Click to Pay utiliza encripta\xe7\xe3o para manter as suas informa\xe7\xf5es seguras",
            "ctp.infoPopup.benefit2": "Use-o com comerciantes em todo o mundo",
            "ctp.infoPopup.benefit3": "Configure uma vez para pagamentos sem complica\xe7\xf5es no futuro",
            "ctp.errors.AUTH_INVALID": "Autentica\xe7\xe3o inv\xe1lida",
            "ctp.errors.NOT_FOUND": "Nenhuma conta encontrada, insira um e-mail v\xe1lido ou continue usando a entrada manual do cart\xe3o",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formato n\xe3o suportado",
            "ctp.errors.FRAUD": "A conta de utilizador foi bloqueada ou desativada",
            "ctp.errors.CONSUMER_ID_MISSING": "A identidade do consumidor est\xe1 em falta no pedido",
            "ctp.errors.ACCT_INACCESSIBLE": "Esta conta n\xe3o est\xe1 atualmente dispon\xedvel, por exemplo, est\xe1 bloqueada",
            "ctp.errors.CODE_INVALID": "C\xf3digo de verifica\xe7\xe3o incorreto",
            "ctp.errors.CODE_EXPIRED": "Este c\xf3digo expirou",
            "ctp.errors.RETRIES_EXCEEDED": "Ultrapassou o limite para o n\xfamero de tentativas para a gera\xe7\xe3o OTP.",
            "ctp.errors.OTP_SEND_FAILED": "N\xe3o foi poss\xedvel enviar a OTP ao destinat\xe1rio",
            "ctp.errors.REQUEST_TIMEOUT": "Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual",
            "ctp.errors.UNKNOWN_ERROR": "Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual",
            "ctp.errors.SERVICE_ERROR": "Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual",
            "ctp.errors.SERVER_ERROR": "Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual",
            "ctp.errors.INVALID_PARAMETER": "Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual",
            "ctp.errors.AUTH_ERROR": "Algo correu mal, tente de novo ou use a entrada do cart\xe3o manual",
            "paymentMethodsList.aria.label": "Escolha um m\xe9todo de pagamento",
            "companyDetails.name.invalid": "Insira o nome da empresa",
            "companyDetails.registrationNumber.invalid": "Insira o n\xfamero de registo",
            "consent.checkbox.invalid": "Tem de aceitar os termos e condi\xe7\xf5es",
            "form.instruction": "Todos os campos s\xe3o obrigat\xf3rios, a menos que assinalados em contr\xe1rio.",
            "trustly.descriptor": "Pagamento banc\xe1rio instant\xe2neo",
            "trustly.description1": "Pague diretamente a partir de qualquer uma das suas contas banc\xe1rias, com a seguran\xe7a de um banco",
            "trustly.description2": "Sem cart\xf5es, sem transferir aplica\xe7\xf5es, sem registo",
            "ancv.input.label": "A sua identifica\xe7\xe3o de ANCV",
            "ancv.confirmPayment": "Use a sua aplica\xe7\xe3o ANCV para confirmar o pagamento.",
            "ancv.form.instruction": "A app Cheque-Vacances \xe9 necess\xe1ria para validar este pagamento.",
            "ancv.beneficiaryId.invalid": "Insira um endere\xe7o de e-mail ou ID v\xe1lido de ANCV",
            "payme.openPayMeApp": "Conclua o seu pagamento na app PayMe autorizando o pagamento na app e aguardando a confirma\xe7\xe3o.",
            "payme.redirectButtonLabel": "Abrir a app PayMe",
            "payme.scanQrCode": "Conclua o seu pagamento por c\xf3digo QR",
            "payme.timeToPay": "Este c\xf3digo QR \xe9 v\xe1lido para %@",
            "payme.instructions.steps": "Abra a app PayMe.%@Leia o c\xf3digo QR para autorizar o pagamento.%@Conclua o pagamento na app e aguarde a confirma\xe7\xe3o.",
            "payme.instructions.footnote": "N\xe3o feche esta p\xe1gina antes de concluir o pagamento"
        }
    }), s2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Pl\u0103ti\u021Bi",
            "payButton.redirecting": "Se redirec\u021Bioneaz\u0103...",
            "payButton.with": "Pl\u0103ti\u021Bi %{value} cu %{maskedData}",
            "payButton.saveDetails": "Salva\u021Bi detaliile",
            close: "\xcenchidere",
            storeDetails: "Salveaz\u0103 pentru urm\u0103toarea mea plat\u0103",
            readMore: "Citi\u021Bi mai mult",
            "creditCard.holderName": "Numele de pe card",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "Completa\u021Bi numele dup\u0103 cum figureaz\u0103 pe card",
            "creditCard.numberField.title": "Num\u0103r card",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Data expir\u0103rii",
            "creditCard.expiryDateField.placeholder": "LL/AA",
            "creditCard.expiryDateField.month": "Lun\u0103",
            "creditCard.expiryDateField.month.placeholder": "LL",
            "creditCard.expiryDateField.year.placeholder": "AA",
            "creditCard.expiryDateField.year": "An",
            "creditCard.cvcField.title": "Cod de securitate",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Re\u021Bine pentru data viitoare",
            "creditCard.cvcField.placeholder.4digits": "4 cifre",
            "creditCard.cvcField.placeholder.3digits": "3 cifre",
            "creditCard.taxNumber.placeholder": "AALLZZ / 0123456789",
            installments: "Num\u0103r de rate",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} luni",
            "installments.oneTime": "Plat\u0103 unic\u0103",
            "installments.installments": "Plat\u0103 \xeen rate",
            "installments.revolving": "Plat\u0103 recurent\u0103",
            "sepaDirectDebit.ibanField.invalid": "Num\u0103rul de cont este incorect",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "Nume posesor",
            "sepa.ibanNumber": "Num\u0103r cont (IBAN)",
            "error.title": "Eroare",
            "error.subtitle.redirect": "Redirec\u021Bionare e\u0219uat\u0103",
            "error.subtitle.payment": "Plat\u0103 e\u0219uat\u0103",
            "error.subtitle.refused": "Plat\u0103 refuzat\u0103",
            "error.message.unknown": "S-a produs o eroare necunoscut\u0103",
            "errorPanel.title": "Erori existente",
            "idealIssuer.selectField.title": "Banc\u0103",
            "idealIssuer.selectField.placeholder": "Selecta\u021Bi-v\u0103 banca",
            "creditCard.success": "Plat\u0103 reu\u0219it\u0103",
            loading: "Se \xeencarc\u0103...",
            continue: "Continuare",
            continueTo: "Continua\u021Bi c\u0103tre",
            "wechatpay.timetopay": "Trebuie s\u0103 achita\u021Bi %@",
            "sr.wechatpay.timetopay": "Ave\u021Bi la dispozi\u021Bie %#minute%# %#secunde%# pentru a pl\u0103ti",
            "wechatpay.scanqrcode": "Scana\u021Bi codul QR",
            personalDetails: "Informa\u021Bii personale",
            companyDetails: "Informa\u021Bii societate",
            "companyDetails.name": "Denumirea societ\u0103\u021Bii",
            "companyDetails.registrationNumber": "Num\u0103r de \xeenregistrare",
            socialSecurityNumber: "Cod numeric personal",
            firstName: "Prenume",
            "firstName.invalid": "Completa\u021Bi prenumele dvs.",
            infix: "Titulatur\u0103",
            lastName: "Nume de familie",
            "lastName.invalid": "Completa\u021Bi numele dvs. de familie",
            mobileNumber: "Num\u0103r de mobil",
            "mobileNumber.invalid": "Num\u0103r de telefon mobil incorect",
            city: "Ora\u0219",
            postalCode: "Cod po\u0219tal",
            "postalCode.optional": "Cod po\u0219tal (op\u021Bional)",
            countryCode: "Codul \u021B\u0103rii",
            telephoneNumber: "Num\u0103r de telefon",
            dateOfBirth: "Data na\u0219terii",
            shopperEmail: "Adres\u0103 de e-mail",
            gender: "Gen",
            "gender.notselected": "Selecta\u021Bi sexul dvs.",
            male: "B\u0103rbat",
            female: "Femeie",
            billingAddress: "Adresa de facturare",
            street: "Strada",
            stateOrProvince: "Jude\u021B sau provincie",
            country: "\u021Aar\u0103",
            houseNumberOrName: "Num\u0103r",
            separateDeliveryAddress: "Specifica\u021Bi o adres\u0103 de livrare separat\u0103",
            deliveryAddress: "Adres\u0103 de livrare",
            "deliveryAddress.firstName": "Prenumele destinatarului",
            "deliveryAddress.lastName": "Numele de familie al destinatarului",
            zipCode: "Cod po\u0219tal",
            apartmentSuite: "Apartament",
            provinceOrTerritory: "Provincie sau teritoriu",
            cityTown: "Ora\u0219/localitate",
            address: "Adres\u0103",
            "address.placeholder": "G\u0103si\u021Bi-v\u0103 adresa",
            "address.errors.incomplete": "Pentru a continua, introduce\u021Bi o adres\u0103",
            "address.enterManually": "Introduce\u021Bi adresa manual",
            state: "Stat",
            "field.title.optional": "(op\u021Bional)",
            "creditCard.cvcField.title.optional": "Cod de securitate (op\u021Bional)",
            "issuerList.wallet.placeholder": "Selecta\u021Bi-v\u0103 portofelul",
            privacyPolicy: "Politica de confiden\u021Bialitate",
            "afterPay.agreement": "Sunt de acord cu %@ apar\u021Bin\xe2nd Riverty",
            paymentConditions: "condi\u021Bii de plat\u0103",
            openApp: "Deschide\u021Bi aplica\u021Bia",
            "voucher.readInstructions": "Citi\u021Bi instruc\u021Biunile",
            "voucher.introduction": "V\u0103 mul\u021Bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021Bi urm\u0103torul cupon pentru a v\u0103 finaliza plata.",
            "voucher.expirationDate": "Data de expirare",
            "voucher.alternativeReference": "Referin\u021B\u0103 alternativ\u0103",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Selecta\u021Bi furnizorul dvs.",
            "dragonpay.voucher.bank.selectField.placeholder": "Selecta\u021Bi banca dvs.",
            "voucher.paymentReferenceLabel": "Referin\u021Ba pl\u0103\u021Bii",
            "voucher.surcharge": "Include suprataxa de %@",
            "voucher.introduction.doku": "V\u0103 mul\u021Bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021Bi urm\u0103toarele informa\u021Bii pentru a v\u0103 finaliza plata.",
            "voucher.shopperName": "Nume cump\u0103r\u0103tor",
            "voucher.merchantName": "Comerciant",
            "voucher.introduction.econtext": "V\u0103 mul\u021Bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021Bi urm\u0103toarele informa\u021Bii pentru a v\u0103 finaliza plata.",
            "voucher.telephoneNumber": "Num\u0103r de telefon",
            "voucher.shopperReference": "Referin\u021B\u0103 cump\u0103r\u0103tor",
            "voucher.collectionInstitutionNumber": "Num\u0103r institu\u021Bie de colectare",
            "voucher.econtext.telephoneNumber.invalid": "Num\u0103rul de telefon trebuie s\u0103 aib\u0103 10 sau 11 cifre",
            "boletobancario.btnLabel": "Generare Boleto",
            "boleto.sendCopyToEmail": "Trimite o copie la adresa mea de e-mail",
            "button.copy": "Copiere",
            "button.download": "Desc\u0103rcare",
            "boleto.socialSecurityNumber.invalid": "C\xe2mpul nu este valid",
            "creditCard.storedCard.description.ariaLabel": "Cardul memorat se termin\u0103 \xeen %@",
            "voucher.entity": "Entitate",
            donateButton: "Dona\u021Bi",
            notNowButton: "Nu acum",
            thanksForYourSupport: "V\u0103 mul\u021Bumim pentru sprijin!",
            "resultMessages.preauthorized": "Detalii salvate",
            preauthorizeWith: "Preautorizare cu",
            confirmPreauthorization: "Confirma\u021Bi preautorizarea",
            confirmPurchase: "Confirma\u021Bi achizi\u021Bia",
            applyGiftcard: "Valorificare",
            giftcardBalance: "Soldul de pe cardul cadou",
            deductedBalance: "Sold sc\u0103zut",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "Primele 2 cifre ale parolei aferente cardului",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Parol\u0103 incorect\u0103",
            "creditCard.taxNumber": "Data de na\u0219tere a posesorului de card sau codul unic de \xeenregistrare al societ\u0103\u021Bii",
            "creditCard.taxNumber.label": "Data de na\u0219tere a posesorului de card (AALLZZ) sau num\u0103rul de \xeenregistrare al societ\u0103\u021Bii (10 cifre).",
            "creditCard.taxNumber.labelAlt": "Num\u0103rul de \xeenregistrare al societ\u0103\u021Bii (10 cifre)",
            "creditCard.taxNumber.invalid": "Data de na\u0219tere a posesorului de card sau num\u0103rul de \xeenregistrare al societ\u0103\u021Bii este incorect",
            "storedPaymentMethod.disable.button": "\u0218tergere",
            "storedPaymentMethod.disable.confirmation": "\u0218terge\u021Bi metoda de plat\u0103 memorat\u0103",
            "storedPaymentMethod.disable.confirmButton": "Da, \u0219terge",
            "storedPaymentMethod.disable.cancelButton": "Anulare",
            "ach.bankAccount": "Cont bancar",
            "ach.accountHolderNameField.title": "Numele titularului de cont",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "Numele titularului de cont este incorect",
            "ach.accountNumberField.title": "Num\u0103r de cont",
            "ach.accountNumberField.invalid": "Num\u0103rul de cont este incorect",
            "ach.accountLocationField.title": "Num\u0103r de direc\u021Bionare ABA",
            "ach.accountLocationField.invalid": "Num\u0103r de direc\u021Bionare ABA incorect",
            "ach.savedBankAccount": "Cont bancar salvat",
            "select.state": "Selecta\u021Bi statul",
            "select.stateOrProvince": "Selecta\u021Bi jude\u021Bul sau provincia",
            "select.provinceOrTerritory": "Selecta\u021Bi provincia sau teritoriul",
            "select.country": "Selecta\u021Bi \u021Bara",
            "select.noOptionsFound": "Nu s-a g\u0103sit nicio op\u021Biune",
            "select.filter.placeholder": "C\u0103utare...",
            "telephoneNumber.invalid": "Num\u0103r de telefon incorect",
            qrCodeOrApp: "sau",
            "paypal.processingPayment": "Se prelucreaz\u0103 plata...",
            generateQRCode: "Genera\u021Bi codul QR",
            "await.waitForConfirmation": "Se a\u0219teapt\u0103 confirmarea",
            "mbway.confirmPayment": "Confirma\u021Bi plata \xeen aplica\u021Bia MB WAY",
            "shopperEmail.invalid": "Adres\u0103 de e-mail incorect\u0103",
            "dateOfBirth.format": "ZZ/LL/AAAA",
            "dateOfBirth.invalid": "Completa\u021Bi o dat\u0103 de na\u0219tere valabil\u0103 care s\u0103 indice c\u0103 ave\u021Bi cel pu\u021Bin 18 ani.",
            "blik.confirmPayment": "Deschide\u021Bi aplica\u021Bia dvs. de banking pentru a confirma plata.",
            "blik.invalid": "Introduce\u021Bi 6 cifre",
            "blik.code": "Cod din 6 cifre",
            "blik.help": "Ob\u021Bine\u021Bi codul din aplica\u021Bia dvs. de banking.",
            "swish.pendingMessage": "Dup\u0103 ce scana\u021Bi, starea poate fi \u201E\xeen a\u0219teptare\u201D timp de maximum 10 minute. \xcencerc\u0103rile de a pl\u0103ti din nou \xeen acest r\u0103stimp pot genera prelev\u0103ri multiple de fonduri.",
            "field.valid": "C\xe2mp valid",
            "field.invalid": "C\xe2mp incorect",
            "error.va.gen.01": "C\xe2mp incomplet",
            "error.va.gen.02": "C\xe2mp incorect",
            "error.va.sf-cc-num.01": "Completa\u021Bi un num\u0103r valabil de card",
            "error.va.sf-cc-num.02": "Completa\u021Bi num\u0103rul cardului",
            "error.va.sf-cc-num.03": "Completa\u021Bi un brand de card acceptat",
            "error.va.sf-cc-num.04": "Completa\u021Bi num\u0103rul complet al cardului",
            "error.va.sf-cc-dat.01": "Completa\u021Bi o dat\u0103 de expirare valabil\u0103",
            "error.va.sf-cc-dat.02": "Completa\u021Bi o dat\u0103 de expirare valabil\u0103",
            "error.va.sf-cc-dat.03": "Card de credit pe cale s\u0103 expire",
            "error.va.sf-cc-dat.04": "Completa\u021Bi data de expirare",
            "error.va.sf-cc-dat.05": "Completa\u021Bi data de expirare complet\u0103",
            "error.va.sf-cc-mth.01": "Completa\u021Bi luna de expirare",
            "error.va.sf-cc-yr.01": "Completa\u021Bi anul de expirare",
            "error.va.sf-cc-yr.02": "Completa\u021Bi anul de expirare complet",
            "error.va.sf-cc-cvc.01": "Completa\u021Bi codul de securitate",
            "error.va.sf-cc-cvc.02": "Completa\u021Bi codul de securitate complet",
            "error.va.sf-ach-num.01": "C\xe2mpul pentru num\u0103rul de cont bancar este necompletat",
            "error.va.sf-ach-num.02": "Num\u0103rul contului bancar are lungimea gre\u0219it\u0103",
            "error.va.sf-ach-loc.01": "C\xe2mpul pentru num\u0103rul de rutare al b\u0103ncii este necompletat",
            "error.va.sf-ach-loc.02": "Num\u0103rul de rutare al b\u0103ncii are lungimea gre\u0219it\u0103",
            "error.va.sf-kcp-pwd.01": "C\xe2mpul pentru parol\u0103 este necompletat",
            "error.va.sf-kcp-pwd.02": "Parola are lungimea gre\u0219it\u0103",
            "error.giftcard.no-balance": "Acest card cadou are soldul zero",
            "error.giftcard.card-error": "\xcen eviden\u021Bele noastre nu figureaz\u0103 niciun card cadou cu acest num\u0103r",
            "error.giftcard.currency-error": "Cardurile cadou sunt valabile numai \xeen moneda \xeen care au fost emise",
            "amazonpay.signout": "Deconecta\u021Bi-v\u0103 de pe platforma Amazon",
            "amazonpay.changePaymentDetails": "Modifica\u021Bi detaliile de plat\u0103",
            "partialPayment.warning": "Pentru a achita suma r\u0103mas\u0103, selecta\u021Bi o alt\u0103 metod\u0103 de plat\u0103",
            "partialPayment.remainingBalance": "Soldul r\u0103mas va fi de %{amount}",
            "bankTransfer.beneficiary": "Beneficiar",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Referin\u0163\u0103",
            "bankTransfer.introduction": "Continua\u021Bi s\u0103 crea\u021Bi o nou\u0103 plat\u0103 prin transfer bancar. Pute\u021Bi utiliza detaliile din ecranul urm\u0103tor pentru a finaliza aceast\u0103 plat\u0103.",
            "bankTransfer.instructions": "V\u0103 mul\u021Bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021Bi urm\u0103toarele informa\u021Bii pentru a v\u0103 finaliza plata.",
            "bacs.accountHolderName": "Numele titularului contului bancar",
            "bacs.accountHolderName.invalid": "Numele titularului contului bancar este incorect",
            "bacs.accountNumber": "Num\u0103rul contului bancar",
            "bacs.accountNumber.invalid": "Num\u0103rul contului bancar este incorect",
            "bacs.bankLocationId": "Cod de identificare bancar\u0103",
            "bacs.bankLocationId.invalid": "Cod de identificare bancar\u0103 incorect",
            "bacs.consent.amount": "Sunt de acord ca suma men\u021Bionat\u0103 mai sus s\u0103 fie dedus\u0103 din contul meu bancar.",
            "bacs.consent.account": "Confirm c\u0103 sunt titularul acestui cont \u0219i c\u0103 sunt singurul semnatar necesar pentru autorizarea debitului direct pentru acest cont.",
            edit: "Editare",
            "bacs.confirm": "Confirma\u021Bi \u0219i pl\u0103ti\u021Bi",
            "bacs.result.introduction": "Desc\u0103rca\u021Bi instruc\u021Biunile de debitare direct\u0103 (DDI/mandat)",
            "download.pdf": "Desc\u0103rca\u021Bi PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe pentru num\u0103rul cardului",
            "creditCard.encryptedCardNumber.aria.label": "Num\u0103r card",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe pentru data de expirare",
            "creditCard.encryptedExpiryDate.aria.label": "Data expir\u0103rii",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe pentru luna de expirare",
            "creditCard.encryptedExpiryMonth.aria.label": "Luna de expirare",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe pentru anul de expirare",
            "creditCard.encryptedExpiryYear.aria.label": "Anul de expirare",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe pentru codul de securitate",
            "creditCard.encryptedSecurityCode.aria.label": "Cod de securitate",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe pentru parol\u0103",
            "creditCard.encryptedPassword.aria.label": "Primele 2 cifre ale parolei aferente cardului",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe pentru num\u0103rul cardului",
            "giftcard.encryptedCardNumber.aria.label": "Num\u0103r card",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe pentru PIN",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Pentru acest card cadou, suma maxim\u0103 permis\u0103 per tranzac\u021Bie este de %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe pentru num\u0103rul de cont bancar",
            "ach.encryptedBankAccountNumber.aria.label": "Num\u0103r de cont",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe pentru num\u0103rul de identificare bancar\u0103",
            "ach.encryptedBankLocationId.aria.label": "Num\u0103r de direc\u021Bionare ABA",
            "twint.saved": "salvat",
            orPayWith: "sau pl\u0103ti\u021Bi cu",
            invalidFormatExpects: "Format nevalid. Format solicitat: %{format}",
            "upi.qrCodeWaitingMessage": "Scana\u021Bi codul QR folosind aplica\u021Bia UPI preferat\u0103 pentru a finaliza plata",
            "upi.vpaWaitingMessage": "Deschide\u021Bi aplica\u021Bia UPI pentru a confirma plata",
            "upi.modeSelection": "Selecta\u021Bi modul \xeen care dori\u021Bi s\u0103 utiliza\u021Bi UPI.",
            "onlineBanking.termsAndConditions": "Continu\xe2nd, sunte\u021Bi de acord cu %#terms and conditions%#",
            "onlineBankingPL.termsAndConditions": "Continu\xe2nd, sunte\u021Bi de acord cu %#reglement\u0103rile%# \u0219i cu %#obliga\u021Bia de informare%# a Przelewy24",
            "ctp.loading.poweredByCtp": "Sus\u021Binut de Click to Pay",
            "ctp.loading.intro": "Verific\u0103m dac\u0103 ave\u021Bi vreun card salvat cu Click to Pay...",
            "ctp.login.title": "Continua\u021Bi c\u0103tre Click to Pay",
            "ctp.login.subtitle": "Introduce\u021Bi adresa de e-mail care este conectat\u0103 la Click to Pay pentru a continua.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "Nu sunte\u021Bi dvs.?",
            "ctp.logout.notYourCards": "Nu sunt cardurile dvs.?",
            "ctp.logout.notYourCard": "Nu este cardul dvs.?",
            "ctp.logout.notYourProfile": "Nu este profilul dvs.?",
            "ctp.otp.fieldLabel": "Cod unic",
            "ctp.otp.resendCode": "Retrimite\u021Bi codul",
            "ctp.otp.codeResent": "Cod retrimis",
            "ctp.otp.title": "Accesa\u021Bi-v\u0103 cardurile Click to Pay",
            "ctp.otp.subtitle": "Introduce\u021Bi codul %@ pe care l-am trimis la %@ pentru a confirma c\u0103 sunte\u021Bi dvs.",
            "ctp.otp.saveCookiesCheckbox.label": "Omite\u021Bi verificarea data viitoare",
            "ctp.otp.saveCookiesCheckbox.information": "Selecta\u021Bi pentru a fi re\u021Binut pe dispozitiv \u0219i \xeen browserul dvs. la magazinele participante pentru o plat\u0103 mai rapid\u0103. Nerecomandat pentru dispozitivele partajate.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Selecta\u021Bi pentru a fi memorat pe dispozitiv \u0219i browser",
            "ctp.emptyProfile.message": "Niciun card \xeenregistrat \xeen acest profil Click to Pay",
            "ctp.separatorText": "sau folosi\u021Bi",
            "ctp.cards.title": "Finaliza\u021Bi plata cu Click to Pay",
            "ctp.cards.subtitle": "Selecta\u021Bi un card pe care s\u0103 \xeel utiliza\u021Bi.",
            "ctp.cards.expiredCard": "Expirat",
            "ctp.manualCardEntry": "Introducere manual\u0103 a cardului",
            "ctp.aria.infoModalButton": "Ce este Click to Pay",
            "ctp.infoPopup.title": "Click to Pay v\u0103 ofer\u0103 facilit\u0103\u021Bile contactless, online",
            "ctp.infoPopup.subtitle": "O metod\u0103 de plat\u0103 rapid\u0103 \u0219i sigur\u0103, compatibil\u0103 cu Mastercard, Visa \u0219i alte carduri de plat\u0103.",
            "ctp.infoPopup.benefit1": "Click to Pay folose\u0219te criptarea pentru a v\u0103 p\u0103stra informa\u021Biile \xeen siguran\u021B\u0103",
            "ctp.infoPopup.benefit2": "Utiliza\u021Bi-l la comercian\u021Bii din \xeentreaga lume",
            "ctp.infoPopup.benefit3": "Configura\u021Bi o dat\u0103 pentru a pl\u0103ti f\u0103r\u0103 probleme \xeen viitor",
            "ctp.errors.AUTH_INVALID": "Autentificare incorect\u0103",
            "ctp.errors.NOT_FOUND": "Nu s-a g\u0103sit niciun cont; introduce\u021Bi o adres\u0103 de e-mail valabil\u0103 sau continua\u021Bi complet\xe2nd manual cardul",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Format neacceptat",
            "ctp.errors.FRAUD": "Contul de utilizator a fost blocat sau dezactivat",
            "ctp.errors.CONSUMER_ID_MISSING": "Identitatea consumatorului lipse\u0219te din solicitare",
            "ctp.errors.ACCT_INACCESSIBLE": "Acest cont nu este disponibil \xeen prezent, de exemplu, este blocat.",
            "ctp.errors.CODE_INVALID": "Cod de verificare incorect",
            "ctp.errors.CODE_EXPIRED": "Acest cod a expirat",
            "ctp.errors.RETRIES_EXCEEDED": "A fost dep\u0103\u0219it\u0103 limita num\u0103rului de \xeencerc\u0103ri pentru generarea parolei unice",
            "ctp.errors.OTP_SEND_FAILED": "Parola unic\u0103 nu a putut fi trimis\u0103 destinatarului",
            "ctp.errors.REQUEST_TIMEOUT": "Ceva nu a mers bine, \xeencerca\u021Bi din nou sau introduce\u021Bi manual cardul",
            "ctp.errors.UNKNOWN_ERROR": "Ceva nu a mers bine, \xeencerca\u021Bi din nou sau introduce\u021Bi manual cardul",
            "ctp.errors.SERVICE_ERROR": "Ceva nu a mers bine, \xeencerca\u021Bi din nou sau introduce\u021Bi manual cardul",
            "ctp.errors.SERVER_ERROR": "Ceva nu a mers bine, \xeencerca\u021Bi din nou sau introduce\u021Bi manual cardul",
            "ctp.errors.INVALID_PARAMETER": "Ceva nu a mers bine, \xeencerca\u021Bi din nou sau introduce\u021Bi manual cardul",
            "ctp.errors.AUTH_ERROR": "Ceva nu a mers bine, \xeencerca\u021Bi din nou sau introduce\u021Bi manual cardul",
            "paymentMethodsList.aria.label": "Alege\u021Bi o metod\u0103 de plat\u0103",
            "companyDetails.name.invalid": "Completa\u021Bi numele societ\u0103\u021Bii",
            "companyDetails.registrationNumber.invalid": "Completa\u021Bi num\u0103rul de \xeenregistrare",
            "consent.checkbox.invalid": "Trebuie s\u0103 fi\u021Bi de acord cu termenii \u0219i condi\u021Biile",
            "form.instruction": "Toate c\xe2mpurile sunt obligatorii, numai dac\u0103 nu este marcat altfel.",
            "trustly.descriptor": "Plat\u0103 bancar\u0103 instantanee",
            "trustly.description1": "Pl\u0103ti\u021Bi direct din oricare dintre conturile dvs. bancare, cu sprijinul unei securit\u0103\u021Bi de nivel bancar",
            "trustly.description2": "F\u0103r\u0103 carduri, f\u0103r\u0103 desc\u0103rc\u0103ri de aplica\u021Bii, f\u0103r\u0103 \xeenregistrare",
            "ancv.input.label": "Identificarea dvs. ANCV",
            "ancv.confirmPayment": "Utiliza\u021Bi aplica\u021Bia ANCV pentru a confirma plata.",
            "ancv.form.instruction": "Aplica\u021Bia Cheque-Vacances este necesar\u0103 pentru a valida aceast\u0103 plat\u0103.",
            "ancv.beneficiaryId.invalid": "Completa\u021Bi o adres\u0103 de e-mail sau un ID ANCV valabil",
            "payme.openPayMeApp": "Finaliza\u021Bi plata \xeen aplica\u021Bia PayMe, autoriz\xe2nd plata \xeen aplica\u021Bie, \u0219i a\u0219tepta\u021Bi confirmarea.",
            "payme.redirectButtonLabel": "Deschide\u021Bi aplica\u021Bia PayMe",
            "payme.scanQrCode": "Finaliza\u021Bi plata folosind codul QR",
            "payme.timeToPay": "Acest cod QR este valabil pentru %@",
            "payme.instructions.steps": "Deschide\u021Bi aplica\u021Bia PayMe.%@Scana\u021Bi codul QR pentru a autoriza plata.%@Finaliza\u021Bi plata \xeen aplica\u021Bie \u0219i a\u0219tepta\u021Bi confirmarea.",
            "payme.instructions.footnote": "Nu \xeenchide\u021Bi aceast\u0103 pagin\u0103 \xeenainte de finalizarea pl\u0103\u021Bii."
        }
    }), u2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "\u0417\u0430\u043F\u043B\u0430\u0442\u0438\u0442\u044C",
            "payButton.redirecting": "\u041F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435...",
            "payButton.with": "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C %{value} %{maskedData}",
            "payButton.saveDetails": "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
            close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
            storeDetails: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0434\u043B\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u0430",
            readMore: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
            "creditCard.holderName": "\u0418\u043C\u044F \u043D\u0430 \u043A\u0430\u0440\u0442\u0435",
            "creditCard.holderName.placeholder": "\u0418. \u041F\u0435\u0442\u0440\u043E\u0432",
            "creditCard.holderName.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043C\u044F, \u043A\u0430\u043A \u043E\u043D\u043E \u0443\u043A\u0430\u0437\u0430\u043D\u043E \u043D\u0430 \u043A\u0430\u0440\u0442\u0435",
            "creditCard.numberField.title": "\u041D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "creditCard.expiryDateField.placeholder": "\u041C\u041C/\u0413\u0413",
            "creditCard.expiryDateField.month": "\u041C\u0435\u0441\u044F\u0446",
            "creditCard.expiryDateField.month.placeholder": "\u041C\u041C",
            "creditCard.expiryDateField.year.placeholder": "\u0413\u0413",
            "creditCard.expiryDateField.year": "\u0413\u043E\u0434",
            "creditCard.cvcField.title": "\u0417\u0430\u0449\u0438\u0442\u043D\u044B\u0439 \u043A\u043E\u0434",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "\u0417\u0430\u043F\u043E\u043C\u043D\u0438\u0442\u044C \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0440\u0430\u0437",
            "creditCard.cvcField.placeholder.4digits": "4 \u0446\u0438\u0444\u0440\u044B",
            "creditCard.cvcField.placeholder.3digits": "3 \u0446\u0438\u0444\u0440\u044B",
            "creditCard.taxNumber.placeholder": "\u0413\u0413\u041C\u041C\u0414\u0414 / 0123456789",
            installments: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439",
            installmentOption: "%{times}\xd7 %{partialValue}",
            installmentOptionMonths: "%{times} \u043C\u0435\u0441.",
            "installments.oneTime": "\u041E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0439 \u043F\u043B\u0430\u0442\u0435\u0436",
            "installments.installments": "\u0420\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0430",
            "installments.revolving": "\u041F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0449\u0430\u044F\u0441\u044F \u043E\u043F\u043B\u0430\u0442\u0430",
            "sepaDirectDebit.ibanField.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0441\u0447\u0435\u0442\u0430",
            "sepaDirectDebit.nameField.placeholder": "\u0418. \u041F\u0435\u0442\u0440\u043E\u0432",
            "sepa.ownerName": "\u0418\u043C\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430",
            "sepa.ibanNumber": "\u041D\u043E\u043C\u0435\u0440 \u0441\u0447\u0435\u0442\u0430 (IBAN)",
            "error.title": "\u041E\u0448\u0438\u0431\u043A\u0430",
            "error.subtitle.redirect": "\u0421\u0431\u043E\u0439 \u043F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F",
            "error.subtitle.payment": "\u0421\u0431\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B",
            "error.subtitle.refused": "\u041E\u043F\u043B\u0430\u0442\u0430 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430",
            "error.message.unknown": "\u0412\u043E\u0437\u043D\u0438\u043A\u043B\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430",
            "errorPanel.title": "\u0418\u043C\u0435\u044E\u0449\u0438\u0435\u0441\u044F \u043E\u0448\u0438\u0431\u043A\u0438",
            "idealIssuer.selectField.title": "\u0411\u0430\u043D\u043A",
            "idealIssuer.selectField.placeholder": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0430\u043D\u043A",
            "creditCard.success": "\u041F\u043B\u0430\u0442\u0435\u0436 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D",
            loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
            continue: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C",
            continueTo: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A",
            "wechatpay.timetopay": "\u0423 \u0432\u0430\u0441 %@ \u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u0443",
            "sr.wechatpay.timetopay": "\u0423 \u0432\u0430\u0441 \u0435\u0441\u0442\u044C %#\u043C\u0438\u043D.%# %#\u0441\u0435\u043A.%# \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B",
            "wechatpay.scanqrcode": "\u0421\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C QR-\u043A\u043E\u0434",
            personalDetails: "\u041B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435",
            companyDetails: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438",
            "companyDetails.name": "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438",
            "companyDetails.registrationNumber": "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440",
            socialSecurityNumber: "\u041D\u043E\u043C\u0435\u0440 \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u044F \u0438\u043B\u0438 \u0418\u041D\u041D",
            firstName: "\u0418\u043C\u044F",
            "firstName.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043C\u044F",
            infix: "\u041F\u0440\u0438\u0441\u0442\u0430\u0432\u043A\u0430",
            lastName: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F",
            "lastName.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0444\u0430\u043C\u0438\u043B\u0438\u044E",
            mobileNumber: "\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
            "mobileNumber.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u043D\u043E\u043C\u0435\u0440 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E",
            city: "\u0413\u043E\u0440\u043E\u0434",
            postalCode: "\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0438\u043D\u0434\u0435\u043A\u0441",
            "postalCode.optional": "\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0438\u043D\u0434\u0435\u043A\u0441 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
            countryCode: "\u041A\u043E\u0434 \u0441\u0442\u0440\u0430\u043D\u044B",
            telephoneNumber: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
            dateOfBirth: "\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F",
            shopperEmail: "\u0410\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B",
            gender: "\u041F\u043E\u043B",
            "gender.notselected": "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u043F\u043E\u043B",
            male: "\u041C\u0443\u0436\u0447\u0438\u043D\u0430",
            female: "\u0416\u0435\u043D\u0449\u0438\u043D\u0430",
            billingAddress: "\u041F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441",
            street: "\u0423\u043B\u0438\u0446\u0430",
            stateOrProvince: "\u0420\u0435\u0433\u0438\u043E\u043D",
            country: "\u0421\u0442\u0440\u0430\u043D\u0430",
            houseNumberOrName: "\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u043C\u0430",
            separateDeliveryAddress: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
            deliveryAddress: "\u0410\u0434\u0440\u0435\u0441 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
            "deliveryAddress.firstName": "\u0418\u043C\u044F \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F",
            "deliveryAddress.lastName": "\u0424\u0430\u043C\u0438\u043B\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F",
            zipCode: "\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0438\u043D\u0434\u0435\u043A\u0441",
            apartmentSuite: "\u041A\u0432\u0430\u0440\u0442\u0438\u0440\u0430 / \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0435",
            provinceOrTerritory: "\u041F\u0440\u043E\u0432\u0438\u043D\u0446\u0438\u044F \u0438\u043B\u0438 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F",
            cityTown: "\u0413\u043E\u0440\u043E\u0434",
            address: "\u0410\u0434\u0440\u0435\u0441",
            "address.placeholder": "\u041D\u0430\u0439\u0442\u0438 \u0441\u0432\u043E\u0439 \u0430\u0434\u0440\u0435\u0441",
            "address.errors.incomplete": "\u0414\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u0443\u043A\u0430\u0436\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441",
            "address.enterManually": "\u0412\u0432\u0435\u0441\u0442\u0438 \u0430\u0434\u0440\u0435\u0441 \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            state: "\u0428\u0442\u0430\u0442",
            "field.title.optional": "(\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
            "creditCard.cvcField.title.optional": "\u0417\u0430\u0449\u0438\u0442\u043D\u044B\u0439 \u043A\u043E\u0434 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
            "issuerList.wallet.placeholder": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
            privacyPolicy: "\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438",
            "afterPay.agreement": "\u042F \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u044E %@ Riverty",
            paymentConditions: "\u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B",
            openApp: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
            "voucher.readInstructions": "\u041F\u0440\u043E\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438",
            "voucher.introduction": "\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0443. \u0414\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u043A\u0443\u043F\u043E\u043D.",
            "voucher.expirationDate": "\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "voucher.alternativeReference": "\u0414\u0440\u0443\u0433\u043E\u0439 \u043A\u043E\u0434",
            "dragonpay.voucher.non.bank.selectField.placeholder": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0432\u043E\u0435\u0433\u043E \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430",
            "dragonpay.voucher.bank.selectField.placeholder": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0430\u043D\u043A",
            "voucher.paymentReferenceLabel": "\u041A\u043E\u0434 \u043E\u043F\u043B\u0430\u0442\u044B",
            "voucher.surcharge": "\u0412\u043A\u043B. \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044E %@",
            "voucher.introduction.doku": "\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0443. \u0414\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F.",
            "voucher.shopperName": "\u0418\u043C\u044F \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F",
            "voucher.merchantName": "\u041F\u0440\u043E\u0434\u0430\u0432\u0435\u0446",
            "voucher.introduction.econtext": "\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0443. \u0414\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F.",
            "voucher.telephoneNumber": "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
            "voucher.shopperReference": "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F",
            "voucher.collectionInstitutionNumber": "\u041D\u043E\u043C\u0435\u0440 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F \u0441\u0440\u0435\u0434\u0441\u0442\u0432",
            "voucher.econtext.telephoneNumber.invalid": "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0434\u043B\u0438\u043D\u043E\u0439 10 \u0438\u043B\u0438 11 \u0446\u0438\u0444\u0440",
            "boletobancario.btnLabel": "\u0421\u043E\u0437\u0434\u0430\u0442\u044C Boleto",
            "boleto.sendCopyToEmail": "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043C\u043D\u0435 \u043A\u043E\u043F\u0438\u044E \u043D\u0430 \u044D\u043B. \u043F\u043E\u0447\u0442\u0443",
            "button.copy": "\u041A\u043E\u043F\u0438\u044F",
            "button.download": "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C",
            "boleto.socialSecurityNumber.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435",
            "creditCard.storedCard.description.ariaLabel": "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430 \u0437\u0430\u043A\u0430\u043D\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043D\u0430 %@",
            "voucher.entity": "\u041E\u0431\u044A\u0435\u043A\u0442",
            donateButton: "\u041F\u043E\u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u0442\u044C",
            notNowButton: "\u041F\u043E\u0437\u0436\u0435",
            thanksForYourSupport: "\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443!",
            "resultMessages.preauthorized": "\u0414\u0430\u043D\u043D\u044B\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B",
            preauthorizeWith: "\u041F\u0440\u0435\u0434\u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F \u0432",
            confirmPreauthorization: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u043F\u0440\u0435\u0434\u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044E",
            confirmPurchase: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u043F\u043E\u043A\u0443\u043F\u043A\u0443",
            applyGiftcard: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C",
            giftcardBalance: "\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B",
            deductedBalance: "\u0411\u0430\u043B\u0430\u043D\u0441 \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0439",
            "creditCard.pin.title": "PIN-\u043A\u043E\u0434",
            "creditCard.encryptedPassword.label": "\u041F\u0435\u0440\u0432\u044B\u0435 2 \u0446\u0438\u0444\u0440\u044B \u043F\u0430\u0440\u043E\u043B\u044F \u043A\u0430\u0440\u0442\u044B",
            "creditCard.encryptedPassword.invalid": "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
            "creditCard.taxNumber": "\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u043A\u0430\u0440\u0442\u044B \u0438\u043B\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u044F",
            "creditCard.taxNumber.label": "\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u043A\u0430\u0440\u0442\u044B (\u0413\u0413\u041C\u041C\u0414\u0414) \u0438\u043B\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u044F (10 \u0446\u0438\u0444\u0440)",
            "creditCard.taxNumber.labelAlt": "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u044F (10 \u0446\u0438\u0444\u0440)",
            "creditCard.taxNumber.invalid": "\u041D\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u0434\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u043A\u0430\u0440\u0442\u044B \u0438\u043B\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u044F",
            "storedPaymentMethod.disable.button": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
            "storedPaymentMethod.disable.confirmation": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B",
            "storedPaymentMethod.disable.confirmButton": "\u0414\u0430, \u0443\u0434\u0430\u043B\u0438\u0442\u044C",
            "storedPaymentMethod.disable.cancelButton": "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C",
            "ach.bankAccount": "\u0411\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0439 \u0441\u0447\u0435\u0442",
            "ach.accountHolderNameField.title": "\u0418\u043C\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u043A\u0430\u0440\u0442\u044B",
            "ach.accountHolderNameField.placeholder": "\u0418. \u041F\u0435\u0442\u0440\u043E\u0432",
            "ach.accountHolderNameField.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0438\u043C\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u043A\u0430\u0440\u0442\u044B",
            "ach.accountNumberField.title": "\u041D\u043E\u043C\u0435\u0440 \u0441\u0447\u0435\u0442\u0430",
            "ach.accountNumberField.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0441\u0447\u0435\u0442\u0430",
            "ach.accountLocationField.title": "\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 ABA",
            "ach.accountLocationField.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 ABA",
            "ach.savedBankAccount": "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0439 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0439 \u0441\u0447\u0435\u0442",
            "select.state": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0442\u0430\u0442",
            "select.stateOrProvince": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0442\u0430\u0442 \u0438\u043B\u0438 \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
            "select.provinceOrTerritory": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0440\u043E\u0432\u0438\u043D\u0446\u0438\u044E \u0438\u043B\u0438 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044E",
            "select.country": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0443",
            "select.noOptionsFound": "\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0432 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E",
            "select.filter.placeholder": "\u041F\u043E\u0438\u0441\u043A\u2026",
            "telephoneNumber.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
            qrCodeOrApp: "\u0438\u043B\u0438",
            "paypal.processingPayment": "\u041F\u043B\u0430\u0442\u0435\u0436 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F\u2026",
            generateQRCode: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C QR-\u043A\u043E\u0434",
            "await.waitForConfirmation": "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F",
            "mbway.confirmPayment": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043E\u043F\u043B\u0430\u0442\u0443 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 MB WAY",
            "shopperEmail.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B",
            "dateOfBirth.format": "\u0414\u0414/\u041C\u041C/\u0413\u0413\u0413\u0413",
            "dateOfBirth.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0443\u044E \u0434\u0430\u0442\u0443 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F. \u0412\u0430\u043C \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 18 \u043B\u0435\u0442.",
            "blik.confirmPayment": "\u0414\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u043E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430.",
            "blik.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 6 \u0446\u0438\u0444\u0440",
            "blik.code": "6-\u0437\u043D\u0430\u0447\u043D\u044B\u0439 \u043A\u043E\u0434",
            "blik.help": "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043A\u043E\u0434 \u0438\u0437 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u0431\u0430\u043D\u043A\u0430.",
            "swish.pendingMessage": "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043E\u043F\u043B\u0430\u0442\u044B \u043F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043D\u044F\u0442\u044C 10 \u043C\u0438\u043D\u0443\u0442. \u041F\u043E\u043F\u044B\u0442\u043A\u0430 \u043F\u0440\u043E\u0432\u0435\u0441\u0442\u0438 \u043E\u043F\u043B\u0430\u0442\u0443 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0438\u0432\u0435\u0441\u0442\u0438 \u043A \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u043C \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F\u043C \u0441\u043E \u0441\u0447\u0435\u0442\u0430.",
            "field.valid": "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435",
            "field.invalid": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435",
            "error.va.gen.01": "\u041D\u0435\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u043E\u0435 \u043F\u043E\u043B\u0435",
            "error.va.gen.02": "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435",
            "error.va.sf-cc-num.01": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B",
            "error.va.sf-cc-num.02": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B",
            "error.va.sf-cc-num.03": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043C\u0443\u044E \u043C\u0430\u0440\u043A\u0443 \u043A\u0430\u0440\u0442\u044B",
            "error.va.sf-cc-num.04": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E",
            "error.va.sf-cc-dat.01": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0443\u044E \u0434\u0430\u0442\u0443 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "error.va.sf-cc-dat.02": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0443\u044E \u0434\u0430\u0442\u0443 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "error.va.sf-cc-dat.03": "\u0421\u043A\u043E\u0440\u043E \u0438\u0441\u0442\u0435\u043A\u0430\u0435\u0442 \u0441\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B",
            "error.va.sf-cc-dat.04": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0440\u043E\u043A \u0433\u043E\u0434\u043D\u043E\u0441\u0442\u0438",
            "error.va.sf-cc-dat.05": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E\u043B\u043D\u0443\u044E \u0434\u0430\u0442\u0443 \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "error.va.sf-cc-mth.01": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043C\u0435\u0441\u044F\u0446 \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "error.va.sf-cc-yr.01": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0433\u043E\u0434 \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "error.va.sf-cc-yr.02": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0433\u043E\u0434 \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E",
            "error.va.sf-cc-cvc.01": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0437\u0430\u0449\u0438\u0442\u043D\u044B\u0439 \u043A\u043E\u0434",
            "error.va.sf-cc-cvc.02": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0437\u0430\u0449\u0438\u0442\u043D\u044B\u0439 \u043A\u043E\u0434 \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E",
            "error.va.sf-ach-num.01": "\u041F\u043E\u043B\u0435 \u043D\u043E\u043C\u0435\u0440\u0430 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430 \u043D\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E",
            "error.va.sf-ach-num.02": "\u041D\u043E\u043C\u0435\u0440 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430 \u0438\u043C\u0435\u0435\u0442 \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0443\u044E \u0434\u043B\u0438\u043D\u0443",
            "error.va.sf-ach-loc.01": "\u041F\u043E\u043B\u0435 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u0431\u0430\u043D\u043A\u0430 \u043D\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E",
            "error.va.sf-ach-loc.02": "\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0431\u0430\u043D\u043A\u0430 \u0438\u043C\u0435\u0435\u0442 \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0443\u044E \u0434\u043B\u0438\u043D\u0443",
            "error.va.sf-kcp-pwd.01": "\u041F\u043E\u043B\u0435 \u043F\u0430\u0440\u043E\u043B\u044F \u043D\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E",
            "error.va.sf-kcp-pwd.02": "\u041F\u0430\u0440\u043E\u043B\u044C \u0438\u043C\u0435\u0435\u0442 \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0443\u044E \u0434\u043B\u0438\u043D\u0443",
            "error.giftcard.no-balance": "\u041D\u0430 \u044D\u0442\u043E\u0439 \u043F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435 \u043D\u0435\u0442 \u0441\u0440\u0435\u0434\u0441\u0442\u0432",
            "error.giftcard.card-error": "\u0423 \u043D\u0430\u0441 \u043D\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u043A\u0430\u0440\u0442\u0430 \u0441 \u0442\u0430\u043A\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u043E\u043C",
            "error.giftcard.currency-error": "\u041F\u0440\u0438\u043D\u0438\u043C\u0430\u044E\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u044B\u0435 \u043A\u0430\u0440\u0442\u044B \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0439 \u0432\u0430\u043B\u044E\u0442\u044B",
            "amazonpay.signout": "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 Amazon",
            "amazonpay.changePaymentDetails": "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u0435",
            "partialPayment.warning": "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B \u043E\u0441\u0442\u0430\u0442\u043A\u0430",
            "partialPayment.remainingBalance": "\u041E\u0441\u0442\u0430\u0442\u043E\u043A \u043D\u0430 \u0431\u0430\u043B\u0430\u043D\u0441\u0435 \u0441\u043E\u0441\u0442\u0430\u0432\u0438\u0442 %{amount}",
            "bankTransfer.beneficiary": "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C",
            "bankTransfer.reference": "\u0421\u0441\u044B\u043B\u043A\u0430",
            "bankTransfer.introduction": "\u0414\u043B\u044F \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u043D\u043E\u0432\u043E\u0433\u043E \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u043F\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u0434\u0430\u043B\u0435\u0435. \u0414\u043B\u044F \u043E\u043A\u043E\u043D\u0447\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u044D\u043A\u0440\u0430\u043D\u0435.",
            "bankTransfer.instructions": "\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0443. \u0414\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F.",
            "bacs.accountHolderName": "\u0418\u043C\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430",
            "bacs.accountHolderName.invalid": "\u041D\u0435\u0432\u0435\u0440\u043D\u043E\u0435 \u0438\u043C\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430",
            "bacs.accountNumber": "\u041D\u043E\u043C\u0435\u0440 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430",
            "bacs.accountNumber.invalid": "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430",
            "bacs.bankLocationId": "\u041A\u043E\u0434 \u0431\u0430\u043D\u043A\u0430",
            "bacs.bankLocationId.invalid": "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043A\u043E\u0434 \u0431\u0430\u043D\u043A\u0430",
            "bacs.consent.amount": "\u0412\u044B\u0440\u0430\u0436\u0430\u044E \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0432\u044B\u0448\u0435\u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0439 \u0441\u0443\u043C\u043C\u044B \u0441 \u043C\u043E\u0435\u0433\u043E \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430.",
            "bacs.consent.account": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E, \u0447\u0442\u043E \u0441\u0447\u0435\u0442 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D \u043D\u0430 \u043C\u043E\u0435 \u0438\u043C\u044F \u0438 \u0447\u0442\u043E \u044F \u2013 \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435 \u043B\u0438\u0446\u043E, \u0438\u043C\u0435\u044E\u0449\u0435\u0435 \u043F\u0440\u0430\u0432\u043E \u043F\u043E\u0434\u043F\u0438\u0441\u0438, \u0440\u0430\u0437\u0440\u0435\u0448\u0430\u044E\u0449\u0435\u0439 \u043F\u0440\u044F\u043C\u043E\u0435 \u0434\u0435\u0431\u0435\u0442\u043E\u0432\u0430\u043D\u0438\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0441\u043E \u0441\u0447\u0435\u0442\u0430.",
            edit: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C",
            "bacs.confirm": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0438 \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C",
            "bacs.result.introduction": "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u043F\u043E\u0440\u044F\u0436\u0435\u043D\u0438\u0435 \u043F\u0440\u044F\u043C\u043E\u0433\u043E \u0434\u0435\u0431\u0435\u0442\u043E\u0432\u0430\u043D\u0438\u044F (DDI / \u043F\u043E\u0440\u0443\u0447\u0435\u043D\u0438\u0435)",
            "download.pdf": "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u043D\u043E\u043C\u0435\u0440\u0430 \u043A\u0430\u0440\u0442\u044B",
            "creditCard.encryptedCardNumber.aria.label": "\u041D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u0434\u0430\u0442\u044B \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "creditCard.encryptedExpiryDate.aria.label": "\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u043C\u0435\u0441\u044F\u0446\u0430 \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "creditCard.encryptedExpiryMonth.aria.label": "\u041C\u0435\u0441\u044F\u0446 \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u0433\u043E\u0434\u0430 \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "creditCard.encryptedExpiryYear.aria.label": "\u0413\u043E\u0434 \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u0437\u0430\u0449\u0438\u0442\u043D\u043E\u0433\u043E \u043A\u043E\u0434\u0430",
            "creditCard.encryptedSecurityCode.aria.label": "\u0417\u0430\u0449\u0438\u0442\u043D\u044B\u0439 \u043A\u043E\u0434",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u043F\u0430\u0440\u043E\u043B\u044F",
            "creditCard.encryptedPassword.aria.label": "\u041F\u0435\u0440\u0432\u044B\u0435 2 \u0446\u0438\u0444\u0440\u044B \u043F\u0430\u0440\u043E\u043B\u044F \u043A\u0430\u0440\u0442\u044B",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u043D\u043E\u043C\u0435\u0440\u0430 \u043A\u0430\u0440\u0442\u044B",
            "giftcard.encryptedCardNumber.aria.label": "\u041D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe \u0434\u043B\u044F PIN-\u043A\u043E\u0434\u0430",
            "giftcard.encryptedSecurityCode.aria.label": "PIN-\u043A\u043E\u0434",
            giftcardTransactionLimit: "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u043F\u043E \u044D\u0442\u043E\u0439 \u043F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435: %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u043D\u043E\u043C\u0435\u0440\u0430 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430",
            "ach.encryptedBankAccountNumber.aria.label": "\u041D\u043E\u043C\u0435\u0440 \u0441\u0447\u0435\u0442\u0430",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe \u0434\u043B\u044F \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u0431\u0430\u043D\u043A\u0430",
            "ach.encryptedBankLocationId.aria.label": "\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 ABA",
            "twint.saved": "\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E",
            orPayWith: "\u0438\u043B\u0438 \u0437\u0430\u043F\u043B\u0430\u0442\u0438\u0442\u0435 \u0447\u0435\u0440\u0435\u0437",
            invalidFormatExpects: "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442. \u041E\u0436\u0438\u0434\u0430\u0435\u043C\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442: %{format}",
            "upi.qrCodeWaitingMessage": "\u0414\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043F\u0440\u0435\u0434\u043F\u043E\u0447\u0438\u0442\u0430\u0435\u043C\u043E\u0433\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F UPI",
            "upi.vpaWaitingMessage": "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 UPI \u0434\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0430",
            "upi.modeSelection": "\u0423\u043A\u0430\u0436\u0438\u0442\u0435, \u043A\u0430\u043A \u0432\u044B \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442\u0435\u0441\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C UPI.",
            "onlineBanking.termsAndConditions": "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u044F, \u0432\u044B \u0442\u0435\u043C \u0441\u0430\u043C\u044B\u043C \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441 %#\u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438%#",
            "onlineBankingPL.termsAndConditions": "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u044F, \u0432\u044B \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441 %#\u043F\u0440\u0430\u0432\u0438\u043B\u0430\u043C\u0438%# \u0438 %#\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430\u043C\u0438 \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u0434\u0430\u043D\u043D\u044B\u0445%# Przelewy24",
            "ctp.loading.poweredByCtp": "\u041D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435 Click to Pay",
            "ctp.loading.intro": "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043D\u0430\u043B\u0438\u0447\u0438\u044F \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0445 \u043A\u0430\u0440\u0442 Click to Pay\u2026",
            "ctp.login.title": "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 Click to Pay",
            "ctp.login.subtitle": "\u0414\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0439 \u0441 Click to Pay.",
            "ctp.login.inputLabel": "\u042D\u043B. \u043F\u043E\u0447\u0442\u0430",
            "ctp.logout.notYou": "\u042D\u0442\u043E \u043D\u0435 \u0432\u044B?",
            "ctp.logout.notYourCards": "\u041D\u0435 \u0432\u0430\u0448\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0435 \u043A\u0430\u0440\u0442\u044B?",
            "ctp.logout.notYourCard": "\u041D\u0435 \u0432\u0430\u0448\u0430 \u043A\u0430\u0440\u0442\u0430?",
            "ctp.logout.notYourProfile": "\u041D\u0435 \u0432\u0430\u0448 \u043F\u0440\u043E\u0444\u0438\u043B\u044C?",
            "ctp.otp.fieldLabel": "\u041E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0439 \u043A\u043E\u0434",
            "ctp.otp.resendCode": "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
            "ctp.otp.codeResent": "\u041A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
            "ctp.otp.title": "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0432\u043E\u0438\u043C \u043A\u0430\u0440\u0442\u0430\u043C Click to Pay",
            "ctp.otp.subtitle": "\u0414\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0441\u0432\u043E\u0435\u0439 \u043B\u0438\u0447\u043D\u043E\u0441\u0442\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 %@, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 %@.",
            "ctp.otp.saveCookiesCheckbox.label": "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0440\u0430\u0437",
            "ctp.otp.saveCookiesCheckbox.information": "\u0427\u0442\u043E\u0431\u044B \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430\u0445 \u0437\u0430\u043F\u043E\u043C\u043D\u0438\u043B\u0438 \u0432\u0430\u0448\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0438 \u0431\u0440\u0430\u0443\u0437\u0435\u0440, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u044D\u0442\u0443 \u043E\u043F\u0446\u0438\u044E. \u042D\u0442\u043E \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 \u0431\u044B\u0441\u0442\u0440\u0435\u0435 \u043E\u0444\u043E\u0440\u043C\u043B\u044F\u0442\u044C \u0437\u0430\u043A\u0430\u0437\u044B. \u041D\u0435 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442\u0441\u044F \u043D\u0430 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430\u0445 \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E\u0433\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u043F\u043E\u043C\u043D\u0438\u043B\u0438 \u0432\u0430\u0448\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0438 \u0431\u0440\u0430\u0443\u0437\u0435\u0440",
            "ctp.emptyProfile.message": "\u0412 \u0434\u0430\u043D\u043D\u043E\u043C \u043F\u0440\u043E\u0444\u0438\u043B\u0435 Click to Pay \u043D\u0435\u0442 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043A\u0430\u0440\u0442",
            "ctp.separatorText": "\u0438\u043B\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435",
            "ctp.cards.title": "\u041E\u0444\u043E\u0440\u043C\u0438\u0442\u0435 \u043E\u043F\u043B\u0430\u0442\u0443 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E Click to Pay",
            "ctp.cards.subtitle": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u0430\u0440\u0442\u0443.",
            "ctp.cards.expiredCard": "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u0430",
            "ctp.manualCardEntry": "\u0412\u0432\u043E\u0434 \u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "ctp.aria.infoModalButton": "\u0427\u0442\u043E \u0442\u0430\u043A\u043E\u0435 Click to Pay",
            "ctp.infoPopup.title": "Click to Pay \u2013 \u0443\u0434\u043E\u0431\u043D\u0430\u044F \u0431\u0435\u0441\u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0430\u044F \u043E\u043F\u043B\u0430\u0442\u0430 \u043E\u043D\u043B\u0430\u0439\u043D",
            "ctp.infoPopup.subtitle": "\u0411\u044B\u0441\u0442\u0440\u044B\u0439 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B, \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043C\u044B\u0439 Mastercard, Visa \u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u043C\u0438 \u043A\u0430\u0440\u0442\u0430\u043C\u0438.",
            "ctp.infoPopup.benefit1": "\u0414\u043B\u044F \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u0432\u0430\u0448\u0438\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 Click to Pay \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442 \u0448\u0438\u0444\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
            "ctp.infoPopup.benefit2": "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0435\u0433\u043E \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430\u0445 \u043F\u043E \u0432\u0441\u0435\u043C\u0443 \u043C\u0438\u0440\u0443",
            "ctp.infoPopup.benefit3": "\u0411\u0435\u0441\u043F\u0440\u043E\u0431\u043B\u0435\u043C\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0432 \u0431\u0443\u0434\u0443\u0449\u0435\u043C \u2014 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u043E\u0434\u0438\u043D \u0440\u0430\u0437",
            "ctp.errors.AUTH_INVALID": "\u0410\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0430",
            "ctp.errors.NOT_FOUND": "\u0423\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B \u0438\u043B\u0438 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435 \u0432\u0432\u043E\u0434 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "\u0424\u043E\u0440\u043C\u0430\u0442 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F",
            "ctp.errors.FRAUD": "\u0423\u0447. \u0437\u0430\u043F\u0438\u0441\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0438\u043B\u0438 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0430",
            "ctp.errors.CONSUMER_ID_MISSING": "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u044F \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0432 \u0437\u0430\u043F\u0440\u043E\u0441\u0435",
            "ctp.errors.ACCT_INACCESSIBLE": "\u042D\u0442\u0430 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C \u0441\u0435\u0439\u0447\u0430\u0441 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 (\u043E\u043D\u0430 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430)",
            "ctp.errors.CODE_INVALID": "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F",
            "ctp.errors.CODE_EXPIRED": "\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043A\u043E\u0434\u0430 \u0438\u0441\u0442\u0435\u043A",
            "ctp.errors.RETRIES_EXCEEDED": "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D \u043B\u0438\u043C\u0438\u0442 \u043F\u043E\u043F\u044B\u0442\u043E\u043A \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u043E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u043E\u0433\u043E \u043F\u0430\u0440\u043E\u043B\u044F",
            "ctp.errors.OTP_SEND_FAILED": "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044E \u043E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
            "ctp.errors.REQUEST_TIMEOUT": "\u0412\u043E\u0437\u043D\u0438\u043A \u0441\u0431\u043E\u0439. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "ctp.errors.UNKNOWN_ERROR": "\u0412\u043E\u0437\u043D\u0438\u043A \u0441\u0431\u043E\u0439. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "ctp.errors.SERVICE_ERROR": "\u0412\u043E\u0437\u043D\u0438\u043A \u0441\u0431\u043E\u0439. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "ctp.errors.SERVER_ERROR": "\u0412\u043E\u0437\u043D\u0438\u043A \u0441\u0431\u043E\u0439. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "ctp.errors.INVALID_PARAMETER": "\u0412\u043E\u0437\u043D\u0438\u043A \u0441\u0431\u043E\u0439. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "ctp.errors.AUTH_ERROR": "\u0412\u043E\u0437\u043D\u0438\u043A \u0441\u0431\u043E\u0439. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u0438\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E",
            "paymentMethodsList.aria.label": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B",
            "companyDetails.name.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438",
            "companyDetails.registrationNumber.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440",
            "consent.checkbox.invalid": "\u0422\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0432\u044B\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438",
            "form.instruction": "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F, \u0435\u0441\u043B\u0438 \u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u043E \u0438\u043D\u043E\u0435.",
            "trustly.descriptor": "\u041C\u0433\u043D\u043E\u0432\u0435\u043D\u043D\u044B\u0439 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0439 \u043F\u043B\u0430\u0442\u0435\u0436",
            "trustly.description1": "\u041F\u043B\u0430\u0442\u0438\u0442\u0435 \u043D\u0435\u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u043E \u0441\u043E \u0441\u0432\u043E\u0435\u0433\u043E \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0441\u0447\u0435\u0442\u0430 \u043F\u043E\u0434 \u0442\u0430\u043A\u043E\u0439 \u0436\u0435 \u043D\u0430\u0434\u0435\u0436\u043D\u043E\u0439 \u0437\u0430\u0449\u0438\u0442\u043E\u0439, \u043A\u0430\u043A \u0432 \u0431\u0430\u043D\u043A\u0430\u0445",
            "trustly.description2": "\u0411\u0435\u0437 \u043A\u0430\u0440\u0442, \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438",
            "ancv.input.label": "\u0412\u0430\u0448 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 ANCV",
            "ancv.confirmPayment": "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 ANCV \u0434\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0430.",
            "ancv.form.instruction": "\u0414\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0433\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Cheque-Vacances.",
            "ancv.beneficiaryId.invalid": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0438\u043B\u0438 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 ANCV",
            "payme.openPayMeApp": "\u0414\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0440\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u0435\u0435 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 PayMe \u0438 \u0434\u043E\u0436\u0434\u0438\u0442\u0435\u0441\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F.",
            "payme.redirectButtonLabel": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 PayMe",
            "payme.scanQrCode": "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u043F\u043B\u0430\u0442\u0435\u0436 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E QR-\u043A\u043E\u0434\u0430",
            "payme.timeToPay": "\u0414\u0430\u043D\u043D\u044B\u0439 QR-\u043A\u043E\u0434 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 %@",
            "payme.instructions.steps": "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 PayMe.%@\u041E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434, \u0447\u0442\u043E\u0431\u044B \u0440\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u043F\u043B\u0430\u0442\u0435\u0436.%@\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0435 \u043F\u043B\u0430\u0442\u0435\u0436 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u0438 \u0434\u043E\u0436\u0434\u0438\u0442\u0435\u0441\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F.",
            "payme.instructions.footnote": "\u041D\u0435 \u0437\u0430\u043A\u0440\u044B\u0432\u0430\u0439\u0442\u0435 \u044D\u0442\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0434\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0430"
        }
    }), d2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Zaplati\u0165",
            "payButton.redirecting": "Prebieha presmerovanie...",
            "payButton.with": "Zaplati\u0165 %{value} pomocou %{maskedData}",
            "payButton.saveDetails": "Ulo\u017Ei\u0165 \xfadaje",
            close: "Zavrie\u0165",
            storeDetails: "Ulo\u017Ei\u0165 pre moju \u010Fal\u0161iu platbu",
            readMore: "Pre\u010D\xedtajte si viac",
            "creditCard.holderName": "Meno na karte",
            "creditCard.holderName.placeholder": "J. Nov\xe1k",
            "creditCard.holderName.invalid": "Zadajte meno tak, ako je uveden\xe9 na karte",
            "creditCard.numberField.title": "\u010C\xedslo karty",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Koniec platnosti",
            "creditCard.expiryDateField.placeholder": "MM/RR",
            "creditCard.expiryDateField.month": "Mesiac",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "RR",
            "creditCard.expiryDateField.year": "Rok",
            "creditCard.cvcField.title": "Bezpe\u010Dnostn\xfd k\xf3d",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Zapam\xe4ta\u0165 na bud\xface pou\u017Eitie",
            "creditCard.cvcField.placeholder.4digits": "4 \u010D\xedslice",
            "creditCard.cvcField.placeholder.3digits": "3 \u010D\xedslice",
            "creditCard.taxNumber.placeholder": "RRMMDD/0123456789",
            installments: "Po\u010Det spl\xe1tok",
            installmentOption: "% {times} x % {partialValue}",
            installmentOptionMonths: "%{times} mesiace/-ov",
            "installments.oneTime": "Jednorazov\xe1 platba",
            "installments.installments": "Platba po spl\xe1tkach",
            "installments.revolving": "Revolvingov\xe1 platba",
            "sepaDirectDebit.ibanField.invalid": "Neplatn\xe9 \u010D\xedslo \xfa\u010Dtu",
            "sepaDirectDebit.nameField.placeholder": "J. Nov\xe1k",
            "sepa.ownerName": "Meno dr\u017Eite\u013Ea",
            "sepa.ibanNumber": "\u010C\xedslo \xfa\u010Dtu (IBAN)",
            "error.title": "Chyba",
            "error.subtitle.redirect": "Nepodarilo sa presmerova\u0165",
            "error.subtitle.payment": "Platba zlyhala",
            "error.subtitle.refused": "Platba bola zamietnut\xe1",
            "error.message.unknown": "Vyskytla sa nezn\xe1ma chyba",
            "errorPanel.title": "Existuj\xface chyby",
            "idealIssuer.selectField.title": "Banka",
            "idealIssuer.selectField.placeholder": "Vyberte svoju banku",
            "creditCard.success": "Platba bola \xfaspe\u0161n\xe1",
            loading: "Na\u010D\xedtava sa\u2026",
            continue: "Pokra\u010Dova\u0165",
            continueTo: "Pokra\u010Dova\u0165 do",
            "wechatpay.timetopay": "Na zaplatenie m\xe1te %@",
            "sr.wechatpay.timetopay": "Na zaplatenie m\xe1te %#min. %# %#sek.%#",
            "wechatpay.scanqrcode": "Naskenujte QR k\xf3d",
            personalDetails: "Osobn\xe9 \xfadaje",
            companyDetails: "\xdadaje o spolo\u010Dnosti",
            "companyDetails.name": "N\xe1zov spolo\u010Dnosti",
            "companyDetails.registrationNumber": "Identifika\u010Dn\xe9 \u010D\xedslo",
            socialSecurityNumber: "Rodn\xe9 \u010D\xedslo",
            firstName: "Krstn\xe9 meno",
            "firstName.invalid": "Zadajte svoje meno",
            infix: "Predpona k priezvisku (ak existuje)",
            lastName: "Priezvisko",
            "lastName.invalid": "Zadajte svoje priezvisko",
            mobileNumber: "Mobiln\xe9 telef\xf3nne \u010D\xedslo",
            "mobileNumber.invalid": "Neplatn\xe9 \u010D\xedslo na mobil",
            city: "Mesto",
            postalCode: "PS\u010C",
            "postalCode.optional": "Po\u0161tov\xe9 smerovacie \u010D\xedslo (nepovinn\xe9)",
            countryCode: "K\xf3d krajiny",
            telephoneNumber: "Telef\xf3nne \u010D\xedslo",
            dateOfBirth: "D\xe1tum narodenia",
            shopperEmail: "E-mailov\xe1 adresa",
            gender: "Pohlavie",
            "gender.notselected": "Vyberte rod, s ktor\xfdm sa stoto\u017E\u0148ujete",
            male: "Mu\u017E",
            female: "\u017Dena",
            billingAddress: "Faktura\u010Dn\xe1 adresa",
            street: "Ulica",
            stateOrProvince: "Kraj",
            country: "Krajina",
            houseNumberOrName: "\u010C\xedslo domu",
            separateDeliveryAddress: "Zadajte samostatn\xfa dodaciu adresu",
            deliveryAddress: "Dodacia adresa",
            "deliveryAddress.firstName": "Krstn\xe9 meno pr\xedjemcu",
            "deliveryAddress.lastName": "Priezvisko pr\xedjemcu",
            zipCode: "PS\u010C",
            apartmentSuite: "Byt/apartm\xe1n",
            provinceOrTerritory: "Okres alebo \xfazemie",
            cityTown: "Mesto/obec",
            address: "Adresa",
            "address.placeholder": "Vyh\u013Eadajte svoju adresu",
            "address.errors.incomplete": "Ak chcete pokra\u010Dova\u0165, zadajte adresu",
            "address.enterManually": "Manu\xe1lne zadajte adresu",
            state: "\u0160t\xe1t",
            "field.title.optional": "(volite\u013En\xe9)",
            "creditCard.cvcField.title.optional": "Bezpe\u010Dnostn\xfd k\xf3d (volite\u013En\xfd)",
            "issuerList.wallet.placeholder": "Vyberte si pe\u0148a\u017Eenku",
            privacyPolicy: "Z\xe1sady ochrany osobn\xfdch \xfadajov",
            "afterPay.agreement": "S\xfahlas\xedm, \u017Ee budem dodr\u017Eiava\u0165 %@ spolo\u010Dnosti Riverty",
            paymentConditions: "podmienkami platby",
            openApp: "Otvorte aplik\xe1ciu",
            "voucher.readInstructions": "Pre\u010D\xedtajte si pokyny",
            "voucher.introduction": "\u010Eakujeme v\xe1m za n\xe1kup; na dokon\u010Denie platby pou\u017Eite nasleduj\xfaci kup\xf3n.",
            "voucher.expirationDate": "D\xe1tum vypr\u0161ania platnosti",
            "voucher.alternativeReference": "Alternat\xedvny odkaz",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Vyberte si poskytovate\u013Ea",
            "dragonpay.voucher.bank.selectField.placeholder": "Vyberte svoju banku",
            "voucher.paymentReferenceLabel": "Platobn\xe1 referencia",
            "voucher.surcharge": "Vr\xe1tane poplatku vo v\xfd\u0161ke %@",
            "voucher.introduction.doku": "\u010Eakujeme v\xe1m za n\xe1kup. Na dokon\u010Denie platby pou\u017Eite nasleduj\xface inform\xe1cie.",
            "voucher.shopperName": "Meno kupuj\xfaceho",
            "voucher.merchantName": "Predajca",
            "voucher.introduction.econtext": "\u010Eakujeme v\xe1m za n\xe1kup. Na dokon\u010Denie platby pou\u017Eite nasleduj\xface inform\xe1cie.",
            "voucher.telephoneNumber": "Telef\xf3nne \u010D\xedslo",
            "voucher.shopperReference": "Referencia kupuj\xfaceho",
            "voucher.collectionInstitutionNumber": "\u010C\xedslo inkasnej in\u0161tit\xfacie",
            "voucher.econtext.telephoneNumber.invalid": "Telef\xf3nne \u010D\xedslo mus\xed ma\u0165 10 alebo 11 \u010D\xedslic",
            "boletobancario.btnLabel": "Generova\u0165 Boleto",
            "boleto.sendCopyToEmail": "Zasla\u0165 k\xf3piu na m\xf4j e-mail",
            "button.copy": "Kop\xedrova\u0165",
            "button.download": "Stiahnu\u0165",
            "boleto.socialSecurityNumber.invalid": "Pole je neplatn\xe9",
            "creditCard.storedCard.description.ariaLabel": "Platnos\u0165 ulo\u017Eenej karty kon\u010D\xed o %@",
            "voucher.entity": "Subjekt",
            donateButton: "Prispie\u0165",
            notNowButton: "Teraz nie",
            thanksForYourSupport: "\u010Eakujeme za podporu!",
            "resultMessages.preauthorized": "\xdadaje boli ulo\u017Een\xe9",
            preauthorizeWith: "Predbe\u017Ene autorizova\u0165 pomocou",
            confirmPreauthorization: "Potvr\u010Fte predbe\u017En\xfa autoriz\xe1ciu",
            confirmPurchase: "Potvr\u010Fte n\xe1kup",
            applyGiftcard: "Uplatni\u0165",
            giftcardBalance: "Zostatok na dar\u010Dekovej karte",
            deductedBalance: "Zn\xed\u017Een\xfd zostatok",
            "creditCard.pin.title": "K\xf3d PIN",
            "creditCard.encryptedPassword.label": "Prv\xe9 2 \u010D\xedslice hesla karty",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Neplan\xe9 heslo",
            "creditCard.taxNumber": "D\xe1tum narodenia dr\u017Eite\u013Ea karty alebo identifika\u010Dn\xe9 \u010D\xedslo organiz\xe1cie",
            "creditCard.taxNumber.label": "D\xe1tum narodenia dr\u017Eite\u013Ea karty (RRRMMDD) alebo identifika\u010Dn\xe9 \u010D\xedslo organiz\xe1cie (10 \u010D\xedslic)",
            "creditCard.taxNumber.labelAlt": "Identifika\u010Dn\xe9 \u010D\xedslo organiz\xe1cie (10 \u010D\xedslic)",
            "creditCard.taxNumber.invalid": "Neplatn\xfd d\xe1tum narodenia dr\u017Eite\u013Ea karty alebo identifika\u010Dn\xe9 \u010D\xedslo organiz\xe1cie",
            "storedPaymentMethod.disable.button": "Odstr\xe1ni\u0165",
            "storedPaymentMethod.disable.confirmation": "Odstr\xe1ni\u0165 ulo\u017Een\xfd sp\xf4sob platby",
            "storedPaymentMethod.disable.confirmButton": "\xc1no, odstr\xe1ni\u0165",
            "storedPaymentMethod.disable.cancelButton": "Zru\u0161i\u0165",
            "ach.bankAccount": "Bankov\xfd \xfa\u010Det",
            "ach.accountHolderNameField.title": "Meno majite\u013Ea \xfa\u010Dtu",
            "ach.accountHolderNameField.placeholder": "J. Nov\xe1k",
            "ach.accountHolderNameField.invalid": "Neplatn\xe9 meno majite\u013Ea \xfa\u010Dtu",
            "ach.accountNumberField.title": "\u010C\xedslo \xfa\u010Dtu",
            "ach.accountNumberField.invalid": "Neplatn\xe9 \u010D\xedslo \xfa\u010Dtu",
            "ach.accountLocationField.title": "Smerovacie \u010D\xedslo ABA",
            "ach.accountLocationField.invalid": "Neplatn\xe9 smerovacie \u010D\xedslo ABA",
            "ach.savedBankAccount": "Ulo\u017Een\xfd bankov\xfd \xfa\u010Det",
            "select.state": "Vyberte kraj",
            "select.stateOrProvince": "Vyberte kraj alebo okres",
            "select.provinceOrTerritory": "Vyberte okres alebo \xfazemie",
            "select.country": "Vyberte krajinu",
            "select.noOptionsFound": "Neboli n\xe1jden\xe9 \u017Eiadne mo\u017Enosti",
            "select.filter.placeholder": "Vyh\u013Ead\xe1vanie...",
            "telephoneNumber.invalid": "Neplatn\xe9 telef\xf3nne \u010D\xedslo",
            qrCodeOrApp: "alebo",
            "paypal.processingPayment": "Platba sa sprac\xfava.",
            generateQRCode: "Generova\u0165 QR k\xf3d",
            "await.waitForConfirmation": "\u010Cak\xe1 sa na potvrdenie",
            "mbway.confirmPayment": "Potvr\u010Fte svoju platbu v aplik\xe1cii MB WAY",
            "shopperEmail.invalid": "Neplatn\xe1 emailov\xe1 adresa",
            "dateOfBirth.format": "DD/MM/RRRR",
            "dateOfBirth.invalid": "Zadajte platn\xfd d\xe1tum narodenia, ktor\xfd uv\xe1dza, \u017Ee m\xe1te aspo\u0148 18 rokov",
            "blik.confirmPayment": "Otvorte svoju bankov\xfa aplik\xe1ciu a potvr\u010Fte platbu.",
            "blik.invalid": "Zadajte 6 \u010D\xedslic",
            "blik.code": "6-cifern\xfd k\xf3d",
            "blik.help": "Z\xedskajte k\xf3d zo svojej bankovej aplik\xe1cie.",
            "swish.pendingMessage": "Po nasn\xedman\xed m\xf4\u017Ee spracovanie trva\u0165 a\u017E 10 min\xfat. Pokus o op\xe4tovn\xe9 zaplatenie v tejto lehote m\xf4\u017Ee vies\u0165 k nieko\u013Ek\xfdm poplatkom.",
            "field.valid": "Pole je platn\xe9",
            "field.invalid": "Pole je neplatn\xe9",
            "error.va.gen.01": "Ne\xfapln\xe9 pole",
            "error.va.gen.02": "Pole je neplatn\xe9",
            "error.va.sf-cc-num.01": "Zadajte \u010D\xedslo platnej karty",
            "error.va.sf-cc-num.02": "Zadajte \u010D\xedslo karty",
            "error.va.sf-cc-num.03": "Zadajte podporovan\xfa zna\u010Dku karty",
            "error.va.sf-cc-num.04": "Zadajte cel\xe9 \u010D\xedslo karty",
            "error.va.sf-cc-dat.01": "Zadajte platn\xfd d\xe1tum vypr\u0161ania platnosti",
            "error.va.sf-cc-dat.02": "Zadajte platn\xfd d\xe1tum vypr\u0161ania platnosti",
            "error.va.sf-cc-dat.03": "Platnos\u0165 kreditnej karty \u010Doskoro vypr\u0161\xed",
            "error.va.sf-cc-dat.04": "Zadajte de\u0148 vypr\u0161ania platnosti",
            "error.va.sf-cc-dat.05": "Zadajte cel\xfd d\xe1tum vypr\u0161ania platnosti",
            "error.va.sf-cc-mth.01": "Zadajte mesiac vypr\u0161ania platnosti",
            "error.va.sf-cc-yr.01": "Zadajte rok vypr\u0161ania platnosti",
            "error.va.sf-cc-yr.02": "Zadajte cel\xfd rok vypr\u0161ania platnosti",
            "error.va.sf-cc-cvc.01": "Zadajte bezpe\u010Dnostn\xfd k\xf3d",
            "error.va.sf-cc-cvc.02": "Zadajte cel\xfd bezpe\u010Dnostn\xfd k\xf3d",
            "error.va.sf-ach-num.01": "Pole na zadanie \u010D\xedsla bankov\xe9ho \xfa\u010Dtu je pr\xe1zdne",
            "error.va.sf-ach-num.02": "\u010C\xedslo bankov\xe9ho \xfa\u010Dtu m\xe1 nespr\xe1vnu d\u013A\u017Eku",
            "error.va.sf-ach-loc.01": "Pole na zadanie smerov\xe9ho \u010D\xedsla banky je pr\xe1zdne",
            "error.va.sf-ach-loc.02": "Smerov\xe9 \u010D\xedslo banky m\xe1 nespr\xe1vnu d\u013A\u017Eku",
            "error.va.sf-kcp-pwd.01": "Pole na zadanie hesla je pr\xe1zdne",
            "error.va.sf-kcp-pwd.02": "Heslo m\xe1 nespr\xe1vnu d\u013A\u017Eku",
            "error.giftcard.no-balance": "T\xe1to dar\u010Dekov\xe1 karta m\xe1 nulov\xfd zostatok",
            "error.giftcard.card-error": "V na\u0161ich z\xe1znamoch nem\xe1me \u017Eiadnu dar\u010Dekov\xfa kartu s t\xfdmto \u010D\xedslom",
            "error.giftcard.currency-error": "Dar\u010Dekov\xe9 karty s\xfa platn\xe9 iba v mene, v ktorej boli vydan\xe9",
            "amazonpay.signout": "Odhl\xe1si\u0165 sa z Amazonu",
            "amazonpay.changePaymentDetails": "Zmeni\u0165 podrobnosti o platbe",
            "partialPayment.warning": "Ak chcete zaplati\u0165 zostatok, vyberte in\xfd sp\xf4sob platby",
            "partialPayment.remainingBalance": "Zvy\u0161n\xfd zostatok bude %{amount}",
            "bankTransfer.beneficiary": "Pr\xedjemca",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Referencie",
            "bankTransfer.introduction": "Pokra\u010Dujte vo vytv\xe1ran\xed novej platby bankov\xfdm prevodom. T\xfato platbu m\xf4\u017Eete dokon\u010Di\u0165 pomocou inform\xe1ci\xed na nasleduj\xfacej obrazovke.",
            "bankTransfer.instructions": "\u010Eakujeme v\xe1m za n\xe1kup. Na dokon\u010Denie platby pou\u017Eite nasleduj\xface inform\xe1cie.",
            "bacs.accountHolderName": "Meno majite\u013Ea bankov\xe9ho \xfa\u010Dtu",
            "bacs.accountHolderName.invalid": "Neplatn\xe9 meno majite\u013Ea bankov\xe9ho \xfa\u010Dtu",
            "bacs.accountNumber": "\u010C\xedslo bankov\xe9ho \xfa\u010Dtu",
            "bacs.accountNumber.invalid": "Neplatn\xe9 \u010D\xedslo bankov\xe9ho \xfa\u010Dtu",
            "bacs.bankLocationId": "Variabiln\xfd symbol",
            "bacs.bankLocationId.invalid": "Neplatn\xfd variabiln\xfd symbol",
            "bacs.consent.amount": "S\xfahlas\xedm s t\xfdm, \u017Ee ni\u017E\u0161ie uveden\xe1 \u010Diastka bude odp\xedsan\xe1 z m\xf4jho bankov\xe9ho \xfa\u010Dtu.",
            "bacs.consent.account": "Potvrdzujem, \u017Ee \xfa\u010Det je na moje meno a som jedin\xfd podpisovate\u013E, ktor\xfd je povinn\xfd autorizova\u0165 inkaso v tomto \xfa\u010Dte.",
            edit: "Upravi\u0165",
            "bacs.confirm": "Potvrdi\u0165 a zaplati\u0165",
            "bacs.result.introduction": "Stiahnite si pokyny k inkasu (DDI/Mand\xe1t)",
            "download.pdf": "Stiahnu\u0165 vo form\xe1te PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe pre \u010D\xedslo karty",
            "creditCard.encryptedCardNumber.aria.label": "\u010C\xedslo karty",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe pre de\u0148 vypr\u0161ania platnosti",
            "creditCard.encryptedExpiryDate.aria.label": "Koniec platnosti",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe pre mesiac vypr\u0161ania platnosti",
            "creditCard.encryptedExpiryMonth.aria.label": "Mesiac skon\u010Denia platnosti",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe pre rok vypr\u0161ania platnosti",
            "creditCard.encryptedExpiryYear.aria.label": "Rok skon\u010Denia platnosti",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe pre bezpe\u010Dnostn\xfd k\xf3d",
            "creditCard.encryptedSecurityCode.aria.label": "Bezpe\u010Dnostn\xfd k\xf3d",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe pre heslo",
            "creditCard.encryptedPassword.aria.label": "Prv\xe9 2 \u010D\xedslice hesla karty",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe pre \u010D\xedslo karty",
            "giftcard.encryptedCardNumber.aria.label": "\u010C\xedslo karty",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe pre PIN",
            "giftcard.encryptedSecurityCode.aria.label": "K\xf3d PIN",
            giftcardTransactionLimit: "Pre transakciu s touto dar\u010Dekovou kartou je povolen\xe9 maximum %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe pre \u010D\xedslo bankov\xe9ho \xfa\u010Dtu",
            "ach.encryptedBankAccountNumber.aria.label": "\u010C\xedslo \xfa\u010Dtu",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe pre smerovacie \u010D\xedslo banky",
            "ach.encryptedBankLocationId.aria.label": "Smerovacie \u010D\xedslo ABA",
            "twint.saved": "ulo\u017Een\xe9",
            orPayWith: "alebo zaplati\u0165 pomocou",
            invalidFormatExpects: "Neplatn\xfd form\xe1t. O\u010Dak\xe1van\xfd form\xe1t: %{format}",
            "upi.qrCodeWaitingMessage": "Naskenujte QR k\xf3d pomocou preferovanej aplik\xe1cie UPI a dokon\u010Dite platbu",
            "upi.vpaWaitingMessage": "Otvorte aplik\xe1ciu UPI a potvr\u010Fte platbu",
            "upi.modeSelection": "Vyberte si, ako by ste chceli pou\u017E\xedva\u0165 UPI.",
            "onlineBanking.termsAndConditions": "Pokra\u010Dovan\xedm s\xfahlas\xedte so %#zmluvn\xfdmi podmienkami%#",
            "onlineBankingPL.termsAndConditions": "Pokra\u010Dovan\xedm s\xfahlas\xedte, \u017Ee budete dodr\u017Eiava\u0165 %#regulations%# a %#information obligation%# spolo\u010Dnosti Przelewy24",
            "ctp.loading.poweredByCtp": "Vyu\u017E\xedva technol\xf3giu Click to Pay",
            "ctp.loading.intro": "Zis\u0165ujeme, \u010Di m\xe1te ulo\u017Een\xe9 nejak\xe9 karty v\xa0slu\u017Ebe Click to Pay...",
            "ctp.login.title": "Pokra\u010Dova\u0165 do slu\u017Eby Click to Pay",
            "ctp.login.subtitle": "Na pokra\u010Dovanie zadajte e-mailov\xfa adresu, ktor\xe1 je pripojen\xe1 k slu\u017Ebe Click to Pay.",
            "ctp.login.inputLabel": "E-mail",
            "ctp.logout.notYou": "Nie ste to vy?",
            "ctp.logout.notYourCards": "Nie s\xfa to va\u0161e karty?",
            "ctp.logout.notYourCard": "Nie je to va\u0161a karta?",
            "ctp.logout.notYourProfile": "Nie je to v\xe1\u0161 profil?",
            "ctp.otp.fieldLabel": "Jednorazov\xfd k\xf3d",
            "ctp.otp.resendCode": "Znova odosla\u0165 k\xf3d",
            "ctp.otp.codeResent": "K\xf3d bol znova odoslan\xfd",
            "ctp.otp.title": "Z\xedskajte pr\xedstup k va\u0161im kart\xe1m v\xa0slu\u017Ebe Click to Pay",
            "ctp.otp.subtitle": "Zadajte k\xf3d %@, ktor\xfd sme poslali na adresu %@, aby sme overili, \u017Ee ste to vy.",
            "ctp.otp.saveCookiesCheckbox.label": "Nabud\xface presko\u010Di\u0165 overovanie",
            "ctp.otp.saveCookiesCheckbox.information": "Vyberte t\xfato mo\u017Enos\u0165 na zapam\xe4tanie v zariaden\xed a prehliada\u010Di v z\xfa\u010Dastnen\xfdch obchodoch, \u010D\xedm ur\xfdchlite platbu. Neodpor\xfa\u010Da sa pre zdie\u013Ean\xe9 zariadenia.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Vyberte t\xfato mo\u017Enos\u0165 na zapam\xe4tanie v\xa0zariaden\xed a\xa0prehliada\u010Di",
            "ctp.emptyProfile.message": "V\xa0tomto profile Click to Pay nie s\xfa registrovan\xe9 \u017Eiadne karty",
            "ctp.separatorText": "alebo pou\u017Eite",
            "ctp.cards.title": "Dokon\u010Dite platbu v\xa0slu\u017Ebe Click to Pay",
            "ctp.cards.subtitle": "Vyberte kartu, ktor\xfa chcete pou\u017Ei\u0165.",
            "ctp.cards.expiredCard": "Platnos\u0165 uplynula",
            "ctp.manualCardEntry": "Manu\xe1lne zadanie karty",
            "ctp.aria.infoModalButton": "\u010Co znamen\xe1 Click to Pay",
            "ctp.infoPopup.title": "Click to Pay prin\xe1\u0161a jednoduchos\u0165 bezkontaktn\xfdch platieb online",
            "ctp.infoPopup.subtitle": "R\xfdchly a\xa0bezpe\u010Dn\xfd sp\xf4sob platby podporovan\xfd platobn\xfdmi kartami Mastercard, Visa a\xa0\u010Fal\u0161\xedmi.",
            "ctp.infoPopup.benefit1": "Click to Pay pou\u017E\xedva \u0161ifrovanie, aby boli va\u0161e \xfadaje v\xa0bezpe\u010D\xed",
            "ctp.infoPopup.benefit2": "Pou\u017E\xedvajte ju u\xa0obchodn\xedkov po celom svete",
            "ctp.infoPopup.benefit3": "Jedno nastavenie pre pohodln\xe9 platby v\xa0bud\xfacnosti",
            "ctp.errors.AUTH_INVALID": "Overenie bolo neplatn\xe9",
            "ctp.errors.NOT_FOUND": "Nena\u0161iel sa \u017Eiadny \xfa\u010Det. Zadajte platn\xfd e-mail alebo pokra\u010Dujte manu\xe1lnym zadan\xedm karty.",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Form\xe1t nie je podporovan\xfd",
            "ctp.errors.FRAUD": "Pou\u017E\xedvate\u013Esk\xfd \xfa\u010Det bol uzamknut\xfd alebo zak\xe1zan\xfd",
            "ctp.errors.CONSUMER_ID_MISSING": "V \u017Eiadosti ch\xfdba identita spotrebite\u013Ea",
            "ctp.errors.ACCT_INACCESSIBLE": "Tento \xfa\u010Det je moment\xe1lne nedostupn\xfd (napr. je zamknut\xfd)",
            "ctp.errors.CODE_INVALID": "Nespr\xe1vny overovac\xed k\xf3d",
            "ctp.errors.CODE_EXPIRED": "Platnos\u0165 tohto k\xf3du uplynula",
            "ctp.errors.RETRIES_EXCEEDED": "Limit po\u010Dtu opakovan\xed pre generovanie jednorazov\xe9ho hesla bol prekro\u010Den\xfd",
            "ctp.errors.OTP_SEND_FAILED": "Jednorazov\xe9 heslo nebolo mo\u017En\xe9 odosla\u0165 pr\xedjemcovi",
            "ctp.errors.REQUEST_TIMEOUT": "Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010Dne.",
            "ctp.errors.UNKNOWN_ERROR": "Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010Dne.",
            "ctp.errors.SERVICE_ERROR": "Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010Dne.",
            "ctp.errors.SERVER_ERROR": "Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010Dne.",
            "ctp.errors.INVALID_PARAMETER": "Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010Dne.",
            "ctp.errors.AUTH_ERROR": "Do\u0161lo k chybe. Sk\xfaste to znova alebo kartu zadajte ru\u010Dne.",
            "paymentMethodsList.aria.label": "V\xfdber sp\xf4sobu platby",
            "companyDetails.name.invalid": "Zadajte n\xe1zov spolo\u010Dnosti",
            "companyDetails.registrationNumber.invalid": "Zadajte registra\u010Dn\xe9 \u010D\xedslo",
            "consent.checkbox.invalid": "Mus\xedte s\xfahlasi\u0165 s obchodn\xfdmi podmienkami",
            "form.instruction": "V\u0161etky polia s\xfa povinn\xe9, ak nie je ozna\u010Den\xe9 inak.",
            "trustly.descriptor": "Okam\u017Eit\xe1 bankov\xe1 platba",
            "trustly.description1": "Platba priamo z ktor\xe9hoko\u013Evek bankov\xe9ho \xfa\u010Dtu so zabezpe\u010Den\xedm na \xfarovni banky",
            "trustly.description2": "\u017Diadne karty, \u017Eiadne s\u0165ahovanie aplik\xe1ci\xed, \u017Eiadna registr\xe1cia",
            "ancv.input.label": "Va\u0161a identifik\xe1cia ANCV",
            "ancv.confirmPayment": "Na potvrdenie platby pou\u017Eite svoju aplik\xe1ciu ANCV.",
            "ancv.form.instruction": "Na potvrdenie tejto platby je potrebn\xe1 aplik\xe1cia Cheque-Vacances.",
            "ancv.beneficiaryId.invalid": "Zadajte platn\xfa e-mailov\xfa adresu alebo ANCV ID",
            "payme.openPayMeApp": "Dokon\u010Dite platbu v aplik\xe1cii PayMe tak, \u017Ee v aplik\xe1cii autorizujete platbu a po\u010Dk\xe1te na potvrdenie.",
            "payme.redirectButtonLabel": "Otvori\u0165 aplik\xe1ciu PayMe",
            "payme.scanQrCode": "Dokon\u010Dite platbu pomocou k\xf3du QR",
            "payme.timeToPay": "Tento k\xf3d QR plat\xed %@",
            "payme.instructions.steps": "Otvorte aplik\xe1ciu PayMe.%@Autorizujte platbu naskenovan\xedm QR k\xf3du.%@Dokon\u010Dite platbu v aplik\xe1cii a po\u010Dkajte na potvrdenie.",
            "payme.instructions.footnote": "Nezatv\xe1rajte t\xfato str\xe1nku pred dokon\u010Den\xedm platby"
        }
    }), p2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Pla\u010Dilo",
            "payButton.redirecting": "Preusmerjanje...",
            "payButton.with": "Pla\u010Dajte %{value} z %{maskedData}",
            "payButton.saveDetails": "Shrani podrobnosti",
            close: "Zapri",
            storeDetails: "Shrani za moje naslednje pla\u010Dilo",
            readMore: "Preberi ve\u010D",
            "creditCard.holderName": "Ime na kartici",
            "creditCard.holderName.placeholder": "J. Novak",
            "creditCard.holderName.invalid": "Vnesite ime, kot je prikazano na kartici",
            "creditCard.numberField.title": "\u0160tevilka kartice",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Datum veljavnosti",
            "creditCard.expiryDateField.placeholder": "MM/LL",
            "creditCard.expiryDateField.month": "Mesec",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "LL",
            "creditCard.expiryDateField.year": "Leto",
            "creditCard.cvcField.title": "Varnostna koda",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Zapomni si za prihodnji\u010D",
            "creditCard.cvcField.placeholder.4digits": "4 \u0161tevke",
            "creditCard.cvcField.placeholder.3digits": "3 \u0161tevke",
            "creditCard.taxNumber.placeholder": "LLMMDD / 0123456789",
            installments: "\u0160tevilo obrokov",
            installmentOption: "%{times} \xd7 %{partialValue}",
            installmentOptionMonths: "\u0160t. mesecev: %{times}",
            "installments.oneTime": "Enkratno pla\u010Dilo",
            "installments.installments": "Obro\u010Dno pla\u010Dilo",
            "installments.revolving": "Revolving pla\u010Dilo",
            "sepaDirectDebit.ibanField.invalid": "Neveljavna \u0161tevilka ra\u010Duna",
            "sepaDirectDebit.nameField.placeholder": "J. Novak",
            "sepa.ownerName": "Ime imetnika",
            "sepa.ibanNumber": "\u0160tevilka ra\u010Duna (IBAN)",
            "error.title": "Napaka",
            "error.subtitle.redirect": "Preusmeritev ni uspela",
            "error.subtitle.payment": "Pla\u010Dilo ni uspelo",
            "error.subtitle.refused": "Pla\u010Dilo je bilo zavrnjeno",
            "error.message.unknown": "Pri\u0161lo je do neznane napake",
            "errorPanel.title": "Obstoje\u010De napake",
            "idealIssuer.selectField.title": "Banka",
            "idealIssuer.selectField.placeholder": "Izberite svojo banko",
            "creditCard.success": "Pla\u010Dilo je bilo uspe\u0161no",
            loading: "Nalaganje\u2026",
            continue: "Nadaljuj",
            continueTo: "Nadaljujte na",
            "wechatpay.timetopay": "Pla\u010Dati morate %@",
            "sr.wechatpay.timetopay": "\u010Casa za pla\u010Dilo imate %#min.%# %#s.%#",
            "wechatpay.scanqrcode": "Opti\u010Dno preberite kodo QR",
            personalDetails: "Osebni podatki",
            companyDetails: "Podrobnosti o podjetju",
            "companyDetails.name": "Ime podjetja",
            "companyDetails.registrationNumber": "Mati\u010Dna \u0161tevilka podjetja",
            socialSecurityNumber: "\u0160tevilka socialnega zavarovanja",
            firstName: "Ime",
            "firstName.invalid": "Vnesite svoje ime",
            infix: "Naziv",
            lastName: "Priimek",
            "lastName.invalid": "Vnesite svoj priimek",
            mobileNumber: "\u0160tevilka mobilnega telefona",
            "mobileNumber.invalid": "Neveljavna \u0161tevilka mobilnega telefona",
            city: "Mesto",
            postalCode: "Po\u0161tna \u0161tevilka",
            "postalCode.optional": "Po\u0161tna \u0161tevilka (neobvezno)",
            countryCode: "Koda dr\u017Eave",
            telephoneNumber: "Telefonska \u0161tevilka",
            dateOfBirth: "Datum rojstva",
            shopperEmail: "Elektronski naslov",
            gender: "Spol",
            "gender.notselected": "Izberite svoj spol",
            male: "Mo\u0161ki",
            female: "\u017Denski",
            billingAddress: "Naslov za ra\u010Dun",
            street: "Ulica",
            stateOrProvince: "Dr\u017Eava ali provinca",
            country: "Dr\u017Eava",
            houseNumberOrName: "Hi\u0161na \u0161tevilka",
            separateDeliveryAddress: "Navedite lo\u010Den naslov za dostavo",
            deliveryAddress: "Naslov za dostavo",
            "deliveryAddress.firstName": "Ime prejemnika",
            "deliveryAddress.lastName": "Priimek prejemnika",
            zipCode: "Po\u0161tna \u0161tevilka",
            apartmentSuite: "\u0160t. apartmaja/stanovanja",
            provinceOrTerritory: "Obmo\u010Dje ali ozemlje",
            cityTown: "Mesto",
            address: "Naslov",
            "address.placeholder": "Poi\u0161\u010Dite svoj naslov",
            "address.errors.incomplete": "Za nadaljevanje vnesite naslov",
            "address.enterManually": "Naslov vnesite ro\u010Dno",
            state: "Dr\u017Eava",
            "field.title.optional": "(izbirno)",
            "creditCard.cvcField.title.optional": "Varnostna koda (neobvezno)",
            "issuerList.wallet.placeholder": "Izberite svojo denarnico",
            privacyPolicy: "Pravilnik o zasebnosti",
            "afterPay.agreement": "Strinjam se s %@ ponudnika Riverty",
            paymentConditions: "pla\u010Dilnimi pogoji",
            openApp: "Odprite aplikacijo",
            "voucher.readInstructions": "Preberite navodila",
            "voucher.introduction": "Zahvaljujemo se vam za nakup. Za dokon\u010Danje pla\u010Dila uporabite naslednji kupon.",
            "voucher.expirationDate": "Datum poteka veljavnosti",
            "voucher.alternativeReference": "Druga referen\u010Dna \u0161tevilka",
            "dragonpay.voucher.non.bank.selectField.placeholder": "Izberite svojega ponudnika",
            "dragonpay.voucher.bank.selectField.placeholder": "Izberite svojo banko",
            "voucher.paymentReferenceLabel": "Referen\u010Dna \u0161tevilka pla\u010Dila",
            "voucher.surcharge": "Vklj. %@ dopla\u010Dila",
            "voucher.introduction.doku": "Zahvaljujemo se vam za nakup. Za dokon\u010Danje pla\u010Dila uporabite naslednji kupon.",
            "voucher.shopperName": "Ime kupca",
            "voucher.merchantName": "Trgovec",
            "voucher.introduction.econtext": "Zahvaljujemo se vam za nakup. Za dokon\u010Danje pla\u010Dila uporabite naslednji kupon.",
            "voucher.telephoneNumber": "Telefonska \u0161tevilka",
            "voucher.shopperReference": "Referen\u010Dna \u0161tevilka kupca",
            "voucher.collectionInstitutionNumber": "\u0160tevilka ustanove za zbiranje",
            "voucher.econtext.telephoneNumber.invalid": "Telefonska \u0161tevilka mora vsebovati 10 ali 11 \u0161tevk",
            "boletobancario.btnLabel": "Ustvari Boleto",
            "boleto.sendCopyToEmail": "Po\u0161lji kopijo na moj elektronski naslov",
            "button.copy": "Kopiraj",
            "button.download": "Prenesi",
            "boleto.socialSecurityNumber.invalid": "Polje ni veljavno",
            "creditCard.storedCard.description.ariaLabel": "Shranjena kartica se kon\u010Da na %@",
            "voucher.entity": "Entiteta",
            donateButton: "Donirajte",
            notNowButton: "Ne zdaj",
            thanksForYourSupport: "Zahvaljujemo se vam za podporo!",
            "resultMessages.preauthorized": "Podrobnosti so shranjene",
            preauthorizeWith: "Predhodna odobritev s/z:",
            confirmPreauthorization: "Potrdi predhodno odobritev",
            confirmPurchase: "Potrditev nakupa",
            applyGiftcard: "Unov\u010Di",
            giftcardBalance: "Stanje na darilni kartici",
            deductedBalance: "Odbiti znesek",
            "creditCard.pin.title": "PIN",
            "creditCard.encryptedPassword.label": "Prvi dve \u0161tevki gesla za kartico",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Neveljavno geslo",
            "creditCard.taxNumber": "Datum rojstva imetnika kartice ali mati\u010Dna \u0161tevilka podjetja",
            "creditCard.taxNumber.label": "Datum rojstva imetnika kartice (LLMMDD) ali registracijska \u0161tevilka podjetja (10 \u0161tevk)",
            "creditCard.taxNumber.labelAlt": "Mati\u010Dna \u0161tevilka podjetja (10 \u0161tevk)",
            "creditCard.taxNumber.invalid": "Neveljaven datum rojstva imetnika kartice ali mati\u010Dna \u0161tevilka podjetja",
            "storedPaymentMethod.disable.button": "Odstrani",
            "storedPaymentMethod.disable.confirmation": "Odstrani shranjen na\u010Din pla\u010Dila",
            "storedPaymentMethod.disable.confirmButton": "Da, odstrani",
            "storedPaymentMethod.disable.cancelButton": "Prekli\u010Di",
            "ach.bankAccount": "Ban\u010Dni ra\u010Dun",
            "ach.accountHolderNameField.title": "Ime imetnika ra\u010Duna",
            "ach.accountHolderNameField.placeholder": "J. Novak",
            "ach.accountHolderNameField.invalid": "Neveljavno ime imetnika ra\u010Duna",
            "ach.accountNumberField.title": "\u0160tevilka ra\u010Duna",
            "ach.accountNumberField.invalid": "Neveljavna \u0161tevilka ra\u010Duna",
            "ach.accountLocationField.title": "Koda banke ABA",
            "ach.accountLocationField.invalid": "Neveljavna koda banke ABA",
            "ach.savedBankAccount": "Shranjen ban\u010Dni ra\u010Dun",
            "select.state": "Izberite dr\u017Eavo",
            "select.stateOrProvince": "Izberite dr\u017Eavo ali provinco",
            "select.provinceOrTerritory": "Izberite obmo\u010Dje ali ozemlje",
            "select.country": "Izberite dr\u017Eavo",
            "select.noOptionsFound": "Ni najdenih mo\u017Enosti",
            "select.filter.placeholder": "Iskanje...",
            "telephoneNumber.invalid": "Neveljavna telefonska \u0161tevilka",
            qrCodeOrApp: "ali",
            "paypal.processingPayment": "Obdelava pla\u010Dila...",
            generateQRCode: "Ustvari kodo QR",
            "await.waitForConfirmation": "\u010Cakanje na potrditev",
            "mbway.confirmPayment": "Potrdite svoje pla\u010Dilo v aplikaciji MB WAY",
            "shopperEmail.invalid": "Neveljaven elektronski naslov",
            "dateOfBirth.format": "DD/MM/LLLL",
            "dateOfBirth.invalid": "Vnesite veljaven datum rojstva, ki ka\u017Ee, da ste stari vsaj 18 let.",
            "blik.confirmPayment": "Za potrditev pla\u010Dila odprite svojo ban\u010Dno aplikacijo.",
            "blik.invalid": "Vnesite 6 \u0161tevilk",
            "blik.code": "6-mestna koda",
            "blik.help": "Pridobite kodo iz ban\u010Dne aplikacije.",
            "swish.pendingMessage": "Ko opti\u010Dno preberete, lahko \u010Dakanje traja do 10 minut. Poskus ponovnega pla\u010Dila v tem \u010Dasu lahko povzro\u010Di ve\u010D odtegljajev.",
            "field.valid": "Polje je veljavno",
            "field.invalid": "Polje ni veljavno",
            "error.va.gen.01": "Nepopolno polje",
            "error.va.gen.02": "Polje ni veljavno",
            "error.va.sf-cc-num.01": "Vnesite veljavno \u0161tevilko kartice",
            "error.va.sf-cc-num.02": "Vnesite \u0161tevilko kartice",
            "error.va.sf-cc-num.03": "Vnesite podprto blagovno znamko kartice",
            "error.va.sf-cc-num.04": "Vnesite celotno \u0161tevilko kartice",
            "error.va.sf-cc-dat.01": "Vnesite veljavni datum poteka veljavnosti",
            "error.va.sf-cc-dat.02": "Vnesite veljavni datum poteka veljavnosti",
            "error.va.sf-cc-dat.03": "Kreditna kartica bo kmalu potekla",
            "error.va.sf-cc-dat.04": "Vnesite datum poteka veljavnosti",
            "error.va.sf-cc-dat.05": "Vnesite celoten datum poteka veljavnosti",
            "error.va.sf-cc-mth.01": "Vnesite mesec poteka veljavnosti",
            "error.va.sf-cc-yr.01": "Vnesite leto poteka veljavnosti",
            "error.va.sf-cc-yr.02": "Vnesite celotno leto poteka veljavnosti",
            "error.va.sf-cc-cvc.01": "Vnesite varnostno kodo",
            "error.va.sf-cc-cvc.02": "Vnesite celotno varnostno kodo",
            "error.va.sf-ach-num.01": "Polje s \u0161tevilko ban\u010Dnega ra\u010Duna je prazno",
            "error.va.sf-ach-num.02": "\u0160tevilka ban\u010Dnega ra\u010Duna je napa\u010Dne dol\u017Eine",
            "error.va.sf-ach-loc.01": "Polje z ban\u010Dno usmerjevalno \u0161tevilko je prazno",
            "error.va.sf-ach-loc.02": "Ban\u010Dna usmerjevalna \u0161tevilka je napa\u010Dne dol\u017Eine",
            "error.va.sf-kcp-pwd.01": "Polje z geslom je prazno",
            "error.va.sf-kcp-pwd.02": "Geslo je napa\u010Dne dol\u017Eine",
            "error.giftcard.no-balance": "Na tej darilni kartici ni sredstev",
            "error.giftcard.card-error": "V na\u0161i evidenci nimamo darilne kartice s to \u0161tevilko",
            "error.giftcard.currency-error": "Darilne kartice so veljavne samo za valuto, za katero so bile izdane",
            "amazonpay.signout": "Odjava iz Amazona",
            "amazonpay.changePaymentDetails": "Sprememba podrobnosti pla\u010Dila",
            "partialPayment.warning": "Izberite drugo vrsto pla\u010Dila za pla\u010Dilo ostanka",
            "partialPayment.remainingBalance": "Preostalo stanje bo %{amount}",
            "bankTransfer.beneficiary": "Upravi\u010Denec",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "Referenca",
            "bankTransfer.introduction": "Nadaljujte ustvarjanje novega pla\u010Dila z ban\u010Dnim nakazilom. Za dokon\u010Danje tega pla\u010Dila lahko uporabite podatke na naslednjem zaslonu.",
            "bankTransfer.instructions": "Zahvaljujemo se vam za nakup. Za dokon\u010Danje pla\u010Dila uporabite naslednji kupon.",
            "bacs.accountHolderName": "Ime imetnika ban\u010Dnega ra\u010Duna",
            "bacs.accountHolderName.invalid": "Neveljavno ime imetnika ra\u010Duna",
            "bacs.accountNumber": "\u0160tevilka ban\u010Dnega ra\u010Duna",
            "bacs.accountNumber.invalid": "Neveljavna \u0161tevilka ban\u010Dnega ra\u010Duna",
            "bacs.bankLocationId": "\u0160tevilka banke",
            "bacs.bankLocationId.invalid": "Neveljavna \u0161tevilka banke",
            "bacs.consent.amount": "Sogla\u0161am s tem, da bo zgornji znesek odtegnjen z mojega ban\u010Dnega ra\u010Duna.",
            "bacs.consent.account": "Potrjujem, da je ra\u010Dun ustvarjen v mojem imenu in sem edini podpisnik za odobritev neposredne bremenitve za ta ra\u010Dun.",
            edit: "Uredi",
            "bacs.confirm": "Potrdi in pla\u010Daj",
            "bacs.result.introduction": "Prenesite navodila za neposredno bremenitev (DDI/mandat)",
            "download.pdf": "Prenos datoteke PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe za \u0161tevilko kartice",
            "creditCard.encryptedCardNumber.aria.label": "\u0160tevilka kartice",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe za datum poteka veljavnosti",
            "creditCard.encryptedExpiryDate.aria.label": "Datum veljavnosti",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe za mesec poteka veljavnosti",
            "creditCard.encryptedExpiryMonth.aria.label": "Mesec poteka",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe za leto poteka veljavnosti",
            "creditCard.encryptedExpiryYear.aria.label": "Leto poteka",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe za varnostno kodo",
            "creditCard.encryptedSecurityCode.aria.label": "Varnostna koda",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe za geslo",
            "creditCard.encryptedPassword.aria.label": "Prvi dve \u0161tevki gesla za kartico",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe za \u0161tevilko kartice",
            "giftcard.encryptedCardNumber.aria.label": "\u0160tevilka kartice",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe za kodo PIN",
            "giftcard.encryptedSecurityCode.aria.label": "PIN",
            giftcardTransactionLimit: "Za posamezno transakcijo na tej darilni kartici je dovoljeno najve\u010D %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe za \u0161tevilko ban\u010Dnega ra\u010Duna",
            "ach.encryptedBankAccountNumber.aria.label": "\u0160tevilka ra\u010Duna",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe za usmerjevalno \u0161tevilko banke",
            "ach.encryptedBankLocationId.aria.label": "Koda banke ABA",
            "twint.saved": "shranjeno",
            orPayWith: "ali pla\u010Dajte s/z",
            invalidFormatExpects: "Neveljavna oblika zapisa. Pri\u010Dakovana oblika zapisa: %{format}",
            "upi.qrCodeWaitingMessage": "Za dokon\u010Danje pla\u010Dila opti\u010Dno preberite kodo QR z \u017Eeleno aplikacijo UPI",
            "upi.vpaWaitingMessage": "Za potrditev pla\u010Dila odprite svojo aplikacijo UPI",
            "upi.modeSelection": "Izberite, kako \u017Eelite uporabljati aplikacijo UPI.",
            "onlineBanking.termsAndConditions": "Z nadaljevanjem se strinjate s %#pogoji%#",
            "onlineBankingPL.termsAndConditions": "Z nadaljevanjem se strinjate s %#predpisi%# in %#obveznostjo obve\u0161\u010Danja%# dru\u017Ebe Przelewy24",
            "ctp.loading.poweredByCtp": "Omogo\u010Da storitev Click to Pay",
            "ctp.loading.intro": "Preverjamo, ali imate shranjene kartice v storitvi Click to Pay...",
            "ctp.login.title": "Nadaljuj na storitev Click to Pay",
            "ctp.login.subtitle": "Za nadaljevanje vnesite e-po\u0161tni naslov, ki je povezan s storitvijo Click to Pay.",
            "ctp.login.inputLabel": "E-po\u0161ta",
            "ctp.logout.notYou": "To niste vi?",
            "ctp.logout.notYourCards": "To niso va\u0161e kartice?",
            "ctp.logout.notYourCard": "To ni va\u0161a kartica?",
            "ctp.logout.notYourProfile": "To ni va\u0161 profil?",
            "ctp.otp.fieldLabel": "Enkratna koda",
            "ctp.otp.resendCode": "Znova po\u0161lji kodo",
            "ctp.otp.codeResent": "Koda je bila znova poslana",
            "ctp.otp.title": "Dostop do va\u0161ih kartic Click to Pay",
            "ctp.otp.subtitle": "Vnesite kodo %@, ki smo jo poslali na %@, da potrdite, da ste to res vi.",
            "ctp.otp.saveCookiesCheckbox.label": "Naslednji\u010D presko\u010Di preverjanje",
            "ctp.otp.saveCookiesCheckbox.information": "Izberite \u010De \u017Eelite, da se v va\u0161i napravi in brskalniku v sodelujo\u010Dih trgovinah va\u0161i podatki shranijo za hitrej\u0161i zaklju\u010Dek zakupa. Ni priporo\u010Dljivo za naprave v skupni rabi.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "Izberite, \u010De \u017Eelite, da se v va\u0161i napravi in brskalniku shranijo va\u0161i podatki",
            "ctp.emptyProfile.message": "V tem profilu Click to Pay ni registriranih nobenih kartic",
            "ctp.separatorText": "ali uporabite",
            "ctp.cards.title": "Dokon\u010Dajte pla\u010Dilo s storitvijo Click to Pay",
            "ctp.cards.subtitle": "Izberite kartico, ki jo \u017Eelite uporabiti.",
            "ctp.cards.expiredCard": "Veljavnost potekla",
            "ctp.manualCardEntry": "Ro\u010Dni vnos kartice",
            "ctp.aria.infoModalButton": "Kaj je storitev Click to Pay",
            "ctp.infoPopup.title": "Storitev Click to Pay prina\u0161a enostavnost brezsti\u010Dnega pla\u010Devanja v spletno okolje",
            "ctp.infoPopup.subtitle": "Hiter in varen na\u010Din pla\u010Dila, ki ga podpirajo Mastercard, Visa in druge pla\u010Dilne kartice.",
            "ctp.infoPopup.benefit1": "Storitev Click to Pay s \u0161ifriranjem poskrbi, da so va\u0161i podatki varni in za\u0161\u010Diteni",
            "ctp.infoPopup.benefit2": "Uporabljate jo lahko pri prodajalcih po vsem svetu",
            "ctp.infoPopup.benefit3": "Enkratna nastavitev za brezskrbno pla\u010Devanje v prihodnje",
            "ctp.errors.AUTH_INVALID": "Preverjanje pristnosti ni veljavno",
            "ctp.errors.NOT_FOUND": "Ra\u010Duna ni bilo mogo\u010De najti, vnesite veljaven e-po\u0161tni naslov ali nadaljujte z uporabo ro\u010Dnega vnosa kartice",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Oblika zapisa ni podprta",
            "ctp.errors.FRAUD": "Uporabni\u0161ki ra\u010Dun je bil zaklenjen ali onemogo\u010Den",
            "ctp.errors.CONSUMER_ID_MISSING": "V zahtevi manjka identiteta potro\u0161nika",
            "ctp.errors.ACCT_INACCESSIBLE": "Ta ra\u010Dun trenutno ni na voljo, npr. morda je zaklenjen",
            "ctp.errors.CODE_INVALID": "Koda za preverjanje ni pravilna",
            "ctp.errors.CODE_EXPIRED": "Ta koda je potekla",
            "ctp.errors.RETRIES_EXCEEDED": "Omejitev \u0161tevila ponovnih poskusov za generiranje gesla OTP je bila prese\u017Eena",
            "ctp.errors.OTP_SEND_FAILED": "Gesla OTP ni bilo mogo\u010De poslati prejemniku",
            "ctp.errors.REQUEST_TIMEOUT": "Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010Dni vnos kartice",
            "ctp.errors.UNKNOWN_ERROR": "Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010Dni vnos kartice",
            "ctp.errors.SERVICE_ERROR": "Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010Dni vnos kartice",
            "ctp.errors.SERVER_ERROR": "Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010Dni vnos kartice",
            "ctp.errors.INVALID_PARAMETER": "Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010Dni vnos kartice",
            "ctp.errors.AUTH_ERROR": "Nekaj je \u0161lo narobe, poskusite znova ali uporabite ro\u010Dni vnos kartice",
            "paymentMethodsList.aria.label": "Izberite na\u010Din pla\u010Dila",
            "companyDetails.name.invalid": "Vnesite ime podjetja",
            "companyDetails.registrationNumber.invalid": "Vnesite registracijsko \u0161tevilko",
            "consent.checkbox.invalid": "Strinjati se morate s pogoji in dolo\u010Dili",
            "form.instruction": "Vsa polja so obvezna, razen \u010De ni ozna\u010Deno druga\u010De.",
            "trustly.descriptor": "Takoj\u0161nje ban\u010Dno nakazilo",
            "trustly.description1": "Pla\u010Dajte neposredno s svojega poljubnega ban\u010Dnega ra\u010Duna, pri \u010Demer je varnost zagotovljena na ravni banke.",
            "trustly.description2": "Brez kartic, brez prenosa aplikacije, brez registracije",
            "ancv.input.label": "Va\u0161a identifikacija ANCV",
            "ancv.confirmPayment": "Za potrditev pla\u010Dila uporabite aplikacijo ANCV.",
            "ancv.form.instruction": "Za potrditev tega pla\u010Dila je potrebna aplikacija Cheque-Vacances.",
            "ancv.beneficiaryId.invalid": "Vnesite veljaven e-po\u0161tni naslov ali ANCV ID",
            "payme.openPayMeApp": "Pla\u010Dilo dokon\u010Dajte v aplikaciji PayMe tako, da ga odobrite v aplikaciji in po\u010Dakate na potrditev.",
            "payme.redirectButtonLabel": "Odprite aplikacijo PayMe",
            "payme.scanQrCode": "Izvedite pla\u010Dilo s kodo QR",
            "payme.timeToPay": "Ta koda QR velja za %@",
            "payme.instructions.steps": "Odprite aplikacijo PayMe.%@Skenirajte kodo QR, da odobrite pla\u010Dilo.%@Zaklju\u010Dite pla\u010Dilo v aplikaciji in po\u010Dakajte na potrditev.",
            "payme.instructions.footnote": "Ne zapirajte te strani, preden je pla\u010Dilo zaklju\u010Deno."
        }
    }), m2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "Betala",
            "payButton.redirecting": "Omdirigerar\u2026",
            "payButton.with": "Betala %{value} med %{maskedData}",
            "payButton.saveDetails": "Spara information",
            close: "St\xe4ng",
            storeDetails: "Spara till min n\xe4sta betalning",
            readMore: "L\xe4s mer",
            "creditCard.holderName": "Namn p\xe5 kort",
            "creditCard.holderName.placeholder": "A. Andersson",
            "creditCard.holderName.invalid": "Ange namnet som det st\xe5r p\xe5 kortet",
            "creditCard.numberField.title": "Kortnummer",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "Utg\xe5ngsdatum",
            "creditCard.expiryDateField.placeholder": "MM/\xc5\xc5",
            "creditCard.expiryDateField.month": "M\xe5nad",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "\xc5\xc5",
            "creditCard.expiryDateField.year": "\xc5r",
            "creditCard.cvcField.title": "S\xe4kerhetskod",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "Spara kortuppgifter",
            "creditCard.cvcField.placeholder.4digits": "4 siffror",
            "creditCard.cvcField.placeholder.3digits": "3 siffror",
            "creditCard.taxNumber.placeholder": "\xc5\xc5MMDD / 0123456789",
            installments: "Antal delbetalningar",
            installmentOption: "%{times} x %{partialValue}",
            installmentOptionMonths: "%{times} m\xe5nader",
            "installments.oneTime": "Eng\xe5ngsbetalning",
            "installments.installments": "Delbetalningar",
            "installments.revolving": "Uppdelad betalning",
            "sepaDirectDebit.ibanField.invalid": "Ogiltigt kontonummer",
            "sepaDirectDebit.nameField.placeholder": "A. Andersson",
            "sepa.ownerName": "K\xe4nt av kontoinnehavaren",
            "sepa.ibanNumber": "Kontonummer (IBAN)",
            "error.title": "Fel",
            "error.subtitle.redirect": "Omdirigering misslyckades",
            "error.subtitle.payment": "Betalning misslyckades",
            "error.subtitle.refused": "Betalning avvisad",
            "error.message.unknown": "Ett ok\xe4nt fel uppstod",
            "errorPanel.title": "Befintliga fel",
            "idealIssuer.selectField.title": "Bank",
            "idealIssuer.selectField.placeholder": "V\xe4lj din bank",
            "creditCard.success": "Betalning lyckades",
            loading: "Laddar\u2026",
            continue: "Forts\xe4tt",
            continueTo: "Forts\xe4tt till",
            "wechatpay.timetopay": "Du har %@ att betala",
            "sr.wechatpay.timetopay": "Du har %#minuter%# och %#sekunder%# p\xe5 dig att betala",
            "wechatpay.scanqrcode": "Skanna QR-kod",
            personalDetails: "Personuppgifter",
            companyDetails: "F\xf6retagsinformation",
            "companyDetails.name": "F\xf6retagsnamn",
            "companyDetails.registrationNumber": "Registreringsnummer",
            socialSecurityNumber: "Personnummer",
            firstName: "F\xf6rnamn",
            "firstName.invalid": "Ange ditt f\xf6rnamn",
            infix: "Prefix",
            lastName: "Efternamn",
            "lastName.invalid": "Ange ditt efternamn",
            mobileNumber: "Mobilnummer",
            "mobileNumber.invalid": "Ogiltigt mobilnummer",
            city: "Stad",
            postalCode: "Postnummer",
            "postalCode.optional": "Postnummer (valfritt)",
            countryCode: "Landskod",
            telephoneNumber: "Telefonnummer",
            dateOfBirth: "F\xf6delsedatum",
            shopperEmail: "E-postadress",
            gender: "K\xf6n",
            "gender.notselected": "V\xe4lj k\xf6n",
            male: "Man",
            female: "Kvinna",
            billingAddress: "Faktureringsadress",
            street: "Gatuadress",
            stateOrProvince: "Delstat eller region",
            country: "Land",
            houseNumberOrName: "Husnummer",
            separateDeliveryAddress: "Ange en separat leveransadress",
            deliveryAddress: "Leveransadress",
            "deliveryAddress.firstName": "Mottagarens f\xf6rnamn",
            "deliveryAddress.lastName": "Mottagarens efternamn",
            zipCode: "Postnummer",
            apartmentSuite: "L\xe4genhetsnummer",
            provinceOrTerritory: "Provins eller territorium",
            cityTown: "Ort",
            address: "Adress",
            "address.placeholder": "Hitta din adress",
            "address.errors.incomplete": "Ange en adress f\xf6r att forts\xe4tta",
            "address.enterManually": "Ange adress manuellt",
            state: "Delstat",
            "field.title.optional": "(valfritt)",
            "creditCard.cvcField.title.optional": "S\xe4kerhetskod (valfritt)",
            "issuerList.wallet.placeholder": "V\xe4j din pl\xe5nbok",
            privacyPolicy: "Sekretesspolicy",
            "afterPay.agreement": "Jag godk\xe4nner Rivertys %@",
            paymentConditions: "betalvillkor",
            openApp: "\xd6ppna appen",
            "voucher.readInstructions": "L\xe4s instruktionerna",
            "voucher.introduction": "Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande kupong f\xf6r att slutf\xf6ra din betalning.",
            "voucher.expirationDate": "Utg\xe5ngsdatum",
            "voucher.alternativeReference": "Alternativ referens",
            "dragonpay.voucher.non.bank.selectField.placeholder": "V\xe4lj din leverant\xf6r",
            "dragonpay.voucher.bank.selectField.placeholder": "V\xe4lj din bank",
            "voucher.paymentReferenceLabel": "Betalreferens",
            "voucher.surcharge": "Inklusive %@ i avgift",
            "voucher.introduction.doku": "Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.",
            "voucher.shopperName": "Konsumentens namn",
            "voucher.merchantName": "Handlare",
            "voucher.introduction.econtext": "Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.",
            "voucher.telephoneNumber": "Telefonnummer",
            "voucher.shopperReference": "K\xf6parreferens",
            "voucher.collectionInstitutionNumber": "Nummer p\xe5 upph\xe4mtningsplats",
            "voucher.econtext.telephoneNumber.invalid": "Telefonnumret m\xe5ste inneh\xe5lla 10 eller 11 siffror",
            "boletobancario.btnLabel": "Generera Boleto",
            "boleto.sendCopyToEmail": "Skicka en kopia till min e-post",
            "button.copy": "Kopiera",
            "button.download": "Ladda ner",
            "boleto.socialSecurityNumber.invalid": "F\xe4ltet \xe4r ogiltigt",
            "creditCard.storedCard.description.ariaLabel": "Sparat kort slutar p\xe5 %@",
            "voucher.entity": "Enhet",
            donateButton: "Donera",
            notNowButton: "Inte nu",
            thanksForYourSupport: "Tack f\xf6r ditt st\xf6d!",
            "resultMessages.preauthorized": "Information sparad",
            preauthorizeWith: "F\xf6rauktorisera med",
            confirmPreauthorization: "Bekr\xe4fta f\xf6rauktorisering",
            confirmPurchase: "Bekr\xe4fta k\xf6p",
            applyGiftcard: "L\xf6s in",
            giftcardBalance: "Presentkortssaldo",
            deductedBalance: "Avdraget saldo",
            "creditCard.pin.title": "PIN-kod",
            "creditCard.encryptedPassword.label": "De tv\xe5 f\xf6rsta siffrorna i kortets l\xf6senord",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "Ogiltigt l\xf6senord",
            "creditCard.taxNumber": "Kortinnehavarens f\xf6delsedatum eller f\xf6retagets organisationsnummer",
            "creditCard.taxNumber.label": "Kortinnehavarens f\xf6delsedatum (\xc5\xc5MMDD) eller f\xf6retagets organisationsnummer (10 siffror)",
            "creditCard.taxNumber.labelAlt": "F\xf6retagets organisationsnummer (10 siffror)",
            "creditCard.taxNumber.invalid": "Ogiltigt f\xf6delsedatum eller organisationsnummer",
            "storedPaymentMethod.disable.button": "Ta bort",
            "storedPaymentMethod.disable.confirmation": "Ta bort sparat betalningss\xe4tt",
            "storedPaymentMethod.disable.confirmButton": "Ja, ta bort",
            "storedPaymentMethod.disable.cancelButton": "Avbryt",
            "ach.bankAccount": "Bankkonto",
            "ach.accountHolderNameField.title": "Kontoinnehavarens namn",
            "ach.accountHolderNameField.placeholder": "A. Andersson",
            "ach.accountHolderNameField.invalid": "Kontoinnehavarens namn \xe4r ogiltigt",
            "ach.accountNumberField.title": "Kontonummer",
            "ach.accountNumberField.invalid": "Ogiltigt kontonummer",
            "ach.accountLocationField.title": "ABA-nummer",
            "ach.accountLocationField.invalid": "Ogiltigt ABA-nummer",
            "ach.savedBankAccount": "Sparat bankkonto",
            "select.state": "V\xe4lj delstat",
            "select.stateOrProvince": "V\xe4lj delstat eller provins",
            "select.provinceOrTerritory": "V\xe4lj provins eller territorium",
            "select.country": "V\xe4lj land",
            "select.noOptionsFound": "Inga alternativ hittades",
            "select.filter.placeholder": "S\xf6k efter\u2026",
            "telephoneNumber.invalid": "Ogiltigt telefonnummer",
            qrCodeOrApp: "eller",
            "paypal.processingPayment": "Behandlar betalning\u2026",
            generateQRCode: "Generera QR-kod",
            "await.waitForConfirmation": "V\xe4ntar p\xe5 bekr\xe4ftelse",
            "mbway.confirmPayment": "Bekr\xe4fta din betalning i appen MB WAY",
            "shopperEmail.invalid": "Ogiltig e-postadress",
            "dateOfBirth.format": "DD/MM/\xc5\xc5\xc5\xc5",
            "dateOfBirth.invalid": "Ange ett giltigt f\xf6delsedatum som visar att du \xe4r minst 18 \xe5r gammal",
            "blik.confirmPayment": "\xd6ppna din bankapp f\xf6r att bekr\xe4fta betalningen.",
            "blik.invalid": "Ange 6 siffror",
            "blik.code": "Sexsiffrig kod",
            "blik.help": "H\xe4mta koden fr\xe5n din bankapp.",
            "swish.pendingMessage": "N\xe4r du har skannat kan statusen vara v\xe4ntande i upp till tio minuter. Att f\xf6rs\xf6ka betala igen inom denna tid kan leda till flera debiteringar.",
            "field.valid": "F\xe4ltet \xe4r giltigt",
            "field.invalid": "F\xe4ltet ogiltigt",
            "error.va.gen.01": "Ofullst\xe4ndigt f\xe4lt",
            "error.va.gen.02": "F\xe4ltet ogiltigt",
            "error.va.sf-cc-num.01": "Ange ett giltigt kortnummer",
            "error.va.sf-cc-num.02": "Ange kortnumret",
            "error.va.sf-cc-num.03": "Ange ett kortm\xe4rke som st\xf6ds",
            "error.va.sf-cc-num.04": "Ange det fullst\xe4ndiga kortnumret",
            "error.va.sf-cc-dat.01": "Ange ett giltigt utg\xe5ngsdatum",
            "error.va.sf-cc-dat.02": "Ange ett giltigt utg\xe5ngsdatum",
            "error.va.sf-cc-dat.03": "Kreditkortet g\xe5r snart ut",
            "error.va.sf-cc-dat.04": "Ange utg\xe5ngsdatumet",
            "error.va.sf-cc-dat.05": "Ange det fullst\xe4ndiga utg\xe5ngsdatumet",
            "error.va.sf-cc-mth.01": "Ange utg\xe5ngsm\xe5naden",
            "error.va.sf-cc-yr.01": "Ange utg\xe5ngs\xe5ret",
            "error.va.sf-cc-yr.02": "Ange det fullst\xe4ndiga utg\xe5ngs\xe5ret",
            "error.va.sf-cc-cvc.01": "Ange s\xe4kerhetskoden",
            "error.va.sf-cc-cvc.02": "Ange den fullst\xe4ndiga s\xe4kerhetskoden",
            "error.va.sf-ach-num.01": "F\xe4ltet f\xf6r bankkontonummer \xe4r tomt",
            "error.va.sf-ach-num.02": "Bankkontonumret har fel l\xe4ngd",
            "error.va.sf-ach-loc.01": "F\xe4ltet f\xf6r clearingnummer \xe4r tomt",
            "error.va.sf-ach-loc.02": "Clearingnumret har fel l\xe4ngd",
            "error.va.sf-kcp-pwd.01": "F\xe4ltet f\xf6r l\xf6senord \xe4r tomt",
            "error.va.sf-kcp-pwd.02": "L\xf6senordet har fel l\xe4ngd",
            "error.giftcard.no-balance": "Saldot f\xf6r detta presentkort \xe4r noll",
            "error.giftcard.card-error": "Vi har inte registrerat n\xe5got presentkort med det numret",
            "error.giftcard.currency-error": "Presentkort \xe4r endast giltiga i den valuta som de utf\xe4rdades i",
            "amazonpay.signout": "Logga ut fr\xe5n Amazon",
            "amazonpay.changePaymentDetails": "\xc4ndra betalningsuppgifter",
            "partialPayment.warning": "V\xe4lj ett annat betalningss\xe4tt f\xf6r att betala det \xe5terst\xe5ende",
            "partialPayment.remainingBalance": "\xc5terst\xe5ende saldo blir %{amount}",
            "bankTransfer.beneficiary": "Mottagare",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "referens",
            "bankTransfer.introduction": "Forts\xe4tt f\xf6r att skapa en ny bank\xf6verf\xf6ring. Du kan anv\xe4nda informationen p\xe5 f\xf6ljande sk\xe4rm f\xf6r att slutf\xf6ra denna betalning.",
            "bankTransfer.instructions": "Tack f\xf6r ditt k\xf6p! Anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.",
            "bacs.accountHolderName": "Bankkontoinnehavarens namn",
            "bacs.accountHolderName.invalid": "Ogiltigt namn p\xe5 bankkontoinnehavare",
            "bacs.accountNumber": "Bankkontonummer",
            "bacs.accountNumber.invalid": "Ogiltigt bankkontonummer",
            "bacs.bankLocationId": "Clearingnummer",
            "bacs.bankLocationId.invalid": "Ogiltigt clearingnummer",
            "bacs.consent.amount": "Jag godk\xe4nner att ovanst\xe5ende belopp dras fr\xe5n mitt bankkonto.",
            "bacs.consent.account": "Jag bekr\xe4ftar att jag \xe4r kontoinnehavare och att jag \xe4r den enda person vars godk\xe4nnande kr\xe4vs f\xf6r att auktorisera autogiro fr\xe5n detta konto.",
            edit: "Redigera",
            "bacs.confirm": "Bekr\xe4fta och betala",
            "bacs.result.introduction": "Ladda ner din instruktion f\xf6r autogiro/direktdebitering (DDI / Mandate)",
            "download.pdf": "Ladda ner PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "Iframe f\xf6r kortnummer",
            "creditCard.encryptedCardNumber.aria.label": "Kortnummer",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "Iframe f\xf6r utg\xe5ngsdatum",
            "creditCard.encryptedExpiryDate.aria.label": "Utg\xe5ngsdatum",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "Iframe f\xf6r utg\xe5ngsm\xe5nad",
            "creditCard.encryptedExpiryMonth.aria.label": "Utg\xe5ngsm\xe5nad",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "Iframe f\xf6r utg\xe5ngs\xe5r",
            "creditCard.encryptedExpiryYear.aria.label": "Utg\xe5ngs\xe5r",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "Iframe f\xf6r s\xe4kerhetskod",
            "creditCard.encryptedSecurityCode.aria.label": "S\xe4kerhetskod",
            "creditCard.encryptedPassword.aria.iframeTitle": "Iframe f\xf6r l\xf6senord",
            "creditCard.encryptedPassword.aria.label": "De tv\xe5 f\xf6rsta siffrorna i kortets l\xf6senord",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "Iframe f\xf6r kortnummer",
            "giftcard.encryptedCardNumber.aria.label": "Kortnummer",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "Iframe f\xf6r PIN",
            "giftcard.encryptedSecurityCode.aria.label": "PIN-kod",
            giftcardTransactionLimit: "Maximalt %{amount} per transaktion \xe4r till\xe5tet p\xe5 detta presentkort",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "Iframe f\xf6r bankkontonummer",
            "ach.encryptedBankAccountNumber.aria.label": "Kontonummer",
            "ach.encryptedBankLocationId.aria.iframeTitle": "Iframe f\xf6r clearingnummer",
            "ach.encryptedBankLocationId.aria.label": "ABA-nummer",
            "twint.saved": "sparat",
            orPayWith: "eller betala med",
            invalidFormatExpects: "Ogiltigt format. F\xf6rv\xe4ntat format: %{format}",
            "upi.qrCodeWaitingMessage": "Skanna QR-koden med valfri UPI-app f\xf6r att slutf\xf6ra betalningen",
            "upi.vpaWaitingMessage": "\xd6ppna din UPI-app f\xf6r att bekr\xe4fta betalningen",
            "upi.modeSelection": "V\xe4lj hur du vill anv\xe4nda UPI.",
            "onlineBanking.termsAndConditions": "Genom att forts\xe4tta godk\xe4nner du %#villkoren%#",
            "onlineBankingPL.termsAndConditions": "Genom att forts\xe4tta godk\xe4nner du Przelewy24s %#regler%# och %#informationsplikt%#.",
            "ctp.loading.poweredByCtp": "Drivs av Click to Pay",
            "ctp.loading.intro": "Vi kontrollerar om du har n\xe5gra sparade kort med Click to Pay...",
            "ctp.login.title": "Forts\xe4tt till Click to Pay",
            "ctp.login.subtitle": "Ange den e-postadress som \xe4r ansluten till Click to Pay f\xf6r att forts\xe4tta.",
            "ctp.login.inputLabel": "E-postadress",
            "ctp.logout.notYou": "Inte du?",
            "ctp.logout.notYourCards": "Inte dina kort?",
            "ctp.logout.notYourCard": "Inte ditt kort?",
            "ctp.logout.notYourProfile": "Inte din profil?",
            "ctp.otp.fieldLabel": "Eng\xe5ngskod",
            "ctp.otp.resendCode": "Skicka koden igen",
            "ctp.otp.codeResent": "Koden skickad igen",
            "ctp.otp.title": "F\xe5 tillg\xe5ng till dina Click to Pay-kort",
            "ctp.otp.subtitle": "Ange koden som %@ skickade till %@ f\xf6r att verifiera att det \xe4r du.",
            "ctp.otp.saveCookiesCheckbox.label": "Hoppa \xf6ver verifieringen n\xe4sta g\xe5ng",
            "ctp.otp.saveCookiesCheckbox.information": "V\xe4lj att bli ih\xe5gkommen p\xe5 din enhet och webbl\xe4sare i deltagande butiker f\xf6r snabbare utcheckning. Rekommenderas inte f\xf6r delade enheter.",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "V\xe4lj att bli ih\xe5gkommen p\xe5 din enhet och i din webbl\xe4sare",
            "ctp.emptyProfile.message": "Inga kort registrerade i denna Click to Pay-profil",
            "ctp.separatorText": "eller anv\xe4nd",
            "ctp.cards.title": "Slutf\xf6r betalningen med Click to Pay",
            "ctp.cards.subtitle": "V\xe4lj ett kort att anv\xe4nda.",
            "ctp.cards.expiredCard": "Utg\xe5ngna",
            "ctp.manualCardEntry": "Manuell kortinmatning",
            "ctp.aria.infoModalButton": "Vad \xe4r Click to Pay?",
            "ctp.infoPopup.title": "Click to Pay \u2013 lika enkelt som kontaktl\xf6s betalning, fast online",
            "ctp.infoPopup.subtitle": "En snabb och s\xe4ker betalningsmetod som st\xf6ds av Mastercard, Visa och andra betalkort.",
            "ctp.infoPopup.benefit1": "Click to Pay anv\xe4nder kryptering f\xf6r att h\xe5lla din information s\xe4ker och trygg",
            "ctp.infoPopup.benefit2": "Anv\xe4nd den hos handlare \xf6ver hela v\xe4rlden",
            "ctp.infoPopup.benefit3": "Konfigurera en g\xe5ng f\xf6r problemfria betalningar i framtiden",
            "ctp.errors.AUTH_INVALID": "Autentisering ogiltig",
            "ctp.errors.NOT_FOUND": "Inget konto hittades, ange en giltig e-postadress eller forts\xe4tt med manuell kortinmatning",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "Formatet st\xf6ds inte",
            "ctp.errors.FRAUD": "Anv\xe4ndarkontot var l\xe5st eller inaktiverat",
            "ctp.errors.CONSUMER_ID_MISSING": "Konsumentidentitet saknas i beg\xe4ran",
            "ctp.errors.ACCT_INACCESSIBLE": "Det h\xe4r kontot \xe4r f\xf6r n\xe4rvarande inte tillg\xe4ngligt, det kanske \xe4r l\xe5st",
            "ctp.errors.CODE_INVALID": "Felaktig verifieringskod",
            "ctp.errors.CODE_EXPIRED": "Denna kod har g\xe5tt ut",
            "ctp.errors.RETRIES_EXCEEDED": "Gr\xe4nsen f\xf6r antalet f\xf6rs\xf6k till OTP-generering har \xf6verskridits",
            "ctp.errors.OTP_SEND_FAILED": "OTP kunde inte skickas till mottagaren",
            "ctp.errors.REQUEST_TIMEOUT": "N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd den manuella kortinmatningen",
            "ctp.errors.UNKNOWN_ERROR": "N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning",
            "ctp.errors.SERVICE_ERROR": "N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning",
            "ctp.errors.SERVER_ERROR": "N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning",
            "ctp.errors.INVALID_PARAMETER": "N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning",
            "ctp.errors.AUTH_ERROR": "N\xe5got gick fel, f\xf6rs\xf6k igen eller anv\xe4nd manuell kortinmatning",
            "paymentMethodsList.aria.label": "V\xe4lj en betalningsmetod",
            "companyDetails.name.invalid": "Ange f\xf6retagsnamnet",
            "companyDetails.registrationNumber.invalid": "Ange registreringsnumret",
            "consent.checkbox.invalid": "Du m\xe5ste godk\xe4nna villkoren",
            "form.instruction": "Alla f\xe4lt \xe4r obligatoriska om inte n\xe5got annat anges.",
            "trustly.descriptor": "Omedelbar bankbetalning",
            "ancv.input.label": "Din ANCV-identifiering",
            "ancv.confirmPayment": "Bekr\xe4fta betalningen i din ANCV-app.",
            "ancv.form.instruction": "Appen Cheque-Vacances kr\xe4vs f\xf6r att validera denna betalning.",
            "ancv.beneficiaryId.invalid": "Ange en giltig e-postadress eller ANCV-ID",
            "payme.openPayMeApp": "Slutf\xf6r din betalning i PayMe-appen genom att godk\xe4nna betalningen i appen och v\xe4nta p\xe5 bekr\xe4ftelse.",
            "payme.redirectButtonLabel": "\xd6ppna PayMe-appen",
            "payme.scanQrCode": "Slutf\xf6r din betalning med QR-kod",
            "payme.timeToPay": "Denna QR-kod \xe4r giltig i %@",
            "payme.instructions.steps": "\xd6ppna PayMe-appen.%@Skanna QR-koden f\xf6r att godk\xe4nna betalningen.%@Slutf\xf6r betalningen i appen och v\xe4nta p\xe5 bekr\xe4ftelse.",
            "payme.instructions.footnote": "St\xe4ng inte denna sida innan betalningen \xe4r slutf\xf6rd"
        }
    }), f2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "\u652F\u4ED8",
            "payButton.redirecting": "\u6B63\u5728\u91CD\u5B9A\u5411...",
            "payButton.with": "\u4F7F\u7528 %{maskedData} \u652F\u4ED8 %{value}",
            "payButton.saveDetails": "\u4FDD\u5B58\u8BE6\u60C5",
            close: "\u5173\u95ED",
            storeDetails: "\u4FDD\u5B58\u4EE5\u4FBF\u4E0B\u6B21\u652F\u4ED8\u4F7F\u7528",
            readMore: "\u9605\u8BFB\u66F4\u591A",
            "creditCard.holderName": "\u5361\u7247\u4E0A\u7684\u59D3\u540D",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "\u8F93\u5165\u5361\u7247\u4E0A\u663E\u793A\u7684\u59D3\u540D",
            "creditCard.numberField.title": "\u5361\u53F7",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "\u6709\u6548\u671F",
            "creditCard.expiryDateField.placeholder": "\u6708\u6708/\u5E74\u5E74",
            "creditCard.expiryDateField.month": "\u6708",
            "creditCard.expiryDateField.month.placeholder": "\u6708\u6708",
            "creditCard.expiryDateField.year.placeholder": "\u5E74\u5E74",
            "creditCard.expiryDateField.year": "\u5E74",
            "creditCard.cvcField.title": "\u5B89\u5168\u7801",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "\u8BB0\u4F4F\u4EE5\u4FBF\u4E0B\u6B21\u4F7F\u7528",
            "creditCard.cvcField.placeholder.4digits": "4 \u4F4D\u6570",
            "creditCard.cvcField.placeholder.3digits": "3 \u4F4D\u6570",
            "creditCard.taxNumber.placeholder": "\u5E74\u6708\u65E5 / 0123456789",
            installments: "\u5206\u671F\u4ED8\u6B3E\u671F\u6570",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} \u4E2A\u6708",
            "installments.oneTime": "\u5168\u6B3E\u652F\u4ED8",
            "installments.installments": "\u5206\u671F\u652F\u4ED8",
            "installments.revolving": "\u5FAA\u73AF\u652F\u4ED8",
            "sepaDirectDebit.ibanField.invalid": "\u65E0\u6548\u7684\u8D26\u53F7",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "\u6301\u5361\u4EBA\u59D3\u540D",
            "sepa.ibanNumber": "\u8D26\u53F7 (IBAN)",
            "error.title": "\u9519\u8BEF",
            "error.subtitle.redirect": "\u91CD\u5B9A\u5411\u5931\u8D25",
            "error.subtitle.payment": "\u652F\u4ED8\u5931\u8D25",
            "error.subtitle.refused": "\u652F\u4ED8\u88AB\u62D2",
            "error.message.unknown": "\u53D1\u751F\u672A\u77E5\u9519\u8BEF",
            "errorPanel.title": "\u73B0\u6709\u9519\u8BEF",
            "idealIssuer.selectField.title": "\u94F6\u884C",
            "idealIssuer.selectField.placeholder": "\u9009\u62E9\u60A8\u7684\u94F6\u884C",
            "creditCard.success": "\u652F\u4ED8\u6210\u529F",
            loading: "\u6B63\u5728\u52A0\u8F7D...",
            continue: "\u7EE7\u7EED",
            continueTo: "\u7EE7\u7EED\u81F3",
            "wechatpay.timetopay": "\u60A8\u9700\u8981\u652F\u4ED8 %@",
            "sr.wechatpay.timetopay": "\u60A8\u6709 %#\u5206%# %#\u79D2%# \u53EF\u4EE5\u652F\u4ED8",
            "wechatpay.scanqrcode": "\u626B\u63CF\u4E8C\u7EF4\u7801",
            personalDetails: "\u4E2A\u4EBA\u8BE6\u7EC6\u4FE1\u606F",
            companyDetails: "\u516C\u53F8\u8BE6\u60C5",
            "companyDetails.name": "\u516C\u53F8\u540D\u79F0",
            "companyDetails.registrationNumber": "\u6CE8\u518C\u53F7",
            socialSecurityNumber: "\u793E\u4F1A\u4FDD\u9669\u53F7\u7801",
            firstName: "\u540D\u5B57",
            "firstName.invalid": "\u8F93\u5165\u60A8\u7684\u540D\u5B57",
            infix: "\u524D\u7F00",
            lastName: "\u59D3\u6C0F",
            "lastName.invalid": "\u8F93\u5165\u60A8\u7684\u59D3\u6C0F",
            mobileNumber: "\u624B\u673A\u53F7",
            "mobileNumber.invalid": "\u65E0\u6548\u7684\u624B\u673A\u53F7\u7801",
            city: "\u57CE\u5E02",
            postalCode: "\u90AE\u653F\u7F16\u7801",
            "postalCode.optional": "\u90AE\u653F\u7F16\u7801\uFF08\u53EF\u9009\uFF09",
            countryCode: "\u56FD\u5BB6\u4EE3\u7801",
            telephoneNumber: "\u7535\u8BDD\u53F7\u7801",
            dateOfBirth: "\u51FA\u751F\u65E5\u671F",
            shopperEmail: "\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
            gender: "\u6027\u522B",
            "gender.notselected": "\u9009\u62E9\u60A8\u7684\u6027\u522B",
            male: "\u7537",
            female: "\u5973",
            billingAddress: "\u8D26\u5355\u5730\u5740",
            street: "\u8857\u9053",
            stateOrProvince: "\u5DDE\u6216\u7701",
            country: "\u56FD\u5BB6/\u5730\u533A",
            houseNumberOrName: "\u95E8\u724C\u53F7",
            separateDeliveryAddress: "\u6307\u5B9A\u4E00\u4E2A\u5355\u72EC\u7684\u5BC4\u9001\u5730\u5740",
            deliveryAddress: "\u5BC4\u9001\u5730\u5740",
            "deliveryAddress.firstName": "\u6536\u4EF6\u4EBA\u540D\u5B57",
            "deliveryAddress.lastName": "\u6536\u4EF6\u4EBA\u59D3\u6C0F",
            zipCode: "\u90AE\u653F\u7F16\u7801",
            apartmentSuite: "\u516C\u5BD3 / \u5957\u623F",
            provinceOrTerritory: "\u7701\u6216\u5730\u533A",
            cityTown: "\u5E02 / \u9547",
            address: "\u5730\u5740",
            "address.placeholder": "\u67E5\u627E\u60A8\u7684\u5730\u5740",
            "address.errors.incomplete": "\u8F93\u5165\u5730\u5740\u4EE5\u7EE7\u7EED",
            "address.enterManually": "\u624B\u52A8\u8F93\u5165\u5730\u5740",
            state: "\u5DDE",
            "field.title.optional": "\uFF08\u53EF\u9009\uFF09",
            "creditCard.cvcField.title.optional": "\u5B89\u5168\u7801\uFF08\u53EF\u9009\uFF09",
            "issuerList.wallet.placeholder": "\u9009\u62E9\u60A8\u7684\u94B1\u5305",
            privacyPolicy: "\u9690\u79C1\u653F\u7B56",
            "afterPay.agreement": "\u6211\u540C\u610F Riverty \u7684 %@",
            paymentConditions: "\u652F\u4ED8\u6761\u4EF6",
            openApp: "\u6253\u5F00\u5E94\u7528",
            "voucher.readInstructions": "\u9605\u8BFB\u8BF4\u660E",
            "voucher.introduction": "\u611F\u8C22\u60A8\u7684\u8D2D\u4E70\uFF0C\u8BF7\u4F7F\u7528\u4EE5\u4E0B\u4F18\u60E0\u5238\u5B8C\u6210\u652F\u4ED8\u3002",
            "voucher.expirationDate": "\u6709\u6548\u671F",
            "voucher.alternativeReference": "\u5907\u9009\u4EE3\u7801",
            "dragonpay.voucher.non.bank.selectField.placeholder": "\u9009\u62E9\u60A8\u7684\u63D0\u4F9B\u5546",
            "dragonpay.voucher.bank.selectField.placeholder": "\u9009\u62E9\u60A8\u7684\u94F6\u884C",
            "voucher.paymentReferenceLabel": "\u4EA4\u6613\u53F7",
            "voucher.surcharge": "\u5305\u62EC %@ \u7684\u9644\u52A0\u8D39",
            "voucher.introduction.doku": "\u611F\u8C22\u60A8\u7684\u8D2D\u4E70\uFF0C\u8BF7\u4F7F\u7528\u4EE5\u4E0B\u4FE1\u606F\u5B8C\u6210\u652F\u4ED8\u3002",
            "voucher.shopperName": "\u987E\u5BA2\u59D3\u540D",
            "voucher.merchantName": "\u5546\u6237",
            "voucher.introduction.econtext": "\u611F\u8C22\u60A8\u7684\u8D2D\u4E70\uFF0C\u8BF7\u4F7F\u7528\u4EE5\u4E0B\u4FE1\u606F\u5B8C\u6210\u652F\u4ED8\u3002",
            "voucher.telephoneNumber": "\u7535\u8BDD\u53F7\u7801",
            "voucher.shopperReference": "\u987E\u5BA2\u53C2\u8003",
            "voucher.collectionInstitutionNumber": "\u6536\u6B3E\u673A\u6784\u7F16\u53F7",
            "voucher.econtext.telephoneNumber.invalid": "\u7535\u8BDD\u53F7\u7801\u5FC5\u987B\u4E3A 10 \u6216 11 \u4F4D\u6570\u5B57",
            "boletobancario.btnLabel": "\u751F\u6210 Boleto",
            "boleto.sendCopyToEmail": "\u5C06\u526F\u672C\u53D1\u9001\u5230\u6211\u7684\u7535\u5B50\u90AE\u7BB1",
            "button.copy": "\u590D\u5236",
            "button.download": "\u4E0B\u8F7D",
            "boleto.socialSecurityNumber.invalid": "\u5B57\u6BB5\u65E0\u6548",
            "creditCard.storedCard.description.ariaLabel": "\u5B58\u50A8\u7684\u5361\u7247\u4EE5 \uFF05@ \u7ED3\u5C3E",
            "voucher.entity": "\u5B9E\u4F53",
            donateButton: "\u6350\u8D60",
            notNowButton: "\u6682\u4E0D",
            thanksForYourSupport: "\u611F\u8C22\u60A8\u7684\u652F\u6301\uFF01",
            "resultMessages.preauthorized": "\u8BE6\u60C5\u5DF2\u4FDD\u5B58",
            preauthorizeWith: "\u9884\u5148\u6388\u6743",
            confirmPreauthorization: "\u786E\u8BA4\u9884\u5148\u6388\u6743",
            confirmPurchase: "\u786E\u8BA4\u8D2D\u4E70",
            applyGiftcard: "\u5151\u6362",
            giftcardBalance: "\u793C\u54C1\u5361\u4F59\u989D",
            deductedBalance: "\u6263\u51CF\u4F59\u989D",
            "creditCard.pin.title": "Pin",
            "creditCard.encryptedPassword.label": "\u5361\u7247\u5BC6\u7801\u7684\u524D 2 \u4F4D\u6570",
            "creditCard.encryptedPassword.invalid": "\u65E0\u6548\u7684\u5BC6\u7801",
            "creditCard.taxNumber": "\u6301\u5361\u4EBA\u751F\u65E5\u6216\u516C\u53F8\u6CE8\u518C\u53F7",
            "creditCard.taxNumber.label": "\u6301\u5361\u4EBA\u751F\u65E5 (YYMMDD) \u6216\u516C\u53F8\u6CE8\u518C\u53F7\uFF0810 \u4F4D\u6570\uFF09",
            "creditCard.taxNumber.labelAlt": "\u516C\u53F8\u6CE8\u518C\u53F7\uFF0810 \u4F4D\u6570\uFF09",
            "creditCard.taxNumber.invalid": "\u65E0\u6548\u7684\u6301\u5361\u4EBA\u751F\u65E5\u6216\u516C\u53F8\u6CE8\u518C\u53F7",
            "storedPaymentMethod.disable.button": "\u5220\u9664",
            "storedPaymentMethod.disable.confirmation": "\u5220\u9664\u5B58\u50A8\u7684\u652F\u4ED8\u65B9\u5F0F",
            "storedPaymentMethod.disable.confirmButton": "\u662F\uFF0C\u5220\u9664",
            "storedPaymentMethod.disable.cancelButton": "\u53D6\u6D88",
            "ach.bankAccount": "\u94F6\u884C\u8D26\u6237",
            "ach.accountHolderNameField.title": "\u8D26\u6237\u6301\u6709\u4EBA\u59D3\u540D",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "\u65E0\u6548\u7684\u8D26\u6237\u6301\u6709\u4EBA\u59D3\u540D",
            "ach.accountNumberField.title": "\u8D26\u53F7",
            "ach.accountNumberField.invalid": "\u65E0\u6548\u7684\u8D26\u53F7",
            "ach.accountLocationField.title": "ABA \u8DEF\u7531\u7535\u6C47\u7F16\u7801",
            "ach.accountLocationField.invalid": "\u65E0\u6548\u7684 ABA \u8DEF\u7531\u7535\u6C47\u7F16\u7801",
            "ach.savedBankAccount": "\u5DF2\u4FDD\u5B58\u7684\u94F6\u884C\u8D26\u6237",
            "select.state": "\u9009\u62E9\u5DDE",
            "select.stateOrProvince": "\u9009\u62E9\u5DDE\u6216\u7701",
            "select.provinceOrTerritory": "\u9009\u62E9\u7701\u6216\u5730\u533A",
            "select.country": "\u9009\u62E9\u56FD\u5BB6/\u5730\u533A",
            "select.noOptionsFound": "\u672A\u627E\u5230\u4EFB\u4F55\u9009\u9879",
            "select.filter.placeholder": "\u641C\u7D22\u2026\u2026",
            "telephoneNumber.invalid": "\u65E0\u6548\u7684\u7535\u8BDD\u53F7\u7801",
            qrCodeOrApp: "\u6216\u8005",
            "paypal.processingPayment": "\u6B63\u5728\u5904\u7406\u4ED8\u6B3E...",
            generateQRCode: "\u751F\u6210\u4E8C\u7EF4\u7801",
            "await.waitForConfirmation": "\u7B49\u5F85\u786E\u8BA4",
            "mbway.confirmPayment": "\u5728 MB WAY \u5E94\u7528\u4E0A\u786E\u8BA4\u60A8\u7684\u4ED8\u6B3E",
            "shopperEmail.invalid": "\u65E0\u6548\u7684\u90AE\u4EF6\u5730\u5740",
            "dateOfBirth.format": "DD/MM/YYYY",
            "dateOfBirth.invalid": "\u8BF7\u8F93\u5165\u6709\u6548\u51FA\u751F\u65E5\u671F\uFF0C\u8868\u660E\u60A8\u5DF2\u5E74\u6EE1 18 \u5C81",
            "blik.confirmPayment": "\u6253\u5F00\u60A8\u7684\u94F6\u884C\u5E94\u7528\u4EE5\u786E\u8BA4\u652F\u4ED8\u3002",
            "blik.invalid": "\u8F93\u5165 6 \u4F4D\u6570",
            "blik.code": "6 \u4F4D\u6570\u4EE3\u7801",
            "blik.help": "\u4ECE\u60A8\u7684\u94F6\u884C\u5E94\u7528\u4E2D\u83B7\u53D6\u4EE3\u7801\u3002",
            "swish.pendingMessage": "\u626B\u63CF\u540E\uFF0C\u72B6\u6001\u53EF\u80FD\u4F1A\u4FDD\u6301\u6700\u591A 10 \u5206\u949F\u3002\u5728\u6B64\u65F6\u95F4\u5185\u518D\u6B21\u5C1D\u8BD5\u4ED8\u6B3E\u53EF\u80FD\u4F1A\u5BFC\u81F4\u591A\u6B21\u6536\u8D39\u3002",
            "field.valid": "\u5B57\u6BB5\u6709\u6548",
            "field.invalid": "\u65E0\u6548\u5B57\u6BB5",
            "error.va.gen.01": "\u4E0D\u5B8C\u6574\u5B57\u6BB5",
            "error.va.gen.02": "\u65E0\u6548\u5B57\u6BB5",
            "error.va.sf-cc-num.01": "\u8F93\u5165\u6709\u6548\u5361\u53F7",
            "error.va.sf-cc-num.02": "\u8F93\u5165\u5361\u53F7",
            "error.va.sf-cc-num.03": "\u8F93\u5165\u652F\u6301\u7684\u5361\u7247\u54C1\u724C",
            "error.va.sf-cc-num.04": "\u8F93\u5165\u5B8C\u6574\u5361\u53F7",
            "error.va.sf-cc-dat.01": "\u8F93\u5165\u6709\u6548\u5230\u671F\u65E5",
            "error.va.sf-cc-dat.02": "\u8F93\u5165\u6709\u6548\u5230\u671F\u65E5\u671F",
            "error.va.sf-cc-dat.03": "\u4FE1\u7528\u5361\u5373\u5C06\u8FC7\u671F",
            "error.va.sf-cc-dat.04": "\u8F93\u5165\u5230\u671F\u65E5\u671F",
            "error.va.sf-cc-dat.05": "\u8F93\u5165\u5B8C\u6574\u5230\u671F\u65E5\u671F",
            "error.va.sf-cc-mth.01": "\u8F93\u5165\u5230\u671F\u6708\u4EFD",
            "error.va.sf-cc-yr.01": "\u8F93\u5165\u5230\u671F\u5E74\u4EFD",
            "error.va.sf-cc-yr.02": "\u8F93\u5165\u5B8C\u6574\u5230\u671F\u5E74\u4EFD",
            "error.va.sf-cc-cvc.01": "\u8F93\u5165\u5B89\u5168\u7801",
            "error.va.sf-cc-cvc.02": "\u8F93\u5165\u5B8C\u6574\u5B89\u5168\u7801",
            "error.va.sf-ach-num.01": "\u94F6\u884C\u8D26\u53F7\u5B57\u6BB5\u4E3A\u7A7A",
            "error.va.sf-ach-num.02": "\u94F6\u884C\u8D26\u53F7\u957F\u5EA6\u4E0D\u6B63\u786E",
            "error.va.sf-ach-loc.01": "\u94F6\u884C\u8DEF\u7531\u53F7\u7801\u5B57\u6BB5\u4E3A\u7A7A",
            "error.va.sf-ach-loc.02": "\u94F6\u884C\u8DEF\u7531\u53F7\u7801\u957F\u5EA6\u4E0D\u6B63\u786E",
            "error.va.sf-kcp-pwd.01": "\u5BC6\u7801\u5B57\u6BB5\u4E3A\u7A7A",
            "error.va.sf-kcp-pwd.02": "\u5BC6\u7801\u957F\u5EA6\u4E0D\u6B63\u786E",
            "error.giftcard.no-balance": "\u793C\u54C1\u5361\u4F59\u989D\u4E3A\u96F6",
            "error.giftcard.card-error": "\u6211\u4EEC\u7684\u6570\u636E\u5E93\u4E2D\u6CA1\u6709\u8FD9\u4E2A\u53F7\u7801\u7684\u793C\u54C1\u5361",
            "error.giftcard.currency-error": "\u793C\u54C1\u5361\u4EC5\u4EE5\u5176\u53D1\u884C\u7684\u8D27\u5E01\u4E3A\u6709\u6548\u8D27\u5E01",
            "amazonpay.signout": "\u9000\u51FA Amazon",
            "amazonpay.changePaymentDetails": "\u66F4\u6539\u652F\u4ED8\u8BE6\u60C5",
            "partialPayment.warning": "\u8BF7\u9009\u62E9\u5176\u4ED6\u652F\u4ED8\u65B9\u5F0F\u652F\u4ED8\u5269\u4F59\u6B3E\u9879",
            "partialPayment.remainingBalance": "\u5269\u4F59\u989D\u5EA6\u4E3A %{amount}",
            "bankTransfer.beneficiary": "\u6536\u6B3E\u4EBA",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "\u4E2D\u56FD\u5DE5\u5546\u94F6\u884C",
            "bankTransfer.reference": "\u53C2\u8003",
            "bankTransfer.introduction": "\u7EE7\u7EED\u65B0\u5EFA\u94F6\u884C\u8F6C\u8D26\u4ED8\u6B3E\u3002\u60A8\u53EF\u4EE5\u4F7F\u7528\u4EE5\u4E0B\u5C4F\u5E55\u4E2D\u7684\u8BE6\u7EC6\u4FE1\u606F\u6765\u5B8C\u6210\u8FD9\u7B14\u4ED8\u6B3E\u3002",
            "bankTransfer.instructions": "\u611F\u8C22\u60A8\u7684\u8D2D\u4E70\uFF0C\u8BF7\u4F7F\u7528\u4EE5\u4E0B\u4FE1\u606F\u5B8C\u6210\u652F\u4ED8\u3002",
            "bacs.accountHolderName": "\u94F6\u884C\u8D26\u6237\u6301\u6709\u4EBA\u59D3\u540D",
            "bacs.accountHolderName.invalid": "\u65E0\u6548\u7684\u94F6\u884C\u8D26\u6237\u6301\u6709\u4EBA\u59D3\u540D",
            "bacs.accountNumber": "\u94F6\u884C\u8D26\u53F7",
            "bacs.accountNumber.invalid": "\u65E0\u6548\u7684\u94F6\u884C\u8D26\u53F7",
            "bacs.bankLocationId": "\u5206\u7C7B\u4EE3\u7801",
            "bacs.bankLocationId.invalid": "\u65E0\u6548\u7684\u5206\u7C7B\u4EE3\u7801",
            "bacs.consent.amount": "\u6211\u540C\u610F\u4ECE\u94F6\u884C\u8D26\u6237\u4E2D\u6263\u9664\u4E0A\u8FF0\u91D1\u989D\u3002",
            "bacs.consent.account": "\u6211\u786E\u8BA4\u8BE5\u8D26\u6237\u4E3A\u6211\u540D\u4E0B\u7684\u8D26\u6237\uFF0C\u5E76\u4E14\u6211\u662F\u6388\u6743\u8BE5\u8D26\u6237\u76F4\u63A5\u501F\u8BB0\u7684\u552F\u4E00\u7B7E\u7F72\u4EBA\u3002",
            edit: "\u7F16\u8F91",
            "bacs.confirm": "\u786E\u8BA4\u5E76\u652F\u4ED8",
            "bacs.result.introduction": "\u4E0B\u8F7D\u60A8\u7684\u76F4\u63A5\u501F\u8BB0\u6307\u793A\uFF08DDI/\u59D4\u6258\uFF09",
            "download.pdf": "\u4E0B\u8F7D PDF \u6587\u4EF6",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "\u5361\u53F7 Iframe",
            "creditCard.encryptedCardNumber.aria.label": "\u5361\u53F7",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "\u5230\u671F\u65E5\u671F Iframe",
            "creditCard.encryptedExpiryDate.aria.label": "\u6709\u6548\u671F",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "\u5230\u671F\u6708\u4EFD Iframe",
            "creditCard.encryptedExpiryMonth.aria.label": "\u8FC7\u671F\u6708\u4EFD",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "\u5230\u671F\u5E74\u4EFD Iframe",
            "creditCard.encryptedExpiryYear.aria.label": "\u8FC7\u671F\u5E74\u4EFD",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "\u5B89\u5168\u7801 Iframe",
            "creditCard.encryptedSecurityCode.aria.label": "\u5B89\u5168\u7801",
            "creditCard.encryptedPassword.aria.iframeTitle": "\u5BC6\u7801 Iframe",
            "creditCard.encryptedPassword.aria.label": "\u5361\u7247\u5BC6\u7801\u7684\u524D 2 \u4F4D\u6570",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "\u5361\u53F7 Iframe",
            "giftcard.encryptedCardNumber.aria.label": "\u5361\u53F7",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "PIN \u7801 Iframe",
            "giftcard.encryptedSecurityCode.aria.label": "Pin",
            giftcardTransactionLimit: "\u6B64\u793C\u54C1\u5361\u4E0A\u6BCF\u7B14\u4EA4\u6613\u5141\u8BB8\u7684\u6700\u5927\u91D1\u989D\u4E3A %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "\u94F6\u884C\u8D26\u53F7 Iframe",
            "ach.encryptedBankAccountNumber.aria.label": "\u8D26\u53F7",
            "ach.encryptedBankLocationId.aria.iframeTitle": "\u94F6\u884C\u8DEF\u7531\u7535\u6C47\u7F16\u7801 Iframe",
            "ach.encryptedBankLocationId.aria.label": "ABA \u8DEF\u7531\u7535\u6C47\u7F16\u7801",
            "twint.saved": "\u5DF2\u4FDD\u5B58",
            orPayWith: "\u6216\u4F7F\u7528\u4EE5\u4E0B\u65B9\u5F0F\u652F\u4ED8",
            invalidFormatExpects: "\u65E0\u6548\u7684\u683C\u5F0F\u3002\u9884\u671F\u683C\u5F0F\uFF1A%{format}",
            "upi.qrCodeWaitingMessage": "\u4F7F\u7528\u60A8\u9996\u9009\u7684 UPI \u5E94\u7528\u626B\u63CF\u4E8C\u7EF4\u7801\u4EE5\u5B8C\u6210\u4ED8\u6B3E",
            "upi.vpaWaitingMessage": "\u6253\u5F00\u60A8\u7684 UPI \u5E94\u7528\u4EE5\u786E\u8BA4\u4ED8\u6B3E",
            "upi.modeSelection": "\u8BF7\u9009\u62E9\u60A8\u5E0C\u671B\u5982\u4F55\u4F7F\u7528 UPI\u3002",
            "onlineBanking.termsAndConditions": "\u7EE7\u7EED\uFF0C\u5373\u8868\u793A\u60A8\u540C\u610F%#\u6761\u6B3E\u548C\u7EC6\u5219%#",
            "onlineBankingPL.termsAndConditions": "\u7EE7\u7EED\u5373\u8868\u793A\u60A8\u540C\u610F Przelewy24 \u7684%#\u6761\u4F8B%#\u548C%#\u4FE1\u606F\u4E49\u52A1%#",
            "ctp.loading.poweredByCtp": "\u7531 Click to Pay \u63D0\u4F9B\u6280\u672F\u652F\u6301",
            "ctp.loading.intro": "\u6211\u4EEC\u6B63\u5728\u68C0\u67E5\u60A8\u662F\u5426\u62E5\u6709\u4EFB\u4F55\u901A\u8FC7 Click to Pay \u4FDD\u5B58\u7684\u5361\u7247\u2026",
            "ctp.login.title": "\u7EE7\u7EED\u4F7F\u7528 Click to Pay \u529F\u80FD",
            "ctp.login.subtitle": "\u8F93\u5165\u5173\u8054\u81F3 Click to Pay \u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u4EE5\u7EE7\u7EED\u3002",
            "ctp.login.inputLabel": "\u7535\u5B50\u90AE\u4EF6",
            "ctp.logout.notYou": "\u4E0D\u662F\u60A8\u672C\u4EBA\uFF1F",
            "ctp.logout.notYourCards": "\u4E0D\u662F\u60A8\u7684\u5361\uFF1F",
            "ctp.logout.notYourCard": "\u4E0D\u662F\u60A8\u7684\u5361\u7247\uFF1F",
            "ctp.logout.notYourProfile": "\u4E0D\u662F\u60A8\u7684\u4E2A\u4EBA\u8D44\u6599\uFF1F",
            "ctp.otp.fieldLabel": "\u4E00\u6B21\u6027\u4EE3\u7801",
            "ctp.otp.resendCode": "\u91CD\u65B0\u53D1\u9001\u4EE3\u7801",
            "ctp.otp.codeResent": "\u4EE3\u7801\u5DF2\u91CD\u65B0\u53D1\u9001",
            "ctp.otp.title": "\u8BBF\u95EE\u60A8\u7684 Click to Pay \u5361",
            "ctp.otp.subtitle": "\u8BF7\u8F93\u5165\u6211\u4EEC\u53D1\u9001\u81F3 %@ \u7684\u4EE3\u7801 (%@)\uFF0C\u4EE5\u9A8C\u8BC1\u662F\u60A8\u672C\u4EBA\u3002",
            "ctp.otp.saveCookiesCheckbox.label": "\u4E0B\u6B21\u8DF3\u8FC7\u9A8C\u8BC1",
            "ctp.otp.saveCookiesCheckbox.information": "\u5728\u60A8\u7684\u8BBE\u5907\u548C\u6D4F\u89C8\u5668\u4E0A\uFF0C\u5728\u53C2\u4E0E\u6D3B\u52A8\u7684\u5E97\u94FA\u4E2D\u9009\u62E9\u8BB0\u4F4F\u8BE5\u9009\u9879\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u7ED3\u8D26\u3002\u4E0D\u5EFA\u8BAE\u7528\u4E8E\u5171\u4EAB\u8BBE\u5907\u3002",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "\u9009\u62E9\u5728\u60A8\u7684\u8BBE\u5907\u548C\u6D4F\u89C8\u5668\u4E0A\u8BB0\u4F4F",
            "ctp.emptyProfile.message": "\u6B64 Click to Pay \u4E2A\u4EBA\u8D44\u6599\u4E2D\u5C1A\u672A\u6CE8\u518C\u4EFB\u4F55\u5361\u7247",
            "ctp.separatorText": "\u6216\u4F7F\u7528",
            "ctp.cards.title": "\u501F\u52A9 Click to Pay \u5B8C\u6210\u4ED8\u6B3E",
            "ctp.cards.subtitle": "\u9009\u62E9\u8981\u4F7F\u7528\u7684\u5361\u7247\u3002",
            "ctp.cards.expiredCard": "\u5DF2\u8FC7\u671F",
            "ctp.manualCardEntry": "\u624B\u52A8\u5361\u7247\u5F55\u5165",
            "ctp.aria.infoModalButton": "\u4EC0\u4E48\u662F Click to Pay",
            "ctp.infoPopup.title": "Click to Pay \u5E26\u6765\u975E\u63A5\u89E6\u5F0F\u7684\u5728\u7EBF\u4FBF\u6377\u4F53\u9A8C",
            "ctp.infoPopup.subtitle": "Mastercard\u3001Visa \u548C\u5176\u4ED6\u652F\u4ED8\u5361\u652F\u6301\u7684\u5FEB\u901F\u3001\u5B89\u5168\u7684\u652F\u4ED8\u65B9\u5F0F\u3002",
            "ctp.infoPopup.benefit1": "Click to Pay \u4F7F\u7528\u52A0\u5BC6\u6280\u672F\uFF0C\u786E\u4FDD\u60A8\u7684\u4FE1\u606F\u5B89\u5168",
            "ctp.infoPopup.benefit2": "\u4E0E\u5168\u7403\u5546\u6237\u4E00\u8D77\u4F7F\u7528",
            "ctp.infoPopup.benefit3": "\u8BBE\u7F6E\u4E00\u6B21\uFF0C\u652F\u4ED8\u65E0\u5FE7",
            "ctp.errors.AUTH_INVALID": "\u8EAB\u4EFD\u9A8C\u8BC1\u65E0\u6548",
            "ctp.errors.NOT_FOUND": "\u672A\u627E\u5230\u5E10\u6237\uFF0C\u8BF7\u8F93\u5165\u6709\u6548\u7684\u7535\u5B50\u90AE\u4EF6\u6216\u7EE7\u7EED\u4F7F\u7528\u624B\u52A8\u5361\u7247\u8F93\u5165",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "\u4E0D\u652F\u6301\u683C\u5F0F",
            "ctp.errors.FRAUD": "\u7528\u6237\u8D26\u6237\u5DF2\u9501\u5B9A\u6216\u7981\u7528",
            "ctp.errors.CONSUMER_ID_MISSING": "\u8BF7\u6C42\u4E2D\u7F3A\u5C11\u4F7F\u7528\u8005\u6807\u8BC6",
            "ctp.errors.ACCT_INACCESSIBLE": "\u6B64\u5E10\u6237\u5F53\u524D\u4E0D\u53EF\u7528\uFF08\u4F8B\u5982\uFF0C\u5DF2\u9501\u5B9A\uFF09",
            "ctp.errors.CODE_INVALID": "\u9A8C\u8BC1\u7801\u4E0D\u6B63\u786E",
            "ctp.errors.CODE_EXPIRED": "\u6B64\u4EE3\u7801\u5DF2\u8FC7\u671F",
            "ctp.errors.RETRIES_EXCEEDED": "\u5DF2\u8D85\u51FA OTP \u751F\u6210\u7684\u91CD\u8BD5\u6B21\u6570\u9650\u5236",
            "ctp.errors.OTP_SEND_FAILED": "OTP \u65E0\u6CD5\u53D1\u9001\u81F3\u6536\u4EF6\u4EBA",
            "ctp.errors.REQUEST_TIMEOUT": "\u53D1\u751F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5\u6216\u4F7F\u7528\u624B\u52A8\u5361\u7247\u8F93\u5165",
            "ctp.errors.UNKNOWN_ERROR": "\u53D1\u751F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5\u6216\u4F7F\u7528\u624B\u52A8\u5361\u7247\u8F93\u5165",
            "ctp.errors.SERVICE_ERROR": "\u53D1\u751F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5\u6216\u4F7F\u7528\u624B\u52A8\u5361\u7247\u8F93\u5165",
            "ctp.errors.SERVER_ERROR": "\u53D1\u751F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5\u6216\u4F7F\u7528\u624B\u52A8\u5361\u7247\u8F93\u5165",
            "ctp.errors.INVALID_PARAMETER": "\u53D1\u751F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5\u6216\u4F7F\u7528\u624B\u52A8\u5361\u7247\u8F93\u5165",
            "ctp.errors.AUTH_ERROR": "\u53D1\u751F\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5\u6216\u4F7F\u7528\u624B\u52A8\u5361\u7247\u8F93\u5165",
            "paymentMethodsList.aria.label": "\u9009\u62E9\u652F\u4ED8\u65B9\u5F0F",
            "companyDetails.name.invalid": "\u8F93\u5165\u516C\u53F8\u540D\u79F0",
            "companyDetails.registrationNumber.invalid": "\u8F93\u5165\u6CE8\u518C\u53F7",
            "consent.checkbox.invalid": "\u60A8\u5FC5\u987B\u540C\u610F\u6761\u6B3E\u548C\u7EC6\u5219",
            "form.instruction": "\u9664\u975E\u53E6\u6709\u6807\u8BB0\uFF0C\u5426\u5219\u6240\u6709\u5B57\u6BB5\u5747\u4E3A\u5FC5\u586B\u9879\u3002",
            "trustly.descriptor": "\u5373\u65F6\u94F6\u884C\u4ED8\u6B3E",
            "trustly.description1": "\u76F4\u63A5\u4ECE\u60A8\u7684\u4EFB\u4F55\u94F6\u884C\u8D26\u6237\u4ED8\u6B3E\uFF0C\u5E76\u914D\u5907\u94F6\u884C\u7EA7\u5B89\u5168\u4FDD\u969C",
            "trustly.description2": "\u65E0\u9700\u5361\u7247\uFF0C\u65E0\u9700\u4E0B\u8F7D\u5E94\u7528\uFF0C\u65E0\u9700\u6CE8\u518C",
            "ancv.input.label": "\u60A8\u7684 ANCV \u8EAB\u4EFD\u8BC1\u660E",
            "ancv.confirmPayment": "\u4F7F\u7528\u60A8\u7684 ANCV \u5E94\u7528\u4EE5\u786E\u8BA4\u4ED8\u6B3E\u3002",
            "ancv.form.instruction": "\u8981\u9A8C\u8BC1\u8FD9\u7B14\u4ED8\u6B3E\uFF0C\u5FC5\u987B\u4F7F\u7528 Checke-Vacances \u5E94\u7528\u3002",
            "ancv.beneficiaryId.invalid": "\u8F93\u5165\u6709\u6548\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u6216 ANCV ID",
            "payme.openPayMeApp": "\u5728 PayMe \u5E94\u7528\u4E2D\u6388\u6743\u4ED8\u6B3E\u5E76\u7B49\u5F85\u786E\u8BA4\uFF0C\u5373\u53EF\u5B8C\u6210\u60A8\u5728\u8BE5\u5E94\u7528\u4E2D\u7684\u4ED8\u6B3E\u3002",
            "payme.redirectButtonLabel": "\u6253\u5F00 PayMe \u5E94\u7528",
            "payme.scanQrCode": "\u901A\u8FC7\u4E8C\u7EF4\u7801\u5B8C\u6210\u4ED8\u6B3E",
            "payme.timeToPay": "\u6B64\u4E8C\u7EF4\u7801\u6709\u6548\u671F\u4E3A %@",
            "payme.instructions.steps": "\u6253\u5F00 PayMe \u5E94\u7528\u3002%@\u626B\u63CF\u4E8C\u7EF4\u7801\u5373\u53EF\u6388\u6743\u4ED8\u6B3E\u3002%@\u5728\u5E94\u7528\u4E2D\u5B8C\u6210\u652F\u4ED8\u5E76\u7B49\u5F85\u786E\u8BA4\u3002",
            "payme.instructions.footnote": "\u4ED8\u6B3E\u5B8C\u6210\u524D\uFF0C\u8BF7\u52FF\u5173\u95ED\u6B64\u9875\u9762"
        }
    }), h2 = Object.freeze({
        __proto__: null,
        default: {
            payButton: "\u652F\u4ED8",
            "payButton.redirecting": "\u91CD\u65B0\u5C0E\u5411\u4E2D......",
            "payButton.with": "\u7528 %{maskedData} \u652F\u4ED8 %{value}",
            "payButton.saveDetails": "\u5132\u5B58\u8A73\u7D30\u8CC7\u6599",
            close: "\u95DC\u9589",
            storeDetails: "\u5132\u5B58\u4EE5\u4F9B\u4E0B\u6B21\u4ED8\u6B3E\u4F7F\u7528",
            readMore: "\u95B1\u8B80\u5168\u6587",
            "creditCard.holderName": "\u4FE1\u7528\u5361\u4E0A\u7684\u59D3\u540D",
            "creditCard.holderName.placeholder": "J. Smith",
            "creditCard.holderName.invalid": "\u8F38\u5165\u5361\u4E0A\u6240\u793A\u7684\u59D3\u540D",
            "creditCard.numberField.title": "\u4FE1\u7528\u5361\u865F\u78BC",
            "creditCard.numberField.placeholder": "1234 5678 9012 3456",
            "creditCard.expiryDateField.title": "\u5230\u671F\u65E5\u671F",
            "creditCard.expiryDateField.placeholder": "MM/YY",
            "creditCard.expiryDateField.month": "\u6708\u4EFD",
            "creditCard.expiryDateField.month.placeholder": "MM",
            "creditCard.expiryDateField.year.placeholder": "YY",
            "creditCard.expiryDateField.year": "\u5E74\u4EFD",
            "creditCard.cvcField.title": "\u5B89\u5168\u78BC",
            "creditCard.cvcField.placeholder": "123",
            "creditCard.storeDetailsButton": "\u8A18\u4F4F\u4F9B\u4E0B\u6B21\u4F7F\u7528",
            "creditCard.cvcField.placeholder.4digits": "4 \u4F4D\u6578",
            "creditCard.cvcField.placeholder.3digits": "3 \u4F4D\u6578",
            "creditCard.taxNumber.placeholder": "\u5E74\u6708\u65E5\uFF0F0123456789",
            installments: "\u5206\u671F\u4ED8\u6B3E\u7684\u671F\u6578",
            installmentOption: "%{times}x %{partialValue}",
            installmentOptionMonths: "%{times} \u500B\u6708",
            "installments.oneTime": "\u4E00\u6B21\u6027\u4ED8\u6B3E",
            "installments.installments": "\u5206\u671F\u4ED8\u6B3E",
            "installments.revolving": "\u5EF6\u671F\u4ED8\u6B3E",
            "sepaDirectDebit.ibanField.invalid": "\u5E33\u6236\u865F\u78BC\u7121\u6548",
            "sepaDirectDebit.nameField.placeholder": "J. Smith",
            "sepa.ownerName": "\u6301\u6709\u4EBA\u540D\u7A31",
            "sepa.ibanNumber": "\u5E33\u6236\u865F\u78BC (IBAN)",
            "error.title": "\u932F\u8AA4",
            "error.subtitle.redirect": "\u7121\u6CD5\u91CD\u65B0\u5C0E\u5411",
            "error.subtitle.payment": "\u4ED8\u6B3E\u5931\u6557",
            "error.subtitle.refused": "\u4ED8\u6B3E\u906D\u62D2\u7D55",
            "error.message.unknown": "\u767C\u751F\u672A\u77E5\u932F\u8AA4",
            "errorPanel.title": "\u73FE\u6709\u932F\u8AA4",
            "idealIssuer.selectField.title": "\u9280\u884C",
            "idealIssuer.selectField.placeholder": "\u9078\u53D6\u60A8\u7684\u9280\u884C",
            "creditCard.success": "\u4ED8\u6B3E\u6210\u529F",
            loading: "\u6B63\u5728\u8F09\u5165...",
            continue: "\u7E7C\u7E8C",
            continueTo: "\u7E7C\u7E8C\u524D\u5F80",
            "wechatpay.timetopay": "\u60A8\u6709 %@ \u53EF\u4EE5\u652F\u4ED8",
            "sr.wechatpay.timetopay": "\u60A8\u4ED8\u6B3E\u7684\u6642\u9593\u9084\u5269 %#\u5206%# %#\u79D2%#",
            "wechatpay.scanqrcode": "\u6383\u63CF QR \u4EE3\u78BC",
            personalDetails: "\u500B\u4EBA\u8A73\u7D30\u8CC7\u6599",
            companyDetails: "\u516C\u53F8\u8A73\u60C5",
            "companyDetails.name": "\u516C\u53F8\u540D\u7A31",
            "companyDetails.registrationNumber": "\u8A3B\u518A\u865F\u78BC",
            socialSecurityNumber: "\u793E\u6703\u5B89\u5168\u78BC",
            firstName: "\u540D\u5B57",
            "firstName.invalid": "\u8F38\u5165\u60A8\u7684\u540D\u5B57",
            infix: "\u524D\u7DB4",
            lastName: "\u59D3\u6C0F",
            "lastName.invalid": "\u8F38\u5165\u60A8\u7684\u59D3\u6C0F",
            mobileNumber: "\u884C\u52D5\u96FB\u8A71\u865F\u78BC",
            "mobileNumber.invalid": "\u624B\u6A5F\u865F\u78BC\u7121\u6548",
            city: "\u57CE\u5E02",
            postalCode: "\u90F5\u905E\u5340\u865F",
            "postalCode.optional": "\u90F5\u905E\u5340\u865F\uFF08\u9078\u7528\uFF09",
            countryCode: "\u570B\u5BB6\u4EE3\u78BC",
            telephoneNumber: "\u96FB\u8A71\u865F\u78BC",
            dateOfBirth: "\u51FA\u751F\u65E5\u671F",
            shopperEmail: "\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
            gender: "\u6027\u5225",
            "gender.notselected": "\u9078\u64C7\u60A8\u7684\u6027\u5225",
            male: "\u7537",
            female: "\u5973",
            billingAddress: "\u5E33\u55AE\u5730\u5740",
            street: "\u8857\u9053",
            stateOrProvince: "\u5DDE/\u7E23/\u5E02",
            country: "\u570B\u5BB6/\u5730\u5340",
            houseNumberOrName: "\u9580\u724C\u865F",
            separateDeliveryAddress: "\u6307\u5B9A\u53E6\u4E00\u500B\u6D3E\u9001\u5730\u5740",
            deliveryAddress: "\u6D3E\u9001\u5730\u5740",
            "deliveryAddress.firstName": "\u6536\u4EF6\u8005\u540D\u5B57",
            "deliveryAddress.lastName": "\u6536\u4EF6\u8005\u59D3\u6C0F",
            zipCode: "\u90F5\u905E\u5340\u865F",
            apartmentSuite: "\u516C\u5BD3\uFF0F\u5957\u623F",
            provinceOrTerritory: "\u7701\u6216\u5730\u5340",
            cityTown: "\u5E02\uFF0F\u93AE",
            address: "\u5730\u5740",
            "address.placeholder": "\u67E5\u627E\u60A8\u7684\u5730\u5740",
            "address.errors.incomplete": "\u8F38\u5165\u5730\u5740\u4EE5\u7E7C\u7E8C",
            "address.enterManually": "\u624B\u52D5\u8F38\u5165\u5730\u5740",
            state: "\u5DDE",
            "field.title.optional": "\uFF08\u9078\u7528\uFF09",
            "creditCard.cvcField.title.optional": "\u5B89\u5168\u78BC\uFF08\u9078\u586B\uFF09",
            "issuerList.wallet.placeholder": "\u9078\u53D6\u60A8\u7684\u96FB\u5B50\u9322\u5305",
            privacyPolicy: "\u96B1\u79C1\u6B0A\u653F\u7B56",
            "afterPay.agreement": "\u6211\u540C\u610F Riverty \u7684%@",
            paymentConditions: "\u4ED8\u6B3E\u7D30\u5247",
            openApp: "\u958B\u555F\u61C9\u7528\u7A0B\u5F0F",
            "voucher.readInstructions": "\u95B1\u89BD\u8AAA\u660E",
            "voucher.introduction": "\u591A\u8B1D\u60E0\u9867\uFF0C\u8ACB\u4F7F\u7528\u4EE5\u4E0B\u512A\u60E0\u5238\u5B8C\u6210\u4ED8\u6B3E\u3002",
            "voucher.expirationDate": "\u5230\u671F\u65E5\u671F",
            "voucher.alternativeReference": "\u5099\u9078\u53C3\u7167",
            "dragonpay.voucher.non.bank.selectField.placeholder": "\u9078\u64C7\u60A8\u7684\u4F9B\u61C9\u5546",
            "dragonpay.voucher.bank.selectField.placeholder": "\u9078\u53D6\u60A8\u7684\u9280\u884C",
            "voucher.paymentReferenceLabel": "\u4ED8\u6B3E\u53C3\u7167\u865F\u78BC",
            "voucher.surcharge": "\u5305\u542B %@ \u9644\u52A0\u8CBB",
            "voucher.introduction.doku": "\u591A\u8B1D\u60E0\u9867\uFF0C\u8ACB\u4F7F\u7528\u4EE5\u4E0B\u8CC7\u8A0A\u5B8C\u6210\u4ED8\u6B3E\u3002",
            "voucher.shopperName": "\u8CFC\u7269\u8005\u59D3\u540D",
            "voucher.merchantName": "\u5546\u5BB6",
            "voucher.introduction.econtext": "\u591A\u8B1D\u60E0\u9867\uFF0C\u8ACB\u4F7F\u7528\u4EE5\u4E0B\u8CC7\u8A0A\u5B8C\u6210\u4ED8\u6B3E\u3002",
            "voucher.telephoneNumber": "\u96FB\u8A71\u865F\u78BC",
            "voucher.shopperReference": "\u8CFC\u7269\u8005\u53C3\u8003",
            "voucher.collectionInstitutionNumber": "\u6536\u6B3E\u6A5F\u69CB\u7DE8\u865F",
            "voucher.econtext.telephoneNumber.invalid": "\u96FB\u8A71\u865F\u78BC\u7684\u9577\u5EA6\u5FC5\u9808\u70BA 10 \u6216 11 \u4F4D\u6578",
            "boletobancario.btnLabel": "\u7522\u751F Boleto",
            "boleto.sendCopyToEmail": "\u5C07\u8907\u672C\u50B3\u9001\u81F3\u6211\u7684\u96FB\u5B50\u90F5\u4EF6",
            "button.copy": "\u8907\u88FD",
            "button.download": "\u4E0B\u8F09",
            "boleto.socialSecurityNumber.invalid": "\u6B04\u4F4D\u7121\u6548",
            "creditCard.storedCard.description.ariaLabel": "\u5DF2\u5132\u5B58\u4EE5 %@ \u7D50\u5C3E\u7684\u4FE1\u7528\u5361",
            "voucher.entity": "\u5BE6\u9AD4",
            donateButton: "\u6350\u8D08",
            notNowButton: "\u7A0D\u5F8C\u518D\u8AAA",
            thanksForYourSupport: "\u611F\u8B1D\u60A8\u7684\u652F\u6301\uFF01",
            "resultMessages.preauthorized": "\u5DF2\u5132\u5B58\u8A73\u7D30\u8CC7\u6599",
            preauthorizeWith: "\u900F\u904E\u4EE5\u4E0B\u65B9\u5F0F\u9032\u884C\u9810\u5148\u6388\u6B0A\uFF1A",
            confirmPreauthorization: "\u78BA\u8A8D\u9810\u5148\u6388\u6B0A",
            confirmPurchase: "\u78BA\u8A8D\u8CFC\u8CB7",
            applyGiftcard: "\u514C\u63DB",
            giftcardBalance: "\u79AE\u54C1\u5361\u9918\u984D",
            deductedBalance: "\u6263\u9664\u9918\u984D",
            "creditCard.pin.title": "\u6578\u5B57\u5BC6\u78BC",
            "creditCard.encryptedPassword.label": "\u5361\u5BC6\u78BC\u7684\u524D 2 \u4F4D\u6578\u5B57",
            "creditCard.encryptedPassword.placeholder": "12",
            "creditCard.encryptedPassword.invalid": "\u5BC6\u78BC\u7121\u6548",
            "creditCard.taxNumber": "\u6301\u5361\u4EBA\u751F\u65E5\u6216\u516C\u53F8\u8A3B\u518A\u865F\u78BC",
            "creditCard.taxNumber.label": "\u6301\u5361\u4EBA\u751F\u65E5\uFF08\u5E74\u6708\u65E5\uFF09\u6216\u516C\u53F8\u8A3B\u518A\u865F\u78BC\uFF0810 \u4F4D\u6578\uFF09",
            "creditCard.taxNumber.labelAlt": "\u516C\u53F8\u8A3B\u518A\u865F\u78BC\uFF0810 \u4F4D\u6578\uFF09",
            "creditCard.taxNumber.invalid": "\u6301\u5361\u4EBA\u751F\u65E5\u6216\u516C\u53F8\u8A3B\u518A\u865F\u78BC\u7121\u6548",
            "storedPaymentMethod.disable.button": "\u79FB\u9664",
            "storedPaymentMethod.disable.confirmation": "\u79FB\u9664\u5DF2\u5132\u5B58\u4ED8\u6B3E\u65B9\u5F0F",
            "storedPaymentMethod.disable.confirmButton": "\u662F\uFF0C\u8ACB\u79FB\u9664",
            "storedPaymentMethod.disable.cancelButton": "\u53D6\u6D88",
            "ach.bankAccount": "\u9280\u884C\u5E33\u6236",
            "ach.accountHolderNameField.title": "\u5E33\u6236\u6301\u6709\u4EBA\u59D3\u540D",
            "ach.accountHolderNameField.placeholder": "J. Smith",
            "ach.accountHolderNameField.invalid": "\u5E33\u6236\u6301\u6709\u4EBA\u59D3\u540D\u7121\u6548",
            "ach.accountNumberField.title": "\u5E33\u6236\u865F\u78BC",
            "ach.accountNumberField.invalid": "\u5E33\u6236\u865F\u78BC\u7121\u6548",
            "ach.accountLocationField.title": "ABA \u532F\u6B3E\u8DEF\u5F91\u7DE8\u865F",
            "ach.accountLocationField.invalid": "ABA \u532F\u6B3E\u8DEF\u5F91\u7DE8\u865F\u7121\u6548",
            "ach.savedBankAccount": "\u5132\u5B58\u7684\u9280\u884C\u5E33\u6236",
            "select.state": "\u9078\u53D6\u5DDE",
            "select.stateOrProvince": "\u9078\u64C7\u5DDE\u6216\u7701",
            "select.provinceOrTerritory": "\u9078\u53D6\u7701\u6216\u5730\u5340",
            "select.country": "\u9078\u64C7\u570B\u5BB6\uFF0F\u5730\u5340",
            "select.noOptionsFound": "\u627E\u4E0D\u5230\u4EFB\u4F55\u9078\u9805",
            "select.filter.placeholder": "\u641C\u5C0B\u2026\u2026",
            "telephoneNumber.invalid": "\u96FB\u8A71\u865F\u78BC\u7121\u6548",
            qrCodeOrApp: "\u6216",
            "paypal.processingPayment": "\u6B63\u5728\u8655\u7406\u4ED8\u6B3E\u2026\u2026",
            generateQRCode: "\u7522\u751F QR \u4EE3\u78BC",
            "await.waitForConfirmation": "\u6B63\u5728\u7B49\u5019\u78BA\u8A8D",
            "mbway.confirmPayment": "\u5728 MB WAY \u61C9\u7528\u7A0B\u5F0F\u4E0A\u78BA\u8A8D\u60A8\u7684\u4ED8\u6B3E",
            "shopperEmail.invalid": "\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u7121\u6548",
            "dateOfBirth.format": "\u65E5\uFF0F\u6708\uFF0F\u5E74",
            "dateOfBirth.invalid": "\u8F38\u5165\u8868\u660E\u60A8\u81F3\u5C11\u5E74\u6EFF 18 \u6B72\u7684\u6709\u6548\u51FA\u751F\u65E5\u671F",
            "blik.confirmPayment": "\u958B\u555F\u60A8\u7684\u9280\u884C\u61C9\u7528\u7A0B\u5F0F\u4EE5\u78BA\u8A8D\u4ED8\u6B3E\u3002",
            "blik.invalid": "\u8F38\u5165 6 \u500B\u6578\u5B57",
            "blik.code": "6 \u4F4D\u6578\u4EE3\u78BC",
            "blik.help": "\u5F9E\u60A8\u7684\u9280\u884C\u61C9\u7528\u7A0B\u5F0F\u4E2D\u7372\u53D6\u4EE3\u78BC\u3002",
            "swish.pendingMessage": "\u6383\u63CF\u5F8C\uFF0C\u8A72\u5F85\u5B8C\u6210\u72C0\u614B\u53EF\u80FD\u6301\u7E8C\u9577\u9054 10 \u5206\u9418\u3002\u8A66\u5716\u5728\u9019\u6BB5\u6642\u9593\u5167\u518D\u6B21\u4ED8\u6B3E\u53EF\u80FD\u6703\u5C0E\u81F4\u591A\u91CD\u6536\u8CBB\u3002",
            "field.valid": "\u6B04\u4F4D\u6709\u6548",
            "field.invalid": "\u6B04\u4F4D\u7121\u6548",
            "error.va.gen.01": "\u4E0D\u5B8C\u6574\u6B04\u4F4D",
            "error.va.gen.02": "\u6B04\u4F4D\u7121\u6548",
            "error.va.sf-cc-num.01": "\u8ACB\u8F38\u5165\u6709\u6548\u7684\u5361\u865F",
            "error.va.sf-cc-num.02": "\u8F38\u5165\u5361\u865F",
            "error.va.sf-cc-num.03": "\u8F38\u5165\u652F\u63F4\u7684\u5361\u54C1\u724C",
            "error.va.sf-cc-num.04": "\u8F38\u5165\u5B8C\u6574\u7684\u5361\u865F",
            "error.va.sf-cc-dat.01": "\u8F38\u5165\u6709\u6548\u7684\u5230\u671F\u65E5",
            "error.va.sf-cc-dat.02": "\u8F38\u5165\u6709\u6548\u7684\u5230\u671F\u65E5",
            "error.va.sf-cc-dat.03": "\u4FE1\u7528\u5361\u5373\u5C07\u5230\u671F",
            "error.va.sf-cc-dat.04": "\u8F38\u5165\u5230\u671F\u65E5",
            "error.va.sf-cc-dat.05": "\u8F38\u5165\u5B8C\u6574\u7684\u5230\u671F\u65E5",
            "error.va.sf-cc-mth.01": "\u8F38\u5165\u5230\u671F\u6708\u4EFD",
            "error.va.sf-cc-yr.01": "\u8F38\u5165\u5230\u671F\u5E74\u4EFD",
            "error.va.sf-cc-yr.02": "\u8F38\u5165\u5B8C\u6574\u7684\u5230\u671F\u5E74\u4EFD",
            "error.va.sf-cc-cvc.01": "\u8F38\u5165\u5B89\u5168\u78BC",
            "error.va.sf-cc-cvc.02": "\u8F38\u5165\u5B8C\u6574\u7684\u5B89\u5168\u78BC",
            "error.va.sf-ach-num.01": "\u9280\u884C\u5E33\u6236\u865F\u78BC\u6B04\u4F4D\u73FE\u70BA\u7A7A\u767D",
            "error.va.sf-ach-num.02": "\u9280\u884C\u5E33\u6236\u865F\u78BC\u9577\u5EA6\u6709\u8AA4",
            "error.va.sf-ach-loc.01": "\u9280\u884C\u532F\u6B3E\u8DEF\u5F91\u7DE8\u865F\u6B04\u4F4D\u73FE\u70BA\u7A7A\u767D",
            "error.va.sf-ach-loc.02": "\u9280\u884C\u532F\u6B3E\u8DEF\u5F91\u7DE8\u865F\u9577\u5EA6\u6709\u8AA4",
            "error.va.sf-kcp-pwd.01": "\u5BC6\u78BC\u6B04\u4F4D\u73FE\u70BA\u7A7A\u767D",
            "error.va.sf-kcp-pwd.02": "\u5BC6\u78BC\u9577\u5EA6\u6709\u8AA4",
            "error.giftcard.no-balance": "\u6B64\u79AE\u54C1\u5361\u7684\u9918\u984D\u70BA\u96F6",
            "error.giftcard.card-error": "\u6211\u5011\u7684\u8A18\u9304\u4E2D\u4E26\u6C92\u6709\u9019\u500B\u865F\u78BC\u7684\u79AE\u54C1\u5361",
            "error.giftcard.currency-error": "\u79AE\u54C1\u5361\u53EA\u80FD\u4EE5\u5176\u7C3D\u767C\u6642\u6240\u4F7F\u7528\u7684\u8CA8\u5E63\u9032\u884C\u7D50\u7B97",
            "amazonpay.signout": "\u5F9E Amazon \u767B\u51FA",
            "amazonpay.changePaymentDetails": "\u8B8A\u66F4\u4ED8\u6B3E\u660E\u7D30",
            "partialPayment.warning": "\u9078\u53D6\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u4F86\u652F\u4ED8\u9918\u984D",
            "partialPayment.remainingBalance": "\u9918\u984D\u5C07\u70BA %{amount}",
            "bankTransfer.beneficiary": "\u53D7\u6B3E\u4EBA",
            "bankTransfer.iban": "IBAN",
            "bankTransfer.bic": "BIC",
            "bankTransfer.reference": "\u53C3\u7167",
            "bankTransfer.introduction": "\u7E7C\u7E8C\u5EFA\u7ACB\u65B0\u7684\u9280\u884C\u8F49\u5E33\u4ED8\u6B3E\u3002\u60A8\u53EF\u4EE5\u4F7F\u7528\u4EE5\u4E0B\u87A2\u5E55\u4E2D\u7684\u8A73\u7D30\u8CC7\u8A0A\u4F86\u5B8C\u6210\u6B64\u9805\u4ED8\u6B3E\u3002",
            "bankTransfer.instructions": "\u591A\u8B1D\u60E0\u9867\uFF0C\u8ACB\u4F7F\u7528\u4EE5\u4E0B\u8CC7\u8A0A\u5B8C\u6210\u4ED8\u6B3E\u3002",
            "bacs.accountHolderName": "\u9280\u884C\u5E33\u6236\u6301\u6709\u4EBA\u59D3\u540D",
            "bacs.accountHolderName.invalid": "\u9280\u884C\u5E33\u6236\u6301\u6709\u4EBA\u59D3\u540D\u7121\u6548",
            "bacs.accountNumber": "\u9280\u884C\u5E33\u6236\u865F\u78BC",
            "bacs.accountNumber.invalid": "\u9280\u884C\u5E33\u6236\u865F\u78BC\u7121\u6548",
            "bacs.bankLocationId": "\u9280\u884C\u4EE3\u78BC",
            "bacs.bankLocationId.invalid": "\u9280\u884C\u4EE3\u78BC\u7121\u6548",
            "bacs.consent.amount": "\u6211\u540C\u610F\u5F9E\u6211\u7684\u9280\u884C\u5E33\u6236\u6263\u9664\u4E0A\u8FF0\u91D1\u984D\u3002",
            "bacs.consent.account": "\u6211\u78BA\u8A8D\u8A72\u5E33\u6236\u4EE5\u6211\u7684\u540D\u7FA9\u958B\u8A2D\uFF0C\u4E26\u4E14\u6211\u662F\u6388\u6B0A\u5F9E\u8A72\u5E33\u6236\u76F4\u63A5\u6263\u6B3E\u7684\u552F\u4E00\u7C3D\u7F72\u4EBA\u3002",
            edit: "\u7DE8\u8F2F",
            "bacs.confirm": "\u78BA\u8A8D\u4E26\u652F\u4ED8",
            "bacs.result.introduction": "\u4E0B\u8F09\u60A8\u7684\u76F4\u63A5\u6263\u6B3E\u6307\u793A\uFF08DDI\uFF0F\u6388\u6B0A\uFF09",
            "download.pdf": "\u4E0B\u8F09 PDF",
            "creditCard.encryptedCardNumber.aria.iframeTitle": "\u5361\u865F\u7684 IFrame",
            "creditCard.encryptedCardNumber.aria.label": "\u4FE1\u7528\u5361\u865F\u78BC",
            "creditCard.encryptedExpiryDate.aria.iframeTitle": "\u5230\u671F\u65E5\u7684 IFrame",
            "creditCard.encryptedExpiryDate.aria.label": "\u5230\u671F\u65E5\u671F",
            "creditCard.encryptedExpiryMonth.aria.iframeTitle": "\u5230\u671F\u6708\u4EFD\u7684 IFrame",
            "creditCard.encryptedExpiryMonth.aria.label": "\u5230\u671F\u6708\u4EFD",
            "creditCard.encryptedExpiryYear.aria.iframeTitle": "\u5230\u671F\u5E74\u4EFD\u7684 IFrame",
            "creditCard.encryptedExpiryYear.aria.label": "\u5230\u671F\u5E74\u4EFD",
            "creditCard.encryptedSecurityCode.aria.iframeTitle": "\u5B89\u5168\u78BC\u7684 IFrame",
            "creditCard.encryptedSecurityCode.aria.label": "\u5B89\u5168\u78BC",
            "creditCard.encryptedPassword.aria.iframeTitle": "\u5BC6\u78BC\u7684 IFrame",
            "creditCard.encryptedPassword.aria.label": "\u5361\u5BC6\u78BC\u7684\u524D 2 \u4F4D\u6578\u5B57",
            "giftcard.encryptedCardNumber.aria.iframeTitle": "\u5361\u865F\u7684 IFrame",
            "giftcard.encryptedCardNumber.aria.label": "\u4FE1\u7528\u5361\u865F\u78BC",
            "giftcard.encryptedSecurityCode.aria.iframeTitle": "PIN \u78BC\u7684 IFrame",
            "giftcard.encryptedSecurityCode.aria.label": "\u6578\u5B57\u5BC6\u78BC",
            giftcardTransactionLimit: "\u6B64\u79AE\u54C1\u5361\u6BCF\u7B46\u4EA4\u6613\u7684\u91D1\u984D\u4E0A\u9650\u70BA %{amount}",
            "ach.encryptedBankAccountNumber.aria.iframeTitle": "\u9280\u884C\u5E33\u6236\u865F\u78BC\u7684 IFrame",
            "ach.encryptedBankAccountNumber.aria.label": "\u5E33\u6236\u865F\u78BC",
            "ach.encryptedBankLocationId.aria.iframeTitle": "\u9280\u884C\u532F\u6B3E\u8DEF\u5F91\u7DE8\u865F\u7684 IFrame",
            "ach.encryptedBankLocationId.aria.label": "ABA \u532F\u6B3E\u8DEF\u5F91\u7DE8\u865F",
            "twint.saved": "\u5132\u5B58\u7684",
            orPayWith: "\u6216\u900F\u904E\u4EE5\u4E0B\u65B9\u5F0F\u652F\u4ED8\uFF1A",
            invalidFormatExpects: "\u683C\u5F0F\u7121\u6548\u3002\u683C\u5F0F\u5FC5\u9808\u70BA\uFF1A%{format}",
            "upi.qrCodeWaitingMessage": "\u4F7F\u7528\u60A8\u504F\u597D\u7684 UPI \u61C9\u7528\u7A0B\u5F0F\u6383\u63CF QR \u4EE3\u78BC\u4EE5\u5B8C\u6210\u4ED8\u6B3E",
            "upi.vpaWaitingMessage": "\u958B\u555F\u60A8\u7684 UPI \u61C9\u7528\u7A0B\u5F0F\u4EE5\u78BA\u8A8D\u4ED8\u6B3E",
            "upi.modeSelection": "\u9078\u64C7\u6240\u9700\u7684 UPI \u4F7F\u7528\u65B9\u5F0F\u3002",
            "onlineBanking.termsAndConditions": "\u7E7C\u7E8C\u64CD\u4F5C\u5373\u8868\u793A\u60A8\u540C\u610F%#\u689D\u6B3E\u53CA\u7D30\u5247%#",
            "onlineBankingPL.termsAndConditions": "\u7E7C\u7E8C\u64CD\u4F5C\u5373\u8868\u793A\u60A8\u540C\u610F Przelewy24 \u7684%#\u6CD5\u898F%#\u548C%#\u8CC7\u8A0A\u8CAC\u4EFB%#",
            "ctp.loading.poweredByCtp": "\u7531 Click to Pay \u63D0\u4F9B\u6280\u8853\u652F\u63F4",
            "ctp.loading.intro": "\u6211\u5011\u6B63\u5728\u6AA2\u67E5\u60A8\u662F\u5426\u6709\u4EFB\u4F55\u4F9B Click to Pay \u4F7F\u7528\u7684\u5DF2\u5132\u5B58\u5361\u2026\u2026",
            "ctp.login.title": "\u7E7C\u7E8C\u4F7F\u7528 Click to Pay",
            "ctp.login.subtitle": "\u8F38\u5165\u9023\u63A5\u5230 Click to Pay \u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u4EE5\u7E7C\u7E8C\u3002",
            "ctp.login.inputLabel": "\u96FB\u5B50\u90F5\u4EF6",
            "ctp.logout.notYou": "\u4E0D\u662F\u60A8\u672C\u4EBA\uFF1F",
            "ctp.logout.notYourCards": "\u4E0D\u662F\u60A8\u7684\u5361\uFF1F",
            "ctp.logout.notYourCard": "\u4E0D\u662F\u60A8\u7684\u5361\uFF1F",
            "ctp.logout.notYourProfile": "\u4E0D\u662F\u60A8\u7684\u500B\u4EBA\u8CC7\u6599\uFF1F",
            "ctp.otp.fieldLabel": "\u4E00\u6B21\u6027\u9A57\u8B49\u78BC",
            "ctp.otp.resendCode": "\u91CD\u65B0\u50B3\u9001\u9A57\u8B49\u78BC",
            "ctp.otp.codeResent": "\u5DF2\u91CD\u65B0\u50B3\u9001\u9A57\u8B49\u78BC",
            "ctp.otp.title": "\u5B58\u53D6\u60A8\u7684 Click to Pay \u5361",
            "ctp.otp.subtitle": "\u8ACB\u8F38\u5165\u6211\u5011\u50B3\u9001\u81F3 %@ \u7684\u9A57\u8B49\u78BC %@\uFF0C\u4EE5\u9A57\u8B49\u662F\u60A8\u672C\u4EBA\u3002",
            "ctp.otp.saveCookiesCheckbox.label": "\u4E0B\u6B21\u7565\u904E\u9A57\u8B49",
            "ctp.otp.saveCookiesCheckbox.information": "\u9078\u64C7\u5728\u88DD\u7F6E\u548C\u700F\u89BD\u5668\u4E2D\u8A18\u4F4F\u53C3\u8207\u5546\u5E97\u7684\u9A57\u8B49\u8CC7\u8A0A\uFF0C\u4EE5\u52A0\u5FEB\u7D50\u5E33\u901F\u5EA6\u3002\u4E0D\u5EFA\u8B70\u5728\u5171\u4EAB\u88DD\u7F6E\u4E0A\u9078\u53D6\u8A72\u8A2D\u5B9A\u3002",
            "ctp.otp.saveCookiesCheckbox.shorterInfo": "\u9078\u64C7\u5728\u88DD\u7F6E\u548C\u700F\u89BD\u5668\u4E2D\u8A18\u4F4F",
            "ctp.emptyProfile.message": "\u6B64 Click to Pay \u500B\u4EBA\u8CC7\u6599\u4E2D\u672A\u8A3B\u518A\u4EFB\u4F55\u5361",
            "ctp.separatorText": "\u6216\u4F7F\u7528",
            "ctp.cards.title": "\u4F7F\u7528 Click to Pay \u5B8C\u6210\u4ED8\u6B3E",
            "ctp.cards.subtitle": "\u9078\u53D6\u8981\u4F7F\u7528\u7684\u5361\u3002",
            "ctp.cards.expiredCard": "\u5DF2\u904E\u671F",
            "ctp.manualCardEntry": "\u624B\u52D5\u5361\u8F38\u5165",
            "ctp.aria.infoModalButton": "\u4EC0\u9EBC\u662F Click to Pay",
            "ctp.infoPopup.title": "Click to Pay \u63D0\u4F9B\u4FBF\u6377\u7684\u7DDA\u4E0A\u975E\u63A5\u89F8\u5F0F\u652F\u4ED8\u65B9\u5F0F",
            "ctp.infoPopup.subtitle": "Mastercard\u3001Visa \u548C\u5176\u4ED6\u652F\u4ED8\u5361\u652F\u63F4\u7684\u5B89\u5168\u5FEB\u6377\u652F\u4ED8\u65B9\u5F0F\u3002",
            "ctp.infoPopup.benefit1": "Click to Pay \u4F7F\u7528\u52A0\u5BC6\u6280\u8853\uFF0C\u78BA\u4FDD\u60A8\u7684\u8CC7\u6599\u5B89\u5168\u7121\u865E",
            "ctp.infoPopup.benefit2": "\u8207\u5168\u7403\u5546\u5BB6\u4E00\u8D77\u4F7F\u7528",
            "ctp.infoPopup.benefit3": "\u53EA\u9700\u8A2D\u5B9A\u4E00\u6B21\uFF0C\u5373\u53EF\u8F15\u9B06\u652F\u4ED8",
            "ctp.errors.AUTH_INVALID": "\u9A57\u8B49\u7121\u6548",
            "ctp.errors.NOT_FOUND": "\u627E\u4E0D\u5230\u5E33\u6236\uFF0C\u8ACB\u8F38\u5165\u6709\u6548\u7684\u96FB\u5B50\u90F5\u4EF6\u6216\u7E7C\u7E8C\u624B\u52D5\u8F38\u5165\u5361\u8CC7\u6599",
            "ctp.errors.ID_FORMAT_UNSUPPORTED": "\u4E0D\u652F\u63F4\u6B64\u683C\u5F0F",
            "ctp.errors.FRAUD": "\u4F7F\u7528\u8005\u5E33\u6236\u5DF2\u9396\u5B9A\u6216\u505C\u7528",
            "ctp.errors.CONSUMER_ID_MISSING": "\u8ACB\u6C42\u4E2D\u907A\u6F0F\u53D6\u7528\u8005\u8EAB\u4EFD\u8B58\u5225",
            "ctp.errors.ACCT_INACCESSIBLE": "\u76EE\u524D\u7121\u6CD5\u4F7F\u7528\u6B64\u5E33\u6236\uFF0C\u4F8B\u5982\u5DF2\u9396\u5B9A",
            "ctp.errors.CODE_INVALID": "\u9A57\u8B49\u78BC\u6709\u8AA4",
            "ctp.errors.CODE_EXPIRED": "\u6B64\u9A57\u8B49\u78BC\u5DF2\u904E\u671F",
            "ctp.errors.RETRIES_EXCEEDED": "\u8D85\u51FA\u4E86\u7522\u751F OTP \u7684\u91CD\u8A66\u6B21\u6578\u4E0A\u9650",
            "ctp.errors.OTP_SEND_FAILED": "OTP \u7121\u6CD5\u50B3\u9001\u7D66\u6536\u4EF6\u8005",
            "ctp.errors.REQUEST_TIMEOUT": "\u51FA\u4E86\u4E00\u4E9B\u554F\u984C\uFF0C\u8ACB\u91CD\u8A66\u6216\u624B\u52D5\u8F38\u5165\u5361\u8CC7\u6599",
            "ctp.errors.UNKNOWN_ERROR": "\u51FA\u4E86\u4E00\u4E9B\u554F\u984C\uFF0C\u8ACB\u91CD\u8A66\u6216\u624B\u52D5\u8F38\u5165\u5361\u8CC7\u6599",
            "ctp.errors.SERVICE_ERROR": "\u51FA\u4E86\u4E00\u4E9B\u554F\u984C\uFF0C\u8ACB\u91CD\u8A66\u6216\u624B\u52D5\u8F38\u5165\u5361\u8CC7\u6599",
            "ctp.errors.SERVER_ERROR": "\u51FA\u4E86\u4E00\u4E9B\u554F\u984C\uFF0C\u8ACB\u91CD\u8A66\u6216\u624B\u52D5\u8F38\u5165\u5361\u8CC7\u6599",
            "ctp.errors.INVALID_PARAMETER": "\u51FA\u4E86\u4E00\u4E9B\u554F\u984C\uFF0C\u8ACB\u91CD\u8A66\u6216\u624B\u52D5\u8F38\u5165\u5361\u8CC7\u6599",
            "ctp.errors.AUTH_ERROR": "\u51FA\u4E86\u4E00\u4E9B\u554F\u984C\uFF0C\u8ACB\u91CD\u8A66\u6216\u624B\u52D5\u8F38\u5165\u5361\u8CC7\u6599",
            "paymentMethodsList.aria.label": "\u9078\u64C7\u4ED8\u6B3E\u65B9\u5F0F",
            "companyDetails.name.invalid": "\u8F38\u5165\u516C\u53F8\u540D\u7A31",
            "companyDetails.registrationNumber.invalid": "\u8F38\u5165\u8A3B\u518A\u865F\u78BC",
            "consent.checkbox.invalid": "\u60A8\u5FC5\u9808\u540C\u610F\u76F8\u95DC\u689D\u6B3E\u53CA\u7D30\u5247",
            "form.instruction": "\u9664\u975E\u53E6\u6709\u6A19\u793A\uFF0C\u5426\u5247\u5FC5\u9808\u586B\u5BEB\u6240\u6709\u6B04\u4F4D\u3002",
            "trustly.descriptor": "\u5373\u6642\u9280\u884C\u4ED8\u6B3E",
            "trustly.description1": "\u76F4\u63A5\u5F9E\u4EFB\u4F55\u9280\u884C\u5E33\u6236\u4ED8\u6B3E\uFF0C\u4E26\u7372\u5F97\u9280\u884C\u7D1A\u5225\u5B89\u5168\u4FDD\u969C",
            "trustly.description2": "\u7121\u9700\u5361\uFF0C\u7121\u9700\u4E0B\u8F09\u61C9\u7528\u7A0B\u5F0F\uFF0C\u7121\u9700\u8A3B\u518A",
            "ancv.input.label": "\u60A8\u7684 ANCV \u8EAB\u5206\u8B58\u5225",
            "ancv.confirmPayment": "\u4F7F\u7528\u60A8\u7684 ANCV \u61C9\u7528\u7A0B\u5F0F\u78BA\u8A8D\u4ED8\u6B3E\u3002",
            "ancv.form.instruction": "\u5FC5\u9808\u7533\u8ACB Cheque-Vacances \u624D\u80FD\u9A57\u8B49\u6B64\u4ED8\u6B3E\u3002",
            "ancv.beneficiaryId.invalid": "\u8F38\u5165\u6709\u6548\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u6216 ANCV ID",
            "payme.openPayMeApp": "\u5728 PayMe \u61C9\u7528\u7A0B\u5F0F\u4E2D\u6388\u6B0A\u4ED8\u6B3E\uFF0C\u5B8C\u6210\u4ED8\u6B3E\u4E26\u7B49\u5F85\u78BA\u8A8D\u3002",
            "payme.redirectButtonLabel": "\u958B\u555F PayMe \u61C9\u7528\u7A0B\u5F0F",
            "payme.scanQrCode": "\u4F7F\u7528 QR \u4EE3\u78BC\u5B8C\u6210\u4ED8\u6B3E",
            "payme.timeToPay": "\u6B64 QR \u4EE3\u78BC\u5C0D %@ \u6709\u6548",
            "payme.instructions.steps": "\u958B\u555F PayMe \u61C9\u7528\u7A0B\u5F0F\u3002%@\u6383\u63CF QR \u4EE3\u78BC\u6388\u6B0A\u4ED8\u6B3E\u3002%@\u5728\u61C9\u7528\u7A0B\u5F0F\u4E2D\u5B8C\u6210\u4ED8\u6B3E\u4E26\u7B49\u5F85\u78BA\u8A8D\u3002",
            "payme.instructions.footnote": "\u5B8C\u6210\u4ED8\u6B3E\u524D\uFF0C\u8ACB\u52FF\u95DC\u9589\u6B64\u9801\u9762"
        }
    });
    return function(e) {
        return H1.apply(this, arguments);
    };
});

});

parcelRegister("6ohhc", function(module, exports) {

var $5BcBK = parcelRequire("5BcBK");

var $hyPW0 = parcelRequire("hyPW0");
const $4a7262b7f309c68f$var$Mixpanel = (()=>{
    let userSsoId = null;
    let mixpanelJson = null;
    const mixpanelDebugMode = false;
    const fetchMixpanelJSON = async ()=>{
        try {
            const response = await fetch("https://services.mewatch.sg/analytics/mixpanel.json");
            const data = await response.json();
            return data;
        } catch (error) {
            console.error(error);
            return null;
        }
    };
    const getEventsMap = async ()=>{
        const mixpanelMap = await fetchMixpanelJSON();
        if (!mixpanelMap) return;
        const { events: events, metadata: metadata, superProperties: superProperties, eventProperties: eventProperties, userProperties: userProperties } = mixpanelMap;
        const mappedEvents = {
            events: events,
            superProperties: {
                ...superProperties.all,
                ...superProperties.web
            },
            eventProperties: {
                ...eventProperties.all,
                ...eventProperties.web
            },
            userProperties: {
                ...userProperties.all,
                ...userProperties.web
            },
            metadata: {
                ...metadata.all,
                ...metadata.web
            }
        };
        mixpanelJson = mappedEvents;
        return mappedEvents;
    };
    const readyMixpanelTracking = async ()=>{
        const mixpanelEventsMap = await getEventsMap();
        if (mixpanelEventsMap) trackMixpanelEvent((0, $hyPW0.MIXPANEL_EVENT).SubscribePaymentPage);
    };
    const trackMixpanelEvent = (event)=>{
        enqueueEvent({
            eventName: event
        });
    };
    const enqueueEvent = async (event)=>{
        const eventMap = mixpanelJson.events;
        const eventInMap = eventMap && eventMap.hasOwnProperty(event.eventName);
        if (!eventInMap) return;
        await processQueue(event);
    };
    const processQueue = async (event)=>{
        if (mixpanelDebugMode) console.log(`%c[Mixpanel] Processing #${event.eventName}`, "color: blue");
        await track(event);
    };
    const track = async (event)=>{
        const { events: eventMap } = mixpanelJson;
        const { eventName: eventName } = event;
        const { setSuperProps: setSuperProps, setUserProps: setUserProps, setEventProps: setEventProps, unionUserProps: unionUserProps } = eventMap[eventName];
        // Super props
        const superProps = getProperties((0, $hyPW0.MIXPANEL_PROPERTY_TYPE).Super, setSuperProps, event);
        if (!(0, $hyPW0.isEmptyObject)(superProps)) (0, $5BcBK.default).register(superProps);
        switch(eventName){
            case (0, $hyPW0.MIXPANEL_EVENT).SubscribePaymentPage:
                handleAnonymousUser();
                break;
            default:
                break;
        }
        // User props
        const userPropsToSet = getProperties((0, $hyPW0.MIXPANEL_PROPERTY_TYPE).User, setUserProps, event);
        const userPropsToUnion = getProperties((0, $hyPW0.MIXPANEL_PROPERTY_TYPE).User, unionUserProps, event);
        if (!(0, $hyPW0.isEmptyObject)(userPropsToSet)) (0, $5BcBK.default).people.set(userPropsToSet);
        if (!(0, $hyPW0.isEmptyObject)(userPropsToUnion)) (0, $5BcBK.default).people.union(userPropsToUnion);
        // Event props and Tracking
        // Added additional eventName prop to getProperties for debug logs, will be removed later
        const eventProps = getProperties((0, $hyPW0.MIXPANEL_PROPERTY_TYPE).Event, setEventProps, event);
        if ((0, $hyPW0.isEmptyObject)(eventProps)) (0, $5BcBK.default).track(eventName);
        else (0, $5BcBK.default).track(eventName, eventProps);
    };
    const getProperties = (propertyType, propertyList, event)=>{
        if (!propertyList || propertyList.length === 0) return {};
        const properties = {};
        for(let i = 0; i < propertyList.length; i++){
            let propertyName = propertyList[i];
            if (propertyName in mixpanelJson[propertyType]) {
                let property = mixpanelJson[propertyType][propertyName];
                let propertyValue = getPropertyValue(property);
                const notEmptyArray = Array.isArray(propertyValue) && propertyValue.length > 0;
                const valueExistAndNotArray = !Array.isArray(propertyValue) && typeof propertyValue !== "undefined" && propertyValue !== "";
                if (valueExistAndNotArray || notEmptyArray) properties[propertyName] = propertyValue;
                valueChecker(event.eventName, propertyName, propertyValue);
            }
        }
        return properties;
    };
    const getPropertyValue = (property)=>{
        const { source: source, variable: variable } = property;
        switch(source){
            case (0, $hyPW0.MIXPANEL_PROPERTY_SOURCE).Axis:
                return getAxisValue(variable);
            case (0, $hyPW0.MIXPANEL_PROPERTY_SOURCE).Client:
                return getClientValue(variable);
            default:
                return;
        }
    };
    const getAxisValue = (variable)=>{
        const [source] = variable.split("|");
        switch(source){
            case (0, $hyPW0.MIXPANEL_VARIABLES).SsoID:
                return userSsoId;
            default:
                return;
        }
    };
    const getClientValue = (variable)=>{
        switch(variable){
            case (0, $hyPW0.MIXPANEL_VARIABLES).UniqueUserId:
                return `mewatch-${userSsoId}`;
            default:
                return;
        }
    };
    const valueChecker = (name, variable, value)=>{
        if (mixpanelDebugMode && (value === undefined || value === null)) {
            const debugString = `${name} var: ${variable} has no value`;
            console.log(`%c[Mixpanel] ${debugString}`, "color: red");
        }
        return value;
    };
    const handleAnonymousUser = ()=>{
        (0, $5BcBK.default).identify((0, $hyPW0.getPrefixSSOID)(userSsoId));
        (0, $5BcBK.default).alias((0, $5BcBK.default).get_distinct_id(), userSsoId);
    };
    return {
        initMixpanel: (ssoId)=>{
            (0, $5BcBK.default).init("32231f8971e8246b52f0a566df2bbe20", {
                debug: mixpanelDebugMode
            });
            userSsoId = ssoId;
            readyMixpanelTracking();
        },
        trackMixpanelEvent: (event)=>{
            enqueueEvent({
                eventName: event
            });
        }
    };
})();
module.exports = $4a7262b7f309c68f$var$Mixpanel;

});
parcelRegister("5BcBK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $413a30192b54574f$export$2e2bcd8739ae039; });
// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file

var $3aNd6 = parcelRequire("3aNd6");
var $413a30192b54574f$require$Buffer = $3aNd6.Buffer;
var $413a30192b54574f$var$win;
if (typeof window === "undefined") {
    var $413a30192b54574f$var$loc = {
        hostname: ""
    };
    $413a30192b54574f$var$win = {
        crypto: {
            randomUUID: function() {
                throw Error("unsupported");
            }
        },
        navigator: {
            userAgent: "",
            onLine: true
        },
        document: {
            createElement: function() {
                return {};
            },
            location: $413a30192b54574f$var$loc,
            referrer: ""
        },
        screen: {
            width: 0,
            height: 0
        },
        location: $413a30192b54574f$var$loc,
        addEventListener: function() {},
        removeEventListener: function() {}
    };
} else $413a30192b54574f$var$win = window;
function $413a30192b54574f$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $413a30192b54574f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $413a30192b54574f$var$_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $413a30192b54574f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $413a30192b54574f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $413a30192b54574f$var$_construct(Parent, args, Class) {
    if ($413a30192b54574f$var$_is_native_reflect_construct()) $413a30192b54574f$var$_construct = Reflect.construct;
    else $413a30192b54574f$var$_construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $413a30192b54574f$var$_set_prototype_of(instance, Class.prototype);
        return instance;
    };
    return $413a30192b54574f$var$_construct.apply(null, arguments);
}
function $413a30192b54574f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $413a30192b54574f$var$_create_class(Constructor, protoProps, staticProps) {
    if (protoProps) $413a30192b54574f$var$_defineProperties(Constructor.prototype, protoProps);
    return Constructor;
}
function $413a30192b54574f$var$_extends() {
    $413a30192b54574f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $413a30192b54574f$var$_extends.apply(this, arguments);
}
function $413a30192b54574f$var$_get_prototype_of(o) {
    $413a30192b54574f$var$_get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $413a30192b54574f$var$_get_prototype_of(o);
}
function $413a30192b54574f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $413a30192b54574f$var$_set_prototype_of(subClass, superClass);
}
function $413a30192b54574f$var$_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) return !!right[Symbol.hasInstance](left);
    else return left instanceof right;
}
function $413a30192b54574f$var$_is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $413a30192b54574f$var$_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $413a30192b54574f$var$_set_prototype_of(o, p) {
    $413a30192b54574f$var$_set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $413a30192b54574f$var$_set_prototype_of(o, p);
}
function $413a30192b54574f$var$_type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function $413a30192b54574f$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $413a30192b54574f$var$_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $413a30192b54574f$var$_array_like_to_array(o, minLen);
}
function $413a30192b54574f$var$_wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $413a30192b54574f$var$_wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !$413a30192b54574f$var$_is_native_function(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $413a30192b54574f$var$_construct(Class, arguments, $413a30192b54574f$var$_get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $413a30192b54574f$var$_set_prototype_of(Wrapper, Class);
    };
    return $413a30192b54574f$var$_wrap_native_super(Class);
}
function $413a30192b54574f$var$_is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($413a30192b54574f$var$_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function $413a30192b54574f$var$_create_for_of_iterator_helper_loose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $413a30192b54574f$var$_unsupported_iterable_to_array(o)) || allowArrayLike) {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $413a30192b54574f$var$_ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $413a30192b54574f$var$_ts_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
var $413a30192b54574f$var$__defProp = Object.defineProperty;
var $413a30192b54574f$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $413a30192b54574f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $413a30192b54574f$var$__publicField = function(obj, key, value) {
    return $413a30192b54574f$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
var $413a30192b54574f$var$_a;
var $413a30192b54574f$var$__defProp$1 = Object.defineProperty;
var $413a30192b54574f$var$__defNormalProp$1 = function(obj, key, value) {
    return key in obj ? $413a30192b54574f$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $413a30192b54574f$var$__publicField$1 = function(obj, key, value) {
    return $413a30192b54574f$var$__defNormalProp$1(obj, (typeof key === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
var $413a30192b54574f$var$NodeType$3 = /* @__PURE__ */ function(NodeType2) {
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
}($413a30192b54574f$var$NodeType$3 || {});
var $413a30192b54574f$var$testableAccessors$1 = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
var $413a30192b54574f$var$testableMethods$1 = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
var $413a30192b54574f$var$untaintedBasePrototype$1 = {};
var $413a30192b54574f$var$isAngularZonePresent$1 = function() {
    return !!globalThis.Zone;
};
function $413a30192b54574f$var$getUntaintedPrototype$1(key) {
    if ($413a30192b54574f$var$untaintedBasePrototype$1[key]) return $413a30192b54574f$var$untaintedBasePrototype$1[key];
    var defaultObj = globalThis[key];
    var defaultPrototype = defaultObj.prototype;
    var accessorNames = key in $413a30192b54574f$var$testableAccessors$1 ? $413a30192b54574f$var$testableAccessors$1[key] : void 0;
    var isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every(function(accessor) {
        var _a2, _b;
        return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    var methodNames = key in $413a30192b54574f$var$testableMethods$1 ? $413a30192b54574f$var$testableMethods$1[key] : void 0;
    var isUntaintedMethods = Boolean(methodNames && methodNames.every(function(method) {
        var _a2;
        return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods && !$413a30192b54574f$var$isAngularZonePresent$1()) {
        $413a30192b54574f$var$untaintedBasePrototype$1[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        var iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        var win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        var untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return $413a30192b54574f$var$untaintedBasePrototype$1[key] = untaintedObject;
    } catch (e) {
        return defaultPrototype;
    }
}
var $413a30192b54574f$var$untaintedAccessorCache$1 = {};
function $413a30192b54574f$var$getUntaintedAccessor$1(key, instance, accessor) {
    var _a2;
    var cacheKey = key + "." + String(accessor);
    if ($413a30192b54574f$var$untaintedAccessorCache$1[cacheKey]) return $413a30192b54574f$var$untaintedAccessorCache$1[cacheKey].call(instance);
    var untaintedPrototype = $413a30192b54574f$var$getUntaintedPrototype$1(key);
    var untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
    if (!untaintedAccessor) return instance[accessor];
    $413a30192b54574f$var$untaintedAccessorCache$1[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
var $413a30192b54574f$var$untaintedMethodCache$1 = {};
function $413a30192b54574f$var$getUntaintedMethod$1(key, instance, method) {
    var cacheKey = key + "." + String(method);
    if ($413a30192b54574f$var$untaintedMethodCache$1[cacheKey]) return $413a30192b54574f$var$untaintedMethodCache$1[cacheKey].bind(instance);
    var untaintedPrototype = $413a30192b54574f$var$getUntaintedPrototype$1(key);
    var untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    $413a30192b54574f$var$untaintedMethodCache$1[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function $413a30192b54574f$var$childNodes$1(n2) {
    return $413a30192b54574f$var$getUntaintedAccessor$1("Node", n2, "childNodes");
}
function $413a30192b54574f$var$parentNode$1(n2) {
    return $413a30192b54574f$var$getUntaintedAccessor$1("Node", n2, "parentNode");
}
function $413a30192b54574f$var$parentElement$1(n2) {
    return $413a30192b54574f$var$getUntaintedAccessor$1("Node", n2, "parentElement");
}
function $413a30192b54574f$var$textContent$1(n2) {
    return $413a30192b54574f$var$getUntaintedAccessor$1("Node", n2, "textContent");
}
function $413a30192b54574f$var$contains$1(n2, other) {
    return $413a30192b54574f$var$getUntaintedMethod$1("Node", n2, "contains")(other);
}
function $413a30192b54574f$var$getRootNode$1(n2) {
    return $413a30192b54574f$var$getUntaintedMethod$1("Node", n2, "getRootNode")();
}
function $413a30192b54574f$var$host$1(n2) {
    if (!n2 || !("host" in n2)) return null;
    return $413a30192b54574f$var$getUntaintedAccessor$1("ShadowRoot", n2, "host");
}
function $413a30192b54574f$var$styleSheets$1(n2) {
    return n2.styleSheets;
}
function $413a30192b54574f$var$shadowRoot$1(n2) {
    if (!n2 || !("shadowRoot" in n2)) return null;
    return $413a30192b54574f$var$getUntaintedAccessor$1("Element", n2, "shadowRoot");
}
function $413a30192b54574f$var$querySelector$1(n2, selectors) {
    return $413a30192b54574f$var$getUntaintedAccessor$1("Element", n2, "querySelector")(selectors);
}
function $413a30192b54574f$var$querySelectorAll$1(n2, selectors) {
    return $413a30192b54574f$var$getUntaintedAccessor$1("Element", n2, "querySelectorAll")(selectors);
}
function $413a30192b54574f$var$mutationObserverCtor$1() {
    return $413a30192b54574f$var$getUntaintedPrototype$1("MutationObserver").constructor;
}
function $413a30192b54574f$var$patch$1(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (e) {
        return function() {};
    }
}
var $413a30192b54574f$var$index$1 = {
    childNodes: $413a30192b54574f$var$childNodes$1,
    parentNode: $413a30192b54574f$var$parentNode$1,
    parentElement: $413a30192b54574f$var$parentElement$1,
    textContent: $413a30192b54574f$var$textContent$1,
    contains: $413a30192b54574f$var$contains$1,
    getRootNode: $413a30192b54574f$var$getRootNode$1,
    host: $413a30192b54574f$var$host$1,
    styleSheets: $413a30192b54574f$var$styleSheets$1,
    shadowRoot: $413a30192b54574f$var$shadowRoot$1,
    querySelector: $413a30192b54574f$var$querySelector$1,
    querySelectorAll: $413a30192b54574f$var$querySelectorAll$1,
    mutationObserver: $413a30192b54574f$var$mutationObserverCtor$1,
    patch: $413a30192b54574f$var$patch$1
};
function $413a30192b54574f$var$isElement(n2) {
    return n2.nodeType === n2.ELEMENT_NODE;
}
function $413a30192b54574f$var$isShadowRoot(n2) {
    var hostEl = // but only shadow roots have a `mode` property
    n2 && "host" in n2 && "mode" in n2 && $413a30192b54574f$var$index$1.host(n2) || null;
    return Boolean(hostEl && "shadowRoot" in hostEl && $413a30192b54574f$var$index$1.shadowRoot(hostEl) === n2);
}
function $413a30192b54574f$var$isNativeShadowDom(shadowRoot2) {
    return Object.prototype.toString.call(shadowRoot2) === "[object ShadowRoot]";
}
function $413a30192b54574f$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $413a30192b54574f$var$escapeImportStatement(rule2) {
    var cssText = rule2.cssText;
    if (cssText.split('"').length < 3) return cssText;
    var statement = [
        "@import",
        "url(" + JSON.stringify(rule2.href) + ")"
    ];
    if (rule2.layerName === "") statement.push("layer");
    else if (rule2.layerName) statement.push("layer(" + rule2.layerName + ")");
    if (rule2.supportsText) statement.push("supports(" + rule2.supportsText + ")");
    if (rule2.media.length) statement.push(rule2.media.mediaText);
    return statement.join(" ") + ";";
}
function $413a30192b54574f$var$stringifyStylesheet(s2) {
    try {
        var rules2 = s2.rules || s2.cssRules;
        if (!rules2) return null;
        var sheetHref = s2.href;
        if (!sheetHref && s2.ownerNode && s2.ownerNode.ownerDocument) sheetHref = s2.ownerNode.ownerDocument.location.href;
        var stringifiedRules = Array.from(rules2, function(rule2) {
            return $413a30192b54574f$var$stringifyRule(rule2, sheetHref);
        }).join("");
        return $413a30192b54574f$var$fixBrowserCompatibilityIssuesInCSS(stringifiedRules);
    } catch (error) {
        return null;
    }
}
function $413a30192b54574f$var$stringifyRule(rule2, sheetHref) {
    if ($413a30192b54574f$var$isCSSImportRule(rule2)) {
        var importStringified;
        try {
            importStringified = $413a30192b54574f$var$stringifyStylesheet(rule2.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
            $413a30192b54574f$var$escapeImportStatement(rule2);
        } catch (error) {
            importStringified = rule2.cssText;
        }
        if (rule2.styleSheet.href) return $413a30192b54574f$var$absolutifyURLs(importStringified, rule2.styleSheet.href);
        return importStringified;
    } else {
        var ruleStringified = rule2.cssText;
        if ($413a30192b54574f$var$isCSSStyleRule(rule2) && rule2.selectorText.includes(":")) ruleStringified = $413a30192b54574f$var$fixSafariColons(ruleStringified);
        if (sheetHref) return $413a30192b54574f$var$absolutifyURLs(ruleStringified, sheetHref);
        return ruleStringified;
    }
}
function $413a30192b54574f$var$fixSafariColons(cssStringified) {
    var regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $413a30192b54574f$var$isCSSImportRule(rule2) {
    return "styleSheet" in rule2;
}
function $413a30192b54574f$var$isCSSStyleRule(rule2) {
    return "selectorText" in rule2;
}
var $413a30192b54574f$var$Mirror = /*#__PURE__*/ function() {
    function Mirror() {
        $413a30192b54574f$var$__publicField$1(this, "idNodeMap", /* @__PURE__ */ new Map());
        $413a30192b54574f$var$__publicField$1(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    var _proto = Mirror.prototype;
    _proto.getId = function getId(n2) {
        var _a2;
        if (!n2) return -1;
        var id = (_a2 = this.getMeta(n2)) == null ? void 0 : _a2.id;
        return id != null ? id : -1;
    };
    _proto.getNode = function getNode(id) {
        return this.idNodeMap.get(id) || null;
    };
    _proto.getIds = function getIds() {
        return Array.from(this.idNodeMap.keys());
    };
    _proto.getMeta = function getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    };
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    _proto.removeNodeFromMap = function removeNodeFromMap(n2) {
        var _this = this;
        var id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) n2.childNodes.forEach(function(childNode) {
            return _this.removeNodeFromMap(childNode);
        });
    };
    _proto.has = function has(id) {
        return this.idNodeMap.has(id);
    };
    _proto.hasNode = function hasNode(node2) {
        return this.nodeMetaMap.has(node2);
    };
    _proto.add = function add(n2, meta) {
        var id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    };
    _proto.replace = function replace(id, n2) {
        var oldNode = this.getNode(id);
        if (oldNode) {
            var meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    };
    _proto.reset = function reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    };
    return Mirror;
}();
function $413a30192b54574f$var$createMirror$2() {
    return new $413a30192b54574f$var$Mirror();
}
function $413a30192b54574f$var$maskInputValue(param) {
    var element = param.element, maskInputOptions = param.maskInputOptions, tagName = param.tagName, type = param.type, value = param.value, maskInputFn = param.maskInputFn;
    var text = value || "";
    var actualType = type && $413a30192b54574f$var$toLowerCase(type);
    if (maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType]) {
        if (maskInputFn) text = maskInputFn(text, element);
        else text = "*".repeat(text.length);
    }
    return text;
}
function $413a30192b54574f$var$toLowerCase(str) {
    return str.toLowerCase();
}
var $413a30192b54574f$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $413a30192b54574f$var$is2DCanvasBlank(canvas) {
    var ctx = canvas.getContext("2d");
    if (!ctx) return true;
    var chunkSize = 50;
    for(var x2 = 0; x2 < canvas.width; x2 += chunkSize)for(var y = 0; y < canvas.height; y += chunkSize){
        var getImageData = ctx.getImageData;
        var originalGetImageData = $413a30192b54574f$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$413a30192b54574f$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        var pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x2, y, Math.min(chunkSize, canvas.width - x2), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some(function(pixel) {
            return pixel !== 0;
        })) return false;
    }
    return true;
}
function $413a30192b54574f$var$getInputType(element) {
    var type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $413a30192b54574f$var$toLowerCase(type) : null;
}
function $413a30192b54574f$var$extractFileExtension(path, baseURL) {
    var url;
    try {
        url = new URL(path, baseURL != null ? baseURL : window.location.href);
    } catch (err) {
        return null;
    }
    var regex = /\.([0-9a-z]+)(?:$)/i;
    var match = url.pathname.match(regex);
    var _ref;
    return (_ref = match == null ? void 0 : match[1]) != null ? _ref : null;
}
function $413a30192b54574f$var$extractOrigin(url) {
    var origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
var $413a30192b54574f$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
var $413a30192b54574f$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
var $413a30192b54574f$var$URL_WWW_MATCH = /^www\..*/i;
var $413a30192b54574f$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $413a30192b54574f$var$absolutifyURLs(cssText, href) {
    return (cssText || "").replace($413a30192b54574f$var$URL_IN_CSS_REF, function(origin, quote1, path1, quote2, path2, path3) {
        var filePath = path1 || path2 || path3;
        var maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($413a30192b54574f$var$URL_PROTOCOL_MATCH.test(filePath) || $413a30192b54574f$var$URL_WWW_MATCH.test(filePath)) return "url(" + maybeQuote + filePath + maybeQuote + ")";
        if ($413a30192b54574f$var$DATA_URI.test(filePath)) return "url(" + maybeQuote + filePath + maybeQuote + ")";
        if (filePath[0] === "/") return "url(" + maybeQuote + ($413a30192b54574f$var$extractOrigin(href) + filePath) + maybeQuote + ")";
        var stack = href.split("/");
        var parts = filePath.split("/");
        stack.pop();
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(parts), _step; !(_step = _iterator()).done;){
            var part = _step.value;
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return "url(" + maybeQuote + stack.join("/") + maybeQuote + ")";
    });
}
function $413a30192b54574f$var$normalizeCssString(cssText, _testNoPxNorm) {
    if (_testNoPxNorm === void 0) _testNoPxNorm = false;
    if (_testNoPxNorm) return cssText.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "");
    else return cssText.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "").replace(/0px/g, "0");
}
function $413a30192b54574f$var$splitCssText(cssText, style, _testNoPxNorm) {
    if (_testNoPxNorm === void 0) _testNoPxNorm = false;
    var childNodes2 = Array.from(style.childNodes);
    var splits = [];
    var iterCount = 0;
    if (childNodes2.length > 1 && cssText && typeof cssText === "string") {
        var cssTextNorm = $413a30192b54574f$var$normalizeCssString(cssText, _testNoPxNorm);
        var normFactor = cssTextNorm.length / cssText.length;
        for(var i2 = 1; i2 < childNodes2.length; i2++)if (childNodes2[i2].textContent && typeof childNodes2[i2].textContent === "string") {
            var textContentNorm = $413a30192b54574f$var$normalizeCssString(childNodes2[i2].textContent, _testNoPxNorm);
            var jLimit = 100;
            var j = 3;
            for(; j < textContentNorm.length; j++){
                if (textContentNorm[j].match(/[a-zA-Z0-9]/) || // substring needs to be unique to this section
                textContentNorm.indexOf(textContentNorm.substring(0, j), 1) !== -1) continue;
                break;
            }
            for(; j < textContentNorm.length; j++){
                var startSubstring = textContentNorm.substring(0, j);
                var cssNormSplits = cssTextNorm.split(startSubstring);
                var splitNorm = -1;
                if (cssNormSplits.length === 2) splitNorm = cssNormSplits[0].length;
                else if (cssNormSplits.length > 2 && cssNormSplits[0] === "" && childNodes2[i2 - 1].textContent !== "") splitNorm = cssTextNorm.indexOf(startSubstring, 1);
                else if (cssNormSplits.length === 1) {
                    startSubstring = startSubstring.substring(0, startSubstring.length - 1);
                    cssNormSplits = cssTextNorm.split(startSubstring);
                    if (cssNormSplits.length <= 1) {
                        splits.push(cssText);
                        return splits;
                    }
                    j = jLimit + 1;
                } else if (j === textContentNorm.length - 1) splitNorm = cssTextNorm.indexOf(startSubstring);
                if (cssNormSplits.length >= 2 && j > jLimit) {
                    var prevTextContent = childNodes2[i2 - 1].textContent;
                    if (prevTextContent && typeof prevTextContent === "string") {
                        var prevMinLength = $413a30192b54574f$var$normalizeCssString(prevTextContent).length;
                        splitNorm = cssTextNorm.indexOf(startSubstring, prevMinLength);
                    }
                    if (splitNorm === -1) splitNorm = cssNormSplits[0].length;
                }
                if (splitNorm !== -1) {
                    var k = Math.floor(splitNorm / normFactor);
                    for(; k > 0 && k < cssText.length;){
                        iterCount += 1;
                        if (iterCount > 50 * childNodes2.length) {
                            splits.push(cssText);
                            return splits;
                        }
                        var normPart = $413a30192b54574f$var$normalizeCssString(cssText.substring(0, k), _testNoPxNorm);
                        if (normPart.length === splitNorm) {
                            splits.push(cssText.substring(0, k));
                            cssText = cssText.substring(k);
                            cssTextNorm = cssTextNorm.substring(splitNorm);
                            break;
                        } else if (normPart.length < splitNorm) k += Math.max(1, Math.floor((splitNorm - normPart.length) / normFactor));
                        else k -= Math.max(1, Math.floor((normPart.length - splitNorm) * normFactor));
                    }
                    break;
                }
            }
        }
    }
    splits.push(cssText);
    return splits;
}
function $413a30192b54574f$var$markCssSplits(cssText, style) {
    return $413a30192b54574f$var$splitCssText(cssText, style).join("/* rr_split */");
}
var $413a30192b54574f$var$_id = 1;
var $413a30192b54574f$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
var $413a30192b54574f$var$IGNORED_NODE = -2;
function $413a30192b54574f$var$genId() {
    return $413a30192b54574f$var$_id++;
}
function $413a30192b54574f$var$getValidTagName$1(element) {
    if ($413a30192b54574f$var$_instanceof(element, HTMLFormElement)) return "form";
    var processedTagName = $413a30192b54574f$var$toLowerCase(element.tagName);
    if ($413a30192b54574f$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
var $413a30192b54574f$var$canvasService;
var $413a30192b54574f$var$canvasCtx;
var $413a30192b54574f$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
var $413a30192b54574f$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $413a30192b54574f$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    var pos = 0;
    function collectCharacters(regEx) {
        var chars2;
        var match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    var output = [];
    while(true){
        collectCharacters($413a30192b54574f$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        var url = collectCharacters($413a30192b54574f$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $413a30192b54574f$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            var descriptorsStr = "";
            url = $413a30192b54574f$var$absoluteToDoc(doc, url);
            var inParens = false;
            while(true){
                var c2 = attributeValue.charAt(pos);
                if (c2 === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c2 === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c2 === "(") inParens = true;
                } else if (c2 === ")") inParens = false;
                descriptorsStr += c2;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
var $413a30192b54574f$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $413a30192b54574f$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $413a30192b54574f$var$getHref(doc, attributeValue);
}
function $413a30192b54574f$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $413a30192b54574f$var$getHref(doc, customHref) {
    var a2 = $413a30192b54574f$var$cachedDocument.get(doc);
    if (!a2) {
        a2 = doc.createElement("a");
        $413a30192b54574f$var$cachedDocument.set(doc, a2);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a2.setAttribute("href", customHref);
    return a2.href;
}
function $413a30192b54574f$var$transformAttribute(doc, tagName, name, value) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $413a30192b54574f$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $413a30192b54574f$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $413a30192b54574f$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $413a30192b54574f$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $413a30192b54574f$var$absolutifyURLs(value, $413a30192b54574f$var$getHref(doc));
    else if (tagName === "object" && name === "data") return $413a30192b54574f$var$absoluteToDoc(doc, value);
    return value;
}
function $413a30192b54574f$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $413a30192b54574f$var$_isBlockedElement(element, blockClass, blockSelector) {
    try {
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(var eIndex = element.classList.length; eIndex--;){
            var className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e2) {}
    return false;
}
function $413a30192b54574f$var$classMatchesRegex(node2, regex, checkAncestors) {
    if (!node2) return false;
    if (node2.nodeType !== node2.ELEMENT_NODE) {
        if (!checkAncestors) return false;
        return $413a30192b54574f$var$classMatchesRegex($413a30192b54574f$var$index$1.parentNode(node2), regex, checkAncestors);
    }
    for(var eIndex = node2.classList.length; eIndex--;){
        var className = node2.classList[eIndex];
        if (regex.test(className)) return true;
    }
    if (!checkAncestors) return false;
    return $413a30192b54574f$var$classMatchesRegex($413a30192b54574f$var$index$1.parentNode(node2), regex, checkAncestors);
}
function $413a30192b54574f$var$needMaskingText(node2, maskTextClass, maskTextSelector, checkAncestors) {
    var el;
    if ($413a30192b54574f$var$isElement(node2)) {
        el = node2;
        if (!$413a30192b54574f$var$index$1.childNodes(el).length) return false;
    } else if ($413a30192b54574f$var$index$1.parentElement(node2) === null) return false;
    else el = $413a30192b54574f$var$index$1.parentElement(node2);
    try {
        if (typeof maskTextClass === "string") {
            if (checkAncestors) {
                if (el.closest("." + maskTextClass)) return true;
            } else {
                if (el.classList.contains(maskTextClass)) return true;
            }
        } else {
            if ($413a30192b54574f$var$classMatchesRegex(el, maskTextClass, checkAncestors)) return true;
        }
        if (maskTextSelector) {
            if (checkAncestors) {
                if (el.closest(maskTextSelector)) return true;
            } else {
                if (el.matches(maskTextSelector)) return true;
            }
        }
    } catch (e2) {}
    return false;
}
function $413a30192b54574f$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    var win = iframeEl.contentWindow;
    if (!win) return;
    var fired = false;
    var readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        var timer = setTimeout(function() {
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", function() {
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    var blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $413a30192b54574f$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    var fired = false;
    var styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    var timer = setTimeout(function() {
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", function() {
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $413a30192b54574f$var$serializeNode(n2, options) {
    var doc = options.doc, mirror2 = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, needsMask = options.needsMask, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, _options_cssCaptured = options.cssCaptured, cssCaptured = _options_cssCaptured === void 0 ? false : _options_cssCaptured;
    var rootId = $413a30192b54574f$var$getRootId(doc, mirror2);
    switch(n2.nodeType){
        case n2.DOCUMENT_NODE:
            if (n2.compatMode !== "CSS1Compat") return {
                type: $413a30192b54574f$var$NodeType$3.Document,
                childNodes: [],
                compatMode: n2.compatMode
            };
            else return {
                type: $413a30192b54574f$var$NodeType$3.Document,
                childNodes: []
            };
        case n2.DOCUMENT_TYPE_NODE:
            return {
                type: $413a30192b54574f$var$NodeType$3.DocumentType,
                name: n2.name,
                publicId: n2.publicId,
                systemId: n2.systemId,
                rootId: rootId
            };
        case n2.ELEMENT_NODE:
            return $413a30192b54574f$var$serializeElementNode(n2, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId
            });
        case n2.TEXT_NODE:
            return $413a30192b54574f$var$serializeTextNode(n2, {
                doc: doc,
                needsMask: needsMask,
                maskTextFn: maskTextFn,
                rootId: rootId,
                cssCaptured: cssCaptured
            });
        case n2.CDATA_SECTION_NODE:
            return {
                type: $413a30192b54574f$var$NodeType$3.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n2.COMMENT_NODE:
            return {
                type: $413a30192b54574f$var$NodeType$3.Comment,
                textContent: $413a30192b54574f$var$index$1.textContent(n2) || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $413a30192b54574f$var$getRootId(doc, mirror2) {
    if (!mirror2.hasNode(doc)) return void 0;
    var docId = mirror2.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $413a30192b54574f$var$serializeTextNode(n2, options) {
    var needsMask = options.needsMask, maskTextFn = options.maskTextFn, rootId = options.rootId, cssCaptured = options.cssCaptured;
    var parent = $413a30192b54574f$var$index$1.parentNode(n2);
    var parentTagName = parent && parent.tagName;
    var textContent2 = "";
    var isStyle = parentTagName === "STYLE" ? true : void 0;
    var isScript = parentTagName === "SCRIPT" ? true : void 0;
    if (isScript) textContent2 = "SCRIPT_PLACEHOLDER";
    else if (!cssCaptured) {
        textContent2 = $413a30192b54574f$var$index$1.textContent(n2);
        if (isStyle && textContent2) textContent2 = $413a30192b54574f$var$absolutifyURLs(textContent2, $413a30192b54574f$var$getHref(options.doc));
    }
    if (!isStyle && !isScript && textContent2 && needsMask) textContent2 = maskTextFn ? maskTextFn(textContent2, $413a30192b54574f$var$index$1.parentElement(n2)) : textContent2.replace(/[\S]/g, "*");
    return {
        type: $413a30192b54574f$var$NodeType$3.Text,
        textContent: textContent2 || "",
        rootId: rootId
    };
}
function $413a30192b54574f$var$serializeElementNode(n2, options) {
    var doc = options.doc, blockClass = options.blockClass, blockSelector = options.blockSelector, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, rootId = options.rootId;
    var needBlock = $413a30192b54574f$var$_isBlockedElement(n2, blockClass, blockSelector);
    var tagName = $413a30192b54574f$var$getValidTagName$1(n2);
    var attributes = {};
    var len = n2.attributes.length;
    for(var i2 = 0; i2 < len; i2++){
        var attr = n2.attributes[i2];
        if (!$413a30192b54574f$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $413a30192b54574f$var$transformAttribute(doc, tagName, $413a30192b54574f$var$toLowerCase(attr.name), attr.value);
    }
    if (tagName === "link" && inlineStylesheet) {
        var stylesheet = Array.from(doc.styleSheets).find(function(s2) {
            return s2.href === n2.href;
        });
        var cssText = null;
        if (stylesheet) cssText = $413a30192b54574f$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = cssText;
        }
    }
    if (tagName === "style" && n2.sheet) {
        var cssText1 = $413a30192b54574f$var$stringifyStylesheet(n2.sheet);
        if (cssText1) {
            if (n2.childNodes.length > 1) cssText1 = $413a30192b54574f$var$markCssSplits(cssText1, n2);
            attributes._cssText = cssText1;
        }
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select") {
        var value = n2.value;
        var checked = n2.checked;
        if (attributes.type !== "radio" && attributes.type !== "checkbox" && attributes.type !== "submit" && attributes.type !== "button" && value) attributes.value = $413a30192b54574f$var$maskInputValue({
            element: n2,
            type: $413a30192b54574f$var$getInputType(n2),
            tagName: tagName,
            value: value,
            maskInputOptions: maskInputOptions,
            maskInputFn: maskInputFn
        });
        else if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n2.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "dialog" && n2.open) attributes.rr_open_mode = n2.matches("dialog:modal") ? "modal" : "non-modal";
    if (tagName === "canvas" && recordCanvas) {
        if (n2.__context === "2d") {
            if (!$413a30192b54574f$var$is2DCanvasBlank(n2)) attributes.rr_dataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n2)) {
            var canvasDataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            var blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n2.width;
            blankCanvas.height = n2.height;
            var blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$413a30192b54574f$var$canvasService) {
            $413a30192b54574f$var$canvasService = doc.createElement("canvas");
            $413a30192b54574f$var$canvasCtx = $413a30192b54574f$var$canvasService.getContext("2d");
        }
        var image = n2;
        var imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        var priorCrossOrigin = image.crossOrigin;
        var recordInlineImage = function() {
            image.removeEventListener("load", recordInlineImage);
            try {
                $413a30192b54574f$var$canvasService.width = image.naturalWidth;
                $413a30192b54574f$var$canvasService.height = image.naturalHeight;
                $413a30192b54574f$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $413a30192b54574f$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn("Cannot inline img src=" + imageSrc + "! Error: " + err);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        var mediaAttributes = attributes;
        mediaAttributes.rr_mediaState = n2.paused ? "paused" : "played";
        mediaAttributes.rr_mediaCurrentTime = n2.currentTime;
        mediaAttributes.rr_mediaPlaybackRate = n2.playbackRate;
        mediaAttributes.rr_mediaMuted = n2.muted;
        mediaAttributes.rr_mediaLoop = n2.loop;
        mediaAttributes.rr_mediaVolume = n2.volume;
    }
    if (!newlyAddedElement) {
        if (n2.scrollLeft) attributes.rr_scrollLeft = n2.scrollLeft;
        if (n2.scrollTop) attributes.rr_scrollTop = n2.scrollTop;
    }
    if (needBlock) {
        var _n2_getBoundingClientRect = n2.getBoundingClientRect(), width = _n2_getBoundingClientRect.width, height = _n2_getBoundingClientRect.height;
        attributes = {
            class: attributes.class,
            rr_width: "" + width + "px",
            rr_height: "" + height + "px"
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n2.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    var isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e2) {}
    return {
        type: $413a30192b54574f$var$NodeType$3.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $413a30192b54574f$var$isSVGElement(n2) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $413a30192b54574f$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $413a30192b54574f$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $413a30192b54574f$var$NodeType$3.Comment) return true;
    else if (sn.type === $413a30192b54574f$var$NodeType$3.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" && sn.attributes.as === "script" || sn.attributes.rel === "modulepreload") || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $413a30192b54574f$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($413a30192b54574f$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "application-name" || $413a30192b54574f$var$lowerIfExists(sn.attributes.rel) === "icon" || $413a30192b54574f$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $413a30192b54574f$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $413a30192b54574f$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($413a30192b54574f$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $413a30192b54574f$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "robots" || $413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "googlebot" || $413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "author" || $413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "generator" || $413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "framework" || $413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "publisher" || $413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "progid" || $413a30192b54574f$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $413a30192b54574f$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "verification" || $413a30192b54574f$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $413a30192b54574f$var$serializeNodeWithId(n2, options) {
    var doc = options.doc, mirror2 = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, maskTextClass = options.maskTextClass, maskTextSelector = options.maskTextSelector, _options_skipChild = options.skipChild, skipChild = _options_skipChild === void 0 ? false : _options_skipChild, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, slimDOMOptions = options.slimDOMOptions, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, onSerialize = options.onSerialize, onIframeLoad = options.onIframeLoad, _options_iframeLoadTimeout = options.iframeLoadTimeout, iframeLoadTimeout = _options_iframeLoadTimeout === void 0 ? 5e3 : _options_iframeLoadTimeout, onStylesheetLoad = options.onStylesheetLoad, _options_stylesheetLoadTimeout = options.stylesheetLoadTimeout, stylesheetLoadTimeout = _options_stylesheetLoadTimeout === void 0 ? 5e3 : _options_stylesheetLoadTimeout, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, _options_cssCaptured = options.cssCaptured, cssCaptured = _options_cssCaptured === void 0 ? false : _options_cssCaptured;
    var needsMask = options.needsMask;
    var _options_preserveWhiteSpace = options.preserveWhiteSpace, preserveWhiteSpace = _options_preserveWhiteSpace === void 0 ? true : _options_preserveWhiteSpace;
    if (!needsMask) {
        var checkAncestors = needsMask === void 0;
        needsMask = $413a30192b54574f$var$needMaskingText(n2, maskTextClass, maskTextSelector, checkAncestors);
    }
    var _serializedNode = $413a30192b54574f$var$serializeNode(n2, {
        doc: doc,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        needsMask: needsMask,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        cssCaptured: cssCaptured
    });
    if (!_serializedNode) {
        console.warn(n2, "not serialized");
        return null;
    }
    var id;
    if (mirror2.hasNode(n2)) id = mirror2.getId(n2);
    else if ($413a30192b54574f$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $413a30192b54574f$var$NodeType$3.Text && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $413a30192b54574f$var$IGNORED_NODE;
    else id = $413a30192b54574f$var$genId();
    var serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror2.add(n2, serializedNode);
    if (id === $413a30192b54574f$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n2);
    var recordChild = !skipChild;
    if (serializedNode.type === $413a30192b54574f$var$NodeType$3.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        var shadowRootEl = $413a30192b54574f$var$index$1.shadowRoot(n2);
        if (shadowRootEl && $413a30192b54574f$var$isNativeShadowDom(shadowRootEl)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $413a30192b54574f$var$NodeType$3.Document || serializedNode.type === $413a30192b54574f$var$NodeType$3.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $413a30192b54574f$var$NodeType$3.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        var bypassOptions = {
            doc: doc,
            mirror: mirror2,
            blockClass: blockClass,
            blockSelector: blockSelector,
            needsMask: needsMask,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn,
            cssCaptured: false
        };
        if (serializedNode.type === $413a30192b54574f$var$NodeType$3.Element && serializedNode.tagName === "textarea" && serializedNode.attributes.value !== void 0) ;
        else {
            if (serializedNode.type === $413a30192b54574f$var$NodeType$3.Element && serializedNode.attributes._cssText !== void 0 && typeof serializedNode.attributes._cssText === "string") bypassOptions.cssCaptured = true;
            for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(Array.from($413a30192b54574f$var$index$1.childNodes(n2))), _step; !(_step = _iterator()).done;){
                var childN = _step.value;
                var serializedChildNode = $413a30192b54574f$var$serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
            }
        }
        var shadowRootEl1 = null;
        if ($413a30192b54574f$var$isElement(n2) && (shadowRootEl1 = $413a30192b54574f$var$index$1.shadowRoot(n2))) for(var _iterator1 = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(Array.from($413a30192b54574f$var$index$1.childNodes(shadowRootEl1))), _step1; !(_step1 = _iterator1()).done;){
            var childN1 = _step1.value;
            var serializedChildNode1 = $413a30192b54574f$var$serializeNodeWithId(childN1, bypassOptions);
            if (serializedChildNode1) {
                $413a30192b54574f$var$isNativeShadowDom(shadowRootEl1) && (serializedChildNode1.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode1);
            }
        }
    }
    var parent = $413a30192b54574f$var$index$1.parentNode(n2);
    if (parent && $413a30192b54574f$var$isShadowRoot(parent) && $413a30192b54574f$var$isNativeShadowDom(parent)) serializedNode.isShadow = true;
    if (serializedNode.type === $413a30192b54574f$var$NodeType$3.Element && serializedNode.tagName === "iframe") $413a30192b54574f$var$onceIframeLoaded(n2, function() {
        var iframeDoc = n2.contentDocument;
        if (iframeDoc && onIframeLoad) {
            var serializedIframeNode = $413a30192b54574f$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n2, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $413a30192b54574f$var$NodeType$3.Element && serializedNode.tagName === "link" && typeof serializedNode.attributes.rel === "string" && (serializedNode.attributes.rel === "stylesheet" || serializedNode.attributes.rel === "preload" && typeof serializedNode.attributes.href === "string" && $413a30192b54574f$var$extractFileExtension(serializedNode.attributes.href) === "css")) $413a30192b54574f$var$onceStylesheetLoaded(n2, function() {
        if (onStylesheetLoad) {
            var serializedLinkNode = $413a30192b54574f$var$serializeNodeWithId(n2, {
                doc: doc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n2, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $413a30192b54574f$var$snapshot(n2, options) {
    var _ref = options || {}, tmp = _ref.mirror, mirror2 = tmp === void 0 ? new $413a30192b54574f$var$Mirror() : tmp, _ref_blockClass = _ref.blockClass, blockClass = _ref_blockClass === void 0 ? "rr-block" : _ref_blockClass, _ref_blockSelector = _ref.blockSelector, blockSelector = _ref_blockSelector === void 0 ? null : _ref_blockSelector, _ref_maskTextClass = _ref.maskTextClass, maskTextClass = _ref_maskTextClass === void 0 ? "rr-mask" : _ref_maskTextClass, _ref_maskTextSelector = _ref.maskTextSelector, maskTextSelector = _ref_maskTextSelector === void 0 ? null : _ref_maskTextSelector, _ref_inlineStylesheet = _ref.inlineStylesheet, inlineStylesheet = _ref_inlineStylesheet === void 0 ? true : _ref_inlineStylesheet, _ref_inlineImages = _ref.inlineImages, inlineImages = _ref_inlineImages === void 0 ? false : _ref_inlineImages, _ref_recordCanvas = _ref.recordCanvas, recordCanvas = _ref_recordCanvas === void 0 ? false : _ref_recordCanvas, _ref_maskAllInputs = _ref.maskAllInputs, maskAllInputs = _ref_maskAllInputs === void 0 ? false : _ref_maskAllInputs, maskTextFn = _ref.maskTextFn, maskInputFn = _ref.maskInputFn, _ref_slimDOM = _ref.slimDOM, slimDOM = _ref_slimDOM === void 0 ? false : _ref_slimDOM, dataURLOptions = _ref.dataURLOptions, preserveWhiteSpace = _ref.preserveWhiteSpace, onSerialize = _ref.onSerialize, onIframeLoad = _ref.onIframeLoad, iframeLoadTimeout = _ref.iframeLoadTimeout, onStylesheetLoad = _ref.onStylesheetLoad, stylesheetLoadTimeout = _ref.stylesheetLoadTimeout, _ref_keepIframeSrcFn = _ref.keepIframeSrcFn, keepIframeSrcFn = _ref_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _ref_keepIframeSrcFn;
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true,
        hidden: true
    } : maskAllInputs === false ? {
        password: true
    } : maskAllInputs;
    var slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $413a30192b54574f$var$serializeNodeWithId(n2, {
        doc: n2,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $413a30192b54574f$var$getDefaultExportFromCjs$1(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function $413a30192b54574f$var$getAugmentedNamespace$1(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a22() {
            if ($413a30192b54574f$var$_instanceof(this, a22)) return Reflect.construct(f2, arguments, this.constructor);
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n2, k);
        Object.defineProperty(a2, k, d.get ? d : {
            enumerable: true,
            get: function get() {
                return n2[k];
            }
        });
    });
    return a2;
}
var $413a30192b54574f$var$picocolors_browser$1 = {
    exports: {}
};
var $413a30192b54574f$var$x$1 = String;
var $413a30192b54574f$var$create$1 = function create$1() {
    return {
        isColorSupported: false,
        reset: $413a30192b54574f$var$x$1,
        bold: $413a30192b54574f$var$x$1,
        dim: $413a30192b54574f$var$x$1,
        italic: $413a30192b54574f$var$x$1,
        underline: $413a30192b54574f$var$x$1,
        inverse: $413a30192b54574f$var$x$1,
        hidden: $413a30192b54574f$var$x$1,
        strikethrough: $413a30192b54574f$var$x$1,
        black: $413a30192b54574f$var$x$1,
        red: $413a30192b54574f$var$x$1,
        green: $413a30192b54574f$var$x$1,
        yellow: $413a30192b54574f$var$x$1,
        blue: $413a30192b54574f$var$x$1,
        magenta: $413a30192b54574f$var$x$1,
        cyan: $413a30192b54574f$var$x$1,
        white: $413a30192b54574f$var$x$1,
        gray: $413a30192b54574f$var$x$1,
        bgBlack: $413a30192b54574f$var$x$1,
        bgRed: $413a30192b54574f$var$x$1,
        bgGreen: $413a30192b54574f$var$x$1,
        bgYellow: $413a30192b54574f$var$x$1,
        bgBlue: $413a30192b54574f$var$x$1,
        bgMagenta: $413a30192b54574f$var$x$1,
        bgCyan: $413a30192b54574f$var$x$1,
        bgWhite: $413a30192b54574f$var$x$1
    };
};
$413a30192b54574f$var$picocolors_browser$1.exports = $413a30192b54574f$var$create$1();
$413a30192b54574f$var$picocolors_browser$1.exports.createColors = $413a30192b54574f$var$create$1;
var $413a30192b54574f$var$picocolors_browserExports$1 = $413a30192b54574f$var$picocolors_browser$1.exports;
var $413a30192b54574f$var$__viteBrowserExternal$2 = {};
var $413a30192b54574f$var$__viteBrowserExternal$1$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $413a30192b54574f$var$__viteBrowserExternal$2
}, Symbol.toStringTag, {
    value: "Module"
}));
var $413a30192b54574f$var$require$$2$1 = /* @__PURE__ */ $413a30192b54574f$var$getAugmentedNamespace$1($413a30192b54574f$var$__viteBrowserExternal$1$1);
var $413a30192b54574f$var$pico$1 = $413a30192b54574f$var$picocolors_browserExports$1;
var $413a30192b54574f$var$terminalHighlight$1$1 = $413a30192b54574f$var$require$$2$1;
var $413a30192b54574f$var$CssSyntaxError$3$1 = /*#__PURE__*/ function(Error1) {
    $413a30192b54574f$var$_inherits(CssSyntaxError, Error1);
    function CssSyntaxError(message, line, column, source, file, plugin22) {
        var _this;
        _this = Error1.call(this, message) || this;
        _this.name = "CssSyntaxError";
        _this.reason = message;
        if (file) _this.file = file;
        if (source) _this.source = source;
        if (plugin22) _this.plugin = plugin22;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                _this.line = line;
                _this.column = column;
            } else {
                _this.line = line.line;
                _this.column = line.column;
                _this.endLine = column.line;
                _this.endColumn = column.column;
            }
        }
        _this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(_this, CssSyntaxError);
        return _this;
    }
    var _proto = CssSyntaxError.prototype;
    _proto.setMessage = function setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    };
    _proto.showSourceCode = function showSourceCode(color) {
        var _this = this;
        if (!this.source) return "";
        var css = this.source;
        if (color == null) color = $413a30192b54574f$var$pico$1.isColorSupported;
        if ($413a30192b54574f$var$terminalHighlight$1$1) {
            if (color) css = $413a30192b54574f$var$terminalHighlight$1$1(css);
        }
        var lines = css.split(/\r?\n/);
        var start = Math.max(this.line - 3, 0);
        var end = Math.min(this.line + 2, lines.length);
        var maxWidth = String(end).length;
        var mark, aside;
        if (color) {
            var _pico$1_createColors = $413a30192b54574f$var$pico$1.createColors(true), bold = _pico$1_createColors.bold, gray = _pico$1_createColors.gray, red = _pico$1_createColors.red;
            mark = function(text) {
                return bold(red(text));
            };
            aside = function(text) {
                return gray(text);
            };
        } else mark = aside = function(str) {
            return str;
        };
        return lines.slice(start, end).map(function(line, index2) {
            var number = start + 1 + index2;
            var gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === _this.line) {
                var spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, _this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    };
    _proto.toString = function toString() {
        var code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    };
    return CssSyntaxError;
}($413a30192b54574f$var$_wrap_native_super(Error));
var $413a30192b54574f$var$cssSyntaxError$1 = $413a30192b54574f$var$CssSyntaxError$3$1;
$413a30192b54574f$var$CssSyntaxError$3$1.default = $413a30192b54574f$var$CssSyntaxError$3$1;
var $413a30192b54574f$var$symbols$1 = {};
$413a30192b54574f$var$symbols$1.isClean = Symbol("isClean");
$413a30192b54574f$var$symbols$1.my = Symbol("my");
var $413a30192b54574f$var$DEFAULT_RAW$1 = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $413a30192b54574f$var$capitalize$1(str) {
    return str[0].toUpperCase() + str.slice(1);
}
var $413a30192b54574f$var$Stringifier$2$1 = /*#__PURE__*/ function() {
    function Stringifier(builder) {
        this.builder = builder;
    }
    var _proto = Stringifier.prototype;
    _proto.atrule = function atrule(node2, semicolon) {
        var name = "@" + node2.name;
        var params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") name += node2.raws.afterName;
        else if (params) name += " ";
        if (node2.nodes) this.block(node2, name + params);
        else {
            var end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    };
    _proto.beforeAfter = function beforeAfter(node2, detect) {
        var value;
        if (node2.type === "decl") value = this.raw(node2, null, "beforeDecl");
        else if (node2.type === "comment") value = this.raw(node2, null, "beforeComment");
        else if (detect === "before") value = this.raw(node2, null, "beforeRule");
        else value = this.raw(node2, null, "beforeClose");
        var buf = node2.parent;
        var depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            var indent = this.raw(node2, null, "indent");
            if (indent.length) for(var step = 0; step < depth; step++)value += indent;
        }
        return value;
    };
    _proto.block = function block(node2, start) {
        var between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        var after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else after = this.raw(node2, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    };
    _proto.body = function body(node2) {
        var last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        var semicolon = this.raw(node2, "semicolon");
        for(var i2 = 0; i2 < node2.nodes.length; i2++){
            var child = node2.nodes[i2];
            var before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i2 || semicolon);
        }
    };
    _proto.comment = function comment(node2) {
        var left = this.raw(node2, "left", "commentLeft");
        var right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    };
    _proto.decl = function decl(node2, semicolon) {
        var between = this.raw(node2, "between", "colon");
        var string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) string += node2.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node2);
    };
    _proto.document = function document1(node2) {
        this.body(node2);
    };
    _proto.raw = function raw(node2, own, detect) {
        var value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        var parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) return "";
            if (parent && parent.type === "document") return "";
        }
        if (!parent) return $413a30192b54574f$var$DEFAULT_RAW$1[detect];
        var root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") return root2.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node2, detect);
        else {
            var method = "raw" + $413a30192b54574f$var$capitalize$1(detect);
            if (this[method]) value = this[method](root2, node2);
            else root2.walk(function(i2) {
                value = i2.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $413a30192b54574f$var$DEFAULT_RAW$1[detect];
        root2.rawCache[detect] = value;
        return value;
    };
    _proto.rawBeforeClose = function rawBeforeClose(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length > 0) {
                if (typeof i2.raws.after !== "undefined") {
                    value = i2.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeComment = function rawBeforeComment(root2, node2) {
        var value;
        root2.walkComments(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeDecl = function rawBeforeDecl(root2, node2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeOpen = function rawBeforeOpen(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.type !== "decl") {
                value = i2.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawBeforeRule = function rawBeforeRule(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
                if (typeof i2.raws.before !== "undefined") {
                    value = i2.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawColon = function rawColon(root2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.between !== "undefined") {
                value = i2.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    };
    _proto.rawEmptyBody = function rawEmptyBody(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length === 0) {
                value = i2.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawIndent = function rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        var value;
        root2.walk(function(i2) {
            var p = i2.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i2.raws.before !== "undefined") {
                    var parts = i2.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    };
    _proto.rawSemicolon = function rawSemicolon(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
                value = i2.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawValue = function rawValue(node2, prop) {
        var value = node2[prop];
        var raw = node2.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    };
    _proto.root = function root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    };
    _proto.rule = function rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) this.builder(node2.raws.ownSemicolon, node2, "end");
    };
    _proto.stringify = function stringify(node2, semicolon) {
        if (!this[node2.type]) throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        this[node2.type](node2, semicolon);
    };
    return Stringifier;
}();
var $413a30192b54574f$var$stringifier$1 = $413a30192b54574f$var$Stringifier$2$1;
$413a30192b54574f$var$Stringifier$2$1.default = $413a30192b54574f$var$Stringifier$2$1;
var $413a30192b54574f$var$Stringifier$1$1 = $413a30192b54574f$var$stringifier$1;
function $413a30192b54574f$var$stringify$4$1(node2, builder) {
    var str = new $413a30192b54574f$var$Stringifier$1$1(builder);
    str.stringify(node2);
}
var $413a30192b54574f$var$stringify_1$1 = $413a30192b54574f$var$stringify$4$1;
$413a30192b54574f$var$stringify$4$1.default = $413a30192b54574f$var$stringify$4$1;
var $413a30192b54574f$var$isClean$2$1 = $413a30192b54574f$var$symbols$1.isClean, $413a30192b54574f$var$my$2$1 = $413a30192b54574f$var$symbols$1.my;
var $413a30192b54574f$var$CssSyntaxError$2$1 = $413a30192b54574f$var$cssSyntaxError$1;
var $413a30192b54574f$var$Stringifier2$1 = $413a30192b54574f$var$stringifier$1;
var $413a30192b54574f$var$stringify$3$1 = $413a30192b54574f$var$stringify_1$1;
function $413a30192b54574f$var$cloneNode$1(obj, parent) {
    var cloned = new obj.constructor();
    for(var i2 in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i2)) continue;
        if (i2 === "proxyCache") continue;
        var value = obj[i2];
        var type = typeof value === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(value);
        if (i2 === "parent" && type === "object") {
            if (parent) cloned[i2] = parent;
        } else if (i2 === "source") cloned[i2] = value;
        else if (Array.isArray(value)) cloned[i2] = value.map(function(j) {
            return $413a30192b54574f$var$cloneNode$1(j, cloned);
        });
        else {
            if (type === "object" && value !== null) value = $413a30192b54574f$var$cloneNode$1(value);
            cloned[i2] = value;
        }
    }
    return cloned;
}
var $413a30192b54574f$var$Node$4$1 = /*#__PURE__*/ function() {
    function Node2(defaults) {
        if (defaults === void 0) defaults = {};
        this.raws = {};
        this[$413a30192b54574f$var$isClean$2$1] = false;
        this[$413a30192b54574f$var$my$2$1] = true;
        for(var name in defaults)if (name === "nodes") {
            this.nodes = [];
            for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(defaults[name]), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (typeof node2.clone === "function") this.append(node2.clone());
                else this.append(node2);
            }
        } else this[name] = defaults[name];
    }
    var _proto = Node2.prototype;
    _proto.addToError = function addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            var s2 = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, "$&" + s2.input.from + ":" + s2.start.line + ":" + s2.start.column + "$&");
        }
        return error;
    };
    _proto.after = function after(add) {
        this.parent.insertAfter(this, add);
        return this;
    };
    _proto.assign = function assign(overrides) {
        if (overrides === void 0) overrides = {};
        for(var name in overrides)this[name] = overrides[name];
        return this;
    };
    _proto.before = function before(add) {
        this.parent.insertBefore(this, add);
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    };
    _proto.clone = function clone(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = $413a30192b54574f$var$cloneNode$1(this);
        for(var name in overrides)cloned[name] = overrides[name];
        return cloned;
    };
    _proto.cloneAfter = function cloneAfter(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    };
    _proto.cloneBefore = function cloneBefore(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    };
    _proto.error = function error(message, opts) {
        if (opts === void 0) opts = {};
        if (this.source) {
            var _this_rangeBy = this.rangeBy(opts), end = _this_rangeBy.end, start = _this_rangeBy.start;
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $413a30192b54574f$var$CssSyntaxError$2$1(message);
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node2.markDirty();
                return true;
            }
        };
    };
    _proto.markDirty = function markDirty() {
        if (this[$413a30192b54574f$var$isClean$2$1]) {
            this[$413a30192b54574f$var$isClean$2$1] = false;
            var next = this;
            while(next = next.parent)next[$413a30192b54574f$var$isClean$2$1] = false;
        }
    };
    _proto.next = function next() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    };
    _proto.positionBy = function positionBy(opts, stringRepresentation) {
        var pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    };
    _proto.positionInside = function positionInside(index2, stringRepresentation) {
        var string = stringRepresentation || this.toString();
        var column = this.source.start.column;
        var line = this.source.start.line;
        for(var i2 = 0; i2 < index2; i2++)if (string[i2] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    };
    _proto.prev = function prev() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    };
    _proto.rangeBy = function rangeBy(opts) {
        var start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        var end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            var stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === "number") end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    };
    _proto.raw = function raw(prop, defaultType) {
        var str = new $413a30192b54574f$var$Stringifier2$1();
        return str.raw(this, prop, defaultType);
    };
    _proto.remove = function remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = void 0;
        return this;
    };
    _proto.replaceWith = function replaceWith() {
        for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++)nodes[_key] = arguments[_key];
        if (this.parent) {
            var bookmark = this;
            var foundSelf = false;
            for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (node2 === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else this.parent.insertBefore(bookmark, node2);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    };
    _proto.root = function root() {
        var result2 = this;
        while(result2.parent && result2.parent.type !== "document")result2 = result2.parent;
        return result2;
    };
    _proto.toJSON = function toJSON(_, inputs) {
        var fixed = {};
        var emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        var inputsNextIndex = 0;
        for(var name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            var value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map(function(i2) {
                if ((typeof i2 === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(i2)) === "object" && i2.toJSON) return i2.toJSON(null, inputs);
                else return i2;
            });
            else if ((typeof value === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(value)) === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                var inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [].concat(inputs.keys()).map(function(input2) {
            return input2.toJSON();
        });
        return fixed;
    };
    _proto.toProxy = function toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    };
    _proto.toString = function toString(stringifier2) {
        if (stringifier2 === void 0) stringifier2 = $413a30192b54574f$var$stringify$3$1;
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        var result2 = "";
        stringifier2(this, function(i2) {
            result2 += i2;
        });
        return result2;
    };
    _proto.warn = function warn(result2, text, opts) {
        var data = {
            node: this
        };
        for(var i2 in opts)data[i2] = opts[i2];
        return result2.warn(text, data);
    };
    $413a30192b54574f$var$_create_class(Node2, [
        {
            key: "proxyOf",
            get: function get() {
                return this;
            }
        }
    ]);
    return Node2;
}();
var $413a30192b54574f$var$node$1 = $413a30192b54574f$var$Node$4$1;
$413a30192b54574f$var$Node$4$1.default = $413a30192b54574f$var$Node$4$1;
var $413a30192b54574f$var$Node$3$1 = $413a30192b54574f$var$node$1;
var $413a30192b54574f$var$Declaration$4$1 = /*#__PURE__*/ function(Node$3$1) {
    $413a30192b54574f$var$_inherits(Declaration, Node$3$1);
    function Declaration(defaults) {
        var _this;
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = $413a30192b54574f$var$_extends({}, defaults, {
            value: String(defaults.value)
        });
        _this = Node$3$1.call(this, defaults) || this;
        _this.type = "decl";
        return _this;
    }
    $413a30192b54574f$var$_create_class(Declaration, [
        {
            key: "variable",
            get: function get() {
                return this.prop.startsWith("--") || this.prop[0] === "$";
            }
        }
    ]);
    return Declaration;
}($413a30192b54574f$var$Node$3$1);
var $413a30192b54574f$var$declaration$1 = $413a30192b54574f$var$Declaration$4$1;
$413a30192b54574f$var$Declaration$4$1.default = $413a30192b54574f$var$Declaration$4$1;
var $413a30192b54574f$var$urlAlphabet$1 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var $413a30192b54574f$var$nanoid$1$1 = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i2 = size;
    while(i2--)id += $413a30192b54574f$var$urlAlphabet$1[Math.random() * 64 | 0];
    return id;
};
var $413a30192b54574f$var$nonSecure$1 = {
    nanoid: $413a30192b54574f$var$nanoid$1$1
};
var $413a30192b54574f$var$SourceMapConsumer$2$1 = $413a30192b54574f$var$require$$2$1.SourceMapConsumer, $413a30192b54574f$var$SourceMapGenerator$2$1 = $413a30192b54574f$var$require$$2$1.SourceMapGenerator;
var $413a30192b54574f$var$existsSync$1 = $413a30192b54574f$var$require$$2$1.existsSync, $413a30192b54574f$var$readFileSync$1 = $413a30192b54574f$var$require$$2$1.readFileSync;
var $413a30192b54574f$var$dirname$1$1 = $413a30192b54574f$var$require$$2$1.dirname, $413a30192b54574f$var$join$1 = $413a30192b54574f$var$require$$2$1.join;
function $413a30192b54574f$var$fromBase64$1(str) {
    if ($413a30192b54574f$require$Buffer) return $413a30192b54574f$require$Buffer.from(str, "base64").toString();
    else return window.atob(str);
}
var $413a30192b54574f$var$PreviousMap$2$1 = /*#__PURE__*/ function() {
    function PreviousMap(css, opts) {
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        var prev = opts.map ? opts.map.prev : void 0;
        var text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $413a30192b54574f$var$dirname$1$1(this.mapFile);
        if (text) this.text = text;
    }
    var _proto = PreviousMap.prototype;
    _proto.consumer = function consumer() {
        if (!this.consumerCache) this.consumerCache = new $413a30192b54574f$var$SourceMapConsumer$2$1(this.text);
        return this.consumerCache;
    };
    _proto.decodeInline = function decodeInline(text) {
        var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        var baseUri = /^data:application\/json;base64,/;
        var charsetUri = /^data:application\/json;charset=utf-?8,/;
        var uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $413a30192b54574f$var$fromBase64$1(text.substr(RegExp.lastMatch.length));
        var encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    };
    _proto.getAnnotationURL = function getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    };
    _proto.isMap = function isMap(map) {
        if ((typeof map === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(map)) !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    };
    _proto.loadAnnotation = function loadAnnotation(css) {
        var comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        var start = css.lastIndexOf(comments.pop());
        var end = css.indexOf("*/", start);
        if (start > -1 && end > -1) this.annotation = this.getAnnotationURL(css.substring(start, end));
    };
    _proto.loadFile = function loadFile(path) {
        this.root = $413a30192b54574f$var$dirname$1$1(path);
        if ($413a30192b54574f$var$existsSync$1(path)) {
            this.mapFile = path;
            return $413a30192b54574f$var$readFileSync$1(path, "utf-8").toString().trim();
        }
    };
    _proto.loadMap = function loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                var prevPath = prev(file);
                if (prevPath) {
                    var map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if ($413a30192b54574f$var$_instanceof(prev, $413a30192b54574f$var$SourceMapConsumer$2$1)) return $413a30192b54574f$var$SourceMapGenerator$2$1.fromSourceMap(prev).toString();
            else if ($413a30192b54574f$var$_instanceof(prev, $413a30192b54574f$var$SourceMapGenerator$2$1)) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            var map1 = this.annotation;
            if (file) map1 = $413a30192b54574f$var$join$1($413a30192b54574f$var$dirname$1$1(file), map1);
            return this.loadFile(map1);
        }
    };
    _proto.startWith = function startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    };
    _proto.withContent = function withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    };
    return PreviousMap;
}();
var $413a30192b54574f$var$previousMap$1 = $413a30192b54574f$var$PreviousMap$2$1;
$413a30192b54574f$var$PreviousMap$2$1.default = $413a30192b54574f$var$PreviousMap$2$1;
var $413a30192b54574f$var$SourceMapConsumer$1$1 = $413a30192b54574f$var$require$$2$1.SourceMapConsumer, $413a30192b54574f$var$SourceMapGenerator$1$1 = $413a30192b54574f$var$require$$2$1.SourceMapGenerator;
var $413a30192b54574f$var$fileURLToPath$1 = $413a30192b54574f$var$require$$2$1.fileURLToPath, $413a30192b54574f$var$pathToFileURL$1$1 = $413a30192b54574f$var$require$$2$1.pathToFileURL;
var $413a30192b54574f$var$isAbsolute$1 = $413a30192b54574f$var$require$$2$1.isAbsolute, $413a30192b54574f$var$resolve$1$1 = $413a30192b54574f$var$require$$2$1.resolve;
var $413a30192b54574f$var$nanoid$2 = $413a30192b54574f$var$nonSecure$1.nanoid;
var $413a30192b54574f$var$terminalHighlight$2 = $413a30192b54574f$var$require$$2$1;
var $413a30192b54574f$var$CssSyntaxError$1$1 = $413a30192b54574f$var$cssSyntaxError$1;
var $413a30192b54574f$var$PreviousMap$1$1 = $413a30192b54574f$var$previousMap$1;
var $413a30192b54574f$var$fromOffsetCache$1 = Symbol("fromOffsetCache");
var $413a30192b54574f$var$sourceMapAvailable$1$1 = Boolean($413a30192b54574f$var$SourceMapConsumer$1$1 && $413a30192b54574f$var$SourceMapGenerator$1$1);
var $413a30192b54574f$var$pathAvailable$1$1 = Boolean($413a30192b54574f$var$resolve$1$1 && $413a30192b54574f$var$isAbsolute$1);
var $413a30192b54574f$var$Input$4$1 = /*#__PURE__*/ function() {
    function Input(css, opts) {
        if (opts === void 0) opts = {};
        if (css === null || typeof css === "undefined" || (typeof css === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(css)) === "object" && !css.toString) throw new Error("PostCSS received " + css + " instead of CSS string");
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$413a30192b54574f$var$pathAvailable$1$1 || /^\w+:\/\//.test(opts.from) || $413a30192b54574f$var$isAbsolute$1(opts.from)) this.file = opts.from;
            else this.file = $413a30192b54574f$var$resolve$1$1(opts.from);
        }
        if ($413a30192b54574f$var$pathAvailable$1$1 && $413a30192b54574f$var$sourceMapAvailable$1$1) {
            var map = new $413a30192b54574f$var$PreviousMap$1$1(this.css, opts);
            if (map.text) {
                this.map = map;
                var file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $413a30192b54574f$var$nanoid$2(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    var _proto = Input.prototype;
    _proto.error = function error(message, line, column, opts) {
        if (opts === void 0) opts = {};
        var result2, endLine, endColumn;
        if (line && (typeof line === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(line)) === "object") {
            var start = line;
            var end = column;
            if (typeof start.offset === "number") {
                var pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                var pos1 = this.fromOffset(end.offset);
                endLine = pos1.line;
                endColumn = pos1.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            var pos2 = this.fromOffset(line);
            line = pos2.line;
            column = pos2.col;
        }
        var origin = this.origin(line, column, endLine, endColumn);
        if (origin) result2 = new $413a30192b54574f$var$CssSyntaxError$1$1(message, origin.endLine === void 0 ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === void 0 ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result2 = new $413a30192b54574f$var$CssSyntaxError$1$1(message, endLine === void 0 ? line : {
            column: column,
            line: line
        }, endLine === void 0 ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result2.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($413a30192b54574f$var$pathToFileURL$1$1) result2.input.url = $413a30192b54574f$var$pathToFileURL$1$1(this.file).toString();
            result2.input.file = this.file;
        }
        return result2;
    };
    _proto.fromOffset = function fromOffset(offset) {
        var lastLine, lineToIndex;
        if (!this[$413a30192b54574f$var$fromOffsetCache$1]) {
            var lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            var prevIndex = 0;
            for(var i2 = 0, l2 = lines.length; i2 < l2; i2++){
                lineToIndex[i2] = prevIndex;
                prevIndex += lines[i2].length + 1;
            }
            this[$413a30192b54574f$var$fromOffsetCache$1] = lineToIndex;
        } else lineToIndex = this[$413a30192b54574f$var$fromOffsetCache$1];
        lastLine = lineToIndex[lineToIndex.length - 1];
        var min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            var max = lineToIndex.length - 2;
            var mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    };
    _proto.mapResolve = function mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $413a30192b54574f$var$resolve$1$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    };
    _proto.origin = function origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        var consumer = this.map.consumer();
        var from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        var to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        var fromUrl;
        if ($413a30192b54574f$var$isAbsolute$1(from.source)) fromUrl = $413a30192b54574f$var$pathToFileURL$1$1(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $413a30192b54574f$var$pathToFileURL$1$1(this.map.mapFile));
        var result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($413a30192b54574f$var$fileURLToPath$1) result2.file = $413a30192b54574f$var$fileURLToPath$1(fromUrl);
            else throw new Error("file: protocol is not available in this PostCSS build");
        }
        var source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    };
    _proto.toJSON = function toJSON() {
        var json = {};
        for(var _i = 0, _iter = [
            "hasBOM",
            "css",
            "file",
            "id"
        ]; _i < _iter.length; _i++){
            var name = _iter[_i];
            if (this[name] != null) json[name] = this[name];
        }
        if (this.map) {
            json.map = $413a30192b54574f$var$_extends({}, this.map);
            if (json.map.consumerCache) json.map.consumerCache = void 0;
        }
        return json;
    };
    $413a30192b54574f$var$_create_class(Input, [
        {
            key: "from",
            get: function get() {
                return this.file || this.id;
            }
        }
    ]);
    return Input;
}();
var $413a30192b54574f$var$input$1 = $413a30192b54574f$var$Input$4$1;
$413a30192b54574f$var$Input$4$1.default = $413a30192b54574f$var$Input$4$1;
if ($413a30192b54574f$var$terminalHighlight$2 && $413a30192b54574f$var$terminalHighlight$2.registerInput) $413a30192b54574f$var$terminalHighlight$2.registerInput($413a30192b54574f$var$Input$4$1);
var $413a30192b54574f$var$SourceMapConsumer$3 = $413a30192b54574f$var$require$$2$1.SourceMapConsumer, $413a30192b54574f$var$SourceMapGenerator$3 = $413a30192b54574f$var$require$$2$1.SourceMapGenerator;
var $413a30192b54574f$var$dirname$2 = $413a30192b54574f$var$require$$2$1.dirname, $413a30192b54574f$var$relative$1 = $413a30192b54574f$var$require$$2$1.relative, $413a30192b54574f$var$resolve$2 = $413a30192b54574f$var$require$$2$1.resolve, $413a30192b54574f$var$sep$1 = $413a30192b54574f$var$require$$2$1.sep;
var $413a30192b54574f$var$pathToFileURL$2 = $413a30192b54574f$var$require$$2$1.pathToFileURL;
var $413a30192b54574f$var$Input$3$1 = $413a30192b54574f$var$input$1;
var $413a30192b54574f$var$sourceMapAvailable$2 = Boolean($413a30192b54574f$var$SourceMapConsumer$3 && $413a30192b54574f$var$SourceMapGenerator$3);
var $413a30192b54574f$var$pathAvailable$2 = Boolean($413a30192b54574f$var$dirname$2 && $413a30192b54574f$var$resolve$2 && $413a30192b54574f$var$relative$1 && $413a30192b54574f$var$sep$1);
var $413a30192b54574f$var$MapGenerator$2$1 = /*#__PURE__*/ function() {
    function MapGenerator(stringify2, root2, opts, cssString) {
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    var _proto = MapGenerator.prototype;
    _proto.addAnnotation = function addAnnotation() {
        var content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        var eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    };
    _proto.applyPrevMaps = function applyPrevMaps() {
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(this.previous()), _step; !(_step = _iterator()).done;){
            var prev = _step.value;
            var from = this.toUrl(this.path(prev.file));
            var root2 = prev.root || $413a30192b54574f$var$dirname$2(prev.file);
            var map = void 0;
            if (this.mapOpts.sourcesContent === false) {
                map = new $413a30192b54574f$var$SourceMapConsumer$3(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    };
    _proto.clearAnnotation = function clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            var node2;
            for(var i2 = this.root.nodes.length - 1; i2 >= 0; i2--){
                node2 = this.root.nodes[i2];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i2);
            }
        } else if (this.css) this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    };
    _proto.generate = function generate() {
        this.clearAnnotation();
        if ($413a30192b54574f$var$pathAvailable$2 && $413a30192b54574f$var$sourceMapAvailable$2 && this.isMap()) return this.generateMap();
        else {
            var result2 = "";
            this.stringify(this.root, function(i2) {
                result2 += i2;
            });
            return [
                result2
            ];
        }
    };
    _proto.generateMap = function generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            var prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $413a30192b54574f$var$SourceMapGenerator$3.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $413a30192b54574f$var$SourceMapGenerator$3({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    };
    _proto.generateString = function generateString() {
        var _this = this;
        this.css = "";
        this.map = new $413a30192b54574f$var$SourceMapGenerator$3({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        var line = 1;
        var column = 1;
        var noSource = "<no source>";
        var mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        var lines, last;
        this.stringify(this.root, function(str, node2, type) {
            _this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = _this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    _this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    _this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node2 && type !== "start") {
                var p = node2.parent || {
                    raws: {}
                };
                var childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = _this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        _this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        _this.map.addMapping(mapping);
                    }
                }
            }
        });
    };
    _proto.isAnnotation = function isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.annotation;
        });
        return true;
    };
    _proto.isInline = function isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        var annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.inline;
        });
        return true;
    };
    _proto.isMap = function isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    };
    _proto.isSourcesContent = function isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.withContent();
        });
        return true;
    };
    _proto.outputFile = function outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    };
    _proto.path = function path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        var cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        var from = this.opts.to ? $413a30192b54574f$var$dirname$2(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $413a30192b54574f$var$dirname$2($413a30192b54574f$var$resolve$2(from, this.mapOpts.annotation));
        var path = $413a30192b54574f$var$relative$1(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    };
    _proto.previous = function previous() {
        var _this = this;
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk(function(node2) {
                if (node2.source && node2.source.input.map) {
                    var map = node2.source.input.map;
                    if (!_this.previousMaps.includes(map)) _this.previousMaps.push(map);
                }
            });
            else {
                var input2 = new $413a30192b54574f$var$Input$3$1(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    };
    _proto.setSourcesContent = function setSourcesContent() {
        var _this = this;
        var already = {};
        if (this.root) this.root.walk(function(node2) {
            if (node2.source) {
                var from = node2.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    var fromUrl = _this.usesFileUrls ? _this.toFileUrl(from) : _this.toUrl(_this.path(from));
                    _this.map.setSourceContent(fromUrl, node2.source.input.css);
                }
            }
        });
        else if (this.css) {
            var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    };
    _proto.sourcePath = function sourcePath(node2) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node2.source.input.from);
        else return this.toUrl(this.path(node2.source.input.from));
    };
    _proto.toBase64 = function toBase64(str) {
        if ($413a30192b54574f$require$Buffer) return $413a30192b54574f$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    };
    _proto.toFileUrl = function toFileUrl(path) {
        var cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($413a30192b54574f$var$pathToFileURL$2) {
            var fileURL = $413a30192b54574f$var$pathToFileURL$2(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    };
    _proto.toUrl = function toUrl(path) {
        var cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($413a30192b54574f$var$sep$1 === "\\") path = path.replace(/\\/g, "/");
        var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    };
    return MapGenerator;
}();
var $413a30192b54574f$var$mapGenerator$1 = $413a30192b54574f$var$MapGenerator$2$1;
var $413a30192b54574f$var$Node$2$1 = $413a30192b54574f$var$node$1;
var $413a30192b54574f$var$Comment$4$1 = /*#__PURE__*/ function(Node$2$1) {
    $413a30192b54574f$var$_inherits(Comment, Node$2$1);
    function Comment(defaults) {
        var _this;
        _this = Node$2$1.call(this, defaults) || this;
        _this.type = "comment";
        return _this;
    }
    return Comment;
}($413a30192b54574f$var$Node$2$1);
var $413a30192b54574f$var$comment$1 = $413a30192b54574f$var$Comment$4$1;
$413a30192b54574f$var$Comment$4$1.default = $413a30192b54574f$var$Comment$4$1;
var $413a30192b54574f$var$isClean$1$1 = $413a30192b54574f$var$symbols$1.isClean, $413a30192b54574f$var$my$1$1 = $413a30192b54574f$var$symbols$1.my;
var $413a30192b54574f$var$Declaration$3$1 = $413a30192b54574f$var$declaration$1;
var $413a30192b54574f$var$Comment$3$1 = $413a30192b54574f$var$comment$1;
var $413a30192b54574f$var$Node$1$1 = $413a30192b54574f$var$node$1;
var $413a30192b54574f$var$parse$4$1, $413a30192b54574f$var$Rule$4$1, $413a30192b54574f$var$AtRule$4$1, $413a30192b54574f$var$Root$6$1;
function $413a30192b54574f$var$cleanSource$1(nodes) {
    return nodes.map(function(i2) {
        if (i2.nodes) i2.nodes = $413a30192b54574f$var$cleanSource$1(i2.nodes);
        delete i2.source;
        return i2;
    });
}
function $413a30192b54574f$var$markDirtyUp$1(node2) {
    node2[$413a30192b54574f$var$isClean$1$1] = false;
    if (node2.proxyOf.nodes) for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(node2.proxyOf.nodes), _step; !(_step = _iterator()).done;){
        var i2 = _step.value;
        $413a30192b54574f$var$markDirtyUp$1(i2);
    }
}
var $413a30192b54574f$var$Container$7$1 = /*#__PURE__*/ function(Node$1$1) {
    $413a30192b54574f$var$_inherits(Container, Node$1$1);
    function Container() {
        return Node$1$1.apply(this, arguments) || this;
    }
    var _proto = Container.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.last);
            for(var _iterator1 = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.push(node2);
            }
        }
        this.markDirty();
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        Node$1$1.prototype.cleanRaws.call(this, keepBetween);
        if (this.nodes) for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(this.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.cleanRaws(keepBetween);
        }
    };
    _proto.each = function each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        var iterator = this.getIterator();
        var index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    };
    _proto.every = function every(condition) {
        return this.nodes.every(condition);
    };
    _proto.getIterator = function getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        var iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (!node2[prop]) return node2[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _node2;
                    return (_node2 = node2)[prop].apply(_node2, [].concat(args.map(function(i2) {
                        if (typeof i2 === "function") return function(child, index2) {
                            return i2(child.toProxy(), index2);
                        };
                        else return i2;
                    })));
                };
                else if (prop === "every" || prop === "some") return function(cb) {
                    return node2[prop](function(child) {
                        for(var _len = arguments.length, other = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)other[_key - 1] = arguments[_key];
                        return cb.apply(void 0, [].concat([
                            child.toProxy()
                        ], other));
                    });
                };
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else if (prop === "nodes") return node2.nodes.map(function(i2) {
                    return i2.toProxy();
                });
                else if (prop === "first" || prop === "last") return node2[prop].toProxy();
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node2.markDirty();
                return true;
            }
        };
    };
    _proto.index = function index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    };
    _proto.insertAfter = function insertAfter(exist, add) {
        var existIndex = this.index(exist);
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.insertBefore = function insertBefore(exist, add) {
        var existIndex = this.index(exist);
        var type = existIndex === 0 ? "prepend" : false;
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.normalize = function normalize(nodes, sample) {
        var _this = this;
        if (typeof nodes === "string") nodes = $413a30192b54574f$var$cleanSource$1($413a30192b54574f$var$parse$4$1(nodes).nodes);
        else if (typeof nodes === "undefined") nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var i2 = _step.value;
                if (i2.parent) i2.parent.removeChild(i2, "ignore");
            }
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for(var _iterator1 = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var i21 = _step1.value;
                if (i21.parent) i21.parent.removeChild(i21, "ignore");
            }
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $413a30192b54574f$var$Declaration$3$1(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $413a30192b54574f$var$Rule$4$1(nodes)
        ];
        else if (nodes.name) nodes = [
            new $413a30192b54574f$var$AtRule$4$1(nodes)
        ];
        else if (nodes.text) nodes = [
            new $413a30192b54574f$var$Comment$3$1(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        var processed = nodes.map(function(i2) {
            if (!i2[$413a30192b54574f$var$my$1$1]) Container.rebuild(i2);
            i2 = i2.proxyOf;
            if (i2.parent) i2.parent.removeChild(i2);
            if (i2[$413a30192b54574f$var$isClean$1$1]) $413a30192b54574f$var$markDirtyUp$1(i2);
            if (typeof i2.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i2.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i2.parent = _this.proxyOf;
            return i2;
        });
        return processed;
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        children = children.reverse();
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.first, "prepend").reverse();
            for(var _iterator1 = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.unshift(node2);
            }
            for(var id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.push = function push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    };
    _proto.removeAll = function removeAll() {
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(this.proxyOf.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.parent = void 0;
        }
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    };
    _proto.removeChild = function removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) this.indexes[id] = index2 - 1;
        }
        this.markDirty();
        return this;
    };
    _proto.replaceValues = function replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls(function(decl) {
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    };
    _proto.some = function some(condition) {
        return this.nodes.some(condition);
    };
    _proto.walk = function walk(callback) {
        return this.each(function(child, i2) {
            var result2;
            try {
                result2 = callback(child, i2);
            } catch (e2) {
                throw child.addToError(e2);
            }
            if (result2 !== false && child.walk) result2 = child.walk(callback);
            return result2;
        });
    };
    _proto.walkAtRules = function walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk(function(child, i2) {
                if (child.type === "atrule") return callback(child, i2);
            });
        }
        if ($413a30192b54574f$var$_instanceof(name, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "atrule" && child.name === name) return callback(child, i2);
        });
    };
    _proto.walkComments = function walkComments(callback) {
        return this.walk(function(child, i2) {
            if (child.type === "comment") return callback(child, i2);
        });
    };
    _proto.walkDecls = function walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk(function(child, i2) {
                if (child.type === "decl") return callback(child, i2);
            });
        }
        if ($413a30192b54574f$var$_instanceof(prop, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "decl" && child.prop === prop) return callback(child, i2);
        });
    };
    _proto.walkRules = function walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk(function(child, i2) {
                if (child.type === "rule") return callback(child, i2);
            });
        }
        if ($413a30192b54574f$var$_instanceof(selector, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "rule" && child.selector === selector) return callback(child, i2);
        });
    };
    $413a30192b54574f$var$_create_class(Container, [
        {
            key: "first",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[0];
            }
        },
        {
            key: "last",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
            }
        }
    ]);
    return Container;
}($413a30192b54574f$var$Node$1$1);
$413a30192b54574f$var$Container$7$1.registerParse = function(dependant) {
    $413a30192b54574f$var$parse$4$1 = dependant;
};
$413a30192b54574f$var$Container$7$1.registerRule = function(dependant) {
    $413a30192b54574f$var$Rule$4$1 = dependant;
};
$413a30192b54574f$var$Container$7$1.registerAtRule = function(dependant) {
    $413a30192b54574f$var$AtRule$4$1 = dependant;
};
$413a30192b54574f$var$Container$7$1.registerRoot = function(dependant) {
    $413a30192b54574f$var$Root$6$1 = dependant;
};
var $413a30192b54574f$var$container$1 = $413a30192b54574f$var$Container$7$1;
$413a30192b54574f$var$Container$7$1.default = $413a30192b54574f$var$Container$7$1;
$413a30192b54574f$var$Container$7$1.rebuild = function(node2) {
    if (node2.type === "atrule") Object.setPrototypeOf(node2, $413a30192b54574f$var$AtRule$4$1.prototype);
    else if (node2.type === "rule") Object.setPrototypeOf(node2, $413a30192b54574f$var$Rule$4$1.prototype);
    else if (node2.type === "decl") Object.setPrototypeOf(node2, $413a30192b54574f$var$Declaration$3$1.prototype);
    else if (node2.type === "comment") Object.setPrototypeOf(node2, $413a30192b54574f$var$Comment$3$1.prototype);
    else if (node2.type === "root") Object.setPrototypeOf(node2, $413a30192b54574f$var$Root$6$1.prototype);
    node2[$413a30192b54574f$var$my$1$1] = true;
    if (node2.nodes) node2.nodes.forEach(function(child) {
        $413a30192b54574f$var$Container$7$1.rebuild(child);
    });
};
var $413a30192b54574f$var$Container$6$1 = $413a30192b54574f$var$container$1;
var $413a30192b54574f$var$LazyResult$4$1, $413a30192b54574f$var$Processor$3$1;
var $413a30192b54574f$var$Document$3$1 = /*#__PURE__*/ function(Container$6$1) {
    $413a30192b54574f$var$_inherits(Document2, Container$6$1);
    function Document2(defaults) {
        var _this;
        _this = Container$6$1.call(this, $413a30192b54574f$var$_extends({
            type: "document"
        }, defaults)) || this;
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Document2.prototype;
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $413a30192b54574f$var$LazyResult$4$1(new $413a30192b54574f$var$Processor$3$1(), this, opts);
        return lazy.stringify();
    };
    return Document2;
}($413a30192b54574f$var$Container$6$1);
$413a30192b54574f$var$Document$3$1.registerLazyResult = function(dependant) {
    $413a30192b54574f$var$LazyResult$4$1 = dependant;
};
$413a30192b54574f$var$Document$3$1.registerProcessor = function(dependant) {
    $413a30192b54574f$var$Processor$3$1 = dependant;
};
var $413a30192b54574f$var$document$1$1 = $413a30192b54574f$var$Document$3$1;
$413a30192b54574f$var$Document$3$1.default = $413a30192b54574f$var$Document$3$1;
var $413a30192b54574f$var$printed$1 = {};
var $413a30192b54574f$var$warnOnce$2$1 = function warnOnce(message) {
    if ($413a30192b54574f$var$printed$1[message]) return;
    $413a30192b54574f$var$printed$1[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};
var $413a30192b54574f$var$Warning$2$1 = /*#__PURE__*/ function() {
    function Warning(text, opts) {
        if (opts === void 0) opts = {};
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            var range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(var opt in opts)this[opt] = opts[opt];
    }
    var _proto = Warning.prototype;
    _proto.toString = function toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    };
    return Warning;
}();
var $413a30192b54574f$var$warning$1 = $413a30192b54574f$var$Warning$2$1;
$413a30192b54574f$var$Warning$2$1.default = $413a30192b54574f$var$Warning$2$1;
var $413a30192b54574f$var$Warning$1$1 = $413a30192b54574f$var$warning$1;
var $413a30192b54574f$var$Result$3$1 = /*#__PURE__*/ function() {
    function Result(processor2, root2, opts) {
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
    var _proto = Result.prototype;
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.warn = function warn(text, opts) {
        if (opts === void 0) opts = {};
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        var warning2 = new $413a30192b54574f$var$Warning$1$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    };
    _proto.warnings = function warnings() {
        return this.messages.filter(function(i2) {
            return i2.type === "warning";
        });
    };
    $413a30192b54574f$var$_create_class(Result, [
        {
            key: "content",
            get: function get() {
                return this.css;
            }
        }
    ]);
    return Result;
}();
var $413a30192b54574f$var$result$1 = $413a30192b54574f$var$Result$3$1;
$413a30192b54574f$var$Result$3$1.default = $413a30192b54574f$var$Result$3$1;
var $413a30192b54574f$var$SINGLE_QUOTE$1 = "'".charCodeAt(0);
var $413a30192b54574f$var$DOUBLE_QUOTE$1 = '"'.charCodeAt(0);
var $413a30192b54574f$var$BACKSLASH$1 = "\\".charCodeAt(0);
var $413a30192b54574f$var$SLASH$1 = "/".charCodeAt(0);
var $413a30192b54574f$var$NEWLINE$1 = "\n".charCodeAt(0);
var $413a30192b54574f$var$SPACE$1 = " ".charCodeAt(0);
var $413a30192b54574f$var$FEED$1 = "\f".charCodeAt(0);
var $413a30192b54574f$var$TAB$1 = "	".charCodeAt(0);
var $413a30192b54574f$var$CR$1 = "\r".charCodeAt(0);
var $413a30192b54574f$var$OPEN_SQUARE$1 = "[".charCodeAt(0);
var $413a30192b54574f$var$CLOSE_SQUARE$1 = "]".charCodeAt(0);
var $413a30192b54574f$var$OPEN_PARENTHESES$1 = "(".charCodeAt(0);
var $413a30192b54574f$var$CLOSE_PARENTHESES$1 = ")".charCodeAt(0);
var $413a30192b54574f$var$OPEN_CURLY$1 = "{".charCodeAt(0);
var $413a30192b54574f$var$CLOSE_CURLY$1 = "}".charCodeAt(0);
var $413a30192b54574f$var$SEMICOLON$1 = ";".charCodeAt(0);
var $413a30192b54574f$var$ASTERISK$1 = "*".charCodeAt(0);
var $413a30192b54574f$var$COLON$1 = ":".charCodeAt(0);
var $413a30192b54574f$var$AT$1 = "@".charCodeAt(0);
var $413a30192b54574f$var$RE_AT_END$1 = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var $413a30192b54574f$var$RE_WORD_END$1 = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var $413a30192b54574f$var$RE_BAD_BRACKET$1 = /.[\r\n"'(/\\]/;
var $413a30192b54574f$var$RE_HEX_ESCAPE$1 = /[\da-f]/i;
var $413a30192b54574f$var$tokenize$1 = function tokenizer(input2, options) {
    if (options === void 0) options = {};
    var css = input2.css.valueOf();
    var ignore = options.ignoreErrors;
    var code, next, quote, content, escape;
    var escaped, escapePos, prev, n2, currentToken;
    var length = css.length;
    var pos = 0;
    var buffer = [];
    var returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $413a30192b54574f$var$NEWLINE$1:
            case $413a30192b54574f$var$SPACE$1:
            case $413a30192b54574f$var$TAB$1:
            case $413a30192b54574f$var$CR$1:
            case $413a30192b54574f$var$FEED$1:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $413a30192b54574f$var$SPACE$1 || code === $413a30192b54574f$var$NEWLINE$1 || code === $413a30192b54574f$var$TAB$1 || code === $413a30192b54574f$var$CR$1 || code === $413a30192b54574f$var$FEED$1);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $413a30192b54574f$var$OPEN_SQUARE$1:
            case $413a30192b54574f$var$CLOSE_SQUARE$1:
            case $413a30192b54574f$var$OPEN_CURLY$1:
            case $413a30192b54574f$var$CLOSE_CURLY$1:
            case $413a30192b54574f$var$COLON$1:
            case $413a30192b54574f$var$SEMICOLON$1:
            case $413a30192b54574f$var$CLOSE_PARENTHESES$1:
                var controlChar = String.fromCharCode(code);
                currentToken = [
                    controlChar,
                    controlChar,
                    pos
                ];
                break;
            case $413a30192b54574f$var$OPEN_PARENTHESES$1:
                prev = buffer.length ? buffer.pop()[1] : "";
                n2 = css.charCodeAt(pos + 1);
                if (prev === "url" && n2 !== $413a30192b54574f$var$SINGLE_QUOTE$1 && n2 !== $413a30192b54574f$var$DOUBLE_QUOTE$1 && n2 !== $413a30192b54574f$var$SPACE$1 && n2 !== $413a30192b54574f$var$NEWLINE$1 && n2 !== $413a30192b54574f$var$TAB$1 && n2 !== $413a30192b54574f$var$FEED$1 && n2 !== $413a30192b54574f$var$CR$1) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $413a30192b54574f$var$BACKSLASH$1){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $413a30192b54574f$var$RE_BAD_BRACKET$1.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $413a30192b54574f$var$SINGLE_QUOTE$1:
            case $413a30192b54574f$var$DOUBLE_QUOTE$1:
                quote = code === $413a30192b54574f$var$SINGLE_QUOTE$1 ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $413a30192b54574f$var$BACKSLASH$1){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $413a30192b54574f$var$AT$1:
                $413a30192b54574f$var$RE_AT_END$1.lastIndex = pos + 1;
                $413a30192b54574f$var$RE_AT_END$1.test(css);
                if ($413a30192b54574f$var$RE_AT_END$1.lastIndex === 0) next = css.length - 1;
                else next = $413a30192b54574f$var$RE_AT_END$1.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $413a30192b54574f$var$BACKSLASH$1:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $413a30192b54574f$var$BACKSLASH$1){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $413a30192b54574f$var$SLASH$1 && code !== $413a30192b54574f$var$SPACE$1 && code !== $413a30192b54574f$var$NEWLINE$1 && code !== $413a30192b54574f$var$TAB$1 && code !== $413a30192b54574f$var$CR$1 && code !== $413a30192b54574f$var$FEED$1) {
                    next += 1;
                    if ($413a30192b54574f$var$RE_HEX_ESCAPE$1.test(css.charAt(next))) {
                        while($413a30192b54574f$var$RE_HEX_ESCAPE$1.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $413a30192b54574f$var$SPACE$1) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $413a30192b54574f$var$SLASH$1 && css.charCodeAt(pos + 1) === $413a30192b54574f$var$ASTERISK$1) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $413a30192b54574f$var$RE_WORD_END$1.lastIndex = pos + 1;
                    $413a30192b54574f$var$RE_WORD_END$1.test(css);
                    if ($413a30192b54574f$var$RE_WORD_END$1.lastIndex === 0) next = css.length - 1;
                    else next = $413a30192b54574f$var$RE_WORD_END$1.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};
var $413a30192b54574f$var$Container$5$1 = $413a30192b54574f$var$container$1;
var $413a30192b54574f$var$AtRule$3$1 = /*#__PURE__*/ function(Container$5$1) {
    $413a30192b54574f$var$_inherits(AtRule, Container$5$1);
    function AtRule(defaults) {
        var _this;
        _this = Container$5$1.call(this, defaults) || this;
        _this.type = "atrule";
        return _this;
    }
    var _proto = AtRule.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5$1_prototype_append;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5$1_prototype_append = Container$5$1.prototype.append).call.apply(_Container$5$1_prototype_append, [].concat([
            this
        ], children));
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5$1_prototype_prepend;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5$1_prototype_prepend = Container$5$1.prototype.prepend).call.apply(_Container$5$1_prototype_prepend, [].concat([
            this
        ], children));
    };
    return AtRule;
}($413a30192b54574f$var$Container$5$1);
var $413a30192b54574f$var$atRule$1 = $413a30192b54574f$var$AtRule$3$1;
$413a30192b54574f$var$AtRule$3$1.default = $413a30192b54574f$var$AtRule$3$1;
$413a30192b54574f$var$Container$5$1.registerAtRule($413a30192b54574f$var$AtRule$3$1);
var $413a30192b54574f$var$Container$4$1 = $413a30192b54574f$var$container$1;
var $413a30192b54574f$var$LazyResult$3$1, $413a30192b54574f$var$Processor$2$1;
var $413a30192b54574f$var$Root$5$1 = /*#__PURE__*/ function(Container$4$1) {
    $413a30192b54574f$var$_inherits(Root, Container$4$1);
    function Root(defaults) {
        var _this;
        _this = Container$4$1.call(this, defaults) || this;
        _this.type = "root";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Root.prototype;
    _proto.normalize = function normalize(child, sample, type) {
        var nodes = Container$4$1.prototype.normalize.call(this, child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                node2.raws.before = sample.raws.before;
            }
        }
        return nodes;
    };
    _proto.removeChild = function removeChild(child, ignore) {
        var index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index2].raws.before;
        return Container$4$1.prototype.removeChild.call(this, child);
    };
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $413a30192b54574f$var$LazyResult$3$1(new $413a30192b54574f$var$Processor$2$1(), this, opts);
        return lazy.stringify();
    };
    return Root;
}($413a30192b54574f$var$Container$4$1);
$413a30192b54574f$var$Root$5$1.registerLazyResult = function(dependant) {
    $413a30192b54574f$var$LazyResult$3$1 = dependant;
};
$413a30192b54574f$var$Root$5$1.registerProcessor = function(dependant) {
    $413a30192b54574f$var$Processor$2$1 = dependant;
};
var $413a30192b54574f$var$root$1 = $413a30192b54574f$var$Root$5$1;
$413a30192b54574f$var$Root$5$1.default = $413a30192b54574f$var$Root$5$1;
$413a30192b54574f$var$Container$4$1.registerRoot($413a30192b54574f$var$Root$5$1);
var $413a30192b54574f$var$list$2$1 = {
    comma: function comma(string) {
        return $413a30192b54574f$var$list$2$1.split(string, [
            ","
        ], true);
    },
    space: function space(string) {
        var spaces = [
            " ",
            "\n",
            "	"
        ];
        return $413a30192b54574f$var$list$2$1.split(string, spaces);
    },
    split: function split(string, separators, last) {
        var array = [];
        var current = "";
        var split = false;
        var func = 0;
        var inQuote = false;
        var prevQuote = "";
        var escape = false;
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(string), _step; !(_step = _iterator()).done;){
            var letter = _step.value;
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var $413a30192b54574f$var$list_1$1 = $413a30192b54574f$var$list$2$1;
$413a30192b54574f$var$list$2$1.default = $413a30192b54574f$var$list$2$1;
var $413a30192b54574f$var$Container$3$1 = $413a30192b54574f$var$container$1;
var $413a30192b54574f$var$list$1$1 = $413a30192b54574f$var$list_1$1;
var $413a30192b54574f$var$Rule$3$1 = /*#__PURE__*/ function(Container$3$1) {
    $413a30192b54574f$var$_inherits(Rule, Container$3$1);
    function Rule(defaults) {
        var _this;
        _this = Container$3$1.call(this, defaults) || this;
        _this.type = "rule";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    $413a30192b54574f$var$_create_class(Rule, [
        {
            key: "selectors",
            get: function get() {
                return $413a30192b54574f$var$list$1$1.comma(this.selector);
            },
            set: function set(values) {
                var match = this.selector ? this.selector.match(/,\s*/) : null;
                var sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
                this.selector = values.join(sep2);
            }
        }
    ]);
    return Rule;
}($413a30192b54574f$var$Container$3$1);
var $413a30192b54574f$var$rule$1 = $413a30192b54574f$var$Rule$3$1;
$413a30192b54574f$var$Rule$3$1.default = $413a30192b54574f$var$Rule$3$1;
$413a30192b54574f$var$Container$3$1.registerRule($413a30192b54574f$var$Rule$3$1);
var $413a30192b54574f$var$Declaration$2$1 = $413a30192b54574f$var$declaration$1;
var $413a30192b54574f$var$tokenizer2$1 = $413a30192b54574f$var$tokenize$1;
var $413a30192b54574f$var$Comment$2$1 = $413a30192b54574f$var$comment$1;
var $413a30192b54574f$var$AtRule$2$1 = $413a30192b54574f$var$atRule$1;
var $413a30192b54574f$var$Root$4$1 = $413a30192b54574f$var$root$1;
var $413a30192b54574f$var$Rule$2$1 = $413a30192b54574f$var$rule$1;
var $413a30192b54574f$var$SAFE_COMMENT_NEIGHBOR$1 = {
    empty: true,
    space: true
};
function $413a30192b54574f$var$findLastWithPosition$1(tokens) {
    for(var i2 = tokens.length - 1; i2 >= 0; i2--){
        var token = tokens[i2];
        var pos = token[3] || token[2];
        if (pos) return pos;
    }
}
var $413a30192b54574f$var$Parser$1$1 = /*#__PURE__*/ function() {
    function Parser(input2) {
        this.input = input2;
        this.root = new $413a30192b54574f$var$Root$4$1();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    var _proto = Parser.prototype;
    _proto.atrule = function atrule(token) {
        var node2 = new $413a30192b54574f$var$AtRule$2$1();
        node2.name = token[1].slice(1);
        if (node2.name === "") this.unnamedAtrule(node2, token);
        this.init(node2, token[2]);
        var type;
        var prev;
        var shift;
        var last = false;
        var open = false;
        var params = [];
        var brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    };
    _proto.checkMissedSemicolon = function checkMissedSemicolon(tokens) {
        var colon = this.colon(tokens);
        if (colon === false) return;
        var founded = 0;
        var token;
        for(var j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    };
    _proto.colon = function colon(tokens) {
        var brackets = 0;
        var token, type, prev;
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(tokens.entries()), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, i2 = _step_value[0], element = _step_value[1];
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i2;
            }
            prev = token;
        }
        return false;
    };
    _proto.comment = function comment(token) {
        var node2 = new $413a30192b54574f$var$Comment$2$1();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        var text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    };
    _proto.createTokenizer = function createTokenizer() {
        this.tokenizer = $413a30192b54574f$var$tokenizer2$1(this.input);
    };
    _proto.decl = function decl(tokens, customProperty) {
        var node2 = new $413a30192b54574f$var$Declaration$2$1();
        this.init(node2, tokens[0][2]);
        var last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || $413a30192b54574f$var$findLastWithPosition$1(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            var type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        var token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        var firstSpaces = [];
        var next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(var i2 = tokens.length - 1; i2 >= 0; i2--){
            token = tokens[i2];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                var string = this.stringFrom(tokens, i2);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                var cache = tokens.slice(0);
                var str = "";
                for(var j = i2; j > 0; j--){
                    var type1 = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type1 !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        var hasWord = tokens.some(function(i2) {
            return i2[0] !== "space" && i2[0] !== "comment";
        });
        if (hasWord) {
            node2.raws.between += firstSpaces.map(function(i2) {
                return i2[1];
            }).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    };
    _proto.doubleColon = function doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    _proto.emptyRule = function emptyRule(token) {
        var node2 = new $413a30192b54574f$var$Rule$2$1();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    };
    _proto.end = function end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    };
    _proto.endFile = function endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    };
    _proto.freeSemicolon = function freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            var prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    };
    // Helpers
    _proto.getPosition = function getPosition(offset) {
        var pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    };
    _proto.init = function init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    };
    _proto.other = function other(start) {
        var end = false;
        var type = null;
        var colon = false;
        var bracket = null;
        var brackets = [];
        var customProperty = start[1].startsWith("--");
        var tokens = [];
        var token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    };
    _proto.parse = function parse() {
        var token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    };
    _proto.precheckMissedSemicolon = function precheckMissedSemicolon() {};
    _proto.raw = function raw(node2, prop, tokens, customProperty) {
        var token, type;
        var length = tokens.length;
        var value = "";
        var clean = true;
        var next, prev;
        for(var i2 = 0; i2 < length; i2 += 1){
            token = tokens[i2];
            type = token[0];
            if (type === "space" && i2 === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
                next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
                if (!$413a30192b54574f$var$SAFE_COMMENT_NEIGHBOR$1[prev] && !$413a30192b54574f$var$SAFE_COMMENT_NEIGHBOR$1[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            var raw = tokens.reduce(function(all, i2) {
                return all + i2[1];
            }, "");
            node2.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node2[prop] = value;
    };
    _proto.rule = function rule(tokens) {
        tokens.pop();
        var node2 = new $413a30192b54574f$var$Rule$2$1();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    };
    _proto.spacesAndCommentsFromEnd = function spacesAndCommentsFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    // Errors
    _proto.spacesAndCommentsFromStart = function spacesAndCommentsFromStart(tokens) {
        var next;
        var spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    };
    _proto.spacesFromEnd = function spacesFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    _proto.stringFrom = function stringFrom(tokens, from) {
        var result2 = "";
        for(var i2 = from; i2 < tokens.length; i2++)result2 += tokens[i2][1];
        tokens.splice(from, tokens.length - from);
        return result2;
    };
    _proto.unclosedBlock = function unclosedBlock() {
        var pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    };
    _proto.unclosedBracket = function unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    };
    _proto.unexpectedClose = function unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    };
    _proto.unknownWord = function unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    };
    _proto.unnamedAtrule = function unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    return Parser;
}();
var $413a30192b54574f$var$parser$1 = $413a30192b54574f$var$Parser$1$1;
var $413a30192b54574f$var$Container$2$1 = $413a30192b54574f$var$container$1;
var $413a30192b54574f$var$Parser2$1 = $413a30192b54574f$var$parser$1;
var $413a30192b54574f$var$Input$2$1 = $413a30192b54574f$var$input$1;
function $413a30192b54574f$var$parse$3$1(css, opts) {
    var input2 = new $413a30192b54574f$var$Input$2$1(css, opts);
    var parser2 = new $413a30192b54574f$var$Parser2$1(input2);
    try {
        parser2.parse();
    } catch (e2) {
        throw e2;
    }
    return parser2.root;
}
var $413a30192b54574f$var$parse_1$1 = $413a30192b54574f$var$parse$3$1;
$413a30192b54574f$var$parse$3$1.default = $413a30192b54574f$var$parse$3$1;
$413a30192b54574f$var$Container$2$1.registerParse($413a30192b54574f$var$parse$3$1);
var $413a30192b54574f$var$isClean$3 = $413a30192b54574f$var$symbols$1.isClean, $413a30192b54574f$var$my$3 = $413a30192b54574f$var$symbols$1.my;
var $413a30192b54574f$var$MapGenerator$1$1 = $413a30192b54574f$var$mapGenerator$1;
var $413a30192b54574f$var$stringify$2$1 = $413a30192b54574f$var$stringify_1$1;
var $413a30192b54574f$var$Container$1$1 = $413a30192b54574f$var$container$1;
var $413a30192b54574f$var$Document$2$1 = $413a30192b54574f$var$document$1$1;
var $413a30192b54574f$var$warnOnce$1$1 = $413a30192b54574f$var$warnOnce$2$1;
var $413a30192b54574f$var$Result$2$1 = $413a30192b54574f$var$result$1;
var $413a30192b54574f$var$parse$2$1 = $413a30192b54574f$var$parse_1$1;
var $413a30192b54574f$var$Root$3$1 = $413a30192b54574f$var$root$1;
var $413a30192b54574f$var$TYPE_TO_CLASS_NAME$1 = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
var $413a30192b54574f$var$PLUGIN_PROPS$1 = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
var $413a30192b54574f$var$NOT_VISITORS$1 = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
var $413a30192b54574f$var$CHILDREN$1 = 0;
function $413a30192b54574f$var$isPromise$1(obj) {
    return (typeof obj === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(obj)) === "object" && typeof obj.then === "function";
}
function $413a30192b54574f$var$getEvents$1(node2) {
    var key = false;
    var type = $413a30192b54574f$var$TYPE_TO_CLASS_NAME$1[node2.type];
    if (node2.type === "decl") key = node2.prop.toLowerCase();
    else if (node2.type === "atrule") key = node2.name.toLowerCase();
    if (key && node2.append) return [
        type,
        type + "-" + key,
        $413a30192b54574f$var$CHILDREN$1,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node2.append) return [
        type,
        $413a30192b54574f$var$CHILDREN$1,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $413a30192b54574f$var$toStack$1(node2) {
    var events;
    if (node2.type === "document") events = [
        "Document",
        $413a30192b54574f$var$CHILDREN$1,
        "DocumentExit"
    ];
    else if (node2.type === "root") events = [
        "Root",
        $413a30192b54574f$var$CHILDREN$1,
        "RootExit"
    ];
    else events = $413a30192b54574f$var$getEvents$1(node2);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function $413a30192b54574f$var$cleanMarks$1(node2) {
    node2[$413a30192b54574f$var$isClean$3] = false;
    if (node2.nodes) node2.nodes.forEach(function(i2) {
        return $413a30192b54574f$var$cleanMarks$1(i2);
    });
    return node2;
}
var $413a30192b54574f$var$postcss$2$1 = {};
var $413a30192b54574f$var$LazyResult$2$1 = /*#__PURE__*/ function() {
    function LazyResult(processor2, css, opts) {
        var _this = this;
        this.stringified = false;
        this.processed = false;
        var root2;
        if ((typeof css === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(css)) === "object" && css !== null && (css.type === "root" || css.type === "document")) root2 = $413a30192b54574f$var$cleanMarks$1(css);
        else if ($413a30192b54574f$var$_instanceof(css, LazyResult) || $413a30192b54574f$var$_instanceof(css, $413a30192b54574f$var$Result$2$1)) {
            root2 = $413a30192b54574f$var$cleanMarks$1(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            var parser2 = $413a30192b54574f$var$parse$2$1;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[$413a30192b54574f$var$my$3]) $413a30192b54574f$var$Container$1$1.rebuild(root2);
        }
        this.result = new $413a30192b54574f$var$Result$2$1(processor2, root2, opts);
        this.helpers = $413a30192b54574f$var$_extends({}, $413a30192b54574f$var$postcss$2$1, {
            postcss: $413a30192b54574f$var$postcss$2$1,
            result: this.result
        });
        this.plugins = this.processor.plugins.map(function(plugin22) {
            if ((typeof plugin22 === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(plugin22)) === "object" && plugin22.prepare) return $413a30192b54574f$var$_extends({}, plugin22, plugin22.prepare(_this.result));
            else return plugin22;
        });
    }
    var _proto = LazyResult.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.getAsyncError = function getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    };
    _proto.handleError = function handleError(error, node2) {
        var plugin22 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin22.postcssPlugin;
                error.setMessage();
            } else if (plugin22.postcssVersion) var pluginName, pluginVer, runtimeVer, a2, b;
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    };
    _proto.prepareVisitors = function prepareVisitors() {
        var _this = this;
        this.listeners = {};
        var add = function(plugin22, type, cb) {
            if (!_this.listeners[type]) _this.listeners[type] = [];
            _this.listeners[type].push([
                plugin22,
                cb
            ]);
        };
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            if ((typeof plugin22 === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(plugin22)) === "object") for(var event in plugin22){
                if (!$413a30192b54574f$var$PLUGIN_PROPS$1[event] && /^[A-Z]/.test(event)) throw new Error("Unknown event " + event + " in " + plugin22.postcssPlugin + ". Try to update PostCSS (" + this.processor.version + " now).");
                if (!$413a30192b54574f$var$NOT_VISITORS$1[event]) {
                    if ($413a30192b54574f$var$_type_of(plugin22[event]) === "object") {
                        for(var filter in plugin22[event])if (filter === "*") add(plugin22, event, plugin22[event][filter]);
                        else add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                    } else if (typeof plugin22[event] === "function") add(plugin22, event, plugin22[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    };
    _proto.runAsync = function runAsync() {
        var _this = this;
        return $413a30192b54574f$var$_async_to_generator(function() {
            var i2, plugin22, promise, error, root2, stack, promise1, e2, node2, _loop, _iterator, _step;
            return $413a30192b54574f$var$_ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.plugin = 0;
                        i2 = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i2 < _this.plugins.length)) return [
                            3,
                            6
                        ];
                        plugin22 = _this.plugins[i2];
                        promise = _this.runOnRoot(plugin22);
                        if (!$413a30192b54574f$var$isPromise$1(promise)) return [
                            3,
                            5
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        throw _this.handleError(error);
                    case 5:
                        i2++;
                        return [
                            3,
                            1
                        ];
                    case 6:
                        _this.prepareVisitors();
                        if (!_this.hasListener) return [
                            3,
                            18
                        ];
                        root2 = _this.result.root;
                        _state.label = 7;
                    case 7:
                        if (!!root2[$413a30192b54574f$var$isClean$3]) return [
                            3,
                            14
                        ];
                        root2[$413a30192b54574f$var$isClean$3] = true;
                        stack = [
                            $413a30192b54574f$var$toStack$1(root2)
                        ];
                        _state.label = 8;
                    case 8:
                        if (!(stack.length > 0)) return [
                            3,
                            13
                        ];
                        promise1 = _this.visitTick(stack);
                        if (!$413a30192b54574f$var$isPromise$1(promise1)) return [
                            3,
                            12
                        ];
                        _state.label = 9;
                    case 9:
                        _state.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        return [
                            4,
                            promise1
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 11:
                        e2 = _state.sent();
                        node2 = stack[stack.length - 1].node;
                        throw _this.handleError(e2, node2);
                    case 12:
                        return [
                            3,
                            8
                        ];
                    case 13:
                        return [
                            3,
                            7
                        ];
                    case 14:
                        if (!_this.listeners.OnceExit) return [
                            3,
                            18
                        ];
                        _loop = function() {
                            var _step_value, plugin22, visitor, roots, e2;
                            return $413a30192b54574f$var$_ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
                                        _this.result.lastPlugin = plugin22;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            ,
                                            7
                                        ]);
                                        if (!(root2.type === "document")) return [
                                            3,
                                            3
                                        ];
                                        roots = root2.nodes.map(function(subRoot) {
                                            return visitor(subRoot, _this.helpers);
                                        });
                                        return [
                                            4,
                                            Promise.all(roots)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            visitor(root2, _this.helpers)
                                        ];
                                    case 4:
                                        _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        return [
                                            3,
                                            7
                                        ];
                                    case 6:
                                        e2 = _state.sent();
                                        throw _this.handleError(e2);
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(_this.listeners.OnceExit);
                        _state.label = 15;
                    case 15:
                        if (!!(_step = _iterator()).done) return [
                            3,
                            18
                        ];
                        return [
                            5,
                            $413a30192b54574f$var$_ts_values(_loop())
                        ];
                    case 16:
                        _state.sent();
                        _state.label = 17;
                    case 17:
                        return [
                            3,
                            15
                        ];
                    case 18:
                        _this.processed = true;
                        return [
                            2,
                            _this.stringify()
                        ];
                }
            });
        })();
    };
    _proto.runOnRoot = function runOnRoot(plugin22) {
        var _this = this;
        this.result.lastPlugin = plugin22;
        try {
            if ((typeof plugin22 === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(plugin22)) === "object" && plugin22.Once) {
                if (this.result.root.type === "document") {
                    var roots = this.result.root.nodes.map(function(root2) {
                        return plugin22.Once(root2, _this.helpers);
                    });
                    if ($413a30192b54574f$var$isPromise$1(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin22.Once(this.result.root, this.helpers);
            } else if (typeof plugin22 === "function") return plugin22(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    };
    _proto.stringify = function stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        var opts = this.result.opts;
        var str = $413a30192b54574f$var$stringify$2$1;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        var map = new $413a30192b54574f$var$MapGenerator$1$1(str, this.result.root, this.result.opts);
        var data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            var promise = this.runOnRoot(plugin22);
            if ($413a30192b54574f$var$isPromise$1(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            var root2 = this.result.root;
            while(!root2[$413a30192b54574f$var$isClean$3]){
                root2[$413a30192b54574f$var$isClean$3] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") for(var _iterator1 = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(root2.nodes), _step1; !(_step1 = _iterator1()).done;){
                    var subRoot = _step1.value;
                    this.visitSync(this.listeners.OnceExit, subRoot);
                }
                else this.visitSync(this.listeners.OnceExit, root2);
            }
        }
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.visitSync = function visitSync(visitors, node2) {
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(visitors), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
            this.result.lastPlugin = plugin22;
            var promise = void 0;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) return true;
            if ($413a30192b54574f$var$isPromise$1(promise)) throw this.getAsyncError();
        }
    };
    _proto.visitTick = function visitTick(stack) {
        var visit2 = stack[stack.length - 1];
        var node2 = visit2.node, visitors = visit2.visitors;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            var _visitors_visit2_visitorIndex = visitors[visit2.visitorIndex], plugin22 = _visitors_visit2_visitorIndex[0], visitor = _visitors_visit2_visitorIndex[1];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin22;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2);
            }
        }
        if (visit2.iterator !== 0) {
            var iterator = visit2.iterator;
            var child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[$413a30192b54574f$var$isClean$3]) {
                    child[$413a30192b54574f$var$isClean$3] = true;
                    stack.push($413a30192b54574f$var$toStack$1(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        var events = visit2.events;
        while(visit2.eventIndex < events.length){
            var event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === $413a30192b54574f$var$CHILDREN$1) {
                if (node2.nodes && node2.nodes.length) {
                    node2[$413a30192b54574f$var$isClean$3] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    };
    _proto.walkSync = function walkSync(node2) {
        var _this = this;
        node2[$413a30192b54574f$var$isClean$3] = true;
        var events = $413a30192b54574f$var$getEvents$1(node2);
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(events), _step; !(_step = _iterator()).done;){
            var event = _step.value;
            if (event === $413a30192b54574f$var$CHILDREN$1) {
                if (node2.nodes) node2.each(function(child) {
                    if (!child[$413a30192b54574f$var$isClean$3]) _this.walkSync(child);
                });
            } else {
                var visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    };
    _proto.warnings = function warnings() {
        return this.sync().warnings();
    };
    $413a30192b54574f$var$_create_class(LazyResult, [
        {
            key: "content",
            get: function get() {
                return this.stringify().content;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.stringify().css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.stringify().map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return this.sync().messages;
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                return this.sync().root;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "LazyResult";
            }
        }
    ]);
    return LazyResult;
}();
$413a30192b54574f$var$LazyResult$2$1.registerPostcss = function(dependant) {
    $413a30192b54574f$var$postcss$2$1 = dependant;
};
var $413a30192b54574f$var$lazyResult$1 = $413a30192b54574f$var$LazyResult$2$1;
$413a30192b54574f$var$LazyResult$2$1.default = $413a30192b54574f$var$LazyResult$2$1;
$413a30192b54574f$var$Root$3$1.registerLazyResult($413a30192b54574f$var$LazyResult$2$1);
$413a30192b54574f$var$Document$2$1.registerLazyResult($413a30192b54574f$var$LazyResult$2$1);
var $413a30192b54574f$var$MapGenerator2$1 = $413a30192b54574f$var$mapGenerator$1;
var $413a30192b54574f$var$stringify$1$1 = $413a30192b54574f$var$stringify_1$1;
var $413a30192b54574f$var$warnOnce2$1 = $413a30192b54574f$var$warnOnce$2$1;
var $413a30192b54574f$var$parse$1$1 = $413a30192b54574f$var$parse_1$1;
var $413a30192b54574f$var$Result$1$1 = $413a30192b54574f$var$result$1;
var $413a30192b54574f$var$NoWorkResult$1$1 = /*#__PURE__*/ function() {
    function NoWorkResult(processor2, css, opts) {
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        var root2;
        var str = $413a30192b54574f$var$stringify$1$1;
        this.result = new $413a30192b54574f$var$Result$1$1(this._processor, root2, this._opts);
        this.result.css = css;
        var self = this;
        Object.defineProperty(this.result, "root", {
            get: function get() {
                return self.root;
            }
        });
        var map = new $413a30192b54574f$var$MapGenerator2$1(str, root2, this._opts, css);
        if (map.isMap()) {
            var _map_generate = map.generate(), generatedCSS = _map_generate[0], generatedMap = _map_generate[1];
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    var _proto = NoWorkResult.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this._css;
    };
    _proto.warnings = function warnings() {
        return [];
    };
    $413a30192b54574f$var$_create_class(NoWorkResult, [
        {
            key: "content",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.result.map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return [];
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                if (this._root) return this._root;
                var root2;
                var parser2 = $413a30192b54574f$var$parse$1$1;
                try {
                    root2 = parser2(this._css, this._opts);
                } catch (error) {
                    this.error = error;
                }
                if (this.error) throw this.error;
                else {
                    this._root = root2;
                    return root2;
                }
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "NoWorkResult";
            }
        }
    ]);
    return NoWorkResult;
}();
var $413a30192b54574f$var$noWorkResult$1 = $413a30192b54574f$var$NoWorkResult$1$1;
$413a30192b54574f$var$NoWorkResult$1$1.default = $413a30192b54574f$var$NoWorkResult$1$1;
var $413a30192b54574f$var$NoWorkResult2$1 = $413a30192b54574f$var$noWorkResult$1;
var $413a30192b54574f$var$LazyResult$1$1 = $413a30192b54574f$var$lazyResult$1;
var $413a30192b54574f$var$Document$1$1 = $413a30192b54574f$var$document$1$1;
var $413a30192b54574f$var$Root$2$1 = $413a30192b54574f$var$root$1;
var $413a30192b54574f$var$Processor$1$1 = /*#__PURE__*/ function() {
    function Processor(plugins) {
        if (plugins === void 0) plugins = [];
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
    var _proto = Processor.prototype;
    _proto.normalize = function normalize(plugins) {
        var normalized = [];
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(plugins), _step; !(_step = _iterator()).done;){
            var i2 = _step.value;
            if (i2.postcss === true) i2 = i2();
            else if (i2.postcss) i2 = i2.postcss;
            if ((typeof i2 === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(i2)) === "object" && Array.isArray(i2.plugins)) normalized = normalized.concat(i2.plugins);
            else if ((typeof i2 === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(i2)) === "object" && i2.postcssPlugin) normalized.push(i2);
            else if (typeof i2 === "function") normalized.push(i2);
            else if ((typeof i2 === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(i2)) === "object" && (i2.parse || i2.stringify)) ;
            else throw new Error(i2 + " is not a PostCSS plugin");
        }
        return normalized;
    };
    _proto.process = function process1(css, opts) {
        if (opts === void 0) opts = {};
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $413a30192b54574f$var$NoWorkResult2$1(this, css, opts);
        else return new $413a30192b54574f$var$LazyResult$1$1(this, css, opts);
    };
    _proto.use = function use(plugin22) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin22
        ]));
        return this;
    };
    return Processor;
}();
var $413a30192b54574f$var$processor$1 = $413a30192b54574f$var$Processor$1$1;
$413a30192b54574f$var$Processor$1$1.default = $413a30192b54574f$var$Processor$1$1;
$413a30192b54574f$var$Root$2$1.registerProcessor($413a30192b54574f$var$Processor$1$1);
$413a30192b54574f$var$Document$1$1.registerProcessor($413a30192b54574f$var$Processor$1$1);
var $413a30192b54574f$var$Declaration$1$1 = $413a30192b54574f$var$declaration$1;
var $413a30192b54574f$var$PreviousMap2$1 = $413a30192b54574f$var$previousMap$1;
var $413a30192b54574f$var$Comment$1$1 = $413a30192b54574f$var$comment$1;
var $413a30192b54574f$var$AtRule$1$1 = $413a30192b54574f$var$atRule$1;
var $413a30192b54574f$var$Input$1$1 = $413a30192b54574f$var$input$1;
var $413a30192b54574f$var$Root$1$1 = $413a30192b54574f$var$root$1;
var $413a30192b54574f$var$Rule$1$1 = $413a30192b54574f$var$rule$1;
function $413a30192b54574f$var$fromJSON$1$1(json, inputs) {
    if (Array.isArray(json)) return json.map(function(n2) {
        return $413a30192b54574f$var$fromJSON$1$1(n2);
    });
    var ownInputs = json.inputs, defaults = $413a30192b54574f$var$_object_without_properties_loose(json, [
        "inputs"
    ]);
    if (ownInputs) {
        inputs = [];
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(ownInputs), _step; !(_step = _iterator()).done;){
            var input2 = _step.value;
            var inputHydrated = $413a30192b54574f$var$_extends({}, input2, {
                __proto__: $413a30192b54574f$var$Input$1$1.prototype
            });
            if (inputHydrated.map) inputHydrated.map = $413a30192b54574f$var$_extends({}, inputHydrated.map, {
                __proto__: $413a30192b54574f$var$PreviousMap2$1.prototype
            });
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map(function(n2) {
        return $413a30192b54574f$var$fromJSON$1$1(n2, inputs);
    });
    if (defaults.source) {
        var _defaults_source = defaults.source, inputId = _defaults_source.inputId, source = $413a30192b54574f$var$_object_without_properties_loose(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $413a30192b54574f$var$Root$1$1(defaults);
    else if (defaults.type === "decl") return new $413a30192b54574f$var$Declaration$1$1(defaults);
    else if (defaults.type === "rule") return new $413a30192b54574f$var$Rule$1$1(defaults);
    else if (defaults.type === "comment") return new $413a30192b54574f$var$Comment$1$1(defaults);
    else if (defaults.type === "atrule") return new $413a30192b54574f$var$AtRule$1$1(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
var $413a30192b54574f$var$fromJSON_1$1 = $413a30192b54574f$var$fromJSON$1$1;
$413a30192b54574f$var$fromJSON$1$1.default = $413a30192b54574f$var$fromJSON$1$1;
var $413a30192b54574f$var$CssSyntaxError2$1 = $413a30192b54574f$var$cssSyntaxError$1;
var $413a30192b54574f$var$Declaration2$1 = $413a30192b54574f$var$declaration$1;
var $413a30192b54574f$var$LazyResult2$1 = $413a30192b54574f$var$lazyResult$1;
var $413a30192b54574f$var$Container2$1 = $413a30192b54574f$var$container$1;
var $413a30192b54574f$var$Processor2$1 = $413a30192b54574f$var$processor$1;
var $413a30192b54574f$var$stringify$5 = $413a30192b54574f$var$stringify_1$1;
var $413a30192b54574f$var$fromJSON$2 = $413a30192b54574f$var$fromJSON_1$1;
var $413a30192b54574f$var$Document22 = $413a30192b54574f$var$document$1$1;
var $413a30192b54574f$var$Warning2$1 = $413a30192b54574f$var$warning$1;
var $413a30192b54574f$var$Comment2$1 = $413a30192b54574f$var$comment$1;
var $413a30192b54574f$var$AtRule2$1 = $413a30192b54574f$var$atRule$1;
var $413a30192b54574f$var$Result2$1 = $413a30192b54574f$var$result$1;
var $413a30192b54574f$var$Input2$1 = $413a30192b54574f$var$input$1;
var $413a30192b54574f$var$parse$5 = $413a30192b54574f$var$parse_1$1;
var $413a30192b54574f$var$list$3 = $413a30192b54574f$var$list_1$1;
var $413a30192b54574f$var$Rule2$1 = $413a30192b54574f$var$rule$1;
var $413a30192b54574f$var$Root2$1 = $413a30192b54574f$var$root$1;
var $413a30192b54574f$var$Node2$1 = $413a30192b54574f$var$node$1;
function $413a30192b54574f$var$postcss$3() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $413a30192b54574f$var$Processor2$1(plugins);
}
$413a30192b54574f$var$postcss$3.plugin = function plugin(name, initializer) {
    var warningPrinted = false;
    function creator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        var transformer = initializer.apply(void 0, [].concat(args));
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $413a30192b54574f$var$Processor2$1().version;
        return transformer;
    }
    var cache;
    Object.defineProperty(creator, "postcss", {
        get: function get() {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $413a30192b54574f$var$postcss$3([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$413a30192b54574f$var$postcss$3.stringify = $413a30192b54574f$var$stringify$5;
$413a30192b54574f$var$postcss$3.parse = $413a30192b54574f$var$parse$5;
$413a30192b54574f$var$postcss$3.fromJSON = $413a30192b54574f$var$fromJSON$2;
$413a30192b54574f$var$postcss$3.list = $413a30192b54574f$var$list$3;
$413a30192b54574f$var$postcss$3.comment = function(defaults) {
    return new $413a30192b54574f$var$Comment2$1(defaults);
};
$413a30192b54574f$var$postcss$3.atRule = function(defaults) {
    return new $413a30192b54574f$var$AtRule2$1(defaults);
};
$413a30192b54574f$var$postcss$3.decl = function(defaults) {
    return new $413a30192b54574f$var$Declaration2$1(defaults);
};
$413a30192b54574f$var$postcss$3.rule = function(defaults) {
    return new $413a30192b54574f$var$Rule2$1(defaults);
};
$413a30192b54574f$var$postcss$3.root = function(defaults) {
    return new $413a30192b54574f$var$Root2$1(defaults);
};
$413a30192b54574f$var$postcss$3.document = function(defaults) {
    return new $413a30192b54574f$var$Document22(defaults);
};
$413a30192b54574f$var$postcss$3.CssSyntaxError = $413a30192b54574f$var$CssSyntaxError2$1;
$413a30192b54574f$var$postcss$3.Declaration = $413a30192b54574f$var$Declaration2$1;
$413a30192b54574f$var$postcss$3.Container = $413a30192b54574f$var$Container2$1;
$413a30192b54574f$var$postcss$3.Processor = $413a30192b54574f$var$Processor2$1;
$413a30192b54574f$var$postcss$3.Document = $413a30192b54574f$var$Document22;
$413a30192b54574f$var$postcss$3.Comment = $413a30192b54574f$var$Comment2$1;
$413a30192b54574f$var$postcss$3.Warning = $413a30192b54574f$var$Warning2$1;
$413a30192b54574f$var$postcss$3.AtRule = $413a30192b54574f$var$AtRule2$1;
$413a30192b54574f$var$postcss$3.Result = $413a30192b54574f$var$Result2$1;
$413a30192b54574f$var$postcss$3.Input = $413a30192b54574f$var$Input2$1;
$413a30192b54574f$var$postcss$3.Rule = $413a30192b54574f$var$Rule2$1;
$413a30192b54574f$var$postcss$3.Root = $413a30192b54574f$var$Root2$1;
$413a30192b54574f$var$postcss$3.Node = $413a30192b54574f$var$Node2$1;
$413a30192b54574f$var$LazyResult2$1.registerPostcss($413a30192b54574f$var$postcss$3);
var $413a30192b54574f$var$postcss_1$1 = $413a30192b54574f$var$postcss$3;
$413a30192b54574f$var$postcss$3.default = $413a30192b54574f$var$postcss$3;
var $413a30192b54574f$var$postcss$1$1 = /* @__PURE__ */ $413a30192b54574f$var$getDefaultExportFromCjs$1($413a30192b54574f$var$postcss_1$1);
$413a30192b54574f$var$postcss$1$1.stringify;
$413a30192b54574f$var$postcss$1$1.fromJSON;
$413a30192b54574f$var$postcss$1$1.plugin;
$413a30192b54574f$var$postcss$1$1.parse;
$413a30192b54574f$var$postcss$1$1.list;
$413a30192b54574f$var$postcss$1$1.document;
$413a30192b54574f$var$postcss$1$1.comment;
$413a30192b54574f$var$postcss$1$1.atRule;
$413a30192b54574f$var$postcss$1$1.rule;
$413a30192b54574f$var$postcss$1$1.decl;
$413a30192b54574f$var$postcss$1$1.root;
$413a30192b54574f$var$postcss$1$1.CssSyntaxError;
$413a30192b54574f$var$postcss$1$1.Declaration;
$413a30192b54574f$var$postcss$1$1.Container;
$413a30192b54574f$var$postcss$1$1.Processor;
$413a30192b54574f$var$postcss$1$1.Document;
$413a30192b54574f$var$postcss$1$1.Comment;
$413a30192b54574f$var$postcss$1$1.Warning;
$413a30192b54574f$var$postcss$1$1.AtRule;
$413a30192b54574f$var$postcss$1$1.Result;
$413a30192b54574f$var$postcss$1$1.Input;
$413a30192b54574f$var$postcss$1$1.Rule;
$413a30192b54574f$var$postcss$1$1.Root;
$413a30192b54574f$var$postcss$1$1.Node;
var $413a30192b54574f$var$__defProp2 = Object.defineProperty;
var $413a30192b54574f$var$__defNormalProp2 = function(obj, key, value) {
    return key in obj ? $413a30192b54574f$var$__defProp2(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $413a30192b54574f$var$__publicField2 = function(obj, key, value) {
    return $413a30192b54574f$var$__defNormalProp2(obj, (typeof key === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
function $413a30192b54574f$var$getDefaultExportFromCjs(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function $413a30192b54574f$var$getAugmentedNamespace(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a22() {
            if ($413a30192b54574f$var$_instanceof(this, a22)) return Reflect.construct(f2, arguments, this.constructor);
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n2, k);
        Object.defineProperty(a2, k, d.get ? d : {
            enumerable: true,
            get: function get() {
                return n2[k];
            }
        });
    });
    return a2;
}
var $413a30192b54574f$var$picocolors_browser = {
    exports: {}
};
var $413a30192b54574f$var$x = String;
var $413a30192b54574f$var$create = function create() {
    return {
        isColorSupported: false,
        reset: $413a30192b54574f$var$x,
        bold: $413a30192b54574f$var$x,
        dim: $413a30192b54574f$var$x,
        italic: $413a30192b54574f$var$x,
        underline: $413a30192b54574f$var$x,
        inverse: $413a30192b54574f$var$x,
        hidden: $413a30192b54574f$var$x,
        strikethrough: $413a30192b54574f$var$x,
        black: $413a30192b54574f$var$x,
        red: $413a30192b54574f$var$x,
        green: $413a30192b54574f$var$x,
        yellow: $413a30192b54574f$var$x,
        blue: $413a30192b54574f$var$x,
        magenta: $413a30192b54574f$var$x,
        cyan: $413a30192b54574f$var$x,
        white: $413a30192b54574f$var$x,
        gray: $413a30192b54574f$var$x,
        bgBlack: $413a30192b54574f$var$x,
        bgRed: $413a30192b54574f$var$x,
        bgGreen: $413a30192b54574f$var$x,
        bgYellow: $413a30192b54574f$var$x,
        bgBlue: $413a30192b54574f$var$x,
        bgMagenta: $413a30192b54574f$var$x,
        bgCyan: $413a30192b54574f$var$x,
        bgWhite: $413a30192b54574f$var$x
    };
};
$413a30192b54574f$var$picocolors_browser.exports = $413a30192b54574f$var$create();
$413a30192b54574f$var$picocolors_browser.exports.createColors = $413a30192b54574f$var$create;
var $413a30192b54574f$var$picocolors_browserExports = $413a30192b54574f$var$picocolors_browser.exports;
var $413a30192b54574f$var$__viteBrowserExternal = {};
var $413a30192b54574f$var$__viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $413a30192b54574f$var$__viteBrowserExternal
}, Symbol.toStringTag, {
    value: "Module"
}));
var $413a30192b54574f$var$require$$2 = /* @__PURE__ */ $413a30192b54574f$var$getAugmentedNamespace($413a30192b54574f$var$__viteBrowserExternal$1);
var $413a30192b54574f$var$pico = $413a30192b54574f$var$picocolors_browserExports;
var $413a30192b54574f$var$terminalHighlight$1 = $413a30192b54574f$var$require$$2;
var $413a30192b54574f$var$CssSyntaxError$3 = /*#__PURE__*/ function(Error1) {
    $413a30192b54574f$var$_inherits(CssSyntaxError2, Error1);
    function CssSyntaxError2(message, line, column, source, file, plugin22) {
        var _this;
        _this = Error1.call(this, message) || this;
        _this.name = "CssSyntaxError";
        _this.reason = message;
        if (file) _this.file = file;
        if (source) _this.source = source;
        if (plugin22) _this.plugin = plugin22;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                _this.line = line;
                _this.column = column;
            } else {
                _this.line = line.line;
                _this.column = line.column;
                _this.endLine = column.line;
                _this.endColumn = column.column;
            }
        }
        _this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(_this, CssSyntaxError2);
        return _this;
    }
    var _proto = CssSyntaxError2.prototype;
    _proto.setMessage = function setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    };
    _proto.showSourceCode = function showSourceCode(color) {
        var _this = this;
        if (!this.source) return "";
        var css = this.source;
        if (color == null) color = $413a30192b54574f$var$pico.isColorSupported;
        if ($413a30192b54574f$var$terminalHighlight$1) {
            if (color) css = $413a30192b54574f$var$terminalHighlight$1(css);
        }
        var lines = css.split(/\r?\n/);
        var start = Math.max(this.line - 3, 0);
        var end = Math.min(this.line + 2, lines.length);
        var maxWidth = String(end).length;
        var mark, aside;
        if (color) {
            var _pico_createColors = $413a30192b54574f$var$pico.createColors(true), bold = _pico_createColors.bold, gray = _pico_createColors.gray, red = _pico_createColors.red;
            mark = function(text) {
                return bold(red(text));
            };
            aside = function(text) {
                return gray(text);
            };
        } else mark = aside = function(str) {
            return str;
        };
        return lines.slice(start, end).map(function(line, index2) {
            var number = start + 1 + index2;
            var gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === _this.line) {
                var spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, _this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    };
    _proto.toString = function toString() {
        var code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    };
    return CssSyntaxError2;
}($413a30192b54574f$var$_wrap_native_super(Error));
var $413a30192b54574f$var$cssSyntaxError = $413a30192b54574f$var$CssSyntaxError$3;
$413a30192b54574f$var$CssSyntaxError$3.default = $413a30192b54574f$var$CssSyntaxError$3;
var $413a30192b54574f$var$symbols = {};
$413a30192b54574f$var$symbols.isClean = Symbol("isClean");
$413a30192b54574f$var$symbols.my = Symbol("my");
var $413a30192b54574f$var$DEFAULT_RAW = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $413a30192b54574f$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
var $413a30192b54574f$var$Stringifier$2 = /*#__PURE__*/ function() {
    function Stringifier2(builder) {
        this.builder = builder;
    }
    var _proto = Stringifier2.prototype;
    _proto.atrule = function atrule(node2, semicolon) {
        var name = "@" + node2.name;
        var params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") name += node2.raws.afterName;
        else if (params) name += " ";
        if (node2.nodes) this.block(node2, name + params);
        else {
            var end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    };
    _proto.beforeAfter = function beforeAfter(node2, detect) {
        var value;
        if (node2.type === "decl") value = this.raw(node2, null, "beforeDecl");
        else if (node2.type === "comment") value = this.raw(node2, null, "beforeComment");
        else if (detect === "before") value = this.raw(node2, null, "beforeRule");
        else value = this.raw(node2, null, "beforeClose");
        var buf = node2.parent;
        var depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            var indent = this.raw(node2, null, "indent");
            if (indent.length) for(var step = 0; step < depth; step++)value += indent;
        }
        return value;
    };
    _proto.block = function block(node2, start) {
        var between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        var after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else after = this.raw(node2, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    };
    _proto.body = function body(node2) {
        var last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        var semicolon = this.raw(node2, "semicolon");
        for(var i2 = 0; i2 < node2.nodes.length; i2++){
            var child = node2.nodes[i2];
            var before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i2 || semicolon);
        }
    };
    _proto.comment = function comment(node2) {
        var left = this.raw(node2, "left", "commentLeft");
        var right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    };
    _proto.decl = function decl(node2, semicolon) {
        var between = this.raw(node2, "between", "colon");
        var string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) string += node2.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node2);
    };
    _proto.document = function document1(node2) {
        this.body(node2);
    };
    _proto.raw = function raw(node2, own, detect) {
        var value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        var parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) return "";
            if (parent && parent.type === "document") return "";
        }
        if (!parent) return $413a30192b54574f$var$DEFAULT_RAW[detect];
        var root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") return root2.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node2, detect);
        else {
            var method = "raw" + $413a30192b54574f$var$capitalize(detect);
            if (this[method]) value = this[method](root2, node2);
            else root2.walk(function(i2) {
                value = i2.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $413a30192b54574f$var$DEFAULT_RAW[detect];
        root2.rawCache[detect] = value;
        return value;
    };
    _proto.rawBeforeClose = function rawBeforeClose(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length > 0) {
                if (typeof i2.raws.after !== "undefined") {
                    value = i2.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeComment = function rawBeforeComment(root2, node2) {
        var value;
        root2.walkComments(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeDecl = function rawBeforeDecl(root2, node2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeOpen = function rawBeforeOpen(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.type !== "decl") {
                value = i2.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawBeforeRule = function rawBeforeRule(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
                if (typeof i2.raws.before !== "undefined") {
                    value = i2.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawColon = function rawColon(root2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.between !== "undefined") {
                value = i2.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    };
    _proto.rawEmptyBody = function rawEmptyBody(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length === 0) {
                value = i2.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawIndent = function rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        var value;
        root2.walk(function(i2) {
            var p = i2.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i2.raws.before !== "undefined") {
                    var parts = i2.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    };
    _proto.rawSemicolon = function rawSemicolon(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
                value = i2.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawValue = function rawValue(node2, prop) {
        var value = node2[prop];
        var raw = node2.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    };
    _proto.root = function root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    };
    _proto.rule = function rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) this.builder(node2.raws.ownSemicolon, node2, "end");
    };
    _proto.stringify = function stringify(node2, semicolon) {
        if (!this[node2.type]) throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        this[node2.type](node2, semicolon);
    };
    return Stringifier2;
}();
var $413a30192b54574f$var$stringifier = $413a30192b54574f$var$Stringifier$2;
$413a30192b54574f$var$Stringifier$2.default = $413a30192b54574f$var$Stringifier$2;
var $413a30192b54574f$var$Stringifier$1 = $413a30192b54574f$var$stringifier;
function $413a30192b54574f$var$stringify$4(node2, builder) {
    var str = new $413a30192b54574f$var$Stringifier$1(builder);
    str.stringify(node2);
}
var $413a30192b54574f$var$stringify_1 = $413a30192b54574f$var$stringify$4;
$413a30192b54574f$var$stringify$4.default = $413a30192b54574f$var$stringify$4;
var $413a30192b54574f$var$isClean$2 = $413a30192b54574f$var$symbols.isClean, $413a30192b54574f$var$my$2 = $413a30192b54574f$var$symbols.my;
var $413a30192b54574f$var$CssSyntaxError$2 = $413a30192b54574f$var$cssSyntaxError;
var $413a30192b54574f$var$Stringifier22 = $413a30192b54574f$var$stringifier;
var $413a30192b54574f$var$stringify$3 = $413a30192b54574f$var$stringify_1;
function $413a30192b54574f$var$cloneNode(obj, parent) {
    var cloned = new obj.constructor();
    for(var i2 in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i2)) continue;
        if (i2 === "proxyCache") continue;
        var value = obj[i2];
        var type = typeof value === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(value);
        if (i2 === "parent" && type === "object") {
            if (parent) cloned[i2] = parent;
        } else if (i2 === "source") cloned[i2] = value;
        else if (Array.isArray(value)) cloned[i2] = value.map(function(j) {
            return $413a30192b54574f$var$cloneNode(j, cloned);
        });
        else {
            if (type === "object" && value !== null) value = $413a30192b54574f$var$cloneNode(value);
            cloned[i2] = value;
        }
    }
    return cloned;
}
var $413a30192b54574f$var$Node$4 = /*#__PURE__*/ function() {
    function Node3(defaults) {
        if (defaults === void 0) defaults = {};
        this.raws = {};
        this[$413a30192b54574f$var$isClean$2] = false;
        this[$413a30192b54574f$var$my$2] = true;
        for(var name in defaults)if (name === "nodes") {
            this.nodes = [];
            for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(defaults[name]), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (typeof node2.clone === "function") this.append(node2.clone());
                else this.append(node2);
            }
        } else this[name] = defaults[name];
    }
    var _proto = Node3.prototype;
    _proto.addToError = function addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            var s2 = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, "$&" + s2.input.from + ":" + s2.start.line + ":" + s2.start.column + "$&");
        }
        return error;
    };
    _proto.after = function after(add) {
        this.parent.insertAfter(this, add);
        return this;
    };
    _proto.assign = function assign(overrides) {
        if (overrides === void 0) overrides = {};
        for(var name in overrides)this[name] = overrides[name];
        return this;
    };
    _proto.before = function before(add) {
        this.parent.insertBefore(this, add);
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    };
    _proto.clone = function clone(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = $413a30192b54574f$var$cloneNode(this);
        for(var name in overrides)cloned[name] = overrides[name];
        return cloned;
    };
    _proto.cloneAfter = function cloneAfter(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    };
    _proto.cloneBefore = function cloneBefore(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    };
    _proto.error = function error(message, opts) {
        if (opts === void 0) opts = {};
        if (this.source) {
            var _this_rangeBy = this.rangeBy(opts), end = _this_rangeBy.end, start = _this_rangeBy.start;
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $413a30192b54574f$var$CssSyntaxError$2(message);
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node2.markDirty();
                return true;
            }
        };
    };
    _proto.markDirty = function markDirty() {
        if (this[$413a30192b54574f$var$isClean$2]) {
            this[$413a30192b54574f$var$isClean$2] = false;
            var next = this;
            while(next = next.parent)next[$413a30192b54574f$var$isClean$2] = false;
        }
    };
    _proto.next = function next() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    };
    _proto.positionBy = function positionBy(opts, stringRepresentation) {
        var pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    };
    _proto.positionInside = function positionInside(index2, stringRepresentation) {
        var string = stringRepresentation || this.toString();
        var column = this.source.start.column;
        var line = this.source.start.line;
        for(var i2 = 0; i2 < index2; i2++)if (string[i2] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    };
    _proto.prev = function prev() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    };
    _proto.rangeBy = function rangeBy(opts) {
        var start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        var end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            var stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === "number") end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    };
    _proto.raw = function raw(prop, defaultType) {
        var str = new $413a30192b54574f$var$Stringifier22();
        return str.raw(this, prop, defaultType);
    };
    _proto.remove = function remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = void 0;
        return this;
    };
    _proto.replaceWith = function replaceWith() {
        for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++)nodes[_key] = arguments[_key];
        if (this.parent) {
            var bookmark = this;
            var foundSelf = false;
            for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (node2 === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else this.parent.insertBefore(bookmark, node2);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    };
    _proto.root = function root() {
        var result2 = this;
        while(result2.parent && result2.parent.type !== "document")result2 = result2.parent;
        return result2;
    };
    _proto.toJSON = function toJSON(_, inputs) {
        var fixed = {};
        var emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        var inputsNextIndex = 0;
        for(var name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            var value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map(function(i2) {
                if ((typeof i2 === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(i2)) === "object" && i2.toJSON) return i2.toJSON(null, inputs);
                else return i2;
            });
            else if ((typeof value === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(value)) === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                var inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [].concat(inputs.keys()).map(function(input2) {
            return input2.toJSON();
        });
        return fixed;
    };
    _proto.toProxy = function toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    };
    _proto.toString = function toString(stringifier2) {
        if (stringifier2 === void 0) stringifier2 = $413a30192b54574f$var$stringify$3;
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        var result2 = "";
        stringifier2(this, function(i2) {
            result2 += i2;
        });
        return result2;
    };
    _proto.warn = function warn(result2, text, opts) {
        var data = {
            node: this
        };
        for(var i2 in opts)data[i2] = opts[i2];
        return result2.warn(text, data);
    };
    $413a30192b54574f$var$_create_class(Node3, [
        {
            key: "proxyOf",
            get: function get() {
                return this;
            }
        }
    ]);
    return Node3;
}();
var $413a30192b54574f$var$node = $413a30192b54574f$var$Node$4;
$413a30192b54574f$var$Node$4.default = $413a30192b54574f$var$Node$4;
var $413a30192b54574f$var$Node$3 = $413a30192b54574f$var$node;
var $413a30192b54574f$var$Declaration$4 = /*#__PURE__*/ function(Node$3) {
    $413a30192b54574f$var$_inherits(Declaration2, Node$3);
    function Declaration2(defaults) {
        var _this;
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = $413a30192b54574f$var$_extends({}, defaults, {
            value: String(defaults.value)
        });
        _this = Node$3.call(this, defaults) || this;
        _this.type = "decl";
        return _this;
    }
    $413a30192b54574f$var$_create_class(Declaration2, [
        {
            key: "variable",
            get: function get() {
                return this.prop.startsWith("--") || this.prop[0] === "$";
            }
        }
    ]);
    return Declaration2;
}($413a30192b54574f$var$Node$3);
var $413a30192b54574f$var$declaration = $413a30192b54574f$var$Declaration$4;
$413a30192b54574f$var$Declaration$4.default = $413a30192b54574f$var$Declaration$4;
var $413a30192b54574f$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var $413a30192b54574f$var$nanoid$1 = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i2 = size;
    while(i2--)id += $413a30192b54574f$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
var $413a30192b54574f$var$nonSecure = {
    nanoid: $413a30192b54574f$var$nanoid$1
};
var $413a30192b54574f$var$SourceMapConsumer$2 = $413a30192b54574f$var$require$$2.SourceMapConsumer, $413a30192b54574f$var$SourceMapGenerator$2 = $413a30192b54574f$var$require$$2.SourceMapGenerator;
var $413a30192b54574f$var$existsSync = $413a30192b54574f$var$require$$2.existsSync, $413a30192b54574f$var$readFileSync = $413a30192b54574f$var$require$$2.readFileSync;
var $413a30192b54574f$var$dirname$1 = $413a30192b54574f$var$require$$2.dirname, $413a30192b54574f$var$join = $413a30192b54574f$var$require$$2.join;
function $413a30192b54574f$var$fromBase64(str) {
    if ($413a30192b54574f$require$Buffer) return $413a30192b54574f$require$Buffer.from(str, "base64").toString();
    else return window.atob(str);
}
var $413a30192b54574f$var$PreviousMap$2 = /*#__PURE__*/ function() {
    function PreviousMap2(css, opts) {
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        var prev = opts.map ? opts.map.prev : void 0;
        var text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $413a30192b54574f$var$dirname$1(this.mapFile);
        if (text) this.text = text;
    }
    var _proto = PreviousMap2.prototype;
    _proto.consumer = function consumer() {
        if (!this.consumerCache) this.consumerCache = new $413a30192b54574f$var$SourceMapConsumer$2(this.text);
        return this.consumerCache;
    };
    _proto.decodeInline = function decodeInline(text) {
        var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        var baseUri = /^data:application\/json;base64,/;
        var charsetUri = /^data:application\/json;charset=utf-?8,/;
        var uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $413a30192b54574f$var$fromBase64(text.substr(RegExp.lastMatch.length));
        var encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    };
    _proto.getAnnotationURL = function getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    };
    _proto.isMap = function isMap(map) {
        if ((typeof map === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(map)) !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    };
    _proto.loadAnnotation = function loadAnnotation(css) {
        var comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        var start = css.lastIndexOf(comments.pop());
        var end = css.indexOf("*/", start);
        if (start > -1 && end > -1) this.annotation = this.getAnnotationURL(css.substring(start, end));
    };
    _proto.loadFile = function loadFile(path) {
        this.root = $413a30192b54574f$var$dirname$1(path);
        if ($413a30192b54574f$var$existsSync(path)) {
            this.mapFile = path;
            return $413a30192b54574f$var$readFileSync(path, "utf-8").toString().trim();
        }
    };
    _proto.loadMap = function loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                var prevPath = prev(file);
                if (prevPath) {
                    var map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if ($413a30192b54574f$var$_instanceof(prev, $413a30192b54574f$var$SourceMapConsumer$2)) return $413a30192b54574f$var$SourceMapGenerator$2.fromSourceMap(prev).toString();
            else if ($413a30192b54574f$var$_instanceof(prev, $413a30192b54574f$var$SourceMapGenerator$2)) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            var map1 = this.annotation;
            if (file) map1 = $413a30192b54574f$var$join($413a30192b54574f$var$dirname$1(file), map1);
            return this.loadFile(map1);
        }
    };
    _proto.startWith = function startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    };
    _proto.withContent = function withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    };
    return PreviousMap2;
}();
var $413a30192b54574f$var$previousMap = $413a30192b54574f$var$PreviousMap$2;
$413a30192b54574f$var$PreviousMap$2.default = $413a30192b54574f$var$PreviousMap$2;
var $413a30192b54574f$var$SourceMapConsumer$1 = $413a30192b54574f$var$require$$2.SourceMapConsumer, $413a30192b54574f$var$SourceMapGenerator$1 = $413a30192b54574f$var$require$$2.SourceMapGenerator;
var $413a30192b54574f$var$fileURLToPath = $413a30192b54574f$var$require$$2.fileURLToPath, $413a30192b54574f$var$pathToFileURL$1 = $413a30192b54574f$var$require$$2.pathToFileURL;
var $413a30192b54574f$var$isAbsolute = $413a30192b54574f$var$require$$2.isAbsolute, $413a30192b54574f$var$resolve$1 = $413a30192b54574f$var$require$$2.resolve;
var $413a30192b54574f$var$nanoid = $413a30192b54574f$var$nonSecure.nanoid;
var $413a30192b54574f$var$terminalHighlight = $413a30192b54574f$var$require$$2;
var $413a30192b54574f$var$CssSyntaxError$1 = $413a30192b54574f$var$cssSyntaxError;
var $413a30192b54574f$var$PreviousMap$1 = $413a30192b54574f$var$previousMap;
var $413a30192b54574f$var$fromOffsetCache = Symbol("fromOffsetCache");
var $413a30192b54574f$var$sourceMapAvailable$1 = Boolean($413a30192b54574f$var$SourceMapConsumer$1 && $413a30192b54574f$var$SourceMapGenerator$1);
var $413a30192b54574f$var$pathAvailable$1 = Boolean($413a30192b54574f$var$resolve$1 && $413a30192b54574f$var$isAbsolute);
var $413a30192b54574f$var$Input$4 = /*#__PURE__*/ function() {
    function Input2(css, opts) {
        if (opts === void 0) opts = {};
        if (css === null || typeof css === "undefined" || (typeof css === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(css)) === "object" && !css.toString) throw new Error("PostCSS received " + css + " instead of CSS string");
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$413a30192b54574f$var$pathAvailable$1 || /^\w+:\/\//.test(opts.from) || $413a30192b54574f$var$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $413a30192b54574f$var$resolve$1(opts.from);
        }
        if ($413a30192b54574f$var$pathAvailable$1 && $413a30192b54574f$var$sourceMapAvailable$1) {
            var map = new $413a30192b54574f$var$PreviousMap$1(this.css, opts);
            if (map.text) {
                this.map = map;
                var file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $413a30192b54574f$var$nanoid(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    var _proto = Input2.prototype;
    _proto.error = function error(message, line, column, opts) {
        if (opts === void 0) opts = {};
        var result2, endLine, endColumn;
        if (line && (typeof line === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(line)) === "object") {
            var start = line;
            var end = column;
            if (typeof start.offset === "number") {
                var pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                var pos1 = this.fromOffset(end.offset);
                endLine = pos1.line;
                endColumn = pos1.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            var pos2 = this.fromOffset(line);
            line = pos2.line;
            column = pos2.col;
        }
        var origin = this.origin(line, column, endLine, endColumn);
        if (origin) result2 = new $413a30192b54574f$var$CssSyntaxError$1(message, origin.endLine === void 0 ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === void 0 ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result2 = new $413a30192b54574f$var$CssSyntaxError$1(message, endLine === void 0 ? line : {
            column: column,
            line: line
        }, endLine === void 0 ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result2.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($413a30192b54574f$var$pathToFileURL$1) result2.input.url = $413a30192b54574f$var$pathToFileURL$1(this.file).toString();
            result2.input.file = this.file;
        }
        return result2;
    };
    _proto.fromOffset = function fromOffset(offset) {
        var lastLine, lineToIndex;
        if (!this[$413a30192b54574f$var$fromOffsetCache]) {
            var lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            var prevIndex = 0;
            for(var i2 = 0, l2 = lines.length; i2 < l2; i2++){
                lineToIndex[i2] = prevIndex;
                prevIndex += lines[i2].length + 1;
            }
            this[$413a30192b54574f$var$fromOffsetCache] = lineToIndex;
        } else lineToIndex = this[$413a30192b54574f$var$fromOffsetCache];
        lastLine = lineToIndex[lineToIndex.length - 1];
        var min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            var max = lineToIndex.length - 2;
            var mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    };
    _proto.mapResolve = function mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $413a30192b54574f$var$resolve$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    };
    _proto.origin = function origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        var consumer = this.map.consumer();
        var from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        var to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        var fromUrl;
        if ($413a30192b54574f$var$isAbsolute(from.source)) fromUrl = $413a30192b54574f$var$pathToFileURL$1(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $413a30192b54574f$var$pathToFileURL$1(this.map.mapFile));
        var result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($413a30192b54574f$var$fileURLToPath) result2.file = $413a30192b54574f$var$fileURLToPath(fromUrl);
            else throw new Error("file: protocol is not available in this PostCSS build");
        }
        var source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    };
    _proto.toJSON = function toJSON() {
        var json = {};
        for(var _i = 0, _iter = [
            "hasBOM",
            "css",
            "file",
            "id"
        ]; _i < _iter.length; _i++){
            var name = _iter[_i];
            if (this[name] != null) json[name] = this[name];
        }
        if (this.map) {
            json.map = $413a30192b54574f$var$_extends({}, this.map);
            if (json.map.consumerCache) json.map.consumerCache = void 0;
        }
        return json;
    };
    $413a30192b54574f$var$_create_class(Input2, [
        {
            key: "from",
            get: function get() {
                return this.file || this.id;
            }
        }
    ]);
    return Input2;
}();
var $413a30192b54574f$var$input = $413a30192b54574f$var$Input$4;
$413a30192b54574f$var$Input$4.default = $413a30192b54574f$var$Input$4;
if ($413a30192b54574f$var$terminalHighlight && $413a30192b54574f$var$terminalHighlight.registerInput) $413a30192b54574f$var$terminalHighlight.registerInput($413a30192b54574f$var$Input$4);
var $413a30192b54574f$var$SourceMapConsumer = $413a30192b54574f$var$require$$2.SourceMapConsumer, $413a30192b54574f$var$SourceMapGenerator = $413a30192b54574f$var$require$$2.SourceMapGenerator;
var $413a30192b54574f$var$dirname = $413a30192b54574f$var$require$$2.dirname, $413a30192b54574f$var$relative = $413a30192b54574f$var$require$$2.relative, $413a30192b54574f$var$resolve$3 = $413a30192b54574f$var$require$$2.resolve, $413a30192b54574f$var$sep = $413a30192b54574f$var$require$$2.sep;
var $413a30192b54574f$var$pathToFileURL = $413a30192b54574f$var$require$$2.pathToFileURL;
var $413a30192b54574f$var$Input$3 = $413a30192b54574f$var$input;
var $413a30192b54574f$var$sourceMapAvailable = Boolean($413a30192b54574f$var$SourceMapConsumer && $413a30192b54574f$var$SourceMapGenerator);
var $413a30192b54574f$var$pathAvailable = Boolean($413a30192b54574f$var$dirname && $413a30192b54574f$var$resolve$3 && $413a30192b54574f$var$relative && $413a30192b54574f$var$sep);
var $413a30192b54574f$var$MapGenerator$2 = /*#__PURE__*/ function() {
    function MapGenerator2(stringify2, root2, opts, cssString) {
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    var _proto = MapGenerator2.prototype;
    _proto.addAnnotation = function addAnnotation() {
        var content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        var eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    };
    _proto.applyPrevMaps = function applyPrevMaps() {
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(this.previous()), _step; !(_step = _iterator()).done;){
            var prev = _step.value;
            var from = this.toUrl(this.path(prev.file));
            var root2 = prev.root || $413a30192b54574f$var$dirname(prev.file);
            var map = void 0;
            if (this.mapOpts.sourcesContent === false) {
                map = new $413a30192b54574f$var$SourceMapConsumer(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    };
    _proto.clearAnnotation = function clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            var node2;
            for(var i2 = this.root.nodes.length - 1; i2 >= 0; i2--){
                node2 = this.root.nodes[i2];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i2);
            }
        } else if (this.css) this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    };
    _proto.generate = function generate() {
        this.clearAnnotation();
        if ($413a30192b54574f$var$pathAvailable && $413a30192b54574f$var$sourceMapAvailable && this.isMap()) return this.generateMap();
        else {
            var result2 = "";
            this.stringify(this.root, function(i2) {
                result2 += i2;
            });
            return [
                result2
            ];
        }
    };
    _proto.generateMap = function generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            var prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $413a30192b54574f$var$SourceMapGenerator.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $413a30192b54574f$var$SourceMapGenerator({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    };
    _proto.generateString = function generateString() {
        var _this = this;
        this.css = "";
        this.map = new $413a30192b54574f$var$SourceMapGenerator({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        var line = 1;
        var column = 1;
        var noSource = "<no source>";
        var mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        var lines, last;
        this.stringify(this.root, function(str, node2, type) {
            _this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = _this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    _this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    _this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node2 && type !== "start") {
                var p = node2.parent || {
                    raws: {}
                };
                var childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = _this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        _this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        _this.map.addMapping(mapping);
                    }
                }
            }
        });
    };
    _proto.isAnnotation = function isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.annotation;
        });
        return true;
    };
    _proto.isInline = function isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        var annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.inline;
        });
        return true;
    };
    _proto.isMap = function isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    };
    _proto.isSourcesContent = function isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.withContent();
        });
        return true;
    };
    _proto.outputFile = function outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    };
    _proto.path = function path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        var cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        var from = this.opts.to ? $413a30192b54574f$var$dirname(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $413a30192b54574f$var$dirname($413a30192b54574f$var$resolve$3(from, this.mapOpts.annotation));
        var path = $413a30192b54574f$var$relative(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    };
    _proto.previous = function previous() {
        var _this = this;
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk(function(node2) {
                if (node2.source && node2.source.input.map) {
                    var map = node2.source.input.map;
                    if (!_this.previousMaps.includes(map)) _this.previousMaps.push(map);
                }
            });
            else {
                var input2 = new $413a30192b54574f$var$Input$3(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    };
    _proto.setSourcesContent = function setSourcesContent() {
        var _this = this;
        var already = {};
        if (this.root) this.root.walk(function(node2) {
            if (node2.source) {
                var from = node2.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    var fromUrl = _this.usesFileUrls ? _this.toFileUrl(from) : _this.toUrl(_this.path(from));
                    _this.map.setSourceContent(fromUrl, node2.source.input.css);
                }
            }
        });
        else if (this.css) {
            var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    };
    _proto.sourcePath = function sourcePath(node2) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node2.source.input.from);
        else return this.toUrl(this.path(node2.source.input.from));
    };
    _proto.toBase64 = function toBase64(str) {
        if ($413a30192b54574f$require$Buffer) return $413a30192b54574f$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    };
    _proto.toFileUrl = function toFileUrl(path) {
        var cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($413a30192b54574f$var$pathToFileURL) {
            var fileURL = $413a30192b54574f$var$pathToFileURL(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    };
    _proto.toUrl = function toUrl(path) {
        var cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($413a30192b54574f$var$sep === "\\") path = path.replace(/\\/g, "/");
        var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    };
    return MapGenerator2;
}();
var $413a30192b54574f$var$mapGenerator = $413a30192b54574f$var$MapGenerator$2;
var $413a30192b54574f$var$Node$2 = $413a30192b54574f$var$node;
var $413a30192b54574f$var$Comment$4 = /*#__PURE__*/ function(Node$2) {
    $413a30192b54574f$var$_inherits(Comment2, Node$2);
    function Comment2(defaults) {
        var _this;
        _this = Node$2.call(this, defaults) || this;
        _this.type = "comment";
        return _this;
    }
    return Comment2;
}($413a30192b54574f$var$Node$2);
var $413a30192b54574f$var$comment = $413a30192b54574f$var$Comment$4;
$413a30192b54574f$var$Comment$4.default = $413a30192b54574f$var$Comment$4;
var $413a30192b54574f$var$isClean$1 = $413a30192b54574f$var$symbols.isClean, $413a30192b54574f$var$my$1 = $413a30192b54574f$var$symbols.my;
var $413a30192b54574f$var$Declaration$3 = $413a30192b54574f$var$declaration;
var $413a30192b54574f$var$Comment$3 = $413a30192b54574f$var$comment;
var $413a30192b54574f$var$Node$1 = $413a30192b54574f$var$node;
var $413a30192b54574f$var$parse$4, $413a30192b54574f$var$Rule$4, $413a30192b54574f$var$AtRule$4, $413a30192b54574f$var$Root$6;
function $413a30192b54574f$var$cleanSource(nodes) {
    return nodes.map(function(i2) {
        if (i2.nodes) i2.nodes = $413a30192b54574f$var$cleanSource(i2.nodes);
        delete i2.source;
        return i2;
    });
}
function $413a30192b54574f$var$markDirtyUp(node2) {
    node2[$413a30192b54574f$var$isClean$1] = false;
    if (node2.proxyOf.nodes) for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(node2.proxyOf.nodes), _step; !(_step = _iterator()).done;){
        var i2 = _step.value;
        $413a30192b54574f$var$markDirtyUp(i2);
    }
}
var $413a30192b54574f$var$Container$7 = /*#__PURE__*/ function(Node$1) {
    $413a30192b54574f$var$_inherits(Container2, Node$1);
    function Container2() {
        return Node$1.apply(this, arguments) || this;
    }
    var _proto = Container2.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.last);
            for(var _iterator1 = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.push(node2);
            }
        }
        this.markDirty();
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        Node$1.prototype.cleanRaws.call(this, keepBetween);
        if (this.nodes) for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(this.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.cleanRaws(keepBetween);
        }
    };
    _proto.each = function each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        var iterator = this.getIterator();
        var index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    };
    _proto.every = function every(condition) {
        return this.nodes.every(condition);
    };
    _proto.getIterator = function getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        var iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (!node2[prop]) return node2[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _node2;
                    return (_node2 = node2)[prop].apply(_node2, [].concat(args.map(function(i2) {
                        if (typeof i2 === "function") return function(child, index2) {
                            return i2(child.toProxy(), index2);
                        };
                        else return i2;
                    })));
                };
                else if (prop === "every" || prop === "some") return function(cb) {
                    return node2[prop](function(child) {
                        for(var _len = arguments.length, other = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)other[_key - 1] = arguments[_key];
                        return cb.apply(void 0, [].concat([
                            child.toProxy()
                        ], other));
                    });
                };
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else if (prop === "nodes") return node2.nodes.map(function(i2) {
                    return i2.toProxy();
                });
                else if (prop === "first" || prop === "last") return node2[prop].toProxy();
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node2.markDirty();
                return true;
            }
        };
    };
    _proto.index = function index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    };
    _proto.insertAfter = function insertAfter(exist, add) {
        var existIndex = this.index(exist);
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.insertBefore = function insertBefore(exist, add) {
        var existIndex = this.index(exist);
        var type = existIndex === 0 ? "prepend" : false;
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.normalize = function normalize(nodes, sample) {
        var _this = this;
        if (typeof nodes === "string") nodes = $413a30192b54574f$var$cleanSource($413a30192b54574f$var$parse$4(nodes).nodes);
        else if (typeof nodes === "undefined") nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var i2 = _step.value;
                if (i2.parent) i2.parent.removeChild(i2, "ignore");
            }
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for(var _iterator1 = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var i21 = _step1.value;
                if (i21.parent) i21.parent.removeChild(i21, "ignore");
            }
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $413a30192b54574f$var$Declaration$3(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $413a30192b54574f$var$Rule$4(nodes)
        ];
        else if (nodes.name) nodes = [
            new $413a30192b54574f$var$AtRule$4(nodes)
        ];
        else if (nodes.text) nodes = [
            new $413a30192b54574f$var$Comment$3(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        var processed = nodes.map(function(i2) {
            if (!i2[$413a30192b54574f$var$my$1]) Container2.rebuild(i2);
            i2 = i2.proxyOf;
            if (i2.parent) i2.parent.removeChild(i2);
            if (i2[$413a30192b54574f$var$isClean$1]) $413a30192b54574f$var$markDirtyUp(i2);
            if (typeof i2.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i2.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i2.parent = _this.proxyOf;
            return i2;
        });
        return processed;
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        children = children.reverse();
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.first, "prepend").reverse();
            for(var _iterator1 = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.unshift(node2);
            }
            for(var id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.push = function push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    };
    _proto.removeAll = function removeAll() {
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(this.proxyOf.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.parent = void 0;
        }
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    };
    _proto.removeChild = function removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) this.indexes[id] = index2 - 1;
        }
        this.markDirty();
        return this;
    };
    _proto.replaceValues = function replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls(function(decl) {
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    };
    _proto.some = function some(condition) {
        return this.nodes.some(condition);
    };
    _proto.walk = function walk(callback) {
        return this.each(function(child, i2) {
            var result2;
            try {
                result2 = callback(child, i2);
            } catch (e2) {
                throw child.addToError(e2);
            }
            if (result2 !== false && child.walk) result2 = child.walk(callback);
            return result2;
        });
    };
    _proto.walkAtRules = function walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk(function(child, i2) {
                if (child.type === "atrule") return callback(child, i2);
            });
        }
        if ($413a30192b54574f$var$_instanceof(name, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "atrule" && child.name === name) return callback(child, i2);
        });
    };
    _proto.walkComments = function walkComments(callback) {
        return this.walk(function(child, i2) {
            if (child.type === "comment") return callback(child, i2);
        });
    };
    _proto.walkDecls = function walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk(function(child, i2) {
                if (child.type === "decl") return callback(child, i2);
            });
        }
        if ($413a30192b54574f$var$_instanceof(prop, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "decl" && child.prop === prop) return callback(child, i2);
        });
    };
    _proto.walkRules = function walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk(function(child, i2) {
                if (child.type === "rule") return callback(child, i2);
            });
        }
        if ($413a30192b54574f$var$_instanceof(selector, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "rule" && child.selector === selector) return callback(child, i2);
        });
    };
    $413a30192b54574f$var$_create_class(Container2, [
        {
            key: "first",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[0];
            }
        },
        {
            key: "last",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
            }
        }
    ]);
    return Container2;
}($413a30192b54574f$var$Node$1);
$413a30192b54574f$var$Container$7.registerParse = function(dependant) {
    $413a30192b54574f$var$parse$4 = dependant;
};
$413a30192b54574f$var$Container$7.registerRule = function(dependant) {
    $413a30192b54574f$var$Rule$4 = dependant;
};
$413a30192b54574f$var$Container$7.registerAtRule = function(dependant) {
    $413a30192b54574f$var$AtRule$4 = dependant;
};
$413a30192b54574f$var$Container$7.registerRoot = function(dependant) {
    $413a30192b54574f$var$Root$6 = dependant;
};
var $413a30192b54574f$var$container = $413a30192b54574f$var$Container$7;
$413a30192b54574f$var$Container$7.default = $413a30192b54574f$var$Container$7;
$413a30192b54574f$var$Container$7.rebuild = function(node2) {
    if (node2.type === "atrule") Object.setPrototypeOf(node2, $413a30192b54574f$var$AtRule$4.prototype);
    else if (node2.type === "rule") Object.setPrototypeOf(node2, $413a30192b54574f$var$Rule$4.prototype);
    else if (node2.type === "decl") Object.setPrototypeOf(node2, $413a30192b54574f$var$Declaration$3.prototype);
    else if (node2.type === "comment") Object.setPrototypeOf(node2, $413a30192b54574f$var$Comment$3.prototype);
    else if (node2.type === "root") Object.setPrototypeOf(node2, $413a30192b54574f$var$Root$6.prototype);
    node2[$413a30192b54574f$var$my$1] = true;
    if (node2.nodes) node2.nodes.forEach(function(child) {
        $413a30192b54574f$var$Container$7.rebuild(child);
    });
};
var $413a30192b54574f$var$Container$6 = $413a30192b54574f$var$container;
var $413a30192b54574f$var$LazyResult$4, $413a30192b54574f$var$Processor$3;
var $413a30192b54574f$var$Document$3 = /*#__PURE__*/ function(Container$6) {
    $413a30192b54574f$var$_inherits(Document23, Container$6);
    function Document23(defaults) {
        var _this;
        _this = Container$6.call(this, $413a30192b54574f$var$_extends({
            type: "document"
        }, defaults)) || this;
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Document23.prototype;
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $413a30192b54574f$var$LazyResult$4(new $413a30192b54574f$var$Processor$3(), this, opts);
        return lazy.stringify();
    };
    return Document23;
}($413a30192b54574f$var$Container$6);
$413a30192b54574f$var$Document$3.registerLazyResult = function(dependant) {
    $413a30192b54574f$var$LazyResult$4 = dependant;
};
$413a30192b54574f$var$Document$3.registerProcessor = function(dependant) {
    $413a30192b54574f$var$Processor$3 = dependant;
};
var $413a30192b54574f$var$document$1$2 = $413a30192b54574f$var$Document$3;
$413a30192b54574f$var$Document$3.default = $413a30192b54574f$var$Document$3;
var $413a30192b54574f$var$printed = {};
var $413a30192b54574f$var$warnOnce$2 = function warnOnce2(message) {
    if ($413a30192b54574f$var$printed[message]) return;
    $413a30192b54574f$var$printed[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};
var $413a30192b54574f$var$Warning$2 = /*#__PURE__*/ function() {
    function Warning2(text, opts) {
        if (opts === void 0) opts = {};
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            var range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(var opt in opts)this[opt] = opts[opt];
    }
    var _proto = Warning2.prototype;
    _proto.toString = function toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    };
    return Warning2;
}();
var $413a30192b54574f$var$warning = $413a30192b54574f$var$Warning$2;
$413a30192b54574f$var$Warning$2.default = $413a30192b54574f$var$Warning$2;
var $413a30192b54574f$var$Warning$1 = $413a30192b54574f$var$warning;
var $413a30192b54574f$var$Result$3 = /*#__PURE__*/ function() {
    function Result2(processor2, root2, opts) {
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
    var _proto = Result2.prototype;
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.warn = function warn(text, opts) {
        if (opts === void 0) opts = {};
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        var warning2 = new $413a30192b54574f$var$Warning$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    };
    _proto.warnings = function warnings() {
        return this.messages.filter(function(i2) {
            return i2.type === "warning";
        });
    };
    $413a30192b54574f$var$_create_class(Result2, [
        {
            key: "content",
            get: function get() {
                return this.css;
            }
        }
    ]);
    return Result2;
}();
var $413a30192b54574f$var$result = $413a30192b54574f$var$Result$3;
$413a30192b54574f$var$Result$3.default = $413a30192b54574f$var$Result$3;
var $413a30192b54574f$var$SINGLE_QUOTE = "'".charCodeAt(0);
var $413a30192b54574f$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
var $413a30192b54574f$var$BACKSLASH = "\\".charCodeAt(0);
var $413a30192b54574f$var$SLASH = "/".charCodeAt(0);
var $413a30192b54574f$var$NEWLINE = "\n".charCodeAt(0);
var $413a30192b54574f$var$SPACE = " ".charCodeAt(0);
var $413a30192b54574f$var$FEED = "\f".charCodeAt(0);
var $413a30192b54574f$var$TAB = "	".charCodeAt(0);
var $413a30192b54574f$var$CR = "\r".charCodeAt(0);
var $413a30192b54574f$var$OPEN_SQUARE = "[".charCodeAt(0);
var $413a30192b54574f$var$CLOSE_SQUARE = "]".charCodeAt(0);
var $413a30192b54574f$var$OPEN_PARENTHESES = "(".charCodeAt(0);
var $413a30192b54574f$var$CLOSE_PARENTHESES = ")".charCodeAt(0);
var $413a30192b54574f$var$OPEN_CURLY = "{".charCodeAt(0);
var $413a30192b54574f$var$CLOSE_CURLY = "}".charCodeAt(0);
var $413a30192b54574f$var$SEMICOLON = ";".charCodeAt(0);
var $413a30192b54574f$var$ASTERISK = "*".charCodeAt(0);
var $413a30192b54574f$var$COLON = ":".charCodeAt(0);
var $413a30192b54574f$var$AT = "@".charCodeAt(0);
var $413a30192b54574f$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var $413a30192b54574f$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var $413a30192b54574f$var$RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
var $413a30192b54574f$var$RE_HEX_ESCAPE = /[\da-f]/i;
var $413a30192b54574f$var$tokenize = function tokenizer2(input2, options) {
    if (options === void 0) options = {};
    var css = input2.css.valueOf();
    var ignore = options.ignoreErrors;
    var code, next, quote, content, escape;
    var escaped, escapePos, prev, n2, currentToken;
    var length = css.length;
    var pos = 0;
    var buffer = [];
    var returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $413a30192b54574f$var$NEWLINE:
            case $413a30192b54574f$var$SPACE:
            case $413a30192b54574f$var$TAB:
            case $413a30192b54574f$var$CR:
            case $413a30192b54574f$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $413a30192b54574f$var$SPACE || code === $413a30192b54574f$var$NEWLINE || code === $413a30192b54574f$var$TAB || code === $413a30192b54574f$var$CR || code === $413a30192b54574f$var$FEED);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $413a30192b54574f$var$OPEN_SQUARE:
            case $413a30192b54574f$var$CLOSE_SQUARE:
            case $413a30192b54574f$var$OPEN_CURLY:
            case $413a30192b54574f$var$CLOSE_CURLY:
            case $413a30192b54574f$var$COLON:
            case $413a30192b54574f$var$SEMICOLON:
            case $413a30192b54574f$var$CLOSE_PARENTHESES:
                var controlChar = String.fromCharCode(code);
                currentToken = [
                    controlChar,
                    controlChar,
                    pos
                ];
                break;
            case $413a30192b54574f$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : "";
                n2 = css.charCodeAt(pos + 1);
                if (prev === "url" && n2 !== $413a30192b54574f$var$SINGLE_QUOTE && n2 !== $413a30192b54574f$var$DOUBLE_QUOTE && n2 !== $413a30192b54574f$var$SPACE && n2 !== $413a30192b54574f$var$NEWLINE && n2 !== $413a30192b54574f$var$TAB && n2 !== $413a30192b54574f$var$FEED && n2 !== $413a30192b54574f$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $413a30192b54574f$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $413a30192b54574f$var$RE_BAD_BRACKET.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $413a30192b54574f$var$SINGLE_QUOTE:
            case $413a30192b54574f$var$DOUBLE_QUOTE:
                quote = code === $413a30192b54574f$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $413a30192b54574f$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $413a30192b54574f$var$AT:
                $413a30192b54574f$var$RE_AT_END.lastIndex = pos + 1;
                $413a30192b54574f$var$RE_AT_END.test(css);
                if ($413a30192b54574f$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $413a30192b54574f$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $413a30192b54574f$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $413a30192b54574f$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $413a30192b54574f$var$SLASH && code !== $413a30192b54574f$var$SPACE && code !== $413a30192b54574f$var$NEWLINE && code !== $413a30192b54574f$var$TAB && code !== $413a30192b54574f$var$CR && code !== $413a30192b54574f$var$FEED) {
                    next += 1;
                    if ($413a30192b54574f$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($413a30192b54574f$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $413a30192b54574f$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $413a30192b54574f$var$SLASH && css.charCodeAt(pos + 1) === $413a30192b54574f$var$ASTERISK) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $413a30192b54574f$var$RE_WORD_END.lastIndex = pos + 1;
                    $413a30192b54574f$var$RE_WORD_END.test(css);
                    if ($413a30192b54574f$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $413a30192b54574f$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};
var $413a30192b54574f$var$Container$5 = $413a30192b54574f$var$container;
var $413a30192b54574f$var$AtRule$3 = /*#__PURE__*/ function(Container$5) {
    $413a30192b54574f$var$_inherits(AtRule2, Container$5);
    function AtRule2(defaults) {
        var _this;
        _this = Container$5.call(this, defaults) || this;
        _this.type = "atrule";
        return _this;
    }
    var _proto = AtRule2.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5_prototype_append;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5_prototype_append = Container$5.prototype.append).call.apply(_Container$5_prototype_append, [].concat([
            this
        ], children));
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5_prototype_prepend;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5_prototype_prepend = Container$5.prototype.prepend).call.apply(_Container$5_prototype_prepend, [].concat([
            this
        ], children));
    };
    return AtRule2;
}($413a30192b54574f$var$Container$5);
var $413a30192b54574f$var$atRule = $413a30192b54574f$var$AtRule$3;
$413a30192b54574f$var$AtRule$3.default = $413a30192b54574f$var$AtRule$3;
$413a30192b54574f$var$Container$5.registerAtRule($413a30192b54574f$var$AtRule$3);
var $413a30192b54574f$var$Container$4 = $413a30192b54574f$var$container;
var $413a30192b54574f$var$LazyResult$3, $413a30192b54574f$var$Processor$2;
var $413a30192b54574f$var$Root$5 = /*#__PURE__*/ function(Container$4) {
    $413a30192b54574f$var$_inherits(Root2, Container$4);
    function Root2(defaults) {
        var _this;
        _this = Container$4.call(this, defaults) || this;
        _this.type = "root";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Root2.prototype;
    _proto.normalize = function normalize(child, sample, type) {
        var nodes = Container$4.prototype.normalize.call(this, child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                node2.raws.before = sample.raws.before;
            }
        }
        return nodes;
    };
    _proto.removeChild = function removeChild(child, ignore) {
        var index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index2].raws.before;
        return Container$4.prototype.removeChild.call(this, child);
    };
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $413a30192b54574f$var$LazyResult$3(new $413a30192b54574f$var$Processor$2(), this, opts);
        return lazy.stringify();
    };
    return Root2;
}($413a30192b54574f$var$Container$4);
$413a30192b54574f$var$Root$5.registerLazyResult = function(dependant) {
    $413a30192b54574f$var$LazyResult$3 = dependant;
};
$413a30192b54574f$var$Root$5.registerProcessor = function(dependant) {
    $413a30192b54574f$var$Processor$2 = dependant;
};
var $413a30192b54574f$var$root = $413a30192b54574f$var$Root$5;
$413a30192b54574f$var$Root$5.default = $413a30192b54574f$var$Root$5;
$413a30192b54574f$var$Container$4.registerRoot($413a30192b54574f$var$Root$5);
var $413a30192b54574f$var$list$2 = {
    comma: function comma(string) {
        return $413a30192b54574f$var$list$2.split(string, [
            ","
        ], true);
    },
    space: function space(string) {
        var spaces = [
            " ",
            "\n",
            "	"
        ];
        return $413a30192b54574f$var$list$2.split(string, spaces);
    },
    split: function split(string, separators, last) {
        var array = [];
        var current = "";
        var split = false;
        var func = 0;
        var inQuote = false;
        var prevQuote = "";
        var escape = false;
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(string), _step; !(_step = _iterator()).done;){
            var letter = _step.value;
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var $413a30192b54574f$var$list_1 = $413a30192b54574f$var$list$2;
$413a30192b54574f$var$list$2.default = $413a30192b54574f$var$list$2;
var $413a30192b54574f$var$Container$3 = $413a30192b54574f$var$container;
var $413a30192b54574f$var$list$1 = $413a30192b54574f$var$list_1;
var $413a30192b54574f$var$Rule$3 = /*#__PURE__*/ function(Container$3) {
    $413a30192b54574f$var$_inherits(Rule2, Container$3);
    function Rule2(defaults) {
        var _this;
        _this = Container$3.call(this, defaults) || this;
        _this.type = "rule";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    $413a30192b54574f$var$_create_class(Rule2, [
        {
            key: "selectors",
            get: function get() {
                return $413a30192b54574f$var$list$1.comma(this.selector);
            },
            set: function set(values) {
                var match = this.selector ? this.selector.match(/,\s*/) : null;
                var sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
                this.selector = values.join(sep2);
            }
        }
    ]);
    return Rule2;
}($413a30192b54574f$var$Container$3);
var $413a30192b54574f$var$rule = $413a30192b54574f$var$Rule$3;
$413a30192b54574f$var$Rule$3.default = $413a30192b54574f$var$Rule$3;
$413a30192b54574f$var$Container$3.registerRule($413a30192b54574f$var$Rule$3);
var $413a30192b54574f$var$Declaration$2 = $413a30192b54574f$var$declaration;
var $413a30192b54574f$var$tokenizer22 = $413a30192b54574f$var$tokenize;
var $413a30192b54574f$var$Comment$2 = $413a30192b54574f$var$comment;
var $413a30192b54574f$var$AtRule$2 = $413a30192b54574f$var$atRule;
var $413a30192b54574f$var$Root$4 = $413a30192b54574f$var$root;
var $413a30192b54574f$var$Rule$2 = $413a30192b54574f$var$rule;
var $413a30192b54574f$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $413a30192b54574f$var$findLastWithPosition(tokens) {
    for(var i2 = tokens.length - 1; i2 >= 0; i2--){
        var token = tokens[i2];
        var pos = token[3] || token[2];
        if (pos) return pos;
    }
}
var $413a30192b54574f$var$Parser$1 = /*#__PURE__*/ function() {
    function Parser2(input2) {
        this.input = input2;
        this.root = new $413a30192b54574f$var$Root$4();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    var _proto = Parser2.prototype;
    _proto.atrule = function atrule(token) {
        var node2 = new $413a30192b54574f$var$AtRule$2();
        node2.name = token[1].slice(1);
        if (node2.name === "") this.unnamedAtrule(node2, token);
        this.init(node2, token[2]);
        var type;
        var prev;
        var shift;
        var last = false;
        var open = false;
        var params = [];
        var brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    };
    _proto.checkMissedSemicolon = function checkMissedSemicolon(tokens) {
        var colon = this.colon(tokens);
        if (colon === false) return;
        var founded = 0;
        var token;
        for(var j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    };
    _proto.colon = function colon(tokens) {
        var brackets = 0;
        var token, type, prev;
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(tokens.entries()), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, i2 = _step_value[0], element = _step_value[1];
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i2;
            }
            prev = token;
        }
        return false;
    };
    _proto.comment = function comment(token) {
        var node2 = new $413a30192b54574f$var$Comment$2();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        var text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    };
    _proto.createTokenizer = function createTokenizer() {
        this.tokenizer = $413a30192b54574f$var$tokenizer22(this.input);
    };
    _proto.decl = function decl(tokens, customProperty) {
        var node2 = new $413a30192b54574f$var$Declaration$2();
        this.init(node2, tokens[0][2]);
        var last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || $413a30192b54574f$var$findLastWithPosition(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            var type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        var token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        var firstSpaces = [];
        var next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(var i2 = tokens.length - 1; i2 >= 0; i2--){
            token = tokens[i2];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                var string = this.stringFrom(tokens, i2);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                var cache = tokens.slice(0);
                var str = "";
                for(var j = i2; j > 0; j--){
                    var type1 = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type1 !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        var hasWord = tokens.some(function(i2) {
            return i2[0] !== "space" && i2[0] !== "comment";
        });
        if (hasWord) {
            node2.raws.between += firstSpaces.map(function(i2) {
                return i2[1];
            }).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    };
    _proto.doubleColon = function doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    _proto.emptyRule = function emptyRule(token) {
        var node2 = new $413a30192b54574f$var$Rule$2();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    };
    _proto.end = function end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    };
    _proto.endFile = function endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    };
    _proto.freeSemicolon = function freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            var prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    };
    // Helpers
    _proto.getPosition = function getPosition(offset) {
        var pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    };
    _proto.init = function init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    };
    _proto.other = function other(start) {
        var end = false;
        var type = null;
        var colon = false;
        var bracket = null;
        var brackets = [];
        var customProperty = start[1].startsWith("--");
        var tokens = [];
        var token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    };
    _proto.parse = function parse() {
        var token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    };
    _proto.precheckMissedSemicolon = function precheckMissedSemicolon() {};
    _proto.raw = function raw(node2, prop, tokens, customProperty) {
        var token, type;
        var length = tokens.length;
        var value = "";
        var clean = true;
        var next, prev;
        for(var i2 = 0; i2 < length; i2 += 1){
            token = tokens[i2];
            type = token[0];
            if (type === "space" && i2 === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
                next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
                if (!$413a30192b54574f$var$SAFE_COMMENT_NEIGHBOR[prev] && !$413a30192b54574f$var$SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            var raw = tokens.reduce(function(all, i2) {
                return all + i2[1];
            }, "");
            node2.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node2[prop] = value;
    };
    _proto.rule = function rule(tokens) {
        tokens.pop();
        var node2 = new $413a30192b54574f$var$Rule$2();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    };
    _proto.spacesAndCommentsFromEnd = function spacesAndCommentsFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    // Errors
    _proto.spacesAndCommentsFromStart = function spacesAndCommentsFromStart(tokens) {
        var next;
        var spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    };
    _proto.spacesFromEnd = function spacesFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    _proto.stringFrom = function stringFrom(tokens, from) {
        var result2 = "";
        for(var i2 = from; i2 < tokens.length; i2++)result2 += tokens[i2][1];
        tokens.splice(from, tokens.length - from);
        return result2;
    };
    _proto.unclosedBlock = function unclosedBlock() {
        var pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    };
    _proto.unclosedBracket = function unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    };
    _proto.unexpectedClose = function unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    };
    _proto.unknownWord = function unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    };
    _proto.unnamedAtrule = function unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    return Parser2;
}();
var $413a30192b54574f$var$parser = $413a30192b54574f$var$Parser$1;
var $413a30192b54574f$var$Container$2 = $413a30192b54574f$var$container;
var $413a30192b54574f$var$Parser22 = $413a30192b54574f$var$parser;
var $413a30192b54574f$var$Input$2 = $413a30192b54574f$var$input;
function $413a30192b54574f$var$parse$3(css, opts) {
    var input2 = new $413a30192b54574f$var$Input$2(css, opts);
    var parser2 = new $413a30192b54574f$var$Parser22(input2);
    try {
        parser2.parse();
    } catch (e2) {
        throw e2;
    }
    return parser2.root;
}
var $413a30192b54574f$var$parse_1 = $413a30192b54574f$var$parse$3;
$413a30192b54574f$var$parse$3.default = $413a30192b54574f$var$parse$3;
$413a30192b54574f$var$Container$2.registerParse($413a30192b54574f$var$parse$3);
var $413a30192b54574f$var$isClean = $413a30192b54574f$var$symbols.isClean, $413a30192b54574f$var$my = $413a30192b54574f$var$symbols.my;
var $413a30192b54574f$var$MapGenerator$1 = $413a30192b54574f$var$mapGenerator;
var $413a30192b54574f$var$stringify$2 = $413a30192b54574f$var$stringify_1;
var $413a30192b54574f$var$Container$1 = $413a30192b54574f$var$container;
var $413a30192b54574f$var$Document$2 = $413a30192b54574f$var$document$1$2;
var $413a30192b54574f$var$warnOnce$1 = $413a30192b54574f$var$warnOnce$2;
var $413a30192b54574f$var$Result$2 = $413a30192b54574f$var$result;
var $413a30192b54574f$var$parse$2 = $413a30192b54574f$var$parse_1;
var $413a30192b54574f$var$Root$3 = $413a30192b54574f$var$root;
var $413a30192b54574f$var$TYPE_TO_CLASS_NAME = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
var $413a30192b54574f$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
var $413a30192b54574f$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
var $413a30192b54574f$var$CHILDREN = 0;
function $413a30192b54574f$var$isPromise(obj) {
    return (typeof obj === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(obj)) === "object" && typeof obj.then === "function";
}
function $413a30192b54574f$var$getEvents(node2) {
    var key = false;
    var type = $413a30192b54574f$var$TYPE_TO_CLASS_NAME[node2.type];
    if (node2.type === "decl") key = node2.prop.toLowerCase();
    else if (node2.type === "atrule") key = node2.name.toLowerCase();
    if (key && node2.append) return [
        type,
        type + "-" + key,
        $413a30192b54574f$var$CHILDREN,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node2.append) return [
        type,
        $413a30192b54574f$var$CHILDREN,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $413a30192b54574f$var$toStack(node2) {
    var events;
    if (node2.type === "document") events = [
        "Document",
        $413a30192b54574f$var$CHILDREN,
        "DocumentExit"
    ];
    else if (node2.type === "root") events = [
        "Root",
        $413a30192b54574f$var$CHILDREN,
        "RootExit"
    ];
    else events = $413a30192b54574f$var$getEvents(node2);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function $413a30192b54574f$var$cleanMarks(node2) {
    node2[$413a30192b54574f$var$isClean] = false;
    if (node2.nodes) node2.nodes.forEach(function(i2) {
        return $413a30192b54574f$var$cleanMarks(i2);
    });
    return node2;
}
var $413a30192b54574f$var$postcss$2 = {};
var $413a30192b54574f$var$LazyResult$2 = /*#__PURE__*/ function() {
    function LazyResult2(processor2, css, opts) {
        var _this = this;
        this.stringified = false;
        this.processed = false;
        var root2;
        if ((typeof css === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(css)) === "object" && css !== null && (css.type === "root" || css.type === "document")) root2 = $413a30192b54574f$var$cleanMarks(css);
        else if ($413a30192b54574f$var$_instanceof(css, LazyResult2) || $413a30192b54574f$var$_instanceof(css, $413a30192b54574f$var$Result$2)) {
            root2 = $413a30192b54574f$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            var parser2 = $413a30192b54574f$var$parse$2;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[$413a30192b54574f$var$my]) $413a30192b54574f$var$Container$1.rebuild(root2);
        }
        this.result = new $413a30192b54574f$var$Result$2(processor2, root2, opts);
        this.helpers = $413a30192b54574f$var$_extends({}, $413a30192b54574f$var$postcss$2, {
            postcss: $413a30192b54574f$var$postcss$2,
            result: this.result
        });
        this.plugins = this.processor.plugins.map(function(plugin22) {
            if ((typeof plugin22 === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(plugin22)) === "object" && plugin22.prepare) return $413a30192b54574f$var$_extends({}, plugin22, plugin22.prepare(_this.result));
            else return plugin22;
        });
    }
    var _proto = LazyResult2.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.getAsyncError = function getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    };
    _proto.handleError = function handleError(error, node2) {
        var plugin22 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin22.postcssPlugin;
                error.setMessage();
            } else if (plugin22.postcssVersion) var pluginName, pluginVer, runtimeVer, a2, b;
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    };
    _proto.prepareVisitors = function prepareVisitors() {
        var _this = this;
        this.listeners = {};
        var add = function(plugin22, type, cb) {
            if (!_this.listeners[type]) _this.listeners[type] = [];
            _this.listeners[type].push([
                plugin22,
                cb
            ]);
        };
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            if ((typeof plugin22 === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(plugin22)) === "object") for(var event in plugin22){
                if (!$413a30192b54574f$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error("Unknown event " + event + " in " + plugin22.postcssPlugin + ". Try to update PostCSS (" + this.processor.version + " now).");
                if (!$413a30192b54574f$var$NOT_VISITORS[event]) {
                    if ($413a30192b54574f$var$_type_of(plugin22[event]) === "object") {
                        for(var filter in plugin22[event])if (filter === "*") add(plugin22, event, plugin22[event][filter]);
                        else add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                    } else if (typeof plugin22[event] === "function") add(plugin22, event, plugin22[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    };
    _proto.runAsync = function runAsync() {
        var _this = this;
        return $413a30192b54574f$var$_async_to_generator(function() {
            var i2, plugin22, promise, error, root2, stack, promise1, e2, node2, _loop, _iterator, _step;
            return $413a30192b54574f$var$_ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.plugin = 0;
                        i2 = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i2 < _this.plugins.length)) return [
                            3,
                            6
                        ];
                        plugin22 = _this.plugins[i2];
                        promise = _this.runOnRoot(plugin22);
                        if (!$413a30192b54574f$var$isPromise(promise)) return [
                            3,
                            5
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        throw _this.handleError(error);
                    case 5:
                        i2++;
                        return [
                            3,
                            1
                        ];
                    case 6:
                        _this.prepareVisitors();
                        if (!_this.hasListener) return [
                            3,
                            18
                        ];
                        root2 = _this.result.root;
                        _state.label = 7;
                    case 7:
                        if (!!root2[$413a30192b54574f$var$isClean]) return [
                            3,
                            14
                        ];
                        root2[$413a30192b54574f$var$isClean] = true;
                        stack = [
                            $413a30192b54574f$var$toStack(root2)
                        ];
                        _state.label = 8;
                    case 8:
                        if (!(stack.length > 0)) return [
                            3,
                            13
                        ];
                        promise1 = _this.visitTick(stack);
                        if (!$413a30192b54574f$var$isPromise(promise1)) return [
                            3,
                            12
                        ];
                        _state.label = 9;
                    case 9:
                        _state.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        return [
                            4,
                            promise1
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 11:
                        e2 = _state.sent();
                        node2 = stack[stack.length - 1].node;
                        throw _this.handleError(e2, node2);
                    case 12:
                        return [
                            3,
                            8
                        ];
                    case 13:
                        return [
                            3,
                            7
                        ];
                    case 14:
                        if (!_this.listeners.OnceExit) return [
                            3,
                            18
                        ];
                        _loop = function() {
                            var _step_value, plugin22, visitor, roots, e2;
                            return $413a30192b54574f$var$_ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
                                        _this.result.lastPlugin = plugin22;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            ,
                                            7
                                        ]);
                                        if (!(root2.type === "document")) return [
                                            3,
                                            3
                                        ];
                                        roots = root2.nodes.map(function(subRoot) {
                                            return visitor(subRoot, _this.helpers);
                                        });
                                        return [
                                            4,
                                            Promise.all(roots)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            visitor(root2, _this.helpers)
                                        ];
                                    case 4:
                                        _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        return [
                                            3,
                                            7
                                        ];
                                    case 6:
                                        e2 = _state.sent();
                                        throw _this.handleError(e2);
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(_this.listeners.OnceExit);
                        _state.label = 15;
                    case 15:
                        if (!!(_step = _iterator()).done) return [
                            3,
                            18
                        ];
                        return [
                            5,
                            $413a30192b54574f$var$_ts_values(_loop())
                        ];
                    case 16:
                        _state.sent();
                        _state.label = 17;
                    case 17:
                        return [
                            3,
                            15
                        ];
                    case 18:
                        _this.processed = true;
                        return [
                            2,
                            _this.stringify()
                        ];
                }
            });
        })();
    };
    _proto.runOnRoot = function runOnRoot(plugin22) {
        var _this = this;
        this.result.lastPlugin = plugin22;
        try {
            if ((typeof plugin22 === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(plugin22)) === "object" && plugin22.Once) {
                if (this.result.root.type === "document") {
                    var roots = this.result.root.nodes.map(function(root2) {
                        return plugin22.Once(root2, _this.helpers);
                    });
                    if ($413a30192b54574f$var$isPromise(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin22.Once(this.result.root, this.helpers);
            } else if (typeof plugin22 === "function") return plugin22(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    };
    _proto.stringify = function stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        var opts = this.result.opts;
        var str = $413a30192b54574f$var$stringify$2;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        var map = new $413a30192b54574f$var$MapGenerator$1(str, this.result.root, this.result.opts);
        var data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            var promise = this.runOnRoot(plugin22);
            if ($413a30192b54574f$var$isPromise(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            var root2 = this.result.root;
            while(!root2[$413a30192b54574f$var$isClean]){
                root2[$413a30192b54574f$var$isClean] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") for(var _iterator1 = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(root2.nodes), _step1; !(_step1 = _iterator1()).done;){
                    var subRoot = _step1.value;
                    this.visitSync(this.listeners.OnceExit, subRoot);
                }
                else this.visitSync(this.listeners.OnceExit, root2);
            }
        }
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.visitSync = function visitSync(visitors, node2) {
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(visitors), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
            this.result.lastPlugin = plugin22;
            var promise = void 0;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) return true;
            if ($413a30192b54574f$var$isPromise(promise)) throw this.getAsyncError();
        }
    };
    _proto.visitTick = function visitTick(stack) {
        var visit2 = stack[stack.length - 1];
        var node2 = visit2.node, visitors = visit2.visitors;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            var _visitors_visit2_visitorIndex = visitors[visit2.visitorIndex], plugin22 = _visitors_visit2_visitorIndex[0], visitor = _visitors_visit2_visitorIndex[1];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin22;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2);
            }
        }
        if (visit2.iterator !== 0) {
            var iterator = visit2.iterator;
            var child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[$413a30192b54574f$var$isClean]) {
                    child[$413a30192b54574f$var$isClean] = true;
                    stack.push($413a30192b54574f$var$toStack(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        var events = visit2.events;
        while(visit2.eventIndex < events.length){
            var event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === $413a30192b54574f$var$CHILDREN) {
                if (node2.nodes && node2.nodes.length) {
                    node2[$413a30192b54574f$var$isClean] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    };
    _proto.walkSync = function walkSync(node2) {
        var _this = this;
        node2[$413a30192b54574f$var$isClean] = true;
        var events = $413a30192b54574f$var$getEvents(node2);
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(events), _step; !(_step = _iterator()).done;){
            var event = _step.value;
            if (event === $413a30192b54574f$var$CHILDREN) {
                if (node2.nodes) node2.each(function(child) {
                    if (!child[$413a30192b54574f$var$isClean]) _this.walkSync(child);
                });
            } else {
                var visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    };
    _proto.warnings = function warnings() {
        return this.sync().warnings();
    };
    $413a30192b54574f$var$_create_class(LazyResult2, [
        {
            key: "content",
            get: function get() {
                return this.stringify().content;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.stringify().css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.stringify().map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return this.sync().messages;
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                return this.sync().root;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "LazyResult";
            }
        }
    ]);
    return LazyResult2;
}();
$413a30192b54574f$var$LazyResult$2.registerPostcss = function(dependant) {
    $413a30192b54574f$var$postcss$2 = dependant;
};
var $413a30192b54574f$var$lazyResult = $413a30192b54574f$var$LazyResult$2;
$413a30192b54574f$var$LazyResult$2.default = $413a30192b54574f$var$LazyResult$2;
$413a30192b54574f$var$Root$3.registerLazyResult($413a30192b54574f$var$LazyResult$2);
$413a30192b54574f$var$Document$2.registerLazyResult($413a30192b54574f$var$LazyResult$2);
var $413a30192b54574f$var$MapGenerator22 = $413a30192b54574f$var$mapGenerator;
var $413a30192b54574f$var$stringify$1 = $413a30192b54574f$var$stringify_1;
var $413a30192b54574f$var$warnOnce22 = $413a30192b54574f$var$warnOnce$2;
var $413a30192b54574f$var$parse$1 = $413a30192b54574f$var$parse_1;
var $413a30192b54574f$var$Result$1 = $413a30192b54574f$var$result;
var $413a30192b54574f$var$NoWorkResult$1 = /*#__PURE__*/ function() {
    function NoWorkResult2(processor2, css, opts) {
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        var root2;
        var str = $413a30192b54574f$var$stringify$1;
        this.result = new $413a30192b54574f$var$Result$1(this._processor, root2, this._opts);
        this.result.css = css;
        var self = this;
        Object.defineProperty(this.result, "root", {
            get: function get() {
                return self.root;
            }
        });
        var map = new $413a30192b54574f$var$MapGenerator22(str, root2, this._opts, css);
        if (map.isMap()) {
            var _map_generate = map.generate(), generatedCSS = _map_generate[0], generatedMap = _map_generate[1];
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    var _proto = NoWorkResult2.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this._css;
    };
    _proto.warnings = function warnings() {
        return [];
    };
    $413a30192b54574f$var$_create_class(NoWorkResult2, [
        {
            key: "content",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.result.map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return [];
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                if (this._root) return this._root;
                var root2;
                var parser2 = $413a30192b54574f$var$parse$1;
                try {
                    root2 = parser2(this._css, this._opts);
                } catch (error) {
                    this.error = error;
                }
                if (this.error) throw this.error;
                else {
                    this._root = root2;
                    return root2;
                }
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "NoWorkResult";
            }
        }
    ]);
    return NoWorkResult2;
}();
var $413a30192b54574f$var$noWorkResult = $413a30192b54574f$var$NoWorkResult$1;
$413a30192b54574f$var$NoWorkResult$1.default = $413a30192b54574f$var$NoWorkResult$1;
var $413a30192b54574f$var$NoWorkResult22 = $413a30192b54574f$var$noWorkResult;
var $413a30192b54574f$var$LazyResult$1 = $413a30192b54574f$var$lazyResult;
var $413a30192b54574f$var$Document$1 = $413a30192b54574f$var$document$1$2;
var $413a30192b54574f$var$Root$2 = $413a30192b54574f$var$root;
var $413a30192b54574f$var$Processor$1 = /*#__PURE__*/ function() {
    function Processor2(plugins) {
        if (plugins === void 0) plugins = [];
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
    var _proto = Processor2.prototype;
    _proto.normalize = function normalize(plugins) {
        var normalized = [];
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(plugins), _step; !(_step = _iterator()).done;){
            var i2 = _step.value;
            if (i2.postcss === true) i2 = i2();
            else if (i2.postcss) i2 = i2.postcss;
            if ((typeof i2 === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(i2)) === "object" && Array.isArray(i2.plugins)) normalized = normalized.concat(i2.plugins);
            else if ((typeof i2 === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(i2)) === "object" && i2.postcssPlugin) normalized.push(i2);
            else if (typeof i2 === "function") normalized.push(i2);
            else if ((typeof i2 === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(i2)) === "object" && (i2.parse || i2.stringify)) ;
            else throw new Error(i2 + " is not a PostCSS plugin");
        }
        return normalized;
    };
    _proto.process = function process1(css, opts) {
        if (opts === void 0) opts = {};
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $413a30192b54574f$var$NoWorkResult22(this, css, opts);
        else return new $413a30192b54574f$var$LazyResult$1(this, css, opts);
    };
    _proto.use = function use(plugin22) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin22
        ]));
        return this;
    };
    return Processor2;
}();
var $413a30192b54574f$var$processor = $413a30192b54574f$var$Processor$1;
$413a30192b54574f$var$Processor$1.default = $413a30192b54574f$var$Processor$1;
$413a30192b54574f$var$Root$2.registerProcessor($413a30192b54574f$var$Processor$1);
$413a30192b54574f$var$Document$1.registerProcessor($413a30192b54574f$var$Processor$1);
var $413a30192b54574f$var$Declaration$1 = $413a30192b54574f$var$declaration;
var $413a30192b54574f$var$PreviousMap22 = $413a30192b54574f$var$previousMap;
var $413a30192b54574f$var$Comment$1 = $413a30192b54574f$var$comment;
var $413a30192b54574f$var$AtRule$1 = $413a30192b54574f$var$atRule;
var $413a30192b54574f$var$Input$1 = $413a30192b54574f$var$input;
var $413a30192b54574f$var$Root$1 = $413a30192b54574f$var$root;
var $413a30192b54574f$var$Rule$1 = $413a30192b54574f$var$rule;
function $413a30192b54574f$var$fromJSON$1(json, inputs) {
    if (Array.isArray(json)) return json.map(function(n2) {
        return $413a30192b54574f$var$fromJSON$1(n2);
    });
    var ownInputs = json.inputs, defaults = $413a30192b54574f$var$_object_without_properties_loose(json, [
        "inputs"
    ]);
    if (ownInputs) {
        inputs = [];
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(ownInputs), _step; !(_step = _iterator()).done;){
            var input2 = _step.value;
            var inputHydrated = $413a30192b54574f$var$_extends({}, input2, {
                __proto__: $413a30192b54574f$var$Input$1.prototype
            });
            if (inputHydrated.map) inputHydrated.map = $413a30192b54574f$var$_extends({}, inputHydrated.map, {
                __proto__: $413a30192b54574f$var$PreviousMap22.prototype
            });
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map(function(n2) {
        return $413a30192b54574f$var$fromJSON$1(n2, inputs);
    });
    if (defaults.source) {
        var _defaults_source = defaults.source, inputId = _defaults_source.inputId, source = $413a30192b54574f$var$_object_without_properties_loose(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $413a30192b54574f$var$Root$1(defaults);
    else if (defaults.type === "decl") return new $413a30192b54574f$var$Declaration$1(defaults);
    else if (defaults.type === "rule") return new $413a30192b54574f$var$Rule$1(defaults);
    else if (defaults.type === "comment") return new $413a30192b54574f$var$Comment$1(defaults);
    else if (defaults.type === "atrule") return new $413a30192b54574f$var$AtRule$1(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
var $413a30192b54574f$var$fromJSON_1 = $413a30192b54574f$var$fromJSON$1;
$413a30192b54574f$var$fromJSON$1.default = $413a30192b54574f$var$fromJSON$1;
var $413a30192b54574f$var$CssSyntaxError22 = $413a30192b54574f$var$cssSyntaxError;
var $413a30192b54574f$var$Declaration22 = $413a30192b54574f$var$declaration;
var $413a30192b54574f$var$LazyResult22 = $413a30192b54574f$var$lazyResult;
var $413a30192b54574f$var$Container22 = $413a30192b54574f$var$container;
var $413a30192b54574f$var$Processor22 = $413a30192b54574f$var$processor;
var $413a30192b54574f$var$stringify = $413a30192b54574f$var$stringify_1;
var $413a30192b54574f$var$fromJSON = $413a30192b54574f$var$fromJSON_1;
var $413a30192b54574f$var$Document222 = $413a30192b54574f$var$document$1$2;
var $413a30192b54574f$var$Warning22 = $413a30192b54574f$var$warning;
var $413a30192b54574f$var$Comment22 = $413a30192b54574f$var$comment;
var $413a30192b54574f$var$AtRule22 = $413a30192b54574f$var$atRule;
var $413a30192b54574f$var$Result22 = $413a30192b54574f$var$result;
var $413a30192b54574f$var$Input22 = $413a30192b54574f$var$input;
var $413a30192b54574f$var$parse = $413a30192b54574f$var$parse_1;
var $413a30192b54574f$var$list = $413a30192b54574f$var$list_1;
var $413a30192b54574f$var$Rule22 = $413a30192b54574f$var$rule;
var $413a30192b54574f$var$Root22 = $413a30192b54574f$var$root;
var $413a30192b54574f$var$Node22 = $413a30192b54574f$var$node;
function $413a30192b54574f$var$postcss() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $413a30192b54574f$var$Processor22(plugins);
}
$413a30192b54574f$var$postcss.plugin = function plugin2(name, initializer) {
    var warningPrinted = false;
    function creator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        var transformer = initializer.apply(void 0, [].concat(args));
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $413a30192b54574f$var$Processor22().version;
        return transformer;
    }
    var cache;
    Object.defineProperty(creator, "postcss", {
        get: function get() {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $413a30192b54574f$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$413a30192b54574f$var$postcss.stringify = $413a30192b54574f$var$stringify;
$413a30192b54574f$var$postcss.parse = $413a30192b54574f$var$parse;
$413a30192b54574f$var$postcss.fromJSON = $413a30192b54574f$var$fromJSON;
$413a30192b54574f$var$postcss.list = $413a30192b54574f$var$list;
$413a30192b54574f$var$postcss.comment = function(defaults) {
    return new $413a30192b54574f$var$Comment22(defaults);
};
$413a30192b54574f$var$postcss.atRule = function(defaults) {
    return new $413a30192b54574f$var$AtRule22(defaults);
};
$413a30192b54574f$var$postcss.decl = function(defaults) {
    return new $413a30192b54574f$var$Declaration22(defaults);
};
$413a30192b54574f$var$postcss.rule = function(defaults) {
    return new $413a30192b54574f$var$Rule22(defaults);
};
$413a30192b54574f$var$postcss.root = function(defaults) {
    return new $413a30192b54574f$var$Root22(defaults);
};
$413a30192b54574f$var$postcss.document = function(defaults) {
    return new $413a30192b54574f$var$Document222(defaults);
};
$413a30192b54574f$var$postcss.CssSyntaxError = $413a30192b54574f$var$CssSyntaxError22;
$413a30192b54574f$var$postcss.Declaration = $413a30192b54574f$var$Declaration22;
$413a30192b54574f$var$postcss.Container = $413a30192b54574f$var$Container22;
$413a30192b54574f$var$postcss.Processor = $413a30192b54574f$var$Processor22;
$413a30192b54574f$var$postcss.Document = $413a30192b54574f$var$Document222;
$413a30192b54574f$var$postcss.Comment = $413a30192b54574f$var$Comment22;
$413a30192b54574f$var$postcss.Warning = $413a30192b54574f$var$Warning22;
$413a30192b54574f$var$postcss.AtRule = $413a30192b54574f$var$AtRule22;
$413a30192b54574f$var$postcss.Result = $413a30192b54574f$var$Result22;
$413a30192b54574f$var$postcss.Input = $413a30192b54574f$var$Input22;
$413a30192b54574f$var$postcss.Rule = $413a30192b54574f$var$Rule22;
$413a30192b54574f$var$postcss.Root = $413a30192b54574f$var$Root22;
$413a30192b54574f$var$postcss.Node = $413a30192b54574f$var$Node22;
$413a30192b54574f$var$LazyResult22.registerPostcss($413a30192b54574f$var$postcss);
var $413a30192b54574f$var$postcss_1 = $413a30192b54574f$var$postcss;
$413a30192b54574f$var$postcss.default = $413a30192b54574f$var$postcss;
var $413a30192b54574f$var$postcss$1 = /* @__PURE__ */ $413a30192b54574f$var$getDefaultExportFromCjs($413a30192b54574f$var$postcss_1);
$413a30192b54574f$var$postcss$1.stringify;
$413a30192b54574f$var$postcss$1.fromJSON;
$413a30192b54574f$var$postcss$1.plugin;
$413a30192b54574f$var$postcss$1.parse;
$413a30192b54574f$var$postcss$1.list;
$413a30192b54574f$var$postcss$1.document;
$413a30192b54574f$var$postcss$1.comment;
$413a30192b54574f$var$postcss$1.atRule;
$413a30192b54574f$var$postcss$1.rule;
$413a30192b54574f$var$postcss$1.decl;
$413a30192b54574f$var$postcss$1.root;
$413a30192b54574f$var$postcss$1.CssSyntaxError;
$413a30192b54574f$var$postcss$1.Declaration;
$413a30192b54574f$var$postcss$1.Container;
$413a30192b54574f$var$postcss$1.Processor;
$413a30192b54574f$var$postcss$1.Document;
$413a30192b54574f$var$postcss$1.Comment;
$413a30192b54574f$var$postcss$1.Warning;
$413a30192b54574f$var$postcss$1.AtRule;
$413a30192b54574f$var$postcss$1.Result;
$413a30192b54574f$var$postcss$1.Input;
$413a30192b54574f$var$postcss$1.Rule;
$413a30192b54574f$var$postcss$1.Root;
$413a30192b54574f$var$postcss$1.Node;
var $413a30192b54574f$var$BaseRRNode = /*#__PURE__*/ function() {
    function BaseRRNode() {
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        $413a30192b54574f$var$__publicField2(this, "parentElement", null);
        $413a30192b54574f$var$__publicField2(this, "parentNode", null);
        $413a30192b54574f$var$__publicField2(this, "ownerDocument");
        $413a30192b54574f$var$__publicField2(this, "firstChild", null);
        $413a30192b54574f$var$__publicField2(this, "lastChild", null);
        $413a30192b54574f$var$__publicField2(this, "previousSibling", null);
        $413a30192b54574f$var$__publicField2(this, "nextSibling", null);
        $413a30192b54574f$var$__publicField2(this, "ELEMENT_NODE", 1);
        $413a30192b54574f$var$__publicField2(this, "TEXT_NODE", 3);
        $413a30192b54574f$var$__publicField2(this, "nodeType");
        $413a30192b54574f$var$__publicField2(this, "nodeName");
        $413a30192b54574f$var$__publicField2(this, "RRNodeType");
    }
    var _proto = BaseRRNode.prototype;
    _proto.contains = function contains(node2) {
        if (!$413a30192b54574f$var$_instanceof(node2, BaseRRNode)) return false;
        else if (node2.ownerDocument !== this.ownerDocument) return false;
        else if (node2 === this) return true;
        while(node2.parentNode){
            if (node2.parentNode === this) return true;
            node2 = node2.parentNode;
        }
        return false;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.appendChild = function appendChild(_newChild) {
        throw new Error("RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method.");
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.insertBefore = function insertBefore(_newChild, _refChild) {
        throw new Error("RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method.");
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.removeChild = function removeChild(_node) {
        throw new Error("RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method.");
    };
    _proto.toString = function toString() {
        return "RRNode";
    };
    $413a30192b54574f$var$_create_class(BaseRRNode, [
        {
            key: "childNodes",
            get: function get() {
                var childNodes2 = [];
                var childIterator = this.firstChild;
                while(childIterator){
                    childNodes2.push(childIterator);
                    childIterator = childIterator.nextSibling;
                }
                return childNodes2;
            }
        }
    ]);
    return BaseRRNode;
}();
var $413a30192b54574f$var$testableAccessors = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
var $413a30192b54574f$var$testableMethods = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
var $413a30192b54574f$var$untaintedBasePrototype = {};
var $413a30192b54574f$var$isAngularZonePresent = function() {
    return !!globalThis.Zone;
};
function $413a30192b54574f$var$getUntaintedPrototype(key) {
    if ($413a30192b54574f$var$untaintedBasePrototype[key]) return $413a30192b54574f$var$untaintedBasePrototype[key];
    var defaultObj = globalThis[key];
    var defaultPrototype = defaultObj.prototype;
    var accessorNames = key in $413a30192b54574f$var$testableAccessors ? $413a30192b54574f$var$testableAccessors[key] : void 0;
    var isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every(function(accessor) {
        var _a2, _b;
        return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    var methodNames = key in $413a30192b54574f$var$testableMethods ? $413a30192b54574f$var$testableMethods[key] : void 0;
    var isUntaintedMethods = Boolean(methodNames && methodNames.every(function(method) {
        var _a2;
        return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods && !$413a30192b54574f$var$isAngularZonePresent()) {
        $413a30192b54574f$var$untaintedBasePrototype[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        var iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        var win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        var untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return $413a30192b54574f$var$untaintedBasePrototype[key] = untaintedObject;
    } catch (e) {
        return defaultPrototype;
    }
}
var $413a30192b54574f$var$untaintedAccessorCache = {};
function $413a30192b54574f$var$getUntaintedAccessor(key, instance, accessor) {
    var _a2;
    var cacheKey = key + "." + String(accessor);
    if ($413a30192b54574f$var$untaintedAccessorCache[cacheKey]) return $413a30192b54574f$var$untaintedAccessorCache[cacheKey].call(instance);
    var untaintedPrototype = $413a30192b54574f$var$getUntaintedPrototype(key);
    var untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
    if (!untaintedAccessor) return instance[accessor];
    $413a30192b54574f$var$untaintedAccessorCache[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
var $413a30192b54574f$var$untaintedMethodCache = {};
function $413a30192b54574f$var$getUntaintedMethod(key, instance, method) {
    var cacheKey = key + "." + String(method);
    if ($413a30192b54574f$var$untaintedMethodCache[cacheKey]) return $413a30192b54574f$var$untaintedMethodCache[cacheKey].bind(instance);
    var untaintedPrototype = $413a30192b54574f$var$getUntaintedPrototype(key);
    var untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    $413a30192b54574f$var$untaintedMethodCache[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function $413a30192b54574f$var$childNodes(n2) {
    return $413a30192b54574f$var$getUntaintedAccessor("Node", n2, "childNodes");
}
function $413a30192b54574f$var$parentNode(n2) {
    return $413a30192b54574f$var$getUntaintedAccessor("Node", n2, "parentNode");
}
function $413a30192b54574f$var$parentElement(n2) {
    return $413a30192b54574f$var$getUntaintedAccessor("Node", n2, "parentElement");
}
function $413a30192b54574f$var$textContent(n2) {
    return $413a30192b54574f$var$getUntaintedAccessor("Node", n2, "textContent");
}
function $413a30192b54574f$var$contains(n2, other) {
    return $413a30192b54574f$var$getUntaintedMethod("Node", n2, "contains")(other);
}
function $413a30192b54574f$var$getRootNode(n2) {
    return $413a30192b54574f$var$getUntaintedMethod("Node", n2, "getRootNode")();
}
function $413a30192b54574f$var$host(n2) {
    if (!n2 || !("host" in n2)) return null;
    return $413a30192b54574f$var$getUntaintedAccessor("ShadowRoot", n2, "host");
}
function $413a30192b54574f$var$styleSheets(n2) {
    return n2.styleSheets;
}
function $413a30192b54574f$var$shadowRoot(n2) {
    if (!n2 || !("shadowRoot" in n2)) return null;
    return $413a30192b54574f$var$getUntaintedAccessor("Element", n2, "shadowRoot");
}
function $413a30192b54574f$var$querySelector(n2, selectors) {
    return $413a30192b54574f$var$getUntaintedAccessor("Element", n2, "querySelector")(selectors);
}
function $413a30192b54574f$var$querySelectorAll(n2, selectors) {
    return $413a30192b54574f$var$getUntaintedAccessor("Element", n2, "querySelectorAll")(selectors);
}
function $413a30192b54574f$var$mutationObserverCtor() {
    return $413a30192b54574f$var$getUntaintedPrototype("MutationObserver").constructor;
}
function $413a30192b54574f$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (e) {
        return function() {};
    }
}
var $413a30192b54574f$var$index = {
    childNodes: $413a30192b54574f$var$childNodes,
    parentNode: $413a30192b54574f$var$parentNode,
    parentElement: $413a30192b54574f$var$parentElement,
    textContent: $413a30192b54574f$var$textContent,
    contains: $413a30192b54574f$var$contains,
    getRootNode: $413a30192b54574f$var$getRootNode,
    host: $413a30192b54574f$var$host,
    styleSheets: $413a30192b54574f$var$styleSheets,
    shadowRoot: $413a30192b54574f$var$shadowRoot,
    querySelector: $413a30192b54574f$var$querySelector,
    querySelectorAll: $413a30192b54574f$var$querySelectorAll,
    mutationObserver: $413a30192b54574f$var$mutationObserverCtor,
    patch: $413a30192b54574f$var$patch
};
function $413a30192b54574f$var$on(type, fn, target) {
    if (target === void 0) target = document;
    var options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return function() {
        return target.removeEventListener(type, fn, options);
    };
}
var $413a30192b54574f$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
var $413a30192b54574f$var$_mirror = {
    map: {},
    getId: function getId() {
        console.error($413a30192b54574f$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode: function getNode() {
        console.error($413a30192b54574f$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap: function removeNodeFromMap() {
        console.error($413a30192b54574f$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has: function has() {
        console.error($413a30192b54574f$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset: function reset() {
        console.error($413a30192b54574f$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $413a30192b54574f$var$_mirror = new Proxy($413a30192b54574f$var$_mirror, {
    get: function get(target, prop, receiver) {
        if (prop === "map") console.error($413a30192b54574f$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $413a30192b54574f$var$throttle(func, wait, options) {
    if (options === void 0) options = {};
    var timeout = null;
    var previous = 0;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        var context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(function() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $413a30192b54574f$var$hookSetter(target, key, d, isRevoked, win) {
    if (win === void 0) win = window;
    var original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set: function set(value) {
            var _this = this;
            setTimeout(function() {
                d.set.call(_this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return function() {
        return $413a30192b54574f$var$hookSetter(target, key, original || {}, true);
    };
}
var $413a30192b54574f$var$nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) $413a30192b54574f$var$nowTimestamp = function() {
    return /* @__PURE__ */ new Date().getTime();
};
function $413a30192b54574f$var$getWindowScroll(win) {
    var _a2, _b, _c, _d;
    var doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc.documentElement.scrollLeft || (doc == null ? void 0 : doc.body) && ((_a2 = $413a30192b54574f$var$index.parentElement(doc.body)) == null ? void 0 : _a2.scrollLeft) || ((_b = doc == null ? void 0 : doc.body) == null ? void 0 : _b.scrollLeft) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : (doc == null ? void 0 : doc.documentElement.scrollTop) || (doc == null ? void 0 : doc.body) && ((_c = $413a30192b54574f$var$index.parentElement(doc.body)) == null ? void 0 : _c.scrollTop) || ((_d = doc == null ? void 0 : doc.body) == null ? void 0 : _d.scrollTop) || 0
    };
}
function $413a30192b54574f$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $413a30192b54574f$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $413a30192b54574f$var$closestElementOfNode(node2) {
    if (!node2) return null;
    var el = node2.nodeType === node2.ELEMENT_NODE ? node2 : $413a30192b54574f$var$index.parentElement(node2);
    return el;
}
function $413a30192b54574f$var$isBlocked(node2, blockClass, blockSelector, checkAncestors) {
    if (!node2) return false;
    var el = $413a30192b54574f$var$closestElementOfNode(node2);
    if (!el) return false;
    try {
        if (typeof blockClass === "string") {
            if (el.classList.contains(blockClass)) return true;
            if (checkAncestors && el.closest("." + blockClass) !== null) return true;
        } else {
            if ($413a30192b54574f$var$classMatchesRegex(el, blockClass, checkAncestors)) return true;
        }
    } catch (e2) {}
    if (blockSelector) {
        if (el.matches(blockSelector)) return true;
        if (checkAncestors && el.closest(blockSelector) !== null) return true;
    }
    return false;
}
function $413a30192b54574f$var$isSerialized(n2, mirror2) {
    return mirror2.getId(n2) !== -1;
}
function $413a30192b54574f$var$isIgnored(n2, mirror2, slimDOMOptions) {
    if (n2.tagName === "TITLE" && slimDOMOptions.headTitleMutations) return true;
    return mirror2.getId(n2) === $413a30192b54574f$var$IGNORED_NODE;
}
function $413a30192b54574f$var$isAncestorRemoved(target, mirror2) {
    if ($413a30192b54574f$var$isShadowRoot(target)) return false;
    var id = mirror2.getId(target);
    if (!mirror2.has(id)) return true;
    var parent = $413a30192b54574f$var$index.parentNode(target);
    if (parent && parent.nodeType === target.DOCUMENT_NODE) return false;
    if (!parent) return true;
    return $413a30192b54574f$var$isAncestorRemoved(parent, mirror2);
}
function $413a30192b54574f$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $413a30192b54574f$var$polyfill$1(win) {
    if (win === void 0) win = window;
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
}
function $413a30192b54574f$var$isSerializedIframe(n2, mirror2) {
    return Boolean(n2.nodeName === "IFRAME" && mirror2.getMeta(n2));
}
function $413a30192b54574f$var$isSerializedStylesheet(n2, mirror2) {
    return Boolean(n2.nodeName === "LINK" && n2.nodeType === n2.ELEMENT_NODE && n2.getAttribute && n2.getAttribute("rel") === "stylesheet" && mirror2.getMeta(n2));
}
function $413a30192b54574f$var$hasShadowRoot(n2) {
    if (!n2) return false;
    if ($413a30192b54574f$var$_instanceof(n2, $413a30192b54574f$var$BaseRRNode) && "shadowRoot" in n2) return Boolean(n2.shadowRoot);
    return Boolean($413a30192b54574f$var$index.shadowRoot(n2));
}
var $413a30192b54574f$var$StyleSheetMirror = /*#__PURE__*/ function() {
    function StyleSheetMirror() {
        $413a30192b54574f$var$__publicField(this, "id", 1);
        $413a30192b54574f$var$__publicField(this, "styleIDMap", /* @__PURE__ */ new WeakMap());
        $413a30192b54574f$var$__publicField(this, "idStyleMap", /* @__PURE__ */ new Map());
    }
    var _proto = StyleSheetMirror.prototype;
    _proto.getId = function getId(stylesheet) {
        var _this_styleIDMap_get;
        return (_this_styleIDMap_get = this.styleIDMap.get(stylesheet)) != null ? _this_styleIDMap_get : -1;
    };
    _proto.has = function has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    };
    /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ _proto.add = function add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        var newId;
        if (id === void 0) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    };
    _proto.getStyle = function getStyle(id) {
        return this.idStyleMap.get(id) || null;
    };
    _proto.reset = function reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
        this.id = 1;
    };
    _proto.generateId = function generateId() {
        return this.id++;
    };
    return StyleSheetMirror;
}();
function $413a30192b54574f$var$getShadowHost(n2) {
    var _a2;
    var shadowHost = null;
    if ("getRootNode" in n2 && ((_a2 = $413a30192b54574f$var$index.getRootNode(n2)) == null ? void 0 : _a2.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && $413a30192b54574f$var$index.host($413a30192b54574f$var$index.getRootNode(n2))) shadowHost = $413a30192b54574f$var$index.host($413a30192b54574f$var$index.getRootNode(n2));
    return shadowHost;
}
function $413a30192b54574f$var$getRootShadowHost(n2) {
    var rootShadowHost = n2;
    var shadowHost;
    while(shadowHost = $413a30192b54574f$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $413a30192b54574f$var$shadowHostInDom(n2) {
    var doc = n2.ownerDocument;
    if (!doc) return false;
    var shadowHost = $413a30192b54574f$var$getRootShadowHost(n2);
    return $413a30192b54574f$var$index.contains(doc, shadowHost);
}
function $413a30192b54574f$var$inDom(n2) {
    var doc = n2.ownerDocument;
    if (!doc) return false;
    return $413a30192b54574f$var$index.contains(doc, n2) || $413a30192b54574f$var$shadowHostInDom(n2);
}
var $413a30192b54574f$var$EventType = /* @__PURE__ */ function(EventType2) {
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
}($413a30192b54574f$var$EventType || {});
var $413a30192b54574f$var$IncrementalSource = /* @__PURE__ */ function(IncrementalSource2) {
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
}($413a30192b54574f$var$IncrementalSource || {});
var $413a30192b54574f$var$MouseInteractions = /* @__PURE__ */ function(MouseInteractions2) {
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
}($413a30192b54574f$var$MouseInteractions || {});
var $413a30192b54574f$var$PointerTypes = /* @__PURE__ */ function(PointerTypes2) {
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
}($413a30192b54574f$var$PointerTypes || {});
var $413a30192b54574f$var$CanvasContext = /* @__PURE__ */ function(CanvasContext2) {
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
}($413a30192b54574f$var$CanvasContext || {});
var $413a30192b54574f$var$MediaInteractions = /* @__PURE__ */ function(MediaInteractions2) {
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
}($413a30192b54574f$var$MediaInteractions || {});
var $413a30192b54574f$var$NodeType = /* @__PURE__ */ function(NodeType2) {
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
}($413a30192b54574f$var$NodeType || {});
function $413a30192b54574f$var$isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
var $413a30192b54574f$var$DoubleLinkedList = /*#__PURE__*/ function() {
    function DoubleLinkedList() {
        $413a30192b54574f$var$__publicField(this, "length", 0);
        $413a30192b54574f$var$__publicField(this, "head", null);
        $413a30192b54574f$var$__publicField(this, "tail", null);
    }
    var _proto = DoubleLinkedList.prototype;
    _proto.get = function get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        var current = this.head;
        for(var index2 = 0; index2 < position; index2++)current = (current == null ? void 0 : current.next) || null;
        return current;
    };
    _proto.addNode = function addNode(n2) {
        var node2 = {
            value: n2,
            previous: null,
            next: null
        };
        n2.__ln = node2;
        if (n2.previousSibling && $413a30192b54574f$var$isNodeInLinkedList(n2.previousSibling)) {
            var current = n2.previousSibling.__ln.next;
            node2.next = current;
            node2.previous = n2.previousSibling.__ln;
            n2.previousSibling.__ln.next = node2;
            if (current) current.previous = node2;
        } else if (n2.nextSibling && $413a30192b54574f$var$isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
            var current1 = n2.nextSibling.__ln.previous;
            node2.previous = current1;
            node2.next = n2.nextSibling.__ln;
            n2.nextSibling.__ln.previous = node2;
            if (current1) current1.next = node2;
        } else {
            if (this.head) this.head.previous = node2;
            node2.next = this.head;
            this.head = node2;
        }
        if (node2.next === null) this.tail = node2;
        this.length++;
    };
    _proto.removeNode = function removeNode(n2) {
        var current = n2.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n2.__ln) delete n2.__ln;
        this.length--;
    };
    return DoubleLinkedList;
}();
var $413a30192b54574f$var$moveKey = function(id, parentId) {
    return id + "@" + parentId;
};
var $413a30192b54574f$var$MutationBuffer = /*#__PURE__*/ function() {
    function MutationBuffer() {
        var _this = this;
        $413a30192b54574f$var$__publicField(this, "frozen", false);
        $413a30192b54574f$var$__publicField(this, "locked", false);
        $413a30192b54574f$var$__publicField(this, "texts", []);
        $413a30192b54574f$var$__publicField(this, "attributes", []);
        $413a30192b54574f$var$__publicField(this, "attributeMap", /* @__PURE__ */ new WeakMap());
        $413a30192b54574f$var$__publicField(this, "removes", []);
        $413a30192b54574f$var$__publicField(this, "mapRemoves", []);
        $413a30192b54574f$var$__publicField(this, "movedMap", {});
        /**
     * the browser MutationObserver emits multiple mutations after
     * a delay for performance reasons, making tracing added nodes hard
     * in our `processMutations` callback function.
     * For example, if we append an element el_1 into body, and then append
     * another element el_2 into el_1, these two mutations may be passed to the
     * callback function together when the two operations were done.
     * Generally we need to trace child nodes of newly added nodes, but in this
     * case if we count el_2 as el_1's child node in the first mutation record,
     * then we will count el_2 again in the second mutation record which was
     * duplicated.
     * To avoid of duplicate counting added nodes, we use a Set to store
     * added nodes and its child nodes during iterate mutation records. Then
     * collect added nodes from the Set which have no duplicate copy. But
     * this also causes newly added nodes will not be serialized with id ASAP,
     * which means all the id related calculation should be lazy too.
     */ $413a30192b54574f$var$__publicField(this, "addedSet", /* @__PURE__ */ new Set());
        $413a30192b54574f$var$__publicField(this, "movedSet", /* @__PURE__ */ new Set());
        $413a30192b54574f$var$__publicField(this, "droppedSet", /* @__PURE__ */ new Set());
        $413a30192b54574f$var$__publicField(this, "removesSubTreeCache", /* @__PURE__ */ new Set());
        $413a30192b54574f$var$__publicField(this, "mutationCb");
        $413a30192b54574f$var$__publicField(this, "blockClass");
        $413a30192b54574f$var$__publicField(this, "blockSelector");
        $413a30192b54574f$var$__publicField(this, "maskTextClass");
        $413a30192b54574f$var$__publicField(this, "maskTextSelector");
        $413a30192b54574f$var$__publicField(this, "inlineStylesheet");
        $413a30192b54574f$var$__publicField(this, "maskInputOptions");
        $413a30192b54574f$var$__publicField(this, "maskTextFn");
        $413a30192b54574f$var$__publicField(this, "maskInputFn");
        $413a30192b54574f$var$__publicField(this, "keepIframeSrcFn");
        $413a30192b54574f$var$__publicField(this, "recordCanvas");
        $413a30192b54574f$var$__publicField(this, "inlineImages");
        $413a30192b54574f$var$__publicField(this, "slimDOMOptions");
        $413a30192b54574f$var$__publicField(this, "dataURLOptions");
        $413a30192b54574f$var$__publicField(this, "doc");
        $413a30192b54574f$var$__publicField(this, "mirror");
        $413a30192b54574f$var$__publicField(this, "iframeManager");
        $413a30192b54574f$var$__publicField(this, "stylesheetManager");
        $413a30192b54574f$var$__publicField(this, "shadowDomManager");
        $413a30192b54574f$var$__publicField(this, "canvasManager");
        $413a30192b54574f$var$__publicField(this, "processedNodeManager");
        $413a30192b54574f$var$__publicField(this, "unattachedDoc");
        $413a30192b54574f$var$__publicField(this, "processMutations", function(mutations) {
            mutations.forEach(_this.processMutation);
            _this.emit();
        });
        $413a30192b54574f$var$__publicField(this, "emit", function() {
            if (_this.frozen || _this.locked) return;
            var adds = [];
            var addedIds = /* @__PURE__ */ new Set();
            var addList = new $413a30192b54574f$var$DoubleLinkedList();
            var getNextId = function(n2) {
                var ns = n2;
                var nextId = $413a30192b54574f$var$IGNORED_NODE;
                while(nextId === $413a30192b54574f$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && _this.mirror.getId(ns);
                }
                return nextId;
            };
            var pushAdd = function(n2) {
                var parent = $413a30192b54574f$var$index.parentNode(n2);
                if (!parent || !$413a30192b54574f$var$inDom(n2)) return;
                var cssCaptured = false;
                if (n2.nodeType === Node.TEXT_NODE) {
                    var parentTag = parent.tagName;
                    if (parentTag === "TEXTAREA") return;
                    else if (parentTag === "STYLE" && _this.addedSet.has(parent)) cssCaptured = true;
                }
                var parentId = $413a30192b54574f$var$isShadowRoot(parent) ? _this.mirror.getId($413a30192b54574f$var$getShadowHost(n2)) : _this.mirror.getId(parent);
                var nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                var sn = $413a30192b54574f$var$serializeNodeWithId(n2, {
                    doc: _this.doc,
                    mirror: _this.mirror,
                    blockClass: _this.blockClass,
                    blockSelector: _this.blockSelector,
                    maskTextClass: _this.maskTextClass,
                    maskTextSelector: _this.maskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: _this.inlineStylesheet,
                    maskInputOptions: _this.maskInputOptions,
                    maskTextFn: _this.maskTextFn,
                    maskInputFn: _this.maskInputFn,
                    slimDOMOptions: _this.slimDOMOptions,
                    dataURLOptions: _this.dataURLOptions,
                    recordCanvas: _this.recordCanvas,
                    inlineImages: _this.inlineImages,
                    onSerialize: function(currentN) {
                        if ($413a30192b54574f$var$isSerializedIframe(currentN, _this.mirror)) _this.iframeManager.addIframe(currentN);
                        if ($413a30192b54574f$var$isSerializedStylesheet(currentN, _this.mirror)) _this.stylesheetManager.trackLinkElement(currentN);
                        if ($413a30192b54574f$var$hasShadowRoot(n2)) _this.shadowDomManager.addShadowRoot($413a30192b54574f$var$index.shadowRoot(n2), _this.doc);
                    },
                    onIframeLoad: function(iframe, childSn) {
                        _this.iframeManager.attachIframe(iframe, childSn);
                        _this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: function(link, childSn) {
                        _this.stylesheetManager.attachLinkElement(link, childSn);
                    },
                    cssCaptured: cssCaptured
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(_this.mapRemoves.length)_this.mirror.removeNodeFromMap(_this.mapRemoves.shift());
            for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(_this.movedSet), _step; !(_step = _iterator()).done;){
                var n2 = _step.value;
                if ($413a30192b54574f$var$isParentRemoved(_this.removesSubTreeCache, n2, _this.mirror) && !_this.movedSet.has($413a30192b54574f$var$index.parentNode(n2))) continue;
                pushAdd(n2);
            }
            for(var _iterator1 = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(_this.addedSet), _step1; !(_step1 = _iterator1()).done;){
                var n21 = _step1.value;
                if (!$413a30192b54574f$var$isAncestorInSet(_this.droppedSet, n21) && !$413a30192b54574f$var$isParentRemoved(_this.removesSubTreeCache, n21, _this.mirror)) pushAdd(n21);
                else if ($413a30192b54574f$var$isAncestorInSet(_this.movedSet, n21)) pushAdd(n21);
                else _this.droppedSet.add(n21);
            }
            var candidate = null;
            while(addList.length){
                var node2 = null;
                if (candidate) {
                    var parentId = _this.mirror.getId($413a30192b54574f$var$index.parentNode(candidate.value));
                    var nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node2 = candidate;
                }
                if (!node2) {
                    var tailNode = addList.tail;
                    while(tailNode){
                        var _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            var parentId1 = _this.mirror.getId($413a30192b54574f$var$index.parentNode(_node.value));
                            var nextId1 = getNextId(_node.value);
                            if (nextId1 === -1) continue;
                            else if (parentId1 !== -1) {
                                node2 = _node;
                                break;
                            } else {
                                var unhandledNode = _node.value;
                                var parent = $413a30192b54574f$var$index.parentNode(unhandledNode);
                                if (parent && parent.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    var shadowHost = $413a30192b54574f$var$index.host(parent);
                                    var parentId2 = _this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node2 = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node2) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node2.previous;
                addList.removeNode(node2.value);
                pushAdd(node2.value);
            }
            var payload = {
                texts: _this.texts.map(function(text) {
                    var n2 = text.node;
                    var parent = $413a30192b54574f$var$index.parentNode(n2);
                    if (parent && parent.tagName === "TEXTAREA") _this.genTextAreaValueMutation(parent);
                    return {
                        id: _this.mirror.getId(n2),
                        value: text.value
                    };
                }).filter(function(text) {
                    return !addedIds.has(text.id);
                }).filter(function(text) {
                    return _this.mirror.has(text.id);
                }),
                attributes: _this.attributes.map(function(attribute) {
                    var attributes = attribute.attributes;
                    if (typeof attributes.style === "string") {
                        var diffAsStr = JSON.stringify(attribute.styleDiff);
                        var unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: _this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter(function(attribute) {
                    return !addedIds.has(attribute.id);
                }).filter(function(attribute) {
                    return _this.mirror.has(attribute.id);
                }),
                removes: _this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            _this.texts = [];
            _this.attributes = [];
            _this.attributeMap = /* @__PURE__ */ new WeakMap();
            _this.removes = [];
            _this.addedSet = /* @__PURE__ */ new Set();
            _this.movedSet = /* @__PURE__ */ new Set();
            _this.droppedSet = /* @__PURE__ */ new Set();
            _this.removesSubTreeCache = /* @__PURE__ */ new Set();
            _this.movedMap = {};
            _this.mutationCb(payload);
        });
        $413a30192b54574f$var$__publicField(this, "genTextAreaValueMutation", function(textarea) {
            var item = _this.attributeMap.get(textarea);
            if (!item) {
                item = {
                    node: textarea,
                    attributes: {},
                    styleDiff: {},
                    _unchangedStyles: {}
                };
                _this.attributes.push(item);
                _this.attributeMap.set(textarea, item);
            }
            var value = Array.from($413a30192b54574f$var$index.childNodes(textarea), function(cn) {
                return $413a30192b54574f$var$index.textContent(cn) || "";
            }).join("");
            item.attributes.value = $413a30192b54574f$var$maskInputValue({
                element: textarea,
                maskInputOptions: _this.maskInputOptions,
                tagName: textarea.tagName,
                type: $413a30192b54574f$var$getInputType(textarea),
                value: value,
                maskInputFn: _this.maskInputFn
            });
        });
        $413a30192b54574f$var$__publicField(this, "processMutation", function(m) {
            if ($413a30192b54574f$var$isIgnored(m.target, _this.mirror, _this.slimDOMOptions)) return;
            switch(m.type){
                case "characterData":
                    var value = $413a30192b54574f$var$index.textContent(m.target);
                    if (!$413a30192b54574f$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) && value !== m.oldValue) _this.texts.push({
                        value: $413a30192b54574f$var$needMaskingText(m.target, _this.maskTextClass, _this.maskTextSelector, true) && value ? _this.maskTextFn ? _this.maskTextFn(value, $413a30192b54574f$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                        node: m.target
                    });
                    break;
                case "attributes":
                    var target = m.target;
                    var attributeName = m.attributeName;
                    var value1 = m.target.getAttribute(attributeName);
                    if (attributeName === "value") {
                        var type = $413a30192b54574f$var$getInputType(target);
                        value1 = $413a30192b54574f$var$maskInputValue({
                            element: target,
                            maskInputOptions: _this.maskInputOptions,
                            tagName: target.tagName,
                            type: type,
                            value: value1,
                            maskInputFn: _this.maskInputFn
                        });
                    }
                    if ($413a30192b54574f$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) || value1 === m.oldValue) return;
                    var item = _this.attributeMap.get(m.target);
                    if (target.tagName === "IFRAME" && attributeName === "src" && !_this.keepIframeSrcFn(value1)) {
                        if (!target.contentDocument) attributeName = "rr_src";
                        else return;
                    }
                    if (!item) {
                        item = {
                            node: m.target,
                            attributes: {},
                            styleDiff: {},
                            _unchangedStyles: {}
                        };
                        _this.attributes.push(item);
                        _this.attributeMap.set(m.target, item);
                    }
                    if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                    if (!$413a30192b54574f$var$ignoreAttribute(target.tagName, attributeName)) {
                        item.attributes[attributeName] = $413a30192b54574f$var$transformAttribute(_this.doc, $413a30192b54574f$var$toLowerCase(target.tagName), $413a30192b54574f$var$toLowerCase(attributeName), value1);
                        if (attributeName === "style") {
                            if (!_this.unattachedDoc) try {
                                _this.unattachedDoc = document.implementation.createHTMLDocument();
                            } catch (e2) {
                                _this.unattachedDoc = _this.doc;
                            }
                            var old = _this.unattachedDoc.createElement("span");
                            if (m.oldValue) old.setAttribute("style", m.oldValue);
                            for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(Array.from(target.style)), _step; !(_step = _iterator()).done;){
                                var pname = _step.value;
                                var newValue = target.style.getPropertyValue(pname);
                                var newPriority = target.style.getPropertyPriority(pname);
                                if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                    if (newPriority === "") item.styleDiff[pname] = newValue;
                                    else item.styleDiff[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                } else item._unchangedStyles[pname] = [
                                    newValue,
                                    newPriority
                                ];
                            }
                            for(var _iterator1 = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(Array.from(old.style)), _step1; !(_step1 = _iterator1()).done;){
                                var pname1 = _step1.value;
                                if (target.style.getPropertyValue(pname1) === "") item.styleDiff[pname1] = false;
                            }
                        } else if (attributeName === "open" && target.tagName === "DIALOG") {
                            if (target.matches("dialog:modal")) item.attributes["rr_open_mode"] = "modal";
                            else item.attributes["rr_open_mode"] = "non-modal";
                        }
                    }
                    break;
                case "childList":
                    if ($413a30192b54574f$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, true)) return;
                    if (m.target.tagName === "TEXTAREA") {
                        _this.genTextAreaValueMutation(m.target);
                        return;
                    }
                    m.addedNodes.forEach(function(n2) {
                        return _this.genAdds(n2, m.target);
                    });
                    m.removedNodes.forEach(function(n2) {
                        var nodeId = _this.mirror.getId(n2);
                        var parentId = $413a30192b54574f$var$isShadowRoot(m.target) ? _this.mirror.getId($413a30192b54574f$var$index.host(m.target)) : _this.mirror.getId(m.target);
                        if ($413a30192b54574f$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) || $413a30192b54574f$var$isIgnored(n2, _this.mirror, _this.slimDOMOptions) || !$413a30192b54574f$var$isSerialized(n2, _this.mirror)) return;
                        if (_this.addedSet.has(n2)) {
                            $413a30192b54574f$var$deepDelete(_this.addedSet, n2);
                            _this.droppedSet.add(n2);
                        } else if (_this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($413a30192b54574f$var$isAncestorRemoved(m.target, _this.mirror)) ;
                        else if (_this.movedSet.has(n2) && _this.movedMap[$413a30192b54574f$var$moveKey(nodeId, parentId)]) $413a30192b54574f$var$deepDelete(_this.movedSet, n2);
                        else {
                            _this.removes.push({
                                parentId: parentId,
                                id: nodeId,
                                isShadow: $413a30192b54574f$var$isShadowRoot(m.target) && $413a30192b54574f$var$isNativeShadowDom(m.target) ? true : void 0
                            });
                            $413a30192b54574f$var$processRemoves(n2, _this.removesSubTreeCache);
                        }
                        _this.mapRemoves.push(n2);
                    });
                    break;
            }
        });
        /**
     * Make sure you check if `n`'s parent is blocked before calling this function
     * */ $413a30192b54574f$var$__publicField(this, "genAdds", function(n2, target) {
            if (_this.processedNodeManager.inOtherBuffer(n2, _this)) return;
            if (_this.addedSet.has(n2) || _this.movedSet.has(n2)) return;
            if (_this.mirror.hasNode(n2)) {
                if ($413a30192b54574f$var$isIgnored(n2, _this.mirror, _this.slimDOMOptions)) return;
                _this.movedSet.add(n2);
                var targetId = null;
                if (target && _this.mirror.hasNode(target)) targetId = _this.mirror.getId(target);
                if (targetId && targetId !== -1) _this.movedMap[$413a30192b54574f$var$moveKey(_this.mirror.getId(n2), targetId)] = true;
            } else {
                _this.addedSet.add(n2);
                _this.droppedSet.delete(n2);
            }
            if (!$413a30192b54574f$var$isBlocked(n2, _this.blockClass, _this.blockSelector, false)) {
                $413a30192b54574f$var$index.childNodes(n2).forEach(function(childN) {
                    return _this.genAdds(childN);
                });
                if ($413a30192b54574f$var$hasShadowRoot(n2)) $413a30192b54574f$var$index.childNodes($413a30192b54574f$var$index.shadowRoot(n2)).forEach(function(childN) {
                    _this.processedNodeManager.add(childN, _this);
                    _this.genAdds(childN, n2);
                });
            }
        });
    }
    var _proto = MutationBuffer.prototype;
    _proto.init = function init(options) {
        var _this = this;
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "maskTextClass",
            "maskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach(function(key) {
            _this[key] = options[key];
        });
    };
    _proto.freeze = function freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    };
    _proto.unfreeze = function unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    };
    _proto.isFrozen = function isFrozen() {
        return this.frozen;
    };
    _proto.lock = function lock() {
        this.locked = true;
        this.canvasManager.lock();
    };
    _proto.unlock = function unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    };
    _proto.reset = function reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    };
    return MutationBuffer;
}();
function $413a30192b54574f$var$deepDelete(addsSet, n2) {
    addsSet.delete(n2);
    $413a30192b54574f$var$index.childNodes(n2).forEach(function(childN) {
        return $413a30192b54574f$var$deepDelete(addsSet, childN);
    });
}
function $413a30192b54574f$var$processRemoves(n2, cache) {
    var queue = [
        n2
    ];
    while(queue.length){
        var next = queue.pop();
        if (cache.has(next)) continue;
        cache.add(next);
        $413a30192b54574f$var$index.childNodes(next).forEach(function(n22) {
            return queue.push(n22);
        });
    }
    return;
}
function $413a30192b54574f$var$isParentRemoved(removes, n2, mirror2) {
    if (removes.size === 0) return false;
    return $413a30192b54574f$var$_isParentRemoved(removes, n2);
}
function $413a30192b54574f$var$_isParentRemoved(removes, n2, _mirror2) {
    var node2 = $413a30192b54574f$var$index.parentNode(n2);
    if (!node2) return false;
    return removes.has(node2);
}
function $413a30192b54574f$var$isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return $413a30192b54574f$var$_isAncestorInSet(set, n2);
}
function $413a30192b54574f$var$_isAncestorInSet(set, n2) {
    var parent = $413a30192b54574f$var$index.parentNode(n2);
    if (!parent) return false;
    if (set.has(parent)) return true;
    return $413a30192b54574f$var$_isAncestorInSet(set, parent);
}
var $413a30192b54574f$var$errorHandler;
function $413a30192b54574f$var$registerErrorHandler(handler) {
    $413a30192b54574f$var$errorHandler = handler;
}
function $413a30192b54574f$var$unregisterErrorHandler() {
    $413a30192b54574f$var$errorHandler = void 0;
}
var $413a30192b54574f$var$callbackWrapper = function(cb) {
    if (!$413a30192b54574f$var$errorHandler) return cb;
    var rrwebWrapped = function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++)rest[_key] = arguments[_key];
        try {
            return cb.apply(void 0, [].concat(rest));
        } catch (error) {
            if ($413a30192b54574f$var$errorHandler && $413a30192b54574f$var$errorHandler(error) === true) return;
            throw error;
        }
    };
    return rrwebWrapped;
};
var $413a30192b54574f$var$mutationBuffers = [];
function $413a30192b54574f$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            var path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e) {}
    return event && event.target;
}
function $413a30192b54574f$var$initMutationObserver(options, rootEl) {
    var mutationBuffer = new $413a30192b54574f$var$MutationBuffer();
    $413a30192b54574f$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    var observer = new ($413a30192b54574f$var$mutationObserverCtor())($413a30192b54574f$var$callbackWrapper(mutationBuffer.processMutations.bind(mutationBuffer)));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $413a30192b54574f$var$initMoveObserver(param) {
    var mousemoveCb = param.mousemoveCb, sampling = param.sampling, doc = param.doc, mirror2 = param.mirror;
    if (sampling.mousemove === false) return function() {};
    var threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    var callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    var positions = [];
    var timeBaseline;
    var wrappedCb = $413a30192b54574f$var$throttle($413a30192b54574f$var$callbackWrapper(function(source) {
        var totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map(function(p) {
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    var updatePosition = $413a30192b54574f$var$callbackWrapper($413a30192b54574f$var$throttle($413a30192b54574f$var$callbackWrapper(function(evt) {
        var target = $413a30192b54574f$var$getEventTarget(evt);
        var _ref = $413a30192b54574f$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt, clientX = _ref.clientX, clientY = _ref.clientY;
        if (!timeBaseline) timeBaseline = $413a30192b54574f$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: $413a30192b54574f$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && $413a30192b54574f$var$_instanceof(evt, DragEvent) ? $413a30192b54574f$var$IncrementalSource.Drag : $413a30192b54574f$var$_instanceof(evt, MouseEvent) ? $413a30192b54574f$var$IncrementalSource.MouseMove : $413a30192b54574f$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    var handlers = [
        $413a30192b54574f$var$on("mousemove", updatePosition, doc),
        $413a30192b54574f$var$on("touchmove", updatePosition, doc),
        $413a30192b54574f$var$on("drag", updatePosition, doc)
    ];
    return $413a30192b54574f$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $413a30192b54574f$var$initMouseInteractionObserver(param) {
    var mouseInteractionCb = param.mouseInteractionCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, sampling = param.sampling;
    if (sampling.mouseInteraction === false) return function() {};
    var disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    var handlers = [];
    var currentPointerType = null;
    var getHandler = function(eventKey) {
        return function(event) {
            var target = $413a30192b54574f$var$getEventTarget(event);
            if ($413a30192b54574f$var$isBlocked(target, blockClass, blockSelector, true)) return;
            var pointerType = null;
            var thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $413a30192b54574f$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $413a30192b54574f$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $413a30192b54574f$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $413a30192b54574f$var$PointerTypes.Touch) {
                    if ($413a30192b54574f$var$MouseInteractions[eventKey] === $413a30192b54574f$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($413a30192b54574f$var$MouseInteractions[eventKey] === $413a30192b54574f$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $413a30192b54574f$var$PointerTypes.Pen;
            } else if ($413a30192b54574f$var$legacy_isTouchEvent(event)) pointerType = $413a30192b54574f$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $413a30192b54574f$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $413a30192b54574f$var$PointerTypes.Mouse) pointerType = null;
            } else if ($413a30192b54574f$var$MouseInteractions[eventKey] === $413a30192b54574f$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            var e2 = $413a30192b54574f$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            var id = mirror2.getId(target);
            var clientX = e2.clientX, clientY = e2.clientY;
            $413a30192b54574f$var$callbackWrapper(mouseInteractionCb)($413a30192b54574f$var$_extends({
                type: $413a30192b54574f$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY
            }, pointerType !== null && {
                pointerType: pointerType
            }));
        };
    };
    Object.keys($413a30192b54574f$var$MouseInteractions).filter(function(key) {
        return Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false;
    }).forEach(function(eventKey) {
        var eventName = $413a30192b54574f$var$toLowerCase(eventKey);
        var handler = getHandler(eventKey);
        if (window.PointerEvent) switch($413a30192b54574f$var$MouseInteractions[eventKey]){
            case $413a30192b54574f$var$MouseInteractions.MouseDown:
            case $413a30192b54574f$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $413a30192b54574f$var$MouseInteractions.TouchStart:
            case $413a30192b54574f$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($413a30192b54574f$var$on(eventName, handler, doc));
    });
    return $413a30192b54574f$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $413a30192b54574f$var$initScrollObserver(param) {
    var scrollCb = param.scrollCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, sampling = param.sampling;
    var updatePosition = $413a30192b54574f$var$callbackWrapper($413a30192b54574f$var$throttle($413a30192b54574f$var$callbackWrapper(function(evt) {
        var target = $413a30192b54574f$var$getEventTarget(evt);
        if (!target || $413a30192b54574f$var$isBlocked(target, blockClass, blockSelector, true)) return;
        var id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            var scrollLeftTop = $413a30192b54574f$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $413a30192b54574f$var$on("scroll", updatePosition, doc);
}
function $413a30192b54574f$var$initViewportResizeObserver(param, param1) {
    var viewportResizeCb = param.viewportResizeCb;
    var win = param1.win;
    var lastH = -1;
    var lastW = -1;
    var updateDimension = $413a30192b54574f$var$callbackWrapper($413a30192b54574f$var$throttle($413a30192b54574f$var$callbackWrapper(function() {
        var height = $413a30192b54574f$var$getWindowHeight();
        var width = $413a30192b54574f$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $413a30192b54574f$var$on("resize", updateDimension, win);
}
var $413a30192b54574f$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
var $413a30192b54574f$var$lastInputValueMap = /* @__PURE__ */ new WeakMap();
function $413a30192b54574f$var$initInputObserver(param) {
    var inputCb = param.inputCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, ignoreClass = param.ignoreClass, ignoreSelector = param.ignoreSelector, maskInputOptions = param.maskInputOptions, maskInputFn = param.maskInputFn, sampling = param.sampling, userTriggeredOnInput = param.userTriggeredOnInput;
    function eventHandler(event) {
        var target = $413a30192b54574f$var$getEventTarget(event);
        var userTriggered = event.isTrusted;
        var tagName = target && target.tagName;
        if (target && tagName === "OPTION") target = $413a30192b54574f$var$index.parentElement(target);
        if (!target || !tagName || $413a30192b54574f$var$INPUT_TAGS.indexOf(tagName) < 0 || $413a30192b54574f$var$isBlocked(target, blockClass, blockSelector, true)) return;
        if (target.classList.contains(ignoreClass) || ignoreSelector && target.matches(ignoreSelector)) return;
        var text = target.value;
        var isChecked = false;
        var type = $413a30192b54574f$var$getInputType(target) || "";
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        else if (maskInputOptions[tagName.toLowerCase()] || maskInputOptions[type]) text = $413a30192b54574f$var$maskInputValue({
            element: target,
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        var name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll('input[type="radio"][name="' + name + '"]').forEach(function(el) {
            if (el !== target) {
                var text2 = el.value;
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        var lastInputValue = $413a30192b54574f$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            $413a30192b54574f$var$lastInputValueMap.set(target, v2);
            var id = mirror2.getId(target);
            $413a30192b54574f$var$callbackWrapper(inputCb)($413a30192b54574f$var$_extends({}, v2, {
                id: id
            }));
        }
    }
    var events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    var handlers = events.map(function(eventName) {
        return $413a30192b54574f$var$on(eventName, $413a30192b54574f$var$callbackWrapper(eventHandler), doc);
    });
    var currentWindow = doc.defaultView;
    if (!currentWindow) return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
    var propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    var hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) {
        var _handlers;
        (_handlers = handlers).push.apply(_handlers, [].concat(hookProperties.map(function(p) {
            return $413a30192b54574f$var$hookSetter(p[0], p[1], {
                set: function set() {
                    $413a30192b54574f$var$callbackWrapper(eventHandler)({
                        target: this,
                        isTrusted: false
                    });
                }
            }, false, currentWindow);
        })));
    }
    return $413a30192b54574f$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $413a30192b54574f$var$getNestedCSSRulePositions(rule2) {
    var positions = [];
    function recurse(childRule, pos) {
        if ($413a30192b54574f$var$hasNestedCSSRule("CSSGroupingRule") && $413a30192b54574f$var$_instanceof(childRule.parentRule, CSSGroupingRule) || $413a30192b54574f$var$hasNestedCSSRule("CSSMediaRule") && $413a30192b54574f$var$_instanceof(childRule.parentRule, CSSMediaRule) || $413a30192b54574f$var$hasNestedCSSRule("CSSSupportsRule") && $413a30192b54574f$var$_instanceof(childRule.parentRule, CSSSupportsRule) || $413a30192b54574f$var$hasNestedCSSRule("CSSConditionRule") && $413a30192b54574f$var$_instanceof(childRule.parentRule, CSSConditionRule)) {
            var rules2 = Array.from(childRule.parentRule.cssRules);
            var index2 = rules2.indexOf(childRule);
            pos.unshift(index2);
        } else if (childRule.parentStyleSheet) {
            var rules21 = Array.from(childRule.parentStyleSheet.cssRules);
            var index21 = rules21.indexOf(childRule);
            pos.unshift(index21);
        }
        return pos;
    }
    return recurse(rule2, positions);
}
function $413a30192b54574f$var$getIdAndStyleId(sheet, mirror2, styleMirror) {
    var id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $413a30192b54574f$var$initStyleSheetObserver(param, param1) {
    var styleSheetRuleCb = param.styleSheetRuleCb, mirror2 = param.mirror, stylesheetManager = param.stylesheetManager;
    var win = param1.win;
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return function() {};
    var insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $413a30192b54574f$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var rule2 = argumentsList[0], index2 = argumentsList[1];
            var _getIdAndStyleId = $413a30192b54574f$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule2,
                        index: index2
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    win.CSSStyleSheet.prototype.addRule = function(selector, styleBlock, index2) {
        if (index2 === void 0) index2 = this.cssRules.length;
        var rule2 = selector + " { " + styleBlock + " }";
        return win.CSSStyleSheet.prototype.insertRule.apply(this, [
            rule2,
            index2
        ]);
    };
    var deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $413a30192b54574f$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var index2 = argumentsList[0];
            var _getIdAndStyleId = $413a30192b54574f$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index2
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    win.CSSStyleSheet.prototype.removeRule = function(index2) {
        return win.CSSStyleSheet.prototype.deleteRule.apply(this, [
            index2
        ]);
    };
    var replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $413a30192b54574f$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var text = argumentsList[0];
                var _getIdAndStyleId = $413a30192b54574f$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $413a30192b54574f$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var text = argumentsList[0];
                var _getIdAndStyleId = $413a30192b54574f$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var supportedNestedCSSRuleTypes = {};
    if ($413a30192b54574f$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($413a30192b54574f$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($413a30192b54574f$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($413a30192b54574f$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    var unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
        var typeKey = param[0], type = param[1];
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $413a30192b54574f$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var rule2 = argumentsList[0], index2 = argumentsList[1];
                var _getIdAndStyleId = $413a30192b54574f$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule2,
                            index: [].concat($413a30192b54574f$var$getNestedCSSRulePositions(thisArg), [
                                index2 || 0
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $413a30192b54574f$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var index2 = argumentsList[0];
                var _getIdAndStyleId = $413a30192b54574f$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [].concat($413a30192b54574f$var$getNestedCSSRulePositions(thisArg), [
                                index2
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $413a30192b54574f$var$callbackWrapper(function() {
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
            var typeKey = param[0], type = param[1];
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $413a30192b54574f$var$initAdoptedStyleSheetObserver(param, host2) {
    var mirror2 = param.mirror, stylesheetManager = param.stylesheetManager;
    var _a2, _b, _c;
    var hostId = null;
    if (host2.nodeName === "#document") hostId = mirror2.getId(host2);
    else hostId = mirror2.getId($413a30192b54574f$var$index.host(host2));
    var patchTarget = host2.nodeName === "#document" ? (_a2 = host2.defaultView) == null ? void 0 : _a2.Document : (_c = (_b = host2.ownerDocument) == null ? void 0 : _b.defaultView) == null ? void 0 : _c.ShadowRoot;
    var originalPropertyDescriptor = (patchTarget == null ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget == null ? void 0 : patchTarget.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return function() {};
    Object.defineProperty(host2, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get: function get() {
            var _a3;
            return (_a3 = originalPropertyDescriptor.get) == null ? void 0 : _a3.call(this);
        },
        set: function set(sheets) {
            var _a3;
            var result2 = (_a3 = originalPropertyDescriptor.set) == null ? void 0 : _a3.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result2;
        }
    });
    return $413a30192b54574f$var$callbackWrapper(function() {
        Object.defineProperty(host2, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function $413a30192b54574f$var$initStyleDeclarationObserver(param, param1) {
    var styleDeclarationCb = param.styleDeclarationCb, mirror2 = param.mirror, ignoreCSSAttributes = param.ignoreCSSAttributes, stylesheetManager = param.stylesheetManager;
    var win = param1.win;
    var setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $413a30192b54574f$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _a2;
            var property = argumentsList[0], value = argumentsList[1], priority = argumentsList[2];
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            var _getIdAndStyleId = $413a30192b54574f$var$getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $413a30192b54574f$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $413a30192b54574f$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _a2;
            var property = argumentsList[0];
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            var _getIdAndStyleId = $413a30192b54574f$var$getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $413a30192b54574f$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $413a30192b54574f$var$callbackWrapper(function() {
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $413a30192b54574f$var$initMediaInteractionObserver(param) {
    var mediaInteractionCb = param.mediaInteractionCb, blockClass = param.blockClass, blockSelector = param.blockSelector, mirror2 = param.mirror, sampling = param.sampling, doc = param.doc;
    var handler = $413a30192b54574f$var$callbackWrapper(function(type) {
        return $413a30192b54574f$var$throttle($413a30192b54574f$var$callbackWrapper(function(event) {
            var target = $413a30192b54574f$var$getEventTarget(event);
            if (!target || $413a30192b54574f$var$isBlocked(target, blockClass, blockSelector, true)) return;
            var currentTime = target.currentTime, volume = target.volume, muted = target.muted, playbackRate = target.playbackRate, loop = target.loop;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate,
                loop: loop
            });
        }), sampling.media || 500);
    });
    var handlers = [
        $413a30192b54574f$var$on("play", handler($413a30192b54574f$var$MediaInteractions.Play), doc),
        $413a30192b54574f$var$on("pause", handler($413a30192b54574f$var$MediaInteractions.Pause), doc),
        $413a30192b54574f$var$on("seeked", handler($413a30192b54574f$var$MediaInteractions.Seeked), doc),
        $413a30192b54574f$var$on("volumechange", handler($413a30192b54574f$var$MediaInteractions.VolumeChange), doc),
        $413a30192b54574f$var$on("ratechange", handler($413a30192b54574f$var$MediaInteractions.RateChange), doc)
    ];
    return $413a30192b54574f$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $413a30192b54574f$var$initFontObserver(param) {
    var fontCb = param.fontCb, doc = param.doc;
    var win = doc.defaultView;
    if (!win) return function() {};
    var handlers = [];
    var fontMap = /* @__PURE__ */ new WeakMap();
    var originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        var fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    var restoreHandler = $413a30192b54574f$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout($413a30192b54574f$var$callbackWrapper(function() {
                var p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(function() {
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $413a30192b54574f$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $413a30192b54574f$var$initSelectionObserver(param) {
    var doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, selectionCb = param.selectionCb;
    var collapsed = true;
    var updateSelection = $413a30192b54574f$var$callbackWrapper(function() {
        var selection = doc.getSelection();
        if (!selection || collapsed && (selection == null ? void 0 : selection.isCollapsed)) return;
        collapsed = selection.isCollapsed || false;
        var ranges = [];
        var count = selection.rangeCount || 0;
        for(var i2 = 0; i2 < count; i2++){
            var range = selection.getRangeAt(i2);
            var startContainer = range.startContainer, startOffset = range.startOffset, endContainer = range.endContainer, endOffset = range.endOffset;
            var blocked = $413a30192b54574f$var$isBlocked(startContainer, blockClass, blockSelector, true) || $413a30192b54574f$var$isBlocked(endContainer, blockClass, blockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $413a30192b54574f$var$on("selectionchange", updateSelection);
}
function $413a30192b54574f$var$initCustomElementObserver(param) {
    var doc = param.doc, customElementCb = param.customElementCb;
    var win = doc.defaultView;
    if (!win || !win.customElements) return function() {};
    var restoreHandler = $413a30192b54574f$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {
                console.warn("Custom element callback failed for " + name);
            }
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $413a30192b54574f$var$mergeHooks(o2, hooks) {
    var mutationCb = o2.mutationCb, mousemoveCb = o2.mousemoveCb, mouseInteractionCb = o2.mouseInteractionCb, scrollCb = o2.scrollCb, viewportResizeCb = o2.viewportResizeCb, inputCb = o2.inputCb, mediaInteractionCb = o2.mediaInteractionCb, styleSheetRuleCb = o2.styleSheetRuleCb, styleDeclarationCb = o2.styleDeclarationCb, canvasMutationCb = o2.canvasMutationCb, fontCb = o2.fontCb, selectionCb = o2.selectionCb, customElementCb = o2.customElementCb;
    o2.mutationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mutation) {
            var _hooks;
            (_hooks = hooks).mutation.apply(_hooks, [].concat(p));
        }
        mutationCb.apply(void 0, [].concat(p));
    };
    o2.mousemoveCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mousemove) {
            var _hooks;
            (_hooks = hooks).mousemove.apply(_hooks, [].concat(p));
        }
        mousemoveCb.apply(void 0, [].concat(p));
    };
    o2.mouseInteractionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mouseInteraction) {
            var _hooks;
            (_hooks = hooks).mouseInteraction.apply(_hooks, [].concat(p));
        }
        mouseInteractionCb.apply(void 0, [].concat(p));
    };
    o2.scrollCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.scroll) {
            var _hooks;
            (_hooks = hooks).scroll.apply(_hooks, [].concat(p));
        }
        scrollCb.apply(void 0, [].concat(p));
    };
    o2.viewportResizeCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.viewportResize) {
            var _hooks;
            (_hooks = hooks).viewportResize.apply(_hooks, [].concat(p));
        }
        viewportResizeCb.apply(void 0, [].concat(p));
    };
    o2.inputCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.input) {
            var _hooks;
            (_hooks = hooks).input.apply(_hooks, [].concat(p));
        }
        inputCb.apply(void 0, [].concat(p));
    };
    o2.mediaInteractionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mediaInteaction) {
            var _hooks;
            (_hooks = hooks).mediaInteaction.apply(_hooks, [].concat(p));
        }
        mediaInteractionCb.apply(void 0, [].concat(p));
    };
    o2.styleSheetRuleCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.styleSheetRule) {
            var _hooks;
            (_hooks = hooks).styleSheetRule.apply(_hooks, [].concat(p));
        }
        styleSheetRuleCb.apply(void 0, [].concat(p));
    };
    o2.styleDeclarationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.styleDeclaration) {
            var _hooks;
            (_hooks = hooks).styleDeclaration.apply(_hooks, [].concat(p));
        }
        styleDeclarationCb.apply(void 0, [].concat(p));
    };
    o2.canvasMutationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.canvasMutation) {
            var _hooks;
            (_hooks = hooks).canvasMutation.apply(_hooks, [].concat(p));
        }
        canvasMutationCb.apply(void 0, [].concat(p));
    };
    o2.fontCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.font) {
            var _hooks;
            (_hooks = hooks).font.apply(_hooks, [].concat(p));
        }
        fontCb.apply(void 0, [].concat(p));
    };
    o2.selectionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.selection) {
            var _hooks;
            (_hooks = hooks).selection.apply(_hooks, [].concat(p));
        }
        selectionCb.apply(void 0, [].concat(p));
    };
    o2.customElementCb = function() {
        for(var _len = arguments.length, c2 = new Array(_len), _key = 0; _key < _len; _key++)c2[_key] = arguments[_key];
        if (hooks.customElement) {
            var _hooks;
            (_hooks = hooks).customElement.apply(_hooks, [].concat(c2));
        }
        customElementCb.apply(void 0, [].concat(c2));
    };
}
function $413a30192b54574f$var$initObservers(o2, hooks) {
    if (hooks === void 0) hooks = {};
    var currentWindow = o2.doc.defaultView;
    if (!currentWindow) return function() {};
    $413a30192b54574f$var$mergeHooks(o2, hooks);
    var mutationObserver;
    if (o2.recordDOM) mutationObserver = $413a30192b54574f$var$initMutationObserver(o2, o2.doc);
    var mousemoveHandler = $413a30192b54574f$var$initMoveObserver(o2);
    var mouseInteractionHandler = $413a30192b54574f$var$initMouseInteractionObserver(o2);
    var scrollHandler = $413a30192b54574f$var$initScrollObserver(o2);
    var viewportResizeHandler = $413a30192b54574f$var$initViewportResizeObserver(o2, {
        win: currentWindow
    });
    var inputHandler = $413a30192b54574f$var$initInputObserver(o2);
    var mediaInteractionHandler = $413a30192b54574f$var$initMediaInteractionObserver(o2);
    var styleSheetObserver = function() {};
    var adoptedStyleSheetObserver = function() {};
    var styleDeclarationObserver = function() {};
    var fontObserver = function() {};
    if (o2.recordDOM) {
        styleSheetObserver = $413a30192b54574f$var$initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $413a30192b54574f$var$initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = $413a30192b54574f$var$initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = $413a30192b54574f$var$initFontObserver(o2);
    }
    var selectionObserver = $413a30192b54574f$var$initSelectionObserver(o2);
    var customElementObserver = $413a30192b54574f$var$initCustomElementObserver(o2);
    var pluginHandlers = [];
    for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(o2.plugins), _step; !(_step = _iterator()).done;){
        var plugin3 = _step.value;
        pluginHandlers.push(plugin3.observer(plugin3.callback, currentWindow, plugin3.options));
    }
    return $413a30192b54574f$var$callbackWrapper(function() {
        $413a30192b54574f$var$mutationBuffers.forEach(function(b) {
            return b.reset();
        });
        mutationObserver == null || mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach(function(h) {
            return h();
        });
    });
}
function $413a30192b54574f$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $413a30192b54574f$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
var $413a30192b54574f$var$CrossOriginIframeMirror = /*#__PURE__*/ function() {
    function CrossOriginIframeMirror(generateIdFn) {
        $413a30192b54574f$var$__publicField(this, "iframeIdToRemoteIdMap", /* @__PURE__ */ new WeakMap());
        $413a30192b54574f$var$__publicField(this, "iframeRemoteIdToIdMap", /* @__PURE__ */ new WeakMap());
        this.generateIdFn = generateIdFn;
    }
    var _proto = CrossOriginIframeMirror.prototype;
    _proto.getId = function getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        var idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        var remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        var id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    };
    _proto.getIds = function getIds(iframe, remoteId) {
        var _this = this;
        var idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map(function(id) {
            return _this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap);
        });
    };
    _proto.getRemoteId = function getRemoteId(iframe, id, map) {
        var remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        var remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    };
    _proto.getRemoteIds = function getRemoteIds(iframe, ids) {
        var _this = this;
        var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map(function(id) {
            return _this.getRemoteId(iframe, id, remoteIdToIdMap);
        });
    };
    _proto.reset = function reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
            this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    };
    _proto.getIdToRemoteIdMap = function getIdToRemoteIdMap(iframe) {
        var idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = /* @__PURE__ */ new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    };
    _proto.getRemoteIdToIdMap = function getRemoteIdToIdMap(iframe) {
        var remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = /* @__PURE__ */ new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    };
    return CrossOriginIframeMirror;
}();
var $413a30192b54574f$var$IframeManager = /*#__PURE__*/ function() {
    function IframeManager(options) {
        $413a30192b54574f$var$__publicField(this, "iframes", /* @__PURE__ */ new WeakMap());
        $413a30192b54574f$var$__publicField(this, "crossOriginIframeMap", /* @__PURE__ */ new WeakMap());
        $413a30192b54574f$var$__publicField(this, "crossOriginIframeMirror", new $413a30192b54574f$var$CrossOriginIframeMirror($413a30192b54574f$var$genId));
        $413a30192b54574f$var$__publicField(this, "crossOriginIframeStyleMirror");
        $413a30192b54574f$var$__publicField(this, "crossOriginIframeRootIdMap", /* @__PURE__ */ new WeakMap());
        $413a30192b54574f$var$__publicField(this, "mirror");
        $413a30192b54574f$var$__publicField(this, "mutationCb");
        $413a30192b54574f$var$__publicField(this, "wrappedEmit");
        $413a30192b54574f$var$__publicField(this, "loadListener");
        $413a30192b54574f$var$__publicField(this, "stylesheetManager");
        $413a30192b54574f$var$__publicField(this, "recordCrossOriginIframes");
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $413a30192b54574f$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    var _proto = IframeManager.prototype;
    _proto.addIframe = function addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    };
    _proto.addLoadListener = function addLoadListener(cb) {
        this.loadListener = cb;
    };
    _proto.attachIframe = function attachIframe(iframeEl, childSn) {
        var _a2, _b;
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        if (this.recordCrossOriginIframes) (_a2 = iframeEl.contentWindow) == null || _a2.addEventListener("message", this.handleMessage.bind(this));
        (_b = this.loadListener) == null || _b.call(this, iframeEl);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    };
    _proto.handleMessage = function handleMessage(message) {
        var crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
        crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        var iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        var iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        var transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    };
    _proto.transformCrossOriginEvent = function transformCrossOriginEvent(iframeEl, e2) {
        var _this = this;
        var _a2;
        switch(e2.type){
            case $413a30192b54574f$var$EventType.FullSnapshot:
                this.crossOriginIframeMirror.reset(iframeEl);
                this.crossOriginIframeStyleMirror.reset(iframeEl);
                this.replaceIdOnNode(e2.data.node, iframeEl);
                var rootId = e2.data.node.id;
                this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                this.patchRootIdOnNode(e2.data.node, rootId);
                return {
                    timestamp: e2.timestamp,
                    type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
                    data: {
                        source: $413a30192b54574f$var$IncrementalSource.Mutation,
                        adds: [
                            {
                                parentId: this.mirror.getId(iframeEl),
                                nextId: null,
                                node: e2.data.node
                            }
                        ],
                        removes: [],
                        texts: [],
                        attributes: [],
                        isAttachIframe: true
                    }
                };
            case $413a30192b54574f$var$EventType.Meta:
            case $413a30192b54574f$var$EventType.Load:
            case $413a30192b54574f$var$EventType.DomContentLoaded:
                return false;
            case $413a30192b54574f$var$EventType.Plugin:
                return e2;
            case $413a30192b54574f$var$EventType.Custom:
                this.replaceIds(e2.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e2;
            case $413a30192b54574f$var$EventType.IncrementalSnapshot:
                switch(e2.data.source){
                    case $413a30192b54574f$var$IncrementalSource.Mutation:
                        e2.data.adds.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            _this.replaceIdOnNode(n2.node, iframeEl);
                            var rootId = _this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && _this.patchRootIdOnNode(n2.node, rootId);
                        });
                        e2.data.removes.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e2.data.attributes.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        e2.data.texts.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $413a30192b54574f$var$IncrementalSource.Drag:
                    case $413a30192b54574f$var$IncrementalSource.TouchMove:
                    case $413a30192b54574f$var$IncrementalSource.MouseMove:
                        e2.data.positions.forEach(function(p) {
                            _this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $413a30192b54574f$var$IncrementalSource.ViewportResize:
                        return false;
                    case $413a30192b54574f$var$IncrementalSource.MediaInteraction:
                    case $413a30192b54574f$var$IncrementalSource.MouseInteraction:
                    case $413a30192b54574f$var$IncrementalSource.Scroll:
                    case $413a30192b54574f$var$IncrementalSource.CanvasMutation:
                    case $413a30192b54574f$var$IncrementalSource.Input:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        return e2;
                    case $413a30192b54574f$var$IncrementalSource.StyleSheetRule:
                    case $413a30192b54574f$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleId"
                        ]);
                        return e2;
                    case $413a30192b54574f$var$IncrementalSource.Font:
                        return e2;
                    case $413a30192b54574f$var$IncrementalSource.Selection:
                        e2.data.ranges.forEach(function(range) {
                            _this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e2;
                    case $413a30192b54574f$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleIds"
                        ]);
                        (_a2 = e2.data.styles) == null || _a2.forEach(function(style) {
                            _this.replaceStyleIds(style, iframeEl, [
                                "styleId"
                            ]);
                        });
                        return e2;
                }
        }
        return false;
    };
    _proto.replace = function replace(iframeMirror, obj, iframeEl, keys) {
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(keys), _step; !(_step = _iterator()).done;){
            var key = _step.value;
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    };
    _proto.replaceIds = function replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    };
    _proto.replaceStyleIds = function replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    };
    _proto.replaceIdOnNode = function replaceIdOnNode(node2, iframeEl) {
        var _this = this;
        this.replaceIds(node2, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node2) node2.childNodes.forEach(function(child) {
            _this.replaceIdOnNode(child, iframeEl);
        });
    };
    _proto.patchRootIdOnNode = function patchRootIdOnNode(node2, rootId) {
        var _this = this;
        if (node2.type !== $413a30192b54574f$var$NodeType.Document && !node2.rootId) node2.rootId = rootId;
        if ("childNodes" in node2) node2.childNodes.forEach(function(child) {
            _this.patchRootIdOnNode(child, rootId);
        });
    };
    return IframeManager;
}();
var $413a30192b54574f$var$ShadowDomManager = /*#__PURE__*/ function() {
    function ShadowDomManager(options) {
        $413a30192b54574f$var$__publicField(this, "shadowDoms", /* @__PURE__ */ new WeakSet());
        $413a30192b54574f$var$__publicField(this, "mutationCb");
        $413a30192b54574f$var$__publicField(this, "scrollCb");
        $413a30192b54574f$var$__publicField(this, "bypassOptions");
        $413a30192b54574f$var$__publicField(this, "mirror");
        $413a30192b54574f$var$__publicField(this, "restoreHandlers", []);
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    var _proto = ShadowDomManager.prototype;
    _proto.init = function init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    };
    _proto.addShadowRoot = function addShadowRoot(shadowRoot2, doc) {
        var _this = this;
        if (!$413a30192b54574f$var$isNativeShadowDom(shadowRoot2)) return;
        if (this.shadowDoms.has(shadowRoot2)) return;
        this.shadowDoms.add(shadowRoot2);
        var observer = $413a30192b54574f$var$initMutationObserver($413a30192b54574f$var$_extends({}, this.bypassOptions, {
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }), shadowRoot2);
        this.restoreHandlers.push(function() {
            return observer.disconnect();
        });
        this.restoreHandlers.push($413a30192b54574f$var$initScrollObserver($413a30192b54574f$var$_extends({}, this.bypassOptions, {
            scrollCb: this.scrollCb,
            // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
            // scroll is not allowed to pass the boundary, so we need to listen the shadow document
            doc: shadowRoot2,
            mirror: this.mirror
        })));
        setTimeout(function() {
            if (shadowRoot2.adoptedStyleSheets && shadowRoot2.adoptedStyleSheets.length > 0) _this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot2.adoptedStyleSheets, _this.mirror.getId($413a30192b54574f$var$index.host(shadowRoot2)));
            _this.restoreHandlers.push($413a30192b54574f$var$initAdoptedStyleSheetObserver({
                mirror: _this.mirror,
                stylesheetManager: _this.bypassOptions.stylesheetManager
            }, shadowRoot2));
        }, 0);
    };
    /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ _proto.observeAttachShadow = function observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    };
    /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ _proto.patchAttachShadow = function patchAttachShadow(element, doc) {
        var manager = this;
        this.restoreHandlers.push($413a30192b54574f$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                var sRoot = original.call(this, option);
                var shadowRootEl = $413a30192b54574f$var$index.shadowRoot(this);
                if (shadowRootEl && $413a30192b54574f$var$inDom(this)) manager.addShadowRoot(shadowRootEl, doc);
                return sRoot;
            };
        }));
    };
    _proto.reset = function reset() {
        this.restoreHandlers.forEach(function(handler) {
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
    };
    return ShadowDomManager;
}();
var $413a30192b54574f$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $413a30192b54574f$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $413a30192b54574f$var$i$1 = 0; $413a30192b54574f$var$i$1 < $413a30192b54574f$var$chars.length; $413a30192b54574f$var$i$1++)$413a30192b54574f$var$lookup[$413a30192b54574f$var$chars.charCodeAt($413a30192b54574f$var$i$1)] = $413a30192b54574f$var$i$1;
var $413a30192b54574f$var$encode = function encode(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
    for(i2 = 0; i2 < len; i2 += 3){
        base64 += $413a30192b54574f$var$chars[bytes[i2] >> 2];
        base64 += $413a30192b54574f$var$chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
        base64 += $413a30192b54574f$var$chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
        base64 += $413a30192b54574f$var$chars[bytes[i2 + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
var $413a30192b54574f$var$canvasVarMap = /* @__PURE__ */ new Map();
function $413a30192b54574f$var$variableListFor$1(ctx, ctor) {
    var contextMap = $413a30192b54574f$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = /* @__PURE__ */ new Map();
        $413a30192b54574f$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
var $413a30192b54574f$var$saveWebGLVar = function(value, win, ctx) {
    if (!value || !($413a30192b54574f$var$isInstanceOfWebGLObject(value, win) || (typeof value === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(value)) === "object")) return;
    var name = value.constructor.name;
    var list2 = $413a30192b54574f$var$variableListFor$1(ctx, name);
    var index2 = list2.indexOf(value);
    if (index2 === -1) {
        index2 = list2.length;
        list2.push(value);
    }
    return index2;
};
function $413a30192b54574f$var$serializeArg(value, win, ctx) {
    if ($413a30192b54574f$var$_instanceof(value, Array)) return value.map(function(arg) {
        return $413a30192b54574f$var$serializeArg(arg, win, ctx);
    });
    else if (value === null) return value;
    else if ($413a30192b54574f$var$_instanceof(value, Float32Array) || $413a30192b54574f$var$_instanceof(value, Float64Array) || $413a30192b54574f$var$_instanceof(value, Int32Array) || $413a30192b54574f$var$_instanceof(value, Uint32Array) || $413a30192b54574f$var$_instanceof(value, Uint8Array) || $413a30192b54574f$var$_instanceof(value, Uint16Array) || $413a30192b54574f$var$_instanceof(value, Int16Array) || $413a30192b54574f$var$_instanceof(value, Int8Array) || $413a30192b54574f$var$_instanceof(value, Uint8ClampedArray)) {
        var name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (// More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    $413a30192b54574f$var$_instanceof(value, ArrayBuffer)) {
        var name1 = value.constructor.name;
        var base64 = $413a30192b54574f$var$encode(value);
        return {
            rr_type: name1,
            base64: base64
        };
    } else if ($413a30192b54574f$var$_instanceof(value, DataView)) {
        var name2 = value.constructor.name;
        return {
            rr_type: name2,
            args: [
                $413a30192b54574f$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if ($413a30192b54574f$var$_instanceof(value, HTMLImageElement)) {
        var name3 = value.constructor.name;
        var src = value.src;
        return {
            rr_type: name3,
            src: src
        };
    } else if ($413a30192b54574f$var$_instanceof(value, HTMLCanvasElement)) {
        var name4 = "HTMLImageElement";
        var src1 = value.toDataURL();
        return {
            rr_type: name4,
            src: src1
        };
    } else if ($413a30192b54574f$var$_instanceof(value, ImageData)) {
        var name5 = value.constructor.name;
        return {
            rr_type: name5,
            args: [
                $413a30192b54574f$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($413a30192b54574f$var$isInstanceOfWebGLObject(value, win) || (typeof value === "undefined" ? "undefined" : $413a30192b54574f$var$_type_of(value)) === "object") {
        var name6 = value.constructor.name;
        var index2 = $413a30192b54574f$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name6,
            index: index2
        };
    }
    return value;
}
var $413a30192b54574f$var$serializeArgs = function(args, win, ctx) {
    return args.map(function(arg) {
        return $413a30192b54574f$var$serializeArg(arg, win, ctx);
    });
};
var $413a30192b54574f$var$isInstanceOfWebGLObject = function(value, win) {
    var webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
        "WebGLVertexArrayObjectOES"
    ];
    var supportedWebGLConstructorNames = webGLConstructorNames.filter(function(name) {
        return typeof win[name] === "function";
    });
    return Boolean(supportedWebGLConstructorNames.find(function(name) {
        return $413a30192b54574f$var$_instanceof(value, win[name]);
    }));
};
function $413a30192b54574f$var$initCanvas2DMutationObserver(cb, win, blockClass, blockSelector) {
    var _loop = function() {
        var prop = _step.value;
        try {
            if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") return "continue";
            var restoreHandler = $413a30192b54574f$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
                return function() {
                    var _this = this;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    if (!$413a30192b54574f$var$isBlocked(this.canvas, blockClass, blockSelector, true)) setTimeout(function() {
                        var recordArgs = $413a30192b54574f$var$serializeArgs(args, win, _this);
                        cb(_this.canvas, {
                            type: $413a30192b54574f$var$CanvasContext["2D"],
                            property: prop,
                            args: recordArgs
                        });
                    }, 0);
                    return original.apply(this, args);
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            var hookHandler = $413a30192b54574f$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
                set: function set(v2) {
                    cb(this.canvas, {
                        type: $413a30192b54574f$var$CanvasContext["2D"],
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    };
    var handlers = [];
    var props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(props2D), _step; !(_step = _iterator()).done;)_loop();
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $413a30192b54574f$var$getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function $413a30192b54574f$var$initCanvasContextObserver(win, blockClass, blockSelector, setPreserveDrawingBufferToTrue) {
    var handlers = [];
    try {
        var restoreHandler = $413a30192b54574f$var$patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (!$413a30192b54574f$var$isBlocked(this, blockClass, blockSelector, true)) {
                    var ctxName = $413a30192b54574f$var$getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && $413a30192b54574f$var$_type_of(args[0]) === "object") {
                            var contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [].concat([
                    contextType
                ], args));
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $413a30192b54574f$var$patchGLPrototype(prototype, type, cb, blockClass, blockSelector, win) {
    var _loop = function() {
        var prop = _step.value;
        if ([
            "isContextLost",
            "canvas",
            "drawingBufferWidth",
            "drawingBufferHeight"
        ].includes(prop)) return "continue";
        try {
            if (typeof prototype[prop] !== "function") return "continue";
            var restoreHandler = $413a30192b54574f$var$patch(prototype, prop, function(original) {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var result2 = original.apply(this, args);
                    $413a30192b54574f$var$saveWebGLVar(result2, win, this);
                    if ("tagName" in this.canvas && !$413a30192b54574f$var$isBlocked(this.canvas, blockClass, blockSelector, true)) {
                        var recordArgs = $413a30192b54574f$var$serializeArgs(args, win, this);
                        var mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result2;
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            var hookHandler = $413a30192b54574f$var$hookSetter(prototype, prop, {
                set: function set(v2) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    };
    var handlers = [];
    var props = Object.getOwnPropertyNames(prototype);
    for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(props), _step; !(_step = _iterator()).done;)_loop();
    return handlers;
}
function $413a30192b54574f$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector) {
    var _handlers;
    var handlers = [];
    (_handlers = handlers).push.apply(_handlers, [].concat($413a30192b54574f$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $413a30192b54574f$var$CanvasContext.WebGL, cb, blockClass, blockSelector, win)));
    if (typeof win.WebGL2RenderingContext !== "undefined") {
        var _handlers1;
        (_handlers1 = handlers).push.apply(_handlers1, [].concat($413a30192b54574f$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $413a30192b54574f$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, win)));
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
var $413a30192b54574f$var$encodedJs = "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";
var $413a30192b54574f$var$decodeBase64 = function(base64) {
    return Uint8Array.from(atob(base64), function(c2) {
        return c2.charCodeAt(0);
    });
};
var $413a30192b54574f$var$blob = typeof window !== "undefined" && window.Blob && new Blob([
    $413a30192b54574f$var$decodeBase64($413a30192b54574f$var$encodedJs)
], {
    type: "text/javascript;charset=utf-8"
});
function $413a30192b54574f$var$WorkerWrapper(options) {
    var objURL;
    try {
        objURL = $413a30192b54574f$var$blob && (window.URL || window.webkitURL).createObjectURL($413a30192b54574f$var$blob);
        if (!objURL) throw "";
        var worker = new Worker(objURL, {
            name: options == null ? void 0 : options.name
        });
        worker.addEventListener("error", function() {
            (window.URL || window.webkitURL).revokeObjectURL(objURL);
        });
        return worker;
    } catch (e2) {
        return new Worker("data:text/javascript;base64," + $413a30192b54574f$var$encodedJs, {
            name: options == null ? void 0 : options.name
        });
    } finally{
        objURL && (window.URL || window.webkitURL).revokeObjectURL(objURL);
    }
}
var $413a30192b54574f$var$CanvasManager = /*#__PURE__*/ function() {
    function CanvasManager(options) {
        var _this = this;
        $413a30192b54574f$var$__publicField(this, "pendingCanvasMutations", /* @__PURE__ */ new Map());
        $413a30192b54574f$var$__publicField(this, "rafStamps", {
            latestId: 0,
            invokeId: null
        });
        $413a30192b54574f$var$__publicField(this, "mirror");
        $413a30192b54574f$var$__publicField(this, "mutationCb");
        $413a30192b54574f$var$__publicField(this, "resetObservers");
        $413a30192b54574f$var$__publicField(this, "frozen", false);
        $413a30192b54574f$var$__publicField(this, "locked", false);
        $413a30192b54574f$var$__publicField(this, "processMutation", function(target, mutation) {
            var newFrame = _this.rafStamps.invokeId && _this.rafStamps.latestId !== _this.rafStamps.invokeId;
            if (newFrame || !_this.rafStamps.invokeId) _this.rafStamps.invokeId = _this.rafStamps.latestId;
            if (!_this.pendingCanvasMutations.has(target)) _this.pendingCanvasMutations.set(target, []);
            _this.pendingCanvasMutations.get(target).push(mutation);
        });
        var _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? "all" : _options_sampling, win = options.win, blockClass = options.blockClass, blockSelector = options.blockSelector, recordCanvas = options.recordCanvas, dataURLOptions = options.dataURLOptions;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector);
        if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, {
            dataURLOptions: dataURLOptions
        });
    }
    var _proto = CanvasManager.prototype;
    _proto.reset = function reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    };
    _proto.freeze = function freeze() {
        this.frozen = true;
    };
    _proto.unfreeze = function unfreeze() {
        this.frozen = false;
    };
    _proto.lock = function lock() {
        this.locked = true;
    };
    _proto.unlock = function unlock() {
        this.locked = false;
    };
    _proto.initCanvasFPSObserver = function initCanvasFPSObserver(fps, win, blockClass, blockSelector, options) {
        var _this = this;
        var canvasContextReset = $413a30192b54574f$var$initCanvasContextObserver(win, blockClass, blockSelector, true);
        var snapshotInProgressMap = /* @__PURE__ */ new Map();
        var worker = new $413a30192b54574f$var$WorkerWrapper();
        worker.onmessage = function(e2) {
            var id = e2.data.id;
            snapshotInProgressMap.set(id, false);
            if (!("base64" in e2.data)) return;
            var _e2_data = e2.data, base64 = _e2_data.base64, type = _e2_data.type, width = _e2_data.width, height = _e2_data.height;
            _this.mutationCb({
                id: id,
                type: $413a30192b54574f$var$CanvasContext["2D"],
                commands: [
                    {
                        property: "clearRect",
                        // wipe canvas
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: "drawImage",
                        // draws (semi-transparent) image
                        args: [
                            {
                                rr_type: "ImageBitmap",
                                args: [
                                    {
                                        rr_type: "Blob",
                                        data: [
                                            {
                                                rr_type: "ArrayBuffer",
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0
                        ]
                    }
                ]
            });
        };
        var timeBetweenSnapshots = 1e3 / fps;
        var lastSnapshotTime = 0;
        var rafId;
        var getCanvas = function() {
            var matchedCanvas = [];
            win.document.querySelectorAll("canvas").forEach(function(canvas) {
                if (!$413a30192b54574f$var$isBlocked(canvas, blockClass, blockSelector, true)) matchedCanvas.push(canvas);
            });
            return matchedCanvas;
        };
        var takeCanvasSnapshots = function(timestamp) {
            if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = requestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            var _this1 = _this;
            getCanvas().forEach(/*#__PURE__*/ $413a30192b54574f$var$_async_to_generator(function(canvas) {
                var _a2, id, context, bitmap;
                return $413a30192b54574f$var$_ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = _this1.mirror.getId(canvas);
                            if (snapshotInProgressMap.get(id)) return [
                                2
                            ];
                            if (canvas.width === 0 || canvas.height === 0) return [
                                2
                            ];
                            snapshotInProgressMap.set(id, true);
                            if ([
                                "webgl",
                                "webgl2"
                            ].includes(canvas.__context)) {
                                context = canvas.getContext(canvas.__context);
                                if (((_a2 = context == null ? void 0 : context.getContextAttributes()) == null ? void 0 : _a2.preserveDrawingBuffer) === false) context.clear(context.COLOR_BUFFER_BIT);
                            }
                            return [
                                4,
                                createImageBitmap(canvas)
                            ];
                        case 1:
                            bitmap = _state.sent();
                            worker.postMessage({
                                id: id,
                                bitmap: bitmap,
                                width: canvas.width,
                                height: canvas.height,
                                dataURLOptions: options.dataURLOptions
                            }, [
                                bitmap
                            ]);
                            return [
                                2
                            ];
                    }
                });
            }));
            rafId = requestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = requestAnimationFrame(takeCanvasSnapshots);
        this.resetObservers = function() {
            canvasContextReset();
            cancelAnimationFrame(rafId);
        };
    };
    _proto.initCanvasMutationObserver = function initCanvasMutationObserver(win, blockClass, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        var canvasContextReset = $413a30192b54574f$var$initCanvasContextObserver(win, blockClass, blockSelector, false);
        var canvas2DReset = $413a30192b54574f$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        var canvasWebGL1and2Reset = $413a30192b54574f$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        this.resetObservers = function() {
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    };
    _proto.startPendingCanvasMutationFlusher = function startPendingCanvasMutationFlusher() {
        var _this = this;
        requestAnimationFrame(function() {
            return _this.flushPendingCanvasMutations();
        });
    };
    _proto.startRAFTimestamping = function startRAFTimestamping() {
        var _this = this;
        var setLatestRAFTimestamp = function(timestamp) {
            _this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    };
    _proto.flushPendingCanvasMutations = function flushPendingCanvasMutations() {
        var _this = this;
        this.pendingCanvasMutations.forEach(function(_values, canvas) {
            var id = _this.mirror.getId(canvas);
            _this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(function() {
            return _this.flushPendingCanvasMutations();
        });
    };
    _proto.flushPendingCanvasMutationFor = function flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        var valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        var values = valuesWithType.map(function(value) {
            value.type;
            var rest = $413a30192b54574f$var$_object_without_properties_loose(value, [
                "type"
            ]);
            return rest;
        });
        var type = valuesWithType[0].type;
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    };
    return CanvasManager;
}();
var $413a30192b54574f$var$StylesheetManager = /*#__PURE__*/ function() {
    function StylesheetManager(options) {
        $413a30192b54574f$var$__publicField(this, "trackedLinkElements", /* @__PURE__ */ new WeakSet());
        $413a30192b54574f$var$__publicField(this, "mutationCb");
        $413a30192b54574f$var$__publicField(this, "adoptedStyleSheetCb");
        $413a30192b54574f$var$__publicField(this, "styleMirror", new $413a30192b54574f$var$StyleSheetMirror());
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    var _proto = StylesheetManager.prototype;
    _proto.attachLinkElement = function attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    };
    _proto.trackLinkElement = function trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    };
    _proto.adoptStyleSheets = function adoptStyleSheets(sheets, hostId) {
        var _this, _loop = function() {
            var sheet = _step.value;
            var styleId = void 0;
            if (!_this.styleMirror.has(sheet)) {
                styleId = _this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, function(r2, index2) {
                        return {
                            rule: $413a30192b54574f$var$stringifyRule(r2, sheet.href),
                            index: index2
                        };
                    })
                });
            } else styleId = _this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        };
        if (sheets.length === 0) return;
        var adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        var styles = [];
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(sheets), _step; !(_step = _iterator()).done;)_this = this, _loop();
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    };
    _proto.reset = function reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    };
    // TODO: take snapshot on stylesheet reload by applying event listener
    _proto.trackStylesheetInLinkElement = function trackStylesheetInLinkElement(_linkEl) {};
    return StylesheetManager;
}();
var $413a30192b54574f$var$ProcessedNodeManager = /*#__PURE__*/ function() {
    function ProcessedNodeManager() {
        $413a30192b54574f$var$__publicField(this, "nodeMap", /* @__PURE__ */ new WeakMap());
        $413a30192b54574f$var$__publicField(this, "active", false);
    }
    var _proto = ProcessedNodeManager.prototype;
    _proto.inOtherBuffer = function inOtherBuffer(node2, thisBuffer) {
        var buffers = this.nodeMap.get(node2);
        return buffers && Array.from(buffers).some(function(buffer) {
            return buffer !== thisBuffer;
        });
    };
    _proto.add = function add(node2, buffer) {
        var _this = this;
        if (!this.active) {
            this.active = true;
            requestAnimationFrame(function() {
                _this.nodeMap = /* @__PURE__ */ new WeakMap();
                _this.active = false;
            });
        }
        this.nodeMap.set(node2, (this.nodeMap.get(node2) || /* @__PURE__ */ new Set()).add(buffer));
    };
    _proto.destroy = function destroy() {};
    return ProcessedNodeManager;
}();
var $413a30192b54574f$var$wrappedEmit;
var $413a30192b54574f$var$takeFullSnapshot$1;
var $413a30192b54574f$var$canvasManager;
var $413a30192b54574f$var$recording = false;
try {
    if (Array.from([
        1
    ], function(x2) {
        return x2 * 2;
    })[0] !== 2) {
        var $413a30192b54574f$var$cleanFrame = document.createElement("iframe");
        document.body.appendChild($413a30192b54574f$var$cleanFrame);
        Array.from = (($413a30192b54574f$var$_a = $413a30192b54574f$var$cleanFrame.contentWindow) == null ? void 0 : $413a30192b54574f$var$_a.Array.from) || Array.from;
        document.body.removeChild($413a30192b54574f$var$cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
var $413a30192b54574f$var$mirror = $413a30192b54574f$var$createMirror$2();
function $413a30192b54574f$var$record(options) {
    if (options === void 0) options = {};
    var emit = options.emit, checkoutEveryNms = options.checkoutEveryNms, checkoutEveryNth = options.checkoutEveryNth, _options_blockClass = options.blockClass, blockClass = _options_blockClass === void 0 ? "rr-block" : _options_blockClass, _options_blockSelector = options.blockSelector, blockSelector = _options_blockSelector === void 0 ? null : _options_blockSelector, _options_ignoreClass = options.ignoreClass, ignoreClass = _options_ignoreClass === void 0 ? "rr-ignore" : _options_ignoreClass, _options_ignoreSelector = options.ignoreSelector, ignoreSelector = _options_ignoreSelector === void 0 ? null : _options_ignoreSelector, _options_maskTextClass = options.maskTextClass, maskTextClass = _options_maskTextClass === void 0 ? "rr-mask" : _options_maskTextClass, _options_maskTextSelector = options.maskTextSelector, maskTextSelector = _options_maskTextSelector === void 0 ? null : _options_maskTextSelector, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, maskAllInputs = options.maskAllInputs, _maskInputOptions = options.maskInputOptions, _slimDOMOptions = options.slimDOMOptions, maskInputFn = options.maskInputFn, maskTextFn = options.maskTextFn, hooks = options.hooks, packFn = options.packFn, _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? {} : _options_sampling, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, mousemoveWait = options.mousemoveWait, _options_recordDOM = options.recordDOM, recordDOM = _options_recordDOM === void 0 ? true : _options_recordDOM, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, _options_recordCrossOriginIframes = options.recordCrossOriginIframes, recordCrossOriginIframes = _options_recordCrossOriginIframes === void 0 ? false : _options_recordCrossOriginIframes, _options_recordAfter = options.recordAfter, recordAfter = _options_recordAfter === void 0 ? options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load" : _options_recordAfter, _options_userTriggeredOnInput = options.userTriggeredOnInput, userTriggeredOnInput = _options_userTriggeredOnInput === void 0 ? false : _options_userTriggeredOnInput, _options_collectFonts = options.collectFonts, collectFonts = _options_collectFonts === void 0 ? false : _options_collectFonts, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, plugins = options.plugins, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_ignoreCSSAttributes = options.ignoreCSSAttributes, ignoreCSSAttributes = _options_ignoreCSSAttributes === void 0 ? /* @__PURE__ */ new Set([]) : _options_ignoreCSSAttributes, errorHandler2 = options.errorHandler;
    $413a30192b54574f$var$registerErrorHandler(errorHandler2);
    var inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    var passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return function() {};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    $413a30192b54574f$var$mirror.reset();
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true,
        hidden: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {
        password: true
    };
    var slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all",
        headTitleMutations: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $413a30192b54574f$var$polyfill$1();
    var lastFullSnapshotEvent;
    var incrementalSnapshotCount = 0;
    var eventProcessor = function(e2) {
        for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(plugins || []), _step; !(_step = _iterator()).done;){
            var plugin3 = _step.value;
            if (plugin3.eventProcessor) e2 = plugin3.eventProcessor(e2);
        }
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    $413a30192b54574f$var$wrappedEmit = function(r2, isCheckout) {
        var _a2;
        var e2 = r2;
        e2.timestamp = $413a30192b54574f$var$nowTimestamp();
        if (((_a2 = $413a30192b54574f$var$mutationBuffers[0]) == null ? void 0 : _a2.isFrozen()) && e2.type !== $413a30192b54574f$var$EventType.FullSnapshot && !(e2.type === $413a30192b54574f$var$EventType.IncrementalSnapshot && e2.data.source === $413a30192b54574f$var$IncrementalSource.Mutation)) $413a30192b54574f$var$mutationBuffers.forEach(function(buf) {
            return buf.unfreeze();
        });
        if (inEmittingFrame) emit == null || emit(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            var message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === $413a30192b54574f$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === $413a30192b54574f$var$EventType.IncrementalSnapshot) {
            if (e2.data.source === $413a30192b54574f$var$IncrementalSource.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            var exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            var exceedTime = checkoutEveryNms && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) $413a30192b54574f$var$takeFullSnapshot$1(true);
        }
    };
    var wrappedMutationEmit = function(m) {
        $413a30192b54574f$var$wrappedEmit({
            type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
            data: $413a30192b54574f$var$_extends({
                source: $413a30192b54574f$var$IncrementalSource.Mutation
            }, m)
        });
    };
    var wrappedScrollEmit = function(p) {
        return $413a30192b54574f$var$wrappedEmit({
            type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
            data: $413a30192b54574f$var$_extends({
                source: $413a30192b54574f$var$IncrementalSource.Scroll
            }, p)
        });
    };
    var wrappedCanvasMutationEmit = function(p) {
        return $413a30192b54574f$var$wrappedEmit({
            type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
            data: $413a30192b54574f$var$_extends({
                source: $413a30192b54574f$var$IncrementalSource.CanvasMutation
            }, p)
        });
    };
    var wrappedAdoptedStyleSheetEmit = function(a2) {
        return $413a30192b54574f$var$wrappedEmit({
            type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
            data: $413a30192b54574f$var$_extends({
                source: $413a30192b54574f$var$IncrementalSource.AdoptedStyleSheet
            }, a2)
        });
    };
    var stylesheetManager = new $413a30192b54574f$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    var iframeManager = new $413a30192b54574f$var$IframeManager({
        mirror: $413a30192b54574f$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $413a30192b54574f$var$wrappedEmit
    });
    for(var _iterator = $413a30192b54574f$var$_create_for_of_iterator_helper_loose(plugins || []), _step; !(_step = _iterator()).done;){
        var plugin3 = _step.value;
        if (plugin3.getMirror) plugin3.getMirror({
            nodeMirror: $413a30192b54574f$var$mirror,
            crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
            crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
        });
    }
    var processedNodeManager = new $413a30192b54574f$var$ProcessedNodeManager();
    $413a30192b54574f$var$canvasManager = new $413a30192b54574f$var$CanvasManager({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        blockSelector: blockSelector,
        mirror: $413a30192b54574f$var$mirror,
        sampling: sampling.canvas,
        dataURLOptions: dataURLOptions
    });
    var shadowDomManager = new $413a30192b54574f$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: $413a30192b54574f$var$canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $413a30192b54574f$var$mirror
    });
    $413a30192b54574f$var$takeFullSnapshot$1 = function(isCheckout) {
        if (isCheckout === void 0) isCheckout = false;
        if (!recordDOM) return;
        $413a30192b54574f$var$wrappedEmit({
            type: $413a30192b54574f$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $413a30192b54574f$var$getWindowWidth(),
                height: $413a30192b54574f$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $413a30192b54574f$var$mutationBuffers.forEach(function(buf) {
            return buf.lock();
        });
        var node2 = $413a30192b54574f$var$snapshot(document, {
            mirror: $413a30192b54574f$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: function(n2) {
                if ($413a30192b54574f$var$isSerializedIframe(n2, $413a30192b54574f$var$mirror)) iframeManager.addIframe(n2);
                if ($413a30192b54574f$var$isSerializedStylesheet(n2, $413a30192b54574f$var$mirror)) stylesheetManager.trackLinkElement(n2);
                if ($413a30192b54574f$var$hasShadowRoot(n2)) shadowDomManager.addShadowRoot($413a30192b54574f$var$index.shadowRoot(n2), document);
            },
            onIframeLoad: function(iframe, childSn) {
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: function(linkEl, childSn) {
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node2) return console.warn("Failed to snapshot the document");
        $413a30192b54574f$var$wrappedEmit({
            type: $413a30192b54574f$var$EventType.FullSnapshot,
            data: {
                node: node2,
                initialOffset: $413a30192b54574f$var$getWindowScroll(window)
            }
        }, isCheckout);
        $413a30192b54574f$var$mutationBuffers.forEach(function(buf) {
            return buf.unlock();
        });
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $413a30192b54574f$var$mirror.getId(document));
    };
    try {
        var handlers = [];
        var observe = function(doc) {
            var _a2;
            return $413a30192b54574f$var$callbackWrapper($413a30192b54574f$var$initObservers)({
                mutationCb: wrappedMutationEmit,
                mousemoveCb: function(positions, source) {
                    return $413a30192b54574f$var$wrappedEmit({
                        type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    });
                },
                mouseInteractionCb: function(d) {
                    return $413a30192b54574f$var$wrappedEmit({
                        type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
                        data: $413a30192b54574f$var$_extends({
                            source: $413a30192b54574f$var$IncrementalSource.MouseInteraction
                        }, d)
                    });
                },
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: function(d) {
                    return $413a30192b54574f$var$wrappedEmit({
                        type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
                        data: $413a30192b54574f$var$_extends({
                            source: $413a30192b54574f$var$IncrementalSource.ViewportResize
                        }, d)
                    });
                },
                inputCb: function(v2) {
                    return $413a30192b54574f$var$wrappedEmit({
                        type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
                        data: $413a30192b54574f$var$_extends({
                            source: $413a30192b54574f$var$IncrementalSource.Input
                        }, v2)
                    });
                },
                mediaInteractionCb: function(p) {
                    return $413a30192b54574f$var$wrappedEmit({
                        type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
                        data: $413a30192b54574f$var$_extends({
                            source: $413a30192b54574f$var$IncrementalSource.MediaInteraction
                        }, p)
                    });
                },
                styleSheetRuleCb: function(r2) {
                    return $413a30192b54574f$var$wrappedEmit({
                        type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
                        data: $413a30192b54574f$var$_extends({
                            source: $413a30192b54574f$var$IncrementalSource.StyleSheetRule
                        }, r2)
                    });
                },
                styleDeclarationCb: function(r2) {
                    return $413a30192b54574f$var$wrappedEmit({
                        type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
                        data: $413a30192b54574f$var$_extends({
                            source: $413a30192b54574f$var$IncrementalSource.StyleDeclaration
                        }, r2)
                    });
                },
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: function(p) {
                    return $413a30192b54574f$var$wrappedEmit({
                        type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
                        data: $413a30192b54574f$var$_extends({
                            source: $413a30192b54574f$var$IncrementalSource.Font
                        }, p)
                    });
                },
                selectionCb: function(p) {
                    $413a30192b54574f$var$wrappedEmit({
                        type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
                        data: $413a30192b54574f$var$_extends({
                            source: $413a30192b54574f$var$IncrementalSource.Selection
                        }, p)
                    });
                },
                customElementCb: function(c2) {
                    $413a30192b54574f$var$wrappedEmit({
                        type: $413a30192b54574f$var$EventType.IncrementalSnapshot,
                        data: $413a30192b54574f$var$_extends({
                            source: $413a30192b54574f$var$IncrementalSource.CustomElement
                        }, c2)
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $413a30192b54574f$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: $413a30192b54574f$var$canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: ((_a2 = plugins == null ? void 0 : plugins.filter(function(p) {
                    return p.observer;
                })) == null ? void 0 : _a2.map(function(p) {
                    return {
                        observer: p.observer,
                        options: p.options,
                        callback: function(payload) {
                            return $413a30192b54574f$var$wrappedEmit({
                                type: $413a30192b54574f$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            });
                        }
                    };
                })) || []
            }, hooks);
        };
        iframeManager.addLoadListener(function(iframeEl) {
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        var init = function() {
            $413a30192b54574f$var$takeFullSnapshot$1();
            handlers.push(observe(document));
            $413a30192b54574f$var$recording = true;
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($413a30192b54574f$var$on("DOMContentLoaded", function() {
                $413a30192b54574f$var$wrappedEmit({
                    type: $413a30192b54574f$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($413a30192b54574f$var$on("load", function() {
                $413a30192b54574f$var$wrappedEmit({
                    type: $413a30192b54574f$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return function() {
            handlers.forEach(function(handler) {
                try {
                    handler();
                } catch (error) {
                    var msg = String(error).toLowerCase();
                    if (!msg.includes("cross-origin")) console.warn(error);
                }
            });
            processedNodeManager.destroy();
            $413a30192b54574f$var$recording = false;
            $413a30192b54574f$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
$413a30192b54574f$var$record.addCustomEvent = function(tag, payload) {
    if (!$413a30192b54574f$var$recording) throw new Error("please add custom event after start recording");
    $413a30192b54574f$var$wrappedEmit({
        type: $413a30192b54574f$var$EventType.Custom,
        data: {
            tag: tag,
            payload: payload
        }
    });
};
$413a30192b54574f$var$record.freezePage = function() {
    $413a30192b54574f$var$mutationBuffers.forEach(function(buf) {
        return buf.freeze();
    });
};
$413a30192b54574f$var$record.takeFullSnapshot = function(isCheckout) {
    if (!$413a30192b54574f$var$recording) throw new Error("please take full snapshot after start recording");
    $413a30192b54574f$var$takeFullSnapshot$1(isCheckout);
};
$413a30192b54574f$var$record.mirror = $413a30192b54574f$var$mirror;
var $413a30192b54574f$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($413a30192b54574f$var$n || ($413a30192b54574f$var$n = {}));
$413a30192b54574f$var$record.addCustomEvent;
$413a30192b54574f$var$record.freezePage;
$413a30192b54574f$var$record.takeFullSnapshot;
var $413a30192b54574f$var$setImmediate = $413a30192b54574f$var$win["setImmediate"];
var $413a30192b54574f$var$builtInProp, $413a30192b54574f$var$cycle, $413a30192b54574f$var$schedulingQueue, $413a30192b54574f$var$ToString = Object.prototype.toString, $413a30192b54574f$var$timer = typeof $413a30192b54574f$var$setImmediate !== "undefined" ? function timer(fn) {
    return $413a30192b54574f$var$setImmediate(fn);
} : setTimeout;
// dammit, IE8.
try {
    Object.defineProperty({}, "x", {});
    $413a30192b54574f$var$builtInProp = function builtInProp(obj, name, val, config) {
        return Object.defineProperty(obj, name, {
            value: val,
            writable: true,
            configurable: config !== false
        });
    };
} catch (err) {
    $413a30192b54574f$var$builtInProp = function builtInProp(obj, name, val) {
        obj[name] = val;
        return obj;
    };
}
// Note: using a queue instead of array for efficiency
$413a30192b54574f$var$schedulingQueue = function Queue() {
    var first, last, item;
    function Item(fn, self) {
        this.fn = fn;
        this.self = self;
        this.next = void 0;
    }
    return {
        add: function add(fn, self) {
            item = new Item(fn, self);
            if (last) last.next = item;
            else first = item;
            last = item;
            item = void 0;
        },
        drain: function drain() {
            var f = first;
            first = last = $413a30192b54574f$var$cycle = void 0;
            while(f){
                f.fn.call(f.self);
                f = f.next;
            }
        }
    };
}();
function $413a30192b54574f$var$schedule(fn, self) {
    $413a30192b54574f$var$schedulingQueue.add(fn, self);
    if (!$413a30192b54574f$var$cycle) $413a30192b54574f$var$cycle = $413a30192b54574f$var$timer($413a30192b54574f$var$schedulingQueue.drain);
}
// promise duck typing
function $413a30192b54574f$var$isThenable(o) {
    var _then, oType = typeof o;
    if (o !== null && (oType === "object" || oType === "function")) _then = o.then;
    return typeof _then === "function" ? _then : false;
}
function $413a30192b54574f$var$notify() {
    for(var i = 0; i < this.chain.length; i++)$413a30192b54574f$var$notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
    this.chain.length = 0;
}
// NOTE: This is a separate function to isolate
// the `try..catch` so that other code can be
// optimized better
function $413a30192b54574f$var$notifyIsolated(self, cb, chain) {
    var ret, _then;
    try {
        if (cb === false) chain.reject(self.msg);
        else {
            if (cb === true) ret = self.msg;
            else ret = cb.call(void 0, self.msg);
            if (ret === chain.promise) chain.reject(TypeError("Promise-chain cycle"));
            else if (_then = $413a30192b54574f$var$isThenable(ret)) _then.call(ret, chain.resolve, chain.reject);
            else chain.resolve(ret);
        }
    } catch (err) {
        chain.reject(err);
    }
}
function $413a30192b54574f$var$resolve(msg) {
    var _then, self = this;
    // already triggered?
    if (self.triggered) return;
    self.triggered = true;
    // unwrap
    if (self.def) self = self.def;
    try {
        // eslint-disable-next-line no-cond-assign
        if (_then = $413a30192b54574f$var$isThenable(msg)) $413a30192b54574f$var$schedule(function() {
            var defWrapper = new $413a30192b54574f$var$MakeDefWrapper(self);
            try {
                _then.call(msg, function $resolve$() {
                    $413a30192b54574f$var$resolve.apply(defWrapper, arguments);
                }, function $reject$() {
                    $413a30192b54574f$var$reject.apply(defWrapper, arguments);
                });
            } catch (err) {
                $413a30192b54574f$var$reject.call(defWrapper, err);
            }
        });
        else {
            self.msg = msg;
            self.state = 1;
            if (self.chain.length > 0) $413a30192b54574f$var$schedule($413a30192b54574f$var$notify, self);
        }
    } catch (err) {
        $413a30192b54574f$var$reject.call(new $413a30192b54574f$var$MakeDefWrapper(self), err);
    }
}
function $413a30192b54574f$var$reject(msg) {
    var self = this;
    // already triggered?
    if (self.triggered) return;
    self.triggered = true;
    // unwrap
    if (self.def) self = self.def;
    self.msg = msg;
    self.state = 2;
    if (self.chain.length > 0) $413a30192b54574f$var$schedule($413a30192b54574f$var$notify, self);
}
function $413a30192b54574f$var$iteratePromises(Constructor, arr, resolver, rejecter) {
    for(var idx = 0; idx < arr.length; idx++)(function IIFE(idx) {
        Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
            resolver(idx, msg);
        }, rejecter);
    })(idx);
}
function $413a30192b54574f$var$MakeDefWrapper(self) {
    this.def = self;
    this.triggered = false;
}
function $413a30192b54574f$var$MakeDef(self) {
    this.promise = self;
    this.state = 0;
    this.triggered = false;
    this.chain = [];
    this.msg = void 0;
}
function $413a30192b54574f$var$NpoPromise(executor) {
    if (typeof executor !== "function") throw TypeError("Not a function");
    if (this["__NPO__"] !== 0) throw TypeError("Not a promise");
    // instance shadowing the inherited "brand"
    // to signal an already "initialized" promise
    this["__NPO__"] = 1;
    var def = new $413a30192b54574f$var$MakeDef(this);
    this["then"] = function then(success, failure) {
        var o = {
            success: typeof success === "function" ? success : true,
            failure: typeof failure === "function" ? failure : false
        };
        // Note: `then(..)` itself can be borrowed to be used against
        // a different promise constructor for making the chained promise,
        // by substituting a different `this` binding.
        o.promise = new this.constructor(function extractChain(resolve, reject) {
            if (typeof resolve !== "function" || typeof reject !== "function") throw TypeError("Not a function");
            o.resolve = resolve;
            o.reject = reject;
        });
        def.chain.push(o);
        if (def.state !== 0) $413a30192b54574f$var$schedule($413a30192b54574f$var$notify, def);
        return o.promise;
    };
    this["catch"] = function $catch$(failure) {
        return this.then(void 0, failure);
    };
    try {
        executor.call(void 0, function publicResolve(msg) {
            $413a30192b54574f$var$resolve.call(def, msg);
        }, function publicReject(msg) {
            $413a30192b54574f$var$reject.call(def, msg);
        });
    } catch (err) {
        $413a30192b54574f$var$reject.call(def, err);
    }
}
var $413a30192b54574f$var$PromisePrototype = $413a30192b54574f$var$builtInProp({}, "constructor", $413a30192b54574f$var$NpoPromise, /*configurable=*/ false);
// Note: Android 4 cannot use `Object.defineProperty(..)` here
$413a30192b54574f$var$NpoPromise.prototype = $413a30192b54574f$var$PromisePrototype;
// built-in "brand" to signal an "uninitialized" promise
$413a30192b54574f$var$builtInProp($413a30192b54574f$var$PromisePrototype, "__NPO__", 0, /*configurable=*/ false);
$413a30192b54574f$var$builtInProp($413a30192b54574f$var$NpoPromise, "resolve", function Promise$resolve(msg) {
    var Constructor = this;
    // spec mandated checks
    // note: best "isPromise" check that's practical for now
    if (msg && typeof msg === "object" && msg["__NPO__"] === 1) return msg;
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== "function" || typeof reject !== "function") throw TypeError("Not a function");
        resolve(msg);
    });
});
$413a30192b54574f$var$builtInProp($413a30192b54574f$var$NpoPromise, "reject", function Promise$reject(msg) {
    return new this(function executor(resolve, reject) {
        if (typeof resolve !== "function" || typeof reject !== "function") throw TypeError("Not a function");
        reject(msg);
    });
});
$413a30192b54574f$var$builtInProp($413a30192b54574f$var$NpoPromise, "all", function Promise$all(arr) {
    var Constructor = this;
    // spec mandated checks
    if ($413a30192b54574f$var$ToString.call(arr) !== "[object Array]") return Constructor.reject(TypeError("Not an array"));
    if (arr.length === 0) return Constructor.resolve([]);
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== "function" || typeof reject !== "function") throw TypeError("Not a function");
        var len = arr.length, msgs = Array(len), count = 0;
        $413a30192b54574f$var$iteratePromises(Constructor, arr, function resolver(idx, msg) {
            msgs[idx] = msg;
            if (++count === len) resolve(msgs);
        }, reject);
    });
});
$413a30192b54574f$var$builtInProp($413a30192b54574f$var$NpoPromise, "race", function Promise$race(arr) {
    var Constructor = this;
    // spec mandated checks
    if ($413a30192b54574f$var$ToString.call(arr) !== "[object Array]") return Constructor.reject(TypeError("Not an array"));
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== "function" || typeof reject !== "function") throw TypeError("Not a function");
        $413a30192b54574f$var$iteratePromises(Constructor, arr, function resolver(idx, msg) {
            resolve(msg);
        }, reject);
    });
});
var $413a30192b54574f$var$PromisePolyfill;
if (typeof Promise !== "undefined" && Promise.toString().indexOf("[native code]") !== -1) $413a30192b54574f$var$PromisePolyfill = Promise;
else $413a30192b54574f$var$PromisePolyfill = $413a30192b54574f$var$NpoPromise;
var $413a30192b54574f$var$Config = {
    DEBUG: false,
    LIB_VERSION: "2.71.1"
};
/* eslint camelcase: "off", eqeqeq: "off" */ // Maximum allowed session recording length
var $413a30192b54574f$var$MAX_RECORDING_MS = 86400000; // 24 hours
// Maximum allowed value for minimum session recording length
var $413a30192b54574f$var$MAX_VALUE_FOR_MIN_RECORDING_MS = 8000; // 8 seconds
/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */ var $413a30192b54574f$var$ArrayProto = Array.prototype, $413a30192b54574f$var$FuncProto = Function.prototype, $413a30192b54574f$var$ObjProto = Object.prototype, $413a30192b54574f$var$slice = $413a30192b54574f$var$ArrayProto.slice, $413a30192b54574f$var$toString = $413a30192b54574f$var$ObjProto.toString, $413a30192b54574f$var$hasOwnProperty = $413a30192b54574f$var$ObjProto.hasOwnProperty, $413a30192b54574f$var$windowConsole = $413a30192b54574f$var$win.console, $413a30192b54574f$var$navigator = $413a30192b54574f$var$win.navigator, $413a30192b54574f$var$document$1 = $413a30192b54574f$var$win.document, $413a30192b54574f$var$windowOpera = $413a30192b54574f$var$win.opera, $413a30192b54574f$var$screen = $413a30192b54574f$var$win.screen, $413a30192b54574f$var$userAgent = $413a30192b54574f$var$navigator.userAgent;
var $413a30192b54574f$var$nativeBind = $413a30192b54574f$var$FuncProto.bind, $413a30192b54574f$var$nativeForEach = $413a30192b54574f$var$ArrayProto.forEach, $413a30192b54574f$var$nativeIndexOf = $413a30192b54574f$var$ArrayProto.indexOf, $413a30192b54574f$var$nativeMap = $413a30192b54574f$var$ArrayProto.map, $413a30192b54574f$var$nativeIsArray = Array.isArray, $413a30192b54574f$var$breaker = {};
var $413a30192b54574f$var$_ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    }
};
// Console override
var $413a30192b54574f$var$console$1 = {
    /** @type {function(...*)} */ log: function() {
        if ($413a30192b54574f$var$Config.DEBUG && !$413a30192b54574f$var$_.isUndefined($413a30192b54574f$var$windowConsole) && $413a30192b54574f$var$windowConsole) try {
            $413a30192b54574f$var$windowConsole.log.apply($413a30192b54574f$var$windowConsole, arguments);
        } catch (err) {
            $413a30192b54574f$var$_.each(arguments, function(arg) {
                $413a30192b54574f$var$windowConsole.log(arg);
            });
        }
    },
    /** @type {function(...*)} */ warn: function() {
        if ($413a30192b54574f$var$Config.DEBUG && !$413a30192b54574f$var$_.isUndefined($413a30192b54574f$var$windowConsole) && $413a30192b54574f$var$windowConsole) {
            var args = [
                "Mixpanel warning:"
            ].concat($413a30192b54574f$var$_.toArray(arguments));
            try {
                $413a30192b54574f$var$windowConsole.warn.apply($413a30192b54574f$var$windowConsole, args);
            } catch (err) {
                $413a30192b54574f$var$_.each(args, function(arg) {
                    $413a30192b54574f$var$windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ error: function() {
        if ($413a30192b54574f$var$Config.DEBUG && !$413a30192b54574f$var$_.isUndefined($413a30192b54574f$var$windowConsole) && $413a30192b54574f$var$windowConsole) {
            var args = [
                "Mixpanel error:"
            ].concat($413a30192b54574f$var$_.toArray(arguments));
            try {
                $413a30192b54574f$var$windowConsole.error.apply($413a30192b54574f$var$windowConsole, args);
            } catch (err) {
                $413a30192b54574f$var$_.each(args, function(arg) {
                    $413a30192b54574f$var$windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ critical: function() {
        if (!$413a30192b54574f$var$_.isUndefined($413a30192b54574f$var$windowConsole) && $413a30192b54574f$var$windowConsole) {
            var args = [
                "Mixpanel error:"
            ].concat($413a30192b54574f$var$_.toArray(arguments));
            try {
                $413a30192b54574f$var$windowConsole.error.apply($413a30192b54574f$var$windowConsole, args);
            } catch (err) {
                $413a30192b54574f$var$_.each(args, function(arg) {
                    $413a30192b54574f$var$windowConsole.error(arg);
                });
            }
        }
    }
};
var $413a30192b54574f$var$log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = "[" + prefix + "] " + arguments[0];
        return func.apply($413a30192b54574f$var$console$1, arguments);
    };
};
var $413a30192b54574f$var$console_with_prefix = function(prefix) {
    return {
        log: $413a30192b54574f$var$log_func_with_prefix($413a30192b54574f$var$console$1.log, prefix),
        error: $413a30192b54574f$var$log_func_with_prefix($413a30192b54574f$var$console$1.error, prefix),
        critical: $413a30192b54574f$var$log_func_with_prefix($413a30192b54574f$var$console$1.critical, prefix)
    };
};
var $413a30192b54574f$var$safewrap = function(f) {
    return function() {
        try {
            return f.apply(this, arguments);
        } catch (e) {
            $413a30192b54574f$var$console$1.critical("Implementation error. Please turn on debug and contact support@mixpanel.com.");
            if ($413a30192b54574f$var$Config.DEBUG) $413a30192b54574f$var$console$1.critical(e);
        }
    };
};
var $413a30192b54574f$var$safewrapClass = function(klass) {
    var proto = klass.prototype;
    for(var func in proto)if (typeof proto[func] === "function") proto[func] = $413a30192b54574f$var$safewrap(proto[func]);
};
// UNDERSCORE
// Embed part of the Underscore Library
$413a30192b54574f$var$_.bind = function(func, context) {
    var args, bound;
    if ($413a30192b54574f$var$nativeBind && func.bind === $413a30192b54574f$var$nativeBind) return $413a30192b54574f$var$nativeBind.apply(func, $413a30192b54574f$var$slice.call(arguments, 1));
    if (!$413a30192b54574f$var$_.isFunction(func)) throw new TypeError();
    args = $413a30192b54574f$var$slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) return func.apply(context, args.concat($413a30192b54574f$var$slice.call(arguments)));
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat($413a30192b54574f$var$slice.call(arguments)));
        if (Object(result) === result) return result;
        return self;
    };
    return bound;
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */ $413a30192b54574f$var$_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) return;
    if ($413a30192b54574f$var$nativeForEach && obj.forEach === $413a30192b54574f$var$nativeForEach) obj.forEach(iterator, context);
    else if (obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(context, obj[i], i, obj) === $413a30192b54574f$var$breaker) return;
    }
    else {
        for(var key in obj)if ($413a30192b54574f$var$hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === $413a30192b54574f$var$breaker) return;
        }
    }
};
$413a30192b54574f$var$_.extend = function(obj) {
    $413a30192b54574f$var$_.each($413a30192b54574f$var$slice.call(arguments, 1), function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
$413a30192b54574f$var$_.isArray = $413a30192b54574f$var$nativeIsArray || function(obj) {
    return $413a30192b54574f$var$toString.call(obj) === "[object Array]";
};
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
$413a30192b54574f$var$_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
$413a30192b54574f$var$_.isArguments = function(obj) {
    return !!(obj && $413a30192b54574f$var$hasOwnProperty.call(obj, "callee"));
};
$413a30192b54574f$var$_.toArray = function(iterable) {
    if (!iterable) return [];
    if (iterable.toArray) return iterable.toArray();
    if ($413a30192b54574f$var$_.isArray(iterable)) return $413a30192b54574f$var$slice.call(iterable);
    if ($413a30192b54574f$var$_.isArguments(iterable)) return $413a30192b54574f$var$slice.call(iterable);
    return $413a30192b54574f$var$_.values(iterable);
};
$413a30192b54574f$var$_.map = function(arr, callback, context) {
    if ($413a30192b54574f$var$nativeMap && arr.map === $413a30192b54574f$var$nativeMap) return arr.map(callback, context);
    else {
        var results = [];
        $413a30192b54574f$var$_.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};
$413a30192b54574f$var$_.keys = function(obj) {
    var results = [];
    if (obj === null) return results;
    $413a30192b54574f$var$_.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};
$413a30192b54574f$var$_.values = function(obj) {
    var results = [];
    if (obj === null) return results;
    $413a30192b54574f$var$_.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};
$413a30192b54574f$var$_.include = function(obj, target) {
    var found = false;
    if (obj === null) return found;
    if ($413a30192b54574f$var$nativeIndexOf && obj.indexOf === $413a30192b54574f$var$nativeIndexOf) return obj.indexOf(target) != -1;
    $413a30192b54574f$var$_.each(obj, function(value) {
        if (found || (found = value === target)) return $413a30192b54574f$var$breaker;
    });
    return found;
};
$413a30192b54574f$var$_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};
// Underscore Addons
$413a30192b54574f$var$_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};
$413a30192b54574f$var$_.isObject = function(obj) {
    return obj === Object(obj) && !$413a30192b54574f$var$_.isArray(obj);
};
$413a30192b54574f$var$_.isEmptyObject = function(obj) {
    if ($413a30192b54574f$var$_.isObject(obj)) {
        for(var key in obj){
            if ($413a30192b54574f$var$hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    return false;
};
$413a30192b54574f$var$_.isUndefined = function(obj) {
    return obj === void 0;
};
$413a30192b54574f$var$_.isString = function(obj) {
    return $413a30192b54574f$var$toString.call(obj) == "[object String]";
};
$413a30192b54574f$var$_.isDate = function(obj) {
    return $413a30192b54574f$var$toString.call(obj) == "[object Date]";
};
$413a30192b54574f$var$_.isNumber = function(obj) {
    return $413a30192b54574f$var$toString.call(obj) == "[object Number]";
};
$413a30192b54574f$var$_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};
$413a30192b54574f$var$_.encodeDates = function(obj) {
    $413a30192b54574f$var$_.each(obj, function(v, k) {
        if ($413a30192b54574f$var$_.isDate(v)) obj[k] = $413a30192b54574f$var$_.formatDate(v);
        else if ($413a30192b54574f$var$_.isObject(v)) obj[k] = $413a30192b54574f$var$_.encodeDates(v); // recurse
    });
    return obj;
};
$413a30192b54574f$var$_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};
$413a30192b54574f$var$_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? "0" + n : n;
    }
    return d.getUTCFullYear() + "-" + pad(d.getUTCMonth() + 1) + "-" + pad(d.getUTCDate()) + "T" + pad(d.getUTCHours()) + ":" + pad(d.getUTCMinutes()) + ":" + pad(d.getUTCSeconds());
};
$413a30192b54574f$var$_.strip_empty_properties = function(p) {
    var ret = {};
    $413a30192b54574f$var$_.each(p, function(v, k) {
        if ($413a30192b54574f$var$_.isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */ $413a30192b54574f$var$_.truncate = function(obj, length) {
    var ret;
    if (typeof obj === "string") ret = obj.slice(0, length);
    else if ($413a30192b54574f$var$_.isArray(obj)) {
        ret = [];
        $413a30192b54574f$var$_.each(obj, function(val) {
            ret.push($413a30192b54574f$var$_.truncate(val, length));
        });
    } else if ($413a30192b54574f$var$_.isObject(obj)) {
        ret = {};
        $413a30192b54574f$var$_.each(obj, function(val, key) {
            ret[key] = $413a30192b54574f$var$_.truncate(val, length);
        });
    } else ret = obj;
    return ret;
};
$413a30192b54574f$var$_.JSONEncode = function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = {
                "\b": "\\b",
                "	": "\\t",
                "\n": "\\n",
                "\f": "\\f",
                "\r": "\\r",
                '"': '\\"',
                "\\": "\\\\"
            };
            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };
        var str = function(key, holder) {
            var gap = "";
            var indent = "    ";
            var i = 0; // The loop counter.
            var k = ""; // The member key.
            var v = ""; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];
            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === "object" && typeof value.toJSON === "function") value = value.toJSON(key);
            // What happens next depends on the value's type.
            switch(typeof value){
                case "string":
                    return quote(value);
                case "number":
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : "null";
                case "boolean":
                case "null":
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.
                    return String(value);
                case "object":
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) return "null";
                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];
                    // Is the value an array?
                    if ($413a30192b54574f$var$toString.apply(value) === "[object Array]") {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.
                        length = value.length;
                        for(i = 0; i < length; i += 1)partial[i] = str(i, value) || "null";
                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                        gap = mind;
                        return v;
                    }
                    // Iterate through all of the keys in the object.
                    for(k in value)if ($413a30192b54574f$var$hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? "{}" : gap ? "{" + partial.join(",") + "" + mind + "}" : "{" + partial.join(",") + "}";
                    gap = mind;
                    return v;
            }
        };
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str("", {
            "": value
        });
    };
}();
/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */ $413a30192b54574f$var$_.JSONDecode = function() {
    var at, ch, escapee = {
        '"': '"',
        "\\": "\\",
        "/": "/",
        "b": "\b",
        "f": "\f",
        "n": "\n",
        "r": "\r",
        "t": "	"
    }, text, error = function(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error("Expected '" + c + "' instead of '" + ch + "'");
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = "";
        if (ch === "-") {
            string = "-";
            next("-");
        }
        while(ch >= "0" && ch <= "9"){
            string += ch;
            next();
        }
        if (ch === ".") {
            string += ".";
            while(next() && ch >= "0" && ch <= "9")string += ch;
        }
        if (ch === "e" || ch === "E") {
            string += ch;
            next();
            if (ch === "-" || ch === "+") {
                string += ch;
                next();
            }
            while(ch >= "0" && ch <= "9"){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error("Bad number");
        else return number;
    }, string = function() {
        // Parse a string value.
        var hex, i, string = "", uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') while(next()){
            if (ch === '"') {
                next();
                return string;
            }
            if (ch === "\\") {
                next();
                if (ch === "u") {
                    uffff = 0;
                    for(i = 0; i < 4; i += 1){
                        hex = parseInt(next(), 16);
                        if (!isFinite(hex)) break;
                        uffff = uffff * 16 + hex;
                    }
                    string += String.fromCharCode(uffff);
                } else if (typeof escapee[ch] === "string") string += escapee[ch];
                else break;
            } else string += ch;
        }
        error("Bad string");
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= " ")next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case "t":
                next("t");
                next("r");
                next("u");
                next("e");
                return true;
            case "f":
                next("f");
                next("a");
                next("l");
                next("s");
                next("e");
                return false;
            case "n":
                next("n");
                next("u");
                next("l");
                next("l");
                return null;
        }
        error('Unexpected "' + ch + '"');
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === "[") {
            next("[");
            white();
            if (ch === "]") {
                next("]");
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === "]") {
                    next("]");
                    return array;
                }
                next(",");
                white();
            }
        }
        error("Bad array");
    }, object = function() {
        // Parse an object value.
        var key, object = {};
        if (ch === "{") {
            next("{");
            white();
            if (ch === "}") {
                next("}");
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(":");
                if (Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                object[key] = value();
                white();
                if (ch === "}") {
                    next("}");
                    return object;
                }
                next(",");
                white();
            }
        }
        error("Bad object");
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch(ch){
            case "{":
                return object();
            case "[":
                return array();
            case '"':
                return string();
            case "-":
                return number();
            default:
                return ch >= "0" && ch <= "9" ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;
        text = source;
        at = 0;
        ch = " ";
        result = value();
        white();
        if (ch) error("Syntax error");
        return result;
    };
}();
$413a30192b54574f$var$_.base64Encode = function(data) {
    var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = "", tmp_arr = [];
    if (!data) return data;
    data = $413a30192b54574f$var$_.utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    }while (i < data.length);
    enc = tmp_arr.join("");
    switch(data.length % 3){
        case 1:
            enc = enc.slice(0, -2) + "==";
            break;
        case 2:
            enc = enc.slice(0, -1) + "=";
            break;
    }
    return enc;
};
$413a30192b54574f$var$_.utf8Encode = function(string) {
    string = (string + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    var utftext = "", start, end;
    var stringl = 0, n;
    start = end = 0;
    stringl = string.length;
    for(n = 0; n < stringl; n++){
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) end++;
        else if (c1 > 127 && c1 < 2048) enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        else enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        if (enc !== null) {
            if (end > start) utftext += string.substring(start, end);
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) utftext += string.substring(start, string.length);
    return utftext;
};
$413a30192b54574f$var$_.UUID = function() {
    try {
        // use native Crypto API when available
        return $413a30192b54574f$var$win["crypto"]["randomUUID"]();
    } catch (err) {
        // fall back to generating our own UUID
        // based on https://gist.github.com/scwood/3bff42cc005cc20ab7ec98f0d8e1d59d
        var uuid = new Array(36);
        for(var i = 0; i < 36; i++)uuid[i] = Math.floor(Math.random() * 16);
        uuid[14] = 4; // set bits 12-15 of time-high-and-version to 0100
        uuid[19] = uuid[19] &= -5; // set bit 6 of clock-seq-and-reserved to zero
        uuid[19] = uuid[19] |= 8; // set bit 7 of clock-seq-and-reserved to one
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
        return $413a30192b54574f$var$_.map(uuid, function(x) {
            return x.toString(16);
        }).join("");
    }
};
// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var $413a30192b54574f$var$BLOCKED_UA_STRS = [
    "ahrefsbot",
    "ahrefssiteaudit",
    "amazonbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "facebookexternal",
    "petalbot",
    "pinterest",
    "screaming frog",
    "yahoo! slurp",
    "yandex",
    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google"
];
$413a30192b54574f$var$_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for(i = 0; i < $413a30192b54574f$var$BLOCKED_UA_STRS.length; i++){
        if (ua.indexOf($413a30192b54574f$var$BLOCKED_UA_STRS[i]) !== -1) return true;
    }
    return false;
};
/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */ $413a30192b54574f$var$_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];
    if ($413a30192b54574f$var$_.isUndefined(arg_separator)) arg_separator = "&";
    $413a30192b54574f$var$_.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + "=" + use_val;
    });
    return tmp_arr.join(arg_separator);
};
$413a30192b54574f$var$_.getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/g, "\\[").replace(/[\]]/g, "\\]");
    var regexS = "[\\?&]" + param + "=([^&#]*)", regex = new RegExp(regexS), results = regex.exec(url);
    if (results === null || results && typeof results[1] !== "string" && results[1].length) return "";
    else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch (err) {
            $413a30192b54574f$var$console$1.error("Skipping decoding for malformed query param: " + result);
        }
        return result.replace(/\+/g, " ");
    }
};
// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
$413a30192b54574f$var$_.cookie = {
    get: function(name) {
        var nameEQ = name + "=";
        var ca = $413a30192b54574f$var$document$1.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    parse: function(name) {
        var cookie;
        try {
            cookie = $413a30192b54574f$var$_.JSONDecode($413a30192b54574f$var$_.cookie.get(name)) || {};
        } catch (err) {
        // noop
        }
        return cookie;
    },
    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = "", expires = "", secure = "";
        if (domain_override) cdomain = "; domain=" + domain_override;
        else if (is_cross_subdomain) {
            var domain = $413a30192b54574f$var$extract_domain($413a30192b54574f$var$document$1.location.hostname);
            cdomain = domain ? "; domain=." + domain : "";
        }
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = "; expires=" + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = "; SameSite=None";
        }
        if (is_secure) secure += "; secure";
        $413a30192b54574f$var$document$1.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/" + cdomain + secure;
    },
    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = "", expires = "", secure = "";
        if (domain_override) cdomain = "; domain=" + domain_override;
        else if (is_cross_subdomain) {
            var domain = $413a30192b54574f$var$extract_domain($413a30192b54574f$var$document$1.location.hostname);
            cdomain = domain ? "; domain=." + domain : "";
        }
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = "; expires=" + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = "; SameSite=None";
        }
        if (is_secure) secure += "; secure";
        var new_cookie_val = name + "=" + encodeURIComponent(value) + expires + "; path=/" + cdomain + secure;
        $413a30192b54574f$var$document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },
    remove: function(name, is_cross_subdomain, domain_override) {
        $413a30192b54574f$var$_.cookie.set(name, "", -1, is_cross_subdomain, false, false, domain_override);
    }
};
var $413a30192b54574f$var$_testStorageSupported = function(storage) {
    var supported = true;
    try {
        var key = "__mplss_" + $413a30192b54574f$var$cheap_guid(8), val = "xyz";
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) supported = false;
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }
    return supported;
};
var $413a30192b54574f$var$_localStorageSupported = null;
var $413a30192b54574f$var$localStorageSupported = function(storage, forceCheck) {
    if ($413a30192b54574f$var$_localStorageSupported !== null && !forceCheck) return $413a30192b54574f$var$_localStorageSupported;
    return $413a30192b54574f$var$_localStorageSupported = $413a30192b54574f$var$_testStorageSupported(storage || $413a30192b54574f$var$win.localStorage);
};
var $413a30192b54574f$var$_sessionStorageSupported = null;
var $413a30192b54574f$var$sessionStorageSupported = function(storage, forceCheck) {
    if ($413a30192b54574f$var$_sessionStorageSupported !== null && !forceCheck) return $413a30192b54574f$var$_sessionStorageSupported;
    return $413a30192b54574f$var$_sessionStorageSupported = $413a30192b54574f$var$_testStorageSupported(storage || $413a30192b54574f$var$win.sessionStorage);
};
function $413a30192b54574f$var$_storageWrapper(storage, name, is_supported_fn) {
    var log_error = function(msg) {
        $413a30192b54574f$var$console$1.error(name + " error: " + msg);
    };
    return {
        is_supported: function(forceCheck) {
            var supported = is_supported_fn(storage, forceCheck);
            if (!supported) $413a30192b54574f$var$console$1.error(name + " unsupported");
            return supported;
        },
        error: log_error,
        get: function(key) {
            try {
                return storage.getItem(key);
            } catch (err) {
                log_error(err);
            }
            return null;
        },
        parse: function(key) {
            try {
                return $413a30192b54574f$var$_.JSONDecode(storage.getItem(key)) || {};
            } catch (err) {
            // noop
            }
            return null;
        },
        set: function(key, value) {
            try {
                storage.setItem(key, value);
            } catch (err) {
                log_error(err);
            }
        },
        remove: function(key) {
            try {
                storage.removeItem(key);
            } catch (err) {
                log_error(err);
            }
        }
    };
}
$413a30192b54574f$var$_.localStorage = $413a30192b54574f$var$_storageWrapper($413a30192b54574f$var$win.localStorage, "localStorage", $413a30192b54574f$var$localStorageSupported);
$413a30192b54574f$var$_.sessionStorage = $413a30192b54574f$var$_storageWrapper($413a30192b54574f$var$win.sessionStorage, "sessionStorage", $413a30192b54574f$var$sessionStorageSupported);
$413a30192b54574f$var$_.register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            $413a30192b54574f$var$console$1.error("No valid element provided to register_event");
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = "on" + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent($413a30192b54574f$var$win.event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result, new_result;
            if ($413a30192b54574f$var$_.isFunction(old_handlers)) old_result = old_handlers(event);
            new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
        return handler;
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var $413a30192b54574f$var$TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
$413a30192b54574f$var$_.dom_query = function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */ function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName("*");
    }
    var bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
        var className = " " + selector + " ";
        return (" " + elem.className + " ").replace(bad_whitespace, " ").indexOf(className) >= 0;
    }
    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!$413a30192b54574f$var$document$1.getElementsByTagName) return [];
        // Split selector in to tokens
        var tokens = selector.split(" ");
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [
            $413a30192b54574f$var$document$1
        ];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i].replace(/^\s+/, "").replace(/\s+$/, "");
            if (token.indexOf("#") > -1) {
                // Token is an ID selector
                bits = token.split("#");
                tagName = bits[0];
                var id = bits[1];
                var element = $413a30192b54574f$var$document$1.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) // element not found or tag with that ID not found, return false
                return [];
                // Set currentContext to contain just this element
                currentContext = [
                    element
                ];
                continue; // Skip to next token
            }
            if (token.indexOf(".") > -1) {
                // Token contains a class selector
                bits = token.split(".");
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) tagName = "*";
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == "*") elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (found[j].className && $413a30192b54574f$var$_.isString(found[j].className) && // some SVG elements have classNames which are not strings
                hasClass(found[j], className)) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match($413a30192b54574f$var$TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) tagName = "*";
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == "*") elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch(attrOperator){
                    case "=":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case "~":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp("\\b" + attrValue + "\\b"));
                        };
                        break;
                    case "|":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp("^" + attrValue + "-?"));
                        };
                        break;
                    case "^":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case "$":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case "*":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (checkFunction(found[j])) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for(j = 0; j < currentContext.length; j++){
                elements = currentContext[j].getElementsByTagName(tagName);
                for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
            }
            currentContext = found;
        }
        return currentContext;
    }
    return function(query) {
        if ($413a30192b54574f$var$_.isElement(query)) return [
            query
        ];
        else if ($413a30192b54574f$var$_.isObject(query) && !$413a30192b54574f$var$_.isUndefined(query.length)) return query;
        else return getElementsBySelector.call(this, query);
    };
}();
var $413a30192b54574f$var$CAMPAIGN_KEYWORDS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "utm_id",
    "utm_source_platform",
    "utm_campaign_id",
    "utm_creative_format",
    "utm_marketing_tactic"
];
var $413a30192b54574f$var$CLICK_IDS = [
    "dclid",
    "fbclid",
    "gclid",
    "ko_click_id",
    "li_fat_id",
    "msclkid",
    "sccid",
    "ttclid",
    "twclid",
    "wbraid"
];
$413a30192b54574f$var$_.info = {
    campaignParams: function(default_value) {
        var kw = "", params = {};
        $413a30192b54574f$var$_.each($413a30192b54574f$var$CAMPAIGN_KEYWORDS, function(kwkey) {
            kw = $413a30192b54574f$var$_.getQueryParam($413a30192b54574f$var$document$1.URL, kwkey);
            if (kw.length) params[kwkey] = kw;
            else if (default_value !== undefined) params[kwkey] = default_value;
        });
        return params;
    },
    clickParams: function() {
        var id = "", params = {};
        $413a30192b54574f$var$_.each($413a30192b54574f$var$CLICK_IDS, function(idkey) {
            id = $413a30192b54574f$var$_.getQueryParam($413a30192b54574f$var$document$1.URL, idkey);
            if (id.length) params[idkey] = id;
        });
        return params;
    },
    marketingParams: function() {
        return $413a30192b54574f$var$_.extend($413a30192b54574f$var$_.info.campaignParams(), $413a30192b54574f$var$_.info.clickParams());
    },
    searchEngine: function(referrer) {
        if (referrer.search("https?://(.*)google.([^/?]*)") === 0) return "google";
        else if (referrer.search("https?://(.*)bing.com") === 0) return "bing";
        else if (referrer.search("https?://(.*)yahoo.com") === 0) return "yahoo";
        else if (referrer.search("https?://(.*)duckduckgo.com") === 0) return "duckduckgo";
        else return null;
    },
    searchInfo: function(referrer) {
        var search = $413a30192b54574f$var$_.info.searchEngine(referrer), param = search != "yahoo" ? "q" : "p", ret = {};
        if (search !== null) {
            ret["$search_engine"] = search;
            var keyword = $413a30192b54574f$var$_.getQueryParam(referrer, param);
            if (keyword.length) ret["mp_keyword"] = keyword;
        }
        return ret;
    },
    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */ browser: function(user_agent, vendor, opera) {
        vendor = vendor || ""; // vendor is undefined for at least IE9
        if (opera || $413a30192b54574f$var$_.includes(user_agent, " OPR/")) {
            if ($413a30192b54574f$var$_.includes(user_agent, "Mini")) return "Opera Mini";
            return "Opera";
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return "BlackBerry";
        else if ($413a30192b54574f$var$_.includes(user_agent, "IEMobile") || $413a30192b54574f$var$_.includes(user_agent, "WPDesktop")) return "Internet Explorer Mobile";
        else if ($413a30192b54574f$var$_.includes(user_agent, "SamsungBrowser/")) // https://developer.samsung.com/internet/user-agent-string-format
        return "Samsung Internet";
        else if ($413a30192b54574f$var$_.includes(user_agent, "Edge") || $413a30192b54574f$var$_.includes(user_agent, "Edg/")) return "Microsoft Edge";
        else if ($413a30192b54574f$var$_.includes(user_agent, "FBIOS")) return "Facebook Mobile";
        else if ($413a30192b54574f$var$_.includes(user_agent, "Whale/")) // https://user-agents.net/browsers/whale-browser
        return "Whale Browser";
        else if ($413a30192b54574f$var$_.includes(user_agent, "Chrome")) return "Chrome";
        else if ($413a30192b54574f$var$_.includes(user_agent, "CriOS")) return "Chrome iOS";
        else if ($413a30192b54574f$var$_.includes(user_agent, "UCWEB") || $413a30192b54574f$var$_.includes(user_agent, "UCBrowser")) return "UC Browser";
        else if ($413a30192b54574f$var$_.includes(user_agent, "FxiOS")) return "Firefox iOS";
        else if ($413a30192b54574f$var$_.includes(vendor, "Apple")) {
            if ($413a30192b54574f$var$_.includes(user_agent, "Mobile")) return "Mobile Safari";
            return "Safari";
        } else if ($413a30192b54574f$var$_.includes(user_agent, "Android")) return "Android Mobile";
        else if ($413a30192b54574f$var$_.includes(user_agent, "Konqueror")) return "Konqueror";
        else if ($413a30192b54574f$var$_.includes(user_agent, "Firefox")) return "Firefox";
        else if ($413a30192b54574f$var$_.includes(user_agent, "MSIE") || $413a30192b54574f$var$_.includes(user_agent, "Trident/")) return "Internet Explorer";
        else if ($413a30192b54574f$var$_.includes(user_agent, "Gecko")) return "Mozilla";
        else return "";
    },
    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */ browserVersion: function(userAgent, vendor, opera) {
        var browser = $413a30192b54574f$var$_.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
            "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
            "Chrome": /Chrome\/(\d+(\.\d+)?)/,
            "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
            "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            "Safari": /Version\/(\d+(\.\d+)?)/,
            "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
            "Opera": /(Opera|OPR)\/(\d+(\.\d+)?)/,
            "Firefox": /Firefox\/(\d+(\.\d+)?)/,
            "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
            "Konqueror": /Konqueror:(\d+(\.\d+)?)/,
            "BlackBerry": /BlackBerry (\d+(\.\d+)?)/,
            "Android Mobile": /android\s(\d+(\.\d+)?)/,
            "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
            "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
            "Mozilla": /rv:(\d+(\.\d+)?)/,
            "Whale Browser": /Whale\/(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) return null;
        var matches = userAgent.match(regex);
        if (!matches) return null;
        return parseFloat(matches[matches.length - 2]);
    },
    os: function() {
        var a = $413a30192b54574f$var$userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) return "Windows Phone";
            return "Windows";
        } else if (/(iPhone|iPad|iPod)/.test(a)) return "iOS";
        else if (/Android/.test(a)) return "Android";
        else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return "BlackBerry";
        else if (/Mac/i.test(a)) return "Mac OS X";
        else if (/Linux/.test(a)) return "Linux";
        else if (/CrOS/.test(a)) return "Chrome OS";
        else return "";
    },
    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return "Windows Phone";
        else if (/iPad/.test(user_agent)) return "iPad";
        else if (/iPod/.test(user_agent)) return "iPod Touch";
        else if (/iPhone/.test(user_agent)) return "iPhone";
        else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return "BlackBerry";
        else if (/Android/.test(user_agent)) return "Android";
        else return "";
    },
    referringDomain: function(referrer) {
        var split = referrer.split("/");
        if (split.length >= 3) return split[2];
        return "";
    },
    currentUrl: function() {
        return $413a30192b54574f$var$win.location.href;
    },
    properties: function(extra_props) {
        if (typeof extra_props !== "object") extra_props = {};
        return $413a30192b54574f$var$_.extend($413a30192b54574f$var$_.strip_empty_properties({
            "$os": $413a30192b54574f$var$_.info.os(),
            "$browser": $413a30192b54574f$var$_.info.browser($413a30192b54574f$var$userAgent, $413a30192b54574f$var$navigator.vendor, $413a30192b54574f$var$windowOpera),
            "$referrer": $413a30192b54574f$var$document$1.referrer,
            "$referring_domain": $413a30192b54574f$var$_.info.referringDomain($413a30192b54574f$var$document$1.referrer),
            "$device": $413a30192b54574f$var$_.info.device($413a30192b54574f$var$userAgent)
        }), {
            "$current_url": $413a30192b54574f$var$_.info.currentUrl(),
            "$browser_version": $413a30192b54574f$var$_.info.browserVersion($413a30192b54574f$var$userAgent, $413a30192b54574f$var$navigator.vendor, $413a30192b54574f$var$windowOpera),
            "$screen_height": $413a30192b54574f$var$screen.height,
            "$screen_width": $413a30192b54574f$var$screen.width,
            "mp_lib": "web",
            "$lib_version": $413a30192b54574f$var$Config.LIB_VERSION,
            "$insert_id": $413a30192b54574f$var$cheap_guid(),
            "time": $413a30192b54574f$var$_.timestamp() / 1000 // epoch time in seconds
        }, $413a30192b54574f$var$_.strip_empty_properties(extra_props));
    },
    people_properties: function() {
        return $413a30192b54574f$var$_.extend($413a30192b54574f$var$_.strip_empty_properties({
            "$os": $413a30192b54574f$var$_.info.os(),
            "$browser": $413a30192b54574f$var$_.info.browser($413a30192b54574f$var$userAgent, $413a30192b54574f$var$navigator.vendor, $413a30192b54574f$var$windowOpera)
        }), {
            "$browser_version": $413a30192b54574f$var$_.info.browserVersion($413a30192b54574f$var$userAgent, $413a30192b54574f$var$navigator.vendor, $413a30192b54574f$var$windowOpera)
        });
    },
    mpPageViewProperties: function() {
        return $413a30192b54574f$var$_.strip_empty_properties({
            "current_page_title": $413a30192b54574f$var$document$1.title,
            "current_domain": $413a30192b54574f$var$win.location.hostname,
            "current_url_path": $413a30192b54574f$var$win.location.pathname,
            "current_url_protocol": $413a30192b54574f$var$win.location.protocol,
            "current_url_search": $413a30192b54574f$var$win.location.search
        });
    }
};
/**
 * Returns a throttled function that will only run at most every `waitMs` and returns a promise that resolves with the next invocation.
 * Throttled calls will build up a batch of args and invoke the callback with all args since the last invocation.
 */ var $413a30192b54574f$var$batchedThrottle = function(fn, waitMs) {
    var timeoutPromise = null;
    var throttledItems = [];
    return function(item) {
        var self = this;
        throttledItems.push(item);
        if (!timeoutPromise) timeoutPromise = new $413a30192b54574f$var$PromisePolyfill(function(resolve) {
            setTimeout(function() {
                var returnValue = fn.apply(self, [
                    throttledItems
                ]);
                timeoutPromise = null;
                throttledItems = [];
                resolve(returnValue);
            }, waitMs);
        });
        return timeoutPromise;
    };
};
var $413a30192b54574f$var$cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};
/**
 * Generates a W3C traceparent header for easy interop with distributed tracing systems i.e Open Telemetry
 * https://www.w3.org/TR/trace-context/#traceparent-header
*/ var $413a30192b54574f$var$generateTraceparent = function() {
    var traceID = $413a30192b54574f$var$_.UUID().replace(/-/g, "");
    var parentID = $413a30192b54574f$var$_.UUID().replace(/-/g, "").substring(0, 16);
    // Sampled trace
    var traceFlags = "01";
    return "00-" + traceID + "-" + parentID + "-" + traceFlags;
};
// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var $413a30192b54574f$var$SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var $413a30192b54574f$var$DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */ var $413a30192b54574f$var$extract_domain = function(hostname) {
    var domain_regex = $413a30192b54574f$var$DOMAIN_MATCH_REGEX;
    var parts = hostname.split(".");
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === "com" || tld === "org") domain_regex = $413a30192b54574f$var$SIMPLE_DOMAIN_MATCH_REGEX;
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : "";
};
/**
 * Check whether we have network connection. default to true for browsers that don't support navigator.onLine (IE)
 * @returns {boolean}
 */ var $413a30192b54574f$var$isOnline = function() {
    var onLine = $413a30192b54574f$var$win.navigator["onLine"];
    return $413a30192b54574f$var$_.isUndefined(onLine) || onLine;
};
var $413a30192b54574f$var$NOOP_FUNC = function() {};
var $413a30192b54574f$var$JSONStringify = null, $413a30192b54574f$var$JSONParse = null;
if (typeof JSON !== "undefined") {
    $413a30192b54574f$var$JSONStringify = JSON.stringify;
    $413a30192b54574f$var$JSONParse = JSON.parse;
}
$413a30192b54574f$var$JSONStringify = $413a30192b54574f$var$JSONStringify || $413a30192b54574f$var$_.JSONEncode;
$413a30192b54574f$var$JSONParse = $413a30192b54574f$var$JSONParse || $413a30192b54574f$var$_.JSONDecode;
// UNMINIFIED EXPORTS (for closure compiler)
$413a30192b54574f$var$_["info"] = $413a30192b54574f$var$_.info;
$413a30192b54574f$var$_["info"]["browser"] = $413a30192b54574f$var$_.info.browser;
$413a30192b54574f$var$_["info"]["browserVersion"] = $413a30192b54574f$var$_.info.browserVersion;
$413a30192b54574f$var$_["info"]["device"] = $413a30192b54574f$var$_.info.device;
$413a30192b54574f$var$_["info"]["properties"] = $413a30192b54574f$var$_.info.properties;
$413a30192b54574f$var$_["isBlockedUA"] = $413a30192b54574f$var$_.isBlockedUA;
$413a30192b54574f$var$_["isEmptyObject"] = $413a30192b54574f$var$_.isEmptyObject;
$413a30192b54574f$var$_["isObject"] = $413a30192b54574f$var$_.isObject;
$413a30192b54574f$var$_["JSONDecode"] = $413a30192b54574f$var$_.JSONDecode;
$413a30192b54574f$var$_["JSONEncode"] = $413a30192b54574f$var$_.JSONEncode;
$413a30192b54574f$var$_["toArray"] = $413a30192b54574f$var$_.toArray;
$413a30192b54574f$var$_["NPO"] = $413a30192b54574f$var$NpoPromise;
var $413a30192b54574f$var$MIXPANEL_DB_NAME = "mixpanelBrowserDb";
var $413a30192b54574f$var$RECORDING_EVENTS_STORE_NAME = "mixpanelRecordingEvents";
var $413a30192b54574f$var$RECORDING_REGISTRY_STORE_NAME = "mixpanelRecordingRegistry";
// note: increment the version number when adding new object stores
var $413a30192b54574f$var$DB_VERSION = 1;
var $413a30192b54574f$var$OBJECT_STORES = [
    $413a30192b54574f$var$RECORDING_EVENTS_STORE_NAME,
    $413a30192b54574f$var$RECORDING_REGISTRY_STORE_NAME
];
/**
 * @type {import('./wrapper').StorageWrapper}
 */ var $413a30192b54574f$var$IDBStorageWrapper = function(storeName) {
    /**
     * @type {Promise<IDBDatabase>|null}
     */ this.dbPromise = null;
    this.storeName = storeName;
};
$413a30192b54574f$var$IDBStorageWrapper.prototype._openDb = function() {
    return new $413a30192b54574f$var$PromisePolyfill(function(resolve, reject) {
        var openRequest = $413a30192b54574f$var$win.indexedDB.open($413a30192b54574f$var$MIXPANEL_DB_NAME, $413a30192b54574f$var$DB_VERSION);
        openRequest["onerror"] = function() {
            reject(openRequest.error);
        };
        openRequest["onsuccess"] = function() {
            resolve(openRequest.result);
        };
        openRequest["onupgradeneeded"] = function(ev) {
            var db = ev.target.result;
            $413a30192b54574f$var$OBJECT_STORES.forEach(function(storeName) {
                db.createObjectStore(storeName);
            });
        };
    });
};
$413a30192b54574f$var$IDBStorageWrapper.prototype.init = function() {
    if (!$413a30192b54574f$var$win.indexedDB) return $413a30192b54574f$var$PromisePolyfill.reject("indexedDB is not supported in this browser");
    if (!this.dbPromise) this.dbPromise = this._openDb();
    return this.dbPromise.then(function(dbOrError) {
        if (dbOrError instanceof $413a30192b54574f$var$win["IDBDatabase"]) return $413a30192b54574f$var$PromisePolyfill.resolve();
        else return $413a30192b54574f$var$PromisePolyfill.reject(dbOrError);
    });
};
$413a30192b54574f$var$IDBStorageWrapper.prototype.isInitialized = function() {
    return !!this.dbPromise;
};
/**
 * @param {IDBTransactionMode} mode
 * @param {function(IDBObjectStore): void} storeCb
 */ $413a30192b54574f$var$IDBStorageWrapper.prototype.makeTransaction = function(mode, storeCb) {
    var storeName = this.storeName;
    var doTransaction = function(db) {
        return new $413a30192b54574f$var$PromisePolyfill(function(resolve, reject) {
            var transaction = db.transaction(storeName, mode);
            transaction.oncomplete = function() {
                resolve(transaction);
            };
            transaction.onabort = transaction.onerror = function() {
                reject(transaction.error);
            };
            storeCb(transaction.objectStore(storeName));
        });
    };
    return this.dbPromise.then(doTransaction).catch((function(err) {
        if (err && err["name"] === "InvalidStateError") {
            // try reopening the DB if the connection is closed
            this.dbPromise = this._openDb();
            return this.dbPromise.then(doTransaction);
        } else return $413a30192b54574f$var$PromisePolyfill.reject(err);
    }).bind(this));
};
$413a30192b54574f$var$IDBStorageWrapper.prototype.setItem = function(key, value) {
    return this.makeTransaction("readwrite", function(objectStore) {
        objectStore.put(value, key);
    });
};
$413a30192b54574f$var$IDBStorageWrapper.prototype.getItem = function(key) {
    var req;
    return this.makeTransaction("readonly", function(objectStore) {
        req = objectStore.get(key);
    }).then(function() {
        return req.result;
    });
};
$413a30192b54574f$var$IDBStorageWrapper.prototype.removeItem = function(key) {
    return this.makeTransaction("readwrite", function(objectStore) {
        objectStore.delete(key);
    });
};
$413a30192b54574f$var$IDBStorageWrapper.prototype.getAll = function() {
    var req;
    return this.makeTransaction("readonly", function(objectStore) {
        req = objectStore.getAll();
    }).then(function() {
        return req.result;
    });
};
/**
 * GDPR utils
 *
 * The General Data Protection Regulation (GDPR) is a regulation in EU law on data protection
 * and privacy for all individuals within the European Union. It addresses the export of personal
 * data outside the EU. The GDPR aims primarily to give control back to citizens and residents
 * over their personal data and to simplify the regulatory environment for international business
 * by unifying the regulation within the EU.
 *
 * This set of utilities is intended to enable opt in/out functionality in the Mixpanel JS SDK.
 * These functions are used internally by the SDK and are not intended to be publicly exposed.
 */ /**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */ /** Public **/ var $413a30192b54574f$var$GDPR_DEFAULT_PERSISTENCE_PREFIX = "__mp_opt_in_out_";
/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $413a30192b54574f$var$optIn(token, options) {
    $413a30192b54574f$var$_optInOut(true, token, options);
}
/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */ function $413a30192b54574f$var$optOut(token, options) {
    $413a30192b54574f$var$_optInOut(false, token, options);
}
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */ function $413a30192b54574f$var$hasOptedIn(token, options) {
    return $413a30192b54574f$var$_getStorageValue(token, options) === "1";
}
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */ function $413a30192b54574f$var$hasOptedOut(token, options) {
    if ($413a30192b54574f$var$_hasDoNotTrackFlagOn(options)) {
        $413a30192b54574f$var$console$1.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = $413a30192b54574f$var$_getStorageValue(token, options) === "0";
    if (optedOut) $413a30192b54574f$var$console$1.warn("You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.");
    return optedOut;
}
/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $413a30192b54574f$var$addOptOutCheckMixpanelLib(method) {
    return $413a30192b54574f$var$_addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}
/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $413a30192b54574f$var$addOptOutCheckMixpanelPeople(method) {
    return $413a30192b54574f$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $413a30192b54574f$var$addOptOutCheckMixpanelGroup(method) {
    return $413a30192b54574f$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $413a30192b54574f$var$clearOptInOut(token, options) {
    options = options || {};
    $413a30192b54574f$var$_getStorage(options).remove($413a30192b54574f$var$_getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain);
}
/** Private **/ /**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */ function $413a30192b54574f$var$_getStorage(options) {
    options = options || {};
    return options.persistenceType === "localStorage" ? $413a30192b54574f$var$_.localStorage : $413a30192b54574f$var$_.cookie;
}
/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */ function $413a30192b54574f$var$_getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || $413a30192b54574f$var$GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}
/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */ function $413a30192b54574f$var$_getStorageValue(token, options) {
    return $413a30192b54574f$var$_getStorage(options).get($413a30192b54574f$var$_getStorageKey(token, options));
}
/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */ function $413a30192b54574f$var$_hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) return false;
    var win$1 = options && options.window || $413a30192b54574f$var$win;
    var nav = win$1["navigator"] || {};
    var hasDntOn = false;
    $413a30192b54574f$var$_.each([
        nav["doNotTrack"],
        nav["msDoNotTrack"],
        win$1["doNotTrack"]
    ], function(dntValue) {
        if ($413a30192b54574f$var$_.includes([
            true,
            1,
            "1",
            "yes"
        ], dntValue)) hasDntOn = true;
    });
    return hasDntOn;
}
/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $413a30192b54574f$var$_optInOut(optValue, token, options) {
    if (!$413a30192b54574f$var$_.isString(token) || !token.length) {
        $413a30192b54574f$var$console$1.error("gdpr." + (optValue ? "optIn" : "optOut") + " called with an invalid token");
        return;
    }
    options = options || {};
    $413a30192b54574f$var$_getStorage(options).set($413a30192b54574f$var$_getStorageKey(token, options), optValue ? 1 : 0, $413a30192b54574f$var$_.isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie, !!options.crossSiteCookie, options.cookieDomain);
    if (options.track && optValue) options.track(options.trackEventName || "$opt_in", options.trackProperties, {
        "send_immediately": true
    });
}
/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $413a30192b54574f$var$_addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;
        try {
            var token = getConfigValue.call(this, "token");
            var ignoreDnt = getConfigValue.call(this, "ignore_dnt");
            var persistenceType = getConfigValue.call(this, "opt_out_tracking_persistence_type");
            var persistencePrefix = getConfigValue.call(this, "opt_out_tracking_cookie_prefix");
            var win = getConfigValue.call(this, "window"); // used to override window during browser tests
            if (token) optedOut = $413a30192b54574f$var$hasOptedOut(token, {
                ignoreDnt: ignoreDnt,
                persistenceType: persistenceType,
                persistencePrefix: persistencePrefix,
                window: win
            });
        } catch (err) {
            $413a30192b54574f$var$console$1.error("Unexpected error when checking tracking opt-out status: " + err);
        }
        if (!optedOut) return method.apply(this, arguments);
        var callback = arguments[arguments.length - 1];
        if (typeof callback === "function") callback(0);
        return;
    };
}
var $413a30192b54574f$var$logger$6 = $413a30192b54574f$var$console_with_prefix("lock");
/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */ var $413a30192b54574f$var$SharedLock = function(key, options) {
    options = options || {};
    this.storageKey = key;
    this.storage = options.storage || $413a30192b54574f$var$win.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
    // dependency-inject promise implementation for testing purposes
    this.promiseImpl = options.promiseImpl || $413a30192b54574f$var$PromisePolyfill;
};
// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
$413a30192b54574f$var$SharedLock.prototype.withLock = function(lockedCB, pid) {
    var Promise1 = this.promiseImpl;
    return new Promise1($413a30192b54574f$var$_.bind(function(resolve, reject) {
        var i = pid || new Date().getTime() + "|" + Math.random();
        var startTime = new Date().getTime();
        var key = this.storageKey;
        var pollIntervalMS = this.pollIntervalMS;
        var timeoutMS = this.timeoutMS;
        var storage = this.storage;
        var keyX = key + ":X";
        var keyY = key + ":Y";
        var keyZ = key + ":Z";
        var delay = function(cb) {
            if (new Date().getTime() - startTime > timeoutMS) {
                $413a30192b54574f$var$logger$6.error("Timeout waiting for mutex on " + key + "; clearing lock. [" + i + "]");
                storage.removeItem(keyZ);
                storage.removeItem(keyY);
                loop();
                return;
            }
            setTimeout(function() {
                try {
                    cb();
                } catch (err) {
                    reject(err);
                }
            }, pollIntervalMS * (Math.random() + 0.1));
        };
        var waitFor = function(predicate, cb) {
            if (predicate()) cb();
            else delay(function() {
                waitFor(predicate, cb);
            });
        };
        var getSetY = function() {
            var valY = storage.getItem(keyY);
            if (valY && valY !== i) return false;
            else {
                storage.setItem(keyY, i);
                if (storage.getItem(keyY) === i) return true;
                else {
                    if (!$413a30192b54574f$var$localStorageSupported(storage, true)) reject(new Error("localStorage support dropped while acquiring lock"));
                    return false;
                }
            }
        };
        var loop = function() {
            storage.setItem(keyX, i);
            waitFor(getSetY, function() {
                if (storage.getItem(keyX) === i) {
                    criticalSection();
                    return;
                }
                delay(function() {
                    if (storage.getItem(keyY) !== i) {
                        loop();
                        return;
                    }
                    waitFor(function() {
                        return !storage.getItem(keyZ);
                    }, criticalSection);
                });
            });
        };
        var criticalSection = function() {
            storage.setItem(keyZ, "1");
            var removeLock = function() {
                storage.removeItem(keyZ);
                if (storage.getItem(keyY) === i) storage.removeItem(keyY);
                if (storage.getItem(keyX) === i) storage.removeItem(keyX);
            };
            lockedCB().then(function(ret) {
                removeLock();
                resolve(ret);
            }).catch(function(err) {
                removeLock();
                reject(err);
            });
        };
        try {
            if ($413a30192b54574f$var$localStorageSupported(storage, true)) loop();
            else throw new Error("localStorage support check failed");
        } catch (err) {
            reject(err);
        }
    }, this));
};
/**
 * @type {import('./wrapper').StorageWrapper}
 */ var $413a30192b54574f$var$LocalStorageWrapper = function(storageOverride) {
    this.storage = storageOverride || $413a30192b54574f$var$win.localStorage;
};
$413a30192b54574f$var$LocalStorageWrapper.prototype.init = function() {
    return $413a30192b54574f$var$PromisePolyfill.resolve();
};
$413a30192b54574f$var$LocalStorageWrapper.prototype.isInitialized = function() {
    return true;
};
$413a30192b54574f$var$LocalStorageWrapper.prototype.setItem = function(key, value) {
    return new $413a30192b54574f$var$PromisePolyfill($413a30192b54574f$var$_.bind(function(resolve, reject) {
        try {
            this.storage.setItem(key, $413a30192b54574f$var$JSONStringify(value));
        } catch (e) {
            reject(e);
        }
        resolve();
    }, this));
};
$413a30192b54574f$var$LocalStorageWrapper.prototype.getItem = function(key) {
    return new $413a30192b54574f$var$PromisePolyfill($413a30192b54574f$var$_.bind(function(resolve, reject) {
        var item;
        try {
            item = $413a30192b54574f$var$JSONParse(this.storage.getItem(key));
        } catch (e) {
            reject(e);
        }
        resolve(item);
    }, this));
};
$413a30192b54574f$var$LocalStorageWrapper.prototype.removeItem = function(key) {
    return new $413a30192b54574f$var$PromisePolyfill($413a30192b54574f$var$_.bind(function(resolve, reject) {
        try {
            this.storage.removeItem(key);
        } catch (e) {
            reject(e);
        }
        resolve();
    }, this));
};
var $413a30192b54574f$var$logger$5 = $413a30192b54574f$var$console_with_prefix("batch");
/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */ var $413a30192b54574f$var$RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.usePersistence = options.usePersistence;
    if (this.usePersistence) {
        this.queueStorage = options.queueStorage || new $413a30192b54574f$var$LocalStorageWrapper();
        this.lock = new $413a30192b54574f$var$SharedLock(storageKey, {
            storage: options.sharedLockStorage || $413a30192b54574f$var$win.localStorage,
            timeoutMS: options.sharedLockTimeoutMS
        });
    }
    this.reportError = options.errorReporter || $413a30192b54574f$var$_.bind($413a30192b54574f$var$logger$5.error, $413a30192b54574f$var$logger$5);
    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
    this.memQueue = [];
    this.initialized = false;
    if (options.enqueueThrottleMs) this.enqueuePersisted = $413a30192b54574f$var$batchedThrottle($413a30192b54574f$var$_.bind(this._enqueuePersisted, this), options.enqueueThrottleMs);
    else this.enqueuePersisted = $413a30192b54574f$var$_.bind(function(queueEntry) {
        return this._enqueuePersisted([
            queueEntry
        ]);
    }, this);
};
$413a30192b54574f$var$RequestQueue.prototype.ensureInit = function() {
    if (this.initialized || !this.usePersistence) return $413a30192b54574f$var$PromisePolyfill.resolve();
    return this.queueStorage.init().then($413a30192b54574f$var$_.bind(function() {
        this.initialized = true;
    }, this)).catch($413a30192b54574f$var$_.bind(function(err) {
        this.reportError("Error initializing queue persistence. Disabling persistence", err);
        this.initialized = true;
        this.usePersistence = false;
    }, this));
};
/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */ $413a30192b54574f$var$RequestQueue.prototype.enqueue = function(item, flushInterval) {
    var queueEntry = {
        "id": $413a30192b54574f$var$cheap_guid(),
        "flushAfter": new Date().getTime() + flushInterval * 2,
        "payload": item
    };
    if (!this.usePersistence) {
        this.memQueue.push(queueEntry);
        return $413a30192b54574f$var$PromisePolyfill.resolve(true);
    } else return this.enqueuePersisted(queueEntry);
};
$413a30192b54574f$var$RequestQueue.prototype._enqueuePersisted = function(queueEntries) {
    var enqueueItem = $413a30192b54574f$var$_.bind(function() {
        return this.ensureInit().then($413a30192b54574f$var$_.bind(function() {
            return this.readFromStorage();
        }, this)).then($413a30192b54574f$var$_.bind(function(storedQueue) {
            return this.saveToStorage(storedQueue.concat(queueEntries));
        }, this)).then($413a30192b54574f$var$_.bind(function(succeeded) {
            // only add to in-memory queue when storage succeeds
            if (succeeded) this.memQueue = this.memQueue.concat(queueEntries);
            return succeeded;
        }, this)).catch($413a30192b54574f$var$_.bind(function(err) {
            this.reportError("Error enqueueing items", err, queueEntries);
            return false;
        }, this));
    }, this);
    return this.lock.withLock(enqueueItem, this.pid).catch($413a30192b54574f$var$_.bind(function(err) {
        this.reportError("Error acquiring storage lock", err);
        return false;
    }, this));
};
/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */ $413a30192b54574f$var$RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (this.usePersistence && batch.length < batchSize) // don't need lock just to read events; localStorage is thread-safe
    // and the worst that could happen is a duplicate send of some
    // orphaned events, which will be deduplicated on the server side
    return this.ensureInit().then($413a30192b54574f$var$_.bind(function() {
        return this.readFromStorage();
    }, this)).then($413a30192b54574f$var$_.bind(function(storedQueue) {
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            $413a30192b54574f$var$_.each(batch, function(item) {
                idsInBatch[item["id"]] = true;
            });
            for(var i = 0; i < storedQueue.length; i++){
                var item = storedQueue[i];
                if (new Date().getTime() > item["flushAfter"] && !idsInBatch[item["id"]]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) break;
                }
            }
        }
        return batch;
    }, this));
    else return $413a30192b54574f$var$PromisePolyfill.resolve(batch);
};
/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */ var $413a30192b54574f$var$filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    $413a30192b54574f$var$_.each(items, function(item) {
        if (item["id"] && !idSet[item["id"]]) filteredItems.push(item);
    });
    return filteredItems;
};
/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */ $413a30192b54574f$var$RequestQueue.prototype.removeItemsByID = function(ids) {
    var idSet = {}; // poor man's Set
    $413a30192b54574f$var$_.each(ids, function(id) {
        idSet[id] = true;
    });
    this.memQueue = $413a30192b54574f$var$filterOutIDsAndInvalid(this.memQueue, idSet);
    if (!this.usePersistence) return $413a30192b54574f$var$PromisePolyfill.resolve(true);
    else {
        var removeFromStorage = $413a30192b54574f$var$_.bind(function() {
            return this.ensureInit().then($413a30192b54574f$var$_.bind(function() {
                return this.readFromStorage();
            }, this)).then($413a30192b54574f$var$_.bind(function(storedQueue) {
                storedQueue = $413a30192b54574f$var$filterOutIDsAndInvalid(storedQueue, idSet);
                return this.saveToStorage(storedQueue);
            }, this)).then($413a30192b54574f$var$_.bind(function() {
                return this.readFromStorage();
            }, this)).then($413a30192b54574f$var$_.bind(function(storedQueue) {
                // an extra check: did storage report success but somehow
                // the items are still there?
                for(var i = 0; i < storedQueue.length; i++){
                    var item = storedQueue[i];
                    if (item["id"] && !!idSet[item["id"]]) throw new Error("Item not removed from storage");
                }
                return true;
            }, this)).catch($413a30192b54574f$var$_.bind(function(err) {
                this.reportError("Error removing items", err, ids);
                return false;
            }, this));
        }, this);
        return this.lock.withLock(removeFromStorage, this.pid).catch($413a30192b54574f$var$_.bind(function(err) {
            this.reportError("Error acquiring storage lock", err);
            if (!$413a30192b54574f$var$localStorageSupported(this.lock.storage, true)) // Looks like localStorage writes have stopped working sometime after
            // initialization (probably full), and so nobody can acquire locks
            // anymore. Consider it temporarily safe to remove items without the
            // lock, since nobody's writing successfully anyway.
            return removeFromStorage().then($413a30192b54574f$var$_.bind(function(success) {
                if (!success) // OK, we couldn't even write out the smaller queue. Try clearing it
                // entirely.
                return this.queueStorage.removeItem(this.storageKey).then(function() {
                    return success;
                });
                return success;
            }, this)).catch($413a30192b54574f$var$_.bind(function(err) {
                this.reportError("Error clearing queue", err);
                return false;
            }, this));
            else return false;
        }, this));
    }
};
// internal helper for RequestQueue.updatePayloads
var $413a30192b54574f$var$updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    $413a30192b54574f$var$_.each(existingItems, function(item) {
        var id = item["id"];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item["payload"] = newPayload;
                newItems.push(item);
            }
        } else // no update
        newItems.push(item);
    });
    return newItems;
};
/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */ $413a30192b54574f$var$RequestQueue.prototype.updatePayloads = function(itemsToUpdate) {
    this.memQueue = $413a30192b54574f$var$updatePayloads(this.memQueue, itemsToUpdate);
    if (!this.usePersistence) return $413a30192b54574f$var$PromisePolyfill.resolve(true);
    else return this.lock.withLock($413a30192b54574f$var$_.bind(function lockAcquired() {
        return this.ensureInit().then($413a30192b54574f$var$_.bind(function() {
            return this.readFromStorage();
        }, this)).then($413a30192b54574f$var$_.bind(function(storedQueue) {
            storedQueue = $413a30192b54574f$var$updatePayloads(storedQueue, itemsToUpdate);
            return this.saveToStorage(storedQueue);
        }, this)).catch($413a30192b54574f$var$_.bind(function(err) {
            this.reportError("Error updating items", itemsToUpdate, err);
            return false;
        }, this));
    }, this), this.pid).catch($413a30192b54574f$var$_.bind(function(err) {
        this.reportError("Error acquiring storage lock", err);
        return false;
    }, this));
};
/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */ $413a30192b54574f$var$RequestQueue.prototype.readFromStorage = function() {
    return this.ensureInit().then($413a30192b54574f$var$_.bind(function() {
        return this.queueStorage.getItem(this.storageKey);
    }, this)).then($413a30192b54574f$var$_.bind(function(storageEntry) {
        if (storageEntry) {
            if (!$413a30192b54574f$var$_.isArray(storageEntry)) {
                this.reportError("Invalid storage entry:", storageEntry);
                storageEntry = null;
            }
        }
        return storageEntry || [];
    }, this)).catch($413a30192b54574f$var$_.bind(function(err) {
        this.reportError("Error retrieving queue", err);
        return [];
    }, this));
};
/**
 * Serialize the given items array to localStorage.
 */ $413a30192b54574f$var$RequestQueue.prototype.saveToStorage = function(queue) {
    return this.ensureInit().then($413a30192b54574f$var$_.bind(function() {
        return this.queueStorage.setItem(this.storageKey, queue);
    }, this)).then(function() {
        return true;
    }).catch($413a30192b54574f$var$_.bind(function(err) {
        this.reportError("Error saving queue", err);
        return false;
    }, this));
};
/**
 * Clear out queues (memory and localStorage).
 */ $413a30192b54574f$var$RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    if (this.usePersistence) return this.ensureInit().then($413a30192b54574f$var$_.bind(function() {
        return this.queueStorage.removeItem(this.storageKey);
    }, this));
    else return $413a30192b54574f$var$PromisePolyfill.resolve();
};
// maximum interval between request retries after exponential backoff
var $413a30192b54574f$var$MAX_RETRY_INTERVAL_MS = 600000; // 10 minutes
var $413a30192b54574f$var$logger$4 = $413a30192b54574f$var$console_with_prefix("batch");
/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */ var $413a30192b54574f$var$RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new $413a30192b54574f$var$RequestQueue(storageKey, {
        errorReporter: $413a30192b54574f$var$_.bind(this.reportError, this),
        queueStorage: options.queueStorage,
        sharedLockStorage: options.sharedLockStorage,
        sharedLockTimeoutMS: options.sharedLockTimeoutMS,
        usePersistence: options.usePersistence,
        enqueueThrottleMs: options.enqueueThrottleMs
    });
    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;
    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig["batch_size"];
    this.flushInterval = this.libConfig["batch_flush_interval_ms"];
    this.stopped = !this.libConfig["batch_autostart"];
    this.consecutiveRemovalFailures = 0;
    // extra client-side dedupe
    this.itemIdsSentSuccessfully = {};
    // Make the flush occur at the interval specified by flushIntervalMs, default behavior will attempt consecutive flushes
    // as long as the queue is not empty. This is useful for high-frequency events like Session Replay where we might end up
    // in a request loop and get ratelimited by the server.
    this.flushOnlyOnInterval = options.flushOnlyOnInterval || false;
    this._flushPromise = null;
};
/**
 * Add one item to queue.
 */ $413a30192b54574f$var$RequestBatcher.prototype.enqueue = function(item) {
    return this.queue.enqueue(item, this.flushInterval);
};
/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */ $413a30192b54574f$var$RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    return this.flush();
};
/**
 * Stop flushing batches. Can be restarted by calling start().
 */ $413a30192b54574f$var$RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};
/**
 * Clear out queue.
 */ $413a30192b54574f$var$RequestBatcher.prototype.clear = function() {
    return this.queue.clear();
};
/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */ $413a30192b54574f$var$RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig["batch_size"];
};
/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */ $413a30192b54574f$var$RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig["batch_flush_interval_ms"]);
};
/**
 * Schedule the next flush in the given number of milliseconds.
 */ $413a30192b54574f$var$RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) this.timeoutID = setTimeout($413a30192b54574f$var$_.bind(function() {
        if (!this.stopped) this._flushPromise = this.flush();
    }, this), this.flushInterval);
};
/**
 * Send a request using the sendRequest callback, but promisified.
 * TODO: sendRequest should be promisified in the first place.
 */ $413a30192b54574f$var$RequestBatcher.prototype.sendRequestPromise = function(data, options) {
    return new $413a30192b54574f$var$PromisePolyfill($413a30192b54574f$var$_.bind(function(resolve) {
        this.sendRequest(data, options, resolve);
    }, this));
};
/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */ $413a30192b54574f$var$RequestBatcher.prototype.flush = function(options) {
    if (this.requestInProgress) {
        $413a30192b54574f$var$logger$4.log("Flush: Request already in progress");
        return $413a30192b54574f$var$PromisePolyfill.resolve();
    }
    this.requestInProgress = true;
    options = options || {};
    var timeoutMS = this.libConfig["batch_request_timeout_ms"];
    var startTime = new Date().getTime();
    var currentBatchSize = this.batchSize;
    return this.queue.fillBatch(currentBatchSize).then($413a30192b54574f$var$_.bind(function(batch) {
        // if there's more items in the queue than the batch size, attempt
        // to flush again after the current batch is done.
        var attemptSecondaryFlush = batch.length === currentBatchSize;
        var dataForRequest = [];
        var transformedItems = {};
        $413a30192b54574f$var$_.each(batch, function(item) {
            var payload = item["payload"];
            if (this.beforeSendHook && !item.orphaned) payload = this.beforeSendHook(payload);
            if (payload) {
                // mp_sent_by_lib_version prop captures which lib version actually
                // sends each event (regardless of which version originally queued
                // it for sending)
                if (payload["event"] && payload["properties"]) payload["properties"] = $413a30192b54574f$var$_.extend({}, payload["properties"], {
                    "mp_sent_by_lib_version": $413a30192b54574f$var$Config.LIB_VERSION
                });
                var addPayload = true;
                var itemId = item["id"];
                if (itemId) {
                    if ((this.itemIdsSentSuccessfully[itemId] || 0) > 5) {
                        this.reportError("[dupe] item ID sent too many times, not sending", {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                        addPayload = false;
                    }
                } else this.reportError("[dupe] found item with no ID", {
                    item: item
                });
                if (addPayload) dataForRequest.push(payload);
            }
            transformedItems[item["id"]] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.requestInProgress = false;
            this.resetFlush();
            return $413a30192b54574f$var$PromisePolyfill.resolve(); // nothing to do
        }
        var removeItemsFromQueue = $413a30192b54574f$var$_.bind(function() {
            return this.queue.removeItemsByID($413a30192b54574f$var$_.map(batch, function(item) {
                return item["id"];
            })).then($413a30192b54574f$var$_.bind(function(succeeded) {
                // client-side dedupe
                $413a30192b54574f$var$_.each(batch, $413a30192b54574f$var$_.bind(function(item) {
                    var itemId = item["id"];
                    if (itemId) {
                        this.itemIdsSentSuccessfully[itemId] = this.itemIdsSentSuccessfully[itemId] || 0;
                        this.itemIdsSentSuccessfully[itemId]++;
                        if (this.itemIdsSentSuccessfully[itemId] > 5) this.reportError("[dupe] item ID sent too many times", {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                    } else this.reportError("[dupe] found item with no ID while removing", {
                        item: item
                    });
                }, this));
                if (succeeded) {
                    this.consecutiveRemovalFailures = 0;
                    if (this.flushOnlyOnInterval && !attemptSecondaryFlush) {
                        this.resetFlush(); // schedule next batch with a delay
                        return $413a30192b54574f$var$PromisePolyfill.resolve();
                    } else return this.flush(); // handle next batch if the queue isn't empty
                } else {
                    if (++this.consecutiveRemovalFailures > 5) {
                        this.reportError("Too many queue failures; disabling batching system.");
                        this.stopAllBatching();
                    } else this.resetFlush();
                    return $413a30192b54574f$var$PromisePolyfill.resolve();
                }
            }, this));
        }, this);
        var batchSendCallback = $413a30192b54574f$var$_.bind(function(res) {
            this.requestInProgress = false;
            try {
                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong
                if (options.unloading) // update persisted data to include hook transformations
                return this.queue.updatePayloads(transformedItems);
                else if ($413a30192b54574f$var$_.isObject(res) && res.error === "timeout" && new Date().getTime() - startTime >= timeoutMS) {
                    this.reportError("Network timeout; retrying");
                    return this.flush();
                } else if ($413a30192b54574f$var$_.isObject(res) && (res.httpStatusCode >= 500 || res.httpStatusCode === 429 || res.httpStatusCode <= 0 && !$413a30192b54574f$var$isOnline() || res.error === "timeout")) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    if (res.retryAfter) retryMS = parseInt(res.retryAfter, 10) * 1000 || retryMS;
                    retryMS = Math.min($413a30192b54574f$var$MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError("Error; retry in " + retryMS + " ms");
                    this.scheduleFlush(retryMS);
                    return $413a30192b54574f$var$PromisePolyfill.resolve();
                } else if ($413a30192b54574f$var$_.isObject(res) && res.httpStatusCode === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError("413 response; reducing batch size to " + this.batchSize);
                        this.resetFlush();
                        return $413a30192b54574f$var$PromisePolyfill.resolve();
                    } else {
                        this.reportError("Single-event request too large; dropping", batch);
                        this.resetBatchSize();
                        return removeItemsFromQueue();
                    }
                } else // successful network request+response; remove each item in batch from queue
                // (even if it was e.g. a 400, in which case retrying won't help)
                return removeItemsFromQueue();
            } catch (err) {
                this.reportError("Error handling API response", err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: "POST",
            verbose: true,
            ignore_json_errors: true,
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) requestOptions.transport = "sendBeacon";
        $413a30192b54574f$var$logger$4.log("MIXPANEL REQUEST:", dataForRequest);
        return this.sendRequestPromise(dataForRequest, requestOptions).then(batchSendCallback);
    }, this)).catch($413a30192b54574f$var$_.bind(function(err) {
        this.reportError("Error flushing request queue", err);
        this.resetFlush();
    }, this));
};
/**
 * Log error to global logger and optional user-defined logger.
 */ $413a30192b54574f$var$RequestBatcher.prototype.reportError = function(msg, err) {
    $413a30192b54574f$var$logger$4.error.apply($413a30192b54574f$var$logger$4.error, arguments);
    if (this.errorReporter) try {
        if (!(err instanceof Error)) err = new Error(msg);
        this.errorReporter(msg, err);
    } catch (err) {
        $413a30192b54574f$var$logger$4.error(err);
    }
};
/**
 * @param {import('./session-recording').SerializedRecording} serializedRecording
 * @returns {boolean}
 */ var $413a30192b54574f$var$isRecordingExpired = function(serializedRecording) {
    var now = Date.now();
    return !serializedRecording || now > serializedRecording["maxExpires"] || now > serializedRecording["idleExpires"];
};
var $413a30192b54574f$var$RECORD_ENQUEUE_THROTTLE_MS = 250;
var $413a30192b54574f$var$logger$3 = $413a30192b54574f$var$console_with_prefix("recorder");
var $413a30192b54574f$var$CompressionStream = $413a30192b54574f$var$win["CompressionStream"];
var $413a30192b54574f$var$RECORDER_BATCHER_LIB_CONFIG = {
    "batch_size": 1000,
    "batch_flush_interval_ms": 10000,
    "batch_request_timeout_ms": 90000,
    "batch_autostart": true
};
var $413a30192b54574f$var$ACTIVE_SOURCES = new Set([
    $413a30192b54574f$var$IncrementalSource.MouseMove,
    $413a30192b54574f$var$IncrementalSource.MouseInteraction,
    $413a30192b54574f$var$IncrementalSource.Scroll,
    $413a30192b54574f$var$IncrementalSource.ViewportResize,
    $413a30192b54574f$var$IncrementalSource.Input,
    $413a30192b54574f$var$IncrementalSource.TouchMove,
    $413a30192b54574f$var$IncrementalSource.MediaInteraction,
    $413a30192b54574f$var$IncrementalSource.Drag,
    $413a30192b54574f$var$IncrementalSource.Selection
]);
function $413a30192b54574f$var$isUserEvent(ev) {
    return ev.type === $413a30192b54574f$var$EventType.IncrementalSnapshot && $413a30192b54574f$var$ACTIVE_SOURCES.has(ev.data.source);
}
/**
 * @typedef {Object} SerializedRecording
 * @property {number} idleExpires
 * @property {number} maxExpires
 * @property {number} replayStartTime
 * @property {number} seqNo
 * @property {string} batchStartUrl
 * @property {string} replayId
 * @property {string} tabId
 * @property {string} replayStartUrl
 */ /**
 * @typedef {Object} SessionRecordingOptions
 * @property {Object} [options.mixpanelInstance] - reference to the core MixpanelLib
 * @property {String} [options.replayId] - unique uuid for a single replay
 * @property {Function} [options.onIdleTimeout] - callback when a recording reaches idle timeout
 * @property {Function} [options.onMaxLengthReached] - callback when a recording reaches its maximum length
 * @property {Function} [options.rrwebRecord] - rrweb's `record` function
 * @property {Function} [options.onBatchSent] - callback when a batch of events is sent to the server
 * @property {Storage} [options.sharedLockStorage] - optional storage for shared lock, used for test dependency injection
 * optional properties for deserialization:
 * @property {number} idleExpires
 * @property {number} maxExpires
 * @property {number} replayStartTime
 * @property {number} seqNo
 * @property {string} batchStartUrl
 * @property {string} replayStartUrl
 */ /**
 * @typedef {Object} UserIdInfo
 * @property {string} distinct_id
 * @property {string} user_id
 * @property {string} device_id
 */ /**
 * This class encapsulates a single session recording and its lifecycle.
 * @param {SessionRecordingOptions} options
 */ var $413a30192b54574f$var$SessionRecording = function(options) {
    this._mixpanel = options.mixpanelInstance;
    this._onIdleTimeout = options.onIdleTimeout || $413a30192b54574f$var$NOOP_FUNC;
    this._onMaxLengthReached = options.onMaxLengthReached || $413a30192b54574f$var$NOOP_FUNC;
    this._onBatchSent = options.onBatchSent || $413a30192b54574f$var$NOOP_FUNC;
    this._rrwebRecord = options.rrwebRecord || null;
    // internal rrweb stopRecording function
    this._stopRecording = null;
    this.replayId = options.replayId;
    this.batchStartUrl = options.batchStartUrl || null;
    this.replayStartUrl = options.replayStartUrl || null;
    this.idleExpires = options.idleExpires || null;
    this.maxExpires = options.maxExpires || null;
    this.replayStartTime = options.replayStartTime || null;
    this.seqNo = options.seqNo || 0;
    this.idleTimeoutId = null;
    this.maxTimeoutId = null;
    this.recordMaxMs = $413a30192b54574f$var$MAX_RECORDING_MS;
    this.recordMinMs = 0;
    // disable persistence if localStorage is not supported
    // request-queue will automatically disable persistence if indexedDB fails to initialize
    var usePersistence = $413a30192b54574f$var$localStorageSupported(options.sharedLockStorage, true) && !this.getConfig("disable_persistence");
    // each replay has its own batcher key to avoid conflicts between rrweb events of different recordings
    this.batcherKey = "__mprec_" + this.getConfig("name") + "_" + this.getConfig("token") + "_" + this.replayId;
    this.queueStorage = new $413a30192b54574f$var$IDBStorageWrapper($413a30192b54574f$var$RECORDING_EVENTS_STORE_NAME);
    this.batcher = new $413a30192b54574f$var$RequestBatcher(this.batcherKey, {
        errorReporter: this.reportError.bind(this),
        flushOnlyOnInterval: true,
        libConfig: $413a30192b54574f$var$RECORDER_BATCHER_LIB_CONFIG,
        sendRequestFunc: this.flushEventsWithOptOut.bind(this),
        queueStorage: this.queueStorage,
        sharedLockStorage: options.sharedLockStorage,
        usePersistence: usePersistence,
        stopAllBatchingFunc: this.stopRecording.bind(this),
        // increased throttle and shared lock timeout because recording events are very high frequency.
        // this will minimize the amount of lock contention between enqueued events.
        // for session recordings there is a lock for each tab anyway, so there's no risk of deadlock between tabs.
        enqueueThrottleMs: $413a30192b54574f$var$RECORD_ENQUEUE_THROTTLE_MS,
        sharedLockTimeoutMS: 10000
    });
};
/**
 * @returns {UserIdInfo}
 */ $413a30192b54574f$var$SessionRecording.prototype.getUserIdInfo = function() {
    if (this.finalFlushUserIdInfo) return this.finalFlushUserIdInfo;
    var userIdInfo = {
        "distinct_id": String(this._mixpanel.get_distinct_id())
    };
    // send ID management props if they exist
    var deviceId = this._mixpanel.get_property("$device_id");
    if (deviceId) userIdInfo["$device_id"] = deviceId;
    var userId = this._mixpanel.get_property("$user_id");
    if (userId) userIdInfo["$user_id"] = userId;
    return userIdInfo;
};
$413a30192b54574f$var$SessionRecording.prototype.unloadPersistedData = function() {
    this.batcher.stop();
    return this.batcher.flush().then((function() {
        return this.queueStorage.removeItem(this.batcherKey);
    }).bind(this));
};
$413a30192b54574f$var$SessionRecording.prototype.getConfig = function(configVar) {
    return this._mixpanel.get_config(configVar);
};
// Alias for getConfig, used by the common addOptOutCheckMixpanelLib function which
// reaches into this class instance and expects the snake case version of the function.
// eslint-disable-next-line camelcase
$413a30192b54574f$var$SessionRecording.prototype.get_config = function(configVar) {
    return this.getConfig(configVar);
};
$413a30192b54574f$var$SessionRecording.prototype.startRecording = function(shouldStopBatcher) {
    if (this._rrwebRecord === null) {
        this.reportError("rrweb record function not provided. ");
        return;
    }
    if (this._stopRecording !== null) {
        $413a30192b54574f$var$logger$3.log("Recording already in progress, skipping startRecording.");
        return;
    }
    this.recordMaxMs = this.getConfig("record_max_ms");
    if (this.recordMaxMs > $413a30192b54574f$var$MAX_RECORDING_MS) {
        this.recordMaxMs = $413a30192b54574f$var$MAX_RECORDING_MS;
        $413a30192b54574f$var$logger$3.critical("record_max_ms cannot be greater than " + $413a30192b54574f$var$MAX_RECORDING_MS + "ms. Capping value.");
    }
    if (!this.maxExpires) this.maxExpires = new Date().getTime() + this.recordMaxMs;
    this.recordMinMs = this.getConfig("record_min_ms");
    if (this.recordMinMs > $413a30192b54574f$var$MAX_VALUE_FOR_MIN_RECORDING_MS) {
        this.recordMinMs = $413a30192b54574f$var$MAX_VALUE_FOR_MIN_RECORDING_MS;
        $413a30192b54574f$var$logger$3.critical("record_min_ms cannot be greater than " + $413a30192b54574f$var$MAX_VALUE_FOR_MIN_RECORDING_MS + "ms. Capping value.");
    }
    if (!this.replayStartTime) {
        this.replayStartTime = new Date().getTime();
        this.batchStartUrl = $413a30192b54574f$var$_.info.currentUrl();
        this.replayStartUrl = $413a30192b54574f$var$_.info.currentUrl();
    }
    if (shouldStopBatcher || this.recordMinMs > 0) // the primary case for shouldStopBatcher is when we're starting recording after a reset
    // and don't want to send anything over the network until there's
    // actual user activity
    // this also applies if the minimum recording length has not been hit yet
    // so that we don't send data until we know the recording will be long enough
    this.batcher.stop();
    else this.batcher.start();
    var resetIdleTimeout = (function() {
        clearTimeout(this.idleTimeoutId);
        var idleTimeoutMs = this.getConfig("record_idle_timeout_ms");
        this.idleTimeoutId = setTimeout(this._onIdleTimeout, idleTimeoutMs);
        this.idleExpires = new Date().getTime() + idleTimeoutMs;
    }).bind(this);
    resetIdleTimeout();
    var blockSelector = this.getConfig("record_block_selector");
    if (blockSelector === "" || blockSelector === null) blockSelector = undefined;
    try {
        this._stopRecording = this._rrwebRecord({
            "emit": (function(ev) {
                if (this.idleExpires && this.idleExpires < ev.timestamp) {
                    this._onIdleTimeout();
                    return;
                }
                if ($413a30192b54574f$var$isUserEvent(ev)) {
                    if (this.batcher.stopped && new Date().getTime() - this.replayStartTime >= this.recordMinMs) // start flushing again after user activity
                    this.batcher.start();
                    resetIdleTimeout();
                }
                // promise only used to await during tests
                this.__enqueuePromise = this.batcher.enqueue(ev);
            }).bind(this),
            "blockClass": this.getConfig("record_block_class"),
            "blockSelector": blockSelector,
            "collectFonts": this.getConfig("record_collect_fonts"),
            "dataURLOptions": {
                "type": "image/webp",
                "quality": 0.6
            },
            "maskAllInputs": true,
            "maskTextClass": this.getConfig("record_mask_text_class"),
            "maskTextSelector": this.getConfig("record_mask_text_selector"),
            "recordCanvas": this.getConfig("record_canvas"),
            "sampling": {
                "canvas": 15
            }
        });
    } catch (err) {
        this.reportError("Unexpected error when starting rrweb recording.", err);
    }
    if (typeof this._stopRecording !== "function") {
        this.reportError("rrweb failed to start, skipping this recording.");
        this._stopRecording = null;
        this.stopRecording(); // stop batcher looping and any timeouts
        return;
    }
    var maxTimeoutMs = this.maxExpires - new Date().getTime();
    this.maxTimeoutId = setTimeout(this._onMaxLengthReached.bind(this), maxTimeoutMs);
};
$413a30192b54574f$var$SessionRecording.prototype.stopRecording = function(skipFlush) {
    // store the user ID info in case this is getting called in mixpanel.reset()
    this.finalFlushUserIdInfo = this.getUserIdInfo();
    if (!this.isRrwebStopped()) {
        try {
            this._stopRecording();
        } catch (err) {
            this.reportError("Error with rrweb stopRecording", err);
        }
        this._stopRecording = null;
    }
    var flushPromise;
    if (this.batcher.stopped) // never got user activity to flush after reset, so just clear the batcher
    flushPromise = this.batcher.clear();
    else if (!skipFlush) // flush any remaining events from running batcher
    flushPromise = this.batcher.flush();
    this.batcher.stop();
    clearTimeout(this.idleTimeoutId);
    clearTimeout(this.maxTimeoutId);
    return flushPromise;
};
$413a30192b54574f$var$SessionRecording.prototype.isRrwebStopped = function() {
    return this._stopRecording === null;
};
/**
 * Flushes the current batch of events to the server, but passes an opt-out callback to make sure
 * we stop recording and dump any queued events if the user has opted out.
 */ $413a30192b54574f$var$SessionRecording.prototype.flushEventsWithOptOut = function(data, options, cb) {
    var onOptOut = (function(code) {
        // addOptOutCheckMixpanelLib invokes this function with code=0 when the user has opted out
        if (code === 0) {
            this.stopRecording();
            cb({
                error: "Tracking has been opted out, stopping recording."
            });
        }
    }).bind(this);
    this._flushEvents(data, options, cb, onOptOut);
};
/**
 * @returns {SerializedRecording}
 */ $413a30192b54574f$var$SessionRecording.prototype.serialize = function() {
    // don't break if mixpanel instance was destroyed at some point
    var tabId;
    try {
        tabId = this._mixpanel.get_tab_id();
    } catch (e) {
        this.reportError("Error getting tab ID for serialization ", e);
        tabId = null;
    }
    return {
        "replayId": this.replayId,
        "seqNo": this.seqNo,
        "replayStartTime": this.replayStartTime,
        "batchStartUrl": this.batchStartUrl,
        "replayStartUrl": this.replayStartUrl,
        "idleExpires": this.idleExpires,
        "maxExpires": this.maxExpires,
        "tabId": tabId
    };
};
/**
 * @static
 * @param {SerializedRecording} serializedRecording
 * @param {SessionRecordingOptions} options
 * @returns {SessionRecording}
 */ $413a30192b54574f$var$SessionRecording.deserialize = function(serializedRecording, options) {
    var recording = new $413a30192b54574f$var$SessionRecording($413a30192b54574f$var$_.extend({}, options, {
        replayId: serializedRecording["replayId"],
        batchStartUrl: serializedRecording["batchStartUrl"],
        replayStartUrl: serializedRecording["replayStartUrl"],
        idleExpires: serializedRecording["idleExpires"],
        maxExpires: serializedRecording["maxExpires"],
        replayStartTime: serializedRecording["replayStartTime"],
        seqNo: serializedRecording["seqNo"],
        sharedLockStorage: options.sharedLockStorage
    }));
    return recording;
};
$413a30192b54574f$var$SessionRecording.prototype._sendRequest = function(currentReplayId, reqParams, reqBody, callback) {
    var onSuccess = (function(response, responseBody) {
        // Update batch specific props only if the request was successful to guarantee ordering.
        // RequestBatcher will always flush the next batch after the previous one succeeds.
        // extra check to see if the replay ID has changed so that we don't increment the seqNo on the wrong replay
        if (response.status === 200 && this.replayId === currentReplayId) {
            this.seqNo++;
            this.batchStartUrl = $413a30192b54574f$var$_.info.currentUrl();
        }
        this._onBatchSent();
        callback({
            status: 0,
            httpStatusCode: response.status,
            responseBody: responseBody,
            retryAfter: response.headers.get("Retry-After")
        });
    }).bind(this);
    var apiHost = this._mixpanel.get_api_host && this._mixpanel.get_api_host("record") || this.getConfig("api_host");
    $413a30192b54574f$var$win["fetch"](apiHost + "/" + this.getConfig("api_routes")["record"] + "?" + new URLSearchParams(reqParams), {
        "method": "POST",
        "headers": {
            "Authorization": "Basic " + btoa(this.getConfig("token") + ":"),
            "Content-Type": "application/octet-stream"
        },
        "body": reqBody
    }).then(function(response) {
        response.json().then(function(responseBody) {
            onSuccess(response, responseBody);
        }).catch(function(error) {
            callback({
                error: error
            });
        });
    }).catch(function(error) {
        callback({
            error: error,
            httpStatusCode: 0
        });
    });
};
$413a30192b54574f$var$SessionRecording.prototype._flushEvents = $413a30192b54574f$var$addOptOutCheckMixpanelLib(function(data, options, callback) {
    var numEvents = data.length;
    if (numEvents > 0) {
        var replayId = this.replayId;
        // each rrweb event has a timestamp - leverage those to get time properties
        var batchStartTime = Infinity;
        var batchEndTime = -Infinity;
        var hasFullSnapshot = false;
        for(var i = 0; i < numEvents; i++){
            batchStartTime = Math.min(batchStartTime, data[i].timestamp);
            batchEndTime = Math.max(batchEndTime, data[i].timestamp);
            if (data[i].type === $413a30192b54574f$var$EventType.FullSnapshot) hasFullSnapshot = true;
        }
        if (this.seqNo === 0) {
            if (!hasFullSnapshot) {
                callback({
                    error: "First batch does not contain a full snapshot. Aborting recording."
                });
                this.stopRecording(true);
                return;
            }
            this.replayStartTime = batchStartTime;
        } else if (!this.replayStartTime) {
            this.reportError("Replay start time not set but seqNo is not 0. Using current batch start time as a fallback.");
            this.replayStartTime = batchStartTime;
        }
        var replayLengthMs = batchEndTime - this.replayStartTime;
        var reqParams = {
            "$current_url": this.batchStartUrl,
            "$lib_version": $413a30192b54574f$var$Config.LIB_VERSION,
            "batch_start_time": batchStartTime / 1000,
            "mp_lib": "web",
            "replay_id": replayId,
            "replay_length_ms": replayLengthMs,
            "replay_start_time": this.replayStartTime / 1000,
            "replay_start_url": this.replayStartUrl,
            "seq": this.seqNo
        };
        var eventsJson = JSON.stringify(data);
        Object.assign(reqParams, this.getUserIdInfo());
        if ($413a30192b54574f$var$CompressionStream) {
            var jsonStream = new Blob([
                eventsJson
            ], {
                type: "application/json"
            }).stream();
            var gzipStream = jsonStream.pipeThrough(new $413a30192b54574f$var$CompressionStream("gzip"));
            new Response(gzipStream).blob().then((function(compressedBlob) {
                reqParams["format"] = "gzip";
                this._sendRequest(replayId, reqParams, compressedBlob, callback);
            }).bind(this));
        } else {
            reqParams["format"] = "body";
            this._sendRequest(replayId, reqParams, eventsJson, callback);
        }
    }
});
$413a30192b54574f$var$SessionRecording.prototype.reportError = function(msg, err) {
    $413a30192b54574f$var$logger$3.error.apply($413a30192b54574f$var$logger$3.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.getConfig("error_reporter")(msg, err);
    } catch (err) {
        $413a30192b54574f$var$logger$3.error(err);
    }
};
/**
 * Module for handling the storage and retrieval of recording metadata as well as any active recordings.
 * Makes sure that only one tab can be recording at a time.
 */ var $413a30192b54574f$var$RecordingRegistry = function(options) {
    /** @type {IDBStorageWrapper} */ this.idb = new $413a30192b54574f$var$IDBStorageWrapper($413a30192b54574f$var$RECORDING_REGISTRY_STORE_NAME);
    this.errorReporter = options.errorReporter;
    this.mixpanelInstance = options.mixpanelInstance;
    this.sharedLockStorage = options.sharedLockStorage;
};
$413a30192b54574f$var$RecordingRegistry.prototype.isPersistenceEnabled = function() {
    return !this.mixpanelInstance.get_config("disable_persistence");
};
$413a30192b54574f$var$RecordingRegistry.prototype.handleError = function(err) {
    this.errorReporter("IndexedDB error: ", err);
};
/**
 * @param {import('./session-recording').SerializedRecording} serializedRecording
 */ $413a30192b54574f$var$RecordingRegistry.prototype.setActiveRecording = function(serializedRecording) {
    if (!this.isPersistenceEnabled()) return $413a30192b54574f$var$PromisePolyfill.resolve();
    var tabId = serializedRecording["tabId"];
    if (!tabId) {
        console.warn("No tab ID is set, cannot persist recording metadata.");
        return $413a30192b54574f$var$PromisePolyfill.resolve();
    }
    return this.idb.init().then((function() {
        return this.idb.setItem(tabId, serializedRecording);
    }).bind(this)).catch(this.handleError.bind(this));
};
/**
 * @returns {Promise<import('./session-recording').SerializedRecording>}
 */ $413a30192b54574f$var$RecordingRegistry.prototype.getActiveRecording = function() {
    if (!this.isPersistenceEnabled()) return $413a30192b54574f$var$PromisePolyfill.resolve(null);
    return this.idb.init().then((function() {
        return this.idb.getItem(this.mixpanelInstance.get_tab_id());
    }).bind(this)).then((function(serializedRecording) {
        return $413a30192b54574f$var$isRecordingExpired(serializedRecording) ? null : serializedRecording;
    }).bind(this)).catch(this.handleError.bind(this));
};
$413a30192b54574f$var$RecordingRegistry.prototype.clearActiveRecording = function() {
    if (this.isPersistenceEnabled()) // mark recording as expired instead of deleting it in case the page unloads mid-flush and doesn't make it to ingestion.
    // this will ensure the next pageload will flush the remaining events, but not try to continue the recording.
    return this.markActiveRecordingExpired();
    else return this.deleteActiveRecording();
};
$413a30192b54574f$var$RecordingRegistry.prototype.markActiveRecordingExpired = function() {
    return this.getActiveRecording().then((function(serializedRecording) {
        if (serializedRecording) {
            serializedRecording["maxExpires"] = 0;
            return this.setActiveRecording(serializedRecording);
        }
    }).bind(this)).catch(this.handleError.bind(this));
};
$413a30192b54574f$var$RecordingRegistry.prototype.deleteActiveRecording = function() {
    // avoid initializing IDB if this registry instance hasn't already written a recording
    if (this.idb.isInitialized()) return this.idb.removeItem(this.mixpanelInstance.get_tab_id()).catch(this.handleError.bind(this));
    else return $413a30192b54574f$var$PromisePolyfill.resolve();
};
/**
 * Flush any inactive recordings from the registry to minimize data loss.
 * The main idea here is that we can flush remaining rrweb events on the next page load if a tab is closed mid-batch.
 */ $413a30192b54574f$var$RecordingRegistry.prototype.flushInactiveRecordings = function() {
    if (!this.isPersistenceEnabled()) return $413a30192b54574f$var$PromisePolyfill.resolve([]);
    return this.idb.init().then((function() {
        return this.idb.getAll();
    }).bind(this)).then((function(serializedRecordings) {
        // clean up any expired recordings from the registry, non-expired ones may be active in other tabs
        var unloadPromises = serializedRecordings.filter(function(serializedRecording) {
            return $413a30192b54574f$var$isRecordingExpired(serializedRecording);
        }).map((function(serializedRecording) {
            var sessionRecording = $413a30192b54574f$var$SessionRecording.deserialize(serializedRecording, {
                mixpanelInstance: this.mixpanelInstance,
                sharedLockStorage: this.sharedLockStorage
            });
            return sessionRecording.unloadPersistedData().then((function() {
                // expired recording was successfully flushed, we can clean it up from the registry
                return this.idb.removeItem(serializedRecording["tabId"]);
            }).bind(this)).catch(this.handleError.bind(this));
        }).bind(this));
        return $413a30192b54574f$var$PromisePolyfill.all(unloadPromises);
    }).bind(this)).catch(this.handleError.bind(this));
};
var $413a30192b54574f$var$logger$2 = $413a30192b54574f$var$console_with_prefix("recorder");
/**
 * Recorder API: bundles rrweb and and exposes methods to start and stop recordings.
 * @param {Object} [options.mixpanelInstance] - reference to the core MixpanelLib
*/ var $413a30192b54574f$var$MixpanelRecorder = function(mixpanelInstance, rrwebRecord, sharedLockStorage) {
    this.mixpanelInstance = mixpanelInstance;
    this.rrwebRecord = rrwebRecord || $413a30192b54574f$var$record;
    this.sharedLockStorage = sharedLockStorage;
    /**
     * @member {import('./registry').RecordingRegistry}
     */ this.recordingRegistry = new $413a30192b54574f$var$RecordingRegistry({
        mixpanelInstance: this.mixpanelInstance,
        errorReporter: $413a30192b54574f$var$logger$2.error,
        sharedLockStorage: sharedLockStorage
    });
    this._flushInactivePromise = this.recordingRegistry.flushInactiveRecordings();
    this.activeRecording = null;
    this.stopRecordingInProgress = false;
};
$413a30192b54574f$var$MixpanelRecorder.prototype.startRecording = function(options) {
    options = options || {};
    if (this.activeRecording && !this.activeRecording.isRrwebStopped()) {
        $413a30192b54574f$var$logger$2.log("Recording already in progress, skipping startRecording.");
        return;
    }
    var onIdleTimeout = (function() {
        $413a30192b54574f$var$logger$2.log("Idle timeout reached, restarting recording.");
        this.resetRecording();
    }).bind(this);
    var onMaxLengthReached = (function() {
        $413a30192b54574f$var$logger$2.log("Max recording length reached, stopping recording.");
        this.resetRecording();
    }).bind(this);
    var onBatchSent = (function() {
        this.recordingRegistry.setActiveRecording(this.activeRecording.serialize());
        this["__flushPromise"] = this.activeRecording.batcher._flushPromise;
    }).bind(this);
    /**
     * @type {import('./session-recording').SessionRecordingOptions}
     */ var sessionRecordingOptions = {
        mixpanelInstance: this.mixpanelInstance,
        onBatchSent: onBatchSent,
        onIdleTimeout: onIdleTimeout,
        onMaxLengthReached: onMaxLengthReached,
        replayId: $413a30192b54574f$var$_.UUID(),
        rrwebRecord: this.rrwebRecord,
        sharedLockStorage: this.sharedLockStorage
    };
    if (options.activeSerializedRecording) this.activeRecording = $413a30192b54574f$var$SessionRecording.deserialize(options.activeSerializedRecording, sessionRecordingOptions);
    else this.activeRecording = new $413a30192b54574f$var$SessionRecording(sessionRecordingOptions);
    this.activeRecording.startRecording(options.shouldStopBatcher);
    return this.recordingRegistry.setActiveRecording(this.activeRecording.serialize());
};
$413a30192b54574f$var$MixpanelRecorder.prototype.stopRecording = function() {
    // Prevents activeSerializedRecording from being reused when stopping the recording.
    this.stopRecordingInProgress = true;
    return this._stopCurrentRecording(false, true).then((function() {
        return this.recordingRegistry.clearActiveRecording();
    }).bind(this)).then((function() {
        this.stopRecordingInProgress = false;
    }).bind(this));
};
$413a30192b54574f$var$MixpanelRecorder.prototype.pauseRecording = function() {
    return this._stopCurrentRecording(false);
};
$413a30192b54574f$var$MixpanelRecorder.prototype._stopCurrentRecording = function(skipFlush, disableActiveRecording) {
    if (this.activeRecording) {
        var stopRecordingPromise = this.activeRecording.stopRecording(skipFlush);
        if (disableActiveRecording) this.activeRecording = null;
        return stopRecordingPromise;
    }
    return $413a30192b54574f$var$PromisePolyfill.resolve();
};
$413a30192b54574f$var$MixpanelRecorder.prototype.resumeRecording = function(startNewIfInactive) {
    if (this.activeRecording && this.activeRecording.isRrwebStopped()) {
        this.activeRecording.startRecording(false);
        return $413a30192b54574f$var$PromisePolyfill.resolve(null);
    }
    return this.recordingRegistry.getActiveRecording().then((function(activeSerializedRecording) {
        if (activeSerializedRecording && !this.stopRecordingInProgress) return this.startRecording({
            activeSerializedRecording: activeSerializedRecording
        });
        else if (startNewIfInactive) return this.startRecording({
            shouldStopBatcher: false
        });
        else {
            $413a30192b54574f$var$logger$2.log("No resumable recording found.");
            return null;
        }
    }).bind(this));
};
$413a30192b54574f$var$MixpanelRecorder.prototype.resetRecording = function() {
    this.stopRecording();
    this.startRecording({
        shouldStopBatcher: true
    });
};
$413a30192b54574f$var$MixpanelRecorder.prototype.getActiveReplayId = function() {
    if (this.activeRecording && !this.activeRecording.isRrwebStopped()) return this.activeRecording.replayId;
    else return null;
};
// getter so that older mixpanel-core versions can still retrieve the replay ID
// when pulling the latest recorder bundle from the CDN
Object.defineProperty($413a30192b54574f$var$MixpanelRecorder.prototype, "replayId", {
    get: function() {
        return this.getActiveReplayId();
    }
});
$413a30192b54574f$var$win["__mp_recorder"] = $413a30192b54574f$var$MixpanelRecorder;
// stateless utils
// mostly from https://github.com/mixpanel/mixpanel-js/blob/989ada50f518edab47b9c4fd9535f9fbd5ec5fc0/src/autotrack-utils.js
var $413a30192b54574f$var$EV_CHANGE = "change";
var $413a30192b54574f$var$EV_CLICK = "click";
var $413a30192b54574f$var$EV_HASHCHANGE = "hashchange";
var $413a30192b54574f$var$EV_INPUT = "input";
var $413a30192b54574f$var$EV_LOAD = "load";
var $413a30192b54574f$var$EV_MP_LOCATION_CHANGE = "mp_locationchange";
var $413a30192b54574f$var$EV_POPSTATE = "popstate";
// TODO scrollend isn't available in Safari: document or polyfill?
var $413a30192b54574f$var$EV_SCROLLEND = "scrollend";
var $413a30192b54574f$var$EV_SCROLL = "scroll";
var $413a30192b54574f$var$EV_SELECT = "select";
var $413a30192b54574f$var$EV_SUBMIT = "submit";
var $413a30192b54574f$var$EV_TOGGLE = "toggle";
var $413a30192b54574f$var$EV_VISIBILITYCHANGE = "visibilitychange";
var $413a30192b54574f$var$CLICK_EVENT_PROPS = [
    "clientX",
    "clientY",
    "offsetX",
    "offsetY",
    "pageX",
    "pageY",
    "screenX",
    "screenY",
    "x",
    "y"
];
var $413a30192b54574f$var$OPT_IN_CLASSES = [
    "mp-include"
];
var $413a30192b54574f$var$OPT_OUT_CLASSES = [
    "mp-no-track"
];
var $413a30192b54574f$var$SENSITIVE_DATA_CLASSES = $413a30192b54574f$var$OPT_OUT_CLASSES.concat([
    "mp-sensitive"
]);
var $413a30192b54574f$var$TRACKED_ATTRS = [
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "href",
    "name",
    "role",
    "title",
    "type"
];
var $413a30192b54574f$var$INTERACTIVE_ARIA_ROLES = {
    "button": true,
    "checkbox": true,
    "combobox": true,
    "grid": true,
    "link": true,
    "listbox": true,
    "menu": true,
    "menubar": true,
    "menuitem": true,
    "menuitemcheckbox": true,
    "menuitemradio": true,
    "navigation": true,
    "option": true,
    "radio": true,
    "radiogroup": true,
    "searchbox": true,
    "slider": true,
    "spinbutton": true,
    "switch": true,
    "tab": true,
    "tablist": true,
    "textbox": true,
    "tree": true,
    "treegrid": true,
    "treeitem": true
};
var $413a30192b54574f$var$ALWAYS_NON_INTERACTIVE_TAGS = {
    // Document metadata
    "base": true,
    "head": true,
    "html": true,
    "link": true,
    "meta": true,
    "script": true,
    "style": true,
    "title": true,
    // Text formatting
    "br": true,
    "hr": true,
    "wbr": true,
    // Other
    "noscript": true,
    "picture": true,
    "source": true,
    "template": true,
    "track": true
};
// Common container tags that need additional checks
var $413a30192b54574f$var$TEXT_CONTAINER_TAGS = {
    "article": true,
    "div": true,
    "h1": true,
    "h2": true,
    "h3": true,
    "h4": true,
    "h5": true,
    "h6": true,
    "p": true,
    "section": true,
    "span": true
};
var $413a30192b54574f$var$EVENT_HANDLER_ATTRIBUTES = [
    "onclick",
    "onmousedown",
    "onmouseup",
    "onpointerdown",
    "onpointerup",
    "ontouchend",
    "ontouchstart"
];
var $413a30192b54574f$var$MAX_DEPTH = 5;
var $413a30192b54574f$var$logger$1 = $413a30192b54574f$var$console_with_prefix("autocapture");
function $413a30192b54574f$var$getClasses(el) {
    var classes = {};
    var classList = $413a30192b54574f$var$getClassName(el).split(" ");
    for(var i = 0; i < classList.length; i++){
        var cls = classList[i];
        if (cls) classes[cls] = true;
    }
    return classes;
}
/*
 * Get the className of an element, accounting for edge cases where element.className is an object
 * @param {Element} el - element to get the className of
 * @returns {string} the element's class
 */ function $413a30192b54574f$var$getClassName(el) {
    switch(typeof el.className){
        case "string":
            return el.className;
        case "object":
            return el.className.baseVal || el.getAttribute("class") || "";
        default:
            return "";
    }
}
function $413a30192b54574f$var$getPreviousElementSibling(el) {
    if (el.previousElementSibling) return el.previousElementSibling;
    else {
        do el = el.previousSibling;
        while (el && !$413a30192b54574f$var$isElementNode(el));
        return el;
    }
}
function $413a30192b54574f$var$getPropertiesFromElement(el, ev, blockAttrsSet, extraAttrs, allowElementCallback, allowSelectors) {
    var props = {
        "$classes": $413a30192b54574f$var$getClassName(el).split(" "),
        "$tag_name": el.tagName.toLowerCase()
    };
    var elId = el.id;
    if (elId) props["$id"] = elId;
    if ($413a30192b54574f$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors)) $413a30192b54574f$var$_.each($413a30192b54574f$var$TRACKED_ATTRS.concat(extraAttrs), function(attr) {
        if (el.hasAttribute(attr) && !blockAttrsSet[attr]) {
            var attrVal = el.getAttribute(attr);
            if ($413a30192b54574f$var$shouldTrackValue(attrVal)) props["$attr-" + attr] = attrVal;
        }
    });
    var nthChild = 1;
    var nthOfType = 1;
    var currentElem = el;
    while(currentElem = $413a30192b54574f$var$getPreviousElementSibling(currentElem)){
        nthChild++;
        if (currentElem.tagName === el.tagName) nthOfType++;
    }
    props["$nth_child"] = nthChild;
    props["$nth_of_type"] = nthOfType;
    return props;
}
function $413a30192b54574f$var$getPropsForDOMEvent(ev, config) {
    var allowElementCallback = config.allowElementCallback;
    var allowSelectors = config.allowSelectors || [];
    var blockAttrs = config.blockAttrs || [];
    var blockElementCallback = config.blockElementCallback;
    var blockSelectors = config.blockSelectors || [];
    var captureTextContent = config.captureTextContent || false;
    var captureExtraAttrs = config.captureExtraAttrs || [];
    var capturedForHeatMap = config.capturedForHeatMap || false;
    // convert array to set every time, as the config may have changed
    var blockAttrsSet = {};
    $413a30192b54574f$var$_.each(blockAttrs, function(attr) {
        blockAttrsSet[attr] = true;
    });
    var props = null;
    var target = typeof ev.target === "undefined" ? ev.srcElement : ev.target;
    if ($413a30192b54574f$var$isTextNode(target)) target = target.parentNode;
    if ($413a30192b54574f$var$shouldTrackDomEvent(target, ev) && $413a30192b54574f$var$isElementAllowed(target, ev, allowElementCallback, allowSelectors) && !$413a30192b54574f$var$isElementBlocked(target, ev, blockElementCallback, blockSelectors)) {
        var targetElementList = [
            target
        ];
        var curEl = target;
        while(curEl.parentNode && !$413a30192b54574f$var$isTag(curEl, "body")){
            targetElementList.push(curEl.parentNode);
            curEl = curEl.parentNode;
        }
        var elementsJson = [];
        var href, explicitNoTrack = false;
        $413a30192b54574f$var$_.each(targetElementList, function(el) {
            var shouldTrackDetails = $413a30192b54574f$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors);
            // if the element or a parent element is an anchor tag
            // include the href as a property
            if (!blockAttrsSet["href"] && el.tagName.toLowerCase() === "a") {
                href = el.getAttribute("href");
                href = shouldTrackDetails && $413a30192b54574f$var$shouldTrackValue(href) && href;
            }
            if ($413a30192b54574f$var$isElementBlocked(el, ev, blockElementCallback, blockSelectors)) explicitNoTrack = true;
            elementsJson.push($413a30192b54574f$var$getPropertiesFromElement(el, ev, blockAttrsSet, captureExtraAttrs, allowElementCallback, allowSelectors));
        }, this);
        if (!explicitNoTrack) {
            var docElement = $413a30192b54574f$var$document$1["documentElement"];
            props = {
                "$event_type": ev.type,
                "$host": $413a30192b54574f$var$win.location.host,
                "$pathname": $413a30192b54574f$var$win.location.pathname,
                "$elements": elementsJson,
                "$el_attr__href": href,
                "$viewportHeight": Math.max(docElement["clientHeight"], $413a30192b54574f$var$win["innerHeight"] || 0),
                "$viewportWidth": Math.max(docElement["clientWidth"], $413a30192b54574f$var$win["innerWidth"] || 0),
                "$pageHeight": $413a30192b54574f$var$document$1["body"]["offsetHeight"] || 0,
                "$pageWidth": $413a30192b54574f$var$document$1["body"]["offsetWidth"] || 0
            };
            $413a30192b54574f$var$_.each(captureExtraAttrs, function(attr) {
                if (!blockAttrsSet[attr] && target.hasAttribute(attr)) {
                    var attrVal = target.getAttribute(attr);
                    if ($413a30192b54574f$var$shouldTrackValue(attrVal)) props["$el_attr__" + attr] = attrVal;
                }
            });
            if (captureTextContent) {
                elementText = $413a30192b54574f$var$getSafeText(target, ev, allowElementCallback, allowSelectors);
                if (elementText && elementText.length) props["$el_text"] = elementText;
            }
            if (ev.type === $413a30192b54574f$var$EV_CLICK) {
                $413a30192b54574f$var$_.each($413a30192b54574f$var$CLICK_EVENT_PROPS, function(prop) {
                    if (prop in ev) props["$" + prop] = ev[prop];
                });
                if (capturedForHeatMap) props["$captured_for_heatmap"] = true;
                target = $413a30192b54574f$var$guessRealClickTarget(ev);
            }
            // prioritize text content from "real" click target if different from original target
            if (captureTextContent) {
                var elementText = $413a30192b54574f$var$getSafeText(target, ev, allowElementCallback, allowSelectors);
                if (elementText && elementText.length) props["$el_text"] = elementText;
            }
            if (target) {
                // target may have been recalculated; check allowlists and blocklists again
                if (!$413a30192b54574f$var$isElementAllowed(target, ev, allowElementCallback, allowSelectors) || $413a30192b54574f$var$isElementBlocked(target, ev, blockElementCallback, blockSelectors)) return null;
                var targetProps = $413a30192b54574f$var$getPropertiesFromElement(target, ev, blockAttrsSet, captureExtraAttrs, allowElementCallback, allowSelectors);
                props["$target"] = targetProps;
                // pull up more props onto main event props
                props["$el_classes"] = targetProps["$classes"];
                $413a30192b54574f$var$_.extend(props, $413a30192b54574f$var$_.strip_empty_properties({
                    "$el_id": targetProps["$id"],
                    "$el_tag_name": targetProps["$tag_name"]
                }));
            }
        }
    }
    return props;
}
/**
 * Get the direct text content of an element, protecting against sensitive data collection.
 * Concats textContent of each of the element's text node children; this avoids potential
 * collection of sensitive data that could happen if we used element.textContent and the
 * element had sensitive child elements, since element.textContent includes child content.
 * Scrubs values that look like they could be sensitive (i.e. cc or ssn number).
 * @param {Element} el - element to get the text of
 * @param {Array<string>} allowSelectors - CSS selectors for elements that should be included
 * @returns {string} the element's direct text content
 */ function $413a30192b54574f$var$getSafeText(el, ev, allowElementCallback, allowSelectors) {
    var elText = "";
    if ($413a30192b54574f$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors) && el.childNodes && el.childNodes.length) $413a30192b54574f$var$_.each(el.childNodes, function(child) {
        if ($413a30192b54574f$var$isTextNode(child) && child.textContent) elText += $413a30192b54574f$var$_.trim(child.textContent)// scrub potentially sensitive values
        .split(/(\s+)/).filter($413a30192b54574f$var$shouldTrackValue).join("")// normalize whitespace
        .replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ")// truncate
        .substring(0, 255);
    });
    return $413a30192b54574f$var$_.trim(elText);
}
function $413a30192b54574f$var$guessRealClickTarget(ev) {
    var target = ev.target;
    var composedPath = ev["composedPath"]();
    for(var i = 0; i < composedPath.length; i++){
        var node = composedPath[i];
        if ($413a30192b54574f$var$isTag(node, "a") || $413a30192b54574f$var$isTag(node, "button") || $413a30192b54574f$var$isTag(node, "input") || $413a30192b54574f$var$isTag(node, "select") || node.getAttribute && node.getAttribute("role") === "button") {
            target = node;
            break;
        }
        if (node === target) break;
    }
    return target;
}
function $413a30192b54574f$var$isElementAllowed(el, ev, allowElementCallback, allowSelectors) {
    if (allowElementCallback) try {
        if (!allowElementCallback(el, ev)) return false;
    } catch (err) {
        $413a30192b54574f$var$logger$1.critical("Error while checking element in allowElementCallback", err);
        return false;
    }
    if (!allowSelectors.length) // no allowlist; all elements are fair game
    return true;
    for(var i = 0; i < allowSelectors.length; i++){
        var sel = allowSelectors[i];
        try {
            if (el["matches"](sel)) return true;
        } catch (err) {
            $413a30192b54574f$var$logger$1.critical("Error while checking selector: " + sel, err);
        }
    }
    return false;
}
function $413a30192b54574f$var$isElementBlocked(el, ev, blockElementCallback, blockSelectors) {
    var i;
    if (blockElementCallback) try {
        if (blockElementCallback(el, ev)) return true;
    } catch (err) {
        $413a30192b54574f$var$logger$1.critical("Error while checking element in blockElementCallback", err);
        return true;
    }
    if (blockSelectors && blockSelectors.length) // programmatically prevent tracking of elements that match CSS selectors
    for(i = 0; i < blockSelectors.length; i++){
        var sel = blockSelectors[i];
        try {
            if (el["matches"](sel)) return true;
        } catch (err) {
            $413a30192b54574f$var$logger$1.critical("Error while checking selector: " + sel, err);
        }
    }
    // allow users to programmatically prevent tracking of elements by adding default classes such as 'mp-no-track'
    var classes = $413a30192b54574f$var$getClasses(el);
    for(i = 0; i < $413a30192b54574f$var$OPT_OUT_CLASSES.length; i++){
        if (classes[$413a30192b54574f$var$OPT_OUT_CLASSES[i]]) return true;
    }
    return false;
}
/*
 * Check whether a DOM node has nodeType Node.ELEMENT_NODE
 * @param {Node} node - node to check
 * @returns {boolean} whether node is of the correct nodeType
 */ function $413a30192b54574f$var$isElementNode(node) {
    return node && node.nodeType === 1; // Node.ELEMENT_NODE - use integer constant for browser portability
}
/*
 * Check whether an element is of a given tag type.
 * Due to potential reference discrepancies (such as the webcomponents.js polyfill),
 * we want to match tagNames instead of specific references because something like
 * element === document.body won't always work because element might not be a native
 * element.
 * @param {Element} el - element to check
 * @param {string} tag - tag name (e.g., "div")
 * @returns {boolean} whether el is of the given tag type
 */ function $413a30192b54574f$var$isTag(el, tag) {
    return el && el.tagName && el.tagName.toLowerCase() === tag.toLowerCase();
}
/*
 * Check whether a DOM node is a TEXT_NODE
 * @param {Node} node - node to check
 * @returns {boolean} whether node is of type Node.TEXT_NODE
 */ function $413a30192b54574f$var$isTextNode(node) {
    return node && node.nodeType === 3; // Node.TEXT_NODE - use integer constant for browser portability
}
function $413a30192b54574f$var$minDOMApisSupported() {
    try {
        var testEl = $413a30192b54574f$var$document$1.createElement("div");
        return !!testEl["matches"];
    } catch (err) {
        return false;
    }
}
function $413a30192b54574f$var$weakSetSupported() {
    return typeof WeakSet !== "undefined";
}
/*
 * Check whether a DOM event should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Event} ev - event to check
 * @returns {boolean} whether the event should be tracked
 */ function $413a30192b54574f$var$shouldTrackDomEvent(el, ev) {
    if (!el || $413a30192b54574f$var$isTag(el, "html") || !$413a30192b54574f$var$isElementNode(el)) return false;
    var tag = el.tagName.toLowerCase();
    switch(tag){
        case "form":
            return ev.type === $413a30192b54574f$var$EV_SUBMIT;
        case "input":
            if ([
                "button",
                "submit"
            ].indexOf(el.getAttribute("type")) === -1) return ev.type === $413a30192b54574f$var$EV_CHANGE;
            else return ev.type === $413a30192b54574f$var$EV_CLICK;
        case "select":
        case "textarea":
            return ev.type === $413a30192b54574f$var$EV_CHANGE;
        default:
            return ev.type === $413a30192b54574f$var$EV_CLICK;
    }
}
/*
 * Check whether a DOM element should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Array<string>} allowSelectors - CSS selectors for elements that should be included
 * @returns {boolean} whether the element should be tracked
 */ function $413a30192b54574f$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors) {
    var i;
    if (!$413a30192b54574f$var$isElementAllowed(el, ev, allowElementCallback, allowSelectors)) return false;
    for(var curEl = el; curEl.parentNode && !$413a30192b54574f$var$isTag(curEl, "body"); curEl = curEl.parentNode){
        var classes = $413a30192b54574f$var$getClasses(curEl);
        for(i = 0; i < $413a30192b54574f$var$SENSITIVE_DATA_CLASSES.length; i++){
            if (classes[$413a30192b54574f$var$SENSITIVE_DATA_CLASSES[i]]) return false;
        }
    }
    var elClasses = $413a30192b54574f$var$getClasses(el);
    for(i = 0; i < $413a30192b54574f$var$OPT_IN_CLASSES.length; i++){
        if (elClasses[$413a30192b54574f$var$OPT_IN_CLASSES[i]]) return true;
    }
    // don't send data from inputs or similar elements since there will always be
    // a risk of clientside javascript placing sensitive data in attributes
    if ($413a30192b54574f$var$isTag(el, "input") || $413a30192b54574f$var$isTag(el, "select") || $413a30192b54574f$var$isTag(el, "textarea") || el.getAttribute("contenteditable") === "true") return false;
    // don't include hidden or password fields
    var type = el.type || "";
    if (typeof type === "string") switch(type.toLowerCase()){
        case "hidden":
            return false;
        case "password":
            return false;
    }
    // filter out data from fields that look like sensitive fields
    var name = el.name || el.id || "";
    if (typeof name === "string") {
        var sensitiveNameRegex = /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i;
        if (sensitiveNameRegex.test(name.replace(/[^a-zA-Z0-9]/g, ""))) return false;
    }
    return true;
}
/*
 * Check whether a string value should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {string} value - string value to check
 * @returns {boolean} whether the element should be tracked
 */ function $413a30192b54574f$var$shouldTrackValue(value) {
    if (value === null || $413a30192b54574f$var$_.isUndefined(value)) return false;
    if (typeof value === "string") {
        value = $413a30192b54574f$var$_.trim(value);
        // check to see if input value looks like a credit card number
        // see: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch04s20.html
        var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        if (ccRegex.test((value || "").replace(/[- ]/g, ""))) return false;
        // check to see if input value looks like a social security number
        var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
        if (ssnRegex.test(value)) return false;
    }
    return true;
}
/**
 * Creates a cross-browser compatible scroll end function with appropriate event listener.
 * For browsers that support scrollend, returns the original function with scrollend event.
 * For browsers without scrollend support, returns a debounced function that triggers
 * 100ms after the last scroll event to simulate scrollend behavior.
 * @param {Function} originalFunction - The function to call when scrolling ends
 * @returns {Object} Object containing listener function and eventType string
 * @returns {Function} returns.listener - The wrapped function to use as event listener
 * @returns {string} returns.eventType - The event type to listen for ('scrollend' or 'scroll')
 */ function $413a30192b54574f$var$getPolyfillScrollEndFunction(originalFunction) {
    var supportsScrollEnd = "onscrollend" in $413a30192b54574f$var$win;
    var polyfillFunction = $413a30192b54574f$var$safewrap(originalFunction);
    var polyfillEvent = $413a30192b54574f$var$EV_SCROLLEND;
    if (!supportsScrollEnd) {
        // Polyfill for browsers without scrollend support: wait 100ms after the last scroll event
        // https://developer.chrome.com/blog/scrollend-a-new-javascript-event
        var scrollTimer = null;
        var scrollDelayMs = 100;
        polyfillFunction = $413a30192b54574f$var$safewrap(function() {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(originalFunction, scrollDelayMs);
        });
        polyfillEvent = $413a30192b54574f$var$EV_SCROLL;
    }
    return {
        listener: polyfillFunction,
        eventType: polyfillEvent
    };
}
function $413a30192b54574f$var$hasInlineEventHandlers(element) {
    for(var i = 0; i < $413a30192b54574f$var$EVENT_HANDLER_ATTRIBUTES.length; i++){
        if (element.hasAttribute($413a30192b54574f$var$EVENT_HANDLER_ATTRIBUTES[i])) return true;
    }
    return false;
}
function $413a30192b54574f$var$hasInteractiveAriaRole(element) {
    var role = element.getAttribute("role");
    if (!role) return false;
    // Handle invalid markup where multiple roles might be specified
    // Only the first token is recognized per ARIA spec
    var primaryRole = role.trim().split(/\s+/)[0].toLowerCase();
    return $413a30192b54574f$var$INTERACTIVE_ARIA_ROLES[primaryRole];
}
function $413a30192b54574f$var$hasAnyInteractivityIndicators(element) {
    var tagName = element.tagName.toLowerCase();
    // Check for interactive HTML elements
    if (tagName === "button" || tagName === "input" || tagName === "select" || tagName === "textarea" || tagName === "details" || tagName === "dialog") return true;
    if (element.isContentEditable) return true;
    if (element.onclick || element.onmousedown || element.onmouseup || element.ontouchstart || element.ontouchend) return true;
    if ($413a30192b54574f$var$hasInlineEventHandlers(element)) return true;
    if ($413a30192b54574f$var$hasInteractiveAriaRole(element)) return true;
    if (tagName === "a" && element.hasAttribute("href")) return true;
    if (element.hasAttribute("tabindex")) return true;
    return false;
}
function $413a30192b54574f$var$isDefinitelyNonInteractive(element) {
    if (!element || !element.tagName) return true;
    var tagName = element.tagName.toLowerCase();
    // These tags are definitely non-interactive
    if ($413a30192b54574f$var$ALWAYS_NON_INTERACTIVE_TAGS[tagName]) return true;
    // For all other elements, we can only be certain they're non-interactive if they lack ALL indicators of interactivity
    // Check for any signs of interactivity
    if ($413a30192b54574f$var$hasAnyInteractivityIndicators(element)) return false;
    // Check parent chain for interactive context
    var parent = element.parentElement;
    var depth = 0;
    while(parent && depth < $413a30192b54574f$var$MAX_DEPTH){
        if ($413a30192b54574f$var$hasAnyInteractivityIndicators(parent)) return false; // Element is inside an interactive parent
        if (parent.getRootNode && parent.getRootNode() !== $413a30192b54574f$var$document$1) {
            var root = parent.getRootNode();
            if (root.host && $413a30192b54574f$var$hasAnyInteractivityIndicators(root.host)) return false; // Inside an interactive shadow host
        }
        parent = parent.parentElement;
        depth++;
    }
    // Pure text containers without any interactive context
    if ($413a30192b54574f$var$TEXT_CONTAINER_TAGS[tagName]) // These are non-interactive ONLY if they have no interactive indicators (already checked as part of hasAnyInteractivityIndicators)
    return true;
    // Default: we can't be certain it's non-interactive
    return false;
}
/** @const */ var $413a30192b54574f$var$DEFAULT_RAGE_CLICK_THRESHOLD_PX = 30;
/** @const */ var $413a30192b54574f$var$DEFAULT_RAGE_CLICK_TIMEOUT_MS = 1000;
/** @const */ var $413a30192b54574f$var$DEFAULT_RAGE_CLICK_CLICK_COUNT = 4;
function $413a30192b54574f$var$RageClickTracker() {
    this.clicks = [];
}
$413a30192b54574f$var$RageClickTracker.prototype.isRageClick = function(x, y, options) {
    options = options || {};
    var thresholdPx = options["threshold_px"] || $413a30192b54574f$var$DEFAULT_RAGE_CLICK_THRESHOLD_PX;
    var timeoutMs = options["timeout_ms"] || $413a30192b54574f$var$DEFAULT_RAGE_CLICK_TIMEOUT_MS;
    var clickCount = options["click_count"] || $413a30192b54574f$var$DEFAULT_RAGE_CLICK_CLICK_COUNT;
    var timestamp = Date.now();
    var lastClick = this.clicks[this.clicks.length - 1];
    if (lastClick && timestamp - lastClick.timestamp < timeoutMs && Math.sqrt(Math.pow(x - lastClick.x, 2) + Math.pow(y - lastClick.y, 2)) < thresholdPx) {
        this.clicks.push({
            x: x,
            y: y,
            timestamp: timestamp
        });
        if (this.clicks.length >= clickCount) {
            this.clicks = [];
            return true;
        }
    } else this.clicks = [
        {
            x: x,
            y: y,
            timestamp: timestamp
        }
    ];
    return false;
};
function $413a30192b54574f$var$ShadowDOMObserver(changeCallback, observerConfig) {
    this.changeCallback = changeCallback || function() {};
    this.observerConfig = observerConfig;
    this.observedShadowRoots = null;
    this.shadowObservers = [];
}
$413a30192b54574f$var$ShadowDOMObserver.prototype.getEventTarget = function(event) {
    if (!this.observedShadowRoots) return;
    var path = this.getComposedPath(event);
    if (path && path.length) return path[0];
    return event["target"] || event["srcElement"];
};
$413a30192b54574f$var$ShadowDOMObserver.prototype.getComposedPath = function(event) {
    if ("composedPath" in event) return event["composedPath"]();
    return [];
};
$413a30192b54574f$var$ShadowDOMObserver.prototype.observeFromEvent = function(event) {
    if (!this.observedShadowRoots) return;
    var path = this.getComposedPath(event);
    // Check each element in path for shadow roots
    for(var i = 0; i < path.length; i++){
        var element = path[i];
        if (element && element.shadowRoot) this.observeShadowRoot(element.shadowRoot);
    }
};
$413a30192b54574f$var$ShadowDOMObserver.prototype.observeShadowRoot = function(shadowRoot) {
    if (!this.observedShadowRoots || this.observedShadowRoots.has(shadowRoot)) return;
    var self = this;
    try {
        this.observedShadowRoots.add(shadowRoot);
        var observer = new window.MutationObserver(function() {
            self.changeCallback();
        });
        observer.observe(shadowRoot, this.observerConfig);
        this.shadowObservers.push(observer);
    } catch (e) {
        $413a30192b54574f$var$logger$1.critical("Error while observing shadow root", e);
    }
};
$413a30192b54574f$var$ShadowDOMObserver.prototype.start = function() {
    if (this.observedShadowRoots) return;
    if (!$413a30192b54574f$var$weakSetSupported()) {
        $413a30192b54574f$var$logger$1.critical("Shadow DOM observation unavailable: WeakSet not supported");
        return;
    }
    this.observedShadowRoots = new WeakSet();
};
$413a30192b54574f$var$ShadowDOMObserver.prototype.stop = function() {
    if (!this.observedShadowRoots) return;
    for(var i = 0; i < this.shadowObservers.length; i++)try {
        this.shadowObservers[i].disconnect();
    } catch (e) {
        $413a30192b54574f$var$logger$1.critical("Error while disconnecting shadow DOM observer", e);
    }
    this.shadowObservers = [];
    this.observedShadowRoots = null;
};
/** @const */ var $413a30192b54574f$var$DEFAULT_DEAD_CLICK_TIMEOUT_MS = 500;
/** @const */ var $413a30192b54574f$var$INTERACTION_EVENTS = [
    $413a30192b54574f$var$EV_CHANGE,
    $413a30192b54574f$var$EV_INPUT,
    $413a30192b54574f$var$EV_SUBMIT,
    $413a30192b54574f$var$EV_SELECT,
    $413a30192b54574f$var$EV_TOGGLE
];
/** @const */ var $413a30192b54574f$var$LAYOUT_EVENTS = [
    $413a30192b54574f$var$EV_SCROLLEND
];
/** @const */ var $413a30192b54574f$var$NAVIGATION_EVENTS = [
    $413a30192b54574f$var$EV_HASHCHANGE
];
/** @const */ var $413a30192b54574f$var$MUTATION_OBSERVER_CONFIG = {
    characterData: true,
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [
        "style",
        "class",
        "hidden",
        "checked",
        "selected",
        "value",
        "display",
        "visibility"
    ]
};
function $413a30192b54574f$var$DeadClickTracker(onDeadClickCallback) {
    this.eventListeners = [];
    this.mutationObserver = null;
    this.shadowDOMObserver = null;
    this.isTracking = false;
    this.lastChangeEventTimestamp = 0;
    this.pendingClicks = [];
    this.onDeadClickCallback = onDeadClickCallback;
    this.processingActive = false;
    this.processingTimeout = null;
}
$413a30192b54574f$var$DeadClickTracker.prototype.addClick = function(event) {
    var element = this.shadowDOMObserver && this.shadowDOMObserver.getEventTarget(event);
    if (!element) element = event["target"] || event["srcElement"];
    if (!element || $413a30192b54574f$var$isDefinitelyNonInteractive(element)) return false;
    if (this.shadowDOMObserver) this.shadowDOMObserver.observeFromEvent(event);
    this.pendingClicks.push({
        element: element,
        event: event,
        timestamp: Date.now()
    });
    return true;
};
$413a30192b54574f$var$DeadClickTracker.prototype.trackClick = function(event, config) {
    if (!this.isTracking) return false;
    var added = this.addClick(event);
    if (added) this.triggerProcessing(config);
    return added;
};
$413a30192b54574f$var$DeadClickTracker.prototype.getDeadClicks = function(config) {
    if (this.pendingClicks.length === 0) return [];
    var timeoutMs = config["timeout_ms"];
    var now = Date.now();
    var clicksToEvaluate = this.pendingClicks.slice(); // Copy array
    this.pendingClicks = []; // Clear original
    var deadClicks = [];
    for(var i = 0; i < clicksToEvaluate.length; i++){
        var click = clicksToEvaluate[i];
        if (now - click.timestamp >= timeoutMs) // Click has exceeded timeout, check if it's dead by looking for changes after this specific click
        {
            if (!this.hasChangesAfter(click.timestamp)) deadClicks.push(click);
        } else // Still pending - add back
        this.pendingClicks.push(click);
    }
    return deadClicks;
};
$413a30192b54574f$var$DeadClickTracker.prototype.hasChangesAfter = function(timestamp) {
    // 100ms tolerance for race condition between when we record the click and the change event
    return this.lastChangeEventTimestamp >= timestamp - 100;
};
$413a30192b54574f$var$DeadClickTracker.prototype.recordChangeEvent = function() {
    this.lastChangeEventTimestamp = Date.now();
};
$413a30192b54574f$var$DeadClickTracker.prototype.triggerProcessing = function(config) {
    // Prevent multiple concurrent processing chains
    if (this.processingActive) return;
    this.processingActive = true;
    this.processRecursively(config);
};
$413a30192b54574f$var$DeadClickTracker.prototype.processRecursively = function(config) {
    if (!this.isTracking || !this.onDeadClickCallback) {
        this.processingActive = false;
        return;
    }
    var timeoutMs = config["timeout_ms"];
    var self = this;
    this.processingTimeout = setTimeout(function() {
        if (!self.processingActive) return;
        var deadClicks = self.getDeadClicks(config);
        for(var i = 0; i < deadClicks.length; i++)self.onDeadClickCallback(deadClicks[i].event);
        if (self.pendingClicks.length > 0) self.processRecursively(config);
        else self.processingActive = false;
    }, timeoutMs);
};
$413a30192b54574f$var$DeadClickTracker.prototype.startTracking = function() {
    if (this.isTracking) return;
    this.isTracking = true;
    var self = this;
    $413a30192b54574f$var$INTERACTION_EVENTS.forEach(function(event) {
        var handler = function() {
            self.recordChangeEvent();
        };
        document.addEventListener(event, handler, {
            capture: true,
            passive: true
        });
        self.eventListeners.push({
            target: document,
            event: event,
            handler: handler,
            options: {
                capture: true,
                passive: true
            }
        });
    });
    $413a30192b54574f$var$NAVIGATION_EVENTS.forEach(function(event) {
        var handler = function() {
            self.recordChangeEvent();
        };
        window.addEventListener(event, handler);
        self.eventListeners.push({
            target: window,
            event: event,
            handler: handler
        });
    });
    $413a30192b54574f$var$LAYOUT_EVENTS.forEach(function(event) {
        var handler = function() {
            self.recordChangeEvent();
        };
        window.addEventListener(event, handler, {
            passive: true
        });
        self.eventListeners.push({
            target: window,
            event: event,
            handler: handler,
            options: {
                passive: true
            }
        });
    });
    var selectionHandler = function() {
        self.recordChangeEvent();
    };
    document.addEventListener("selectionchange", selectionHandler);
    self.eventListeners.push({
        target: document,
        event: "selectionchange",
        handler: selectionHandler
    });
    // Set up MutationObserver
    if (window.MutationObserver) try {
        this.mutationObserver = new window.MutationObserver(function() {
            self.recordChangeEvent();
        });
        this.mutationObserver.observe(document.body || document.documentElement, $413a30192b54574f$var$MUTATION_OBSERVER_CONFIG);
    } catch (e) {
        $413a30192b54574f$var$logger$1.critical("Error while setting up mutation observer", e);
    }
    // Set up Shadow DOM observer
    if (window.customElements) try {
        this.shadowDOMObserver = new $413a30192b54574f$var$ShadowDOMObserver(function() {
            self.recordChangeEvent();
        }, $413a30192b54574f$var$MUTATION_OBSERVER_CONFIG);
        this.shadowDOMObserver.start();
    } catch (e) {
        $413a30192b54574f$var$logger$1.critical("Error while setting up shadow DOM observer", e);
        this.shadowDOMObserver = null;
    }
};
$413a30192b54574f$var$DeadClickTracker.prototype.stopTracking = function() {
    if (!this.isTracking) return;
    this.isTracking = false;
    this.pendingClicks = [];
    this.lastChangeEventTimestamp = 0;
    this.processingActive = false;
    if (this.processingTimeout) {
        clearTimeout(this.processingTimeout);
        this.processingTimeout = null;
    }
    // Remove all event listeners
    for(var i = 0; i < this.eventListeners.length; i++){
        var listener = this.eventListeners[i];
        try {
            listener.target.removeEventListener(listener.event, listener.handler, listener.options);
        } catch (e) {
            $413a30192b54574f$var$logger$1.critical("Error while removing event listener", e);
        }
    }
    this.eventListeners = [];
    if (this.mutationObserver) {
        try {
            this.mutationObserver.disconnect();
        } catch (e) {
            $413a30192b54574f$var$logger$1.critical("Error while disconnecting mutation observer", e);
        }
        this.mutationObserver = null;
    }
    if (this.shadowDOMObserver) {
        try {
            this.shadowDOMObserver.stop();
        } catch (e) {
            $413a30192b54574f$var$logger$1.critical("Error while stopping shadow DOM observer", e);
        }
        this.shadowDOMObserver = null;
    }
};
var $413a30192b54574f$var$AUTOCAPTURE_CONFIG_KEY = "autocapture";
var $413a30192b54574f$var$LEGACY_PAGEVIEW_CONFIG_KEY = "track_pageview";
var $413a30192b54574f$var$PAGEVIEW_OPTION_FULL_URL = "full-url";
var $413a30192b54574f$var$PAGEVIEW_OPTION_URL_WITH_PATH_AND_QUERY_STRING = "url-with-path-and-query-string";
var $413a30192b54574f$var$PAGEVIEW_OPTION_URL_WITH_PATH = "url-with-path";
var $413a30192b54574f$var$CONFIG_ALLOW_ELEMENT_CALLBACK = "allow_element_callback";
var $413a30192b54574f$var$CONFIG_ALLOW_SELECTORS = "allow_selectors";
var $413a30192b54574f$var$CONFIG_ALLOW_URL_REGEXES = "allow_url_regexes";
var $413a30192b54574f$var$CONFIG_BLOCK_ATTRS = "block_attrs";
var $413a30192b54574f$var$CONFIG_BLOCK_ELEMENT_CALLBACK = "block_element_callback";
var $413a30192b54574f$var$CONFIG_BLOCK_SELECTORS = "block_selectors";
var $413a30192b54574f$var$CONFIG_BLOCK_URL_REGEXES = "block_url_regexes";
var $413a30192b54574f$var$CONFIG_CAPTURE_EXTRA_ATTRS = "capture_extra_attrs";
var $413a30192b54574f$var$CONFIG_CAPTURE_TEXT_CONTENT = "capture_text_content";
var $413a30192b54574f$var$CONFIG_SCROLL_CAPTURE_ALL = "scroll_capture_all";
var $413a30192b54574f$var$CONFIG_SCROLL_CHECKPOINTS = "scroll_depth_percent_checkpoints";
var $413a30192b54574f$var$CONFIG_TRACK_CLICK = "click";
var $413a30192b54574f$var$CONFIG_TRACK_DEAD_CLICK = "dead_click";
var $413a30192b54574f$var$CONFIG_TRACK_INPUT = "input";
var $413a30192b54574f$var$CONFIG_TRACK_PAGEVIEW = "pageview";
var $413a30192b54574f$var$CONFIG_TRACK_RAGE_CLICK = "rage_click";
var $413a30192b54574f$var$CONFIG_TRACK_SCROLL = "scroll";
var $413a30192b54574f$var$CONFIG_TRACK_PAGE_LEAVE = "page_leave";
var $413a30192b54574f$var$CONFIG_TRACK_SUBMIT = "submit";
var $413a30192b54574f$var$CONFIG_DEFAULTS$1 = {};
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_ALLOW_SELECTORS] = [];
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_ALLOW_URL_REGEXES] = [];
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_BLOCK_ATTRS] = [];
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_BLOCK_ELEMENT_CALLBACK] = null;
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_BLOCK_SELECTORS] = [];
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_BLOCK_URL_REGEXES] = [];
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_CAPTURE_EXTRA_ATTRS] = [];
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_CAPTURE_TEXT_CONTENT] = false;
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_SCROLL_CAPTURE_ALL] = false;
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_SCROLL_CHECKPOINTS] = [
    25,
    50,
    75,
    100
];
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_TRACK_CLICK] = true;
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_TRACK_DEAD_CLICK] = true;
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_TRACK_INPUT] = true;
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_TRACK_PAGEVIEW] = $413a30192b54574f$var$PAGEVIEW_OPTION_FULL_URL;
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_TRACK_RAGE_CLICK] = true;
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_TRACK_SCROLL] = true;
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_TRACK_PAGE_LEAVE] = false;
$413a30192b54574f$var$CONFIG_DEFAULTS$1[$413a30192b54574f$var$CONFIG_TRACK_SUBMIT] = true;
var $413a30192b54574f$var$DEFAULT_PROPS = {
    "$mp_autocapture": true
};
var $413a30192b54574f$var$MP_EV_CLICK = "$mp_click";
var $413a30192b54574f$var$MP_EV_DEAD_CLICK = "$mp_dead_click";
var $413a30192b54574f$var$MP_EV_INPUT = "$mp_input_change";
var $413a30192b54574f$var$MP_EV_RAGE_CLICK = "$mp_rage_click";
var $413a30192b54574f$var$MP_EV_SCROLL = "$mp_scroll";
var $413a30192b54574f$var$MP_EV_SUBMIT = "$mp_submit";
var $413a30192b54574f$var$MP_EV_PAGE_LEAVE = "$mp_page_leave";
/**
 * Autocapture: manages automatic event tracking
 * @constructor
 */ var $413a30192b54574f$var$Autocapture = function(mp) {
    this.mp = mp;
    this.maxScrollViewDepth = 0;
    this.hasTrackedScrollSession = false;
    this.previousScrollHeight = 0;
};
$413a30192b54574f$var$Autocapture.prototype.init = function() {
    if (!$413a30192b54574f$var$minDOMApisSupported()) {
        $413a30192b54574f$var$logger$1.critical("Autocapture unavailable: missing required DOM APIs");
        return;
    }
    this.initPageListeners();
    this.initPageviewTracking();
    this.initClickTracking();
    this.initDeadClickTracking();
    this.initInputTracking();
    this.initScrollTracking();
    this.initSubmitTracking();
    this.initRageClickTracking();
    this.initPageLeaveTracking();
};
$413a30192b54574f$var$Autocapture.prototype.getFullConfig = function() {
    var autocaptureConfig = this.mp.get_config($413a30192b54574f$var$AUTOCAPTURE_CONFIG_KEY);
    if (!autocaptureConfig) // Autocapture is completely off
    return {};
    else if ($413a30192b54574f$var$_.isObject(autocaptureConfig)) return $413a30192b54574f$var$_.extend({}, $413a30192b54574f$var$CONFIG_DEFAULTS$1, autocaptureConfig);
    else // Autocapture config is non-object truthy value, return default
    return $413a30192b54574f$var$CONFIG_DEFAULTS$1;
};
$413a30192b54574f$var$Autocapture.prototype.getConfig = function(key) {
    return this.getFullConfig()[key];
};
$413a30192b54574f$var$Autocapture.prototype.currentUrlBlocked = function() {
    var i;
    var currentUrl = $413a30192b54574f$var$_.info.currentUrl();
    var allowUrlRegexes = this.getConfig($413a30192b54574f$var$CONFIG_ALLOW_URL_REGEXES) || [];
    if (allowUrlRegexes.length) {
        // we're using an allowlist, only track if current URL matches
        var allowed = false;
        for(i = 0; i < allowUrlRegexes.length; i++){
            var allowRegex = allowUrlRegexes[i];
            try {
                if (currentUrl.match(allowRegex)) {
                    allowed = true;
                    break;
                }
            } catch (err) {
                $413a30192b54574f$var$logger$1.critical("Error while checking block URL regex: " + allowRegex, err);
                return true;
            }
        }
        if (!allowed) // wasn't allowed by any regex
        return true;
    }
    var blockUrlRegexes = this.getConfig($413a30192b54574f$var$CONFIG_BLOCK_URL_REGEXES) || [];
    if (!blockUrlRegexes || !blockUrlRegexes.length) return false;
    for(i = 0; i < blockUrlRegexes.length; i++)try {
        if (currentUrl.match(blockUrlRegexes[i])) return true;
    } catch (err) {
        $413a30192b54574f$var$logger$1.critical("Error while checking block URL regex: " + blockUrlRegexes[i], err);
        return true;
    }
    return false;
};
$413a30192b54574f$var$Autocapture.prototype.pageviewTrackingConfig = function() {
    // supports both autocapture config and old track_pageview config
    if (this.mp.get_config($413a30192b54574f$var$AUTOCAPTURE_CONFIG_KEY)) return this.getConfig($413a30192b54574f$var$CONFIG_TRACK_PAGEVIEW);
    else return this.mp.get_config($413a30192b54574f$var$LEGACY_PAGEVIEW_CONFIG_KEY);
};
// helper for event handlers
$413a30192b54574f$var$Autocapture.prototype.trackDomEvent = function(ev, mpEventName) {
    if (this.currentUrlBlocked()) return;
    var isCapturedForHeatMap = this.mp.is_recording_heatmap_data() && (mpEventName === $413a30192b54574f$var$MP_EV_CLICK && !this.getConfig($413a30192b54574f$var$CONFIG_TRACK_CLICK) || mpEventName === $413a30192b54574f$var$MP_EV_RAGE_CLICK && !this._getClickTrackingConfig($413a30192b54574f$var$CONFIG_TRACK_RAGE_CLICK) || mpEventName === $413a30192b54574f$var$MP_EV_DEAD_CLICK && !this._getClickTrackingConfig($413a30192b54574f$var$CONFIG_TRACK_DEAD_CLICK));
    var props = $413a30192b54574f$var$getPropsForDOMEvent(ev, {
        allowElementCallback: this.getConfig($413a30192b54574f$var$CONFIG_ALLOW_ELEMENT_CALLBACK),
        allowSelectors: this.getConfig($413a30192b54574f$var$CONFIG_ALLOW_SELECTORS),
        blockAttrs: this.getConfig($413a30192b54574f$var$CONFIG_BLOCK_ATTRS),
        blockElementCallback: this.getConfig($413a30192b54574f$var$CONFIG_BLOCK_ELEMENT_CALLBACK),
        blockSelectors: this.getConfig($413a30192b54574f$var$CONFIG_BLOCK_SELECTORS),
        captureExtraAttrs: this.getConfig($413a30192b54574f$var$CONFIG_CAPTURE_EXTRA_ATTRS),
        captureTextContent: this.getConfig($413a30192b54574f$var$CONFIG_CAPTURE_TEXT_CONTENT),
        capturedForHeatMap: isCapturedForHeatMap
    });
    if (props) {
        $413a30192b54574f$var$_.extend(props, $413a30192b54574f$var$DEFAULT_PROPS);
        this.mp.track(mpEventName, props);
    }
};
$413a30192b54574f$var$Autocapture.prototype.initPageListeners = function() {
    $413a30192b54574f$var$win.removeEventListener($413a30192b54574f$var$EV_POPSTATE, this.listenerPopstate);
    $413a30192b54574f$var$win.removeEventListener($413a30192b54574f$var$EV_HASHCHANGE, this.listenerHashchange);
    if (!this.pageviewTrackingConfig() && !this.getConfig($413a30192b54574f$var$CONFIG_TRACK_PAGE_LEAVE) && !this.mp.get_config("record_heatmap_data")) // These are all the configs that use these listeners
    return;
    this.listenerPopstate = function() {
        $413a30192b54574f$var$win.dispatchEvent(new Event($413a30192b54574f$var$EV_MP_LOCATION_CHANGE));
    };
    this.listenerHashchange = function() {
        $413a30192b54574f$var$win.dispatchEvent(new Event($413a30192b54574f$var$EV_MP_LOCATION_CHANGE));
    };
    $413a30192b54574f$var$win.addEventListener($413a30192b54574f$var$EV_POPSTATE, this.listenerPopstate);
    $413a30192b54574f$var$win.addEventListener($413a30192b54574f$var$EV_HASHCHANGE, this.listenerHashchange);
    var nativePushState = $413a30192b54574f$var$win.history.pushState;
    if (typeof nativePushState === "function") $413a30192b54574f$var$win.history.pushState = function(state, unused, url) {
        nativePushState.call($413a30192b54574f$var$win.history, state, unused, url);
        $413a30192b54574f$var$win.dispatchEvent(new Event($413a30192b54574f$var$EV_MP_LOCATION_CHANGE));
    };
    var nativeReplaceState = $413a30192b54574f$var$win.history.replaceState;
    if (typeof nativeReplaceState === "function") $413a30192b54574f$var$win.history.replaceState = function(state, unused, url) {
        nativeReplaceState.call($413a30192b54574f$var$win.history, state, unused, url);
        $413a30192b54574f$var$win.dispatchEvent(new Event($413a30192b54574f$var$EV_MP_LOCATION_CHANGE));
    };
};
$413a30192b54574f$var$Autocapture.prototype._getClickTrackingConfig = function(configKey) {
    var config = this.getConfig(configKey);
    if (!config) return null; // click tracking disabled
    if (config === true) return {}; // use defaults
    if (typeof config === "object") return config; // use custom configuration
    return {}; // fallback to defaults for any other truthy value
};
$413a30192b54574f$var$Autocapture.prototype._trackPageLeave = function(ev, currentUrl, currentScrollHeight) {
    if (this.hasTrackedScrollSession) // User has navigated away already ending their impression.
    return;
    if (!this.getConfig($413a30192b54574f$var$CONFIG_TRACK_PAGE_LEAVE) && !this.mp.is_recording_heatmap_data()) return;
    this.hasTrackedScrollSession = true;
    var viewportHeight = Math.max($413a30192b54574f$var$document$1.documentElement.clientHeight, $413a30192b54574f$var$win.innerHeight || 0);
    var scrollPercentage = Math.round(Math.max(this.maxScrollViewDepth - viewportHeight, 0) / (currentScrollHeight - viewportHeight) * 100);
    var foldLinePercentage = Math.round(viewportHeight / currentScrollHeight * 100);
    if (currentScrollHeight <= viewportHeight) {
        // If the content fits within the viewport, consider it fully scrolled
        scrollPercentage = 100;
        foldLinePercentage = 100;
    }
    var props = $413a30192b54574f$var$_.extend({
        "$max_scroll_view_depth": this.maxScrollViewDepth,
        "$max_scroll_percentage": scrollPercentage,
        "$fold_line_percentage": foldLinePercentage,
        "$scroll_height": currentScrollHeight,
        "$event_type": ev.type,
        "$current_url": currentUrl || $413a30192b54574f$var$_.info.currentUrl(),
        "$viewportHeight": viewportHeight,
        "$viewportWidth": Math.max($413a30192b54574f$var$document$1.documentElement.clientWidth, $413a30192b54574f$var$win.innerWidth || 0),
        "$captured_for_heatmap": this.mp.is_recording_heatmap_data()
    }, $413a30192b54574f$var$DEFAULT_PROPS);
    // Send with beacon transport to ensure event is sent before unload
    this.mp.track($413a30192b54574f$var$MP_EV_PAGE_LEAVE, props, {
        transport: "sendBeacon"
    });
};
$413a30192b54574f$var$Autocapture.prototype._initScrollDepthTracking = function() {
    $413a30192b54574f$var$win.removeEventListener($413a30192b54574f$var$EV_SCROLL, this.listenerScrollDepth);
    $413a30192b54574f$var$win.removeEventListener($413a30192b54574f$var$EV_SCROLLEND, this.listenerScrollDepth);
    if (!this.mp.get_config("record_heatmap_data")) return;
    $413a30192b54574f$var$logger$1.log("Initializing scroll depth tracking");
    this.maxScrollViewDepth = Math.max($413a30192b54574f$var$document$1.documentElement.clientHeight, $413a30192b54574f$var$win.innerHeight || 0);
    var updateScrollDepth = (function() {
        if (this.currentUrlBlocked()) return;
        var scrollViewHeight = Math.max($413a30192b54574f$var$document$1.documentElement.clientHeight, $413a30192b54574f$var$win.innerHeight || 0) + $413a30192b54574f$var$win.scrollY;
        if (scrollViewHeight > this.maxScrollViewDepth) this.maxScrollViewDepth = scrollViewHeight;
        this.previousScrollHeight = $413a30192b54574f$var$document$1.body.scrollHeight;
    }).bind(this);
    var scrollEndPolyfill = $413a30192b54574f$var$getPolyfillScrollEndFunction(updateScrollDepth);
    this.listenerScrollDepth = scrollEndPolyfill.listener;
    $413a30192b54574f$var$win.addEventListener(scrollEndPolyfill.eventType, this.listenerScrollDepth);
};
$413a30192b54574f$var$Autocapture.prototype.initClickTracking = function() {
    $413a30192b54574f$var$win.removeEventListener($413a30192b54574f$var$EV_CLICK, this.listenerClick);
    if (!this.getConfig($413a30192b54574f$var$CONFIG_TRACK_CLICK) && !this.mp.get_config("record_heatmap_data")) return;
    $413a30192b54574f$var$logger$1.log("Initializing click tracking");
    this.listenerClick = (function(ev) {
        if (!this.getConfig($413a30192b54574f$var$CONFIG_TRACK_CLICK) && !this.mp.is_recording_heatmap_data()) return;
        this.trackDomEvent(ev, $413a30192b54574f$var$MP_EV_CLICK);
    }).bind(this);
    $413a30192b54574f$var$win.addEventListener($413a30192b54574f$var$EV_CLICK, this.listenerClick);
};
$413a30192b54574f$var$Autocapture.prototype.initDeadClickTracking = function() {
    var deadClickConfig = this._getClickTrackingConfig($413a30192b54574f$var$CONFIG_TRACK_DEAD_CLICK);
    if (!deadClickConfig && !this.mp.get_config("record_heatmap_data")) {
        this.stopDeadClickTracking();
        return;
    }
    $413a30192b54574f$var$logger$1.log("Initializing dead click tracking");
    if (!this._deadClickTracker) {
        this._deadClickTracker = new $413a30192b54574f$var$DeadClickTracker((function(deadClickEvent) {
            this.trackDomEvent(deadClickEvent, $413a30192b54574f$var$MP_EV_DEAD_CLICK);
        }).bind(this));
        this._deadClickTracker.startTracking();
    }
    if (!this.listenerDeadClick) {
        this.listenerDeadClick = (function(ev) {
            var currentDeadClickConfig = this._getClickTrackingConfig($413a30192b54574f$var$CONFIG_TRACK_DEAD_CLICK);
            if (!currentDeadClickConfig && !this.mp.is_recording_heatmap_data()) return;
            if (this.currentUrlBlocked()) return;
            // Normalize config to ensure timeout_ms is always set
            var normalizedConfig = currentDeadClickConfig || {};
            if (!normalizedConfig["timeout_ms"]) normalizedConfig["timeout_ms"] = $413a30192b54574f$var$DEFAULT_DEAD_CLICK_TIMEOUT_MS;
            this._deadClickTracker.trackClick(ev, normalizedConfig);
        }).bind(this);
        $413a30192b54574f$var$win.addEventListener($413a30192b54574f$var$EV_CLICK, this.listenerDeadClick);
    }
};
$413a30192b54574f$var$Autocapture.prototype.initInputTracking = function() {
    $413a30192b54574f$var$win.removeEventListener($413a30192b54574f$var$EV_CHANGE, this.listenerChange);
    if (!this.getConfig($413a30192b54574f$var$CONFIG_TRACK_INPUT)) return;
    $413a30192b54574f$var$logger$1.log("Initializing input tracking");
    this.listenerChange = (function(ev) {
        if (!this.getConfig($413a30192b54574f$var$CONFIG_TRACK_INPUT)) return;
        this.trackDomEvent(ev, $413a30192b54574f$var$MP_EV_INPUT);
    }).bind(this);
    $413a30192b54574f$var$win.addEventListener($413a30192b54574f$var$EV_CHANGE, this.listenerChange);
};
$413a30192b54574f$var$Autocapture.prototype.initPageviewTracking = function() {
    $413a30192b54574f$var$win.removeEventListener($413a30192b54574f$var$EV_MP_LOCATION_CHANGE, this.listenerLocationchange);
    if (!this.pageviewTrackingConfig()) return;
    $413a30192b54574f$var$logger$1.log("Initializing pageview tracking");
    var previousTrackedUrl = "";
    var tracked = false;
    if (!this.currentUrlBlocked()) tracked = this.mp.track_pageview($413a30192b54574f$var$DEFAULT_PROPS);
    if (tracked) previousTrackedUrl = $413a30192b54574f$var$_.info.currentUrl();
    this.listenerLocationchange = $413a30192b54574f$var$safewrap((function() {
        if (this.currentUrlBlocked()) return;
        var currentUrl = $413a30192b54574f$var$_.info.currentUrl();
        var shouldTrack = false;
        var didPathChange = currentUrl.split("#")[0].split("?")[0] !== previousTrackedUrl.split("#")[0].split("?")[0];
        var trackPageviewOption = this.pageviewTrackingConfig();
        if (trackPageviewOption === $413a30192b54574f$var$PAGEVIEW_OPTION_FULL_URL) shouldTrack = currentUrl !== previousTrackedUrl;
        else if (trackPageviewOption === $413a30192b54574f$var$PAGEVIEW_OPTION_URL_WITH_PATH_AND_QUERY_STRING) shouldTrack = currentUrl.split("#")[0] !== previousTrackedUrl.split("#")[0];
        else if (trackPageviewOption === $413a30192b54574f$var$PAGEVIEW_OPTION_URL_WITH_PATH) shouldTrack = didPathChange;
        if (shouldTrack) {
            var tracked = this.mp.track_pageview($413a30192b54574f$var$DEFAULT_PROPS);
            if (tracked) previousTrackedUrl = currentUrl;
            if (didPathChange) {
                this.lastScrollCheckpoint = 0;
                $413a30192b54574f$var$logger$1.log("Path change: re-initializing scroll depth checkpoints");
            }
        }
    }).bind(this));
    $413a30192b54574f$var$win.addEventListener($413a30192b54574f$var$EV_MP_LOCATION_CHANGE, this.listenerLocationchange);
};
$413a30192b54574f$var$Autocapture.prototype.initRageClickTracking = function() {
    $413a30192b54574f$var$win.removeEventListener($413a30192b54574f$var$EV_CLICK, this.listenerRageClick);
    var rageClickConfig = this._getClickTrackingConfig($413a30192b54574f$var$CONFIG_TRACK_RAGE_CLICK);
    if (!rageClickConfig && !this.mp.get_config("record_heatmap_data")) return;
    $413a30192b54574f$var$logger$1.log("Initializing rage click tracking");
    if (!this._rageClickTracker) this._rageClickTracker = new $413a30192b54574f$var$RageClickTracker();
    this.listenerRageClick = (function(ev) {
        var currentRageClickConfig = this._getClickTrackingConfig($413a30192b54574f$var$CONFIG_TRACK_RAGE_CLICK);
        if (!currentRageClickConfig && !this.mp.is_recording_heatmap_data()) return;
        if (this.currentUrlBlocked()) return;
        if (this._rageClickTracker.isRageClick(ev["pageX"], ev["pageY"], currentRageClickConfig)) this.trackDomEvent(ev, $413a30192b54574f$var$MP_EV_RAGE_CLICK);
    }).bind(this);
    $413a30192b54574f$var$win.addEventListener($413a30192b54574f$var$EV_CLICK, this.listenerRageClick);
};
$413a30192b54574f$var$Autocapture.prototype.initScrollTracking = function() {
    $413a30192b54574f$var$win.removeEventListener($413a30192b54574f$var$EV_SCROLLEND, this.listenerScroll);
    $413a30192b54574f$var$win.removeEventListener($413a30192b54574f$var$EV_SCROLL, this.listenerScroll);
    if (!this.getConfig($413a30192b54574f$var$CONFIG_TRACK_SCROLL)) return;
    $413a30192b54574f$var$logger$1.log("Initializing scroll tracking");
    this.lastScrollCheckpoint = 0;
    var scrollTrackFunction = (function() {
        if (!this.getConfig($413a30192b54574f$var$CONFIG_TRACK_SCROLL)) return;
        if (this.currentUrlBlocked()) return;
        var shouldTrack = this.getConfig($413a30192b54574f$var$CONFIG_SCROLL_CAPTURE_ALL);
        var scrollCheckpoints = (this.getConfig($413a30192b54574f$var$CONFIG_SCROLL_CHECKPOINTS) || []).slice().sort(function(a, b) {
            return a - b;
        });
        var scrollTop = $413a30192b54574f$var$win.scrollY;
        var props = $413a30192b54574f$var$_.extend({
            "$scroll_top": scrollTop
        }, $413a30192b54574f$var$DEFAULT_PROPS);
        try {
            var scrollHeight = $413a30192b54574f$var$document$1.body.scrollHeight;
            var scrollPercentage = Math.round(scrollTop / (scrollHeight - $413a30192b54574f$var$win.innerHeight) * 100);
            props["$scroll_height"] = scrollHeight;
            props["$scroll_percentage"] = scrollPercentage;
            if (scrollPercentage > this.lastScrollCheckpoint) for(var i = 0; i < scrollCheckpoints.length; i++){
                var checkpoint = scrollCheckpoints[i];
                if (scrollPercentage >= checkpoint && this.lastScrollCheckpoint < checkpoint) {
                    props["$scroll_checkpoint"] = checkpoint;
                    this.lastScrollCheckpoint = checkpoint;
                    shouldTrack = true;
                }
            }
        } catch (err) {
            $413a30192b54574f$var$logger$1.critical("Error while calculating scroll percentage", err);
        }
        if (shouldTrack) this.mp.track($413a30192b54574f$var$MP_EV_SCROLL, props);
    }).bind(this);
    var scrollEndPolyfill = $413a30192b54574f$var$getPolyfillScrollEndFunction(scrollTrackFunction);
    this.listenerScroll = scrollEndPolyfill.listener;
    $413a30192b54574f$var$win.addEventListener(scrollEndPolyfill.eventType, this.listenerScroll);
};
$413a30192b54574f$var$Autocapture.prototype.initSubmitTracking = function() {
    $413a30192b54574f$var$win.removeEventListener($413a30192b54574f$var$EV_SUBMIT, this.listenerSubmit);
    if (!this.getConfig($413a30192b54574f$var$CONFIG_TRACK_SUBMIT)) return;
    $413a30192b54574f$var$logger$1.log("Initializing submit tracking");
    this.listenerSubmit = (function(ev) {
        if (!this.getConfig($413a30192b54574f$var$CONFIG_TRACK_SUBMIT)) return;
        this.trackDomEvent(ev, $413a30192b54574f$var$MP_EV_SUBMIT);
    }).bind(this);
    $413a30192b54574f$var$win.addEventListener($413a30192b54574f$var$EV_SUBMIT, this.listenerSubmit);
};
$413a30192b54574f$var$Autocapture.prototype.initPageLeaveTracking = function() {
    // Capture page_leave both when the user navigates away from the page (visibilitychange) as well
    // as when they navigate to a different page within the SPA (popstate/pushstate/hashchange).
    $413a30192b54574f$var$document$1.removeEventListener($413a30192b54574f$var$EV_VISIBILITYCHANGE, this.listenerPageLeaveVisibilitychange);
    $413a30192b54574f$var$win.removeEventListener($413a30192b54574f$var$EV_MP_LOCATION_CHANGE, this.listenerPageLeaveLocationchange);
    $413a30192b54574f$var$win.removeEventListener($413a30192b54574f$var$EV_LOAD, this.listenerPageLoad);
    if (!this.getConfig($413a30192b54574f$var$CONFIG_TRACK_PAGE_LEAVE) && !this.mp.get_config("record_heatmap_data")) return;
    $413a30192b54574f$var$logger$1.log("Initializing page visibility tracking.");
    this._initScrollDepthTracking();
    var previousTrackedUrl = $413a30192b54574f$var$_.info.currentUrl();
    // Initialize previousScrollHeight on `load` which handles async loading
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
    this.listenerPageLoad = (function() {
        this.previousScrollHeight = $413a30192b54574f$var$document$1.body.scrollHeight;
    }).bind(this);
    $413a30192b54574f$var$win.addEventListener($413a30192b54574f$var$EV_LOAD, this.listenerPageLoad);
    // Track page navigation events similar to how initPageviewTracking does it
    this.listenerPageLeaveLocationchange = $413a30192b54574f$var$safewrap((function(ev) {
        if (this.currentUrlBlocked()) return;
        var currentUrl = $413a30192b54574f$var$_.info.currentUrl();
        // Track all URL changes including query string or fragment changes as separate scroll sessions
        var shouldTrack = currentUrl !== previousTrackedUrl;
        if (shouldTrack) {
            this._trackPageLeave(ev, previousTrackedUrl, this.previousScrollHeight);
            previousTrackedUrl = currentUrl;
            // Fragment navigation should call scroll(end) and trigger listener, don't add window.scrollY here.
            this.maxScrollViewDepth = Math.max($413a30192b54574f$var$document$1.documentElement.clientHeight, $413a30192b54574f$var$win.innerHeight || 0);
            this.previousScrollHeight = $413a30192b54574f$var$document$1.body.scrollHeight;
            this.hasTrackedScrollSession = false;
        }
    }).bind(this));
    $413a30192b54574f$var$win.addEventListener($413a30192b54574f$var$EV_MP_LOCATION_CHANGE, this.listenerPageLeaveLocationchange);
    this.listenerPageLeaveVisibilitychange = (function(ev) {
        if ($413a30192b54574f$var$document$1.hidden) this._trackPageLeave(ev, previousTrackedUrl, this.previousScrollHeight);
    }).bind(this);
    $413a30192b54574f$var$document$1.addEventListener($413a30192b54574f$var$EV_VISIBILITYCHANGE, this.listenerPageLeaveVisibilitychange);
};
$413a30192b54574f$var$Autocapture.prototype.stopDeadClickTracking = function() {
    if (this.listenerDeadClick) {
        $413a30192b54574f$var$win.removeEventListener($413a30192b54574f$var$EV_CLICK, this.listenerDeadClick);
        this.listenerDeadClick = null;
    }
    if (this._deadClickTracker) {
        this._deadClickTracker.stopTracking();
        this._deadClickTracker = null;
    }
};
// TODO integrate error_reporter from mixpanel instance
$413a30192b54574f$var$safewrapClass($413a30192b54574f$var$Autocapture);
var $413a30192b54574f$var$logger = $413a30192b54574f$var$console_with_prefix("flags");
var $413a30192b54574f$var$FLAGS_CONFIG_KEY = "flags";
var $413a30192b54574f$var$CONFIG_CONTEXT = "context";
var $413a30192b54574f$var$CONFIG_DEFAULTS = {};
$413a30192b54574f$var$CONFIG_DEFAULTS[$413a30192b54574f$var$CONFIG_CONTEXT] = {};
/**
 * FeatureFlagManager: support for Mixpanel's feature flagging product
 * @constructor
 */ var $413a30192b54574f$var$FeatureFlagManager = function(initOptions) {
    this.fetch = $413a30192b54574f$var$win["fetch"];
    this.getFullApiRoute = initOptions.getFullApiRoute;
    this.getMpConfig = initOptions.getConfigFunc;
    this.setMpConfig = initOptions.setConfigFunc;
    this.getMpProperty = initOptions.getPropertyFunc;
    this.track = initOptions.trackingFunc;
};
$413a30192b54574f$var$FeatureFlagManager.prototype.init = function() {
    if (!this.minApisSupported()) {
        $413a30192b54574f$var$logger.critical("Feature Flags unavailable: missing minimum required APIs");
        return;
    }
    this.flags = null;
    this.fetchFlags();
    this.trackedFeatures = new Set();
};
$413a30192b54574f$var$FeatureFlagManager.prototype.getFullConfig = function() {
    var ffConfig = this.getMpConfig($413a30192b54574f$var$FLAGS_CONFIG_KEY);
    if (!ffConfig) // flags are completely off
    return {};
    else if ($413a30192b54574f$var$_.isObject(ffConfig)) return $413a30192b54574f$var$_.extend({}, $413a30192b54574f$var$CONFIG_DEFAULTS, ffConfig);
    else // config is non-object truthy value, return default
    return $413a30192b54574f$var$CONFIG_DEFAULTS;
};
$413a30192b54574f$var$FeatureFlagManager.prototype.getConfig = function(key) {
    return this.getFullConfig()[key];
};
$413a30192b54574f$var$FeatureFlagManager.prototype.isSystemEnabled = function() {
    return !!this.getMpConfig($413a30192b54574f$var$FLAGS_CONFIG_KEY);
};
$413a30192b54574f$var$FeatureFlagManager.prototype.updateContext = function(newContext, options) {
    if (!this.isSystemEnabled()) {
        $413a30192b54574f$var$logger.critical("Feature Flags not enabled, cannot update context");
        return Promise.resolve();
    }
    var ffConfig = this.getMpConfig($413a30192b54574f$var$FLAGS_CONFIG_KEY);
    if (!$413a30192b54574f$var$_.isObject(ffConfig)) ffConfig = {};
    var oldContext = options && options["replace"] ? {} : this.getConfig($413a30192b54574f$var$CONFIG_CONTEXT);
    ffConfig[$413a30192b54574f$var$CONFIG_CONTEXT] = $413a30192b54574f$var$_.extend({}, oldContext, newContext);
    this.setMpConfig($413a30192b54574f$var$FLAGS_CONFIG_KEY, ffConfig);
    return this.fetchFlags();
};
$413a30192b54574f$var$FeatureFlagManager.prototype.areFlagsReady = function() {
    if (!this.isSystemEnabled()) $413a30192b54574f$var$logger.error("Feature Flags not enabled");
    return !!this.flags;
};
$413a30192b54574f$var$FeatureFlagManager.prototype.fetchFlags = function() {
    if (!this.isSystemEnabled()) return Promise.resolve();
    var distinctId = this.getMpProperty("distinct_id");
    var deviceId = this.getMpProperty("$device_id");
    var traceparent = $413a30192b54574f$var$generateTraceparent();
    $413a30192b54574f$var$logger.log("Fetching flags for distinct ID: " + distinctId);
    var context = $413a30192b54574f$var$_.extend({
        "distinct_id": distinctId,
        "device_id": deviceId
    }, this.getConfig($413a30192b54574f$var$CONFIG_CONTEXT));
    var searchParams = new URLSearchParams();
    searchParams.set("context", JSON.stringify(context));
    searchParams.set("token", this.getMpConfig("token"));
    searchParams.set("mp_lib", "web");
    searchParams.set("$lib_version", $413a30192b54574f$var$Config.LIB_VERSION);
    var url = this.getFullApiRoute() + "?" + searchParams.toString();
    this._fetchInProgressStartTime = Date.now();
    this.fetchPromise = this.fetch.call($413a30192b54574f$var$win, url, {
        "method": "GET",
        "headers": {
            "Authorization": "Basic " + btoa(this.getMpConfig("token") + ":"),
            "traceparent": traceparent
        }
    }).then((function(response) {
        this.markFetchComplete();
        return response.json().then((function(responseBody) {
            var responseFlags = responseBody["flags"];
            if (!responseFlags) throw new Error("No flags in API response");
            var flags = new Map();
            $413a30192b54574f$var$_.each(responseFlags, function(data, key) {
                flags.set(key, {
                    "key": data["variant_key"],
                    "value": data["variant_value"],
                    "experiment_id": data["experiment_id"],
                    "is_experiment_active": data["is_experiment_active"],
                    "is_qa_tester": data["is_qa_tester"]
                });
            });
            this.flags = flags;
            this._traceparent = traceparent;
        }).bind(this)).catch((function(error) {
            this.markFetchComplete();
            $413a30192b54574f$var$logger.error(error);
        }).bind(this));
    }).bind(this)).catch((function(error) {
        this.markFetchComplete();
        $413a30192b54574f$var$logger.error(error);
    }).bind(this));
    return this.fetchPromise;
};
$413a30192b54574f$var$FeatureFlagManager.prototype.markFetchComplete = function() {
    if (!this._fetchInProgressStartTime) {
        $413a30192b54574f$var$logger.error("Fetch in progress started time not set, cannot mark fetch complete");
        return;
    }
    this._fetchStartTime = this._fetchInProgressStartTime;
    this._fetchCompleteTime = Date.now();
    this._fetchLatency = this._fetchCompleteTime - this._fetchStartTime;
    this._fetchInProgressStartTime = null;
};
$413a30192b54574f$var$FeatureFlagManager.prototype.getVariant = function(featureName, fallback) {
    if (!this.fetchPromise) return new Promise(function(resolve) {
        $413a30192b54574f$var$logger.critical("Feature Flags not initialized");
        resolve(fallback);
    });
    return this.fetchPromise.then((function() {
        return this.getVariantSync(featureName, fallback);
    }).bind(this)).catch(function(error) {
        $413a30192b54574f$var$logger.error(error);
        return fallback;
    });
};
$413a30192b54574f$var$FeatureFlagManager.prototype.getVariantSync = function(featureName, fallback) {
    if (!this.areFlagsReady()) {
        $413a30192b54574f$var$logger.log("Flags not loaded yet");
        return fallback;
    }
    var feature = this.flags.get(featureName);
    if (!feature) {
        $413a30192b54574f$var$logger.log('No flag found: "' + featureName + '"');
        return fallback;
    }
    this.trackFeatureCheck(featureName, feature);
    return feature;
};
$413a30192b54574f$var$FeatureFlagManager.prototype.getVariantValue = function(featureName, fallbackValue) {
    return this.getVariant(featureName, {
        "value": fallbackValue
    }).then(function(feature) {
        return feature["value"];
    }).catch(function(error) {
        $413a30192b54574f$var$logger.error(error);
        return fallbackValue;
    });
};
// TODO remove deprecated method
$413a30192b54574f$var$FeatureFlagManager.prototype.getFeatureData = function(featureName, fallbackValue) {
    $413a30192b54574f$var$logger.critical("mixpanel.flags.get_feature_data() is deprecated and will be removed in a future release. Use mixpanel.flags.get_variant_value() instead.");
    return this.getVariantValue(featureName, fallbackValue);
};
$413a30192b54574f$var$FeatureFlagManager.prototype.getVariantValueSync = function(featureName, fallbackValue) {
    return this.getVariantSync(featureName, {
        "value": fallbackValue
    })["value"];
};
$413a30192b54574f$var$FeatureFlagManager.prototype.isEnabled = function(featureName, fallbackValue) {
    return this.getVariantValue(featureName).then((function() {
        return this.isEnabledSync(featureName, fallbackValue);
    }).bind(this)).catch(function(error) {
        $413a30192b54574f$var$logger.error(error);
        return fallbackValue;
    });
};
$413a30192b54574f$var$FeatureFlagManager.prototype.isEnabledSync = function(featureName, fallbackValue) {
    fallbackValue = fallbackValue || false;
    var val = this.getVariantValueSync(featureName, fallbackValue);
    if (val !== true && val !== false) {
        $413a30192b54574f$var$logger.error('Feature flag "' + featureName + '" value: ' + val + " is not a boolean; returning fallback value: " + fallbackValue);
        val = fallbackValue;
    }
    return val;
};
$413a30192b54574f$var$FeatureFlagManager.prototype.trackFeatureCheck = function(featureName, feature) {
    if (this.trackedFeatures.has(featureName)) return;
    this.trackedFeatures.add(featureName);
    var trackingProperties = {
        "Experiment name": featureName,
        "Variant name": feature["key"],
        "$experiment_type": "feature_flag",
        "Variant fetch start time": new Date(this._fetchStartTime).toISOString(),
        "Variant fetch complete time": new Date(this._fetchCompleteTime).toISOString(),
        "Variant fetch latency (ms)": this._fetchLatency,
        "Variant fetch traceparent": this._traceparent
    };
    if (feature["experiment_id"] !== "undefined") trackingProperties["$experiment_id"] = feature["experiment_id"];
    if (feature["is_experiment_active"] !== "undefined") trackingProperties["$is_experiment_active"] = feature["is_experiment_active"];
    if (feature["is_qa_tester"] !== "undefined") trackingProperties["$is_qa_tester"] = feature["is_qa_tester"];
    this.track("$experiment_started", trackingProperties);
};
$413a30192b54574f$var$FeatureFlagManager.prototype.minApisSupported = function() {
    return !!this.fetch && typeof Promise !== "undefined" && typeof Map !== "undefined" && typeof Set !== "undefined";
};
$413a30192b54574f$var$safewrapClass($413a30192b54574f$var$FeatureFlagManager);
$413a30192b54574f$var$FeatureFlagManager.prototype["are_flags_ready"] = $413a30192b54574f$var$FeatureFlagManager.prototype.areFlagsReady;
$413a30192b54574f$var$FeatureFlagManager.prototype["get_variant"] = $413a30192b54574f$var$FeatureFlagManager.prototype.getVariant;
$413a30192b54574f$var$FeatureFlagManager.prototype["get_variant_sync"] = $413a30192b54574f$var$FeatureFlagManager.prototype.getVariantSync;
$413a30192b54574f$var$FeatureFlagManager.prototype["get_variant_value"] = $413a30192b54574f$var$FeatureFlagManager.prototype.getVariantValue;
$413a30192b54574f$var$FeatureFlagManager.prototype["get_variant_value_sync"] = $413a30192b54574f$var$FeatureFlagManager.prototype.getVariantValueSync;
$413a30192b54574f$var$FeatureFlagManager.prototype["is_enabled"] = $413a30192b54574f$var$FeatureFlagManager.prototype.isEnabled;
$413a30192b54574f$var$FeatureFlagManager.prototype["is_enabled_sync"] = $413a30192b54574f$var$FeatureFlagManager.prototype.isEnabledSync;
$413a30192b54574f$var$FeatureFlagManager.prototype["update_context"] = $413a30192b54574f$var$FeatureFlagManager.prototype.updateContext;
// Deprecated method
$413a30192b54574f$var$FeatureFlagManager.prototype["get_feature_data"] = $413a30192b54574f$var$FeatureFlagManager.prototype.getFeatureData;
/* eslint camelcase: "off" */ /**
 * DomTracker Object
 * @constructor
 */ var $413a30192b54574f$var$DomTracker = function() {};
// interface
$413a30192b54574f$var$DomTracker.prototype.create_properties = function() {};
$413a30192b54574f$var$DomTracker.prototype.event_handler = function() {};
$413a30192b54574f$var$DomTracker.prototype.after_track_handler = function() {};
$413a30192b54574f$var$DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};
/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */ $413a30192b54574f$var$DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = $413a30192b54574f$var$_.dom_query(query);
    if (elements.length === 0) {
        $413a30192b54574f$var$console$1.error("The DOM query (" + query + ") returned 0 elements");
        return;
    }
    $413a30192b54574f$var$_.each(elements, function(element) {
        $413a30192b54574f$var$_.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config("track_links_timeout");
            that.event_handler(e, this, options);
            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);
    return true;
};
/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */ $413a30192b54574f$var$DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;
    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) return;
        options.callback_fired = true;
        if (user_callback && user_callback(timeout_occured, props) === false) // user can prevent the default functionality by
        // returning false from their callback
        return;
        that.after_track_handler(props, options, timeout_occured);
    };
};
$413a30192b54574f$var$DomTracker.prototype.create_properties = function(properties, element) {
    var props;
    if (typeof properties === "function") props = properties(element);
    else props = $413a30192b54574f$var$_.extend({}, properties);
    return props;
};
/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */ var $413a30192b54574f$var$LinkTracker = function() {
    this.override_event = "click";
};
$413a30192b54574f$var$_.inherit($413a30192b54574f$var$LinkTracker, $413a30192b54574f$var$DomTracker);
$413a30192b54574f$var$LinkTracker.prototype.create_properties = function(properties, element) {
    var props = $413a30192b54574f$var$LinkTracker.superclass.create_properties.apply(this, arguments);
    if (element.href) props["url"] = element.href;
    return props;
};
$413a30192b54574f$var$LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === "_blank";
    options.href = element.href;
    if (!options.new_tab) evt.preventDefault();
};
$413a30192b54574f$var$LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) return;
    setTimeout(function() {
        window.location = options.href;
    }, 0);
};
/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */ var $413a30192b54574f$var$FormTracker = function() {
    this.override_event = "submit";
};
$413a30192b54574f$var$_.inherit($413a30192b54574f$var$FormTracker, $413a30192b54574f$var$DomTracker);
$413a30192b54574f$var$FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};
$413a30192b54574f$var$FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};
/* eslint camelcase: "off" */ /** @const */ var $413a30192b54574f$var$SET_ACTION = "$set";
/** @const */ var $413a30192b54574f$var$SET_ONCE_ACTION = "$set_once";
/** @const */ var $413a30192b54574f$var$UNSET_ACTION = "$unset";
/** @const */ var $413a30192b54574f$var$ADD_ACTION = "$add";
/** @const */ var $413a30192b54574f$var$APPEND_ACTION = "$append";
/** @const */ var $413a30192b54574f$var$UNION_ACTION = "$union";
/** @const */ var $413a30192b54574f$var$REMOVE_ACTION = "$remove";
/** @const */ var $413a30192b54574f$var$DELETE_ACTION = "$delete";
// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var $413a30192b54574f$var$apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if ($413a30192b54574f$var$_.isObject(prop)) $413a30192b54574f$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set[k] = v;
        }, this);
        else $set[prop] = to;
        data[$413a30192b54574f$var$SET_ACTION] = $set;
        return data;
    },
    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!$413a30192b54574f$var$_.isArray(prop)) prop = [
            prop
        ];
        $413a30192b54574f$var$_.each(prop, function(k) {
            if (!this._is_reserved_property(k)) $unset.push(k);
        }, this);
        data[$413a30192b54574f$var$UNSET_ACTION] = $unset;
        return data;
    },
    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if ($413a30192b54574f$var$_.isObject(prop)) $413a30192b54574f$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set_once[k] = v;
        }, this);
        else $set_once[prop] = to;
        data[$413a30192b54574f$var$SET_ONCE_ACTION] = $set_once;
        return data;
    },
    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if ($413a30192b54574f$var$_.isObject(list_name)) $413a30192b54574f$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $union[k] = $413a30192b54574f$var$_.isArray(v) ? v : [
                v
            ];
        }, this);
        else $union[list_name] = $413a30192b54574f$var$_.isArray(values) ? values : [
            values
        ];
        data[$413a30192b54574f$var$UNION_ACTION] = $union;
        return data;
    },
    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if ($413a30192b54574f$var$_.isObject(list_name)) $413a30192b54574f$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $append[k] = v;
        }, this);
        else $append[list_name] = value;
        data[$413a30192b54574f$var$APPEND_ACTION] = $append;
        return data;
    },
    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if ($413a30192b54574f$var$_.isObject(list_name)) $413a30192b54574f$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $remove[k] = v;
        }, this);
        else $remove[list_name] = value;
        data[$413a30192b54574f$var$REMOVE_ACTION] = $remove;
        return data;
    },
    delete_action: function() {
        var data = {};
        data[$413a30192b54574f$var$DELETE_ACTION] = "";
        return data;
    }
};
/* eslint camelcase: "off" */ /**
 * Mixpanel Group Object
 * @constructor
 */ var $413a30192b54574f$var$MixpanelGroup = function() {};
$413a30192b54574f$var$_.extend($413a30192b54574f$var$MixpanelGroup.prototype, $413a30192b54574f$var$apiActions);
$413a30192b54574f$var$MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};
/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $413a30192b54574f$var$MixpanelGroup.prototype.set = $413a30192b54574f$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($413a30192b54574f$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $413a30192b54574f$var$MixpanelGroup.prototype.set_once = $413a30192b54574f$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($413a30192b54574f$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $413a30192b54574f$var$MixpanelGroup.prototype.unset = $413a30192b54574f$var$addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $413a30192b54574f$var$MixpanelGroup.prototype.union = $413a30192b54574f$var$addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if ($413a30192b54574f$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $413a30192b54574f$var$MixpanelGroup.prototype["delete"] = $413a30192b54574f$var$addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});
/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $413a30192b54574f$var$MixpanelGroup.prototype.remove = $413a30192b54574f$var$addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
$413a30192b54574f$var$MixpanelGroup.prototype._send_request = function(data, callback) {
    data["$group_key"] = this._group_key;
    data["$group_id"] = this._group_id;
    data["$token"] = this._get_config("token");
    var date_encoded_data = $413a30192b54574f$var$_.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: "groups",
        data: date_encoded_data,
        endpoint: this._mixpanel.get_api_host("groups") + "/" + this._get_config("api_routes")["groups"],
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};
$413a30192b54574f$var$MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === "$group_key" || prop === "$group_id";
};
$413a30192b54574f$var$MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};
$413a30192b54574f$var$MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + ".group." + this._group_key + "." + this._group_id;
};
// MixpanelGroup Exports
$413a30192b54574f$var$MixpanelGroup.prototype["remove"] = $413a30192b54574f$var$MixpanelGroup.prototype.remove;
$413a30192b54574f$var$MixpanelGroup.prototype["set"] = $413a30192b54574f$var$MixpanelGroup.prototype.set;
$413a30192b54574f$var$MixpanelGroup.prototype["set_once"] = $413a30192b54574f$var$MixpanelGroup.prototype.set_once;
$413a30192b54574f$var$MixpanelGroup.prototype["union"] = $413a30192b54574f$var$MixpanelGroup.prototype.union;
$413a30192b54574f$var$MixpanelGroup.prototype["unset"] = $413a30192b54574f$var$MixpanelGroup.prototype.unset;
$413a30192b54574f$var$MixpanelGroup.prototype["toString"] = $413a30192b54574f$var$MixpanelGroup.prototype.toString;
/* eslint camelcase: "off" */ /**
 * Mixpanel People Object
 * @constructor
 */ var $413a30192b54574f$var$MixpanelPeople = function() {};
$413a30192b54574f$var$_.extend($413a30192b54574f$var$MixpanelPeople.prototype, $413a30192b54574f$var$apiActions);
$413a30192b54574f$var$MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};
/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $413a30192b54574f$var$MixpanelPeople.prototype.set = $413a30192b54574f$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($413a30192b54574f$var$_.isObject(prop)) callback = to;
    // make sure that the referrer info has been updated and saved
    if (this._get_config("save_referrer")) this._mixpanel["persistence"].update_referrer_info(document.referrer);
    // update $set object with default people properties
    data[$413a30192b54574f$var$SET_ACTION] = $413a30192b54574f$var$_.extend({}, $413a30192b54574f$var$_.info.people_properties(), data[$413a30192b54574f$var$SET_ACTION]);
    return this._send_request(data, callback);
});
/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $413a30192b54574f$var$MixpanelPeople.prototype.set_once = $413a30192b54574f$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($413a30192b54574f$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $413a30192b54574f$var$MixpanelPeople.prototype.unset = $413a30192b54574f$var$addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $413a30192b54574f$var$MixpanelPeople.prototype.increment = $413a30192b54574f$var$addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if ($413a30192b54574f$var$_.isObject(prop)) {
        $413a30192b54574f$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    $413a30192b54574f$var$console$1.error("Invalid increment value passed to mixpanel.people.increment - must be a number");
                    return;
                } else $add[k] = v;
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if ($413a30192b54574f$var$_.isUndefined(by)) by = 1;
        $add[prop] = by;
    }
    data[$413a30192b54574f$var$ADD_ACTION] = $add;
    return this._send_request(data, callback);
});
/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $413a30192b54574f$var$MixpanelPeople.prototype.append = $413a30192b54574f$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($413a30192b54574f$var$_.isObject(list_name)) callback = value;
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $413a30192b54574f$var$MixpanelPeople.prototype.remove = $413a30192b54574f$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($413a30192b54574f$var$_.isObject(list_name)) callback = value;
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $413a30192b54574f$var$MixpanelPeople.prototype.union = $413a30192b54574f$var$addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if ($413a30192b54574f$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 * @deprecated
 */ $413a30192b54574f$var$MixpanelPeople.prototype.track_charge = $413a30192b54574f$var$addOptOutCheckMixpanelPeople(function() {
    $413a30192b54574f$var$console$1.error("mixpanel.people.track_charge() is deprecated and no longer has any effect.");
});
/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 * @deprecated
 */ $413a30192b54574f$var$MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set("$transactions", [], callback);
};
/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/ $413a30192b54574f$var$MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        $413a30192b54574f$var$console$1.error("mixpanel.people.delete_user() requires you to call identify() first");
        return;
    }
    var data = {
        "$delete": this._mixpanel.get_distinct_id()
    };
    return this._send_request(data);
};
$413a30192b54574f$var$MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + ".people";
};
$413a30192b54574f$var$MixpanelPeople.prototype._send_request = function(data, callback) {
    data["$token"] = this._get_config("token");
    data["$distinct_id"] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property("$device_id");
    var user_id = this._mixpanel.get_property("$user_id");
    var had_persisted_distinct_id = this._mixpanel.get_property("$had_persisted_distinct_id");
    if (device_id) data["$device_id"] = device_id;
    if (user_id) data["$user_id"] = user_id;
    if (had_persisted_distinct_id) data["$had_persisted_distinct_id"] = had_persisted_distinct_id;
    var date_encoded_data = $413a30192b54574f$var$_.encodeDates(data);
    if (!this._identify_called()) {
        this._enqueue(data);
        if (!$413a30192b54574f$var$_.isUndefined(callback)) {
            if (this._get_config("verbose")) callback({
                status: -1,
                error: null
            });
            else callback(-1);
        }
        return $413a30192b54574f$var$_.truncate(date_encoded_data, 255);
    }
    return this._mixpanel._track_or_batch({
        type: "people",
        data: date_encoded_data,
        endpoint: this._mixpanel.get_api_host("people") + "/" + this._get_config("api_routes")["engage"],
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};
$413a30192b54574f$var$MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};
$413a30192b54574f$var$MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};
// Queue up engage operations if identify hasn't been called yet.
$413a30192b54574f$var$MixpanelPeople.prototype._enqueue = function(data) {
    if ($413a30192b54574f$var$SET_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($413a30192b54574f$var$SET_ACTION, data);
    else if ($413a30192b54574f$var$SET_ONCE_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($413a30192b54574f$var$SET_ONCE_ACTION, data);
    else if ($413a30192b54574f$var$UNSET_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($413a30192b54574f$var$UNSET_ACTION, data);
    else if ($413a30192b54574f$var$ADD_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($413a30192b54574f$var$ADD_ACTION, data);
    else if ($413a30192b54574f$var$APPEND_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($413a30192b54574f$var$APPEND_ACTION, data);
    else if ($413a30192b54574f$var$REMOVE_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($413a30192b54574f$var$REMOVE_ACTION, data);
    else if ($413a30192b54574f$var$UNION_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($413a30192b54574f$var$UNION_ACTION, data);
    else $413a30192b54574f$var$console$1.error("Invalid call to _enqueue():", data);
};
$413a30192b54574f$var$MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = $413a30192b54574f$var$_.extend({}, this._mixpanel["persistence"].load_queue(action));
    var action_params = queued_data;
    if (!$413a30192b54574f$var$_.isUndefined(queued_data) && $413a30192b54574f$var$_.isObject(queued_data) && !$413a30192b54574f$var$_.isEmptyObject(queued_data)) {
        _this._mixpanel["persistence"]._pop_from_people_queue(action, queued_data);
        _this._mixpanel["persistence"].save();
        if (queue_to_params_fn) action_params = queue_to_params_fn(queued_data);
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue(action, queued_data);
            if (!$413a30192b54574f$var$_.isUndefined(callback)) callback(response, data);
        });
    }
};
// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
$413a30192b54574f$var$MixpanelPeople.prototype._flush = function(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    var _this = this;
    this._flush_one_queue($413a30192b54574f$var$SET_ACTION, this.set, _set_callback);
    this._flush_one_queue($413a30192b54574f$var$SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue($413a30192b54574f$var$UNSET_ACTION, this.unset, _unset_callback, function(queue) {
        return $413a30192b54574f$var$_.keys(queue);
    });
    this._flush_one_queue($413a30192b54574f$var$ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue($413a30192b54574f$var$UNION_ACTION, this.union, _union_callback);
    // we have to fire off each $append individually since there is
    // no concat method server side
    var $append_queue = this._mixpanel["persistence"].load_queue($413a30192b54574f$var$APPEND_ACTION);
    if (!$413a30192b54574f$var$_.isUndefined($append_queue) && $413a30192b54574f$var$_.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue($413a30192b54574f$var$APPEND_ACTION, $append_item);
            if (!$413a30192b54574f$var$_.isUndefined(_append_callback)) _append_callback(response, data);
        };
        for(var i = $append_queue.length - 1; i >= 0; i--){
            $append_queue = this._mixpanel["persistence"].load_queue($413a30192b54574f$var$APPEND_ACTION);
            $append_item = $append_queue.pop();
            _this._mixpanel["persistence"].save();
            if (!$413a30192b54574f$var$_.isEmptyObject($append_item)) _this.append($append_item, append_callback);
        }
    }
    // same for $remove
    var $remove_queue = this._mixpanel["persistence"].load_queue($413a30192b54574f$var$REMOVE_ACTION);
    if (!$413a30192b54574f$var$_.isUndefined($remove_queue) && $413a30192b54574f$var$_.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue($413a30192b54574f$var$REMOVE_ACTION, $remove_item);
            if (!$413a30192b54574f$var$_.isUndefined(_remove_callback)) _remove_callback(response, data);
        };
        for(var j = $remove_queue.length - 1; j >= 0; j--){
            $remove_queue = this._mixpanel["persistence"].load_queue($413a30192b54574f$var$REMOVE_ACTION);
            $remove_item = $remove_queue.pop();
            _this._mixpanel["persistence"].save();
            if (!$413a30192b54574f$var$_.isEmptyObject($remove_item)) _this.remove($remove_item, remove_callback);
        }
    }
};
$413a30192b54574f$var$MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === "$distinct_id" || prop === "$token" || prop === "$device_id" || prop === "$user_id" || prop === "$had_persisted_distinct_id";
};
// MixpanelPeople Exports
$413a30192b54574f$var$MixpanelPeople.prototype["set"] = $413a30192b54574f$var$MixpanelPeople.prototype.set;
$413a30192b54574f$var$MixpanelPeople.prototype["set_once"] = $413a30192b54574f$var$MixpanelPeople.prototype.set_once;
$413a30192b54574f$var$MixpanelPeople.prototype["unset"] = $413a30192b54574f$var$MixpanelPeople.prototype.unset;
$413a30192b54574f$var$MixpanelPeople.prototype["increment"] = $413a30192b54574f$var$MixpanelPeople.prototype.increment;
$413a30192b54574f$var$MixpanelPeople.prototype["append"] = $413a30192b54574f$var$MixpanelPeople.prototype.append;
$413a30192b54574f$var$MixpanelPeople.prototype["remove"] = $413a30192b54574f$var$MixpanelPeople.prototype.remove;
$413a30192b54574f$var$MixpanelPeople.prototype["union"] = $413a30192b54574f$var$MixpanelPeople.prototype.union;
$413a30192b54574f$var$MixpanelPeople.prototype["track_charge"] = $413a30192b54574f$var$MixpanelPeople.prototype.track_charge;
$413a30192b54574f$var$MixpanelPeople.prototype["clear_charges"] = $413a30192b54574f$var$MixpanelPeople.prototype.clear_charges;
$413a30192b54574f$var$MixpanelPeople.prototype["delete_user"] = $413a30192b54574f$var$MixpanelPeople.prototype.delete_user;
$413a30192b54574f$var$MixpanelPeople.prototype["toString"] = $413a30192b54574f$var$MixpanelPeople.prototype.toString;
/* eslint camelcase: "off" */ /*
 * Constants
 */ /** @const */ var $413a30192b54574f$var$SET_QUEUE_KEY = "__mps";
/** @const */ var $413a30192b54574f$var$SET_ONCE_QUEUE_KEY = "__mpso";
/** @const */ var $413a30192b54574f$var$UNSET_QUEUE_KEY = "__mpus";
/** @const */ var $413a30192b54574f$var$ADD_QUEUE_KEY = "__mpa";
/** @const */ var $413a30192b54574f$var$APPEND_QUEUE_KEY = "__mpap";
/** @const */ var $413a30192b54574f$var$REMOVE_QUEUE_KEY = "__mpr";
/** @const */ var $413a30192b54574f$var$UNION_QUEUE_KEY = "__mpu";
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var $413a30192b54574f$var$PEOPLE_DISTINCT_ID_KEY = "$people_distinct_id";
/** @const */ var $413a30192b54574f$var$ALIAS_ID_KEY = "__alias";
/** @const */ var $413a30192b54574f$var$EVENT_TIMERS_KEY = "__timers";
/** @const */ var $413a30192b54574f$var$RESERVED_PROPERTIES = [
    $413a30192b54574f$var$SET_QUEUE_KEY,
    $413a30192b54574f$var$SET_ONCE_QUEUE_KEY,
    $413a30192b54574f$var$UNSET_QUEUE_KEY,
    $413a30192b54574f$var$ADD_QUEUE_KEY,
    $413a30192b54574f$var$APPEND_QUEUE_KEY,
    $413a30192b54574f$var$REMOVE_QUEUE_KEY,
    $413a30192b54574f$var$UNION_QUEUE_KEY,
    $413a30192b54574f$var$PEOPLE_DISTINCT_ID_KEY,
    $413a30192b54574f$var$ALIAS_ID_KEY,
    $413a30192b54574f$var$EVENT_TIMERS_KEY
];
/**
 * Mixpanel Persistence Object
 * @constructor
 */ var $413a30192b54574f$var$MixpanelPersistence = function(config) {
    this["props"] = {};
    this.campaign_params_saved = false;
    if (config["persistence_name"]) this.name = "mp_" + config["persistence_name"];
    else this.name = "mp_" + config["token"] + "_mixpanel";
    var storage_type = config["persistence"];
    if (storage_type !== "cookie" && storage_type !== "localStorage") {
        $413a30192b54574f$var$console$1.critical("Unknown persistence type " + storage_type + "; falling back to cookie");
        storage_type = config["persistence"] = "cookie";
    }
    if (storage_type === "localStorage" && $413a30192b54574f$var$_.localStorage.is_supported()) this.storage = $413a30192b54574f$var$_.localStorage;
    else this.storage = $413a30192b54574f$var$_.cookie;
    this.load();
    this.update_config(config);
    this.upgrade();
    this.save();
};
$413a30192b54574f$var$MixpanelPersistence.prototype.properties = function() {
    var p = {};
    this.load();
    // Filter out reserved properties
    $413a30192b54574f$var$_.each(this["props"], function(v, k) {
        if (!$413a30192b54574f$var$_.include($413a30192b54574f$var$RESERVED_PROPERTIES, k)) p[k] = v;
    });
    return p;
};
$413a30192b54574f$var$MixpanelPersistence.prototype.load = function() {
    if (this.disabled) return;
    var entry = this.storage.parse(this.name);
    if (entry) this["props"] = $413a30192b54574f$var$_.extend({}, entry);
};
$413a30192b54574f$var$MixpanelPersistence.prototype.upgrade = function() {
    var old_cookie, old_localstorage;
    // if transferring from cookie to localStorage or vice-versa, copy existing
    // super properties over to new storage mode
    if (this.storage === $413a30192b54574f$var$_.localStorage) {
        old_cookie = $413a30192b54574f$var$_.cookie.parse(this.name);
        $413a30192b54574f$var$_.cookie.remove(this.name);
        $413a30192b54574f$var$_.cookie.remove(this.name, true);
        if (old_cookie) this.register_once(old_cookie);
    } else if (this.storage === $413a30192b54574f$var$_.cookie) {
        old_localstorage = $413a30192b54574f$var$_.localStorage.parse(this.name);
        $413a30192b54574f$var$_.localStorage.remove(this.name);
        if (old_localstorage) this.register_once(old_localstorage);
    }
};
$413a30192b54574f$var$MixpanelPersistence.prototype.save = function() {
    if (this.disabled) return;
    this.storage.set(this.name, $413a30192b54574f$var$JSONStringify(this["props"]), this.expire_days, this.cross_subdomain, this.secure, this.cross_site, this.cookie_domain);
};
$413a30192b54574f$var$MixpanelPersistence.prototype.load_prop = function(key) {
    this.load();
    return this["props"][key];
};
$413a30192b54574f$var$MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};
// removes the storage entry and deletes all loaded data
// forced name for tests
$413a30192b54574f$var$MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this["props"] = {};
};
/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/ $413a30192b54574f$var$MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if ($413a30192b54574f$var$_.isObject(props)) {
        if (typeof default_value === "undefined") default_value = "None";
        this.expire_days = typeof days === "undefined" ? this.default_expiry : days;
        this.load();
        $413a30192b54574f$var$_.each(props, function(val, prop) {
            if (!this["props"].hasOwnProperty(prop) || this["props"][prop] === default_value) this["props"][prop] = val;
        }, this);
        this.save();
        return true;
    }
    return false;
};
/**
* @param {Object} props
* @param {number=} days
*/ $413a30192b54574f$var$MixpanelPersistence.prototype.register = function(props, days) {
    if ($413a30192b54574f$var$_.isObject(props)) {
        this.expire_days = typeof days === "undefined" ? this.default_expiry : days;
        this.load();
        $413a30192b54574f$var$_.extend(this["props"], props);
        this.save();
        return true;
    }
    return false;
};
$413a30192b54574f$var$MixpanelPersistence.prototype.unregister = function(prop) {
    this.load();
    if (prop in this["props"]) {
        delete this["props"][prop];
        this.save();
    }
};
$413a30192b54574f$var$MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register($413a30192b54574f$var$_.info.searchInfo(referrer));
};
// EXPORTED METHOD, we test this directly.
$413a30192b54574f$var$MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        "$initial_referrer": referrer || "$direct",
        "$initial_referring_domain": $413a30192b54574f$var$_.info.referringDomain(referrer) || "$direct"
    }, "");
};
$413a30192b54574f$var$MixpanelPersistence.prototype.get_referrer_info = function() {
    return $413a30192b54574f$var$_.strip_empty_properties({
        "$initial_referrer": this["props"]["$initial_referrer"],
        "$initial_referring_domain": this["props"]["$initial_referring_domain"]
    });
};
$413a30192b54574f$var$MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config["cookie_expiration"];
    this.set_disabled(config["disable_persistence"]);
    this.set_cookie_domain(config["cookie_domain"]);
    this.set_cross_site(config["cross_site_cookie"]);
    this.set_cross_subdomain(config["cross_subdomain_cookie"]);
    this.set_secure(config["secure_cookie"]);
};
$413a30192b54574f$var$MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) this.remove();
    else this.save();
};
$413a30192b54574f$var$MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};
$413a30192b54574f$var$MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};
$413a30192b54574f$var$MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};
$413a30192b54574f$var$MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};
$413a30192b54574f$var$MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};
$413a30192b54574f$var$MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue), q_data = data[queue], set_q = this._get_or_create_queue($413a30192b54574f$var$SET_ACTION), set_once_q = this._get_or_create_queue($413a30192b54574f$var$SET_ONCE_ACTION), unset_q = this._get_or_create_queue($413a30192b54574f$var$UNSET_ACTION), add_q = this._get_or_create_queue($413a30192b54574f$var$ADD_ACTION), union_q = this._get_or_create_queue($413a30192b54574f$var$UNION_ACTION), remove_q = this._get_or_create_queue($413a30192b54574f$var$REMOVE_ACTION, []), append_q = this._get_or_create_queue($413a30192b54574f$var$APPEND_ACTION, []);
    if (q_key === $413a30192b54574f$var$SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        $413a30192b54574f$var$_.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue($413a30192b54574f$var$ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue($413a30192b54574f$var$UNION_ACTION, q_data);
        this._pop_from_people_queue($413a30192b54574f$var$UNSET_ACTION, q_data);
    } else if (q_key === $413a30192b54574f$var$SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        $413a30192b54574f$var$_.each(q_data, function(v, k) {
            if (!(k in set_once_q)) set_once_q[k] = v;
        });
        this._pop_from_people_queue($413a30192b54574f$var$UNSET_ACTION, q_data);
    } else if (q_key === $413a30192b54574f$var$UNSET_QUEUE_KEY) $413a30192b54574f$var$_.each(q_data, function(prop) {
        // undo previously-queued actions on this key
        $413a30192b54574f$var$_.each([
            set_q,
            set_once_q,
            add_q,
            union_q
        ], function(enqueued_obj) {
            if (prop in enqueued_obj) delete enqueued_obj[prop];
        });
        $413a30192b54574f$var$_.each(append_q, function(append_obj) {
            if (prop in append_obj) delete append_obj[prop];
        });
        unset_q[prop] = true;
    });
    else if (q_key === $413a30192b54574f$var$ADD_QUEUE_KEY) {
        $413a30192b54574f$var$_.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) set_q[k] += v;
            else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) add_q[k] = 0;
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue($413a30192b54574f$var$UNSET_ACTION, q_data);
    } else if (q_key === $413a30192b54574f$var$UNION_QUEUE_KEY) {
        $413a30192b54574f$var$_.each(q_data, function(v, k) {
            if ($413a30192b54574f$var$_.isArray(v)) {
                if (!(k in union_q)) union_q[k] = [];
                // Prevent duplicate values
                $413a30192b54574f$var$_.each(v, function(item) {
                    if (!$413a30192b54574f$var$_.include(union_q[k], item)) union_q[k].push(item);
                });
            }
        });
        this._pop_from_people_queue($413a30192b54574f$var$UNSET_ACTION, q_data);
    } else if (q_key === $413a30192b54574f$var$REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue($413a30192b54574f$var$APPEND_ACTION, q_data);
    } else if (q_key === $413a30192b54574f$var$APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue($413a30192b54574f$var$UNSET_ACTION, q_data);
    }
    $413a30192b54574f$var$console$1.log("MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):");
    $413a30192b54574f$var$console$1.log(data);
    this.save();
};
$413a30192b54574f$var$MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this["props"][this._get_queue_key(queue)];
    if (!$413a30192b54574f$var$_.isUndefined(q)) $413a30192b54574f$var$_.each(data, function(v, k) {
        if (queue === $413a30192b54574f$var$APPEND_ACTION || queue === $413a30192b54574f$var$REMOVE_ACTION) // list actions: only remove if both k+v match
        // e.g. remove should not override append in a case like
        // append({foo: 'bar'}); remove({foo: 'qux'})
        $413a30192b54574f$var$_.each(q, function(queued_action) {
            if (queued_action[k] === v) delete queued_action[k];
        });
        else delete q[k];
    }, this);
};
$413a30192b54574f$var$MixpanelPersistence.prototype.load_queue = function(queue) {
    return this.load_prop(this._get_queue_key(queue));
};
$413a30192b54574f$var$MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === $413a30192b54574f$var$SET_ACTION) return $413a30192b54574f$var$SET_QUEUE_KEY;
    else if (queue === $413a30192b54574f$var$SET_ONCE_ACTION) return $413a30192b54574f$var$SET_ONCE_QUEUE_KEY;
    else if (queue === $413a30192b54574f$var$UNSET_ACTION) return $413a30192b54574f$var$UNSET_QUEUE_KEY;
    else if (queue === $413a30192b54574f$var$ADD_ACTION) return $413a30192b54574f$var$ADD_QUEUE_KEY;
    else if (queue === $413a30192b54574f$var$APPEND_ACTION) return $413a30192b54574f$var$APPEND_QUEUE_KEY;
    else if (queue === $413a30192b54574f$var$REMOVE_ACTION) return $413a30192b54574f$var$REMOVE_QUEUE_KEY;
    else if (queue === $413a30192b54574f$var$UNION_ACTION) return $413a30192b54574f$var$UNION_QUEUE_KEY;
    else $413a30192b54574f$var$console$1.error("Invalid queue:", queue);
};
$413a30192b54574f$var$MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = $413a30192b54574f$var$_.isUndefined(default_val) ? {} : default_val;
    return this["props"][key] || (this["props"][key] = default_val);
};
$413a30192b54574f$var$MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this.load_prop($413a30192b54574f$var$EVENT_TIMERS_KEY) || {};
    timers[event_name] = timestamp;
    this["props"][$413a30192b54574f$var$EVENT_TIMERS_KEY] = timers;
    this.save();
};
$413a30192b54574f$var$MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this.load_prop($413a30192b54574f$var$EVENT_TIMERS_KEY) || {};
    var timestamp = timers[event_name];
    if (!$413a30192b54574f$var$_.isUndefined(timestamp)) {
        delete this["props"][$413a30192b54574f$var$EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};
/* eslint camelcase: "off" */ /*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */ /*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/ var $413a30192b54574f$var$init_type; // MODULE or SNIPPET loader
// allow bundlers to specify how extra code (recorder bundle) should be loaded
// eslint-disable-next-line no-unused-vars
var $413a30192b54574f$var$load_extra_bundle = function(src, _onload) {
    throw new Error(src + " not available in this build.");
};
var $413a30192b54574f$var$mixpanel_master; // main mixpanel instance / object
var $413a30192b54574f$var$INIT_MODULE = 0;
var $413a30192b54574f$var$INIT_SNIPPET = 1;
var $413a30192b54574f$var$IDENTITY_FUNC = function(x) {
    return x;
};
/** @const */ var $413a30192b54574f$var$PRIMARY_INSTANCE_NAME = "mixpanel";
/** @const */ var $413a30192b54574f$var$PAYLOAD_TYPE_BASE64 = "base64";
/** @const */ var $413a30192b54574f$var$PAYLOAD_TYPE_JSON = "json";
/** @const */ var $413a30192b54574f$var$DEVICE_ID_PREFIX = "$device:";
/*
 * Dynamic... constants? Is that an oxymoron?
 */ // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var $413a30192b54574f$var$USE_XHR = $413a30192b54574f$var$win.XMLHttpRequest && "withCredentials" in new XMLHttpRequest();
// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var $413a30192b54574f$var$ENQUEUE_REQUESTS = !$413a30192b54574f$var$USE_XHR && $413a30192b54574f$var$userAgent.indexOf("MSIE") === -1 && $413a30192b54574f$var$userAgent.indexOf("Mozilla") === -1;
// save reference to navigator.sendBeacon so it can be minified
var $413a30192b54574f$var$sendBeacon = null;
if ($413a30192b54574f$var$navigator["sendBeacon"]) $413a30192b54574f$var$sendBeacon = function() {
    // late reference to navigator.sendBeacon to allow patching/spying
    return $413a30192b54574f$var$navigator["sendBeacon"].apply($413a30192b54574f$var$navigator, arguments);
};
var $413a30192b54574f$var$DEFAULT_API_ROUTES = {
    "track": "track/",
    "engage": "engage/",
    "groups": "groups/",
    "record": "record/",
    "flags": "flags/"
};
/*
 * Module-level globals
 */ var $413a30192b54574f$var$DEFAULT_CONFIG = {
    "api_host": "https://api-js.mixpanel.com",
    "api_hosts": {},
    "api_routes": $413a30192b54574f$var$DEFAULT_API_ROUTES,
    "api_extra_query_params": {},
    "api_method": "POST",
    "api_transport": "XHR",
    "api_payload_format": $413a30192b54574f$var$PAYLOAD_TYPE_BASE64,
    "app_host": "https://mixpanel.com",
    "autocapture": false,
    "cdn": "https://cdn.mxpnl.com",
    "cross_site_cookie": false,
    "cross_subdomain_cookie": true,
    "error_reporter": $413a30192b54574f$var$NOOP_FUNC,
    "flags": false,
    "persistence": "cookie",
    "persistence_name": "",
    "cookie_domain": "",
    "cookie_name": "",
    "loaded": $413a30192b54574f$var$NOOP_FUNC,
    "mp_loader": null,
    "track_marketing": true,
    "track_pageview": false,
    "skip_first_touch_marketing": false,
    "store_google": true,
    "stop_utm_persistence": false,
    "save_referrer": true,
    "test": false,
    "verbose": false,
    "img": false,
    "debug": false,
    "track_links_timeout": 300,
    "cookie_expiration": 365,
    "upgrade": false,
    "disable_persistence": false,
    "disable_cookie": false,
    "secure_cookie": false,
    "ip": true,
    "opt_out_tracking_by_default": false,
    "opt_out_persistence_by_default": false,
    "opt_out_tracking_persistence_type": "localStorage",
    "opt_out_tracking_cookie_prefix": null,
    "property_blacklist": [],
    "xhr_headers": {},
    "ignore_dnt": false,
    "batch_requests": true,
    "batch_size": 50,
    "batch_flush_interval_ms": 5000,
    "batch_request_timeout_ms": 90000,
    "batch_autostart": true,
    "hooks": {},
    "record_block_class": new RegExp("^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$"),
    "record_block_selector": "img, video, audio",
    "record_canvas": false,
    "record_collect_fonts": false,
    "record_heatmap_data": false,
    "record_idle_timeout_ms": 1800000,
    "record_mask_text_class": new RegExp("^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$"),
    "record_mask_text_selector": "*",
    "record_max_ms": $413a30192b54574f$var$MAX_RECORDING_MS,
    "record_min_ms": 0,
    "record_sessions_percent": 0,
    "recorder_src": "https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js"
};
var $413a30192b54574f$var$DOM_LOADED = false;
/**
 * Mixpanel Library Object
 * @constructor
 */ var $413a30192b54574f$var$MixpanelLib = function() {};
/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */ var $413a30192b54574f$var$create_mplib = function(token, config, name) {
    var instance, target = name === $413a30192b54574f$var$PRIMARY_INSTANCE_NAME ? $413a30192b54574f$var$mixpanel_master : $413a30192b54574f$var$mixpanel_master[name];
    if (target && $413a30192b54574f$var$init_type === $413a30192b54574f$var$INIT_MODULE) instance = target;
    else {
        if (target && !$413a30192b54574f$var$_.isArray(target)) {
            $413a30192b54574f$var$console$1.error("You have already initialized " + name);
            return;
        }
        instance = new $413a30192b54574f$var$MixpanelLib();
    }
    instance._cached_groups = {}; // cache groups in a pool
    instance._init(token, config, name);
    instance["people"] = new $413a30192b54574f$var$MixpanelPeople();
    instance["people"]._init(instance);
    if (!instance.get_config("skip_first_touch_marketing")) {
        // We need null UTM params in the object because
        // UTM parameters act as a tuple. If any UTM param
        // is present, then we set all UTM params including
        // empty ones together
        var utm_params = $413a30192b54574f$var$_.info.campaignParams(null);
        var initial_utm_params = {};
        var has_utm = false;
        $413a30192b54574f$var$_.each(utm_params, function(utm_value, utm_key) {
            initial_utm_params["initial_" + utm_key] = utm_value;
            if (utm_value) has_utm = true;
        });
        if (has_utm) instance["people"].set_once(initial_utm_params);
    }
    // if any instance on the page has debug = true, we set the
    // global debug to be true
    $413a30192b54574f$var$Config.DEBUG = $413a30192b54574f$var$Config.DEBUG || instance.get_config("debug");
    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!$413a30192b54574f$var$_.isUndefined(target) && $413a30192b54574f$var$_.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance["people"], target["people"]);
        instance._execute_array(target);
    }
    return instance;
};
// Initialization methods
/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/v2.46.0/src/mixpanel-core.js#L88-L127">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */ $413a30192b54574f$var$MixpanelLib.prototype.init = function(token, config, name) {
    if ($413a30192b54574f$var$_.isUndefined(name)) {
        this.report_error("You must name your new library: init(token, config, name)");
        return;
    }
    if (name === $413a30192b54574f$var$PRIMARY_INSTANCE_NAME) {
        this.report_error("You must initialize the main mixpanel object right after you include the Mixpanel js snippet");
        return;
    }
    var instance = $413a30192b54574f$var$create_mplib(token, config, name);
    $413a30192b54574f$var$mixpanel_master[name] = instance;
    instance._loaded();
    return instance;
};
// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
$413a30192b54574f$var$MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};
    this["__loaded"] = true;
    this["config"] = {};
    var variable_features = {};
    // default to JSON payload for standard mixpanel.com API hosts
    if (!("api_payload_format" in config)) {
        var api_host = config["api_host"] || $413a30192b54574f$var$DEFAULT_CONFIG["api_host"];
        if (api_host.match(/\.mixpanel\.com/)) variable_features["api_payload_format"] = $413a30192b54574f$var$PAYLOAD_TYPE_JSON;
    }
    this.set_config($413a30192b54574f$var$_.extend({}, $413a30192b54574f$var$DEFAULT_CONFIG, variable_features, config, {
        "name": name,
        "token": token,
        "callback_fn": (name === $413a30192b54574f$var$PRIMARY_INSTANCE_NAME ? name : $413a30192b54574f$var$PRIMARY_INSTANCE_NAME + "." + name) + "._jsc"
    }));
    this["_jsc"] = $413a30192b54574f$var$NOOP_FUNC;
    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        "disable_all_events": false,
        "identify_called": false
    };
    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config("batch_requests");
    if (this._batch_requests) {
        if (!$413a30192b54574f$var$_.localStorage.is_supported(true) || !$413a30192b54574f$var$USE_XHR) {
            this._batch_requests = false;
            $413a30192b54574f$var$console$1.log("Turning off Mixpanel request-queueing; needs XHR and localStorage support");
            $413a30192b54574f$var$_.each(this.get_batcher_configs(), function(batcher_config) {
                $413a30192b54574f$var$console$1.log("Clearing batch queue " + batcher_config.queue_key);
                $413a30192b54574f$var$_.localStorage.remove(batcher_config.queue_key);
            });
        } else {
            this.init_batchers();
            if ($413a30192b54574f$var$sendBeacon && $413a30192b54574f$var$win.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = $413a30192b54574f$var$_.bind(function() {
                    if (!this.request_batchers.events.stopped) this.request_batchers.events.flush({
                        unloading: true
                    });
                }, this);
                $413a30192b54574f$var$win.addEventListener("pagehide", function(ev) {
                    if (ev["persisted"]) flush_on_unload();
                });
                $413a30192b54574f$var$win.addEventListener("visibilitychange", function() {
                    if ($413a30192b54574f$var$document$1["visibilityState"] === "hidden") flush_on_unload();
                });
            }
        }
    }
    this["persistence"] = this["cookie"] = new $413a30192b54574f$var$MixpanelPersistence(this["config"]);
    this.unpersisted_superprops = {};
    this._gdpr_init();
    var uuid = $413a30192b54574f$var$_.UUID();
    if (!this.get_distinct_id()) // There is no need to set the distinct id
    // or the device id if something was already stored
    // in the persitence
    this.register_once({
        "distinct_id": $413a30192b54574f$var$DEVICE_ID_PREFIX + uuid,
        "$device_id": uuid
    }, "");
    this.flags = new $413a30192b54574f$var$FeatureFlagManager({
        getFullApiRoute: $413a30192b54574f$var$_.bind(function() {
            return this.get_api_host("flags") + "/" + this.get_config("api_routes")["flags"];
        }, this),
        getConfigFunc: $413a30192b54574f$var$_.bind(this.get_config, this),
        setConfigFunc: $413a30192b54574f$var$_.bind(this.set_config, this),
        getPropertyFunc: $413a30192b54574f$var$_.bind(this.get_property, this),
        trackingFunc: $413a30192b54574f$var$_.bind(this.track, this)
    });
    this.flags.init();
    this["flags"] = this.flags;
    this.autocapture = new $413a30192b54574f$var$Autocapture(this);
    this.autocapture.init();
    this._init_tab_id();
    this._check_and_start_session_recording();
};
/**
 * Assigns a unique UUID to this tab / window by leveraging sessionStorage.
 * This is primarily used for session recording, where data must be isolated to the current tab.
 */ $413a30192b54574f$var$MixpanelLib.prototype._init_tab_id = function() {
    if (this.get_config("disable_persistence")) $413a30192b54574f$var$console$1.log("Tab ID initialization skipped due to disable_persistence config");
    else if ($413a30192b54574f$var$_.sessionStorage.is_supported()) try {
        var key_suffix = this.get_config("name") + "_" + this.get_config("token");
        var tab_id_key = "mp_tab_id_" + key_suffix;
        // A flag is used to determine if sessionStorage is copied over and we need to generate a new tab ID.
        // This enforces a unique ID in the cases like duplicated tab, window.open(...)
        var should_generate_new_tab_id_key = "mp_gen_new_tab_id_" + key_suffix;
        if ($413a30192b54574f$var$_.sessionStorage.get(should_generate_new_tab_id_key) || !$413a30192b54574f$var$_.sessionStorage.get(tab_id_key)) $413a30192b54574f$var$_.sessionStorage.set(tab_id_key, "$tab-" + $413a30192b54574f$var$_.UUID());
        $413a30192b54574f$var$_.sessionStorage.set(should_generate_new_tab_id_key, "1");
        this.tab_id = $413a30192b54574f$var$_.sessionStorage.get(tab_id_key);
        // Remove the flag when the tab is unloaded to indicate the stored tab ID can be reused. This event is not reliable to detect all page unloads,
        // but reliable in cases where the user remains in the tab e.g. a refresh or href navigation.
        // If the flag is absent, this indicates to the next SDK instance that we can reuse the stored tab_id.
        $413a30192b54574f$var$win.addEventListener("beforeunload", function() {
            $413a30192b54574f$var$_.sessionStorage.remove(should_generate_new_tab_id_key);
        });
    } catch (err) {
        this.report_error("Error initializing tab id", err);
    }
    else this.report_error("Session storage is not supported, cannot keep track of unique tab ID.");
};
$413a30192b54574f$var$MixpanelLib.prototype.get_tab_id = function() {
    return this.tab_id || null;
};
$413a30192b54574f$var$MixpanelLib.prototype._should_load_recorder = function() {
    if (this.get_config("disable_persistence")) {
        $413a30192b54574f$var$console$1.log("Load recorder check skipped due to disable_persistence config");
        return Promise.resolve(false);
    }
    var recording_registry_idb = new $413a30192b54574f$var$IDBStorageWrapper($413a30192b54574f$var$RECORDING_REGISTRY_STORE_NAME);
    var tab_id = this.get_tab_id();
    return recording_registry_idb.init().then(function() {
        return recording_registry_idb.getAll();
    }).then(function(recordings) {
        for(var i = 0; i < recordings.length; i++){
            // if there are expired recordings in the registry, we should load the recorder to flush them
            // if there's a recording for this tab id, we should load the recorder to continue the recording
            if ($413a30192b54574f$var$isRecordingExpired(recordings[i]) || recordings[i]["tabId"] === tab_id) return true;
        }
        return false;
    }).catch($413a30192b54574f$var$_.bind(function(err) {
        this.report_error("Error checking recording registry", err);
    }, this));
};
$413a30192b54574f$var$MixpanelLib.prototype._check_and_start_session_recording = $413a30192b54574f$var$addOptOutCheckMixpanelLib(function(force_start) {
    if (!$413a30192b54574f$var$win["MutationObserver"]) {
        $413a30192b54574f$var$console$1.critical("Browser does not support MutationObserver; skipping session recording");
        return;
    }
    var loadRecorder = $413a30192b54574f$var$_.bind(function(startNewIfInactive) {
        var handleLoadedRecorder = $413a30192b54574f$var$_.bind(function() {
            this._recorder = this._recorder || new $413a30192b54574f$var$win["__mp_recorder"](this);
            this._recorder["resumeRecording"](startNewIfInactive);
        }, this);
        if ($413a30192b54574f$var$_.isUndefined($413a30192b54574f$var$win["__mp_recorder"])) $413a30192b54574f$var$load_extra_bundle(this.get_config("recorder_src"), handleLoadedRecorder);
        else handleLoadedRecorder();
    }, this);
    /**
     * If the user is sampled or start_session_recording is called, we always load the recorder since it's guaranteed a recording should start.
     * Otherwise, if the recording registry has any records then it's likely there's a recording in progress or orphaned data that needs to be flushed.
     */ var is_sampled = this.get_config("record_sessions_percent") > 0 && Math.random() * 100 <= this.get_config("record_sessions_percent");
    if (force_start || is_sampled) loadRecorder(true);
    else this._should_load_recorder().then(function(shouldLoad) {
        if (shouldLoad) loadRecorder(false);
    });
});
$413a30192b54574f$var$MixpanelLib.prototype.start_session_recording = function() {
    this._check_and_start_session_recording(true);
};
$413a30192b54574f$var$MixpanelLib.prototype.stop_session_recording = function() {
    if (this._recorder) return this._recorder["stopRecording"]();
    return Promise.resolve();
};
$413a30192b54574f$var$MixpanelLib.prototype.pause_session_recording = function() {
    if (this._recorder) return this._recorder["pauseRecording"]();
    return Promise.resolve();
};
$413a30192b54574f$var$MixpanelLib.prototype.resume_session_recording = function() {
    if (this._recorder) return this._recorder["resumeRecording"]();
    return Promise.resolve();
};
$413a30192b54574f$var$MixpanelLib.prototype.is_recording_heatmap_data = function() {
    return this._get_session_replay_id() && this.get_config("record_heatmap_data");
};
$413a30192b54574f$var$MixpanelLib.prototype.get_session_recording_properties = function() {
    var props = {};
    var replay_id = this._get_session_replay_id();
    if (replay_id) props["$mp_replay_id"] = replay_id;
    return props;
};
$413a30192b54574f$var$MixpanelLib.prototype.get_session_replay_url = function() {
    var replay_url = null;
    var replay_id = this._get_session_replay_id();
    if (replay_id) {
        var query_params = $413a30192b54574f$var$_.HTTPBuildQuery({
            "replay_id": replay_id,
            "distinct_id": this.get_distinct_id(),
            "token": this.get_config("token")
        });
        replay_url = "https://mixpanel.com/projects/replay-redirect?" + query_params;
    }
    return replay_url;
};
$413a30192b54574f$var$MixpanelLib.prototype._get_session_replay_id = function() {
    var replay_id = null;
    if (this._recorder) replay_id = this._recorder["replayId"];
    return replay_id || null;
};
// "private" public method to reach into the recorder in test cases
$413a30192b54574f$var$MixpanelLib.prototype.__get_recorder = function() {
    return this._recorder;
};
// Private methods
$413a30192b54574f$var$MixpanelLib.prototype._loaded = function() {
    this.get_config("loaded")(this);
    this._set_default_superprops();
    this["people"].set_once(this["persistence"].get_referrer_info());
    // `store_google` is now deprecated and previously stored UTM parameters are cleared
    // from persistence by default.
    if (this.get_config("store_google") && this.get_config("stop_utm_persistence")) {
        var utm_params = $413a30192b54574f$var$_.info.campaignParams(null);
        $413a30192b54574f$var$_.each(utm_params, (function(_utm_value, utm_key) {
            // We need to unregister persisted UTM parameters so old values
            // are not mixed with the new UTM parameters
            this.unregister(utm_key);
        }).bind(this));
    }
};
// update persistence with info on referrer, UTM params, etc
$413a30192b54574f$var$MixpanelLib.prototype._set_default_superprops = function() {
    this["persistence"].update_search_keyword($413a30192b54574f$var$document$1.referrer);
    // Registering super properties for UTM persistence by 'store_google' is deprecated.
    if (this.get_config("store_google") && !this.get_config("stop_utm_persistence")) this.register($413a30192b54574f$var$_.info.campaignParams());
    if (this.get_config("save_referrer")) this["persistence"].update_referrer_info($413a30192b54574f$var$document$1.referrer);
};
$413a30192b54574f$var$MixpanelLib.prototype._dom_loaded = function() {
    $413a30192b54574f$var$_.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    if (!this.has_opted_out_tracking()) $413a30192b54574f$var$_.each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};
$413a30192b54574f$var$MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config("img")) {
        this.report_error("You can't use DOM tracking functions with img = true.");
        return false;
    }
    if (!$413a30192b54574f$var$DOM_LOADED) {
        this.__dom_loaded_queue.push([
            DomClass,
            args
        ]);
        return false;
    }
    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};
/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */ $413a30192b54574f$var$MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if ($413a30192b54574f$var$_.isUndefined(callback)) return null;
    if ($413a30192b54574f$var$USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this["_jsc"];
        var randomized_cb = "" + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config("callback_fn") + "[" + randomized_cb + "]";
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};
$413a30192b54574f$var$MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;
    if ($413a30192b54574f$var$ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }
    var DEFAULT_OPTIONS = {
        method: this.get_config("api_method"),
        transport: this.get_config("api_transport"),
        verbose: this.get_config("verbose")
    };
    var body_data = null;
    if (!callback && ($413a30192b54574f$var$_.isFunction(options) || typeof options === "string")) {
        callback = options;
        options = null;
    }
    options = $413a30192b54574f$var$_.extend(DEFAULT_OPTIONS, options || {});
    if (!$413a30192b54574f$var$USE_XHR) options.method = "GET";
    var use_post = options.method === "POST";
    var use_sendBeacon = $413a30192b54574f$var$sendBeacon && use_post && options.transport.toLowerCase() === "sendbeacon";
    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data["verbose"]) verbose_mode = true;
    if (this.get_config("test")) data["test"] = 1;
    if (verbose_mode) data["verbose"] = 1;
    if (this.get_config("img")) data["img"] = 1;
    if (!$413a30192b54574f$var$USE_XHR) {
        if (callback) data["callback"] = callback;
        else if (verbose_mode || this.get_config("test")) // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data["callback"] = "(function(){})";
    }
    data["ip"] = this.get_config("ip") ? 1 : 0;
    data["_"] = new Date().getTime().toString();
    if (use_post) {
        body_data = "data=" + encodeURIComponent(data["data"]);
        delete data["data"];
    }
    $413a30192b54574f$var$_.extend(data, this.get_config("api_extra_query_params"));
    url += "?" + $413a30192b54574f$var$_.HTTPBuildQuery(data);
    var lib = this;
    if ("img" in data) {
        var img = $413a30192b54574f$var$document$1.createElement("img");
        img.src = url;
        $413a30192b54574f$var$document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = $413a30192b54574f$var$sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) callback(succeeded ? 1 : 0);
        } catch (e) {
            lib.report_error(e);
        }
    } else if ($413a30192b54574f$var$USE_XHR) try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);
        var headers = this.get_config("xhr_headers");
        if (use_post) headers["Content-Type"] = "application/x-www-form-urlencoded";
        $413a30192b54574f$var$_.each(headers, function(headerValue, headerName) {
            req.setRequestHeader(headerName, headerValue);
        });
        if (options.timeout_ms && typeof req.timeout !== "undefined") {
            req.timeout = options.timeout_ms;
            var start_time = new Date().getTime();
        }
        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    if (callback) {
                        if (verbose_mode) {
                            var response;
                            try {
                                response = $413a30192b54574f$var$_.JSONDecode(req.responseText);
                            } catch (e) {
                                lib.report_error(e);
                                if (options.ignore_json_errors) response = req.responseText;
                                else return;
                            }
                            callback(response);
                        } else callback(Number(req.responseText));
                    }
                } else {
                    var error;
                    if (req.timeout && !req.status && new Date().getTime() - start_time >= req.timeout) error = "timeout";
                    else error = "Bad HTTP status: " + req.status + " " + req.statusText;
                    lib.report_error(error);
                    if (callback) {
                        if (verbose_mode) {
                            var response_headers = req["responseHeaders"] || {};
                            callback({
                                status: 0,
                                httpStatusCode: req["status"],
                                error: error,
                                retryAfter: response_headers["Retry-After"]
                            });
                        } else callback(0);
                    }
                }
            }
        };
        req.send(body_data);
    } catch (e) {
        lib.report_error(e);
        succeeded = false;
    }
    else {
        var script = $413a30192b54574f$var$document$1.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = $413a30192b54574f$var$document$1.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(script, s);
    }
    return succeeded;
};
/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */ $413a30192b54574f$var$MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    $413a30192b54574f$var$_.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if ($413a30192b54574f$var$_.isArray(fn_name)) tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            else if (typeof item === "function") item.call(this);
            else if ($413a30192b54574f$var$_.isArray(item) && fn_name === "alias") alias_calls.push(item);
            else if ($413a30192b54574f$var$_.isArray(item) && fn_name.indexOf("track") !== -1 && typeof this[fn_name] === "function") tracking_calls.push(item);
            else other_calls.push(item);
        }
    }, this);
    var execute = function(calls, context) {
        $413a30192b54574f$var$_.each(calls, function(item) {
            if ($413a30192b54574f$var$_.isArray(item[0])) {
                // chained call
                var caller = context;
                $413a30192b54574f$var$_.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else this[item[0]].apply(this, item.slice(1));
        }, context);
    };
    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};
// request queueing utils
$413a30192b54574f$var$MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};
$413a30192b54574f$var$MixpanelLib.prototype.get_batcher_configs = function() {
    var queue_prefix = "__mpq_" + this.get_config("token");
    this._batcher_configs = this._batcher_configs || {
        events: {
            type: "events",
            api_name: "track",
            queue_key: queue_prefix + "_ev"
        },
        people: {
            type: "people",
            api_name: "engage",
            queue_key: queue_prefix + "_pp"
        },
        groups: {
            type: "groups",
            api_name: "groups",
            queue_key: queue_prefix + "_gr"
        }
    };
    return this._batcher_configs;
};
$413a30192b54574f$var$MixpanelLib.prototype.init_batchers = function() {
    if (!this.are_batchers_initialized()) {
        var batcher_for = $413a30192b54574f$var$_.bind(function(attrs) {
            return new $413a30192b54574f$var$RequestBatcher(attrs.queue_key, {
                libConfig: this["config"],
                errorReporter: this.get_config("error_reporter"),
                sendRequestFunc: $413a30192b54574f$var$_.bind(function(data, options, cb) {
                    var api_routes = this.get_config("api_routes");
                    this._send_request(this.get_api_host(attrs.api_name) + "/" + api_routes[attrs.api_name], this._encode_data_for_request(data), options, this._prepare_callback(cb, data));
                }, this),
                beforeSendHook: $413a30192b54574f$var$_.bind(function(item) {
                    return this._run_hook("before_send_" + attrs.type, item);
                }, this),
                stopAllBatchingFunc: $413a30192b54574f$var$_.bind(this.stop_batch_senders, this),
                usePersistence: true
            });
        }, this);
        var batcher_configs = this.get_batcher_configs();
        this.request_batchers = {
            events: batcher_for(batcher_configs.events),
            people: batcher_for(batcher_configs.people),
            groups: batcher_for(batcher_configs.groups)
        };
    }
    if (this.get_config("batch_autostart")) this.start_batch_senders();
};
$413a30192b54574f$var$MixpanelLib.prototype.start_batch_senders = function() {
    this._batchers_were_started = true;
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        $413a30192b54574f$var$_.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};
$413a30192b54574f$var$MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    $413a30192b54574f$var$_.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};
/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */ $413a30192b54574f$var$MixpanelLib.prototype.push = function(item) {
    this._execute_array([
        item
    ]);
};
/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */ $413a30192b54574f$var$MixpanelLib.prototype.disable = function(events) {
    if (typeof events === "undefined") this._flags.disable_all_events = true;
    else this.__disabled_events = this.__disabled_events.concat(events);
};
$413a30192b54574f$var$MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = $413a30192b54574f$var$JSONStringify(data);
    if (this.get_config("api_payload_format") === $413a30192b54574f$var$PAYLOAD_TYPE_BASE64) encoded_data = $413a30192b54574f$var$_.base64Encode(encoded_data);
    return {
        "data": encoded_data
    };
};
// internal method for handling track vs batch-enqueue logic
$413a30192b54574f$var$MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = $413a30192b54574f$var$_.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || $413a30192b54574f$var$NOOP_FUNC;
    var request_enqueued_or_initiated = true;
    var send_request_immediately = $413a30192b54574f$var$_.bind(function() {
        if (!send_request_options.skip_hooks) truncated_data = this._run_hook("before_send_" + options.type, truncated_data);
        if (truncated_data) {
            $413a30192b54574f$var$console$1.log("MIXPANEL REQUEST:");
            $413a30192b54574f$var$console$1.log(truncated_data);
            return this._send_request(endpoint, this._encode_data_for_request(truncated_data), send_request_options, this._prepare_callback(callback, truncated_data));
        } else return null;
    }, this);
    if (this._batch_requests && !should_send_immediately) batcher.enqueue(truncated_data).then(function(succeeded) {
        if (succeeded) callback(1, truncated_data);
        else send_request_immediately();
    });
    else request_enqueued_or_initiated = send_request_immediately();
    return request_enqueued_or_initiated && truncated_data;
};
/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $413a30192b54574f$var$MixpanelLib.prototype.track = $413a30192b54574f$var$addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === "function") {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options["transport"]; // external API, don't minify 'transport' prop
    if (transport) options.transport = transport; // 'transport' prop name can be minified internally
    var should_send_immediately = options["send_immediately"];
    if (typeof callback !== "function") callback = $413a30192b54574f$var$NOOP_FUNC;
    if ($413a30192b54574f$var$_.isUndefined(event_name)) {
        this.report_error("No event name provided to mixpanel.track");
        return;
    }
    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }
    // set defaults
    properties = $413a30192b54574f$var$_.extend({}, properties);
    properties["token"] = this.get_config("token");
    // set $duration if time_event was previously called for this event
    var start_timestamp = this["persistence"].remove_event_timer(event_name);
    if (!$413a30192b54574f$var$_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties["$duration"] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }
    this._set_default_superprops();
    var marketing_properties = this.get_config("track_marketing") ? $413a30192b54574f$var$_.info.marketingParams() : {};
    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object
    // update properties with pageview info and super-properties
    properties = $413a30192b54574f$var$_.extend({}, $413a30192b54574f$var$_.info.properties({
        "mp_loader": this.get_config("mp_loader")
    }), marketing_properties, this["persistence"].properties(), this.unpersisted_superprops, this.get_session_recording_properties(), properties);
    var property_blacklist = this.get_config("property_blacklist");
    if ($413a30192b54574f$var$_.isArray(property_blacklist)) $413a30192b54574f$var$_.each(property_blacklist, function(blacklisted_prop) {
        delete properties[blacklisted_prop];
    });
    else this.report_error("Invalid value for property_blacklist config: " + property_blacklist);
    var data = {
        "event": event_name,
        "properties": properties
    };
    var ret = this._track_or_batch({
        type: "events",
        data: data,
        endpoint: this.get_api_host("events") + "/" + this.get_config("api_routes")["track"],
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);
    return ret;
});
/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */ $413a30192b54574f$var$MixpanelLib.prototype.set_group = $413a30192b54574f$var$addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!$413a30192b54574f$var$_.isArray(group_ids)) group_ids = [
        group_ids
    ];
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this["people"].set(group_key, group_ids, callback);
});
/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $413a30192b54574f$var$MixpanelLib.prototype.add_group = $413a30192b54574f$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    var prop = {};
    if (old_values === undefined) {
        prop[group_key] = [
            group_id
        ];
        this.register(prop);
    } else if (old_values.indexOf(group_id) === -1) {
        old_values.push(group_id);
        prop[group_key] = old_values;
        this.register(prop);
    }
    return this["people"].union(group_key, group_id, callback);
});
/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $413a30192b54574f$var$MixpanelLib.prototype.remove_group = $413a30192b54574f$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({
                group_key: old_value
            });
        }
        if (old_value.length === 0) this.unregister(group_key);
    }
    return this["people"].remove(group_key, group_id, callback);
});
/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $413a30192b54574f$var$MixpanelLib.prototype.track_with_groups = $413a30192b54574f$var$addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = $413a30192b54574f$var$_.extend({}, properties || {});
    $413a30192b54574f$var$_.each(groups, function(v, k) {
        if (v !== null && v !== undefined) tracking_props[k] = v;
    });
    return this.track(event_name, tracking_props, callback);
});
$413a30192b54574f$var$MixpanelLib.prototype._create_map_key = function(group_key, group_id) {
    return group_key + "_" + JSON.stringify(group_id);
};
$413a30192b54574f$var$MixpanelLib.prototype._remove_group_from_cache = function(group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};
/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */ $413a30192b54574f$var$MixpanelLib.prototype.get_group = function(group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new $413a30192b54574f$var$MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};
/**
 * Track a default Mixpanel page view event, which includes extra default event properties to
 * improve page view data.
 *
 * ### Usage:
 *
 *     // track a default $mp_web_page_view event
 *     mixpanel.track_pageview();
 *
 *     // track a page view event with additional event properties
 *     mixpanel.track_pageview({'ab_test_variant': 'card-layout-b'});
 *
 *     // example approach to track page views on different page types as event properties
 *     mixpanel.track_pageview({'page': 'pricing'});
 *     mixpanel.track_pageview({'page': 'homepage'});
 *
 *     // UNCOMMON: Tracking a page view event with a custom event_name option. NOT expected to be used for
 *     // individual pages on the same site or product. Use cases for custom event_name may be page
 *     // views on different products or internal applications that are considered completely separate
 *     mixpanel.track_pageview({'page': 'customer-search'}, {'event_name': '[internal] Admin Page View'});
 *
 * ### Notes:
 *
 * The `config.track_pageview` option for <a href="#mixpanelinit">mixpanel.init()</a>
 * may be turned on for tracking page loads automatically.
 *
 *     // track only page loads
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: true});
 *
 *     // track when the URL changes in any manner
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'full-url'});
 *
 *     // track when the URL changes, ignoring any changes in the hash part
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path-and-query-string'});
 *
 *     // track when the path changes, ignoring any query parameter or hash changes
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path'});
 *
 * @param {Object} [properties] An optional set of additional properties to send with the page view event
 * @param {Object} [options] Page view tracking options
 * @param {String} [options.event_name] - Alternate name for the tracking event
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $413a30192b54574f$var$MixpanelLib.prototype.track_pageview = $413a30192b54574f$var$addOptOutCheckMixpanelLib(function(properties, options) {
    if (typeof properties !== "object") properties = {};
    options = options || {};
    var event_name = options["event_name"] || "$mp_web_page_view";
    var default_page_properties = $413a30192b54574f$var$_.extend($413a30192b54574f$var$_.info.mpPageViewProperties(), $413a30192b54574f$var$_.info.campaignParams(), $413a30192b54574f$var$_.info.clickParams());
    var event_properties = $413a30192b54574f$var$_.extend({}, default_page_properties, properties);
    return this.track(event_name, event_properties);
});
/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */ $413a30192b54574f$var$MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, $413a30192b54574f$var$LinkTracker, arguments);
};
/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */ $413a30192b54574f$var$MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, $413a30192b54574f$var$FormTracker, arguments);
};
/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */ $413a30192b54574f$var$MixpanelLib.prototype.time_event = function(event_name) {
    if ($413a30192b54574f$var$_.isUndefined(event_name)) {
        this.report_error("No event name provided to mixpanel.time_event");
        return;
    }
    if (this._event_is_disabled(event_name)) return;
    this["persistence"].set_event_timer(event_name, new Date().getTime());
};
var $413a30192b54574f$var$REGISTER_DEFAULTS = {
    "persistent": true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */ var $413a30192b54574f$var$options_for_register = function(days_or_options) {
    var options;
    if ($413a30192b54574f$var$_.isObject(days_or_options)) options = days_or_options;
    else if (!$413a30192b54574f$var$_.isUndefined(days_or_options)) options = {
        "days": days_or_options
    };
    else options = {};
    return $413a30192b54574f$var$_.extend({}, $413a30192b54574f$var$REGISTER_DEFAULTS, options);
};
/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $413a30192b54574f$var$MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = $413a30192b54574f$var$options_for_register(days_or_options);
    if (options["persistent"]) this["persistence"].register(props, options["days"]);
    else $413a30192b54574f$var$_.extend(this.unpersisted_superprops, props);
};
/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $413a30192b54574f$var$MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = $413a30192b54574f$var$options_for_register(days_or_options);
    if (options["persistent"]) this["persistence"].register_once(props, default_value, options["days"]);
    else {
        if (typeof default_value === "undefined") default_value = "None";
        $413a30192b54574f$var$_.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) this.unpersisted_superprops[prop] = val;
        }, this);
    }
};
/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */ $413a30192b54574f$var$MixpanelLib.prototype.unregister = function(property, options) {
    options = $413a30192b54574f$var$options_for_register(options);
    if (options["persistent"]) this["persistence"].unregister(property);
    else delete this.unpersisted_superprops[property];
};
$413a30192b54574f$var$MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};
/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */ $413a30192b54574f$var$MixpanelLib.prototype.identify = function(new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
    var previous_distinct_id = this.get_distinct_id();
    if (new_distinct_id && previous_distinct_id !== new_distinct_id) {
        // we allow the following condition if previous distinct_id is same as new_distinct_id
        // so that you can force flush people updates for anonymous profiles.
        if (typeof new_distinct_id === "string" && new_distinct_id.indexOf($413a30192b54574f$var$DEVICE_ID_PREFIX) === 0) {
            this.report_error("distinct_id cannot have $device: prefix");
            return -1;
        }
        this.register({
            "$user_id": new_distinct_id
        });
    }
    if (!this.get_property("$device_id")) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            "$had_persisted_distinct_id": true,
            "$device_id": device_id
        }, "");
    }
    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property($413a30192b54574f$var$ALIAS_ID_KEY)) {
        this.unregister($413a30192b54574f$var$ALIAS_ID_KEY);
        this.register({
            "distinct_id": new_distinct_id
        });
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this["people"]._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) this.track("$identify", {
        "distinct_id": new_distinct_id,
        "$anon_distinct_id": previous_distinct_id
    }, {
        skip_hooks: true
    });
    // check feature flags again if distinct id has changed
    if (new_distinct_id !== previous_distinct_id) this.flags.fetchFlags();
};
/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */ $413a30192b54574f$var$MixpanelLib.prototype.reset = function() {
    this.stop_session_recording();
    this["persistence"].clear();
    this._flags.identify_called = false;
    var uuid = $413a30192b54574f$var$_.UUID();
    this.register_once({
        "distinct_id": $413a30192b54574f$var$DEVICE_ID_PREFIX + uuid,
        "$device_id": uuid
    }, "");
    this._check_and_start_session_recording();
};
/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */ $413a30192b54574f$var$MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property("distinct_id");
};
/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */ $413a30192b54574f$var$MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property($413a30192b54574f$var$PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error("Attempting to create alias for existing People user - aborting.");
        return -2;
    }
    var _this = this;
    if ($413a30192b54574f$var$_.isUndefined(original)) original = this.get_distinct_id();
    if (alias !== original) {
        this._register_single($413a30192b54574f$var$ALIAS_ID_KEY, alias);
        return this.track("$create_alias", {
            "alias": alias,
            "distinct_id": original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error("alias matches current distinct_id - skipping api call.");
        this.identify(alias);
        return -1;
    }
};
/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */ $413a30192b54574f$var$MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single("mp_name_tag", name_tag);
};
/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // host for requests (customizable for e.g. a local proxy)
 *       api_host: 'https://api-js.mixpanel.com',
 *
 *       // endpoints for different types of requests
 *       api_routes: {
 *         track: 'track/',
 *         engage: 'engage/',
 *         groups: 'groups/',
 *       }
 *
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // request-batching/queueing/retry
 *       batch_requests: true,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // disables enriching user profiles with first touch marketing data
 *       skip_first_touch_marketing: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // adds any UTM parameters and click IDs present on the page to any events fired
 *       track_marketing: true
 *
 *       // enables automatic page view tracking using default page view events through
 *       // the track_pageview() method
 *       track_pageview: false
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */ $413a30192b54574f$var$MixpanelLib.prototype.set_config = function(config) {
    if ($413a30192b54574f$var$_.isObject(config)) {
        $413a30192b54574f$var$_.extend(this["config"], config);
        var new_batch_size = config["batch_size"];
        if (new_batch_size) $413a30192b54574f$var$_.each(this.request_batchers, function(batcher) {
            batcher.resetBatchSize();
        });
        if (!this.get_config("persistence_name")) this["config"]["persistence_name"] = this["config"]["cookie_name"];
        if (!this.get_config("disable_persistence")) this["config"]["disable_persistence"] = this["config"]["disable_cookie"];
        if (this["persistence"]) this["persistence"].update_config(this["config"]);
        $413a30192b54574f$var$Config.DEBUG = $413a30192b54574f$var$Config.DEBUG || this.get_config("debug");
        if (("autocapture" in config || "record_heatmap_data" in config) && this.autocapture) this.autocapture.init();
    }
};
/**
 * returns the current config object for the library.
 */ $413a30192b54574f$var$MixpanelLib.prototype.get_config = function(prop_name) {
    return this["config"][prop_name];
};
/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */ $413a30192b54574f$var$MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this["config"]["hooks"][hook_name] || $413a30192b54574f$var$IDENTITY_FUNC).apply(this, $413a30192b54574f$var$slice.call(arguments, 1));
    if (typeof ret === "undefined") {
        this.report_error(hook_name + " hook did not return a value");
        ret = null;
    }
    return ret;
};
/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */ $413a30192b54574f$var$MixpanelLib.prototype.get_property = function(property_name) {
    return this["persistence"].load_prop([
        property_name
    ]);
};
/**
 * Get the API host for a specific endpoint type, falling back to the default api_host if not specified
 *
 * @param {String} endpoint_type The type of endpoint (e.g., "events", "people", "groups")
 * @returns {String} The API host to use for this endpoint
 */ $413a30192b54574f$var$MixpanelLib.prototype.get_api_host = function(endpoint_type) {
    return this.get_config("api_hosts")[endpoint_type] || this.get_config("api_host");
};
$413a30192b54574f$var$MixpanelLib.prototype.toString = function() {
    var name = this.get_config("name");
    if (name !== $413a30192b54574f$var$PRIMARY_INSTANCE_NAME) name = $413a30192b54574f$var$PRIMARY_INSTANCE_NAME + "." + name;
    return name;
};
$413a30192b54574f$var$MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return $413a30192b54574f$var$_.isBlockedUA($413a30192b54574f$var$userAgent) || this._flags.disable_all_events || $413a30192b54574f$var$_.include(this.__disabled_events, event_name);
};
// perform some housekeeping around GDPR opt-in/out state
$413a30192b54574f$var$MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config("opt_out_tracking_persistence_type") === "localStorage";
    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && $413a30192b54574f$var$_.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({
            "persistence_type": "cookie"
        })) this.opt_in_tracking({
            "enable_persistence": false
        });
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({
            "persistence_type": "cookie"
        })) this.opt_out_tracking({
            "clear_persistence": false
        });
        this.clear_opt_in_out_tracking({
            "persistence_type": "cookie",
            "enable_persistence": false
        });
    }
    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) this._gdpr_update_persistence({
        "clear_persistence": true
    });
    else if (!this.has_opted_in_tracking() && (this.get_config("opt_out_tracking_by_default") || $413a30192b54574f$var$_.cookie.get("mp_optout"))) {
        $413a30192b54574f$var$_.cookie.remove("mp_optout");
        this.opt_out_tracking({
            "clear_persistence": this.get_config("opt_out_persistence_by_default")
        });
    }
};
/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */ $413a30192b54574f$var$MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options["clear_persistence"]) disabled = true;
    else if (options && options["enable_persistence"]) disabled = false;
    else return;
    if (!this.get_config("disable_persistence") && this["persistence"].disabled !== disabled) this["persistence"].set_disabled(disabled);
    if (disabled) {
        this.stop_batch_senders();
        this.stop_session_recording();
    } else // only start batchers after opt-in if they have previously been started
    // in order to avoid unintentionally starting up batching for the first time
    if (this._batchers_were_started) this.start_batch_senders();
};
// call a base gdpr function after constructing the appropriate token and options args
$413a30192b54574f$var$MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = $413a30192b54574f$var$_.extend({
        "track": $413a30192b54574f$var$_.bind(this.track, this),
        "persistence_type": this.get_config("opt_out_tracking_persistence_type"),
        "cookie_prefix": this.get_config("opt_out_tracking_cookie_prefix"),
        "cookie_expiration": this.get_config("cookie_expiration"),
        "cross_site_cookie": this.get_config("cross_site_cookie"),
        "cross_subdomain_cookie": this.get_config("cross_subdomain_cookie"),
        "cookie_domain": this.get_config("cookie_domain"),
        "secure_cookie": this.get_config("secure_cookie"),
        "ignore_dnt": this.get_config("ignore_dnt")
    }, options);
    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!$413a30192b54574f$var$_.localStorage.is_supported()) options["persistence_type"] = "cookie";
    return func(this.get_config("token"), {
        track: options["track"],
        trackEventName: options["track_event_name"],
        trackProperties: options["track_properties"],
        persistenceType: options["persistence_type"],
        persistencePrefix: options["cookie_prefix"],
        cookieDomain: options["cookie_domain"],
        cookieExpiration: options["cookie_expiration"],
        crossSiteCookie: options["cross_site_cookie"],
        crossSubdomainCookie: options["cross_subdomain_cookie"],
        secureCookie: options["secure_cookie"],
        ignoreDnt: options["ignore_dnt"]
    });
};
/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $413a30192b54574f$var$MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = $413a30192b54574f$var$_.extend({
        "enable_persistence": true
    }, options);
    this._gdpr_call_func($413a30192b54574f$var$optIn, options);
    this._gdpr_update_persistence(options);
};
/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $413a30192b54574f$var$MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = $413a30192b54574f$var$_.extend({
        "clear_persistence": true,
        "delete_user": true
    }, options);
    // delete user and clear charges since these methods may be disabled by opt-out
    if (options["delete_user"] && this["people"] && this["people"]._identify_called()) {
        this["people"].delete_user();
        this["people"].clear_charges();
    }
    this._gdpr_call_func($413a30192b54574f$var$optOut, options);
    this._gdpr_update_persistence(options);
};
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */ $413a30192b54574f$var$MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func($413a30192b54574f$var$hasOptedIn, options);
};
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */ $413a30192b54574f$var$MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func($413a30192b54574f$var$hasOptedOut, options);
};
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $413a30192b54574f$var$MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = $413a30192b54574f$var$_.extend({
        "enable_persistence": true
    }, options);
    this._gdpr_call_func($413a30192b54574f$var$clearOptInOut, options);
    this._gdpr_update_persistence(options);
};
$413a30192b54574f$var$MixpanelLib.prototype.report_error = function(msg, err) {
    $413a30192b54574f$var$console$1.error.apply($413a30192b54574f$var$console$1.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config("error_reporter")(msg, err);
    } catch (err) {
        $413a30192b54574f$var$console$1.error(err);
    }
};
// EXPORTS (for closure compiler)
// MixpanelLib Exports
$413a30192b54574f$var$MixpanelLib.prototype["init"] = $413a30192b54574f$var$MixpanelLib.prototype.init;
$413a30192b54574f$var$MixpanelLib.prototype["reset"] = $413a30192b54574f$var$MixpanelLib.prototype.reset;
$413a30192b54574f$var$MixpanelLib.prototype["disable"] = $413a30192b54574f$var$MixpanelLib.prototype.disable;
$413a30192b54574f$var$MixpanelLib.prototype["time_event"] = $413a30192b54574f$var$MixpanelLib.prototype.time_event;
$413a30192b54574f$var$MixpanelLib.prototype["track"] = $413a30192b54574f$var$MixpanelLib.prototype.track;
$413a30192b54574f$var$MixpanelLib.prototype["track_links"] = $413a30192b54574f$var$MixpanelLib.prototype.track_links;
$413a30192b54574f$var$MixpanelLib.prototype["track_forms"] = $413a30192b54574f$var$MixpanelLib.prototype.track_forms;
$413a30192b54574f$var$MixpanelLib.prototype["track_pageview"] = $413a30192b54574f$var$MixpanelLib.prototype.track_pageview;
$413a30192b54574f$var$MixpanelLib.prototype["register"] = $413a30192b54574f$var$MixpanelLib.prototype.register;
$413a30192b54574f$var$MixpanelLib.prototype["register_once"] = $413a30192b54574f$var$MixpanelLib.prototype.register_once;
$413a30192b54574f$var$MixpanelLib.prototype["unregister"] = $413a30192b54574f$var$MixpanelLib.prototype.unregister;
$413a30192b54574f$var$MixpanelLib.prototype["identify"] = $413a30192b54574f$var$MixpanelLib.prototype.identify;
$413a30192b54574f$var$MixpanelLib.prototype["alias"] = $413a30192b54574f$var$MixpanelLib.prototype.alias;
$413a30192b54574f$var$MixpanelLib.prototype["name_tag"] = $413a30192b54574f$var$MixpanelLib.prototype.name_tag;
$413a30192b54574f$var$MixpanelLib.prototype["set_config"] = $413a30192b54574f$var$MixpanelLib.prototype.set_config;
$413a30192b54574f$var$MixpanelLib.prototype["get_config"] = $413a30192b54574f$var$MixpanelLib.prototype.get_config;
$413a30192b54574f$var$MixpanelLib.prototype["get_api_host"] = $413a30192b54574f$var$MixpanelLib.prototype.get_api_host;
$413a30192b54574f$var$MixpanelLib.prototype["get_property"] = $413a30192b54574f$var$MixpanelLib.prototype.get_property;
$413a30192b54574f$var$MixpanelLib.prototype["get_distinct_id"] = $413a30192b54574f$var$MixpanelLib.prototype.get_distinct_id;
$413a30192b54574f$var$MixpanelLib.prototype["toString"] = $413a30192b54574f$var$MixpanelLib.prototype.toString;
$413a30192b54574f$var$MixpanelLib.prototype["opt_out_tracking"] = $413a30192b54574f$var$MixpanelLib.prototype.opt_out_tracking;
$413a30192b54574f$var$MixpanelLib.prototype["opt_in_tracking"] = $413a30192b54574f$var$MixpanelLib.prototype.opt_in_tracking;
$413a30192b54574f$var$MixpanelLib.prototype["has_opted_out_tracking"] = $413a30192b54574f$var$MixpanelLib.prototype.has_opted_out_tracking;
$413a30192b54574f$var$MixpanelLib.prototype["has_opted_in_tracking"] = $413a30192b54574f$var$MixpanelLib.prototype.has_opted_in_tracking;
$413a30192b54574f$var$MixpanelLib.prototype["clear_opt_in_out_tracking"] = $413a30192b54574f$var$MixpanelLib.prototype.clear_opt_in_out_tracking;
$413a30192b54574f$var$MixpanelLib.prototype["get_group"] = $413a30192b54574f$var$MixpanelLib.prototype.get_group;
$413a30192b54574f$var$MixpanelLib.prototype["set_group"] = $413a30192b54574f$var$MixpanelLib.prototype.set_group;
$413a30192b54574f$var$MixpanelLib.prototype["add_group"] = $413a30192b54574f$var$MixpanelLib.prototype.add_group;
$413a30192b54574f$var$MixpanelLib.prototype["remove_group"] = $413a30192b54574f$var$MixpanelLib.prototype.remove_group;
$413a30192b54574f$var$MixpanelLib.prototype["track_with_groups"] = $413a30192b54574f$var$MixpanelLib.prototype.track_with_groups;
$413a30192b54574f$var$MixpanelLib.prototype["start_batch_senders"] = $413a30192b54574f$var$MixpanelLib.prototype.start_batch_senders;
$413a30192b54574f$var$MixpanelLib.prototype["stop_batch_senders"] = $413a30192b54574f$var$MixpanelLib.prototype.stop_batch_senders;
$413a30192b54574f$var$MixpanelLib.prototype["start_session_recording"] = $413a30192b54574f$var$MixpanelLib.prototype.start_session_recording;
$413a30192b54574f$var$MixpanelLib.prototype["stop_session_recording"] = $413a30192b54574f$var$MixpanelLib.prototype.stop_session_recording;
$413a30192b54574f$var$MixpanelLib.prototype["pause_session_recording"] = $413a30192b54574f$var$MixpanelLib.prototype.pause_session_recording;
$413a30192b54574f$var$MixpanelLib.prototype["resume_session_recording"] = $413a30192b54574f$var$MixpanelLib.prototype.resume_session_recording;
$413a30192b54574f$var$MixpanelLib.prototype["get_session_recording_properties"] = $413a30192b54574f$var$MixpanelLib.prototype.get_session_recording_properties;
$413a30192b54574f$var$MixpanelLib.prototype["get_session_replay_url"] = $413a30192b54574f$var$MixpanelLib.prototype.get_session_replay_url;
$413a30192b54574f$var$MixpanelLib.prototype["get_tab_id"] = $413a30192b54574f$var$MixpanelLib.prototype.get_tab_id;
$413a30192b54574f$var$MixpanelLib.prototype["DEFAULT_API_ROUTES"] = $413a30192b54574f$var$DEFAULT_API_ROUTES;
// Exports intended only for testing
$413a30192b54574f$var$MixpanelLib.prototype["__get_recorder"] = $413a30192b54574f$var$MixpanelLib.prototype.__get_recorder;
// MixpanelPersistence Exports
$413a30192b54574f$var$MixpanelPersistence.prototype["properties"] = $413a30192b54574f$var$MixpanelPersistence.prototype.properties;
$413a30192b54574f$var$MixpanelPersistence.prototype["update_search_keyword"] = $413a30192b54574f$var$MixpanelPersistence.prototype.update_search_keyword;
$413a30192b54574f$var$MixpanelPersistence.prototype["update_referrer_info"] = $413a30192b54574f$var$MixpanelPersistence.prototype.update_referrer_info;
$413a30192b54574f$var$MixpanelPersistence.prototype["get_cross_subdomain"] = $413a30192b54574f$var$MixpanelPersistence.prototype.get_cross_subdomain;
$413a30192b54574f$var$MixpanelPersistence.prototype["clear"] = $413a30192b54574f$var$MixpanelPersistence.prototype.clear;
var $413a30192b54574f$var$instances = {};
var $413a30192b54574f$var$extend_mp = function() {
    // add all the sub mixpanel instances
    $413a30192b54574f$var$_.each($413a30192b54574f$var$instances, function(instance, name) {
        if (name !== $413a30192b54574f$var$PRIMARY_INSTANCE_NAME) $413a30192b54574f$var$mixpanel_master[name] = instance;
    });
    // add private functions as _
    $413a30192b54574f$var$mixpanel_master["_"] = $413a30192b54574f$var$_;
};
var $413a30192b54574f$var$override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    $413a30192b54574f$var$mixpanel_master["init"] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!$413a30192b54574f$var$mixpanel_master[name]) {
                $413a30192b54574f$var$mixpanel_master[name] = $413a30192b54574f$var$instances[name] = $413a30192b54574f$var$create_mplib(token, config, name);
                $413a30192b54574f$var$mixpanel_master[name]._loaded();
            }
            return $413a30192b54574f$var$mixpanel_master[name];
        } else {
            var instance = $413a30192b54574f$var$mixpanel_master;
            if ($413a30192b54574f$var$instances[$413a30192b54574f$var$PRIMARY_INSTANCE_NAME]) // main mixpanel lib already initialized
            instance = $413a30192b54574f$var$instances[$413a30192b54574f$var$PRIMARY_INSTANCE_NAME];
            else if (token) {
                // intialize the main mixpanel lib
                instance = $413a30192b54574f$var$create_mplib(token, config, $413a30192b54574f$var$PRIMARY_INSTANCE_NAME);
                instance._loaded();
                $413a30192b54574f$var$instances[$413a30192b54574f$var$PRIMARY_INSTANCE_NAME] = instance;
            }
            $413a30192b54574f$var$mixpanel_master = instance;
            if ($413a30192b54574f$var$init_type === $413a30192b54574f$var$INIT_SNIPPET) $413a30192b54574f$var$win[$413a30192b54574f$var$PRIMARY_INSTANCE_NAME] = $413a30192b54574f$var$mixpanel_master;
            $413a30192b54574f$var$extend_mp();
        }
    };
};
var $413a30192b54574f$var$add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) return;
        dom_loaded_handler.done = true;
        $413a30192b54574f$var$DOM_LOADED = true;
        $413a30192b54574f$var$ENQUEUE_REQUESTS = false;
        $413a30192b54574f$var$_.each($413a30192b54574f$var$instances, function(inst) {
            inst._dom_loaded();
        });
    }
    function do_scroll_check() {
        try {
            $413a30192b54574f$var$document$1.documentElement.doScroll("left");
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }
        dom_loaded_handler();
    }
    if ($413a30192b54574f$var$document$1.addEventListener) {
        if ($413a30192b54574f$var$document$1.readyState === "complete") // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
        else $413a30192b54574f$var$document$1.addEventListener("DOMContentLoaded", dom_loaded_handler, false);
    } else if ($413a30192b54574f$var$document$1.attachEvent) {
        // IE
        $413a30192b54574f$var$document$1.attachEvent("onreadystatechange", dom_loaded_handler);
        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = $413a30192b54574f$var$win.frameElement === null;
        } catch (e) {
        // noop
        }
        if ($413a30192b54574f$var$document$1.documentElement.doScroll && toplevel) do_scroll_check();
    }
    // fallback handler, always will work
    $413a30192b54574f$var$_.register_event($413a30192b54574f$var$win, "load", dom_loaded_handler, true);
};
function $413a30192b54574f$var$init_as_module(bundle_loader) {
    $413a30192b54574f$var$load_extra_bundle = bundle_loader;
    $413a30192b54574f$var$init_type = $413a30192b54574f$var$INIT_MODULE;
    $413a30192b54574f$var$mixpanel_master = new $413a30192b54574f$var$MixpanelLib();
    $413a30192b54574f$var$override_mp_init_func();
    $413a30192b54574f$var$mixpanel_master["init"]();
    $413a30192b54574f$var$add_dom_loaded_handler();
    return $413a30192b54574f$var$mixpanel_master;
}
// For loading separate bundles asynchronously via script tag
// so that we don't load them until they are needed at runtime.
// For builds that have everything in one bundle, no extra work.
function $413a30192b54574f$var$loadNoop(_src, onload) {
    onload();
}
/* eslint camelcase: "off" */ var $413a30192b54574f$export$2e2bcd8739ae039 = $413a30192b54574f$var$init_as_module($413a30192b54574f$var$loadNoop);

});
parcelRegister("3aNd6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $24f87a6f86a8996f$export$a143d493d941bafc; }, function (v) { return $24f87a6f86a8996f$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $24f87a6f86a8996f$export$f99ded8fe4b79145; }, function (v) { return $24f87a6f86a8996f$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
"use strict";

var $5d11t = parcelRequire("5d11t");

var $7rddL = parcelRequire("7rddL");
const $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
const $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    let buf = $24f87a6f86a8996f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    const buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        const len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        const buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) buf = $24f87a6f86a8996f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case "ascii":
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case "base64":
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5d11t.fromByteArray(buf);
    else return $5d11t.fromByteArray(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $24f87a6f86a8996f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $24f87a6f86a8996f$var$errors = {};
function $24f87a6f86a8996f$var$E(sym, getMessage, Base) {
    $24f87a6f86a8996f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$24f87a6f86a8996f$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$24f87a6f86a8996f$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$24f87a6f86a8996f$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $24f87a6f86a8996f$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $24f87a6f86a8996f$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $24f87a6f86a8996f$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength) {
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $24f87a6f86a8996f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength);
}
function $24f87a6f86a8996f$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $24f87a6f86a8996f$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $24f87a6f86a8996f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $24f87a6f86a8996f$var$validateNumber(value, type);
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $24f87a6f86a8996f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $5d11t.toByteArray($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $24f87a6f86a8996f$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $24f87a6f86a8996f$var$BufferBigIntNotDefined : fn;
}
function $24f87a6f86a8996f$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("5d11t", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $3caef5c332c7293f$export$d622b2ad8d90c771; }, function (v) { return $3caef5c332c7293f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $3caef5c332c7293f$export$6100ba28696e12de; }, function (v) { return $3caef5c332c7293f$export$6100ba28696e12de = v; });
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
"use strict";
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup["-".charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup["_".charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("7rddL", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $56a54f6ebabce67d$export$aafa59e2e03f2942; }, function (v) { return $56a54f6ebabce67d$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $56a54f6ebabce67d$export$68d8715fc104d294; }, function (v) { return $56a54f6ebabce67d$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("hyPW0", function(module, exports) {

$parcel$export(module.exports, "MIXPANEL_PROPERTY_TYPE", function () { return $cc8de5c0b12c4073$export$48e1578cb4525f9c; });
$parcel$export(module.exports, "MIXPANEL_PROPERTY_SOURCE", function () { return $cc8de5c0b12c4073$export$daf30df7bb755d6a; });
$parcel$export(module.exports, "MIXPANEL_EVENT", function () { return $cc8de5c0b12c4073$export$a978c6c170f584a1; });
$parcel$export(module.exports, "MIXPANEL_VARIABLES", function () { return $cc8de5c0b12c4073$export$8ccea0e8ce65be8b; });
$parcel$export(module.exports, "isMixpanelEnabled", function () { return $cc8de5c0b12c4073$export$33fdb3eba95772e0; });
$parcel$export(module.exports, "isEmptyObject", function () { return $cc8de5c0b12c4073$export$83b788b1a3698c03; });
$parcel$export(module.exports, "getPrefixSSOID", function () { return $cc8de5c0b12c4073$export$41cd2a6fe1364754; });
const $cc8de5c0b12c4073$export$48e1578cb4525f9c = {
    Super: "superProperties",
    User: "userProperties",
    Event: "eventProperties"
};
const $cc8de5c0b12c4073$export$daf30df7bb755d6a = {
    Client: "client",
    Axis: "axis"
};
const $cc8de5c0b12c4073$export$a978c6c170f584a1 = {
    SubscribePaymentPage: "subscribe_payment_page",
    SubscribePaymentPagePayNow: "subscribe_payment_page_paynow"
};
const $cc8de5c0b12c4073$export$8ccea0e8ce65be8b = {
    SsoID: "user.userId",
    UniqueUserId: "uniqueUserId"
};
const $cc8de5c0b12c4073$export$33fdb3eba95772e0 = ()=>{
    return true;
};
const $cc8de5c0b12c4073$export$83b788b1a3698c03 = (obj)=>{
    return Object.keys(obj).length === 0 && obj.constructor === Object;
};
const $cc8de5c0b12c4073$export$41cd2a6fe1364754 = (ssoID)=>{
    return `mewatch-${ssoID}`;
};

});



})();
//# sourceMappingURL=index.56c186c8.js.map
